function iI(e, t) {
  for (var n = 0; n < t.length; n++) {
    const r = t[n];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const i in r)
        if (i !== "default" && !(i in e)) {
          const o = Object.getOwnPropertyDescriptor(r, i);
          o && Object.defineProperty(e, i, o.get ? o : {
            enumerable: !0,
            get: () => r[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
function nE(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var rE = { exports: {} }, an = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vf = Symbol.for("react.element"), oI = Symbol.for("react.portal"), aI = Symbol.for("react.fragment"), sI = Symbol.for("react.strict_mode"), lI = Symbol.for("react.profiler"), uI = Symbol.for("react.provider"), cI = Symbol.for("react.context"), dI = Symbol.for("react.forward_ref"), pI = Symbol.for("react.suspense"), fI = Symbol.for("react.memo"), hI = Symbol.for("react.lazy"), V8 = Symbol.iterator;
function mI(e) {
  return e === null || typeof e != "object" ? null : (e = V8 && e[V8] || e["@@iterator"], typeof e == "function" ? e : null);
}
var iE = { isMounted: function() {
  return !1;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, oE = Object.assign, aE = {};
function rd(e, t, n) {
  this.props = e, this.context = t, this.refs = aE, this.updater = n || iE;
}
rd.prototype.isReactComponent = {};
rd.prototype.setState = function(e, t) {
  if (typeof e != "object" && typeof e != "function" && e != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
  this.updater.enqueueSetState(this, e, t, "setState");
};
rd.prototype.forceUpdate = function(e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
};
function sE() {
}
sE.prototype = rd.prototype;
function o6(e, t, n) {
  this.props = e, this.context = t, this.refs = aE, this.updater = n || iE;
}
var a6 = o6.prototype = new sE();
a6.constructor = o6;
oE(a6, rd.prototype);
a6.isPureReactComponent = !0;
var U8 = Array.isArray, lE = Object.prototype.hasOwnProperty, s6 = { current: null }, uE = { key: !0, ref: !0, __self: !0, __source: !0 };
function cE(e, t, n) {
  var r, i = {}, o = null, a = null;
  if (t != null) for (r in t.ref !== void 0 && (a = t.ref), t.key !== void 0 && (o = "" + t.key), t) lE.call(t, r) && !uE.hasOwnProperty(r) && (i[r] = t[r]);
  var s = arguments.length - 2;
  if (s === 1) i.children = n;
  else if (1 < s) {
    for (var l = Array(s), u = 0; u < s; u++) l[u] = arguments[u + 2];
    i.children = l;
  }
  if (e && e.defaultProps) for (r in s = e.defaultProps, s) i[r] === void 0 && (i[r] = s[r]);
  return { $$typeof: vf, type: e, key: o, ref: a, props: i, _owner: s6.current };
}
function gI(e, t) {
  return { $$typeof: vf, type: e.type, key: t, ref: e.ref, props: e.props, _owner: e._owner };
}
function l6(e) {
  return typeof e == "object" && e !== null && e.$$typeof === vf;
}
function vI(e) {
  var t = { "=": "=0", ":": "=2" };
  return "$" + e.replace(/[=:]/g, function(n) {
    return t[n];
  });
}
var W8 = /\/+/g;
function q2(e, t) {
  return typeof e == "object" && e !== null && e.key != null ? vI("" + e.key) : t.toString(36);
}
function f1(e, t, n, r, i) {
  var o = typeof e;
  (o === "undefined" || o === "boolean") && (e = null);
  var a = !1;
  if (e === null) a = !0;
  else switch (o) {
    case "string":
    case "number":
      a = !0;
      break;
    case "object":
      switch (e.$$typeof) {
        case vf:
        case oI:
          a = !0;
      }
  }
  if (a) return a = e, i = i(a), e = r === "" ? "." + q2(a, 0) : r, U8(i) ? (n = "", e != null && (n = e.replace(W8, "$&/") + "/"), f1(i, t, n, "", function(u) {
    return u;
  })) : i != null && (l6(i) && (i = gI(i, n + (!i.key || a && a.key === i.key ? "" : ("" + i.key).replace(W8, "$&/") + "/") + e)), t.push(i)), 1;
  if (a = 0, r = r === "" ? "." : r + ":", U8(e)) for (var s = 0; s < e.length; s++) {
    o = e[s];
    var l = r + q2(o, s);
    a += f1(o, t, n, l, i);
  }
  else if (l = mI(e), typeof l == "function") for (e = l.call(e), s = 0; !(o = e.next()).done; ) o = o.value, l = r + q2(o, s++), a += f1(o, t, n, l, i);
  else if (o === "object") throw t = String(e), Error("Objects are not valid as a React child (found: " + (t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t) + "). If you meant to render a collection of children, use an array instead.");
  return a;
}
function hh(e, t, n) {
  if (e == null) return e;
  var r = [], i = 0;
  return f1(e, r, "", "", function(o) {
    return t.call(n, o, i++);
  }), r;
}
function yI(e) {
  if (e._status === -1) {
    var t = e._result;
    t = t(), t.then(function(n) {
      (e._status === 0 || e._status === -1) && (e._status = 1, e._result = n);
    }, function(n) {
      (e._status === 0 || e._status === -1) && (e._status = 2, e._result = n);
    }), e._status === -1 && (e._status = 0, e._result = t);
  }
  if (e._status === 1) return e._result.default;
  throw e._result;
}
var Ii = { current: null }, h1 = { transition: null }, xI = { ReactCurrentDispatcher: Ii, ReactCurrentBatchConfig: h1, ReactCurrentOwner: s6 };
an.Children = { map: hh, forEach: function(e, t, n) {
  hh(e, function() {
    t.apply(this, arguments);
  }, n);
}, count: function(e) {
  var t = 0;
  return hh(e, function() {
    t++;
  }), t;
}, toArray: function(e) {
  return hh(e, function(t) {
    return t;
  }) || [];
}, only: function(e) {
  if (!l6(e)) throw Error("React.Children.only expected to receive a single React element child.");
  return e;
} };
an.Component = rd;
an.Fragment = aI;
an.Profiler = lI;
an.PureComponent = o6;
an.StrictMode = sI;
an.Suspense = pI;
an.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = xI;
an.cloneElement = function(e, t, n) {
  if (e == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + e + ".");
  var r = oE({}, e.props), i = e.key, o = e.ref, a = e._owner;
  if (t != null) {
    if (t.ref !== void 0 && (o = t.ref, a = s6.current), t.key !== void 0 && (i = "" + t.key), e.type && e.type.defaultProps) var s = e.type.defaultProps;
    for (l in t) lE.call(t, l) && !uE.hasOwnProperty(l) && (r[l] = t[l] === void 0 && s !== void 0 ? s[l] : t[l]);
  }
  var l = arguments.length - 2;
  if (l === 1) r.children = n;
  else if (1 < l) {
    s = Array(l);
    for (var u = 0; u < l; u++) s[u] = arguments[u + 2];
    r.children = s;
  }
  return { $$typeof: vf, type: e.type, key: i, ref: o, props: r, _owner: a };
};
an.createContext = function(e) {
  return e = { $$typeof: cI, _currentValue: e, _currentValue2: e, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, e.Provider = { $$typeof: uI, _context: e }, e.Consumer = e;
};
an.createElement = cE;
an.createFactory = function(e) {
  var t = cE.bind(null, e);
  return t.type = e, t;
};
an.createRef = function() {
  return { current: null };
};
an.forwardRef = function(e) {
  return { $$typeof: dI, render: e };
};
an.isValidElement = l6;
an.lazy = function(e) {
  return { $$typeof: hI, _payload: { _status: -1, _result: e }, _init: yI };
};
an.memo = function(e, t) {
  return { $$typeof: fI, type: e, compare: t === void 0 ? null : t };
};
an.startTransition = function(e) {
  var t = h1.transition;
  h1.transition = {};
  try {
    e();
  } finally {
    h1.transition = t;
  }
};
an.unstable_act = function() {
  throw Error("act(...) is not supported in production builds of React.");
};
an.useCallback = function(e, t) {
  return Ii.current.useCallback(e, t);
};
an.useContext = function(e) {
  return Ii.current.useContext(e);
};
an.useDebugValue = function() {
};
an.useDeferredValue = function(e) {
  return Ii.current.useDeferredValue(e);
};
an.useEffect = function(e, t) {
  return Ii.current.useEffect(e, t);
};
an.useId = function() {
  return Ii.current.useId();
};
an.useImperativeHandle = function(e, t, n) {
  return Ii.current.useImperativeHandle(e, t, n);
};
an.useInsertionEffect = function(e, t) {
  return Ii.current.useInsertionEffect(e, t);
};
an.useLayoutEffect = function(e, t) {
  return Ii.current.useLayoutEffect(e, t);
};
an.useMemo = function(e, t) {
  return Ii.current.useMemo(e, t);
};
an.useReducer = function(e, t, n) {
  return Ii.current.useReducer(e, t, n);
};
an.useRef = function(e) {
  return Ii.current.useRef(e);
};
an.useState = function(e) {
  return Ii.current.useState(e);
};
an.useSyncExternalStore = function(e, t, n) {
  return Ii.current.useSyncExternalStore(e, t, n);
};
an.useTransition = function() {
  return Ii.current.useTransition();
};
an.version = "18.2.0";
rE.exports = an;
var v = rE.exports;
const dt = /* @__PURE__ */ nE(v), Z8 = /* @__PURE__ */ iI({
  __proto__: null,
  default: dt
}, [v]);
var dE = { exports: {} }, Po = {}, pE = { exports: {} }, fE = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function(e) {
  function t(de, ye) {
    var Ne = de.length;
    de.push(ye);
    e: for (; 0 < Ne; ) {
      var Me = Ne - 1 >>> 1, Ie = de[Me];
      if (0 < i(Ie, ye)) de[Me] = ye, de[Ne] = Ie, Ne = Me;
      else break e;
    }
  }
  function n(de) {
    return de.length === 0 ? null : de[0];
  }
  function r(de) {
    if (de.length === 0) return null;
    var ye = de[0], Ne = de.pop();
    if (Ne !== ye) {
      de[0] = Ne;
      e: for (var Me = 0, Ie = de.length, at = Ie >>> 1; Me < at; ) {
        var Ve = 2 * (Me + 1) - 1, mt = de[Ve], ae = Ve + 1, Se = de[ae];
        if (0 > i(mt, Ne)) ae < Ie && 0 > i(Se, mt) ? (de[Me] = Se, de[ae] = Ne, Me = ae) : (de[Me] = mt, de[Ve] = Ne, Me = Ve);
        else if (ae < Ie && 0 > i(Se, Ne)) de[Me] = Se, de[ae] = Ne, Me = ae;
        else break e;
      }
    }
    return ye;
  }
  function i(de, ye) {
    var Ne = de.sortIndex - ye.sortIndex;
    return Ne !== 0 ? Ne : de.id - ye.id;
  }
  if (typeof performance == "object" && typeof performance.now == "function") {
    var o = performance;
    e.unstable_now = function() {
      return o.now();
    };
  } else {
    var a = Date, s = a.now();
    e.unstable_now = function() {
      return a.now() - s;
    };
  }
  var l = [], u = [], d = 1, p = null, f = 3, m = !1, y = !1, g = !1, x = typeof setTimeout == "function" ? setTimeout : null, E = typeof clearTimeout == "function" ? clearTimeout : null, b = typeof setImmediate < "u" ? setImmediate : null;
  typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
  function C(de) {
    for (var ye = n(u); ye !== null; ) {
      if (ye.callback === null) r(u);
      else if (ye.startTime <= de) r(u), ye.sortIndex = ye.expirationTime, t(l, ye);
      else break;
      ye = n(u);
    }
  }
  function T(de) {
    if (g = !1, C(de), !y) if (n(l) !== null) y = !0, D(z);
    else {
      var ye = n(u);
      ye !== null && j(T, ye.startTime - de);
    }
  }
  function z(de, ye) {
    y = !1, g && (g = !1, E(M), M = -1), m = !0;
    var Ne = f;
    try {
      for (C(ye), p = n(l); p !== null && (!(p.expirationTime > ye) || de && !W()); ) {
        var Me = p.callback;
        if (typeof Me == "function") {
          p.callback = null, f = p.priorityLevel;
          var Ie = Me(p.expirationTime <= ye);
          ye = e.unstable_now(), typeof Ie == "function" ? p.callback = Ie : p === n(l) && r(l), C(ye);
        } else r(l);
        p = n(l);
      }
      if (p !== null) var at = !0;
      else {
        var Ve = n(u);
        Ve !== null && j(T, Ve.startTime - ye), at = !1;
      }
      return at;
    } finally {
      p = null, f = Ne, m = !1;
    }
  }
  var I = !1, w = null, M = -1, R = 5, F = -1;
  function W() {
    return !(e.unstable_now() - F < R);
  }
  function X() {
    if (w !== null) {
      var de = e.unstable_now();
      F = de;
      var ye = !0;
      try {
        ye = w(!0, de);
      } finally {
        ye ? le() : (I = !1, w = null);
      }
    } else I = !1;
  }
  var le;
  if (typeof b == "function") le = function() {
    b(X);
  };
  else if (typeof MessageChannel < "u") {
    var ne = new MessageChannel(), fe = ne.port2;
    ne.port1.onmessage = X, le = function() {
      fe.postMessage(null);
    };
  } else le = function() {
    x(X, 0);
  };
  function D(de) {
    w = de, I || (I = !0, le());
  }
  function j(de, ye) {
    M = x(function() {
      de(e.unstable_now());
    }, ye);
  }
  e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(de) {
    de.callback = null;
  }, e.unstable_continueExecution = function() {
    y || m || (y = !0, D(z));
  }, e.unstable_forceFrameRate = function(de) {
    0 > de || 125 < de ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : R = 0 < de ? Math.floor(1e3 / de) : 5;
  }, e.unstable_getCurrentPriorityLevel = function() {
    return f;
  }, e.unstable_getFirstCallbackNode = function() {
    return n(l);
  }, e.unstable_next = function(de) {
    switch (f) {
      case 1:
      case 2:
      case 3:
        var ye = 3;
        break;
      default:
        ye = f;
    }
    var Ne = f;
    f = ye;
    try {
      return de();
    } finally {
      f = Ne;
    }
  }, e.unstable_pauseExecution = function() {
  }, e.unstable_requestPaint = function() {
  }, e.unstable_runWithPriority = function(de, ye) {
    switch (de) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        de = 3;
    }
    var Ne = f;
    f = de;
    try {
      return ye();
    } finally {
      f = Ne;
    }
  }, e.unstable_scheduleCallback = function(de, ye, Ne) {
    var Me = e.unstable_now();
    switch (typeof Ne == "object" && Ne !== null ? (Ne = Ne.delay, Ne = typeof Ne == "number" && 0 < Ne ? Me + Ne : Me) : Ne = Me, de) {
      case 1:
        var Ie = -1;
        break;
      case 2:
        Ie = 250;
        break;
      case 5:
        Ie = 1073741823;
        break;
      case 4:
        Ie = 1e4;
        break;
      default:
        Ie = 5e3;
    }
    return Ie = Ne + Ie, de = { id: d++, callback: ye, priorityLevel: de, startTime: Ne, expirationTime: Ie, sortIndex: -1 }, Ne > Me ? (de.sortIndex = Ne, t(u, de), n(l) === null && de === n(u) && (g ? (E(M), M = -1) : g = !0, j(T, Ne - Me))) : (de.sortIndex = Ie, t(l, de), y || m || (y = !0, D(z))), de;
  }, e.unstable_shouldYield = W, e.unstable_wrapCallback = function(de) {
    var ye = f;
    return function() {
      var Ne = f;
      f = ye;
      try {
        return de.apply(this, arguments);
      } finally {
        f = Ne;
      }
    };
  };
})(fE);
pE.exports = fE;
var bI = pE.exports;
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wI = v, Mo = bI;
function Qe(e) {
  for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var hE = /* @__PURE__ */ new Set(), Np = {};
function zc(e, t) {
  I0(e, t), I0(e + "Capture", t);
}
function I0(e, t) {
  for (Np[e] = t, e = 0; e < t.length; e++) hE.add(t[e]);
}
var Ys = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), z3 = Object.prototype.hasOwnProperty, CI = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, G8 = {}, K8 = {};
function kI(e) {
  return z3.call(K8, e) ? !0 : z3.call(G8, e) ? !1 : CI.test(e) ? K8[e] = !0 : (G8[e] = !0, !1);
}
function EI(e, t, n, r) {
  if (n !== null && n.type === 0) return !1;
  switch (typeof t) {
    case "function":
    case "symbol":
      return !0;
    case "boolean":
      return r ? !1 : n !== null ? !n.acceptsBooleans : (e = e.toLowerCase().slice(0, 5), e !== "data-" && e !== "aria-");
    default:
      return !1;
  }
}
function SI(e, t, n, r) {
  if (t === null || typeof t > "u" || EI(e, t, n, r)) return !0;
  if (r) return !1;
  if (n !== null) switch (n.type) {
    case 3:
      return !t;
    case 4:
      return t === !1;
    case 5:
      return isNaN(t);
    case 6:
      return isNaN(t) || 1 > t;
  }
  return !1;
}
function Ri(e, t, n, r, i, o, a) {
  this.acceptsBooleans = t === 2 || t === 3 || t === 4, this.attributeName = r, this.attributeNamespace = i, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = o, this.removeEmptyString = a;
}
var ai = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
  ai[e] = new Ri(e, 0, !1, e, null, !1, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
  var t = e[0];
  ai[t] = new Ri(t, 1, !1, e[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
  ai[e] = new Ri(e, 2, !1, e.toLowerCase(), null, !1, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
  ai[e] = new Ri(e, 2, !1, e, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
  ai[e] = new Ri(e, 3, !1, e.toLowerCase(), null, !1, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function(e) {
  ai[e] = new Ri(e, 3, !0, e, null, !1, !1);
});
["capture", "download"].forEach(function(e) {
  ai[e] = new Ri(e, 4, !1, e, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function(e) {
  ai[e] = new Ri(e, 6, !1, e, null, !1, !1);
});
["rowSpan", "start"].forEach(function(e) {
  ai[e] = new Ri(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var u6 = /[\-:]([a-z])/g;
function c6(e) {
  return e[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
  var t = e.replace(
    u6,
    c6
  );
  ai[t] = new Ri(t, 1, !1, e, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
  var t = e.replace(u6, c6);
  ai[t] = new Ri(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function(e) {
  var t = e.replace(u6, c6);
  ai[t] = new Ri(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function(e) {
  ai[e] = new Ri(e, 1, !1, e.toLowerCase(), null, !1, !1);
});
ai.xlinkHref = new Ri("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
["src", "href", "action", "formAction"].forEach(function(e) {
  ai[e] = new Ri(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
function d6(e, t, n, r) {
  var i = ai.hasOwnProperty(t) ? ai[t] : null;
  (i !== null ? i.type !== 0 : r || !(2 < t.length) || t[0] !== "o" && t[0] !== "O" || t[1] !== "n" && t[1] !== "N") && (SI(t, n, i, r) && (n = null), r || i === null ? kI(t) && (n === null ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : i.mustUseProperty ? e[i.propertyName] = n === null ? i.type === 3 ? !1 : "" : n : (t = i.attributeName, r = i.attributeNamespace, n === null ? e.removeAttribute(t) : (i = i.type, n = i === 3 || i === 4 && n === !0 ? "" : "" + n, r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
}
var ml = wI.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, mh = Symbol.for("react.element"), a0 = Symbol.for("react.portal"), s0 = Symbol.for("react.fragment"), p6 = Symbol.for("react.strict_mode"), F3 = Symbol.for("react.profiler"), mE = Symbol.for("react.provider"), gE = Symbol.for("react.context"), f6 = Symbol.for("react.forward_ref"), L3 = Symbol.for("react.suspense"), M3 = Symbol.for("react.suspense_list"), h6 = Symbol.for("react.memo"), Ml = Symbol.for("react.lazy"), vE = Symbol.for("react.offscreen"), X8 = Symbol.iterator;
function zd(e) {
  return e === null || typeof e != "object" ? null : (e = X8 && e[X8] || e["@@iterator"], typeof e == "function" ? e : null);
}
var pr = Object.assign, $2;
function Kd(e) {
  if ($2 === void 0) try {
    throw Error();
  } catch (n) {
    var t = n.stack.trim().match(/\n( *(at )?)/);
    $2 = t && t[1] || "";
  }
  return `
` + $2 + e;
}
var H2 = !1;
function V2(e, t) {
  if (!e || H2) return "";
  H2 = !0;
  var n = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (t) if (t = function() {
      throw Error();
    }, Object.defineProperty(t.prototype, "props", { set: function() {
      throw Error();
    } }), typeof Reflect == "object" && Reflect.construct) {
      try {
        Reflect.construct(t, []);
      } catch (u) {
        var r = u;
      }
      Reflect.construct(e, [], t);
    } else {
      try {
        t.call();
      } catch (u) {
        r = u;
      }
      e.call(t.prototype);
    }
    else {
      try {
        throw Error();
      } catch (u) {
        r = u;
      }
      e();
    }
  } catch (u) {
    if (u && r && typeof u.stack == "string") {
      for (var i = u.stack.split(`
`), o = r.stack.split(`
`), a = i.length - 1, s = o.length - 1; 1 <= a && 0 <= s && i[a] !== o[s]; ) s--;
      for (; 1 <= a && 0 <= s; a--, s--) if (i[a] !== o[s]) {
        if (a !== 1 || s !== 1)
          do
            if (a--, s--, 0 > s || i[a] !== o[s]) {
              var l = `
` + i[a].replace(" at new ", " at ");
              return e.displayName && l.includes("<anonymous>") && (l = l.replace("<anonymous>", e.displayName)), l;
            }
          while (1 <= a && 0 <= s);
        break;
      }
    }
  } finally {
    H2 = !1, Error.prepareStackTrace = n;
  }
  return (e = e ? e.displayName || e.name : "") ? Kd(e) : "";
}
function DI(e) {
  switch (e.tag) {
    case 5:
      return Kd(e.type);
    case 16:
      return Kd("Lazy");
    case 13:
      return Kd("Suspense");
    case 19:
      return Kd("SuspenseList");
    case 0:
    case 2:
    case 15:
      return e = V2(e.type, !1), e;
    case 11:
      return e = V2(e.type.render, !1), e;
    case 1:
      return e = V2(e.type, !0), e;
    default:
      return "";
  }
}
function B3(e) {
  if (e == null) return null;
  if (typeof e == "function") return e.displayName || e.name || null;
  if (typeof e == "string") return e;
  switch (e) {
    case s0:
      return "Fragment";
    case a0:
      return "Portal";
    case F3:
      return "Profiler";
    case p6:
      return "StrictMode";
    case L3:
      return "Suspense";
    case M3:
      return "SuspenseList";
  }
  if (typeof e == "object") switch (e.$$typeof) {
    case gE:
      return (e.displayName || "Context") + ".Consumer";
    case mE:
      return (e._context.displayName || "Context") + ".Provider";
    case f6:
      var t = e.render;
      return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
    case h6:
      return t = e.displayName || null, t !== null ? t : B3(e.type) || "Memo";
    case Ml:
      t = e._payload, e = e._init;
      try {
        return B3(e(t));
      } catch {
      }
  }
  return null;
}
function AI(e) {
  var t = e.type;
  switch (e.tag) {
    case 24:
      return "Cache";
    case 9:
      return (t.displayName || "Context") + ".Consumer";
    case 10:
      return (t._context.displayName || "Context") + ".Provider";
    case 18:
      return "DehydratedFragment";
    case 11:
      return e = t.render, e = e.displayName || e.name || "", t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
    case 7:
      return "Fragment";
    case 5:
      return t;
    case 4:
      return "Portal";
    case 3:
      return "Root";
    case 6:
      return "Text";
    case 16:
      return B3(t);
    case 8:
      return t === p6 ? "StrictMode" : "Mode";
    case 22:
      return "Offscreen";
    case 12:
      return "Profiler";
    case 21:
      return "Scope";
    case 13:
      return "Suspense";
    case 19:
      return "SuspenseList";
    case 25:
      return "TracingMarker";
    case 1:
    case 0:
    case 17:
    case 2:
    case 14:
    case 15:
      if (typeof t == "function") return t.displayName || t.name || null;
      if (typeof t == "string") return t;
  }
  return null;
}
function cu(e) {
  switch (typeof e) {
    case "boolean":
    case "number":
    case "string":
    case "undefined":
      return e;
    case "object":
      return e;
    default:
      return "";
  }
}
function yE(e) {
  var t = e.type;
  return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
}
function TI(e) {
  var t = yE(e) ? "checked" : "value", n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t), r = "" + e[t];
  if (!e.hasOwnProperty(t) && typeof n < "u" && typeof n.get == "function" && typeof n.set == "function") {
    var i = n.get, o = n.set;
    return Object.defineProperty(e, t, { configurable: !0, get: function() {
      return i.call(this);
    }, set: function(a) {
      r = "" + a, o.call(this, a);
    } }), Object.defineProperty(e, t, { enumerable: n.enumerable }), { getValue: function() {
      return r;
    }, setValue: function(a) {
      r = "" + a;
    }, stopTracking: function() {
      e._valueTracker = null, delete e[t];
    } };
  }
}
function gh(e) {
  e._valueTracker || (e._valueTracker = TI(e));
}
function xE(e) {
  if (!e) return !1;
  var t = e._valueTracker;
  if (!t) return !0;
  var n = t.getValue(), r = "";
  return e && (r = yE(e) ? e.checked ? "true" : "false" : e.value), e = r, e !== n ? (t.setValue(e), !0) : !1;
}
function K1(e) {
  if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function I3(e, t) {
  var n = t.checked;
  return pr({}, t, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: n ?? e._wrapperState.initialChecked });
}
function Q8(e, t) {
  var n = t.defaultValue == null ? "" : t.defaultValue, r = t.checked != null ? t.checked : t.defaultChecked;
  n = cu(t.value != null ? t.value : n), e._wrapperState = { initialChecked: r, initialValue: n, controlled: t.type === "checkbox" || t.type === "radio" ? t.checked != null : t.value != null };
}
function bE(e, t) {
  t = t.checked, t != null && d6(e, "checked", t, !1);
}
function R3(e, t) {
  bE(e, t);
  var n = cu(t.value), r = t.type;
  if (n != null) r === "number" ? (n === 0 && e.value === "" || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);
  else if (r === "submit" || r === "reset") {
    e.removeAttribute("value");
    return;
  }
  t.hasOwnProperty("value") ? P3(e, t.type, n) : t.hasOwnProperty("defaultValue") && P3(e, t.type, cu(t.defaultValue)), t.checked == null && t.defaultChecked != null && (e.defaultChecked = !!t.defaultChecked);
}
function Y8(e, t, n) {
  if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
    var r = t.type;
    if (!(r !== "submit" && r !== "reset" || t.value !== void 0 && t.value !== null)) return;
    t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
  }
  n = e.name, n !== "" && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, n !== "" && (e.name = n);
}
function P3(e, t, n) {
  (t !== "number" || K1(e.ownerDocument) !== e) && (n == null ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
}
var Xd = Array.isArray;
function k0(e, t, n, r) {
  if (e = e.options, t) {
    t = {};
    for (var i = 0; i < n.length; i++) t["$" + n[i]] = !0;
    for (n = 0; n < e.length; n++) i = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
  } else {
    for (n = "" + cu(n), t = null, i = 0; i < e.length; i++) {
      if (e[i].value === n) {
        e[i].selected = !0, r && (e[i].defaultSelected = !0);
        return;
      }
      t !== null || e[i].disabled || (t = e[i]);
    }
    t !== null && (t.selected = !0);
  }
}
function _3(e, t) {
  if (t.dangerouslySetInnerHTML != null) throw Error(Qe(91));
  return pr({}, t, { value: void 0, defaultValue: void 0, children: "" + e._wrapperState.initialValue });
}
function J8(e, t) {
  var n = t.value;
  if (n == null) {
    if (n = t.children, t = t.defaultValue, n != null) {
      if (t != null) throw Error(Qe(92));
      if (Xd(n)) {
        if (1 < n.length) throw Error(Qe(93));
        n = n[0];
      }
      t = n;
    }
    t == null && (t = ""), n = t;
  }
  e._wrapperState = { initialValue: cu(n) };
}
function wE(e, t) {
  var n = cu(t.value), r = cu(t.defaultValue);
  n != null && (n = "" + n, n !== e.value && (e.value = n), t.defaultValue == null && e.defaultValue !== n && (e.defaultValue = n)), r != null && (e.defaultValue = "" + r);
}
function ex(e) {
  var t = e.textContent;
  t === e._wrapperState.initialValue && t !== "" && t !== null && (e.value = t);
}
function CE(e) {
  switch (e) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function q3(e, t) {
  return e == null || e === "http://www.w3.org/1999/xhtml" ? CE(t) : e === "http://www.w3.org/2000/svg" && t === "foreignObject" ? "http://www.w3.org/1999/xhtml" : e;
}
var vh, kE = function(e) {
  return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(t, n, r, i) {
    MSApp.execUnsafeLocalFunction(function() {
      return e(t, n, r, i);
    });
  } : e;
}(function(e, t) {
  if (e.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e) e.innerHTML = t;
  else {
    for (vh = vh || document.createElement("div"), vh.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = vh.firstChild; e.firstChild; ) e.removeChild(e.firstChild);
    for (; t.firstChild; ) e.appendChild(t.firstChild);
  }
});
function Op(e, t) {
  if (t) {
    var n = e.firstChild;
    if (n && n === e.lastChild && n.nodeType === 3) {
      n.nodeValue = t;
      return;
    }
  }
  e.textContent = t;
}
var lp = {
  animationIterationCount: !0,
  aspectRatio: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, jI = ["Webkit", "ms", "Moz", "O"];
Object.keys(lp).forEach(function(e) {
  jI.forEach(function(t) {
    t = t + e.charAt(0).toUpperCase() + e.substring(1), lp[t] = lp[e];
  });
});
function EE(e, t, n) {
  return t == null || typeof t == "boolean" || t === "" ? "" : n || typeof t != "number" || t === 0 || lp.hasOwnProperty(e) && lp[e] ? ("" + t).trim() : t + "px";
}
function SE(e, t) {
  e = e.style;
  for (var n in t) if (t.hasOwnProperty(n)) {
    var r = n.indexOf("--") === 0, i = EE(n, t[n], r);
    n === "float" && (n = "cssFloat"), r ? e.setProperty(n, i) : e[n] = i;
  }
}
var NI = pr({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
function $3(e, t) {
  if (t) {
    if (NI[e] && (t.children != null || t.dangerouslySetInnerHTML != null)) throw Error(Qe(137, e));
    if (t.dangerouslySetInnerHTML != null) {
      if (t.children != null) throw Error(Qe(60));
      if (typeof t.dangerouslySetInnerHTML != "object" || !("__html" in t.dangerouslySetInnerHTML)) throw Error(Qe(61));
    }
    if (t.style != null && typeof t.style != "object") throw Error(Qe(62));
  }
}
function H3(e, t) {
  if (e.indexOf("-") === -1) return typeof t.is == "string";
  switch (e) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;
    default:
      return !0;
  }
}
var V3 = null;
function m6(e) {
  return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
}
var U3 = null, E0 = null, S0 = null;
function tx(e) {
  if (e = bf(e)) {
    if (typeof U3 != "function") throw Error(Qe(280));
    var t = e.stateNode;
    t && (t = ag(t), U3(e.stateNode, e.type, t));
  }
}
function DE(e) {
  E0 ? S0 ? S0.push(e) : S0 = [e] : E0 = e;
}
function AE() {
  if (E0) {
    var e = E0, t = S0;
    if (S0 = E0 = null, tx(e), t) for (e = 0; e < t.length; e++) tx(t[e]);
  }
}
function TE(e, t) {
  return e(t);
}
function jE() {
}
var U2 = !1;
function NE(e, t, n) {
  if (U2) return e(t, n);
  U2 = !0;
  try {
    return TE(e, t, n);
  } finally {
    U2 = !1, (E0 !== null || S0 !== null) && (jE(), AE());
  }
}
function zp(e, t) {
  var n = e.stateNode;
  if (n === null) return null;
  var r = ag(n);
  if (r === null) return null;
  n = r[t];
  e: switch (t) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
      break e;
    default:
      e = !1;
  }
  if (e) return null;
  if (n && typeof n != "function") throw Error(Qe(231, t, typeof n));
  return n;
}
var W3 = !1;
if (Ys) try {
  var Fd = {};
  Object.defineProperty(Fd, "passive", { get: function() {
    W3 = !0;
  } }), window.addEventListener("test", Fd, Fd), window.removeEventListener("test", Fd, Fd);
} catch {
  W3 = !1;
}
function OI(e, t, n, r, i, o, a, s, l) {
  var u = Array.prototype.slice.call(arguments, 3);
  try {
    t.apply(n, u);
  } catch (d) {
    this.onError(d);
  }
}
var up = !1, X1 = null, Q1 = !1, Z3 = null, zI = { onError: function(e) {
  up = !0, X1 = e;
} };
function FI(e, t, n, r, i, o, a, s, l) {
  up = !1, X1 = null, OI.apply(zI, arguments);
}
function LI(e, t, n, r, i, o, a, s, l) {
  if (FI.apply(this, arguments), up) {
    if (up) {
      var u = X1;
      up = !1, X1 = null;
    } else throw Error(Qe(198));
    Q1 || (Q1 = !0, Z3 = u);
  }
}
function Fc(e) {
  var t = e, n = e;
  if (e.alternate) for (; t.return; ) t = t.return;
  else {
    e = t;
    do
      t = e, t.flags & 4098 && (n = t.return), e = t.return;
    while (e);
  }
  return t.tag === 3 ? n : null;
}
function OE(e) {
  if (e.tag === 13) {
    var t = e.memoizedState;
    if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
  }
  return null;
}
function nx(e) {
  if (Fc(e) !== e) throw Error(Qe(188));
}
function MI(e) {
  var t = e.alternate;
  if (!t) {
    if (t = Fc(e), t === null) throw Error(Qe(188));
    return t !== e ? null : e;
  }
  for (var n = e, r = t; ; ) {
    var i = n.return;
    if (i === null) break;
    var o = i.alternate;
    if (o === null) {
      if (r = i.return, r !== null) {
        n = r;
        continue;
      }
      break;
    }
    if (i.child === o.child) {
      for (o = i.child; o; ) {
        if (o === n) return nx(i), e;
        if (o === r) return nx(i), t;
        o = o.sibling;
      }
      throw Error(Qe(188));
    }
    if (n.return !== r.return) n = i, r = o;
    else {
      for (var a = !1, s = i.child; s; ) {
        if (s === n) {
          a = !0, n = i, r = o;
          break;
        }
        if (s === r) {
          a = !0, r = i, n = o;
          break;
        }
        s = s.sibling;
      }
      if (!a) {
        for (s = o.child; s; ) {
          if (s === n) {
            a = !0, n = o, r = i;
            break;
          }
          if (s === r) {
            a = !0, r = o, n = i;
            break;
          }
          s = s.sibling;
        }
        if (!a) throw Error(Qe(189));
      }
    }
    if (n.alternate !== r) throw Error(Qe(190));
  }
  if (n.tag !== 3) throw Error(Qe(188));
  return n.stateNode.current === n ? e : t;
}
function zE(e) {
  return e = MI(e), e !== null ? FE(e) : null;
}
function FE(e) {
  if (e.tag === 5 || e.tag === 6) return e;
  for (e = e.child; e !== null; ) {
    var t = FE(e);
    if (t !== null) return t;
    e = e.sibling;
  }
  return null;
}
var LE = Mo.unstable_scheduleCallback, rx = Mo.unstable_cancelCallback, BI = Mo.unstable_shouldYield, II = Mo.unstable_requestPaint, kr = Mo.unstable_now, RI = Mo.unstable_getCurrentPriorityLevel, g6 = Mo.unstable_ImmediatePriority, ME = Mo.unstable_UserBlockingPriority, Y1 = Mo.unstable_NormalPriority, PI = Mo.unstable_LowPriority, BE = Mo.unstable_IdlePriority, ng = null, ss = null;
function _I(e) {
  if (ss && typeof ss.onCommitFiberRoot == "function") try {
    ss.onCommitFiberRoot(ng, e, void 0, (e.current.flags & 128) === 128);
  } catch {
  }
}
var Ra = Math.clz32 ? Math.clz32 : HI, qI = Math.log, $I = Math.LN2;
function HI(e) {
  return e >>>= 0, e === 0 ? 32 : 31 - (qI(e) / $I | 0) | 0;
}
var yh = 64, xh = 4194304;
function Qd(e) {
  switch (e & -e) {
    case 1:
      return 1;
    case 2:
      return 2;
    case 4:
      return 4;
    case 8:
      return 8;
    case 16:
      return 16;
    case 32:
      return 32;
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return e & 4194240;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return e & 130023424;
    case 134217728:
      return 134217728;
    case 268435456:
      return 268435456;
    case 536870912:
      return 536870912;
    case 1073741824:
      return 1073741824;
    default:
      return e;
  }
}
function J1(e, t) {
  var n = e.pendingLanes;
  if (n === 0) return 0;
  var r = 0, i = e.suspendedLanes, o = e.pingedLanes, a = n & 268435455;
  if (a !== 0) {
    var s = a & ~i;
    s !== 0 ? r = Qd(s) : (o &= a, o !== 0 && (r = Qd(o)));
  } else a = n & ~i, a !== 0 ? r = Qd(a) : o !== 0 && (r = Qd(o));
  if (r === 0) return 0;
  if (t !== 0 && t !== r && !(t & i) && (i = r & -r, o = t & -t, i >= o || i === 16 && (o & 4194240) !== 0)) return t;
  if (r & 4 && (r |= n & 16), t = e.entangledLanes, t !== 0) for (e = e.entanglements, t &= r; 0 < t; ) n = 31 - Ra(t), i = 1 << n, r |= e[n], t &= ~i;
  return r;
}
function VI(e, t) {
  switch (e) {
    case 1:
    case 2:
    case 4:
      return t + 250;
    case 8:
    case 16:
    case 32:
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return t + 5e3;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return -1;
    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;
    default:
      return -1;
  }
}
function UI(e, t) {
  for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, o = e.pendingLanes; 0 < o; ) {
    var a = 31 - Ra(o), s = 1 << a, l = i[a];
    l === -1 ? (!(s & n) || s & r) && (i[a] = VI(s, t)) : l <= t && (e.expiredLanes |= s), o &= ~s;
  }
}
function G3(e) {
  return e = e.pendingLanes & -1073741825, e !== 0 ? e : e & 1073741824 ? 1073741824 : 0;
}
function IE() {
  var e = yh;
  return yh <<= 1, !(yh & 4194240) && (yh = 64), e;
}
function W2(e) {
  for (var t = [], n = 0; 31 > n; n++) t.push(e);
  return t;
}
function yf(e, t, n) {
  e.pendingLanes |= t, t !== 536870912 && (e.suspendedLanes = 0, e.pingedLanes = 0), e = e.eventTimes, t = 31 - Ra(t), e[t] = n;
}
function WI(e, t) {
  var n = e.pendingLanes & ~t;
  e.pendingLanes = t, e.suspendedLanes = 0, e.pingedLanes = 0, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t, t = e.entanglements;
  var r = e.eventTimes;
  for (e = e.expirationTimes; 0 < n; ) {
    var i = 31 - Ra(n), o = 1 << i;
    t[i] = 0, r[i] = -1, e[i] = -1, n &= ~o;
  }
}
function v6(e, t) {
  var n = e.entangledLanes |= t;
  for (e = e.entanglements; n; ) {
    var r = 31 - Ra(n), i = 1 << r;
    i & t | e[r] & t && (e[r] |= t), n &= ~i;
  }
}
var Cn = 0;
function RE(e) {
  return e &= -e, 1 < e ? 4 < e ? e & 268435455 ? 16 : 536870912 : 4 : 1;
}
var PE, y6, _E, qE, $E, K3 = !1, bh = [], Ql = null, Yl = null, Jl = null, Fp = /* @__PURE__ */ new Map(), Lp = /* @__PURE__ */ new Map(), _l = [], ZI = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function ix(e, t) {
  switch (e) {
    case "focusin":
    case "focusout":
      Ql = null;
      break;
    case "dragenter":
    case "dragleave":
      Yl = null;
      break;
    case "mouseover":
    case "mouseout":
      Jl = null;
      break;
    case "pointerover":
    case "pointerout":
      Fp.delete(t.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      Lp.delete(t.pointerId);
  }
}
function Ld(e, t, n, r, i, o) {
  return e === null || e.nativeEvent !== o ? (e = { blockedOn: t, domEventName: n, eventSystemFlags: r, nativeEvent: o, targetContainers: [i] }, t !== null && (t = bf(t), t !== null && y6(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, i !== null && t.indexOf(i) === -1 && t.push(i), e);
}
function GI(e, t, n, r, i) {
  switch (t) {
    case "focusin":
      return Ql = Ld(Ql, e, t, n, r, i), !0;
    case "dragenter":
      return Yl = Ld(Yl, e, t, n, r, i), !0;
    case "mouseover":
      return Jl = Ld(Jl, e, t, n, r, i), !0;
    case "pointerover":
      var o = i.pointerId;
      return Fp.set(o, Ld(Fp.get(o) || null, e, t, n, r, i)), !0;
    case "gotpointercapture":
      return o = i.pointerId, Lp.set(o, Ld(Lp.get(o) || null, e, t, n, r, i)), !0;
  }
  return !1;
}
function HE(e) {
  var t = ac(e.target);
  if (t !== null) {
    var n = Fc(t);
    if (n !== null) {
      if (t = n.tag, t === 13) {
        if (t = OE(n), t !== null) {
          e.blockedOn = t, $E(e.priority, function() {
            _E(n);
          });
          return;
        }
      } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
        e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
        return;
      }
    }
  }
  e.blockedOn = null;
}
function m1(e) {
  if (e.blockedOn !== null) return !1;
  for (var t = e.targetContainers; 0 < t.length; ) {
    var n = X3(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
    if (n === null) {
      n = e.nativeEvent;
      var r = new n.constructor(n.type, n);
      V3 = r, n.target.dispatchEvent(r), V3 = null;
    } else return t = bf(n), t !== null && y6(t), e.blockedOn = n, !1;
    t.shift();
  }
  return !0;
}
function ox(e, t, n) {
  m1(e) && n.delete(t);
}
function KI() {
  K3 = !1, Ql !== null && m1(Ql) && (Ql = null), Yl !== null && m1(Yl) && (Yl = null), Jl !== null && m1(Jl) && (Jl = null), Fp.forEach(ox), Lp.forEach(ox);
}
function Md(e, t) {
  e.blockedOn === t && (e.blockedOn = null, K3 || (K3 = !0, Mo.unstable_scheduleCallback(Mo.unstable_NormalPriority, KI)));
}
function Mp(e) {
  function t(i) {
    return Md(i, e);
  }
  if (0 < bh.length) {
    Md(bh[0], e);
    for (var n = 1; n < bh.length; n++) {
      var r = bh[n];
      r.blockedOn === e && (r.blockedOn = null);
    }
  }
  for (Ql !== null && Md(Ql, e), Yl !== null && Md(Yl, e), Jl !== null && Md(Jl, e), Fp.forEach(t), Lp.forEach(t), n = 0; n < _l.length; n++) r = _l[n], r.blockedOn === e && (r.blockedOn = null);
  for (; 0 < _l.length && (n = _l[0], n.blockedOn === null); ) HE(n), n.blockedOn === null && _l.shift();
}
var D0 = ml.ReactCurrentBatchConfig, em = !0;
function XI(e, t, n, r) {
  var i = Cn, o = D0.transition;
  D0.transition = null;
  try {
    Cn = 1, x6(e, t, n, r);
  } finally {
    Cn = i, D0.transition = o;
  }
}
function QI(e, t, n, r) {
  var i = Cn, o = D0.transition;
  D0.transition = null;
  try {
    Cn = 4, x6(e, t, n, r);
  } finally {
    Cn = i, D0.transition = o;
  }
}
function x6(e, t, n, r) {
  if (em) {
    var i = X3(e, t, n, r);
    if (i === null) n4(e, t, r, tm, n), ix(e, r);
    else if (GI(i, e, t, n, r)) r.stopPropagation();
    else if (ix(e, r), t & 4 && -1 < ZI.indexOf(e)) {
      for (; i !== null; ) {
        var o = bf(i);
        if (o !== null && PE(o), o = X3(e, t, n, r), o === null && n4(e, t, r, tm, n), o === i) break;
        i = o;
      }
      i !== null && r.stopPropagation();
    } else n4(e, t, r, null, n);
  }
}
var tm = null;
function X3(e, t, n, r) {
  if (tm = null, e = m6(r), e = ac(e), e !== null) if (t = Fc(e), t === null) e = null;
  else if (n = t.tag, n === 13) {
    if (e = OE(t), e !== null) return e;
    e = null;
  } else if (n === 3) {
    if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
    e = null;
  } else t !== e && (e = null);
  return tm = e, null;
}
function VE(e) {
  switch (e) {
    case "cancel":
    case "click":
    case "close":
    case "contextmenu":
    case "copy":
    case "cut":
    case "auxclick":
    case "dblclick":
    case "dragend":
    case "dragstart":
    case "drop":
    case "focusin":
    case "focusout":
    case "input":
    case "invalid":
    case "keydown":
    case "keypress":
    case "keyup":
    case "mousedown":
    case "mouseup":
    case "paste":
    case "pause":
    case "play":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
    case "ratechange":
    case "reset":
    case "resize":
    case "seeked":
    case "submit":
    case "touchcancel":
    case "touchend":
    case "touchstart":
    case "volumechange":
    case "change":
    case "selectionchange":
    case "textInput":
    case "compositionstart":
    case "compositionend":
    case "compositionupdate":
    case "beforeblur":
    case "afterblur":
    case "beforeinput":
    case "blur":
    case "fullscreenchange":
    case "focus":
    case "hashchange":
    case "popstate":
    case "select":
    case "selectstart":
      return 1;
    case "drag":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "mousemove":
    case "mouseout":
    case "mouseover":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "scroll":
    case "toggle":
    case "touchmove":
    case "wheel":
    case "mouseenter":
    case "mouseleave":
    case "pointerenter":
    case "pointerleave":
      return 4;
    case "message":
      switch (RI()) {
        case g6:
          return 1;
        case ME:
          return 4;
        case Y1:
        case PI:
          return 16;
        case BE:
          return 536870912;
        default:
          return 16;
      }
    default:
      return 16;
  }
}
var Vl = null, b6 = null, g1 = null;
function UE() {
  if (g1) return g1;
  var e, t = b6, n = t.length, r, i = "value" in Vl ? Vl.value : Vl.textContent, o = i.length;
  for (e = 0; e < n && t[e] === i[e]; e++) ;
  var a = n - e;
  for (r = 1; r <= a && t[n - r] === i[o - r]; r++) ;
  return g1 = i.slice(e, 1 < r ? 1 - r : void 0);
}
function v1(e) {
  var t = e.keyCode;
  return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
}
function wh() {
  return !0;
}
function ax() {
  return !1;
}
function _o(e) {
  function t(n, r, i, o, a) {
    this._reactName = n, this._targetInst = i, this.type = r, this.nativeEvent = o, this.target = a, this.currentTarget = null;
    for (var s in e) e.hasOwnProperty(s) && (n = e[s], this[s] = n ? n(o) : o[s]);
    return this.isDefaultPrevented = (o.defaultPrevented != null ? o.defaultPrevented : o.returnValue === !1) ? wh : ax, this.isPropagationStopped = ax, this;
  }
  return pr(t.prototype, { preventDefault: function() {
    this.defaultPrevented = !0;
    var n = this.nativeEvent;
    n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = wh);
  }, stopPropagation: function() {
    var n = this.nativeEvent;
    n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = wh);
  }, persist: function() {
  }, isPersistent: wh }), t;
}
var id = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(e) {
  return e.timeStamp || Date.now();
}, defaultPrevented: 0, isTrusted: 0 }, w6 = _o(id), xf = pr({}, id, { view: 0, detail: 0 }), YI = _o(xf), Z2, G2, Bd, rg = pr({}, xf, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: C6, button: 0, buttons: 0, relatedTarget: function(e) {
  return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
}, movementX: function(e) {
  return "movementX" in e ? e.movementX : (e !== Bd && (Bd && e.type === "mousemove" ? (Z2 = e.screenX - Bd.screenX, G2 = e.screenY - Bd.screenY) : G2 = Z2 = 0, Bd = e), Z2);
}, movementY: function(e) {
  return "movementY" in e ? e.movementY : G2;
} }), sx = _o(rg), JI = pr({}, rg, { dataTransfer: 0 }), eR = _o(JI), tR = pr({}, xf, { relatedTarget: 0 }), K2 = _o(tR), nR = pr({}, id, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), rR = _o(nR), iR = pr({}, id, { clipboardData: function(e) {
  return "clipboardData" in e ? e.clipboardData : window.clipboardData;
} }), oR = _o(iR), aR = pr({}, id, { data: 0 }), lx = _o(aR), sR = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
}, lR = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
}, uR = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
function cR(e) {
  var t = this.nativeEvent;
  return t.getModifierState ? t.getModifierState(e) : (e = uR[e]) ? !!t[e] : !1;
}
function C6() {
  return cR;
}
var dR = pr({}, xf, { key: function(e) {
  if (e.key) {
    var t = sR[e.key] || e.key;
    if (t !== "Unidentified") return t;
  }
  return e.type === "keypress" ? (e = v1(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? lR[e.keyCode] || "Unidentified" : "";
}, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: C6, charCode: function(e) {
  return e.type === "keypress" ? v1(e) : 0;
}, keyCode: function(e) {
  return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
}, which: function(e) {
  return e.type === "keypress" ? v1(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
} }), pR = _o(dR), fR = pr({}, rg, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), ux = _o(fR), hR = pr({}, xf, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: C6 }), mR = _o(hR), gR = pr({}, id, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), vR = _o(gR), yR = pr({}, rg, {
  deltaX: function(e) {
    return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
  },
  deltaY: function(e) {
    return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
}), xR = _o(yR), bR = [9, 13, 27, 32], k6 = Ys && "CompositionEvent" in window, cp = null;
Ys && "documentMode" in document && (cp = document.documentMode);
var wR = Ys && "TextEvent" in window && !cp, WE = Ys && (!k6 || cp && 8 < cp && 11 >= cp), cx = " ", dx = !1;
function ZE(e, t) {
  switch (e) {
    case "keyup":
      return bR.indexOf(t.keyCode) !== -1;
    case "keydown":
      return t.keyCode !== 229;
    case "keypress":
    case "mousedown":
    case "focusout":
      return !0;
    default:
      return !1;
  }
}
function GE(e) {
  return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
}
var l0 = !1;
function CR(e, t) {
  switch (e) {
    case "compositionend":
      return GE(t);
    case "keypress":
      return t.which !== 32 ? null : (dx = !0, cx);
    case "textInput":
      return e = t.data, e === cx && dx ? null : e;
    default:
      return null;
  }
}
function kR(e, t) {
  if (l0) return e === "compositionend" || !k6 && ZE(e, t) ? (e = UE(), g1 = b6 = Vl = null, l0 = !1, e) : null;
  switch (e) {
    case "paste":
      return null;
    case "keypress":
      if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
        if (t.char && 1 < t.char.length) return t.char;
        if (t.which) return String.fromCharCode(t.which);
      }
      return null;
    case "compositionend":
      return WE && t.locale !== "ko" ? null : t.data;
    default:
      return null;
  }
}
var ER = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
function px(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t === "input" ? !!ER[e.type] : t === "textarea";
}
function KE(e, t, n, r) {
  DE(r), t = nm(t, "onChange"), 0 < t.length && (n = new w6("onChange", "change", null, n, r), e.push({ event: n, listeners: t }));
}
var dp = null, Bp = null;
function SR(e) {
  aS(e, 0);
}
function ig(e) {
  var t = d0(e);
  if (xE(t)) return e;
}
function DR(e, t) {
  if (e === "change") return t;
}
var XE = !1;
if (Ys) {
  var X2;
  if (Ys) {
    var Q2 = "oninput" in document;
    if (!Q2) {
      var fx = document.createElement("div");
      fx.setAttribute("oninput", "return;"), Q2 = typeof fx.oninput == "function";
    }
    X2 = Q2;
  } else X2 = !1;
  XE = X2 && (!document.documentMode || 9 < document.documentMode);
}
function hx() {
  dp && (dp.detachEvent("onpropertychange", QE), Bp = dp = null);
}
function QE(e) {
  if (e.propertyName === "value" && ig(Bp)) {
    var t = [];
    KE(t, Bp, e, m6(e)), NE(SR, t);
  }
}
function AR(e, t, n) {
  e === "focusin" ? (hx(), dp = t, Bp = n, dp.attachEvent("onpropertychange", QE)) : e === "focusout" && hx();
}
function TR(e) {
  if (e === "selectionchange" || e === "keyup" || e === "keydown") return ig(Bp);
}
function jR(e, t) {
  if (e === "click") return ig(t);
}
function NR(e, t) {
  if (e === "input" || e === "change") return ig(t);
}
function OR(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var qa = typeof Object.is == "function" ? Object.is : OR;
function Ip(e, t) {
  if (qa(e, t)) return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null) return !1;
  var n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (r = 0; r < n.length; r++) {
    var i = n[r];
    if (!z3.call(t, i) || !qa(e[i], t[i])) return !1;
  }
  return !0;
}
function mx(e) {
  for (; e && e.firstChild; ) e = e.firstChild;
  return e;
}
function gx(e, t) {
  var n = mx(e);
  e = 0;
  for (var r; n; ) {
    if (n.nodeType === 3) {
      if (r = e + n.textContent.length, e <= t && r >= t) return { node: n, offset: t - e };
      e = r;
    }
    e: {
      for (; n; ) {
        if (n.nextSibling) {
          n = n.nextSibling;
          break e;
        }
        n = n.parentNode;
      }
      n = void 0;
    }
    n = mx(n);
  }
}
function YE(e, t) {
  return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? YE(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
}
function JE() {
  for (var e = window, t = K1(); t instanceof e.HTMLIFrameElement; ) {
    try {
      var n = typeof t.contentWindow.location.href == "string";
    } catch {
      n = !1;
    }
    if (n) e = t.contentWindow;
    else break;
    t = K1(e.document);
  }
  return t;
}
function E6(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
}
function zR(e) {
  var t = JE(), n = e.focusedElem, r = e.selectionRange;
  if (t !== n && n && n.ownerDocument && YE(n.ownerDocument.documentElement, n)) {
    if (r !== null && E6(n)) {
      if (t = r.start, e = r.end, e === void 0 && (e = t), "selectionStart" in n) n.selectionStart = t, n.selectionEnd = Math.min(e, n.value.length);
      else if (e = (t = n.ownerDocument || document) && t.defaultView || window, e.getSelection) {
        e = e.getSelection();
        var i = n.textContent.length, o = Math.min(r.start, i);
        r = r.end === void 0 ? o : Math.min(r.end, i), !e.extend && o > r && (i = r, r = o, o = i), i = gx(n, o);
        var a = gx(
          n,
          r
        );
        i && a && (e.rangeCount !== 1 || e.anchorNode !== i.node || e.anchorOffset !== i.offset || e.focusNode !== a.node || e.focusOffset !== a.offset) && (t = t.createRange(), t.setStart(i.node, i.offset), e.removeAllRanges(), o > r ? (e.addRange(t), e.extend(a.node, a.offset)) : (t.setEnd(a.node, a.offset), e.addRange(t)));
      }
    }
    for (t = [], e = n; e = e.parentNode; ) e.nodeType === 1 && t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
    for (typeof n.focus == "function" && n.focus(), n = 0; n < t.length; n++) e = t[n], e.element.scrollLeft = e.left, e.element.scrollTop = e.top;
  }
}
var FR = Ys && "documentMode" in document && 11 >= document.documentMode, u0 = null, Q3 = null, pp = null, Y3 = !1;
function vx(e, t, n) {
  var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
  Y3 || u0 == null || u0 !== K1(r) || (r = u0, "selectionStart" in r && E6(r) ? r = { start: r.selectionStart, end: r.selectionEnd } : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = { anchorNode: r.anchorNode, anchorOffset: r.anchorOffset, focusNode: r.focusNode, focusOffset: r.focusOffset }), pp && Ip(pp, r) || (pp = r, r = nm(Q3, "onSelect"), 0 < r.length && (t = new w6("onSelect", "select", null, t, n), e.push({ event: t, listeners: r }), t.target = u0)));
}
function Ch(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
}
var c0 = { animationend: Ch("Animation", "AnimationEnd"), animationiteration: Ch("Animation", "AnimationIteration"), animationstart: Ch("Animation", "AnimationStart"), transitionend: Ch("Transition", "TransitionEnd") }, Y2 = {}, eS = {};
Ys && (eS = document.createElement("div").style, "AnimationEvent" in window || (delete c0.animationend.animation, delete c0.animationiteration.animation, delete c0.animationstart.animation), "TransitionEvent" in window || delete c0.transitionend.transition);
function og(e) {
  if (Y2[e]) return Y2[e];
  if (!c0[e]) return e;
  var t = c0[e], n;
  for (n in t) if (t.hasOwnProperty(n) && n in eS) return Y2[e] = t[n];
  return e;
}
var tS = og("animationend"), nS = og("animationiteration"), rS = og("animationstart"), iS = og("transitionend"), oS = /* @__PURE__ */ new Map(), yx = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function Cu(e, t) {
  oS.set(e, t), zc(t, [e]);
}
for (var J2 = 0; J2 < yx.length; J2++) {
  var e4 = yx[J2], LR = e4.toLowerCase(), MR = e4[0].toUpperCase() + e4.slice(1);
  Cu(LR, "on" + MR);
}
Cu(tS, "onAnimationEnd");
Cu(nS, "onAnimationIteration");
Cu(rS, "onAnimationStart");
Cu("dblclick", "onDoubleClick");
Cu("focusin", "onFocus");
Cu("focusout", "onBlur");
Cu(iS, "onTransitionEnd");
I0("onMouseEnter", ["mouseout", "mouseover"]);
I0("onMouseLeave", ["mouseout", "mouseover"]);
I0("onPointerEnter", ["pointerout", "pointerover"]);
I0("onPointerLeave", ["pointerout", "pointerover"]);
zc("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
zc("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
zc("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
zc("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
zc("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
zc("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Yd = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), BR = new Set("cancel close invalid load scroll toggle".split(" ").concat(Yd));
function xx(e, t, n) {
  var r = e.type || "unknown-event";
  e.currentTarget = n, LI(r, t, void 0, e), e.currentTarget = null;
}
function aS(e, t) {
  t = (t & 4) !== 0;
  for (var n = 0; n < e.length; n++) {
    var r = e[n], i = r.event;
    r = r.listeners;
    e: {
      var o = void 0;
      if (t) for (var a = r.length - 1; 0 <= a; a--) {
        var s = r[a], l = s.instance, u = s.currentTarget;
        if (s = s.listener, l !== o && i.isPropagationStopped()) break e;
        xx(i, s, u), o = l;
      }
      else for (a = 0; a < r.length; a++) {
        if (s = r[a], l = s.instance, u = s.currentTarget, s = s.listener, l !== o && i.isPropagationStopped()) break e;
        xx(i, s, u), o = l;
      }
    }
  }
  if (Q1) throw e = Z3, Q1 = !1, Z3 = null, e;
}
function _n(e, t) {
  var n = t[rv];
  n === void 0 && (n = t[rv] = /* @__PURE__ */ new Set());
  var r = e + "__bubble";
  n.has(r) || (sS(t, e, 2, !1), n.add(r));
}
function t4(e, t, n) {
  var r = 0;
  t && (r |= 4), sS(n, e, r, t);
}
var kh = "_reactListening" + Math.random().toString(36).slice(2);
function Rp(e) {
  if (!e[kh]) {
    e[kh] = !0, hE.forEach(function(n) {
      n !== "selectionchange" && (BR.has(n) || t4(n, !1, e), t4(n, !0, e));
    });
    var t = e.nodeType === 9 ? e : e.ownerDocument;
    t === null || t[kh] || (t[kh] = !0, t4("selectionchange", !1, t));
  }
}
function sS(e, t, n, r) {
  switch (VE(t)) {
    case 1:
      var i = XI;
      break;
    case 4:
      i = QI;
      break;
    default:
      i = x6;
  }
  n = i.bind(null, t, n, e), i = void 0, !W3 || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (i = !0), r ? i !== void 0 ? e.addEventListener(t, n, { capture: !0, passive: i }) : e.addEventListener(t, n, !0) : i !== void 0 ? e.addEventListener(t, n, { passive: i }) : e.addEventListener(t, n, !1);
}
function n4(e, t, n, r, i) {
  var o = r;
  if (!(t & 1) && !(t & 2) && r !== null) e: for (; ; ) {
    if (r === null) return;
    var a = r.tag;
    if (a === 3 || a === 4) {
      var s = r.stateNode.containerInfo;
      if (s === i || s.nodeType === 8 && s.parentNode === i) break;
      if (a === 4) for (a = r.return; a !== null; ) {
        var l = a.tag;
        if ((l === 3 || l === 4) && (l = a.stateNode.containerInfo, l === i || l.nodeType === 8 && l.parentNode === i)) return;
        a = a.return;
      }
      for (; s !== null; ) {
        if (a = ac(s), a === null) return;
        if (l = a.tag, l === 5 || l === 6) {
          r = o = a;
          continue e;
        }
        s = s.parentNode;
      }
    }
    r = r.return;
  }
  NE(function() {
    var u = o, d = m6(n), p = [];
    e: {
      var f = oS.get(e);
      if (f !== void 0) {
        var m = w6, y = e;
        switch (e) {
          case "keypress":
            if (v1(n) === 0) break e;
          case "keydown":
          case "keyup":
            m = pR;
            break;
          case "focusin":
            y = "focus", m = K2;
            break;
          case "focusout":
            y = "blur", m = K2;
            break;
          case "beforeblur":
          case "afterblur":
            m = K2;
            break;
          case "click":
            if (n.button === 2) break e;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            m = sx;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            m = eR;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            m = mR;
            break;
          case tS:
          case nS:
          case rS:
            m = rR;
            break;
          case iS:
            m = vR;
            break;
          case "scroll":
            m = YI;
            break;
          case "wheel":
            m = xR;
            break;
          case "copy":
          case "cut":
          case "paste":
            m = oR;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            m = ux;
        }
        var g = (t & 4) !== 0, x = !g && e === "scroll", E = g ? f !== null ? f + "Capture" : null : f;
        g = [];
        for (var b = u, C; b !== null; ) {
          C = b;
          var T = C.stateNode;
          if (C.tag === 5 && T !== null && (C = T, E !== null && (T = zp(b, E), T != null && g.push(Pp(b, T, C)))), x) break;
          b = b.return;
        }
        0 < g.length && (f = new m(f, y, null, n, d), p.push({ event: f, listeners: g }));
      }
    }
    if (!(t & 7)) {
      e: {
        if (f = e === "mouseover" || e === "pointerover", m = e === "mouseout" || e === "pointerout", f && n !== V3 && (y = n.relatedTarget || n.fromElement) && (ac(y) || y[Js])) break e;
        if ((m || f) && (f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window, m ? (y = n.relatedTarget || n.toElement, m = u, y = y ? ac(y) : null, y !== null && (x = Fc(y), y !== x || y.tag !== 5 && y.tag !== 6) && (y = null)) : (m = null, y = u), m !== y)) {
          if (g = sx, T = "onMouseLeave", E = "onMouseEnter", b = "mouse", (e === "pointerout" || e === "pointerover") && (g = ux, T = "onPointerLeave", E = "onPointerEnter", b = "pointer"), x = m == null ? f : d0(m), C = y == null ? f : d0(y), f = new g(T, b + "leave", m, n, d), f.target = x, f.relatedTarget = C, T = null, ac(d) === u && (g = new g(E, b + "enter", y, n, d), g.target = C, g.relatedTarget = x, T = g), x = T, m && y) t: {
            for (g = m, E = y, b = 0, C = g; C; C = Xc(C)) b++;
            for (C = 0, T = E; T; T = Xc(T)) C++;
            for (; 0 < b - C; ) g = Xc(g), b--;
            for (; 0 < C - b; ) E = Xc(E), C--;
            for (; b--; ) {
              if (g === E || E !== null && g === E.alternate) break t;
              g = Xc(g), E = Xc(E);
            }
            g = null;
          }
          else g = null;
          m !== null && bx(p, f, m, g, !1), y !== null && x !== null && bx(p, x, y, g, !0);
        }
      }
      e: {
        if (f = u ? d0(u) : window, m = f.nodeName && f.nodeName.toLowerCase(), m === "select" || m === "input" && f.type === "file") var z = DR;
        else if (px(f)) if (XE) z = NR;
        else {
          z = TR;
          var I = AR;
        }
        else (m = f.nodeName) && m.toLowerCase() === "input" && (f.type === "checkbox" || f.type === "radio") && (z = jR);
        if (z && (z = z(e, u))) {
          KE(p, z, n, d);
          break e;
        }
        I && I(e, f, u), e === "focusout" && (I = f._wrapperState) && I.controlled && f.type === "number" && P3(f, "number", f.value);
      }
      switch (I = u ? d0(u) : window, e) {
        case "focusin":
          (px(I) || I.contentEditable === "true") && (u0 = I, Q3 = u, pp = null);
          break;
        case "focusout":
          pp = Q3 = u0 = null;
          break;
        case "mousedown":
          Y3 = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          Y3 = !1, vx(p, n, d);
          break;
        case "selectionchange":
          if (FR) break;
        case "keydown":
        case "keyup":
          vx(p, n, d);
      }
      var w;
      if (k6) e: {
        switch (e) {
          case "compositionstart":
            var M = "onCompositionStart";
            break e;
          case "compositionend":
            M = "onCompositionEnd";
            break e;
          case "compositionupdate":
            M = "onCompositionUpdate";
            break e;
        }
        M = void 0;
      }
      else l0 ? ZE(e, n) && (M = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (M = "onCompositionStart");
      M && (WE && n.locale !== "ko" && (l0 || M !== "onCompositionStart" ? M === "onCompositionEnd" && l0 && (w = UE()) : (Vl = d, b6 = "value" in Vl ? Vl.value : Vl.textContent, l0 = !0)), I = nm(u, M), 0 < I.length && (M = new lx(M, e, null, n, d), p.push({ event: M, listeners: I }), w ? M.data = w : (w = GE(n), w !== null && (M.data = w)))), (w = wR ? CR(e, n) : kR(e, n)) && (u = nm(u, "onBeforeInput"), 0 < u.length && (d = new lx("onBeforeInput", "beforeinput", null, n, d), p.push({ event: d, listeners: u }), d.data = w));
    }
    aS(p, t);
  });
}
function Pp(e, t, n) {
  return { instance: e, listener: t, currentTarget: n };
}
function nm(e, t) {
  for (var n = t + "Capture", r = []; e !== null; ) {
    var i = e, o = i.stateNode;
    i.tag === 5 && o !== null && (i = o, o = zp(e, n), o != null && r.unshift(Pp(e, o, i)), o = zp(e, t), o != null && r.push(Pp(e, o, i))), e = e.return;
  }
  return r;
}
function Xc(e) {
  if (e === null) return null;
  do
    e = e.return;
  while (e && e.tag !== 5);
  return e || null;
}
function bx(e, t, n, r, i) {
  for (var o = t._reactName, a = []; n !== null && n !== r; ) {
    var s = n, l = s.alternate, u = s.stateNode;
    if (l !== null && l === r) break;
    s.tag === 5 && u !== null && (s = u, i ? (l = zp(n, o), l != null && a.unshift(Pp(n, l, s))) : i || (l = zp(n, o), l != null && a.push(Pp(n, l, s)))), n = n.return;
  }
  a.length !== 0 && e.push({ event: t, listeners: a });
}
var IR = /\r\n?/g, RR = /\u0000|\uFFFD/g;
function wx(e) {
  return (typeof e == "string" ? e : "" + e).replace(IR, `
`).replace(RR, "");
}
function Eh(e, t, n) {
  if (t = wx(t), wx(e) !== t && n) throw Error(Qe(425));
}
function rm() {
}
var J3 = null, ev = null;
function tv(e, t) {
  return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
}
var nv = typeof setTimeout == "function" ? setTimeout : void 0, PR = typeof clearTimeout == "function" ? clearTimeout : void 0, Cx = typeof Promise == "function" ? Promise : void 0, _R = typeof queueMicrotask == "function" ? queueMicrotask : typeof Cx < "u" ? function(e) {
  return Cx.resolve(null).then(e).catch(qR);
} : nv;
function qR(e) {
  setTimeout(function() {
    throw e;
  });
}
function r4(e, t) {
  var n = t, r = 0;
  do {
    var i = n.nextSibling;
    if (e.removeChild(n), i && i.nodeType === 8) if (n = i.data, n === "/$") {
      if (r === 0) {
        e.removeChild(i), Mp(t);
        return;
      }
      r--;
    } else n !== "$" && n !== "$?" && n !== "$!" || r++;
    n = i;
  } while (n);
  Mp(t);
}
function eu(e) {
  for (; e != null; e = e.nextSibling) {
    var t = e.nodeType;
    if (t === 1 || t === 3) break;
    if (t === 8) {
      if (t = e.data, t === "$" || t === "$!" || t === "$?") break;
      if (t === "/$") return null;
    }
  }
  return e;
}
function kx(e) {
  e = e.previousSibling;
  for (var t = 0; e; ) {
    if (e.nodeType === 8) {
      var n = e.data;
      if (n === "$" || n === "$!" || n === "$?") {
        if (t === 0) return e;
        t--;
      } else n === "/$" && t++;
    }
    e = e.previousSibling;
  }
  return null;
}
var od = Math.random().toString(36).slice(2), is = "__reactFiber$" + od, _p = "__reactProps$" + od, Js = "__reactContainer$" + od, rv = "__reactEvents$" + od, $R = "__reactListeners$" + od, HR = "__reactHandles$" + od;
function ac(e) {
  var t = e[is];
  if (t) return t;
  for (var n = e.parentNode; n; ) {
    if (t = n[Js] || n[is]) {
      if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = kx(e); e !== null; ) {
        if (n = e[is]) return n;
        e = kx(e);
      }
      return t;
    }
    e = n, n = e.parentNode;
  }
  return null;
}
function bf(e) {
  return e = e[is] || e[Js], !e || e.tag !== 5 && e.tag !== 6 && e.tag !== 13 && e.tag !== 3 ? null : e;
}
function d0(e) {
  if (e.tag === 5 || e.tag === 6) return e.stateNode;
  throw Error(Qe(33));
}
function ag(e) {
  return e[_p] || null;
}
var iv = [], p0 = -1;
function ku(e) {
  return { current: e };
}
function Hn(e) {
  0 > p0 || (e.current = iv[p0], iv[p0] = null, p0--);
}
function Ln(e, t) {
  p0++, iv[p0] = e.current, e.current = t;
}
var du = {}, xi = ku(du), eo = ku(!1), yc = du;
function R0(e, t) {
  var n = e.type.contextTypes;
  if (!n) return du;
  var r = e.stateNode;
  if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
  var i = {}, o;
  for (o in n) i[o] = t[o];
  return r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = i), i;
}
function to(e) {
  return e = e.childContextTypes, e != null;
}
function im() {
  Hn(eo), Hn(xi);
}
function Ex(e, t, n) {
  if (xi.current !== du) throw Error(Qe(168));
  Ln(xi, t), Ln(eo, n);
}
function lS(e, t, n) {
  var r = e.stateNode;
  if (t = t.childContextTypes, typeof r.getChildContext != "function") return n;
  r = r.getChildContext();
  for (var i in r) if (!(i in t)) throw Error(Qe(108, AI(e) || "Unknown", i));
  return pr({}, n, r);
}
function om(e) {
  return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || du, yc = xi.current, Ln(xi, e), Ln(eo, eo.current), !0;
}
function Sx(e, t, n) {
  var r = e.stateNode;
  if (!r) throw Error(Qe(169));
  n ? (e = lS(e, t, yc), r.__reactInternalMemoizedMergedChildContext = e, Hn(eo), Hn(xi), Ln(xi, e)) : Hn(eo), Ln(eo, n);
}
var Rs = null, sg = !1, i4 = !1;
function uS(e) {
  Rs === null ? Rs = [e] : Rs.push(e);
}
function VR(e) {
  sg = !0, uS(e);
}
function Eu() {
  if (!i4 && Rs !== null) {
    i4 = !0;
    var e = 0, t = Cn;
    try {
      var n = Rs;
      for (Cn = 1; e < n.length; e++) {
        var r = n[e];
        do
          r = r(!0);
        while (r !== null);
      }
      Rs = null, sg = !1;
    } catch (i) {
      throw Rs !== null && (Rs = Rs.slice(e + 1)), LE(g6, Eu), i;
    } finally {
      Cn = t, i4 = !1;
    }
  }
  return null;
}
var f0 = [], h0 = 0, am = null, sm = 0, Jo = [], ea = 0, xc = null, $s = 1, Hs = "";
function Qu(e, t) {
  f0[h0++] = sm, f0[h0++] = am, am = e, sm = t;
}
function cS(e, t, n) {
  Jo[ea++] = $s, Jo[ea++] = Hs, Jo[ea++] = xc, xc = e;
  var r = $s;
  e = Hs;
  var i = 32 - Ra(r) - 1;
  r &= ~(1 << i), n += 1;
  var o = 32 - Ra(t) + i;
  if (30 < o) {
    var a = i - i % 5;
    o = (r & (1 << a) - 1).toString(32), r >>= a, i -= a, $s = 1 << 32 - Ra(t) + i | n << i | r, Hs = o + e;
  } else $s = 1 << o | n << i | r, Hs = e;
}
function S6(e) {
  e.return !== null && (Qu(e, 1), cS(e, 1, 0));
}
function D6(e) {
  for (; e === am; ) am = f0[--h0], f0[h0] = null, sm = f0[--h0], f0[h0] = null;
  for (; e === xc; ) xc = Jo[--ea], Jo[ea] = null, Hs = Jo[--ea], Jo[ea] = null, $s = Jo[--ea], Jo[ea] = null;
}
var No = null, Ao = null, Gn = !1, La = null;
function dS(e, t) {
  var n = ia(5, null, null, 0);
  n.elementType = "DELETED", n.stateNode = t, n.return = e, t = e.deletions, t === null ? (e.deletions = [n], e.flags |= 16) : t.push(n);
}
function Dx(e, t) {
  switch (e.tag) {
    case 5:
      var n = e.type;
      return t = t.nodeType !== 1 || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t, t !== null ? (e.stateNode = t, No = e, Ao = eu(t.firstChild), !0) : !1;
    case 6:
      return t = e.pendingProps === "" || t.nodeType !== 3 ? null : t, t !== null ? (e.stateNode = t, No = e, Ao = null, !0) : !1;
    case 13:
      return t = t.nodeType !== 8 ? null : t, t !== null ? (n = xc !== null ? { id: $s, overflow: Hs } : null, e.memoizedState = { dehydrated: t, treeContext: n, retryLane: 1073741824 }, n = ia(18, null, null, 0), n.stateNode = t, n.return = e, e.child = n, No = e, Ao = null, !0) : !1;
    default:
      return !1;
  }
}
function ov(e) {
  return (e.mode & 1) !== 0 && (e.flags & 128) === 0;
}
function av(e) {
  if (Gn) {
    var t = Ao;
    if (t) {
      var n = t;
      if (!Dx(e, t)) {
        if (ov(e)) throw Error(Qe(418));
        t = eu(n.nextSibling);
        var r = No;
        t && Dx(e, t) ? dS(r, n) : (e.flags = e.flags & -4097 | 2, Gn = !1, No = e);
      }
    } else {
      if (ov(e)) throw Error(Qe(418));
      e.flags = e.flags & -4097 | 2, Gn = !1, No = e;
    }
  }
}
function Ax(e) {
  for (e = e.return; e !== null && e.tag !== 5 && e.tag !== 3 && e.tag !== 13; ) e = e.return;
  No = e;
}
function Sh(e) {
  if (e !== No) return !1;
  if (!Gn) return Ax(e), Gn = !0, !1;
  var t;
  if ((t = e.tag !== 3) && !(t = e.tag !== 5) && (t = e.type, t = t !== "head" && t !== "body" && !tv(e.type, e.memoizedProps)), t && (t = Ao)) {
    if (ov(e)) throw pS(), Error(Qe(418));
    for (; t; ) dS(e, t), t = eu(t.nextSibling);
  }
  if (Ax(e), e.tag === 13) {
    if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(Qe(317));
    e: {
      for (e = e.nextSibling, t = 0; e; ) {
        if (e.nodeType === 8) {
          var n = e.data;
          if (n === "/$") {
            if (t === 0) {
              Ao = eu(e.nextSibling);
              break e;
            }
            t--;
          } else n !== "$" && n !== "$!" && n !== "$?" || t++;
        }
        e = e.nextSibling;
      }
      Ao = null;
    }
  } else Ao = No ? eu(e.stateNode.nextSibling) : null;
  return !0;
}
function pS() {
  for (var e = Ao; e; ) e = eu(e.nextSibling);
}
function P0() {
  Ao = No = null, Gn = !1;
}
function A6(e) {
  La === null ? La = [e] : La.push(e);
}
var UR = ml.ReactCurrentBatchConfig;
function Id(e, t, n) {
  if (e = n.ref, e !== null && typeof e != "function" && typeof e != "object") {
    if (n._owner) {
      if (n = n._owner, n) {
        if (n.tag !== 1) throw Error(Qe(309));
        var r = n.stateNode;
      }
      if (!r) throw Error(Qe(147, e));
      var i = r, o = "" + e;
      return t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === o ? t.ref : (t = function(a) {
        var s = i.refs;
        a === null ? delete s[o] : s[o] = a;
      }, t._stringRef = o, t);
    }
    if (typeof e != "string") throw Error(Qe(284));
    if (!n._owner) throw Error(Qe(290, e));
  }
  return e;
}
function Dh(e, t) {
  throw e = Object.prototype.toString.call(t), Error(Qe(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e));
}
function Tx(e) {
  var t = e._init;
  return t(e._payload);
}
function fS(e) {
  function t(E, b) {
    if (e) {
      var C = E.deletions;
      C === null ? (E.deletions = [b], E.flags |= 16) : C.push(b);
    }
  }
  function n(E, b) {
    if (!e) return null;
    for (; b !== null; ) t(E, b), b = b.sibling;
    return null;
  }
  function r(E, b) {
    for (E = /* @__PURE__ */ new Map(); b !== null; ) b.key !== null ? E.set(b.key, b) : E.set(b.index, b), b = b.sibling;
    return E;
  }
  function i(E, b) {
    return E = iu(E, b), E.index = 0, E.sibling = null, E;
  }
  function o(E, b, C) {
    return E.index = C, e ? (C = E.alternate, C !== null ? (C = C.index, C < b ? (E.flags |= 2, b) : C) : (E.flags |= 2, b)) : (E.flags |= 1048576, b);
  }
  function a(E) {
    return e && E.alternate === null && (E.flags |= 2), E;
  }
  function s(E, b, C, T) {
    return b === null || b.tag !== 6 ? (b = d4(C, E.mode, T), b.return = E, b) : (b = i(b, C), b.return = E, b);
  }
  function l(E, b, C, T) {
    var z = C.type;
    return z === s0 ? d(E, b, C.props.children, T, C.key) : b !== null && (b.elementType === z || typeof z == "object" && z !== null && z.$$typeof === Ml && Tx(z) === b.type) ? (T = i(b, C.props), T.ref = Id(E, b, C), T.return = E, T) : (T = E1(C.type, C.key, C.props, null, E.mode, T), T.ref = Id(E, b, C), T.return = E, T);
  }
  function u(E, b, C, T) {
    return b === null || b.tag !== 4 || b.stateNode.containerInfo !== C.containerInfo || b.stateNode.implementation !== C.implementation ? (b = p4(C, E.mode, T), b.return = E, b) : (b = i(b, C.children || []), b.return = E, b);
  }
  function d(E, b, C, T, z) {
    return b === null || b.tag !== 7 ? (b = pc(C, E.mode, T, z), b.return = E, b) : (b = i(b, C), b.return = E, b);
  }
  function p(E, b, C) {
    if (typeof b == "string" && b !== "" || typeof b == "number") return b = d4("" + b, E.mode, C), b.return = E, b;
    if (typeof b == "object" && b !== null) {
      switch (b.$$typeof) {
        case mh:
          return C = E1(b.type, b.key, b.props, null, E.mode, C), C.ref = Id(E, null, b), C.return = E, C;
        case a0:
          return b = p4(b, E.mode, C), b.return = E, b;
        case Ml:
          var T = b._init;
          return p(E, T(b._payload), C);
      }
      if (Xd(b) || zd(b)) return b = pc(b, E.mode, C, null), b.return = E, b;
      Dh(E, b);
    }
    return null;
  }
  function f(E, b, C, T) {
    var z = b !== null ? b.key : null;
    if (typeof C == "string" && C !== "" || typeof C == "number") return z !== null ? null : s(E, b, "" + C, T);
    if (typeof C == "object" && C !== null) {
      switch (C.$$typeof) {
        case mh:
          return C.key === z ? l(E, b, C, T) : null;
        case a0:
          return C.key === z ? u(E, b, C, T) : null;
        case Ml:
          return z = C._init, f(
            E,
            b,
            z(C._payload),
            T
          );
      }
      if (Xd(C) || zd(C)) return z !== null ? null : d(E, b, C, T, null);
      Dh(E, C);
    }
    return null;
  }
  function m(E, b, C, T, z) {
    if (typeof T == "string" && T !== "" || typeof T == "number") return E = E.get(C) || null, s(b, E, "" + T, z);
    if (typeof T == "object" && T !== null) {
      switch (T.$$typeof) {
        case mh:
          return E = E.get(T.key === null ? C : T.key) || null, l(b, E, T, z);
        case a0:
          return E = E.get(T.key === null ? C : T.key) || null, u(b, E, T, z);
        case Ml:
          var I = T._init;
          return m(E, b, C, I(T._payload), z);
      }
      if (Xd(T) || zd(T)) return E = E.get(C) || null, d(b, E, T, z, null);
      Dh(b, T);
    }
    return null;
  }
  function y(E, b, C, T) {
    for (var z = null, I = null, w = b, M = b = 0, R = null; w !== null && M < C.length; M++) {
      w.index > M ? (R = w, w = null) : R = w.sibling;
      var F = f(E, w, C[M], T);
      if (F === null) {
        w === null && (w = R);
        break;
      }
      e && w && F.alternate === null && t(E, w), b = o(F, b, M), I === null ? z = F : I.sibling = F, I = F, w = R;
    }
    if (M === C.length) return n(E, w), Gn && Qu(E, M), z;
    if (w === null) {
      for (; M < C.length; M++) w = p(E, C[M], T), w !== null && (b = o(w, b, M), I === null ? z = w : I.sibling = w, I = w);
      return Gn && Qu(E, M), z;
    }
    for (w = r(E, w); M < C.length; M++) R = m(w, E, M, C[M], T), R !== null && (e && R.alternate !== null && w.delete(R.key === null ? M : R.key), b = o(R, b, M), I === null ? z = R : I.sibling = R, I = R);
    return e && w.forEach(function(W) {
      return t(E, W);
    }), Gn && Qu(E, M), z;
  }
  function g(E, b, C, T) {
    var z = zd(C);
    if (typeof z != "function") throw Error(Qe(150));
    if (C = z.call(C), C == null) throw Error(Qe(151));
    for (var I = z = null, w = b, M = b = 0, R = null, F = C.next(); w !== null && !F.done; M++, F = C.next()) {
      w.index > M ? (R = w, w = null) : R = w.sibling;
      var W = f(E, w, F.value, T);
      if (W === null) {
        w === null && (w = R);
        break;
      }
      e && w && W.alternate === null && t(E, w), b = o(W, b, M), I === null ? z = W : I.sibling = W, I = W, w = R;
    }
    if (F.done) return n(
      E,
      w
    ), Gn && Qu(E, M), z;
    if (w === null) {
      for (; !F.done; M++, F = C.next()) F = p(E, F.value, T), F !== null && (b = o(F, b, M), I === null ? z = F : I.sibling = F, I = F);
      return Gn && Qu(E, M), z;
    }
    for (w = r(E, w); !F.done; M++, F = C.next()) F = m(w, E, M, F.value, T), F !== null && (e && F.alternate !== null && w.delete(F.key === null ? M : F.key), b = o(F, b, M), I === null ? z = F : I.sibling = F, I = F);
    return e && w.forEach(function(X) {
      return t(E, X);
    }), Gn && Qu(E, M), z;
  }
  function x(E, b, C, T) {
    if (typeof C == "object" && C !== null && C.type === s0 && C.key === null && (C = C.props.children), typeof C == "object" && C !== null) {
      switch (C.$$typeof) {
        case mh:
          e: {
            for (var z = C.key, I = b; I !== null; ) {
              if (I.key === z) {
                if (z = C.type, z === s0) {
                  if (I.tag === 7) {
                    n(E, I.sibling), b = i(I, C.props.children), b.return = E, E = b;
                    break e;
                  }
                } else if (I.elementType === z || typeof z == "object" && z !== null && z.$$typeof === Ml && Tx(z) === I.type) {
                  n(E, I.sibling), b = i(I, C.props), b.ref = Id(E, I, C), b.return = E, E = b;
                  break e;
                }
                n(E, I);
                break;
              } else t(E, I);
              I = I.sibling;
            }
            C.type === s0 ? (b = pc(C.props.children, E.mode, T, C.key), b.return = E, E = b) : (T = E1(C.type, C.key, C.props, null, E.mode, T), T.ref = Id(E, b, C), T.return = E, E = T);
          }
          return a(E);
        case a0:
          e: {
            for (I = C.key; b !== null; ) {
              if (b.key === I) if (b.tag === 4 && b.stateNode.containerInfo === C.containerInfo && b.stateNode.implementation === C.implementation) {
                n(E, b.sibling), b = i(b, C.children || []), b.return = E, E = b;
                break e;
              } else {
                n(E, b);
                break;
              }
              else t(E, b);
              b = b.sibling;
            }
            b = p4(C, E.mode, T), b.return = E, E = b;
          }
          return a(E);
        case Ml:
          return I = C._init, x(E, b, I(C._payload), T);
      }
      if (Xd(C)) return y(E, b, C, T);
      if (zd(C)) return g(E, b, C, T);
      Dh(E, C);
    }
    return typeof C == "string" && C !== "" || typeof C == "number" ? (C = "" + C, b !== null && b.tag === 6 ? (n(E, b.sibling), b = i(b, C), b.return = E, E = b) : (n(E, b), b = d4(C, E.mode, T), b.return = E, E = b), a(E)) : n(E, b);
  }
  return x;
}
var _0 = fS(!0), hS = fS(!1), lm = ku(null), um = null, m0 = null, T6 = null;
function j6() {
  T6 = m0 = um = null;
}
function N6(e) {
  var t = lm.current;
  Hn(lm), e._currentValue = t;
}
function sv(e, t, n) {
  for (; e !== null; ) {
    var r = e.alternate;
    if ((e.childLanes & t) !== t ? (e.childLanes |= t, r !== null && (r.childLanes |= t)) : r !== null && (r.childLanes & t) !== t && (r.childLanes |= t), e === n) break;
    e = e.return;
  }
}
function A0(e, t) {
  um = e, T6 = m0 = null, e = e.dependencies, e !== null && e.firstContext !== null && (e.lanes & t && (Yi = !0), e.firstContext = null);
}
function da(e) {
  var t = e._currentValue;
  if (T6 !== e) if (e = { context: e, memoizedValue: t, next: null }, m0 === null) {
    if (um === null) throw Error(Qe(308));
    m0 = e, um.dependencies = { lanes: 0, firstContext: e };
  } else m0 = m0.next = e;
  return t;
}
var sc = null;
function O6(e) {
  sc === null ? sc = [e] : sc.push(e);
}
function mS(e, t, n, r) {
  var i = t.interleaved;
  return i === null ? (n.next = n, O6(t)) : (n.next = i.next, i.next = n), t.interleaved = n, el(e, r);
}
function el(e, t) {
  e.lanes |= t;
  var n = e.alternate;
  for (n !== null && (n.lanes |= t), n = e, e = e.return; e !== null; ) e.childLanes |= t, n = e.alternate, n !== null && (n.childLanes |= t), n = e, e = e.return;
  return n.tag === 3 ? n.stateNode : null;
}
var Bl = !1;
function z6(e) {
  e.updateQueue = { baseState: e.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
}
function gS(e, t) {
  e = e.updateQueue, t.updateQueue === e && (t.updateQueue = { baseState: e.baseState, firstBaseUpdate: e.firstBaseUpdate, lastBaseUpdate: e.lastBaseUpdate, shared: e.shared, effects: e.effects });
}
function Gs(e, t) {
  return { eventTime: e, lane: t, tag: 0, payload: null, callback: null, next: null };
}
function tu(e, t, n) {
  var r = e.updateQueue;
  if (r === null) return null;
  if (r = r.shared, dn & 2) {
    var i = r.pending;
    return i === null ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, el(e, n);
  }
  return i = r.interleaved, i === null ? (t.next = t, O6(r)) : (t.next = i.next, i.next = t), r.interleaved = t, el(e, n);
}
function y1(e, t, n) {
  if (t = t.updateQueue, t !== null && (t = t.shared, (n & 4194240) !== 0)) {
    var r = t.lanes;
    r &= e.pendingLanes, n |= r, t.lanes = n, v6(e, n);
  }
}
function jx(e, t) {
  var n = e.updateQueue, r = e.alternate;
  if (r !== null && (r = r.updateQueue, n === r)) {
    var i = null, o = null;
    if (n = n.firstBaseUpdate, n !== null) {
      do {
        var a = { eventTime: n.eventTime, lane: n.lane, tag: n.tag, payload: n.payload, callback: n.callback, next: null };
        o === null ? i = o = a : o = o.next = a, n = n.next;
      } while (n !== null);
      o === null ? i = o = t : o = o.next = t;
    } else i = o = t;
    n = { baseState: r.baseState, firstBaseUpdate: i, lastBaseUpdate: o, shared: r.shared, effects: r.effects }, e.updateQueue = n;
    return;
  }
  e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
}
function cm(e, t, n, r) {
  var i = e.updateQueue;
  Bl = !1;
  var o = i.firstBaseUpdate, a = i.lastBaseUpdate, s = i.shared.pending;
  if (s !== null) {
    i.shared.pending = null;
    var l = s, u = l.next;
    l.next = null, a === null ? o = u : a.next = u, a = l;
    var d = e.alternate;
    d !== null && (d = d.updateQueue, s = d.lastBaseUpdate, s !== a && (s === null ? d.firstBaseUpdate = u : s.next = u, d.lastBaseUpdate = l));
  }
  if (o !== null) {
    var p = i.baseState;
    a = 0, d = u = l = null, s = o;
    do {
      var f = s.lane, m = s.eventTime;
      if ((r & f) === f) {
        d !== null && (d = d.next = {
          eventTime: m,
          lane: 0,
          tag: s.tag,
          payload: s.payload,
          callback: s.callback,
          next: null
        });
        e: {
          var y = e, g = s;
          switch (f = t, m = n, g.tag) {
            case 1:
              if (y = g.payload, typeof y == "function") {
                p = y.call(m, p, f);
                break e;
              }
              p = y;
              break e;
            case 3:
              y.flags = y.flags & -65537 | 128;
            case 0:
              if (y = g.payload, f = typeof y == "function" ? y.call(m, p, f) : y, f == null) break e;
              p = pr({}, p, f);
              break e;
            case 2:
              Bl = !0;
          }
        }
        s.callback !== null && s.lane !== 0 && (e.flags |= 64, f = i.effects, f === null ? i.effects = [s] : f.push(s));
      } else m = { eventTime: m, lane: f, tag: s.tag, payload: s.payload, callback: s.callback, next: null }, d === null ? (u = d = m, l = p) : d = d.next = m, a |= f;
      if (s = s.next, s === null) {
        if (s = i.shared.pending, s === null) break;
        f = s, s = f.next, f.next = null, i.lastBaseUpdate = f, i.shared.pending = null;
      }
    } while (!0);
    if (d === null && (l = p), i.baseState = l, i.firstBaseUpdate = u, i.lastBaseUpdate = d, t = i.shared.interleaved, t !== null) {
      i = t;
      do
        a |= i.lane, i = i.next;
      while (i !== t);
    } else o === null && (i.shared.lanes = 0);
    wc |= a, e.lanes = a, e.memoizedState = p;
  }
}
function Nx(e, t, n) {
  if (e = t.effects, t.effects = null, e !== null) for (t = 0; t < e.length; t++) {
    var r = e[t], i = r.callback;
    if (i !== null) {
      if (r.callback = null, r = n, typeof i != "function") throw Error(Qe(191, i));
      i.call(r);
    }
  }
}
var wf = {}, ls = ku(wf), qp = ku(wf), $p = ku(wf);
function lc(e) {
  if (e === wf) throw Error(Qe(174));
  return e;
}
function F6(e, t) {
  switch (Ln($p, t), Ln(qp, e), Ln(ls, wf), e = t.nodeType, e) {
    case 9:
    case 11:
      t = (t = t.documentElement) ? t.namespaceURI : q3(null, "");
      break;
    default:
      e = e === 8 ? t.parentNode : t, t = e.namespaceURI || null, e = e.tagName, t = q3(t, e);
  }
  Hn(ls), Ln(ls, t);
}
function q0() {
  Hn(ls), Hn(qp), Hn($p);
}
function vS(e) {
  lc($p.current);
  var t = lc(ls.current), n = q3(t, e.type);
  t !== n && (Ln(qp, e), Ln(ls, n));
}
function L6(e) {
  qp.current === e && (Hn(ls), Hn(qp));
}
var lr = ku(0);
function dm(e) {
  for (var t = e; t !== null; ) {
    if (t.tag === 13) {
      var n = t.memoizedState;
      if (n !== null && (n = n.dehydrated, n === null || n.data === "$?" || n.data === "$!")) return t;
    } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
      if (t.flags & 128) return t;
    } else if (t.child !== null) {
      t.child.return = t, t = t.child;
      continue;
    }
    if (t === e) break;
    for (; t.sibling === null; ) {
      if (t.return === null || t.return === e) return null;
      t = t.return;
    }
    t.sibling.return = t.return, t = t.sibling;
  }
  return null;
}
var o4 = [];
function M6() {
  for (var e = 0; e < o4.length; e++) o4[e]._workInProgressVersionPrimary = null;
  o4.length = 0;
}
var x1 = ml.ReactCurrentDispatcher, a4 = ml.ReactCurrentBatchConfig, bc = 0, dr = null, _r = null, Zr = null, pm = !1, fp = !1, Hp = 0, WR = 0;
function pi() {
  throw Error(Qe(321));
}
function B6(e, t) {
  if (t === null) return !1;
  for (var n = 0; n < t.length && n < e.length; n++) if (!qa(e[n], t[n])) return !1;
  return !0;
}
function I6(e, t, n, r, i, o) {
  if (bc = o, dr = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, x1.current = e === null || e.memoizedState === null ? XR : QR, e = n(r, i), fp) {
    o = 0;
    do {
      if (fp = !1, Hp = 0, 25 <= o) throw Error(Qe(301));
      o += 1, Zr = _r = null, t.updateQueue = null, x1.current = YR, e = n(r, i);
    } while (fp);
  }
  if (x1.current = fm, t = _r !== null && _r.next !== null, bc = 0, Zr = _r = dr = null, pm = !1, t) throw Error(Qe(300));
  return e;
}
function R6() {
  var e = Hp !== 0;
  return Hp = 0, e;
}
function ts() {
  var e = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
  return Zr === null ? dr.memoizedState = Zr = e : Zr = Zr.next = e, Zr;
}
function pa() {
  if (_r === null) {
    var e = dr.alternate;
    e = e !== null ? e.memoizedState : null;
  } else e = _r.next;
  var t = Zr === null ? dr.memoizedState : Zr.next;
  if (t !== null) Zr = t, _r = e;
  else {
    if (e === null) throw Error(Qe(310));
    _r = e, e = { memoizedState: _r.memoizedState, baseState: _r.baseState, baseQueue: _r.baseQueue, queue: _r.queue, next: null }, Zr === null ? dr.memoizedState = Zr = e : Zr = Zr.next = e;
  }
  return Zr;
}
function Vp(e, t) {
  return typeof t == "function" ? t(e) : t;
}
function s4(e) {
  var t = pa(), n = t.queue;
  if (n === null) throw Error(Qe(311));
  n.lastRenderedReducer = e;
  var r = _r, i = r.baseQueue, o = n.pending;
  if (o !== null) {
    if (i !== null) {
      var a = i.next;
      i.next = o.next, o.next = a;
    }
    r.baseQueue = i = o, n.pending = null;
  }
  if (i !== null) {
    o = i.next, r = r.baseState;
    var s = a = null, l = null, u = o;
    do {
      var d = u.lane;
      if ((bc & d) === d) l !== null && (l = l.next = { lane: 0, action: u.action, hasEagerState: u.hasEagerState, eagerState: u.eagerState, next: null }), r = u.hasEagerState ? u.eagerState : e(r, u.action);
      else {
        var p = {
          lane: d,
          action: u.action,
          hasEagerState: u.hasEagerState,
          eagerState: u.eagerState,
          next: null
        };
        l === null ? (s = l = p, a = r) : l = l.next = p, dr.lanes |= d, wc |= d;
      }
      u = u.next;
    } while (u !== null && u !== o);
    l === null ? a = r : l.next = s, qa(r, t.memoizedState) || (Yi = !0), t.memoizedState = r, t.baseState = a, t.baseQueue = l, n.lastRenderedState = r;
  }
  if (e = n.interleaved, e !== null) {
    i = e;
    do
      o = i.lane, dr.lanes |= o, wc |= o, i = i.next;
    while (i !== e);
  } else i === null && (n.lanes = 0);
  return [t.memoizedState, n.dispatch];
}
function l4(e) {
  var t = pa(), n = t.queue;
  if (n === null) throw Error(Qe(311));
  n.lastRenderedReducer = e;
  var r = n.dispatch, i = n.pending, o = t.memoizedState;
  if (i !== null) {
    n.pending = null;
    var a = i = i.next;
    do
      o = e(o, a.action), a = a.next;
    while (a !== i);
    qa(o, t.memoizedState) || (Yi = !0), t.memoizedState = o, t.baseQueue === null && (t.baseState = o), n.lastRenderedState = o;
  }
  return [o, r];
}
function yS() {
}
function xS(e, t) {
  var n = dr, r = pa(), i = t(), o = !qa(r.memoizedState, i);
  if (o && (r.memoizedState = i, Yi = !0), r = r.queue, P6(CS.bind(null, n, r, e), [e]), r.getSnapshot !== t || o || Zr !== null && Zr.memoizedState.tag & 1) {
    if (n.flags |= 2048, Up(9, wS.bind(null, n, r, i, t), void 0, null), Kr === null) throw Error(Qe(349));
    bc & 30 || bS(n, t, i);
  }
  return i;
}
function bS(e, t, n) {
  e.flags |= 16384, e = { getSnapshot: t, value: n }, t = dr.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, dr.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
}
function wS(e, t, n, r) {
  t.value = n, t.getSnapshot = r, kS(t) && ES(e);
}
function CS(e, t, n) {
  return n(function() {
    kS(t) && ES(e);
  });
}
function kS(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var n = t();
    return !qa(e, n);
  } catch {
    return !0;
  }
}
function ES(e) {
  var t = el(e, 1);
  t !== null && Pa(t, e, 1, -1);
}
function Ox(e) {
  var t = ts();
  return typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Vp, lastRenderedState: e }, t.queue = e, e = e.dispatch = KR.bind(null, dr, e), [t.memoizedState, e];
}
function Up(e, t, n, r) {
  return e = { tag: e, create: t, destroy: n, deps: r, next: null }, t = dr.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, dr.updateQueue = t, t.lastEffect = e.next = e) : (n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e)), e;
}
function SS() {
  return pa().memoizedState;
}
function b1(e, t, n, r) {
  var i = ts();
  dr.flags |= e, i.memoizedState = Up(1 | t, n, void 0, r === void 0 ? null : r);
}
function lg(e, t, n, r) {
  var i = pa();
  r = r === void 0 ? null : r;
  var o = void 0;
  if (_r !== null) {
    var a = _r.memoizedState;
    if (o = a.destroy, r !== null && B6(r, a.deps)) {
      i.memoizedState = Up(t, n, o, r);
      return;
    }
  }
  dr.flags |= e, i.memoizedState = Up(1 | t, n, o, r);
}
function zx(e, t) {
  return b1(8390656, 8, e, t);
}
function P6(e, t) {
  return lg(2048, 8, e, t);
}
function DS(e, t) {
  return lg(4, 2, e, t);
}
function AS(e, t) {
  return lg(4, 4, e, t);
}
function TS(e, t) {
  if (typeof t == "function") return e = e(), t(e), function() {
    t(null);
  };
  if (t != null) return e = e(), t.current = e, function() {
    t.current = null;
  };
}
function jS(e, t, n) {
  return n = n != null ? n.concat([e]) : null, lg(4, 4, TS.bind(null, t, e), n);
}
function _6() {
}
function NS(e, t) {
  var n = pa();
  t = t === void 0 ? null : t;
  var r = n.memoizedState;
  return r !== null && t !== null && B6(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
}
function OS(e, t) {
  var n = pa();
  t = t === void 0 ? null : t;
  var r = n.memoizedState;
  return r !== null && t !== null && B6(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [e, t], e);
}
function zS(e, t, n) {
  return bc & 21 ? (qa(n, t) || (n = IE(), dr.lanes |= n, wc |= n, e.baseState = !0), t) : (e.baseState && (e.baseState = !1, Yi = !0), e.memoizedState = n);
}
function ZR(e, t) {
  var n = Cn;
  Cn = n !== 0 && 4 > n ? n : 4, e(!0);
  var r = a4.transition;
  a4.transition = {};
  try {
    e(!1), t();
  } finally {
    Cn = n, a4.transition = r;
  }
}
function FS() {
  return pa().memoizedState;
}
function GR(e, t, n) {
  var r = ru(e);
  if (n = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null }, LS(e)) MS(t, n);
  else if (n = mS(e, t, n, r), n !== null) {
    var i = Mi();
    Pa(n, e, r, i), BS(n, t, r);
  }
}
function KR(e, t, n) {
  var r = ru(e), i = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null };
  if (LS(e)) MS(t, i);
  else {
    var o = e.alternate;
    if (e.lanes === 0 && (o === null || o.lanes === 0) && (o = t.lastRenderedReducer, o !== null)) try {
      var a = t.lastRenderedState, s = o(a, n);
      if (i.hasEagerState = !0, i.eagerState = s, qa(s, a)) {
        var l = t.interleaved;
        l === null ? (i.next = i, O6(t)) : (i.next = l.next, l.next = i), t.interleaved = i;
        return;
      }
    } catch {
    } finally {
    }
    n = mS(e, t, i, r), n !== null && (i = Mi(), Pa(n, e, r, i), BS(n, t, r));
  }
}
function LS(e) {
  var t = e.alternate;
  return e === dr || t !== null && t === dr;
}
function MS(e, t) {
  fp = pm = !0;
  var n = e.pending;
  n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
}
function BS(e, t, n) {
  if (n & 4194240) {
    var r = t.lanes;
    r &= e.pendingLanes, n |= r, t.lanes = n, v6(e, n);
  }
}
var fm = { readContext: da, useCallback: pi, useContext: pi, useEffect: pi, useImperativeHandle: pi, useInsertionEffect: pi, useLayoutEffect: pi, useMemo: pi, useReducer: pi, useRef: pi, useState: pi, useDebugValue: pi, useDeferredValue: pi, useTransition: pi, useMutableSource: pi, useSyncExternalStore: pi, useId: pi, unstable_isNewReconciler: !1 }, XR = { readContext: da, useCallback: function(e, t) {
  return ts().memoizedState = [e, t === void 0 ? null : t], e;
}, useContext: da, useEffect: zx, useImperativeHandle: function(e, t, n) {
  return n = n != null ? n.concat([e]) : null, b1(
    4194308,
    4,
    TS.bind(null, t, e),
    n
  );
}, useLayoutEffect: function(e, t) {
  return b1(4194308, 4, e, t);
}, useInsertionEffect: function(e, t) {
  return b1(4, 2, e, t);
}, useMemo: function(e, t) {
  var n = ts();
  return t = t === void 0 ? null : t, e = e(), n.memoizedState = [e, t], e;
}, useReducer: function(e, t, n) {
  var r = ts();
  return t = n !== void 0 ? n(t) : t, r.memoizedState = r.baseState = t, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: e, lastRenderedState: t }, r.queue = e, e = e.dispatch = GR.bind(null, dr, e), [r.memoizedState, e];
}, useRef: function(e) {
  var t = ts();
  return e = { current: e }, t.memoizedState = e;
}, useState: Ox, useDebugValue: _6, useDeferredValue: function(e) {
  return ts().memoizedState = e;
}, useTransition: function() {
  var e = Ox(!1), t = e[0];
  return e = ZR.bind(null, e[1]), ts().memoizedState = e, [t, e];
}, useMutableSource: function() {
}, useSyncExternalStore: function(e, t, n) {
  var r = dr, i = ts();
  if (Gn) {
    if (n === void 0) throw Error(Qe(407));
    n = n();
  } else {
    if (n = t(), Kr === null) throw Error(Qe(349));
    bc & 30 || bS(r, t, n);
  }
  i.memoizedState = n;
  var o = { value: n, getSnapshot: t };
  return i.queue = o, zx(CS.bind(
    null,
    r,
    o,
    e
  ), [e]), r.flags |= 2048, Up(9, wS.bind(null, r, o, n, t), void 0, null), n;
}, useId: function() {
  var e = ts(), t = Kr.identifierPrefix;
  if (Gn) {
    var n = Hs, r = $s;
    n = (r & ~(1 << 32 - Ra(r) - 1)).toString(32) + n, t = ":" + t + "R" + n, n = Hp++, 0 < n && (t += "H" + n.toString(32)), t += ":";
  } else n = WR++, t = ":" + t + "r" + n.toString(32) + ":";
  return e.memoizedState = t;
}, unstable_isNewReconciler: !1 }, QR = {
  readContext: da,
  useCallback: NS,
  useContext: da,
  useEffect: P6,
  useImperativeHandle: jS,
  useInsertionEffect: DS,
  useLayoutEffect: AS,
  useMemo: OS,
  useReducer: s4,
  useRef: SS,
  useState: function() {
    return s4(Vp);
  },
  useDebugValue: _6,
  useDeferredValue: function(e) {
    var t = pa();
    return zS(t, _r.memoizedState, e);
  },
  useTransition: function() {
    var e = s4(Vp)[0], t = pa().memoizedState;
    return [e, t];
  },
  useMutableSource: yS,
  useSyncExternalStore: xS,
  useId: FS,
  unstable_isNewReconciler: !1
}, YR = { readContext: da, useCallback: NS, useContext: da, useEffect: P6, useImperativeHandle: jS, useInsertionEffect: DS, useLayoutEffect: AS, useMemo: OS, useReducer: l4, useRef: SS, useState: function() {
  return l4(Vp);
}, useDebugValue: _6, useDeferredValue: function(e) {
  var t = pa();
  return _r === null ? t.memoizedState = e : zS(t, _r.memoizedState, e);
}, useTransition: function() {
  var e = l4(Vp)[0], t = pa().memoizedState;
  return [e, t];
}, useMutableSource: yS, useSyncExternalStore: xS, useId: FS, unstable_isNewReconciler: !1 };
function Oa(e, t) {
  if (e && e.defaultProps) {
    t = pr({}, t), e = e.defaultProps;
    for (var n in e) t[n] === void 0 && (t[n] = e[n]);
    return t;
  }
  return t;
}
function lv(e, t, n, r) {
  t = e.memoizedState, n = n(r, t), n = n == null ? t : pr({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
}
var ug = { isMounted: function(e) {
  return (e = e._reactInternals) ? Fc(e) === e : !1;
}, enqueueSetState: function(e, t, n) {
  e = e._reactInternals;
  var r = Mi(), i = ru(e), o = Gs(r, i);
  o.payload = t, n != null && (o.callback = n), t = tu(e, o, i), t !== null && (Pa(t, e, i, r), y1(t, e, i));
}, enqueueReplaceState: function(e, t, n) {
  e = e._reactInternals;
  var r = Mi(), i = ru(e), o = Gs(r, i);
  o.tag = 1, o.payload = t, n != null && (o.callback = n), t = tu(e, o, i), t !== null && (Pa(t, e, i, r), y1(t, e, i));
}, enqueueForceUpdate: function(e, t) {
  e = e._reactInternals;
  var n = Mi(), r = ru(e), i = Gs(n, r);
  i.tag = 2, t != null && (i.callback = t), t = tu(e, i, r), t !== null && (Pa(t, e, r, n), y1(t, e, r));
} };
function Fx(e, t, n, r, i, o, a) {
  return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, o, a) : t.prototype && t.prototype.isPureReactComponent ? !Ip(n, r) || !Ip(i, o) : !0;
}
function IS(e, t, n) {
  var r = !1, i = du, o = t.contextType;
  return typeof o == "object" && o !== null ? o = da(o) : (i = to(t) ? yc : xi.current, r = t.contextTypes, o = (r = r != null) ? R0(e, i) : du), t = new t(n, o), e.memoizedState = t.state !== null && t.state !== void 0 ? t.state : null, t.updater = ug, e.stateNode = t, t._reactInternals = e, r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = i, e.__reactInternalMemoizedMaskedChildContext = o), t;
}
function Lx(e, t, n, r) {
  e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && ug.enqueueReplaceState(t, t.state, null);
}
function uv(e, t, n, r) {
  var i = e.stateNode;
  i.props = n, i.state = e.memoizedState, i.refs = {}, z6(e);
  var o = t.contextType;
  typeof o == "object" && o !== null ? i.context = da(o) : (o = to(t) ? yc : xi.current, i.context = R0(e, o)), i.state = e.memoizedState, o = t.getDerivedStateFromProps, typeof o == "function" && (lv(e, t, o, n), i.state = e.memoizedState), typeof t.getDerivedStateFromProps == "function" || typeof i.getSnapshotBeforeUpdate == "function" || typeof i.UNSAFE_componentWillMount != "function" && typeof i.componentWillMount != "function" || (t = i.state, typeof i.componentWillMount == "function" && i.componentWillMount(), typeof i.UNSAFE_componentWillMount == "function" && i.UNSAFE_componentWillMount(), t !== i.state && ug.enqueueReplaceState(i, i.state, null), cm(e, n, i, r), i.state = e.memoizedState), typeof i.componentDidMount == "function" && (e.flags |= 4194308);
}
function $0(e, t) {
  try {
    var n = "", r = t;
    do
      n += DI(r), r = r.return;
    while (r);
    var i = n;
  } catch (o) {
    i = `
Error generating stack: ` + o.message + `
` + o.stack;
  }
  return { value: e, source: t, stack: i, digest: null };
}
function u4(e, t, n) {
  return { value: e, source: null, stack: n ?? null, digest: t ?? null };
}
function cv(e, t) {
  try {
    console.error(t.value);
  } catch (n) {
    setTimeout(function() {
      throw n;
    });
  }
}
var JR = typeof WeakMap == "function" ? WeakMap : Map;
function RS(e, t, n) {
  n = Gs(-1, n), n.tag = 3, n.payload = { element: null };
  var r = t.value;
  return n.callback = function() {
    mm || (mm = !0, bv = r), cv(e, t);
  }, n;
}
function PS(e, t, n) {
  n = Gs(-1, n), n.tag = 3;
  var r = e.type.getDerivedStateFromError;
  if (typeof r == "function") {
    var i = t.value;
    n.payload = function() {
      return r(i);
    }, n.callback = function() {
      cv(e, t);
    };
  }
  var o = e.stateNode;
  return o !== null && typeof o.componentDidCatch == "function" && (n.callback = function() {
    cv(e, t), typeof r != "function" && (nu === null ? nu = /* @__PURE__ */ new Set([this]) : nu.add(this));
    var a = t.stack;
    this.componentDidCatch(t.value, { componentStack: a !== null ? a : "" });
  }), n;
}
function Mx(e, t, n) {
  var r = e.pingCache;
  if (r === null) {
    r = e.pingCache = new JR();
    var i = /* @__PURE__ */ new Set();
    r.set(t, i);
  } else i = r.get(t), i === void 0 && (i = /* @__PURE__ */ new Set(), r.set(t, i));
  i.has(n) || (i.add(n), e = fP.bind(null, e, t, n), t.then(e, e));
}
function Bx(e) {
  do {
    var t;
    if ((t = e.tag === 13) && (t = e.memoizedState, t = t !== null ? t.dehydrated !== null : !0), t) return e;
    e = e.return;
  } while (e !== null);
  return null;
}
function Ix(e, t, n, r, i) {
  return e.mode & 1 ? (e.flags |= 65536, e.lanes = i, e) : (e === t ? e.flags |= 65536 : (e.flags |= 128, n.flags |= 131072, n.flags &= -52805, n.tag === 1 && (n.alternate === null ? n.tag = 17 : (t = Gs(-1, 1), t.tag = 2, tu(n, t, 1))), n.lanes |= 1), e);
}
var eP = ml.ReactCurrentOwner, Yi = !1;
function ji(e, t, n, r) {
  t.child = e === null ? hS(t, null, n, r) : _0(t, e.child, n, r);
}
function Rx(e, t, n, r, i) {
  n = n.render;
  var o = t.ref;
  return A0(t, i), r = I6(e, t, n, r, o, i), n = R6(), e !== null && !Yi ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~i, tl(e, t, i)) : (Gn && n && S6(t), t.flags |= 1, ji(e, t, r, i), t.child);
}
function Px(e, t, n, r, i) {
  if (e === null) {
    var o = n.type;
    return typeof o == "function" && !G6(o) && o.defaultProps === void 0 && n.compare === null && n.defaultProps === void 0 ? (t.tag = 15, t.type = o, _S(e, t, o, r, i)) : (e = E1(n.type, null, r, t, t.mode, i), e.ref = t.ref, e.return = t, t.child = e);
  }
  if (o = e.child, !(e.lanes & i)) {
    var a = o.memoizedProps;
    if (n = n.compare, n = n !== null ? n : Ip, n(a, r) && e.ref === t.ref) return tl(e, t, i);
  }
  return t.flags |= 1, e = iu(o, r), e.ref = t.ref, e.return = t, t.child = e;
}
function _S(e, t, n, r, i) {
  if (e !== null) {
    var o = e.memoizedProps;
    if (Ip(o, r) && e.ref === t.ref) if (Yi = !1, t.pendingProps = r = o, (e.lanes & i) !== 0) e.flags & 131072 && (Yi = !0);
    else return t.lanes = e.lanes, tl(e, t, i);
  }
  return dv(e, t, n, r, i);
}
function qS(e, t, n) {
  var r = t.pendingProps, i = r.children, o = e !== null ? e.memoizedState : null;
  if (r.mode === "hidden") if (!(t.mode & 1)) t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Ln(v0, Co), Co |= n;
  else {
    if (!(n & 1073741824)) return e = o !== null ? o.baseLanes | n : n, t.lanes = t.childLanes = 1073741824, t.memoizedState = { baseLanes: e, cachePool: null, transitions: null }, t.updateQueue = null, Ln(v0, Co), Co |= e, null;
    t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, r = o !== null ? o.baseLanes : n, Ln(v0, Co), Co |= r;
  }
  else o !== null ? (r = o.baseLanes | n, t.memoizedState = null) : r = n, Ln(v0, Co), Co |= r;
  return ji(e, t, i, n), t.child;
}
function $S(e, t) {
  var n = t.ref;
  (e === null && n !== null || e !== null && e.ref !== n) && (t.flags |= 512, t.flags |= 2097152);
}
function dv(e, t, n, r, i) {
  var o = to(n) ? yc : xi.current;
  return o = R0(t, o), A0(t, i), n = I6(e, t, n, r, o, i), r = R6(), e !== null && !Yi ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~i, tl(e, t, i)) : (Gn && r && S6(t), t.flags |= 1, ji(e, t, n, i), t.child);
}
function _x(e, t, n, r, i) {
  if (to(n)) {
    var o = !0;
    om(t);
  } else o = !1;
  if (A0(t, i), t.stateNode === null) w1(e, t), IS(t, n, r), uv(t, n, r, i), r = !0;
  else if (e === null) {
    var a = t.stateNode, s = t.memoizedProps;
    a.props = s;
    var l = a.context, u = n.contextType;
    typeof u == "object" && u !== null ? u = da(u) : (u = to(n) ? yc : xi.current, u = R0(t, u));
    var d = n.getDerivedStateFromProps, p = typeof d == "function" || typeof a.getSnapshotBeforeUpdate == "function";
    p || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (s !== r || l !== u) && Lx(t, a, r, u), Bl = !1;
    var f = t.memoizedState;
    a.state = f, cm(t, r, a, i), l = t.memoizedState, s !== r || f !== l || eo.current || Bl ? (typeof d == "function" && (lv(t, n, d, r), l = t.memoizedState), (s = Bl || Fx(t, n, s, r, f, l, u)) ? (p || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount()), typeof a.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), a.props = r, a.state = l, a.context = u, r = s) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
  } else {
    a = t.stateNode, gS(e, t), s = t.memoizedProps, u = t.type === t.elementType ? s : Oa(t.type, s), a.props = u, p = t.pendingProps, f = a.context, l = n.contextType, typeof l == "object" && l !== null ? l = da(l) : (l = to(n) ? yc : xi.current, l = R0(t, l));
    var m = n.getDerivedStateFromProps;
    (d = typeof m == "function" || typeof a.getSnapshotBeforeUpdate == "function") || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (s !== p || f !== l) && Lx(t, a, r, l), Bl = !1, f = t.memoizedState, a.state = f, cm(t, r, a, i);
    var y = t.memoizedState;
    s !== p || f !== y || eo.current || Bl ? (typeof m == "function" && (lv(t, n, m, r), y = t.memoizedState), (u = Bl || Fx(t, n, u, r, f, y, l) || !1) ? (d || typeof a.UNSAFE_componentWillUpdate != "function" && typeof a.componentWillUpdate != "function" || (typeof a.componentWillUpdate == "function" && a.componentWillUpdate(r, y, l), typeof a.UNSAFE_componentWillUpdate == "function" && a.UNSAFE_componentWillUpdate(r, y, l)), typeof a.componentDidUpdate == "function" && (t.flags |= 4), typeof a.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof a.componentDidUpdate != "function" || s === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || s === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = y), a.props = r, a.state = y, a.context = l, r = u) : (typeof a.componentDidUpdate != "function" || s === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || s === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1);
  }
  return pv(e, t, n, r, o, i);
}
function pv(e, t, n, r, i, o) {
  $S(e, t);
  var a = (t.flags & 128) !== 0;
  if (!r && !a) return i && Sx(t, n, !1), tl(e, t, o);
  r = t.stateNode, eP.current = t;
  var s = a && typeof n.getDerivedStateFromError != "function" ? null : r.render();
  return t.flags |= 1, e !== null && a ? (t.child = _0(t, e.child, null, o), t.child = _0(t, null, s, o)) : ji(e, t, s, o), t.memoizedState = r.state, i && Sx(t, n, !0), t.child;
}
function HS(e) {
  var t = e.stateNode;
  t.pendingContext ? Ex(e, t.pendingContext, t.pendingContext !== t.context) : t.context && Ex(e, t.context, !1), F6(e, t.containerInfo);
}
function qx(e, t, n, r, i) {
  return P0(), A6(i), t.flags |= 256, ji(e, t, n, r), t.child;
}
var fv = { dehydrated: null, treeContext: null, retryLane: 0 };
function hv(e) {
  return { baseLanes: e, cachePool: null, transitions: null };
}
function VS(e, t, n) {
  var r = t.pendingProps, i = lr.current, o = !1, a = (t.flags & 128) !== 0, s;
  if ((s = a) || (s = e !== null && e.memoizedState === null ? !1 : (i & 2) !== 0), s ? (o = !0, t.flags &= -129) : (e === null || e.memoizedState !== null) && (i |= 1), Ln(lr, i & 1), e === null)
    return av(t), e = t.memoizedState, e !== null && (e = e.dehydrated, e !== null) ? (t.mode & 1 ? e.data === "$!" ? t.lanes = 8 : t.lanes = 1073741824 : t.lanes = 1, null) : (a = r.children, e = r.fallback, o ? (r = t.mode, o = t.child, a = { mode: "hidden", children: a }, !(r & 1) && o !== null ? (o.childLanes = 0, o.pendingProps = a) : o = pg(a, r, 0, null), e = pc(e, r, n, null), o.return = t, e.return = t, o.sibling = e, t.child = o, t.child.memoizedState = hv(n), t.memoizedState = fv, e) : q6(t, a));
  if (i = e.memoizedState, i !== null && (s = i.dehydrated, s !== null)) return tP(e, t, a, r, s, i, n);
  if (o) {
    o = r.fallback, a = t.mode, i = e.child, s = i.sibling;
    var l = { mode: "hidden", children: r.children };
    return !(a & 1) && t.child !== i ? (r = t.child, r.childLanes = 0, r.pendingProps = l, t.deletions = null) : (r = iu(i, l), r.subtreeFlags = i.subtreeFlags & 14680064), s !== null ? o = iu(s, o) : (o = pc(o, a, n, null), o.flags |= 2), o.return = t, r.return = t, r.sibling = o, t.child = r, r = o, o = t.child, a = e.child.memoizedState, a = a === null ? hv(n) : { baseLanes: a.baseLanes | n, cachePool: null, transitions: a.transitions }, o.memoizedState = a, o.childLanes = e.childLanes & ~n, t.memoizedState = fv, r;
  }
  return o = e.child, e = o.sibling, r = iu(o, { mode: "visible", children: r.children }), !(t.mode & 1) && (r.lanes = n), r.return = t, r.sibling = null, e !== null && (n = t.deletions, n === null ? (t.deletions = [e], t.flags |= 16) : n.push(e)), t.child = r, t.memoizedState = null, r;
}
function q6(e, t) {
  return t = pg({ mode: "visible", children: t }, e.mode, 0, null), t.return = e, e.child = t;
}
function Ah(e, t, n, r) {
  return r !== null && A6(r), _0(t, e.child, null, n), e = q6(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
}
function tP(e, t, n, r, i, o, a) {
  if (n)
    return t.flags & 256 ? (t.flags &= -257, r = u4(Error(Qe(422))), Ah(e, t, a, r)) : t.memoizedState !== null ? (t.child = e.child, t.flags |= 128, null) : (o = r.fallback, i = t.mode, r = pg({ mode: "visible", children: r.children }, i, 0, null), o = pc(o, i, a, null), o.flags |= 2, r.return = t, o.return = t, r.sibling = o, t.child = r, t.mode & 1 && _0(t, e.child, null, a), t.child.memoizedState = hv(a), t.memoizedState = fv, o);
  if (!(t.mode & 1)) return Ah(e, t, a, null);
  if (i.data === "$!") {
    if (r = i.nextSibling && i.nextSibling.dataset, r) var s = r.dgst;
    return r = s, o = Error(Qe(419)), r = u4(o, r, void 0), Ah(e, t, a, r);
  }
  if (s = (a & e.childLanes) !== 0, Yi || s) {
    if (r = Kr, r !== null) {
      switch (a & -a) {
        case 4:
          i = 2;
          break;
        case 16:
          i = 8;
          break;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          i = 32;
          break;
        case 536870912:
          i = 268435456;
          break;
        default:
          i = 0;
      }
      i = i & (r.suspendedLanes | a) ? 0 : i, i !== 0 && i !== o.retryLane && (o.retryLane = i, el(e, i), Pa(r, e, i, -1));
    }
    return Z6(), r = u4(Error(Qe(421))), Ah(e, t, a, r);
  }
  return i.data === "$?" ? (t.flags |= 128, t.child = e.child, t = hP.bind(null, e), i._reactRetry = t, null) : (e = o.treeContext, Ao = eu(i.nextSibling), No = t, Gn = !0, La = null, e !== null && (Jo[ea++] = $s, Jo[ea++] = Hs, Jo[ea++] = xc, $s = e.id, Hs = e.overflow, xc = t), t = q6(t, r.children), t.flags |= 4096, t);
}
function $x(e, t, n) {
  e.lanes |= t;
  var r = e.alternate;
  r !== null && (r.lanes |= t), sv(e.return, t, n);
}
function c4(e, t, n, r, i) {
  var o = e.memoizedState;
  o === null ? e.memoizedState = { isBackwards: t, rendering: null, renderingStartTime: 0, last: r, tail: n, tailMode: i } : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i);
}
function US(e, t, n) {
  var r = t.pendingProps, i = r.revealOrder, o = r.tail;
  if (ji(e, t, r.children, n), r = lr.current, r & 2) r = r & 1 | 2, t.flags |= 128;
  else {
    if (e !== null && e.flags & 128) e: for (e = t.child; e !== null; ) {
      if (e.tag === 13) e.memoizedState !== null && $x(e, n, t);
      else if (e.tag === 19) $x(e, n, t);
      else if (e.child !== null) {
        e.child.return = e, e = e.child;
        continue;
      }
      if (e === t) break e;
      for (; e.sibling === null; ) {
        if (e.return === null || e.return === t) break e;
        e = e.return;
      }
      e.sibling.return = e.return, e = e.sibling;
    }
    r &= 1;
  }
  if (Ln(lr, r), !(t.mode & 1)) t.memoizedState = null;
  else switch (i) {
    case "forwards":
      for (n = t.child, i = null; n !== null; ) e = n.alternate, e !== null && dm(e) === null && (i = n), n = n.sibling;
      n = i, n === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), c4(t, !1, i, n, o);
      break;
    case "backwards":
      for (n = null, i = t.child, t.child = null; i !== null; ) {
        if (e = i.alternate, e !== null && dm(e) === null) {
          t.child = i;
          break;
        }
        e = i.sibling, i.sibling = n, n = i, i = e;
      }
      c4(t, !0, n, null, o);
      break;
    case "together":
      c4(t, !1, null, null, void 0);
      break;
    default:
      t.memoizedState = null;
  }
  return t.child;
}
function w1(e, t) {
  !(t.mode & 1) && e !== null && (e.alternate = null, t.alternate = null, t.flags |= 2);
}
function tl(e, t, n) {
  if (e !== null && (t.dependencies = e.dependencies), wc |= t.lanes, !(n & t.childLanes)) return null;
  if (e !== null && t.child !== e.child) throw Error(Qe(153));
  if (t.child !== null) {
    for (e = t.child, n = iu(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null; ) e = e.sibling, n = n.sibling = iu(e, e.pendingProps), n.return = t;
    n.sibling = null;
  }
  return t.child;
}
function nP(e, t, n) {
  switch (t.tag) {
    case 3:
      HS(t), P0();
      break;
    case 5:
      vS(t);
      break;
    case 1:
      to(t.type) && om(t);
      break;
    case 4:
      F6(t, t.stateNode.containerInfo);
      break;
    case 10:
      var r = t.type._context, i = t.memoizedProps.value;
      Ln(lm, r._currentValue), r._currentValue = i;
      break;
    case 13:
      if (r = t.memoizedState, r !== null)
        return r.dehydrated !== null ? (Ln(lr, lr.current & 1), t.flags |= 128, null) : n & t.child.childLanes ? VS(e, t, n) : (Ln(lr, lr.current & 1), e = tl(e, t, n), e !== null ? e.sibling : null);
      Ln(lr, lr.current & 1);
      break;
    case 19:
      if (r = (n & t.childLanes) !== 0, e.flags & 128) {
        if (r) return US(e, t, n);
        t.flags |= 128;
      }
      if (i = t.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), Ln(lr, lr.current), r) break;
      return null;
    case 22:
    case 23:
      return t.lanes = 0, qS(e, t, n);
  }
  return tl(e, t, n);
}
var WS, mv, ZS, GS;
WS = function(e, t) {
  for (var n = t.child; n !== null; ) {
    if (n.tag === 5 || n.tag === 6) e.appendChild(n.stateNode);
    else if (n.tag !== 4 && n.child !== null) {
      n.child.return = n, n = n.child;
      continue;
    }
    if (n === t) break;
    for (; n.sibling === null; ) {
      if (n.return === null || n.return === t) return;
      n = n.return;
    }
    n.sibling.return = n.return, n = n.sibling;
  }
};
mv = function() {
};
ZS = function(e, t, n, r) {
  var i = e.memoizedProps;
  if (i !== r) {
    e = t.stateNode, lc(ls.current);
    var o = null;
    switch (n) {
      case "input":
        i = I3(e, i), r = I3(e, r), o = [];
        break;
      case "select":
        i = pr({}, i, { value: void 0 }), r = pr({}, r, { value: void 0 }), o = [];
        break;
      case "textarea":
        i = _3(e, i), r = _3(e, r), o = [];
        break;
      default:
        typeof i.onClick != "function" && typeof r.onClick == "function" && (e.onclick = rm);
    }
    $3(n, r);
    var a;
    n = null;
    for (u in i) if (!r.hasOwnProperty(u) && i.hasOwnProperty(u) && i[u] != null) if (u === "style") {
      var s = i[u];
      for (a in s) s.hasOwnProperty(a) && (n || (n = {}), n[a] = "");
    } else u !== "dangerouslySetInnerHTML" && u !== "children" && u !== "suppressContentEditableWarning" && u !== "suppressHydrationWarning" && u !== "autoFocus" && (Np.hasOwnProperty(u) ? o || (o = []) : (o = o || []).push(u, null));
    for (u in r) {
      var l = r[u];
      if (s = i != null ? i[u] : void 0, r.hasOwnProperty(u) && l !== s && (l != null || s != null)) if (u === "style") if (s) {
        for (a in s) !s.hasOwnProperty(a) || l && l.hasOwnProperty(a) || (n || (n = {}), n[a] = "");
        for (a in l) l.hasOwnProperty(a) && s[a] !== l[a] && (n || (n = {}), n[a] = l[a]);
      } else n || (o || (o = []), o.push(
        u,
        n
      )), n = l;
      else u === "dangerouslySetInnerHTML" ? (l = l ? l.__html : void 0, s = s ? s.__html : void 0, l != null && s !== l && (o = o || []).push(u, l)) : u === "children" ? typeof l != "string" && typeof l != "number" || (o = o || []).push(u, "" + l) : u !== "suppressContentEditableWarning" && u !== "suppressHydrationWarning" && (Np.hasOwnProperty(u) ? (l != null && u === "onScroll" && _n("scroll", e), o || s === l || (o = [])) : (o = o || []).push(u, l));
    }
    n && (o = o || []).push("style", n);
    var u = o;
    (t.updateQueue = u) && (t.flags |= 4);
  }
};
GS = function(e, t, n, r) {
  n !== r && (t.flags |= 4);
};
function Rd(e, t) {
  if (!Gn) switch (e.tailMode) {
    case "hidden":
      t = e.tail;
      for (var n = null; t !== null; ) t.alternate !== null && (n = t), t = t.sibling;
      n === null ? e.tail = null : n.sibling = null;
      break;
    case "collapsed":
      n = e.tail;
      for (var r = null; n !== null; ) n.alternate !== null && (r = n), n = n.sibling;
      r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
  }
}
function fi(e) {
  var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
  if (t) for (var i = e.child; i !== null; ) n |= i.lanes | i.childLanes, r |= i.subtreeFlags & 14680064, r |= i.flags & 14680064, i.return = e, i = i.sibling;
  else for (i = e.child; i !== null; ) n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
  return e.subtreeFlags |= r, e.childLanes = n, t;
}
function rP(e, t, n) {
  var r = t.pendingProps;
  switch (D6(t), t.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return fi(t), null;
    case 1:
      return to(t.type) && im(), fi(t), null;
    case 3:
      return r = t.stateNode, q0(), Hn(eo), Hn(xi), M6(), r.pendingContext && (r.context = r.pendingContext, r.pendingContext = null), (e === null || e.child === null) && (Sh(t) ? t.flags |= 4 : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, La !== null && (kv(La), La = null))), mv(e, t), fi(t), null;
    case 5:
      L6(t);
      var i = lc($p.current);
      if (n = t.type, e !== null && t.stateNode != null) ZS(e, t, n, r, i), e.ref !== t.ref && (t.flags |= 512, t.flags |= 2097152);
      else {
        if (!r) {
          if (t.stateNode === null) throw Error(Qe(166));
          return fi(t), null;
        }
        if (e = lc(ls.current), Sh(t)) {
          r = t.stateNode, n = t.type;
          var o = t.memoizedProps;
          switch (r[is] = t, r[_p] = o, e = (t.mode & 1) !== 0, n) {
            case "dialog":
              _n("cancel", r), _n("close", r);
              break;
            case "iframe":
            case "object":
            case "embed":
              _n("load", r);
              break;
            case "video":
            case "audio":
              for (i = 0; i < Yd.length; i++) _n(Yd[i], r);
              break;
            case "source":
              _n("error", r);
              break;
            case "img":
            case "image":
            case "link":
              _n(
                "error",
                r
              ), _n("load", r);
              break;
            case "details":
              _n("toggle", r);
              break;
            case "input":
              Q8(r, o), _n("invalid", r);
              break;
            case "select":
              r._wrapperState = { wasMultiple: !!o.multiple }, _n("invalid", r);
              break;
            case "textarea":
              J8(r, o), _n("invalid", r);
          }
          $3(n, o), i = null;
          for (var a in o) if (o.hasOwnProperty(a)) {
            var s = o[a];
            a === "children" ? typeof s == "string" ? r.textContent !== s && (o.suppressHydrationWarning !== !0 && Eh(r.textContent, s, e), i = ["children", s]) : typeof s == "number" && r.textContent !== "" + s && (o.suppressHydrationWarning !== !0 && Eh(
              r.textContent,
              s,
              e
            ), i = ["children", "" + s]) : Np.hasOwnProperty(a) && s != null && a === "onScroll" && _n("scroll", r);
          }
          switch (n) {
            case "input":
              gh(r), Y8(r, o, !0);
              break;
            case "textarea":
              gh(r), ex(r);
              break;
            case "select":
            case "option":
              break;
            default:
              typeof o.onClick == "function" && (r.onclick = rm);
          }
          r = i, t.updateQueue = r, r !== null && (t.flags |= 4);
        } else {
          a = i.nodeType === 9 ? i : i.ownerDocument, e === "http://www.w3.org/1999/xhtml" && (e = CE(n)), e === "http://www.w3.org/1999/xhtml" ? n === "script" ? (e = a.createElement("div"), e.innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild)) : typeof r.is == "string" ? e = a.createElement(n, { is: r.is }) : (e = a.createElement(n), n === "select" && (a = e, r.multiple ? a.multiple = !0 : r.size && (a.size = r.size))) : e = a.createElementNS(e, n), e[is] = t, e[_p] = r, WS(e, t, !1, !1), t.stateNode = e;
          e: {
            switch (a = H3(n, r), n) {
              case "dialog":
                _n("cancel", e), _n("close", e), i = r;
                break;
              case "iframe":
              case "object":
              case "embed":
                _n("load", e), i = r;
                break;
              case "video":
              case "audio":
                for (i = 0; i < Yd.length; i++) _n(Yd[i], e);
                i = r;
                break;
              case "source":
                _n("error", e), i = r;
                break;
              case "img":
              case "image":
              case "link":
                _n(
                  "error",
                  e
                ), _n("load", e), i = r;
                break;
              case "details":
                _n("toggle", e), i = r;
                break;
              case "input":
                Q8(e, r), i = I3(e, r), _n("invalid", e);
                break;
              case "option":
                i = r;
                break;
              case "select":
                e._wrapperState = { wasMultiple: !!r.multiple }, i = pr({}, r, { value: void 0 }), _n("invalid", e);
                break;
              case "textarea":
                J8(e, r), i = _3(e, r), _n("invalid", e);
                break;
              default:
                i = r;
            }
            $3(n, i), s = i;
            for (o in s) if (s.hasOwnProperty(o)) {
              var l = s[o];
              o === "style" ? SE(e, l) : o === "dangerouslySetInnerHTML" ? (l = l ? l.__html : void 0, l != null && kE(e, l)) : o === "children" ? typeof l == "string" ? (n !== "textarea" || l !== "") && Op(e, l) : typeof l == "number" && Op(e, "" + l) : o !== "suppressContentEditableWarning" && o !== "suppressHydrationWarning" && o !== "autoFocus" && (Np.hasOwnProperty(o) ? l != null && o === "onScroll" && _n("scroll", e) : l != null && d6(e, o, l, a));
            }
            switch (n) {
              case "input":
                gh(e), Y8(e, r, !1);
                break;
              case "textarea":
                gh(e), ex(e);
                break;
              case "option":
                r.value != null && e.setAttribute("value", "" + cu(r.value));
                break;
              case "select":
                e.multiple = !!r.multiple, o = r.value, o != null ? k0(e, !!r.multiple, o, !1) : r.defaultValue != null && k0(
                  e,
                  !!r.multiple,
                  r.defaultValue,
                  !0
                );
                break;
              default:
                typeof i.onClick == "function" && (e.onclick = rm);
            }
            switch (n) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                r = !!r.autoFocus;
                break e;
              case "img":
                r = !0;
                break e;
              default:
                r = !1;
            }
          }
          r && (t.flags |= 4);
        }
        t.ref !== null && (t.flags |= 512, t.flags |= 2097152);
      }
      return fi(t), null;
    case 6:
      if (e && t.stateNode != null) GS(e, t, e.memoizedProps, r);
      else {
        if (typeof r != "string" && t.stateNode === null) throw Error(Qe(166));
        if (n = lc($p.current), lc(ls.current), Sh(t)) {
          if (r = t.stateNode, n = t.memoizedProps, r[is] = t, (o = r.nodeValue !== n) && (e = No, e !== null)) switch (e.tag) {
            case 3:
              Eh(r.nodeValue, n, (e.mode & 1) !== 0);
              break;
            case 5:
              e.memoizedProps.suppressHydrationWarning !== !0 && Eh(r.nodeValue, n, (e.mode & 1) !== 0);
          }
          o && (t.flags |= 4);
        } else r = (n.nodeType === 9 ? n : n.ownerDocument).createTextNode(r), r[is] = t, t.stateNode = r;
      }
      return fi(t), null;
    case 13:
      if (Hn(lr), r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
        if (Gn && Ao !== null && t.mode & 1 && !(t.flags & 128)) pS(), P0(), t.flags |= 98560, o = !1;
        else if (o = Sh(t), r !== null && r.dehydrated !== null) {
          if (e === null) {
            if (!o) throw Error(Qe(318));
            if (o = t.memoizedState, o = o !== null ? o.dehydrated : null, !o) throw Error(Qe(317));
            o[is] = t;
          } else P0(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
          fi(t), o = !1;
        } else La !== null && (kv(La), La = null), o = !0;
        if (!o) return t.flags & 65536 ? t : null;
      }
      return t.flags & 128 ? (t.lanes = n, t) : (r = r !== null, r !== (e !== null && e.memoizedState !== null) && r && (t.child.flags |= 8192, t.mode & 1 && (e === null || lr.current & 1 ? $r === 0 && ($r = 3) : Z6())), t.updateQueue !== null && (t.flags |= 4), fi(t), null);
    case 4:
      return q0(), mv(e, t), e === null && Rp(t.stateNode.containerInfo), fi(t), null;
    case 10:
      return N6(t.type._context), fi(t), null;
    case 17:
      return to(t.type) && im(), fi(t), null;
    case 19:
      if (Hn(lr), o = t.memoizedState, o === null) return fi(t), null;
      if (r = (t.flags & 128) !== 0, a = o.rendering, a === null) if (r) Rd(o, !1);
      else {
        if ($r !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null; ) {
          if (a = dm(e), a !== null) {
            for (t.flags |= 128, Rd(o, !1), r = a.updateQueue, r !== null && (t.updateQueue = r, t.flags |= 4), t.subtreeFlags = 0, r = n, n = t.child; n !== null; ) o = n, e = r, o.flags &= 14680066, a = o.alternate, a === null ? (o.childLanes = 0, o.lanes = e, o.child = null, o.subtreeFlags = 0, o.memoizedProps = null, o.memoizedState = null, o.updateQueue = null, o.dependencies = null, o.stateNode = null) : (o.childLanes = a.childLanes, o.lanes = a.lanes, o.child = a.child, o.subtreeFlags = 0, o.deletions = null, o.memoizedProps = a.memoizedProps, o.memoizedState = a.memoizedState, o.updateQueue = a.updateQueue, o.type = a.type, e = a.dependencies, o.dependencies = e === null ? null : { lanes: e.lanes, firstContext: e.firstContext }), n = n.sibling;
            return Ln(lr, lr.current & 1 | 2), t.child;
          }
          e = e.sibling;
        }
        o.tail !== null && kr() > H0 && (t.flags |= 128, r = !0, Rd(o, !1), t.lanes = 4194304);
      }
      else {
        if (!r) if (e = dm(a), e !== null) {
          if (t.flags |= 128, r = !0, n = e.updateQueue, n !== null && (t.updateQueue = n, t.flags |= 4), Rd(o, !0), o.tail === null && o.tailMode === "hidden" && !a.alternate && !Gn) return fi(t), null;
        } else 2 * kr() - o.renderingStartTime > H0 && n !== 1073741824 && (t.flags |= 128, r = !0, Rd(o, !1), t.lanes = 4194304);
        o.isBackwards ? (a.sibling = t.child, t.child = a) : (n = o.last, n !== null ? n.sibling = a : t.child = a, o.last = a);
      }
      return o.tail !== null ? (t = o.tail, o.rendering = t, o.tail = t.sibling, o.renderingStartTime = kr(), t.sibling = null, n = lr.current, Ln(lr, r ? n & 1 | 2 : n & 1), t) : (fi(t), null);
    case 22:
    case 23:
      return W6(), r = t.memoizedState !== null, e !== null && e.memoizedState !== null !== r && (t.flags |= 8192), r && t.mode & 1 ? Co & 1073741824 && (fi(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : fi(t), null;
    case 24:
      return null;
    case 25:
      return null;
  }
  throw Error(Qe(156, t.tag));
}
function iP(e, t) {
  switch (D6(t), t.tag) {
    case 1:
      return to(t.type) && im(), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
    case 3:
      return q0(), Hn(eo), Hn(xi), M6(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
    case 5:
      return L6(t), null;
    case 13:
      if (Hn(lr), e = t.memoizedState, e !== null && e.dehydrated !== null) {
        if (t.alternate === null) throw Error(Qe(340));
        P0();
      }
      return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
    case 19:
      return Hn(lr), null;
    case 4:
      return q0(), null;
    case 10:
      return N6(t.type._context), null;
    case 22:
    case 23:
      return W6(), null;
    case 24:
      return null;
    default:
      return null;
  }
}
var Th = !1, vi = !1, oP = typeof WeakSet == "function" ? WeakSet : Set, bt = null;
function g0(e, t) {
  var n = e.ref;
  if (n !== null) if (typeof n == "function") try {
    n(null);
  } catch (r) {
    mr(e, t, r);
  }
  else n.current = null;
}
function gv(e, t, n) {
  try {
    n();
  } catch (r) {
    mr(e, t, r);
  }
}
var Hx = !1;
function aP(e, t) {
  if (J3 = em, e = JE(), E6(e)) {
    if ("selectionStart" in e) var n = { start: e.selectionStart, end: e.selectionEnd };
    else e: {
      n = (n = e.ownerDocument) && n.defaultView || window;
      var r = n.getSelection && n.getSelection();
      if (r && r.rangeCount !== 0) {
        n = r.anchorNode;
        var i = r.anchorOffset, o = r.focusNode;
        r = r.focusOffset;
        try {
          n.nodeType, o.nodeType;
        } catch {
          n = null;
          break e;
        }
        var a = 0, s = -1, l = -1, u = 0, d = 0, p = e, f = null;
        t: for (; ; ) {
          for (var m; p !== n || i !== 0 && p.nodeType !== 3 || (s = a + i), p !== o || r !== 0 && p.nodeType !== 3 || (l = a + r), p.nodeType === 3 && (a += p.nodeValue.length), (m = p.firstChild) !== null; )
            f = p, p = m;
          for (; ; ) {
            if (p === e) break t;
            if (f === n && ++u === i && (s = a), f === o && ++d === r && (l = a), (m = p.nextSibling) !== null) break;
            p = f, f = p.parentNode;
          }
          p = m;
        }
        n = s === -1 || l === -1 ? null : { start: s, end: l };
      } else n = null;
    }
    n = n || { start: 0, end: 0 };
  } else n = null;
  for (ev = { focusedElem: e, selectionRange: n }, em = !1, bt = t; bt !== null; ) if (t = bt, e = t.child, (t.subtreeFlags & 1028) !== 0 && e !== null) e.return = t, bt = e;
  else for (; bt !== null; ) {
    t = bt;
    try {
      var y = t.alternate;
      if (t.flags & 1024) switch (t.tag) {
        case 0:
        case 11:
        case 15:
          break;
        case 1:
          if (y !== null) {
            var g = y.memoizedProps, x = y.memoizedState, E = t.stateNode, b = E.getSnapshotBeforeUpdate(t.elementType === t.type ? g : Oa(t.type, g), x);
            E.__reactInternalSnapshotBeforeUpdate = b;
          }
          break;
        case 3:
          var C = t.stateNode.containerInfo;
          C.nodeType === 1 ? C.textContent = "" : C.nodeType === 9 && C.documentElement && C.removeChild(C.documentElement);
          break;
        case 5:
        case 6:
        case 4:
        case 17:
          break;
        default:
          throw Error(Qe(163));
      }
    } catch (T) {
      mr(t, t.return, T);
    }
    if (e = t.sibling, e !== null) {
      e.return = t.return, bt = e;
      break;
    }
    bt = t.return;
  }
  return y = Hx, Hx = !1, y;
}
function hp(e, t, n) {
  var r = t.updateQueue;
  if (r = r !== null ? r.lastEffect : null, r !== null) {
    var i = r = r.next;
    do {
      if ((i.tag & e) === e) {
        var o = i.destroy;
        i.destroy = void 0, o !== void 0 && gv(t, n, o);
      }
      i = i.next;
    } while (i !== r);
  }
}
function cg(e, t) {
  if (t = t.updateQueue, t = t !== null ? t.lastEffect : null, t !== null) {
    var n = t = t.next;
    do {
      if ((n.tag & e) === e) {
        var r = n.create;
        n.destroy = r();
      }
      n = n.next;
    } while (n !== t);
  }
}
function vv(e) {
  var t = e.ref;
  if (t !== null) {
    var n = e.stateNode;
    switch (e.tag) {
      case 5:
        e = n;
        break;
      default:
        e = n;
    }
    typeof t == "function" ? t(e) : t.current = e;
  }
}
function KS(e) {
  var t = e.alternate;
  t !== null && (e.alternate = null, KS(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && (delete t[is], delete t[_p], delete t[rv], delete t[$R], delete t[HR])), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
}
function XS(e) {
  return e.tag === 5 || e.tag === 3 || e.tag === 4;
}
function Vx(e) {
  e: for (; ; ) {
    for (; e.sibling === null; ) {
      if (e.return === null || XS(e.return)) return null;
      e = e.return;
    }
    for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
      if (e.flags & 2 || e.child === null || e.tag === 4) continue e;
      e.child.return = e, e = e.child;
    }
    if (!(e.flags & 2)) return e.stateNode;
  }
}
function yv(e, t, n) {
  var r = e.tag;
  if (r === 5 || r === 6) e = e.stateNode, t ? n.nodeType === 8 ? n.parentNode.insertBefore(e, t) : n.insertBefore(e, t) : (n.nodeType === 8 ? (t = n.parentNode, t.insertBefore(e, n)) : (t = n, t.appendChild(e)), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = rm));
  else if (r !== 4 && (e = e.child, e !== null)) for (yv(e, t, n), e = e.sibling; e !== null; ) yv(e, t, n), e = e.sibling;
}
function xv(e, t, n) {
  var r = e.tag;
  if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
  else if (r !== 4 && (e = e.child, e !== null)) for (xv(e, t, n), e = e.sibling; e !== null; ) xv(e, t, n), e = e.sibling;
}
var ei = null, za = !1;
function Al(e, t, n) {
  for (n = n.child; n !== null; ) QS(e, t, n), n = n.sibling;
}
function QS(e, t, n) {
  if (ss && typeof ss.onCommitFiberUnmount == "function") try {
    ss.onCommitFiberUnmount(ng, n);
  } catch {
  }
  switch (n.tag) {
    case 5:
      vi || g0(n, t);
    case 6:
      var r = ei, i = za;
      ei = null, Al(e, t, n), ei = r, za = i, ei !== null && (za ? (e = ei, n = n.stateNode, e.nodeType === 8 ? e.parentNode.removeChild(n) : e.removeChild(n)) : ei.removeChild(n.stateNode));
      break;
    case 18:
      ei !== null && (za ? (e = ei, n = n.stateNode, e.nodeType === 8 ? r4(e.parentNode, n) : e.nodeType === 1 && r4(e, n), Mp(e)) : r4(ei, n.stateNode));
      break;
    case 4:
      r = ei, i = za, ei = n.stateNode.containerInfo, za = !0, Al(e, t, n), ei = r, za = i;
      break;
    case 0:
    case 11:
    case 14:
    case 15:
      if (!vi && (r = n.updateQueue, r !== null && (r = r.lastEffect, r !== null))) {
        i = r = r.next;
        do {
          var o = i, a = o.destroy;
          o = o.tag, a !== void 0 && (o & 2 || o & 4) && gv(n, t, a), i = i.next;
        } while (i !== r);
      }
      Al(e, t, n);
      break;
    case 1:
      if (!vi && (g0(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function")) try {
        r.props = n.memoizedProps, r.state = n.memoizedState, r.componentWillUnmount();
      } catch (s) {
        mr(n, t, s);
      }
      Al(e, t, n);
      break;
    case 21:
      Al(e, t, n);
      break;
    case 22:
      n.mode & 1 ? (vi = (r = vi) || n.memoizedState !== null, Al(e, t, n), vi = r) : Al(e, t, n);
      break;
    default:
      Al(e, t, n);
  }
}
function Ux(e) {
  var t = e.updateQueue;
  if (t !== null) {
    e.updateQueue = null;
    var n = e.stateNode;
    n === null && (n = e.stateNode = new oP()), t.forEach(function(r) {
      var i = mP.bind(null, e, r);
      n.has(r) || (n.add(r), r.then(i, i));
    });
  }
}
function Ta(e, t) {
  var n = t.deletions;
  if (n !== null) for (var r = 0; r < n.length; r++) {
    var i = n[r];
    try {
      var o = e, a = t, s = a;
      e: for (; s !== null; ) {
        switch (s.tag) {
          case 5:
            ei = s.stateNode, za = !1;
            break e;
          case 3:
            ei = s.stateNode.containerInfo, za = !0;
            break e;
          case 4:
            ei = s.stateNode.containerInfo, za = !0;
            break e;
        }
        s = s.return;
      }
      if (ei === null) throw Error(Qe(160));
      QS(o, a, i), ei = null, za = !1;
      var l = i.alternate;
      l !== null && (l.return = null), i.return = null;
    } catch (u) {
      mr(i, t, u);
    }
  }
  if (t.subtreeFlags & 12854) for (t = t.child; t !== null; ) YS(t, e), t = t.sibling;
}
function YS(e, t) {
  var n = e.alternate, r = e.flags;
  switch (e.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      if (Ta(t, e), Ya(e), r & 4) {
        try {
          hp(3, e, e.return), cg(3, e);
        } catch (g) {
          mr(e, e.return, g);
        }
        try {
          hp(5, e, e.return);
        } catch (g) {
          mr(e, e.return, g);
        }
      }
      break;
    case 1:
      Ta(t, e), Ya(e), r & 512 && n !== null && g0(n, n.return);
      break;
    case 5:
      if (Ta(t, e), Ya(e), r & 512 && n !== null && g0(n, n.return), e.flags & 32) {
        var i = e.stateNode;
        try {
          Op(i, "");
        } catch (g) {
          mr(e, e.return, g);
        }
      }
      if (r & 4 && (i = e.stateNode, i != null)) {
        var o = e.memoizedProps, a = n !== null ? n.memoizedProps : o, s = e.type, l = e.updateQueue;
        if (e.updateQueue = null, l !== null) try {
          s === "input" && o.type === "radio" && o.name != null && bE(i, o), H3(s, a);
          var u = H3(s, o);
          for (a = 0; a < l.length; a += 2) {
            var d = l[a], p = l[a + 1];
            d === "style" ? SE(i, p) : d === "dangerouslySetInnerHTML" ? kE(i, p) : d === "children" ? Op(i, p) : d6(i, d, p, u);
          }
          switch (s) {
            case "input":
              R3(i, o);
              break;
            case "textarea":
              wE(i, o);
              break;
            case "select":
              var f = i._wrapperState.wasMultiple;
              i._wrapperState.wasMultiple = !!o.multiple;
              var m = o.value;
              m != null ? k0(i, !!o.multiple, m, !1) : f !== !!o.multiple && (o.defaultValue != null ? k0(
                i,
                !!o.multiple,
                o.defaultValue,
                !0
              ) : k0(i, !!o.multiple, o.multiple ? [] : "", !1));
          }
          i[_p] = o;
        } catch (g) {
          mr(e, e.return, g);
        }
      }
      break;
    case 6:
      if (Ta(t, e), Ya(e), r & 4) {
        if (e.stateNode === null) throw Error(Qe(162));
        i = e.stateNode, o = e.memoizedProps;
        try {
          i.nodeValue = o;
        } catch (g) {
          mr(e, e.return, g);
        }
      }
      break;
    case 3:
      if (Ta(t, e), Ya(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
        Mp(t.containerInfo);
      } catch (g) {
        mr(e, e.return, g);
      }
      break;
    case 4:
      Ta(t, e), Ya(e);
      break;
    case 13:
      Ta(t, e), Ya(e), i = e.child, i.flags & 8192 && (o = i.memoizedState !== null, i.stateNode.isHidden = o, !o || i.alternate !== null && i.alternate.memoizedState !== null || (V6 = kr())), r & 4 && Ux(e);
      break;
    case 22:
      if (d = n !== null && n.memoizedState !== null, e.mode & 1 ? (vi = (u = vi) || d, Ta(t, e), vi = u) : Ta(t, e), Ya(e), r & 8192) {
        if (u = e.memoizedState !== null, (e.stateNode.isHidden = u) && !d && e.mode & 1) for (bt = e, d = e.child; d !== null; ) {
          for (p = bt = d; bt !== null; ) {
            switch (f = bt, m = f.child, f.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                hp(4, f, f.return);
                break;
              case 1:
                g0(f, f.return);
                var y = f.stateNode;
                if (typeof y.componentWillUnmount == "function") {
                  r = f, n = f.return;
                  try {
                    t = r, y.props = t.memoizedProps, y.state = t.memoizedState, y.componentWillUnmount();
                  } catch (g) {
                    mr(r, n, g);
                  }
                }
                break;
              case 5:
                g0(f, f.return);
                break;
              case 22:
                if (f.memoizedState !== null) {
                  Zx(p);
                  continue;
                }
            }
            m !== null ? (m.return = f, bt = m) : Zx(p);
          }
          d = d.sibling;
        }
        e: for (d = null, p = e; ; ) {
          if (p.tag === 5) {
            if (d === null) {
              d = p;
              try {
                i = p.stateNode, u ? (o = i.style, typeof o.setProperty == "function" ? o.setProperty("display", "none", "important") : o.display = "none") : (s = p.stateNode, l = p.memoizedProps.style, a = l != null && l.hasOwnProperty("display") ? l.display : null, s.style.display = EE("display", a));
              } catch (g) {
                mr(e, e.return, g);
              }
            }
          } else if (p.tag === 6) {
            if (d === null) try {
              p.stateNode.nodeValue = u ? "" : p.memoizedProps;
            } catch (g) {
              mr(e, e.return, g);
            }
          } else if ((p.tag !== 22 && p.tag !== 23 || p.memoizedState === null || p === e) && p.child !== null) {
            p.child.return = p, p = p.child;
            continue;
          }
          if (p === e) break e;
          for (; p.sibling === null; ) {
            if (p.return === null || p.return === e) break e;
            d === p && (d = null), p = p.return;
          }
          d === p && (d = null), p.sibling.return = p.return, p = p.sibling;
        }
      }
      break;
    case 19:
      Ta(t, e), Ya(e), r & 4 && Ux(e);
      break;
    case 21:
      break;
    default:
      Ta(
        t,
        e
      ), Ya(e);
  }
}
function Ya(e) {
  var t = e.flags;
  if (t & 2) {
    try {
      e: {
        for (var n = e.return; n !== null; ) {
          if (XS(n)) {
            var r = n;
            break e;
          }
          n = n.return;
        }
        throw Error(Qe(160));
      }
      switch (r.tag) {
        case 5:
          var i = r.stateNode;
          r.flags & 32 && (Op(i, ""), r.flags &= -33);
          var o = Vx(e);
          xv(e, o, i);
          break;
        case 3:
        case 4:
          var a = r.stateNode.containerInfo, s = Vx(e);
          yv(e, s, a);
          break;
        default:
          throw Error(Qe(161));
      }
    } catch (l) {
      mr(e, e.return, l);
    }
    e.flags &= -3;
  }
  t & 4096 && (e.flags &= -4097);
}
function sP(e, t, n) {
  bt = e, JS(e);
}
function JS(e, t, n) {
  for (var r = (e.mode & 1) !== 0; bt !== null; ) {
    var i = bt, o = i.child;
    if (i.tag === 22 && r) {
      var a = i.memoizedState !== null || Th;
      if (!a) {
        var s = i.alternate, l = s !== null && s.memoizedState !== null || vi;
        s = Th;
        var u = vi;
        if (Th = a, (vi = l) && !u) for (bt = i; bt !== null; ) a = bt, l = a.child, a.tag === 22 && a.memoizedState !== null ? Gx(i) : l !== null ? (l.return = a, bt = l) : Gx(i);
        for (; o !== null; ) bt = o, JS(o), o = o.sibling;
        bt = i, Th = s, vi = u;
      }
      Wx(e);
    } else i.subtreeFlags & 8772 && o !== null ? (o.return = i, bt = o) : Wx(e);
  }
}
function Wx(e) {
  for (; bt !== null; ) {
    var t = bt;
    if (t.flags & 8772) {
      var n = t.alternate;
      try {
        if (t.flags & 8772) switch (t.tag) {
          case 0:
          case 11:
          case 15:
            vi || cg(5, t);
            break;
          case 1:
            var r = t.stateNode;
            if (t.flags & 4 && !vi) if (n === null) r.componentDidMount();
            else {
              var i = t.elementType === t.type ? n.memoizedProps : Oa(t.type, n.memoizedProps);
              r.componentDidUpdate(i, n.memoizedState, r.__reactInternalSnapshotBeforeUpdate);
            }
            var o = t.updateQueue;
            o !== null && Nx(t, o, r);
            break;
          case 3:
            var a = t.updateQueue;
            if (a !== null) {
              if (n = null, t.child !== null) switch (t.child.tag) {
                case 5:
                  n = t.child.stateNode;
                  break;
                case 1:
                  n = t.child.stateNode;
              }
              Nx(t, a, n);
            }
            break;
          case 5:
            var s = t.stateNode;
            if (n === null && t.flags & 4) {
              n = s;
              var l = t.memoizedProps;
              switch (t.type) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  l.autoFocus && n.focus();
                  break;
                case "img":
                  l.src && (n.src = l.src);
              }
            }
            break;
          case 6:
            break;
          case 4:
            break;
          case 12:
            break;
          case 13:
            if (t.memoizedState === null) {
              var u = t.alternate;
              if (u !== null) {
                var d = u.memoizedState;
                if (d !== null) {
                  var p = d.dehydrated;
                  p !== null && Mp(p);
                }
              }
            }
            break;
          case 19:
          case 17:
          case 21:
          case 22:
          case 23:
          case 25:
            break;
          default:
            throw Error(Qe(163));
        }
        vi || t.flags & 512 && vv(t);
      } catch (f) {
        mr(t, t.return, f);
      }
    }
    if (t === e) {
      bt = null;
      break;
    }
    if (n = t.sibling, n !== null) {
      n.return = t.return, bt = n;
      break;
    }
    bt = t.return;
  }
}
function Zx(e) {
  for (; bt !== null; ) {
    var t = bt;
    if (t === e) {
      bt = null;
      break;
    }
    var n = t.sibling;
    if (n !== null) {
      n.return = t.return, bt = n;
      break;
    }
    bt = t.return;
  }
}
function Gx(e) {
  for (; bt !== null; ) {
    var t = bt;
    try {
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          var n = t.return;
          try {
            cg(4, t);
          } catch (l) {
            mr(t, n, l);
          }
          break;
        case 1:
          var r = t.stateNode;
          if (typeof r.componentDidMount == "function") {
            var i = t.return;
            try {
              r.componentDidMount();
            } catch (l) {
              mr(t, i, l);
            }
          }
          var o = t.return;
          try {
            vv(t);
          } catch (l) {
            mr(t, o, l);
          }
          break;
        case 5:
          var a = t.return;
          try {
            vv(t);
          } catch (l) {
            mr(t, a, l);
          }
      }
    } catch (l) {
      mr(t, t.return, l);
    }
    if (t === e) {
      bt = null;
      break;
    }
    var s = t.sibling;
    if (s !== null) {
      s.return = t.return, bt = s;
      break;
    }
    bt = t.return;
  }
}
var lP = Math.ceil, hm = ml.ReactCurrentDispatcher, $6 = ml.ReactCurrentOwner, la = ml.ReactCurrentBatchConfig, dn = 0, Kr = null, Or = null, oi = 0, Co = 0, v0 = ku(0), $r = 0, Wp = null, wc = 0, dg = 0, H6 = 0, mp = null, Qi = null, V6 = 0, H0 = 1 / 0, Is = null, mm = !1, bv = null, nu = null, jh = !1, Ul = null, gm = 0, gp = 0, wv = null, C1 = -1, k1 = 0;
function Mi() {
  return dn & 6 ? kr() : C1 !== -1 ? C1 : C1 = kr();
}
function ru(e) {
  return e.mode & 1 ? dn & 2 && oi !== 0 ? oi & -oi : UR.transition !== null ? (k1 === 0 && (k1 = IE()), k1) : (e = Cn, e !== 0 || (e = window.event, e = e === void 0 ? 16 : VE(e.type)), e) : 1;
}
function Pa(e, t, n, r) {
  if (50 < gp) throw gp = 0, wv = null, Error(Qe(185));
  yf(e, n, r), (!(dn & 2) || e !== Kr) && (e === Kr && (!(dn & 2) && (dg |= n), $r === 4 && ql(e, oi)), no(e, r), n === 1 && dn === 0 && !(t.mode & 1) && (H0 = kr() + 500, sg && Eu()));
}
function no(e, t) {
  var n = e.callbackNode;
  UI(e, t);
  var r = J1(e, e === Kr ? oi : 0);
  if (r === 0) n !== null && rx(n), e.callbackNode = null, e.callbackPriority = 0;
  else if (t = r & -r, e.callbackPriority !== t) {
    if (n != null && rx(n), t === 1) e.tag === 0 ? VR(Kx.bind(null, e)) : uS(Kx.bind(null, e)), _R(function() {
      !(dn & 6) && Eu();
    }), n = null;
    else {
      switch (RE(r)) {
        case 1:
          n = g6;
          break;
        case 4:
          n = ME;
          break;
        case 16:
          n = Y1;
          break;
        case 536870912:
          n = BE;
          break;
        default:
          n = Y1;
      }
      n = sD(n, eD.bind(null, e));
    }
    e.callbackPriority = t, e.callbackNode = n;
  }
}
function eD(e, t) {
  if (C1 = -1, k1 = 0, dn & 6) throw Error(Qe(327));
  var n = e.callbackNode;
  if (T0() && e.callbackNode !== n) return null;
  var r = J1(e, e === Kr ? oi : 0);
  if (r === 0) return null;
  if (r & 30 || r & e.expiredLanes || t) t = vm(e, r);
  else {
    t = r;
    var i = dn;
    dn |= 2;
    var o = nD();
    (Kr !== e || oi !== t) && (Is = null, H0 = kr() + 500, dc(e, t));
    do
      try {
        dP();
        break;
      } catch (s) {
        tD(e, s);
      }
    while (!0);
    j6(), hm.current = o, dn = i, Or !== null ? t = 0 : (Kr = null, oi = 0, t = $r);
  }
  if (t !== 0) {
    if (t === 2 && (i = G3(e), i !== 0 && (r = i, t = Cv(e, i))), t === 1) throw n = Wp, dc(e, 0), ql(e, r), no(e, kr()), n;
    if (t === 6) ql(e, r);
    else {
      if (i = e.current.alternate, !(r & 30) && !uP(i) && (t = vm(e, r), t === 2 && (o = G3(e), o !== 0 && (r = o, t = Cv(e, o))), t === 1)) throw n = Wp, dc(e, 0), ql(e, r), no(e, kr()), n;
      switch (e.finishedWork = i, e.finishedLanes = r, t) {
        case 0:
        case 1:
          throw Error(Qe(345));
        case 2:
          Yu(e, Qi, Is);
          break;
        case 3:
          if (ql(e, r), (r & 130023424) === r && (t = V6 + 500 - kr(), 10 < t)) {
            if (J1(e, 0) !== 0) break;
            if (i = e.suspendedLanes, (i & r) !== r) {
              Mi(), e.pingedLanes |= e.suspendedLanes & i;
              break;
            }
            e.timeoutHandle = nv(Yu.bind(null, e, Qi, Is), t);
            break;
          }
          Yu(e, Qi, Is);
          break;
        case 4:
          if (ql(e, r), (r & 4194240) === r) break;
          for (t = e.eventTimes, i = -1; 0 < r; ) {
            var a = 31 - Ra(r);
            o = 1 << a, a = t[a], a > i && (i = a), r &= ~o;
          }
          if (r = i, r = kr() - r, r = (120 > r ? 120 : 480 > r ? 480 : 1080 > r ? 1080 : 1920 > r ? 1920 : 3e3 > r ? 3e3 : 4320 > r ? 4320 : 1960 * lP(r / 1960)) - r, 10 < r) {
            e.timeoutHandle = nv(Yu.bind(null, e, Qi, Is), r);
            break;
          }
          Yu(e, Qi, Is);
          break;
        case 5:
          Yu(e, Qi, Is);
          break;
        default:
          throw Error(Qe(329));
      }
    }
  }
  return no(e, kr()), e.callbackNode === n ? eD.bind(null, e) : null;
}
function Cv(e, t) {
  var n = mp;
  return e.current.memoizedState.isDehydrated && (dc(e, t).flags |= 256), e = vm(e, t), e !== 2 && (t = Qi, Qi = n, t !== null && kv(t)), e;
}
function kv(e) {
  Qi === null ? Qi = e : Qi.push.apply(Qi, e);
}
function uP(e) {
  for (var t = e; ; ) {
    if (t.flags & 16384) {
      var n = t.updateQueue;
      if (n !== null && (n = n.stores, n !== null)) for (var r = 0; r < n.length; r++) {
        var i = n[r], o = i.getSnapshot;
        i = i.value;
        try {
          if (!qa(o(), i)) return !1;
        } catch {
          return !1;
        }
      }
    }
    if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
    else {
      if (t === e) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e) return !0;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
  }
  return !0;
}
function ql(e, t) {
  for (t &= ~H6, t &= ~dg, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t; ) {
    var n = 31 - Ra(t), r = 1 << n;
    e[n] = -1, t &= ~r;
  }
}
function Kx(e) {
  if (dn & 6) throw Error(Qe(327));
  T0();
  var t = J1(e, 0);
  if (!(t & 1)) return no(e, kr()), null;
  var n = vm(e, t);
  if (e.tag !== 0 && n === 2) {
    var r = G3(e);
    r !== 0 && (t = r, n = Cv(e, r));
  }
  if (n === 1) throw n = Wp, dc(e, 0), ql(e, t), no(e, kr()), n;
  if (n === 6) throw Error(Qe(345));
  return e.finishedWork = e.current.alternate, e.finishedLanes = t, Yu(e, Qi, Is), no(e, kr()), null;
}
function U6(e, t) {
  var n = dn;
  dn |= 1;
  try {
    return e(t);
  } finally {
    dn = n, dn === 0 && (H0 = kr() + 500, sg && Eu());
  }
}
function Cc(e) {
  Ul !== null && Ul.tag === 0 && !(dn & 6) && T0();
  var t = dn;
  dn |= 1;
  var n = la.transition, r = Cn;
  try {
    if (la.transition = null, Cn = 1, e) return e();
  } finally {
    Cn = r, la.transition = n, dn = t, !(dn & 6) && Eu();
  }
}
function W6() {
  Co = v0.current, Hn(v0);
}
function dc(e, t) {
  e.finishedWork = null, e.finishedLanes = 0;
  var n = e.timeoutHandle;
  if (n !== -1 && (e.timeoutHandle = -1, PR(n)), Or !== null) for (n = Or.return; n !== null; ) {
    var r = n;
    switch (D6(r), r.tag) {
      case 1:
        r = r.type.childContextTypes, r != null && im();
        break;
      case 3:
        q0(), Hn(eo), Hn(xi), M6();
        break;
      case 5:
        L6(r);
        break;
      case 4:
        q0();
        break;
      case 13:
        Hn(lr);
        break;
      case 19:
        Hn(lr);
        break;
      case 10:
        N6(r.type._context);
        break;
      case 22:
      case 23:
        W6();
    }
    n = n.return;
  }
  if (Kr = e, Or = e = iu(e.current, null), oi = Co = t, $r = 0, Wp = null, H6 = dg = wc = 0, Qi = mp = null, sc !== null) {
    for (t = 0; t < sc.length; t++) if (n = sc[t], r = n.interleaved, r !== null) {
      n.interleaved = null;
      var i = r.next, o = n.pending;
      if (o !== null) {
        var a = o.next;
        o.next = i, r.next = a;
      }
      n.pending = r;
    }
    sc = null;
  }
  return e;
}
function tD(e, t) {
  do {
    var n = Or;
    try {
      if (j6(), x1.current = fm, pm) {
        for (var r = dr.memoizedState; r !== null; ) {
          var i = r.queue;
          i !== null && (i.pending = null), r = r.next;
        }
        pm = !1;
      }
      if (bc = 0, Zr = _r = dr = null, fp = !1, Hp = 0, $6.current = null, n === null || n.return === null) {
        $r = 1, Wp = t, Or = null;
        break;
      }
      e: {
        var o = e, a = n.return, s = n, l = t;
        if (t = oi, s.flags |= 32768, l !== null && typeof l == "object" && typeof l.then == "function") {
          var u = l, d = s, p = d.tag;
          if (!(d.mode & 1) && (p === 0 || p === 11 || p === 15)) {
            var f = d.alternate;
            f ? (d.updateQueue = f.updateQueue, d.memoizedState = f.memoizedState, d.lanes = f.lanes) : (d.updateQueue = null, d.memoizedState = null);
          }
          var m = Bx(a);
          if (m !== null) {
            m.flags &= -257, Ix(m, a, s, o, t), m.mode & 1 && Mx(o, u, t), t = m, l = u;
            var y = t.updateQueue;
            if (y === null) {
              var g = /* @__PURE__ */ new Set();
              g.add(l), t.updateQueue = g;
            } else y.add(l);
            break e;
          } else {
            if (!(t & 1)) {
              Mx(o, u, t), Z6();
              break e;
            }
            l = Error(Qe(426));
          }
        } else if (Gn && s.mode & 1) {
          var x = Bx(a);
          if (x !== null) {
            !(x.flags & 65536) && (x.flags |= 256), Ix(x, a, s, o, t), A6($0(l, s));
            break e;
          }
        }
        o = l = $0(l, s), $r !== 4 && ($r = 2), mp === null ? mp = [o] : mp.push(o), o = a;
        do {
          switch (o.tag) {
            case 3:
              o.flags |= 65536, t &= -t, o.lanes |= t;
              var E = RS(o, l, t);
              jx(o, E);
              break e;
            case 1:
              s = l;
              var b = o.type, C = o.stateNode;
              if (!(o.flags & 128) && (typeof b.getDerivedStateFromError == "function" || C !== null && typeof C.componentDidCatch == "function" && (nu === null || !nu.has(C)))) {
                o.flags |= 65536, t &= -t, o.lanes |= t;
                var T = PS(o, s, t);
                jx(o, T);
                break e;
              }
          }
          o = o.return;
        } while (o !== null);
      }
      iD(n);
    } catch (z) {
      t = z, Or === n && n !== null && (Or = n = n.return);
      continue;
    }
    break;
  } while (!0);
}
function nD() {
  var e = hm.current;
  return hm.current = fm, e === null ? fm : e;
}
function Z6() {
  ($r === 0 || $r === 3 || $r === 2) && ($r = 4), Kr === null || !(wc & 268435455) && !(dg & 268435455) || ql(Kr, oi);
}
function vm(e, t) {
  var n = dn;
  dn |= 2;
  var r = nD();
  (Kr !== e || oi !== t) && (Is = null, dc(e, t));
  do
    try {
      cP();
      break;
    } catch (i) {
      tD(e, i);
    }
  while (!0);
  if (j6(), dn = n, hm.current = r, Or !== null) throw Error(Qe(261));
  return Kr = null, oi = 0, $r;
}
function cP() {
  for (; Or !== null; ) rD(Or);
}
function dP() {
  for (; Or !== null && !BI(); ) rD(Or);
}
function rD(e) {
  var t = aD(e.alternate, e, Co);
  e.memoizedProps = e.pendingProps, t === null ? iD(e) : Or = t, $6.current = null;
}
function iD(e) {
  var t = e;
  do {
    var n = t.alternate;
    if (e = t.return, t.flags & 32768) {
      if (n = iP(n, t), n !== null) {
        n.flags &= 32767, Or = n;
        return;
      }
      if (e !== null) e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null;
      else {
        $r = 6, Or = null;
        return;
      }
    } else if (n = rP(n, t, Co), n !== null) {
      Or = n;
      return;
    }
    if (t = t.sibling, t !== null) {
      Or = t;
      return;
    }
    Or = t = e;
  } while (t !== null);
  $r === 0 && ($r = 5);
}
function Yu(e, t, n) {
  var r = Cn, i = la.transition;
  try {
    la.transition = null, Cn = 1, pP(e, t, n, r);
  } finally {
    la.transition = i, Cn = r;
  }
  return null;
}
function pP(e, t, n, r) {
  do
    T0();
  while (Ul !== null);
  if (dn & 6) throw Error(Qe(327));
  n = e.finishedWork;
  var i = e.finishedLanes;
  if (n === null) return null;
  if (e.finishedWork = null, e.finishedLanes = 0, n === e.current) throw Error(Qe(177));
  e.callbackNode = null, e.callbackPriority = 0;
  var o = n.lanes | n.childLanes;
  if (WI(e, o), e === Kr && (Or = Kr = null, oi = 0), !(n.subtreeFlags & 2064) && !(n.flags & 2064) || jh || (jh = !0, sD(Y1, function() {
    return T0(), null;
  })), o = (n.flags & 15990) !== 0, n.subtreeFlags & 15990 || o) {
    o = la.transition, la.transition = null;
    var a = Cn;
    Cn = 1;
    var s = dn;
    dn |= 4, $6.current = null, aP(e, n), YS(n, e), zR(ev), em = !!J3, ev = J3 = null, e.current = n, sP(n), II(), dn = s, Cn = a, la.transition = o;
  } else e.current = n;
  if (jh && (jh = !1, Ul = e, gm = i), o = e.pendingLanes, o === 0 && (nu = null), _I(n.stateNode), no(e, kr()), t !== null) for (r = e.onRecoverableError, n = 0; n < t.length; n++) i = t[n], r(i.value, { componentStack: i.stack, digest: i.digest });
  if (mm) throw mm = !1, e = bv, bv = null, e;
  return gm & 1 && e.tag !== 0 && T0(), o = e.pendingLanes, o & 1 ? e === wv ? gp++ : (gp = 0, wv = e) : gp = 0, Eu(), null;
}
function T0() {
  if (Ul !== null) {
    var e = RE(gm), t = la.transition, n = Cn;
    try {
      if (la.transition = null, Cn = 16 > e ? 16 : e, Ul === null) var r = !1;
      else {
        if (e = Ul, Ul = null, gm = 0, dn & 6) throw Error(Qe(331));
        var i = dn;
        for (dn |= 4, bt = e.current; bt !== null; ) {
          var o = bt, a = o.child;
          if (bt.flags & 16) {
            var s = o.deletions;
            if (s !== null) {
              for (var l = 0; l < s.length; l++) {
                var u = s[l];
                for (bt = u; bt !== null; ) {
                  var d = bt;
                  switch (d.tag) {
                    case 0:
                    case 11:
                    case 15:
                      hp(8, d, o);
                  }
                  var p = d.child;
                  if (p !== null) p.return = d, bt = p;
                  else for (; bt !== null; ) {
                    d = bt;
                    var f = d.sibling, m = d.return;
                    if (KS(d), d === u) {
                      bt = null;
                      break;
                    }
                    if (f !== null) {
                      f.return = m, bt = f;
                      break;
                    }
                    bt = m;
                  }
                }
              }
              var y = o.alternate;
              if (y !== null) {
                var g = y.child;
                if (g !== null) {
                  y.child = null;
                  do {
                    var x = g.sibling;
                    g.sibling = null, g = x;
                  } while (g !== null);
                }
              }
              bt = o;
            }
          }
          if (o.subtreeFlags & 2064 && a !== null) a.return = o, bt = a;
          else e: for (; bt !== null; ) {
            if (o = bt, o.flags & 2048) switch (o.tag) {
              case 0:
              case 11:
              case 15:
                hp(9, o, o.return);
            }
            var E = o.sibling;
            if (E !== null) {
              E.return = o.return, bt = E;
              break e;
            }
            bt = o.return;
          }
        }
        var b = e.current;
        for (bt = b; bt !== null; ) {
          a = bt;
          var C = a.child;
          if (a.subtreeFlags & 2064 && C !== null) C.return = a, bt = C;
          else e: for (a = b; bt !== null; ) {
            if (s = bt, s.flags & 2048) try {
              switch (s.tag) {
                case 0:
                case 11:
                case 15:
                  cg(9, s);
              }
            } catch (z) {
              mr(s, s.return, z);
            }
            if (s === a) {
              bt = null;
              break e;
            }
            var T = s.sibling;
            if (T !== null) {
              T.return = s.return, bt = T;
              break e;
            }
            bt = s.return;
          }
        }
        if (dn = i, Eu(), ss && typeof ss.onPostCommitFiberRoot == "function") try {
          ss.onPostCommitFiberRoot(ng, e);
        } catch {
        }
        r = !0;
      }
      return r;
    } finally {
      Cn = n, la.transition = t;
    }
  }
  return !1;
}
function Xx(e, t, n) {
  t = $0(n, t), t = RS(e, t, 1), e = tu(e, t, 1), t = Mi(), e !== null && (yf(e, 1, t), no(e, t));
}
function mr(e, t, n) {
  if (e.tag === 3) Xx(e, e, n);
  else for (; t !== null; ) {
    if (t.tag === 3) {
      Xx(t, e, n);
      break;
    } else if (t.tag === 1) {
      var r = t.stateNode;
      if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (nu === null || !nu.has(r))) {
        e = $0(n, e), e = PS(t, e, 1), t = tu(t, e, 1), e = Mi(), t !== null && (yf(t, 1, e), no(t, e));
        break;
      }
    }
    t = t.return;
  }
}
function fP(e, t, n) {
  var r = e.pingCache;
  r !== null && r.delete(t), t = Mi(), e.pingedLanes |= e.suspendedLanes & n, Kr === e && (oi & n) === n && ($r === 4 || $r === 3 && (oi & 130023424) === oi && 500 > kr() - V6 ? dc(e, 0) : H6 |= n), no(e, t);
}
function oD(e, t) {
  t === 0 && (e.mode & 1 ? (t = xh, xh <<= 1, !(xh & 130023424) && (xh = 4194304)) : t = 1);
  var n = Mi();
  e = el(e, t), e !== null && (yf(e, t, n), no(e, n));
}
function hP(e) {
  var t = e.memoizedState, n = 0;
  t !== null && (n = t.retryLane), oD(e, n);
}
function mP(e, t) {
  var n = 0;
  switch (e.tag) {
    case 13:
      var r = e.stateNode, i = e.memoizedState;
      i !== null && (n = i.retryLane);
      break;
    case 19:
      r = e.stateNode;
      break;
    default:
      throw Error(Qe(314));
  }
  r !== null && r.delete(t), oD(e, n);
}
var aD;
aD = function(e, t, n) {
  if (e !== null) if (e.memoizedProps !== t.pendingProps || eo.current) Yi = !0;
  else {
    if (!(e.lanes & n) && !(t.flags & 128)) return Yi = !1, nP(e, t, n);
    Yi = !!(e.flags & 131072);
  }
  else Yi = !1, Gn && t.flags & 1048576 && cS(t, sm, t.index);
  switch (t.lanes = 0, t.tag) {
    case 2:
      var r = t.type;
      w1(e, t), e = t.pendingProps;
      var i = R0(t, xi.current);
      A0(t, n), i = I6(null, t, r, e, i, n);
      var o = R6();
      return t.flags |= 1, typeof i == "object" && i !== null && typeof i.render == "function" && i.$$typeof === void 0 ? (t.tag = 1, t.memoizedState = null, t.updateQueue = null, to(r) ? (o = !0, om(t)) : o = !1, t.memoizedState = i.state !== null && i.state !== void 0 ? i.state : null, z6(t), i.updater = ug, t.stateNode = i, i._reactInternals = t, uv(t, r, e, n), t = pv(null, t, r, !0, o, n)) : (t.tag = 0, Gn && o && S6(t), ji(null, t, i, n), t = t.child), t;
    case 16:
      r = t.elementType;
      e: {
        switch (w1(e, t), e = t.pendingProps, i = r._init, r = i(r._payload), t.type = r, i = t.tag = vP(r), e = Oa(r, e), i) {
          case 0:
            t = dv(null, t, r, e, n);
            break e;
          case 1:
            t = _x(null, t, r, e, n);
            break e;
          case 11:
            t = Rx(null, t, r, e, n);
            break e;
          case 14:
            t = Px(null, t, r, Oa(r.type, e), n);
            break e;
        }
        throw Error(Qe(
          306,
          r,
          ""
        ));
      }
      return t;
    case 0:
      return r = t.type, i = t.pendingProps, i = t.elementType === r ? i : Oa(r, i), dv(e, t, r, i, n);
    case 1:
      return r = t.type, i = t.pendingProps, i = t.elementType === r ? i : Oa(r, i), _x(e, t, r, i, n);
    case 3:
      e: {
        if (HS(t), e === null) throw Error(Qe(387));
        r = t.pendingProps, o = t.memoizedState, i = o.element, gS(e, t), cm(t, r, null, n);
        var a = t.memoizedState;
        if (r = a.element, o.isDehydrated) if (o = { element: r, isDehydrated: !1, cache: a.cache, pendingSuspenseBoundaries: a.pendingSuspenseBoundaries, transitions: a.transitions }, t.updateQueue.baseState = o, t.memoizedState = o, t.flags & 256) {
          i = $0(Error(Qe(423)), t), t = qx(e, t, r, n, i);
          break e;
        } else if (r !== i) {
          i = $0(Error(Qe(424)), t), t = qx(e, t, r, n, i);
          break e;
        } else for (Ao = eu(t.stateNode.containerInfo.firstChild), No = t, Gn = !0, La = null, n = hS(t, null, r, n), t.child = n; n; ) n.flags = n.flags & -3 | 4096, n = n.sibling;
        else {
          if (P0(), r === i) {
            t = tl(e, t, n);
            break e;
          }
          ji(e, t, r, n);
        }
        t = t.child;
      }
      return t;
    case 5:
      return vS(t), e === null && av(t), r = t.type, i = t.pendingProps, o = e !== null ? e.memoizedProps : null, a = i.children, tv(r, i) ? a = null : o !== null && tv(r, o) && (t.flags |= 32), $S(e, t), ji(e, t, a, n), t.child;
    case 6:
      return e === null && av(t), null;
    case 13:
      return VS(e, t, n);
    case 4:
      return F6(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = _0(t, null, r, n) : ji(e, t, r, n), t.child;
    case 11:
      return r = t.type, i = t.pendingProps, i = t.elementType === r ? i : Oa(r, i), Rx(e, t, r, i, n);
    case 7:
      return ji(e, t, t.pendingProps, n), t.child;
    case 8:
      return ji(e, t, t.pendingProps.children, n), t.child;
    case 12:
      return ji(e, t, t.pendingProps.children, n), t.child;
    case 10:
      e: {
        if (r = t.type._context, i = t.pendingProps, o = t.memoizedProps, a = i.value, Ln(lm, r._currentValue), r._currentValue = a, o !== null) if (qa(o.value, a)) {
          if (o.children === i.children && !eo.current) {
            t = tl(e, t, n);
            break e;
          }
        } else for (o = t.child, o !== null && (o.return = t); o !== null; ) {
          var s = o.dependencies;
          if (s !== null) {
            a = o.child;
            for (var l = s.firstContext; l !== null; ) {
              if (l.context === r) {
                if (o.tag === 1) {
                  l = Gs(-1, n & -n), l.tag = 2;
                  var u = o.updateQueue;
                  if (u !== null) {
                    u = u.shared;
                    var d = u.pending;
                    d === null ? l.next = l : (l.next = d.next, d.next = l), u.pending = l;
                  }
                }
                o.lanes |= n, l = o.alternate, l !== null && (l.lanes |= n), sv(
                  o.return,
                  n,
                  t
                ), s.lanes |= n;
                break;
              }
              l = l.next;
            }
          } else if (o.tag === 10) a = o.type === t.type ? null : o.child;
          else if (o.tag === 18) {
            if (a = o.return, a === null) throw Error(Qe(341));
            a.lanes |= n, s = a.alternate, s !== null && (s.lanes |= n), sv(a, n, t), a = o.sibling;
          } else a = o.child;
          if (a !== null) a.return = o;
          else for (a = o; a !== null; ) {
            if (a === t) {
              a = null;
              break;
            }
            if (o = a.sibling, o !== null) {
              o.return = a.return, a = o;
              break;
            }
            a = a.return;
          }
          o = a;
        }
        ji(e, t, i.children, n), t = t.child;
      }
      return t;
    case 9:
      return i = t.type, r = t.pendingProps.children, A0(t, n), i = da(i), r = r(i), t.flags |= 1, ji(e, t, r, n), t.child;
    case 14:
      return r = t.type, i = Oa(r, t.pendingProps), i = Oa(r.type, i), Px(e, t, r, i, n);
    case 15:
      return _S(e, t, t.type, t.pendingProps, n);
    case 17:
      return r = t.type, i = t.pendingProps, i = t.elementType === r ? i : Oa(r, i), w1(e, t), t.tag = 1, to(r) ? (e = !0, om(t)) : e = !1, A0(t, n), IS(t, r, i), uv(t, r, i, n), pv(null, t, r, !0, e, n);
    case 19:
      return US(e, t, n);
    case 22:
      return qS(e, t, n);
  }
  throw Error(Qe(156, t.tag));
};
function sD(e, t) {
  return LE(e, t);
}
function gP(e, t, n, r) {
  this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
}
function ia(e, t, n, r) {
  return new gP(e, t, n, r);
}
function G6(e) {
  return e = e.prototype, !(!e || !e.isReactComponent);
}
function vP(e) {
  if (typeof e == "function") return G6(e) ? 1 : 0;
  if (e != null) {
    if (e = e.$$typeof, e === f6) return 11;
    if (e === h6) return 14;
  }
  return 2;
}
function iu(e, t) {
  var n = e.alternate;
  return n === null ? (n = ia(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 14680064, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
}
function E1(e, t, n, r, i, o) {
  var a = 2;
  if (r = e, typeof e == "function") G6(e) && (a = 1);
  else if (typeof e == "string") a = 5;
  else e: switch (e) {
    case s0:
      return pc(n.children, i, o, t);
    case p6:
      a = 8, i |= 8;
      break;
    case F3:
      return e = ia(12, n, t, i | 2), e.elementType = F3, e.lanes = o, e;
    case L3:
      return e = ia(13, n, t, i), e.elementType = L3, e.lanes = o, e;
    case M3:
      return e = ia(19, n, t, i), e.elementType = M3, e.lanes = o, e;
    case vE:
      return pg(n, i, o, t);
    default:
      if (typeof e == "object" && e !== null) switch (e.$$typeof) {
        case mE:
          a = 10;
          break e;
        case gE:
          a = 9;
          break e;
        case f6:
          a = 11;
          break e;
        case h6:
          a = 14;
          break e;
        case Ml:
          a = 16, r = null;
          break e;
      }
      throw Error(Qe(130, e == null ? e : typeof e, ""));
  }
  return t = ia(a, n, t, i), t.elementType = e, t.type = r, t.lanes = o, t;
}
function pc(e, t, n, r) {
  return e = ia(7, e, r, t), e.lanes = n, e;
}
function pg(e, t, n, r) {
  return e = ia(22, e, r, t), e.elementType = vE, e.lanes = n, e.stateNode = { isHidden: !1 }, e;
}
function d4(e, t, n) {
  return e = ia(6, e, null, t), e.lanes = n, e;
}
function p4(e, t, n) {
  return t = ia(4, e.children !== null ? e.children : [], e.key, t), t.lanes = n, t.stateNode = { containerInfo: e.containerInfo, pendingChildren: null, implementation: e.implementation }, t;
}
function yP(e, t, n, r, i) {
  this.tag = t, this.containerInfo = e, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = W2(0), this.expirationTimes = W2(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = W2(0), this.identifierPrefix = r, this.onRecoverableError = i, this.mutableSourceEagerHydrationData = null;
}
function K6(e, t, n, r, i, o, a, s, l) {
  return e = new yP(e, t, n, s, l), t === 1 ? (t = 1, o === !0 && (t |= 8)) : t = 0, o = ia(3, null, null, t), e.current = o, o.stateNode = e, o.memoizedState = { element: r, isDehydrated: n, cache: null, transitions: null, pendingSuspenseBoundaries: null }, z6(o), e;
}
function xP(e, t, n) {
  var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
  return { $$typeof: a0, key: r == null ? null : "" + r, children: e, containerInfo: t, implementation: n };
}
function lD(e) {
  if (!e) return du;
  e = e._reactInternals;
  e: {
    if (Fc(e) !== e || e.tag !== 1) throw Error(Qe(170));
    var t = e;
    do {
      switch (t.tag) {
        case 3:
          t = t.stateNode.context;
          break e;
        case 1:
          if (to(t.type)) {
            t = t.stateNode.__reactInternalMemoizedMergedChildContext;
            break e;
          }
      }
      t = t.return;
    } while (t !== null);
    throw Error(Qe(171));
  }
  if (e.tag === 1) {
    var n = e.type;
    if (to(n)) return lS(e, n, t);
  }
  return t;
}
function uD(e, t, n, r, i, o, a, s, l) {
  return e = K6(n, r, !0, e, i, o, a, s, l), e.context = lD(null), n = e.current, r = Mi(), i = ru(n), o = Gs(r, i), o.callback = t ?? null, tu(n, o, i), e.current.lanes = i, yf(e, i, r), no(e, r), e;
}
function fg(e, t, n, r) {
  var i = t.current, o = Mi(), a = ru(i);
  return n = lD(n), t.context === null ? t.context = n : t.pendingContext = n, t = Gs(o, a), t.payload = { element: e }, r = r === void 0 ? null : r, r !== null && (t.callback = r), e = tu(i, t, a), e !== null && (Pa(e, i, a, o), y1(e, i, a)), a;
}
function ym(e) {
  if (e = e.current, !e.child) return null;
  switch (e.child.tag) {
    case 5:
      return e.child.stateNode;
    default:
      return e.child.stateNode;
  }
}
function Qx(e, t) {
  if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
    var n = e.retryLane;
    e.retryLane = n !== 0 && n < t ? n : t;
  }
}
function X6(e, t) {
  Qx(e, t), (e = e.alternate) && Qx(e, t);
}
function bP() {
  return null;
}
var cD = typeof reportError == "function" ? reportError : function(e) {
  console.error(e);
};
function Q6(e) {
  this._internalRoot = e;
}
hg.prototype.render = Q6.prototype.render = function(e) {
  var t = this._internalRoot;
  if (t === null) throw Error(Qe(409));
  fg(e, t, null, null);
};
hg.prototype.unmount = Q6.prototype.unmount = function() {
  var e = this._internalRoot;
  if (e !== null) {
    this._internalRoot = null;
    var t = e.containerInfo;
    Cc(function() {
      fg(null, e, null, null);
    }), t[Js] = null;
  }
};
function hg(e) {
  this._internalRoot = e;
}
hg.prototype.unstable_scheduleHydration = function(e) {
  if (e) {
    var t = qE();
    e = { blockedOn: null, target: e, priority: t };
    for (var n = 0; n < _l.length && t !== 0 && t < _l[n].priority; n++) ;
    _l.splice(n, 0, e), n === 0 && HE(e);
  }
};
function Y6(e) {
  return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
}
function mg(e) {
  return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11 && (e.nodeType !== 8 || e.nodeValue !== " react-mount-point-unstable "));
}
function Yx() {
}
function wP(e, t, n, r, i) {
  if (i) {
    if (typeof r == "function") {
      var o = r;
      r = function() {
        var u = ym(a);
        o.call(u);
      };
    }
    var a = uD(t, r, e, 0, null, !1, !1, "", Yx);
    return e._reactRootContainer = a, e[Js] = a.current, Rp(e.nodeType === 8 ? e.parentNode : e), Cc(), a;
  }
  for (; i = e.lastChild; ) e.removeChild(i);
  if (typeof r == "function") {
    var s = r;
    r = function() {
      var u = ym(l);
      s.call(u);
    };
  }
  var l = K6(e, 0, !1, null, null, !1, !1, "", Yx);
  return e._reactRootContainer = l, e[Js] = l.current, Rp(e.nodeType === 8 ? e.parentNode : e), Cc(function() {
    fg(t, l, n, r);
  }), l;
}
function gg(e, t, n, r, i) {
  var o = n._reactRootContainer;
  if (o) {
    var a = o;
    if (typeof i == "function") {
      var s = i;
      i = function() {
        var l = ym(a);
        s.call(l);
      };
    }
    fg(t, a, e, i);
  } else a = wP(n, t, e, i, r);
  return ym(a);
}
PE = function(e) {
  switch (e.tag) {
    case 3:
      var t = e.stateNode;
      if (t.current.memoizedState.isDehydrated) {
        var n = Qd(t.pendingLanes);
        n !== 0 && (v6(t, n | 1), no(t, kr()), !(dn & 6) && (H0 = kr() + 500, Eu()));
      }
      break;
    case 13:
      Cc(function() {
        var r = el(e, 1);
        if (r !== null) {
          var i = Mi();
          Pa(r, e, 1, i);
        }
      }), X6(e, 1);
  }
};
y6 = function(e) {
  if (e.tag === 13) {
    var t = el(e, 134217728);
    if (t !== null) {
      var n = Mi();
      Pa(t, e, 134217728, n);
    }
    X6(e, 134217728);
  }
};
_E = function(e) {
  if (e.tag === 13) {
    var t = ru(e), n = el(e, t);
    if (n !== null) {
      var r = Mi();
      Pa(n, e, t, r);
    }
    X6(e, t);
  }
};
qE = function() {
  return Cn;
};
$E = function(e, t) {
  var n = Cn;
  try {
    return Cn = e, t();
  } finally {
    Cn = n;
  }
};
U3 = function(e, t, n) {
  switch (t) {
    case "input":
      if (R3(e, n), t = n.name, n.type === "radio" && t != null) {
        for (n = e; n.parentNode; ) n = n.parentNode;
        for (n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++) {
          var r = n[t];
          if (r !== e && r.form === e.form) {
            var i = ag(r);
            if (!i) throw Error(Qe(90));
            xE(r), R3(r, i);
          }
        }
      }
      break;
    case "textarea":
      wE(e, n);
      break;
    case "select":
      t = n.value, t != null && k0(e, !!n.multiple, t, !1);
  }
};
TE = U6;
jE = Cc;
var CP = { usingClientEntryPoint: !1, Events: [bf, d0, ag, DE, AE, U6] }, Pd = { findFiberByHostInstance: ac, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, kP = { bundleType: Pd.bundleType, version: Pd.version, rendererPackageName: Pd.rendererPackageName, rendererConfig: Pd.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: ml.ReactCurrentDispatcher, findHostInstanceByFiber: function(e) {
  return e = zE(e), e === null ? null : e.stateNode;
}, findFiberByHostInstance: Pd.findFiberByHostInstance || bP, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
  var Nh = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!Nh.isDisabled && Nh.supportsFiber) try {
    ng = Nh.inject(kP), ss = Nh;
  } catch {
  }
}
Po.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = CP;
Po.createPortal = function(e, t) {
  var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
  if (!Y6(t)) throw Error(Qe(200));
  return xP(e, t, null, n);
};
Po.createRoot = function(e, t) {
  if (!Y6(e)) throw Error(Qe(299));
  var n = !1, r = "", i = cD;
  return t != null && (t.unstable_strictMode === !0 && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onRecoverableError !== void 0 && (i = t.onRecoverableError)), t = K6(e, 1, !1, null, null, n, !1, r, i), e[Js] = t.current, Rp(e.nodeType === 8 ? e.parentNode : e), new Q6(t);
};
Po.findDOMNode = function(e) {
  if (e == null) return null;
  if (e.nodeType === 1) return e;
  var t = e._reactInternals;
  if (t === void 0)
    throw typeof e.render == "function" ? Error(Qe(188)) : (e = Object.keys(e).join(","), Error(Qe(268, e)));
  return e = zE(t), e = e === null ? null : e.stateNode, e;
};
Po.flushSync = function(e) {
  return Cc(e);
};
Po.hydrate = function(e, t, n) {
  if (!mg(t)) throw Error(Qe(200));
  return gg(null, e, t, !0, n);
};
Po.hydrateRoot = function(e, t, n) {
  if (!Y6(e)) throw Error(Qe(405));
  var r = n != null && n.hydratedSources || null, i = !1, o = "", a = cD;
  if (n != null && (n.unstable_strictMode === !0 && (i = !0), n.identifierPrefix !== void 0 && (o = n.identifierPrefix), n.onRecoverableError !== void 0 && (a = n.onRecoverableError)), t = uD(t, null, e, 1, n ?? null, i, !1, o, a), e[Js] = t.current, Rp(e), r) for (e = 0; e < r.length; e++) n = r[e], i = n._getVersion, i = i(n._source), t.mutableSourceEagerHydrationData == null ? t.mutableSourceEagerHydrationData = [n, i] : t.mutableSourceEagerHydrationData.push(
    n,
    i
  );
  return new hg(t);
};
Po.render = function(e, t, n) {
  if (!mg(t)) throw Error(Qe(200));
  return gg(null, e, t, !1, n);
};
Po.unmountComponentAtNode = function(e) {
  if (!mg(e)) throw Error(Qe(40));
  return e._reactRootContainer ? (Cc(function() {
    gg(null, null, e, !1, function() {
      e._reactRootContainer = null, e[Js] = null;
    });
  }), !0) : !1;
};
Po.unstable_batchedUpdates = U6;
Po.unstable_renderSubtreeIntoContainer = function(e, t, n, r) {
  if (!mg(n)) throw Error(Qe(200));
  if (e == null || e._reactInternals === void 0) throw Error(Qe(38));
  return gg(e, t, n, !1, r);
};
Po.version = "18.3.1-next-f1338f8080-20240426";
function dD() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(dD);
    } catch (e) {
      console.error(e);
    }
}
dD(), dE.exports = Po;
var ms = dE.exports;
const Cf = /* @__PURE__ */ nE(ms);
var EP = Object.defineProperty, SP = (e, t, n) => t in e ? EP(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, pD = (e, t, n) => SP(e, t + "", n), Jx = {}, Sn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof Jx < "u" ? Jx : typeof self < "u" ? self : {};
function wi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function DP(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var fD = { exports: {} }, vg = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var AP = dt, TP = Symbol.for("react.element"), jP = Symbol.for("react.fragment"), NP = Object.prototype.hasOwnProperty, OP = AP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, zP = { key: !0, ref: !0, __self: !0, __source: !0 };
function hD(e, t, n) {
  var r, i = {}, o = null, a = null;
  n !== void 0 && (o = "" + n), t.key !== void 0 && (o = "" + t.key), t.ref !== void 0 && (a = t.ref);
  for (r in t) NP.call(t, r) && !zP.hasOwnProperty(r) && (i[r] = t[r]);
  if (e && e.defaultProps) for (r in t = e.defaultProps, t) i[r] === void 0 && (i[r] = t[r]);
  return { $$typeof: TP, type: e, key: o, ref: a, props: i, _owner: OP.current };
}
vg.Fragment = jP;
vg.jsx = hD;
vg.jsxs = hD;
fD.exports = vg;
var c = fD.exports;
const J6 = "unsupportedPluginType", FP = new Event(J6);
function LP() {
  document.dispatchEvent(FP);
}
function MP(e) {
  document.addEventListener(J6, e, { capture: !0, once: !0 });
}
function BP(e) {
  document.removeEventListener(J6, e, !0);
}
const si = /* @__PURE__ */ function() {
  let e = null;
  function t(o) {
    e || (e = o, Object.freeze(e));
  }
  function n() {
    if (!e) throw new Error("init editor plugins first");
    return e;
  }
  function r(o) {
    const a = n();
    let s = a.find((l) => l.type === o);
    return s === void 0 && (LP(), s = a.find((l) => l.type === "unsupported")), (s == null ? void 0 : s.plugin) ?? null;
  }
  function i(o) {
    return !!n().find((a) => a.type === o);
  }
  return { init: t, getAllWithData: n, getByType: r, isSupported: i };
}();
var Y = /* @__PURE__ */ ((e) => (e.Anchor = "anchor", e.Article = "article", e.Audio = "audio", e.ArticleIntroduction = "articleIntroduction", e.Box = "box", e.Course = "course", e.Equations = "equations", e.Geogebra = "geogebra", e.H5p = "h5p", e.Highlight = "highlight", e.Image = "image", e.ImageGallery = "imageGallery", e.InteractiveVideo = "interactiveVideo", e.Injection = "injection", e.Multimedia = "multimedia", e.PageLayout = "pageLayout", e.PagePartners = "pagePartners", e.PasteHack = "pasteHack", e.Rows = "rows", e.SerloTable = "serloTable", e.Spoiler = "spoiler", e.Text = "text", e.Video = "video", e.DropzoneImage = "dropzoneImage", e.ExerciseGroup = "exerciseGroup", e.Exercise = "exercise", e.ScMcExercise = "scMcExercise", e.InputExercise = "inputExercise", e.TextAreaExercise = "textAreaExercise", e.BlanksExercise = "blanksExercise", e.Solution = "solution", e.SerloInjection = "serloInjection", e.EdusharingAsset = "edusharingAsset", e.Unsupported = "unsupported", e))(Y || {});
function mD(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = mD(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function IP() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = mD(e)) && (r && (r += " "), r += t);
  return r;
}
function Le(...e) {
  const t = e.map(
    (n) => typeof n == "string" ? n.trim().replace(/\s+/gm, " ") : n
  );
  return IP(t);
}
function qn(e) {
  return e != null && typeof e == "object" && e["@@functional/placeholder"] === !0;
}
function zr(e) {
  return function t(n) {
    return arguments.length === 0 || qn(n) ? t : e.apply(this, arguments);
  };
}
function ri(e) {
  return function t(n, r) {
    switch (arguments.length) {
      case 0:
        return t;
      case 1:
        return qn(n) ? t : zr(function(i) {
          return e(n, i);
        });
      default:
        return qn(n) && qn(r) ? t : qn(n) ? zr(function(i) {
          return e(i, r);
        }) : qn(r) ? zr(function(i) {
          return e(n, i);
        }) : e(n, r);
    }
  };
}
function RP(e, t) {
  e = e || [], t = t || [];
  var n, r = e.length, i = t.length, o = [];
  for (n = 0; n < r; )
    o[o.length] = e[n], n += 1;
  for (n = 0; n < i; )
    o[o.length] = t[n], n += 1;
  return o;
}
function gD(e, t) {
  switch (e) {
    case 0:
      return function() {
        return t.apply(this, arguments);
      };
    case 1:
      return function(n) {
        return t.apply(this, arguments);
      };
    case 2:
      return function(n, r) {
        return t.apply(this, arguments);
      };
    case 3:
      return function(n, r, i) {
        return t.apply(this, arguments);
      };
    case 4:
      return function(n, r, i, o) {
        return t.apply(this, arguments);
      };
    case 5:
      return function(n, r, i, o, a) {
        return t.apply(this, arguments);
      };
    case 6:
      return function(n, r, i, o, a, s) {
        return t.apply(this, arguments);
      };
    case 7:
      return function(n, r, i, o, a, s, l) {
        return t.apply(this, arguments);
      };
    case 8:
      return function(n, r, i, o, a, s, l, u) {
        return t.apply(this, arguments);
      };
    case 9:
      return function(n, r, i, o, a, s, l, u, d) {
        return t.apply(this, arguments);
      };
    case 10:
      return function(n, r, i, o, a, s, l, u, d, p) {
        return t.apply(this, arguments);
      };
    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}
function vD(e, t, n) {
  return function() {
    for (var r = [], i = 0, o = e, a = 0, s = !1; a < t.length || i < arguments.length; ) {
      var l;
      a < t.length && (!qn(t[a]) || i >= arguments.length) ? l = t[a] : (l = arguments[i], i += 1), r[a] = l, qn(l) ? s = !0 : o -= 1, a += 1;
    }
    return !s && o <= 0 ? n.apply(this, r) : gD(Math.max(0, o), vD(e, r, n));
  };
}
var PP = /* @__PURE__ */ ri(function(e, t) {
  return e === 1 ? zr(t) : gD(e, vD(e, [], t));
});
function va(e) {
  return function t(n, r, i) {
    switch (arguments.length) {
      case 0:
        return t;
      case 1:
        return qn(n) ? t : ri(function(o, a) {
          return e(n, o, a);
        });
      case 2:
        return qn(n) && qn(r) ? t : qn(n) ? ri(function(o, a) {
          return e(o, r, a);
        }) : qn(r) ? ri(function(o, a) {
          return e(n, o, a);
        }) : zr(function(o) {
          return e(n, r, o);
        });
      default:
        return qn(n) && qn(r) && qn(i) ? t : qn(n) && qn(r) ? ri(function(o, a) {
          return e(o, a, i);
        }) : qn(n) && qn(i) ? ri(function(o, a) {
          return e(o, r, a);
        }) : qn(r) && qn(i) ? ri(function(o, a) {
          return e(n, o, a);
        }) : qn(n) ? zr(function(o) {
          return e(o, r, i);
        }) : qn(r) ? zr(function(o) {
          return e(n, o, i);
        }) : qn(i) ? zr(function(o) {
          return e(n, r, o);
        }) : e(n, r, i);
    }
  };
}
var _P = /* @__PURE__ */ va(function(e, t, n) {
  var r = n.length;
  if (e >= r || e < -r)
    return n;
  var i = (r + e) % r, o = RP(n);
  return o[i] = t(n[i]), o;
});
const yg = Array.isArray || function(e) {
  return e != null && e.length >= 0 && Object.prototype.toString.call(e) === "[object Array]";
};
function qP(e) {
  return e != null && typeof e["@@transducer/step"] == "function";
}
function yD(e, t, n) {
  return function() {
    if (arguments.length === 0)
      return n();
    var r = arguments[arguments.length - 1];
    if (!yg(r)) {
      for (var i = 0; i < e.length; ) {
        if (typeof r[e[i]] == "function")
          return r[e[i]].apply(r, Array.prototype.slice.call(arguments, 0, -1));
        i += 1;
      }
      if (qP(r)) {
        var o = t.apply(null, Array.prototype.slice.call(arguments, 0, -1));
        return o(r);
      }
    }
    return n.apply(this, arguments);
  };
}
function $P(e) {
  return e && e["@@transducer/reduced"] ? e : {
    "@@transducer/value": e,
    "@@transducer/reduced": !0
  };
}
const Ev = {
  init: function() {
    return this.xf["@@transducer/init"]();
  },
  result: function(e) {
    return this.xf["@@transducer/result"](e);
  }
};
function eb(e) {
  for (var t = [], n; !(n = e.next()).done; )
    t.push(n.value);
  return t;
}
function tb(e, t, n) {
  for (var r = 0, i = n.length; r < i; ) {
    if (e(t, n[r]))
      return !0;
    r += 1;
  }
  return !1;
}
function HP(e) {
  var t = String(e).match(/^function (\w*)/);
  return t == null ? "" : t[1];
}
function Vs(e, t) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function VP(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
const f4 = typeof Object.is == "function" ? Object.is : VP;
var nb = Object.prototype.toString, UP = /* @__PURE__ */ function() {
  return nb.call(arguments) === "[object Arguments]" ? function(e) {
    return nb.call(e) === "[object Arguments]";
  } : function(e) {
    return Vs("callee", e);
  };
}(), WP = !/* @__PURE__ */ {
  toString: null
}.propertyIsEnumerable("toString"), rb = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"], ib = /* @__PURE__ */ function() {
  return arguments.propertyIsEnumerable("length");
}(), ZP = function(e, t) {
  for (var n = 0; n < e.length; ) {
    if (e[n] === t)
      return !0;
    n += 1;
  }
  return !1;
}, Zp = /* @__PURE__ */ zr(typeof Object.keys == "function" && !ib ? function(e) {
  return Object(e) !== e ? [] : Object.keys(e);
} : function(e) {
  if (Object(e) !== e)
    return [];
  var t, n, r = [], i = ib && UP(e);
  for (t in e)
    Vs(t, e) && (!i || t !== "length") && (r[r.length] = t);
  if (WP)
    for (n = rb.length - 1; n >= 0; )
      t = rb[n], Vs(t, e) && !ZP(r, t) && (r[r.length] = t), n -= 1;
  return r;
}), Sv = /* @__PURE__ */ zr(function(e) {
  return e === null ? "Null" : e === void 0 ? "Undefined" : Object.prototype.toString.call(e).slice(8, -1);
});
function ob(e, t, n, r) {
  var i = eb(e), o = eb(t);
  function a(s, l) {
    return e7(s, l, n.slice(), r.slice());
  }
  return !tb(function(s, l) {
    return !tb(a, l, s);
  }, o, i);
}
function e7(e, t, n, r) {
  if (f4(e, t))
    return !0;
  var i = Sv(e);
  if (i !== Sv(t))
    return !1;
  if (typeof e["fantasy-land/equals"] == "function" || typeof t["fantasy-land/equals"] == "function")
    return typeof e["fantasy-land/equals"] == "function" && e["fantasy-land/equals"](t) && typeof t["fantasy-land/equals"] == "function" && t["fantasy-land/equals"](e);
  if (typeof e.equals == "function" || typeof t.equals == "function")
    return typeof e.equals == "function" && e.equals(t) && typeof t.equals == "function" && t.equals(e);
  switch (i) {
    case "Arguments":
    case "Array":
    case "Object":
      if (typeof e.constructor == "function" && HP(e.constructor) === "Promise")
        return e === t;
      break;
    case "Boolean":
    case "Number":
    case "String":
      if (!(typeof e == typeof t && f4(e.valueOf(), t.valueOf())))
        return !1;
      break;
    case "Date":
      if (!f4(e.valueOf(), t.valueOf()))
        return !1;
      break;
    case "Error":
      return e.name === t.name && e.message === t.message;
    case "RegExp":
      if (!(e.source === t.source && e.global === t.global && e.ignoreCase === t.ignoreCase && e.multiline === t.multiline && e.sticky === t.sticky && e.unicode === t.unicode))
        return !1;
      break;
  }
  for (var o = n.length - 1; o >= 0; ) {
    if (n[o] === e)
      return r[o] === t;
    o -= 1;
  }
  switch (i) {
    case "Map":
      return e.size !== t.size ? !1 : ob(e.entries(), t.entries(), n.concat([e]), r.concat([t]));
    case "Set":
      return e.size !== t.size ? !1 : ob(e.values(), t.values(), n.concat([e]), r.concat([t]));
    case "Arguments":
    case "Array":
    case "Object":
    case "Boolean":
    case "Number":
    case "String":
    case "Date":
    case "Error":
    case "RegExp":
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "ArrayBuffer":
      break;
    default:
      return !1;
  }
  var a = Zp(e);
  if (a.length !== Zp(t).length)
    return !1;
  var s = n.concat([e]), l = r.concat([t]);
  for (o = a.length - 1; o >= 0; ) {
    var u = a[o];
    if (!(Vs(u, t) && e7(t[u], e[u], s, l)))
      return !1;
    o -= 1;
  }
  return !0;
}
var t7 = /* @__PURE__ */ ri(function(e, t) {
  return e7(e, t, [], []);
});
function GP(e, t, n) {
  var r, i;
  if (typeof e.indexOf == "function")
    switch (typeof t) {
      case "number":
        if (t === 0) {
          for (r = 1 / t; n < e.length; ) {
            if (i = e[n], i === 0 && 1 / i === r)
              return n;
            n += 1;
          }
          return -1;
        } else if (t !== t) {
          for (; n < e.length; ) {
            if (i = e[n], typeof i == "number" && i !== i)
              return n;
            n += 1;
          }
          return -1;
        }
        return e.indexOf(t, n);
      case "string":
      case "boolean":
      case "function":
      case "undefined":
        return e.indexOf(t, n);
      case "object":
        if (t === null)
          return e.indexOf(t, n);
    }
  for (; n < e.length; ) {
    if (t7(e[n], t))
      return n;
    n += 1;
  }
  return -1;
}
function KP(e, t) {
  return GP(t, e, 0) >= 0;
}
function XP(e, t) {
  for (var n = 0, r = t.length, i = Array(r); n < r; )
    i[n] = e(t[n]), n += 1;
  return i;
}
function xD(e, t, n) {
  for (var r = 0, i = n.length; r < i; )
    t = e(t, n[r]), r += 1;
  return t;
}
function ab(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
var QP = /* @__PURE__ */ function() {
  function e(t, n) {
    this.xf = n, this.f = t;
  }
  return e.prototype["@@transducer/init"] = Ev.init, e.prototype["@@transducer/result"] = Ev.result, e.prototype["@@transducer/step"] = function(t, n) {
    return this.xf["@@transducer/step"](t, this.f(n));
  }, e;
}(), YP = function(e) {
  return function(t) {
    return new QP(e, t);
  };
}, rc = /* @__PURE__ */ ri(/* @__PURE__ */ yD(["fantasy-land/map", "map"], YP, function(e, t) {
  switch (Object.prototype.toString.call(t)) {
    case "[object Function]":
      return PP(t.length, function() {
        return e.call(this, t.apply(this, arguments));
      });
    case "[object Object]":
      return xD(function(n, r) {
        return n[r] = e(t[r]), n;
      }, {}, Zp(t));
    default:
      return XP(e, t);
  }
}));
const n7 = Number.isInteger || function(e) {
  return e << 0 === e;
};
function r7(e) {
  return Object.prototype.toString.call(e) === "[object String]";
}
function bD(e, t) {
  var n = e < 0 ? t.length + e : e;
  return r7(t) ? t.charAt(n) : t[n];
}
var JP = /* @__PURE__ */ ri(function(e, t) {
  if (t != null)
    return n7(e) ? bD(e, t) : t[e];
}), e_ = /* @__PURE__ */ zr(function(e) {
  return yg(e) ? !0 : !e || typeof e != "object" || r7(e) ? !1 : e.length === 0 ? !0 : e.length > 0 ? e.hasOwnProperty(0) && e.hasOwnProperty(e.length - 1) : !1;
}), wD = /* @__PURE__ */ zr(function(e) {
  return function() {
    return e;
  };
}), t_ = /* @__PURE__ */ function() {
  function e(t, n) {
    this.xf = n, this.f = t, this.any = !1;
  }
  return e.prototype["@@transducer/init"] = Ev.init, e.prototype["@@transducer/result"] = function(t) {
    return this.any || (t = this.xf["@@transducer/step"](t, !1)), this.xf["@@transducer/result"](t);
  }, e.prototype["@@transducer/step"] = function(t, n) {
    return this.f(n) && (this.any = !0, t = $P(this.xf["@@transducer/step"](t, !0))), t;
  }, e;
}();
function n_(e) {
  return function(t) {
    return new t_(e, t);
  };
}
var r_ = /* @__PURE__ */ ri(/* @__PURE__ */ yD(["any"], n_, function(e, t) {
  for (var n = 0; n < t.length; ) {
    if (e(t[n]))
      return !0;
    n += 1;
  }
  return !1;
})), i_ = /* @__PURE__ */ zr(function(e) {
  for (var t = Zp(e), n = t.length, r = [], i = 0; i < n; )
    r[i] = e[t[i]], i += 1;
  return r;
});
function o_(e, t, n) {
  if (n7(e) && yg(n)) {
    var r = [].concat(n);
    return r[e] = t, r;
  }
  var i = {};
  for (var o in n)
    i[o] = n[o];
  return i[e] = t, i;
}
var a_ = /* @__PURE__ */ zr(function(e) {
  return e == null;
}), s_ = /* @__PURE__ */ va(function e(t, n, r) {
  if (t.length === 0)
    return n;
  var i = t[0];
  if (t.length > 1) {
    var o = !a_(r) && Vs(i, r) && typeof r[i] == "object" ? r[i] : n7(t[1]) ? [] : {};
    n = e(Array.prototype.slice.call(t, 1), n, o);
  }
  return o_(i, n, r);
}), l_ = /* @__PURE__ */ va(function(e, t, n) {
  return s_([e], t, n);
});
function u_(e) {
  return function t(n) {
    for (var r, i, o, a = [], s = 0, l = n.length; s < l; ) {
      if (e_(n[s]))
        for (r = t(n[s]), o = 0, i = r.length; o < i; )
          a[a.length] = r[o], o += 1;
      else
        a[a.length] = n[s];
      s += 1;
    }
    return a;
  };
}
function c_(e) {
  return new RegExp(e.source, e.flags ? e.flags : (e.global ? "g" : "") + (e.ignoreCase ? "i" : "") + (e.multiline ? "m" : "") + (e.sticky ? "y" : "") + (e.unicode ? "u" : "") + (e.dotAll ? "s" : ""));
}
function CD(e, t, n) {
  if (n || (n = new p_()), d_(e))
    return e;
  var r = function(i) {
    var o = n.get(e);
    if (o)
      return o;
    n.set(e, i);
    for (var a in e)
      Object.prototype.hasOwnProperty.call(e, a) && (i[a] = CD(e[a], !0, n));
    return i;
  };
  switch (Sv(e)) {
    case "Object":
      return r(Object.create(Object.getPrototypeOf(e)));
    case "Array":
      return r(Array(e.length));
    case "Date":
      return new Date(e.valueOf());
    case "RegExp":
      return c_(e);
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "BigInt64Array":
    case "BigUint64Array":
      return e.slice();
    default:
      return e;
  }
}
function d_(e) {
  var t = typeof e;
  return e == null || t != "object" && t != "function";
}
var p_ = /* @__PURE__ */ function() {
  function e() {
    this.map = {}, this.length = 0;
  }
  return e.prototype.set = function(t, n) {
    var r = this.hash(t), i = this.map[r];
    i || (this.map[r] = i = []), i.push([t, n]), this.length += 1;
  }, e.prototype.hash = function(t) {
    var n = [];
    for (var r in t)
      n.push(Object.prototype.toString.call(t[r]));
    return n.join();
  }, e.prototype.get = function(t) {
    if (this.length <= 180) {
      for (var n in this.map)
        for (var a = this.map[n], r = 0; r < a.length; r += 1) {
          var i = a[r];
          if (i[0] === t)
            return i[1];
        }
      return;
    }
    var o = this.hash(t), a = this.map[o];
    if (a)
      for (var r = 0; r < a.length; r += 1) {
        var i = a[r];
        if (i[0] === t)
          return i[1];
      }
  }, e;
}(), f_ = /* @__PURE__ */ zr(function(e) {
  return e != null && typeof e.clone == "function" ? e.clone() : CD(e);
});
function kD(e, t) {
  return function() {
    var n = arguments.length;
    if (n === 0)
      return t();
    var r = arguments[n - 1];
    return yg(r) || typeof r[e] != "function" ? t.apply(this, arguments) : r[e].apply(r, Array.prototype.slice.call(arguments, 0, n - 1));
  };
}
var h_ = /* @__PURE__ */ va(/* @__PURE__ */ kD("slice", function(e, t, n) {
  return Array.prototype.slice.call(n, e, t);
})), m_ = /* @__PURE__ */ zr(/* @__PURE__ */ kD("tail", /* @__PURE__ */ h_(1, 1 / 0))), ED = /* @__PURE__ */ zr(function(e) {
  return r7(e) ? e.split("").reverse().join("") : Array.prototype.slice.call(e, 0).reverse();
}), SD = /* @__PURE__ */ zr(function(e) {
  return bD(0, e);
}), DD = /* @__PURE__ */ va(function(e, t, n) {
  var r = Array.prototype.slice.call(n, 0);
  return r.splice(e, t), r;
}), AD = /* @__PURE__ */ zr(/* @__PURE__ */ u_()), g_ = /* @__PURE__ */ ri(KP), TD = /* @__PURE__ */ va(function(e, t, n) {
  e = e < n.length && e >= 0 ? e : n.length;
  var r = Array.prototype.slice.call(n, 0);
  return r.splice(e, 0, t), r;
}), v_ = /* @__PURE__ */ ri(function(e, t) {
  return function(n) {
    return function(r) {
      return rc(function(i) {
        return t(i, r);
      }, n(e(r)));
    };
  };
}), sb = /* @__PURE__ */ va(function(e, t, n) {
  return _P(e, wD(t), n);
}), lb = /* @__PURE__ */ zr(function(e) {
  return v_(JP(e), l_(e));
}), Oh = /* @__PURE__ */ ri(function(e, t) {
  return xD(function(n, r) {
    return n[r] = e(t[r], r, t), n;
  }, {}, Zp(t));
}), y_ = /* @__PURE__ */ va(function(e, t, n) {
  var r = {}, i;
  t = t || {}, n = n || {};
  for (i in t)
    Vs(i, t) && (r[i] = Vs(i, n) ? e(i, t[i], n[i]) : t[i]);
  for (i in n)
    Vs(i, n) && !Vs(i, r) && (r[i] = n[i]);
  return r;
}), x_ = /* @__PURE__ */ va(function e(t, n, r) {
  return y_(function(i, o, a) {
    return ab(o) && ab(a) ? e(t, o, a) : t(i, o, a);
  }, n, r);
}), i7 = /* @__PURE__ */ ri(function(e, t) {
  return x_(function(n, r, i) {
    return i;
  }, e, t);
}), b_ = /* @__PURE__ */ va(function(e, t, n) {
  var r = n.length, i = n.slice(), o = e < 0 ? r + e : e, a = t < 0 ? r + t : t, s = i.splice(o, 1);
  return o < 0 || o >= n.length || a < 0 || a >= n.length ? n : [].concat(i.slice(0, a)).concat(s).concat(i.slice(a, n.length));
}), w_ = /* @__PURE__ */ ri(function(e, t) {
  for (var n = {}, r = {}, i = 0, o = e.length; i < o; )
    r[e[i]] = 1, i += 1;
  for (var a in t)
    r.hasOwnProperty(a) || (n[a] = t[a]);
  return n;
}), jD = function(e) {
  return {
    value: e,
    map: function(t) {
      return jD(t(e));
    }
  };
}, C_ = /* @__PURE__ */ va(function(e, t, n) {
  return e(function(r) {
    return jD(t(r));
  })(n).value;
}), k_ = /* @__PURE__ */ ri(function(e, t) {
  var n = Number(t);
  if (n < 0 || isNaN(n))
    throw new RangeError("n must be a non-negative number");
  for (var r = 0, i = Array(n); r < n; )
    i[r] = e(r), r += 1;
  return i;
}), ub = /* @__PURE__ */ va(function(e, t, n) {
  return C_(e, wD(t), n);
});
function Dv() {
  return Dv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Dv.apply(null, arguments);
}
var ND = ["shift", "alt", "meta", "mod", "ctrl"], E_ = {
  esc: "escape",
  return: "enter",
  ".": "period",
  ",": "comma",
  "-": "slash",
  " ": "space",
  "`": "backquote",
  "#": "backslash",
  "+": "bracketright",
  ShiftLeft: "shift",
  ShiftRight: "shift",
  AltLeft: "alt",
  AltRight: "alt",
  MetaLeft: "meta",
  MetaRight: "meta",
  OSLeft: "meta",
  OSRight: "meta",
  ControlLeft: "ctrl",
  ControlRight: "ctrl"
};
function Wl(e) {
  return (e && E_[e] || e || "").trim().toLowerCase().replace(/key|digit|numpad|arrow/, "");
}
function S_(e) {
  return ND.includes(e);
}
function h4(e, t) {
  return t === void 0 && (t = ","), e.split(t);
}
function m4(e, t, n) {
  t === void 0 && (t = "+");
  var r = e.toLocaleLowerCase().split(t).map(function(a) {
    return Wl(a);
  }), i = {
    alt: r.includes("alt"),
    ctrl: r.includes("ctrl") || r.includes("control"),
    shift: r.includes("shift"),
    meta: r.includes("meta"),
    mod: r.includes("mod")
  }, o = r.filter(function(a) {
    return !ND.includes(a);
  });
  return Dv({}, i, {
    keys: o,
    description: n,
    hotkey: e
  });
}
(function() {
  typeof document < "u" && (document.addEventListener("keydown", function(e) {
    e.key !== void 0 && OD([Wl(e.key), Wl(e.code)]);
  }), document.addEventListener("keyup", function(e) {
    e.key !== void 0 && zD([Wl(e.key), Wl(e.code)]);
  })), typeof window < "u" && window.addEventListener("blur", function() {
    Zl.clear();
  });
})();
var Zl = /* @__PURE__ */ new Set();
function o7(e) {
  return Array.isArray(e);
}
function D_(e, t) {
  t === void 0 && (t = ",");
  var n = o7(e) ? e : e.split(t);
  return n.every(function(r) {
    return Zl.has(r.trim().toLowerCase());
  });
}
function OD(e) {
  var t = Array.isArray(e) ? e : [e];
  Zl.has("meta") && Zl.forEach(function(n) {
    return !S_(n) && Zl.delete(n.toLowerCase());
  }), t.forEach(function(n) {
    return Zl.add(n.toLowerCase());
  });
}
function zD(e) {
  var t = Array.isArray(e) ? e : [e];
  e === "meta" ? Zl.clear() : t.forEach(function(n) {
    return Zl.delete(n.toLowerCase());
  });
}
function A_(e, t, n) {
  (typeof n == "function" && n(e, t) || n === !0) && e.preventDefault();
}
function T_(e, t, n) {
  return typeof n == "function" ? n(e, t) : n === !0 || n === void 0;
}
function j_(e) {
  return FD(e, ["input", "textarea", "select"]);
}
function FD(e, t) {
  t === void 0 && (t = !1);
  var n = e.target, r = e.composed, i = null;
  return N_(n) && r ? i = e.composedPath()[0] && e.composedPath()[0].tagName : i = n && n.tagName, o7(t) ? !!(i && t && t.some(function(o) {
    var a;
    return o.toLowerCase() === ((a = i) == null ? void 0 : a.toLowerCase());
  })) : !!(i && t && t);
}
function N_(e) {
  return !!e.tagName && !e.tagName.startsWith("-") && e.tagName.includes("-");
}
function O_(e, t) {
  return e.length === 0 && t ? (console.warn('A hotkey has the "scopes" option set, however no active scopes were found. If you want to use the global scopes feature, you need to wrap your app in a <HotkeysProvider>'), !0) : t ? e.some(function(n) {
    return t.includes(n);
  }) || e.includes("*") : !0;
}
var z_ = function(e, t, n) {
  n === void 0 && (n = !1);
  var r = t.alt, i = t.meta, o = t.mod, a = t.shift, s = t.ctrl, l = t.keys, u = e.key, d = e.code, p = e.ctrlKey, f = e.metaKey, m = e.shiftKey, y = e.altKey, g = Wl(d), x = u.toLowerCase();
  if (!(l != null && l.includes(g)) && !(l != null && l.includes(x)) && !["ctrl", "control", "unknown", "meta", "alt", "shift", "os"].includes(g))
    return !1;
  if (!n) {
    if (r === !y && x !== "alt" || a === !m && x !== "shift")
      return !1;
    if (o) {
      if (!f && !p)
        return !1;
    } else if (i === !f && x !== "meta" && x !== "os" || s === !p && x !== "ctrl" && x !== "control")
      return !1;
  }
  return l && l.length === 1 && (l.includes(x) || l.includes(g)) ? !0 : l ? D_(l) : !l;
}, LD = /* @__PURE__ */ v.createContext(void 0), F_ = function() {
  return v.useContext(LD);
};
function L_(e) {
  var t = e.addHotkey, n = e.removeHotkey, r = e.children;
  return /* @__PURE__ */ c.jsx(LD.Provider, {
    value: {
      addHotkey: t,
      removeHotkey: n
    },
    children: r
  });
}
function a7(e, t) {
  return e && t && typeof e == "object" && typeof t == "object" ? Object.keys(e).length === Object.keys(t).length && //@ts-ignore
  Object.keys(e).reduce(function(n, r) {
    return n && a7(e[r], t[r]);
  }, !0) : e === t;
}
var MD = /* @__PURE__ */ v.createContext({
  hotkeys: [],
  enabledScopes: [],
  toggleScope: function() {
  },
  enableScope: function() {
  },
  disableScope: function() {
  }
}), M_ = function() {
  return v.useContext(MD);
}, B_ = function(e) {
  var t = e.initiallyActiveScopes, n = t === void 0 ? ["*"] : t, r = e.children, i = v.useState((n == null ? void 0 : n.length) > 0 ? n : ["*"]), o = i[0], a = i[1], s = v.useState([]), l = s[0], u = s[1], d = v.useCallback(function(g) {
    a(function(x) {
      return x.includes("*") ? [g] : Array.from(new Set([].concat(x, [g])));
    });
  }, []), p = v.useCallback(function(g) {
    a(function(x) {
      return x.filter(function(E) {
        return E !== g;
      }).length === 0 ? ["*"] : x.filter(function(E) {
        return E !== g;
      });
    });
  }, []), f = v.useCallback(function(g) {
    a(function(x) {
      return x.includes(g) ? x.filter(function(E) {
        return E !== g;
      }).length === 0 ? ["*"] : x.filter(function(E) {
        return E !== g;
      }) : x.includes("*") ? [g] : Array.from(new Set([].concat(x, [g])));
    });
  }, []), m = v.useCallback(function(g) {
    u(function(x) {
      return [].concat(x, [g]);
    });
  }, []), y = v.useCallback(function(g) {
    u(function(x) {
      return x.filter(function(E) {
        return !a7(E, g);
      });
    });
  }, []);
  return /* @__PURE__ */ c.jsx(MD.Provider, {
    value: {
      enabledScopes: o,
      hotkeys: l,
      enableScope: d,
      disableScope: p,
      toggleScope: f
    },
    children: /* @__PURE__ */ c.jsx(L_, {
      addHotkey: m,
      removeHotkey: y,
      children: r
    })
  });
};
function I_(e) {
  var t = v.useRef(void 0);
  return a7(t.current, e) || (t.current = e), t.current;
}
var cb = function(e) {
  e.stopPropagation(), e.preventDefault(), e.stopImmediatePropagation();
}, R_ = typeof window < "u" ? v.useLayoutEffect : v.useEffect;
function ua(e, t, n, r) {
  var i = v.useState(null), o = i[0], a = i[1], s = v.useRef(!1), l = n instanceof Array ? r instanceof Array ? void 0 : r : n, u = o7(e) ? e.join(l == null ? void 0 : l.splitKey) : e, d = n instanceof Array ? n : r instanceof Array ? r : void 0, p = v.useCallback(t, d ?? []), f = v.useRef(p);
  d ? f.current = p : f.current = t;
  var m = I_(l), y = M_(), g = y.enabledScopes, x = F_();
  return R_(function() {
    if (!((m == null ? void 0 : m.enabled) === !1 || !O_(g, m == null ? void 0 : m.scopes))) {
      var E = function(z, I) {
        var w;
        if (I === void 0 && (I = !1), !(j_(z) && !FD(z, m == null ? void 0 : m.enableOnFormTags))) {
          if (o !== null) {
            var M = o.getRootNode();
            if ((M instanceof Document || M instanceof ShadowRoot) && M.activeElement !== o && !o.contains(M.activeElement)) {
              cb(z);
              return;
            }
          }
          (w = z.target) != null && w.isContentEditable && !(m != null && m.enableOnContentEditable) || h4(u, m == null ? void 0 : m.splitKey).forEach(function(R) {
            var F, W = m4(R, m == null ? void 0 : m.combinationKey);
            if (z_(z, W, m == null ? void 0 : m.ignoreModifiers) || (F = W.keys) != null && F.includes("*")) {
              if (m != null && m.ignoreEventWhen != null && m.ignoreEventWhen(z) || I && s.current)
                return;
              if (A_(z, W, m == null ? void 0 : m.preventDefault), !T_(z, W, m == null ? void 0 : m.enabled)) {
                cb(z);
                return;
              }
              f.current(z, W), I || (s.current = !0);
            }
          });
        }
      }, b = function(z) {
        z.key !== void 0 && (OD(Wl(z.code)), ((m == null ? void 0 : m.keydown) === void 0 && (m == null ? void 0 : m.keyup) !== !0 || m != null && m.keydown) && E(z));
      }, C = function(z) {
        z.key !== void 0 && (zD(Wl(z.code)), s.current = !1, m != null && m.keyup && E(z, !0));
      }, T = o || (l == null ? void 0 : l.document) || document;
      return T.addEventListener("keyup", C), T.addEventListener("keydown", b), x && h4(u, m == null ? void 0 : m.splitKey).forEach(function(z) {
        return x.addHotkey(m4(z, m == null ? void 0 : m.combinationKey, m == null ? void 0 : m.description));
      }), function() {
        T.removeEventListener("keyup", C), T.removeEventListener("keydown", b), x && h4(u, m == null ? void 0 : m.splitKey).forEach(function(z) {
          return x.removeHotkey(m4(z, m == null ? void 0 : m.combinationKey, m == null ? void 0 : m.description));
        });
      };
    }
  }, [o, u, m, g]), a;
}
function Jr(e) {
  return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var P_ = typeof Symbol == "function" && Symbol.observable || "@@observable", db = P_, g4 = () => Math.random().toString(36).substring(7).split("").join("."), __ = {
  INIT: `@@redux/INIT${/* @__PURE__ */ g4()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ g4()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${g4()}`
}, xm = __;
function s7(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function BD(e, t, n) {
  if (typeof e != "function")
    throw new Error(Jr(2));
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(Jr(0));
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(Jr(1));
    return n(BD)(e, t);
  }
  let r = e, i = t, o = /* @__PURE__ */ new Map(), a = o, s = 0, l = !1;
  function u() {
    a === o && (a = /* @__PURE__ */ new Map(), o.forEach((g, x) => {
      a.set(x, g);
    }));
  }
  function d() {
    if (l)
      throw new Error(Jr(3));
    return i;
  }
  function p(g) {
    if (typeof g != "function")
      throw new Error(Jr(4));
    if (l)
      throw new Error(Jr(5));
    let x = !0;
    u();
    const E = s++;
    return a.set(E, g), function() {
      if (x) {
        if (l)
          throw new Error(Jr(6));
        x = !1, u(), a.delete(E), o = null;
      }
    };
  }
  function f(g) {
    if (!s7(g))
      throw new Error(Jr(7));
    if (typeof g.type > "u")
      throw new Error(Jr(8));
    if (typeof g.type != "string")
      throw new Error(Jr(17));
    if (l)
      throw new Error(Jr(9));
    try {
      l = !0, i = r(i, g);
    } finally {
      l = !1;
    }
    return (o = a).forEach((x) => {
      x();
    }), g;
  }
  function m(g) {
    if (typeof g != "function")
      throw new Error(Jr(10));
    r = g, f({
      type: xm.REPLACE
    });
  }
  function y() {
    const g = p;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(x) {
        if (typeof x != "object" || x === null)
          throw new Error(Jr(11));
        function E() {
          const b = x;
          b.next && b.next(d());
        }
        return E(), {
          unsubscribe: g(E)
        };
      },
      [db]() {
        return this;
      }
    };
  }
  return f({
    type: xm.INIT
  }), {
    dispatch: f,
    subscribe: p,
    getState: d,
    replaceReducer: m,
    [db]: y
  };
}
function q_(e) {
  Object.keys(e).forEach((t) => {
    const n = e[t];
    if (typeof n(void 0, {
      type: xm.INIT
    }) > "u")
      throw new Error(Jr(12));
    if (typeof n(void 0, {
      type: xm.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(Jr(13));
  });
}
function $_(e) {
  const t = Object.keys(e), n = {};
  for (let o = 0; o < t.length; o++) {
    const a = t[o];
    typeof e[a] == "function" && (n[a] = e[a]);
  }
  const r = Object.keys(n);
  let i;
  try {
    q_(n);
  } catch (o) {
    i = o;
  }
  return function(o = {}, a) {
    if (i)
      throw i;
    let s = !1;
    const l = {};
    for (let u = 0; u < r.length; u++) {
      const d = r[u], p = n[d], f = o[d], m = p(f, a);
      if (typeof m > "u")
        throw a && a.type, new Error(Jr(14));
      l[d] = m, s = s || m !== f;
    }
    return s = s || r.length !== Object.keys(o).length, s ? l : o;
  };
}
function bm(...e) {
  return e.length === 0 ? (t) => t : e.length === 1 ? e[0] : e.reduce((t, n) => (...r) => t(n(...r)));
}
function H_(...e) {
  return (t) => (n, r) => {
    const i = t(n, r);
    let o = () => {
      throw new Error(Jr(15));
    };
    const a = {
      getState: i.getState,
      dispatch: (l, ...u) => o(l, ...u)
    }, s = e.map((l) => l(a));
    return o = bm(...s)(i.dispatch), {
      ...i,
      dispatch: o
    };
  };
}
function V_(e) {
  return s7(e) && "type" in e && typeof e.type == "string";
}
var ID = Symbol.for("immer-nothing"), pb = Symbol.for("immer-draftable"), Bo = Symbol.for("immer-state");
function Ma(e, ...t) {
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var V0 = Object.getPrototypeOf;
function pu(e) {
  return !!e && !!e[Bo];
}
function nl(e) {
  var t;
  return e ? RD(e) || Array.isArray(e) || !!e[pb] || !!((t = e.constructor) != null && t[pb]) || bg(e) || wg(e) : !1;
}
var U_ = Object.prototype.constructor.toString();
function RD(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = V0(e);
  if (t === null)
    return !0;
  const n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return n === Object ? !0 : typeof n == "function" && Function.toString.call(n) === U_;
}
function wm(e, t) {
  xg(e) === 0 ? Reflect.ownKeys(e).forEach((n) => {
    t(n, e[n], e);
  }) : e.forEach((n, r) => t(r, n, e));
}
function xg(e) {
  const t = e[Bo];
  return t ? t.type_ : Array.isArray(e) ? 1 : bg(e) ? 2 : wg(e) ? 3 : 0;
}
function Av(e, t) {
  return xg(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function PD(e, t, n) {
  const r = xg(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function W_(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function bg(e) {
  return e instanceof Map;
}
function wg(e) {
  return e instanceof Set;
}
function Ju(e) {
  return e.copy_ || e.base_;
}
function Tv(e, t) {
  if (bg(e))
    return new Map(e);
  if (wg(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const n = RD(e);
  if (t === !0 || t === "class_only" && !n) {
    const r = Object.getOwnPropertyDescriptors(e);
    delete r[Bo];
    let i = Reflect.ownKeys(r);
    for (let o = 0; o < i.length; o++) {
      const a = i[o], s = r[a];
      s.writable === !1 && (s.writable = !0, s.configurable = !0), (s.get || s.set) && (r[a] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: s.enumerable,
        value: e[a]
      });
    }
    return Object.create(V0(e), r);
  } else {
    const r = V0(e);
    if (r !== null && n)
      return { ...e };
    const i = Object.create(r);
    return Object.assign(i, e);
  }
}
function l7(e, t = !1) {
  return Cg(e) || pu(e) || !nl(e) || (xg(e) > 1 && (e.set = e.add = e.clear = e.delete = Z_), Object.freeze(e), t && Object.entries(e).forEach(([n, r]) => l7(r, !0))), e;
}
function Z_() {
  Ma(2);
}
function Cg(e) {
  return Object.isFrozen(e);
}
var G_ = {};
function kc(e) {
  const t = G_[e];
  return t || Ma(0, e), t;
}
var Gp;
function _D() {
  return Gp;
}
function K_(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function fb(e, t) {
  t && (kc("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function jv(e) {
  Nv(e), e.drafts_.forEach(X_), e.drafts_ = null;
}
function Nv(e) {
  e === Gp && (Gp = e.parent_);
}
function hb(e) {
  return Gp = K_(Gp, e);
}
function X_(e) {
  const t = e[Bo];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function mb(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const n = t.drafts_[0];
  return e !== void 0 && e !== n ? (n[Bo].modified_ && (jv(t), Ma(4)), nl(e) && (e = Cm(t, e), t.parent_ || km(t, e)), t.patches_ && kc("Patches").generateReplacementPatches_(
    n[Bo].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = Cm(t, n, []), jv(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== ID ? e : void 0;
}
function Cm(e, t, n) {
  if (Cg(t))
    return t;
  const r = t[Bo];
  if (!r)
    return wm(
      t,
      (i, o) => gb(e, r, t, i, o, n)
    ), t;
  if (r.scope_ !== e)
    return t;
  if (!r.modified_)
    return km(e, r.base_, !0), r.base_;
  if (!r.finalized_) {
    r.finalized_ = !0, r.scope_.unfinalizedDrafts_--;
    const i = r.copy_;
    let o = i, a = !1;
    r.type_ === 3 && (o = new Set(i), i.clear(), a = !0), wm(
      o,
      (s, l) => gb(e, r, i, s, l, n, a)
    ), km(e, i, !1), n && e.patches_ && kc("Patches").generatePatches_(
      r,
      n,
      e.patches_,
      e.inversePatches_
    );
  }
  return r.copy_;
}
function gb(e, t, n, r, i, o, a) {
  if (pu(i)) {
    const s = o && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !Av(t.assigned_, r) ? o.concat(r) : void 0, l = Cm(e, i, s);
    if (PD(n, r, l), pu(l))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else a && n.add(i);
  if (nl(i) && !Cg(i)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    Cm(e, i), (!t || !t.scope_.parent_) && typeof r != "symbol" && Object.prototype.propertyIsEnumerable.call(n, r) && km(e, i);
  }
}
function km(e, t, n = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && l7(t, n);
}
function Q_(e, t) {
  const n = Array.isArray(e), r = {
    type_: n ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : _D(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let i = r, o = u7;
  n && (i = [r], o = Kp);
  const { revoke: a, proxy: s } = Proxy.revocable(i, o);
  return r.draft_ = s, r.revoke_ = a, s;
}
var u7 = {
  get(e, t) {
    if (t === Bo)
      return e;
    const n = Ju(e);
    if (!Av(n, t))
      return Y_(e, n, t);
    const r = n[t];
    return e.finalized_ || !nl(r) ? r : r === v4(e.base_, t) ? (y4(e), e.copy_[t] = zv(r, e)) : r;
  },
  has(e, t) {
    return t in Ju(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(Ju(e));
  },
  set(e, t, n) {
    const r = qD(Ju(e), t);
    if (r != null && r.set)
      return r.set.call(e.draft_, n), !0;
    if (!e.modified_) {
      const i = v4(Ju(e), t), o = i == null ? void 0 : i[Bo];
      if (o && o.base_ === n)
        return e.copy_[t] = n, e.assigned_[t] = !1, !0;
      if (W_(n, i) && (n !== void 0 || Av(e.base_, t)))
        return !0;
      y4(e), Ov(e);
    }
    return e.copy_[t] === n && // special case: handle new props with value 'undefined'
    (n !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(n) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = n, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return v4(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, y4(e), Ov(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const n = Ju(e), r = Reflect.getOwnPropertyDescriptor(n, t);
    return r && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: r.enumerable,
      value: n[t]
    };
  },
  defineProperty() {
    Ma(11);
  },
  getPrototypeOf(e) {
    return V0(e.base_);
  },
  setPrototypeOf() {
    Ma(12);
  }
}, Kp = {};
wm(u7, (e, t) => {
  Kp[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
Kp.deleteProperty = function(e, t) {
  return Kp.set.call(this, e, t, void 0);
};
Kp.set = function(e, t, n) {
  return u7.set.call(this, e[0], t, n, e[0]);
};
function v4(e, t) {
  const n = e[Bo];
  return (n ? Ju(n) : e)[t];
}
function Y_(e, t, n) {
  var r;
  const i = qD(t, n);
  return i ? "value" in i ? i.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (r = i.get) == null ? void 0 : r.call(e.draft_)
  ) : void 0;
}
function qD(e, t) {
  if (!(t in e))
    return;
  let n = V0(e);
  for (; n; ) {
    const r = Object.getOwnPropertyDescriptor(n, t);
    if (r)
      return r;
    n = V0(n);
  }
}
function Ov(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && Ov(e.parent_));
}
function y4(e) {
  e.copy_ || (e.copy_ = Tv(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var J_ = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, n, r) => {
      if (typeof t == "function" && typeof n != "function") {
        const o = n;
        n = t;
        const a = this;
        return function(s = o, ...l) {
          return a.produce(s, (u) => n.call(this, u, ...l));
        };
      }
      typeof n != "function" && Ma(6), r !== void 0 && typeof r != "function" && Ma(7);
      let i;
      if (nl(t)) {
        const o = hb(this), a = zv(t, void 0);
        let s = !0;
        try {
          i = n(a), s = !1;
        } finally {
          s ? jv(o) : Nv(o);
        }
        return fb(o, r), mb(i, o);
      } else if (!t || typeof t != "object") {
        if (i = n(t), i === void 0 && (i = t), i === ID && (i = void 0), this.autoFreeze_ && l7(i, !0), r) {
          const o = [], a = [];
          kc("Patches").generateReplacementPatches_(t, i, o, a), r(o, a);
        }
        return i;
      } else
        Ma(1, t);
    }, this.produceWithPatches = (t, n) => {
      if (typeof t == "function")
        return (o, ...a) => this.produceWithPatches(o, (s) => t(s, ...a));
      let r, i;
      return [this.produce(t, n, (o, a) => {
        r = o, i = a;
      }), r, i];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    nl(e) || Ma(8), pu(e) && (e = eq(e));
    const t = hb(this), n = zv(e, void 0);
    return n[Bo].isManual_ = !0, Nv(t), n;
  }
  finishDraft(e, t) {
    const n = e && e[Bo];
    (!n || !n.isManual_) && Ma(9);
    const { scope_: r } = n;
    return fb(r, t), mb(void 0, r);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let n;
    for (n = t.length - 1; n >= 0; n--) {
      const i = t[n];
      if (i.path.length === 0 && i.op === "replace") {
        e = i.value;
        break;
      }
    }
    n > -1 && (t = t.slice(n + 1));
    const r = kc("Patches").applyPatches_;
    return pu(e) ? r(e, t) : this.produce(
      e,
      (i) => r(i, t)
    );
  }
};
function zv(e, t) {
  const n = bg(e) ? kc("MapSet").proxyMap_(e, t) : wg(e) ? kc("MapSet").proxySet_(e, t) : Q_(e, t);
  return (t ? t.scope_ : _D()).drafts_.push(n), n;
}
function eq(e) {
  return pu(e) || Ma(10, e), $D(e);
}
function $D(e) {
  if (!nl(e) || Cg(e))
    return e;
  const t = e[Bo];
  let n;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, n = Tv(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    n = Tv(e, !0);
  return wm(n, (r, i) => {
    PD(n, r, $D(i));
  }), t && (t.finalized_ = !1), n;
}
var Io = new J_(), kf = Io.produce;
Io.produceWithPatches.bind(
  Io
);
Io.setAutoFreeze.bind(Io);
Io.setUseStrictShallowCopy.bind(Io);
Io.applyPatches.bind(Io);
var vb = Io.createDraft.bind(Io), yb = Io.finishDraft.bind(Io), Em = /* @__PURE__ */ Symbol("NOT_FOUND");
function tq(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function nq(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function rq(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((n) => typeof n == "function")) {
    const n = e.map(
      (r) => typeof r == "function" ? `function ${r.name || "unnamed"}()` : typeof r
    ).join(", ");
    throw new TypeError(`${t}[${n}]`);
  }
}
var xb = (e) => Array.isArray(e) ? e : [e];
function iq(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return rq(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function oq(e, t) {
  const n = [], { length: r } = e;
  for (let i = 0; i < r; i++)
    n.push(e[i].apply(null, t));
  return n;
}
function aq(e) {
  let t;
  return {
    get(n) {
      return t && e(t.key, n) ? t.value : Em;
    },
    put(n, r) {
      t = { key: n, value: r };
    },
    getEntries() {
      return t ? [t] : [];
    },
    clear() {
      t = void 0;
    }
  };
}
function sq(e, t) {
  let n = [];
  function r(s) {
    const l = n.findIndex((u) => t(s, u.key));
    if (l > -1) {
      const u = n[l];
      return l > 0 && (n.splice(l, 1), n.unshift(u)), u.value;
    }
    return Em;
  }
  function i(s, l) {
    r(s) === Em && (n.unshift({ key: s, value: l }), n.length > e && n.pop());
  }
  function o() {
    return n;
  }
  function a() {
    n = [];
  }
  return { get: r, put: i, getEntries: o, clear: a };
}
var lq = (e, t) => e === t;
function uq(e) {
  return function(t, n) {
    if (t === null || n === null || t.length !== n.length)
      return !1;
    const { length: r } = t;
    for (let i = 0; i < r; i++)
      if (!e(t[i], n[i]))
        return !1;
    return !0;
  };
}
function HD(e, t) {
  const n = typeof t == "object" ? t : { equalityCheck: t }, {
    equalityCheck: r = lq,
    maxSize: i = 1,
    resultEqualityCheck: o
  } = n, a = uq(r);
  let s = 0;
  const l = i <= 1 ? aq(a) : sq(i, a);
  function u() {
    let d = l.get(arguments);
    if (d === Em) {
      if (d = e.apply(null, arguments), s++, o) {
        const p = l.getEntries().find(
          (f) => o(f.value, d)
        );
        p && (d = p.value, s !== 0 && s--);
      }
      l.put(arguments, d);
    }
    return d;
  }
  return u.clearCache = () => {
    l.clear(), u.resetResultsCount();
  }, u.resultsCount = () => s, u.resetResultsCount = () => {
    s = 0;
  }, u;
}
var cq = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, dq = typeof WeakRef < "u" ? WeakRef : cq, pq = 0, bb = 1;
function zh() {
  return {
    s: pq,
    v: void 0,
    o: null,
    p: null
  };
}
function VD(e, t = {}) {
  let n = zh();
  const { resultEqualityCheck: r } = t;
  let i, o = 0;
  function a() {
    var s;
    let l = n;
    const { length: u } = arguments;
    for (let f = 0, m = u; f < m; f++) {
      const y = arguments[f];
      if (typeof y == "function" || typeof y == "object" && y !== null) {
        let g = l.o;
        g === null && (l.o = g = /* @__PURE__ */ new WeakMap());
        const x = g.get(y);
        x === void 0 ? (l = zh(), g.set(y, l)) : l = x;
      } else {
        let g = l.p;
        g === null && (l.p = g = /* @__PURE__ */ new Map());
        const x = g.get(y);
        x === void 0 ? (l = zh(), g.set(y, l)) : l = x;
      }
    }
    const d = l;
    let p;
    if (l.s === bb)
      p = l.v;
    else if (p = e.apply(null, arguments), o++, r) {
      const f = ((s = i == null ? void 0 : i.deref) == null ? void 0 : s.call(i)) ?? i;
      f != null && r(f, p) && (p = f, o !== 0 && o--), i = typeof p == "object" && p !== null || typeof p == "function" ? new dq(p) : p;
    }
    return d.s = bb, d.v = p, p;
  }
  return a.clearCache = () => {
    n = zh(), a.resetResultsCount();
  }, a.resultsCount = () => o, a.resetResultsCount = () => {
    o = 0;
  }, a;
}
function c7(e, ...t) {
  const n = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, r = (...i) => {
    let o = 0, a = 0, s, l = {}, u = i.pop();
    typeof u == "object" && (l = u, u = i.pop()), tq(
      u,
      `createSelector expects an output function after the inputs, but received: [${typeof u}]`
    );
    const d = {
      ...n,
      ...l
    }, {
      memoize: p,
      memoizeOptions: f = [],
      argsMemoize: m = VD,
      argsMemoizeOptions: y = [],
      devModeChecks: g = {}
    } = d, x = xb(f), E = xb(y), b = iq(i), C = p(function() {
      return o++, u.apply(
        null,
        arguments
      );
    }, ...x), T = m(function() {
      a++;
      const z = oq(
        b,
        arguments
      );
      return s = C.apply(null, z), s;
    }, ...E);
    return Object.assign(T, {
      resultFunc: u,
      memoizedResultFunc: C,
      dependencies: b,
      dependencyRecomputations: () => a,
      resetDependencyRecomputations: () => {
        a = 0;
      },
      lastResult: () => s,
      recomputations: () => o,
      resetRecomputations: () => {
        o = 0;
      },
      memoize: p,
      argsMemoize: m
    });
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var Vr = /* @__PURE__ */ c7(VD), fq = Object.assign(
  (e, t = Vr) => {
    nq(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const n = Object.keys(e), r = n.map(
      (i) => e[i]
    );
    return t(
      r,
      (...i) => i.reduce((o, a, s) => (o[n[s]] = a, o), {})
    );
  },
  { withTypes: () => fq }
);
function UD(e) {
  return ({ dispatch: t, getState: n }) => (r) => (i) => typeof i == "function" ? i(t, n, e) : r(i);
}
var hq = UD(), mq = UD, gq = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? bm : bm.apply(null, arguments);
}, vq = (e) => e && typeof e.match == "function";
function Oo(e, t) {
  function n(...r) {
    if (t) {
      let i = t(...r);
      if (!i)
        throw new Error(us(0));
      return {
        type: e,
        payload: i.payload,
        ..."meta" in i && {
          meta: i.meta
        },
        ..."error" in i && {
          error: i.error
        }
      };
    }
    return {
      type: e,
      payload: r[0]
    };
  }
  return n.toString = () => `${e}`, n.type = e, n.match = (r) => V_(r) && r.type === e, n;
}
var WD = class Jd extends Array {
  constructor(...t) {
    super(...t), Object.setPrototypeOf(this, Jd.prototype);
  }
  static get [Symbol.species]() {
    return Jd;
  }
  concat(...t) {
    return super.concat.apply(this, t);
  }
  prepend(...t) {
    return t.length === 1 && Array.isArray(t[0]) ? new Jd(...t[0].concat(this)) : new Jd(...t.concat(this));
  }
};
function wb(e) {
  return nl(e) ? kf(e, () => {
  }) : e;
}
function Cb(e, t, n) {
  if (e.has(t)) {
    let i = e.get(t);
    return n.update && (i = n.update(i, t, e), e.set(t, i)), i;
  }
  if (!n.insert) throw new Error(us(10));
  const r = n.insert(t, e);
  return e.set(t, r), r;
}
function yq(e) {
  return typeof e == "boolean";
}
var xq = () => function(e) {
  const {
    thunk: t = !0,
    immutableCheck: n = !0,
    serializableCheck: r = !0,
    actionCreatorCheck: i = !0
  } = e ?? {};
  let o = new WD();
  return t && (yq(t) ? o.push(hq) : o.push(mq(t.extraArgument))), o;
}, bq = "RTK_autoBatch", ZD = (e) => (t) => {
  setTimeout(t, e);
}, wq = typeof window < "u" && window.requestAnimationFrame ? window.requestAnimationFrame : ZD(10), Cq = (e = {
  type: "raf"
}) => (t) => (...n) => {
  const r = t(...n);
  let i = !0, o = !1, a = !1;
  const s = /* @__PURE__ */ new Set(), l = e.type === "tick" ? queueMicrotask : e.type === "raf" ? wq : e.type === "callback" ? e.queueNotification : ZD(e.timeout), u = () => {
    a = !1, o && (o = !1, s.forEach((d) => d()));
  };
  return Object.assign({}, r, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(d) {
      const p = () => i && d(), f = r.subscribe(p);
      return s.add(d), () => {
        f(), s.delete(d);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(d) {
      var p;
      try {
        return i = !((p = d == null ? void 0 : d.meta) != null && p[bq]), o = !i, o && (a || (a = !0, l(u))), r.dispatch(d);
      } finally {
        i = !0;
      }
    }
  });
}, kq = (e) => function(t) {
  const {
    autoBatch: n = !0
  } = t ?? {};
  let r = new WD(e);
  return n && r.push(Cq(typeof n == "object" ? n : void 0)), r;
};
function Eq(e) {
  const t = xq(), {
    reducer: n = void 0,
    middleware: r,
    devTools: i = !0,
    preloadedState: o = void 0,
    enhancers: a = void 0
  } = e || {};
  let s;
  if (typeof n == "function")
    s = n;
  else if (s7(n))
    s = $_(n);
  else
    throw new Error(us(1));
  let l;
  typeof r == "function" ? l = r(t) : l = t();
  let u = bm;
  i && (u = gq({
    // Enable capture of stack traces for dispatched Redux actions
    trace: !1,
    ...typeof i == "object" && i
  }));
  const d = H_(...l), p = kq(d);
  let f = typeof a == "function" ? a(p) : p();
  const m = u(...f);
  return BD(s, o, m);
}
function GD(e) {
  const t = {}, n = [];
  let r;
  const i = {
    addCase(o, a) {
      const s = typeof o == "string" ? o : o.type;
      if (!s)
        throw new Error(us(28));
      if (s in t)
        throw new Error(us(29));
      return t[s] = a, i;
    },
    addMatcher(o, a) {
      return n.push({
        matcher: o,
        reducer: a
      }), i;
    },
    addDefaultCase(o) {
      return r = o, i;
    }
  };
  return e(i), [t, n, r];
}
function Sq(e) {
  return typeof e == "function";
}
function Dq(e, t) {
  let [n, r, i] = GD(t), o;
  if (Sq(e))
    o = () => wb(e());
  else {
    const s = wb(e);
    o = () => s;
  }
  function a(s = o(), l) {
    let u = [n[l.type], ...r.filter(({
      matcher: d
    }) => d(l)).map(({
      reducer: d
    }) => d)];
    return u.filter((d) => !!d).length === 0 && (u = [i]), u.reduce((d, p) => {
      if (p)
        if (pu(d)) {
          const f = p(d, l);
          return f === void 0 ? d : f;
        } else {
          if (nl(d))
            return kf(d, (f) => p(f, l));
          {
            const f = p(d, l);
            if (f === void 0) {
              if (d === null)
                return d;
              throw Error("A case reducer on a non-draftable value must not return undefined");
            }
            return f;
          }
        }
      return d;
    }, s);
  }
  return a.getInitialState = o, a;
}
var Aq = (e, t) => vq(e) ? e.match(t) : e(t);
function Tq(...e) {
  return (t) => e.some((n) => Aq(n, t));
}
var jq = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", Nq = (e = 21) => {
  let t = "", n = e;
  for (; n--; )
    t += jq[Math.random() * 64 | 0];
  return t;
}, Oq = ["name", "message", "stack", "code"], x4 = class {
  constructor(e, t) {
    pD(this, "_type"), this.payload = e, this.meta = t;
  }
}, kb = class {
  constructor(e, t) {
    pD(this, "_type"), this.payload = e, this.meta = t;
  }
}, zq = (e) => {
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const n of Oq)
      typeof e[n] == "string" && (t[n] = e[n]);
    return t;
  }
  return {
    message: String(e)
  };
}, KD = /* @__PURE__ */ (() => {
  function e(t, n, r) {
    const i = Oo(t + "/fulfilled", (l, u, d, p) => ({
      payload: l,
      meta: {
        ...p || {},
        arg: d,
        requestId: u,
        requestStatus: "fulfilled"
      }
    })), o = Oo(t + "/pending", (l, u, d) => ({
      payload: void 0,
      meta: {
        ...d || {},
        arg: u,
        requestId: l,
        requestStatus: "pending"
      }
    })), a = Oo(t + "/rejected", (l, u, d, p, f) => ({
      payload: p,
      error: (r && r.serializeError || zq)(l || "Rejected"),
      meta: {
        ...f || {},
        arg: d,
        requestId: u,
        rejectedWithValue: !!p,
        requestStatus: "rejected",
        aborted: (l == null ? void 0 : l.name) === "AbortError",
        condition: (l == null ? void 0 : l.name) === "ConditionError"
      }
    }));
    function s(l) {
      return (u, d, p) => {
        const f = r != null && r.idGenerator ? r.idGenerator(l) : Nq(), m = new AbortController();
        let y, g;
        function x(b) {
          g = b, m.abort();
        }
        const E = async function() {
          var b, C;
          let T;
          try {
            let z = (b = r == null ? void 0 : r.condition) == null ? void 0 : b.call(r, l, {
              getState: d,
              extra: p
            });
            if (Lq(z) && (z = await z), z === !1 || m.signal.aborted)
              throw {
                name: "ConditionError",
                message: "Aborted due to condition callback returning false."
              };
            const I = new Promise((w, M) => {
              y = () => {
                M({
                  name: "AbortError",
                  message: g || "Aborted"
                });
              }, m.signal.addEventListener("abort", y);
            });
            u(o(f, l, (C = r == null ? void 0 : r.getPendingMeta) == null ? void 0 : C.call(r, {
              requestId: f,
              arg: l
            }, {
              getState: d,
              extra: p
            }))), T = await Promise.race([I, Promise.resolve(n(l, {
              dispatch: u,
              getState: d,
              extra: p,
              requestId: f,
              signal: m.signal,
              abort: x,
              rejectWithValue: (w, M) => new x4(w, M),
              fulfillWithValue: (w, M) => new kb(w, M)
            })).then((w) => {
              if (w instanceof x4)
                throw w;
              return w instanceof kb ? i(w.payload, f, l, w.meta) : i(w, f, l);
            })]);
          } catch (z) {
            T = z instanceof x4 ? a(null, f, l, z.payload, z.meta) : a(z, f, l);
          } finally {
            y && m.signal.removeEventListener("abort", y);
          }
          return r && !r.dispatchConditionRejection && a.match(T) && T.meta.condition || u(T), T;
        }();
        return Object.assign(E, {
          abort: x,
          requestId: f,
          arg: l,
          unwrap() {
            return E.then(Fq);
          }
        });
      };
    }
    return Object.assign(s, {
      pending: o,
      rejected: a,
      fulfilled: i,
      settled: Tq(a, i),
      typePrefix: t
    });
  }
  return e.withTypes = () => e, e;
})();
function Fq(e) {
  if (e.meta && e.meta.rejectedWithValue)
    throw e.payload;
  if (e.error)
    throw e.error;
  return e.payload;
}
function Lq(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var Mq = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function Bq(e, t) {
  return `${e}/${t}`;
}
function Iq({
  creators: e
} = {}) {
  var t;
  const n = (t = e == null ? void 0 : e.asyncThunk) == null ? void 0 : t[Mq];
  return function(r) {
    const {
      name: i,
      reducerPath: o = i
    } = r;
    if (!i)
      throw new Error(us(11));
    const a = (typeof r.reducers == "function" ? r.reducers(Pq()) : r.reducers) || {}, s = Object.keys(a), l = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    }, u = {
      addCase(b, C) {
        const T = typeof b == "string" ? b : b.type;
        if (!T)
          throw new Error(us(12));
        if (T in l.sliceCaseReducersByType)
          throw new Error(us(13));
        return l.sliceCaseReducersByType[T] = C, u;
      },
      addMatcher(b, C) {
        return l.sliceMatchers.push({
          matcher: b,
          reducer: C
        }), u;
      },
      exposeAction(b, C) {
        return l.actionCreators[b] = C, u;
      },
      exposeCaseReducer(b, C) {
        return l.sliceCaseReducersByName[b] = C, u;
      }
    };
    s.forEach((b) => {
      const C = a[b], T = {
        reducerName: b,
        type: Bq(i, b),
        createNotation: typeof r.reducers == "function"
      };
      qq(C) ? Hq(T, C, u, n) : _q(T, C, u);
    });
    function d() {
      const [b = {}, C = [], T = void 0] = typeof r.extraReducers == "function" ? GD(r.extraReducers) : [r.extraReducers], z = {
        ...b,
        ...l.sliceCaseReducersByType
      };
      return Dq(r.initialState, (I) => {
        for (let w in z)
          I.addCase(w, z[w]);
        for (let w of l.sliceMatchers)
          I.addMatcher(w.matcher, w.reducer);
        for (let w of C)
          I.addMatcher(w.matcher, w.reducer);
        T && I.addDefaultCase(T);
      });
    }
    const p = (b) => b, f = /* @__PURE__ */ new Map();
    let m;
    function y(b, C) {
      return m || (m = d()), m(b, C);
    }
    function g() {
      return m || (m = d()), m.getInitialState();
    }
    function x(b, C = !1) {
      function T(I) {
        let w = I[b];
        return typeof w > "u" && C && (w = g()), w;
      }
      function z(I = p) {
        const w = Cb(f, C, {
          insert: () => /* @__PURE__ */ new WeakMap()
        });
        return Cb(w, I, {
          insert: () => {
            const M = {};
            for (const [R, F] of Object.entries(r.selectors ?? {}))
              M[R] = Rq(F, I, g, C);
            return M;
          }
        });
      }
      return {
        reducerPath: b,
        getSelectors: z,
        get selectors() {
          return z(T);
        },
        selectSlice: T
      };
    }
    const E = {
      name: i,
      reducer: y,
      actions: l.actionCreators,
      caseReducers: l.sliceCaseReducersByName,
      getInitialState: g,
      ...x(o),
      injectInto(b, {
        reducerPath: C,
        ...T
      } = {}) {
        const z = C ?? o;
        return b.inject({
          reducerPath: z,
          reducer: y
        }, T), {
          ...E,
          ...x(z, !0)
        };
      }
    };
    return E;
  };
}
function Rq(e, t, n, r) {
  function i(o, ...a) {
    let s = t(o);
    return typeof s > "u" && r && (s = n()), e(s, ...a);
  }
  return i.unwrapped = e, i;
}
var d7 = /* @__PURE__ */ Iq();
function Pq() {
  function e(t, n) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator: t,
      ...n
    };
  }
  return e.withTypes = () => e, {
    reducer(t) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [t.name](...n) {
          return t(...n);
        }
      }[t.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(t, n) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare: t,
        reducer: n
      };
    },
    asyncThunk: e
  };
}
function _q({
  type: e,
  reducerName: t,
  createNotation: n
}, r, i) {
  let o, a;
  if ("reducer" in r) {
    if (n && !$q(r))
      throw new Error(us(17));
    o = r.reducer, a = r.prepare;
  } else
    o = r;
  i.addCase(e, o).exposeCaseReducer(t, o).exposeAction(t, a ? Oo(e, a) : Oo(e));
}
function qq(e) {
  return e._reducerDefinitionType === "asyncThunk";
}
function $q(e) {
  return e._reducerDefinitionType === "reducerWithPrepare";
}
function Hq({
  type: e,
  reducerName: t
}, n, r, i) {
  if (!i)
    throw new Error(us(18));
  const {
    payloadCreator: o,
    fulfilled: a,
    pending: s,
    rejected: l,
    settled: u,
    options: d
  } = n, p = i(e, o, d);
  r.exposeAction(t, p), a && r.addCase(p.fulfilled, a), s && r.addCase(p.pending, s), l && r.addCase(p.rejected, l), u && r.addMatcher(p.settled, u), r.exposeCaseReducer(t, {
    fulfilled: a || Fh,
    pending: s || Fh,
    rejected: l || Fh,
    settled: u || Fh
  });
}
function Fh() {
}
function us(e) {
  return `Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
const Vq = {}, XD = d7({
  name: "documents",
  initialState: Vq,
  reducers: {
    // The insert action with a side effect:
    // Focus the newly inserted document (see `focus` slice)
    insertAndFocusDocument(e, t) {
      const { id: n, plugin: r, state: i } = t.payload;
      e[n] = {
        plugin: r,
        state: i
      };
    },
    // The pure insert action (no side effects)
    pureInsertDocument(e, t) {
      const { id: n, plugin: r, state: i } = t.payload;
      e[n] = {
        plugin: r,
        state: i
      };
    },
    pureRemoveDocument(e, t) {
      delete e[t.payload];
    },
    pureChangeDocument(e, t) {
      const { id: n, state: r } = t.payload;
      if (!e[n]) return e;
      e[n].state = r;
    },
    pureReplaceDocument(e, t) {
      const { id: n, plugin: r, state: i } = t.payload;
      e[n] = {
        plugin: r,
        state: i
      };
    }
  }
}), {
  insertAndFocusDocument: QD,
  pureInsertDocument: Uq,
  pureRemoveDocument: Wq,
  pureChangeDocument: Eb,
  pureReplaceDocument: Sm
} = XD.actions;
function Zq(e) {
  return e.type === QD.type;
}
const ad = Oo("documents/runChangeDocumentSaga"), YD = Oo("documents/runReplaceDocumentSaga"), Ec = "root";
function Su(e, t = Ec) {
  const n = e[t], r = si.getByType(n.plugin).state.getFocusableChildren(n.state).map((i) => Su(e, i.id) || i);
  return { id: t, children: r };
}
function Du(e, t) {
  if (e.id === t)
    return e;
  const n = e.children || [];
  for (let r = 0; r < n.length; r++) {
    const i = Du(n[r], t);
    if (i)
      return i.id === t ? e : i;
  }
  return null;
}
function kg({
  documents: e,
  id: t,
  omitId: n = !1
}) {
  const r = e[t], i = si.getByType(r.plugin), o = {
    getStoreDocument: (a) => kg({ documents: e, id: a, omitId: n }),
    omitId: n
  };
  return {
    plugin: r.plugin,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    state: i.state.toStaticState(r.state, o)
  };
}
function JD(e) {
  const t = si.getByType(e.plugin);
  if (typeof t.isEmpty == "function") {
    const r = t.state.init(e.state, () => {
    });
    return t.isEmpty(r);
  }
  const n = t.state.createInitialState({
    createDocument: () => {
    }
  });
  return t7(e.state, n);
}
const Ef = c7(HD, {
  resultEqualityCheck: t7,
  maxSize: 50
}), Gq = c7(HD, {
  resultEqualityCheck: (e, t) => JSON.stringify(e) === JSON.stringify(t),
  maxSize: 50
}), oo = (e) => e.documents, eA = Vr(
  oo,
  (e) => e
), bi = Vr(
  [oo, (e, t) => t],
  (e, t) => t && e[t] || null
), tA = Vr(
  [oo, (e, t) => t],
  (e, t) => e[t].plugin
), li = Ef(
  [oo, (e, t) => t],
  (e, t) => kg({ documents: e, id: t })
), Kq = Ef(
  [oo, (e, t) => t],
  (e, t) => t.map((n) => kg({ documents: e, id: n }))
), nA = Ef(
  [oo, (e, t) => t],
  (e, t) => kg({ documents: e, id: t, omitId: !0 })
), ou = Vr(
  [oo, (e, t) => t],
  (e, t) => JD(e[t])
), Xq = Vr(
  [oo, (e, t) => t],
  (e, t) => {
    const { children: n } = Su(e, t);
    return n ? n.map((r, i) => {
      const o = e[r.id];
      return o.plugin === Y.Text && JD(o) ? i : null;
    }).filter(Number.isInteger) : [];
  }
), rl = Gq(
  [oo, (e, t) => t],
  (e, t) => Su(e, t)
), il = Vr(
  [oo, (e, t) => t],
  (e, t) => {
    const n = Su(e);
    return Du(n, t);
  }
), p7 = Vr(
  [oo, (e, t) => t],
  (e, t) => {
    const n = Su(e), r = Du(n, t);
    return r && e[r.id].plugin;
  }
), rA = Ef(
  [oo, (e, t) => t],
  (e, t) => {
    const n = Su(e);
    let r = t, i = [t];
    for (; r !== n.id; ) {
      const o = Du(n, r);
      if (!o) return null;
      r = o.id, i = [r, ...i];
    }
    return i;
  }
), Eg = Ef(
  [oo, (e, t) => t],
  (e, t) => {
    const n = Su(e);
    let r = t, i = [];
    for (; r !== n.id; ) {
      const o = Du(n, r);
      if (!o) return null;
      i = [e[o.id].plugin, ...i], r = o.id;
    }
    return i;
  }
), Sg = Vr(
  [oo, (e, t) => t],
  (e, t) => {
    const n = Su(e), r = Du(n, t);
    return r ? e[r.id].plugin === Y.Rows : !1;
  }
);
function iA(e, t) {
  const n = Du(e, t);
  if (!n || n.id === t) return null;
  const { children: r } = n;
  if (!r) return null;
  const i = r.findIndex((o) => o.id === t);
  if (i + 1 < r.length) {
    let o = r[i + 1];
    for (; o.children && o.children.length > 0; )
      o = o.children[0];
    return o.id;
  }
  return iA(e, n.id);
}
function oA(e, t) {
  const n = Du(e, t);
  if (!n || n.id === t) return null;
  const { children: r } = n;
  if (!r) return null;
  const i = r.findIndex((o) => o.id === t);
  if (i >= 1) {
    let o = r[i - 1];
    for (; o.children && o.children.length > 0; )
      o = o.children[o.children.length - 1];
    return o.id;
  }
  return oA(e, n.id);
}
const aA = (e) => e.focus, Sf = Vr(aA, (e) => e), cs = Vr(
  [aA, (e, t) => t],
  (e, t) => e === t
), sA = Vr(
  [(e) => e, (e, t) => t],
  (e, t) => {
    const n = rl(e, t);
    if (!n || !n.children) return !1;
    const r = Sf(e);
    return r_((i) => i.id === r, n.children);
  }
), Qq = null, lA = d7({
  name: "focus",
  initialState: Qq,
  reducers: {
    focus(e, t) {
      return t.payload;
    },
    focusNext(e, t) {
      return !e || !t.payload ? e : iA(t.payload, e) || e;
    },
    focusPrevious(e, t) {
      return !e || !t.payload ? e : oA(t.payload, e) || e;
    }
  },
  extraReducers: (e) => {
    e.addMatcher(
      // Always focus the newly inserted document
      Zq,
      (t, n) => n.payload.id
    );
  }
}), { focus: Ji, focusNext: Dg, focusPrevious: Ag } = lA.actions, Dm = Oo(
  "history/commitActionToHistory"
), uA = Oo("history/commitTemporaryActionToHistory"), sd = (e) => e.history, Fv = Vr(
  sd,
  (e) => e.pendingChanges
), Yq = Vr(
  sd,
  (e) => e.pendingChanges !== 0
), cA = Vr(
  sd,
  (e) => e.undoStack.length > 0
), dA = Vr(
  sd,
  (e) => e.redoStack.length > 0
), Jq = Vr(
  sd,
  (e) => e.undoStack
), e$ = Vr(
  sd,
  (e) => e.redoStack
), t$ = {
  undoStack: [],
  redoStack: [],
  pendingChanges: 0
}, Df = KD("history/undo", (e, { getState: t, dispatch: n }) => {
  const r = Jq(t()), i = SD(r);
  i && ED(i).map(
    (o) => o.reverse
  ).map((o) => {
    n(o);
  });
}), Xp = KD("history/redo", (e, { getState: t, dispatch: n }) => {
  const r = e$(t()), i = SD(r);
  i && i.map((o) => o.action).map((o) => {
    n(o);
  });
}), pA = d7({
  name: "history",
  initialState: t$,
  reducers: {
    persistHistory(e, t) {
      e.initialState = e.initialState || {
        documents: t.payload
      }, e.pendingChanges = 0;
    },
    pureCommitActionToHistory: (e, t) => {
      const { combine: n, actions: r } = t.payload;
      let i = r;
      const { undoStack: o } = e;
      e.undoStack = a(), e.redoStack = [], e.pendingChanges = e.pendingChanges + r.length;
      function a() {
        return n && o.length > 0 ? (i = [...o[0], ...i], [i, ...m_(o)]) : [i, ...o];
      }
    }
  },
  extraReducers: (e) => {
    e.addCase(Df.fulfilled, (t) => {
      const [n, ...r] = t.undoStack;
      if (!n) return t;
      t.undoStack = r, t.redoStack = [n, ...t.redoStack], t.pendingChanges = t.pendingChanges - n.length;
    }).addCase(Xp.fulfilled, (t) => {
      const [n, ...r] = t.redoStack;
      if (!n) return t;
      t.undoStack = [n, ...t.undoStack], t.redoStack = r, t.pendingChanges = t.pendingChanges + n.length;
    });
  }
}), { persistHistory: fA, pureCommitActionToHistory: hA } = pA.actions, n$ = Oo("plugin/insertPluginChildBefore"), Qp = Oo("plugin/insertPluginChildAfter"), j0 = Oo("plugin/removePluginChild"), mA = Oo("root/runInitRootSaga");
var gA = { exports: {} }, vA = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Af = dt;
function r$(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var i$ = typeof Object.is == "function" ? Object.is : r$, o$ = Af.useSyncExternalStore, a$ = Af.useRef, s$ = Af.useEffect, l$ = Af.useMemo, u$ = Af.useDebugValue;
vA.useSyncExternalStoreWithSelector = function(e, t, n, r, i) {
  var o = a$(null);
  if (o.current === null) {
    var a = { hasValue: !1, value: null };
    o.current = a;
  } else a = o.current;
  o = l$(function() {
    function l(m) {
      if (!u) {
        if (u = !0, d = m, m = r(m), i !== void 0 && a.hasValue) {
          var y = a.value;
          if (i(y, m)) return p = y;
        }
        return p = m;
      }
      if (y = p, i$(d, m)) return y;
      var g = r(m);
      return i !== void 0 && i(y, g) ? y : (d = m, p = g);
    }
    var u = !1, d, p, f = n === void 0 ? null : n;
    return [function() {
      return l(t());
    }, f === null ? void 0 : function() {
      return l(f());
    }];
  }, [t, n, r, i]);
  var s = o$(e, o[0], o[1]);
  return s$(function() {
    a.hasValue = !0, a.value = s;
  }, [s]), u$(s), s;
};
gA.exports = vA;
var c$ = gA.exports, To = (
  // prettier-ignore
  // @ts-ignore
  "default" in Z8 ? dt : Z8
), Sb = Symbol.for("react-redux-context"), Db = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function d$() {
  if (!To.createContext)
    return {};
  const e = Db[Sb] ?? (Db[Sb] = /* @__PURE__ */ new Map());
  let t = e.get(To.createContext);
  return t || (t = To.createContext(
    null
  ), e.set(To.createContext, t)), t;
}
var fu = /* @__PURE__ */ d$(), p$ = () => {
  throw new Error("uSES not initialized!");
};
function f7(e = fu) {
  return function() {
    return To.useContext(e);
  };
}
var yA = /* @__PURE__ */ f7(), xA = p$, f$ = (e) => {
  xA = e;
}, h$ = (e, t) => e === t;
function m$(e = fu) {
  const t = e === fu ? yA : f7(e), n = (r, i = {}) => {
    const { equalityFn: o = h$, devModeChecks: a = {} } = typeof i == "function" ? { equalityFn: i } : i, {
      store: s,
      subscription: l,
      getServerState: u,
      stabilityCheck: d,
      identityFunctionCheck: p
    } = t();
    To.useRef(!0);
    const f = To.useCallback(
      {
        [r.name](y) {
          return r(y);
        }
      }[r.name],
      [r, d, a.stabilityCheck]
    ), m = xA(
      l.addNestedSub,
      s.getState,
      u || s.getState,
      f,
      o
    );
    return To.useDebugValue(m), m;
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var g$ = /* @__PURE__ */ m$();
function v$(e) {
  e();
}
function y$() {
  let e = null, t = null;
  return {
    clear() {
      e = null, t = null;
    },
    notify() {
      v$(() => {
        let n = e;
        for (; n; )
          n.callback(), n = n.next;
      });
    },
    get() {
      const n = [];
      let r = e;
      for (; r; )
        n.push(r), r = r.next;
      return n;
    },
    subscribe(n) {
      let r = !0;
      const i = t = {
        callback: n,
        next: null,
        prev: t
      };
      return i.prev ? i.prev.next = i : e = i, function() {
        !r || e === null || (r = !1, i.next ? i.next.prev = i.prev : t = i.prev, i.prev ? i.prev.next = i.next : e = i.next);
      };
    }
  };
}
var Ab = {
  notify() {
  },
  get: () => []
};
function x$(e, t) {
  let n, r = Ab, i = 0, o = !1;
  function a(g) {
    d();
    const x = r.subscribe(g);
    let E = !1;
    return () => {
      E || (E = !0, x(), p());
    };
  }
  function s() {
    r.notify();
  }
  function l() {
    y.onStateChange && y.onStateChange();
  }
  function u() {
    return o;
  }
  function d() {
    i++, n || (n = e.subscribe(l), r = y$());
  }
  function p() {
    i--, n && i === 0 && (n(), n = void 0, r.clear(), r = Ab);
  }
  function f() {
    o || (o = !0, d());
  }
  function m() {
    o && (o = !1, p());
  }
  const y = {
    addNestedSub: a,
    notifyNestedSubs: s,
    handleChangeWrapper: l,
    isSubscribed: u,
    trySubscribe: f,
    tryUnsubscribe: m,
    getListeners: () => r
  };
  return y;
}
var b$ = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", w$ = typeof navigator < "u" && navigator.product === "ReactNative", C$ = b$ || w$ ? To.useLayoutEffect : To.useEffect;
function k$({
  store: e,
  context: t,
  children: n,
  serverState: r,
  stabilityCheck: i = "once",
  identityFunctionCheck: o = "once"
}) {
  const a = To.useMemo(() => {
    const u = x$(e);
    return {
      store: e,
      subscription: u,
      getServerState: r ? () => r : void 0,
      stabilityCheck: i,
      identityFunctionCheck: o
    };
  }, [e, r, i, o]), s = To.useMemo(() => e.getState(), [e]);
  C$(() => {
    const { subscription: u } = a;
    return u.onStateChange = u.notifyNestedSubs, u.trySubscribe(), s !== e.getState() && u.notifyNestedSubs(), () => {
      u.tryUnsubscribe(), u.onStateChange = void 0;
    };
  }, [a, s]);
  const l = t || fu;
  return /* @__PURE__ */ To.createElement(l.Provider, { value: a }, n);
}
var E$ = k$;
function bA(e = fu) {
  const t = e === fu ? yA : (
    // @ts-ignore
    f7(e)
  ), n = () => {
    const { store: r } = t();
    return r;
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var wA = /* @__PURE__ */ bA();
function S$(e = fu) {
  const t = e === fu ? wA : bA(e), n = () => t().dispatch;
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var D$ = /* @__PURE__ */ S$();
f$(c$.useSyncExternalStoreWithSelector);
var Va = function(e) {
  return "@@redux-saga/" + e;
}, CA = /* @__PURE__ */ Va("CANCEL_PROMISE"), kA = /* @__PURE__ */ Va("CHANNEL_END"), EA = /* @__PURE__ */ Va("IO"), Tb = /* @__PURE__ */ Va("MATCH"), SA = /* @__PURE__ */ Va("MULTICAST"), DA = /* @__PURE__ */ Va("SAGA_ACTION"), A$ = /* @__PURE__ */ Va("SELF_CANCELLATION"), T$ = /* @__PURE__ */ Va("TASK"), N0 = /* @__PURE__ */ Va("TASK_CANCEL"), AA = /* @__PURE__ */ Va("TERMINATE"), j$ = /* @__PURE__ */ Va("LOCATION");
function Yp() {
  return Yp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Yp.apply(this, arguments);
}
function TA(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var jA = function(e) {
  return e == null;
}, S1 = function(e) {
  return e != null;
}, ro = function(e) {
  return typeof e == "function";
}, h7 = function(e) {
  return typeof e == "string";
}, Au = Array.isArray, Tg = function(e) {
  return e && ro(e.then);
}, m7 = function(e) {
  return e && ro(e.next) && ro(e.throw);
}, jb = function e(t) {
  return t && (h7(t) || OA(t) || ro(t) || Au(t) && t.every(e));
}, g7 = function(e) {
  return e && ro(e.take) && ro(e.close);
}, NA = function(e) {
  return ro(e) && e.hasOwnProperty("toString");
}, OA = function(e) {
  return !!e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype;
}, N$ = function(e) {
  return g7(e) && e[SA];
}, O$ = 2147483647;
function z$(e, t) {
  t === void 0 && (t = !0);
  var n, r = new Promise(function(i) {
    n = setTimeout(i, Math.min(O$, e), t);
  });
  return r[CA] = function() {
    clearTimeout(n);
  }, r;
}
var F$ = function(e) {
  return function() {
    return e;
  };
}, L$ = /* @__PURE__ */ F$(!0), Ni = function() {
}, zA = function(e) {
  return e;
}, v7 = function(e, t) {
  Yp(e, t), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(t).forEach(function(n) {
    e[n] = t[n];
  });
}, M$ = function(e, t) {
  var n;
  return (n = []).concat.apply(n, t.map(e));
};
function jg(e, t) {
  var n = e.indexOf(t);
  n >= 0 && e.splice(n, 1);
}
function B$(e) {
  var t = !1;
  return function() {
    t || (t = !0, e());
  };
}
var I$ = function(e) {
  throw e;
}, R$ = function(e) {
  return {
    value: e,
    done: !0
  };
};
function Lv(e, t, n) {
  t === void 0 && (t = I$), n === void 0 && (n = "iterator");
  var r = {
    meta: {
      name: n
    },
    next: e,
    throw: t,
    return: R$,
    isSagaIterator: !0
  };
  return typeof Symbol < "u" && (r[Symbol.iterator] = function() {
    return r;
  }), r;
}
function P$(e, t) {
  var n = t.sagaStack;
  console.error(e), console.error(n);
}
var FA = function(e) {
  return Array.apply(null, new Array(e));
}, _$ = function(e) {
  return function(t) {
    return e(Object.defineProperty(t, DA, {
      value: !0
    }));
  };
}, LA = function(e) {
  return e === AA;
}, MA = function(e) {
  return e === N0;
}, BA = function(e) {
  return LA(e) || MA(e);
};
function IA(e, t) {
  var n = Object.keys(e), r = n.length, i = 0, o, a = Au(e) ? FA(r) : {}, s = {};
  function l() {
    i === r && (o = !0, t(a));
  }
  return n.forEach(function(u) {
    var d = function(p, f) {
      o || (f || BA(p) ? (t.cancel(), t(p, f)) : (a[u] = p, i++, l()));
    };
    d.cancel = Ni, s[u] = d;
  }), t.cancel = function() {
    o || (o = !0, n.forEach(function(u) {
      return s[u].cancel();
    }));
  }, s;
}
function y7(e) {
  return {
    name: e.name || "anonymous",
    location: RA(e)
  };
}
function RA(e) {
  return e[j$];
}
function q$() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.length === 0 ? function(r) {
    return r;
  } : t.length === 1 ? t[0] : t.reduce(function(r, i) {
    return function() {
      return r(i.apply(void 0, arguments));
    };
  });
}
var $$ = "Channel's Buffer overflow!", H$ = 1, V$ = 3, PA = 4;
function U$(e, t) {
  e === void 0 && (e = 10);
  var n = new Array(e), r = 0, i = 0, o = 0, a = function(u) {
    n[i] = u, i = (i + 1) % e, r++;
  }, s = function() {
    if (r != 0) {
      var u = n[o];
      return n[o] = null, r--, o = (o + 1) % e, u;
    }
  }, l = function() {
    for (var u = []; r; )
      u.push(s());
    return u;
  };
  return {
    isEmpty: function() {
      return r == 0;
    },
    put: function(u) {
      if (r < e)
        a(u);
      else {
        var d;
        switch (t) {
          case H$:
            throw new Error($$);
          case V$:
            n[i] = u, i = (i + 1) % e, o = i;
            break;
          case PA:
            d = 2 * e, n = l(), r = n.length, i = n.length, o = 0, n.length = d, e = d, a(u);
            break;
        }
      }
    },
    take: s,
    flush: l
  };
}
var W$ = function(e) {
  return U$(e, PA);
}, D1 = "TAKE", _A = "PUT", qA = "ALL", $A = "RACE", HA = "CALL", Z$ = "CPS", VA = "FORK", G$ = "JOIN", K$ = "CANCEL", UA = "SELECT", X$ = "ACTION_CHANNEL", Q$ = "CANCELLED", Y$ = "FLUSH", J$ = "GET_CONTEXT", eH = "SET_CONTEXT", Ks = function(e, t) {
  var n;
  return n = {}, n[EA] = !0, n.combinator = !1, n.type = e, n.payload = t, n;
};
function U0(e, t) {
  if (e === void 0 && (e = "*"), jb(e))
    return S1(t) && console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types"), Ks(D1, {
      pattern: e
    });
  if (N$(e) && S1(t) && jb(t))
    return Ks(D1, {
      channel: e,
      pattern: t
    });
  if (g7(e))
    return S1(t) && console.warn("take(channel) takes one argument but two were provided. Second argument is ignored."), Ks(D1, {
      channel: e
    });
}
function ps(e, t) {
  return jA(t) && (t = e, e = void 0), Ks(_A, {
    channel: e,
    action: t
  });
}
function Lc(e) {
  var t = Ks(qA, e);
  return t.combinator = !0, t;
}
function tH(e) {
  var t = Ks($A, e);
  return t.combinator = !0, t;
}
function WA(e, t) {
  var n = null, r;
  return ro(e) ? r = e : (Au(e) ? (n = e[0], r = e[1]) : (n = e.context, r = e.fn), n && h7(r) && ro(n[r]) && (r = n[r])), {
    context: n,
    fn: r,
    args: t
  };
}
function Er(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return Ks(HA, WA(e, n));
}
function ZA(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return Ks(VA, WA(e, n));
}
function Sc(e) {
  e === void 0 && (e = zA);
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return Ks(UA, {
    selector: e,
    args: n
  });
}
var nH = /* @__PURE__ */ Er.bind(null, z$);
function rH() {
  var e = {};
  return e.promise = new Promise(function(t, n) {
    e.resolve = t, e.reject = n;
  }), e;
}
var GA = [], Ng = 0;
function iH(e) {
  try {
    x7(), e();
  } finally {
    QA();
  }
}
function KA(e) {
  GA.push(e), Ng || (x7(), YA());
}
function XA(e) {
  try {
    return x7(), e();
  } finally {
    YA();
  }
}
function x7() {
  Ng++;
}
function QA() {
  Ng--;
}
function YA() {
  QA();
  for (var e; !Ng && (e = GA.shift()) !== void 0; )
    iH(e);
}
var oH = function(e) {
  return function(t) {
    return e.some(function(n) {
      return b7(n)(t);
    });
  };
}, aH = function(e) {
  return function(t) {
    return e(t);
  };
}, Nb = function(e) {
  return function(t) {
    return t.type === String(e);
  };
}, sH = function(e) {
  return function(t) {
    return t.type === e;
  };
}, JA = function() {
  return L$;
};
function b7(e) {
  var t = e === "*" ? JA : h7(e) ? Nb : Au(e) ? oH : NA(e) ? Nb : ro(e) ? aH : OA(e) ? sH : null;
  if (t === null)
    throw new Error("invalid pattern: " + e);
  return t(e);
}
var vp = {
  type: kA
}, w7 = function(e) {
  return e && e.type === kA;
};
function Og(e) {
  e === void 0 && (e = W$());
  var t = !1, n = [];
  function r(s) {
    if (!t) {
      if (n.length === 0)
        return e.put(s);
      var l = n.shift();
      l(s);
    }
  }
  function i(s) {
    t && e.isEmpty() ? s(vp) : e.isEmpty() ? (n.push(s), s.cancel = function() {
      jg(n, s);
    }) : s(e.take());
  }
  function o(s) {
    if (t && e.isEmpty()) {
      s(vp);
      return;
    }
    s(e.flush());
  }
  function a() {
    if (!t) {
      t = !0;
      var s = n;
      n = [];
      for (var l = 0, u = s.length; l < u; l++) {
        var d = s[l];
        d(vp);
      }
    }
  }
  return {
    take: i,
    put: r,
    flush: o,
    close: a
  };
}
function lH() {
  var e, t = !1, n = [], r = n, i = function() {
    r === n && (r = n.slice());
  }, o = function() {
    t = !0;
    var a = n = r;
    r = [], a.forEach(function(s) {
      s(vp);
    });
  };
  return e = {}, e[SA] = !0, e.put = function(a) {
    if (!t) {
      if (w7(a)) {
        o();
        return;
      }
      for (var s = n = r, l = 0, u = s.length; l < u; l++) {
        var d = s[l];
        d[Tb](a) && (d.cancel(), d(a));
      }
    }
  }, e.take = function(a, s) {
    if (s === void 0 && (s = JA), t) {
      a(vp);
      return;
    }
    a[Tb] = s, i(), r.push(a), a.cancel = B$(function() {
      i(), jg(r, a);
    });
  }, e.close = o, e;
}
function eT() {
  var e = lH(), t = e.put;
  return e.put = function(n) {
    if (n[DA]) {
      t(n);
      return;
    }
    KA(function() {
      t(n);
    });
  }, e;
}
var ic = 0, qs = 1, A1 = 2, tT = 3;
function C7(e, t) {
  var n = e[CA];
  ro(n) && (t.cancel = n), e.then(t, function(r) {
    t(r, !0);
  });
}
var Tf = 0, nT = function() {
  return ++Tf;
}, Qr;
function uH(e, t) {
  return e.isSagaIterator ? {
    name: e.meta.name
  } : y7(t);
}
function cH(e) {
  var t = e.context, n = e.fn, r = e.args;
  try {
    var i = n.apply(t, r);
    if (m7(i))
      return i;
    var o = !1, a = function(s) {
      return o ? {
        value: s,
        done: !0
      } : (o = !0, {
        value: i,
        done: !Tg(i)
      });
    };
    return Lv(a);
  } catch (s) {
    return Lv(function() {
      throw s;
    });
  }
}
function dH(e, t, n) {
  var r = t.channel, i = t.action, o = t.resolve;
  KA(function() {
    var a;
    try {
      a = (r ? r.put : e.dispatch)(i);
    } catch (s) {
      n(s, !0);
      return;
    }
    o && Tg(a) ? C7(a, n) : n(a);
  });
}
function pH(e, t, n) {
  var r = t.channel, i = r === void 0 ? e.channel : r, o = t.pattern, a = t.maybe, s = function(l) {
    if (l instanceof Error) {
      n(l, !0);
      return;
    }
    if (w7(l) && !a) {
      n(AA);
      return;
    }
    n(l);
  };
  try {
    i.take(s, S1(o) ? b7(o) : null);
  } catch (l) {
    n(l, !0);
    return;
  }
  n.cancel = s.cancel;
}
function fH(e, t, n, r) {
  var i = t.context, o = t.fn, a = t.args, s = r.task;
  try {
    var l = o.apply(i, a);
    if (Tg(l)) {
      C7(l, n);
      return;
    }
    if (m7(l)) {
      zg(
        e,
        l,
        s.context,
        Tf,
        y7(o),
        /* isRoot */
        !1,
        n
      );
      return;
    }
    n(l);
  } catch (u) {
    n(u, !0);
  }
}
function hH(e, t, n) {
  var r = t.context, i = t.fn, o = t.args;
  try {
    var a = function(s, l) {
      jA(s) ? n(l) : n(s, !0);
    };
    i.apply(r, o.concat(a)), a.cancel && (n.cancel = a.cancel);
  } catch (s) {
    n(s, !0);
  }
}
function mH(e, t, n, r) {
  var i = t.context, o = t.fn, a = t.args, s = t.detached, l = r.task, u = cH({
    context: i,
    fn: o,
    args: a
  }), d = uH(u, o);
  XA(function() {
    var p = zg(e, u, l.context, Tf, d, s, void 0);
    s ? n(p) : p.isRunning() ? (l.queue.addTask(p), n(p)) : p.isAborted() ? l.queue.abort(p.error()) : n(p);
  });
}
function gH(e, t, n, r) {
  var i = r.task, o = function(s, l) {
    if (s.isRunning()) {
      var u = {
        task: i,
        cb: l
      };
      l.cancel = function() {
        s.isRunning() && jg(s.joiners, u);
      }, s.joiners.push(u);
    } else
      s.isAborted() ? l(s.error(), !0) : l(s.result());
  };
  if (Au(t)) {
    if (t.length === 0) {
      n([]);
      return;
    }
    var a = IA(t, n);
    t.forEach(function(s, l) {
      o(s, a[l]);
    });
  } else
    o(t, n);
}
function b4(e) {
  e.isRunning() && e.cancel();
}
function vH(e, t, n, r) {
  var i = r.task;
  t === A$ ? b4(i) : Au(t) ? t.forEach(b4) : b4(t), n();
}
function yH(e, t, n, r) {
  var i = r.digestEffect, o = Tf, a = Object.keys(t);
  if (a.length === 0) {
    n(Au(t) ? [] : {});
    return;
  }
  var s = IA(t, n);
  a.forEach(function(l) {
    i(t[l], o, s[l], l);
  });
}
function xH(e, t, n, r) {
  var i = r.digestEffect, o = Tf, a = Object.keys(t), s = Au(t) ? FA(a.length) : {}, l = {}, u = !1;
  a.forEach(function(d) {
    var p = function(f, m) {
      u || (m || BA(f) ? (n.cancel(), n(f, m)) : (n.cancel(), u = !0, s[d] = f, n(s)));
    };
    p.cancel = Ni, l[d] = p;
  }), n.cancel = function() {
    u || (u = !0, a.forEach(function(d) {
      return l[d].cancel();
    }));
  }, a.forEach(function(d) {
    u || i(t[d], o, l[d], d);
  });
}
function bH(e, t, n) {
  var r = t.selector, i = t.args;
  try {
    var o = r.apply(void 0, [e.getState()].concat(i));
    n(o);
  } catch (a) {
    n(a, !0);
  }
}
function wH(e, t, n) {
  var r = t.pattern, i = t.buffer, o = Og(i), a = b7(r), s = function u(d) {
    w7(d) || e.channel.take(u, a), o.put(d);
  }, l = o.close;
  o.close = function() {
    s.cancel(), l();
  }, e.channel.take(s, a), n(o);
}
function CH(e, t, n, r) {
  var i = r.task;
  n(i.isCancelled());
}
function kH(e, t, n) {
  t.flush(n);
}
function EH(e, t, n, r) {
  var i = r.task;
  n(i.context[t]);
}
function SH(e, t, n, r) {
  var i = r.task;
  v7(i.context, t), n();
}
var DH = (Qr = {}, Qr[D1] = pH, Qr[_A] = dH, Qr[qA] = yH, Qr[$A] = xH, Qr[HA] = fH, Qr[Z$] = hH, Qr[VA] = mH, Qr[G$] = gH, Qr[K$] = vH, Qr[UA] = bH, Qr[X$] = wH, Qr[Q$] = CH, Qr[Y$] = kH, Qr[J$] = EH, Qr[eH] = SH, Qr);
function AH(e, t, n) {
  var r = [], i, o = !1;
  l(e);
  var a = function() {
    return r;
  };
  function s(d) {
    t(), u(), n(d, !0);
  }
  function l(d) {
    r.push(d), d.cont = function(p, f) {
      o || (jg(r, d), d.cont = Ni, f ? s(p) : (d === e && (i = p), r.length || (o = !0, n(i))));
    };
  }
  function u() {
    o || (o = !0, r.forEach(function(d) {
      d.cont = Ni, d.cancel();
    }), r = []);
  }
  return {
    addTask: l,
    cancelAll: u,
    abort: s,
    getTasks: a
  };
}
function rT(e, t) {
  return e + "?" + t;
}
function TH(e) {
  var t = RA(e);
  if (t) {
    var n = t.code, r = t.fileName, i = t.lineNumber, o = n + "  " + rT(r, i);
    return o;
  }
  return "";
}
function Ob(e) {
  var t = e.name, n = e.location;
  return n ? t + "  " + rT(n.fileName, n.lineNumber) : t;
}
function jH(e) {
  var t = M$(function(n) {
    return n.cancelledTasks;
  }, e);
  return t.length ? ["Tasks cancelled due to error:"].concat(t).join(`
`) : "";
}
var k7 = null, yp = [], NH = function(e) {
  e.crashedEffect = k7, yp.push(e);
}, iT = function() {
  k7 = null, yp.length = 0;
}, OH = function(e) {
  k7 = e;
}, zH = function() {
  var e = yp[0], t = yp.slice(1), n = e.crashedEffect ? TH(e.crashedEffect) : null, r = "The above error occurred in task " + Ob(e.meta) + (n ? ` 
 when executing effect ` + n : "");
  return [r].concat(t.map(function(i) {
    return "    created by " + Ob(i.meta);
  }), [jH(yp)]).join(`
`);
};
function FH(e, t, n, r, i, o, a) {
  var s;
  a === void 0 && (a = Ni);
  var l = ic, u, d, p = null, f = [], m = Object.create(n), y = AH(t, function() {
    f.push.apply(f, y.getTasks().map(function(T) {
      return T.meta.name;
    }));
  }, x);
  function g() {
    l === ic && (l = qs, y.cancelAll(), x(N0, !1));
  }
  function x(T, z) {
    if (!z)
      T === N0 ? l = qs : l !== qs && (l = tT), u = T, p && p.resolve(T);
    else {
      if (l = A1, NH({
        meta: i,
        cancelledTasks: f
      }), C.isRoot) {
        var I = zH();
        iT(), e.onError(T, {
          sagaStack: I
        });
      }
      d = T, p && p.reject(T);
    }
    C.cont(T, z), C.joiners.forEach(function(w) {
      w.cb(T, z);
    }), C.joiners = null;
  }
  function E(T) {
    v7(m, T);
  }
  function b() {
    return p || (p = rH(), l === A1 ? p.reject(d) : l !== ic && p.resolve(u)), p.promise;
  }
  var C = (s = {}, s[T$] = !0, s.id = r, s.meta = i, s.isRoot = o, s.context = m, s.joiners = [], s.queue = y, s.cancel = g, s.cont = a, s.end = x, s.setContext = E, s.toPromise = b, s.isRunning = function() {
    return l === ic;
  }, s.isCancelled = function() {
    return l === qs || l === ic && t.status === qs;
  }, s.isAborted = function() {
    return l === A1;
  }, s.result = function() {
    return u;
  }, s.error = function() {
    return d;
  }, s);
  return C;
}
function zg(e, t, n, r, i, o, a) {
  var s = e.finalizeRunEffect(m);
  f.cancel = Ni;
  var l = {
    meta: i,
    cancel: p,
    status: ic
  }, u = FH(e, l, n, r, i, o, a), d = {
    task: u,
    digestEffect: y
  };
  function p() {
    l.status === ic && (l.status = qs, f(N0));
  }
  return a && (a.cancel = u.cancel), f(), u;
  function f(g, x) {
    try {
      var E;
      x ? (E = t.throw(g), iT()) : MA(g) ? (l.status = qs, f.cancel(), E = ro(t.return) ? t.return(N0) : {
        done: !0,
        value: N0
      }) : LA(g) ? E = ro(t.return) ? t.return() : {
        done: !0
      } : E = t.next(g), E.done ? (l.status !== qs && (l.status = tT), l.cont(E.value)) : y(E.value, r, f);
    } catch (b) {
      if (l.status === qs)
        throw b;
      l.status = A1, l.cont(b, !0);
    }
  }
  function m(g, x, E) {
    if (Tg(g))
      C7(g, E);
    else if (m7(g))
      zg(
        e,
        g,
        u.context,
        x,
        i,
        /* isRoot */
        !1,
        E
      );
    else if (g && g[EA]) {
      var b = DH[g.type];
      b(e, g.payload, E, d);
    } else
      E(g);
  }
  function y(g, x, E, b) {
    b === void 0 && (b = "");
    var C = nT();
    e.sagaMonitor && e.sagaMonitor.effectTriggered({
      effectId: C,
      parentEffectId: x,
      label: b,
      effect: g
    });
    var T;
    function z(I, w) {
      T || (T = !0, E.cancel = Ni, e.sagaMonitor && (w ? e.sagaMonitor.effectRejected(C, I) : e.sagaMonitor.effectResolved(C, I)), w && OH(g), E(I, w));
    }
    z.cancel = Ni, E.cancel = function() {
      T || (T = !0, z.cancel(), z.cancel = Ni, e.sagaMonitor && e.sagaMonitor.effectCancelled(C));
    }, s(g, C, z);
  }
}
function LH(e, t) {
  for (var n = e.channel, r = n === void 0 ? eT() : n, i = e.dispatch, o = e.getState, a = e.context, s = a === void 0 ? {} : a, l = e.sagaMonitor, u = e.effectMiddlewares, d = e.onError, p = d === void 0 ? P$ : d, f = arguments.length, m = new Array(f > 2 ? f - 2 : 0), y = 2; y < f; y++)
    m[y - 2] = arguments[y];
  var g = t.apply(void 0, m), x = nT();
  l && (l.rootSagaStarted = l.rootSagaStarted || Ni, l.effectTriggered = l.effectTriggered || Ni, l.effectResolved = l.effectResolved || Ni, l.effectRejected = l.effectRejected || Ni, l.effectCancelled = l.effectCancelled || Ni, l.actionDispatched = l.actionDispatched || Ni, l.rootSagaStarted({
    effectId: x,
    saga: t,
    args: m
  }));
  var E;
  if (u) {
    var b = q$.apply(void 0, u);
    E = function(T) {
      return function(z, I, w) {
        var M = function(R) {
          return T(R, I, w);
        };
        return b(M)(z);
      };
    };
  } else
    E = zA;
  var C = {
    channel: r,
    dispatch: _$(i),
    getState: o,
    sagaMonitor: l,
    onError: p,
    finalizeRunEffect: E
  };
  return XA(function() {
    var T = zg(
      C,
      g,
      s,
      x,
      y7(t),
      /* isRoot */
      !0,
      void 0
    );
    return l && l.effectResolved(x, T), T;
  });
}
function MH(e) {
  var t = {}, n = t.context, r = n === void 0 ? {} : n, i = t.channel, o = i === void 0 ? eT() : i, a = t.sagaMonitor, s = TA(t, ["context", "channel", "sagaMonitor"]), l;
  function u(d) {
    var p = d.getState, f = d.dispatch;
    return l = LH.bind(null, Yp({}, s, {
      context: r,
      channel: o,
      dispatch: f,
      getState: p,
      sagaMonitor: a
    })), function(m) {
      return function(y) {
        a && a.actionDispatched && a.actionDispatched(y);
        var g = m(y);
        return o.put(y), g;
      };
    };
  }
  return u.run = function() {
    return l.apply(void 0, arguments);
  }, u.setContext = function(d) {
    v7(r, d);
  }, u;
}
var zb = function(e) {
  return {
    done: !0,
    value: e
  };
}, w4 = {};
function BH(e) {
  return g7(e) ? "channel" : NA(e) ? String(e) : ro(e) ? e.name : String(e);
}
function IH(e, t, n) {
  var r, i, o, a = t;
  function s(l, u) {
    if (a === w4)
      return zb(l);
    if (u && !i)
      throw a = w4, u;
    r && r(l);
    var d = u ? e[i](u) : e[a]();
    return a = d.nextState, o = d.effect, r = d.stateUpdater, i = d.errorState, a === w4 ? zb(l) : o;
  }
  return Lv(s, function(l) {
    return s(null, l);
  }, n);
}
function RH(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    r[i - 2] = arguments[i];
  var o = {
    done: !1,
    value: U0(e)
  }, a = function(u) {
    return {
      done: !1,
      value: ZA.apply(void 0, [t].concat(r, [u]))
    };
  }, s, l = function(u) {
    return s = u;
  };
  return IH({
    q1: function() {
      return {
        nextState: "q2",
        effect: o,
        stateUpdater: l
      };
    },
    q2: function() {
      return {
        nextState: "q1",
        effect: a(s)
      };
    }
  }, "q1", "takeEvery(" + BH(e) + ", " + t.name + ")");
}
function fc(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    r[i - 2] = arguments[i];
  return ZA.apply(void 0, [RH, e, t].concat(r));
}
function* PH() {
  yield Lc([
    fc(ad, _H),
    fc(YD, qH)
  ]);
}
function* _H(e) {
  const { id: t, state: n, reverse: r } = e.payload, i = yield Sc(
    bi,
    t
  );
  if (!i) return;
  const [o, a] = yield Er(
    Am,
    (l) => n.initial(i.state, l),
    [],
    !0
    // shouldFocusInsertedDocument
  ), s = (l) => ({
    action: Eb({ id: t, state: l }),
    reverse: Eb({
      id: t,
      state: typeof r == "function" ? r(i.state) : i.state
    })
  });
  if (o.push(s(a)), !n.executor)
    yield ps(Dm(o));
  else {
    const l = yield Er(Og);
    for (yield ps(
      uA({
        initial: o,
        executor: (u, d) => {
          if (!n.executor) {
            u(o);
            return;
          }
          n.executor(
            function(p) {
              l.put({
                resolve: p,
                callback: (f, m) => {
                  u([...f, s(m)]);
                }
              });
            },
            function(p) {
              l.put({
                reject: p,
                callback: (f, m) => {
                  d([...f, s(m)]);
                }
              });
            }
          );
        }
      })
    ); ; ) {
      const u = yield U0(l), d = yield Sc(
        bi,
        t
      );
      if (!d) continue;
      const p = u.resolve || u.next || u.reject || ((y) => y), [f, m] = yield Er(
        Am,
        (y) => p(d.state, y),
        [],
        !0
        // shouldFocusInsertedDocument
      );
      if (u.callback(f, m), u.resolve || u.reject)
        break;
    }
  }
}
function* qH(e) {
  const { id: t, pluginType: n } = e.payload, r = yield Sc(
    bi,
    t
  );
  if (!r) return;
  const i = si.getByType(n);
  if (!i) {
    console.warn(`Invalid plugin '${n}'`);
    return;
  }
  const o = [], a = {
    createDocument(d) {
      o.push(d);
    }
  };
  let s;
  e.payload.state === void 0 ? s = i.state.createInitialState(a) : s = i.state.toStoreState(e.payload.state, a);
  const [l] = yield Er(
    Am,
    () => {
    },
    o,
    !0
    // shouldFocusInsertedDocument
  ), u = {
    action: Sm({
      id: t,
      plugin: n,
      state: s
    }),
    reverse: Sm({
      id: t,
      plugin: r.plugin,
      state: r.state
    })
  };
  yield ps(Dm([...l, u]));
}
function* Am(e, t = [], n = !1) {
  const r = [], i = t, o = {
    createDocument(s) {
      i.push(s);
    }
  }, a = e(o);
  for (let s; s = i.pop(); ) {
    const l = si.getByType(s.plugin);
    if (!l) {
      console.warn(`Invalid plugin '${s.plugin}'`);
      continue;
    }
    const u = s.state === void 0 ? l.state.createInitialState(o) : l.state.toStoreState(s.state, o), d = yield Sc(
      bi,
      s.id
    );
    if (d)
      r.push({
        action: Sm({
          id: s.id,
          plugin: s.plugin,
          state: u
        }),
        reverse: Sm({
          id: s.id,
          plugin: d.plugin,
          state: d.state
        })
      });
    else {
      const p = n ? QD : Uq;
      r.push({
        action: p({
          id: s.id,
          plugin: s.plugin,
          state: u
        }),
        reverse: Wq(s.id)
      });
    }
  }
  return [r, a];
}
function* $H() {
  yield Lc([
    Er(UH),
    fc(uA, HH)
  ]);
}
function* HH(e) {
  const t = yield Er(Og);
  function n(r) {
    return function(i) {
      t.put({
        [r]: i,
        tempActions: e.payload.initial
      });
    };
  }
  e.payload.executor(
    n("resolve"),
    n("reject")
  ), yield Er(VH, t);
}
function* VH(e) {
  for (; ; ) {
    const t = yield U0(e), n = t.resolve || t.reject || [];
    if (yield Lc(n.map((r) => ps(f_(r.action)))), yield ps(hA({ combine: !1, actions: n })), t.resolve || t.reject)
      break;
  }
  e.close();
}
function* UH() {
  for (; ; ) {
    const e = yield U0(
      Dm.type
    );
    for (yield Er(Fb, e.payload, !1); ; ) {
      const {
        action: t,
        timeout: n
      } = yield tH({
        action: U0(Dm.type),
        timeout: nH(1e3)
      });
      if (n)
        break;
      t && (yield Er(Fb, t.payload, !0));
    }
  }
}
function* Fb(e, t) {
  yield Lc(e.map((n) => ps(n.action))), yield ps(
    hA({
      combine: t,
      actions: e
    })
  );
}
function* WH() {
  yield Lc([
    fc(n$, ZH),
    fc(Qp, GH),
    fc(j0, KH)
  ]);
}
function* ZH({
  payload: e
}) {
  const t = yield Sc(
    rl,
    e.parent
  );
  if (!t || !t.children) return;
  const n = t.children.findIndex(({ id: r }) => r === e.sibling);
  n !== -1 && (yield Er(oT, {
    parent: e.parent,
    previousSibling: n === 0 ? void 0 : t.children[n - 1].id,
    document: e.document
  }));
}
function* GH({
  payload: e
}) {
  yield Er(oT, {
    parent: e.parent,
    previousSibling: e.sibling,
    document: e.document
  });
}
function* KH({ payload: e }) {
  yield Er(aT, e.parent, (t, n) => {
    typeof t.removeChild == "function" && t.removeChild(n, e.child);
  });
}
function* oT(e) {
  yield Er(aT, e.parent, (t, n) => {
    typeof t.insertChild == "function" && t.insertChild(n, {
      previousSibling: e.previousSibling,
      document: e.document
    });
  });
}
function* aT(e, t) {
  const n = yield Sc(
    bi,
    e
  );
  if (!n) return;
  const r = si.getByType(n.plugin);
  if (!r) {
    console.warn(`Invalid plugin '${n.plugin}'`);
    return;
  }
  const i = yield Er(Og), o = r.state.init(n.state, (s, l) => {
    const u = ad({
      id: e,
      state: {
        initial: s,
        executor: l == null ? void 0 : l.executor
      },
      reverse: l == null ? void 0 : l.reverse
    });
    i.put(u);
  });
  t(r, o), i.close(), yield Er(a, i);
  function* a(s) {
    for (; ; ) {
      const l = yield U0(s);
      yield ps(l);
    }
  }
}
function* XH() {
  yield fc(mA, QH);
}
function* QH(e) {
  const [t] = yield Er(
    Am,
    () => {
    },
    [{ id: Ec, ...e.payload.initialState || {} }],
    !1
    // shouldFocusInsertedDocument
  );
  yield Lc(t.map((r) => ps(r.action)));
  const n = yield Sc(eA);
  yield ps(fA(n));
}
function* YH() {
  yield Lc([
    Er(PH),
    Er($H),
    Er(WH),
    Er(XH)
  ]);
}
function JH() {
  const e = MH(), t = Eq({
    reducer: {
      documents: XD.reducer,
      focus: lA.reducer,
      history: pA.reducer
    },
    middleware: (n) => n({
      // https://github.com/serlo/backlog/issues/127
      serializableCheck: {
        ignoredActions: [
          "documents/runChangeDocumentSaga",
          "history/commitTemporaryActionToHistory"
        ],
        ignoredActionPaths: [/.*\.state.src.pending$/],
        ignoredPaths: [/.*\.state.src.pending$/]
      }
    }).concat([e])
  });
  return e.run(YH), t;
}
function eV() {
  return JH();
}
function zn() {
  return wA();
}
const Ur = D$, yn = g$, tV = (e, t, n) => {
  const r = zn(), i = Ur(), o = yn(
    (s) => ou(s, e)
  ), a = (s, l) => {
    s && t && typeof t.onKeyDown == "function" && !t.onKeyDown(s) || (s == null || s.preventDefault(), l());
  };
  ua("backspace, del", (s) => {
    o && a(s, () => {
      if (!s || !Sg(
        r.getState(),
        e
      )) return;
      const l = il(r.getState(), e);
      l && (s.key === "Backspace" ? i(Ag(rl(r.getState()))) : s.key === "Delete" && i(Dg(rl(r.getState()))), i(j0({ parent: l.id, child: e })));
    });
  });
}, _d = {
  latestId: null,
  timeout: null
};
function nV({ id: e, pluginProps: t }) {
  const n = zn(), r = Ur(), i = yn((d) => bi(d, e)), o = yn((d) => cs(d, e)), a = si.getByType((i == null ? void 0 : i.plugin) ?? "");
  tV(e, a);
  const s = v.useRef(null), l = v.useCallback(
    (d) => {
      const p = d.target.closest("[data-document]");
      if (!o && p === s.current)
        if ((i == null ? void 0 : i.plugin) === "rows") {
          const f = il(n.getState(), e);
          f && r(Ji(f.id));
        } else
          r(Ji(e));
    },
    [o, e, r, i, n]
  ), u = v.useCallback(
    (d) => {
      i && (["rows", "exercise"].includes(i == null ? void 0 : i.plugin) || (d == null || d.stopPropagation(), _d.timeout && clearTimeout(_d.timeout), _d.latestId = e, _d.timeout = setTimeout(() => {
        var p;
        if (!(tA(n.getState(), e) === Y.SerloTable && ["button", "select"].includes((p = d.target.nodeName) == null ? void 0 : p.toLowerCase())) && _d.latestId === e) {
          const f = d.target.closest(
            "[data-document]"
          );
          !o && f === s.current && r(Ji(e));
        }
      }, 10)));
    },
    [i, o, r, e, n]
  );
  return v.useMemo(() => {
    if (!i)
      return console.warn("SubDocumentEditor -> Document does not exist"), null;
    if (!a)
      return console.warn("SubDocumentEditor -> Plugin does not exist"), null;
    if (!i.plugin)
      return console.warn("SubDocumentEditor -> Document is invalid"), null;
    const d = typeof a.config == "function" ? a.config() : a.config, p = t && t.config || {}, f = i7(d, p), m = (E, b = {}) => {
      r(
        ad({
          id: e,
          state: {
            initial: E,
            executor: b.executor
          },
          reverse: b.reverse
        })
      );
    }, y = a.state.init(i.state, m), g = Object.hasOwn(f, "isInlineChildEditor") && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    f.isInlineChildEditor, x = i.plugin.startsWith("type-");
    return /* @__PURE__ */ c.jsx(
      "div",
      {
        className: Le(
          `plugin-${i == null ? void 0 : i.plugin}`,
          "outline-none",
          g || x ? "" : "plugin-wrapper-container relative -ml-[7px] mb-6 min-h-[10px] pl-[5px]"
        ),
        onMouseDown: l,
        onFocus: u,
        ref: s,
        "data-document": !0,
        tabIndex: -1,
        children: /* @__PURE__ */ c.jsx(
          a.Component,
          {
            containerRef: s,
            id: e,
            focused: o,
            config: f,
            state: y
          }
        )
      }
    );
  }, [
    i,
    a,
    t,
    l,
    u,
    o,
    e,
    r
  ]);
}
const sT = (e) => {
  const t = Ur(), n = v.useCallback(() => {
    t(Df());
  }, [t]);
  return /* @__PURE__ */ c.jsx(rV, { undo: n, children: /* @__PURE__ */ c.jsx(nV, { ...e }) });
};
class rV extends v.Component {
  constructor() {
    super(...arguments), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(t, n) {
    typeof this.context == "function" && this.context(t, n), console.error(t, n);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ c.jsxs("div", { className: "my-12 rounded-2xl bg-orange-200 p-4 font-bold", children: [
      "Leider ist ein Fehler aufgetreten.",
      /* @__PURE__ */ c.jsx(
        "button",
        {
          onClick: () => {
            this.props.undo(), this.setState({ hasError: !1 });
          },
          className: "serlo-button-edit-primary mt-3 block",
          children: "Letzte Änderung rückgänging machen"
        }
      )
    ] }) : this.props.children;
  }
}
const lT = {
  prefix: "fas",
  iconName: "trash-can",
  icon: [448, 512, [61460, "trash-alt"], "f2ed", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z"]
}, ld = lT, iV = {
  prefix: "fas",
  iconName: "hand-point-right",
  icon: [512, 512, [], "f0a4", "M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-208 0 0-64 208 0zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm64-64c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0c17.7 0 32 14.3 32 32zM288 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm-88-96l.6 0c-5.4 9.4-8.6 20.3-8.6 32c0 13.2 4 25.4 10.8 35.6C177.9 364.3 160 388.1 160 416c0 11.7 3.1 22.6 8.6 32l-8.6 0C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64l27 0c35.3 0 64 28.7 64 64l0 88c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56c0 39.8 32.2 72 72 72z"]
}, oV = {
  prefix: "fas",
  iconName: "pencil",
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1 0 32c0 8.8 7.2 16 16 16l32 0zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
}, W0 = oV, aV = {
  prefix: "fas",
  iconName: "film",
  icon: [512, 512, [127902], "f008", "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM48 368l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM48 240l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM48 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L64 96c-8.8 0-16 7.2-16 16zM416 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM160 128l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L192 96c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0z"]
}, sV = {
  prefix: "fas",
  iconName: "lightbulb",
  icon: [384, 512, [128161], "f0eb", "M272 384c9.6-31.9 29.5-59.1 49.2-86.2c0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0c19.8 27.1 39.7 54.4 49.2 86.2l160 0zM192 512c44.2 0 80-35.8 80-80l0-16-160 0 0 16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"]
}, lV = {
  prefix: "fas",
  iconName: "square-check",
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, E7 = lV, uV = {
  prefix: "fas",
  iconName: "eye-slash",
  icon: [640, 512, [], "f070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"]
}, cV = {
  prefix: "fas",
  iconName: "arrow-up-from-bracket",
  icon: [448, 512, [], "e09a", "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3 192 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-64z"]
}, dV = {
  prefix: "fas",
  iconName: "circle-arrow-up",
  icon: [512, 512, ["arrow-circle-up"], "f0aa", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM385 215c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71L280 392c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-214.1-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 103c9.4-9.4 24.6-9.4 33.9 0L385 215z"]
}, pV = dV, fV = {
  prefix: "fas",
  iconName: "caret-up",
  icon: [320, 512, [], "f0d8", "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]
}, hV = {
  prefix: "fas",
  iconName: "circle-play",
  icon: [512, 512, [61469, "play-circle"], "f144", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"]
}, uT = hV, mV = {
  prefix: "fas",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, cT = mV, gV = {
  prefix: "fas",
  iconName: "arrows-rotate",
  icon: [512, 512, [128472, "refresh", "sync"], "f021", "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160 352 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l111.5 0c0 0 0 0 0 0l.4 0c17.7 0 32-14.3 32-32l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1L16 432c0 17.7 14.3 32 32 32s32-14.3 32-32l0-35.1 17.6 17.5c0 0 0 0 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.8c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352l34.4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48.4 288c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"]
}, dT = {
  prefix: "fas",
  iconName: "newspaper",
  icon: [512, 512, [128240], "f1ea", "M96 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L80 480c-44.2 0-80-35.8-80-80L0 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 272c0 8.8 7.2 16 16 16s16-7.2 16-16L96 96zm64 24l0 80c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24L184 96c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16z"]
}, vV = {
  prefix: "fas",
  iconName: "list-ol",
  icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M24 56c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24l0 120 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-96-8 0C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432l33.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
}, yV = {
  prefix: "fas",
  iconName: "code",
  icon: [640, 512, [], "f121", "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"]
}, xV = {
  prefix: "fas",
  iconName: "arrow-up-right-from-square",
  icon: [512, 512, ["external-link"], "f08e", "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"]
}, pT = xV, bV = {
  prefix: "fas",
  iconName: "signs-post",
  icon: [512, 512, ["map-signs"], "f277", "M224 32L64 32C46.3 32 32 46.3 32 64l0 64c0 17.7 14.3 32 32 32l377.4 0c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7L288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 256c0-17.7-14.3-32-32-32l-160 0 0-32-64 0 0 32L70.6 224c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7L448 352c17.7 0 32-14.3 32-32l0-64zM288 480l0-96-64 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
}, wV = bV, CV = {
  prefix: "fas",
  iconName: "circle-question",
  icon: [512, 512, [62108, "question-circle"], "f059", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, fT = CV, hT = {
  prefix: "fas",
  iconName: "eye",
  icon: [576, 512, [128065], "f06e", "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"]
}, kV = {
  prefix: "fas",
  iconName: "arrow-rotate-right",
  icon: [512, 512, [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"], "f01e", "M386.3 160L336 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"]
}, EV = kV, SV = {
  prefix: "fas",
  iconName: "quote-right",
  icon: [448, 512, [8221, "quote-right-alt"], "f10e", "M448 296c0 66.3-53.7 120-120 120l-8 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c30.9 0 56-25.1 56-56l0-8-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32 0 32 0 72zm-256 0c0 66.3-53.7 120-120 120l-8 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c30.9 0 56-25.1 56-56l0-8-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32 0 32 0 72z"]
}, mT = {
  prefix: "fas",
  iconName: "cubes",
  icon: [576, 512, [], "f1b3", "M290.8 48.6l78.4 29.7L288 109.5 206.8 78.3l78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5l0 112.2c-1.3 .4-2.6 .8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7L0 413.9c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3l0-119.1c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3l0-112.2c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zM392 210.6l-82.4 31.2 0-89.2L392 121l0 89.6zM154.8 250.9l78.4 29.7L152 311.7 70.8 280.6l78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4l0-100.5L256 323.2l0 95.9-82.4 36.2zM421.2 250.9c1.8-.7 3.8-.7 5.7 0l78.4 29.7L424 311.7l-81.2-31.1 78.4-29.7zM523.2 421.2l-77.6 34.1 0-100.5L528 323.2l0 90.7c0 3.2-1.9 6-4.8 7.3z"]
}, DV = {
  prefix: "fas",
  iconName: "arrow-rotate-left",
  icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", "M125.7 160l50.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 224c-17.7 0-32-14.3-32-32L16 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"]
}, AV = DV, TV = {
  prefix: "fas",
  iconName: "gear",
  icon: [512, 512, [9881, "cog"], "f013", "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
}, jf = TV, jV = {
  prefix: "fas",
  iconName: "square-root-variable",
  icon: [576, 512, ["square-root-alt"], "f698", "M282.6 78.1c8-27.3 33-46.1 61.4-46.1l200 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L344 96 238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l45.6 0c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1zM393.4 233.4c12.5-12.5 32.8-12.5 45.3 0L480 274.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 320l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"]
}, NV = {
  prefix: "fas",
  iconName: "caret-down",
  icon: [320, 512, [], "f0d7", "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
}, gT = {
  prefix: "fas",
  iconName: "images",
  icon: [576, 512, [], "f302", "M160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320l-144 0-48 0-80 0c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z"]
}, OV = {
  prefix: "fas",
  iconName: "file-circle-check",
  icon: [576, 512, [], "e5a0", "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
}, zV = {
  prefix: "fas",
  iconName: "rotate-right",
  icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M463.5 224l8.5 0c13.3 0 24-10.7 24-24l0-128c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l119.5 0z"]
}, FV = zV, LV = {
  prefix: "fas",
  iconName: "angle-down",
  icon: [448, 512, [8964], "f107", "M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"]
}, MV = {
  prefix: "fas",
  iconName: "ellipsis",
  icon: [448, 512, ["ellipsis-h"], "f141", "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
}, BV = {
  prefix: "fas",
  iconName: "paragraph",
  icon: [448, 512, [182], "f1dd", "M192 32l64 0 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352-32 0 0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-32 0c-88.4 0-160-71.6-160-160s71.6-160 160-160z"]
}, IV = {
  prefix: "fas",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
}, RV = {
  prefix: "fas",
  iconName: "list-ul",
  icon: [512, 512, ["list-dots"], "f0ca", "M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
}, PV = {
  prefix: "fas",
  iconName: "copy",
  icon: [448, 512, [], "f0c5", "M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z"]
}, Dc = {
  prefix: "fas",
  iconName: "plus",
  icon: [448, 512, [10133, 61543, "add"], "2b", "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"]
}, Fg = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, _V = {
  prefix: "fas",
  iconName: "angle-up",
  icon: [448, 512, [8963], "f106", "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"]
}, vT = {
  prefix: "fas",
  iconName: "chevron-left",
  icon: [320, 512, [9001], "f053", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"]
}, yT = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [320, 512, [9002], "f054", "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
}, qV = {
  prefix: "fas",
  iconName: "thumbtack",
  icon: [384, 512, [128204, 128392, "thumb-tack"], "f08d", "M32 32C32 14.3 46.3 0 64 0L320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-29.5 0 11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3L32 352c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64 64 64C46.3 64 32 49.7 32 32zM160 384l64 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96z"]
}, $V = {
  prefix: "fas",
  iconName: "rotate",
  icon: [512, 512, [128260, "sync-alt"], "f2f1", "M142.9 142.9c-17.5 17.5-30.1 38-37.8 59.8c-5.9 16.7-24.2 25.4-40.8 19.5s-25.4-24.2-19.5-40.8C55.6 150.7 73.2 122 97.6 97.6c87.2-87.2 228.3-87.5 315.8-1L455 55c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2l0 128c0 13.3-10.7 24-24 24l-8.4 0c0 0 0 0 0 0L344 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l41.1-41.1c-62.6-61.5-163.1-61.2-225.3 1zM16 312c0-13.3 10.7-24 24-24l7.6 0 .7 0L168 288c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-41.1 41.1c62.6 61.5 163.1 61.2 225.3-1c17.5-17.5 30.1-38 37.8-59.8c5.9-16.7 24.2-25.4 40.8-19.5s25.4 24.2 19.5 40.8c-10.8 30.6-28.4 59.3-52.9 83.8c-87.2 87.2-228.3 87.5-315.8 1L57 457c-6.9 6.9-17.2 8.9-26.2 5.2S16 449.7 16 440l0-119.6 0-.7 0-7.6z"]
}, xT = $V, bT = {
  prefix: "fas",
  iconName: "spinner",
  icon: [512, 512, [], "f110", "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"]
}, HV = {
  prefix: "fas",
  iconName: "splotch",
  icon: [512, 512, [], "f5bc", "M208.5 62.3l28.1-36.9C248.8 9.4 267.8 0 288 0c28.5 0 53.6 18.7 61.8 46l17.8 59.4c10.3 34.4 36.1 62 69.8 74.6l39.8 14.9c20.9 7.9 34.8 27.9 34.8 50.2c0 16.9-7.9 32.8-21.5 42.9l-67.3 50.5c-24.3 18.2-37.2 47.9-33.8 78.1l2.5 22.7c4.3 38.7-26 72.6-65 72.6c-14.8 0-29.3-5.1-40.8-14.3l-55.4-44.3c-4.5-3.6-9.3-6.7-14.5-9.2c-15.8-7.9-33.7-10.4-51-7.3L82.4 451.9C47.8 458.2 16 431.6 16 396.5c0-13.2 4.7-26 13.1-36.2l11.2-13.4c14.6-17.4 22.6-39.4 22.6-62.1c0-18.8-5.5-37.2-15.8-53L8.8 173.5C3.1 164.7 0 154.4 0 143.9c0-33.4 30.1-58.8 63-53.2l51.3 8.7c35.9 6.1 72.2-8.2 94.2-37.1z"]
}, VV = {
  prefix: "fas",
  iconName: "hashtag",
  icon: [448, 512, [62098], "23", "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128l95.1 0 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128l58.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-68.9 0L325.8 320l58.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-68.9 0-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7-95.1 0-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384 32 384c-17.7 0-32-14.3-32-32s14.3-32 32-32l68.9 0 21.3-128L64 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l68.9 0 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320l95.1 0 21.3-128-95.1 0z"]
}, Lg = {
  prefix: "fas",
  iconName: "circle-plus",
  icon: [512, 512, ["plus-circle"], "f055", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
}, UV = Lg, WV = {
  prefix: "fas",
  iconName: "clone",
  icon: [512, 512, [], "f24d", "M288 448L64 448l0-224 64 0 0-64-64 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-64-64 0 0 64zm-64-96l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L224 0c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64z"]
}, wT = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, ZV = wT, GV = wT, KV = {
  prefix: "fas",
  iconName: "brain",
  icon: [512, 512, [129504], "f5dc", "M184 0c30.9 0 56 25.1 56 56l0 400c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1c-30.9 0-56-25.1-56-56l0-400c0-30.9 25.1-56 56-56z"]
}, CT = {
  prefix: "fas",
  iconName: "circle-xmark",
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
}, XV = CT, kT = v.createContext(null), ET = kT.Provider;
function Un() {
  const e = v.useContext(kT);
  if (!e)
    throw new Error("Attempt to use staticStrings outside of provider!");
  return e;
}
const ST = typeof window < "u", DT = ST && navigator.platform.indexOf("Mac") > -1;
ST && navigator.platform.indexOf("Win") > -1;
function vn({
  text: e,
  hotkeys: t,
  className: n
}) {
  const r = Un();
  if (!e && !t) return null;
  const i = t == null ? void 0 : t.replace(
    "%ctrlOrCmd%",
    DT ? "⌘" : r.misc.ctrl
  );
  return /* @__PURE__ */ c.jsx(
    "span",
    {
      className: Le(
        "serlo-tooltip sr-only pointer-events-none bottom-full block cursor-default opacity-0 transition-opacity",
        n
      ),
      children: /* @__PURE__ */ c.jsxs("span", { className: "block w-80 max-w-fit rounded bg-almost-black px-2 py-1.5 text-center text-sm font-bold text-white ", children: [
        e,
        t ? /* @__PURE__ */ c.jsx("span", { className: "block text-gray-300", children: i }) : null
      ] })
    }
  );
}
function ot({ icon: e, className: t, style: n }) {
  return /* @__PURE__ */ c.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      viewBox: `0 0 ${e.icon[0]} ${e.icon[1]}`,
      "aria-hidden": !0,
      focusable: !1,
      className: Le(
        "inline-block h-[1em] overflow-visible align-[-0.125em]",
        t
      ),
      style: n,
      children: /* @__PURE__ */ c.jsx(
        "path",
        {
          fill: "currentColor",
          d: Array.isArray(e.icon[4]) ? e.icon[4][0] : e.icon[4]
        }
      )
    }
  );
}
function QV() {
  const e = Ur(), t = yn(cA), n = yn(dA);
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    r("undo"),
    r("redo")
  ] });
  function r(i) {
    const o = i === "undo", a = o ? !t : !n, s = () => e(o ? Df() : Xp());
    return /* @__PURE__ */ c.jsxs(
      "button",
      {
        className: Le(
          "serlo-button-edit serlo-button-round serlo-tooltip-trigger",
          a ? "cursor-default text-gray-300" : "serlo-button-edit-secondary"
        ),
        onClick: s,
        disabled: a,
        "data-qa": `editor-toolbar-${i}`,
        children: [
          /* @__PURE__ */ c.jsx(
            vn,
            {
              text: o ? "Undo" : "Redo",
              className: "top-8 !-ml-3"
            }
          ),
          /* @__PURE__ */ c.jsx(ot, { icon: o ? AV : EV })
        ]
      }
    );
  }
}
function YV() {
  return /* @__PURE__ */ c.jsxs("nav", { className: "pointer-events-none sticky top-0 z-[90] flex h-14 w-full justify-between pl-5 pr-3 pt-2 md:bg-transparent", children: [
    /* @__PURE__ */ c.jsx("div", { className: "pointer-events-auto -ml-2 flex gap-2 rounded-lg bg-white p-2 md:-ml-28 md:bg-transparent lg:-ml-40", children: /* @__PURE__ */ c.jsx(QV, {}) }),
    /* @__PURE__ */ c.jsx("div", { className: "editor-toolbar-right pointer-events-auto mr-2 rounded-lg bg-white p-2 md:mr-[-11.5vw] lg:-mr-52 xl:-mr-64" })
  ] });
}
const AT = v.createContext(null), TT = AT.Provider;
function nt() {
  const e = v.useContext(AT);
  if (!e)
    throw new Error("Attempt to use editStrings outside of provider!");
  return e;
}
function jT(e, t, n) {
  var r, i, o;
  t === void 0 && (t = 50), n === void 0 && (n = {});
  var a = (r = n.isImmediate) != null && r, s = (i = n.callback) != null && i, l = n.maxWait, u = Date.now(), d = [];
  function p() {
    if (l !== void 0) {
      var m = Date.now() - u;
      if (m + t >= l) return l - m;
    }
    return t;
  }
  var f = function() {
    var m = [].slice.call(arguments), y = this;
    return new Promise(function(g, x) {
      var E = a && o === void 0;
      if (o !== void 0 && clearTimeout(o), o = setTimeout(function() {
        if (o = void 0, u = Date.now(), !a) {
          var C = e.apply(y, m);
          s && s(C), d.forEach(function(T) {
            return (0, T.resolve)(C);
          }), d = [];
        }
      }, p()), E) {
        var b = e.apply(y, m);
        return s && s(b), g(b);
      }
      d.push({ resolve: g, reject: x });
    });
  };
  return f.cancel = function(m) {
    o !== void 0 && clearTimeout(o), d.forEach(function(y) {
      return (0, y.reject)(m);
    }), d = [];
  }, f;
}
const Mv = "serlo-editor";
function JV({
  useStored: e,
  setUseStored: t
}) {
  const n = nt().edtrIo.localStorage;
  return NT() ? /* @__PURE__ */ c.jsx("div", { className: "m-side mt-12 rounded-2xl bg-editor-primary-50 p-side", children: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    n[e ? "restoreInitial" : "found"],
    /* @__PURE__ */ c.jsx("br", {}),
    /* @__PURE__ */ c.jsx(
      "button",
      {
        className: "serlo-button-edit-primary mt-2",
        onClick: () => {
          e ? window.confirm(n.confirmRestore) && (OT(null), t(!1)) : t(!0);
        },
        children: n[e ? "restoreInitialButton" : "foundButton"]
      }
    )
  ] }) }) : null;
}
function NT() {
  const e = localStorage.getItem(Mv);
  return e ? JSON.parse(e)[window.location.pathname] : null;
}
function OT(e) {
  console.log("editor: saving state in browser localstorage");
  const t = localStorage.getItem(Mv), n = t ? JSON.parse(t) : {};
  n[window.location.pathname] = e, localStorage.setItem(Mv, JSON.stringify(n));
}
const eU = jT(
  (e) => OT(e),
  5e3
), tU = "@serlo/editor", nU = "0.21.2", rU = "https://de.serlo.org/editor", iU = {
  url: "https://github.com/serlo/frontend/issues"
}, oU = {
  type: "git",
  url: "https://github.com/serlo/frontend.git",
  directory: "packages/editor"
}, aU = "Apache-2.0", sU = "Serlo Education e.V.", lU = "module", uU = {
  ".": {
    import: "./dist/editor.js",
    require: "./dist/editor.js",
    types: "./dist/index.d.ts"
  },
  "./dist/style.css": "./dist/style.css"
}, cU = "./dist/editor.js", dU = "./dist/editor.js", pU = "./dist/index.d.ts", fU = [
  "dist"
], hU = {
  _eslint: 'eslint "src/**/*.{js,jsx,ts,tsx}"',
  _prettier: "prettier .",
  dev: "vite",
  build: "vite build",
  format: 'npm-run-all --continue-on-error "format:*"',
  "format:eslint": "yarn _eslint --fix",
  "format:prettier": "yarn _prettier --write",
  lint: "npm-run-all lint:tsc lint:eslint lint:prettier",
  "lint:eslint": "yarn _eslint",
  "lint:prettier": "yarn _prettier --check",
  "lint:tsc": "tsc --noEmit",
  test: "jest",
  "publish:package": "npm publish",
  "yalc:publish": "yarn build && yalc publish --push --sig"
}, mU = {
  "@serlo/katex-styles": "1.0.1"
}, gU = {
  "@open-iframe-resizer/react": "1.2.1",
  "@serlo/katex-styles": "1.0.1",
  "@vidstack/react": "next",
  "isomorphic-dompurify": "^2.19.0",
  lit: "^3.2.1",
  motion: "^11.11.17",
  react: "^18.2.0",
  "react-dom": "^18.3.1",
  "react-hot-toast": "^2.4.1",
  "react-resizable": "^3.0.5"
}, vU = {
  "@eslint/eslintrc": "^3.1.0",
  "@eslint/js": "^9.14.0",
  "@fortawesome/fontawesome-svg-core": "6.6.0",
  "@fortawesome/free-brands-svg-icons": "6.6.0",
  "@fortawesome/free-regular-svg-icons": "6.6.0",
  "@fortawesome/free-solid-svg-icons": "6.6.0",
  "@fortawesome/react-fontawesome": "^0.2.2",
  "@prezly/slate-lists": "0.116.0",
  "@radix-ui/react-dialog": "^1.1.2",
  "@radix-ui/react-navigation-menu": "^1.2.1",
  "@radix-ui/react-select": "^2.1.2",
  "@reduxjs/toolkit": "^2.3.0",
  "@rollup/plugin-replace": "^6.0.1",
  "@serlo/typescript-config": "workspace:*",
  "@types/dompurify": "^3.0.5",
  "@types/is-hotkey": "0.1.10",
  "@types/react": "^18.0.25",
  "@types/react-dnd-multi-backend": "^6.0.6",
  "@types/react-dom": "^18.3.1",
  "@types/react-resizable": "^3.0.8",
  "@types/react-syntax-highlighter": "^15.5.13",
  "@typescript-eslint/eslint-plugin": "^8.14.0",
  "@typescript-eslint/parser": "^8.14.0",
  "@vitejs/plugin-react": "^4.3.3",
  autoprefixer: "^10.4.20",
  clsx: "^2.1.1",
  eslint: "^9.14.0",
  "eslint-config-next": "^15.0.3",
  "eslint-config-prettier": "^9.1.0",
  "eslint-import-resolver-typescript": "^3.6.3",
  "eslint-plugin-import": "^2.31.0",
  "eslint-plugin-react": "^7.37.2",
  "eslint-plugin-react-hooks": "^5.0.0",
  "fp-ts": "^2.16.9",
  "io-ts": "^2.2.21",
  "is-hotkey": "0.2.0",
  jest: "^29.7.0",
  "jest-environment-jsdom": "^29.7.0",
  katex: "^0.16.11",
  mathjs: "^13.2.2",
  "npm-run-all": "^4.1.5",
  postcss: "^8.4.49",
  "postcss-flexbugs-fixes": "^5.0.2",
  "postcss-import": "^16.1.0",
  prettier: "^3.3.3",
  "prettier-plugin-packagejson": "^2.5.3",
  "prettier-plugin-tailwindcss": "^0.6.8",
  ramda: "^0.30.1",
  "rdndmb-html5-to-touch": "^8.0.3",
  "react-dnd": "^16.0.1",
  "react-dnd-html5-backend": "^16.0.1",
  "react-dnd-multi-backend": "^8.0.3",
  "react-dnd-touch-backend": "^16.0.1",
  "react-hotkeys-hook": "^4.6.1",
  "react-mathquill": "Entkenntnis/tmp-react-mathquill",
  "react-redux": "^9.1.2",
  "react-syntax-highlighter": "^15.6.1",
  redux: "^5.0.1",
  "redux-saga": "^1.3.0",
  reselect: "^5.1.1",
  slate: "0.110.2",
  "slate-dom": "0.111.0",
  "slate-react": "0.111.0",
  tailwindcss: "^3.4.15",
  "ts-debounce": "^4.0.0",
  "ts-jest": "^29.2.5",
  "ts-key-enum": "^2.0.13",
  typescript: "^5.6.3",
  uuid: "^11.0.3",
  vite: "^5.4.11",
  "vite-plugin-dts": "4.3.0",
  "vite-plugin-svgr": "^4.3.0"
}, yU = "yarn@3.6.1", xU = {
  node: ">=20.0.0"
}, bU = {
  plugins: {
    "postcss-import": {},
    "tailwindcss/nesting": {},
    tailwindcss: {},
    "postcss-flexbugs-fixes": {},
    autoprefixer: {}
  }
}, wU = {
  svgo: !1
}, CU = {
  name: tU,
  version: nU,
  homepage: rU,
  bugs: iU,
  repository: oU,
  license: aU,
  author: sU,
  type: lU,
  exports: uU,
  main: cU,
  module: dU,
  types: pU,
  files: fU,
  scripts: hU,
  resolutions: mU,
  dependencies: gU,
  devDependencies: vU,
  packageManager: yU,
  engines: xU,
  postcss: bU,
  svgr: wU
};
function ud() {
  return CU.version;
}
let kU = { data: "" }, EU = (e) => typeof window == "object" ? ((e ? e.querySelector("#_goober") : window._goober) || Object.assign((e || document.head).appendChild(document.createElement("style")), { innerHTML: " ", id: "_goober" })).firstChild : e || kU, SU = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, DU = /\/\*[^]*?\*\/|  +/g, Lb = /\n+/g, $l = (e, t) => {
  let n = "", r = "", i = "";
  for (let o in e) {
    let a = e[o];
    o[0] == "@" ? o[1] == "i" ? n = o + " " + a + ";" : r += o[1] == "f" ? $l(a, o) : o + "{" + $l(a, o[1] == "k" ? "" : t) + "}" : typeof a == "object" ? r += $l(a, t ? t.replace(/([^,])+/g, (s) => o.replace(/(^:.*)|([^,])+/g, (l) => /&/.test(l) ? l.replace(/&/g, s) : s ? s + " " + l : l)) : o) : a != null && (o = /^--/.test(o) ? o : o.replace(/[A-Z]/g, "-$&").toLowerCase(), i += $l.p ? $l.p(o, a) : o + ":" + a + ";");
  }
  return n + (t && i ? t + "{" + i + "}" : i) + r;
}, Fs = {}, zT = (e) => {
  if (typeof e == "object") {
    let t = "";
    for (let n in e) t += n + zT(e[n]);
    return t;
  }
  return e;
}, AU = (e, t, n, r, i) => {
  let o = zT(e), a = Fs[o] || (Fs[o] = ((l) => {
    let u = 0, d = 11;
    for (; u < l.length; ) d = 101 * d + l.charCodeAt(u++) >>> 0;
    return "go" + d;
  })(o));
  if (!Fs[a]) {
    let l = o !== e ? e : ((u) => {
      let d, p, f = [{}];
      for (; d = SU.exec(u.replace(DU, "")); ) d[4] ? f.shift() : d[3] ? (p = d[3].replace(Lb, " ").trim(), f.unshift(f[0][p] = f[0][p] || {})) : f[0][d[1]] = d[2].replace(Lb, " ").trim();
      return f[0];
    })(e);
    Fs[a] = $l(i ? { ["@keyframes " + a]: l } : l, n ? "" : "." + a);
  }
  let s = n && Fs.g ? Fs.g : null;
  return n && (Fs.g = Fs[a]), ((l, u, d, p) => {
    p ? u.data = u.data.replace(p, l) : u.data.indexOf(l) === -1 && (u.data = d ? l + u.data : u.data + l);
  })(Fs[a], t, r, s), a;
}, TU = (e, t, n) => e.reduce((r, i, o) => {
  let a = t[o];
  if (a && a.call) {
    let s = a(n), l = s && s.props && s.props.className || /^go/.test(s) && s;
    a = l ? "." + l : s && typeof s == "object" ? s.props ? "" : $l(s, "") : s === !1 ? "" : s;
  }
  return r + i + (a ?? "");
}, "");
function Mg(e) {
  let t = this || {}, n = e.call ? e(t.p) : e;
  return AU(n.unshift ? n.raw ? TU(n, [].slice.call(arguments, 1), t.p) : n.reduce((r, i) => Object.assign(r, i && i.call ? i(t.p) : i), {}) : n, EU(t.target), t.g, t.o, t.k);
}
let FT, Bv, Iv;
Mg.bind({ g: 1 });
let ol = Mg.bind({ k: 1 });
function jU(e, t, n, r) {
  $l.p = t, FT = e, Bv = n, Iv = r;
}
function Tu(e, t) {
  let n = this || {};
  return function() {
    let r = arguments;
    function i(o, a) {
      let s = Object.assign({}, o), l = s.className || i.className;
      n.p = Object.assign({ theme: Bv && Bv() }, s), n.o = / *go\d+/.test(l), s.className = Mg.apply(n, r) + (l ? " " + l : "");
      let u = e;
      return e[0] && (u = s.as || e, delete s.as), Iv && u[0] && Iv(s), FT(u, s);
    }
    return i;
  };
}
var NU = (e) => typeof e == "function", Tm = (e, t) => NU(e) ? e(t) : e, OU = /* @__PURE__ */ (() => {
  let e = 0;
  return () => (++e).toString();
})(), LT = /* @__PURE__ */ (() => {
  let e;
  return () => {
    if (e === void 0 && typeof window < "u") {
      let t = matchMedia("(prefers-reduced-motion: reduce)");
      e = !t || t.matches;
    }
    return e;
  };
})(), zU = 20, T1 = /* @__PURE__ */ new Map(), FU = 1e3, Mb = (e) => {
  if (T1.has(e)) return;
  let t = setTimeout(() => {
    T1.delete(e), Mc({ type: 4, toastId: e });
  }, FU);
  T1.set(e, t);
}, LU = (e) => {
  let t = T1.get(e);
  t && clearTimeout(t);
}, Rv = (e, t) => {
  switch (t.type) {
    case 0:
      return { ...e, toasts: [t.toast, ...e.toasts].slice(0, zU) };
    case 1:
      return t.toast.id && LU(t.toast.id), { ...e, toasts: e.toasts.map((o) => o.id === t.toast.id ? { ...o, ...t.toast } : o) };
    case 2:
      let { toast: n } = t;
      return e.toasts.find((o) => o.id === n.id) ? Rv(e, { type: 1, toast: n }) : Rv(e, { type: 0, toast: n });
    case 3:
      let { toastId: r } = t;
      return r ? Mb(r) : e.toasts.forEach((o) => {
        Mb(o.id);
      }), { ...e, toasts: e.toasts.map((o) => o.id === r || r === void 0 ? { ...o, visible: !1 } : o) };
    case 4:
      return t.toastId === void 0 ? { ...e, toasts: [] } : { ...e, toasts: e.toasts.filter((o) => o.id !== t.toastId) };
    case 5:
      return { ...e, pausedAt: t.time };
    case 6:
      let i = t.time - (e.pausedAt || 0);
      return { ...e, pausedAt: void 0, toasts: e.toasts.map((o) => ({ ...o, pauseDuration: o.pauseDuration + i })) };
  }
}, j1 = [], N1 = { toasts: [], pausedAt: void 0 }, Mc = (e) => {
  N1 = Rv(N1, e), j1.forEach((t) => {
    t(N1);
  });
}, MU = { blank: 4e3, error: 4e3, success: 2e3, loading: 1 / 0, custom: 4e3 }, BU = (e = {}) => {
  let [t, n] = v.useState(N1);
  v.useEffect(() => (j1.push(n), () => {
    let i = j1.indexOf(n);
    i > -1 && j1.splice(i, 1);
  }), [t]);
  let r = t.toasts.map((i) => {
    var o, a;
    return { ...e, ...e[i.type], ...i, duration: i.duration || ((o = e[i.type]) == null ? void 0 : o.duration) || (e == null ? void 0 : e.duration) || MU[i.type], style: { ...e.style, ...(a = e[i.type]) == null ? void 0 : a.style, ...i.style } };
  });
  return { ...t, toasts: r };
}, IU = (e, t = "blank", n) => ({ createdAt: Date.now(), visible: !0, type: t, ariaProps: { role: "status", "aria-live": "polite" }, message: e, pauseDuration: 0, ...n, id: (n == null ? void 0 : n.id) || OU() }), Nf = (e) => (t, n) => {
  let r = IU(t, e, n);
  return Mc({ type: 2, toast: r }), r.id;
}, jo = (e, t) => Nf("blank")(e, t);
jo.error = Nf("error");
jo.success = Nf("success");
jo.loading = Nf("loading");
jo.custom = Nf("custom");
jo.dismiss = (e) => {
  Mc({ type: 3, toastId: e });
};
jo.remove = (e) => Mc({ type: 4, toastId: e });
jo.promise = (e, t, n) => {
  let r = jo.loading(t.loading, { ...n, ...n == null ? void 0 : n.loading });
  return e.then((i) => (jo.success(Tm(t.success, i), { id: r, ...n, ...n == null ? void 0 : n.success }), i)).catch((i) => {
    jo.error(Tm(t.error, i), { id: r, ...n, ...n == null ? void 0 : n.error });
  }), e;
};
var RU = (e, t) => {
  Mc({ type: 1, toast: { id: e, height: t } });
}, PU = () => {
  Mc({ type: 5, time: Date.now() });
}, _U = (e) => {
  let { toasts: t, pausedAt: n } = BU(e);
  v.useEffect(() => {
    if (n) return;
    let o = Date.now(), a = t.map((s) => {
      if (s.duration === 1 / 0) return;
      let l = (s.duration || 0) + s.pauseDuration - (o - s.createdAt);
      if (l < 0) {
        s.visible && jo.dismiss(s.id);
        return;
      }
      return setTimeout(() => jo.dismiss(s.id), l);
    });
    return () => {
      a.forEach((s) => s && clearTimeout(s));
    };
  }, [t, n]);
  let r = v.useCallback(() => {
    n && Mc({ type: 6, time: Date.now() });
  }, [n]), i = v.useCallback((o, a) => {
    let { reverseOrder: s = !1, gutter: l = 8, defaultPosition: u } = a || {}, d = t.filter((m) => (m.position || u) === (o.position || u) && m.height), p = d.findIndex((m) => m.id === o.id), f = d.filter((m, y) => y < p && m.visible).length;
    return d.filter((m) => m.visible).slice(...s ? [f + 1] : [0, f]).reduce((m, y) => m + (y.height || 0) + l, 0);
  }, [t]);
  return { toasts: t, handlers: { updateHeight: RU, startPause: PU, endPause: r, calculateOffset: i } };
}, qU = ol`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $U = ol`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, HU = ol`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, VU = Tu("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${qU} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$U} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e) => e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${HU} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`, UU = ol`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, WU = Tu("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e) => e.secondary || "#e0e0e0"};
  border-right-color: ${(e) => e.primary || "#616161"};
  animation: ${UU} 1s linear infinite;
`, ZU = ol`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, GU = ol`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, KU = Tu("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${ZU} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${GU} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e) => e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`, XU = Tu("div")`
  position: absolute;
`, QU = Tu("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, YU = ol`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, JU = Tu("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${YU} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, eW = ({ toast: e }) => {
  let { icon: t, type: n, iconTheme: r } = e;
  return t !== void 0 ? typeof t == "string" ? v.createElement(JU, null, t) : t : n === "blank" ? null : v.createElement(QU, null, v.createElement(WU, { ...r }), n !== "loading" && v.createElement(XU, null, n === "error" ? v.createElement(VU, { ...r }) : v.createElement(KU, { ...r })));
}, tW = (e) => `
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, nW = (e) => `
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, rW = "0%{opacity:0;} 100%{opacity:1;}", iW = "0%{opacity:1;} 100%{opacity:0;}", oW = Tu("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, aW = Tu("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, sW = (e, t) => {
  let n = e.includes("top") ? 1 : -1, [r, i] = LT() ? [rW, iW] : [tW(n), nW(n)];
  return { animation: t ? `${ol(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${ol(i)} 0.4s forwards cubic-bezier(.06,.71,.55,1)` };
}, lW = v.memo(({ toast: e, position: t, style: n, children: r }) => {
  let i = e.height ? sW(e.position || t || "top-center", e.visible) : { opacity: 0 }, o = v.createElement(eW, { toast: e }), a = v.createElement(aW, { ...e.ariaProps }, Tm(e.message, e));
  return v.createElement(oW, { className: e.className, style: { ...i, ...n, ...e.style } }, typeof r == "function" ? r({ icon: o, message: a }) : v.createElement(v.Fragment, null, o, a));
});
jU(v.createElement);
var uW = ({ id: e, className: t, style: n, onHeightUpdate: r, children: i }) => {
  let o = v.useCallback((a) => {
    if (a) {
      let s = () => {
        let l = a.getBoundingClientRect().height;
        r(e, l);
      };
      s(), new MutationObserver(s).observe(a, { subtree: !0, childList: !0, characterData: !0 });
    }
  }, [e, r]);
  return v.createElement("div", { ref: o, className: t, style: n }, i);
}, cW = (e, t) => {
  let n = e.includes("top"), r = n ? { top: 0 } : { bottom: 0 }, i = e.includes("center") ? { justifyContent: "center" } : e.includes("right") ? { justifyContent: "flex-end" } : {};
  return { left: 0, right: 0, display: "flex", position: "absolute", transition: LT() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)", transform: `translateY(${t * (n ? 1 : -1)}px)`, ...r, ...i };
}, dW = Mg`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, Lh = 16, pW = ({ reverseOrder: e, position: t = "top-center", toastOptions: n, gutter: r, children: i, containerStyle: o, containerClassName: a }) => {
  let { toasts: s, handlers: l } = _U(n);
  return v.createElement("div", { style: { position: "fixed", zIndex: 9999, top: Lh, left: Lh, right: Lh, bottom: Lh, pointerEvents: "none", ...o }, className: a, onMouseEnter: l.startPause, onMouseLeave: l.endPause }, s.map((u) => {
    let d = u.position || t, p = l.calculateOffset(u, { reverseOrder: e, gutter: r, defaultPosition: t }), f = cW(d, p);
    return v.createElement(uW, { id: u.id, key: u.id, onHeightUpdate: l.updateHeight, className: u.visible ? dW : "", style: f }, u.type === "custom" ? Tm(u.message, u) : i ? i(u) : v.createElement(lW, { toast: u, position: d }));
  }));
}, Bb = jo;
function MT(e) {
  let t = null;
  return () => (t == null && (t = e()), t);
}
function fW(e, t) {
  return e.filter(
    (n) => n !== t
  );
}
function hW(e, t) {
  const n = /* @__PURE__ */ new Set(), r = (o) => n.add(o);
  e.forEach(r), t.forEach(r);
  const i = [];
  return n.forEach(
    (o) => i.push(o)
  ), i;
}
class mW {
  enter(t) {
    const n = this.entered.length, r = (i) => this.isNodeInDocument(i) && (!i.contains || i.contains(t));
    return this.entered = hW(this.entered.filter(r), [
      t
    ]), n === 0 && this.entered.length > 0;
  }
  leave(t) {
    const n = this.entered.length;
    return this.entered = fW(this.entered.filter(this.isNodeInDocument), t), n > 0 && this.entered.length === 0;
  }
  reset() {
    this.entered = [];
  }
  constructor(t) {
    this.entered = [], this.isNodeInDocument = t;
  }
}
class gW {
  initializeExposedProperties() {
    Object.keys(this.config.exposeProperties).forEach((t) => {
      Object.defineProperty(this.item, t, {
        configurable: !0,
        enumerable: !0,
        get() {
          return console.warn(`Browser doesn't allow reading "${t}" until the drop event.`), null;
        }
      });
    });
  }
  loadDataTransfer(t) {
    if (t) {
      const n = {};
      Object.keys(this.config.exposeProperties).forEach((r) => {
        const i = this.config.exposeProperties[r];
        i != null && (n[r] = {
          value: i(t, this.config.matchesTypes),
          configurable: !0,
          enumerable: !0
        });
      }), Object.defineProperties(this.item, n);
    }
  }
  canDrag() {
    return !0;
  }
  beginDrag() {
    return this.item;
  }
  isDragging(t, n) {
    return n === t.getSourceId();
  }
  endDrag() {
  }
  constructor(t) {
    this.config = t, this.item = {}, this.initializeExposedProperties();
  }
}
const Bg = "__NATIVE_FILE__", Ig = "__NATIVE_URL__", BT = "__NATIVE_TEXT__", IT = "__NATIVE_HTML__", Ib = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FILE: Bg,
  HTML: IT,
  TEXT: BT,
  URL: Ig
}, Symbol.toStringTag, { value: "Module" }));
function C4(e, t, n) {
  return t.reduce(
    (i, o) => i || e.getData(o),
    ""
  ) ?? n;
}
const Pv = {
  [Bg]: {
    exposeProperties: {
      files: (e) => Array.prototype.slice.call(e.files),
      items: (e) => e.items,
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Files"
    ]
  },
  [IT]: {
    exposeProperties: {
      html: (e, t) => C4(e, t, ""),
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Html",
      "text/html"
    ]
  },
  [Ig]: {
    exposeProperties: {
      urls: (e, t) => C4(e, t, "").split(`
`),
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Url",
      "text/uri-list"
    ]
  },
  [BT]: {
    exposeProperties: {
      text: (e, t) => C4(e, t, ""),
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Text",
      "text/plain"
    ]
  }
};
function vW(e, t) {
  const n = Pv[e];
  if (!n)
    throw new Error(`native type ${e} has no configuration`);
  const r = new gW(n);
  return r.loadDataTransfer(t), r;
}
function k4(e) {
  if (!e)
    return null;
  const t = Array.prototype.slice.call(e.types || []);
  return Object.keys(Pv).filter((n) => {
    const r = Pv[n];
    return r != null && r.matchesTypes ? r.matchesTypes.some(
      (i) => t.indexOf(i) > -1
    ) : !1;
  })[0] || null;
}
const yW = MT(
  () => /firefox/i.test(navigator.userAgent)
), RT = MT(
  () => !!window.safari
);
class Rb {
  interpolate(t) {
    const { xs: n, ys: r, c1s: i, c2s: o, c3s: a } = this;
    let s = n.length - 1;
    if (t === n[s])
      return r[s];
    let l = 0, u = a.length - 1, d;
    for (; l <= u; ) {
      d = Math.floor(0.5 * (l + u));
      const m = n[d];
      if (m < t)
        l = d + 1;
      else if (m > t)
        u = d - 1;
      else
        return r[d];
    }
    s = Math.max(0, u);
    const p = t - n[s], f = p * p;
    return r[s] + i[s] * p + o[s] * f + a[s] * p * f;
  }
  constructor(t, n) {
    const { length: r } = t, i = [];
    for (let m = 0; m < r; m++)
      i.push(m);
    i.sort(
      (m, y) => t[m] < t[y] ? -1 : 1
    );
    const o = [], a = [];
    let s, l;
    for (let m = 0; m < r - 1; m++)
      s = t[m + 1] - t[m], l = n[m + 1] - n[m], o.push(s), a.push(l / s);
    const u = [
      a[0]
    ];
    for (let m = 0; m < o.length - 1; m++) {
      const y = a[m], g = a[m + 1];
      if (y * g <= 0)
        u.push(0);
      else {
        s = o[m];
        const x = o[m + 1], E = s + x;
        u.push(3 * E / ((E + x) / y + (E + s) / g));
      }
    }
    u.push(a[a.length - 1]);
    const d = [], p = [];
    let f;
    for (let m = 0; m < u.length - 1; m++) {
      f = a[m];
      const y = u[m], g = 1 / o[m], x = y + u[m + 1] - f - f;
      d.push((f - y - x) * g), p.push(x * g * g);
    }
    this.xs = t, this.ys = n, this.c1s = u, this.c2s = d, this.c3s = p;
  }
}
const xW = 1;
function PT(e) {
  const t = e.nodeType === xW ? e : e.parentElement;
  if (!t)
    return null;
  const { top: n, left: r } = t.getBoundingClientRect();
  return {
    x: r,
    y: n
  };
}
function Mh(e) {
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function bW(e) {
  var t;
  return e.nodeName === "IMG" && (yW() || !(!((t = document.documentElement) === null || t === void 0) && t.contains(e)));
}
function wW(e, t, n, r) {
  let i = e ? t.width : n, o = e ? t.height : r;
  return RT() && e && (o /= window.devicePixelRatio, i /= window.devicePixelRatio), {
    dragPreviewWidth: i,
    dragPreviewHeight: o
  };
}
function CW(e, t, n, r, i) {
  const o = bW(t), a = PT(o ? e : t), s = {
    x: n.x - a.x,
    y: n.y - a.y
  }, { offsetWidth: l, offsetHeight: u } = e, { anchorX: d, anchorY: p } = r, { dragPreviewWidth: f, dragPreviewHeight: m } = wW(o, t, l, u), y = () => {
    let T = new Rb([
      0,
      0.5,
      1
    ], [
      // Dock to the top
      s.y,
      // Align at the center
      s.y / u * m,
      // Dock to the bottom
      s.y + m - u
    ]).interpolate(p);
    return RT() && o && (T += (window.devicePixelRatio - 1) * m), T;
  }, g = () => new Rb([
    0,
    0.5,
    1
  ], [
    // Dock to the left
    s.x,
    // Align at the center
    s.x / l * f,
    // Dock to the right
    s.x + f - l
  ]).interpolate(d), { offsetX: x, offsetY: E } = i, b = x === 0 || x, C = E === 0 || E;
  return {
    x: b ? x : g(),
    y: C ? E : y()
  };
}
let kW = class {
  get window() {
    if (this.globalContext)
      return this.globalContext;
    if (typeof window < "u")
      return window;
  }
  get document() {
    var e;
    return !((e = this.globalContext) === null || e === void 0) && e.document ? this.globalContext.document : this.window ? this.window.document : void 0;
  }
  get rootElement() {
    var e;
    return ((e = this.optionsArgs) === null || e === void 0 ? void 0 : e.rootElement) || this.window;
  }
  constructor(e, t) {
    this.ownerDocument = null, this.globalContext = e, this.optionsArgs = t;
  }
};
function EW(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Pb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      EW(e, i, n[i]);
    });
  }
  return e;
}
class SW {
  /**
  * Generate profiling statistics for the HTML5Backend.
  */
  profile() {
    var t, n;
    return {
      sourcePreviewNodes: this.sourcePreviewNodes.size,
      sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
      sourceNodeOptions: this.sourceNodeOptions.size,
      sourceNodes: this.sourceNodes.size,
      dragStartSourceIds: ((t = this.dragStartSourceIds) === null || t === void 0 ? void 0 : t.length) || 0,
      dropTargetIds: this.dropTargetIds.length,
      dragEnterTargetIds: this.dragEnterTargetIds.length,
      dragOverTargetIds: ((n = this.dragOverTargetIds) === null || n === void 0 ? void 0 : n.length) || 0
    };
  }
  // public for test
  get window() {
    return this.options.window;
  }
  get document() {
    return this.options.document;
  }
  /**
  * Get the root element to use for event subscriptions
  */
  get rootElement() {
    return this.options.rootElement;
  }
  setup() {
    const t = this.rootElement;
    if (t !== void 0) {
      if (t.__isReactDndBackendSetUp)
        throw new Error("Cannot have two HTML5 backends at the same time.");
      t.__isReactDndBackendSetUp = !0, this.addEventListeners(t);
    }
  }
  teardown() {
    const t = this.rootElement;
    if (t !== void 0 && (t.__isReactDndBackendSetUp = !1, this.removeEventListeners(this.rootElement), this.clearCurrentDragSourceNode(), this.asyncEndDragFrameId)) {
      var n;
      (n = this.window) === null || n === void 0 || n.cancelAnimationFrame(this.asyncEndDragFrameId);
    }
  }
  connectDragPreview(t, n, r) {
    return this.sourcePreviewNodeOptions.set(t, r), this.sourcePreviewNodes.set(t, n), () => {
      this.sourcePreviewNodes.delete(t), this.sourcePreviewNodeOptions.delete(t);
    };
  }
  connectDragSource(t, n, r) {
    this.sourceNodes.set(t, n), this.sourceNodeOptions.set(t, r);
    const i = (a) => this.handleDragStart(a, t), o = (a) => this.handleSelectStart(a);
    return n.setAttribute("draggable", "true"), n.addEventListener("dragstart", i), n.addEventListener("selectstart", o), () => {
      this.sourceNodes.delete(t), this.sourceNodeOptions.delete(t), n.removeEventListener("dragstart", i), n.removeEventListener("selectstart", o), n.setAttribute("draggable", "false");
    };
  }
  connectDropTarget(t, n) {
    const r = (a) => this.handleDragEnter(a, t), i = (a) => this.handleDragOver(a, t), o = (a) => this.handleDrop(a, t);
    return n.addEventListener("dragenter", r), n.addEventListener("dragover", i), n.addEventListener("drop", o), () => {
      n.removeEventListener("dragenter", r), n.removeEventListener("dragover", i), n.removeEventListener("drop", o);
    };
  }
  addEventListeners(t) {
    t.addEventListener && (t.addEventListener("dragstart", this.handleTopDragStart), t.addEventListener("dragstart", this.handleTopDragStartCapture, !0), t.addEventListener("dragend", this.handleTopDragEndCapture, !0), t.addEventListener("dragenter", this.handleTopDragEnter), t.addEventListener("dragenter", this.handleTopDragEnterCapture, !0), t.addEventListener("dragleave", this.handleTopDragLeaveCapture, !0), t.addEventListener("dragover", this.handleTopDragOver), t.addEventListener("dragover", this.handleTopDragOverCapture, !0), t.addEventListener("drop", this.handleTopDrop), t.addEventListener("drop", this.handleTopDropCapture, !0));
  }
  removeEventListeners(t) {
    t.removeEventListener && (t.removeEventListener("dragstart", this.handleTopDragStart), t.removeEventListener("dragstart", this.handleTopDragStartCapture, !0), t.removeEventListener("dragend", this.handleTopDragEndCapture, !0), t.removeEventListener("dragenter", this.handleTopDragEnter), t.removeEventListener("dragenter", this.handleTopDragEnterCapture, !0), t.removeEventListener("dragleave", this.handleTopDragLeaveCapture, !0), t.removeEventListener("dragover", this.handleTopDragOver), t.removeEventListener("dragover", this.handleTopDragOverCapture, !0), t.removeEventListener("drop", this.handleTopDrop), t.removeEventListener("drop", this.handleTopDropCapture, !0));
  }
  getCurrentSourceNodeOptions() {
    const t = this.monitor.getSourceId(), n = this.sourceNodeOptions.get(t);
    return Pb({
      dropEffect: this.altKeyPressed ? "copy" : "move"
    }, n || {});
  }
  getCurrentDropEffect() {
    return this.isDraggingNativeItem() ? "copy" : this.getCurrentSourceNodeOptions().dropEffect;
  }
  getCurrentSourcePreviewNodeOptions() {
    const t = this.monitor.getSourceId(), n = this.sourcePreviewNodeOptions.get(t);
    return Pb({
      anchorX: 0.5,
      anchorY: 0.5,
      captureDraggingState: !1
    }, n || {});
  }
  isDraggingNativeItem() {
    const t = this.monitor.getItemType();
    return Object.keys(Ib).some(
      (n) => Ib[n] === t
    );
  }
  beginDragNativeItem(t, n) {
    this.clearCurrentDragSourceNode(), this.currentNativeSource = vW(t, n), this.currentNativeHandle = this.registry.addSource(t, this.currentNativeSource), this.actions.beginDrag([
      this.currentNativeHandle
    ]);
  }
  setCurrentDragSourceNode(t) {
    this.clearCurrentDragSourceNode(), this.currentDragSourceNode = t;
    const n = 1e3;
    this.mouseMoveTimeoutTimer = setTimeout(() => {
      var r;
      return (r = this.rootElement) === null || r === void 0 ? void 0 : r.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
    }, n);
  }
  clearCurrentDragSourceNode() {
    if (this.currentDragSourceNode) {
      if (this.currentDragSourceNode = null, this.rootElement) {
        var t;
        (t = this.window) === null || t === void 0 || t.clearTimeout(this.mouseMoveTimeoutTimer || void 0), this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
      }
      return this.mouseMoveTimeoutTimer = null, !0;
    }
    return !1;
  }
  handleDragStart(t, n) {
    t.defaultPrevented || (this.dragStartSourceIds || (this.dragStartSourceIds = []), this.dragStartSourceIds.unshift(n));
  }
  handleDragEnter(t, n) {
    this.dragEnterTargetIds.unshift(n);
  }
  handleDragOver(t, n) {
    this.dragOverTargetIds === null && (this.dragOverTargetIds = []), this.dragOverTargetIds.unshift(n);
  }
  handleDrop(t, n) {
    this.dropTargetIds.unshift(n);
  }
  constructor(t, n, r) {
    this.sourcePreviewNodes = /* @__PURE__ */ new Map(), this.sourcePreviewNodeOptions = /* @__PURE__ */ new Map(), this.sourceNodes = /* @__PURE__ */ new Map(), this.sourceNodeOptions = /* @__PURE__ */ new Map(), this.dragStartSourceIds = null, this.dropTargetIds = [], this.dragEnterTargetIds = [], this.currentNativeSource = null, this.currentNativeHandle = null, this.currentDragSourceNode = null, this.altKeyPressed = !1, this.mouseMoveTimeoutTimer = null, this.asyncEndDragFrameId = null, this.dragOverTargetIds = null, this.lastClientOffset = null, this.hoverRafId = null, this.getSourceClientOffset = (i) => {
      const o = this.sourceNodes.get(i);
      return o && PT(o) || null;
    }, this.endDragNativeItem = () => {
      this.isDraggingNativeItem() && (this.actions.endDrag(), this.currentNativeHandle && this.registry.removeSource(this.currentNativeHandle), this.currentNativeHandle = null, this.currentNativeSource = null);
    }, this.isNodeInDocument = (i) => !!(i && this.document && this.document.body && this.document.body.contains(i)), this.endDragIfSourceWasRemovedFromDOM = () => {
      const i = this.currentDragSourceNode;
      i == null || this.isNodeInDocument(i) || (this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover());
    }, this.scheduleHover = (i) => {
      this.hoverRafId === null && typeof requestAnimationFrame < "u" && (this.hoverRafId = requestAnimationFrame(() => {
        this.monitor.isDragging() && this.actions.hover(i || [], {
          clientOffset: this.lastClientOffset
        }), this.hoverRafId = null;
      }));
    }, this.cancelHover = () => {
      this.hoverRafId !== null && typeof cancelAnimationFrame < "u" && (cancelAnimationFrame(this.hoverRafId), this.hoverRafId = null);
    }, this.handleTopDragStartCapture = () => {
      this.clearCurrentDragSourceNode(), this.dragStartSourceIds = [];
    }, this.handleTopDragStart = (i) => {
      if (i.defaultPrevented)
        return;
      const { dragStartSourceIds: o } = this;
      this.dragStartSourceIds = null;
      const a = Mh(i);
      this.monitor.isDragging() && (this.actions.endDrag(), this.cancelHover()), this.actions.beginDrag(o || [], {
        publishSource: !1,
        getSourceClientOffset: this.getSourceClientOffset,
        clientOffset: a
      });
      const { dataTransfer: s } = i, l = k4(s);
      if (this.monitor.isDragging()) {
        if (s && typeof s.setDragImage == "function") {
          const d = this.monitor.getSourceId(), p = this.sourceNodes.get(d), f = this.sourcePreviewNodes.get(d) || p;
          if (f) {
            const { anchorX: m, anchorY: y, offsetX: g, offsetY: x } = this.getCurrentSourcePreviewNodeOptions(), E = CW(p, f, a, {
              anchorX: m,
              anchorY: y
            }, {
              offsetX: g,
              offsetY: x
            });
            s.setDragImage(f, E.x, E.y);
          }
        }
        try {
          s == null || s.setData("application/json", {});
        } catch {
        }
        this.setCurrentDragSourceNode(i.target);
        const { captureDraggingState: u } = this.getCurrentSourcePreviewNodeOptions();
        u ? this.actions.publishDragSource() : setTimeout(
          () => this.actions.publishDragSource(),
          0
        );
      } else if (l)
        this.beginDragNativeItem(l);
      else {
        if (s && !s.types && (i.target && !i.target.hasAttribute || !i.target.hasAttribute("draggable")))
          return;
        i.preventDefault();
      }
    }, this.handleTopDragEndCapture = () => {
      this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleTopDragEnterCapture = (i) => {
      if (this.dragEnterTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      }
      if (!this.enterLeaveCounter.enter(i.target) || this.monitor.isDragging())
        return;
      const { dataTransfer: a } = i, s = k4(a);
      s && this.beginDragNativeItem(s, a);
    }, this.handleTopDragEnter = (i) => {
      const { dragEnterTargetIds: o } = this;
      this.dragEnterTargetIds = [], this.monitor.isDragging() && (this.altKeyPressed = i.altKey, o.length > 0 && this.actions.hover(o, {
        clientOffset: Mh(i)
      }), o.some(
        (a) => this.monitor.canDropOnTarget(a)
      ) && (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = this.getCurrentDropEffect())));
    }, this.handleTopDragOverCapture = (i) => {
      if (this.dragOverTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      }
    }, this.handleTopDragOver = (i) => {
      const { dragOverTargetIds: o } = this;
      if (this.dragOverTargetIds = [], !this.monitor.isDragging()) {
        i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = "none");
        return;
      }
      this.altKeyPressed = i.altKey, this.lastClientOffset = Mh(i), this.scheduleHover(o), (o || []).some(
        (a) => this.monitor.canDropOnTarget(a)
      ) ? (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = this.getCurrentDropEffect())) : this.isDraggingNativeItem() ? i.preventDefault() : (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = "none"));
    }, this.handleTopDragLeaveCapture = (i) => {
      this.isDraggingNativeItem() && i.preventDefault(), this.enterLeaveCounter.leave(i.target) && (this.isDraggingNativeItem() && setTimeout(
        () => this.endDragNativeItem(),
        0
      ), this.cancelHover());
    }, this.handleTopDropCapture = (i) => {
      if (this.dropTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        i.preventDefault(), (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      } else k4(i.dataTransfer) && i.preventDefault();
      this.enterLeaveCounter.reset();
    }, this.handleTopDrop = (i) => {
      const { dropTargetIds: o } = this;
      this.dropTargetIds = [], this.actions.hover(o, {
        clientOffset: Mh(i)
      }), this.actions.drop({
        dropEffect: this.getCurrentDropEffect()
      }), this.isDraggingNativeItem() ? this.endDragNativeItem() : this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleSelectStart = (i) => {
      const o = i.target;
      typeof o.dragDrop == "function" && (o.tagName === "INPUT" || o.tagName === "SELECT" || o.tagName === "TEXTAREA" || o.isContentEditable || (i.preventDefault(), o.dragDrop()));
    }, this.options = new kW(n, r), this.actions = t.getActions(), this.monitor = t.getMonitor(), this.registry = t.getRegistry(), this.enterLeaveCounter = new mW(this.isNodeInDocument);
  }
}
const DW = function(e, t, n) {
  return new SW(e, t, n);
};
function Qt(e, t, ...n) {
  if (AW() && t === void 0)
    throw new Error("invariant requires an error message argument");
  if (!e) {
    let r;
    if (t === void 0)
      r = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      let i = 0;
      r = new Error(t.replace(/%s/g, function() {
        return n[i++];
      })), r.name = "Invariant Violation";
    }
    throw r.framesToPop = 1, r;
  }
}
function AW() {
  return typeof process < "u" && !0;
}
var au;
(function(e) {
  e.mouse = "mouse", e.touch = "touch", e.keyboard = "keyboard";
})(au || (au = {}));
class TW {
  get delay() {
    var t;
    return (t = this.args.delay) !== null && t !== void 0 ? t : 0;
  }
  get scrollAngleRanges() {
    return this.args.scrollAngleRanges;
  }
  get getDropTargetElementsAtPoint() {
    return this.args.getDropTargetElementsAtPoint;
  }
  get ignoreContextMenu() {
    var t;
    return (t = this.args.ignoreContextMenu) !== null && t !== void 0 ? t : !1;
  }
  get enableHoverOutsideTarget() {
    var t;
    return (t = this.args.enableHoverOutsideTarget) !== null && t !== void 0 ? t : !1;
  }
  get enableKeyboardEvents() {
    var t;
    return (t = this.args.enableKeyboardEvents) !== null && t !== void 0 ? t : !1;
  }
  get enableMouseEvents() {
    var t;
    return (t = this.args.enableMouseEvents) !== null && t !== void 0 ? t : !1;
  }
  get enableTouchEvents() {
    var t;
    return (t = this.args.enableTouchEvents) !== null && t !== void 0 ? t : !0;
  }
  get touchSlop() {
    return this.args.touchSlop || 0;
  }
  get delayTouchStart() {
    var t, n, r, i;
    return (i = (r = (t = this.args) === null || t === void 0 ? void 0 : t.delayTouchStart) !== null && r !== void 0 ? r : (n = this.args) === null || n === void 0 ? void 0 : n.delay) !== null && i !== void 0 ? i : 0;
  }
  get delayMouseStart() {
    var t, n, r, i;
    return (i = (r = (t = this.args) === null || t === void 0 ? void 0 : t.delayMouseStart) !== null && r !== void 0 ? r : (n = this.args) === null || n === void 0 ? void 0 : n.delay) !== null && i !== void 0 ? i : 0;
  }
  get window() {
    if (this.context && this.context.window)
      return this.context.window;
    if (typeof window < "u")
      return window;
  }
  get document() {
    var t;
    if (!((t = this.context) === null || t === void 0) && t.document)
      return this.context.document;
    if (this.window)
      return this.window.document;
  }
  get rootElement() {
    var t;
    return ((t = this.args) === null || t === void 0 ? void 0 : t.rootElement) || this.document;
  }
  constructor(t, n) {
    this.args = t, this.context = n;
  }
}
function jW(e, t, n, r) {
  return Math.sqrt(Math.pow(Math.abs(n - e), 2) + Math.pow(Math.abs(r - t), 2));
}
function NW(e, t, n, r, i) {
  if (!i)
    return !1;
  const o = Math.atan2(r - t, n - e) * 180 / Math.PI + 180;
  for (let a = 0; a < i.length; ++a) {
    const s = i[a];
    if (s && (s.start == null || o >= s.start) && (s.end == null || o <= s.end))
      return !0;
  }
  return !1;
}
const OW = {
  Left: 1,
  Right: 2,
  Center: 4
}, zW = {
  Left: 0,
  Center: 1,
  Right: 2
};
function E4(e) {
  return e.button === void 0 || e.button === zW.Left;
}
function FW(e) {
  return e.buttons === void 0 || (e.buttons & OW.Left) === 0;
}
function _T(e) {
  return !!e.targetTouches;
}
const LW = 1;
function MW(e) {
  const t = e.nodeType === LW ? e : e.parentElement;
  if (!t)
    return;
  const { top: n, left: r } = t.getBoundingClientRect();
  return {
    x: r,
    y: n
  };
}
function BW(e, t) {
  if (e.targetTouches.length === 1)
    return jm(e.targetTouches[0]);
  if (t && e.touches.length === 1 && e.touches[0].target === t.target)
    return jm(e.touches[0]);
}
function jm(e, t) {
  return _T(e) ? BW(e, t) : {
    x: e.clientX,
    y: e.clientY
  };
}
const _b = (() => {
  let e = !1;
  try {
    addEventListener("test", () => {
    }, Object.defineProperty({}, "passive", {
      get() {
        return e = !0, !0;
      }
    }));
  } catch {
  }
  return e;
})(), qd = {
  [au.mouse]: {
    start: "mousedown",
    move: "mousemove",
    end: "mouseup",
    contextmenu: "contextmenu"
  },
  [au.touch]: {
    start: "touchstart",
    move: "touchmove",
    end: "touchend"
  },
  [au.keyboard]: {
    keydown: "keydown"
  }
};
class xp {
  /**
  * Generate profiling statistics for the HTML5Backend.
  */
  profile() {
    var t;
    return {
      sourceNodes: this.sourceNodes.size,
      sourcePreviewNodes: this.sourcePreviewNodes.size,
      sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
      targetNodes: this.targetNodes.size,
      dragOverTargetIds: ((t = this.dragOverTargetIds) === null || t === void 0 ? void 0 : t.length) || 0
    };
  }
  // public for test
  get document() {
    return this.options.document;
  }
  setup() {
    const t = this.options.rootElement;
    t && (Qt(!xp.isSetUp, "Cannot have two Touch backends at the same time."), xp.isSetUp = !0, this.addEventListener(t, "start", this.getTopMoveStartHandler()), this.addEventListener(t, "start", this.handleTopMoveStartCapture, !0), this.addEventListener(t, "move", this.handleTopMove), this.addEventListener(t, "move", this.handleTopMoveCapture, !0), this.addEventListener(t, "end", this.handleTopMoveEndCapture, !0), this.options.enableMouseEvents && !this.options.ignoreContextMenu && this.addEventListener(t, "contextmenu", this.handleTopMoveEndCapture), this.options.enableKeyboardEvents && this.addEventListener(t, "keydown", this.handleCancelOnEscape, !0));
  }
  teardown() {
    const t = this.options.rootElement;
    t && (xp.isSetUp = !1, this._mouseClientOffset = {}, this.removeEventListener(t, "start", this.handleTopMoveStartCapture, !0), this.removeEventListener(t, "start", this.handleTopMoveStart), this.removeEventListener(t, "move", this.handleTopMoveCapture, !0), this.removeEventListener(t, "move", this.handleTopMove), this.removeEventListener(t, "end", this.handleTopMoveEndCapture, !0), this.options.enableMouseEvents && !this.options.ignoreContextMenu && this.removeEventListener(t, "contextmenu", this.handleTopMoveEndCapture), this.options.enableKeyboardEvents && this.removeEventListener(t, "keydown", this.handleCancelOnEscape, !0), this.uninstallSourceNodeRemovalObserver());
  }
  addEventListener(t, n, r, i = !1) {
    const o = _b ? {
      capture: i,
      passive: !1
    } : i;
    this.listenerTypes.forEach(function(a) {
      const s = qd[a][n];
      s && t.addEventListener(s, r, o);
    });
  }
  removeEventListener(t, n, r, i = !1) {
    const o = _b ? {
      capture: i,
      passive: !1
    } : i;
    this.listenerTypes.forEach(function(a) {
      const s = qd[a][n];
      s && t.removeEventListener(s, r, o);
    });
  }
  connectDragSource(t, n) {
    const r = this.handleMoveStart.bind(this, t);
    return this.sourceNodes.set(t, n), this.addEventListener(n, "start", r), () => {
      this.sourceNodes.delete(t), this.removeEventListener(n, "start", r);
    };
  }
  connectDragPreview(t, n, r) {
    return this.sourcePreviewNodeOptions.set(t, r), this.sourcePreviewNodes.set(t, n), () => {
      this.sourcePreviewNodes.delete(t), this.sourcePreviewNodeOptions.delete(t);
    };
  }
  connectDropTarget(t, n) {
    const r = this.options.rootElement;
    if (!this.document || !r)
      return () => {
      };
    const i = (o) => {
      if (!this.document || !r || !this.monitor.isDragging())
        return;
      let a;
      switch (o.type) {
        case qd.mouse.move:
          a = {
            x: o.clientX,
            y: o.clientY
          };
          break;
        case qd.touch.move:
          var s, l;
          a = {
            x: ((s = o.touches[0]) === null || s === void 0 ? void 0 : s.clientX) || 0,
            y: ((l = o.touches[0]) === null || l === void 0 ? void 0 : l.clientY) || 0
          };
          break;
      }
      const u = a != null ? this.document.elementFromPoint(a.x, a.y) : void 0, d = u && n.contains(u);
      if (u === n || d)
        return this.handleMove(o, t);
    };
    return this.addEventListener(this.document.body, "move", i), this.targetNodes.set(t, n), () => {
      this.document && (this.targetNodes.delete(t), this.removeEventListener(this.document.body, "move", i));
    };
  }
  getTopMoveStartHandler() {
    return !this.options.delayTouchStart && !this.options.delayMouseStart ? this.handleTopMoveStart : this.handleTopMoveStartDelay;
  }
  installSourceNodeRemovalObserver(t) {
    this.uninstallSourceNodeRemovalObserver(), this.draggedSourceNode = t, this.draggedSourceNodeRemovalObserver = new MutationObserver(() => {
      t && !t.parentElement && (this.resurrectSourceNode(), this.uninstallSourceNodeRemovalObserver());
    }), !(!t || !t.parentElement) && this.draggedSourceNodeRemovalObserver.observe(t.parentElement, {
      childList: !0
    });
  }
  resurrectSourceNode() {
    this.document && this.draggedSourceNode && (this.draggedSourceNode.style.display = "none", this.draggedSourceNode.removeAttribute("data-reactid"), this.document.body.appendChild(this.draggedSourceNode));
  }
  uninstallSourceNodeRemovalObserver() {
    this.draggedSourceNodeRemovalObserver && this.draggedSourceNodeRemovalObserver.disconnect(), this.draggedSourceNodeRemovalObserver = void 0, this.draggedSourceNode = void 0;
  }
  constructor(t, n, r) {
    this.getSourceClientOffset = (i) => {
      const o = this.sourceNodes.get(i);
      return o && MW(o);
    }, this.handleTopMoveStartCapture = (i) => {
      E4(i) && (this.moveStartSourceIds = []);
    }, this.handleMoveStart = (i) => {
      Array.isArray(this.moveStartSourceIds) && this.moveStartSourceIds.unshift(i);
    }, this.handleTopMoveStart = (i) => {
      if (!E4(i))
        return;
      const o = jm(i);
      o && (_T(i) && (this.lastTargetTouchFallback = i.targetTouches[0]), this._mouseClientOffset = o), this.waitingForDelay = !1;
    }, this.handleTopMoveStartDelay = (i) => {
      if (!E4(i))
        return;
      const o = i.type === qd.touch.start ? this.options.delayTouchStart : this.options.delayMouseStart;
      this.timeout = setTimeout(this.handleTopMoveStart.bind(this, i), o), this.waitingForDelay = !0;
    }, this.handleTopMoveCapture = () => {
      this.dragOverTargetIds = [];
    }, this.handleMove = (i, o) => {
      this.dragOverTargetIds && this.dragOverTargetIds.unshift(o);
    }, this.handleTopMove = (i) => {
      if (this.timeout && clearTimeout(this.timeout), !this.document || this.waitingForDelay)
        return;
      const { moveStartSourceIds: o, dragOverTargetIds: a } = this, s = this.options.enableHoverOutsideTarget, l = jm(i, this.lastTargetTouchFallback);
      if (!l)
        return;
      if (this._isScrolling || !this.monitor.isDragging() && NW(this._mouseClientOffset.x || 0, this._mouseClientOffset.y || 0, l.x, l.y, this.options.scrollAngleRanges)) {
        this._isScrolling = !0;
        return;
      }
      if (!this.monitor.isDragging() && // eslint-disable-next-line no-prototype-builtins
      this._mouseClientOffset.hasOwnProperty("x") && o && jW(this._mouseClientOffset.x || 0, this._mouseClientOffset.y || 0, l.x, l.y) > (this.options.touchSlop ? this.options.touchSlop : 0) && (this.moveStartSourceIds = void 0, this.actions.beginDrag(o, {
        clientOffset: this._mouseClientOffset,
        getSourceClientOffset: this.getSourceClientOffset,
        publishSource: !1
      })), !this.monitor.isDragging())
        return;
      const u = this.sourceNodes.get(this.monitor.getSourceId());
      this.installSourceNodeRemovalObserver(u), this.actions.publishDragSource(), i.cancelable && i.preventDefault();
      const d = (a || []).map(
        (y) => this.targetNodes.get(y)
      ).filter(
        (y) => !!y
      ), p = this.options.getDropTargetElementsAtPoint ? this.options.getDropTargetElementsAtPoint(l.x, l.y, d) : this.document.elementsFromPoint(l.x, l.y), f = [];
      for (const y in p) {
        if (!p.hasOwnProperty(y))
          continue;
        let g = p[y];
        for (g != null && f.push(g); g; )
          g = g.parentElement, g && f.indexOf(g) === -1 && f.push(g);
      }
      const m = f.filter(
        (y) => d.indexOf(y) > -1
      ).map(
        (y) => this._getDropTargetId(y)
      ).filter(
        (y) => !!y
      ).filter(
        (y, g, x) => x.indexOf(y) === g
      );
      if (s)
        for (const y in this.targetNodes) {
          const g = this.targetNodes.get(y);
          if (u && g && g.contains(u) && m.indexOf(y) === -1) {
            m.unshift(y);
            break;
          }
        }
      m.reverse(), this.actions.hover(m, {
        clientOffset: l
      });
    }, this._getDropTargetId = (i) => {
      const o = this.targetNodes.keys();
      let a = o.next();
      for (; a.done === !1; ) {
        const s = a.value;
        if (i === this.targetNodes.get(s))
          return s;
        a = o.next();
      }
    }, this.handleTopMoveEndCapture = (i) => {
      if (this._isScrolling = !1, this.lastTargetTouchFallback = void 0, !!FW(i)) {
        if (!this.monitor.isDragging() || this.monitor.didDrop()) {
          this.moveStartSourceIds = void 0;
          return;
        }
        i.cancelable && i.preventDefault(), this._mouseClientOffset = {}, this.uninstallSourceNodeRemovalObserver(), this.actions.drop(), this.actions.endDrag();
      }
    }, this.handleCancelOnEscape = (i) => {
      i.key === "Escape" && this.monitor.isDragging() && (this._mouseClientOffset = {}, this.uninstallSourceNodeRemovalObserver(), this.actions.endDrag());
    }, this.options = new TW(r, n), this.actions = t.getActions(), this.monitor = t.getMonitor(), this.sourceNodes = /* @__PURE__ */ new Map(), this.sourcePreviewNodes = /* @__PURE__ */ new Map(), this.sourcePreviewNodeOptions = /* @__PURE__ */ new Map(), this.targetNodes = /* @__PURE__ */ new Map(), this.listenerTypes = [], this._mouseClientOffset = {}, this._isScrolling = !1, this.options.enableMouseEvents && this.listenerTypes.push(au.mouse), this.options.enableTouchEvents && this.listenerTypes.push(au.touch), this.options.enableKeyboardEvents && this.listenerTypes.push(au.keyboard);
  }
}
const IW = function(e, t = {}, n = {}) {
  return new xp(e, t, n);
};
var qT = (e, t, n) => {
  if (!t.has(e)) throw TypeError("Cannot " + n);
}, qt = (e, t, n) => (qT(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Qo = (e, t, n) => {
  if (t.has(e)) throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, ec = (e, t, n, r) => (qT(e, t, "write to private field"), t.set(e, n), n), tc, RW = class {
  constructor() {
    Qo(this, tc, void 0), this.register = (e) => {
      qt(this, tc).push(e);
    }, this.unregister = (e) => {
      let t;
      for (; (t = qt(this, tc).indexOf(e)) !== -1; ) qt(this, tc).splice(t, 1);
    }, this.backendChanged = (e) => {
      for (let t of qt(this, tc)) t.backendChanged(e);
    }, ec(this, tc, []);
  }
};
tc = /* @__PURE__ */ new WeakMap();
var yo, ep, xo, Bs, Fl, _v, qv, $v, O1, z1, tp, $T = class F1 {
  constructor(t, n, r) {
    if (Qo(this, yo, void 0), Qo(this, ep, void 0), Qo(this, xo, void 0), Qo(this, Bs, void 0), Qo(this, Fl, void 0), Qo(this, _v, (i, o, a) => {
      if (!a.backend) throw new Error(`You must specify a 'backend' property in your Backend entry: ${JSON.stringify(a)}`);
      let s = a.backend(i, o, a.options), l = a.id, u = !a.id && s && s.constructor;
      if (u && (l = s.constructor.name), l) u && console.warn(`Deprecation notice: You are using a pipeline which doesn't include backends' 'id'.
        This might be unsupported in the future, please specify 'id' explicitely for every backend.`);
      else throw new Error(`You must specify an 'id' property in your Backend entry: ${JSON.stringify(a)}
        see this guide: https://github.com/louisbrunner/dnd-multi-backend/tree/master/packages/react-dnd-multi-backend#migrating-from-5xx`);
      if (qt(this, xo)[l]) throw new Error(`You must specify a unique 'id' property in your Backend entry:
        ${JSON.stringify(a)} (conflicts with: ${JSON.stringify(qt(this, xo)[l])})`);
      return { id: l, instance: s, preview: a.preview ?? !1, transition: a.transition, skipDispatchOnTransition: a.skipDispatchOnTransition ?? !1 };
    }), this.setup = () => {
      if (!(typeof window > "u")) {
        if (F1.isSetUp) throw new Error("Cannot have two MultiBackends at the same time.");
        F1.isSetUp = !0, qt(this, qv).call(this, window), qt(this, xo)[qt(this, yo)].instance.setup();
      }
    }, this.teardown = () => {
      typeof window > "u" || (F1.isSetUp = !1, qt(this, $v).call(this, window), qt(this, xo)[qt(this, yo)].instance.teardown());
    }, this.connectDragSource = (i, o, a) => qt(this, tp).call(this, "connectDragSource", i, o, a), this.connectDragPreview = (i, o, a) => qt(this, tp).call(this, "connectDragPreview", i, o, a), this.connectDropTarget = (i, o, a) => qt(this, tp).call(this, "connectDropTarget", i, o, a), this.profile = () => qt(this, xo)[qt(this, yo)].instance.profile(), this.previewEnabled = () => qt(this, xo)[qt(this, yo)].preview, this.previewsList = () => qt(this, ep), this.backendsList = () => qt(this, Bs), Qo(this, qv, (i) => {
      qt(this, Bs).forEach((o) => {
        o.transition && i.addEventListener(o.transition.event, qt(this, O1));
      });
    }), Qo(this, $v, (i) => {
      qt(this, Bs).forEach((o) => {
        o.transition && i.removeEventListener(o.transition.event, qt(this, O1));
      });
    }), Qo(this, O1, (i) => {
      var o;
      let a = qt(this, yo);
      if (qt(this, Bs).some((s) => s.id !== qt(this, yo) && s.transition && s.transition.check(i) ? (ec(this, yo, s.id), !0) : !1), qt(this, yo) !== a) {
        qt(this, xo)[a].instance.teardown(), Object.keys(qt(this, Fl)).forEach((d) => {
          let p = qt(this, Fl)[d];
          p.unsubscribe(), p.unsubscribe = qt(this, z1).call(this, p.func, ...p.args);
        }), qt(this, ep).backendChanged(this);
        let s = qt(this, xo)[qt(this, yo)];
        if (s.instance.setup(), s.skipDispatchOnTransition) return;
        let l = i.constructor, u = new l(i.type, i);
        (o = i.target) == null || o.dispatchEvent(u);
      }
    }), Qo(this, z1, (i, o, a, s) => qt(this, xo)[qt(this, yo)].instance[i](o, a, s)), Qo(this, tp, (i, o, a, s) => {
      let l = `${i}_${o}`, u = qt(this, z1).call(this, i, o, a, s);
      return qt(this, Fl)[l] = { func: i, args: [o, a, s], unsubscribe: u }, () => {
        qt(this, Fl)[l].unsubscribe(), delete qt(this, Fl)[l];
      };
    }), !r || !r.backends || r.backends.length < 1) throw new Error(`You must specify at least one Backend, if you are coming from 2.x.x (or don't understand this error)
        see this guide: https://github.com/louisbrunner/dnd-multi-backend/tree/master/packages/react-dnd-multi-backend#migrating-from-2xx`);
    ec(this, ep, new RW()), ec(this, xo, {}), ec(this, Bs, []), r.backends.forEach((i) => {
      let o = qt(this, _v).call(this, t, n, i);
      qt(this, xo)[o.id] = o, qt(this, Bs).push(o);
    }), ec(this, yo, qt(this, Bs)[0].id), ec(this, Fl, {});
  }
};
yo = /* @__PURE__ */ new WeakMap(), ep = /* @__PURE__ */ new WeakMap(), xo = /* @__PURE__ */ new WeakMap(), Bs = /* @__PURE__ */ new WeakMap(), Fl = /* @__PURE__ */ new WeakMap(), _v = /* @__PURE__ */ new WeakMap(), qv = /* @__PURE__ */ new WeakMap(), $v = /* @__PURE__ */ new WeakMap(), O1 = /* @__PURE__ */ new WeakMap(), z1 = /* @__PURE__ */ new WeakMap(), tp = /* @__PURE__ */ new WeakMap(), $T.isSetUp = !1;
var PW = $T, _W = (e, t, n) => new PW(e, t, n), HT = (e, t) => ({ event: e, check: t }), qW = HT("touchstart", (e) => {
  let t = e;
  return t.touches !== null && t.touches !== void 0;
}), $W = HT("pointerdown", (e) => e.pointerType == "mouse"), HW = { backends: [{ id: "html5", backend: DW, transition: $W }, { id: "touch", backend: IW, options: { enableMouseEvents: !0 }, preview: !0, transition: qW }] };
const VT = v.createContext({
  dragDropManager: void 0
});
function Jp(e) {
  "@babel/helpers - typeof";
  return Jp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Jp(e);
}
function VW(e, t) {
  if (Jp(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Jp(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function UW(e) {
  var t = VW(e, "string");
  return Jp(t) === "symbol" ? t : String(t);
}
function UT(e, t, n) {
  return t = UW(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Ko(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var qb = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), S4 = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, $b = {
  INIT: "@@redux/INIT" + S4(),
  REPLACE: "@@redux/REPLACE" + S4(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + S4();
  }
};
function WW(e) {
  if (typeof e != "object" || e === null) return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function WT(e, t, n) {
  var r;
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(Ko(0));
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(Ko(1));
    return n(WT)(e, t);
  }
  if (typeof e != "function")
    throw new Error(Ko(2));
  var i = e, o = t, a = [], s = a, l = !1;
  function u() {
    s === a && (s = a.slice());
  }
  function d() {
    if (l)
      throw new Error(Ko(3));
    return o;
  }
  function p(g) {
    if (typeof g != "function")
      throw new Error(Ko(4));
    if (l)
      throw new Error(Ko(5));
    var x = !0;
    return u(), s.push(g), function() {
      if (x) {
        if (l)
          throw new Error(Ko(6));
        x = !1, u();
        var E = s.indexOf(g);
        s.splice(E, 1), a = null;
      }
    };
  }
  function f(g) {
    if (!WW(g))
      throw new Error(Ko(7));
    if (typeof g.type > "u")
      throw new Error(Ko(8));
    if (l)
      throw new Error(Ko(9));
    try {
      l = !0, o = i(o, g);
    } finally {
      l = !1;
    }
    for (var x = a = s, E = 0; E < x.length; E++) {
      var b = x[E];
      b();
    }
    return g;
  }
  function m(g) {
    if (typeof g != "function")
      throw new Error(Ko(10));
    i = g, f({
      type: $b.REPLACE
    });
  }
  function y() {
    var g, x = p;
    return g = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(E) {
        if (typeof E != "object" || E === null)
          throw new Error(Ko(11));
        function b() {
          E.next && E.next(d());
        }
        b();
        var C = x(b);
        return {
          unsubscribe: C
        };
      }
    }, g[qb] = function() {
      return this;
    }, g;
  }
  return f({
    type: $b.INIT
  }), r = {
    dispatch: f,
    subscribe: p,
    getState: d,
    replaceReducer: m
  }, r[qb] = y, r;
}
function ZW(e, t, n) {
  return t.split(".").reduce(
    (r, i) => r && r[i] ? r[i] : n || null,
    e
  );
}
function GW(e, t) {
  return e.filter(
    (n) => n !== t
  );
}
function ZT(e) {
  return typeof e == "object";
}
function KW(e, t) {
  const n = /* @__PURE__ */ new Map(), r = (o) => {
    n.set(o, n.has(o) ? n.get(o) + 1 : 1);
  };
  e.forEach(r), t.forEach(r);
  const i = [];
  return n.forEach((o, a) => {
    o === 1 && i.push(a);
  }), i;
}
function XW(e, t) {
  return e.filter(
    (n) => t.indexOf(n) > -1
  );
}
const S7 = "dnd-core/INIT_COORDS", Rg = "dnd-core/BEGIN_DRAG", D7 = "dnd-core/PUBLISH_DRAG_SOURCE", Pg = "dnd-core/HOVER", _g = "dnd-core/DROP", qg = "dnd-core/END_DRAG";
function Hb(e, t) {
  return {
    type: S7,
    payload: {
      sourceClientOffset: t || null,
      clientOffset: e || null
    }
  };
}
const QW = {
  type: S7,
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};
function YW(e) {
  return function(t = [], n = {
    publishSource: !0
  }) {
    const { publishSource: r = !0, clientOffset: i, getSourceClientOffset: o } = n, a = e.getMonitor(), s = e.getRegistry();
    e.dispatch(Hb(i)), JW(t, a, s);
    const l = nZ(t, a);
    if (l == null) {
      e.dispatch(QW);
      return;
    }
    let u = null;
    if (i) {
      if (!o)
        throw new Error("getSourceClientOffset must be defined");
      eZ(o), u = o(l);
    }
    e.dispatch(Hb(i, u));
    const d = s.getSource(l).beginDrag(a, l);
    if (d == null)
      return;
    tZ(d), s.pinSource(l);
    const p = s.getSourceType(l);
    return {
      type: Rg,
      payload: {
        itemType: p,
        item: d,
        sourceId: l,
        clientOffset: i || null,
        sourceClientOffset: u || null,
        isSourcePublic: !!r
      }
    };
  };
}
function JW(e, t, n) {
  Qt(!t.isDragging(), "Cannot call beginDrag while dragging."), e.forEach(function(r) {
    Qt(n.getSource(r), "Expected sourceIds to be registered.");
  });
}
function eZ(e) {
  Qt(typeof e == "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function tZ(e) {
  Qt(ZT(e), "Item must be an object.");
}
function nZ(e, t) {
  let n = null;
  for (let r = e.length - 1; r >= 0; r--)
    if (t.canDragSource(e[r])) {
      n = e[r];
      break;
    }
  return n;
}
function rZ(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function iZ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      rZ(e, i, n[i]);
    });
  }
  return e;
}
function oZ(e) {
  return function(t = {}) {
    const n = e.getMonitor(), r = e.getRegistry();
    aZ(n), uZ(n).forEach((i, o) => {
      const a = sZ(i, o, r, n), s = {
        type: _g,
        payload: {
          dropResult: iZ({}, t, a)
        }
      };
      e.dispatch(s);
    });
  };
}
function aZ(e) {
  Qt(e.isDragging(), "Cannot call drop while not dragging."), Qt(!e.didDrop(), "Cannot call drop twice during one drag operation.");
}
function sZ(e, t, n, r) {
  const i = n.getTarget(e);
  let o = i ? i.drop(r, e) : void 0;
  return lZ(o), typeof o > "u" && (o = t === 0 ? {} : r.getDropResult()), o;
}
function lZ(e) {
  Qt(typeof e > "u" || ZT(e), "Drop result must either be an object or undefined.");
}
function uZ(e) {
  const t = e.getTargetIds().filter(e.canDropOnTarget, e);
  return t.reverse(), t;
}
function cZ(e) {
  return function() {
    const t = e.getMonitor(), n = e.getRegistry();
    dZ(t);
    const r = t.getSourceId();
    return r != null && (n.getSource(r, !0).endDrag(t, r), n.unpinSource()), {
      type: qg
    };
  };
}
function dZ(e) {
  Qt(e.isDragging(), "Cannot call endDrag while not dragging.");
}
function Hv(e, t) {
  return t === null ? e === null : Array.isArray(e) ? e.some(
    (n) => n === t
  ) : e === t;
}
function pZ(e) {
  return function(t, { clientOffset: n } = {}) {
    fZ(t);
    const r = t.slice(0), i = e.getMonitor(), o = e.getRegistry(), a = i.getItemType();
    return mZ(r, o, a), hZ(r, i, o), gZ(r, i, o), {
      type: Pg,
      payload: {
        targetIds: r,
        clientOffset: n || null
      }
    };
  };
}
function fZ(e) {
  Qt(Array.isArray(e), "Expected targetIds to be an array.");
}
function hZ(e, t, n) {
  Qt(t.isDragging(), "Cannot call hover while not dragging."), Qt(!t.didDrop(), "Cannot call hover after drop.");
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    Qt(e.lastIndexOf(i) === r, "Expected targetIds to be unique in the passed array.");
    const o = n.getTarget(i);
    Qt(o, "Expected targetIds to be registered.");
  }
}
function mZ(e, t, n) {
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r], o = t.getTargetType(i);
    Hv(o, n) || e.splice(r, 1);
  }
}
function gZ(e, t, n) {
  e.forEach(function(r) {
    n.getTarget(r).hover(t, r);
  });
}
function vZ(e) {
  return function() {
    if (e.getMonitor().isDragging())
      return {
        type: D7
      };
  };
}
function yZ(e) {
  return {
    beginDrag: YW(e),
    publishDragSource: vZ(e),
    hover: pZ(e),
    drop: oZ(e),
    endDrag: cZ(e)
  };
}
class xZ {
  receiveBackend(t) {
    this.backend = t;
  }
  getMonitor() {
    return this.monitor;
  }
  getBackend() {
    return this.backend;
  }
  getRegistry() {
    return this.monitor.registry;
  }
  getActions() {
    const t = this, { dispatch: n } = this.store;
    function r(o) {
      return (...a) => {
        const s = o.apply(t, a);
        typeof s < "u" && n(s);
      };
    }
    const i = yZ(this);
    return Object.keys(i).reduce((o, a) => {
      const s = i[a];
      return o[a] = r(s), o;
    }, {});
  }
  dispatch(t) {
    this.store.dispatch(t);
  }
  constructor(t, n) {
    this.isSetUp = !1, this.handleRefCountChange = () => {
      const r = this.store.getState().refCount > 0;
      this.backend && (r && !this.isSetUp ? (this.backend.setup(), this.isSetUp = !0) : !r && this.isSetUp && (this.backend.teardown(), this.isSetUp = !1));
    }, this.store = t, this.monitor = n, t.subscribe(this.handleRefCountChange);
  }
}
function bZ(e, t) {
  return {
    x: e.x + t.x,
    y: e.y + t.y
  };
}
function GT(e, t) {
  return {
    x: e.x - t.x,
    y: e.y - t.y
  };
}
function wZ(e) {
  const { clientOffset: t, initialClientOffset: n, initialSourceClientOffset: r } = e;
  return !t || !n || !r ? null : GT(bZ(t, r), n);
}
function CZ(e) {
  const { clientOffset: t, initialClientOffset: n } = e;
  return !t || !n ? null : GT(t, n);
}
const bp = [], A7 = [];
bp.__IS_NONE__ = !0;
A7.__IS_ALL__ = !0;
function kZ(e, t) {
  return e === bp ? !1 : e === A7 || typeof t > "u" ? !0 : XW(t, e).length > 0;
}
class EZ {
  subscribeToStateChange(t, n = {}) {
    const { handlerIds: r } = n;
    Qt(typeof t == "function", "listener must be a function."), Qt(typeof r > "u" || Array.isArray(r), "handlerIds, when specified, must be an array of strings.");
    let i = this.store.getState().stateId;
    const o = () => {
      const a = this.store.getState(), s = a.stateId;
      try {
        s === i || s === i + 1 && !kZ(a.dirtyHandlerIds, r) || t();
      } finally {
        i = s;
      }
    };
    return this.store.subscribe(o);
  }
  subscribeToOffsetChange(t) {
    Qt(typeof t == "function", "listener must be a function.");
    let n = this.store.getState().dragOffset;
    const r = () => {
      const i = this.store.getState().dragOffset;
      i !== n && (n = i, t());
    };
    return this.store.subscribe(r);
  }
  canDragSource(t) {
    if (!t)
      return !1;
    const n = this.registry.getSource(t);
    return Qt(n, `Expected to find a valid source. sourceId=${t}`), this.isDragging() ? !1 : n.canDrag(this, t);
  }
  canDropOnTarget(t) {
    if (!t)
      return !1;
    const n = this.registry.getTarget(t);
    if (Qt(n, `Expected to find a valid target. targetId=${t}`), !this.isDragging() || this.didDrop())
      return !1;
    const r = this.registry.getTargetType(t), i = this.getItemType();
    return Hv(r, i) && n.canDrop(this, t);
  }
  isDragging() {
    return !!this.getItemType();
  }
  isDraggingSource(t) {
    if (!t)
      return !1;
    const n = this.registry.getSource(t, !0);
    if (Qt(n, `Expected to find a valid source. sourceId=${t}`), !this.isDragging() || !this.isSourcePublic())
      return !1;
    const r = this.registry.getSourceType(t), i = this.getItemType();
    return r !== i ? !1 : n.isDragging(this, t);
  }
  isOverTarget(t, n = {
    shallow: !1
  }) {
    if (!t)
      return !1;
    const { shallow: r } = n;
    if (!this.isDragging())
      return !1;
    const i = this.registry.getTargetType(t), o = this.getItemType();
    if (o && !Hv(i, o))
      return !1;
    const a = this.getTargetIds();
    if (!a.length)
      return !1;
    const s = a.indexOf(t);
    return r ? s === a.length - 1 : s > -1;
  }
  getItemType() {
    return this.store.getState().dragOperation.itemType;
  }
  getItem() {
    return this.store.getState().dragOperation.item;
  }
  getSourceId() {
    return this.store.getState().dragOperation.sourceId;
  }
  getTargetIds() {
    return this.store.getState().dragOperation.targetIds;
  }
  getDropResult() {
    return this.store.getState().dragOperation.dropResult;
  }
  didDrop() {
    return this.store.getState().dragOperation.didDrop;
  }
  isSourcePublic() {
    return !!this.store.getState().dragOperation.isSourcePublic;
  }
  getInitialClientOffset() {
    return this.store.getState().dragOffset.initialClientOffset;
  }
  getInitialSourceClientOffset() {
    return this.store.getState().dragOffset.initialSourceClientOffset;
  }
  getClientOffset() {
    return this.store.getState().dragOffset.clientOffset;
  }
  getSourceClientOffset() {
    return wZ(this.store.getState().dragOffset);
  }
  getDifferenceFromInitialOffset() {
    return CZ(this.store.getState().dragOffset);
  }
  constructor(t, n) {
    this.store = t, this.registry = n;
  }
}
var Vb = {};
const Ub = typeof Vb < "u" ? Vb : self, KT = Ub.MutationObserver || Ub.WebKitMutationObserver;
function XT(e) {
  return function() {
    const t = setTimeout(r, 0), n = setInterval(r, 50);
    function r() {
      clearTimeout(t), clearInterval(n), e();
    }
  };
}
function SZ(e) {
  let t = 1;
  const n = new KT(e), r = document.createTextNode("");
  return n.observe(r, {
    characterData: !0
  }), function() {
    t = -t, r.data = t;
  };
}
const DZ = typeof KT == "function" ? (
  // reliably everywhere they are implemented.
  // They are implemented in all modern browsers.
  //
  // - Android 4-4.3
  // - Chrome 26-34
  // - Firefox 14-29
  // - Internet Explorer 11
  // - iPad Safari 6-7.1
  // - iPhone Safari 7-7.1
  // - Safari 6-7
  SZ
) : (
  // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
  // 11-12, and in web workers in many engines.
  // Although message channels yield to any queued rendering and IO tasks, they
  // would be better than imposing the 4ms delay of timers.
  // However, they do not work reliably in Internet Explorer or Safari.
  // Internet Explorer 10 is the only browser that has setImmediate but does
  // not have MutationObservers.
  // Although setImmediate yields to the browser's renderer, it would be
  // preferrable to falling back to setTimeout since it does not have
  // the minimum 4ms penalty.
  // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
  // Desktop to a lesser extent) that renders both setImmediate and
  // MessageChannel useless for the purposes of ASAP.
  // https://github.com/kriskowal/q/issues/396
  // Timers are implemented universally.
  // We fall back to timers in workers in most engines, and in foreground
  // contexts in the following browsers.
  // However, note that even this simple case requires nuances to operate in a
  // broad spectrum of browsers.
  //
  // - Firefox 3-13
  // - Internet Explorer 6-9
  // - iPad Safari 4.3
  // - Lynx 2.8.7
  XT
);
class AZ {
  // Use the fastest means possible to execute a task in its own turn, with
  // priority over other events including IO, animation, reflow, and redraw
  // events in browsers.
  //
  // An exception thrown by a task will permanently interrupt the processing of
  // subsequent tasks. The higher level `asap` function ensures that if an
  // exception is thrown by a task, that the task queue will continue flushing as
  // soon as possible, but if you use `rawAsap` directly, you are responsible to
  // either ensure that no exceptions are thrown from your task, or to manually
  // call `rawAsap.requestFlush` if an exception is thrown.
  enqueueTask(t) {
    const { queue: n, requestFlush: r } = this;
    n.length || (r(), this.flushing = !0), n[n.length] = t;
  }
  constructor() {
    this.queue = [], this.pendingErrors = [], this.flushing = !1, this.index = 0, this.capacity = 1024, this.flush = () => {
      const { queue: t } = this;
      for (; this.index < t.length; ) {
        const n = this.index;
        if (this.index++, t[n].call(), this.index > this.capacity) {
          for (let r = 0, i = t.length - this.index; r < i; r++)
            t[r] = t[r + this.index];
          t.length -= this.index, this.index = 0;
        }
      }
      t.length = 0, this.index = 0, this.flushing = !1;
    }, this.registerPendingError = (t) => {
      this.pendingErrors.push(t), this.requestErrorThrow();
    }, this.requestFlush = DZ(this.flush), this.requestErrorThrow = XT(() => {
      if (this.pendingErrors.length)
        throw this.pendingErrors.shift();
    });
  }
}
class TZ {
  call() {
    try {
      this.task && this.task();
    } catch (t) {
      this.onError(t);
    } finally {
      this.task = null, this.release(this);
    }
  }
  constructor(t, n) {
    this.onError = t, this.release = n, this.task = null;
  }
}
class jZ {
  create(t) {
    const n = this.freeTasks, r = n.length ? n.pop() : new TZ(
      this.onError,
      (i) => n[n.length] = i
    );
    return r.task = t, r;
  }
  constructor(t) {
    this.onError = t, this.freeTasks = [];
  }
}
const QT = new AZ(), NZ = new jZ(QT.registerPendingError);
function OZ(e) {
  QT.enqueueTask(NZ.create(e));
}
const T7 = "dnd-core/ADD_SOURCE", j7 = "dnd-core/ADD_TARGET", N7 = "dnd-core/REMOVE_SOURCE", $g = "dnd-core/REMOVE_TARGET";
function zZ(e) {
  return {
    type: T7,
    payload: {
      sourceId: e
    }
  };
}
function FZ(e) {
  return {
    type: j7,
    payload: {
      targetId: e
    }
  };
}
function LZ(e) {
  return {
    type: N7,
    payload: {
      sourceId: e
    }
  };
}
function MZ(e) {
  return {
    type: $g,
    payload: {
      targetId: e
    }
  };
}
function BZ(e) {
  Qt(typeof e.canDrag == "function", "Expected canDrag to be a function."), Qt(typeof e.beginDrag == "function", "Expected beginDrag to be a function."), Qt(typeof e.endDrag == "function", "Expected endDrag to be a function.");
}
function IZ(e) {
  Qt(typeof e.canDrop == "function", "Expected canDrop to be a function."), Qt(typeof e.hover == "function", "Expected hover to be a function."), Qt(typeof e.drop == "function", "Expected beginDrag to be a function.");
}
function Vv(e, t) {
  if (t && Array.isArray(e)) {
    e.forEach(
      (n) => Vv(n, !1)
    );
    return;
  }
  Qt(typeof e == "string" || typeof e == "symbol", t ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}
var ta;
(function(e) {
  e.SOURCE = "SOURCE", e.TARGET = "TARGET";
})(ta || (ta = {}));
let RZ = 0;
function PZ() {
  return RZ++;
}
function _Z(e) {
  const t = PZ().toString();
  switch (e) {
    case ta.SOURCE:
      return `S${t}`;
    case ta.TARGET:
      return `T${t}`;
    default:
      throw new Error(`Unknown Handler Role: ${e}`);
  }
}
function Wb(e) {
  switch (e[0]) {
    case "S":
      return ta.SOURCE;
    case "T":
      return ta.TARGET;
    default:
      throw new Error(`Cannot parse handler ID: ${e}`);
  }
}
function Zb(e, t) {
  const n = e.entries();
  let r = !1;
  do {
    const { done: i, value: [, o] } = n.next();
    if (o === t)
      return !0;
    r = !!i;
  } while (!r);
  return !1;
}
class qZ {
  addSource(t, n) {
    Vv(t), BZ(n);
    const r = this.addHandler(ta.SOURCE, t, n);
    return this.store.dispatch(zZ(r)), r;
  }
  addTarget(t, n) {
    Vv(t, !0), IZ(n);
    const r = this.addHandler(ta.TARGET, t, n);
    return this.store.dispatch(FZ(r)), r;
  }
  containsHandler(t) {
    return Zb(this.dragSources, t) || Zb(this.dropTargets, t);
  }
  getSource(t, n = !1) {
    return Qt(this.isSourceId(t), "Expected a valid source ID."), n && t === this.pinnedSourceId ? this.pinnedSource : this.dragSources.get(t);
  }
  getTarget(t) {
    return Qt(this.isTargetId(t), "Expected a valid target ID."), this.dropTargets.get(t);
  }
  getSourceType(t) {
    return Qt(this.isSourceId(t), "Expected a valid source ID."), this.types.get(t);
  }
  getTargetType(t) {
    return Qt(this.isTargetId(t), "Expected a valid target ID."), this.types.get(t);
  }
  isSourceId(t) {
    return Wb(t) === ta.SOURCE;
  }
  isTargetId(t) {
    return Wb(t) === ta.TARGET;
  }
  removeSource(t) {
    Qt(this.getSource(t), "Expected an existing source."), this.store.dispatch(LZ(t)), OZ(() => {
      this.dragSources.delete(t), this.types.delete(t);
    });
  }
  removeTarget(t) {
    Qt(this.getTarget(t), "Expected an existing target."), this.store.dispatch(MZ(t)), this.dropTargets.delete(t), this.types.delete(t);
  }
  pinSource(t) {
    const n = this.getSource(t);
    Qt(n, "Expected an existing source."), this.pinnedSourceId = t, this.pinnedSource = n;
  }
  unpinSource() {
    Qt(this.pinnedSource, "No source is pinned at the time."), this.pinnedSourceId = null, this.pinnedSource = null;
  }
  addHandler(t, n, r) {
    const i = _Z(t);
    return this.types.set(i, n), t === ta.SOURCE ? this.dragSources.set(i, r) : t === ta.TARGET && this.dropTargets.set(i, r), i;
  }
  constructor(t) {
    this.types = /* @__PURE__ */ new Map(), this.dragSources = /* @__PURE__ */ new Map(), this.dropTargets = /* @__PURE__ */ new Map(), this.pinnedSourceId = null, this.pinnedSource = null, this.store = t;
  }
}
const $Z = (e, t) => e === t;
function HZ(e, t) {
  return !e && !t ? !0 : !e || !t ? !1 : e.x === t.x && e.y === t.y;
}
function VZ(e, t, n = $Z) {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; ++r)
    if (!n(e[r], t[r]))
      return !1;
  return !0;
}
function UZ(e = bp, t) {
  switch (t.type) {
    case Pg:
      break;
    case T7:
    case j7:
    case $g:
    case N7:
      return bp;
    case Rg:
    case D7:
    case qg:
    case _g:
    default:
      return A7;
  }
  const { targetIds: n = [], prevTargetIds: r = [] } = t.payload, i = KW(n, r);
  if (!(i.length > 0 || !VZ(n, r)))
    return bp;
  const o = r[r.length - 1], a = n[n.length - 1];
  return o !== a && (o && i.push(o), a && i.push(a)), i;
}
function WZ(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function ZZ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      WZ(e, i, n[i]);
    });
  }
  return e;
}
const Gb = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};
function GZ(e = Gb, t) {
  const { payload: n } = t;
  switch (t.type) {
    case S7:
    case Rg:
      return {
        initialSourceClientOffset: n.sourceClientOffset,
        initialClientOffset: n.clientOffset,
        clientOffset: n.clientOffset
      };
    case Pg:
      return HZ(e.clientOffset, n.clientOffset) ? e : ZZ({}, e, {
        clientOffset: n.clientOffset
      });
    case qg:
    case _g:
      return Gb;
    default:
      return e;
  }
}
function KZ(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Qc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      KZ(e, i, n[i]);
    });
  }
  return e;
}
const XZ = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: !1,
  isSourcePublic: null
};
function QZ(e = XZ, t) {
  const { payload: n } = t;
  switch (t.type) {
    case Rg:
      return Qc({}, e, {
        itemType: n.itemType,
        item: n.item,
        sourceId: n.sourceId,
        isSourcePublic: n.isSourcePublic,
        dropResult: null,
        didDrop: !1
      });
    case D7:
      return Qc({}, e, {
        isSourcePublic: !0
      });
    case Pg:
      return Qc({}, e, {
        targetIds: n.targetIds
      });
    case $g:
      return e.targetIds.indexOf(n.targetId) === -1 ? e : Qc({}, e, {
        targetIds: GW(e.targetIds, n.targetId)
      });
    case _g:
      return Qc({}, e, {
        dropResult: n.dropResult,
        didDrop: !0,
        targetIds: []
      });
    case qg:
      return Qc({}, e, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: !1,
        isSourcePublic: null,
        targetIds: []
      });
    default:
      return e;
  }
}
function YZ(e = 0, t) {
  switch (t.type) {
    case T7:
    case j7:
      return e + 1;
    case N7:
    case $g:
      return e - 1;
    default:
      return e;
  }
}
function JZ(e = 0) {
  return e + 1;
}
function eG(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function tG(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      eG(e, i, n[i]);
    });
  }
  return e;
}
function nG(e = {}, t) {
  return {
    dirtyHandlerIds: UZ(e.dirtyHandlerIds, {
      type: t.type,
      payload: tG({}, t.payload, {
        prevTargetIds: ZW(e, "dragOperation.targetIds", [])
      })
    }),
    dragOffset: GZ(e.dragOffset, t),
    refCount: YZ(e.refCount, t),
    dragOperation: QZ(e.dragOperation, t),
    stateId: JZ(e.stateId)
  };
}
function rG(e, t = void 0, n = {}, r = !1) {
  const i = iG(r), o = new EZ(i, new qZ(i)), a = new xZ(i, o), s = e(a, t, n);
  return a.receiveBackend(s), a;
}
function iG(e) {
  const t = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION__;
  return WT(nG, e && t && t({
    name: "dnd-core",
    instanceId: "dnd-core"
  }));
}
var Kb = {};
function oG(e, t) {
  if (e == null) return {};
  var n = aG(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function aG(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
let Xb = 0;
const L1 = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var sG = /* @__PURE__ */ v.memo(function(e) {
  var { children: t } = e, n = oG(e, [
    "children"
  ]);
  const [r, i] = lG(n);
  return v.useEffect(() => {
    if (i) {
      const o = YT();
      return ++Xb, () => {
        --Xb === 0 && (o[L1] = null);
      };
    }
  }, []), /* @__PURE__ */ c.jsx(VT.Provider, {
    value: r,
    children: t
  });
});
function lG(e) {
  if ("manager" in e)
    return [
      {
        dragDropManager: e.manager
      },
      !1
    ];
  const t = uG(e.backend, e.context, e.options, e.debugMode), n = !e.context;
  return [
    t,
    n
  ];
}
function uG(e, t = YT(), n, r) {
  const i = t;
  return i[L1] || (i[L1] = {
    dragDropManager: rG(e, t, n, r)
  }), i[L1];
}
function YT() {
  return typeof Kb < "u" ? Kb : window;
}
var cG = function e(t, n) {
  if (t === n) return !0;
  if (t && n && typeof t == "object" && typeof n == "object") {
    if (t.constructor !== n.constructor) return !1;
    var r, i, o;
    if (Array.isArray(t)) {
      if (r = t.length, r != n.length) return !1;
      for (i = r; i-- !== 0; )
        if (!e(t[i], n[i])) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
    if (o = Object.keys(t), r = o.length, r !== Object.keys(n).length) return !1;
    for (i = r; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, o[i])) return !1;
    for (i = r; i-- !== 0; ) {
      var a = o[i];
      if (!e(t[a], n[a])) return !1;
    }
    return !0;
  }
  return t !== t && n !== n;
};
const dG = /* @__PURE__ */ wi(cG), Ac = typeof window < "u" ? v.useLayoutEffect : v.useEffect;
function JT(e, t, n) {
  const [r, i] = v.useState(
    () => t(e)
  ), o = v.useCallback(() => {
    const a = t(e);
    dG(r, a) || (i(a), n && n());
  }, [
    r,
    e,
    n
  ]);
  return Ac(o), [
    r,
    o
  ];
}
function pG(e, t, n) {
  const [r, i] = JT(e, t, n);
  return Ac(function() {
    const o = e.getHandlerId();
    if (o != null)
      return e.subscribeToStateChange(i, {
        handlerIds: [
          o
        ]
      });
  }, [
    e,
    i
  ]), r;
}
function ej(e, t, n) {
  return pG(
    t,
    e || (() => ({})),
    () => n.reconnect()
  );
}
function tj(e, t) {
  const n = [
    ...t || []
  ];
  return t == null && typeof e != "function" && n.push(e), v.useMemo(() => typeof e == "function" ? e() : e, n);
}
function fG(e) {
  return v.useMemo(
    () => e.hooks.dragSource(),
    [
      e
    ]
  );
}
function hG(e) {
  return v.useMemo(
    () => e.hooks.dragPreview(),
    [
      e
    ]
  );
}
let D4 = !1, A4 = !1;
class mG {
  receiveHandlerId(t) {
    this.sourceId = t;
  }
  getHandlerId() {
    return this.sourceId;
  }
  canDrag() {
    Qt(!D4, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return D4 = !0, this.internalMonitor.canDragSource(this.sourceId);
    } finally {
      D4 = !1;
    }
  }
  isDragging() {
    if (!this.sourceId)
      return !1;
    Qt(!A4, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return A4 = !0, this.internalMonitor.isDraggingSource(this.sourceId);
    } finally {
      A4 = !1;
    }
  }
  subscribeToStateChange(t, n) {
    return this.internalMonitor.subscribeToStateChange(t, n);
  }
  isDraggingSource(t) {
    return this.internalMonitor.isDraggingSource(t);
  }
  isOverTarget(t, n) {
    return this.internalMonitor.isOverTarget(t, n);
  }
  getTargetIds() {
    return this.internalMonitor.getTargetIds();
  }
  isSourcePublic() {
    return this.internalMonitor.isSourcePublic();
  }
  getSourceId() {
    return this.internalMonitor.getSourceId();
  }
  subscribeToOffsetChange(t) {
    return this.internalMonitor.subscribeToOffsetChange(t);
  }
  canDragSource(t) {
    return this.internalMonitor.canDragSource(t);
  }
  canDropOnTarget(t) {
    return this.internalMonitor.canDropOnTarget(t);
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(t) {
    this.sourceId = null, this.internalMonitor = t.getMonitor();
  }
}
let T4 = !1;
class gG {
  receiveHandlerId(t) {
    this.targetId = t;
  }
  getHandlerId() {
    return this.targetId;
  }
  subscribeToStateChange(t, n) {
    return this.internalMonitor.subscribeToStateChange(t, n);
  }
  canDrop() {
    if (!this.targetId)
      return !1;
    Qt(!T4, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
    try {
      return T4 = !0, this.internalMonitor.canDropOnTarget(this.targetId);
    } finally {
      T4 = !1;
    }
  }
  isOver(t) {
    return this.targetId ? this.internalMonitor.isOverTarget(this.targetId, t) : !1;
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(t) {
    this.targetId = null, this.internalMonitor = t.getMonitor();
  }
}
function vG(e, t, n) {
  const r = n.getRegistry(), i = r.addTarget(e, t);
  return [
    i,
    () => r.removeTarget(i)
  ];
}
function yG(e, t, n) {
  const r = n.getRegistry(), i = r.addSource(e, t);
  return [
    i,
    () => r.removeSource(i)
  ];
}
function Uv(e, t, n, r) {
  let i;
  if (i !== void 0)
    return !!i;
  if (e === t)
    return !0;
  if (typeof e != "object" || !e || typeof t != "object" || !t)
    return !1;
  const o = Object.keys(e), a = Object.keys(t);
  if (o.length !== a.length)
    return !1;
  const s = Object.prototype.hasOwnProperty.bind(t);
  for (let l = 0; l < o.length; l++) {
    const u = o[l];
    if (!s(u))
      return !1;
    const d = e[u], p = t[u];
    if (i = void 0, i === !1 || i === void 0 && d !== p)
      return !1;
  }
  return !0;
}
function Wv(e) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    e !== null && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current")
  );
}
function xG(e) {
  if (typeof e.type == "string")
    return;
  const t = e.type.displayName || e.type.name || "the component";
  throw new Error(`Only native element nodes can now be passed to React DnD connectors.You can either wrap ${t} into a <div>, or turn it into a drag source or a drop target itself.`);
}
function bG(e) {
  return (t = null, n = null) => {
    if (!v.isValidElement(t)) {
      const i = t;
      return e(i, n), i;
    }
    const r = t;
    return xG(r), wG(r, n ? (i) => e(i, n) : e);
  };
}
function nj(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    const r = e[n];
    if (n.endsWith("Ref"))
      t[n] = e[n];
    else {
      const i = bG(r);
      t[n] = () => i;
    }
  }), t;
}
function Qb(e, t) {
  typeof e == "function" ? e(t) : e.current = t;
}
function wG(e, t) {
  const n = e.ref;
  return Qt(typeof n != "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs"), n ? v.cloneElement(e, {
    ref: (r) => {
      Qb(n, r), Qb(t, r);
    }
  }) : v.cloneElement(e, {
    ref: t
  });
}
class CG {
  receiveHandlerId(t) {
    this.handlerId !== t && (this.handlerId = t, this.reconnect());
  }
  get connectTarget() {
    return this.dragSource;
  }
  get dragSourceOptions() {
    return this.dragSourceOptionsInternal;
  }
  set dragSourceOptions(t) {
    this.dragSourceOptionsInternal = t;
  }
  get dragPreviewOptions() {
    return this.dragPreviewOptionsInternal;
  }
  set dragPreviewOptions(t) {
    this.dragPreviewOptionsInternal = t;
  }
  reconnect() {
    const t = this.reconnectDragSource();
    this.reconnectDragPreview(t);
  }
  reconnectDragSource() {
    const t = this.dragSource, n = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
    return n && this.disconnectDragSource(), this.handlerId ? t ? (n && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragSource = t, this.lastConnectedDragSourceOptions = this.dragSourceOptions, this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, t, this.dragSourceOptions)), n) : (this.lastConnectedDragSource = t, n) : n;
  }
  reconnectDragPreview(t = !1) {
    const n = this.dragPreview, r = t || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
    if (r && this.disconnectDragPreview(), !!this.handlerId) {
      if (!n) {
        this.lastConnectedDragPreview = n;
        return;
      }
      r && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragPreview = n, this.lastConnectedDragPreviewOptions = this.dragPreviewOptions, this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, n, this.dragPreviewOptions));
    }
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didConnectedDragSourceChange() {
    return this.lastConnectedDragSource !== this.dragSource;
  }
  didConnectedDragPreviewChange() {
    return this.lastConnectedDragPreview !== this.dragPreview;
  }
  didDragSourceOptionsChange() {
    return !Uv(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
  }
  didDragPreviewOptionsChange() {
    return !Uv(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
  }
  disconnectDragSource() {
    this.dragSourceUnsubscribe && (this.dragSourceUnsubscribe(), this.dragSourceUnsubscribe = void 0);
  }
  disconnectDragPreview() {
    this.dragPreviewUnsubscribe && (this.dragPreviewUnsubscribe(), this.dragPreviewUnsubscribe = void 0, this.dragPreviewNode = null, this.dragPreviewRef = null);
  }
  get dragSource() {
    return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
  }
  get dragPreview() {
    return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
  }
  clearDragSource() {
    this.dragSourceNode = null, this.dragSourceRef = null;
  }
  clearDragPreview() {
    this.dragPreviewNode = null, this.dragPreviewRef = null;
  }
  constructor(t) {
    this.hooks = nj({
      dragSource: (n, r) => {
        this.clearDragSource(), this.dragSourceOptions = r || null, Wv(n) ? this.dragSourceRef = n : this.dragSourceNode = n, this.reconnectDragSource();
      },
      dragPreview: (n, r) => {
        this.clearDragPreview(), this.dragPreviewOptions = r || null, Wv(n) ? this.dragPreviewRef = n : this.dragPreviewNode = n, this.reconnectDragPreview();
      }
    }), this.handlerId = null, this.dragSourceRef = null, this.dragSourceOptionsInternal = null, this.dragPreviewRef = null, this.dragPreviewOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDragSource = null, this.lastConnectedDragSourceOptions = null, this.lastConnectedDragPreview = null, this.lastConnectedDragPreviewOptions = null, this.backend = t;
  }
}
class kG {
  get connectTarget() {
    return this.dropTarget;
  }
  reconnect() {
    const t = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
    t && this.disconnectDropTarget();
    const n = this.dropTarget;
    if (this.handlerId) {
      if (!n) {
        this.lastConnectedDropTarget = n;
        return;
      }
      t && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDropTarget = n, this.lastConnectedDropTargetOptions = this.dropTargetOptions, this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, n, this.dropTargetOptions));
    }
  }
  receiveHandlerId(t) {
    t !== this.handlerId && (this.handlerId = t, this.reconnect());
  }
  get dropTargetOptions() {
    return this.dropTargetOptionsInternal;
  }
  set dropTargetOptions(t) {
    this.dropTargetOptionsInternal = t;
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didDropTargetChange() {
    return this.lastConnectedDropTarget !== this.dropTarget;
  }
  didOptionsChange() {
    return !Uv(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
  }
  disconnectDropTarget() {
    this.unsubscribeDropTarget && (this.unsubscribeDropTarget(), this.unsubscribeDropTarget = void 0);
  }
  get dropTarget() {
    return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
  }
  clearDropTarget() {
    this.dropTargetRef = null, this.dropTargetNode = null;
  }
  constructor(t) {
    this.hooks = nj({
      dropTarget: (n, r) => {
        this.clearDropTarget(), this.dropTargetOptions = r, Wv(n) ? this.dropTargetRef = n : this.dropTargetNode = n, this.reconnect();
      }
    }), this.handlerId = null, this.dropTargetRef = null, this.dropTargetOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDropTarget = null, this.lastConnectedDropTargetOptions = null, this.backend = t;
  }
}
function Bc() {
  const { dragDropManager: e } = v.useContext(VT);
  return Qt(e != null, "Expected drag drop context"), e;
}
function EG(e, t) {
  const n = Bc(), r = v.useMemo(
    () => new CG(n.getBackend()),
    [
      n
    ]
  );
  return Ac(() => (r.dragSourceOptions = e || null, r.reconnect(), () => r.disconnectDragSource()), [
    r,
    e
  ]), Ac(() => (r.dragPreviewOptions = t || null, r.reconnect(), () => r.disconnectDragPreview()), [
    r,
    t
  ]), r;
}
function SG() {
  const e = Bc();
  return v.useMemo(
    () => new mG(e),
    [
      e
    ]
  );
}
class DG {
  beginDrag() {
    const t = this.spec, n = this.monitor;
    let r = null;
    return typeof t.item == "object" ? r = t.item : typeof t.item == "function" ? r = t.item(n) : r = {}, r ?? null;
  }
  canDrag() {
    const t = this.spec, n = this.monitor;
    return typeof t.canDrag == "boolean" ? t.canDrag : typeof t.canDrag == "function" ? t.canDrag(n) : !0;
  }
  isDragging(t, n) {
    const r = this.spec, i = this.monitor, { isDragging: o } = r;
    return o ? o(i) : n === t.getSourceId();
  }
  endDrag() {
    const t = this.spec, n = this.monitor, r = this.connector, { end: i } = t;
    i && i(n.getItem(), n), r.reconnect();
  }
  constructor(t, n, r) {
    this.spec = t, this.monitor = n, this.connector = r;
  }
}
function AG(e, t, n) {
  const r = v.useMemo(
    () => new DG(e, t, n),
    [
      t,
      n
    ]
  );
  return v.useEffect(() => {
    r.spec = e;
  }, [
    e
  ]), r;
}
function TG(e) {
  return v.useMemo(() => {
    const t = e.type;
    return Qt(t != null, "spec.type must be defined"), t;
  }, [
    e
  ]);
}
function jG(e, t, n) {
  const r = Bc(), i = AG(e, t, n), o = TG(e);
  Ac(function() {
    if (o != null) {
      const [a, s] = yG(o, i, r);
      return t.receiveHandlerId(a), n.receiveHandlerId(a), s;
    }
  }, [
    r,
    t,
    n,
    i,
    o
  ]);
}
function Of(e, t) {
  const n = tj(e, t);
  Qt(!n.begin, "useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)");
  const r = SG(), i = EG(n.options, n.previewOptions);
  return jG(n, r, i), [
    ej(n.collect, r, i),
    fG(i),
    hG(i)
  ];
}
function NG(e) {
  const t = Bc().getMonitor(), [n, r] = JT(t, e);
  return v.useEffect(
    () => t.subscribeToOffsetChange(r)
  ), v.useEffect(
    () => t.subscribeToStateChange(r)
  ), n;
}
function OG(e) {
  return v.useMemo(
    () => e.hooks.dropTarget(),
    [
      e
    ]
  );
}
function zG(e) {
  const t = Bc(), n = v.useMemo(
    () => new kG(t.getBackend()),
    [
      t
    ]
  );
  return Ac(() => (n.dropTargetOptions = e || null, n.reconnect(), () => n.disconnectDropTarget()), [
    e
  ]), n;
}
function FG() {
  const e = Bc();
  return v.useMemo(
    () => new gG(e),
    [
      e
    ]
  );
}
function LG(e) {
  const { accept: t } = e;
  return v.useMemo(() => (Qt(e.accept != null, "accept must be defined"), Array.isArray(t) ? t : [
    t
  ]), [
    t
  ]);
}
class MG {
  canDrop() {
    const t = this.spec, n = this.monitor;
    return t.canDrop ? t.canDrop(n.getItem(), n) : !0;
  }
  hover() {
    const t = this.spec, n = this.monitor;
    t.hover && t.hover(n.getItem(), n);
  }
  drop() {
    const t = this.spec, n = this.monitor;
    if (t.drop)
      return t.drop(n.getItem(), n);
  }
  constructor(t, n) {
    this.spec = t, this.monitor = n;
  }
}
function BG(e, t) {
  const n = v.useMemo(
    () => new MG(e, t),
    [
      t
    ]
  );
  return v.useEffect(() => {
    n.spec = e;
  }, [
    e
  ]), n;
}
function IG(e, t, n) {
  const r = Bc(), i = BG(e, t), o = LG(e);
  Ac(function() {
    const [a, s] = vG(o, i, r);
    return t.receiveHandlerId(a), n.receiveHandlerId(a), s;
  }, [
    r,
    t,
    i,
    n,
    o.map(
      (a) => a.toString()
    ).join("|")
  ]);
}
function cd(e, t) {
  const n = tj(e, t), r = FG(), i = zG(n.options);
  return IG(n, r, i), [
    ej(n.collect, r, i),
    OG(i)
  ];
}
var RG = v.createContext(null), PG = ({ portal: e, ...t }) => {
  let [n, r] = v.useState(null);
  return dt.createElement(RG.Provider, { value: e ?? n }, dt.createElement(sG, { backend: _W, ...t }), e ? null : dt.createElement("div", { ref: r }));
};
function _G(e) {
  const t = v.useRef(null);
  v.useEffect(() => {
    t.current && e(t.current);
  }, [e]), v.useEffect(() => {
    const n = new Image();
    n.src = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==", n.onload = () => e(n);
  }, [e]);
}
const Hg = "blank-solution", rj = "cursor-grab rounded-full border border-brand bg-brand-50 px-2";
function ij(e) {
  const { draggableId: t, text: n, isAnswerCorrect: r } = e, i = v.useMemo(
    () => ({ draggableId: t, text: n }),
    [t, n]
  ), [, o, a] = Of({
    type: Hg,
    item: i
  });
  return _G(a), /* @__PURE__ */ c.jsx(
    "span",
    {
      className: Le(
        rj,
        r && "border-green-500",
        r === !1 && "border-red-500"
      ),
      ref: o,
      children: n
    }
  );
}
function qG() {
  const { itemType: e, isDragging: t, item: n, currentOffset: r } = NG(
    (a) => ({
      item: a.getItem(),
      itemType: a.getItemType(),
      initialOffset: a.getInitialSourceClientOffset(),
      currentOffset: a.getSourceClientOffset(),
      isDragging: a.isDragging()
    })
  );
  if (!t)
    return null;
  const i = r ? `translate(${r.x}px, ${r.y}px)` : "translate(-9999px, -9999px)";
  function o() {
    switch (e) {
      case Hg:
        return /* @__PURE__ */ c.jsx("div", { className: Le("rounded p-2 shadow", rj), children: n == null ? void 0 : n.text });
      default:
        return null;
    }
  }
  return /* @__PURE__ */ c.jsx("div", { className: "pointer-events-none fixed left-0 top-0 z-50 cursor-grab", children: /* @__PURE__ */ c.jsx("div", { style: { transform: i }, children: o() }) });
}
const O7 = ({ children: e }) => /* @__PURE__ */ c.jsxs(
  PG,
  {
    options: HW,
    context: typeof window > "u" ? void 0 : window,
    children: [
      /* @__PURE__ */ c.jsx(qG, {}),
      e
    ]
  }
), $G = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DndWrapper: O7
}, Symbol.toStringTag, { value: "Module" })), oj = {
  visualMath: {
    storageKey: "serlo-editor::visual-math",
    defaultValue: !0
  },
  intermediateTasksExperiment: {
    storageKey: "serlo-editor::intermediate-tasks",
    defaultValue: !1
  }
}, z7 = v.createContext({
  set: () => {
  },
  get: () => !1
});
function HG({
  children: e
}) {
  const [t, n] = v.useState(0);
  function r(i, o) {
    VG(i, o), n(t + 1);
  }
  return /* @__PURE__ */ c.jsx(z7.Provider, { value: { set: r, get: UG }, children: e });
}
function VG(e, t) {
  const { storageKey: n, defaultValue: r } = oj[e];
  r === t ? localStorage.removeItem(n) : localStorage.setItem(n, t ? "1" : "0");
}
function UG(e) {
  const { storageKey: t, defaultValue: n } = oj[e];
  if (typeof window > "u") return n;
  const r = localStorage.getItem(t);
  return r === null ? n : r === "1";
}
function WG({ children: e }) {
  const t = zn(), n = nt(), r = Un(), i = Ur(), o = yn(cA), a = yn(dA), s = v.useCallback(() => {
    i(Df());
  }, [i]), l = v.useCallback(() => {
    i(Xp());
  }, [i]), u = yn(Fv), d = v.useCallback(() => {
    const m = eA(t.getState());
    i(fA(m));
  }, [i, t]), p = v.useCallback(() => li(t.getState(), Ec), [t]), f = /* @__PURE__ */ c.jsx(sT, { id: Ec });
  return typeof e != "function" ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    e,
    f
  ] }) : e({
    element: f,
    i18n: {
      staticStrings: r,
      editStrings: n
    },
    history: {
      hasUndoActions: o,
      hasRedoActions: a,
      pendingChanges: u,
      dispatchUndo: s,
      dispatchRedo: l,
      dispatchPersistHistory: d
    },
    selectRootDocument: p
  });
}
function ZG(e) {
  const t = Ur();
  v.useEffect(() => {
    const n = document.body;
    function r(o) {
      const a = o.target;
      n.querySelector('[data-modal-state="open"]') === null && n.contains(a) && // clicked element is present in the document
      e.current && // provided wrapper is defined
      !e.current.contains(a) && // clicked element is not a child of the provided wrapper
      !a.closest(".serlo-modal") && t(Ji(null));
    }
    const i = document;
    return i.addEventListener("mousedown", r), () => {
      i.removeEventListener("mousedown", r);
    };
  }, [e, t]);
}
function GG({ children: e, onChange: t, ...n }) {
  const [r, i] = v.useState(!1), o = zn(), a = Ur(), s = v.useRef(null);
  return ZG(s), v.useEffect(() => {
    if (typeof t != "function") return;
    let l = Fv(o.getState());
    return o.subscribe(() => {
      const u = Fv(o.getState());
      u !== l && (t({
        changed: Yq(o.getState()),
        getDocument: () => li(o.getState(), Ec)
      }), l = u);
    });
  }, [t, o]), v.useEffect(() => {
    a(mA({ initialState: n.initialState })), i(!0);
  }, [n.initialState, a]), ua(
    ["ctrl+z, meta+z"],
    (l, u) => {
      u.shift || l.key === "y" || (l.preventDefault(), a(Df()));
    },
    {
      enableOnContentEditable: !0,
      enableOnFormTags: !0,
      scopes: ["global"]
    }
  ), ua(
    ["ctrl+y, meta+y"],
    (l) => {
      l.key !== "z" && (l.preventDefault(), a(Xp()));
    },
    {
      enableOnContentEditable: !0,
      enableOnFormTags: !0,
      scopes: ["global"]
    }
  ), ua(
    "ctrl+shift+z, meta+shift+z",
    (l) => {
      l.preventDefault(), a(Xp());
    },
    {
      enableOnContentEditable: !0,
      enableOnFormTags: !0,
      scopes: ["global"]
    }
  ), r ? /* @__PURE__ */ c.jsx("div", { className: "relative", ref: s, children: /* @__PURE__ */ c.jsx(HG, { children: /* @__PURE__ */ c.jsx(WG, { children: e }) }) }) : null;
}
const KG = v.createContext({});
function gl() {
  return v.useContext(KG).isSerlo ?? !1;
}
function XG(e) {
  var t, n;
  const r = gl(), [i, o] = v.useState(!1), a = NT(), s = i && a ? a : e.initialState, l = v.useMemo(() => eV(), []), u = ((t = window == null ? void 0 : window.location) == null ? void 0 : t.href) && ((n = window == null ? void 0 : window.location) == null ? void 0 : n.href.includes("___editor_preview"));
  return /* @__PURE__ */ c.jsx(E$, { store: l, children: /* @__PURE__ */ c.jsx(O7, { children: /* @__PURE__ */ c.jsxs(B_, { initiallyActiveScopes: ["global"], children: [
    r && !u ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx(YV, {}),
      /* @__PURE__ */ c.jsx(
        JV,
        {
          useStored: i,
          setUseStored: o
        }
      )
    ] }) : null,
    r ? null : /* @__PURE__ */ c.jsx(pW, {}),
    /* @__PURE__ */ c.jsx(
      "div",
      {
        className: Le(
          // editor-core resets styles
          "editor-core",
          "mb-24 text-lg leading-cozy",
          // some undocumented style hacks
          "[&_h1]:hyphens-auto",
          "[&_a[data-key]]:hyphens-auto",
          "[&_div[contenteditable]_.serlo-h3]:mt-0",
          "[&_select]:border-2",
          "[&_button>div>svg]:mx-1.5 [&_button>div>svg]:mb-1 [&_button>div>svg]:mt-2"
        ),
        "data-editor-version": ud(),
        children: /* @__PURE__ */ c.jsx(
          GG,
          {
            ...e,
            initialState: s,
            onChange: ({ changed: d, getDocument: p }) => {
              var f;
              (f = e.onChange) == null || f.call(e, { changed: d, getDocument: p }), !(!d || !r) && eU(p());
            }
          }
        )
      }
    )
  ] }) }) });
}
const zf = v.createContext({
  editorVariant: "unknown"
});
var tt = /* @__PURE__ */ ((e) => (e.code = "code", e.colors = "colors", e.headings = "headings", e.links = "links", e.lists = "lists", e.math = "math", e.paragraphs = "paragraphs", e.richTextBold = "richTextBold", e.richTextItalic = "richTextItalic", e.textBlank = "textBlank", e.separator = "separator", e))(tt || {});
const Yr = [];
for (let e = 0; e < 256; ++e)
  Yr.push((e + 256).toString(16).slice(1));
function QG(e, t = 0) {
  return (Yr[e[t + 0]] + Yr[e[t + 1]] + Yr[e[t + 2]] + Yr[e[t + 3]] + "-" + Yr[e[t + 4]] + Yr[e[t + 5]] + "-" + Yr[e[t + 6]] + Yr[e[t + 7]] + "-" + Yr[e[t + 8]] + Yr[e[t + 9]] + "-" + Yr[e[t + 10]] + Yr[e[t + 11]] + Yr[e[t + 12]] + Yr[e[t + 13]] + Yr[e[t + 14]] + Yr[e[t + 15]]).toLowerCase();
}
let j4;
const YG = new Uint8Array(16);
function JG() {
  if (!j4) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    j4 = crypto.getRandomValues.bind(crypto);
  }
  return j4(YG);
}
const eK = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Yb = { randomUUID: eK };
function fa(e, t, n) {
  if (Yb.randomUUID && !t && !e)
    return Yb.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || JG)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, QG(r);
}
function Vn(e) {
  const { plugin: t, initialState: n, config: r } = e;
  return {
    init(i, o) {
      return {
        id: i,
        render: function(a = {}) {
          const s = {
            ...a,
            config: i7(r || {}, a.config || {})
          };
          return /* @__PURE__ */ c.jsx(sT, { pluginProps: s, id: i }, i);
        },
        replace: (a, s) => {
          o((l, u) => (u.createDocument({ id: i, plugin: a, state: s }), i));
        }
      };
    },
    // eslint-disable-next-line @typescript-eslint/unbound-method
    createInitialState({ createDocument: i }) {
      const o = fa();
      return i({ id: o, plugin: t, state: n }), o;
    },
    // eslint-disable-next-line @typescript-eslint/unbound-method
    toStoreState(i, { createDocument: o }) {
      const a = (i == null ? void 0 : i.id) ?? fa();
      return o({ id: a, ...i }), a;
    },
    // eslint-disable-next-line @typescript-eslint/unbound-method
    toStaticState(i, { getStoreDocument: o, omitId: a }) {
      const s = o(i);
      if (s === null)
        throw new Error("No document with this id exists");
      return a ? { plugin: s.plugin, ...w_(["id"], s) } : Object.hasOwn(s, "id") ? s : { ...s, id: i };
    },
    getFocusableChildren(i) {
      return [{ id: i }];
    }
  };
}
function $a(e, t = 0) {
  return {
    init(r, i) {
      const o = r.map((s) => e.init(s.value, a(s.id)));
      return Object.assign(o, {
        set(s) {
          i((l, u) => {
            const d = rc((p) => p.value, l);
            return rc(
              n,
              s(
                d,
                (p) => (
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                  e.toStoreState(p, u)
                )
              )
            );
          });
        },
        insert(s, l) {
          i((u, d) => {
            const p = n(
              l ? e.toStoreState(l, d) : e.createInitialState(d)
            );
            return TD(
              s === void 0 ? u.length : s,
              p,
              u
            );
          });
        },
        remove(s) {
          i((l) => DD(s, 1, l));
        },
        move(s, l) {
          i((u) => b_(s, l, u));
        }
      });
      function a(s) {
        return (l, {
          executor: u,
          reverse: d
        } = {}) => {
          function p(m) {
            return (y) => {
              const g = y.findIndex((x) => x.id === s);
              return sb(
                g,
                { value: m(y[g].value), id: s },
                y
              );
            };
          }
          function f(m) {
            return (y, g) => {
              const x = y.findIndex((E) => E.id === s);
              return sb(
                x,
                { value: m(y[x].value, g), id: s },
                y
              );
            };
          }
          i(f(l), {
            executor: u ? (m, y) => {
              u(
                (g) => m(f(g)),
                (g) => y(f(g))
              );
            } : void 0,
            reverse: d ? p(d) : void 0
          });
        };
      }
    },
    createInitialState(r) {
      return k_(() => n(e.createInitialState(r)), t);
    },
    toStoreState(r, i) {
      return rc((o) => n(e.toStoreState(o, i)), r);
    },
    toStaticState(r, i) {
      return rc(({ value: o }) => e.toStaticState(o, i), r);
    },
    getFocusableChildren(r) {
      return AD(
        rc((i) => e.getFocusableChildren(i.value), r)
      );
    }
  };
  function n(r) {
    return {
      id: fa(),
      value: r
    };
  }
}
function Z0(e) {
  return Vg(e || !1);
}
function oa(e) {
  return Vg(e || 0);
}
function rn(e) {
  return Vg(e || "");
}
function Vg(e) {
  return aj(e, {
    toStoreState(t) {
      return t;
    },
    toStaticState(t) {
      return t;
    }
  });
}
function aj(e, t) {
  return {
    init(n, r) {
      class i {
        get value() {
          return n;
        }
        set value(a) {
          this.set(a);
        }
        set(a, s) {
          r(
            (l) => typeof a == "function" ? a(l) : a,
            {
              reverse: s
            }
          );
        }
      }
      return new i();
    },
    createInitialState() {
      return e;
    },
    getFocusableChildren() {
      return [];
    },
    ...t
  };
}
function tK(e, t) {
  function n(r) {
    return t(r);
  }
  return {
    init(r, i) {
      return {
        value: r,
        set(a, s) {
          i(
            (l) => typeof a == "function" ? a(l) : a,
            {
              executor: s ? (l, u) => {
                s && s(
                  o(l),
                  o(u)
                );
              } : void 0
            }
          );
        }
      };
      function o(a) {
        return (s) => a(typeof s == "function" ? s : () => s);
      }
    },
    createInitialState() {
      return e;
    },
    getFocusableChildren() {
      return [];
    },
    toStoreState(r) {
      return r;
    },
    toStaticState(r) {
      return n(r) ? e : r;
    }
  };
}
function ln(e) {
  const t = (n) => AD(i_(n));
  return {
    init(n, r) {
      return Oh((i, o) => {
        return i.init(n[o], a);
        function a(s, {
          executor: l,
          reverse: u
        } = {}) {
          function d(f) {
            return (m) => ub(lb(o), f(m[o]), m);
          }
          function p(f) {
            return (m, y) => ub(
              lb(o),
              f(m[o], y),
              m
            );
          }
          r(p(s), {
            executor: l ? (f, m) => {
              l(
                (y) => f(p(y)),
                (y) => m(p(y))
              );
            } : void 0,
            reverse: u ? d(u) : void 0
          });
        }
      }, e);
    },
    createInitialState(n) {
      return rc((r) => r.createInitialState(n), e);
    },
    toStoreState(n, r) {
      return Oh((i, o) => i.toStoreState(n[o], r), e);
    },
    toStaticState(n, r) {
      return Oh((i, o) => i.toStaticState(n[o], r), e);
    },
    // Allows to override the default order of focusable children
    getFocusableChildren(n) {
      const r = Oh((i, o) => i.getFocusableChildren(n[o]), e);
      return t(r);
    }
  };
}
function qr(e, t = !1) {
  return {
    init(n, r) {
      if (n.defined) {
        const a = e.init(n.value, i);
        return Object.assign(a, {
          defined: !0,
          remove() {
            r(() => ({
              defined: !1,
              value: null
            }));
          }
        });
      }
      return {
        defined: !1,
        create(a) {
          r((s, l) => ({
            defined: !0,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            value: a === void 0 ? e.createInitialState(l) : e.toStoreState(a, l)
          }));
        }
      };
      function i(a, {
        executor: s
      } = {}) {
        return r(o(a), {
          executor: typeof s == "function" ? (l, u) => {
            s(
              (d) => {
                l(o(d));
              },
              (d) => {
                u(o(d));
              }
            );
          } : void 0
        });
      }
      function o(a) {
        return (s, l) => s.defined ? {
          defined: !0,
          value: a(s.value, l)
        } : {
          defined: !0,
          value: a(e.createInitialState(l), l)
        };
      }
    },
    createInitialState(n) {
      return t ? {
        defined: !0,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        value: e.createInitialState(n)
      } : {
        defined: !1,
        value: null
      };
    },
    toStoreState(n, r) {
      return n === void 0 ? {
        defined: !1,
        value: null
      } : {
        defined: !0,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        value: e.toStoreState(n, r)
      };
    },
    toStaticState(n, r) {
      if (n.defined)
        return e.toStaticState(n.value, r);
    },
    getFocusableChildren(n) {
      return n.defined ? e.getFocusableChildren(n.value) : [];
    }
  };
}
function nK(e) {
  const t = tK(e, _a);
  return {
    ...t,
    init(...n) {
      const r = t.init(...n);
      return {
        ...r,
        set(i) {
          r.set(i);
        },
        isPending: _a(r.value) && !!r.value.pending,
        upload(i, o) {
          const a = o(i);
          return r.set(e, (s, l) => {
            a.then((u) => u).then((u) => {
              s(() => u);
            }).catch(() => {
              l(() => ({ uploadHandled: !0, failed: i }));
            });
          }), a;
        }
      };
    }
  };
}
function rK(e, t) {
  iK([e], t);
}
function iK(e, t) {
  const [n, r] = v.useState(0);
  v.useEffect(() => {
    if (n >= e.length) return;
    const i = e[n];
    _a(i.value) && i.value.pending && !i.value.uploadHandled && (i.set({ ...i.value, uploadHandled: !0 }), i.upload(i.value.pending, t).catch(o).then(o));
    function o() {
      r((a) => a + 1);
    }
  }, [e, t, n]);
}
function _a(e) {
  const t = e;
  return !!(t.pending || t.failed || t.loaded);
}
function fs({
  tooltipText: e,
  value: t,
  changeValue: n,
  options: r,
  dataQa: i
}) {
  return /* @__PURE__ */ c.jsxs("label", { className: "serlo-tooltip-trigger mx-1.5 text-sm", children: [
    /* @__PURE__ */ c.jsx(vn, { text: e }),
    /* @__PURE__ */ c.jsx(
      "select",
      {
        value: t,
        onChange: (o) => {
          n(o.target.value, o.target.selectedIndex);
        },
        className: Le(`
            bg-editor-primary-10 mr-2 max-w-[13rem] cursor-pointer rounded-md !border
            border-gray-500 bg-transparent px-1 py-0.25 text-sm transition-all
            hover:bg-editor-primary-200 focus:bg-editor-primary-200 focus:outline-none
            `),
        "data-qa": i,
        children: r.map(({ value: o, text: a, dataQa: s }) => /* @__PURE__ */ c.jsx("option", { value: o, "data-qa": s, children: a }, o))
      }
    )
  ] });
}
function wp(e, t) {
  return Object.hasOwn(e, t) ? e[t].title : t;
}
const Jb = {
  box: {
    video: "https://editor.serlo.dev/media/serlo-org/yn5sdmqw5r3lp8rw3oy65jaf/video.webm",
    shortExplanation: "Mithilfe der Box lassen sich Inhalt durch einen farblichen Rahmen und Icon besondere Bedeutung verleihen. Es existiert eine didaktische Vorauswahl an Box-Typen: Beispiel, Zitat, Vorgehen, Vorsicht, Merksatz, Beachte, Definition, Satz, Beweis."
  },
  multimedia: {
    shortExplanation: "Autor*innen können einen veranschaulichenden oder erklärenden Multimedia-Inhalt mit zugehöriger Erklärung einfügen. Das Einfügen unterschiedlicher Elemente in Multimedia ist möglich. Du kannst einen veranschaulichenden Multimedia-Inhalt mit zugehöriger Text-Erklärung erstellen. Unter den Einstellungen lässt sich die Art de Multimedia-Elements ändern."
  },
  highlight: {
    video: "https://editor.serlo.dev/media/serlo-org/ni0k03se4usq2u4yly0r283b/video.webm",
    shortExplanation: "Du kannst Code in diverse Programmiersprachen verfassen und ihn somit direkt zum Unterrichtsgegenstand machen."
  },
  equations: {
    video: "https://editor.serlo.dev/media/serlo-org/z87fdcl76gvtkdgny1o4qgyg/video.webm",
    shortExplanation: "Du kannst schnell einfache oder komplexe Term- und Gleichungsumformungen anfertigen und Erklärungen zu den einzelnen Schritten hinzufügen. Die Formeln lassen sich visuell oder mithilfe von LaTex erstellen."
  },
  geogebra: {
    video: "https://editor.serlo.dev/media/serlo-org/yxdeudhk6pbshmlqx70jga9s/video.webm",
    shortExplanation: "Applets von GeoGebra können via Link oder ID eingebunden werden und sorgen für mehr Interaktivität in der Erarbeitung des mathematischen Unterrichtsstoffes."
  },
  image: {
    video: "https://editor.serlo.dev/media/serlo-org/kcba2owimaun8y8pa739vtbf/video.webm",
    shortExplanation: "Bilder können via Upload, URL oder freie Anbieter wie Pixabay hinzugefügt werden. Du kannst Lizenz, Bildunterschrift und Alternativ-Text, sowie Autor*in angeben."
  },
  //   video:
  //     'https://editor.serlo.dev/media/serlo-org/g04q5hmoe0ujijuof9mr0226/video.webm',
  //   shortExplanation:
  //     'Single-Choice-Übungen bieten verschiedene Antwortmöglichkeiten, von denen nur eine richtig ist. Für jede Antwort können die Autoren den Lernenden individuelles Feedback geben, um beispielsweise Missverständnisse hinter häufigen Fehlern zu erklären.',
  // },
  spoiler: {
    video: "https://editor.serlo.dev/media/serlo-org/ljxl3wv6rld9bmkv5q82hew8/video.webm",
    shortExplanation: "Du kannst mit der ausklappbaren Box “Spoiler” Inhalte für den ersten Blick verstecken. Der Spoiler bietet sich z.B. für inhaltliche Exkurse an oder Lösungshinweise. Das Einfügen unterschiedlicher Elemente im Spoiler ist möglich."
  },
  serloTable: {
    video: "https://editor.serlo.dev/media/serlo-org/dhwzrf1uv8bwoxk7uzharu4e/video.webm",
    shortExplanation: "Du kannst individualisierte Tabellen erstellen. Sowohl Zeilen- als auch Spaltentitel können eingestellt werden. Es ist möglich, Text oder Bilder in die Zellen hinzuzufügen."
  },
  text: {
    video: "https://editor.serlo.dev/media/serlo-org/r05t81gsrezs068ylpvkz5n6/video.webm",
    shortExplanation: "Inline Text bearbeiten inklusive Schriftfarbe, Schriftstil, Überschriften, Verlinkungen, Listen, mathematische Formeln, Code-Umgebung"
  },
  video: {
    shortExplanation: "Mithilfe von Video-Einbettungen kann das Lernmaterial diverser gestalten werden. Du kannst Videos nicht direkt hochladen, sondern via Link ein (z.B. über YouTube, Vimeo, Wikimedia Commons o.ä.)"
  },
  injection: {
    shortExplanation: "Bereits existierende Inhalte von serlo.org können durch ihre ID eingebettet werden. So kannst du z.B. schon vorhandene Übungsaufgaben in deinem Inhalt nutzen. "
  },
  imageGallery: {
    shortExplanation: "In der Bilder-Galerie können mehrere Bilder organisiert dargestellt werden. Die Bilder können via Upload, URL oder durch Suche der frei lizenzierten Bilder hinzugefügt werden. Durch Drag & Drop kannst du die Reihenfolge der Bilder ändern."
  },
  inputExercise: {
    video: "https://editor.serlo.dev/media/serlo-org/kj9nmsca29c4kkxpnlj45jsd/video.webm",
    shortExplanation: "Aufgabe mit einem Eingabefeld, in das ein Wert oder eine Zeichenfolge eingegeben und validiert werden kann. Du kannst für bestimmte Antworten individuelles Feedback hinzufügen, um beispielsweise Missverständnisse hinter häufigen Fehlern zu erklären."
  },
  scMcExercise: {
    video: "https://editor.serlo.dev/media/serlo-org/cp82zbdfqgz37fxyoew3czbn/video.webm",
    shortExplanation: "Single- und Multiple-Choice-Übungen bieten verschiedene Antwortmöglichkeiten. Für jede Antwort kannst Du den Lernenden individuelles Feedback geben, um beispielsweise Missverständnisse hinter häufigen Fehlern zu erklären. Bei Single-Choice ist genau eine Antwort richtig. Bei Multiple-Choice können keine oder mehrere Antworten richtig sein."
  },
  dropzoneImage: {
    video: "https://editor.serlo.dev/media/serlo-org/klq5blr8tsjnoqz4bnqs1bgb/video.webm",
    shortExplanation: "Lernende können vorgegebene Antworten per Drag & Drop in Zonen eines Bildes oder leeren Inhalts ziehen und erhalten darauf Feedback. Du kannst zusätzliche falsche Antworten hinzufügen, um die Übung herausfordernder zu gestalten."
  },
  h5p: {
    shortExplanation: "Du kannst eine H5P-Aufgabe einbinden, die auf Lumi liegt. Gib dafür die URL oder ID des Inhalts in das Eingabefeld ein und klicke auf “Einfügen”. Folgende H5P-Aufgaben werden unterstützt: Drag and Drop, Fill in the Blanks, Drag the Words, Find the Hotspot, Image pairing, Bildauswahl (Image Choice), Hotspots in Bild suchen (mehrere) (Find Multiple Hotspots), Memory, Flashcards, Mark The Words"
  },
  blanksExercise: {
    video: "https://editor.serlo.dev/media/serlo-org/bn80f3bpl0vmixs1izpq3oc4/video.webm",
    shortExplanation: "Lückentext-Übungen ermöglichen es den Studierenden, eine eigene Antwort an vorgesehenen Stellen einzugeben. Lehrkräfte können selbst einstellen, welche Antworten akzeptiert werden. Lückentext-Aufgaben können so konfiguriert werden, dass Antworten per Drag & Drop durch die Schüler*innen ausgewählt werden. Autoren können der Liste zusätzliche falsche Antworten hinzufügen, um die Übung herausfordernder zu gestalten. Bei Lückentext-Aufgaben kann man einstellen, ob Lernende ihre Antworten an die vorgesehenen Stellen eintippen sollen, oder per Drag & Drop die Lücken füllen sollen. Du kannst wählen, ob die Lernenden Lücken in einem Text oder einer Tabelle füllen sollen."
  },
  textAreaExercise: {
    shortExplanation: "Freitext-Aufgaben bieten Lernenden die Möglichkeit, ausführliche Antworten in einem längeren Absatz zu verfassen."
  },
  interactiveVideo: {
    shortExplanation: "Beim interaktiven Video kannst du, an frei wählbaren Stellen interaktive Aufgaben direkt in das eingebettete Video einzubinden. Zur Auswahl stehen verschiedene Aufgabentypen wie Single-Choice, Multiple-Choice, Eingabefelder oder Lückentexte. Du kannst auch festlegen, ob die Aufgaben verpflichtend beantwortet werden müssen oder optional sind."
  }
}, N4 = "init static editor renderers first", hu = /* @__PURE__ */ function() {
  let e = null, t = null, n = null;
  function r({
    pluginRenderers: l,
    mathRenderer: u,
    linkRenderer: d
  }) {
    e || (e = l, t = u, n = d, Object.freeze(e), Object.freeze(t), Object.freeze(n));
  }
  function i() {
    if (!e) throw new Error(N4);
    return e;
  }
  function o(l) {
    var u;
    const d = i();
    return ((u = d.find((p) => p.type === l) ?? d.find((p) => p.type === "unsupported")) == null ? void 0 : u.renderer) ?? null;
  }
  function a() {
    if (!t) throw new Error(N4);
    return t;
  }
  function s() {
    if (!n) throw new Error(N4);
    return n;
  }
  return { init: r, getAll: i, getByType: o, getMathRenderer: a, getLinkRenderer: s };
}();
function Nn({
  document: e
}) {
  if (!e) return null;
  if (Array.isArray(e))
    return /* @__PURE__ */ c.jsx(c.Fragment, { children: e.map((n, r) => n ? /* @__PURE__ */ c.jsx(v.Fragment, { children: /* @__PURE__ */ c.jsx(Nn, { document: n }) }, n.id ?? `${n.plugin}${r}`) : null) });
  const t = hu.getByType(e.plugin);
  return t ? /* @__PURE__ */ c.jsx(t, { ...e }) : null;
}
const sj = {
  prefix: "far",
  iconName: "trash-can",
  icon: [448, 512, [61460, "trash-alt"], "f2ed", "M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm80 64l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
}, lj = {
  prefix: "far",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
}, uj = lj, F7 = {
  prefix: "far",
  iconName: "square",
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"]
}, Ug = {
  prefix: "far",
  iconName: "circle",
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
}, cj = {
  prefix: "far",
  iconName: "circle-question",
  icon: [512, 512, [62108, "question-circle"], "f059", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, dj = cj, oK = {
  prefix: "far",
  iconName: "clone",
  icon: [512, 512, [], "f24d", "M64 464l224 0c8.8 0 16-7.2 16-16l0-64 48 0 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l64 0 0 48-64 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zM224 304l224 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16L224 48c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zm-64-16l0-224c0-35.3 28.7-64 64-64L448 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64z"]
};
function Cp(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function aK(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function pj(...e) {
  return (t) => e.forEach((n) => aK(n, t));
}
function Wg(...e) {
  return v.useCallback(pj(...e), e);
}
function sK(e, t) {
  const n = v.createContext(t), r = (o) => {
    const { children: a, ...s } = o, l = v.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ c.jsx(n.Provider, { value: l, children: a });
  };
  r.displayName = e + "Provider";
  function i(o) {
    const a = v.useContext(n);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${o}\` must be used within \`${e}\``);
  }
  return [r, i];
}
function lK(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = v.createContext(a), l = n.length;
    n = [...n, a];
    const u = (p) => {
      var f;
      const { scope: m, children: y, ...g } = p, x = ((f = m == null ? void 0 : m[e]) == null ? void 0 : f[l]) || s, E = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ c.jsx(x.Provider, { value: E, children: y });
    };
    u.displayName = o + "Provider";
    function d(p, f) {
      var m;
      const y = ((m = f == null ? void 0 : f[e]) == null ? void 0 : m[l]) || s, g = v.useContext(y);
      if (g) return g;
      if (a !== void 0) return a;
      throw new Error(`\`${p}\` must be used within \`${o}\``);
    }
    return [u, d];
  }
  const i = () => {
    const o = n.map((a) => v.createContext(a));
    return function(a) {
      const s = (a == null ? void 0 : a[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: s } }),
        [a, s]
      );
    };
  };
  return i.scopeName = e, [r, uK(i, ...t)];
}
function uK(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(i) {
      const o = r.reduce((a, { useScope: s, scopeName: l }) => {
        const u = s(i)[`__scope${l}`];
        return { ...a, ...u };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var gr = globalThis != null && globalThis.document ? v.useLayoutEffect : () => {
}, cK = v.useId || (() => {
}), dK = 0;
function O4(e) {
  const [t, n] = v.useState(cK());
  return gr(() => {
    e || n((r) => r ?? String(dK++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function Nr(e) {
  const t = v.useRef(e);
  return v.useEffect(() => {
    t.current = e;
  }), v.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function pK({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, i] = fK({ defaultProp: t, onChange: n }), o = e !== void 0, a = o ? e : r, s = Nr(n), l = v.useCallback(
    (u) => {
      if (o) {
        const d = typeof u == "function" ? u(e) : u;
        d !== e && s(d);
      } else
        i(u);
    },
    [o, e, i, s]
  );
  return [a, l];
}
function fK({
  defaultProp: e,
  onChange: t
}) {
  const n = v.useState(e), [r] = n, i = v.useRef(r), o = Nr(t);
  return v.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [r, i, o]), n;
}
function z4(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function hK(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function fj(...e) {
  return (t) => e.forEach((n) => hK(n, t));
}
function hj(...e) {
  return v.useCallback(fj(...e), e);
}
var mj = v.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = v.Children.toArray(n), o = i.find(gK);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? v.Children.count(a) > 1 ? v.Children.only(null) : v.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ c.jsx(Zv, { ...r, ref: t, children: v.isValidElement(a) ? v.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ c.jsx(Zv, { ...r, ref: t, children: n });
});
mj.displayName = "Slot";
var Zv = v.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (v.isValidElement(n)) {
    const i = yK(n);
    return v.cloneElement(n, {
      ...vK(r, n.props),
      // @ts-ignore
      ref: t ? fj(t, i) : i
    });
  }
  return v.Children.count(n) > 1 ? v.Children.only(null) : null;
});
Zv.displayName = "SlotClone";
var mK = ({ children: e }) => /* @__PURE__ */ c.jsx(c.Fragment, { children: e });
function gK(e) {
  return v.isValidElement(e) && e.type === mK;
}
function vK(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...a) => {
      o(...a), i(...a);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function yK(e) {
  var t, n;
  let r = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, i = r && "isReactWarning" in r && r.isReactWarning;
  return i ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, i = r && "isReactWarning" in r && r.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var xK = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], gj = xK.reduce((e, t) => {
  const n = v.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? mj : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c.jsx(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function bK(e, t) {
  e && ms.flushSync(() => e.dispatchEvent(t));
}
function wK(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Nr(e);
  v.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var CK = "DismissableLayer", Gv = "dismissableLayer.update", kK = "dismissableLayer.pointerDownOutside", EK = "dismissableLayer.focusOutside", ew, vj = v.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Zg = v.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, u = v.useContext(vj), [d, p] = v.useState(null), f = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = v.useState({}), y = hj(t, (w) => p(w)), g = Array.from(u.layers), [x] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), E = g.indexOf(x), b = d ? g.indexOf(d) : -1, C = u.layersWithOutsidePointerEventsDisabled.size > 0, T = b >= E, z = AK((w) => {
      const M = w.target, R = [...u.branches].some((F) => F.contains(M));
      !T || R || (i == null || i(w), a == null || a(w), w.defaultPrevented || s == null || s());
    }, f), I = TK((w) => {
      const M = w.target;
      [...u.branches].some((R) => R.contains(M)) || (o == null || o(w), a == null || a(w), w.defaultPrevented || s == null || s());
    }, f);
    return wK((w) => {
      b === u.layers.size - 1 && (r == null || r(w), !w.defaultPrevented && s && (w.preventDefault(), s()));
    }, f), v.useEffect(() => {
      if (d)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (ew = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), tw(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = ew);
        };
    }, [d, f, n, u]), v.useEffect(() => () => {
      d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), tw());
    }, [d, u]), v.useEffect(() => {
      const w = () => m({});
      return document.addEventListener(Gv, w), () => document.removeEventListener(Gv, w);
    }, []), /* @__PURE__ */ c.jsx(
      gj.div,
      {
        ...l,
        ref: y,
        style: {
          pointerEvents: C ? T ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: z4(e.onFocusCapture, I.onFocusCapture),
        onBlurCapture: z4(e.onBlurCapture, I.onBlurCapture),
        onPointerDownCapture: z4(
          e.onPointerDownCapture,
          z.onPointerDownCapture
        )
      }
    );
  }
);
Zg.displayName = CK;
var SK = "DismissableLayerBranch", DK = v.forwardRef((e, t) => {
  const n = v.useContext(vj), r = v.useRef(null), i = hj(t, r);
  return v.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ c.jsx(gj.div, { ...e, ref: i });
});
DK.displayName = SK;
function AK(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Nr(e), r = v.useRef(!1), i = v.useRef(() => {
  });
  return v.useEffect(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          yj(
            kK,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = l, t.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function TK(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Nr(e), r = v.useRef(!1);
  return v.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && yj(EK, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function tw() {
  const e = new CustomEvent(Gv);
  document.dispatchEvent(e);
}
function yj(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? bK(i, o) : i.dispatchEvent(o);
}
function jK(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function xj(...e) {
  return (t) => e.forEach((n) => jK(n, t));
}
function NK(...e) {
  return v.useCallback(xj(...e), e);
}
var bj = v.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = v.Children.toArray(n), o = i.find(zK);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? v.Children.count(a) > 1 ? v.Children.only(null) : v.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ c.jsx(Kv, { ...r, ref: t, children: v.isValidElement(a) ? v.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ c.jsx(Kv, { ...r, ref: t, children: n });
});
bj.displayName = "Slot";
var Kv = v.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (v.isValidElement(n)) {
    const i = LK(n);
    return v.cloneElement(n, {
      ...FK(r, n.props),
      // @ts-ignore
      ref: t ? xj(t, i) : i
    });
  }
  return v.Children.count(n) > 1 ? v.Children.only(null) : null;
});
Kv.displayName = "SlotClone";
var OK = ({ children: e }) => /* @__PURE__ */ c.jsx(c.Fragment, { children: e });
function zK(e) {
  return v.isValidElement(e) && e.type === OK;
}
function FK(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...a) => {
      o(...a), i(...a);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function LK(e) {
  var t, n;
  let r = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, i = r && "isReactWarning" in r && r.isReactWarning;
  return i ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, i = r && "isReactWarning" in r && r.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var MK = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], BK = MK.reduce((e, t) => {
  const n = v.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? bj : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c.jsx(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), F4 = "focusScope.autoFocusOnMount", L4 = "focusScope.autoFocusOnUnmount", nw = { bubbles: !1, cancelable: !0 }, IK = "FocusScope", L7 = v.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o,
    ...a
  } = e, [s, l] = v.useState(null), u = Nr(i), d = Nr(o), p = v.useRef(null), f = NK(t, (g) => l(g)), m = v.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  v.useEffect(() => {
    if (r) {
      let g = function(C) {
        if (m.paused || !s) return;
        const T = C.target;
        s.contains(T) ? p.current = T : Ll(p.current, { select: !0 });
      }, x = function(C) {
        if (m.paused || !s) return;
        const T = C.relatedTarget;
        T !== null && (s.contains(T) || Ll(p.current, { select: !0 }));
      }, E = function(C) {
        if (document.activeElement === document.body)
          for (const T of C)
            T.removedNodes.length > 0 && Ll(s);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", x);
      const b = new MutationObserver(E);
      return s && b.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", x), b.disconnect();
      };
    }
  }, [r, s, m.paused]), v.useEffect(() => {
    if (s) {
      iw.add(m);
      const g = document.activeElement;
      if (!s.contains(g)) {
        const x = new CustomEvent(F4, nw);
        s.addEventListener(F4, u), s.dispatchEvent(x), x.defaultPrevented || (RK(HK(wj(s)), { select: !0 }), document.activeElement === g && Ll(s));
      }
      return () => {
        s.removeEventListener(F4, u), setTimeout(() => {
          const x = new CustomEvent(L4, nw);
          s.addEventListener(L4, d), s.dispatchEvent(x), x.defaultPrevented || Ll(g ?? document.body, { select: !0 }), s.removeEventListener(L4, d), iw.remove(m);
        }, 0);
      };
    }
  }, [s, u, d, m]);
  const y = v.useCallback(
    (g) => {
      if (!n && !r || m.paused) return;
      const x = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, E = document.activeElement;
      if (x && E) {
        const b = g.currentTarget, [C, T] = PK(b);
        C && T ? !g.shiftKey && E === T ? (g.preventDefault(), n && Ll(C, { select: !0 })) : g.shiftKey && E === C && (g.preventDefault(), n && Ll(T, { select: !0 })) : E === b && g.preventDefault();
      }
    },
    [n, r, m.paused]
  );
  return /* @__PURE__ */ c.jsx(BK.div, { tabIndex: -1, ...a, ref: f, onKeyDown: y });
});
L7.displayName = IK;
function RK(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Ll(r, { select: t }), document.activeElement !== n) return;
}
function PK(e) {
  const t = wj(e), n = rw(t, e), r = rw(t.reverse(), e);
  return [n, r];
}
function wj(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function rw(e, t) {
  for (const n of e)
    if (!_K(n, { upTo: t })) return n;
}
function _K(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function qK(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ll(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && qK(e) && t && e.select();
  }
}
var iw = $K();
function $K() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = ow(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = ow(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function ow(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function HK(e) {
  return e.filter((t) => t.tagName !== "A");
}
var M7 = v.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = v.Children.toArray(n), o = i.find(UK);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? v.Children.count(a) > 1 ? v.Children.only(null) : v.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ c.jsx(Xv, { ...r, ref: t, children: v.isValidElement(a) ? v.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ c.jsx(Xv, { ...r, ref: t, children: n });
});
M7.displayName = "Slot";
var Xv = v.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (v.isValidElement(n)) {
    const i = ZK(n);
    return v.cloneElement(n, {
      ...WK(r, n.props),
      // @ts-ignore
      ref: t ? pj(t, i) : i
    });
  }
  return v.Children.count(n) > 1 ? v.Children.only(null) : null;
});
Xv.displayName = "SlotClone";
var VK = ({ children: e }) => /* @__PURE__ */ c.jsx(c.Fragment, { children: e });
function UK(e) {
  return v.isValidElement(e) && e.type === VK;
}
function WK(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...a) => {
      o(...a), i(...a);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function ZK(e) {
  var t, n;
  let r = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, i = r && "isReactWarning" in r && r.isReactWarning;
  return i ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, i = r && "isReactWarning" in r && r.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var GK = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], dd = GK.reduce((e, t) => {
  const n = v.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? M7 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c.jsx(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), KK = "Portal", Cj = v.forwardRef((e, t) => {
  var n;
  const { container: r, ...i } = e, [o, a] = v.useState(!1);
  gr(() => a(!0), []);
  const s = r || o && ((n = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : n.body);
  return s ? Cf.createPortal(/* @__PURE__ */ c.jsx(dd.div, { ...i, ref: t }), s) : null;
});
Cj.displayName = KK;
function XK(e, t) {
  return v.useReducer((n, r) => t[n][r] ?? n, e);
}
var Gg = (e) => {
  const { present: t, children: n } = e, r = QK(t), i = typeof n == "function" ? n({ present: r.isPresent }) : v.Children.only(n), o = Wg(r.ref, YK(i));
  return typeof n == "function" || r.isPresent ? v.cloneElement(i, { ref: o }) : null;
};
Gg.displayName = "Presence";
function QK(e) {
  const [t, n] = v.useState(), r = v.useRef({}), i = v.useRef(e), o = v.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = XK(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return v.useEffect(() => {
    const u = Bh(r.current);
    o.current = s === "mounted" ? u : "none";
  }, [s]), gr(() => {
    const u = r.current, d = i.current;
    if (d !== e) {
      const p = o.current, f = Bh(u);
      e ? l("MOUNT") : f === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(d && p !== f ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, l]), gr(() => {
    if (t) {
      let u;
      const d = t.ownerDocument.defaultView ?? window, p = (m) => {
        const y = Bh(r.current).includes(m.animationName);
        if (m.target === t && y && (l("ANIMATION_END"), !i.current)) {
          const g = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = g);
          });
        }
      }, f = (m) => {
        m.target === t && (o.current = Bh(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", p), t.addEventListener("animationend", p), () => {
        d.clearTimeout(u), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", p), t.removeEventListener("animationend", p);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: v.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function Bh(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function YK(e) {
  var t, n;
  let r = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, i = r && "isReactWarning" in r && r.isReactWarning;
  return i ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, i = r && "isReactWarning" in r && r.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var M4 = 0;
function kj() {
  v.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? aw()), document.body.insertAdjacentElement("beforeend", e[1] ?? aw()), M4++, () => {
      M4 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), M4--;
    };
  }, []);
}
function aw() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var os = function() {
  return os = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, os.apply(this, arguments);
};
function Ej(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function JK(e, t, n) {
  for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var M1 = "right-scroll-bar-position", B1 = "width-before-scroll-bar", eX = "with-scroll-bars-hidden", tX = "--removed-body-scroll-bar-size";
function nX(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function rX(e, t) {
  var n = v.useState(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function iX(e, t) {
  return rX(null, function(n) {
    return e.forEach(function(r) {
      return nX(r, n);
    });
  });
}
function oX(e) {
  return e;
}
function aX(e, t) {
  t === void 0 && (t = oX);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(o) {
      var a = t(o, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(o);
      }
      n = {
        push: function(s) {
          return o(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(o), a = n;
      }
      var l = function() {
        var d = a;
        a = [], d.forEach(o);
      }, u = function() {
        return Promise.resolve().then(l);
      };
      u(), n = {
        push: function(d) {
          a.push(d), u();
        },
        filter: function(d) {
          return a = a.filter(d), n;
        }
      };
    }
  };
  return i;
}
function sX(e) {
  e === void 0 && (e = {});
  var t = aX(null);
  return t.options = os({ async: !0, ssr: !1 }, e), t;
}
var Sj = function(e) {
  var t = e.sideCar, n = Ej(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return v.createElement(r, os({}, n));
};
Sj.isSideCarExport = !0;
function lX(e, t) {
  return e.useMedium(t), Sj;
}
var Dj = sX(), B4 = function() {
}, Kg = v.forwardRef(function(e, t) {
  var n = v.useRef(null), r = v.useState({
    onScrollCapture: B4,
    onWheelCapture: B4,
    onTouchMoveCapture: B4
  }), i = r[0], o = r[1], a = e.forwardProps, s = e.children, l = e.className, u = e.removeScrollBar, d = e.enabled, p = e.shards, f = e.sideCar, m = e.noIsolation, y = e.inert, g = e.allowPinchZoom, x = e.as, E = x === void 0 ? "div" : x, b = e.gapMode, C = Ej(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), T = f, z = iX([n, t]), I = os(os({}, C), i);
  return v.createElement(
    v.Fragment,
    null,
    d && v.createElement(T, { sideCar: Dj, removeScrollBar: u, shards: p, noIsolation: m, inert: y, setCallbacks: o, allowPinchZoom: !!g, lockRef: n, gapMode: b }),
    a ? v.cloneElement(v.Children.only(s), os(os({}, I), { ref: z })) : v.createElement(E, os({}, I, { className: l, ref: z }), s)
  );
});
Kg.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Kg.classNames = {
  fullWidth: B1,
  zeroRight: M1
};
var uX = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function cX() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = uX();
  return t && e.setAttribute("nonce", t), e;
}
function dX(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function pX(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var fX = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = cX()) && (dX(t, n), pX(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, hX = function() {
  var e = fX();
  return function(t, n) {
    v.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Aj = function() {
  var e = hX(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, mX = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, I4 = function(e) {
  return parseInt(e || "", 10) || 0;
}, gX = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [I4(n), I4(r), I4(i)];
}, vX = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return mX;
  var t = gX(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, yX = Aj(), O0 = "data-scroll-locked", xX = function(e, t, n, r) {
  var i = e.left, o = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(eX, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(O0, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(M1, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(B1, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(M1, " .").concat(M1, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(B1, " .").concat(B1, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(O0, `] {
    `).concat(tX, ": ").concat(s, `px;
  }
`);
}, sw = function() {
  var e = parseInt(document.body.getAttribute(O0) || "0", 10);
  return isFinite(e) ? e : 0;
}, bX = function() {
  v.useEffect(function() {
    return document.body.setAttribute(O0, (sw() + 1).toString()), function() {
      var e = sw() - 1;
      e <= 0 ? document.body.removeAttribute(O0) : document.body.setAttribute(O0, e.toString());
    };
  }, []);
}, wX = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  bX();
  var o = v.useMemo(function() {
    return vX(i);
  }, [i]);
  return v.createElement(yX, { styles: xX(o, !t, i, n ? "" : "!important") });
}, Qv = !1;
if (typeof window < "u")
  try {
    var Ih = Object.defineProperty({}, "passive", {
      get: function() {
        return Qv = !0, !0;
      }
    });
    window.addEventListener("test", Ih, Ih), window.removeEventListener("test", Ih, Ih);
  } catch {
    Qv = !1;
  }
var Yc = Qv ? { passive: !1 } : !1, CX = function(e) {
  return e.tagName === "TEXTAREA";
}, Tj = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !CX(e) && n[t] === "visible")
  );
}, kX = function(e) {
  return Tj(e, "overflowY");
}, EX = function(e) {
  return Tj(e, "overflowX");
}, lw = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = jj(e, r);
    if (i) {
      var o = Nj(e, r), a = o[1], s = o[2];
      if (a > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, SX = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, DX = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, jj = function(e, t) {
  return e === "v" ? kX(t) : EX(t);
}, Nj = function(e, t) {
  return e === "v" ? SX(t) : DX(t);
}, AX = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, TX = function(e, t, n, r, i) {
  var o = AX(e, window.getComputedStyle(t).direction), a = o * r, s = n.target, l = t.contains(s), u = !1, d = a > 0, p = 0, f = 0;
  do {
    var m = Nj(e, s), y = m[0], g = m[1], x = m[2], E = g - x - o * y;
    (y || E) && jj(e, s) && (p += E, f += y), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (d && (Math.abs(p) < 1 || !i) || !d && (Math.abs(f) < 1 || !i)) && (u = !0), u;
}, Rh = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, uw = function(e) {
  return [e.deltaX, e.deltaY];
}, cw = function(e) {
  return e && "current" in e ? e.current : e;
}, jX = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, NX = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, OX = 0, Jc = [];
function zX(e) {
  var t = v.useRef([]), n = v.useRef([0, 0]), r = v.useRef(), i = v.useState(OX++)[0], o = v.useState(Aj)[0], a = v.useRef(e);
  v.useEffect(function() {
    a.current = e;
  }, [e]), v.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var g = JK([e.lockRef.current], (e.shards || []).map(cw)).filter(Boolean);
      return g.forEach(function(x) {
        return x.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), g.forEach(function(x) {
          return x.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = v.useCallback(function(g, x) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !a.current.allowPinchZoom;
    var E = Rh(g), b = n.current, C = "deltaX" in g ? g.deltaX : b[0] - E[0], T = "deltaY" in g ? g.deltaY : b[1] - E[1], z, I = g.target, w = Math.abs(C) > Math.abs(T) ? "h" : "v";
    if ("touches" in g && w === "h" && I.type === "range")
      return !1;
    var M = lw(w, I);
    if (!M)
      return !0;
    if (M ? z = w : (z = w === "v" ? "h" : "v", M = lw(w, I)), !M)
      return !1;
    if (!r.current && "changedTouches" in g && (C || T) && (r.current = z), !z)
      return !0;
    var R = r.current || z;
    return TX(R, x, g, R === "h" ? C : T, !0);
  }, []), l = v.useCallback(function(g) {
    var x = g;
    if (!(!Jc.length || Jc[Jc.length - 1] !== o)) {
      var E = "deltaY" in x ? uw(x) : Rh(x), b = t.current.filter(function(z) {
        return z.name === x.type && (z.target === x.target || x.target === z.shadowParent) && jX(z.delta, E);
      })[0];
      if (b && b.should) {
        x.cancelable && x.preventDefault();
        return;
      }
      if (!b) {
        var C = (a.current.shards || []).map(cw).filter(Boolean).filter(function(z) {
          return z.contains(x.target);
        }), T = C.length > 0 ? s(x, C[0]) : !a.current.noIsolation;
        T && x.cancelable && x.preventDefault();
      }
    }
  }, []), u = v.useCallback(function(g, x, E, b) {
    var C = { name: g, delta: x, target: E, should: b, shadowParent: FX(E) };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(T) {
        return T !== C;
      });
    }, 1);
  }, []), d = v.useCallback(function(g) {
    n.current = Rh(g), r.current = void 0;
  }, []), p = v.useCallback(function(g) {
    u(g.type, uw(g), g.target, s(g, e.lockRef.current));
  }, []), f = v.useCallback(function(g) {
    u(g.type, Rh(g), g.target, s(g, e.lockRef.current));
  }, []);
  v.useEffect(function() {
    return Jc.push(o), e.setCallbacks({
      onScrollCapture: p,
      onWheelCapture: p,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, Yc), document.addEventListener("touchmove", l, Yc), document.addEventListener("touchstart", d, Yc), function() {
      Jc = Jc.filter(function(g) {
        return g !== o;
      }), document.removeEventListener("wheel", l, Yc), document.removeEventListener("touchmove", l, Yc), document.removeEventListener("touchstart", d, Yc);
    };
  }, []);
  var m = e.removeScrollBar, y = e.inert;
  return v.createElement(
    v.Fragment,
    null,
    y ? v.createElement(o, { styles: NX(i) }) : null,
    m ? v.createElement(wX, { gapMode: e.gapMode }) : null
  );
}
function FX(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const LX = lX(Dj, zX);
var B7 = v.forwardRef(function(e, t) {
  return v.createElement(Kg, os({}, e, { ref: t, sideCar: LX }));
});
B7.classNames = Kg.classNames;
var MX = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, e0 = /* @__PURE__ */ new WeakMap(), Ph = /* @__PURE__ */ new WeakMap(), _h = {}, R4 = 0, Oj = function(e) {
  return e && (e.host || Oj(e.parentNode));
}, BX = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Oj(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, IX = function(e, t, n, r) {
  var i = BX(t, Array.isArray(e) ? e : [e]);
  _h[n] || (_h[n] = /* @__PURE__ */ new WeakMap());
  var o = _h[n], a = [], s = /* @__PURE__ */ new Set(), l = new Set(i), u = function(p) {
    !p || s.has(p) || (s.add(p), u(p.parentNode));
  };
  i.forEach(u);
  var d = function(p) {
    !p || l.has(p) || Array.prototype.forEach.call(p.children, function(f) {
      if (s.has(f))
        d(f);
      else {
        var m = f.getAttribute(r), y = m !== null && m !== "false", g = (e0.get(f) || 0) + 1, x = (o.get(f) || 0) + 1;
        e0.set(f, g), o.set(f, x), a.push(f), g === 1 && y && Ph.set(f, !0), x === 1 && f.setAttribute(n, "true"), y || f.setAttribute(r, "true");
      }
    });
  };
  return d(t), s.clear(), R4++, function() {
    a.forEach(function(p) {
      var f = e0.get(p) - 1, m = o.get(p) - 1;
      e0.set(p, f), o.set(p, m), f || (Ph.has(p) || p.removeAttribute(r), Ph.delete(p)), m || p.removeAttribute(n);
    }), R4--, R4 || (e0 = /* @__PURE__ */ new WeakMap(), e0 = /* @__PURE__ */ new WeakMap(), Ph = /* @__PURE__ */ new WeakMap(), _h = {});
  };
}, zj = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), i = MX(e);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), IX(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, I7 = "Dialog", [Fj, J6e] = lK(I7), [RX, Ua] = Fj(I7), Lj = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    modal: a = !0
  } = e, s = v.useRef(null), l = v.useRef(null), [u = !1, d] = pK({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ c.jsx(
    RX,
    {
      scope: t,
      triggerRef: s,
      contentRef: l,
      contentId: O4(),
      titleId: O4(),
      descriptionId: O4(),
      open: u,
      onOpenChange: d,
      onOpenToggle: v.useCallback(() => d((p) => !p), [d]),
      modal: a,
      children: n
    }
  );
};
Lj.displayName = I7;
var Mj = "DialogTrigger", PX = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Ua(Mj, n), o = Wg(t, i.triggerRef);
    return /* @__PURE__ */ c.jsx(
      dd.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": _7(i.open),
        ...r,
        ref: o,
        onClick: Cp(e.onClick, i.onOpenToggle)
      }
    );
  }
);
PX.displayName = Mj;
var R7 = "DialogPortal", [_X, Bj] = Fj(R7, {
  forceMount: void 0
}), Ij = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, o = Ua(R7, t);
  return /* @__PURE__ */ c.jsx(_X, { scope: t, forceMount: n, children: v.Children.map(r, (a) => /* @__PURE__ */ c.jsx(Gg, { present: n || o.open, children: /* @__PURE__ */ c.jsx(Cj, { asChild: !0, container: i, children: a }) })) });
};
Ij.displayName = R7;
var Nm = "DialogOverlay", Rj = v.forwardRef(
  (e, t) => {
    const n = Bj(Nm, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = Ua(Nm, e.__scopeDialog);
    return o.modal ? /* @__PURE__ */ c.jsx(Gg, { present: r || o.open, children: /* @__PURE__ */ c.jsx(qX, { ...i, ref: t }) }) : null;
  }
);
Rj.displayName = Nm;
var qX = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Ua(Nm, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ c.jsx(B7, { as: M7, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ c.jsx(
        dd.div,
        {
          "data-state": _7(i.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Tc = "DialogContent", Pj = v.forwardRef(
  (e, t) => {
    const n = Bj(Tc, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = Ua(Tc, e.__scopeDialog);
    return /* @__PURE__ */ c.jsx(Gg, { present: r || o.open, children: o.modal ? /* @__PURE__ */ c.jsx($X, { ...i, ref: t }) : /* @__PURE__ */ c.jsx(HX, { ...i, ref: t }) });
  }
);
Pj.displayName = Tc;
var $X = v.forwardRef(
  (e, t) => {
    const n = Ua(Tc, e.__scopeDialog), r = v.useRef(null), i = Wg(t, n.contentRef, r);
    return v.useEffect(() => {
      const o = r.current;
      if (o) return zj(o);
    }, []), /* @__PURE__ */ c.jsx(
      _j,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Cp(e.onCloseAutoFocus, (o) => {
          var a;
          o.preventDefault(), (a = n.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: Cp(e.onPointerDownOutside, (o) => {
          const a = o.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || s) && o.preventDefault();
        }),
        onFocusOutside: Cp(
          e.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), HX = v.forwardRef(
  (e, t) => {
    const n = Ua(Tc, e.__scopeDialog), r = v.useRef(!1), i = v.useRef(!1);
    return /* @__PURE__ */ c.jsx(
      _j,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var a, s;
          (a = e.onCloseAutoFocus) == null || a.call(e, o), o.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), o.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (o) => {
          var a, s;
          (a = e.onInteractOutside) == null || a.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const l = o.target;
          (s = n.triggerRef.current) != null && s.contains(l) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
        }
      }
    );
  }
), _j = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, ...a } = e, s = Ua(Tc, n), l = v.useRef(null), u = Wg(t, l);
    return kj(), /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx(
        L7,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ c.jsx(
            Zg,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": _7(s.open),
              ...a,
              ref: u,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
        /* @__PURE__ */ c.jsx(UX, { titleId: s.titleId }),
        /* @__PURE__ */ c.jsx(ZX, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), P7 = "DialogTitle", qj = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Ua(P7, n);
    return /* @__PURE__ */ c.jsx(dd.h2, { id: i.titleId, ...r, ref: t });
  }
);
qj.displayName = P7;
var $j = "DialogDescription", VX = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Ua($j, n);
    return /* @__PURE__ */ c.jsx(dd.p, { id: i.descriptionId, ...r, ref: t });
  }
);
VX.displayName = $j;
var Hj = "DialogClose", Vj = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Ua(Hj, n);
    return /* @__PURE__ */ c.jsx(
      dd.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Cp(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
Vj.displayName = Hj;
function _7(e) {
  return e ? "open" : "closed";
}
var Uj = "DialogTitleWarning", [e7e, Wj] = sK(Uj, {
  contentName: Tc,
  titleName: P7,
  docsSlug: "dialog"
}), UX = ({ titleId: e }) => {
  const t = Wj(Uj), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return v.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, WX = "DialogDescriptionWarning", ZX = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Wj(WX).contentName}}.`;
  return v.useEffect(() => {
    var r;
    const i = (r = e.current) == null ? void 0 : r.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
}, GX = Lj, KX = Ij, XX = Rj, QX = Pj, YX = qj, JX = Vj;
function qo({
  isOpen: e,
  title: t,
  setIsOpen: n,
  children: r,
  className: i,
  extraTitleClassName: o,
  extraCloseButtonClassName: a,
  extraOverlayClassName: s,
  onEscapeKeyDown: l,
  onKeyDown: u
}) {
  const d = v.useRef(null), p = gl(), f = v.useCallback(
    (m) => {
      if (m !== !1) {
        n(m);
        return;
      }
      m === !1 && setTimeout(() => {
        n(m);
      }, 1);
    },
    [n]
  );
  return v.useEffect(() => {
    if (!e) {
      d.current && d.current.focus();
      return;
    }
    d.current = document.activeElement;
  }, [e]), /* @__PURE__ */ c.jsx(c.Fragment, { children: /* @__PURE__ */ c.jsx(GX, { open: e, onOpenChange: f, children: /* @__PURE__ */ c.jsxs(KX, { children: [
    /* @__PURE__ */ c.jsx(
      XX,
      {
        className: Le(Zj, s)
      }
    ),
    /* @__PURE__ */ c.jsxs(
      QX,
      {
        className: Le(
          "serlo-modal",
          i,
          // The moodle navigation bar has a z-index of 1030...
          !p && "z-[1040]"
        ),
        "data-modal-state": e ? "open" : "closed",
        "aria-describedby": void 0,
        onEscapeKeyDown: l,
        onKeyDown: u,
        children: [
          t ? /* @__PURE__ */ c.jsx(YX, { className: Le("serlo-h2", o), children: t }) : null,
          r,
          /* @__PURE__ */ c.jsx(
            JX,
            {
              "aria-label": "Close",
              onClick: () => f(!1),
              title: t,
              className: Le(
                `absolute right-3.5 top-3.5 z-20 inline-flex flow-root h-9 w-9 cursor-pointer
                 items-center justify-center rounded-full border-none
                 leading-tight text-almost-black hover:bg-brand hover:text-white`,
                a
              ),
              "data-qa": "modal-close-button",
              children: /* @__PURE__ */ c.jsx(ot, { icon: Fg, className: "h-5" })
            }
          )
        ]
      }
    )
  ] }) }) });
}
const Zj = Le(
  "fixed bottom-0 left-0 right-0 top-0 z-[101] bg-white bg-opacity-75"
), Gj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EditorModal: qo,
  defaultModalOverlayStyles: Zj
}, Symbol.toStringTag, { value: "Module" }));
function eQ({
  pluginType: e,
  pluginTitle: t
}) {
  const { lang: n } = nt(), [r, i] = v.useState(!1), o = Object.hasOwn(Jb, e) && Jb[e];
  if (n !== "de" || !o) return null;
  const a = Object.hasOwn(o, "video") ? o.video : void 0, { shortExplanation: s } = o;
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      "button",
      {
        className: "ml-[-8px] hover:text-editor-primary active:text-editor-primary",
        onClick: () => i(!0),
        children: /* @__PURE__ */ c.jsx(ot, { icon: cj, className: "mr-2" })
      }
    ),
    /* @__PURE__ */ c.jsx(
      qo,
      {
        className: "top-0 my-4 max-h-[calc(100vh-2rem)] w-[700px] max-w-[95%] translate-y-0 overflow-hidden pb-0",
        title: `${t}-Plugin Erklärung`,
        isOpen: r,
        extraTitleClassName: "text-lg border-0 -mt-4 mb-3",
        setIsOpen: i,
        children: /* @__PURE__ */ c.jsxs("div", { className: "max-h-[calc(100vh-6rem)] overflow-y-auto pb-7", children: [
          l(),
          a ? /* @__PURE__ */ c.jsx(
            "video",
            {
              muted: !0,
              loop: !0,
              controls: !0,
              playsInline: !0,
              className: "mx-side max-w-[calc(100%-32px)] rounded-md border-4 border-brand-200",
              children: /* @__PURE__ */ c.jsx("source", { src: a, type: "video/webm" })
            }
          ) : null
        ] })
      }
    )
  ] });
  function l() {
    return s ? typeof s == "string" ? /* @__PURE__ */ c.jsx("p", { className: "serlo-p", children: s }) : /* @__PURE__ */ c.jsx(Nn, { document: s }) : null;
  }
}
function tQ(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = v.createContext(a), l = n.length;
    n = [...n, a];
    const u = (p) => {
      var f;
      const { scope: m, children: y, ...g } = p, x = ((f = m == null ? void 0 : m[e]) == null ? void 0 : f[l]) || s, E = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ c.jsx(x.Provider, { value: E, children: y });
    };
    u.displayName = o + "Provider";
    function d(p, f) {
      var m;
      const y = ((m = f == null ? void 0 : f[e]) == null ? void 0 : m[l]) || s, g = v.useContext(y);
      if (g) return g;
      if (a !== void 0) return a;
      throw new Error(`\`${p}\` must be used within \`${o}\``);
    }
    return [u, d];
  }
  const i = () => {
    const o = n.map((a) => v.createContext(a));
    return function(a) {
      const s = (a == null ? void 0 : a[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: s } }),
        [a, s]
      );
    };
  };
  return i.scopeName = e, [r, nQ(i, ...t)];
}
function nQ(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(i) {
      const o = r.reduce((a, { useScope: s, scopeName: l }) => {
        const u = s(i)[`__scope${l}`];
        return { ...a, ...u };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Oi(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function rQ(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function q7(...e) {
  return (t) => e.forEach((n) => rQ(n, t));
}
function pd(...e) {
  return v.useCallback(q7(...e), e);
}
var Kj = v.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = v.Children.toArray(n), o = i.find(oQ);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? v.Children.count(a) > 1 ? v.Children.only(null) : v.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ c.jsx(Yv, { ...r, ref: t, children: v.isValidElement(a) ? v.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ c.jsx(Yv, { ...r, ref: t, children: n });
});
Kj.displayName = "Slot";
var Yv = v.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (v.isValidElement(n)) {
    const i = sQ(n);
    return v.cloneElement(n, {
      ...aQ(r, n.props),
      // @ts-ignore
      ref: t ? q7(t, i) : i
    });
  }
  return v.Children.count(n) > 1 ? v.Children.only(null) : null;
});
Yv.displayName = "SlotClone";
var iQ = ({ children: e }) => /* @__PURE__ */ c.jsx(c.Fragment, { children: e });
function oQ(e) {
  return v.isValidElement(e) && e.type === iQ;
}
function aQ(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...a) => {
      o(...a), i(...a);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function sQ(e) {
  var t, n;
  let r = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, i = r && "isReactWarning" in r && r.isReactWarning;
  return i ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, i = r && "isReactWarning" in r && r.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var lQ = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ha = lQ.reduce((e, t) => {
  const n = v.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? Kj : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c.jsx(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function dw(e, t) {
  e && ms.flushSync(() => e.dispatchEvent(t));
}
function Xj({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, i] = uQ({ defaultProp: t, onChange: n }), o = e !== void 0, a = o ? e : r, s = Nr(n), l = v.useCallback(
    (u) => {
      if (o) {
        const d = typeof u == "function" ? u(e) : u;
        d !== e && s(d);
      } else
        i(u);
    },
    [o, e, i, s]
  );
  return [a, l];
}
function uQ({
  defaultProp: e,
  onChange: t
}) {
  const n = v.useState(e), [r] = n, i = v.useRef(r), o = Nr(t);
  return v.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [r, i, o]), n;
}
var cQ = v.createContext(void 0);
function Qj(e) {
  const t = v.useContext(cQ);
  return e || t || "ltr";
}
function dQ(e, t) {
  return v.useReducer((n, r) => t[n][r] ?? n, e);
}
var Ff = (e) => {
  const { present: t, children: n } = e, r = pQ(t), i = typeof n == "function" ? n({ present: r.isPresent }) : v.Children.only(n), o = pd(r.ref, fQ(i));
  return typeof n == "function" || r.isPresent ? v.cloneElement(i, { ref: o }) : null;
};
Ff.displayName = "Presence";
function pQ(e) {
  const [t, n] = v.useState(), r = v.useRef({}), i = v.useRef(e), o = v.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = dQ(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return v.useEffect(() => {
    const u = qh(r.current);
    o.current = s === "mounted" ? u : "none";
  }, [s]), gr(() => {
    const u = r.current, d = i.current;
    if (d !== e) {
      const p = o.current, f = qh(u);
      e ? l("MOUNT") : f === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(d && p !== f ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, l]), gr(() => {
    if (t) {
      let u;
      const d = t.ownerDocument.defaultView ?? window, p = (m) => {
        const y = qh(r.current).includes(m.animationName);
        if (m.target === t && y && (l("ANIMATION_END"), !i.current)) {
          const g = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = g);
          });
        }
      }, f = (m) => {
        m.target === t && (o.current = qh(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", p), t.addEventListener("animationend", p), () => {
        d.clearTimeout(u), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", p), t.removeEventListener("animationend", p);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: v.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function qh(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function fQ(e) {
  var t, n;
  let r = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, i = r && "isReactWarning" in r && r.isReactWarning;
  return i ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, i = r && "isReactWarning" in r && r.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var hQ = v.useId || (() => {
}), mQ = 0;
function Yj(e) {
  const [t, n] = v.useState(hQ());
  return gr(() => {
    e || n((r) => r ?? String(mQ++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function gQ(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = v.createContext(a), l = n.length;
    n = [...n, a];
    function u(p) {
      const { scope: f, children: m, ...y } = p, g = (f == null ? void 0 : f[e][l]) || s, x = v.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ c.jsx(g.Provider, { value: x, children: m });
    }
    function d(p, f) {
      const m = (f == null ? void 0 : f[e][l]) || s, y = v.useContext(m);
      if (y) return y;
      if (a !== void 0) return a;
      throw new Error(`\`${p}\` must be used within \`${o}\``);
    }
    return u.displayName = o + "Provider", [u, d];
  }
  const i = () => {
    const o = n.map((a) => v.createContext(a));
    return function(a) {
      const s = (a == null ? void 0 : a[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: s } }),
        [a, s]
      );
    };
  };
  return i.scopeName = e, [r, vQ(i, ...t)];
}
function vQ(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(i) {
      const o = r.reduce((a, { useScope: s, scopeName: l }) => {
        const u = s(i)[`__scope${l}`];
        return { ...a, ...u };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function yQ(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Jj(...e) {
  return (t) => e.forEach((n) => yQ(n, t));
}
function pw(...e) {
  return v.useCallback(Jj(...e), e);
}
var Jv = v.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = v.Children.toArray(n), o = i.find(bQ);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? v.Children.count(a) > 1 ? v.Children.only(null) : v.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ c.jsx(e5, { ...r, ref: t, children: v.isValidElement(a) ? v.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ c.jsx(e5, { ...r, ref: t, children: n });
});
Jv.displayName = "Slot";
var e5 = v.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (v.isValidElement(n)) {
    const i = CQ(n);
    return v.cloneElement(n, {
      ...wQ(r, n.props),
      // @ts-ignore
      ref: t ? Jj(t, i) : i
    });
  }
  return v.Children.count(n) > 1 ? v.Children.only(null) : null;
});
e5.displayName = "SlotClone";
var xQ = ({ children: e }) => /* @__PURE__ */ c.jsx(c.Fragment, { children: e });
function bQ(e) {
  return v.isValidElement(e) && e.type === xQ;
}
function wQ(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...a) => {
      o(...a), i(...a);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function CQ(e) {
  var t, n;
  let r = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, i = r && "isReactWarning" in r && r.isReactWarning;
  return i ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, i = r && "isReactWarning" in r && r.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
function $7(e) {
  const t = e + "CollectionProvider", [n, r] = gQ(t), [i, o] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (m) => {
    const { scope: y, children: g } = m, x = dt.useRef(null), E = dt.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ c.jsx(i, { scope: y, itemMap: E, collectionRef: x, children: g });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", l = dt.forwardRef(
    (m, y) => {
      const { scope: g, children: x } = m, E = o(s, g), b = pw(y, E.collectionRef);
      return /* @__PURE__ */ c.jsx(Jv, { ref: b, children: x });
    }
  );
  l.displayName = s;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", p = dt.forwardRef(
    (m, y) => {
      const { scope: g, children: x, ...E } = m, b = dt.useRef(null), C = pw(y, b), T = o(u, g);
      return dt.useEffect(() => (T.itemMap.set(b, { ref: b, ...E }), () => void T.itemMap.delete(b))), /* @__PURE__ */ c.jsx(Jv, { [d]: "", ref: C, children: x });
    }
  );
  p.displayName = u;
  function f(m) {
    const y = o(e + "CollectionConsumer", m);
    return dt.useCallback(() => {
      const g = y.collectionRef.current;
      if (!g) return [];
      const x = Array.from(g.querySelectorAll(`[${d}]`));
      return Array.from(y.itemMap.values()).sort(
        (E, b) => x.indexOf(E.ref.current) - x.indexOf(b.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: a, Slot: l, ItemSlot: p },
    f,
    r
  ];
}
function eN(e) {
  const t = v.useRef({ value: e, previous: e });
  return v.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function kQ(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function EQ(...e) {
  return (t) => e.forEach((n) => kQ(n, t));
}
var tN = v.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = v.Children.toArray(n), o = i.find(DQ);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? v.Children.count(a) > 1 ? v.Children.only(null) : v.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ c.jsx(t5, { ...r, ref: t, children: v.isValidElement(a) ? v.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ c.jsx(t5, { ...r, ref: t, children: n });
});
tN.displayName = "Slot";
var t5 = v.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (v.isValidElement(n)) {
    const i = TQ(n);
    return v.cloneElement(n, {
      ...AQ(r, n.props),
      // @ts-ignore
      ref: t ? EQ(t, i) : i
    });
  }
  return v.Children.count(n) > 1 ? v.Children.only(null) : null;
});
t5.displayName = "SlotClone";
var SQ = ({ children: e }) => /* @__PURE__ */ c.jsx(c.Fragment, { children: e });
function DQ(e) {
  return v.isValidElement(e) && e.type === SQ;
}
function AQ(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...a) => {
      o(...a), i(...a);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function TQ(e) {
  var t, n;
  let r = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, i = r && "isReactWarning" in r && r.isReactWarning;
  return i ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, i = r && "isReactWarning" in r && r.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var jQ = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], NQ = jQ.reduce((e, t) => {
  const n = v.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? tN : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c.jsx(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), OQ = "VisuallyHidden", H7 = v.forwardRef(
  (e, t) => /* @__PURE__ */ c.jsx(
    NQ.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
H7.displayName = OQ;
var zQ = H7, fd = "NavigationMenu", [V7, nN, FQ] = $7(fd), [n5, LQ, MQ] = $7(fd), [U7, t7e] = tQ(
  fd,
  [FQ, MQ]
), [BQ, ya] = U7(fd), [IQ, RQ] = U7(fd), rN = v.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: r,
      onValueChange: i,
      defaultValue: o,
      delayDuration: a = 200,
      skipDelayDuration: s = 300,
      orientation: l = "horizontal",
      dir: u,
      ...d
    } = e, [p, f] = v.useState(null), m = pd(t, (R) => f(R)), y = Qj(u), g = v.useRef(0), x = v.useRef(0), E = v.useRef(0), [b, C] = v.useState(!0), [T = "", z] = Xj({
      prop: r,
      onChange: (R) => {
        const F = R !== "", W = s > 0;
        F ? (window.clearTimeout(E.current), W && C(!1)) : (window.clearTimeout(E.current), E.current = window.setTimeout(
          () => C(!0),
          s
        )), i == null || i(R);
      },
      defaultProp: o
    }), I = v.useCallback(() => {
      window.clearTimeout(x.current), x.current = window.setTimeout(() => z(""), 150);
    }, [z]), w = v.useCallback(
      (R) => {
        window.clearTimeout(x.current), z(R);
      },
      [z]
    ), M = v.useCallback(
      (R) => {
        T === R ? window.clearTimeout(x.current) : g.current = window.setTimeout(() => {
          window.clearTimeout(x.current), z(R);
        }, a);
      },
      [T, z, a]
    );
    return v.useEffect(() => () => {
      window.clearTimeout(g.current), window.clearTimeout(x.current), window.clearTimeout(E.current);
    }, []), /* @__PURE__ */ c.jsx(
      oN,
      {
        scope: n,
        isRootMenu: !0,
        value: T,
        dir: y,
        orientation: l,
        rootNavigationMenu: p,
        onTriggerEnter: (R) => {
          window.clearTimeout(g.current), b ? M(R) : w(R);
        },
        onTriggerLeave: () => {
          window.clearTimeout(g.current), I();
        },
        onContentEnter: () => window.clearTimeout(x.current),
        onContentLeave: I,
        onItemSelect: (R) => {
          z((F) => F === R ? "" : R);
        },
        onItemDismiss: () => z(""),
        children: /* @__PURE__ */ c.jsx(
          Ha.nav,
          {
            "aria-label": "Main",
            "data-orientation": l,
            dir: y,
            ...d,
            ref: m
          }
        )
      }
    );
  }
);
rN.displayName = fd;
var iN = "NavigationMenuSub", PQ = v.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: r,
      onValueChange: i,
      defaultValue: o,
      orientation: a = "horizontal",
      ...s
    } = e, l = ya(iN, n), [u = "", d] = Xj({
      prop: r,
      onChange: i,
      defaultProp: o
    });
    return /* @__PURE__ */ c.jsx(
      oN,
      {
        scope: n,
        isRootMenu: !1,
        value: u,
        dir: l.dir,
        orientation: a,
        rootNavigationMenu: l.rootNavigationMenu,
        onTriggerEnter: (p) => d(p),
        onItemSelect: (p) => d(p),
        onItemDismiss: () => d(""),
        children: /* @__PURE__ */ c.jsx(Ha.div, { "data-orientation": a, ...s, ref: t })
      }
    );
  }
);
PQ.displayName = iN;
var oN = (e) => {
  const {
    scope: t,
    isRootMenu: n,
    rootNavigationMenu: r,
    dir: i,
    orientation: o,
    children: a,
    value: s,
    onItemSelect: l,
    onItemDismiss: u,
    onTriggerEnter: d,
    onTriggerLeave: p,
    onContentEnter: f,
    onContentLeave: m
  } = e, [y, g] = v.useState(null), [x, E] = v.useState(/* @__PURE__ */ new Map()), [b, C] = v.useState(null);
  return /* @__PURE__ */ c.jsx(
    BQ,
    {
      scope: t,
      isRootMenu: n,
      rootNavigationMenu: r,
      value: s,
      previousValue: eN(s),
      baseId: Yj(),
      dir: i,
      orientation: o,
      viewport: y,
      onViewportChange: g,
      indicatorTrack: b,
      onIndicatorTrackChange: C,
      onTriggerEnter: Nr(d),
      onTriggerLeave: Nr(p),
      onContentEnter: Nr(f),
      onContentLeave: Nr(m),
      onItemSelect: Nr(l),
      onItemDismiss: Nr(u),
      onViewportContentChange: v.useCallback((T, z) => {
        E((I) => (I.set(T, z), new Map(I)));
      }, []),
      onViewportContentRemove: v.useCallback((T) => {
        E((z) => z.has(T) ? (z.delete(T), new Map(z)) : z);
      }, []),
      children: /* @__PURE__ */ c.jsx(V7.Provider, { scope: t, children: /* @__PURE__ */ c.jsx(IQ, { scope: t, items: x, children: a }) })
    }
  );
}, aN = "NavigationMenuList", sN = v.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, i = ya(aN, n), o = /* @__PURE__ */ c.jsx(Ha.ul, { "data-orientation": i.orientation, ...r, ref: t });
    return /* @__PURE__ */ c.jsx(Ha.div, { style: { position: "relative" }, ref: i.onIndicatorTrackChange, children: /* @__PURE__ */ c.jsx(V7.Slot, { scope: n, children: i.isRootMenu ? /* @__PURE__ */ c.jsx(hN, { asChild: !0, children: o }) : o }) });
  }
);
sN.displayName = aN;
var lN = "NavigationMenuItem", [_Q, uN] = U7(lN), cN = v.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, value: r, ...i } = e, o = Yj(), a = r || o || "LEGACY_REACT_AUTO_VALUE", s = v.useRef(null), l = v.useRef(null), u = v.useRef(null), d = v.useRef(() => {
    }), p = v.useRef(!1), f = v.useCallback((y = "start") => {
      if (s.current) {
        d.current();
        const g = i5(s.current);
        g.length && G7(y === "start" ? g : g.reverse());
      }
    }, []), m = v.useCallback(() => {
      if (s.current) {
        const y = i5(s.current);
        y.length && (d.current = XQ(y));
      }
    }, []);
    return /* @__PURE__ */ c.jsx(
      _Q,
      {
        scope: n,
        value: a,
        triggerRef: l,
        contentRef: s,
        focusProxyRef: u,
        wasEscapeCloseRef: p,
        onEntryKeyDown: f,
        onFocusProxyEnter: f,
        onRootContentClose: m,
        onContentFocusOutside: m,
        children: /* @__PURE__ */ c.jsx(Ha.li, { ...i, ref: t })
      }
    );
  }
);
cN.displayName = lN;
var r5 = "NavigationMenuTrigger", dN = v.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, disabled: r, ...i } = e, o = ya(r5, e.__scopeNavigationMenu), a = uN(r5, e.__scopeNavigationMenu), s = v.useRef(null), l = pd(s, a.triggerRef, t), u = gN(o.baseId, a.value), d = vN(o.baseId, a.value), p = v.useRef(!1), f = v.useRef(!1), m = a.value === o.value;
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(V7.ItemSlot, { scope: n, value: a.value, children: /* @__PURE__ */ c.jsx(mN, { asChild: !0, children: /* @__PURE__ */ c.jsx(
      Ha.button,
      {
        id: u,
        disabled: r,
        "data-disabled": r ? "" : void 0,
        "data-state": K7(m),
        "aria-expanded": m,
        "aria-controls": d,
        ...i,
        ref: l,
        onPointerEnter: Oi(e.onPointerEnter, () => {
          f.current = !1, a.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: Oi(
          e.onPointerMove,
          Om(() => {
            r || f.current || a.wasEscapeCloseRef.current || p.current || (o.onTriggerEnter(a.value), p.current = !0);
          })
        ),
        onPointerLeave: Oi(
          e.onPointerLeave,
          Om(() => {
            r || (o.onTriggerLeave(), p.current = !1);
          })
        ),
        onClick: Oi(e.onClick, () => {
          o.onItemSelect(a.value), f.current = m;
        }),
        onKeyDown: Oi(e.onKeyDown, (y) => {
          const g = { horizontal: "ArrowDown", vertical: o.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[o.orientation];
          m && y.key === g && (a.onEntryKeyDown(), y.preventDefault());
        })
      }
    ) }) }),
    m && /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx(
        zQ,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: a.focusProxyRef,
          onFocus: (y) => {
            const g = a.contentRef.current, x = y.relatedTarget, E = x === s.current, b = g == null ? void 0 : g.contains(x);
            (E || !b) && a.onFocusProxyEnter(E ? "start" : "end");
          }
        }
      ),
      o.viewport && /* @__PURE__ */ c.jsx("span", { "aria-owns": d })
    ] })
  ] });
});
dN.displayName = r5;
var qQ = "NavigationMenuLink", fw = "navigationMenu.linkSelect", $Q = v.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, active: r, onSelect: i, ...o } = e;
    return /* @__PURE__ */ c.jsx(mN, { asChild: !0, children: /* @__PURE__ */ c.jsx(
      Ha.a,
      {
        "data-active": r ? "" : void 0,
        "aria-current": r ? "page" : void 0,
        ...o,
        ref: t,
        onClick: Oi(
          e.onClick,
          (a) => {
            const s = a.target, l = new CustomEvent(fw, {
              bubbles: !0,
              cancelable: !0
            });
            if (s.addEventListener(fw, (u) => i == null ? void 0 : i(u), { once: !0 }), dw(s, l), !l.defaultPrevented && !a.metaKey) {
              const u = new CustomEvent(I1, {
                bubbles: !0,
                cancelable: !0
              });
              dw(s, u);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
$Q.displayName = qQ;
var W7 = "NavigationMenuIndicator", HQ = v.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, i = ya(W7, e.__scopeNavigationMenu), o = !!i.value;
  return i.indicatorTrack ? Cf.createPortal(
    /* @__PURE__ */ c.jsx(Ff, { present: n || o, children: /* @__PURE__ */ c.jsx(VQ, { ...r, ref: t }) }),
    i.indicatorTrack
  ) : null;
});
HQ.displayName = W7;
var VQ = v.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, ...r } = e, i = ya(W7, n), o = nN(n), [a, s] = v.useState(
    null
  ), [l, u] = v.useState(null), d = i.orientation === "horizontal", p = !!i.value;
  v.useEffect(() => {
    var m;
    const y = (m = o().find((g) => g.value === i.value)) == null ? void 0 : m.ref.current;
    y && s(y);
  }, [o, i.value]);
  const f = () => {
    a && u({
      size: d ? a.offsetWidth : a.offsetHeight,
      offset: d ? a.offsetLeft : a.offsetTop
    });
  };
  return o5(a, f), o5(i.indicatorTrack, f), l ? /* @__PURE__ */ c.jsx(
    Ha.div,
    {
      "aria-hidden": !0,
      "data-state": p ? "visible" : "hidden",
      "data-orientation": i.orientation,
      ...r,
      ref: t,
      style: {
        position: "absolute",
        ...d ? {
          left: 0,
          width: l.size + "px",
          transform: `translateX(${l.offset}px)`
        } : {
          top: 0,
          height: l.size + "px",
          transform: `translateY(${l.offset}px)`
        },
        ...r.style
      }
    }
  ) : null;
}), G0 = "NavigationMenuContent", pN = v.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, i = ya(G0, e.__scopeNavigationMenu), o = uN(G0, e.__scopeNavigationMenu), a = pd(o.contentRef, t), s = o.value === i.value, l = {
    value: o.value,
    triggerRef: o.triggerRef,
    focusProxyRef: o.focusProxyRef,
    wasEscapeCloseRef: o.wasEscapeCloseRef,
    onContentFocusOutside: o.onContentFocusOutside,
    onRootContentClose: o.onRootContentClose,
    ...r
  };
  return i.viewport ? /* @__PURE__ */ c.jsx(UQ, { forceMount: n, ...l, ref: a }) : /* @__PURE__ */ c.jsx(Ff, { present: n || s, children: /* @__PURE__ */ c.jsx(
    fN,
    {
      "data-state": K7(s),
      ...l,
      ref: a,
      onPointerEnter: Oi(e.onPointerEnter, i.onContentEnter),
      onPointerLeave: Oi(
        e.onPointerLeave,
        Om(i.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !s && i.isRootMenu ? "none" : void 0,
        ...l.style
      }
    }
  ) });
});
pN.displayName = G0;
var UQ = v.forwardRef((e, t) => {
  const n = ya(G0, e.__scopeNavigationMenu), { onViewportContentChange: r, onViewportContentRemove: i } = n;
  return gr(() => {
    r(e.value, {
      ref: t,
      ...e
    });
  }, [e, t, r]), gr(() => () => i(e.value), [e.value, i]), null;
}), I1 = "navigationMenu.rootContentDismiss", fN = v.forwardRef((e, t) => {
  const {
    __scopeNavigationMenu: n,
    value: r,
    triggerRef: i,
    focusProxyRef: o,
    wasEscapeCloseRef: a,
    onRootContentClose: s,
    onContentFocusOutside: l,
    ...u
  } = e, d = ya(G0, n), p = v.useRef(null), f = pd(p, t), m = gN(d.baseId, r), y = vN(d.baseId, r), g = nN(n), x = v.useRef(null), { onItemDismiss: E } = d;
  v.useEffect(() => {
    const C = p.current;
    if (d.isRootMenu && C) {
      const T = () => {
        var z;
        E(), s(), C.contains(document.activeElement) && ((z = i.current) == null || z.focus());
      };
      return C.addEventListener(I1, T), () => C.removeEventListener(I1, T);
    }
  }, [d.isRootMenu, e.value, i, E, s]);
  const b = v.useMemo(() => {
    const C = g().map((R) => R.value);
    d.dir === "rtl" && C.reverse();
    const T = C.indexOf(d.value), z = C.indexOf(d.previousValue), I = r === d.value, w = z === C.indexOf(r);
    if (!I && !w) return x.current;
    const M = (() => {
      if (T !== z) {
        if (I && z !== -1) return T > z ? "from-end" : "from-start";
        if (w && T !== -1) return T > z ? "to-start" : "to-end";
      }
      return null;
    })();
    return x.current = M, M;
  }, [d.previousValue, d.value, d.dir, g, r]);
  return /* @__PURE__ */ c.jsx(hN, { asChild: !0, children: /* @__PURE__ */ c.jsx(
    Zg,
    {
      id: y,
      "aria-labelledby": m,
      "data-motion": b,
      "data-orientation": d.orientation,
      ...u,
      ref: f,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        var C;
        const T = new Event(I1, {
          bubbles: !0,
          cancelable: !0
        });
        (C = p.current) == null || C.dispatchEvent(T);
      },
      onFocusOutside: Oi(e.onFocusOutside, (C) => {
        var T;
        l();
        const z = C.target;
        (T = d.rootNavigationMenu) != null && T.contains(z) && C.preventDefault();
      }),
      onPointerDownOutside: Oi(e.onPointerDownOutside, (C) => {
        var T;
        const z = C.target, I = g().some((M) => {
          var R;
          return (R = M.ref.current) == null ? void 0 : R.contains(z);
        }), w = d.isRootMenu && ((T = d.viewport) == null ? void 0 : T.contains(z));
        (I || w || !d.isRootMenu) && C.preventDefault();
      }),
      onKeyDown: Oi(e.onKeyDown, (C) => {
        var T;
        const z = C.altKey || C.ctrlKey || C.metaKey;
        if (C.key === "Tab" && !z) {
          const I = i5(C.currentTarget), w = document.activeElement, M = I.findIndex((F) => F === w), R = C.shiftKey ? I.slice(0, M).reverse() : I.slice(M + 1, I.length);
          G7(R) ? C.preventDefault() : (T = o.current) == null || T.focus();
        }
      }),
      onEscapeKeyDown: Oi(e.onEscapeKeyDown, (C) => {
        a.current = !0;
      })
    }
  ) });
}), Z7 = "NavigationMenuViewport", WQ = v.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, i = !!ya(Z7, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ c.jsx(Ff, { present: n || i, children: /* @__PURE__ */ c.jsx(ZQ, { ...r, ref: t }) });
});
WQ.displayName = Z7;
var ZQ = v.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, children: r, ...i } = e, o = ya(Z7, n), a = pd(t, o.onViewportChange), s = RQ(
    G0,
    e.__scopeNavigationMenu
  ), [l, u] = v.useState(null), [d, p] = v.useState(null), f = l ? (l == null ? void 0 : l.width) + "px" : void 0, m = l ? (l == null ? void 0 : l.height) + "px" : void 0, y = !!o.value, g = y ? o.value : o.previousValue;
  return o5(d, () => {
    d && u({ width: d.offsetWidth, height: d.offsetHeight });
  }), /* @__PURE__ */ c.jsx(
    Ha.div,
    {
      "data-state": K7(y),
      "data-orientation": o.orientation,
      ...i,
      ref: a,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !y && o.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": f,
        "--radix-navigation-menu-viewport-height": m,
        ...i.style
      },
      onPointerEnter: Oi(e.onPointerEnter, o.onContentEnter),
      onPointerLeave: Oi(e.onPointerLeave, Om(o.onContentLeave)),
      children: Array.from(s.items).map(([x, { ref: E, forceMount: b, ...C }]) => {
        const T = g === x;
        return /* @__PURE__ */ c.jsx(Ff, { present: b || T, children: /* @__PURE__ */ c.jsx(
          fN,
          {
            ...C,
            ref: q7(E, (z) => {
              T && z && p(z);
            })
          }
        ) }, x);
      })
    }
  );
}), GQ = "FocusGroup", hN = v.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, i = ya(GQ, n);
    return /* @__PURE__ */ c.jsx(n5.Provider, { scope: n, children: /* @__PURE__ */ c.jsx(n5.Slot, { scope: n, children: /* @__PURE__ */ c.jsx(Ha.div, { dir: i.dir, ...r, ref: t }) }) });
  }
), hw = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], KQ = "FocusGroupItem", mN = v.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, i = LQ(n), o = ya(KQ, n);
    return /* @__PURE__ */ c.jsx(n5.ItemSlot, { scope: n, children: /* @__PURE__ */ c.jsx(
      Ha.button,
      {
        ...r,
        ref: t,
        onKeyDown: Oi(e.onKeyDown, (a) => {
          if (["Home", "End", ...hw].includes(a.key)) {
            let s = i().map((l) => l.ref.current);
            if ([o.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(a.key) && s.reverse(), hw.includes(a.key)) {
              const l = s.indexOf(a.currentTarget);
              s = s.slice(l + 1);
            }
            setTimeout(() => G7(s)), a.preventDefault();
          }
        })
      }
    ) });
  }
);
function i5(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function G7(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function XQ(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const n = t.dataset.tabindex;
      t.setAttribute("tabindex", n);
    });
  };
}
function o5(e, t) {
  const n = Nr(t);
  gr(() => {
    let r = 0;
    if (e) {
      const i = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return i.observe(e), () => {
        window.cancelAnimationFrame(r), i.unobserve(e);
      };
    }
  }, [e, n]);
}
function K7(e) {
  return e ? "open" : "closed";
}
function gN(e, t) {
  return `${e}-trigger-${t}`;
}
function vN(e, t) {
  return `${e}-content-${t}`;
}
function Om(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var QQ = rN, mw = sN, YQ = cN, JQ = dN, eY = pN;
function tY() {
  return v.useMemo(() => {
    let e;
    return {
      // make sure click directly after hover closes menu again
      onClick: (t) => {
        e && t.preventDefault();
      },
      onPointerEnter: (t) => {
        yN() || t.nativeEvent.pointerType === "mouse" && (e && clearTimeout(e), e = setTimeout(() => e = !1, 500));
      },
      // disable hover completely on small screens with touch support
      onPointerLeave: a5,
      onPointerMove: a5
    };
  }, []);
}
const yN = () => window.innerWidth < 1024, a5 = (e) => {
  yN() && e.preventDefault();
};
function nY({ pluginControls: e }) {
  const t = tY();
  return /* @__PURE__ */ c.jsx(QQ, { children: /* @__PURE__ */ c.jsx(mw, { children: /* @__PURE__ */ c.jsxs(YQ, { children: [
    /* @__PURE__ */ c.jsx(JQ, { "data-qa": "additional-toolbar-controls", ...t, children: /* @__PURE__ */ c.jsx(ot, { className: "mx-2 px-2", icon: MV }) }),
    /* @__PURE__ */ c.jsx(eY, { onPointerEnter: a5, children: /* @__PURE__ */ c.jsx(mw, { className: "absolute right-0 z-30", children: /* @__PURE__ */ c.jsx("div", { className: "serlo-sub-list-hover mt-2 bg-editor-primary-100 px-0", children: e }) }) })
  ] }) }) });
}
function Ci({
  pluginType: e,
  interactiveExerciseType: t,
  contentControls: n,
  pluginSettings: r,
  pluginControls: i,
  pluginTitle: o,
  className: a,
  noWhiteShadow: s
}) {
  const l = nt().plugins, u = o ?? wp(l, e);
  return /* @__PURE__ */ c.jsxs(
    "div",
    {
      className: Le(
        `
        plugin-toolbar absolute -top-10 left-[7px] right-0 z-[21]
        flex h-9 items-center justify-between rounded-t-lg bg-editor-primary-100 pl-2
        `,
        !s && `
        before:pointer-events-none before:absolute before:-top-7
        before:left-0 before:block before:h-7 before:w-full
        before:bg-gradient-to-t before:from-[rgba(255,255,255,0.95)] before:via-[rgba(255,255,255,0.7)] before:to-transparent
        `,
        a
      ),
      children: [
        /* @__PURE__ */ c.jsx("div", { className: "clip-vertical-shadow pointer-events-none absolute inset-0 rounded-t-lg shadow-plugin-focus" }),
        /* @__PURE__ */ c.jsxs("div", { children: [
          n,
          /* @__PURE__ */ c.jsx("div", { className: "toolbar-controls-target inline-block" })
        ] }),
        /* @__PURE__ */ c.jsxs("div", { className: "flex flex-grow items-center justify-end", children: [
          /* @__PURE__ */ c.jsx("div", { className: "mx-4 text-sm font-bold", "data-qa": "plugin-type-indicator", children: u }),
          /* @__PURE__ */ c.jsx(
            eQ,
            {
              pluginType: t ?? e,
              pluginTitle: u
            }
          ),
          r ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
            /* @__PURE__ */ c.jsx("div", { className: "mr-2 h-6 w-[2px] bg-gray-300" }),
            r
          ] }) : null,
          i ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
            /* @__PURE__ */ c.jsx("div", { className: "h-6 w-[2px] bg-gray-300" }),
            /* @__PURE__ */ c.jsx(nY, { pluginControls: i })
          ] }) : null
        ] })
      ]
    }
  );
}
function rY({
  previewActive: e,
  setPreviewActive: t
}) {
  const n = nt().plugins.exercise;
  return /* @__PURE__ */ c.jsxs(
    "button",
    {
      onClick: () => t(!e),
      className: "mr-2 rounded-md bg-editor-primary-200 px-1.5 py-0.5 text-sm transition-colors hover:bg-editor-primary-300 focus-visible:bg-editor-primary-300",
      "data-qa": "plugin-exercise-preview-button",
      children: [
        e ? n.toEditView : n.toLearnersView,
        " ",
        /* @__PURE__ */ c.jsx(ot, { icon: e ? W0 : hT })
      ]
    }
  );
}
const iY = (e) => /* @__PURE__ */ v.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 61 40", fill: "none", ...e }, /* @__PURE__ */ v.createElement("path", { fill: "#FFF5E9", d: "M.084 0h60v40h-60z" }), /* @__PURE__ */ v.createElement("path", { fill: "#000", fillOpacity: 0.08, d: "M8.62 2.711h42.928v2.638H8.62z" }), /* @__PURE__ */ v.createElement("rect", { width: 41.196, height: 22.16, x: 9.486, y: 8.92, fill: "#FFF1DB", stroke: "#FFBB62", strokeWidth: 0.859, rx: 1.03 }), /* @__PURE__ */ v.createElement("path", { fill: "#FFD59D", d: "M9.916 9.95a.6.6 0 0 1 .6-.6h39.137a.6.6 0 0 1 .6.6v3.932H9.915V9.95Z" }), /* @__PURE__ */ v.createElement("path", { fill: "#FFBB62", d: "M9.916 18.908h40.337v.957H9.916zM9.916 24.35h40.337v.957H9.916z" }), /* @__PURE__ */ v.createElement("path", { fill: "#FFBB62", d: "M29.916 31.35v-22h1v22z" }), /* @__PURE__ */ v.createElement("path", { fill: "#000", fillOpacity: 0.08, d: "M8.62 34.65h42.928v2.638H8.62z" })), oY = (e) => /* @__PURE__ */ v.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 61 40", fill: "none", ...e }, /* @__PURE__ */ v.createElement("path", { fill: "#FFF5E9", d: "M.084 0h60v40h-60z" }), /* @__PURE__ */ v.createElement("path", { fill: "#FFBE5D", d: "M14.542 11.912h22.827v3.392H14.542zM14.542 18.304h31.084v3.392H14.542z" }), /* @__PURE__ */ v.createElement("path", { fill: "#FFD59D", d: "M14.542 24.696h19.692v3.392H14.542z" }));
function ef({
  onClick: e,
  title: t,
  icon: n,
  dataQa: r
}) {
  return /* @__PURE__ */ c.jsxs(
    "button",
    {
      className: Le(
        "w-min rounded-md bg-editor-primary-100 px-5 py-3",
        "transition-colors hover:bg-editor-primary-200 active:bg-editor-primary-200"
      ),
      onClick: e,
      "data-qa": r,
      children: [
        /* @__PURE__ */ c.jsx(
          "span",
          {
            className: Le(
              "mx-auto mb-3 block w-fit items-center rounded-md border-2 border-gray-600",
              "[&>svg]:rounded-md"
            ),
            children: n
          }
        ),
        t
      ]
    }
  );
}
function aY({
  childPlugin: e,
  setShowSelection: t
}) {
  const n = nt().plugins, r = n.blanksExercise.childPluginSelection, i = Ur();
  function o(a) {
    t(!1), e.replace(a), i(Ji(e.id));
  }
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx("div", { className: "py-6 text-center text-gray-500", children: r }),
    /* @__PURE__ */ c.jsxs("div", { className: "blanks-child-plugin-selection flex justify-center gap-6 [&_svg]:min-w-20", children: [
      /* @__PURE__ */ c.jsx(
        ef,
        {
          onClick: () => o(Y.Text),
          icon: /* @__PURE__ */ c.jsx(oY, {}),
          title: n.text.title,
          dataQa: "plugin-blanks-child-text-button"
        }
      ),
      /* @__PURE__ */ c.jsx(
        ef,
        {
          onClick: () => o(Y.SerloTable),
          icon: /* @__PURE__ */ c.jsx(iY, {}),
          title: n.serloTable.title,
          dataQa: "plugin-blanks-child-table-button"
        }
      )
    ] })
  ] });
}
const X7 = v.forwardRef(function(e, t) {
  const { value: n, size: r, className: i, onChange: o, ...a } = e, s = v.useRef(null), [l, u] = v.useState(null);
  return v.useEffect(() => {
    var d;
    (d = s.current) == null || d.setSelectionRange(l, l);
  }, [t, l, n]), /* heavily inspired by Shaw (https://css-tricks.com/auto-growing-inputs-textareas/#aa-other-ideas)
     this needs a data-value on the wrapping element equal to the value of the input
  */
  /* @__PURE__ */ c.jsx(
    "span",
    {
      className: Le(
        "serlo-autogrow-input relative inline-grid",
        "after:w-auto after:min-w-16 after:resize-none after:px-3 after:[grid-area:1_/_2]",
        "after:invisible after:-ml-2 after:whitespace-pre-wrap after:content-[attr(data-value)_'_']"
      ),
      "data-value": String(n) + "_ ",
      children: /* @__PURE__ */ c.jsx(
        "input",
        {
          ref: (d) => {
            s.current = d, typeof t == "function" ? t(d) : t && (t.current = d);
          },
          className: Le(
            "w-auto min-w-[80px] resize-none rounded-full px-3 [grid-area:1_/_2]",
            "border border-brand bg-brand-50 focus:outline focus:outline-1",
            i
          ),
          value: n,
          size: r || 4,
          spellCheck: !1,
          autoCorrect: "off",
          placeholder: "",
          type: "text",
          onChange: (d) => {
            u(d.target.selectionStart), o == null || o(d);
          },
          ...a
        }
      )
    }
  );
});
function Q7(e) {
  const { children: t, tooltipText: n, onRemoveClick: r } = e;
  return /* @__PURE__ */ c.jsxs("div", { className: "relative flex items-center", children: [
    t,
    /* @__PURE__ */ c.jsxs(
      "button",
      {
        className: Le(
          `serlo-tooltip-trigger absolute right-1 h-6 w-6 rounded-full px-1 py-0.5 leading-none text-black
          opacity-50 hover:bg-editor-primary-200 hover:opacity-100 focus:bg-editor-primary-200 focus:opacity-100`
        ),
        onClick: r,
        children: [
          n ? /* @__PURE__ */ c.jsx(vn, { text: n, className: "-top-10" }) : null,
          /* @__PURE__ */ c.jsx(ot, { icon: CT, className: "text-sm" })
        ]
      }
    )
  ] });
}
function sY(e) {
  const { extraDraggableAnswers: t } = e, n = v.useRef(null), r = nt().plugins.blanksExercise, i = t.defined ? t.map(({ answer: d }) => d.value) : [], [o, a] = v.useState(!0);
  function s() {
    setTimeout(() => {
      var d;
      const p = (d = n.current) == null ? void 0 : d.querySelectorAll("input");
      p == null || p[p.length - 1].focus(), a(!0);
    }, 10);
  }
  function l() {
    t.defined ? t.insert() : t.create([{ answer: "" }]), s();
  }
  function u(d) {
    var p, f;
    if (!t.defined) return;
    t.set(
      (y) => y.filter((g, x) => x !== d)
    );
    const m = (p = n.current) == null ? void 0 : p.querySelectorAll("input");
    m && ((f = [...m].at(-2)) == null || f.focus());
  }
  return /* @__PURE__ */ c.jsxs("div", { className: "mt-8 px-8", ref: n, children: [
    i.length > 0 && t.defined ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      r.dummyAnswers,
      ":",
      /* @__PURE__ */ c.jsx("div", { className: "mb-4 mt-1 flex flex-wrap gap-2", children: i.map((d, p) => /* @__PURE__ */ c.jsx(
        Q7,
        {
          tooltipText: r.removeDummyAnswer,
          onRemoveClick: () => {
            u(p);
          },
          children: /* @__PURE__ */ c.jsx(
            X7,
            {
              value: d,
              className: "serlo-input-font-reset focus:border-red-400 focus:outline-red-400",
              onChange: (f) => {
                t[p].answer.set(f.target.value);
              },
              onKeyDown: (f) => {
                if (f.key === "Enter") {
                  if (d.length === 0) return;
                  a(!1), t.insert(), s();
                }
              },
              onBlur: () => {
                o && t.forEach(({ answer: f }, m) => {
                  const y = f.value.trim();
                  y.length ? f.set(y) : u(m);
                });
              }
            }
          )
        },
        p
      )) })
    ] }) : null,
    /* @__PURE__ */ c.jsxs(
      "button",
      {
        onClick: l,
        className: "serlo-button-edit-secondary",
        children: [
          /* @__PURE__ */ c.jsx(ot, { icon: Dc }),
          " ",
          r.addDummyAnswer
        ]
      }
    )
  ] });
}
function Xg(e) {
  const { children: t, accept: n, className: r, onDrop: i } = e, [{ isOver: o }, a] = cd({
    accept: n,
    drop: i,
    collect: (s) => ({
      isOver: s.isOver()
    })
  });
  return /* @__PURE__ */ c.jsx(
    "div",
    {
      className: Le(
        "mb-6 mt-side flex min-h-8 flex-wrap items-stretch gap-2 rounded-xl bg-slate-100 p-side",
        o ? "bg-slate-200" : "",
        r
      ),
      "data-qa": "blank-solution-area",
      ref: a,
      children: t
    }
  );
}
function Lf(e) {
  const { children: t, correct: n, missedSome: r } = e, i = Un().plugins.exercise, o = i[n ? "correct" : r ? "missedSome" : "wrong"];
  return /* @__PURE__ */ c.jsxs("div", { className: "ml-3 mt-1 flex text-lg animate-in fade-in", children: [
    /* @__PURE__ */ c.jsx(
      "span",
      {
        className: "-mt-1 mr-0.5 text-2xl motion-safe:animate-in motion-safe:zoom-in",
        "data-qa": `plugin-exercise-feedback-${n ? "correct" : "incorrect"}`,
        children: n ? "🎉" : "✋"
      }
    ),
    " ",
    /* @__PURE__ */ c.jsx("div", { className: "serlo-p mb-0 ml-1", children: t ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      r && i.missedSome,
      " ",
      t
    ] }) : o })
  ] });
}
function lY(e) {
  const { isVisible: t, feedback: n, isFeedbackVisible: r, onClick: i } = e, o = Un().plugins.exercise;
  if (!t) return null;
  const a = [...n].every((s) => s[1].isCorrect);
  return /* @__PURE__ */ c.jsxs("div", { className: "mx-side mt-5 flex", children: [
    /* @__PURE__ */ c.jsx(
      "button",
      {
        className: "serlo-button-learner-primary mr-3 h-8",
        onClick: i,
        "data-qa": "plugin-exercise-check-answer-button",
        children: o.check
      }
    ),
    r ? /* @__PURE__ */ c.jsx(Lf, { correct: a }) : null
  ] });
}
const Qg = v.createContext(null);
var uY = function(e) {
  return e._tag === "Left";
}, cY = function(e) {
  return { _tag: "Left", left: e };
}, dY = function(e) {
  return { _tag: "Right", right: e };
}, pY = cY, xN = dY, Ro = uY, xn = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), K0 = function() {
  return K0 = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, K0.apply(this, arguments);
}, hd = pY, ao = function(e, t, n) {
  return hd([{ value: e, context: t, message: n }]);
}, Lr = xN, kn = (
  /** @class */
  function() {
    function e(t, n, r, i) {
      this.name = t, this.is = n, this.validate = r, this.encode = i, this.decode = this.decode.bind(this);
    }
    return e.prototype.pipe = function(t, n) {
      var r = this;
      return n === void 0 && (n = "pipe(".concat(this.name, ", ").concat(t.name, ")")), new e(n, t.is, function(i, o) {
        var a = r.validate(i, o);
        return Ro(a) ? a : t.validate(a.right, o);
      }, this.encode === Mn && t.encode === Mn ? Mn : function(i) {
        return r.encode(t.encode(i));
      });
    }, e.prototype.asDecoder = function() {
      return this;
    }, e.prototype.asEncoder = function() {
      return this;
    }, e.prototype.decode = function(t) {
      return this.validate(t, [{ key: "", type: this, actual: t }]);
    }, e;
  }()
), Mn = function(e) {
  return e;
};
function fY(e) {
  return e.displayName || e.name || "<function".concat(e.length, ">");
}
function X0(e, t, n, r) {
  for (var i = e.length, o = Array(i + 1), a = 0; a < i; a++)
    o[a] = e[a];
  return o[i] = { key: t, type: n, actual: r }, o;
}
function Mf(e, t) {
  for (var n = t.length, r = 0; r < n; r++)
    e.push(t[r]);
}
var Q0 = Object.prototype.hasOwnProperty;
function s5(e) {
  return Object.keys(e).map(function(t) {
    return "".concat(t, ": ").concat(e[t].name);
  }).join(", ");
}
function zm(e) {
  for (var t = 0; t < e.length; t++)
    if (e[t].encode !== Mn)
      return !1;
  return !0;
}
function bN(e) {
  return "{ ".concat(s5(e), " }");
}
function wN(e) {
  return "Partial<".concat(e, ">");
}
function hY(e) {
  return "(" + e.map(function(t) {
    return t.name;
  }).join(" | ") + ")";
}
function gw(e, t) {
  for (var n = !0, r = !0, i = !al.is(e), o = 0, a = t; o < a.length; o++) {
    var s = a[o];
    s !== e && (n = !1), al.is(s) && (r = !1);
  }
  if (n)
    return e;
  if (r)
    return t[t.length - 1];
  for (var l = {}, u = 0, d = t; u < d.length; u++) {
    var s = d[u];
    for (var p in s)
      (!Q0.call(l, p) || i || s[p] !== e[p]) && (l[p] = s[p]);
  }
  return l;
}
function l5(e) {
  switch (e._tag) {
    case "RefinementType":
    case "ReadonlyType":
      return l5(e.type);
    case "InterfaceType":
    case "StrictType":
    case "PartialType":
      return e.props;
    case "IntersectionType":
      return e.types.reduce(function(t, n) {
        return Object.assign(t, l5(n));
      }, {});
  }
}
function vw(e, t) {
  for (var n = Object.getOwnPropertyNames(e), r = !1, i = {}, o = 0; o < n.length; o++) {
    var a = n[o];
    Q0.call(t, a) ? i[a] = e[a] : r = !0;
  }
  return r ? i : e;
}
function mY(e) {
  return kN(e) ? "{| ".concat(s5(e.props), " |}") : bY(e) ? wN("{| ".concat(s5(e.props), " |}")) : "Exact<".concat(e.name, ">");
}
function gY(e) {
  return e.length > 0;
}
var So = {};
function CN(e, t) {
  for (var n = [], r = 0, i = e; r < i.length; r++) {
    var o = i[r];
    t.indexOf(o) !== -1 && n.push(o);
  }
  return n;
}
function vY(e, t) {
  if (e === So)
    return t;
  if (t === So)
    return e;
  var n = Object.assign({}, e);
  for (var r in t)
    if (Q0.call(e, r)) {
      var i = CN(e[r], t[r]);
      if (gY(i))
        n[r] = i;
      else {
        n = So;
        break;
      }
    } else
      n[r] = t[r];
  return n;
}
function yY(e, t) {
  if (e === So || t === So)
    return So;
  var n = So;
  for (var r in e)
    if (Q0.call(t, r)) {
      var i = CN(e[r], t[r]);
      i.length === 0 && (n === So && (n = {}), n[r] = e[r].concat(t[r]));
    }
  return n;
}
function xY(e) {
  return e._tag === "LiteralType";
}
function kN(e) {
  return e._tag === "InterfaceType";
}
function bY(e) {
  return e._tag === "PartialType";
}
function wY(e) {
  return e._tag === "StrictType";
}
function CY(e) {
  return e._tag === "ExactType";
}
function kY(e) {
  return e._tag === "RefinementType";
}
function EY(e) {
  return e._tag === "IntersectionType";
}
function SY(e) {
  return e._tag === "UnionType";
}
function DY(e) {
  return e._tag === "RecursiveType";
}
var P4 = [];
function oc(e) {
  if (P4.indexOf(e) !== -1)
    return So;
  if (kN(e) || wY(e)) {
    var t = So;
    for (var n in e.props) {
      var r = e.props[n];
      xY(r) && (t === So && (t = {}), t[n] = [r.value]);
    }
    return t;
  } else {
    if (CY(e) || kY(e))
      return oc(e.type);
    if (EY(e))
      return e.types.reduce(function(o, a) {
        return vY(o, oc(a));
      }, So);
    if (SY(e))
      return e.types.slice(1).reduce(function(o, a) {
        return yY(o, oc(a));
      }, oc(e.types[0]));
    if (DY(e)) {
      P4.push(e);
      var i = oc(e.type);
      return P4.pop(), i;
    }
  }
  return So;
}
function AY(e) {
  var t = oc(e[0]), n = Object.keys(t), r = e.length, i = function(u) {
    for (var d = t[u].slice(), p = [t[u]], f = 1; f < r; f++) {
      var m = e[f], y = oc(m), g = y[u];
      if (g === void 0 || g.some(function(x) {
        return d.indexOf(x) !== -1;
      }))
        return "continue-keys";
      d.push.apply(d, g), p.push(g);
    }
    return { value: [u, p] };
  };
  e: for (var o = 0, a = n; o < a.length; o++) {
    var s = a[o], l = i(s);
    if (typeof l == "object")
      return l.value;
    switch (l) {
      case "continue-keys":
        continue e;
    }
  }
}
var TY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      var n = e.call(this, "null", function(r) {
        return r === null;
      }, function(r, i) {
        return n.is(r) ? Lr(r) : ao(r, i);
      }, Mn) || this;
      return n._tag = "NullType", n;
    }
    return t;
  }(kn)
), $d = new TY(), jY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      var n = e.call(this, "undefined", function(r) {
        return r === void 0;
      }, function(r, i) {
        return n.is(r) ? Lr(r) : ao(r, i);
      }, Mn) || this;
      return n._tag = "UndefinedType", n;
    }
    return t;
  }(kn)
), y0 = new jY(), NY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      var n = e.call(this, "void", y0.is, y0.validate, Mn) || this;
      return n._tag = "VoidType", n;
    }
    return t;
  }(kn)
);
new NY();
var OY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      var n = e.call(this, "unknown", function(r) {
        return !0;
      }, Lr, Mn) || this;
      return n._tag = "UnknownType", n;
    }
    return t;
  }(kn)
), Y7 = new OY(), zY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      var n = e.call(this, "string", function(r) {
        return typeof r == "string";
      }, function(r, i) {
        return n.is(r) ? Lr(r) : ao(r, i);
      }, Mn) || this;
      return n._tag = "StringType", n;
    }
    return t;
  }(kn)
), Cr = new zY(), FY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      var n = e.call(this, "number", function(r) {
        return typeof r == "number";
      }, function(r, i) {
        return n.is(r) ? Lr(r) : ao(r, i);
      }, Mn) || this;
      return n._tag = "NumberType", n;
    }
    return t;
  }(kn)
), EN = new FY(), LY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      var n = e.call(
        this,
        "bigint",
        // tslint:disable-next-line: valid-typeof
        function(r) {
          return typeof r == "bigint";
        },
        function(r, i) {
          return n.is(r) ? Lr(r) : ao(r, i);
        },
        Mn
      ) || this;
      return n._tag = "BigIntType", n;
    }
    return t;
  }(kn)
);
new LY();
var MY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      var n = e.call(this, "boolean", function(r) {
        return typeof r == "boolean";
      }, function(r, i) {
        return n.is(r) ? Lr(r) : ao(r, i);
      }, Mn) || this;
      return n._tag = "BooleanType", n;
    }
    return t;
  }(kn)
), BY = new MY(), IY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      var n = e.call(this, "UnknownArray", Array.isArray, function(r, i) {
        return n.is(r) ? Lr(r) : ao(r, i);
      }, Mn) || this;
      return n._tag = "AnyArrayType", n;
    }
    return t;
  }(kn)
), yw = new IY(), RY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      var n = e.call(this, "UnknownRecord", function(r) {
        return r !== null && typeof r == "object" && !Array.isArray(r);
      }, function(r, i) {
        return n.is(r) ? Lr(r) : ao(r, i);
      }, Mn) || this;
      return n._tag = "AnyDictionaryType", n;
    }
    return t;
  }(kn)
), al = new RY(), PY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t(n, r, i, o, a) {
      var s = e.call(this, n, r, i, o) || this;
      return s.value = a, s._tag = "LiteralType", s;
    }
    return t;
  }(kn)
);
function mi(e, t) {
  t === void 0 && (t = JSON.stringify(e));
  var n = function(r) {
    return r === e;
  };
  return new PY(t, n, function(r, i) {
    return n(r) ? Lr(e) : ao(r, i);
  }, Mn, e);
}
(function(e) {
  xn(t, e);
  function t(n, r, i, o, a) {
    var s = e.call(this, n, r, i, o) || this;
    return s.keys = a, s._tag = "KeyofType", s;
  }
  return t;
})(kn);
var _Y = (
  /** @class */
  function(e) {
    xn(t, e);
    function t(n, r, i, o, a, s) {
      var l = e.call(this, n, r, i, o) || this;
      return l.type = a, l.predicate = s, l._tag = "RefinementType", l;
    }
    return t;
  }(kn)
);
function qY(e, t, n) {
  return jN(e, t, n);
}
qY(EN, function(e) {
  return Number.isInteger(e);
}, "Int");
var $Y = (
  /** @class */
  function(e) {
    xn(t, e);
    function t(n, r, i, o, a) {
      var s = e.call(this, n, r, i, o) || this;
      return s.runDefinition = a, s._tag = "RecursiveType", s;
    }
    return t;
  }(kn)
);
Object.defineProperty($Y.prototype, "type", {
  get: function() {
    return this.runDefinition();
  },
  enumerable: !0,
  configurable: !0
});
var HY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t(n, r, i, o, a) {
      var s = e.call(this, n, r, i, o) || this;
      return s.type = a, s._tag = "ArrayType", s;
    }
    return t;
  }(kn)
);
function SN(e, t) {
  return t === void 0 && (t = "Array<".concat(e.name, ">")), new HY(t, function(n) {
    return yw.is(n) && n.every(e.is);
  }, function(n, r) {
    var i = yw.validate(n, r);
    if (Ro(i))
      return i;
    for (var o = i.right, a = o.length, s = o, l = [], u = 0; u < a; u++) {
      var d = o[u], p = e.validate(d, X0(r, String(u), e, d));
      if (Ro(p))
        Mf(l, p.left);
      else {
        var f = p.right;
        f !== d && (s === o && (s = o.slice()), s[u] = f);
      }
    }
    return l.length > 0 ? hd(l) : Lr(s);
  }, e.encode === Mn ? Mn : function(n) {
    return n.map(e.encode);
  }, e);
}
var VY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t(n, r, i, o, a) {
      var s = e.call(this, n, r, i, o) || this;
      return s.props = a, s._tag = "InterfaceType", s;
    }
    return t;
  }(kn)
);
function Do(e, t) {
  t === void 0 && (t = bN(e));
  var n = Object.keys(e), r = n.map(function(o) {
    return e[o];
  }), i = n.length;
  return new VY(t, function(o) {
    if (al.is(o)) {
      for (var a = 0; a < i; a++) {
        var s = n[a], l = o[s];
        if (l === void 0 && !Q0.call(o, s) || !r[a].is(l))
          return !1;
      }
      return !0;
    }
    return !1;
  }, function(o, a) {
    var s = al.validate(o, a);
    if (Ro(s))
      return s;
    for (var l = s.right, u = l, d = [], p = 0; p < i; p++) {
      var f = n[p], m = u[f], y = r[p], g = y.validate(m, X0(a, f, y, m));
      if (Ro(g))
        Mf(d, g.left);
      else {
        var x = g.right;
        (x !== m || x === void 0 && !Q0.call(u, f)) && (u === l && (u = K0({}, l)), u[f] = x);
      }
    }
    return d.length > 0 ? hd(d) : Lr(u);
  }, zm(r) ? Mn : function(o) {
    for (var a = K0({}, o), s = 0; s < i; s++) {
      var l = n[s], u = r[s].encode;
      u !== Mn && (a[l] = u(o[l]));
    }
    return a;
  }, e);
}
var UY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t(n, r, i, o, a) {
      var s = e.call(this, n, r, i, o) || this;
      return s.props = a, s._tag = "PartialType", s;
    }
    return t;
  }(kn)
);
function DN(e, t) {
  t === void 0 && (t = wN(bN(e)));
  var n = Object.keys(e), r = n.map(function(o) {
    return e[o];
  }), i = n.length;
  return new UY(t, function(o) {
    if (al.is(o)) {
      for (var a = 0; a < i; a++) {
        var s = n[a], l = o[s];
        if (l !== void 0 && !e[s].is(l))
          return !1;
      }
      return !0;
    }
    return !1;
  }, function(o, a) {
    var s = al.validate(o, a);
    if (Ro(s))
      return s;
    for (var l = s.right, u = l, d = [], p = 0; p < i; p++) {
      var f = n[p], m = u[f], y = e[f], g = y.validate(m, X0(a, f, y, m));
      if (Ro(g))
        m !== void 0 && Mf(d, g.left);
      else {
        var x = g.right;
        x !== m && (u === l && (u = K0({}, l)), u[f] = x);
      }
    }
    return d.length > 0 ? hd(d) : Lr(u);
  }, zm(r) ? Mn : function(o) {
    for (var a = K0({}, o), s = 0; s < i; s++) {
      var l = n[s], u = o[l];
      u !== void 0 && (a[l] = r[s].encode(u));
    }
    return a;
  }, e);
}
(function(e) {
  xn(t, e);
  function t(n, r, i, o, a, s) {
    var l = e.call(this, n, r, i, o) || this;
    return l.domain = a, l.codomain = s, l._tag = "DictionaryType", l;
  }
  return t;
})(kn);
var AN = (
  /** @class */
  function(e) {
    xn(t, e);
    function t(n, r, i, o, a) {
      var s = e.call(this, n, r, i, o) || this;
      return s.types = a, s._tag = "UnionType", s;
    }
    return t;
  }(kn)
);
function i0(e, t) {
  t === void 0 && (t = hY(e));
  var n = AY(e);
  if (n !== void 0 && e.length > 0) {
    var r = n[0], i = n[1], o = i.length, a = function(s) {
      for (var l = 0; l < o; l++)
        if (i[l].indexOf(s) !== -1)
          return l;
    };
    return new YY(t, function(s) {
      if (al.is(s)) {
        var l = a(s[r]);
        return l !== void 0 ? e[l].is(s) : !1;
      }
      return !1;
    }, function(s, l) {
      var u = al.validate(s, l);
      if (Ro(u))
        return u;
      var d = u.right, p = a(d[r]);
      if (p === void 0)
        return ao(s, l);
      var f = e[p];
      return f.validate(d, X0(l, String(p), f, d));
    }, zm(e) ? Mn : function(s) {
      var l = a(s[r]);
      if (l === void 0)
        throw new Error("no codec found to encode value in union codec ".concat(t));
      return e[l].encode(s);
    }, e, r);
  } else
    return new AN(t, function(s) {
      return e.some(function(l) {
        return l.is(s);
      });
    }, function(s, l) {
      for (var u = [], d = 0; d < e.length; d++) {
        var p = e[d], f = p.validate(s, X0(l, String(d), p, s));
        if (Ro(f))
          Mf(u, f.left);
        else
          return Lr(f.right);
      }
      return hd(u);
    }, zm(e) ? Mn : function(s) {
      for (var l = 0, u = e; l < u.length; l++) {
        var d = u[l];
        if (d.is(s))
          return d.encode(s);
      }
      throw new Error("no codec found to encode value in union type ".concat(t));
    }, e);
}
var WY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t(n, r, i, o, a) {
      var s = e.call(this, n, r, i, o) || this;
      return s.types = a, s._tag = "IntersectionType", s;
    }
    return t;
  }(kn)
);
function TN(e, t) {
  t === void 0 && (t = "(".concat(e.map(function(r) {
    return r.name;
  }).join(" & "), ")"));
  var n = e.length;
  return new WY(t, function(r) {
    return e.every(function(i) {
      return i.is(r);
    });
  }, e.length === 0 ? Lr : function(r, i) {
    for (var o = [], a = [], s = 0; s < n; s++) {
      var l = e[s], u = l.validate(r, X0(i, String(s), l, r));
      Ro(u) ? Mf(a, u.left) : o.push(u.right);
    }
    return a.length > 0 ? hd(a) : Lr(gw(r, o));
  }, e.length === 0 ? Mn : function(r) {
    return gw(r, e.map(function(i) {
      return i.encode(r);
    }));
  }, e);
}
(function(e) {
  xn(t, e);
  function t(n, r, i, o, a) {
    var s = e.call(this, n, r, i, o) || this;
    return s.types = a, s._tag = "TupleType", s;
  }
  return t;
})(kn);
(function(e) {
  xn(t, e);
  function t(n, r, i, o, a) {
    var s = e.call(this, n, r, i, o) || this;
    return s.type = a, s._tag = "ReadonlyType", s;
  }
  return t;
})(kn);
(function(e) {
  xn(t, e);
  function t(n, r, i, o, a) {
    var s = e.call(this, n, r, i, o) || this;
    return s.type = a, s._tag = "ReadonlyArrayType", s;
  }
  return t;
})(kn);
var xw = function(e, t) {
  return GY(Do(e), t);
}, ZY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t(n, r, i, o, a) {
      var s = e.call(this, n, r, i, o) || this;
      return s.type = a, s._tag = "ExactType", s;
    }
    return t;
  }(kn)
);
function GY(e, t) {
  t === void 0 && (t = mY(e));
  var n = l5(e);
  return new ZY(t, e.is, function(r, i) {
    var o = al.validate(r, i);
    if (Ro(o))
      return o;
    var a = e.validate(r, i);
    return Ro(a) ? a : xN(vw(a.right, n));
  }, function(r) {
    return e.encode(vw(r, n));
  }, e);
}
var KY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      var n = e.call(
        this,
        "Function",
        // tslint:disable-next-line:strict-type-predicates
        function(r) {
          return typeof r == "function";
        },
        function(r, i) {
          return n.is(r) ? Lr(r) : ao(r, i);
        },
        Mn
      ) || this;
      return n._tag = "FunctionType", n;
    }
    return t;
  }(kn)
);
new KY();
var XY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      var n = e.call(
        this,
        "never",
        function(r) {
          return !1;
        },
        function(r, i) {
          return ao(r, i);
        },
        /* istanbul ignore next */
        function() {
          throw new Error("cannot encode never");
        }
      ) || this;
      return n._tag = "NeverType", n;
    }
    return t;
  }(kn)
);
new XY();
var QY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      var n = e.call(this, "any", function(r) {
        return !0;
      }, Lr, Mn) || this;
      return n._tag = "AnyType", n;
    }
    return t;
  }(kn)
);
new QY();
function jN(e, t, n) {
  return n === void 0 && (n = "(".concat(e.name, " | ").concat(fY(t), ")")), new _Y(n, function(r) {
    return e.is(r) && t(r);
  }, function(r, i) {
    var o = e.validate(r, i);
    if (Ro(o))
      return o;
    var a = o.right;
    return t(a) ? Lr(a) : ao(a, i);
  }, e.encode, e, t);
}
jN(EN, Number.isInteger, "Integer");
var YY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t(n, r, i, o, a, s) {
      var l = e.call(this, n, r, i, o, a) || this;
      return l.tag = s, l;
    }
    return t;
  }(AN)
), JY = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      var n = e.call(this, "object", function(r) {
        return r !== null && typeof r == "object";
      }, function(r, i) {
        return n.is(r) ? Lr(r) : ao(r, i);
      }, Mn) || this;
      return n._tag = "ObjectType", n;
    }
    return t;
  }(kn)
);
new JY();
(function(e) {
  xn(t, e);
  function t(n, r, i, o, a) {
    var s = e.call(this, n, r, i, o) || this;
    return s.props = a, s._tag = "StrictType", s;
  }
  return t;
})(kn);
const eJ = Do({ answer: Cr }), tJ = TN([
  // These props have been present from the beginning, and are therefore required
  Do({
    type: mi("textBlank"),
    children: Y7,
    blankId: Cr,
    correctAnswers: SN(eJ)
  }),
  // These props have been added later, and are therefore optional. They could be
  // made required, if a DB migration was done to populate all Blanks with them.
  DN({
    acceptMathEquivalents: BY
    // Here we could specify incorrect answers for this blank with specific learner feedback
    // incorrectAnswers?: Answer[]
    // Here we could add a default feedback for the learner
    // defaultIncorrectAnswerFeedback: string
  })
]), nJ = v.lazy(
  () => Promise.resolve().then(() => $G).then((e) => ({
    default: e.DndWrapper
  }))
);
function NN({
  childPlugin: e,
  childPluginState: t,
  mode: n,
  extraDraggableAnswers: r,
  initialTextInBlank: i,
  isEditing: o,
  onEvaluate: a
}) {
  const [s, l] = v.useState(!1), [u, d] = v.useState(
    /* @__PURE__ */ new Map()
  ), p = v.useMemo(() => ON(t), [t]), f = v.useMemo(() => p.filter((ne) => {
    const fe = ne.correctAnswers.at(0);
    return fe !== void 0 && fe.answer.trim().length > 0;
  }), [p]), [m, y] = v.useState(
    /* @__PURE__ */ new Map()
  ), [g, x] = v.useState(null);
  v.useEffect(() => void import("./index-JJhwGXE--D5U5lyUP.js").then((ne) => x(ne)), []);
  const E = v.useMemo(() => {
    const ne = /* @__PURE__ */ new Map();
    return p.forEach((fe) => {
      var D;
      const j = ((D = fe.correctAnswers.at(0)) == null ? void 0 : D.answer) ?? "";
      ne.set(fe.blankId, {
        text: i === "correct-answer" ? j : ""
      });
    }), m.forEach(
      (fe, D) => ne.set(D, { text: fe.text })
    ), ne;
  }, [p, m, i]), b = v.useMemo(() => {
    const ne = f.map(
      ({ blankId: D, correctAnswers: j }) => {
        var de;
        return {
          draggableId: `solution-${D}`,
          text: (de = j[0]) == null ? void 0 : de.answer
        };
      }
    );
    if (o) return ne;
    const fe = (r == null ? void 0 : r.map(({ answer: D }) => ({
      draggableId: fa(),
      text: D
    }))) ?? [];
    return [...ne, ...fe].map((D) => ({ draggable: D, sort: Math.random() })).sort((D, j) => D.sort - j.sort).map(({ draggable: D }) => D);
  }, [r, f, o]), [C, T] = v.useState(
    /* @__PURE__ */ new Map()
  ), z = v.useCallback(
    (ne) => {
      const fe = new Map(C);
      fe.delete(ne.draggableId), T(fe), d(
        /* @__PURE__ */ new Map()
      ), l(!1);
    },
    [C]
  ), I = v.useMemo(() => f.length === 0 ? !1 : f.every((ne) => {
    if (n === "typing") {
      const fe = E.get(ne.blankId);
      return fe !== void 0 && fe.text.length > 0;
    }
    if (n === "drag-and-drop")
      return [...C].some(
        (fe) => fe[1] === ne.blankId
      );
  }), [f, C, n, E]);
  v.useEffect(() => {
    y(/* @__PURE__ */ new Map()), T(/* @__PURE__ */ new Map()), d(/* @__PURE__ */ new Map()), l(!1);
  }, [t.plugin]);
  const [w, M] = v.useState(!1);
  if (v.useEffect(() => {
    M(!0);
  }, []), !w)
    return null;
  return /* @__PURE__ */ c.jsx(v.Suspense, { fallback: /* @__PURE__ */ c.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ c.jsx(nJ, { children: /* @__PURE__ */ c.jsxs(
    "div",
    {
      className: Le(
        "mb-block",
        // Increase Slate line height in the editor
        '[&>div>div>div[data-slate-node="element"]]:leading-[30px]',
        // Increase Slate line height in the renderer
        "[&>p]:leading-[30px]"
      ),
      children: [
        /* @__PURE__ */ c.jsx(
          Qg.Provider,
          {
            value: {
              mode: n,
              feedbackForBlanks: {
                value: u,
                set: d
              },
              textInBlanks: E,
              textUserTypedIntoBlanks: {
                value: m,
                set: y
              },
              draggables: b,
              locationOfDraggables: {
                value: C,
                set: T
              },
              isFeedbackVisible: {
                value: s,
                set: l
              }
            },
            children: e
          }
        ),
        n === "drag-and-drop" ? /* @__PURE__ */ c.jsx(
          Xg,
          {
            accept: Hg,
            onDrop: z,
            className: "mx-side",
            children: b.map(
              (ne, fe) => C.get(ne.draggableId) ? null : /* @__PURE__ */ c.jsx(ij, { ...ne }, fe)
            )
          }
        ) : null,
        o ? null : /* @__PURE__ */ c.jsx(
          lY,
          {
            isVisible: I,
            feedback: u,
            isFeedbackVisible: s,
            onClick: R
          }
        )
      ]
    }
  ) }) });
  function R() {
    const ne = /* @__PURE__ */ new Map();
    f.forEach((fe) => {
      const D = F(fe.blankId), j = fe.correctAnswers.some(({ answer: de }) => {
        if (de === D) return !0;
        if (fe.acceptMathEquivalents === !1) return !1;
        const ye = W(de), Ne = W(D);
        return !ye || !Ne ? !1 : ye - Ne === 0;
      });
      ne.set(fe.blankId, { isCorrect: j });
    }), a == null || a(
      [...ne].every((fe) => fe[1].isCorrect)
    ), d(ne), l(!0);
  }
  function F(ne) {
    var fe;
    if (n === "typing") return ((fe = E.get(ne)) == null ? void 0 : fe.text.trim()) ?? "";
    const D = [...C].find(
      ([, de]) => ne === de
    ), j = b.find(
      ({ draggableId: de }) => de === (D == null ? void 0 : D[0])
    );
    return (j == null ? void 0 : j.text.trim()) ?? "";
  }
  function W(ne) {
    const fe = X(ne);
    try {
      return g == null ? void 0 : g.evaluate(le(fe));
    } catch {
      return;
    }
  }
  function X(ne) {
    return ne.replace(/[\s\xa0]+/g, " ").trim();
  }
  function le(ne) {
    return ne.replace(/,/g, ".").replace(/^[+]/, "");
  }
}
function ON(e) {
  return tJ.is(e) ? [e] : Object.values(e).reduce((t, n) => typeof n == "object" && n !== null ? [...t, ...ON(n)] : t, []);
}
const rJ = "editorLearnerEvent", ii = /* @__PURE__ */ function() {
  let e = null;
  function t(r) {
    e || (e = r, Object.freeze(e));
  }
  function n(r) {
    e == null || e(r);
    const i = new CustomEvent(rJ, {
      detail: { ...r }
    });
    document.dispatchEvent(i);
  }
  return { init: t, trigger: n };
}();
function zN({
  id: e,
  state: { text: t, mode: n, extraDraggableAnswers: r }
}) {
  return /* @__PURE__ */ c.jsx(
    NN,
    {
      childPlugin: /* @__PURE__ */ c.jsx(Nn, { document: t }),
      childPluginState: t,
      mode: n,
      initialTextInBlank: "empty",
      extraDraggableAnswers: r,
      onEvaluate: (i) => {
        var o;
        (o = ii.trigger) == null || o.call(ii, {
          pluginId: e,
          verb: "answered",
          correct: i,
          contentType: "blanks-exercise"
        });
      }
    }
  );
}
function Yg({
  containerRef: e,
  children: t
}) {
  var n;
  if (!e || !e.current) return null;
  const r = (n = e.current.closest(".plugin-exercise")) == null ? void 0 : n.querySelector(".exercise-toolbar-interactive-target");
  return r ? ms.createPortal(
    /* @__PURE__ */ c.jsxs("div", { className: "flex", children: [
      /* @__PURE__ */ c.jsx("div", { className: "mr-2 h-6 w-[2px] bg-gray-300" }),
      t
    ] }),
    r
  ) : null;
}
const iJ = ({
  state: e,
  childPluginType: t,
  containerRef: n,
  showSelection: r
}) => {
  const i = nt().plugins, o = i.exercise, a = i.blanksExercise;
  return /* @__PURE__ */ c.jsx(Yg, { containerRef: n, children: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      fs,
      {
        tooltipText: a.chooseType,
        value: e.mode.value,
        dataQa: "plugin-blanks-mode-switch",
        changeValue: (s) => e.mode.set(s),
        options: [
          { value: "typing", text: a.modes.typing },
          {
            value: "drag-and-drop",
            text: a.modes["drag-and-drop"]
          }
        ]
      }
    ),
    r ? null : /* @__PURE__ */ c.jsx(
      fs,
      {
        tooltipText: a.chooseChildPluginType,
        value: t,
        dataQa: "plugin-blanks-child-plugin-switch",
        changeValue: (s) => {
          window.confirm(o.confirmRemoveInteractive) && e.text.replace(s);
        },
        options: [
          {
            value: Y.Text,
            text: i.text.title
          },
          {
            value: Y.SerloTable,
            text: i.serloTable.title
          }
        ]
      }
    )
  ] }) });
}, FN = v.createContext(!1), oJ = FN.Provider;
function Jg() {
  return v.useContext(FN);
}
var Us = /* @__PURE__ */ ((e) => (e.Applet = "type-applet", e.Article = "type-article", e.Course = "type-course", e.Event = "type-event", e.Page = "type-page", e.Taxonomy = "type-taxonomy", e.TextExercise = "type-text-exercise", e.Exercise = "type-text-exercise", e.TextExerciseGroup = "type-text-exercise-group", e.ExerciseGroup = "type-text-exercise-group", e.Video = "type-video", e.User = "type-user", e.GenericContent = "type-generic-content", e))(Us || {});
function LN(e) {
  return e.plugin === Y.Exercise;
}
function Bf(e) {
  return e.plugin === Y.Image;
}
function MN(e) {
  return (e == null ? void 0 : e.plugin) === Y.Rows;
}
function e2(e) {
  return e.plugin === Y.Text;
}
function bw(e) {
  return !e || !e.text ? !0 : e.text.trim().length === 0;
}
function aJ(e) {
  return Object.hasOwn(e, "src") && e.src.trim().length === 0;
}
function BN(e) {
  return Object.hasOwn(e, "type") ? e.type === "p" ? e.children.every(BN) : e.type === "a" || e.type === "h" ? e.children.every(bw) : e.type === "math" ? aJ(e) : !1 : bw(e);
}
function io(e) {
  if (!e) return !0;
  if (!e2(e)) return !1;
  const t = e.state;
  return !t || !t.length ? !0 : t.every(BN);
}
const sJ = [
  tt.code,
  tt.links,
  tt.math,
  tt.textBlank
], lJ = [
  tt.code,
  tt.colors,
  tt.links,
  tt.lists,
  tt.math,
  tt.richTextBold,
  tt.richTextItalic,
  tt.textBlank
];
function uJ(e) {
  const { focused: t, id: n, state: r } = e, { text: i, mode: o, extraDraggableAnswers: a } = r, s = Jg(), l = nt().plugins.blanksExercise, u = yn(
    (E) => cs(E, i.id)
  ), d = yn((E) => li(E, i.id)), p = yn(
    (E) => li(E, n)
  ), [f, m] = v.useState(
    io(p.state.text)
  ), y = v.useMemo(() => {
    if (d.plugin === Y.Text)
      return { placeholder: l.placeholder };
    if (d.plugin === Y.SerloTable)
      return { headerTextFormattingOptions: sJ, cellTextFormattingOptions: lJ };
  }, [d.plugin, l.placeholder]);
  if (!d || !p) return null;
  return /* @__PURE__ */ c.jsxs(
    "div",
    {
      className: Le(
        "group/blanks-exercise mb-12 pb-6",
        "border-3 border-transparent focus-within:rounded-xl focus-within:border-gray-100",
        t && "!border-gray-100"
      ),
      "data-qa": "plugin-blanks-exercise",
      children: [
        /* @__PURE__ */ c.jsx(
          iJ,
          {
            ...e,
            childPluginType: d.plugin,
            showSelection: f
          }
        ),
        s ? /* @__PURE__ */ c.jsx(zN, { ...p }) : f ? x() : g()
      ]
    }
  );
  function g() {
    return /* @__PURE__ */ c.jsxs("div", { className: "relative mt-12", children: [
      /* @__PURE__ */ c.jsx(
        NN,
        {
          isEditing: !0,
          childPlugin: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
            u ? /* @__PURE__ */ c.jsx(
              Ci,
              {
                pluginType: Y.Text,
                className: "!-top-12 !left-0",
                noWhiteShadow: !0
              }
            ) : null,
            i.render({ config: y })
          ] }),
          childPluginState: d,
          extraDraggableAnswers: p.state.extraDraggableAnswers,
          mode: o.value,
          initialTextInBlank: "correct-answer"
        }
      ),
      o.value === "drag-and-drop" ? /* @__PURE__ */ c.jsx(
        sY,
        {
          extraDraggableAnswers: a
        }
      ) : null
    ] });
  }
  function x() {
    return /* @__PURE__ */ c.jsx(
      aY,
      {
        childPlugin: i,
        setShowSelection: m
      }
    );
  }
}
const cJ = ln({
  // text can also be a table plugin
  text: Vn({
    plugin: Y.Text,
    config: {
      formattingOptions: [
        tt.code,
        tt.colors,
        tt.lists,
        tt.richTextBold,
        tt.richTextItalic,
        tt.textBlank,
        tt.math
      ],
      isInlineChildEditor: !0
    }
  }),
  mode: rn("typing"),
  extraDraggableAnswers: qr($a(ln({ answer: rn() })))
});
function dJ() {
  return {
    Component: uJ,
    state: cJ,
    config: {}
  };
}
function IN(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
const pJ = (e) => Array.isArray(e);
function u5(e) {
  return typeof e == "string" || Array.isArray(e);
}
function ww(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function fJ(e, t, n, r) {
  if (typeof t == "function") {
    const [i, o] = ww(r);
    t = t(n !== void 0 ? n : e.custom, i, o);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [i, o] = ww(r);
    t = t(n !== void 0 ? n : e.custom, i, o);
  }
  return t;
}
const hJ = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], mJ = ["initial", ...hJ], t2 = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], RN = new Set(t2), gJ = {
  skipAnimations: !1,
  useManualTiming: !1
}, vJ = (e) => e;
function yJ(e) {
  let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, i = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function s(u) {
    o.has(u) && (l.schedule(u), e()), u(a);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (u, d = !1, p = !1) => {
      const f = p && r ? t : n;
      return d && o.add(u), f.has(u) || f.add(u), u;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (u) => {
      n.delete(u), o.delete(u);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (u) => {
      if (a = u, r) {
        i = !0;
        return;
      }
      r = !0, [t, n] = [n, t], n.clear(), t.forEach(s), r = !1, i && (i = !1, l.process(u));
    }
  };
  return l;
}
const $h = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], xJ = 40;
function PN(e, t) {
  let n = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, o = () => n = !0, a = $h.reduce((g, x) => (g[x] = yJ(o), g), {}), { read: s, resolveKeyframes: l, update: u, preRender: d, render: p, postRender: f } = a, m = () => {
    const g = gJ.useManualTiming ? i.timestamp : performance.now();
    n = !1, i.delta = r ? 1e3 / 60 : Math.max(Math.min(g - i.timestamp, xJ), 1), i.timestamp = g, i.isProcessing = !0, s.process(i), l.process(i), u.process(i), d.process(i), p.process(i), f.process(i), i.isProcessing = !1, n && t && (r = !1, e(m));
  }, y = () => {
    n = !0, r = !0, i.isProcessing || e(m);
  };
  return { schedule: $h.reduce((g, x) => {
    const E = a[x];
    return g[x] = (b, C = !1, T = !1) => (n || y(), E.schedule(b, C, T)), g;
  }, {}), cancel: (g) => {
    for (let x = 0; x < $h.length; x++)
      a[$h[x]].cancel(g);
  }, state: i, steps: a };
}
const { schedule: Cw, cancel: n7e, state: r7e, steps: i7e } = PN(typeof requestAnimationFrame < "u" ? requestAnimationFrame : vJ, !0), _N = (e) => (t) => typeof t == "string" && t.startsWith(e), bJ = /* @__PURE__ */ _N("--"), wJ = /* @__PURE__ */ _N("var(--"), o7e = (e) => wJ(e) ? CJ.test(e.split("/*")[0].trim()) : !1, CJ = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, kJ = (e, t, n) => n > t ? t : n < e ? e : n, J7 = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, c5 = {
  ...J7,
  transform: (e) => kJ(0, 1, e)
}, Hh = {
  ...J7,
  default: 1
}, If = (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), Wu = /* @__PURE__ */ If("deg"), _4 = /* @__PURE__ */ If("%"), $t = /* @__PURE__ */ If("px"), a7e = /* @__PURE__ */ If("vh"), s7e = /* @__PURE__ */ If("vw"), kw = {
  ..._4,
  parse: (e) => _4.parse(e) / 100,
  transform: (e) => _4.transform(e * 100)
}, EJ = {
  // Border props
  borderWidth: $t,
  borderTopWidth: $t,
  borderRightWidth: $t,
  borderBottomWidth: $t,
  borderLeftWidth: $t,
  borderRadius: $t,
  radius: $t,
  borderTopLeftRadius: $t,
  borderTopRightRadius: $t,
  borderBottomRightRadius: $t,
  borderBottomLeftRadius: $t,
  // Positioning props
  width: $t,
  maxWidth: $t,
  height: $t,
  maxHeight: $t,
  top: $t,
  right: $t,
  bottom: $t,
  left: $t,
  // Spacing props
  padding: $t,
  paddingTop: $t,
  paddingRight: $t,
  paddingBottom: $t,
  paddingLeft: $t,
  margin: $t,
  marginTop: $t,
  marginRight: $t,
  marginBottom: $t,
  marginLeft: $t,
  // Misc
  backgroundPositionX: $t,
  backgroundPositionY: $t
}, SJ = {
  rotate: Wu,
  rotateX: Wu,
  rotateY: Wu,
  rotateZ: Wu,
  scale: Hh,
  scaleX: Hh,
  scaleY: Hh,
  scaleZ: Hh,
  skew: Wu,
  skewX: Wu,
  skewY: Wu,
  distance: $t,
  translateX: $t,
  translateY: $t,
  translateZ: $t,
  x: $t,
  y: $t,
  z: $t,
  perspective: $t,
  transformPerspective: $t,
  opacity: c5,
  originX: kw,
  originY: kw,
  originZ: $t
}, Ew = {
  ...J7,
  transform: Math.round
}, qN = {
  ...EJ,
  ...SJ,
  zIndex: Ew,
  size: $t,
  // SVG
  fillOpacity: c5,
  strokeOpacity: c5,
  numOctaves: Ew
}, DJ = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), l7e = (e) => pJ(e) ? e[e.length - 1] || 0 : e, $N = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), AJ = "framerAppearId", TJ = "data-" + $N(AJ), jc = (e) => !!(e && e.getVelocity);
function HN(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
const VN = v.createContext(null), jJ = v.createContext({}), NJ = v.createContext({}), UN = {};
function u7e(e) {
  Object.assign(UN, e);
}
const { schedule: OJ, cancel: c7e } = PN(queueMicrotask, !1);
function zJ(e) {
  const t = jc(e) ? e.get() : e;
  return DJ(t) ? t.toValue() : t;
}
const WN = v.createContext({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), n2 = v.createContext({}), ZN = typeof window < "u", FJ = ZN ? v.useLayoutEffect : v.useEffect, ey = v.createContext({ strict: !1 });
function LJ(e, t, n, r, i) {
  var o, a;
  const { visualElement: s } = v.useContext(n2), l = v.useContext(ey), u = v.useContext(VN), d = v.useContext(WN).reducedMotion, p = v.useRef();
  r = r || l.renderer, !p.current && r && (p.current = r(e, {
    visualState: t,
    parent: s,
    props: n,
    presenceContext: u,
    blockInitialAnimation: u ? u.initial === !1 : !1,
    reducedMotionConfig: d
  }));
  const f = p.current, m = v.useContext(NJ);
  f && !f.projection && i && (f.type === "html" || f.type === "svg") && MJ(p.current, n, i, m);
  const y = v.useRef(!1);
  v.useInsertionEffect(() => {
    f && y.current && f.update(n, u);
  });
  const g = n[TJ], x = v.useRef(!!g && !(!((o = window.MotionHandoffIsComplete) === null || o === void 0) && o.call(window, g)) && ((a = window.MotionHasOptimisedAnimation) === null || a === void 0 ? void 0 : a.call(window, g)));
  return FJ(() => {
    f && (y.current = !0, window.MotionIsMounted = !0, f.updateFeatures(), OJ.render(f.render), x.current && f.animationState && f.animationState.animateChanges());
  }), v.useEffect(() => {
    f && (!x.current && f.animationState && f.animationState.animateChanges(), x.current && (queueMicrotask(() => {
      var E;
      (E = window.MotionHandoffMarkAsComplete) === null || E === void 0 || E.call(window, g);
    }), x.current = !1));
  }), f;
}
function MJ(e, t, n, r) {
  const { layoutId: i, layout: o, drag: a, dragConstraints: s, layoutScroll: l, layoutRoot: u } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : GN(e.parent)), e.projection.setOptions({
    layoutId: i,
    layout: o,
    alwaysMeasureLayout: !!a || s && HN(s),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof o == "string" ? o : "both",
    initialPromotionConfig: r,
    layoutScroll: l,
    layoutRoot: u
  });
}
function GN(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : GN(e.parent);
}
function BJ(e, t, n) {
  return v.useCallback(
    (r) => {
      r && e.mount && e.mount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : HN(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function ty(e) {
  return IN(e.animate) || mJ.some((t) => u5(e[t]));
}
function IJ(e) {
  return !!(ty(e) || e.variants);
}
function RJ(e, t) {
  if (ty(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || u5(n) ? n : void 0,
      animate: u5(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function PJ(e) {
  const { initial: t, animate: n } = RJ(e, v.useContext(n2));
  return v.useMemo(() => ({ initial: t, animate: n }), [Sw(t), Sw(n)]);
}
function Sw(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Dw = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, Fm = {};
for (const e in Dw)
  Fm[e] = {
    isEnabled: (t) => Dw[e].some((n) => !!t[n])
  };
function d5(e) {
  for (const t in e)
    Fm[t] = {
      ...Fm[t],
      ...e[t]
    };
}
const _J = Symbol.for("motionComponentSymbol");
function qJ({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: i }) {
  e && d5(e);
  function o(s, l) {
    let u;
    const d = {
      ...v.useContext(WN),
      ...s,
      layoutId: $J(s)
    }, { isStatic: p } = d, f = PJ(s), m = r(s, p);
    if (!p && ZN) {
      HJ();
      const y = VJ(d);
      u = y.MeasureLayout, f.visualElement = LJ(i, m, d, t, y.ProjectionNode);
    }
    return c.jsxs(n2.Provider, { value: f, children: [u && f.visualElement ? c.jsx(u, { visualElement: f.visualElement, ...d }) : null, n(i, s, BJ(m, f.visualElement, l), m, p, f.visualElement)] });
  }
  const a = v.forwardRef(o);
  return a[_J] = i, a;
}
function $J({ layoutId: e }) {
  const t = v.useContext(jJ).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function HJ(e, t) {
  v.useContext(ey).strict;
}
function VJ(e) {
  const { drag: t, layout: n } = Fm;
  if (!t && !n)
    return {};
  const r = { ...t, ...n };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || n != null && n.isEnabled(e) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
const UJ = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function KN(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
    * If it contains a dash, the element is a custom HTML webcomponent.
    */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(UJ.indexOf(e) > -1 || /**
      * If it contains a capital letter, it's an SVG component
      */
      /[A-Z]/u.test(e))
    )
  );
}
function WJ(e, { style: t, vars: n }, r, i) {
  Object.assign(e.style, t, i && i.getProjectionStyles(r));
  for (const o in n)
    e.style.setProperty(o, n[o]);
}
const ZJ = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function GJ(e, t, n, r) {
  WJ(e, t, void 0, r);
  for (const i in t.attrs)
    e.setAttribute(ZJ.has(i) ? i : $N(i), t.attrs[i]);
}
function XN(e, { layout: t, layoutId: n }) {
  return RN.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!UN[e] || e === "opacity");
}
function QN(e, t, n) {
  var r;
  const { style: i } = e, o = {};
  for (const a in i)
    (jc(i[a]) || t.style && jc(t.style[a]) || XN(a, e) || ((r = n == null ? void 0 : n.getValue(a)) === null || r === void 0 ? void 0 : r.liveStyle) !== void 0) && (o[a] = i[a]);
  return o;
}
function KJ(e, t, n) {
  const r = QN(e, t, n);
  for (const i in e)
    if (jc(e[i]) || jc(t[i])) {
      const o = t2.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[o] = e[i];
    }
  return r;
}
function XJ(e) {
  const t = v.useRef(null);
  return t.current === null && (t.current = e()), t.current;
}
function QJ({ scrapeMotionValuesFromProps: e, createRenderState: t, onMount: n }, r, i, o) {
  const a = {
    latestValues: YJ(r, i, o, e),
    renderState: t()
  };
  return n && (a.mount = (s) => n(r, s, a)), a;
}
const YN = (e) => (t, n) => {
  const r = v.useContext(n2), i = v.useContext(VN), o = () => QJ(e, t, r, i);
  return n ? o() : XJ(o);
};
function YJ(e, t, n, r) {
  const i = {}, o = r(e, {});
  for (const f in o)
    i[f] = zJ(o[f]);
  let { initial: a, animate: s } = e;
  const l = ty(e), u = IJ(e);
  t && u && !l && e.inherit !== !1 && (a === void 0 && (a = t.initial), s === void 0 && (s = t.animate));
  let d = n ? n.initial === !1 : !1;
  d = d || a === !1;
  const p = d ? s : a;
  if (p && typeof p != "boolean" && !IN(p)) {
    const f = Array.isArray(p) ? p : [p];
    for (let m = 0; m < f.length; m++) {
      const y = fJ(e, f[m]);
      if (y) {
        const { transitionEnd: g, transition: x, ...E } = y;
        for (const b in E) {
          let C = E[b];
          if (Array.isArray(C)) {
            const T = d ? C.length - 1 : 0;
            C = C[T];
          }
          C !== null && (i[b] = C);
        }
        for (const b in g)
          i[b] = g[b];
      }
    }
  }
  return i;
}
const ny = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), JN = () => ({
  ...ny(),
  attrs: {}
}), eO = (e, t) => t && typeof e == "number" ? t.transform(e) : e, JJ = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, eee = t2.length;
function tee(e, t, n) {
  let r = "", i = !0;
  for (let o = 0; o < eee; o++) {
    const a = t2[o], s = e[a];
    if (s === void 0)
      continue;
    let l = !0;
    if (typeof s == "number" ? l = s === (a.startsWith("scale") ? 1 : 0) : l = parseFloat(s) === 0, !l || n) {
      const u = eO(s, qN[a]);
      if (!l) {
        i = !1;
        const d = JJ[a] || a;
        r += `${d}(${u}) `;
      }
      n && (t[a] = u);
    }
  }
  return r = r.trim(), n ? r = n(t, i ? "" : r) : i && (r = "none"), r;
}
function tO(e, t, n) {
  const { style: r, vars: i, transformOrigin: o } = e;
  let a = !1, s = !1;
  for (const l in t) {
    const u = t[l];
    if (RN.has(l)) {
      a = !0;
      continue;
    } else if (bJ(l)) {
      i[l] = u;
      continue;
    } else {
      const d = eO(u, qN[l]);
      l.startsWith("origin") ? (s = !0, o[l] = d) : r[l] = d;
    }
  }
  if (t.transform || (a || n ? r.transform = tee(t, e.transform, n) : r.transform && (r.transform = "none")), s) {
    const { originX: l = "50%", originY: u = "50%", originZ: d = 0 } = o;
    r.transformOrigin = `${l} ${u} ${d}`;
  }
}
function Aw(e, t, n) {
  return typeof e == "string" ? e : $t.transform(t + n * e);
}
function nee(e, t, n) {
  const r = Aw(t, e.x, e.width), i = Aw(n, e.y, e.height);
  return `${r} ${i}`;
}
const ree = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, iee = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function oee(e, t, n = 1, r = 0, i = !0) {
  e.pathLength = 1;
  const o = i ? ree : iee;
  e[o.offset] = $t.transform(-r);
  const a = $t.transform(t), s = $t.transform(n);
  e[o.array] = `${a} ${s}`;
}
function nO(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  originX: i,
  originY: o,
  pathLength: a,
  pathSpacing: s = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...u
}, d, p) {
  if (tO(e, u, p), d) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: f, style: m, dimensions: y } = e;
  f.transform && (y && (m.transform = f.transform), delete f.transform), y && (i !== void 0 || o !== void 0 || m.transform) && (m.transformOrigin = nee(y, i !== void 0 ? i : 0.5, o !== void 0 ? o : 0.5)), t !== void 0 && (f.x = t), n !== void 0 && (f.y = n), r !== void 0 && (f.scale = r), a !== void 0 && oee(f, a, s, l, !1);
}
const rO = (e) => typeof e == "string" && e.toLowerCase() === "svg", aee = {
  useVisualState: YN({
    scrapeMotionValuesFromProps: KJ,
    createRenderState: JN,
    onMount: (e, t, { renderState: n, latestValues: r }) => {
      Cw.read(() => {
        try {
          n.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
        } catch {
          n.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), Cw.render(() => {
        nO(n, r, rO(t.tagName), e.transformTemplate), GJ(t, n);
      });
    }
  })
}, see = {
  useVisualState: YN({
    scrapeMotionValuesFromProps: QN,
    createRenderState: ny
  })
};
function iO(e, t, n) {
  for (const r in t)
    !jc(t[r]) && !XN(r, n) && (e[r] = t[r]);
}
function lee({ transformTemplate: e }, t) {
  return v.useMemo(() => {
    const n = ny();
    return tO(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function uee(e, t) {
  const n = e.style || {}, r = {};
  return iO(r, n, e), Object.assign(r, lee(e, t)), r;
}
function cee(e, t) {
  const n = {}, r = uee(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const dee = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Lm(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || dee.has(e);
}
let oO = (e) => !Lm(e);
function pee(e) {
  e && (oO = (t) => t.startsWith("on") ? !Lm(t) : e(t));
}
try {
  pee(require("@emotion/is-prop-valid").default);
} catch {
}
function fee(e, t, n) {
  const r = {};
  for (const i in e)
    i === "values" && typeof e.values == "object" || (oO(i) || n === !0 && Lm(i) || !t && !Lm(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
function hee(e, t, n, r) {
  const i = v.useMemo(() => {
    const o = JN();
    return nO(o, t, rO(r), e.transformTemplate), {
      ...o.attrs,
      style: { ...o.style }
    };
  }, [t]);
  if (e.style) {
    const o = {};
    iO(o, e.style, e), i.style = { ...o, ...i.style };
  }
  return i;
}
function mee(e = !1) {
  return (t, n, r, { latestValues: i }, o) => {
    const a = (KN(t) ? hee : cee)(n, i, o, t), s = fee(n, typeof t == "string", e), l = t !== v.Fragment ? { ...s, ...a, ref: r } : {}, { children: u } = n, d = v.useMemo(() => jc(u) ? u.get() : u, [u]);
    return v.createElement(t, {
      ...l,
      children: d
    });
  };
}
function gee(e, t) {
  return function(n, { forwardMotionProps: r } = { forwardMotionProps: !1 }) {
    const i = {
      ...KN(n) ? aee : see,
      preloadedFeatures: e,
      useRender: mee(r),
      createVisualElement: t,
      Component: n
    };
    return qJ(i);
  };
}
const vee = /* @__PURE__ */ gee();
function yee({ children: e, features: t, strict: n = !1 }) {
  const [, r] = v.useState(!q4(t)), i = v.useRef(void 0);
  if (!q4(t)) {
    const { renderer: o, ...a } = t;
    i.current = o, d5(a);
  }
  return v.useEffect(() => {
    q4(t) && t().then(({ renderer: o, ...a }) => {
      d5(a), i.current = o, r(!0);
    });
  }, []), c.jsx(ey.Provider, { value: { renderer: i.current, strict: n }, children: e });
}
function q4(e) {
  return typeof e == "function";
}
function xee({ onClick: e }) {
  const t = nt().plugins.rows;
  return /* @__PURE__ */ c.jsxs(
    "button",
    {
      className: "serlo-button-edit-secondary mx-auto mt-24 flex items-center rounded-lg px-5 py-2.5 text-xl",
      onClick: e,
      "data-qa": "add-new-plugin-row-button",
      children: [
        /* @__PURE__ */ c.jsx(ot, { icon: Lg, className: "mr-3 text-3xl" }),
        /* @__PURE__ */ c.jsx("span", { className: "text-almost-black", children: t.addAnElement })
      ]
    }
  );
}
const bee = (e) => /* @__PURE__ */ v.createElement("svg", { width: 136, height: 90, viewBox: "0 0 136 90", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("g", { clipPath: "url(#clip0_10837_45923)" }, /* @__PURE__ */ v.createElement("rect", { width: 135, height: 90, transform: "translate(0.5)", fill: "#FFEFDA" }), /* @__PURE__ */ v.createElement("path", { d: "M61.3359 56.48V53.28C61.3359 50.96 61.6026 49.0533 62.1359 47.56C62.6959 46.0667 63.5493 44.8133 64.6959 43.8C65.8693 42.76 67.4159 41.76 69.3359 40.8C71.0159 39.9467 72.3226 39.16 73.2559 38.44C74.1893 37.6933 74.8293 36.9333 75.1759 36.16C75.5493 35.3867 75.7359 34.48 75.7359 33.44C75.7359 31.76 75.0559 30.3733 73.6959 29.28C72.3359 28.16 70.4826 27.6 68.1359 27.6C65.3359 27.6 63.1759 28.2267 61.6559 29.48C60.1626 30.7067 59.3093 32.3467 59.0959 34.4H49.2559C49.5493 29.76 51.2559 26.04 54.3759 23.24C57.5226 20.44 61.9759 19.04 67.7359 19.04C71.5226 19.04 74.7893 19.68 77.5359 20.96C80.2826 22.24 82.4026 23.9733 83.8959 26.16C85.3893 28.3467 86.1359 30.8 86.1359 33.52C86.1359 36.2933 85.4293 38.64 84.0159 40.56C82.6293 42.48 80.4559 44.1867 77.4959 45.68C75.7626 46.56 74.4026 47.3867 73.4159 48.16C72.4559 48.9333 71.7759 49.7867 71.3759 50.72C70.9759 51.6267 70.7759 52.7733 70.7759 54.16V56.48H61.3359ZM66.2959 73.12C64.3493 73.12 62.7626 72.52 61.5359 71.32C60.3359 70.12 59.7359 68.6533 59.7359 66.92C59.7359 65.1067 60.3359 63.6 61.5359 62.4C62.7626 61.1733 64.3359 60.56 66.2559 60.56C68.2026 60.56 69.8159 61.1733 71.0959 62.4C72.3759 63.6 73.0159 65.0933 73.0159 66.88C73.0159 68.64 72.3759 70.12 71.0959 71.32C69.8159 72.52 68.2159 73.12 66.2959 73.12Z", fill: "#FFBE5D" })), /* @__PURE__ */ v.createElement("defs", null, /* @__PURE__ */ v.createElement("clipPath", { id: "clip0_10837_45923" }, /* @__PURE__ */ v.createElement("rect", { x: 0.5, width: 135, height: 90, rx: 6, fill: "white" })))), tf = v.forwardRef(
  function({ label: e, autoFocus: t, ...n }, r) {
    const i = { ...n };
    return delete i.inputWidth, /* @__PURE__ */ c.jsxs("label", { className: "text-almost-black", style: { width: n.width }, children: [
      e ?? "",
      /* @__PURE__ */ c.jsx(
        "input",
        {
          autoFocus: t,
          ...i,
          ref: r,
          className: Le(`
            rounded-xl border-2 border-editor-primary-100 bg-editor-primary-100
            px-2.5 py-[3px] text-almost-black focus:border-editor-primary focus:outline-none
          `),
          style: { width: n.inputWidth }
        }
      )
    ] });
  }
), aO = {
  allowedChildPlugins: void 0,
  showPluginMenu: !1,
  insertIndex: void 0,
  insertCallback: void 0,
  parentPluginId: Ec
}, r2 = v.createContext({
  pluginMenuState: aO,
  pluginMenuDispatch: () => null
});
var su = /* @__PURE__ */ ((e) => (e.OPEN = "OPEN", e.OPEN_WITH_SLASH_KEY = "OPEN_WITH_SLASH_KEY", e.CLOSE = "CLOSE", e))(su || {});
const wee = (e, t) => {
  switch (t.type) {
    case su.OPEN:
      return {
        ...e,
        showPluginMenu: !0,
        insertIndex: t.payload.insertIndex
      };
    case su.OPEN_WITH_SLASH_KEY:
      return {
        ...e,
        showPluginMenu: !0,
        insertIndex: t.payload.insertIndex,
        insertCallback: t.payload.insertCallback
      };
    case su.CLOSE:
      return {
        ...e,
        showPluginMenu: !1,
        insertIndex: void 0,
        insertCallback: void 0
      };
  }
}, Cee = (e) => {
  const { children: t, allowedChildPlugins: n, parentPluginId: r } = e, [i, o] = v.useReducer(
    wee,
    aO
  ), a = {
    ...i,
    parentPluginId: r,
    allowedChildPlugins: n
  };
  return /* @__PURE__ */ c.jsx(r2.Provider, { value: { pluginMenuState: a, pluginMenuDispatch: o }, children: t });
};
var Yo = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), function(t) {
    t.Unidentified = "Unidentified", t.Alt = "Alt", t.AltGraph = "AltGraph", t.CapsLock = "CapsLock", t.Control = "Control", t.Fn = "Fn", t.FnLock = "FnLock", t.Hyper = "Hyper", t.Meta = "Meta", t.NumLock = "NumLock", t.ScrollLock = "ScrollLock", t.Shift = "Shift", t.Super = "Super", t.Symbol = "Symbol", t.SymbolLock = "SymbolLock", t.Enter = "Enter", t.Tab = "Tab", t.ArrowDown = "ArrowDown", t.ArrowLeft = "ArrowLeft", t.ArrowRight = "ArrowRight", t.ArrowUp = "ArrowUp", t.End = "End", t.Home = "Home", t.PageDown = "PageDown", t.PageUp = "PageUp", t.Backspace = "Backspace", t.Clear = "Clear", t.Copy = "Copy", t.CrSel = "CrSel", t.Cut = "Cut", t.Delete = "Delete", t.EraseEof = "EraseEof", t.ExSel = "ExSel", t.Insert = "Insert", t.Paste = "Paste", t.Redo = "Redo", t.Undo = "Undo", t.Accept = "Accept", t.Again = "Again", t.Attn = "Attn", t.Cancel = "Cancel", t.ContextMenu = "ContextMenu", t.Escape = "Escape", t.Execute = "Execute", t.Find = "Find", t.Finish = "Finish", t.Help = "Help", t.Pause = "Pause", t.Play = "Play", t.Props = "Props", t.Select = "Select", t.ZoomIn = "ZoomIn", t.ZoomOut = "ZoomOut", t.BrightnessDown = "BrightnessDown", t.BrightnessUp = "BrightnessUp", t.Eject = "Eject", t.LogOff = "LogOff", t.Power = "Power", t.PowerOff = "PowerOff", t.PrintScreen = "PrintScreen", t.Hibernate = "Hibernate", t.Standby = "Standby", t.WakeUp = "WakeUp", t.AllCandidates = "AllCandidates", t.Alphanumeric = "Alphanumeric", t.CodeInput = "CodeInput", t.Compose = "Compose", t.Convert = "Convert", t.Dead = "Dead", t.FinalMode = "FinalMode", t.GroupFirst = "GroupFirst", t.GroupLast = "GroupLast", t.GroupNext = "GroupNext", t.GroupPrevious = "GroupPrevious", t.ModeChange = "ModeChange", t.NextCandidate = "NextCandidate", t.NonConvert = "NonConvert", t.PreviousCandidate = "PreviousCandidate", t.Process = "Process", t.SingleCandidate = "SingleCandidate", t.HangulMode = "HangulMode", t.HanjaMode = "HanjaMode", t.JunjaMode = "JunjaMode", t.Eisu = "Eisu", t.Hankaku = "Hankaku", t.Hiragana = "Hiragana", t.HiraganaKatakana = "HiraganaKatakana", t.KanaMode = "KanaMode", t.KanjiMode = "KanjiMode", t.Katakana = "Katakana", t.Romaji = "Romaji", t.Zenkaku = "Zenkaku", t.ZenkakuHanaku = "ZenkakuHanaku", t.F1 = "F1", t.F2 = "F2", t.F3 = "F3", t.F4 = "F4", t.F5 = "F5", t.F6 = "F6", t.F7 = "F7", t.F8 = "F8", t.F9 = "F9", t.F10 = "F10", t.F11 = "F11", t.F12 = "F12", t.F13 = "F13", t.F14 = "F14", t.F15 = "F15", t.F16 = "F16", t.F17 = "F17", t.F18 = "F18", t.F19 = "F19", t.F20 = "F20", t.Soft1 = "Soft1", t.Soft2 = "Soft2", t.Soft3 = "Soft3", t.Soft4 = "Soft4", t.AppSwitch = "AppSwitch", t.Call = "Call", t.Camera = "Camera", t.CameraFocus = "CameraFocus", t.EndCall = "EndCall", t.GoBack = "GoBack", t.GoHome = "GoHome", t.HeadsetHook = "HeadsetHook", t.LastNumberRedial = "LastNumberRedial", t.Notification = "Notification", t.MannerMode = "MannerMode", t.VoiceDial = "VoiceDial", t.ChannelDown = "ChannelDown", t.ChannelUp = "ChannelUp", t.MediaFastForward = "MediaFastForward", t.MediaPause = "MediaPause", t.MediaPlay = "MediaPlay", t.MediaPlayPause = "MediaPlayPause", t.MediaRecord = "MediaRecord", t.MediaRewind = "MediaRewind", t.MediaStop = "MediaStop", t.MediaTrackNext = "MediaTrackNext", t.MediaTrackPrevious = "MediaTrackPrevious", t.AudioBalanceLeft = "AudioBalanceLeft", t.AudioBalanceRight = "AudioBalanceRight", t.AudioBassDown = "AudioBassDown", t.AudioBassBoostDown = "AudioBassBoostDown", t.AudioBassBoostToggle = "AudioBassBoostToggle", t.AudioBassBoostUp = "AudioBassBoostUp", t.AudioBassUp = "AudioBassUp", t.AudioFaderFront = "AudioFaderFront", t.AudioFaderRear = "AudioFaderRear", t.AudioSurroundModeNext = "AudioSurroundModeNext", t.AudioTrebleDown = "AudioTrebleDown", t.AudioTrebleUp = "AudioTrebleUp", t.AudioVolumeDown = "AudioVolumeDown", t.AudioVolumeMute = "AudioVolumeMute", t.AudioVolumeUp = "AudioVolumeUp", t.MicrophoneToggle = "MicrophoneToggle", t.MicrophoneVolumeDown = "MicrophoneVolumeDown", t.MicrophoneVolumeMute = "MicrophoneVolumeMute", t.MicrophoneVolumeUp = "MicrophoneVolumeUp", t.TV = "TV", t.TV3DMode = "TV3DMode", t.TVAntennaCable = "TVAntennaCable", t.TVAudioDescription = "TVAudioDescription", t.TVAudioDescriptionMixDown = "TVAudioDescriptionMixDown", t.TVAudioDescriptionMixUp = "TVAudioDescriptionMixUp", t.TVContentsMenu = "TVContentsMenu", t.TVDataService = "TVDataService", t.TVInput = "TVInput", t.TVInputComponent1 = "TVInputComponent1", t.TVInputComponent2 = "TVInputComponent2", t.TVInputComposite1 = "TVInputComposite1", t.TVInputComposite2 = "TVInputComposite2", t.TVInputHDMI1 = "TVInputHDMI1", t.TVInputHDMI2 = "TVInputHDMI2", t.TVInputHDMI3 = "TVInputHDMI3", t.TVInputHDMI4 = "TVInputHDMI4", t.TVInputVGA1 = "TVInputVGA1", t.TVMediaContext = "TVMediaContext", t.TVNetwork = "TVNetwork", t.TVNumberEntry = "TVNumberEntry", t.TVPower = "TVPower", t.TVRadioService = "TVRadioService", t.TVSatellite = "TVSatellite", t.TVSatelliteBS = "TVSatelliteBS", t.TVSatelliteCS = "TVSatelliteCS", t.TVSatelliteToggle = "TVSatelliteToggle", t.TVTerrestrialAnalog = "TVTerrestrialAnalog", t.TVTerrestrialDigital = "TVTerrestrialDigital", t.TVTimer = "TVTimer", t.AVRInput = "AVRInput", t.AVRPower = "AVRPower", t.ColorF0Red = "ColorF0Red", t.ColorF1Green = "ColorF1Green", t.ColorF2Yellow = "ColorF2Yellow", t.ColorF3Blue = "ColorF3Blue", t.ColorF4Grey = "ColorF4Grey", t.ColorF5Brown = "ColorF5Brown", t.ClosedCaptionToggle = "ClosedCaptionToggle", t.Dimmer = "Dimmer", t.DisplaySwap = "DisplaySwap", t.DVR = "DVR", t.Exit = "Exit", t.FavoriteClear0 = "FavoriteClear0", t.FavoriteClear1 = "FavoriteClear1", t.FavoriteClear2 = "FavoriteClear2", t.FavoriteClear3 = "FavoriteClear3", t.FavoriteRecall0 = "FavoriteRecall0", t.FavoriteRecall1 = "FavoriteRecall1", t.FavoriteRecall2 = "FavoriteRecall2", t.FavoriteRecall3 = "FavoriteRecall3", t.FavoriteStore0 = "FavoriteStore0", t.FavoriteStore1 = "FavoriteStore1", t.FavoriteStore2 = "FavoriteStore2", t.FavoriteStore3 = "FavoriteStore3", t.Guide = "Guide", t.GuideNextDay = "GuideNextDay", t.GuidePreviousDay = "GuidePreviousDay", t.Info = "Info", t.InstantReplay = "InstantReplay", t.Link = "Link", t.ListProgram = "ListProgram", t.LiveContent = "LiveContent", t.Lock = "Lock", t.MediaApps = "MediaApps", t.MediaAudioTrack = "MediaAudioTrack", t.MediaLast = "MediaLast", t.MediaSkipBackward = "MediaSkipBackward", t.MediaSkipForward = "MediaSkipForward", t.MediaStepBackward = "MediaStepBackward", t.MediaStepForward = "MediaStepForward", t.MediaTopMenu = "MediaTopMenu", t.NavigateIn = "NavigateIn", t.NavigateNext = "NavigateNext", t.NavigateOut = "NavigateOut", t.NavigatePrevious = "NavigatePrevious", t.NextFavoriteChannel = "NextFavoriteChannel", t.NextUserProfile = "NextUserProfile", t.OnDemand = "OnDemand", t.Pairing = "Pairing", t.PinPDown = "PinPDown", t.PinPMove = "PinPMove", t.PinPToggle = "PinPToggle", t.PinPUp = "PinPUp", t.PlaySpeedDown = "PlaySpeedDown", t.PlaySpeedReset = "PlaySpeedReset", t.PlaySpeedUp = "PlaySpeedUp", t.RandomToggle = "RandomToggle", t.RcLowBattery = "RcLowBattery", t.RecordSpeedNext = "RecordSpeedNext", t.RfBypass = "RfBypass", t.ScanChannelsToggle = "ScanChannelsToggle", t.ScreenModeNext = "ScreenModeNext", t.Settings = "Settings", t.SplitScreenToggle = "SplitScreenToggle", t.STBInput = "STBInput", t.STBPower = "STBPower", t.Subtitle = "Subtitle", t.Teletext = "Teletext", t.VideoModeNext = "VideoModeNext", t.Wink = "Wink", t.ZoomToggle = "ZoomToggle", t.SpeechCorrectionList = "SpeechCorrectionList", t.SpeechInputToggle = "SpeechInputToggle", t.Close = "Close", t.New = "New", t.Open = "Open", t.Print = "Print", t.Save = "Save", t.SpellCheck = "SpellCheck", t.MailForward = "MailForward", t.MailReply = "MailReply", t.MailSend = "MailSend", t.LaunchCalculator = "LaunchCalculator", t.LaunchCalendar = "LaunchCalendar", t.LaunchContacts = "LaunchContacts", t.LaunchMail = "LaunchMail", t.LaunchMediaPlayer = "LaunchMediaPlayer", t.LaunchMusicPlayer = "LaunchMusicPlayer", t.LaunchMyComputer = "LaunchMyComputer", t.LaunchPhone = "LaunchPhone", t.LaunchScreenSaver = "LaunchScreenSaver", t.LaunchSpreadsheet = "LaunchSpreadsheet", t.LaunchWebBrowser = "LaunchWebBrowser", t.LaunchWebCam = "LaunchWebCam", t.LaunchWordProcessor = "LaunchWordProcessor", t.LaunchApplication1 = "LaunchApplication1", t.LaunchApplication2 = "LaunchApplication2", t.LaunchApplication3 = "LaunchApplication3", t.LaunchApplication4 = "LaunchApplication4", t.LaunchApplication5 = "LaunchApplication5", t.LaunchApplication6 = "LaunchApplication6", t.LaunchApplication7 = "LaunchApplication7", t.LaunchApplication8 = "LaunchApplication8", t.LaunchApplication9 = "LaunchApplication9", t.LaunchApplication10 = "LaunchApplication10", t.LaunchApplication11 = "LaunchApplication11", t.LaunchApplication12 = "LaunchApplication12", t.LaunchApplication13 = "LaunchApplication13", t.LaunchApplication14 = "LaunchApplication14", t.LaunchApplication15 = "LaunchApplication15", t.LaunchApplication16 = "LaunchApplication16", t.BrowserBack = "BrowserBack", t.BrowserFavorites = "BrowserFavorites", t.BrowserForward = "BrowserForward", t.BrowserHome = "BrowserHome", t.BrowserRefresh = "BrowserRefresh", t.BrowserSearch = "BrowserSearch", t.BrowserStop = "BrowserStop", t.Decimal = "Decimal", t.Key11 = "Key11", t.Key12 = "Key12", t.Multiply = "Multiply", t.Add = "Add", t.Divide = "Divide", t.Subtract = "Subtract", t.Separator = "Separator";
  }(e.Key || (e.Key = {}));
})(Yo);
function kee(e) {
  return e % 5 === 0 ? "right" : e % 5 === 4 ? "left" : void 0;
}
function Eee({
  basicOptions: e,
  interactiveOptions: t,
  focusedItemIndex: n,
  setFocusedItemIndex: r,
  itemRefs: i,
  onInsertPlugin: o
}) {
  const a = nt();
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    e.length ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx("h3", { className: "pl-6 pt-4 text-lg font-bold text-almost-black", children: a.addPluginsModal.basicPluginsTitle }),
      /* @__PURE__ */ c.jsx("ul", { className: "grid grid-cols-5 gap-4 p-4", children: s(e, 0) })
    ] }) : null,
    t.length ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx("h3", { className: "pl-6 pt-1 text-lg font-bold text-almost-black", children: a.addPluginsModal.interactivePluginsTitle }),
      /* @__PURE__ */ c.jsx("ul", { className: "grid grid-cols-5 gap-4 p-4", children: s(t, e.length) })
    ] }) : null
  ] });
  function s(l, u) {
    return l.map((d, p) => {
      const { type: f, initialState: m, title: y, IconComponent: g, description: x } = d, E = p + u, b = E === n, C = kee(p), T = C ? C === "left" ? "right-0 [&>span]:!min-w-80" : "" : "-left-24";
      return /* @__PURE__ */ c.jsx("li", { children: /* @__PURE__ */ c.jsxs(
        "button",
        {
          "data-qa": `plugin-suggestion-${m.plugin}`,
          ref: (z) => i.current[E] = z,
          onClick: () => o(d),
          onFocus: () => r(E),
          onBlur: () => r(null),
          className: Le(
            "serlo-tooltip-trigger w-full rounded-md p-2 hover:shadow-xl",
            b && "shadow-xl"
          ),
          children: [
            /* @__PURE__ */ c.jsx(vn, { className: T, text: x }),
            /* @__PURE__ */ c.jsx(g, {}),
            /* @__PURE__ */ c.jsx("b", { className: "mt-2 block text-sm", children: y })
          ]
        }
      ) }, f);
    });
  }
}
function See({
  enabled: e,
  focusedItemIndex: t,
  setFocusedItemIndex: n,
  basicItemsLength: r,
  intearctiveItemsLength: i,
  columns: o,
  searchInputRef: a
}) {
  const s = (l) => {
    var u;
    const d = r + i, p = r, f = p, m = t ?? 0, y = m < f, g = m >= f, x = Math.floor(p / o), E = p % o, b = m >= (x - 1) * o && m < x * o, C = m < o, T = m >= x * o && m < p, z = m >= f && m < f + o;
    switch (l.key) {
      case Yo.Key.ArrowDown:
        if (y)
          if (T) {
            const I = m % o;
            n(
              f + I
            );
          } else b && m % o >= E ? n(x * o) : n(
            (I) => Math.min((I ?? 0) + o, d - 1)
          );
        else g && n(
          (I) => Math.min((I ?? 0) + o, d - 1)
        );
        break;
      case Yo.Key.ArrowUp:
        if (g)
          if (z) {
            const I = (m - f) % o;
            I < E ? n(
              x * o + I
            ) : n(
              x * o + E - 1
            );
          } else
            n((I) => Math.max((I ?? 0) - o, 0));
        else y && (C ? (u = a.current) == null || u.focus() : n((I) => Math.max((I ?? 0) - o, 0)));
        break;
      case Yo.Key.ArrowLeft:
        n((I) => Math.max((I ?? 0) - 1, 0));
        break;
      case Yo.Key.ArrowRight:
        n((I) => Math.min((I ?? 0) + 1, d - 1));
        break;
    }
  };
  ua(
    [Yo.Key.ArrowUp, Yo.Key.ArrowDown, Yo.Key.ArrowLeft, Yo.Key.ArrowRight],
    s,
    {
      enabled: e,
      preventDefault: !0,
      enableOnContentEditable: !0
    }
  );
}
function ry(e, t) {
  if (e === Y.Spoiler && t.filter(
    (r) => r === Y.Spoiler
  ).length > 1)
    return !1;
  const n = t.at(0);
  return [Y.PageLayout, Y.PagePartners].includes(
    e
  ) && n !== Us.Page ? !1 : e === Y.Exercise ? t.includes(Y.Exercise) || t.includes(Y.ExerciseGroup) ? !1 : !!(n && [
    Us.Article,
    Us.Course,
    Us.GenericContent,
    Y.Rows
  ].includes(n)) : !0;
}
function Dee() {
  return /* @__PURE__ */ c.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 61 40", fill: "none", children: [
    /* @__PURE__ */ c.jsx("rect", { width: "60", height: "40", fill: "#FFF5E9" }),
    /* @__PURE__ */ c.jsx(
      "rect",
      {
        width: "43",
        height: "23",
        transform: "translate(8.5 5.18077)",
        fill: "#FFDDB2"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M31.8341 14.7394C32.7227 15.8115 32.7227 17.5497 31.8341 18.6217",
        stroke: "#57534F",
        strokeWidth: "0.65",
        strokeMiterlimit: "2",
        strokeLinecap: "round"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M32.8945 13.4606C34.3687 15.2392 34.3687 18.1231 32.8945 19.9018",
        stroke: "#57534F",
        strokeWidth: "0.65",
        strokeMiterlimit: "2",
        strokeLinecap: "round"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M33.9548 12.1808C36.0149 14.6661 36.0149 18.6955 33.9548 21.1808",
        stroke: "#57534F",
        strokeWidth: "0.65",
        strokeMiterlimit: "2",
        strokeLinecap: "round"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M26.4897 14.6435H25.3154C24.8658 14.6435 24.5 15.0848 24.5 15.6274V17.7355C24.5 18.278 24.8658 18.7194 25.3154 18.7194H26.4897V14.6435Z",
        fill: "#57534F"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M30.5116 12.5493C30.3675 12.4512 30.1966 12.4547 30.0551 12.5585L27.2123 14.6429H27.2109V18.7188H27.2123L30.0551 20.8031C30.128 20.8566 30.2089 20.8834 30.2897 20.8834C30.3658 20.8834 30.4418 20.8598 30.5116 20.8124C30.6561 20.7144 30.7422 20.5366 30.7422 20.3368V13.0248C30.7422 12.825 30.6561 12.6473 30.5116 12.5493Z",
        fill: "#57534F"
      }
    ),
    /* @__PURE__ */ c.jsx("rect", { x: "8.5", y: "28.1808", width: "12", height: "1", fill: "#FFBB62" }),
    /* @__PURE__ */ c.jsx("rect", { x: "20.5", y: "28.1808", width: "31", height: "1", fill: "#EBE1D6" }),
    /* @__PURE__ */ c.jsx(
      "rect",
      {
        x: "8.53589",
        y: "32.1808",
        width: "42.9282",
        height: "2.63846",
        fill: "black",
        fillOpacity: "0.08"
      }
    )
  ] });
}
const Aee = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 40" fill="none">
  <rect width="60" height="40" fill="#FFF5E9"/>
  <rect width="43" height="23" transform="translate(8.5 5.18077)" fill="#FFDDB2"/>
  <path d="M31.8341 14.7394C32.7227 15.8115 32.7227 17.5497 31.8341 18.6217" stroke="#57534F" stroke-width="0.65" stroke-miterlimit="2" stroke-linecap="round"/>
  <path d="M32.8945 13.4606C34.3687 15.2392 34.3687 18.1231 32.8945 19.9018" stroke="#57534F" stroke-width="0.65" stroke-miterlimit="2" stroke-linecap="round"/>
  <path d="M33.9548 12.1808C36.0149 14.6661 36.0149 18.6955 33.9548 21.1808" stroke="#57534F" stroke-width="0.65" stroke-miterlimit="2" stroke-linecap="round"/>
  <path d="M26.4897 14.6435H25.3154C24.8658 14.6435 24.5 15.0848 24.5 15.6274V17.7355C24.5 18.278 24.8658 18.7194 25.3154 18.7194H26.4897V14.6435Z" fill="#57534F"/>
  <path d="M30.5116 12.5493C30.3675 12.4512 30.1966 12.4547 30.0551 12.5585L27.2123 14.6429H27.2109V18.7188H27.2123L30.0551 20.8031C30.128 20.8566 30.2089 20.8834 30.2897 20.8834C30.3658 20.8834 30.4418 20.8598 30.5116 20.8124C30.6561 20.7144 30.7422 20.5366 30.7422 20.3368V13.0248C30.7422 12.825 30.6561 12.6473 30.5116 12.5493Z" fill="#57534F"/>
  <rect x="8.5" y="28.1808" width="12" height="1" fill="#FFBB62"/>
  <rect x="20.5" y="28.1808" width="31" height="1" fill="#EBE1D6"/>
  <rect x="8.53589" y="32.1808" width="42.9282" height="2.63846" fill="black" fill-opacity="0.08"/>
</svg>
`;
function Tee() {
  return /* @__PURE__ */ c.jsxs(
    "svg",
    {
      width: "100%",
      height: "100%",
      viewBox: "0 0 90 60",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ c.jsx("rect", { width: "90", height: "60", rx: "4", fill: "#FFEFDA" }),
        /* @__PURE__ */ c.jsx("rect", { width: "90", height: "50", transform: "translate(0 5)", fill: "#FFEFDA" }),
        /* @__PURE__ */ c.jsx("rect", { x: "22.5", y: "21", width: "9", height: "3", fill: "#FFBE5D" }),
        /* @__PURE__ */ c.jsx(
          "rect",
          {
            x: "32.65",
            y: "21.15",
            width: "9.7",
            height: "2.7",
            rx: "0.35",
            stroke: "#57534F",
            strokeWidth: "0.3",
            strokeDasharray: "1 1"
          }
        ),
        /* @__PURE__ */ c.jsx("rect", { x: "43.5", y: "21", width: "24", height: "3", fill: "#FFBE5D" }),
        /* @__PURE__ */ c.jsx("rect", { x: "22.5", y: "26", width: "45", height: "3", fill: "#FFBE5D" }),
        /* @__PURE__ */ c.jsx("rect", { x: "22.5", y: "31", width: "24", height: "3", fill: "#FFBE5D" }),
        /* @__PURE__ */ c.jsx(
          "rect",
          {
            x: "47.65",
            y: "31.15",
            width: "9.7",
            height: "2.7",
            rx: "0.35",
            stroke: "#57534F",
            strokeWidth: "0.3",
            strokeDasharray: "1 1"
          }
        ),
        /* @__PURE__ */ c.jsx("rect", { x: "58.5", y: "31", width: "9", height: "3", fill: "#FFBE5D" }),
        /* @__PURE__ */ c.jsx("rect", { x: "22.5", y: "36", width: "13", height: "3", fill: "#FFBE5D" }),
        /* @__PURE__ */ c.jsx(
          "rect",
          {
            x: "36.65",
            y: "36.15",
            width: "9.7",
            height: "2.7",
            rx: "0.35",
            stroke: "#57534F",
            strokeWidth: "0.3",
            strokeDasharray: "1 1"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "path",
          {
            d: "M48.4841 36.468L48.968 35.9841L49.4519 35.7422H51.1454H68.5648H71.2261L71.9519 36.2261L72.4357 36.9519V39.3712V40.8228H71.9519L71.468 41.3067L70.7422 41.0648L70.0164 41.7906L69.5325 40.5809L68.8067 40.097L68.3228 40.339L68.0809 41.0648L70.2583 44.2099L70.9841 45.4196L70.7422 45.1777H70.0164L69.5325 44.6938H68.8067L68.5648 44.9357V45.4196V45.9035H55.0164H51.8712H49.6938H48.968L48.4841 45.4196L48.2422 45.1777V43.968V43.0003V41.7906V40.339V38.8873V37.4357L48.4841 36.468Z",
            fill: "#FFEFDA"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "path",
          {
            d: "M67.5459 45.6614C67.6593 45.6614 67.7403 45.7622 67.7403 45.863C67.7403 45.9638 67.6593 46.0645 67.5621 46.0645H67.5459H66.4604C66.347 46.0645 66.266 45.9638 66.266 45.863C66.266 45.7622 66.347 45.6614 66.4442 45.6614H66.4604H67.5459ZM69.4738 40.3372L70.2028 41.4121C70.2514 41.2609 70.3487 41.1266 70.4945 41.0426C70.7861 40.8411 71.2073 40.8578 71.4665 41.0426C71.5151 40.8914 71.6123 40.7403 71.742 40.6563C72.0498 40.438 72.552 40.5051 72.8112 40.7403C72.8598 40.5891 72.957 40.4715 73.0866 40.3708C73.4269 40.1356 73.9939 40.2364 74.2207 40.5387V40.5555L74.3179 40.6563C74.7878 41.1938 75.1766 41.748 75.5006 42.3023L75.5654 42.4199L75.6626 42.6046L75.7598 42.7894L75.8408 42.9573C76.2297 43.6963 76.4079 44.217 76.6509 45.208C76.6995 45.4431 76.7643 45.6614 76.8453 45.863C77.0721 45.8294 77.3151 45.8966 77.4771 46.0813L77.4933 46.1149L77.8498 46.5684C78.0766 46.8707 78.0442 47.2906 77.7688 47.5426L77.7364 47.5594L74.9822 49.8604C74.6906 50.0955 74.2855 50.0619 74.0425 49.7764L74.0263 49.7428L73.6699 49.2893C73.5079 49.0878 73.4755 48.8358 73.5565 48.6175H73.5403H73.5241C73.3459 48.5167 73.1352 48.4495 72.9084 48.3991L72.8274 48.3824H72.8112C70.9481 47.8785 68.4855 46.2493 68.2587 45.4767C68.0481 44.7881 68.5503 44.4018 69.1336 44.4857C69.3118 44.5193 69.7492 44.6705 70.4297 44.9896L70.6565 45.0904L70.6241 45.0568C70.3649 44.6537 70.1218 44.3178 69.9112 43.9819L69.49 43.3436L68.9392 42.5374C68.6961 42.1847 68.4207 41.7816 68.1291 41.3281C67.8537 40.9082 67.9347 40.3372 68.3073 40.0684C68.6799 39.8165 69.1984 39.9341 69.4738 40.3372ZM76.7967 46.2829L76.7805 46.2997L74.0101 48.6175C73.8967 48.7183 73.8643 48.8862 73.9615 49.0038L73.9777 49.0206L74.3341 49.4741C74.4313 49.5916 74.5933 49.6252 74.7068 49.5245L74.723 49.5077L77.4933 47.1899C77.6067 47.0891 77.6392 46.9211 77.5419 46.8036L77.5257 46.7868L77.1855 46.3333C77.0883 46.2157 76.9263 46.1989 76.7967 46.2829ZM68.5341 40.4212C68.3397 40.5555 68.3073 40.8578 68.4531 41.093L69.247 42.2519L69.7006 42.9405C69.814 43.1085 69.9112 43.2596 70.0084 43.4108L70.1542 43.6292C70.5269 44.2002 70.9643 44.8049 71.4503 45.4599C71.5799 45.6278 71.4017 45.863 71.2073 45.779L70.7375 45.5607L70.4297 45.4263C69.6844 45.0904 69.2308 44.9224 69.085 44.8888C68.7609 44.8384 68.5665 45.0064 68.6637 45.3423C68.8419 45.9302 71.1425 47.4586 72.876 47.9625L72.9246 47.9793L72.9894 47.9961C73.2325 48.0464 73.4431 48.1304 73.6537 48.2312L73.7185 48.2648C73.7347 48.2816 73.7671 48.2984 73.7833 48.3152L76.4889 46.0477C76.4079 45.8126 76.3269 45.5775 76.2621 45.3087L76.2135 45.1072C75.9542 44.0826 75.7598 43.6124 75.209 42.655C74.885 42.0839 74.4961 41.5129 74.0101 40.9586L73.9129 40.7907L73.8967 40.7739C73.8157 40.6563 73.4755 40.5891 73.3135 40.7067C73.1515 40.8075 73.1028 41.1098 73.1839 41.2609L73.2001 41.2777L73.6051 41.8824C73.6699 41.9832 73.6375 42.1007 73.5565 42.1679C73.4755 42.2351 73.3459 42.2183 73.2811 42.1343L73.2649 42.1175L73.0056 41.7144L72.9732 41.6976L72.552 41.0594C72.471 40.9418 72.1308 40.8746 71.9526 40.9922C71.8068 41.093 71.7582 41.3953 71.8392 41.5297L71.8554 41.5465L72.5034 42.5374L72.6006 42.6718C72.6654 42.7726 72.633 42.8901 72.552 42.9573C72.471 43.0245 72.3414 43.0077 72.2766 42.9237L72.2604 42.9069L71.2883 41.4121C71.2073 41.2945 70.8833 41.2442 70.7051 41.3785C70.5431 41.4961 70.4945 41.7648 70.5755 41.8992L70.5917 41.916L71.6609 43.562V43.5788L71.6771 43.5956V43.6124V43.6292C71.6771 43.6459 71.6771 43.6459 71.6771 43.6627V43.6795V43.6963V43.7131V43.7299L71.6609 43.7467L71.6447 43.7635L71.6285 43.7803V43.8139L71.6123 43.8307L71.5961 43.8475C71.5961 43.8475 71.5799 43.8643 71.5637 43.8643H71.5475H71.5313H71.5151H71.4827H71.4665H71.4503H71.4341C71.4179 43.8643 71.4179 43.8643 71.4017 43.8475L71.3693 43.8307L71.3531 43.8139V43.8307L71.3369 43.8139L71.3207 43.7971L71.3045 43.7803L69.166 40.6059C69.004 40.3708 68.7123 40.2868 68.5341 40.4212ZM71.0615 35.5C71.8716 35.5 72.5358 36.1718 72.552 37.0116V37.062V39.4302C72.552 39.5478 72.4548 39.6318 72.3576 39.6318C72.2604 39.6318 72.1632 39.5478 72.1632 39.447V39.4302V37.0452C72.1632 36.4406 71.6933 35.9367 71.1101 35.9199H71.0777L49.5067 35.9868C48.9235 35.9868 48.4374 36.4739 48.4212 37.0786V37.1122V44.5863C48.4212 45.1909 48.8911 45.6948 49.4743 45.7116H49.5067L65.7476 45.6446C65.861 45.6446 65.942 45.7454 65.942 45.8462C65.942 45.947 65.861 46.0477 65.7638 46.0477H65.7476L49.4905 46.1147C48.6805 46.1147 48.0162 45.4429 48 44.6031V44.5527V37.1122C48 36.2724 48.648 35.5837 49.4581 35.5669H49.5067L71.0615 35.5Z",
            fill: "#57534F"
          }
        )
      ]
    }
  );
}
const jee = `<svg width="100%" height="100%" viewBox="0 0 90 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="90" height="60" rx="4" fill="#FFEFDA"/>
<rect width="90" height="50" transform="translate(0 5)" fill="#FFEFDA"/>
<rect x="22.5" y="21" width="9" height="3" fill="#FFBE5D"/>
<rect x="32.65" y="21.15" width="9.7" height="2.7" rx="0.35" stroke="#57534F" stroke-width="0.3" stroke-dasharray="1 1"/>
<rect x="43.5" y="21" width="24" height="3" fill="#FFBE5D"/>
<rect x="22.5" y="26" width="45" height="3" fill="#FFBE5D"/>
<rect x="22.5" y="31" width="24" height="3" fill="#FFBE5D"/>
<rect x="47.65" y="31.15" width="9.7" height="2.7" rx="0.35" stroke="#57534F" stroke-width="0.3" stroke-dasharray="1 1"/>
<rect x="58.5" y="31" width="9" height="3" fill="#FFBE5D"/>
<rect x="22.5" y="36" width="13" height="3" fill="#FFBE5D"/>
<rect x="36.65" y="36.15" width="9.7" height="2.7" rx="0.35" stroke="#57534F" stroke-width="0.3" stroke-dasharray="1 1"/>
<path d="M48.4841 36.468L48.968 35.9841L49.4519 35.7422H51.1454H68.5648H71.2261L71.9519 36.2261L72.4357 36.9519V39.3712V40.8228H71.9519L71.468 41.3067L70.7422 41.0648L70.0164 41.7906L69.5325 40.5809L68.8067 40.097L68.3228 40.339L68.0809 41.0648L70.2583 44.2099L70.9841 45.4196L70.7422 45.1777H70.0164L69.5325 44.6938H68.8067L68.5648 44.9357V45.4196V45.9035H55.0164H51.8712H49.6938H48.968L48.4841 45.4196L48.2422 45.1777V43.968V43.0003V41.7906V40.339V38.8873V37.4357L48.4841 36.468Z" fill="#FFEFDA"/>
<path d="M67.5459 45.6614C67.6593 45.6614 67.7403 45.7622 67.7403 45.863C67.7403 45.9638 67.6593 46.0645 67.5621 46.0645H67.5459H66.4604C66.347 46.0645 66.266 45.9638 66.266 45.863C66.266 45.7622 66.347 45.6614 66.4442 45.6614H66.4604H67.5459ZM69.4738 40.3372L70.2028 41.4121C70.2514 41.2609 70.3487 41.1266 70.4945 41.0426C70.7861 40.8411 71.2073 40.8578 71.4665 41.0426C71.5151 40.8914 71.6123 40.7403 71.742 40.6563C72.0498 40.438 72.552 40.5051 72.8112 40.7403C72.8598 40.5891 72.957 40.4715 73.0866 40.3708C73.4269 40.1356 73.9939 40.2364 74.2207 40.5387V40.5555L74.3179 40.6563C74.7878 41.1938 75.1766 41.748 75.5006 42.3023L75.5654 42.4199L75.6626 42.6046L75.7598 42.7894L75.8408 42.9573C76.2297 43.6963 76.4079 44.217 76.6509 45.208C76.6995 45.4431 76.7643 45.6614 76.8453 45.863C77.0721 45.8294 77.3151 45.8966 77.4771 46.0813L77.4933 46.1149L77.8498 46.5684C78.0766 46.8707 78.0442 47.2906 77.7688 47.5426L77.7364 47.5594L74.9822 49.8604C74.6906 50.0955 74.2855 50.0619 74.0425 49.7764L74.0263 49.7428L73.6699 49.2893C73.5079 49.0878 73.4755 48.8358 73.5565 48.6175H73.5403H73.5241C73.3459 48.5167 73.1352 48.4495 72.9084 48.3991L72.8274 48.3824H72.8112C70.9481 47.8785 68.4855 46.2493 68.2587 45.4767C68.0481 44.7881 68.5503 44.4018 69.1336 44.4857C69.3118 44.5193 69.7492 44.6705 70.4297 44.9896L70.6565 45.0904L70.6241 45.0568C70.3649 44.6537 70.1218 44.3178 69.9112 43.9819L69.49 43.3436L68.9392 42.5374C68.6961 42.1847 68.4207 41.7816 68.1291 41.3281C67.8537 40.9082 67.9347 40.3372 68.3073 40.0684C68.6799 39.8165 69.1984 39.9341 69.4738 40.3372ZM76.7967 46.2829L76.7805 46.2997L74.0101 48.6175C73.8967 48.7183 73.8643 48.8862 73.9615 49.0038L73.9777 49.0206L74.3341 49.4741C74.4313 49.5916 74.5933 49.6252 74.7068 49.5245L74.723 49.5077L77.4933 47.1899C77.6067 47.0891 77.6392 46.9211 77.5419 46.8036L77.5257 46.7868L77.1855 46.3333C77.0883 46.2157 76.9263 46.1989 76.7967 46.2829ZM68.5341 40.4212C68.3397 40.5555 68.3073 40.8578 68.4531 41.093L69.247 42.2519L69.7006 42.9405C69.814 43.1085 69.9112 43.2596 70.0084 43.4108L70.1542 43.6292C70.5269 44.2002 70.9643 44.8049 71.4503 45.4599C71.5799 45.6278 71.4017 45.863 71.2073 45.779L70.7375 45.5607L70.4297 45.4263C69.6844 45.0904 69.2308 44.9224 69.085 44.8888C68.7609 44.8384 68.5665 45.0064 68.6637 45.3423C68.8419 45.9302 71.1425 47.4586 72.876 47.9625L72.9246 47.9793L72.9894 47.9961C73.2325 48.0464 73.4431 48.1304 73.6537 48.2312L73.7185 48.2648C73.7347 48.2816 73.7671 48.2984 73.7833 48.3152L76.4889 46.0477C76.4079 45.8126 76.3269 45.5775 76.2621 45.3087L76.2135 45.1072C75.9542 44.0826 75.7598 43.6124 75.209 42.655C74.885 42.0839 74.4961 41.5129 74.0101 40.9586L73.9129 40.7907L73.8967 40.7739C73.8157 40.6563 73.4755 40.5891 73.3135 40.7067C73.1515 40.8075 73.1028 41.1098 73.1839 41.2609L73.2001 41.2777L73.6051 41.8824C73.6699 41.9832 73.6375 42.1007 73.5565 42.1679C73.4755 42.2351 73.3459 42.2183 73.2811 42.1343L73.2649 42.1175L73.0056 41.7144L72.9732 41.6976L72.552 41.0594C72.471 40.9418 72.1308 40.8746 71.9526 40.9922C71.8068 41.093 71.7582 41.3953 71.8392 41.5297L71.8554 41.5465L72.5034 42.5374L72.6006 42.6718C72.6654 42.7726 72.633 42.8901 72.552 42.9573C72.471 43.0245 72.3414 43.0077 72.2766 42.9237L72.2604 42.9069L71.2883 41.4121C71.2073 41.2945 70.8833 41.2442 70.7051 41.3785C70.5431 41.4961 70.4945 41.7648 70.5755 41.8992L70.5917 41.916L71.6609 43.562V43.5788L71.6771 43.5956V43.6124V43.6292C71.6771 43.6459 71.6771 43.6459 71.6771 43.6627V43.6795V43.6963V43.7131V43.7299L71.6609 43.7467L71.6447 43.7635L71.6285 43.7803V43.8139L71.6123 43.8307L71.5961 43.8475C71.5961 43.8475 71.5799 43.8643 71.5637 43.8643H71.5475H71.5313H71.5151H71.4827H71.4665H71.4503H71.4341C71.4179 43.8643 71.4179 43.8643 71.4017 43.8475L71.3693 43.8307L71.3531 43.8139V43.8307L71.3369 43.8139L71.3207 43.7971L71.3045 43.7803L69.166 40.6059C69.004 40.3708 68.7123 40.2868 68.5341 40.4212ZM71.0615 35.5C71.8716 35.5 72.5358 36.1718 72.552 37.0116V37.062V39.4302C72.552 39.5478 72.4548 39.6318 72.3576 39.6318C72.2604 39.6318 72.1632 39.5478 72.1632 39.447V39.4302V37.0452C72.1632 36.4406 71.6933 35.9367 71.1101 35.9199H71.0777L49.5067 35.9868C48.9235 35.9868 48.4374 36.4739 48.4212 37.0786V37.1122V44.5863C48.4212 45.1909 48.8911 45.6948 49.4743 45.7116H49.5067L65.7476 45.6446C65.861 45.6446 65.942 45.7454 65.942 45.8462C65.942 45.947 65.861 46.0477 65.7638 46.0477H65.7476L49.4905 46.1147C48.6805 46.1147 48.0162 45.4429 48 44.6031V44.5527V37.1122C48 36.2724 48.648 35.5837 49.4581 35.5669H49.5067L71.0615 35.5Z" fill="#57534F"/>
</svg>
`;
function Nee() {
  return /* @__PURE__ */ c.jsxs(
    "svg",
    {
      width: "100%",
      height: "100%",
      viewBox: "0 0 90 60",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ c.jsxs("g", { clipPath: "url(#clip0_10649_33098)", children: [
          /* @__PURE__ */ c.jsx("rect", { width: "90", height: "60", fill: "#FFEFDA" }),
          /* @__PURE__ */ c.jsx("rect", { x: "22.5", y: "18", width: "9", height: "3", fill: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("rect", { x: "42.5", y: "18", width: "25", height: "3", fill: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("rect", { x: "22.5", y: "25", width: "45", height: "3", fill: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("rect", { x: "22.5", y: "32", width: "25", height: "3", fill: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("rect", { x: "58.5", y: "32", width: "9", height: "3", fill: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("rect", { x: "22.5", y: "39", width: "13", height: "3", fill: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("rect", { x: "48.5", y: "39", width: "19", height: "3", fill: "#FFBE5D" })
        ] }),
        /* @__PURE__ */ c.jsx("defs", { children: /* @__PURE__ */ c.jsx("clipPath", { id: "clip0_10649_33098", children: /* @__PURE__ */ c.jsx("rect", { width: "90", height: "60", rx: "4", fill: "white" }) }) })
      ]
    }
  );
}
const Oee = `<svg width="100%" height="100%" viewBox="0 0 90 60" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_10649_33098)">
    <rect width="90" height="60" fill="#FFEFDA" />
    <rect x="22.5" y="18" width="9" height="3" fill="#FFBE5D" />
    <rect x="42.5" y="18" width="25" height="3" fill="#FFBE5D" />
    <rect x="22.5" y="25" width="45" height="3" fill="#FFBE5D" />
    <rect x="22.5" y="32" width="25" height="3" fill="#FFBE5D" />
    <rect x="58.5" y="32" width="9" height="3" fill="#FFBE5D" />
    <rect x="22.5" y="39" width="13" height="3" fill="#FFBE5D" />
    <rect x="48.5" y="39" width="19" height="3" fill="#FFBE5D" />
  </g>
  <defs>
    <clipPath id="clip0_10649_33098">
      <rect width="90" height="60" rx="4" fill="white" />
    </clipPath>
  </defs>
</svg>
  `;
function zee() {
  return /* @__PURE__ */ c.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 61 40", fill: "none", children: [
    /* @__PURE__ */ c.jsx("path", { fill: "#FFF5E9", d: "M.084 0h60v40h-60z" }),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#000",
        fillOpacity: ".08",
        d: "M10.084 3.565h42.928v2.638H10.084z"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#57534F",
        d: "M18.77 17.52a.235.235 0 0 0 .204-.12.265.265 0 0 0 .032-.117.212.212 0 0 0-.033-.123l-2.218-3.837a.249.249 0 0 0-.21-.12.248.248 0 0 0-.21.12l-2.218 3.837a.216.216 0 0 0-.033.123.26.26 0 0 0 .033.117.235.235 0 0 0 .204.12h4.449Zm-2.225-.72a.233.233 0 0 1-.17-.069.231.231 0 0 1-.07-.17c0-.068.023-.125.07-.171a.23.23 0 0 1 .17-.07c.068 0 .125.024.171.07a.231.231 0 0 1 .07.17.232.232 0 0 1-.07.172.231.231 0 0 1-.17.068Zm0-.719a.233.233 0 0 1-.17-.07.232.232 0 0 1-.07-.17v-.72c0-.067.023-.124.07-.17a.231.231 0 0 1 .17-.07c.068 0 .125.024.171.07a.231.231 0 0 1 .07.17v.72a.232.232 0 0 1-.07.171.231.231 0 0 1-.17.069Z"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#FFD59D",
        d: "M14.084 20.52h24.178v2.638H14.084zM14.084 24.158h15.317v2.638H14.084z"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "rect",
      {
        width: "42.1",
        height: "18.693",
        x: "10.534",
        y: "10.653",
        stroke: "#FFBB62",
        strokeWidth: ".9",
        rx: "1.55"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#000",
        fillOpacity: ".08",
        d: "M10.084 33.797h42.928v2.638H10.084z"
      }
    )
  ] });
}
const Fee = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 40" fill="none">
  <path fill="#FFF5E9" d="M.084 0h60v40h-60z" />
  <path
    fill="#000"
    fill-opacity=".08"
    d="M10.084 3.565h42.928v2.638H10.084z"
  />
  <path
    fill="#57534F"
    d="M18.77 17.52a.235.235 0 0 0 .204-.12.265.265 0 0 0 .032-.117.212.212 0 0 0-.033-.123l-2.218-3.837a.249.249 0 0 0-.21-.12.248.248 0 0 0-.21.12l-2.218 3.837a.216.216 0 0 0-.033.123.26.26 0 0 0 .033.117.235.235 0 0 0 .204.12h4.449Zm-2.225-.72a.233.233 0 0 1-.17-.069.231.231 0 0 1-.07-.17c0-.068.023-.125.07-.171a.23.23 0 0 1 .17-.07c.068 0 .125.024.171.07a.231.231 0 0 1 .07.17.232.232 0 0 1-.07.172.231.231 0 0 1-.17.068Zm0-.719a.233.233 0 0 1-.17-.07.232.232 0 0 1-.07-.17v-.72c0-.067.023-.124.07-.17a.231.231 0 0 1 .17-.07c.068 0 .125.024.171.07a.231.231 0 0 1 .07.17v.72a.232.232 0 0 1-.07.171.231.231 0 0 1-.17.069Z"
  />
  <path
    fill="#FFD59D"
    d="M14.084 20.52h24.178v2.638H14.084zM14.084 24.158h15.317v2.638H14.084z"
  />
  <rect
    width="42.1"
    height="18.693"
    x="10.534"
    y="10.653"
    stroke="#FFBB62"
    strokeWidth=".9"
    rx="1.55"
  />
  <path
    fill="#000"
    fill-opacity=".08"
    d="M10.084 33.797h42.928v2.638H10.084z"
  />
</svg>
`;
function Lee() {
  return /* @__PURE__ */ c.jsxs(
    "svg",
    {
      viewBox: "0 0 90 60",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "xMidYMid meet",
      children: [
        /* @__PURE__ */ c.jsx("rect", { width: "90", height: "60", rx: "4", fill: "#FFEFDA" }),
        /* @__PURE__ */ c.jsxs("g", { clipPath: "url(#clip0_10788_34096)", children: [
          /* @__PURE__ */ c.jsx(
            "rect",
            {
              width: "90",
              height: "50",
              transform: "translate(0 5)",
              fill: "#FFEFDA"
            }
          ),
          /* @__PURE__ */ c.jsx("rect", { x: "7.5", y: "12", width: "75", height: "36", rx: "1", fill: "#FFD59D" }),
          /* @__PURE__ */ c.jsx(
            "path",
            {
              d: "M41.4286 28.6429L38 33.5H52.2857L47.7143 27.5L44.2857 32.3571L41.4286 28.6429Z",
              fill: "#575350",
              stroke: "#575350",
              strokeWidth: "0.5",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ c.jsx(
            "rect",
            {
              x: "15.25",
              y: "20.25",
              width: "20",
              height: "7",
              rx: "0.25",
              stroke: "#57534F",
              strokeWidth: "0.5",
              strokeDasharray: "1 1"
            }
          ),
          /* @__PURE__ */ c.jsx(
            "path",
            {
              d: "M73.25 49.75L73 50L73.25 50.75L74 51.5L75.25 52.25L77.25 53L78.25 53.5V54L79 54.75L79.75 54.5L81 53.25L82 52.5L82.25 51.75L81.75 51.25L81.25 51L81 50.75L80.5 48.75L79.5 47L78.5 45.5H77.75L77.25 46L76.5 45.75L75.75 46.25L75.25 46L74.75 46.5H74.5L74 45.75L73.5 45.25H73L72.75 45.75L73 46.75L74 47.75L74.75 49L75.25 49.75L75.5 50.5L75 50.25L74.5 50L73.75 49.75H73.25Z",
              fill: "#FFEFDA"
            }
          ),
          /* @__PURE__ */ c.jsx(
            "path",
            {
              d: "M52.9841 41.468L53.468 40.9841L53.9519 40.7422H55.6454H73.0648H75.7261L76.4519 41.2261L76.9357 41.9519V44.3712V45.8228H76.4519L75.968 46.3067L75.2422 46.0648L74.5164 46.7906L74.0325 45.5809L73.3067 45.097L72.8228 45.339L72.5809 46.0648L74.7583 49.2099L75.4841 50.4196L75.2422 50.1777H74.5164L74.0325 49.6938H73.3067L73.0648 49.9357V50.4196V50.9035H59.5164H56.3712H54.1938H53.468L52.9841 50.4196L52.7422 50.1777V48.968V48.0003V46.7906V45.339V43.8873V42.4357L52.9841 41.468Z",
              fill: "#FFEFDA"
            }
          ),
          /* @__PURE__ */ c.jsx(
            "path",
            {
              d: "M72.0459 50.6614C72.1593 50.6614 72.2403 50.7622 72.2403 50.863C72.2403 50.9638 72.1593 51.0645 72.0621 51.0645H72.0459H70.9604C70.847 51.0645 70.766 50.9638 70.766 50.863C70.766 50.7622 70.847 50.6614 70.9442 50.6614H70.9604H72.0459ZM73.9738 45.3372L74.7028 46.4121C74.7514 46.2609 74.8487 46.1266 74.9945 46.0426C75.2861 45.8411 75.7073 45.8578 75.9665 46.0426C76.0151 45.8914 76.1123 45.7403 76.242 45.6563C76.5498 45.438 77.052 45.5051 77.3112 45.7403C77.3598 45.5891 77.457 45.4715 77.5866 45.3708C77.9269 45.1356 78.4939 45.2364 78.7207 45.5387V45.5555L78.8179 45.6563C79.2878 46.1938 79.6766 46.748 80.0006 47.3023L80.0654 47.4199L80.1626 47.6046L80.2598 47.7894L80.3408 47.9573C80.7297 48.6963 80.9079 49.217 81.1509 50.208C81.1995 50.4431 81.2643 50.6614 81.3453 50.863C81.5721 50.8294 81.8151 50.8966 81.9771 51.0813L81.9933 51.1149L82.3498 51.5684C82.5766 51.8707 82.5442 52.2906 82.2688 52.5426L82.2364 52.5594L79.4822 54.8604C79.1906 55.0955 78.7855 55.0619 78.5425 54.7764L78.5263 54.7428L78.1699 54.2893C78.0079 54.0878 77.9755 53.8358 78.0565 53.6175H78.0403H78.0241C77.8459 53.5167 77.6352 53.4495 77.4084 53.3991L77.3274 53.3824H77.3112C75.4481 52.8785 72.9855 51.2493 72.7587 50.4767C72.5481 49.7881 73.0503 49.4018 73.6336 49.4857C73.8118 49.5193 74.2492 49.6705 74.9297 49.9896L75.1565 50.0904L75.1241 50.0568C74.8649 49.6537 74.6218 49.3178 74.4112 48.9819L73.99 48.3436L73.4392 47.5374C73.1961 47.1847 72.9207 46.7816 72.6291 46.3281C72.3537 45.9082 72.4347 45.3372 72.8073 45.0684C73.1799 44.8165 73.6984 44.9341 73.9738 45.3372ZM81.2967 51.2829L81.2805 51.2997L78.5101 53.6175C78.3967 53.7183 78.3643 53.8862 78.4615 54.0038L78.4777 54.0206L78.8341 54.4741C78.9313 54.5916 79.0933 54.6252 79.2068 54.5245L79.223 54.5077L81.9933 52.1899C82.1067 52.0891 82.1392 51.9211 82.0419 51.8036L82.0257 51.7868L81.6855 51.3333C81.5883 51.2157 81.4263 51.1989 81.2967 51.2829ZM73.0341 45.4212C72.8397 45.5555 72.8073 45.8578 72.9531 46.093L73.747 47.2519L74.2006 47.9405C74.314 48.1085 74.4112 48.2596 74.5084 48.4108L74.6542 48.6292C75.0269 49.2002 75.4643 49.8049 75.9503 50.4599C76.0799 50.6278 75.9017 50.863 75.7073 50.779L75.2375 50.5607L74.9297 50.4263C74.1844 50.0904 73.7308 49.9224 73.585 49.8888C73.2609 49.8384 73.0665 50.0064 73.1637 50.3423C73.342 50.9302 75.6425 52.4586 77.376 52.9625L77.4246 52.9793L77.4894 52.9961C77.7325 53.0464 77.9431 53.1304 78.1537 53.2312L78.2185 53.2648C78.2347 53.2816 78.2671 53.2984 78.2833 53.3152L80.9889 51.0477C80.9079 50.8126 80.8269 50.5775 80.7621 50.3087L80.7135 50.1072C80.4542 49.0826 80.2598 48.6124 79.709 47.655C79.385 47.0839 78.9961 46.5129 78.5101 45.9586L78.4129 45.7907L78.3967 45.7739C78.3157 45.6563 77.9755 45.5891 77.8135 45.7067C77.6515 45.8075 77.6028 46.1098 77.6839 46.2609L77.7001 46.2777L78.1051 46.8824C78.1699 46.9832 78.1375 47.1007 78.0565 47.1679C77.9755 47.2351 77.8459 47.2183 77.7811 47.1343L77.7649 47.1175L77.5056 46.7144L77.4732 46.6976L77.052 46.0594C76.971 45.9418 76.6308 45.8746 76.4526 45.9922C76.3068 46.093 76.2582 46.3953 76.3392 46.5297L76.3554 46.5465L77.0034 47.5374L77.1006 47.6718C77.1654 47.7726 77.133 47.8901 77.052 47.9573C76.971 48.0245 76.8414 48.0077 76.7766 47.9237L76.7604 47.9069L75.7883 46.4121C75.7073 46.2945 75.3833 46.2442 75.2051 46.3785C75.0431 46.4961 74.9945 46.7648 75.0755 46.8992L75.0917 46.916L76.1609 48.562V48.5788L76.1771 48.5956V48.6124V48.6292C76.1771 48.6459 76.1771 48.6459 76.1771 48.6627V48.6795V48.6963V48.7131V48.7299L76.1609 48.7467L76.1447 48.7635L76.1285 48.7803V48.8139L76.1123 48.8307L76.0961 48.8475C76.0961 48.8475 76.0799 48.8643 76.0637 48.8643H76.0475H76.0313H76.0151H75.9827H75.9665H75.9503H75.9341C75.9179 48.8643 75.9179 48.8643 75.9017 48.8475L75.8693 48.8307L75.8531 48.8139V48.8307L75.8369 48.8139L75.8207 48.7971L75.8045 48.7803L73.666 45.6059C73.504 45.3708 73.2123 45.2868 73.0341 45.4212ZM75.5615 40.5C76.3716 40.5 77.0358 41.1718 77.052 42.0116V42.062V44.4302C77.052 44.5478 76.9548 44.6318 76.8576 44.6318C76.7604 44.6318 76.6632 44.5478 76.6632 44.447V44.4302V42.0452C76.6632 41.4406 76.1933 40.9367 75.6101 40.9199H75.5777L54.0067 40.9868C53.4235 40.9868 52.9374 41.4739 52.9212 42.0786V42.1122V49.5863C52.9212 50.1909 53.3911 50.6948 53.9743 50.7116H54.0067L70.2476 50.6446C70.361 50.6446 70.442 50.7454 70.442 50.8462C70.442 50.947 70.361 51.0477 70.2638 51.0477H70.2476L53.9905 51.1147C53.1805 51.1147 52.5162 50.4429 52.5 49.6031V49.5527V42.1122C52.5 41.2724 53.148 40.5837 53.9581 40.5669H54.0067L75.5615 40.5Z",
              fill: "#57534F"
            }
          )
        ] }),
        /* @__PURE__ */ c.jsx("defs", { children: /* @__PURE__ */ c.jsx("clipPath", { id: "clip0_10788_34096", children: /* @__PURE__ */ c.jsx(
          "rect",
          {
            width: "90",
            height: "50",
            fill: "white",
            transform: "translate(0 5)"
          }
        ) }) })
      ]
    }
  );
}
const Mee = `<svg viewBox="0 0 90 60" fill="none" xmlns="http://www.w3.org/2000/svg"
  preserveAspectRatio="xMidYMid meet">
  <rect width="90" height="60" rx="4" fill="#FFEFDA" />
  <g clip-path="url(#clip0_10788_34096)">
    <rect width="90" height="50" transform="translate(0 5)" fill="#FFEFDA" />
    <rect x="7.5" y="12" width="75" height="36" rx="1" fill="#FFD59D" />
    <path d="M41.4286 28.6429L38 33.5H52.2857L47.7143 27.5L44.2857 32.3571L41.4286 28.6429Z"
      fill="#575350" stroke="#575350" stroke-width="0.5" stroke-linejoin="round" />
    <rect x="15.25" y="20.25" width="20" height="7" rx="0.25" stroke="#57534F" stroke-width="0.5"
      stroke-dasharray="1 1" />
    <path
      d="M73.25 49.75L73 50L73.25 50.75L74 51.5L75.25 52.25L77.25 53L78.25 53.5V54L79 54.75L79.75 54.5L81 53.25L82 52.5L82.25 51.75L81.75 51.25L81.25 51L81 50.75L80.5 48.75L79.5 47L78.5 45.5H77.75L77.25 46L76.5 45.75L75.75 46.25L75.25 46L74.75 46.5H74.5L74 45.75L73.5 45.25H73L72.75 45.75L73 46.75L74 47.75L74.75 49L75.25 49.75L75.5 50.5L75 50.25L74.5 50L73.75 49.75H73.25Z"
      fill="#FFEFDA" />
    <path
      d="M52.9841 41.468L53.468 40.9841L53.9519 40.7422H55.6454H73.0648H75.7261L76.4519 41.2261L76.9357 41.9519V44.3712V45.8228H76.4519L75.968 46.3067L75.2422 46.0648L74.5164 46.7906L74.0325 45.5809L73.3067 45.097L72.8228 45.339L72.5809 46.0648L74.7583 49.2099L75.4841 50.4196L75.2422 50.1777H74.5164L74.0325 49.6938H73.3067L73.0648 49.9357V50.4196V50.9035H59.5164H56.3712H54.1938H53.468L52.9841 50.4196L52.7422 50.1777V48.968V48.0003V46.7906V45.339V43.8873V42.4357L52.9841 41.468Z"
      fill="#FFEFDA" />
    <path
      d="M72.0459 50.6614C72.1593 50.6614 72.2403 50.7622 72.2403 50.863C72.2403 50.9638 72.1593 51.0645 72.0621 51.0645H72.0459H70.9604C70.847 51.0645 70.766 50.9638 70.766 50.863C70.766 50.7622 70.847 50.6614 70.9442 50.6614H70.9604H72.0459ZM73.9738 45.3372L74.7028 46.4121C74.7514 46.2609 74.8487 46.1266 74.9945 46.0426C75.2861 45.8411 75.7073 45.8578 75.9665 46.0426C76.0151 45.8914 76.1123 45.7403 76.242 45.6563C76.5498 45.438 77.052 45.5051 77.3112 45.7403C77.3598 45.5891 77.457 45.4715 77.5866 45.3708C77.9269 45.1356 78.4939 45.2364 78.7207 45.5387V45.5555L78.8179 45.6563C79.2878 46.1938 79.6766 46.748 80.0006 47.3023L80.0654 47.4199L80.1626 47.6046L80.2598 47.7894L80.3408 47.9573C80.7297 48.6963 80.9079 49.217 81.1509 50.208C81.1995 50.4431 81.2643 50.6614 81.3453 50.863C81.5721 50.8294 81.8151 50.8966 81.9771 51.0813L81.9933 51.1149L82.3498 51.5684C82.5766 51.8707 82.5442 52.2906 82.2688 52.5426L82.2364 52.5594L79.4822 54.8604C79.1906 55.0955 78.7855 55.0619 78.5425 54.7764L78.5263 54.7428L78.1699 54.2893C78.0079 54.0878 77.9755 53.8358 78.0565 53.6175H78.0403H78.0241C77.8459 53.5167 77.6352 53.4495 77.4084 53.3991L77.3274 53.3824H77.3112C75.4481 52.8785 72.9855 51.2493 72.7587 50.4767C72.5481 49.7881 73.0503 49.4018 73.6336 49.4857C73.8118 49.5193 74.2492 49.6705 74.9297 49.9896L75.1565 50.0904L75.1241 50.0568C74.8649 49.6537 74.6218 49.3178 74.4112 48.9819L73.99 48.3436L73.4392 47.5374C73.1961 47.1847 72.9207 46.7816 72.6291 46.3281C72.3537 45.9082 72.4347 45.3372 72.8073 45.0684C73.1799 44.8165 73.6984 44.9341 73.9738 45.3372ZM81.2967 51.2829L81.2805 51.2997L78.5101 53.6175C78.3967 53.7183 78.3643 53.8862 78.4615 54.0038L78.4777 54.0206L78.8341 54.4741C78.9313 54.5916 79.0933 54.6252 79.2068 54.5245L79.223 54.5077L81.9933 52.1899C82.1067 52.0891 82.1392 51.9211 82.0419 51.8036L82.0257 51.7868L81.6855 51.3333C81.5883 51.2157 81.4263 51.1989 81.2967 51.2829ZM73.0341 45.4212C72.8397 45.5555 72.8073 45.8578 72.9531 46.093L73.747 47.2519L74.2006 47.9405C74.314 48.1085 74.4112 48.2596 74.5084 48.4108L74.6542 48.6292C75.0269 49.2002 75.4643 49.8049 75.9503 50.4599C76.0799 50.6278 75.9017 50.863 75.7073 50.779L75.2375 50.5607L74.9297 50.4263C74.1844 50.0904 73.7308 49.9224 73.585 49.8888C73.2609 49.8384 73.0665 50.0064 73.1637 50.3423C73.342 50.9302 75.6425 52.4586 77.376 52.9625L77.4246 52.9793L77.4894 52.9961C77.7325 53.0464 77.9431 53.1304 78.1537 53.2312L78.2185 53.2648C78.2347 53.2816 78.2671 53.2984 78.2833 53.3152L80.9889 51.0477C80.9079 50.8126 80.8269 50.5775 80.7621 50.3087L80.7135 50.1072C80.4542 49.0826 80.2598 48.6124 79.709 47.655C79.385 47.0839 78.9961 46.5129 78.5101 45.9586L78.4129 45.7907L78.3967 45.7739C78.3157 45.6563 77.9755 45.5891 77.8135 45.7067C77.6515 45.8075 77.6028 46.1098 77.6839 46.2609L77.7001 46.2777L78.1051 46.8824C78.1699 46.9832 78.1375 47.1007 78.0565 47.1679C77.9755 47.2351 77.8459 47.2183 77.7811 47.1343L77.7649 47.1175L77.5056 46.7144L77.4732 46.6976L77.052 46.0594C76.971 45.9418 76.6308 45.8746 76.4526 45.9922C76.3068 46.093 76.2582 46.3953 76.3392 46.5297L76.3554 46.5465L77.0034 47.5374L77.1006 47.6718C77.1654 47.7726 77.133 47.8901 77.052 47.9573C76.971 48.0245 76.8414 48.0077 76.7766 47.9237L76.7604 47.9069L75.7883 46.4121C75.7073 46.2945 75.3833 46.2442 75.2051 46.3785C75.0431 46.4961 74.9945 46.7648 75.0755 46.8992L75.0917 46.916L76.1609 48.562V48.5788L76.1771 48.5956V48.6124V48.6292C76.1771 48.6459 76.1771 48.6459 76.1771 48.6627V48.6795V48.6963V48.7131V48.7299L76.1609 48.7467L76.1447 48.7635L76.1285 48.7803V48.8139L76.1123 48.8307L76.0961 48.8475C76.0961 48.8475 76.0799 48.8643 76.0637 48.8643H76.0475H76.0313H76.0151H75.9827H75.9665H75.9503H75.9341C75.9179 48.8643 75.9179 48.8643 75.9017 48.8475L75.8693 48.8307L75.8531 48.8139V48.8307L75.8369 48.8139L75.8207 48.7971L75.8045 48.7803L73.666 45.6059C73.504 45.3708 73.2123 45.2868 73.0341 45.4212ZM75.5615 40.5C76.3716 40.5 77.0358 41.1718 77.052 42.0116V42.062V44.4302C77.052 44.5478 76.9548 44.6318 76.8576 44.6318C76.7604 44.6318 76.6632 44.5478 76.6632 44.447V44.4302V42.0452C76.6632 41.4406 76.1933 40.9367 75.6101 40.9199H75.5777L54.0067 40.9868C53.4235 40.9868 52.9374 41.4739 52.9212 42.0786V42.1122V49.5863C52.9212 50.1909 53.3911 50.6948 53.9743 50.7116H54.0067L70.2476 50.6446C70.361 50.6446 70.442 50.7454 70.442 50.8462C70.442 50.947 70.361 51.0477 70.2638 51.0477H70.2476L53.9905 51.1147C53.1805 51.1147 52.5162 50.4429 52.5 49.6031V49.5527V42.1122C52.5 41.2724 53.148 40.5837 53.9581 40.5669H54.0067L75.5615 40.5Z"
      fill="#57534F" />
  </g>
  <defs>
    <clipPath id="clip0_10788_34096">
      <rect width="90" height="50" fill="white" transform="translate(0 5)" />
    </clipPath>
  </defs>
</svg>`, Bee = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 40" fill="none">
  <path fill="#FFF5E9" d="M.084 0h60v40h-60z" />
  <path fill="#000" fill-opacity=".08" d="M8.62 3.688h42.928v2.638H8.62z" />
  <path
    fill="#57534F"
    d="M17.813 13.41c-.22 0-.403-.042-.55-.128a.791.791 0 0 1-.314-.345.903.903 0 0 1-.072-.462.851.851 0 0 1 .174-.468.916.916 0 0 1 .402-.285c.168-.066.36-.1.579-.1.128 0 .25.012.366.034a2.7 2.7 0 0 1 .339.08l.03-.287c.022-.204-.001-.355-.07-.453-.065-.098-.185-.147-.36-.147a.7.7 0 0 0-.275.05.462.462 0 0 0-.19.148.46.46 0 0 0-.083.228h-.696a.957.957 0 0 1 .204-.546.987.987 0 0 1 .444-.3c.182-.064.38-.096.597-.096.382 0 .664.094.846.282.182.186.255.472.219.858l-.174 1.854h-.552a3.272 3.272 0 0 1-.006-.198c0-.066-.002-.132-.006-.198-.102.158-.22.278-.354.36-.134.08-.3.12-.498.12Zm.18-.54a.663.663 0 0 0 .585-.33.834.834 0 0 0 .117-.353 2.37 2.37 0 0 0-.288-.066 1.574 1.574 0 0 0-.297-.03.755.755 0 0 0-.378.09c-.106.058-.165.156-.177.294a.341.341 0 0 0 .108.285c.08.074.19.11.33.11Z"
  />
  <path
    fill="#57534F"
    stroke="#57534F"
    strokeWidth=".368"
    d="M17.9 22.232v-6.72h.368v6.72z"
  />
  <path
    fill="#57534F"
    d="m18.084 24.673-1.955-3.386h3.91l-1.955 3.386ZM18.259 29.757a.697.697 0 0 1-.435-.147.847.847 0 0 1-.282-.44l-.198.503h-.414l.384-4.116h.642l-.15 1.566a.995.995 0 0 1 .342-.33.9.9 0 0 1 .447-.114c.198 0 .373.053.525.16.152.105.272.256.36.452.088.194.132.424.132.69 0 .184-.028.38-.084.585a2.095 2.095 0 0 1-.25.58c-.111.18-.252.326-.422.44-.17.114-.37.171-.597.171Zm-.036-.642a.558.558 0 0 0 .327-.096.802.802 0 0 0 .23-.252c.063-.106.109-.22.139-.345.03-.124.045-.246.045-.366 0-.226-.053-.406-.16-.54a.5.5 0 0 0-.41-.2.71.71 0 0 0-.552.297.7.7 0 0 0-.12.35l-.036.42a.795.795 0 0 0 .05.378.61.61 0 0 0 .199.261.48.48 0 0 0 .288.093Z"
  />
  <path fill="#FFDEB2" d="M22.341 10h12v4h-12z" />
  <path fill="#FFBB62" d="M22.341 18h22v4h-22z" />
  <path fill="#FFDEB2" d="M22.341 26h12v4h-12z" />
  <path fill="#000" fill-opacity=".08" d="M8.62 33.673h42.928v2.638H8.62z" />
</svg>
`;
function Iee() {
  return /* @__PURE__ */ c.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 61 40", fill: "none", children: [
    /* @__PURE__ */ c.jsx("path", { fill: "#FFF5E9", d: "M.084 0h60v40h-60z" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#000", fillOpacity: ".08", d: "M8.62 3.688h42.928v2.638H8.62z" }),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#57534F",
        d: "M17.813 13.41c-.22 0-.403-.042-.55-.128a.791.791 0 0 1-.314-.345.903.903 0 0 1-.072-.462.851.851 0 0 1 .174-.468.916.916 0 0 1 .402-.285c.168-.066.36-.1.579-.1.128 0 .25.012.366.034a2.7 2.7 0 0 1 .339.08l.03-.287c.022-.204-.001-.355-.07-.453-.065-.098-.185-.147-.36-.147a.7.7 0 0 0-.275.05.462.462 0 0 0-.19.148.46.46 0 0 0-.083.228h-.696a.957.957 0 0 1 .204-.546.987.987 0 0 1 .444-.3c.182-.064.38-.096.597-.096.382 0 .664.094.846.282.182.186.255.472.219.858l-.174 1.854h-.552a3.272 3.272 0 0 1-.006-.198c0-.066-.002-.132-.006-.198-.102.158-.22.278-.354.36-.134.08-.3.12-.498.12Zm.18-.54a.663.663 0 0 0 .585-.33.834.834 0 0 0 .117-.353 2.37 2.37 0 0 0-.288-.066 1.574 1.574 0 0 0-.297-.03.755.755 0 0 0-.378.09c-.106.058-.165.156-.177.294a.341.341 0 0 0 .108.285c.08.074.19.11.33.11Z"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#57534F",
        stroke: "#57534F",
        strokeWidth: ".368",
        d: "M17.9 22.232v-6.72h.368v6.72z"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#57534F",
        d: "m18.084 24.673-1.955-3.386h3.91l-1.955 3.386ZM18.259 29.757a.697.697 0 0 1-.435-.147.847.847 0 0 1-.282-.44l-.198.503h-.414l.384-4.116h.642l-.15 1.566a.995.995 0 0 1 .342-.33.9.9 0 0 1 .447-.114c.198 0 .373.053.525.16.152.105.272.256.36.452.088.194.132.424.132.69 0 .184-.028.38-.084.585a2.095 2.095 0 0 1-.25.58c-.111.18-.252.326-.422.44-.17.114-.37.171-.597.171Zm-.036-.642a.558.558 0 0 0 .327-.096.802.802 0 0 0 .23-.252c.063-.106.109-.22.139-.345.03-.124.045-.246.045-.366 0-.226-.053-.406-.16-.54a.5.5 0 0 0-.41-.2.71.71 0 0 0-.552.297.7.7 0 0 0-.12.35l-.036.42a.795.795 0 0 0 .05.378.61.61 0 0 0 .199.261.48.48 0 0 0 .288.093Z"
      }
    ),
    /* @__PURE__ */ c.jsx("path", { fill: "#FFDEB2", d: "M22.341 10h12v4h-12z" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#FFBB62", d: "M22.341 18h22v4h-22z" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#FFDEB2", d: "M22.341 26h12v4h-12z" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#000", fillOpacity: ".08", d: "M8.62 33.673h42.928v2.638H8.62z" })
  ] });
}
function $4() {
  return /* @__PURE__ */ c.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 61 40", fill: "none", children: [
    /* @__PURE__ */ c.jsx("path", { fill: "#FFF5E9", d: "M.084 0h60v40h-60z" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#000", fillOpacity: ".08", d: "M8.584 3.712h42.928V6.35H8.584z" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#FFDDB2", d: "M8.584 9.35h43v21.3h-43z" }),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        stroke: "#57534F",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M36.473 16.004a.47.47 0 0 0-.21-.16l-6-2.27a.45.45 0 0 0-.36 0l-6 2.31a.47.47 0 0 0-.21.12.48.48 0 0 0-.11.3v7.32a.5.5 0 0 0 .32.46l6 2.31h.36l6-2.31a.5.5 0 0 0 .32-.46v-7.28a.48.48 0 0 0-.11-.34ZM30.083 26.464v-7.96m0 0-6.39-2.46m6.39 2.46 6.39-2.46"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#000",
        fillOpacity: ".08",
        d: "M8.584 33.65h42.928v2.638H8.584z"
      }
    )
  ] });
}
const H4 = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 40" fill="none">
  <path fill="#FFF5E9" d="M.084 0h60v40h-60z" />
  <path fill="#000" fill-opacity=".08" d="M8.584 3.712h42.928V6.35H8.584z" />
  <path fill="#FFDDB2" d="M8.584 9.35h43v21.3h-43z" />
  <path
    stroke="#57534F"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M36.473 16.004a.47.47 0 0 0-.21-.16l-6-2.27a.45.45 0 0 0-.36 0l-6 2.31a.47.47 0 0 0-.21.12.48.48 0 0 0-.11.3v7.32a.5.5 0 0 0 .32.46l6 2.31h.36l6-2.31a.5.5 0 0 0 .32-.46v-7.28a.48.48 0 0 0-.11-.34ZM30.083 26.464v-7.96m0 0-6.39-2.46m6.39 2.46 6.39-2.46"
  />
  <path
    fill="#000"
    fill-opacity=".08"
    d="M8.584 33.65h42.928v2.638H8.584z"
  />
</svg>
`;
function Ree() {
  return /* @__PURE__ */ c.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 61 40", fill: "none", children: [
    /* @__PURE__ */ c.jsx("path", { fill: "#FFF5E9", d: "M.084 0h60v40h-60z" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#000", fillOpacity: ".08", d: "M8.584 3.712h42.928V6.35H8.584z" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#FFDDB2", d: "M8.584 9.35h43v21.3h-43z" }),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        stroke: "#57534F",
        d: "M34.833 16.528c1.546 2.113.822 5.444-1.869 7.411-2.69 1.967-6.084 1.647-7.63-.467-1.545-2.113-.82-5.444 1.87-7.411 2.69-1.967 6.084-1.647 7.63.467Z"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "circle",
      {
        cx: "29.782",
        cy: "15",
        r: "1.518",
        fill: "#FFBB62",
        stroke: "#9E8461",
        strokeWidth: ".58"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "circle",
      {
        cx: "35.618",
        cy: "18.062",
        r: "1.518",
        fill: "#FFBB62",
        stroke: "#9E8461",
        strokeWidth: ".58"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "circle",
      {
        cx: "33.319",
        cy: "23.811",
        r: "1.518",
        fill: "#FFBB62",
        stroke: "#9E8461",
        strokeWidth: ".58"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "circle",
      {
        cx: "26.878",
        cy: "24.616",
        r: "1.518",
        fill: "#FFBB62",
        stroke: "#9E8461",
        strokeWidth: ".58"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "circle",
      {
        cx: "24.636",
        cy: "19.039",
        r: "1.518",
        fill: "#FFBB62",
        stroke: "#9E8461",
        strokeWidth: ".58"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#000",
        fillOpacity: ".08",
        d: "M8.584 33.65h42.928v2.638H8.584z"
      }
    )
  ] });
}
const Pee = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 40" fill="none">
  <path fill="#FFF5E9" d="M.084 0h60v40h-60z" />
  <path fill="#000" fill-opacity=".08" d="M8.584 3.712h42.928V6.35H8.584z" />
  <path fill="#FFDDB2" d="M8.584 9.35h43v21.3h-43z" />
  <path
    stroke="#57534F"
    d="M34.833 16.528c1.546 2.113.822 5.444-1.869 7.411-2.69 1.967-6.084 1.647-7.63-.467-1.545-2.113-.82-5.444 1.87-7.411 2.69-1.967 6.084-1.647 7.63.467Z"
  />
  <circle
    cx="29.782"
    cy="15"
    r="1.518"
    fill="#FFBB62"
    stroke="#9E8461"
    strokeWidth=".58"
  />
  <circle
    cx="35.618"
    cy="18.062"
    r="1.518"
    fill="#FFBB62"
    stroke="#9E8461"
    strokeWidth=".58"
  />
  <circle
    cx="33.319"
    cy="23.811"
    r="1.518"
    fill="#FFBB62"
    stroke="#9E8461"
    strokeWidth=".58"
  />
  <circle
    cx="26.878"
    cy="24.616"
    r="1.518"
    fill="#FFBB62"
    stroke="#9E8461"
    strokeWidth=".58"
  />
  <circle
    cx="24.636"
    cy="19.039"
    r="1.518"
    fill="#FFBB62"
    stroke="#9E8461"
    strokeWidth=".58"
  />
  <path
    fill="#000"
    fill-opacity=".08"
    d="M8.584 33.65h42.928v2.638H8.584z"
  />
</svg>
`;
function _ee() {
  return /* @__PURE__ */ c.jsxs(
    "svg",
    {
      viewBox: "0 0 90 60",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "xMidYMid meet",
      children: [
        /* @__PURE__ */ c.jsxs("g", { clipPath: "url(#clip0_10649_33094)", children: [
          /* @__PURE__ */ c.jsx("rect", { width: "90", height: "60", fill: "#FFEFDA" }),
          /* @__PURE__ */ c.jsx(
            "path",
            {
              d: "M22.5 30.0121V20.1738H28.5997V28.6349H35.1914V20.1738H40.1144L40.0615 20.3952C39.9589 20.8252 38.1582 28.7964 37.9391 29.7907C37.8169 30.3454 37.7408 30.8231 37.77 30.8524C37.7992 30.8816 39.0039 31.0683 40.447 31.2672L43.0709 31.629L43.471 31.1609C44.6007 29.8393 46.5207 29.8168 47.6294 31.1122C49.0826 32.8098 47.8207 35.4606 45.564 35.4505C44.7633 35.4469 44.1222 35.1523 43.5202 34.5111L43.0437 34.0036L40.4232 34.375C38.982 34.5792 37.7807 34.7684 37.7538 34.7953C37.6511 34.898 38.1784 36.1915 38.6019 36.8757C39.38 38.1329 40.3178 38.9319 41.6897 39.5066C42.0387 39.6528 42.3426 39.7899 42.3651 39.8112C42.3877 39.8326 40.7828 39.8501 38.7987 39.8501H35.1914V32.5697H28.5997V39.8501H22.5L22.5 30.0121Z",
              fill: "#FFBE5D",
              stroke: "#FFBE5D",
              strokeWidth: "1.21655"
            }
          ),
          /* @__PURE__ */ c.jsx(
            "path",
            {
              d: "M49.5097 39.7646C49.5611 39.7171 49.8291 39.605 50.1054 39.5155C52.4599 38.7521 54.2734 35.8371 54.2755 32.8125C54.2767 31.066 53.75 29.7079 52.6034 28.5009C51.8248 27.6812 50.997 27.1594 49.8981 26.7954C49.176 26.5563 48.9731 26.5341 47.4386 26.5274C45.8699 26.5205 45.7126 26.5371 44.9043 26.794C44.4303 26.9448 43.976 27.0936 43.8947 27.1247C43.7993 27.1614 43.7624 27.134 43.7904 27.0475C43.8143 26.9738 43.9735 26.3048 44.1443 25.5608L44.4548 24.2081H53.3906V20.1504L57.9901 20.1994C62.2779 20.2451 62.643 20.2626 63.3765 20.4575C65.4166 20.9995 66.6181 22.0912 67.2331 23.962C67.4602 24.6527 67.4928 24.9176 67.5 26.1264C67.5061 27.1546 67.4642 27.6659 67.3349 28.1432C66.7717 30.2218 65.2726 31.679 63.1304 32.23C62.3428 32.4326 60.4786 32.5607 58.2358 32.5663L56.5387 32.5706V39.8509H52.9772C50.9302 39.8509 49.4555 39.8142 49.5092 39.7646L49.5097 39.7646ZM60.0887 28.3776C60.7746 28.174 61.3902 27.5803 61.5567 26.9619C61.8693 25.8009 61.222 24.6267 60.0923 24.3055C59.8965 24.2499 59.017 24.1761 58.1377 24.1415L56.5389 24.0787V28.6657L58.048 28.6006C58.9599 28.5613 59.7675 28.4731 60.0887 28.3777L60.0887 28.3776Z",
              fill: "#FFBE5D",
              stroke: "#FFBE5D",
              strokeWidth: "1.21655"
            }
          )
        ] }),
        /* @__PURE__ */ c.jsx("defs", { children: /* @__PURE__ */ c.jsx("clipPath", { id: "clip0_10649_33094", children: /* @__PURE__ */ c.jsx("rect", { width: "90", height: "60", rx: "4", fill: "white" }) }) })
      ]
    }
  );
}
const qee = `<svg viewBox="0 0 90 60" fill="none" xmlns="http://www.w3.org/2000/svg"
  preserveAspectRatio="xMidYMid meet">
  <g clip-path="url(#clip0_10649_33094)">
    <rect width="90" height="60" fill="#FFEFDA" />
    <path
      d="M22.5 30.0121V20.1738H28.5997V28.6349H35.1914V20.1738H40.1144L40.0615 20.3952C39.9589 20.8252 38.1582 28.7964 37.9391 29.7907C37.8169 30.3454 37.7408 30.8231 37.77 30.8524C37.7992 30.8816 39.0039 31.0683 40.447 31.2672L43.0709 31.629L43.471 31.1609C44.6007 29.8393 46.5207 29.8168 47.6294 31.1122C49.0826 32.8098 47.8207 35.4606 45.564 35.4505C44.7633 35.4469 44.1222 35.1523 43.5202 34.5111L43.0437 34.0036L40.4232 34.375C38.982 34.5792 37.7807 34.7684 37.7538 34.7953C37.6511 34.898 38.1784 36.1915 38.6019 36.8757C39.38 38.1329 40.3178 38.9319 41.6897 39.5066C42.0387 39.6528 42.3426 39.7899 42.3651 39.8112C42.3877 39.8326 40.7828 39.8501 38.7987 39.8501H35.1914V32.5697H28.5997V39.8501H22.5L22.5 30.0121Z"
      fill="#FFBE5D" stroke="#FFBE5D" stroke-width="1.21655" />
    <path
      d="M49.5097 39.7646C49.5611 39.7171 49.8291 39.605 50.1054 39.5155C52.4599 38.7521 54.2734 35.8371 54.2755 32.8125C54.2767 31.066 53.75 29.7079 52.6034 28.5009C51.8248 27.6812 50.997 27.1594 49.8981 26.7954C49.176 26.5563 48.9731 26.5341 47.4386 26.5274C45.8699 26.5205 45.7126 26.5371 44.9043 26.794C44.4303 26.9448 43.976 27.0936 43.8947 27.1247C43.7993 27.1614 43.7624 27.134 43.7904 27.0475C43.8143 26.9738 43.9735 26.3048 44.1443 25.5608L44.4548 24.2081H53.3906V20.1504L57.9901 20.1994C62.2779 20.2451 62.643 20.2626 63.3765 20.4575C65.4166 20.9995 66.6181 22.0912 67.2331 23.962C67.4602 24.6527 67.4928 24.9176 67.5 26.1264C67.5061 27.1546 67.4642 27.6659 67.3349 28.1432C66.7717 30.2218 65.2726 31.679 63.1304 32.23C62.3428 32.4326 60.4786 32.5607 58.2358 32.5663L56.5387 32.5706V39.8509H52.9772C50.9302 39.8509 49.4555 39.8142 49.5092 39.7646L49.5097 39.7646ZM60.0887 28.3776C60.7746 28.174 61.3902 27.5803 61.5567 26.9619C61.8693 25.8009 61.222 24.6267 60.0923 24.3055C59.8965 24.2499 59.017 24.1761 58.1377 24.1415L56.5389 24.0787V28.6657L58.048 28.6006C58.9599 28.5613 59.7675 28.4731 60.0887 28.3777L60.0887 28.3776Z"
      fill="#FFBE5D" stroke="#FFBE5D" stroke-width="1.21655" />
  </g>
  <defs>
    <clipPath id="clip0_10649_33094">
      <rect width="90" height="60" rx="4" fill="white" />
    </clipPath>
  </defs>
</svg>`;
function $ee() {
  return /* @__PURE__ */ c.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 61 40", fill: "none", children: [
    /* @__PURE__ */ c.jsx("path", { fill: "#FFF5E9", d: "M.084 0h60v40h-60z" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#000", fillOpacity: ".08", d: "M8.62 4.042h42.928V6.68H8.62z" }),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#57534F",
        d: "M10.558 15.026h.831v-2.442l-.773.192v-.67l.778-.187h.718v3.107h.832v.655h-2.386v-.655Zm.62 8h1.584v.655h-2.388v-.635l.403-.428c.479-.51.77-.823.872-.94.126-.145.216-.272.272-.383a.749.749 0 0 0 .083-.333c0-.168-.051-.297-.154-.388-.1-.092-.244-.138-.43-.138-.133 0-.283.027-.45.08a2.778 2.778 0 0 0-.516.23v-.693c.18-.066.356-.115.527-.149.173-.035.338-.053.496-.053.398 0 .71.093.938.28.228.185.342.437.342.758 0 .148-.025.287-.075.416-.05.13-.134.273-.255.43-.089.115-.333.372-.733.772-.217.216-.389.39-.517.519Zm8.233-2.167h.615l.335 2.162.305-1.424h.597l.3 1.424.34-2.162h.615l-.512 2.822h-.7l-.343-1.467-.34 1.467h-.7l-.512-2.822Zm4.661.532a.47.47 0 0 0-.416.234c-.1.154-.15.37-.15.647s.05.494.15.65c.101.155.24.232.416.232a.474.474 0 0 0 .418-.232c.101-.156.152-.373.152-.65s-.05-.493-.152-.647a.473.473 0 0 0-.418-.234Zm-1.305.881c0-.455.118-.815.353-1.08.236-.268.554-.401.952-.401.4 0 .717.133.952.4.237.266.356.626.356 1.081 0 .456-.119.817-.356 1.084-.235.265-.552.398-.952.398-.398 0-.715-.133-.952-.398-.235-.267-.353-.628-.353-1.084Zm5.762-.634a.79.79 0 0 0-.285-.167 1.086 1.086 0 0 0-.355-.055.954.954 0 0 0-.41.083.608.608 0 0 0-.356.469c-.015.09-.023.228-.023.413v1.3h-.738v-2.822h.739v.438a.799.799 0 0 1 .332-.373c.15-.088.324-.133.524-.133.1 0 .2.012.295.038.097.023.19.058.277.105v.703Zm1.184.866v-2.177h-.748v-.567h1.486v2.744c0 .222.035.379.104.471.069.093.185.139.35.139h.59v.567h-.797c-.35 0-.603-.09-.756-.272-.152-.182-.229-.483-.229-.905Zm4.127-1.244v-1.5h.736v3.92h-.736v-.418a.887.887 0 0 1-.307.368.78.78 0 0 1-.441.124.86.86 0 0 1-.751-.388c-.178-.259-.267-.623-.267-1.094 0-.477.09-.843.27-1.098.18-.255.439-.383.773-.383.151 0 .286.04.406.118.12.078.226.194.317.35Zm-1.028 1.017c0 .272.046.486.136.64.09.155.216.232.376.232s.285-.077.378-.232c.092-.154.138-.368.138-.64s-.046-.485-.139-.64c-.092-.154-.218-.231-.377-.231-.16 0-.285.077-.376.232-.09.154-.136.367-.136.64Zm4.472-2.512c-.221.402-.386.79-.494 1.167a4.092 4.092 0 0 0-.16 1.129c0 .373.053.749.16 1.128.108.378.273.769.494 1.172h-.574a4.776 4.776 0 0 1-.595-1.146 3.542 3.542 0 0 1 0-2.306c.131-.38.33-.76.595-1.143h.574Zm1.56 0h.574c.266.383.463.765.592 1.144a3.49 3.49 0 0 1 .003 2.306c-.13.376-.328.758-.595 1.146h-.574c.221-.403.386-.794.493-1.172.108-.38.162-.755.162-1.128 0-.377-.054-.753-.162-1.129a5.621 5.621 0 0 0-.493-1.166Zm3.462 2.991h.839v.683l-.494.965h-.542l.197-.965v-.683Zm0-1.753h.839v.92h-.84v-.92Z"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#FFBB62",
        d: "M22.11 13.85v1.83h-.734v-1.717c0-.204-.03-.349-.088-.436-.057-.088-.151-.131-.282-.131-.134 0-.24.06-.315.178-.076.118-.113.282-.113.492v1.615h-.734v-3.92h.734v1.521a.686.686 0 0 1 .267-.363.792.792 0 0 1 .456-.128c.267 0 .468.089.604.267.136.176.204.44.204.791Zm3.187 1.692a2.803 2.803 0 0 1-1.089.212c-.472 0-.833-.126-1.083-.378-.249-.254-.373-.618-.373-1.093 0-.46.12-.824.36-1.091.24-.268.568-.401.983-.401.418 0 .742.124.972.373.232.247.348.595.348 1.045v.3h-1.912c.001.222.067.387.196.497.13.109.323.163.58.163.17 0 .336-.024.501-.073.165-.049.337-.126.517-.232v.678Zm-.625-1.587c-.004-.195-.054-.342-.152-.441-.095-.1-.237-.151-.425-.151a.538.538 0 0 0-.406.156c-.1.102-.16.249-.179.438l1.162-.002Zm1.932.55v-2.178h-.748v-.566h1.486v2.743c0 .222.035.379.104.471.069.093.185.139.35.139h.59v.567h-.797c-.35 0-.603-.09-.756-.272-.152-.182-.229-.483-.229-.905Zm3.11 0v-2.178h-.75v-.566h1.487v2.743c0 .222.035.379.104.471.069.093.185.139.35.139h.59v.567h-.797c-.35 0-.603-.09-.756-.272-.152-.182-.229-.483-.229-.905Zm3.685-1.114a.47.47 0 0 0-.416.234c-.1.154-.15.37-.15.647s.05.494.15.65c.101.155.24.232.416.232a.474.474 0 0 0 .418-.232c.101-.156.152-.373.152-.65s-.05-.493-.152-.647a.473.473 0 0 0-.418-.234Zm-1.305.881c0-.455.118-.815.353-1.08.237-.268.554-.401.952-.401.4 0 .717.133.953.4.236.266.355.626.355 1.081 0 .456-.119.817-.355 1.084-.236.265-.553.398-.953.398-.398 0-.715-.133-.952-.398-.235-.267-.353-.628-.353-1.084Zm5.19-2.507c-.221.402-.386.79-.494 1.167a4.092 4.092 0 0 0-.16 1.129c0 .373.053.749.16 1.129.108.377.273.768.494 1.171h-.574a4.776 4.776 0 0 1-.595-1.146 3.542 3.542 0 0 1 0-2.306c.131-.38.33-.76.595-1.144h.574Zm1.56 0h.574c.266.383.463.765.592 1.144a3.49 3.49 0 0 1 .003 2.306c-.13.376-.328.758-.595 1.146h-.574c.221-.403.386-.794.493-1.171.108-.38.162-.756.162-1.13 0-.376-.054-.752-.162-1.128a5.621 5.621 0 0 0-.493-1.167Zm3.462 2.991h.839v.683l-.494.965h-.542l.197-.965v-.683Zm0-1.753h.839v.92h-.84v-.92Z"
      }
    ),
    /* @__PURE__ */ c.jsx("path", { fill: "#EBE1D6", d: "M8.62 28.681h42.928v2.638H8.62z" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#000", fillOpacity: ".08", d: "M8.62 33.319h42.928v2.638H8.62z" })
  ] });
}
const Hee = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 40" fill="none">
  <path fill="#FFF5E9" d="M.084 0h60v40h-60z" />
  <path fill="#000" fill-opacity=".08" d="M8.62 4.042h42.928V6.68H8.62z" />
  <path
    fill="#57534F"
    d="M10.558 15.026h.831v-2.442l-.773.192v-.67l.778-.187h.718v3.107h.832v.655h-2.386v-.655Zm.62 8h1.584v.655h-2.388v-.635l.403-.428c.479-.51.77-.823.872-.94.126-.145.216-.272.272-.383a.749.749 0 0 0 .083-.333c0-.168-.051-.297-.154-.388-.1-.092-.244-.138-.43-.138-.133 0-.283.027-.45.08a2.778 2.778 0 0 0-.516.23v-.693c.18-.066.356-.115.527-.149.173-.035.338-.053.496-.053.398 0 .71.093.938.28.228.185.342.437.342.758 0 .148-.025.287-.075.416-.05.13-.134.273-.255.43-.089.115-.333.372-.733.772-.217.216-.389.39-.517.519Zm8.233-2.167h.615l.335 2.162.305-1.424h.597l.3 1.424.34-2.162h.615l-.512 2.822h-.7l-.343-1.467-.34 1.467h-.7l-.512-2.822Zm4.661.532a.47.47 0 0 0-.416.234c-.1.154-.15.37-.15.647s.05.494.15.65c.101.155.24.232.416.232a.474.474 0 0 0 .418-.232c.101-.156.152-.373.152-.65s-.05-.493-.152-.647a.473.473 0 0 0-.418-.234Zm-1.305.881c0-.455.118-.815.353-1.08.236-.268.554-.401.952-.401.4 0 .717.133.952.4.237.266.356.626.356 1.081 0 .456-.119.817-.356 1.084-.235.265-.552.398-.952.398-.398 0-.715-.133-.952-.398-.235-.267-.353-.628-.353-1.084Zm5.762-.634a.79.79 0 0 0-.285-.167 1.086 1.086 0 0 0-.355-.055.954.954 0 0 0-.41.083.608.608 0 0 0-.356.469c-.015.09-.023.228-.023.413v1.3h-.738v-2.822h.739v.438a.799.799 0 0 1 .332-.373c.15-.088.324-.133.524-.133.1 0 .2.012.295.038.097.023.19.058.277.105v.703Zm1.184.866v-2.177h-.748v-.567h1.486v2.744c0 .222.035.379.104.471.069.093.185.139.35.139h.59v.567h-.797c-.35 0-.603-.09-.756-.272-.152-.182-.229-.483-.229-.905Zm4.127-1.244v-1.5h.736v3.92h-.736v-.418a.887.887 0 0 1-.307.368.78.78 0 0 1-.441.124.86.86 0 0 1-.751-.388c-.178-.259-.267-.623-.267-1.094 0-.477.09-.843.27-1.098.18-.255.439-.383.773-.383.151 0 .286.04.406.118.12.078.226.194.317.35Zm-1.028 1.017c0 .272.046.486.136.64.09.155.216.232.376.232s.285-.077.378-.232c.092-.154.138-.368.138-.64s-.046-.485-.139-.64c-.092-.154-.218-.231-.377-.231-.16 0-.285.077-.376.232-.09.154-.136.367-.136.64Zm4.472-2.512c-.221.402-.386.79-.494 1.167a4.092 4.092 0 0 0-.16 1.129c0 .373.053.749.16 1.128.108.378.273.769.494 1.172h-.574a4.776 4.776 0 0 1-.595-1.146 3.542 3.542 0 0 1 0-2.306c.131-.38.33-.76.595-1.143h.574Zm1.56 0h.574c.266.383.463.765.592 1.144a3.49 3.49 0 0 1 .003 2.306c-.13.376-.328.758-.595 1.146h-.574c.221-.403.386-.794.493-1.172.108-.38.162-.755.162-1.128 0-.377-.054-.753-.162-1.129a5.621 5.621 0 0 0-.493-1.166Zm3.462 2.991h.839v.683l-.494.965h-.542l.197-.965v-.683Zm0-1.753h.839v.92h-.84v-.92Z"
  />
  <path
    fill="#FFBB62"
    d="M22.11 13.85v1.83h-.734v-1.717c0-.204-.03-.349-.088-.436-.057-.088-.151-.131-.282-.131-.134 0-.24.06-.315.178-.076.118-.113.282-.113.492v1.615h-.734v-3.92h.734v1.521a.686.686 0 0 1 .267-.363.792.792 0 0 1 .456-.128c.267 0 .468.089.604.267.136.176.204.44.204.791Zm3.187 1.692a2.803 2.803 0 0 1-1.089.212c-.472 0-.833-.126-1.083-.378-.249-.254-.373-.618-.373-1.093 0-.46.12-.824.36-1.091.24-.268.568-.401.983-.401.418 0 .742.124.972.373.232.247.348.595.348 1.045v.3h-1.912c.001.222.067.387.196.497.13.109.323.163.58.163.17 0 .336-.024.501-.073.165-.049.337-.126.517-.232v.678Zm-.625-1.587c-.004-.195-.054-.342-.152-.441-.095-.1-.237-.151-.425-.151a.538.538 0 0 0-.406.156c-.1.102-.16.249-.179.438l1.162-.002Zm1.932.55v-2.178h-.748v-.566h1.486v2.743c0 .222.035.379.104.471.069.093.185.139.35.139h.59v.567h-.797c-.35 0-.603-.09-.756-.272-.152-.182-.229-.483-.229-.905Zm3.11 0v-2.178h-.75v-.566h1.487v2.743c0 .222.035.379.104.471.069.093.185.139.35.139h.59v.567h-.797c-.35 0-.603-.09-.756-.272-.152-.182-.229-.483-.229-.905Zm3.685-1.114a.47.47 0 0 0-.416.234c-.1.154-.15.37-.15.647s.05.494.15.65c.101.155.24.232.416.232a.474.474 0 0 0 .418-.232c.101-.156.152-.373.152-.65s-.05-.493-.152-.647a.473.473 0 0 0-.418-.234Zm-1.305.881c0-.455.118-.815.353-1.08.237-.268.554-.401.952-.401.4 0 .717.133.953.4.236.266.355.626.355 1.081 0 .456-.119.817-.355 1.084-.236.265-.553.398-.953.398-.398 0-.715-.133-.952-.398-.235-.267-.353-.628-.353-1.084Zm5.19-2.507c-.221.402-.386.79-.494 1.167a4.092 4.092 0 0 0-.16 1.129c0 .373.053.749.16 1.129.108.377.273.768.494 1.171h-.574a4.776 4.776 0 0 1-.595-1.146 3.542 3.542 0 0 1 0-2.306c.131-.38.33-.76.595-1.144h.574Zm1.56 0h.574c.266.383.463.765.592 1.144a3.49 3.49 0 0 1 .003 2.306c-.13.376-.328.758-.595 1.146h-.574c.221-.403.386-.794.493-1.171.108-.38.162-.756.162-1.13 0-.376-.054-.752-.162-1.128a5.621 5.621 0 0 0-.493-1.167Zm3.462 2.991h.839v.683l-.494.965h-.542l.197-.965v-.683Zm0-1.753h.839v.92h-.84v-.92Z"
  />
  <path fill="#EBE1D6" d="M8.62 28.681h42.928v2.638H8.62z" />
  <path fill="#000" fill-opacity=".08" d="M8.62 33.319h42.928v2.638H8.62z" />
</svg>
`;
function Tw() {
  return /* @__PURE__ */ c.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 61 40", fill: "none", children: [
    /* @__PURE__ */ c.jsx("path", { fill: "#FFF5E9", d: "M.084 0h60v40h-60z" }),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#000",
        fillOpacity: ".08",
        d: "M10.084 4.737h42.928v2.638H10.084z"
      }
    ),
    /* @__PURE__ */ c.jsx("path", { fill: "#57534F", d: "M24.298 14.375H38.28v12.05H24.298z" }),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#FFD59D",
        d: "M25.131 28.625c-.504 0-.936-.188-1.295-.564a1.885 1.885 0 0 1-.538-1.353V13.292c0-.527.18-.979.54-1.354.358-.376.79-.564 1.293-.563h12.834c.504 0 .936.188 1.295.563.36.376.539.827.538 1.354v13.416c0 .527-.18.979-.539 1.355-.36.375-.79.563-1.294.562H25.13Zm.917-3.833h11L33.611 20l-2.75 3.833-2.063-2.875-2.75 3.834Z"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#000",
        fillOpacity: ".08",
        d: "M10.084 32.625h42.928v2.638H10.084z"
      }
    )
  ] });
}
const jw = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 40" fill="none">
  <path fill="#FFF5E9" d="M.084 0h60v40h-60z" />
  <path
    fill="#000"
    fill-opacity=".08"
    d="M10.084 4.737h42.928v2.638H10.084z"
  />
  <path fill="#57534F" d="M24.298 14.375H38.28v12.05H24.298z" />
  <path
    fill="#FFD59D"
    d="M25.131 28.625c-.504 0-.936-.188-1.295-.564a1.885 1.885 0 0 1-.538-1.353V13.292c0-.527.18-.979.54-1.354.358-.376.79-.564 1.293-.563h12.834c.504 0 .936.188 1.295.563.36.376.539.827.538 1.354v13.416c0 .527-.18.979-.539 1.355-.36.375-.79.563-1.294.562H25.13Zm.917-3.833h11L33.611 20l-2.75 3.833-2.063-2.875-2.75 3.834Z"
  />
  <path
    fill="#000"
    fill-opacity=".08"
    d="M10.084 32.625h42.928v2.638H10.084z"
  />
</svg>
`;
function Vee() {
  return /* @__PURE__ */ c.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 61 40", fill: "none", children: [
    /* @__PURE__ */ c.jsx("path", { fill: "#FFF5E9", d: "M.084 0h60v40h-60z" }),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#000",
        fillOpacity: ".08",
        d: "M10.084 4.737h42.928v2.638H10.084z"
      }
    ),
    /* @__PURE__ */ c.jsx("path", { fill: "#57534F", d: "M24.298 14.375H38.28v12.05H24.298z" }),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#FFD59D",
        d: "M25.131 28.625c-.504 0-.936-.188-1.295-.564a1.885 1.885 0 0 1-.538-1.353V13.292c0-.527.18-.979.54-1.354.358-.376.79-.564 1.293-.563h12.834c.504 0 .936.188 1.295.563.36.376.539.827.538 1.354v13.416c0 .527-.18.979-.539 1.355-.36.375-.79.563-1.294.562H25.13Zm.917-3.833h11L33.611 20l-2.75 3.833-2.063-2.875-2.75 3.834Z"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#000",
        fillOpacity: ".08",
        d: "M10.084 32.625h42.928v2.638H10.084z"
      }
    )
  ] });
}
const Uee = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 40" fill="none">
  <path fill="#FFF5E9" d="M.084 0h60v40h-60z" />
  <path
    fill="#000"
    fill-opacity=".08"
    d="M10.084 3.712h42.928V6.35H10.084z"
  />
  <path fill="#FFDEB2" d="M10.084 9.35h43v21.3h-43z" />
  <path
    fill="#57534F"
    d="M28.584 14.5c-.55 0-.995.495-.995 1.1l-.005 8.8c0 .605.445 1.1.995 1.1h6.005c.55 0 1-.495 1-1.1v-6.6l-3-3.3h-4Zm3.5 3.85v-3.025l2.75 3.025h-2.75Z"
  />
  <path
    fill="#000"
    fill-opacity=".08"
    d="M10.084 33.65h42.928v2.638H10.084z"
  />
</svg>
`;
function Wee() {
  return /* @__PURE__ */ c.jsxs(
    "svg",
    {
      viewBox: "0 0 90 60",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "xMidYMid meet",
      children: [
        /* @__PURE__ */ c.jsxs("g", { clipPath: "url(#clip0_10788_34139)", children: [
          /* @__PURE__ */ c.jsx("rect", { width: "90", height: "60", fill: "#FFEFDA" }),
          /* @__PURE__ */ c.jsx("rect", { x: "22.5", y: "16.5", width: "45", height: "3", fill: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("rect", { x: "22.5", y: "22.5", width: "45", height: "3", fill: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("rect", { x: "22.5", y: "28.5", width: "30", height: "3", fill: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("rect", { x: "23", y: "36", width: "39", height: "7", rx: "3.5", stroke: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("rect", { x: "26.5", y: "38", width: "1", height: "3.5", rx: "0.5", fill: "#FFBE5D" })
        ] }),
        /* @__PURE__ */ c.jsx("defs", { children: /* @__PURE__ */ c.jsx("clipPath", { id: "clip0_10788_34139", children: /* @__PURE__ */ c.jsx("rect", { width: "90", height: "60", rx: "4", fill: "white" }) }) })
      ]
    }
  );
}
const Zee = `<svg viewBox="0 0 90 60" fill="none" xmlns="http://www.w3.org/2000/svg"
  preserveAspectRatio="xMidYMid meet">
  <g clip-path="url(#clip0_10788_34139)">
    <rect width="90" height="60" fill="#FFEFDA" />
    <rect x="22.5" y="16.5" width="45" height="3" fill="#FFBE5D" />
    <rect x="22.5" y="22.5" width="45" height="3" fill="#FFBE5D" />
    <rect x="22.5" y="28.5" width="30" height="3" fill="#FFBE5D" />
    <rect x="23" y="36" width="39" height="7" rx="3.5" stroke="#FFBE5D" />
    <rect x="26.5" y="38" width="1" height="3.5" rx="0.5" fill="#FFBE5D" />
  </g>
  <defs>
    <clipPath id="clip0_10788_34139">
      <rect width="90" height="60" rx="4" fill="white" />
    </clipPath>
  </defs>
</svg>`;
function Gee() {
  return /* @__PURE__ */ c.jsxs("svg", { viewBox: "0 0 90 60", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ c.jsx("rect", { width: "90", height: "60", rx: "4.2", fill: "#FFF5E9" }),
    /* @__PURE__ */ c.jsx(
      "rect",
      {
        width: "48.375",
        height: "25.875",
        transform: "translate(20.8125 23.5)",
        fill: "#FFDDB2"
      }
    ),
    /* @__PURE__ */ c.jsx("circle", { cx: "44.9982", cy: "36.4357", r: "6.24818", fill: "#57534F" }),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M48.0781 36.4363L43.1873 39.26L43.1873 33.6126L48.0781 36.4363Z",
        fill: "#FFDDB2"
      }
    ),
    /* @__PURE__ */ c.jsx("rect", { x: "20.8125", y: "49.375", width: "13.5", height: "1.125", fill: "#FFBB62" }),
    /* @__PURE__ */ c.jsx(
      "rect",
      {
        x: "34.3125",
        y: "49.375",
        width: "34.875",
        height: "1.125",
        fill: "#EBE1D6"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M28.5056 3.77734C28.5056 3.35761 28.8459 3.01734 29.2656 3.01734H61.3456C61.7654 3.01734 62.1056 3.35761 62.1056 3.77734V26.5897C62.1056 27.0094 61.7654 27.3497 61.3456 27.3497H49.6449C49.2551 27.3497 48.888 27.533 48.6538 27.8446L45.6976 31.7772C45.3881 32.189 44.7672 32.18 44.4697 31.7595L41.7204 27.8735C41.488 27.545 41.1106 27.3497 40.7081 27.3497H29.2656C28.8459 27.3497 28.5056 27.0094 28.5056 26.5897V3.77734Z",
        fill: "white",
        stroke: "#57534F",
        strokeWidth: "0.48"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "rect",
      {
        x: "34.9844",
        y: "9.25781",
        width: "14.08",
        height: "0.96",
        fill: "#FFBE5D"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "rect",
      {
        x: "34.9844",
        y: "7.57812",
        width: "21.12",
        height: "0.96",
        fill: "#FFBE5D"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "circle",
      {
        cx: "37.3844",
        cy: "14.5406",
        r: "2.16",
        fill: "#FFBE5D",
        stroke: "#FFBE5D",
        strokeWidth: "0.48"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M36.9653 15.3214L36.3754 14.7315C36.3091 14.6652 36.202 14.6652 36.1357 14.7315C36.0694 14.7978 36.0694 14.9049 36.1357 14.9712L36.8463 15.6818C36.9126 15.7481 37.0197 15.7481 37.086 15.6818L38.8846 13.8832C38.9509 13.8169 38.9509 13.7098 38.8846 13.6435C38.8183 13.5772 38.7112 13.5772 38.6449 13.6435L36.9653 15.3214Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ c.jsx("rect", { x: "41.7031", y: "14.8984", width: "9.6", height: "0.96", fill: "#FFBE5D" }),
    /* @__PURE__ */ c.jsx("rect", { x: "41.7031", y: "13.2188", width: "14.4", height: "0.96", fill: "#FFBE5D" }),
    /* @__PURE__ */ c.jsx(
      "circle",
      {
        cx: "37.3844",
        cy: "21.2594",
        r: "2.16",
        stroke: "#FFBE5D",
        strokeWidth: "0.48"
      }
    ),
    /* @__PURE__ */ c.jsx("rect", { x: "41.7031", y: "21.6172", width: "9.6", height: "0.96", fill: "#FFBE5D" }),
    /* @__PURE__ */ c.jsx("rect", { x: "41.7031", y: "19.9375", width: "14.4", height: "0.96", fill: "#FFBE5D" })
  ] });
}
const Kee = `<svg viewBox="0 0 90 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="90" height="60" rx="4.2" fill="#FFF5E9"/>
<rect width="48.375" height="25.875" transform="translate(20.8125 23.5)" fill="#FFDDB2"/>
<circle cx="44.9982" cy="36.4357" r="6.24818" fill="#57534F"/>
<path d="M48.0781 36.4363L43.1873 39.26L43.1873 33.6126L48.0781 36.4363Z" fill="#FFDDB2"/>
<rect x="20.8125" y="49.375" width="13.5" height="1.125" fill="#FFBB62"/>
<rect x="34.3125" y="49.375" width="34.875" height="1.125" fill="#EBE1D6"/>
<path d="M28.5056 3.77734C28.5056 3.35761 28.8459 3.01734 29.2656 3.01734H61.3456C61.7654 3.01734 62.1056 3.35761 62.1056 3.77734V26.5897C62.1056 27.0094 61.7654 27.3497 61.3456 27.3497H49.6449C49.2551 27.3497 48.888 27.533 48.6538 27.8446L45.6976 31.7772C45.3881 32.189 44.7672 32.18 44.4697 31.7595L41.7204 27.8735C41.488 27.545 41.1106 27.3497 40.7081 27.3497H29.2656C28.8459 27.3497 28.5056 27.0094 28.5056 26.5897V3.77734Z" fill="white" stroke="#57534F" stroke-width="0.48"/>
<rect x="34.9844" y="9.25781" width="14.08" height="0.96" fill="#FFBE5D"/>
<rect x="34.9844" y="7.57812" width="21.12" height="0.96" fill="#FFBE5D"/>
<circle cx="37.3844" cy="14.5406" r="2.16" fill="#FFBE5D" stroke="#FFBE5D" stroke-width="0.48"/>
<path d="M36.9653 15.3214L36.3754 14.7315C36.3091 14.6652 36.202 14.6652 36.1357 14.7315C36.0694 14.7978 36.0694 14.9049 36.1357 14.9712L36.8463 15.6818C36.9126 15.7481 37.0197 15.7481 37.086 15.6818L38.8846 13.8832C38.9509 13.8169 38.9509 13.7098 38.8846 13.6435C38.8183 13.5772 38.7112 13.5772 38.6449 13.6435L36.9653 15.3214Z" fill="white"/>
<rect x="41.7031" y="14.8984" width="9.6" height="0.96" fill="#FFBE5D"/>
<rect x="41.7031" y="13.2188" width="14.4" height="0.96" fill="#FFBE5D"/>
<circle cx="37.3844" cy="21.2594" r="2.16" stroke="#FFBE5D" stroke-width="0.48"/>
<rect x="41.7031" y="21.6172" width="9.6" height="0.96" fill="#FFBE5D"/>
<rect x="41.7031" y="19.9375" width="14.4" height="0.96" fill="#FFBE5D"/>
</svg>
`;
function Xee() {
  return /* @__PURE__ */ c.jsxs("svg", { viewBox: "0 0 90 60", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ c.jsxs("g", { clipPath: "url(#clip0_11269_34883)", children: [
      /* @__PURE__ */ c.jsx("rect", { width: "90", height: "60", rx: "4", fill: "#FFEFDA" }),
      /* @__PURE__ */ c.jsx("rect", { width: "90", height: "60", fill: "#FFEFDA" }),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M32.0833 10.5H23.9167C23.275 10.5 22.75 11.025 22.75 11.6667V19.8333C22.75 20.475 23.275 21 23.9167 21H32.0833C32.725 21 33.25 20.475 33.25 19.8333V11.6667C33.25 11.025 32.725 10.5 32.0833 10.5ZM27.2475 18.2525C27.02 18.48 26.6525 18.48 26.425 18.2525L24.3308 16.1583C24.1033 15.9308 24.1033 15.5633 24.3308 15.3358C24.5583 15.1083 24.9258 15.1083 25.1533 15.3358L26.8333 17.0158L30.8467 13.0025C31.0742 12.775 31.4417 12.775 31.6692 13.0025C31.8967 13.23 31.8967 13.5975 31.6692 13.825L27.2475 18.2525Z",
          fill: "#FFBE5D"
        }
      ),
      /* @__PURE__ */ c.jsx("rect", { x: "37.25", y: "16.5", width: "20", height: "2", fill: "#FFBE5D" }),
      /* @__PURE__ */ c.jsx("rect", { x: "37.25", y: "13", width: "30", height: "2", fill: "#FFBE5D" }),
      /* @__PURE__ */ c.jsx(
        "rect",
        {
          x: "23.25",
          y: "25.5",
          width: "9",
          height: "9",
          rx: "1.5",
          stroke: "#FFBE5D"
        }
      ),
      /* @__PURE__ */ c.jsx("rect", { x: "36.75", y: "30.75", width: "20", height: "2", fill: "#FFBE5D" }),
      /* @__PURE__ */ c.jsx("rect", { x: "36.75", y: "27.25", width: "30", height: "2", fill: "#FFBE5D" }),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M32.0833 39H23.9167C23.275 39 22.75 39.525 22.75 40.1667V48.3333C22.75 48.975 23.275 49.5 23.9167 49.5H32.0833C32.725 49.5 33.25 48.975 33.25 48.3333V40.1667C33.25 39.525 32.725 39 32.0833 39ZM27.2475 46.7525C27.02 46.98 26.6525 46.98 26.425 46.7525L24.3308 44.6583C24.1033 44.4308 24.1033 44.0633 24.3308 43.8358C24.5583 43.6083 24.9258 43.6083 25.1533 43.8358L26.8333 45.5158L30.8467 41.5025C31.0742 41.275 31.4417 41.275 31.6692 41.5025C31.8967 41.73 31.8967 42.0975 31.6692 42.325L27.2475 46.7525Z",
          fill: "#FFBE5D"
        }
      ),
      /* @__PURE__ */ c.jsx("rect", { x: "37.25", y: "45", width: "20", height: "2", fill: "#FFBE5D" }),
      /* @__PURE__ */ c.jsx("rect", { x: "37.25", y: "41.5", width: "30", height: "2", fill: "#FFBE5D" })
    ] }),
    /* @__PURE__ */ c.jsx("defs", { children: /* @__PURE__ */ c.jsx("clipPath", { id: "clip0_11269_34883", children: /* @__PURE__ */ c.jsx("rect", { width: "90", height: "60", rx: "4", fill: "white" }) }) })
  ] });
}
const Qee = `<svg viewBox="0 0 90 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_11269_34883)">
<rect width="90" height="60" rx="4" fill="#FFEFDA"/>
<rect width="90" height="60" fill="#FFEFDA"/>
<path d="M32.0833 10.5H23.9167C23.275 10.5 22.75 11.025 22.75 11.6667V19.8333C22.75 20.475 23.275 21 23.9167 21H32.0833C32.725 21 33.25 20.475 33.25 19.8333V11.6667C33.25 11.025 32.725 10.5 32.0833 10.5ZM27.2475 18.2525C27.02 18.48 26.6525 18.48 26.425 18.2525L24.3308 16.1583C24.1033 15.9308 24.1033 15.5633 24.3308 15.3358C24.5583 15.1083 24.9258 15.1083 25.1533 15.3358L26.8333 17.0158L30.8467 13.0025C31.0742 12.775 31.4417 12.775 31.6692 13.0025C31.8967 13.23 31.8967 13.5975 31.6692 13.825L27.2475 18.2525Z" fill="#FFBE5D"/>
<rect x="37.25" y="16.5" width="20" height="2" fill="#FFBE5D"/>
<rect x="37.25" y="13" width="30" height="2" fill="#FFBE5D"/>
<rect x="23.25" y="25.5" width="9" height="9" rx="1.5" stroke="#FFBE5D"/>
<rect x="36.75" y="30.75" width="20" height="2" fill="#FFBE5D"/>
<rect x="36.75" y="27.25" width="30" height="2" fill="#FFBE5D"/>
<path d="M32.0833 39H23.9167C23.275 39 22.75 39.525 22.75 40.1667V48.3333C22.75 48.975 23.275 49.5 23.9167 49.5H32.0833C32.725 49.5 33.25 48.975 33.25 48.3333V40.1667C33.25 39.525 32.725 39 32.0833 39ZM27.2475 46.7525C27.02 46.98 26.6525 46.98 26.425 46.7525L24.3308 44.6583C24.1033 44.4308 24.1033 44.0633 24.3308 43.8358C24.5583 43.6083 24.9258 43.6083 25.1533 43.8358L26.8333 45.5158L30.8467 41.5025C31.0742 41.275 31.4417 41.275 31.6692 41.5025C31.8967 41.73 31.8967 42.0975 31.6692 42.325L27.2475 46.7525Z" fill="#FFBE5D"/>
<rect x="37.25" y="45" width="20" height="2" fill="#FFBE5D"/>
<rect x="37.25" y="41.5" width="30" height="2" fill="#FFBE5D"/>
</g>
<defs>
<clipPath id="clip0_11269_34883">
<rect width="90" height="60" rx="4" fill="white"/>
</clipPath>
</defs>
</svg>
`;
function Yee() {
  return /* @__PURE__ */ c.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 61 40", fill: "none", children: [
    /* @__PURE__ */ c.jsx("path", { fill: "#FFF5E9", d: "M.084 0h60v40h-60z" }),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#000",
        fillOpacity: ".08",
        d: "M10.084 5.361h42.928v2.638H10.084z"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#FFBB62",
        d: "M10.084 13.861h22v3h-22zM10.084 18.861h24.178v2.638H10.084zM10.084 23.5h15.317v2.638H10.084z"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#000",
        fillOpacity: ".66",
        d: "M37.856 14.847H49.72v9.78H37.856z"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#FFD59D",
        d: "M38.818 27c-.428 0-.794-.152-1.1-.457a1.495 1.495 0 0 1-.456-1.098v-10.89c0-.428.152-.794.457-1.099A1.495 1.495 0 0 1 38.818 13h10.89c.427 0 .793.152 1.098.457.305.305.457.67.457 1.098v10.89c0 .428-.153.794-.457 1.099a1.495 1.495 0 0 1-1.099.456h-10.89Zm.777-3.11h9.334L46.013 20l-2.334 3.111-1.75-2.333-2.334 3.111Z"
      }
    ),
    /* @__PURE__ */ c.jsx("path", { fill: "#000", fillOpacity: ".08", d: "M10.084 32h42.928v2.638H10.084z" })
  ] });
}
const Jee = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 40" fill="none">
  <path fill="#FFF5E9" d="M.084 0h60v40h-60z" />
  <path
    fill="#000"
    fill-opacity=".08"
    d="M10.084 5.361h42.928v2.638H10.084z"
  />
  <path
    fill="#FFBB62"
    d="M10.084 13.861h22v3h-22zM10.084 18.861h24.178v2.638H10.084zM10.084 23.5h15.317v2.638H10.084z"
  />
  <path
    fill="#000"
    fill-opacity=".66"
    d="M37.856 14.847H49.72v9.78H37.856z"
  />
  <path
    fill="#FFD59D"
    d="M38.818 27c-.428 0-.794-.152-1.1-.457a1.495 1.495 0 0 1-.456-1.098v-10.89c0-.428.152-.794.457-1.099A1.495 1.495 0 0 1 38.818 13h10.89c.427 0 .793.152 1.098.457.305.305.457.67.457 1.098v10.89c0 .428-.153.794-.457 1.099a1.495 1.495 0 0 1-1.099.456h-10.89Zm.777-3.11h9.334L46.013 20l-2.334 3.111-1.75-2.333-2.334 3.111Z"
  />
  <path fill="#000" fill-opacity=".08" d="M10.084 32h42.928v2.638H10.084z" />
</svg>
`;
function ete() {
  return /* @__PURE__ */ c.jsxs(
    "svg",
    {
      viewBox: "0 0 90 60",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "xMidYMid meet",
      children: [
        /* @__PURE__ */ c.jsxs("g", { clipPath: "url(#clip0_10649_33092)", children: [
          /* @__PURE__ */ c.jsx("rect", { width: "90", height: "60", fill: "#FFEFDA" }),
          /* @__PURE__ */ c.jsx("circle", { cx: "28", cy: "16", r: "4.5", fill: "#FFBE5D", stroke: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx(
            "path",
            {
              d: "M27.1132 17.6227L25.8842 16.3937C25.7461 16.2556 25.523 16.2556 25.3848 16.3937C25.2467 16.5318 25.2467 16.7549 25.3848 16.8931L26.8653 18.3735C27.0034 18.5116 27.2265 18.5116 27.3646 18.3735L31.1117 14.6264C31.2498 14.4883 31.2498 14.2652 31.1117 14.127C30.9736 13.9889 30.7505 13.9889 30.6123 14.127L27.1132 17.6227Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ c.jsx("rect", { x: "37", y: "16.75", width: "20", height: "2", fill: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("rect", { x: "37", y: "13.25", width: "30", height: "2", fill: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("circle", { cx: "28", cy: "30", r: "4.5", stroke: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("rect", { x: "37", y: "30.75", width: "20", height: "2", fill: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("rect", { x: "37", y: "27.25", width: "30", height: "2", fill: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("circle", { cx: "28", cy: "44", r: "4.5", stroke: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("rect", { x: "37", y: "44.75", width: "20", height: "2", fill: "#FFBE5D" }),
          /* @__PURE__ */ c.jsx("rect", { x: "37", y: "41.25", width: "30", height: "2", fill: "#FFBE5D" })
        ] }),
        /* @__PURE__ */ c.jsx("defs", { children: /* @__PURE__ */ c.jsx("clipPath", { id: "clip0_10649_33092", children: /* @__PURE__ */ c.jsx("rect", { width: "90", height: "60", rx: "4", fill: "white" }) }) })
      ]
    }
  );
}
const tte = `<svg viewBox="0 0 90 60" fill="none" xmlns="http://www.w3.org/2000/svg"
  preserveAspectRatio="xMidYMid meet">
  <g clip-path="url(#clip0_10649_33092)">
    <rect width="90" height="60" fill="#FFEFDA" />
    <circle cx="28" cy="16" r="4.5" fill="#FFBE5D" stroke="#FFBE5D" />
    <path
      d="M27.1132 17.6227L25.8842 16.3937C25.7461 16.2556 25.523 16.2556 25.3848 16.3937C25.2467 16.5318 25.2467 16.7549 25.3848 16.8931L26.8653 18.3735C27.0034 18.5116 27.2265 18.5116 27.3646 18.3735L31.1117 14.6264C31.2498 14.4883 31.2498 14.2652 31.1117 14.127C30.9736 13.9889 30.7505 13.9889 30.6123 14.127L27.1132 17.6227Z"
      fill="white" />
    <rect x="37" y="16.75" width="20" height="2" fill="#FFBE5D" />
    <rect x="37" y="13.25" width="30" height="2" fill="#FFBE5D" />
    <circle cx="28" cy="30" r="4.5" stroke="#FFBE5D" />
    <rect x="37" y="30.75" width="20" height="2" fill="#FFBE5D" />
    <rect x="37" y="27.25" width="30" height="2" fill="#FFBE5D" />
    <circle cx="28" cy="44" r="4.5" stroke="#FFBE5D" />
    <rect x="37" y="44.75" width="20" height="2" fill="#FFBE5D" />
    <rect x="37" y="41.25" width="30" height="2" fill="#FFBE5D" />
  </g>
  <defs>
    <clipPath id="clip0_10649_33092">
      <rect width="90" height="60" rx="4" fill="white" />
    </clipPath>
  </defs>
</svg>`;
function nte() {
  return /* @__PURE__ */ c.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 61 40", fill: "none", children: [
    /* @__PURE__ */ c.jsx("path", { fill: "#FFF5E9", d: "M.084 0h60v40h-60z" }),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#000",
        fillOpacity: ".08",
        d: "M10.084 3.014h42.928v2.638H10.084z"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#FFBB62",
        d: "M10.084 10.153a1 1 0 0 1 1-1h40.928a1 1 0 0 1 1 1v2.692H10.084v-2.692Z"
      }
    ),
    /* @__PURE__ */ c.jsx("mask", { id: "a", fill: "#fff", children: /* @__PURE__ */ c.jsx("path", { d: "M10.084 12.845h42.928V24.21a2 2 0 0 1-2 2H12.084a2 2 0 0 1-2-2V12.845Z" }) }),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#FFBB62",
        fillRule: "evenodd",
        d: "M10.534 13.319h-1.35v-.474h1.8v.474h-.45Zm.45.947h-1.8v.947h1.8v-.947Zm0 1.894h-1.8v.947h1.8v-.947Zm0 1.893h-1.8V19h1.8v-.947Zm0 1.894h-1.8v.947h1.8v-.947Zm0 1.894h-1.8v.947h1.8v-.947Zm0 1.894h-1.8v.474a2.917 2.917 0 0 0 .055.565l.442-.088.883-.174.44-.088a1.115 1.115 0 0 1-.02-.215v-.474Zm-.937 1.835.748-.5.374-.25a1.1 1.1 0 0 0 .304.304l-.25.374-.5.748-.25.374a2.91 2.91 0 0 1-.8-.8l.374-.25Zm1.56 1.042.174-.883.087-.441c.07.013.141.02.216.02m.512.45v1.35h-.512a3.008 3.008 0 0 1-.565-.055l.087-.441m2.015.497h1.024v-1.8h-1.024v1.8Zm-1.025-1.35v-.45.45Zm-.512-.45h.512-.512Zm3.585 0v1.8h1.025v-1.8H15.67Zm2.05 0v1.8h1.024v-1.8h-1.025Zm2.048 0v1.8h1.025v-1.8h-1.025Zm2.049 0v1.8h1.024v-1.8h-1.024Zm2.049 0v1.8h1.024v-1.8h-1.024Zm2.049 0v1.8h1.024v-1.8h-1.024Zm2.049 0v1.8h1.024v-1.8h-1.024Zm2.049 0v1.8h1.024v-1.8h-1.024Zm2.048 0v1.8h1.025v-1.8H32.06Zm2.05 0v1.8h1.024v-1.8h-1.025Zm2.048 0v1.8h1.024v-1.8h-1.024Zm2.049 0v1.8h1.024v-1.8h-1.024Zm2.049 0v1.8h1.024v-1.8h-1.024Zm2.049 0v1.8h1.024v-1.8h-1.024Zm2.048 0v1.8h1.025v-1.8h-1.025Zm2.05 0v1.8h1.024v-1.8h-1.025Zm2.048 0v1.8h1.025v-1.8H48.45Zm2.049 0v1.8h.512a2.983 2.983 0 0 0 .565-.056l-.087-.441-.175-.883-.087-.441c-.07.013-.141.02-.216.02H50.5Zm1.874.937-.5-.748-.251-.374a1.129 1.129 0 0 0 .305-.305l.373.25.748.501.374.25a2.922 2.922 0 0 1-.799.8l-.25-.374Zm-.262-2.037c0 .074-.007.146-.02.215l.44.088.884.174.441.088a2.887 2.887 0 0 0 .055-.565v-.474h-1.8v.474Zm0-1.42h1.8v-.948h-1.8v.947Zm0-1.895h1.8v-.947h-1.8v.947Zm0-1.894h1.8v-.947h-1.8V19Zm0-1.893h1.8v-.947h-1.8v.947Zm0-1.894h1.8v-.947h-1.8v.947Zm0-1.894h1.8v-.474h-1.8v.474Z",
        clipRule: "evenodd",
        mask: "url(#a)"
      }
    ),
    /* @__PURE__ */ c.jsx("path", { fill: "#57534F", d: "m50.537 12.153-1.258-1.95h2.516l-1.258 1.95Z" }),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#FFD59D",
        d: "M14.084 15.153h24.178v2.638H14.084zM14.084 19.491h15.317v2.638H14.084z"
      }
    ),
    /* @__PURE__ */ c.jsx("path", { fill: "#EBE1D6", d: "M10.084 29.709h42.928v2.638H10.084z" }),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#000",
        fillOpacity: ".08",
        d: "M10.084 34.347h42.928v2.638H10.084z"
      }
    )
  ] });
}
const rte = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 40" fill="none">
  <path fill="#FFF5E9" d="M.084 0h60v40h-60z" />
  <path
    fill="#000"
    fill-opacity=".08"
    d="M10.084 3.014h42.928v2.638H10.084z"
  />
  <path
    fill="#FFBB62"
    d="M10.084 10.153a1 1 0 0 1 1-1h40.928a1 1 0 0 1 1 1v2.692H10.084v-2.692Z"
  />
  <mask id="a" fill="#fff">
    <path d="M10.084 12.845h42.928V24.21a2 2 0 0 1-2 2H12.084a2 2 0 0 1-2-2V12.845Z" />
  </mask>
  <path
    fill="#FFBB62"
    fillRule="evenodd"
    d="M10.534 13.319h-1.35v-.474h1.8v.474h-.45Zm.45.947h-1.8v.947h1.8v-.947Zm0 1.894h-1.8v.947h1.8v-.947Zm0 1.893h-1.8V19h1.8v-.947Zm0 1.894h-1.8v.947h1.8v-.947Zm0 1.894h-1.8v.947h1.8v-.947Zm0 1.894h-1.8v.474a2.917 2.917 0 0 0 .055.565l.442-.088.883-.174.44-.088a1.115 1.115 0 0 1-.02-.215v-.474Zm-.937 1.835.748-.5.374-.25a1.1 1.1 0 0 0 .304.304l-.25.374-.5.748-.25.374a2.91 2.91 0 0 1-.8-.8l.374-.25Zm1.56 1.042.174-.883.087-.441c.07.013.141.02.216.02m.512.45v1.35h-.512a3.008 3.008 0 0 1-.565-.055l.087-.441m2.015.497h1.024v-1.8h-1.024v1.8Zm-1.025-1.35v-.45.45Zm-.512-.45h.512-.512Zm3.585 0v1.8h1.025v-1.8H15.67Zm2.05 0v1.8h1.024v-1.8h-1.025Zm2.048 0v1.8h1.025v-1.8h-1.025Zm2.049 0v1.8h1.024v-1.8h-1.024Zm2.049 0v1.8h1.024v-1.8h-1.024Zm2.049 0v1.8h1.024v-1.8h-1.024Zm2.049 0v1.8h1.024v-1.8h-1.024Zm2.049 0v1.8h1.024v-1.8h-1.024Zm2.048 0v1.8h1.025v-1.8H32.06Zm2.05 0v1.8h1.024v-1.8h-1.025Zm2.048 0v1.8h1.024v-1.8h-1.024Zm2.049 0v1.8h1.024v-1.8h-1.024Zm2.049 0v1.8h1.024v-1.8h-1.024Zm2.049 0v1.8h1.024v-1.8h-1.024Zm2.048 0v1.8h1.025v-1.8h-1.025Zm2.05 0v1.8h1.024v-1.8h-1.025Zm2.048 0v1.8h1.025v-1.8H48.45Zm2.049 0v1.8h.512a2.983 2.983 0 0 0 .565-.056l-.087-.441-.175-.883-.087-.441c-.07.013-.141.02-.216.02H50.5Zm1.874.937-.5-.748-.251-.374a1.129 1.129 0 0 0 .305-.305l.373.25.748.501.374.25a2.922 2.922 0 0 1-.799.8l-.25-.374Zm-.262-2.037c0 .074-.007.146-.02.215l.44.088.884.174.441.088a2.887 2.887 0 0 0 .055-.565v-.474h-1.8v.474Zm0-1.42h1.8v-.948h-1.8v.947Zm0-1.895h1.8v-.947h-1.8v.947Zm0-1.894h1.8v-.947h-1.8V19Zm0-1.893h1.8v-.947h-1.8v.947Zm0-1.894h1.8v-.947h-1.8v.947Zm0-1.894h1.8v-.474h-1.8v.474Z"
    clipRule="evenodd"
    mask="url(#a)"
  />
  <path fill="#57534F" d="m50.537 12.153-1.258-1.95h2.516l-1.258 1.95Z" />
  <path
    fill="#FFD59D"
    d="M14.084 15.153h24.178v2.638H14.084zM14.084 19.491h15.317v2.638H14.084z"
  />
  <path fill="#EBE1D6" d="M10.084 29.709h42.928v2.638H10.084z" />
  <path
    fill="#000"
    fill-opacity=".08"
    d="M10.084 34.347h42.928v2.638H10.084z"
  />
</svg>
`;
function ite() {
  return /* @__PURE__ */ c.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 61 40", fill: "none", children: [
    /* @__PURE__ */ c.jsx("path", { fill: "#FFF5E9", d: "M.084 0h60v40h-60z" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#000", fillOpacity: ".08", d: "M8.62 2.711h42.928v2.638H8.62z" }),
    /* @__PURE__ */ c.jsx(
      "rect",
      {
        width: "41.196",
        height: "22.16",
        x: "9.486",
        y: "8.92",
        fill: "#FFF1DB",
        stroke: "#FFBB62",
        strokeWidth: ".859",
        rx: "1.03"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#FFD59D",
        d: "M9.916 9.95a.6.6 0 0 1 .6-.6h39.137a.6.6 0 0 1 .6.6v3.932H9.915V9.95Z"
      }
    ),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#FFBB62",
        d: "M9.916 18.908h40.337v.957H9.916zM9.916 24.35h40.337v.957H9.916z"
      }
    ),
    /* @__PURE__ */ c.jsx("path", { fill: "#FFBB62", d: "M29.916 31.35v-22h1v22z" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#000", fillOpacity: ".08", d: "M8.62 34.65h42.928v2.638H8.62z" })
  ] });
}
const ote = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 40" fill="none">
  <path fill="#FFF5E9" d="M.084 0h60v40h-60z" />
  <path fill="#000" fill-opacity=".08" d="M8.62 2.711h42.928v2.638H8.62z" />
  <rect width="41.196" height="22.16" x="9.486" y="8.92" fill="#FFF1DB" stroke="#FFBB62" strokeWidth=".859" rx="1.03" />
  <path fill="#FFD59D" d="M9.916 9.95a.6.6 0 0 1 .6-.6h39.137a.6.6 0 0 1 .6.6v3.932H9.915V9.95Z" />
  <path fill="#FFBB62" d="M9.916 18.908h40.337v.957H9.916zM9.916 24.35h40.337v.957H9.916z" />
  <path fill="#FFBB62" d="M29.916 31.35v-22h1v22z" />
  <path fill="#000" fill-opacity=".08" d="M8.62 34.65h42.928v2.638H8.62z" />
</svg>`;
function ate() {
  return /* @__PURE__ */ c.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 61 40", fill: "none", children: [
    /* @__PURE__ */ c.jsx("path", { fill: "#FFF5E9", d: "M.084 0h60v40h-60z" }),
    /* @__PURE__ */ c.jsx(
      "path",
      {
        fill: "#FFBE5D",
        d: "M14.542 11.912h22.827v3.392H14.542zM14.542 18.304h31.084v3.392H14.542z"
      }
    ),
    /* @__PURE__ */ c.jsx("path", { fill: "#FFD59D", d: "M14.542 24.696h19.692v3.392H14.542z" })
  ] });
}
function ste() {
  return /* @__PURE__ */ c.jsxs("svg", { viewBox: "0 0 90 60", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ c.jsx("rect", { width: "90", height: "60", rx: "4", fill: "#FFEFDA" }),
    /* @__PURE__ */ c.jsx("rect", { x: "22.5", y: "13", width: "45", height: "3", fill: "#FFBE5D" }),
    /* @__PURE__ */ c.jsx("rect", { x: "22.5", y: "19", width: "30", height: "3", fill: "#FFBE5D" }),
    /* @__PURE__ */ c.jsx("rect", { x: "23", y: "27.5", width: "44", height: "19", rx: "2.5", stroke: "#FFBE5D" }),
    /* @__PURE__ */ c.jsx("rect", { x: "25.5", y: "31", width: "1", height: "4", rx: "0.5", fill: "#FFBE5D" })
  ] });
}
const lte = `<svg viewBox="0 0 90 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="90" height="60" rx="4" fill="#FFEFDA"/>
<rect x="22.5" y="13" width="45" height="3" fill="#FFBE5D"/>
<rect x="22.5" y="19" width="30" height="3" fill="#FFBE5D"/>
<rect x="23" y="27.5" width="44" height="19" rx="2.5" stroke="#FFBE5D"/>
<rect x="25.5" y="31" width="1" height="4" rx="0.5" fill="#FFBE5D"/>
</svg>
`, ute = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 40" fill="none">
  <path fill="#FFF5E9" d="M.084 0h60v40h-60z" />
  <path
    fill="#FFBE5D"
    d="M14.542 11.912h22.827v3.392H14.542zM14.542 18.304h31.084v3.392H14.542z"
  />
  <path fill="#FFD59D" d="M14.542 24.696h19.692v3.392H14.542z" />
</svg>
`;
function cte() {
  return /* @__PURE__ */ c.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 61 40", fill: "none", children: [
    /* @__PURE__ */ c.jsx("path", { fill: "#FFF5E9", d: "M.084 0h60v40h-60z" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#FFDDB2", d: "M8.584 5.18h43v23h-43z" }),
    /* @__PURE__ */ c.jsx("circle", { cx: "30.084", cy: "16.681", r: "5.554", fill: "#57534F" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#FFDDB2", d: "m32.83 16.68-4.347 2.51v-5.02l4.348 2.51Z" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#FFBB62", d: "M8.584 28.181h12v1h-12z" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#EBE1D6", d: "M20.584 28.181h31v1h-31z" }),
    /* @__PURE__ */ c.jsx("path", { fill: "#000", fillOpacity: ".08", d: "M8.62 32.181h42.928v2.638H8.62z" })
  ] });
}
const dte = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 40" fill="none">
  <path fill="#FFF5E9" d="M.084 0h60v40h-60z" />
  <path fill="#FFDDB2" d="M8.584 5.18h43v23h-43z" />
  <circle cx="30.084" cy="16.681" r="5.554" fill="#57534F" />
  <path fill="#FFDDB2" d="m32.83 16.68-4.347 2.51v-5.02l4.348 2.51Z" />
  <path fill="#FFBB62" d="M8.584 28.181h12v1h-12z" />
  <path fill="#EBE1D6" d="M20.584 28.181h31v1h-31z" />
  <path fill="#000" fill-opacity=".08" d="M8.62 32.181h42.928v2.638H8.62z" />
</svg>
`;
function pte() {
  return /* @__PURE__ */ c.jsxs(
    "svg",
    {
      viewBox: "0 0 90 60",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "xMidYMid meet",
      children: [
        /* @__PURE__ */ c.jsx("rect", { width: "90", height: "60", rx: "4.2", fill: "#FFF5E9" }),
        /* @__PURE__ */ c.jsx(
          "rect",
          {
            x: "16.9662",
            y: "8.62242",
            width: "19.0504",
            height: "19.1864",
            rx: "1.63289",
            fill: "#FFF5E9"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "rect",
          {
            x: "16.9662",
            y: "8.62242",
            width: "19.0504",
            height: "19.1864",
            rx: "1.63289",
            stroke: "#57534F",
            strokeWidth: "1.08859"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "rect",
          {
            x: "22.5469",
            y: "15.1484",
            width: "7.61051",
            height: "6.55868",
            fill: "#57534F"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "path",
          {
            d: "M22.9979 22.9086C22.7235 22.9086 22.4885 22.8064 22.2929 22.6019C22.0973 22.3975 21.9997 22.152 22 21.8654V14.5628C22 14.2759 22.0978 14.0302 22.2934 13.8257C22.489 13.6212 22.7238 13.5192 22.9979 13.5195H29.983C30.2574 13.5195 30.4924 13.6218 30.688 13.8262C30.8836 14.0307 30.9812 14.2762 30.9809 14.5628V21.8654C30.9809 22.1523 30.8831 22.398 30.6875 22.6025C30.4919 22.8069 30.2571 22.909 29.983 22.9086H22.9979ZM23.4968 20.8222H29.4841L27.6131 18.2141L26.1162 20.3006L24.9936 18.7357L23.4968 20.8222Z",
            fill: "#FFD59D"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "rect",
          {
            x: "40.3724",
            y: "8.62242",
            width: "32.6578",
            height: "19.1864",
            rx: "1.63289",
            fill: "#FFF5E9"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "rect",
          {
            x: "40.3724",
            y: "8.62242",
            width: "32.6578",
            height: "19.1864",
            rx: "1.63289",
            stroke: "#57534F",
            strokeWidth: "1.08859"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "rect",
          {
            x: "52.7578",
            y: "15.1484",
            width: "7.61051",
            height: "6.55868",
            fill: "#57534F"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "path",
          {
            d: "M53.2088 22.9086C52.9344 22.9086 52.6994 22.8064 52.5038 22.6019C52.3082 22.3975 52.2106 22.152 52.2109 21.8654V14.5628C52.2109 14.2759 52.3087 14.0302 52.5043 13.8257C52.6999 13.6212 52.9347 13.5192 53.2088 13.5195H60.194C60.4684 13.5195 60.7034 13.6218 60.899 13.8262C61.0945 14.0307 61.1922 14.2762 61.1918 14.5628V21.8654C61.1918 22.1523 61.094 22.398 60.8985 22.6025C60.7029 22.8069 60.468 22.909 60.194 22.9086H53.2088ZM53.7078 20.8222H59.695L57.824 18.2141L56.3272 20.3006L55.2046 18.7357L53.7078 20.8222Z",
            fill: "#FFD59D"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "rect",
          {
            x: "16.9662",
            y: "32.1888",
            width: "32.6578",
            height: "19.1864",
            rx: "1.63289",
            fill: "#FFF5E9"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "rect",
          {
            x: "16.9662",
            y: "32.1888",
            width: "32.6578",
            height: "19.1864",
            rx: "1.63289",
            stroke: "#57534F",
            strokeWidth: "1.08859"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "rect",
          {
            x: "29.3516",
            y: "38.7227",
            width: "7.61051",
            height: "6.55868",
            fill: "#57534F"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "path",
          {
            d: "M29.8026 46.4751C29.5281 46.4751 29.2931 46.3728 29.0976 46.1683C28.902 45.9639 28.8044 45.7184 28.8047 45.4318V38.1292C28.8047 37.8423 28.9025 37.5966 29.0981 37.3921C29.2936 37.1877 29.5285 37.0856 29.8026 37.0859H36.7877C37.0621 37.0859 37.2971 37.1882 37.4927 37.3926C37.6883 37.5971 37.7859 37.8426 37.7856 38.1292V45.4318C37.7856 45.7187 37.6878 45.9644 37.4922 46.1689C37.2966 46.3733 37.0618 46.4754 36.7877 46.4751H29.8026ZM30.3015 44.3886H36.2888L34.4177 41.7805L32.9209 43.867L31.7983 42.3021L30.3015 44.3886Z",
            fill: "#FFD59D"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "rect",
          {
            x: "53.9818",
            y: "32.1888",
            width: "19.0504",
            height: "19.1864",
            rx: "1.63289",
            fill: "#FFF5E9"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "rect",
          {
            x: "53.9818",
            y: "32.1888",
            width: "19.0504",
            height: "19.1864",
            rx: "1.63289",
            stroke: "#57534F",
            strokeWidth: "1.08859"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "rect",
          {
            x: "59.5547",
            y: "38.7227",
            width: "7.61051",
            height: "6.55868",
            fill: "#57534F"
          }
        ),
        /* @__PURE__ */ c.jsx(
          "path",
          {
            d: "M60.0135 46.4751C59.7391 46.4751 59.5041 46.3728 59.3085 46.1683C59.1129 45.9639 59.0153 45.7184 59.0156 45.4318V38.1292C59.0156 37.8423 59.1134 37.5966 59.309 37.3921C59.5046 37.1877 59.7394 37.0856 60.0135 37.0859H66.9986C67.2731 37.0859 67.5081 37.1882 67.7036 37.3926C67.8992 37.5971 67.9968 37.8426 67.9965 38.1292V45.4318C67.9965 45.7187 67.8987 45.9644 67.7031 46.1689C67.5076 46.3733 67.2727 46.4754 66.9986 46.4751H60.0135ZM60.5124 44.3886H66.4997L64.6287 41.7805L63.1319 43.867L62.0093 42.3021L60.5124 44.3886Z",
            fill: "#FFD59D"
          }
        )
      ]
    }
  );
}
const fte = `<svg viewBox="0 0 90 60" fill="none" xmlns="http://www.w3.org/2000/svg"
  preserveAspectRatio="xMidYMid meet">
  <rect width="90" height="60" rx="4.2" fill="#FFF5E9" />
  <rect x="16.9662" y="8.62242" width="19.0504" height="19.1864" rx="1.63289" fill="#FFF5E9" />
  <rect x="16.9662" y="8.62242" width="19.0504" height="19.1864" rx="1.63289" stroke="#57534F"
    stroke-width="1.08859" />
  <rect x="22.5469" y="15.1484" width="7.61051" height="6.55868" fill="#57534F" />
  <path
    d="M22.9979 22.9086C22.7235 22.9086 22.4885 22.8064 22.2929 22.6019C22.0973 22.3975 21.9997 22.152 22 21.8654V14.5628C22 14.2759 22.0978 14.0302 22.2934 13.8257C22.489 13.6212 22.7238 13.5192 22.9979 13.5195H29.983C30.2574 13.5195 30.4924 13.6218 30.688 13.8262C30.8836 14.0307 30.9812 14.2762 30.9809 14.5628V21.8654C30.9809 22.1523 30.8831 22.398 30.6875 22.6025C30.4919 22.8069 30.2571 22.909 29.983 22.9086H22.9979ZM23.4968 20.8222H29.4841L27.6131 18.2141L26.1162 20.3006L24.9936 18.7357L23.4968 20.8222Z"
    fill="#FFD59D" />
  <rect x="40.3724" y="8.62242" width="32.6578" height="19.1864" rx="1.63289" fill="#FFF5E9" />
  <rect x="40.3724" y="8.62242" width="32.6578" height="19.1864" rx="1.63289" stroke="#57534F"
    stroke-width="1.08859" />
  <rect x="52.7578" y="15.1484" width="7.61051" height="6.55868" fill="#57534F" />
  <path
    d="M53.2088 22.9086C52.9344 22.9086 52.6994 22.8064 52.5038 22.6019C52.3082 22.3975 52.2106 22.152 52.2109 21.8654V14.5628C52.2109 14.2759 52.3087 14.0302 52.5043 13.8257C52.6999 13.6212 52.9347 13.5192 53.2088 13.5195H60.194C60.4684 13.5195 60.7034 13.6218 60.899 13.8262C61.0945 14.0307 61.1922 14.2762 61.1918 14.5628V21.8654C61.1918 22.1523 61.094 22.398 60.8985 22.6025C60.7029 22.8069 60.468 22.909 60.194 22.9086H53.2088ZM53.7078 20.8222H59.695L57.824 18.2141L56.3272 20.3006L55.2046 18.7357L53.7078 20.8222Z"
    fill="#FFD59D" />
  <rect x="16.9662" y="32.1888" width="32.6578" height="19.1864" rx="1.63289" fill="#FFF5E9" />
  <rect x="16.9662" y="32.1888" width="32.6578" height="19.1864" rx="1.63289" stroke="#57534F"
    stroke-width="1.08859" />
  <rect x="29.3516" y="38.7227" width="7.61051" height="6.55868" fill="#57534F" />
  <path
    d="M29.8026 46.4751C29.5281 46.4751 29.2931 46.3728 29.0976 46.1683C28.902 45.9639 28.8044 45.7184 28.8047 45.4318V38.1292C28.8047 37.8423 28.9025 37.5966 29.0981 37.3921C29.2936 37.1877 29.5285 37.0856 29.8026 37.0859H36.7877C37.0621 37.0859 37.2971 37.1882 37.4927 37.3926C37.6883 37.5971 37.7859 37.8426 37.7856 38.1292V45.4318C37.7856 45.7187 37.6878 45.9644 37.4922 46.1689C37.2966 46.3733 37.0618 46.4754 36.7877 46.4751H29.8026ZM30.3015 44.3886H36.2888L34.4177 41.7805L32.9209 43.867L31.7983 42.3021L30.3015 44.3886Z"
    fill="#FFD59D" />
  <rect x="53.9818" y="32.1888" width="19.0504" height="19.1864" rx="1.63289" fill="#FFF5E9" />
  <rect x="53.9818" y="32.1888" width="19.0504" height="19.1864" rx="1.63289" stroke="#57534F"
    stroke-width="1.08859" />
  <rect x="59.5547" y="38.7227" width="7.61051" height="6.55868" fill="#57534F" />
  <path
    d="M60.0135 46.4751C59.7391 46.4751 59.5041 46.3728 59.3085 46.1683C59.1129 45.9639 59.0153 45.7184 59.0156 45.4318V38.1292C59.0156 37.8423 59.1134 37.5966 59.309 37.3921C59.5046 37.1877 59.7394 37.0856 60.0135 37.0859H66.9986C67.2731 37.0859 67.5081 37.1882 67.7036 37.3926C67.8992 37.5971 67.9968 37.8426 67.9965 38.1292V45.4318C67.9965 45.7187 67.8987 45.9644 67.7031 46.1689C67.5076 46.3733 67.2727 46.4754 66.9986 46.4751H60.0135ZM60.5124 44.3886H66.4997L64.6287 41.7805L63.1319 43.867L62.0093 42.3021L60.5124 44.3886Z"
    fill="#FFD59D" />
</svg>`, Et = {
  Text: Y.Text,
  Image: Y.Image,
  ImageGallery: Y.ImageGallery,
  Video: Y.Video,
  Highlight: Y.Highlight,
  Spoiler: Y.Spoiler,
  Box: Y.Box,
  SerloTable: Y.SerloTable,
  Equations: Y.Equations,
  Geogebra: Y.Geogebra,
  Injection: Y.Injection,
  Multimedia: Y.Multimedia,
  InteractiveVideo: Y.InteractiveVideo,
  Audio: Y.Audio,
  PageLayout: Y.PageLayout,
  PagePartners: Y.PagePartners,
  SingleChoiceExercise: "singleChoiceExercise",
  MultipleChoiceExercise: "multipleChoiceExercise",
  InputExercise: Y.InputExercise,
  TextAreaExercise: Y.TextAreaExercise,
  BlanksExercise: Y.BlanksExercise,
  BlanksExerciseDragAndDrop: "blanksExerciseDragAndDrop",
  DropzoneImage: Y.DropzoneImage,
  H5p: Y.H5p,
  ExerciseGroup: Y.ExerciseGroup,
  EdusharingAsset: Y.EdusharingAsset
}, hte = Object.values(Et).filter((e) => e !== Et.ExerciseGroup);
function i2(e) {
  return hte.map((t) => mte(e, t));
}
function mte(e, t) {
  const [n, r] = vte(t), i = gte(t, r, e), o = xte(t), a = wte(t);
  return { type: t, icon: o, IconComponent: a, initialState: n, ...i };
}
const Nw = {
  title: "Mystery Plugin 😶‍🌫️",
  description: "This is probably a new plugin, make sure you provide a title and description"
};
function gte(e, t, n) {
  if (Object.hasOwn(n.pluginMenu, e)) {
    const { title: a, description: s } = n.pluginMenu[e];
    return { title: a, description: s };
  }
  if (!Object.hasOwn(n.plugins, t)) return Nw;
  const r = n.plugins[t], i = r.title;
  if (!i) return Nw;
  const o = Object.hasOwn(r, "description") ? r.description : "";
  return { title: i, description: o };
}
function vte(e) {
  switch (e) {
    case Et.BlanksExerciseDragAndDrop:
    case Et.BlanksExercise:
      return [
        V4({
          plugin: Y.BlanksExercise,
          state: {
            text: { plugin: Y.Text },
            mode: e === Et.BlanksExerciseDragAndDrop ? "drag-and-drop" : "typing"
          }
        }),
        Y.BlanksExercise
      ];
    case Et.SingleChoiceExercise:
    case Et.MultipleChoiceExercise:
      return [
        V4({
          plugin: Y.ScMcExercise,
          state: {
            isSingleChoice: e === Et.SingleChoiceExercise,
            answers: [
              {
                content: { plugin: Y.Text },
                isCorrect: !0,
                feedback: { plugin: Y.Text }
              },
              {
                content: { plugin: Y.Text },
                isCorrect: !1,
                feedback: { plugin: Y.Text }
              }
            ]
          }
        }),
        Y.ScMcExercise
      ];
    case Et.InputExercise:
    case Et.TextAreaExercise:
    case Et.DropzoneImage:
    case Et.H5p:
      return [V4({ plugin: e }), e];
    default:
      return [{ plugin: e }, e];
  }
}
function V4(e) {
  return {
    plugin: Y.Exercise,
    state: {
      content: {
        plugin: Y.Rows,
        state: [{ plugin: Y.Text }]
      },
      interactive: e
    }
  };
}
const yte = {
  [Et.Text]: ute,
  [Et.Multimedia]: Jee,
  [Et.Video]: dte,
  [Et.Box]: Fee,
  [Et.Equations]: Bee,
  [Et.Geogebra]: Pee,
  [Et.Highlight]: Hee,
  [Et.Image]: jw,
  [Et.ImageGallery]: fte,
  [Et.Injection]: Uee,
  [Et.SerloTable]: ote,
  [Et.Spoiler]: rte,
  [Et.DropzoneImage]: Mee,
  [Et.SingleChoiceExercise]: tte,
  [Et.MultipleChoiceExercise]: Qee,
  [Et.InputExercise]: Zee,
  [Et.TextAreaExercise]: lte,
  [Et.BlanksExercise]: Oee,
  [Et.BlanksExerciseDragAndDrop]: jee,
  [Et.H5p]: qee,
  [Et.ExerciseGroup]: H4,
  [Et.InteractiveVideo]: Kee,
  [Et.Audio]: Aee,
  [Et.PageLayout]: H4,
  [Et.PagePartners]: H4,
  [Et.EdusharingAsset]: jw
};
function xte(e) {
  return yte[e];
}
const bte = {
  [Et.Text]: ate,
  [Et.Multimedia]: Yee,
  [Et.Video]: cte,
  [Et.Box]: zee,
  [Et.Equations]: Iee,
  [Et.Geogebra]: Ree,
  [Et.Highlight]: $ee,
  [Et.Image]: Tw,
  [Et.ImageGallery]: pte,
  [Et.Injection]: Vee,
  [Et.SerloTable]: ite,
  [Et.Spoiler]: nte,
  [Et.DropzoneImage]: Lee,
  [Et.SingleChoiceExercise]: ete,
  [Et.MultipleChoiceExercise]: Xee,
  [Et.InputExercise]: Wee,
  [Et.TextAreaExercise]: ste,
  [Et.BlanksExercise]: Nee,
  [Et.BlanksExerciseDragAndDrop]: Tee,
  [Et.H5p]: _ee,
  [Et.ExerciseGroup]: $4,
  [Et.InteractiveVideo]: Gee,
  [Et.Audio]: Dee,
  [Et.PageLayout]: $4,
  [Et.PagePartners]: $4,
  [Et.EdusharingAsset]: Tw
};
function wte(e) {
  return bte[e];
}
function Cte(e, t) {
  if (!t.length) return e;
  const n = t.toLowerCase();
  return e.filter(
    (r) => r.title.toLowerCase().includes(n) || r.type.toLowerCase().includes(n) || r.initialState.plugin.toLowerCase().includes(n)
  );
}
function kte({ onInsertPlugin: e }) {
  const t = zn(), n = nt(), r = n.plugins, { pluginMenuState: i, pluginMenuDispatch: o } = v.useContext(r2), [a, s] = v.useState(""), [l, u] = v.useState(null), d = v.useRef([]), p = v.useRef(null), f = i2(n), m = v.useMemo(() => {
    const z = f.map(
      (R) => R.initialState.plugin
    ), I = Array.from(new Set(z)), w = (i.allowedChildPlugins ?? I).filter(
      (R) => si.isSupported(R)
    ), M = Eg(
      t.getState(),
      i.parentPluginId
    );
    return M != null && M.length ? w.filter(
      (R) => ry(R, M)
    ) : w;
  }, [
    f,
    i.allowedChildPlugins,
    i.parentPluginId,
    t
  ]), y = v.useMemo(() => f.filter(({ initialState: z }) => {
    var I;
    const w = m.includes(z.plugin);
    if (!LN(z) || !m.includes(Y.Exercise))
      return w;
    const M = (I = z.state.interactive) == null ? void 0 : I.plugin;
    return M ? si.isSupported(M) : w;
  }), [m, f]), { basicOptions: g, interactiveOptions: x, firstOption: E, isEmpty: b } = v.useMemo(() => {
    const z = Cte(
      y,
      a
    ), I = z.filter(
      ({ initialState: R }) => R.plugin !== Y.Exercise && R.plugin !== Y.InteractiveVideo
    ), w = z.filter(
      ({ initialState: R }) => R.plugin === Y.Exercise || R.plugin === Y.InteractiveVideo
    ), M = I.at(0) ?? w.at(0);
    return { basicOptions: I, interactiveOptions: w, firstOption: M, isEmpty: M === void 0 };
  }, [y, a]), C = (z) => {
    z === !1 && o({ type: su.CLOSE });
  };
  See({
    enabled: i.showPluginMenu,
    focusedItemIndex: l,
    setFocusedItemIndex: u,
    basicItemsLength: g.length,
    intearctiveItemsLength: x.length,
    columns: 5,
    searchInputRef: p
  }), v.useEffect(() => {
    var z;
    l !== null && d.current[l] && ((z = d.current[l]) == null || z.focus());
  }, [l]), v.useEffect(() => {
    i.showPluginMenu && setTimeout(() => {
      var z;
      return (z = p.current) == null ? void 0 : z.focus();
    }, 10);
  }, [i.showPluginMenu, p]);
  function T(z) {
    if (z.key === Yo.Key.ArrowDown && (u(0), z.preventDefault()), z.key === Yo.Key.Enter) {
      if (!E) return;
      e(E), z.preventDefault();
    }
  }
  return v.useEffect(() => {
    s("");
  }, [i.showPluginMenu]), /* @__PURE__ */ c.jsxs(
    qo,
    {
      className: "top-8 max-h-[90vh] w-auto min-w-[700px] translate-y-0 overflow-y-scroll pt-0",
      extraTitleClassName: "sr-only",
      title: r.rows.addAnElement,
      isOpen: i.showPluginMenu,
      setIsOpen: C,
      "data-qa": "plugin-menu-modal",
      onEscapeKeyDown: (z) => {
        a.length !== 0 && z.preventDefault();
      },
      onKeyDown: (z) => {
        var I;
        z.altKey || z.ctrlKey || z.metaKey || !(z.key.length === 1 && z.key.match(new RegExp("\\p{L}", "u"))) && z.key !== "Backspace" && z.key !== "Delete" || ((I = p.current) == null || I.focus(), u(null));
      },
      children: [
        /* @__PURE__ */ c.jsx("div", { className: "sticky top-0 z-10 bg-white pb-3 pl-6 pt-7 shadow-stickysearch", children: /* @__PURE__ */ c.jsx(
          tf,
          {
            "data-qa": "plugin-menu-search-input",
            ref: p,
            autoFocus: !0,
            placeholder: n.addPluginsModal.searchInputPlaceholder,
            value: a,
            onChange: (z) => s(z.target.value),
            onKeyDown: T,
            inputWidth: "50%",
            className: "ml-8 block"
          }
        ) }),
        b ? /* @__PURE__ */ c.jsxs("div", { className: "mt-4 flex flex-col items-center justify-center space-y-2 p-10 pt-4 text-center", children: [
          /* @__PURE__ */ c.jsx(bee, { className: "mb-4" }),
          /* @__PURE__ */ c.jsxs("div", { children: [
            /* @__PURE__ */ c.jsx("h3", { className: "pb-4 text-lg font-bold text-almost-black", children: n.addPluginsModal.noPluginsFoundTitle }),
            /* @__PURE__ */ c.jsx("p", { children: n.addPluginsModal.noPluginsFoundDescription })
          ] })
        ] }) : /* @__PURE__ */ c.jsx(
          Eee,
          {
            basicOptions: g,
            interactiveOptions: x,
            focusedItemIndex: l,
            setFocusedItemIndex: u,
            itemRefs: d,
            onInsertPlugin: e
          }
        )
      ]
    }
  );
}
const Ete = /* @__PURE__ */ vee("div");
function Ow(e) {
  const { focused: t, onClick: n } = e, r = nt().plugins.rows, i = v.useRef(null);
  return /* @__PURE__ */ c.jsxs(
    "button",
    {
      ref: i,
      className: Le(
        `
        relative -top-4 mb-6 flex w-full cursor-pointer items-center bg-gradient-to-b
        from-transparent via-white to-transparent px-8 text-editor-primary-200 opacity-0
        transition-opacity duration-300 hover:z-50 hover:opacity-100 focus:z-50 focus:opacity-100
        `,
        t && "opacity-40"
      ),
      onClick: n,
      children: [
        /* @__PURE__ */ c.jsx("span", { className: "flex-grow border-t-2 border-gray-300" }),
        /* @__PURE__ */ c.jsxs("span", { className: "serlo-tooltip-trigger px-6 text-2xl", children: [
          /* @__PURE__ */ c.jsx(ot, { icon: Lg }),
          /* @__PURE__ */ c.jsx(vn, { text: r.addAnElement })
        ] }),
        /* @__PURE__ */ c.jsx("span", { className: "flex-grow border-t-2 border-gray-300" })
      ]
    }
  );
}
function Ste({ drag: e, rows: t, index: n }) {
  function r() {
    const o = document.getElementById(t[n - 1].id);
    o && Lw(o, { offset: 60, direction: "up" }, () => {
      t.move(n, n - 1);
    });
  }
  function i() {
    const o = document.getElementById(t[n + 1].id);
    o && Lw(o, { offset: 40, direction: "down" }, () => {
      t.move(n, n + 1);
    });
  }
  return /* @__PURE__ */ c.jsxs(
    "div",
    {
      ref: e,
      className: Le(
        "row-controls",
        "absolute bottom-14 left-2 top-0 z-[22] flex flex-col justify-center gap-4",
        "rounded-l-md bg-white bg-opacity-70 opacity-0 transition-opacity"
      ),
      children: [
        /* @__PURE__ */ c.jsx(
          "button",
          {
            className: Le(zw, n === 0 && "hidden"),
            onClick: r,
            children: /* @__PURE__ */ c.jsx("div", { className: Fw, "aria-hidden": "true", children: /* @__PURE__ */ c.jsx(ot, { icon: _V, className: "text-xl" }) })
          }
        ),
        /* @__PURE__ */ c.jsx(
          "button",
          {
            className: Le(zw, n === t.length - 1 && "hidden"),
            onClick: i,
            children: /* @__PURE__ */ c.jsx("div", { className: Fw, "aria-hidden": "true", children: /* @__PURE__ */ c.jsx(ot, { icon: LV, className: "text-xl" }) })
          }
        )
      ]
    }
  );
}
const zw = Le(`
  serlo-tooltip-trigger -mt-[3px] select-none
  rounded-full border-0 bg-none p-0
`), Fw = Le(`
  serlo-button-edit-primary block rounded-full bg-editor-primary-100
  px-0.5 py-0 text-almost-black hover:bg-editor-primary-300
`);
function Lw(e, t, n) {
  const { offset: r, direction: i } = t, o = e.getBoundingClientRect();
  if (o.top >= r && o.bottom <= window.innerHeight - r) return n();
  const a = i === "up" ? o.top + window.scrollY - r : o.bottom + window.scrollY + r - window.innerHeight;
  window.scrollTo({ top: a, behavior: "smooth" }), new IntersectionObserver(
    (s, l) => {
      s[0].isIntersecting && (l.disconnect(), n());
    },
    // Make sure that the whole element is in view
    { threshold: 1 }
  ).observe(e);
}
function Dte(e, t, n) {
  const r = zn();
  return function(u) {
    return u && i(u) && o(u) && !a(u) && !s(u);
  };
  function i(u) {
    if (!n) return !0;
    const d = bi(r.getState(), u);
    return d && n.includes(d.plugin);
  }
  function o(u) {
    const d = Eg(r.getState(), e);
    if (d === null) return !0;
    const p = bi(r.getState(), u);
    return p === null ? !0 : ry(p == null ? void 0 : p.plugin, d);
  }
  function a(u) {
    return (rA(r.getState(), e) || []).includes(u);
  }
  function s(u) {
    const d = il(r.getState(), u), p = l(d, e);
    if (p === null) return !1;
    const f = l(d, u);
    return t ? f === p - 1 : f === p + 1;
  }
  function l(u, d) {
    if (!u) return null;
    const p = (u.children ?? []).findIndex(
      (f) => f.id === d
    );
    return p > -1 ? p : null;
  }
}
const sO = [Bg, Ig];
function Ate({
  config: e,
  row: t,
  rows: n,
  index: r,
  plugins: i,
  dropContainer: o
}) {
  const a = v.useRef(null), [s, l] = v.useState(!0), u = zn(), d = v.useMemo(() => e.allowedPlugins ? e.allowedPlugins : void 0, [e]), p = Dte(t.id, s, d), [f, m, y] = Of({
    type: "row",
    item: () => ({
      id: t.id,
      static: li(u.getState(), t.id),
      onDrop() {
        n.set((T) => {
          const z = T.findIndex((I) => I === t.id);
          return DD(z, 1, T);
        }), n.length <= 1 && n.insert(0, { plugin: Y.Text });
      }
    }),
    collect(T) {
      return { isDragging: !!T.isDragging() };
    }
  }), [g, x] = cd({
    accept: ["row", ...sO],
    collect(T) {
      const z = T.getItemType(), I = T.canDrop() && T.isOver({ shallow: !0 });
      if (Mw(z)) return { isDragging: I, isFile: !0 };
      if (z === "row") {
        const { id: w } = T.getItem();
        return { isDragging: I, id: w };
      }
      return { isDragging: !1 };
    },
    hover(T, z) {
      z.getItemType() === "row" && z.canDrop() && z.isOver({ shallow: !0 }) && l(C(z));
    },
    drop(T, z) {
      const I = z.getItemType();
      if (z.didDrop()) return;
      if (!Mw(I)) {
        if (!p(T.id)) return;
        const R = C(z);
        T.onDrop(), n.set((F, W) => {
          const X = F.findIndex((le) => le === t.id) + (R ? 0 : 1);
          return TD(X, W(T.static), F);
        });
        return;
      }
      const w = r;
      switch (I) {
        case Bg: {
          const R = z.getItem().files;
          i.find(({ type: F, plugin: W }) => {
            const { onFiles: X } = W;
            if (typeof X == "function") {
              const le = X(R);
              if (le !== void 0)
                return M(F, le), !0;
            }
          });
          break;
        }
        case Ig: {
          const R = z.getItem().urls[0];
          i.forEach(async ({ type: F, plugin: W }) => {
            if (typeof W.onText == "function") {
              const X = await W.onText(R);
              X !== void 0 && M(F, X);
            }
          });
          break;
        }
      }
      function M(R, F) {
        C(z) ? n.insert(w, { plugin: R, state: F.state }) : n.insert(w + 1, {
          plugin: R,
          state: F.state
        });
      }
    }
  });
  setTimeout(() => {
    y(x(o));
  });
  const E = g.isDragging && (g.isFile || p(g.id)) ? /* @__PURE__ */ c.jsx("hr", { className: "m-0 border-2 border-brand p-0" }) : null, b = tA(u.getState(), t.id) === Y.Multimedia;
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    s ? E : null,
    /* @__PURE__ */ c.jsxs(
      "div",
      {
        id: t.id,
        ref: a,
        className: Le(
          // Base class, used for nested selectors and DOM querying
          "rows-editor-renderer-container",
          // Hover and focus indicator styles
          "rounded-b-lg pt-2",
          "hover:shadow-plugin-hover",
          "focus-within:shadow-plugin-focus",
          "hover:focus-within:!shadow-plugin-focus",
          // Row controls (left sidebar) styles
          "[&:focus-within>.row-controls]:opacity-100",
          "[&:has(.rows-editor-renderer-container:focus-within)>.row-controls]:opacity-0",
          "[&:hover>.row-controls]:!opacity-100",
          b && "[&>.row-controls]:!-left-1 [&>.row-controls]:!-top-9"
        ),
        children: [
          /* @__PURE__ */ c.jsx(Ste, { drag: m, rows: n, index: r }),
          /* @__PURE__ */ c.jsx(
            "div",
            {
              className: f.isDragging ? "opacity-30" : void 0,
              children: t.render({
                config: {
                  placeholder: e.textPluginPlaceholder
                }
              })
            }
          )
        ]
      }
    ),
    s ? null : E
  ] });
  function C(T) {
    if (!a.current)
      return !1;
    const z = a.current.getBoundingClientRect(), I = (z.bottom - z.top) / 2, w = T.getClientOffset();
    return (w ? w.y - z.top : 0) < I;
  }
}
function Mw(e) {
  return sO.includes(e);
}
function Tte({
  config: e,
  index: t,
  row: n,
  rows: r,
  hideAddButton: i,
  onAddButtonClick: o,
  isRootRow: a
}) {
  const s = yn((p) => cs(p, n.id)), l = si.getAllWithData(), u = v.useRef(null);
  function d(p, f) {
    p.preventDefault(), o(f);
  }
  return /* @__PURE__ */ c.jsxs(
    Ete,
    {
      layout: !0,
      transition: { duration: 0.3, type: "linear" },
      ref: u,
      className: "rows-child relative -ml-12 pl-12",
      children: [
        a && t === 0 && /* @__PURE__ */ c.jsx(
          Ow,
          {
            focused: s,
            onClick: (p) => d(p, t)
          }
        ),
        /* @__PURE__ */ c.jsx(
          Ate,
          {
            config: e,
            row: n,
            rows: r,
            index: t,
            plugins: l,
            dropContainer: u
          }
        ),
        i ? null : /* @__PURE__ */ c.jsx(
          Ow,
          {
            focused: s,
            onClick: (p) => d(p, t + 1)
          }
        )
      ]
    }
  );
}
const jte = () => import("./react-DtWhboZC-CqaQ6tGZ.js").then((e) => e.domMax);
function Nte({ state: e, config: t, id: n }) {
  const r = zn(), i = p7(r.getState(), n), o = i == null ? void 0 : i.startsWith("type-"), a = i === Y.Article || o, { pluginMenuState: s, pluginMenuDispatch: l } = v.useContext(r2);
  function u(f) {
    l({
      type: su.OPEN,
      payload: { insertIndex: f }
    });
  }
  function d(f) {
    s.insertCallback ? s.insertCallback(f.initialState) : (e.insert(s.insertIndex, f.initialState), p()), l({ type: su.CLOSE });
  }
  function p() {
    Xq(r.getState(), n).forEach((f) => {
      f !== s.insertIndex && e.remove(f);
    });
  }
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx("div", { className: "relative mt-6", style: Ote, children: /* @__PURE__ */ c.jsx(yee, { features: jte, strict: !0, children: e.map((f, m) => {
      const y = a && m === e.length - 1;
      return /* @__PURE__ */ c.jsx(
        Tte,
        {
          config: t,
          index: m,
          rows: e,
          row: f,
          isRootRow: i === Y.Rows,
          hideAddButton: !!y,
          onAddButtonClick: u
        },
        f.id
      );
    }) }) }),
    a ? /* @__PURE__ */ c.jsx(
      xee,
      {
        onClick: () => {
          u(e.length);
        }
      }
    ) : null,
    /* @__PURE__ */ c.jsx(kte, { onInsertPlugin: d })
  ] });
}
const Ote = {
  // `overflow-anchor: none` makes sure that the page doesn't jump
  // when moving plugins using the sidebar up/down arrow buttons
  overflowAnchor: "none"
};
function zte(e) {
  const { config: t, id: n } = e;
  return /* @__PURE__ */ c.jsx(
    Cee,
    {
      allowedChildPlugins: t.allowedPlugins,
      parentPluginId: n,
      children: /* @__PURE__ */ c.jsx(Nte, { ...e })
    }
  );
}
const Fte = Vr(
  [(e) => e, (e, t) => t],
  (e, t) => {
    const n = bi(e, t);
    return n && Array.isArray(n.state) && n.state.every((r) => {
      const i = r == null ? void 0 : r.value;
      return typeof i == "string" && ou(e, i);
    });
  }
);
function Lte(e) {
  return $a(Vn(e), 1);
}
const Mte = {
  content: { plugin: Y.Text },
  parentType: Ec
};
function Bte(e = Mte) {
  const { content: t } = e;
  return {
    Component: zte,
    config: e,
    state: Lte(t),
    insertChild(n, { previousSibling: r, document: i }) {
      if (!r) {
        n.insert(0, i);
        return;
      }
      const o = n.findIndex(({ id: a }) => a === r);
      o !== -1 && n.insert(o + 1, i);
    },
    removeChild(n, r) {
      const i = n.findIndex(({ id: o }) => o === r);
      i !== -1 && n.remove(i);
    }
  };
}
function Ite() {
  const e = nt().plugins.box.emptyContentWarning;
  return /* @__PURE__ */ c.jsx(
    "div",
    {
      className: "box-warning text-side absolute right-10 -mt-[1.45rem]",
      "data-qa": "plugin-box-empty-content-warning",
      children: /* @__PURE__ */ c.jsxs("span", { className: "bg-editor-primary-100 px-1.5 py-0.5 text-sm", children: [
        "⚠️ ",
        e
      ] })
    }
  );
}
const Mm = {
  blank: void 0,
  example: HV,
  quote: SV,
  approach: wV,
  attention: ZV,
  remember: KV,
  note: iV,
  definition: qV,
  theorem: sV,
  proof: OV
}, lO = Object.keys(Mm);
function iy({
  boxType: e,
  title: t,
  anchorId: n,
  children: r,
  className: i
}) {
  const o = Un().plugins.box;
  if (!r || !e) return null;
  const a = e === "blank", s = e === "attention", l = Mm[e] ? /* @__PURE__ */ c.jsx(ot, { className: "mr-1", icon: Mm[e] }) : null;
  return /* @__PURE__ */ c.jsxs(
    "figure",
    {
      id: n,
      className: Le(
        `
          serlo-box relative mb-6 
          rounded-lg border-3 pb-2 pt-[2px]
          [&>div.my-block]:first:mt-3.5
          [&>div.my-block]:last:mb-3.5
        `,
        s ? "border-red-100" : "border-brand-200",
        i
      ),
      children: [
        /* @__PURE__ */ c.jsx("figcaption", { className: "px-side pt-2.5 text-lg", children: /* @__PURE__ */ c.jsxs("a", { className: "!no-underline", children: [
          a ? null : /* @__PURE__ */ c.jsxs(
            "span",
            {
              className: Le(
                t && !a ? "mr-1.5" : "",
                s ? "text-orange" : "text-brand"
              ),
              children: [
                l,
                o.types[e]
              ]
            }
          ),
          t
        ] }) }),
        e === "quote" ? /* @__PURE__ */ c.jsx("blockquote", { children: r }) : r
      ]
    }
  );
}
function Rte({ typeState: e }) {
  const t = Un().plugins.box, n = nt();
  function r(i, o) {
    o.preventDefault(), o.stopPropagation(), e.set(i);
  }
  return /* @__PURE__ */ c.jsxs(
    "figure",
    {
      className: "relative mx-side rounded-xl border-3 p-4 pt-2",
      "data-qa": "plugin-box-initial-type-chooser",
      children: [
        /* @__PURE__ */ c.jsx("b", { className: "block pb-3", children: n.plugins.box.type }),
        /* @__PURE__ */ c.jsx("ul", { className: "unstyled-list", children: lO.map((i) => {
          const o = Mm[i];
          return /* @__PURE__ */ c.jsx("li", { className: "inline-block pb-3.5 pr-4", children: /* @__PURE__ */ c.jsxs(
            "button",
            {
              className: "serlo-button-edit-secondary",
              onClick: (a) => r(i, a),
              onKeyDown: (a) => {
                a.key === "Enter" && r(i, a);
              },
              "data-qa": `plugin-box-initial-type-chooser-option-${i}`,
              children: [
                o ? /* @__PURE__ */ c.jsx(ot, { className: "mr-1", icon: o }) : null,
                t.types[i]
              ]
            }
          ) }, i);
        }) })
      ]
    }
  );
}
const Pte = {
  default: "!bg-brand-100",
  warning: "!bg-orange-100 !text-black"
};
function yi(e, t, n) {
  if (t === "success") {
    Bb.success(e, {
      duration: n ?? 3200,
      iconTheme: {
        primary: "#95bc1a",
        secondary: "#fff"
      }
    });
    return;
  }
  Bb(e, {
    duration: n ?? 3200,
    className: Pte[t ?? "default"]
  });
}
function Y0({
  onClick: e,
  label: t,
  icon: n,
  dataQa: r,
  separatorTop: i
}) {
  return /* @__PURE__ */ c.jsx(
    "button",
    {
      className: Le(
        "group/button w-full px-3 text-left",
        i && "mt-2.5 border-t pt-2.5"
      ),
      onClick: e,
      "data-qa": r,
      children: /* @__PURE__ */ c.jsxs("span", { className: "serlo-button-edit-secondary w-fit bg-transparent text-sm group-hover/button:bg-editor-primary-200", children: [
        /* @__PURE__ */ c.jsx(ot, { icon: n }),
        " ",
        t
      ] })
    }
  );
}
function _te({ pluginId: e }) {
  var t, n;
  const r = nt().plugins.rows, i = /\/entity\/repository\/add-revision\/(?<id>\d+)/, o = typeof window < "u" && ((n = (t = window.location.href.match(i)) == null ? void 0 : t.groups) == null ? void 0 : n.id);
  return !o || !navigator.clipboard ? null : /* @__PURE__ */ c.jsx(
    Y0,
    {
      onClick: () => {
        const a = `https://serlo.org/${o}#${e.split("-")[0]}`;
        navigator.clipboard.writeText(a), yi(r.copySuccess, "success", 2e3);
      },
      label: r.copyAnchorLink,
      icon: VV,
      separatorTop: !0,
      dataQa: "copy-anchor-link-button"
    }
  );
}
function qte({ pluginId: e, noSeparator: t }) {
  const n = nt().plugins.rows, r = zn(), i = v.useCallback(() => {
    const o = { plugin: "rows", state: [nA(r.getState(), e)] };
    navigator.clipboard.writeText(JSON.stringify(o)), yi(n.copySuccess, "success", 2e3), yi("👉 " + n.pluginCopyInfo, void 0, 4e3);
  }, [e, n, r]);
  return navigator.clipboard ? /* @__PURE__ */ c.jsx(
    Y0,
    {
      onClick: i,
      label: n.pluginCopyButtonLabel,
      icon: PV,
      separatorTop: !t,
      dataQa: "plugin-copy-tool-button"
    }
  ) : null;
}
function Pi({ pluginId: e }) {
  const t = zn(), n = Ur(), r = nt().plugins, i = v.useMemo(
    () => p7(t.getState(), e) === Y.Rows,
    [e, t]
  ), o = v.useCallback(() => {
    const s = il(t.getState(), e);
    if (!s) return;
    const l = nA(t.getState(), e);
    l && n(
      Qp({
        parent: s.id,
        sibling: e,
        document: l
      })
    );
  }, [n, e, t]), a = v.useCallback(() => {
    var s, l;
    const u = il(t.getState(), e);
    !u || !((s = u.children) != null && s.length) || (((l = u.children) == null ? void 0 : l.length) === 1 && n(
      Qp({
        parent: u.id,
        sibling: e,
        document: { plugin: Y.Text }
      })
    ), n(
      j0({
        parent: u.id,
        child: e
      })
    ));
  }, [n, e, t]);
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    i ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx(
        Y0,
        {
          onClick: o,
          label: r.rows.duplicate,
          icon: WV,
          dataQa: "duplicate-plugin-button"
        }
      ),
      /* @__PURE__ */ c.jsx(
        Y0,
        {
          onClick: a,
          label: r.rows.remove,
          icon: ld,
          dataQa: "remove-plugin-button"
        }
      )
    ] }) : null,
    /* @__PURE__ */ c.jsx(qte, { pluginId: e, noSeparator: !i }),
    i ? /* @__PURE__ */ c.jsx(_te, { pluginId: e }) : null
  ] });
}
const $te = ({ id: e, state: t }) => {
  const n = nt().plugins.box, r = Un().plugins.box;
  return /* @__PURE__ */ c.jsx(
    Ci,
    {
      pluginType: Y.Box,
      pluginSettings: /* @__PURE__ */ c.jsx(c.Fragment, { children: /* @__PURE__ */ c.jsxs("div", { className: "serlo-tooltip-trigger", children: [
        /* @__PURE__ */ c.jsx(
          vn,
          {
            text: n.typeTooltip,
            className: "-ml-4 !pb-1"
          }
        ),
        /* @__PURE__ */ c.jsx(
          fs,
          {
            tooltipText: "",
            value: t.type.value,
            changeValue: (i) => t.type.set(i),
            dataQa: "plugin-box-type-chooser",
            options: lO.map((i) => ({
              value: i,
              text: r.types[i],
              dataQa: `plugin-box-type-chooser-option-${i}`
            }))
          }
        )
      ] }) }),
      pluginControls: /* @__PURE__ */ c.jsx(Pi, { pluginId: e }),
      className: "top-[-33px]"
    }
  );
}, Hte = [
  tt.math,
  tt.code
];
function Vte(e) {
  const { focused: t } = e, { title: n, type: r, content: i, anchorId: o } = e.state, a = r.value === "", s = a ? "blank" : r.value, l = nt(), u = i.id, d = yn(
    (y) => Fte(y, u)
  ), p = yn(
    (y) => cs(y, n.id)
  ), f = t || p;
  if (a)
    return /* @__PURE__ */ c.jsx("div", { "data-qa": "plugin-box", children: /* @__PURE__ */ c.jsx(Rte, { typeState: r }) });
  const m = {
    config: {
      placeholder: l.plugins.box.titlePlaceholder,
      formattingOptions: Hte,
      isInlineChildEditor: !0
    }
  };
  return /* @__PURE__ */ c.jsxs("div", { "data-qa": "plugin-box", className: "pl-0.5", children: [
    f ? /* @__PURE__ */ c.jsx($te, { ...e }) : null,
    /* @__PURE__ */ c.jsxs(
      "div",
      {
        className: Le(
          f && "[&>figure]:rounded-t-none",
          "transition-opacity",
          d && "opacity-30 focus-within:opacity-100",
          f && "!opacity-100 ",
          "[&:focus-within_.box-warning]:hidden",
          // making space for first toolbar, not wysiwyg
          "[&>figure>figcaption]:!mb-9",
          // toolbar finetuning
          "[&_.rows-child:first-child_.plugin-toolbar:before]:hidden",
          // shadow finetuning
          "-mt-2"
        ),
        children: [
          d && !f ? /* @__PURE__ */ c.jsx(Ite, {}) : null,
          /* @__PURE__ */ c.jsx(
            iy,
            {
              boxType: s,
              title: /* @__PURE__ */ c.jsx(
                "div",
                {
                  className: "-ml-1 inline-block max-h-6 min-w-[15rem] font-bold",
                  "data-qa": "plugin-box-title",
                  children: n.render(m)
                }
              ),
              anchorId: o.value,
              children: /* @__PURE__ */ c.jsx("div", { className: "mx-side", "data-qa": "plugin-box-content", children: i.render() })
            }
          )
        ]
      }
    )
  ] });
}
function Ute(e) {
  return ln({
    type: rn(""),
    title: Vn({
      plugin: Y.Text,
      config: {
        noLinebreaks: !0
      }
    }),
    // we don't generate new id's any more but keep the old ones for now
    anchorId: rn(""),
    content: Vn({
      plugin: Y.Rows,
      config: { allowedPlugins: e }
    })
  });
}
const Wte = [
  Y.Text,
  Y.Image,
  Y.Equations,
  Y.Multimedia,
  Y.SerloTable,
  Y.Highlight,
  Y.EdusharingAsset,
  Y.Exercise
];
function Zte(e) {
  const t = Wte.filter(
    (n) => e.includes(n)
  );
  return {
    Component: Vte,
    state: Ute(t),
    config: {
      allowedPlugins: t
    }
  };
}
const uO = (e) => /* @__PURE__ */ v.createElement("svg", { width: 60, height: 40, viewBox: "0 0 60 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("rect", { x: 1, y: 1, width: 58, height: 38, rx: 3, fill: "#FFF5E9" }), /* @__PURE__ */ v.createElement("rect", { x: 10, y: 4.73633, width: 42.9282, height: 2.63846, fill: "black", fillOpacity: 0.08 }), /* @__PURE__ */ v.createElement("rect", { x: 10, y: 32.625, width: 42.9282, height: 2.63846, fill: "black", fillOpacity: 0.08 })), Gte = (e) => /* @__PURE__ */ v.createElement("svg", { width: 40, height: 60, viewBox: "0 0 40 60", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("rect", { x: 1, y: 59, width: 58, height: 38, rx: 3, transform: "rotate(-90 1 59)", fill: "#FFF5E9" }), /* @__PURE__ */ v.createElement("rect", { x: 6, y: 6, width: 28, height: 2.63846, fill: "black", fillOpacity: 0.08 }), /* @__PURE__ */ v.createElement("rect", { x: 6, y: 51.3613, width: 28, height: 2.63846, fill: "black", fillOpacity: 0.08 })), Kte = (e) => /* @__PURE__ */ v.createElement("svg", { width: 50, height: 50, viewBox: "0 0 50 50", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("rect", { x: 1, y: 1, width: 48, height: 48, rx: 3, fill: "#FFF5E9" }), /* @__PURE__ */ v.createElement("rect", { x: 6, y: 6.36133, width: 38, height: 2.63846, fill: "black", fillOpacity: 0.08 }), /* @__PURE__ */ v.createElement("rect", { x: 6, y: 41, width: 38, height: 2.63846, fill: "black", fillOpacity: 0.08 }));
var lu = /* @__PURE__ */ ((e) => (e.Unset = "", e.Image = "image", e.Text = "text", e))(lu || {}), nf = /* @__PURE__ */ ((e) => (e.Blank = "blank", e.Image = "image", e))(nf || {}), zo = /* @__PURE__ */ ((e) => (e.Unset = "", e.Square = "square", e.Landscape = "landscape", e.Portrait = "portrait", e))(zo || {}), Ic = /* @__PURE__ */ ((e) => (e.Full = "full", e.Partial = "partial", e.None = "none", e))(Ic || {}), ti = /* @__PURE__ */ ((e) => (e.Unset = "", e.Settings = "settings", e.CreateDropZone = "createDropZone", e.Edit = "edit", e.CreateWrongAnswer = "createWrongAnswer", e))(ti || {}), Zi = /* @__PURE__ */ ((e) => (e.Unset = "unset", e.Correct = "correct", e.Wrong = "wrong", e.MissedSome = "missedSome", e))(Zi || {});
const uc = 600, Bw = 400, Xte = [
  zo.Square,
  zo.Landscape,
  zo.Portrait
], Qte = {
  [zo.Square]: /* @__PURE__ */ c.jsx(Kte, {}),
  [zo.Portrait]: /* @__PURE__ */ c.jsx(Gte, {}),
  [zo.Landscape]: /* @__PURE__ */ c.jsx(uO, {})
}, Yte = {
  [zo.Square]: {
    canvasHeight: uc,
    canvasWidth: uc
  },
  [zo.Landscape]: {
    canvasHeight: Bw,
    canvasWidth: uc
  },
  [zo.Portrait]: {
    canvasHeight: uc,
    canvasWidth: Bw
  }
};
function Jte({
  canvasShape: e,
  canvasDimensions: t
}) {
  const n = nt().plugins.dropzoneImage.backgroundShapes, r = (i) => {
    const o = Yte[i];
    t.height.set(o.canvasHeight), t.width.set(o.canvasWidth), e.set(i);
  };
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx("h2", { className: "py-6 text-center text-gray-500", children: n.description }),
    /* @__PURE__ */ c.jsx("div", { className: "flex justify-center gap-6", children: Xte.map((i) => /* @__PURE__ */ c.jsx(
      ef,
      {
        onClick: () => r(i),
        icon: Qte[i],
        title: n[i],
        dataQa: `plugin-dropzone-image-background-shape-select-${i}`
      },
      i
    )) })
  ] });
}
const ene = (e) => /* @__PURE__ */ v.createElement("svg", { width: 60, height: 40, viewBox: "0 0 60 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("rect", { x: 1, y: 1, width: 58, height: 38, rx: 3, fill: "#FFF5E9" }), /* @__PURE__ */ v.createElement("rect", { x: 10, y: 4.73633, width: 42.9282, height: 2.63846, fill: "black", fillOpacity: 0.08 }), /* @__PURE__ */ v.createElement("rect", { x: 24.2109, y: 14.375, width: 13.9823, height: 12.0498, fill: "#57534F" }), /* @__PURE__ */ v.createElement("path", { d: "M25.0443 28.625C24.5401 28.625 24.1084 28.4372 23.749 28.0615C23.3897 27.6858 23.2103 27.2348 23.2109 26.7083V13.2917C23.2109 12.7646 23.3906 12.3132 23.7499 11.9375C24.1093 11.5619 24.5407 11.3744 25.0443 11.375H37.8776C38.3818 11.375 38.8135 11.5628 39.1729 11.9385C39.5322 12.3142 39.7115 12.7652 39.7109 13.2917V26.7083C39.7109 27.2354 39.5313 27.6868 39.1719 28.0625C38.8126 28.4381 38.3812 28.6256 37.8776 28.625H25.0443ZM25.9609 24.7917H36.9609L33.5234 20L30.7734 23.8333L28.7109 20.9583L25.9609 24.7917Z", fill: "#FFD59D" }), /* @__PURE__ */ v.createElement("rect", { x: 10, y: 32.625, width: 42.9282, height: 2.63846, fill: "black", fillOpacity: 0.08 }));
function tne({
  backgroundType: e,
  backgroundImage: t,
  canvasShape: n
}) {
  const r = nt().plugins.dropzoneImage.backgroundType;
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx("div", { className: "py-6 text-center text-gray-500", children: r.description }),
    /* @__PURE__ */ c.jsxs("div", { className: "flex justify-center gap-6", children: [
      /* @__PURE__ */ c.jsx(
        ef,
        {
          onClick: () => {
            e.set(nf.Image), t.defined || t.create({ plugin: Y.Image }), n.set(zo.Unset);
          },
          icon: /* @__PURE__ */ c.jsx(ene, {}),
          title: r.image,
          dataQa: "plugin-dropzone-image-background-type-select-image"
        }
      ),
      /* @__PURE__ */ c.jsx(
        ef,
        {
          onClick: () => {
            e.set(nf.Blank), n.set(zo.Unset);
          },
          icon: /* @__PURE__ */ c.jsx(uO, {}),
          title: r.blank,
          dataQa: "plugin-dropzone-image-background-type-select-blank"
        }
      )
    ] })
  ] });
}
function Il(e, t) {
  const n = t / e;
  return Math.round((n + Number.EPSILON) * 1e4) / 1e4;
}
var oy = { exports: {} }, Rf = {}, o2 = { exports: {} }, cO = {}, dO = { exports: {} }, nne = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", rne = nne, ine = rne;
function pO() {
}
function fO() {
}
fO.resetWarningCache = pO;
var one = function() {
  function e(r, i, o, a, s, l) {
    if (l !== ine) {
      var u = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      throw u.name = "Invariant Violation", u;
    }
  }
  e.isRequired = e;
  function t() {
    return e;
  }
  var n = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: fO,
    resetWarningCache: pO
  };
  return n.PropTypes = n, n;
};
dO.exports = one();
var a2 = dO.exports;
function hO(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = hO(e[t])) && (r && (r += " "), r += n);
  else for (t in e) e[t] && (r && (r += " "), r += t);
  return r;
}
function Iw() {
  for (var e, t, n = 0, r = ""; n < arguments.length; ) (e = arguments[n++]) && (t = hO(e)) && (r && (r += " "), r += t);
  return r;
}
const ane = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx: Iw,
  default: Iw
}, Symbol.toStringTag, { value: "Module" })), sne = /* @__PURE__ */ DP(ane);
var vr = {}, gs = {};
Object.defineProperty(gs, "__esModule", {
  value: !0
});
gs.dontSetMe = pne;
gs.findInArray = lne;
gs.int = dne;
gs.isFunction = une;
gs.isNum = cne;
function lne(e, t) {
  for (let n = 0, r = e.length; n < r; n++)
    if (t.apply(t, [e[n], n, e])) return e[n];
}
function une(e) {
  return typeof e == "function" || Object.prototype.toString.call(e) === "[object Function]";
}
function cne(e) {
  return typeof e == "number" && !isNaN(e);
}
function dne(e) {
  return parseInt(e, 10);
}
function pne(e, t, n) {
  if (e[t])
    return new Error("Invalid prop ".concat(t, " passed to ").concat(n, " - do not set this, set it on the child."));
}
var Rc = {};
Object.defineProperty(Rc, "__esModule", {
  value: !0
});
Rc.browserPrefixToKey = gO;
Rc.browserPrefixToStyle = fne;
Rc.default = void 0;
Rc.getPrefix = mO;
const U4 = ["Moz", "Webkit", "O", "ms"];
function mO() {
  var e;
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
  if (typeof window > "u") return "";
  const n = (e = window.document) === null || e === void 0 || (e = e.documentElement) === null || e === void 0 ? void 0 : e.style;
  if (!n || t in n) return "";
  for (let r = 0; r < U4.length; r++)
    if (gO(t, U4[r]) in n) return U4[r];
  return "";
}
function gO(e, t) {
  return t ? "".concat(t).concat(hne(e)) : e;
}
function fne(e, t) {
  return t ? "-".concat(t.toLowerCase(), "-").concat(e) : e;
}
function hne(e) {
  let t = "", n = !0;
  for (let r = 0; r < e.length; r++)
    n ? (t += e[r].toUpperCase(), n = !1) : e[r] === "-" ? n = !0 : t += e[r];
  return t;
}
Rc.default = mO();
Object.defineProperty(vr, "__esModule", {
  value: !0
});
vr.addClassName = xO;
vr.addEvent = vne;
vr.addUserSelectStyles = Tne;
vr.createCSSTransform = Ene;
vr.createSVGTransform = Sne;
vr.getTouch = Dne;
vr.getTouchIdentifier = Ane;
vr.getTranslation = ay;
vr.innerHeight = wne;
vr.innerWidth = Cne;
vr.matchesSelector = yO;
vr.matchesSelectorAndParentsTo = gne;
vr.offsetXYFromParent = kne;
vr.outerHeight = xne;
vr.outerWidth = bne;
vr.removeClassName = bO;
vr.removeEvent = yne;
vr.removeUserSelectStyles = jne;
var Fo = gs, Rw = mne(Rc);
function vO(e) {
  if (typeof WeakMap != "function") return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (vO = function(r) {
    return r ? n : t;
  })(e);
}
function mne(e, t) {
  if (e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = vO(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in e)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
      var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
      a && (a.get || a.set) ? Object.defineProperty(r, o, a) : r[o] = e[o];
    }
  return r.default = e, n && n.set(e, r), r;
}
let Vh = "";
function yO(e, t) {
  return Vh || (Vh = (0, Fo.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(n) {
    return (0, Fo.isFunction)(e[n]);
  })), (0, Fo.isFunction)(e[Vh]) ? e[Vh](t) : !1;
}
function gne(e, t, n) {
  let r = e;
  do {
    if (yO(r, t)) return !0;
    if (r === n) return !1;
    r = r.parentNode;
  } while (r);
  return !1;
}
function vne(e, t, n, r) {
  if (!e) return;
  const i = {
    capture: !0,
    ...r
  };
  e.addEventListener ? e.addEventListener(t, n, i) : e.attachEvent ? e.attachEvent("on" + t, n) : e["on" + t] = n;
}
function yne(e, t, n, r) {
  if (!e) return;
  const i = {
    capture: !0,
    ...r
  };
  e.removeEventListener ? e.removeEventListener(t, n, i) : e.detachEvent ? e.detachEvent("on" + t, n) : e["on" + t] = null;
}
function xne(e) {
  let t = e.clientHeight;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t += (0, Fo.int)(n.borderTopWidth), t += (0, Fo.int)(n.borderBottomWidth), t;
}
function bne(e) {
  let t = e.clientWidth;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t += (0, Fo.int)(n.borderLeftWidth), t += (0, Fo.int)(n.borderRightWidth), t;
}
function wne(e) {
  let t = e.clientHeight;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t -= (0, Fo.int)(n.paddingTop), t -= (0, Fo.int)(n.paddingBottom), t;
}
function Cne(e) {
  let t = e.clientWidth;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t -= (0, Fo.int)(n.paddingLeft), t -= (0, Fo.int)(n.paddingRight), t;
}
function kne(e, t, n) {
  const r = t === t.ownerDocument.body ? {
    left: 0,
    top: 0
  } : t.getBoundingClientRect(), i = (e.clientX + t.scrollLeft - r.left) / n, o = (e.clientY + t.scrollTop - r.top) / n;
  return {
    x: i,
    y: o
  };
}
function Ene(e, t) {
  const n = ay(e, t, "px");
  return {
    [(0, Rw.browserPrefixToKey)("transform", Rw.default)]: n
  };
}
function Sne(e, t) {
  return ay(e, t, "");
}
function ay(e, t, n) {
  let {
    x: r,
    y: i
  } = e, o = "translate(".concat(r).concat(n, ",").concat(i).concat(n, ")");
  if (t) {
    const a = "".concat(typeof t.x == "string" ? t.x : t.x + n), s = "".concat(typeof t.y == "string" ? t.y : t.y + n);
    o = "translate(".concat(a, ", ").concat(s, ")") + o;
  }
  return o;
}
function Dne(e, t) {
  return e.targetTouches && (0, Fo.findInArray)(e.targetTouches, (n) => t === n.identifier) || e.changedTouches && (0, Fo.findInArray)(e.changedTouches, (n) => t === n.identifier);
}
function Ane(e) {
  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
function Tne(e) {
  if (!e) return;
  let t = e.getElementById("react-draggable-style-el");
  t || (t = e.createElement("style"), t.type = "text/css", t.id = "react-draggable-style-el", t.innerHTML = `.react-draggable-transparent-selection *::-moz-selection {all: inherit;}
`, t.innerHTML += `.react-draggable-transparent-selection *::selection {all: inherit;}
`, e.getElementsByTagName("head")[0].appendChild(t)), e.body && xO(e.body, "react-draggable-transparent-selection");
}
function jne(e) {
  if (e)
    try {
      if (e.body && bO(e.body, "react-draggable-transparent-selection"), e.selection)
        e.selection.empty();
      else {
        const t = (e.defaultView || window).getSelection();
        t && t.type !== "Caret" && t.removeAllRanges();
      }
    } catch {
    }
}
function xO(e, t) {
  e.classList ? e.classList.add(t) : e.className.match(new RegExp("(?:^|\\s)".concat(t, "(?!\\S)"))) || (e.className += " ".concat(t));
}
function bO(e, t) {
  e.classList ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(?:^|\\s)".concat(t, "(?!\\S)"), "g"), "");
}
var vs = {};
Object.defineProperty(vs, "__esModule", {
  value: !0
});
vs.canDragX = zne;
vs.canDragY = Fne;
vs.createCoreData = Mne;
vs.createDraggableData = Bne;
vs.getBoundPosition = Nne;
vs.getControlPosition = Lne;
vs.snapToGrid = One;
var bo = gs, x0 = vr;
function Nne(e, t, n) {
  if (!e.props.bounds) return [t, n];
  let {
    bounds: r
  } = e.props;
  r = typeof r == "string" ? r : Ine(r);
  const i = sy(e);
  if (typeof r == "string") {
    const {
      ownerDocument: o
    } = i, a = o.defaultView;
    let s;
    if (r === "parent" ? s = i.parentNode : s = o.querySelector(r), !(s instanceof a.HTMLElement))
      throw new Error('Bounds selector "' + r + '" could not find an element.');
    const l = s, u = a.getComputedStyle(i), d = a.getComputedStyle(l);
    r = {
      left: -i.offsetLeft + (0, bo.int)(d.paddingLeft) + (0, bo.int)(u.marginLeft),
      top: -i.offsetTop + (0, bo.int)(d.paddingTop) + (0, bo.int)(u.marginTop),
      right: (0, x0.innerWidth)(l) - (0, x0.outerWidth)(i) - i.offsetLeft + (0, bo.int)(d.paddingRight) - (0, bo.int)(u.marginRight),
      bottom: (0, x0.innerHeight)(l) - (0, x0.outerHeight)(i) - i.offsetTop + (0, bo.int)(d.paddingBottom) - (0, bo.int)(u.marginBottom)
    };
  }
  return (0, bo.isNum)(r.right) && (t = Math.min(t, r.right)), (0, bo.isNum)(r.bottom) && (n = Math.min(n, r.bottom)), (0, bo.isNum)(r.left) && (t = Math.max(t, r.left)), (0, bo.isNum)(r.top) && (n = Math.max(n, r.top)), [t, n];
}
function One(e, t, n) {
  const r = Math.round(t / e[0]) * e[0], i = Math.round(n / e[1]) * e[1];
  return [r, i];
}
function zne(e) {
  return e.props.axis === "both" || e.props.axis === "x";
}
function Fne(e) {
  return e.props.axis === "both" || e.props.axis === "y";
}
function Lne(e, t, n) {
  const r = typeof t == "number" ? (0, x0.getTouch)(e, t) : null;
  if (typeof t == "number" && !r) return null;
  const i = sy(n), o = n.props.offsetParent || i.offsetParent || i.ownerDocument.body;
  return (0, x0.offsetXYFromParent)(r || e, o, n.props.scale);
}
function Mne(e, t, n) {
  const r = !(0, bo.isNum)(e.lastX), i = sy(e);
  return r ? {
    node: i,
    deltaX: 0,
    deltaY: 0,
    lastX: t,
    lastY: n,
    x: t,
    y: n
  } : {
    node: i,
    deltaX: t - e.lastX,
    deltaY: n - e.lastY,
    lastX: e.lastX,
    lastY: e.lastY,
    x: t,
    y: n
  };
}
function Bne(e, t) {
  const n = e.props.scale;
  return {
    node: t.node,
    x: e.state.x + t.deltaX / n,
    y: e.state.y + t.deltaY / n,
    deltaX: t.deltaX / n,
    deltaY: t.deltaY / n,
    lastX: e.state.x,
    lastY: e.state.y
  };
}
function Ine(e) {
  return {
    left: e.left,
    top: e.top,
    right: e.right,
    bottom: e.bottom
  };
}
function sy(e) {
  const t = e.findDOMNode();
  if (!t)
    throw new Error("<DraggableCore>: Unmounted during event!");
  return t;
}
var s2 = {}, l2 = {};
Object.defineProperty(l2, "__esModule", {
  value: !0
});
l2.default = Rne;
function Rne() {
}
Object.defineProperty(s2, "__esModule", {
  value: !0
});
s2.default = void 0;
var W4 = _ne(dt), Ui = ly(a2), Pne = ly(Cf), hi = vr, Tl = vs, Z4 = gs, Hd = ly(l2);
function ly(e) {
  return e && e.__esModule ? e : { default: e };
}
function wO(e) {
  if (typeof WeakMap != "function") return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (wO = function(r) {
    return r ? n : t;
  })(e);
}
function _ne(e, t) {
  if (e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = wO(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in e)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
      var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
      a && (a.get || a.set) ? Object.defineProperty(r, o, a) : r[o] = e[o];
    }
  return r.default = e, n && n.set(e, r), r;
}
function Ti(e, t, n) {
  return t = qne(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function qne(e) {
  var t = $ne(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function $ne(e, t) {
  if (typeof e != "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const ja = {
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  }
};
let jl = ja.mouse, u2 = class extends W4.Component {
  constructor() {
    super(...arguments), Ti(this, "dragging", !1), Ti(this, "lastX", NaN), Ti(this, "lastY", NaN), Ti(this, "touchIdentifier", null), Ti(this, "mounted", !1), Ti(this, "handleDragStart", (e) => {
      if (this.props.onMouseDown(e), !this.props.allowAnyClick && typeof e.button == "number" && e.button !== 0) return !1;
      const t = this.findDOMNode();
      if (!t || !t.ownerDocument || !t.ownerDocument.body)
        throw new Error("<DraggableCore> not mounted on DragStart!");
      const {
        ownerDocument: n
      } = t;
      if (this.props.disabled || !(e.target instanceof n.defaultView.Node) || this.props.handle && !(0, hi.matchesSelectorAndParentsTo)(e.target, this.props.handle, t) || this.props.cancel && (0, hi.matchesSelectorAndParentsTo)(e.target, this.props.cancel, t))
        return;
      e.type === "touchstart" && e.preventDefault();
      const r = (0, hi.getTouchIdentifier)(e);
      this.touchIdentifier = r;
      const i = (0, Tl.getControlPosition)(e, r, this);
      if (i == null) return;
      const {
        x: o,
        y: a
      } = i, s = (0, Tl.createCoreData)(this, o, a);
      (0, Hd.default)("DraggableCore: handleDragStart: %j", s), (0, Hd.default)("calling", this.props.onStart), !(this.props.onStart(e, s) === !1 || this.mounted === !1) && (this.props.enableUserSelectHack && (0, hi.addUserSelectStyles)(n), this.dragging = !0, this.lastX = o, this.lastY = a, (0, hi.addEvent)(n, jl.move, this.handleDrag), (0, hi.addEvent)(n, jl.stop, this.handleDragStop));
    }), Ti(this, "handleDrag", (e) => {
      const t = (0, Tl.getControlPosition)(e, this.touchIdentifier, this);
      if (t == null) return;
      let {
        x: n,
        y: r
      } = t;
      if (Array.isArray(this.props.grid)) {
        let o = n - this.lastX, a = r - this.lastY;
        if ([o, a] = (0, Tl.snapToGrid)(this.props.grid, o, a), !o && !a) return;
        n = this.lastX + o, r = this.lastY + a;
      }
      const i = (0, Tl.createCoreData)(this, n, r);
      if ((0, Hd.default)("DraggableCore: handleDrag: %j", i), this.props.onDrag(e, i) === !1 || this.mounted === !1) {
        try {
          this.handleDragStop(new MouseEvent("mouseup"));
        } catch {
          const o = document.createEvent("MouseEvents");
          o.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), this.handleDragStop(o);
        }
        return;
      }
      this.lastX = n, this.lastY = r;
    }), Ti(this, "handleDragStop", (e) => {
      if (!this.dragging) return;
      const t = (0, Tl.getControlPosition)(e, this.touchIdentifier, this);
      if (t == null) return;
      let {
        x: n,
        y: r
      } = t;
      if (Array.isArray(this.props.grid)) {
        let a = n - this.lastX || 0, s = r - this.lastY || 0;
        [a, s] = (0, Tl.snapToGrid)(this.props.grid, a, s), n = this.lastX + a, r = this.lastY + s;
      }
      const i = (0, Tl.createCoreData)(this, n, r);
      if (this.props.onStop(e, i) === !1 || this.mounted === !1) return !1;
      const o = this.findDOMNode();
      o && this.props.enableUserSelectHack && (0, hi.removeUserSelectStyles)(o.ownerDocument), (0, Hd.default)("DraggableCore: handleDragStop: %j", i), this.dragging = !1, this.lastX = NaN, this.lastY = NaN, o && ((0, Hd.default)("DraggableCore: Removing handlers"), (0, hi.removeEvent)(o.ownerDocument, jl.move, this.handleDrag), (0, hi.removeEvent)(o.ownerDocument, jl.stop, this.handleDragStop));
    }), Ti(this, "onMouseDown", (e) => (jl = ja.mouse, this.handleDragStart(e))), Ti(this, "onMouseUp", (e) => (jl = ja.mouse, this.handleDragStop(e))), Ti(this, "onTouchStart", (e) => (jl = ja.touch, this.handleDragStart(e))), Ti(this, "onTouchEnd", (e) => (jl = ja.touch, this.handleDragStop(e)));
  }
  componentDidMount() {
    this.mounted = !0;
    const e = this.findDOMNode();
    e && (0, hi.addEvent)(e, ja.touch.start, this.onTouchStart, {
      passive: !1
    });
  }
  componentWillUnmount() {
    this.mounted = !1;
    const e = this.findDOMNode();
    if (e) {
      const {
        ownerDocument: t
      } = e;
      (0, hi.removeEvent)(t, ja.mouse.move, this.handleDrag), (0, hi.removeEvent)(t, ja.touch.move, this.handleDrag), (0, hi.removeEvent)(t, ja.mouse.stop, this.handleDragStop), (0, hi.removeEvent)(t, ja.touch.stop, this.handleDragStop), (0, hi.removeEvent)(e, ja.touch.start, this.onTouchStart, {
        passive: !1
      }), this.props.enableUserSelectHack && (0, hi.removeUserSelectStyles)(t);
    }
  }
  // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
  // the underlying DOM node ourselves. See the README for more information.
  findDOMNode() {
    var e, t;
    return (e = this.props) !== null && e !== void 0 && e.nodeRef ? (t = this.props) === null || t === void 0 || (t = t.nodeRef) === null || t === void 0 ? void 0 : t.current : Pne.default.findDOMNode(this);
  }
  render() {
    return /* @__PURE__ */ W4.cloneElement(W4.Children.only(this.props.children), {
      // Note: mouseMove handler is attached to document so it will still function
      // when the user drags quickly and leaves the bounds of the element.
      onMouseDown: this.onMouseDown,
      onMouseUp: this.onMouseUp,
      // onTouchStart is added on `componentDidMount` so they can be added with
      // {passive: false}, which allows it to cancel. See
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention
      onTouchEnd: this.onTouchEnd
    });
  }
};
s2.default = u2;
Ti(u2, "displayName", "DraggableCore");
Ti(u2, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: Ui.default.bool,
  children: Ui.default.node.isRequired,
  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: Ui.default.bool,
  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: Ui.default.bool,
  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function(e, t) {
    if (e[t] && e[t].nodeType !== 1)
      throw new Error("Draggable's offsetParent must be a DOM Node.");
  },
  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: Ui.default.arrayOf(Ui.default.number),
  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: Ui.default.string,
  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: Ui.default.string,
  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: Ui.default.object,
  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: Ui.default.func,
  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: Ui.default.func,
  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: Ui.default.func,
  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: Ui.default.func,
  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: Ui.default.number,
  /**
   * These properties should be defined on the child, not here.
   */
  className: Z4.dontSetMe,
  style: Z4.dontSetMe,
  transform: Z4.dontSetMe
});
Ti(u2, "defaultProps", {
  allowAnyClick: !1,
  // by default only accept left click
  disabled: !1,
  enableUserSelectHack: !0,
  onStart: function() {
  },
  onDrag: function() {
  },
  onStop: function() {
  },
  onMouseDown: function() {
  },
  scale: 1
});
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "DraggableCore", {
    enumerable: !0,
    get: function() {
      return l.default;
    }
  }), e.default = void 0;
  var t = f(dt), n = d(a2), r = d(Cf), i = d(sne), o = vr, a = vs, s = gs, l = d(s2), u = d(l2);
  function d(b) {
    return b && b.__esModule ? b : { default: b };
  }
  function p(b) {
    if (typeof WeakMap != "function") return null;
    var C = /* @__PURE__ */ new WeakMap(), T = /* @__PURE__ */ new WeakMap();
    return (p = function(z) {
      return z ? T : C;
    })(b);
  }
  function f(b, C) {
    if (b && b.__esModule)
      return b;
    if (b === null || typeof b != "object" && typeof b != "function")
      return { default: b };
    var T = p(C);
    if (T && T.has(b))
      return T.get(b);
    var z = {}, I = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in b)
      if (w !== "default" && Object.prototype.hasOwnProperty.call(b, w)) {
        var M = I ? Object.getOwnPropertyDescriptor(b, w) : null;
        M && (M.get || M.set) ? Object.defineProperty(z, w, M) : z[w] = b[w];
      }
    return z.default = b, T && T.set(b, z), z;
  }
  function m() {
    return m = Object.assign ? Object.assign.bind() : function(b) {
      for (var C = 1; C < arguments.length; C++) {
        var T = arguments[C];
        for (var z in T)
          Object.prototype.hasOwnProperty.call(T, z) && (b[z] = T[z]);
      }
      return b;
    }, m.apply(this, arguments);
  }
  function y(b, C, T) {
    return C = g(C), C in b ? Object.defineProperty(b, C, { value: T, enumerable: !0, configurable: !0, writable: !0 }) : b[C] = T, b;
  }
  function g(b) {
    var C = x(b, "string");
    return typeof C == "symbol" ? C : String(C);
  }
  function x(b, C) {
    if (typeof b != "object" || b === null) return b;
    var T = b[Symbol.toPrimitive];
    if (T !== void 0) {
      var z = T.call(b, C || "default");
      if (typeof z != "object") return z;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (C === "string" ? String : Number)(b);
  }
  class E extends t.Component {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(C, T) {
      let {
        position: z
      } = C, {
        prevPropsPosition: I
      } = T;
      return z && (!I || z.x !== I.x || z.y !== I.y) ? ((0, u.default)("Draggable: getDerivedStateFromProps %j", {
        position: z,
        prevPropsPosition: I
      }), {
        x: z.x,
        y: z.y,
        prevPropsPosition: {
          ...z
        }
      }) : null;
    }
    constructor(C) {
      super(C), y(this, "onDragStart", (T, z) => {
        if ((0, u.default)("Draggable: onDragStart: %j", z), this.props.onStart(T, (0, a.createDraggableData)(this, z)) === !1) return !1;
        this.setState({
          dragging: !0,
          dragged: !0
        });
      }), y(this, "onDrag", (T, z) => {
        if (!this.state.dragging) return !1;
        (0, u.default)("Draggable: onDrag: %j", z);
        const I = (0, a.createDraggableData)(this, z), w = {
          x: I.x,
          y: I.y,
          slackX: 0,
          slackY: 0
        };
        if (this.props.bounds) {
          const {
            x: M,
            y: R
          } = w;
          w.x += this.state.slackX, w.y += this.state.slackY;
          const [F, W] = (0, a.getBoundPosition)(this, w.x, w.y);
          w.x = F, w.y = W, w.slackX = this.state.slackX + (M - w.x), w.slackY = this.state.slackY + (R - w.y), I.x = w.x, I.y = w.y, I.deltaX = w.x - this.state.x, I.deltaY = w.y - this.state.y;
        }
        if (this.props.onDrag(T, I) === !1) return !1;
        this.setState(w);
      }), y(this, "onDragStop", (T, z) => {
        if (!this.state.dragging || this.props.onStop(T, (0, a.createDraggableData)(this, z)) === !1) return !1;
        (0, u.default)("Draggable: onDragStop: %j", z);
        const I = {
          dragging: !1,
          slackX: 0,
          slackY: 0
        };
        if (this.props.position) {
          const {
            x: w,
            y: M
          } = this.props.position;
          I.x = w, I.y = M;
        }
        this.setState(I);
      }), this.state = {
        // Whether or not we are currently dragging.
        dragging: !1,
        // Whether or not we have been dragged before.
        dragged: !1,
        // Current transform x and y.
        x: C.position ? C.position.x : C.defaultPosition.x,
        y: C.position ? C.position.y : C.defaultPosition.y,
        prevPropsPosition: {
          ...C.position
        },
        // Used for compensating for out-of-bounds drags
        slackX: 0,
        slackY: 0,
        // Can only determine if SVG after mounting
        isElementSVG: !1
      }, C.position && !(C.onDrag || C.onStop) && console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
      typeof window.SVGElement < "u" && this.findDOMNode() instanceof window.SVGElement && this.setState({
        isElementSVG: !0
      });
    }
    componentWillUnmount() {
      this.setState({
        dragging: !1
      });
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() {
      var C, T;
      return (C = (T = this.props) === null || T === void 0 || (T = T.nodeRef) === null || T === void 0 ? void 0 : T.current) !== null && C !== void 0 ? C : r.default.findDOMNode(this);
    }
    render() {
      const {
        axis: C,
        bounds: T,
        children: z,
        defaultPosition: I,
        defaultClassName: w,
        defaultClassNameDragging: M,
        defaultClassNameDragged: R,
        position: F,
        positionOffset: W,
        scale: X,
        ...le
      } = this.props;
      let ne = {}, fe = null;
      const D = !F || this.state.dragging, j = F || I, de = {
        // Set left if horizontal drag is enabled
        x: (0, a.canDragX)(this) && D ? this.state.x : j.x,
        // Set top if vertical drag is enabled
        y: (0, a.canDragY)(this) && D ? this.state.y : j.y
      };
      this.state.isElementSVG ? fe = (0, o.createSVGTransform)(de, W) : ne = (0, o.createCSSTransform)(de, W);
      const ye = (0, i.default)(z.props.className || "", w, {
        [M]: this.state.dragging,
        [R]: this.state.dragged
      });
      return /* @__PURE__ */ t.createElement(l.default, m({}, le, {
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop
      }), /* @__PURE__ */ t.cloneElement(t.Children.only(z), {
        className: ye,
        style: {
          ...z.props.style,
          ...ne
        },
        transform: fe
      }));
    }
  }
  e.default = E, y(E, "displayName", "Draggable"), y(E, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...l.default.propTypes,
    /**
     * `axis` determines which axis the draggable can move.
     *
     *  Note that all callbacks will still return data as normal. This only
     *  controls flushing to the DOM.
     *
     * 'both' allows movement horizontally and vertically.
     * 'x' limits movement to horizontal axis.
     * 'y' limits movement to vertical axis.
     * 'none' limits all movement.
     *
     * Defaults to 'both'.
     */
    axis: n.default.oneOf(["both", "x", "y", "none"]),
    /**
     * `bounds` determines the range of movement available to the element.
     * Available values are:
     *
     * 'parent' restricts movement within the Draggable's parent node.
     *
     * Alternatively, pass an object with the following properties, all of which are optional:
     *
     * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
     *
     * All values are in px.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable bounds={{right: 300, bottom: 300}}>
     *              <div>Content</div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    bounds: n.default.oneOfType([n.default.shape({
      left: n.default.number,
      right: n.default.number,
      top: n.default.number,
      bottom: n.default.number
    }), n.default.string, n.default.oneOf([!1])]),
    defaultClassName: n.default.string,
    defaultClassNameDragging: n.default.string,
    defaultClassNameDragged: n.default.string,
    /**
     * `defaultPosition` specifies the x and y that the dragged item should start at
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable defaultPosition={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    defaultPosition: n.default.shape({
      x: n.default.number,
      y: n.default.number
    }),
    positionOffset: n.default.shape({
      x: n.default.oneOfType([n.default.number, n.default.string]),
      y: n.default.oneOfType([n.default.number, n.default.string])
    }),
    /**
     * `position`, if present, defines the current position of the element.
     *
     *  This is similar to how form elements in React work - if no `position` is supplied, the component
     *  is uncontrolled.
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable position={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    position: n.default.shape({
      x: n.default.number,
      y: n.default.number
    }),
    /**
     * These properties should be defined on the child, not here.
     */
    className: s.dontSetMe,
    style: s.dontSetMe,
    transform: s.dontSetMe
  }), y(E, "defaultProps", {
    ...l.default.defaultProps,
    axis: "both",
    bounds: !1,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
      x: 0,
      y: 0
    },
    scale: 1
  });
})(cO);
const {
  default: CO,
  DraggableCore: Hne
} = cO;
o2.exports = CO;
o2.exports.default = CO;
o2.exports.DraggableCore = Hne;
var Vne = o2.exports, uy = {};
uy.__esModule = !0;
uy.cloneElement = Xne;
var Une = Wne(dt);
function Wne(e) {
  return e && e.__esModule ? e : { default: e };
}
function Pw(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _w(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pw(Object(n), !0).forEach(function(r) {
      Zne(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pw(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Zne(e, t, n) {
  return t = Gne(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Gne(e) {
  var t = Kne(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function Kne(e, t) {
  if (typeof e != "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Xne(e, t) {
  return t.style && e.props.style && (t.style = _w(_w({}, e.props.style), t.style)), t.className && e.props.className && (t.className = e.props.className + " " + t.className), /* @__PURE__ */ Une.default.cloneElement(e, t);
}
var Pf = {};
Pf.__esModule = !0;
Pf.resizableProps = void 0;
var Jt = Qne(a2);
function Qne(e) {
  return e && e.__esModule ? e : { default: e };
}
var Yne = {
  /*
  * Restricts resizing to a particular axis (default: 'both')
  * 'both' - allows resizing by width or height
  * 'x' - only allows the width to be changed
  * 'y' - only allows the height to be changed
  * 'none' - disables resizing altogether
  * */
  axis: Jt.default.oneOf(["both", "x", "y", "none"]),
  className: Jt.default.string,
  /*
  * Require that one and only one child be present.
  * */
  children: Jt.default.element.isRequired,
  /*
  * These will be passed wholesale to react-draggable's DraggableCore
  * */
  draggableOpts: Jt.default.shape({
    allowAnyClick: Jt.default.bool,
    cancel: Jt.default.string,
    children: Jt.default.node,
    disabled: Jt.default.bool,
    enableUserSelectHack: Jt.default.bool,
    offsetParent: Jt.default.node,
    grid: Jt.default.arrayOf(Jt.default.number),
    handle: Jt.default.string,
    nodeRef: Jt.default.object,
    onStart: Jt.default.func,
    onDrag: Jt.default.func,
    onStop: Jt.default.func,
    onMouseDown: Jt.default.func,
    scale: Jt.default.number
  }),
  /*
  * Initial height
  * */
  height: function() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    var r = t[0];
    if (r.axis === "both" || r.axis === "y") {
      var i;
      return (i = Jt.default.number).isRequired.apply(i, t);
    }
    return Jt.default.number.apply(Jt.default, t);
  },
  /*
  * Customize cursor resize handle
  * */
  handle: Jt.default.oneOfType([Jt.default.node, Jt.default.func]),
  /*
  * If you change this, be sure to update your css
  * */
  handleSize: Jt.default.arrayOf(Jt.default.number),
  lockAspectRatio: Jt.default.bool,
  /*
  * Max X & Y measure
  * */
  maxConstraints: Jt.default.arrayOf(Jt.default.number),
  /*
  * Min X & Y measure
  * */
  minConstraints: Jt.default.arrayOf(Jt.default.number),
  /*
  * Called on stop resize event
  * */
  onResizeStop: Jt.default.func,
  /*
  * Called on start resize event
  * */
  onResizeStart: Jt.default.func,
  /*
  * Called on resize event
  * */
  onResize: Jt.default.func,
  /*
  * Defines which resize handles should be rendered (default: 'se')
  * 's' - South handle (bottom-center)
  * 'w' - West handle (left-center)
  * 'e' - East handle (right-center)
  * 'n' - North handle (top-center)
  * 'sw' - Southwest handle (bottom-left)
  * 'nw' - Northwest handle (top-left)
  * 'se' - Southeast handle (bottom-right)
  * 'ne' - Northeast handle (top-center)
  * */
  resizeHandles: Jt.default.arrayOf(Jt.default.oneOf(["s", "w", "e", "n", "sw", "nw", "se", "ne"])),
  /*
  * If `transform: scale(n)` is set on the parent, this should be set to `n`.
  * */
  transformScale: Jt.default.number,
  /*
   * Initial width
   */
  width: function() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    var r = t[0];
    if (r.axis === "both" || r.axis === "x") {
      var i;
      return (i = Jt.default.number).isRequired.apply(i, t);
    }
    return Jt.default.number.apply(Jt.default, t);
  }
};
Pf.resizableProps = Yne;
Rf.__esModule = !0;
Rf.default = void 0;
var Vd = rre(dt), Jne = Vne, ere = uy, tre = Pf, nre = ["children", "className", "draggableOpts", "width", "height", "handle", "handleSize", "lockAspectRatio", "axis", "minConstraints", "maxConstraints", "onResize", "onResizeStop", "onResizeStart", "resizeHandles", "transformScale"];
function kO(e) {
  if (typeof WeakMap != "function") return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (kO = function(r) {
    return r ? n : t;
  })(e);
}
function rre(e, t) {
  if (e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = kO(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in e)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
      var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
      a && (a.get || a.set) ? Object.defineProperty(r, o, a) : r[o] = e[o];
    }
  return r.default = e, n && n.set(e, r), r;
}
function p5() {
  return p5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, p5.apply(this, arguments);
}
function ire(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function qw(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function G4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qw(Object(n), !0).forEach(function(r) {
      ore(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qw(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ore(e, t, n) {
  return t = are(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function are(e) {
  var t = sre(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function sre(e, t) {
  if (typeof e != "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function lre(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, f5(e, t);
}
function f5(e, t) {
  return f5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, f5(e, t);
}
var cy = /* @__PURE__ */ function(e) {
  lre(t, e);
  function t() {
    for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return r = e.call.apply(e, [this].concat(o)) || this, r.handleRefs = {}, r.lastHandleRect = null, r.slack = null, r;
  }
  var n = t.prototype;
  return n.componentWillUnmount = function() {
    this.resetData();
  }, n.resetData = function() {
    this.lastHandleRect = this.slack = null;
  }, n.runConstraints = function(r, i) {
    var o = this.props, a = o.minConstraints, s = o.maxConstraints, l = o.lockAspectRatio;
    if (!a && !s && !l) return [r, i];
    if (l) {
      var u = this.props.width / this.props.height, d = r - this.props.width, p = i - this.props.height;
      Math.abs(d) > Math.abs(p * u) ? i = r / u : r = i * u;
    }
    var f = r, m = i, y = this.slack || [0, 0], g = y[0], x = y[1];
    return r += g, i += x, a && (r = Math.max(a[0], r), i = Math.max(a[1], i)), s && (r = Math.min(s[0], r), i = Math.min(s[1], i)), this.slack = [g + (f - r), x + (m - i)], [r, i];
  }, n.resizeHandler = function(r, i) {
    var o = this;
    return function(a, s) {
      var l = s.node, u = s.deltaX, d = s.deltaY;
      r === "onResizeStart" && o.resetData();
      var p = (o.props.axis === "both" || o.props.axis === "x") && i !== "n" && i !== "s", f = (o.props.axis === "both" || o.props.axis === "y") && i !== "e" && i !== "w";
      if (!(!p && !f)) {
        var m = i[0], y = i[i.length - 1], g = l.getBoundingClientRect();
        if (o.lastHandleRect != null) {
          if (y === "w") {
            var x = g.left - o.lastHandleRect.left;
            u += x;
          }
          if (m === "n") {
            var E = g.top - o.lastHandleRect.top;
            d += E;
          }
        }
        o.lastHandleRect = g, y === "w" && (u = -u), m === "n" && (d = -d);
        var b = o.props.width + (p ? u / o.props.transformScale : 0), C = o.props.height + (f ? d / o.props.transformScale : 0), T = o.runConstraints(b, C);
        b = T[0], C = T[1];
        var z = b !== o.props.width || C !== o.props.height, I = typeof o.props[r] == "function" ? o.props[r] : null, w = r === "onResize" && !z;
        I && !w && (a.persist == null || a.persist(), I(a, {
          node: l,
          size: {
            width: b,
            height: C
          },
          handle: i
        })), r === "onResizeStop" && o.resetData();
      }
    };
  }, n.renderResizeHandle = function(r, i) {
    var o = this.props.handle;
    if (!o)
      return /* @__PURE__ */ Vd.createElement("span", {
        className: "react-resizable-handle react-resizable-handle-" + r,
        ref: i
      });
    if (typeof o == "function")
      return o(r, i);
    var a = typeof o.type == "string", s = G4({
      ref: i
    }, a ? {} : {
      handleAxis: r
    });
    return /* @__PURE__ */ Vd.cloneElement(o, s);
  }, n.render = function() {
    var r = this, i = this.props, o = i.children, a = i.className, s = i.draggableOpts;
    i.width, i.height, i.handle, i.handleSize, i.lockAspectRatio, i.axis, i.minConstraints, i.maxConstraints, i.onResize, i.onResizeStop, i.onResizeStart;
    var l = i.resizeHandles;
    i.transformScale;
    var u = ire(i, nre);
    return (0, ere.cloneElement)(o, G4(G4({}, u), {}, {
      className: (a ? a + " " : "") + "react-resizable",
      children: [].concat(o.props.children, l.map(function(d) {
        var p, f = (p = r.handleRefs[d]) != null ? p : r.handleRefs[d] = /* @__PURE__ */ Vd.createRef();
        return /* @__PURE__ */ Vd.createElement(Jne.DraggableCore, p5({}, s, {
          nodeRef: f,
          key: "resizableHandle-" + d,
          onStop: r.resizeHandler("onResizeStop", d),
          onStart: r.resizeHandler("onResizeStart", d),
          onDrag: r.resizeHandler("onResize", d)
        }), r.renderResizeHandle(d, f));
      }))
    }));
  }, t;
}(Vd.Component);
Rf.default = cy;
cy.propTypes = tre.resizableProps;
cy.defaultProps = {
  axis: "both",
  handleSize: [20, 20],
  lockAspectRatio: !1,
  minConstraints: [20, 20],
  maxConstraints: [1 / 0, 1 / 0],
  resizeHandles: ["se"],
  transformScale: 1
};
var c2 = {};
c2.__esModule = !0;
c2.default = void 0;
var K4 = fre(dt), ure = EO(a2), cre = EO(Rf), dre = Pf, pre = ["handle", "handleSize", "onResize", "onResizeStart", "onResizeStop", "draggableOpts", "minConstraints", "maxConstraints", "lockAspectRatio", "axis", "width", "height", "resizeHandles", "style", "transformScale"];
function EO(e) {
  return e && e.__esModule ? e : { default: e };
}
function SO(e) {
  if (typeof WeakMap != "function") return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (SO = function(r) {
    return r ? n : t;
  })(e);
}
function fre(e, t) {
  if (e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = SO(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in e)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
      var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
      a && (a.get || a.set) ? Object.defineProperty(r, o, a) : r[o] = e[o];
    }
  return r.default = e, n && n.set(e, r), r;
}
function h5() {
  return h5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, h5.apply(this, arguments);
}
function $w(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Bm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $w(Object(n), !0).forEach(function(r) {
      hre(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $w(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function hre(e, t, n) {
  return t = mre(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function mre(e) {
  var t = gre(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function gre(e, t) {
  if (typeof e != "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function vre(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function yre(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, m5(e, t);
}
function m5(e, t) {
  return m5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, m5(e, t);
}
var DO = /* @__PURE__ */ function(e) {
  yre(t, e);
  function t() {
    for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return r = e.call.apply(e, [this].concat(o)) || this, r.state = {
      width: r.props.width,
      height: r.props.height,
      propsWidth: r.props.width,
      propsHeight: r.props.height
    }, r.onResize = function(s, l) {
      var u = l.size;
      r.props.onResize ? (s.persist == null || s.persist(), r.setState(u, function() {
        return r.props.onResize && r.props.onResize(s, l);
      })) : r.setState(u);
    }, r;
  }
  t.getDerivedStateFromProps = function(r, i) {
    return i.propsWidth !== r.width || i.propsHeight !== r.height ? {
      width: r.width,
      height: r.height,
      propsWidth: r.width,
      propsHeight: r.height
    } : null;
  };
  var n = t.prototype;
  return n.render = function() {
    var r = this.props, i = r.handle, o = r.handleSize;
    r.onResize;
    var a = r.onResizeStart, s = r.onResizeStop, l = r.draggableOpts, u = r.minConstraints, d = r.maxConstraints, p = r.lockAspectRatio, f = r.axis;
    r.width, r.height;
    var m = r.resizeHandles, y = r.style, g = r.transformScale, x = vre(r, pre);
    return /* @__PURE__ */ K4.createElement(cre.default, {
      axis: f,
      draggableOpts: l,
      handle: i,
      handleSize: o,
      height: this.state.height,
      lockAspectRatio: p,
      maxConstraints: d,
      minConstraints: u,
      onResizeStart: a,
      onResize: this.onResize,
      onResizeStop: s,
      resizeHandles: m,
      transformScale: g,
      width: this.state.width
    }, /* @__PURE__ */ K4.createElement("div", h5({}, x, {
      style: Bm(Bm({}, y), {}, {
        width: this.state.width + "px",
        height: this.state.height + "px"
      })
    })));
  }, t;
}(K4.Component);
c2.default = DO;
DO.propTypes = Bm(Bm({}, dre.resizableProps), {}, {
  children: ure.default.element
});
oy.exports = function() {
  throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
};
oy.exports.Resizable = Rf.default;
var xre = oy.exports.ResizableBox = c2.default;
const AO = "serlo.org";
function sl(e) {
  const t = gl();
  return /* @__PURE__ */ c.jsx("img", { ...e, src: bre(t, e.src) });
}
function bre(e, t) {
  return !e || !t || t.match(/^https:\/\/[a-z]+.(serlo|serlo-staging).(org|dev)\//) || t.startsWith("https://pixabay.com/") ? t : `https://asset-proxy.${AO}/image?url=${encodeURIComponent(t)}`;
}
const TO = v.forwardRef(function(e, t) {
  var n;
  const { blankId: r, context: i, isAnswerCorrect: o, onChange: a, onKeyDown: s, onBlur: l } = e, u = ((n = i.textInBlanks.get(r)) == null ? void 0 : n.text) ?? "";
  return /* @__PURE__ */ c.jsx(
    X7,
    {
      ref: t,
      value: u,
      className: Le(
        "h-[25px]",
        o && "border-green-500 focus:outline-green-500",
        o === !1 && "border-red-400 focus:outline-red-400"
      ),
      "data-qa": "blank-input",
      onChange: (p) => {
        d(p.target.value), a == null || a(p);
      },
      onKeyDown: s,
      onBlur: (p) => {
        d(u.trim()), l == null || l(p);
      }
    }
  );
  function d(p) {
    const f = new Map(
      i.textUserTypedIntoBlanks.value
    );
    f.set(r, { text: p }), i.textUserTypedIntoBlanks.set(f), i.isFeedbackVisible.set(!1), i.feedbackForBlanks.set(
      /* @__PURE__ */ new Map()
    );
  }
});
function wre(e) {
  const { blankId: t, children: n } = e, r = v.useContext(Qg), [{ isOver: i }, o] = cd({
    accept: Hg,
    drop: ({ draggableId: a }) => {
      if (!r) return;
      let s, l;
      const u = new Map(
        // Filtering logic for replacing/swapping already filled blanks
        [...r.locationOfDraggables.value].filter((d) => (d[0] === a && (s = d[1]), d[1] === t && (l = d[0]), d[1] !== t))
      );
      u.set(a, t), s && l && u.set(l, s), r.locationOfDraggables.set(u), r.isFeedbackVisible.set(!1), r.feedbackForBlanks.set(
        /* @__PURE__ */ new Map()
      );
    },
    collect: (a) => ({
      isOver: a.isOver()
    })
  });
  return /* @__PURE__ */ c.jsxs(
    "span",
    {
      className: Le(
        "relative rounded-full border",
        !n && "border-brand bg-brand-50 px-6 text-brand-50",
        i && "bg-slate-400 text-slate-400"
      ),
      ref: o,
      children: [
        n || "_",
        n && i ? /* @__PURE__ */ c.jsx("span", { className: "absolute bottom-0 left-[1px] right-[1px] top-0 block rounded-full bg-slate-400 opacity-80" }) : null
      ]
    }
  );
}
function Cre({ blankId: e }) {
  var t;
  const n = v.useContext(Qg);
  if (n === null) return null;
  const r = [...n.locationOfDraggables.value].find(
    (u) => u[1] === e
  ), i = (r == null ? void 0 : r[0]) ?? null, o = n.draggables.find(
    (u) => u.draggableId === i
  ), a = (o == null ? void 0 : o.text) ?? "", s = (t = n.feedbackForBlanks.value.get(e)) == null ? void 0 : t.isCorrect;
  function l() {
    n == null || n.isFeedbackVisible.set(!1);
  }
  return n.mode === "typing" ? /* @__PURE__ */ c.jsx(
    TO,
    {
      blankId: e,
      context: n,
      isAnswerCorrect: s,
      onChange: l
    }
  ) : /* @__PURE__ */ c.jsx(wre, { blankId: e, children: i ? /* @__PURE__ */ c.jsx(
    ij,
    {
      text: a,
      draggableId: i,
      isAnswerCorrect: s
    }
  ) : null });
}
const Im = [
  { value: "#1794c1", name: "Blue" },
  { value: "#006400", name: "Green" },
  { value: "#ff6600", name: "Orange" }
];
function jO({
  attributes: e,
  leaf: t,
  children: n
}) {
  const r = Im.map(({ value: l }) => l), i = {};
  t.color !== void 0 && (i.color = r[t.color]), t.em && (i.fontStyle = "italic"), t.strong && (i.fontWeight = "bold");
  const o = Object.keys(i).length, a = t.strong ? "b" : t.em ? "i" : t.code ? "code" : "span";
  if (o === 0 && a === "span") return /* @__PURE__ */ c.jsx(c.Fragment, { children: n });
  const s = o > 1 || a === "span";
  return /* @__PURE__ */ c.jsx(
    a,
    {
      style: s ? i : {},
      ...e,
      className: t.code ? "rounded-sm bg-brand-100 p-1 text-base text-brand" : void 0,
      children: n
    }
  );
}
var ur = /* @__PURE__ */ ((e) => (e.UNORDERED_LIST = "unordered-list", e.ORDERED_LIST = "ordered-list", e.LIST_ITEM = "list-item", e.LIST_ITEM_TEXT = "list-item-child", e))(ur || {});
function Ki({
  element: e
}) {
  var t;
  if (Array.isArray(e))
    return /* @__PURE__ */ c.jsx(c.Fragment, { children: e.map((n, r) => /* @__PURE__ */ c.jsx(Ki, { element: n }, r)) });
  if (Object.hasOwn(e, "type")) {
    const { children: n } = e;
    if (e.type === "h") {
      const r = [
        "serlo-h1",
        "serlo-h2",
        "serlo-h3",
        "serlo-p font-bold mb-0 mt-4"
        // h4 fallback
      ];
      return v.createElement(
        `h${e.level}`,
        { className: r[e.level - 1] },
        /* @__PURE__ */ c.jsx(c.Fragment, { children: /* @__PURE__ */ c.jsx(Ki, { element: n }) })
      );
    }
    if (e.type === "a") {
      const r = hu.getLinkRenderer();
      return /* @__PURE__ */ c.jsx(r, { href: e.href, children: /* @__PURE__ */ c.jsx(Ki, { element: n }) });
    }
    if (e.type === ur.UNORDERED_LIST)
      return /* @__PURE__ */ c.jsx("ul", { className: "serlo-ul", children: /* @__PURE__ */ c.jsx(Ki, { element: n }) });
    if (e.type === ur.ORDERED_LIST)
      return /* @__PURE__ */ c.jsx("ol", { className: "serlo-ol", children: /* @__PURE__ */ c.jsx(Ki, { element: n }) });
    if (e.type === ur.LIST_ITEM)
      return /* @__PURE__ */ c.jsx("li", { children: /* @__PURE__ */ c.jsx(Ki, { element: n }) });
    if (e.type === ur.LIST_ITEM_TEXT) {
      const r = n.length === 1 && Object.hasOwn(n[0], "type") ? n[0] : void 0, i = (r == null ? void 0 : r.type) === "p" ? r.children : n;
      return /* @__PURE__ */ c.jsx("p", { className: "slate-p serlo-p mb-0 ml-0 min-h-[1.33em]", children: /* @__PURE__ */ c.jsx(Ki, { element: i }) });
    }
    if (e.type === "math") {
      const r = hu.getMathRenderer();
      return /* @__PURE__ */ c.jsx(r, { ...e });
    }
    return e.type === "textBlank" ? e.correctAnswers.at(0) === void 0 || ((t = e.correctAnswers.at(0)) == null ? void 0 : t.answer.trim().length) === 0 ? null : /* @__PURE__ */ c.jsx(Cre, { blankId: e.blankId }) : e.children.length === 1 && Object.hasOwn(e.children[0], "type") && e.children[0].type === "math" && e.children[0].inline === !1 ? /* @__PURE__ */ c.jsx(Ki, { element: n }) : /* @__PURE__ */ c.jsx("p", { className: "slate-p serlo-p mb-0 min-h-[1.33em]", children: /* @__PURE__ */ c.jsx(Ki, { element: n }) });
  }
  return /* @__PURE__ */ c.jsx(jO, { leaf: e, children: e.text });
}
function NO(e) {
  const { url: t, text: n, className: r } = e;
  return t ? /* @__PURE__ */ c.jsx(
    sl,
    {
      "data-qa": "plugin-dropzone-image-answer-content-image",
      src: t,
      className: Le("h-full w-full object-contain", r)
    }
  ) : n ? /* @__PURE__ */ c.jsx(
    "div",
    {
      "data-qa": "plugin-dropzone-image-answer-content-text",
      className: Le(
        "mx-0 block rounded-full border border-brand px-2",
        "[&>p]:mx-1 [&>p]:sm:mx-2 [&>p]:md:mx-4",
        "[&>p]:text-xs [&>p]:sm:text-base [&>p]:md:text-lg",
        r
      ),
      children: /* @__PURE__ */ c.jsx(Ki, { element: n })
    }
  ) : null;
}
const rf = {
  left: 0.05,
  top: 0.05
}, g5 = {
  width: 0.2,
  height: 0.1
}, kre = (e, t) => {
  const n = li(
    t(),
    e
  );
  return Bf(n) ? n.state : "";
}, OO = (e, t) => {
  const n = li(
    t(),
    e
  );
  return Bf(n) ? n.state.src : "";
}, dy = (e, t) => {
  const n = li(
    t(),
    e
  );
  return e2(n) ? n.state : void 0;
}, zO = (e, t) => {
  const n = e.image.id, r = OO(n, t), i = e.text.id, o = dy(i, t);
  return { id: n, imageUrl: r, text: o };
}, X4 = (e) => e.map((t) => {
  var n;
  const r = Bf(t.image) ? ((n = t.image.state) == null ? void 0 : n.src).toString() : "", i = e2(t.text) ? t.text.state : void 0;
  return { id: t.id, text: i, imageUrl: r };
});
function FO(e, t, n) {
  const r = e.find((a) => a.id.value === t);
  if (!r) return;
  const i = e.length, o = {
    id: `answerZone-${i}`,
    name: r.name.value,
    position: {
      left: r.position.left.value + rf.left,
      top: r.position.top.value + rf.top
    },
    layout: {
      width: r.layout.width.value,
      height: r.layout.height.value
    },
    answers: r.answers.map((a) => ({
      id: fa(),
      image: {
        plugin: Y.Image,
        state: kre(a.image.id, n)
      },
      text: {
        plugin: Y.Text,
        state: dy(a.text.id, n)
      }
    }))
  };
  e.insert(i, o);
}
function Ere(e) {
  const t = e.length;
  e.insert(t, {
    id: `answerZone-${t}`,
    name: "",
    position: rf,
    layout: g5,
    answers: []
  });
}
function Sre(e) {
  const t = zn(), { answer: n, isOnlyAnswer: r, onEditAnswer: i, onRemoveAnswer: o } = e, a = nt().plugins.dropzoneImage, s = OO(
    n.image.id,
    () => t.getState()
  ), l = dy(n.text.id, () => t.getState());
  return /* @__PURE__ */ c.jsxs(
    "div",
    {
      className: Le(
        "group/edit relative",
        Dre(s, r),
        Are(s, r)
      ),
      children: [
        /* @__PURE__ */ c.jsxs(
          "div",
          {
            className: Le(`
          absolute bottom-0 left-0 right-0 top-0 mx-1 hidden h-full
          items-center justify-center rounded-full group-hover/edit:flex
        `),
            children: [
              /* @__PURE__ */ c.jsxs(
                "button",
                {
                  onClick: () => {
                    i(s ? lu.Image : lu.Text);
                  },
                  className: "serlo-button-edit-secondary serlo-tooltip-trigger z-10 mx-1 h-6 w-6 p-0",
                  children: [
                    /* @__PURE__ */ c.jsx(ot, { icon: W0, className: "text-xs" }),
                    /* @__PURE__ */ c.jsx(
                      vn,
                      {
                        text: a.answers.edit,
                        className: "!-ml-2 !pb-2"
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ c.jsxs(
                "button",
                {
                  "data-qa": `answer-zone-${n.id.value}-remove-answer-button`,
                  onClick: o,
                  className: "serlo-button-edit-secondary serlo-tooltip-trigger z-10 mx-1 h-6 w-6 p-0",
                  children: [
                    /* @__PURE__ */ c.jsx(ot, { icon: ld, className: "text-xs" }),
                    /* @__PURE__ */ c.jsx(
                      vn,
                      {
                        text: a.answers.remove,
                        className: "!-ml-2 !pb-2"
                      }
                    )
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ c.jsx(
          NO,
          {
            url: s,
            text: l,
            className: Tre(s, r)
          }
        )
      ]
    }
  );
}
function Dre(e, t) {
  return e ? t ? "h-full object-contain" : "h-16 object-contain" : "";
}
function Are(e, t) {
  return e && t ? "" : "border-3 border-transparent";
}
function Tre(e, t) {
  return t ? "" : e ? "rounded border border-brand" : "";
}
const jre = (e) => {
  const { answerZoneId: t, onClickSettingsButton: n, onClickPlusButton: r } = e, i = nt().plugins.dropzoneImage;
  return /* @__PURE__ */ c.jsxs("div", { className: "absolute inset-0 flex items-center justify-center", children: [
    /* @__PURE__ */ c.jsxs(
      "button",
      {
        className: "serlo-tooltip-trigger absolute right-[2%] top-[4%] rounded bg-orange-100 px-1 pb-0 pt-1",
        onClick: () => n(t),
        children: [
          /* @__PURE__ */ c.jsx(
            vn,
            {
              text: i.answers.settings,
              className: "-ml-5 !pb-1"
            }
          ),
          /* @__PURE__ */ c.jsx(ot, { icon: jf })
        ]
      }
    ),
    /* @__PURE__ */ c.jsxs(
      "button",
      {
        className: "serlo-tooltip-trigger rounded bg-orange-100 px-3 pb-1 pt-2",
        onClick: () => r(t),
        "data-qa": `answer-zone-${t}-add-answer-button`,
        children: [
          /* @__PURE__ */ c.jsx(
            vn,
            {
              text: i.answers.add,
              className: "-ml-5 !pb-1"
            }
          ),
          /* @__PURE__ */ c.jsx(ot, { icon: Dc })
        ]
      }
    )
  ] });
}, Nre = (e) => {
  const { answerZoneId: t, onClickSettingsButton: n, onClickPlusButton: r } = e, i = nt().plugins.dropzoneImage;
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsxs(
      "button",
      {
        className: Le(`
          serlo-tooltip-trigger absolute right-[3%] top-[5%] z-10 aspect-square
          w-[10%] min-w-5 max-w-12 rounded bg-orange-100 p-1 text-[0.5rem]
        `),
        onClick: () => r(t),
        "data-qa": `answer-zone-${t}-add-another-answer-button`,
        children: [
          /* @__PURE__ */ c.jsx(
            vn,
            {
              text: i.answers.add,
              className: "-ml-5 !pb-1"
            }
          ),
          /* @__PURE__ */ c.jsx(ot, { icon: Dc, className: "h-[90%] w-[90%]" })
        ]
      }
    ),
    /* @__PURE__ */ c.jsxs(
      "button",
      {
        className: Le(`
          serlo-tooltip-trigger absolute bottom-[5%] right-[3%] z-10 hidden aspect-square
          w-[10%] min-w-5 max-w-12 rounded bg-orange-100 p-1 text-[0.5rem] group-hover:block
        `),
        onClick: () => n(t),
        "data-qa": `answer-zone-${t}-settings-button`,
        children: [
          /* @__PURE__ */ c.jsx(
            vn,
            {
              text: i.answers.settings,
              className: "-ml-5 !pb-1"
            }
          ),
          /* @__PURE__ */ c.jsx(ot, { icon: jf, className: "h-[90%] w-[90%]" })
        ]
      }
    )
  ] });
}, Ore = ["ne", "se", "sw", "nw"], zre = (e) => {
  const { answerZone: t, canvasSize: n } = e, [r, i] = n, o = t.position.left.value, a = t.position.top.value, s = t.layout.height.value, l = t.layout.width.value, [u, d] = v.useState({
    left: r * o,
    top: i * a,
    width: r * l,
    height: i * s
  }), p = Math.max(i * 0.2, 110), f = Math.max(i * 0.09, 45), m = v.useMemo(
    () => [p, f],
    [f, p]
  );
  v.useEffect(() => {
    d((x) => ({
      ...x,
      width: u.width < p ? p : x.width,
      height: u.height < f ? f : x.height
    })), u.width < p && t.layout.width.set(p / r), u.height < f && t.layout.height.set(f / i);
  }, []), v.useEffect(() => {
    d({
      left: r * o,
      top: i * a,
      width: r * l,
      height: i * s
    });
  }, [i, r, s, o, a, l]);
  const y = (x, { size: E, handle: b }) => {
    d((C) => ({
      ...E,
      left: b === "nw" || b === "sw" ? C.left + C.width - E.width : C.left,
      top: b === "nw" || b === "ne" ? C.top + C.height - E.height : C.top
    }));
  }, g = (x, { size: E, handle: b }) => {
    if (b === "nw" || b === "sw") {
      const C = u.left + u.width - E.width, T = C < 0, z = T ? 0 : C, I = T ? u.width + C : E.width;
      t.position.left.set(Il(r, z)), t.layout.width.set(Il(r, I));
    } else {
      const C = u.left + E.width, T = C > r ? u.width + (r - C) : E.width;
      t.layout.width.set(Il(r, T));
    }
    if (b === "nw" || b === "ne") {
      const C = u.top + u.height - E.height, T = C < 0, z = T ? 0 : C, I = T ? u.height + C : E.height;
      t.position.top.set(Il(i, z)), t.layout.height.set(
        Il(i, I)
      );
    } else {
      const C = u.top + E.height, T = C > i ? u.height + (i - C) : E.height;
      t.layout.height.set(
        Il(i, T)
      );
    }
  };
  return {
    positionState: u,
    resizableBoxProps: {
      className: "h-full w-full",
      width: u.width,
      height: u.height,
      minConstraints: m,
      maxConstraints: n,
      resizeHandles: Ore,
      onResize: y,
      onResizeStop: g
    }
  };
}, LO = "answerZone", Fre = (e) => {
  const {
    answerZone: t,
    canvasSize: n,
    dropzoneVisibility: r,
    onClick: i,
    onClickSettingsButton: o,
    onClickPlusButton: a,
    onClickEditAnswerButton: s
  } = e, l = t.name.value, { positionState: u, resizableBoxProps: d } = zre({
    answerZone: t,
    canvasSize: n
  }), [p, f, m] = Of({
    type: LO,
    item: t,
    collect: (y) => ({
      isDragging: y.isDragging(),
      hideSourceOnDrag: !0
    })
  });
  return p.isDragging ? /* @__PURE__ */ c.jsx("div", { ref: m }) : /* @__PURE__ */ c.jsx(
    "div",
    {
      ref: m,
      className: "absolute flex cursor-move items-center justify-center rounded bg-transparent",
      style: u,
      onClick: i,
      "data-qa": `answer-zone-${t.id.value}`,
      children: /* @__PURE__ */ c.jsx("div", { className: "relative z-20", children: /* @__PURE__ */ c.jsx(xre, { ...d, children: /* @__PURE__ */ c.jsxs(
        "div",
        {
          ref: f,
          className: Le(
            `group relative flex h-full w-full flex-wrap items-center
            justify-center gap-1 border-2 border-blue-500 bg-white`,
            r !== Ic.Full && "border-dashed"
          ),
          children: [
            l ? /* @__PURE__ */ c.jsx("div", { className: "absolute left-0 top-0 bg-white p-1 text-xs", children: l }) : null,
            t.answers.length === 0 ? /* @__PURE__ */ c.jsx(
              jre,
              {
                answerZoneId: t.id.value,
                onClickSettingsButton: o,
                onClickPlusButton: a
              }
            ) : null,
            t.answers.map((y, g) => /* @__PURE__ */ c.jsx(
              Sre,
              {
                answer: y,
                isOnlyAnswer: t.answers.length === 1,
                onEditAnswer: (x) => {
                  s(g, x);
                },
                onRemoveAnswer: () => {
                  t.answers.remove(g);
                }
              },
              g
            )),
            t.answers.length > 0 ? /* @__PURE__ */ c.jsx(
              Nre,
              {
                answerZoneId: t.id.value,
                onClickSettingsButton: o,
                onClickPlusButton: a
              }
            ) : null
          ]
        }
      ) }) })
    }
  );
};
function Lre({
  state: e,
  setModalType: t,
  selectAnswerZone: n,
  selectCurrentAnswer: r
}) {
  var i;
  const { answerZones: o, backgroundImage: a, canvasDimensions: s } = e, l = zn(), u = s.width.value, d = s.height.value, p = a.defined ? li(
    l.getState(),
    a.id
  ) : null, f = ((i = p == null ? void 0 : p.state) == null ? void 0 : i.src) || "", [m, y] = v.useState(!1);
  v.useEffect(() => {
    if (!p || m) return;
    const x = new Image();
    x.src = f, x.onload = () => {
      const E = x.width / x.height, b = uc;
      let C = b, T = b;
      E < 1 ? b / E > b && (C = b * E) : b * E > b && (T = b / E), s.width.set(C), s.height.set(T), y(!0);
    };
  }), v.useEffect(() => {
    y(!1);
  }, [f]);
  const [, g] = cd(
    () => ({
      accept: LO,
      drop(x, E) {
        const b = E.getDifferenceFromInitialOffset();
        if (!b) return;
        const C = x.layout.width.value, T = u * x.position.left.value + b.x, z = Il(u, T), I = z + C;
        z < 0 ? x.position.left.set(0) : I > 1 ? x.position.left.set(1 - C) : x.position.left.set(z);
        const w = x.layout.height.value, M = d * x.position.top.value + b.y, R = Il(d, M), F = R + w;
        R < 0 ? x.position.top.set(0) : F > 1 ? x.position.top.set(1 - w) : x.position.top.set(R);
      }
    }),
    [o]
  );
  return /* @__PURE__ */ c.jsx(
    "div",
    {
      ref: g,
      className: Le(`
        relative mx-auto box-content max-w-full overflow-auto overflow-hidden
        rounded-lg border border-almost-black bg-cover bg-center bg-no-repeat
      `),
      style: {
        backgroundImage: `url(${f})`,
        width: u,
        aspectRatio: `${u} / ${d}`
      },
      "data-qa": "plugin-dropzone-image-editor-canvas",
      children: o == null ? void 0 : o.map((x, E) => {
        const b = x.id.value;
        return /* @__PURE__ */ c.jsx(
          Fre,
          {
            answerZone: x,
            canvasSize: [u, d],
            dropzoneVisibility: e.dropzoneVisibility.value,
            onClick: () => n(b),
            onClickSettingsButton: () => {
              n(b), t(ti.Settings);
            },
            onClickPlusButton: () => {
              n(b), t(ti.CreateDropZone);
            },
            onClickEditAnswerButton: (C, T) => {
              n(b), r(C, T), t(ti.Edit);
            }
          },
          E
        );
      })
    }
  );
}
function MO({
  answerType: e,
  answerIndex: t,
  isWrongAnswer: n = !1,
  zoneId: r,
  onSave: i,
  answerZones: o,
  extraDraggableAnswers: a
}) {
  var s;
  const l = nt().edtrIo, u = Ur();
  v.useEffect(() => {
    f && u(Ji(p.text.id));
  });
  const d = n ? a : (s = o == null ? void 0 : o.find(({ id: m }) => m.value === r)) == null ? void 0 : s.answers;
  if (!d || t >= d.length) return /* @__PURE__ */ c.jsx(c.Fragment, {});
  const p = d[t], f = e === lu.Text;
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx("div", { className: "[&_textarea]:w-[430px] [&_textarea]:max-w-[100%]", children: f ? p.text.render() : p.image.render() }),
    /* @__PURE__ */ c.jsx("button", { className: "serlo-button-edit-primary mt-4", onClick: i, children: l.save })
  ] });
}
function Mre({
  answerZone: e,
  onDuplicate: t,
  onDelete: n
}) {
  const r = nt().plugins.dropzoneImage, i = {
    name: e.name.value,
    height: e.layout.height.value * 100,
    width: e.layout.width.value * 100
  };
  function o(a, s) {
    e.layout[a].set(parseInt(s) / 100);
  }
  return /* @__PURE__ */ c.jsxs("div", { className: "mx-auto flex w-full max-w-sm flex-col items-center justify-center rounded-lg bg-white p-2", children: [
    /* @__PURE__ */ c.jsxs("label", { className: "mb-4 w-full", children: [
      r.answerZone.description,
      /* @__PURE__ */ c.jsx("div", { className: "mt-2 flex justify-center", children: /* @__PURE__ */ c.jsx(
        "input",
        {
          type: "text",
          "data-qa": "answer-zone-settings-form-name-input",
          defaultValue: i.name,
          onChange: (a) => e.name.set(a.target.value),
          className: "w-full rounded border border-gray-300 bg-orange-100 p-2"
        }
      ) })
    ] }),
    /* @__PURE__ */ c.jsxs("label", { className: "mb-4 w-full", children: [
      r.answerZone.sizeLabel,
      /* @__PURE__ */ c.jsxs("div", { className: "mt-2 flex  gap-2", children: [
        /* @__PURE__ */ c.jsx(
          "input",
          {
            type: "number",
            defaultValue: i.height,
            onChange: (a) => o("height", a.target.value),
            className: "w-24 rounded border border-gray-300 bg-orange-100 p-2 text-center"
          }
        ),
        /* @__PURE__ */ c.jsx("span", { className: "self-center", children: "%" }),
        /* @__PURE__ */ c.jsx("span", { className: "self-center", children: "x" }),
        /* @__PURE__ */ c.jsx(
          "input",
          {
            type: "number",
            defaultValue: i.width,
            onChange: (a) => o("width", a.target.value),
            className: "w-24 rounded border border-gray-300 bg-orange-100 p-2 text-center"
          }
        ),
        /* @__PURE__ */ c.jsx("span", { className: "self-center", children: "%" })
      ] })
    ] }),
    /* @__PURE__ */ c.jsxs("div", { className: "flex w-full gap-4", children: [
      /* @__PURE__ */ c.jsxs(
        "button",
        {
          "data-qa": "answer-zone-settings-form-duplicate-button",
          onClick: t,
          className: "flex flex-1 cursor-pointer items-center justify-center rounded border-none bg-orange-100 p-2",
          children: [
            /* @__PURE__ */ c.jsx(ot, { icon: oK, className: "mr-2" }),
            r.answerZone.duplicate
          ]
        }
      ),
      /* @__PURE__ */ c.jsxs(
        "button",
        {
          "data-qa": "answer-zone-settings-form-delete-button",
          onClick: n,
          className: "flex flex-1 cursor-pointer items-center justify-center rounded border-none bg-orange-100 p-2",
          children: [
            /* @__PURE__ */ c.jsx(ot, { icon: sj, className: "mr-2" }),
            r.answerZone.delete
          ]
        }
      )
    ] })
  ] });
}
const Bre = (e) => /* @__PURE__ */ v.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("path", { d: "M21.8333 2.66667V21.3333H3.16667V2.66667H21.8333ZM21.8333 0H3.16667C1.7 0 0.5 1.2 0.5 2.66667V21.3333C0.5 22.8 1.7 24 3.16667 24H21.8333C23.3 24 24.5 22.8 24.5 21.3333V2.66667C24.5 1.2 23.3 0 21.8333 0ZM15.3533 11.8133L11.3533 16.9733L8.5 13.52L4.5 18.6667H20.5L15.3533 11.8133Z", fill: "#404040" }));
function Hw({
  isWrongAnswer: e = !1,
  zoneId: t,
  onSave: n,
  answerZones: r,
  extraDraggableAnswers: i
}) {
  var o;
  const [a, s] = v.useState(0), [l, u] = v.useState(lu.Image), d = nt().plugins, p = e ? i : (o = r == null ? void 0 : r.find(({ id: g }) => g.value === t)) == null ? void 0 : o.answers, f = (g) => {
    p && p.insert(p.length, {
      id: fa(),
      text: { plugin: Y.Text },
      image: { plugin: Y.Image }
    }), u(g), s(1);
  }, m = /* @__PURE__ */ c.jsxs("div", { className: "flex flex-row items-center justify-center", children: [
    /* @__PURE__ */ c.jsx(
      "button",
      {
        "data-qa": "plugin-dropzone-image-answer-zone-new-answer-type-text",
        className: "mx-4 rounded-lg bg-orange-100 p-4 hover:bg-orange-200",
        onClick: () => f(lu.Text),
        children: /* @__PURE__ */ c.jsxs("div", { className: "border border-2 border-black px-1 text-lg font-bold", children: [
          d.text.title,
          "..."
        ] })
      }
    ),
    /* @__PURE__ */ c.jsx("span", { children: d.dropzoneImage.or }),
    /* @__PURE__ */ c.jsxs(
      "button",
      {
        "data-qa": "plugin-dropzone-image-answer-zone-new-answer-type-image",
        className: "mx-4 rounded-lg bg-orange-100 px-4 pb-2 pt-4 hover:bg-orange-200",
        onClick: () => f(lu.Image),
        children: [
          /* @__PURE__ */ c.jsx(Bre, { className: "mx-auto mb-1" }),
          /* @__PURE__ */ c.jsx("span", { className: "text-lg font-bold", children: d.image.title })
        ]
      }
    )
  ] }), y = /* @__PURE__ */ c.jsx(
    MO,
    {
      answerType: l,
      answerIndex: p.length - 1,
      isWrongAnswer: e,
      zoneId: t,
      onSave: n,
      answerZones: r,
      extraDraggableAnswers: i
    }
  );
  return [m, y][a];
}
function Ire({
  state: e,
  modalType: t,
  setModalType: n,
  currentAnswer: r
}) {
  const i = nt().plugins.dropzoneImage, o = zn(), { answerZones: a, extraDraggableAnswers: s } = e, l = t ? i.modal[t] : "";
  return /* @__PURE__ */ c.jsx(
    qo,
    {
      isOpen: t !== ti.Unset,
      setIsOpen: (d) => {
        !d && n(ti.Unset);
      },
      className: "top-[10%] max-h-[80%] translate-y-0 overflow-auto pb-40",
      title: l,
      extraTitleClassName: "serlo-h3 mb-16 px-3",
      children: u()
    }
  );
  function u() {
    if (t === ti.Unset) return null;
    if (t === ti.Settings)
      return /* @__PURE__ */ c.jsx(
        Mre,
        {
          answerZone: r.zone,
          onDuplicate: () => {
            FO(
              a,
              r.zone.id.value,
              () => o.getState()
            );
          },
          onDelete: () => {
            n(ti.Unset);
            const d = a.findIndex(
              (p) => p.id.value === r.zone.id.value
            );
            a.remove(d);
          }
        }
      );
    if (t === ti.CreateDropZone)
      return /* @__PURE__ */ c.jsx(
        Hw,
        {
          answerZones: a,
          extraDraggableAnswers: s,
          zoneId: r.zone.id.value,
          onSave: () => n(ti.Unset)
        }
      );
    if (t === ti.Edit)
      return /* @__PURE__ */ c.jsx(
        MO,
        {
          zoneId: r.zone.id.value,
          answerType: r.type,
          answerIndex: r.index,
          onSave: () => n(ti.Unset),
          answerZones: a,
          extraDraggableAnswers: s
        }
      );
    if (t === ti.CreateWrongAnswer)
      return /* @__PURE__ */ c.jsx(
        Hw,
        {
          isWrongAnswer: !0,
          onSave: () => n(ti.Unset),
          answerZones: a,
          extraDraggableAnswers: s
        }
      );
  }
}
function d2(e) {
  const {
    answer: t,
    dragType: n = "undroppableAnswer",
    originDropzoneId: r,
    isCorrect: i,
    isAnswerCorrect: o,
    isOnlyDroppedAnswer: a = !1,
    hasEnoughDroppedAnswers: s = !0
  } = e, { id: l, imageUrl: u, text: d } = t, [, p] = Of({
    type: n,
    item: { id: l, originDropzoneId: r, imageUrl: u, text: d }
  });
  return /* @__PURE__ */ c.jsx(
    "span",
    {
      className: Le(
        "flex max-h-full cursor-grab items-center justify-center",
        Rre(u, a),
        Pre(u, i, a)
      ),
      ref: p,
      children: /* @__PURE__ */ c.jsx(
        NO,
        {
          url: u,
          text: d,
          className: Le(
            "bg-brand-50",
            _re(
              u,
              i,
              o,
              a,
              s
            )
          )
        }
      )
    }
  );
}
function Rre(e, t) {
  return e ? t ? "h-full object-contain" : "h-16 object-contain" : "";
}
function Pre(e, t, n) {
  return e && n || t === !0 || t === !1 ? "" : "border-3 border-transparent";
}
function _re(e, t, n, r, i) {
  return e && r ? "" : t === !0 && n === !0 && !i ? "rounded border-3 border-red-500" : t === !0 || t === !1 && n === !0 && i ? "rounded border-3 border-green-500" : t === !1 ? "rounded border-3 border-red-500" : e ? "rounded border border-brand" : "";
}
function qre(e) {
  const { extraDraggableAnswers: t, setModalType: n } = e, r = zn(), i = nt().plugins.blanksExercise, o = t.map(
    (a) => zO(a, () => r.getState())
  );
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    o.length > 0 && /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsxs("span", { children: [
        i.dummyAnswers,
        ":"
      ] }),
      /* @__PURE__ */ c.jsx(Xg, { accept: "none", children: o.map((a, s) => /* @__PURE__ */ c.jsx(
        Q7,
        {
          onRemoveClick: () => {
            t.remove(s);
          },
          tooltipText: i.removeDummyAnswer,
          children: /* @__PURE__ */ c.jsx(
            d2,
            {
              answer: a,
              "data-qa": "plugin-dropzone-image-alternative-answer"
            }
          )
        },
        s
      )) })
    ] }),
    /* @__PURE__ */ c.jsx(
      "button",
      {
        className: "serlo-button-edit-secondary",
        onClick: () => n(ti.CreateWrongAnswer),
        "data-qa": "plugin-dropzone-image-add-wrong-answer-button",
        children: i.addDummyAnswer
      }
    )
  ] });
}
function $re({ answerZones: e }) {
  const t = zn(), n = nt().plugins.dropzoneImage, r = e.map(
    ({ answers: i }) => i.map((o) => zO(o, () => t.getState()))
  ).flat();
  return /* @__PURE__ */ c.jsxs("div", { className: "mt-4", children: [
    /* @__PURE__ */ c.jsx(
      "button",
      {
        className: "serlo-button-edit-primary",
        onClick: () => Ere(e),
        "data-qa": "plugin-dropzone-image-add-answer-zone-button",
        children: n.addDropZone
      }
    ),
    /* @__PURE__ */ c.jsxs(Xg, { accept: "none", className: "mt-4", children: [
      r.length === 0 && /* @__PURE__ */ c.jsx("span", { className: "text-sm text-gray-600", children: n.answers.answersPlaceholder }),
      r.map((i, o) => /* @__PURE__ */ c.jsx(
        d2,
        {
          answer: i,
          "data-qa": "plugin-dropzone-image-correct-possible-answer"
        },
        o
      ))
    ] })
  ] });
}
function Hre(e) {
  const t = zn(), [n, r] = v.useState(
    e[0]
  ), [i, o] = v.useState(0), [a, s] = v.useState(
    lu.Unset
  ), l = (f) => {
    const m = e.find((y) => y.id.value === f);
    m && r(m);
  }, u = (f, m) => {
    o(f), s(m);
  }, [d, p] = v.useState(null);
  return ua("backspace, del", (f) => {
    if (!n) return;
    const m = e.findIndex(
      ({ id: y }) => y.value === n.id.value
    );
    m !== -1 && e.remove(m), f.preventDefault();
  }), ua(["ctrl+c, meta+c"], (f) => {
    p(n), f.preventDefault();
  }), ua(["ctrl+v, meta+v"], (f) => {
    if (!d) return;
    const m = d.id.value;
    FO(e, m, () => t.getState()), f.preventDefault();
  }), {
    currentAnswerZone: n,
    currentAnswerIndex: i,
    currentAnswerType: a,
    selectAnswerZone: l,
    selectCurrentAnswer: u
  };
}
function BO(e) {
  const t = Array.from(e);
  for (let n = t.length - 1; n > 0; n--) {
    const r = Math.floor(Math.random() * (n + 1));
    [t[n], t[r]] = [t[r], t[n]];
  }
  return t;
}
function Vre(e) {
  const { feedback: t, isVisible: n, onClick: r } = e, i = Un().plugins.exercise;
  return /* @__PURE__ */ c.jsxs("div", { className: "flex", children: [
    n ? /* @__PURE__ */ c.jsx(
      "button",
      {
        className: "serlo-button-learner-primary mr-3 h-8",
        onClick: r,
        "data-qa": "plugin-exercise-check-answer-button",
        children: i.check
      }
    ) : null,
    t !== Zi.Unset ? /* @__PURE__ */ c.jsx(
      Lf,
      {
        correct: t === Zi.Correct,
        missedSome: t === Zi.MissedSome
      }
    ) : null
  ] });
}
const Ure = v.memo(function(e) {
  const {
    dropZone: t,
    droppedAnswers: n,
    isCorrect: r,
    isAnswerCorrectMap: i,
    visibility: o,
    answersCount: a,
    acceptedDragType: s,
    onAnswerDrop: l
  } = e, { id: u, name: d, position: p, layout: f } = t, { left: m, top: y } = p, { height: g, width: x } = f, [{ isOver: E, canDrop: b }, C] = cd({
    accept: s,
    drop: (I) => {
      n.find(
        (w) => w.id === I.id
      ) || l(I, u, I.originDropzoneId);
    },
    collect: (I) => ({
      isOver: I.isOver(),
      canDrop: I.canDrop()
    })
  }), T = n.length === 1, z = T && !!n[0].imageUrl;
  return /* @__PURE__ */ c.jsxs(
    "div",
    {
      ref: C,
      className: Le(
        "absolute flex flex-wrap items-center justify-center gap-1 rounded p-0",
        Wre(o, E, b),
        Zre(o, r, z),
        Gre(r, z),
        Kre(o)
      ),
      style: {
        left: m * 100 + "%",
        top: y * 100 + "%",
        width: x * 100 + "%",
        height: g * 100 + "%"
      },
      "data-qa": `blank-drop-zone-${u}`,
      children: [
        o !== Ic.None && d ? /* @__PURE__ */ c.jsx("div", { className: "absolute left-0 top-0 bg-white p-1 text-xs", children: d }) : null,
        n.map((I, w) => /* @__PURE__ */ c.jsx(
          d2,
          {
            answer: I,
            dragType: s,
            originDropzoneId: u,
            isCorrect: r,
            isAnswerCorrect: i == null ? void 0 : i.get(I.id),
            isOnlyDroppedAnswer: T,
            hasEnoughDroppedAnswers: n.length === a
          },
          w
        ))
      ]
    }
  );
});
function Wre(e, t, n) {
  return e !== Ic.Full ? "" : t && n ? "bg-brand-400" : n ? "bg-brand-200" : "bg-white";
}
function Zre(e, t, n) {
  return (t === !0 || t === !1) && n ? "border-4" : e === Ic.None ? "border-0" : "border-2";
}
function Gre(e, t) {
  return e === !0 && t ? "border-green-500" : e === !1 && t ? "border-red-500" : "border-brand-500";
}
function Kre(e) {
  return e === Ic.Full ? "border-solid" : "border-dashed";
}
function Xre(e) {
  var t;
  const {
    state: n,
    dropzoneAnswerMap: r,
    isZoneCorrectMap: i,
    isAnswerCorrectMap: o,
    draggableAnswerDragType: a,
    onAnswerDrop: s
  } = e, { answerZones: l, backgroundImage: u, canvasDimensions: d, dropzoneVisibility: p } = n, f = u, m = ((t = f == null ? void 0 : f.state) == null ? void 0 : t.src) || "";
  return /* @__PURE__ */ c.jsx(
    "div",
    {
      className: Le(`
        relative mx-auto box-content max-w-full
        overflow-hidden rounded-lg border
        border-brand-500 bg-cover bg-center bg-no-repeat
      `),
      style: {
        backgroundImage: `url(${m})`,
        width: d.width,
        aspectRatio: `${d.width} / ${d.height}`
      },
      children: l.map((y) => {
        const { answers: g, id: x, ...E } = y, b = { ...E, id: x };
        return /* @__PURE__ */ c.jsx(
          Ure,
          {
            dropZone: b,
            droppedAnswers: r.get(x) || [],
            isCorrect: i.get(x),
            isAnswerCorrectMap: o.get(x),
            visibility: p,
            canvasDimensions: d,
            answersCount: g.length,
            acceptedDragType: a,
            onAnswerDrop: s
          },
          x
        );
      })
    }
  );
}
function IO(e) {
  const { state: t } = e, { answerZones: n, extraDraggableAnswers: r } = t, i = "draggableAnswer" + e.id, o = v.useMemo(() => {
    const I = n.map(({ answers: M }) => X4(M)).flat(), w = X4(r);
    return [...I, ...w];
  }, [n, r]), [a, s] = v.useState(o), [l, u] = v.useState(
    /* @__PURE__ */ new Map()
  ), [d, p] = v.useState(
    /* @__PURE__ */ new Map()
  ), [f, m] = v.useState(
    /* @__PURE__ */ new Map()
  ), [y, g] = v.useState(Zi.Unset);
  v.useEffect(() => {
    s(BO(o));
  }, [o]);
  const x = v.useMemo(
    () => n.filter(({ answers: I }) => I.length),
    [n]
  ), E = v.useMemo(() => {
    const I = Array.from(l.values()).flat();
    return a.filter(({ id: w }) => !I.some((M) => M.id === w));
  }, [a, l]), b = (I, w, M) => {
    u((R) => {
      const F = new Map(R), W = F.get(w) || [];
      if (F.set(w, [...W, I]), M) {
        const X = F.get(M) || [];
        F.set(
          M,
          X.filter(({ id: le }) => le !== I.id)
        ), m((le) => new Map(le.set(I.id, null)));
      }
      return p((X) => {
        var le;
        const ne = new Map(X);
        return ne.set(w, null), M && ((le = F.get(M)) != null && le.length ? ne.set(M, null) : ne.delete(M)), ne;
      }), F;
    }), g(Zi.Unset);
  }, C = (I) => {
    const w = I.originDropzoneId || "";
    u((M) => {
      const R = new Map(M), F = R.get(w);
      return F != null && F.find(({ id: W }) => W === I.id) && R.set(
        w,
        F.filter(({ id: W }) => W !== I.id)
      ), p((W) => {
        var X;
        const le = new Map(W);
        return (X = R.get(w)) != null && X.length ? le.set(w, null) : le.delete(w), le;
      }), R;
    }), g(Zi.Unset);
  }, T = v.useMemo(() => d.size >= x.length, [d.size, x.length]), z = () => {
    let I = Zi.Unset;
    n.forEach((w) => {
      const M = X4(w.answers), R = l.get(w.id) || [], F = /* @__PURE__ */ new Map(), W = R.filter((le) => {
        const ne = M.some((fe) => fe.id === le.id ? !0 : fe.imageUrl === "" || le.imageUrl === "" ? fe.text === le.text : fe.imageUrl === le.imageUrl);
        return F.set(le.id, ne), ne;
      });
      m(
        (le) => new Map(le.set(w.id, F))
      );
      const X = M.length === R.length && W.length === M.length;
      p(
        (le) => new Map(le.set(w.id, X))
      ), M.length > R.length && (I = Zi.MissedSome, g(I)), !X && (I === Zi.Unset || I === Zi.Correct) && (I = Zi.Wrong, g(I)), I === Zi.Unset && (I = Zi.Correct, g(I));
    });
  };
  return /* @__PURE__ */ c.jsx("div", { className: "mx-side", children: /* @__PURE__ */ c.jsxs(O7, { children: [
    /* @__PURE__ */ c.jsx(
      Xre,
      {
        state: t,
        dropzoneAnswerMap: l,
        isZoneCorrectMap: d,
        isAnswerCorrectMap: f,
        draggableAnswerDragType: i,
        onAnswerDrop: b
      }
    ),
    /* @__PURE__ */ c.jsx(
      Xg,
      {
        accept: i,
        onDrop: C,
        children: E.map((I, w) => /* @__PURE__ */ c.jsx(
          d2,
          {
            answer: I,
            dragType: i
          },
          w
        ))
      }
    ),
    /* @__PURE__ */ c.jsx(
      Vre,
      {
        feedback: y,
        isVisible: T,
        onClick: z
      }
    )
  ] }) });
}
function Qre({
  state: e,
  previewActive: t,
  staticDocument: n
}) {
  const [r, i] = v.useState(ti.Unset), { answerZones: o, extraDraggableAnswers: a } = e, {
    currentAnswerZone: s,
    currentAnswerIndex: l,
    currentAnswerType: u,
    selectAnswerZone: d,
    selectCurrentAnswer: p
  } = Hre(o);
  return t ? /* @__PURE__ */ c.jsx(IO, { ...n }) : /* @__PURE__ */ c.jsxs("div", { className: "mx-side", children: [
    /* @__PURE__ */ c.jsx(
      Ire,
      {
        state: e,
        currentAnswer: {
          zone: s,
          index: l,
          type: u
        },
        modalType: r,
        setModalType: i
      }
    ),
    /* @__PURE__ */ c.jsx(
      Lre,
      {
        state: e,
        setModalType: i,
        selectCurrentAnswer: p,
        selectAnswerZone: d
      }
    ),
    /* @__PURE__ */ c.jsx($re, { answerZones: o }),
    /* @__PURE__ */ c.jsx(
      qre,
      {
        extraDraggableAnswers: a,
        setModalType: i
      }
    )
  ] });
}
const Rm = v.forwardRef(
  function({ label: e, autoFocus: t, tooltip: n, ...r }, i) {
    return /* @__PURE__ */ c.jsxs("label", { className: "mx-auto mb-0 mt-5 flex items-center justify-between text-almost-black", children: [
      /* @__PURE__ */ c.jsx("span", { className: "w-1/5", children: e }),
      n && /* @__PURE__ */ c.jsx("span", { className: "w-25 ml-[-25px]", children: n }),
      /* @__PURE__ */ c.jsx(
        "input",
        {
          autoFocus: t,
          ...r,
          ref: i,
          className: Le(`
             serlo-input-font-reset w-3/4 rounded-md border-2
           border-editor-primary-100 bg-editor-primary-100
           focus:border-editor-primary focus:outline-none
          `)
        }
      )
    ] });
  }
);
function Vw(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function ni(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function Yre(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function RO(...e) {
  return (t) => e.forEach((n) => Yre(n, t));
}
function xa(...e) {
  return v.useCallback(RO(...e), e);
}
function Jre(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = v.createContext(a), l = n.length;
    n = [...n, a];
    const u = (p) => {
      var f;
      const { scope: m, children: y, ...g } = p, x = ((f = m == null ? void 0 : m[e]) == null ? void 0 : f[l]) || s, E = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ c.jsx(x.Provider, { value: E, children: y });
    };
    u.displayName = o + "Provider";
    function d(p, f) {
      var m;
      const y = ((m = f == null ? void 0 : f[e]) == null ? void 0 : m[l]) || s, g = v.useContext(y);
      if (g) return g;
      if (a !== void 0) return a;
      throw new Error(`\`${p}\` must be used within \`${o}\``);
    }
    return [u, d];
  }
  const i = () => {
    const o = n.map((a) => v.createContext(a));
    return function(a) {
      const s = (a == null ? void 0 : a[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: s } }),
        [a, s]
      );
    };
  };
  return i.scopeName = e, [r, eie(i, ...t)];
}
function eie(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(i) {
      const o = r.reduce((a, { useScope: s, scopeName: l }) => {
        const u = s(i)[`__scope${l}`];
        return { ...a, ...u };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var tie = v.useId || (() => {
}), nie = 0;
function py(e) {
  const [t, n] = v.useState(tie());
  return gr(() => {
    n((r) => r ?? String(nie++));
  }, [e]), t ? `radix-${t}` : "";
}
const rie = ["top", "right", "bottom", "left"], mu = Math.min, Eo = Math.max, Pm = Math.round, Uh = Math.floor, gu = (e) => ({
  x: e,
  y: e
}), iie = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, oie = {
  start: "end",
  end: "start"
};
function v5(e, t, n) {
  return Eo(e, mu(t, n));
}
function ll(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ul(e) {
  return e.split("-")[0];
}
function md(e) {
  return e.split("-")[1];
}
function fy(e) {
  return e === "x" ? "y" : "x";
}
function hy(e) {
  return e === "y" ? "height" : "width";
}
function gd(e) {
  return ["top", "bottom"].includes(ul(e)) ? "y" : "x";
}
function my(e) {
  return fy(gd(e));
}
function aie(e, t, n) {
  n === void 0 && (n = !1);
  const r = md(e), i = my(e), o = hy(i);
  let a = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (a = _m(a)), [a, _m(a)];
}
function sie(e) {
  const t = _m(e);
  return [y5(e), t, y5(t)];
}
function y5(e) {
  return e.replace(/start|end/g, (t) => oie[t]);
}
function lie(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? o : a;
    default:
      return [];
  }
}
function uie(e, t, n, r) {
  const i = md(e);
  let o = lie(ul(e), n === "start", r);
  return i && (o = o.map((a) => a + "-" + i), t && (o = o.concat(o.map(y5)))), o;
}
function _m(e) {
  return e.replace(/left|right|bottom|top/g, (t) => iie[t]);
}
function cie(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function PO(e) {
  return typeof e != "number" ? cie(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function qm(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Uw(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = gd(t), a = my(t), s = hy(a), l = ul(t), u = o === "y", d = r.x + r.width / 2 - i.width / 2, p = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: d,
        y: r.y - i.height
      };
      break;
    case "bottom":
      m = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: p
      };
      break;
    case "left":
      m = {
        x: r.x - i.width,
        y: p
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch (md(t)) {
    case "start":
      m[a] -= f * (n && u ? -1 : 1);
      break;
    case "end":
      m[a] += f * (n && u ? -1 : 1);
      break;
  }
  return m;
}
const die = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: a
  } = n, s = o.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let u = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: d,
    y: p
  } = Uw(u, r, l), f = r, m = {}, y = 0;
  for (let g = 0; g < s.length; g++) {
    const {
      name: x,
      fn: E
    } = s[g], {
      x: b,
      y: C,
      data: T,
      reset: z
    } = await E({
      x: d,
      y: p,
      initialPlacement: r,
      placement: f,
      strategy: i,
      middlewareData: m,
      rects: u,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (d = b ?? d, p = C ?? p, m = {
      ...m,
      [x]: {
        ...m[x],
        ...T
      }
    }, z && y <= 50) {
      y++, typeof z == "object" && (z.placement && (f = z.placement), z.rects && (u = z.rects === !0 ? await a.getElementRects({
        reference: e,
        floating: t,
        strategy: i
      }) : z.rects), {
        x: d,
        y: p
      } = Uw(u, f, l)), g = -1;
      continue;
    }
  }
  return {
    x: d,
    y: p,
    placement: f,
    strategy: i,
    middlewareData: m
  };
};
async function of(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: p = "floating",
    altBoundary: f = !1,
    padding: m = 0
  } = ll(t, e), y = PO(m), g = s[f ? p === "floating" ? "reference" : "floating" : p], x = qm(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(g))) == null || n ? g : g.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: l
  })), E = p === "floating" ? {
    ...a.floating,
    x: r,
    y: i
  } : a.reference, b = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), C = await (o.isElement == null ? void 0 : o.isElement(b)) ? await (o.getScale == null ? void 0 : o.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, T = qm(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: E,
    offsetParent: b,
    strategy: l
  }) : E);
  return {
    top: (x.top - T.top + y.top) / C.y,
    bottom: (T.bottom - x.bottom + y.bottom) / C.y,
    left: (x.left - T.left + y.left) / C.x,
    right: (T.right - x.right + y.right) / C.x
  };
}
const Ww = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: a,
      elements: s,
      middlewareData: l
    } = t, {
      element: u,
      padding: d = 0
    } = ll(e, t) || {};
    if (u == null)
      return {};
    const p = PO(d), f = {
      x: n,
      y: r
    }, m = my(i), y = hy(m), g = await a.getDimensions(u), x = m === "y", E = x ? "top" : "left", b = x ? "bottom" : "right", C = x ? "clientHeight" : "clientWidth", T = o.reference[y] + o.reference[m] - f[m] - o.floating[y], z = f[m] - o.reference[m], I = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(u));
    let w = I ? I[C] : 0;
    (!w || !await (a.isElement == null ? void 0 : a.isElement(I))) && (w = s.floating[C] || o.floating[y]);
    const M = T / 2 - z / 2, R = w / 2 - g[y] / 2 - 1, F = mu(p[E], R), W = mu(p[b], R), X = F, le = w - g[y] - W, ne = w / 2 - g[y] / 2 + M, fe = v5(X, ne, le), D = !l.arrow && md(i) != null && ne != fe && o.reference[y] / 2 - (ne < X ? F : W) - g[y] / 2 < 0, j = D ? ne < X ? ne - X : ne - le : 0;
    return {
      [m]: f[m] + j,
      data: {
        [m]: fe,
        centerOffset: ne - fe - j,
        ...D && {
          alignmentOffset: j
        }
      },
      reset: D
    };
  }
}), pie = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: u
      } = t, {
        mainAxis: d = !0,
        crossAxis: p = !0,
        fallbackPlacements: f,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: g = !0,
        ...x
      } = ll(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const E = ul(i), b = ul(s) === s, C = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), T = f || (b || !g ? [_m(s)] : sie(s));
      !f && y !== "none" && T.push(...uie(s, g, y, C));
      const z = [s, ...T], I = await of(t, x), w = [];
      let M = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (d && w.push(I[E]), p) {
        const X = aie(i, a, C);
        w.push(I[X[0]], I[X[1]]);
      }
      if (M = [...M, {
        placement: i,
        overflows: w
      }], !w.every((X) => X <= 0)) {
        var R, F;
        const X = (((R = o.flip) == null ? void 0 : R.index) || 0) + 1, le = z[X];
        if (le)
          return {
            data: {
              index: X,
              overflows: M
            },
            reset: {
              placement: le
            }
          };
        let ne = (F = M.filter((fe) => fe.overflows[0] <= 0).sort((fe, D) => fe.overflows[1] - D.overflows[1])[0]) == null ? void 0 : F.placement;
        if (!ne)
          switch (m) {
            case "bestFit": {
              var W;
              const fe = (W = M.map((D) => [D.placement, D.overflows.filter((j) => j > 0).reduce((j, de) => j + de, 0)]).sort((D, j) => D[1] - j[1])[0]) == null ? void 0 : W[0];
              fe && (ne = fe);
              break;
            }
            case "initialPlacement":
              ne = s;
              break;
          }
        if (i !== ne)
          return {
            reset: {
              placement: ne
            }
          };
      }
      return {};
    }
  };
};
function Zw(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Gw(e) {
  return rie.some((t) => e[t] >= 0);
}
const fie = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...i
      } = ll(e, t);
      switch (r) {
        case "referenceHidden": {
          const o = await of(t, {
            ...i,
            elementContext: "reference"
          }), a = Zw(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: Gw(a)
            }
          };
        }
        case "escaped": {
          const o = await of(t, {
            ...i,
            altBoundary: !0
          }), a = Zw(o, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: Gw(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function hie(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), a = ul(n), s = md(n), l = gd(n) === "y", u = ["left", "top"].includes(a) ? -1 : 1, d = o && l ? -1 : 1, p = ll(t, e);
  let {
    mainAxis: f,
    crossAxis: m,
    alignmentAxis: y
  } = typeof p == "number" ? {
    mainAxis: p,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...p
  };
  return s && typeof y == "number" && (m = s === "end" ? y * -1 : y), l ? {
    x: m * d,
    y: f * u
  } : {
    x: f * u,
    y: m * d
  };
}
const mie = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: a,
        middlewareData: s
      } = t, l = await hie(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: i + l.x,
        y: o + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, gie = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: o = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (x) => {
            let {
              x: E,
              y: b
            } = x;
            return {
              x: E,
              y: b
            };
          }
        },
        ...l
      } = ll(e, t), u = {
        x: n,
        y: r
      }, d = await of(t, l), p = gd(ul(i)), f = fy(p);
      let m = u[f], y = u[p];
      if (o) {
        const x = f === "y" ? "top" : "left", E = f === "y" ? "bottom" : "right", b = m + d[x], C = m - d[E];
        m = v5(b, m, C);
      }
      if (a) {
        const x = p === "y" ? "top" : "left", E = p === "y" ? "bottom" : "right", b = y + d[x], C = y - d[E];
        y = v5(b, y, C);
      }
      const g = s.fn({
        ...t,
        [f]: m,
        [p]: y
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r
        }
      };
    }
  };
}, vie = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: o,
        middlewareData: a
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: u = !0
      } = ll(e, t), d = {
        x: n,
        y: r
      }, p = gd(i), f = fy(p);
      let m = d[f], y = d[p];
      const g = ll(s, t), x = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const C = f === "y" ? "height" : "width", T = o.reference[f] - o.floating[C] + x.mainAxis, z = o.reference[f] + o.reference[C] - x.mainAxis;
        m < T ? m = T : m > z && (m = z);
      }
      if (u) {
        var E, b;
        const C = f === "y" ? "width" : "height", T = ["top", "left"].includes(ul(i)), z = o.reference[p] - o.floating[C] + (T && ((E = a.offset) == null ? void 0 : E[p]) || 0) + (T ? 0 : x.crossAxis), I = o.reference[p] + o.reference[C] + (T ? 0 : ((b = a.offset) == null ? void 0 : b[p]) || 0) - (T ? x.crossAxis : 0);
        y < z ? y = z : y > I && (y = I);
      }
      return {
        [f]: m,
        [p]: y
      };
    }
  };
}, yie = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: i,
        elements: o
      } = t, {
        apply: a = () => {
        },
        ...s
      } = ll(e, t), l = await of(t, s), u = ul(n), d = md(n), p = gd(n) === "y", {
        width: f,
        height: m
      } = r.floating;
      let y, g;
      u === "top" || u === "bottom" ? (y = u, g = d === (await (i.isRTL == null ? void 0 : i.isRTL(o.floating)) ? "start" : "end") ? "left" : "right") : (g = u, y = d === "end" ? "top" : "bottom");
      const x = m - l[y], E = f - l[g], b = !t.middlewareData.shift;
      let C = x, T = E;
      if (p) {
        const I = f - l.left - l.right;
        T = d || b ? mu(E, I) : I;
      } else {
        const I = m - l.top - l.bottom;
        C = d || b ? mu(x, I) : I;
      }
      if (b && !d) {
        const I = Eo(l.left, 0), w = Eo(l.right, 0), M = Eo(l.top, 0), R = Eo(l.bottom, 0);
        p ? T = f - 2 * (I !== 0 || w !== 0 ? I + w : Eo(l.left, l.right)) : C = m - 2 * (M !== 0 || R !== 0 ? M + R : Eo(l.top, l.bottom));
      }
      await a({
        ...t,
        availableWidth: T,
        availableHeight: C
      });
      const z = await i.getDimensions(o.floating);
      return f !== z.width || m !== z.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function vu(e) {
  return _O(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Lo(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function vl(e) {
  var t;
  return (t = (_O(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function _O(e) {
  return e instanceof Node || e instanceof Lo(e).Node;
}
function cl(e) {
  return e instanceof Element || e instanceof Lo(e).Element;
}
function hs(e) {
  return e instanceof HTMLElement || e instanceof Lo(e).HTMLElement;
}
function Kw(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Lo(e).ShadowRoot;
}
function _f(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = ha(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function xie(e) {
  return ["table", "td", "th"].includes(vu(e));
}
function gy(e) {
  const t = vy(), n = ha(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function bie(e) {
  let t = J0(e);
  for (; hs(t) && !p2(t); ) {
    if (gy(t))
      return t;
    t = J0(t);
  }
  return null;
}
function vy() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function p2(e) {
  return ["html", "body", "#document"].includes(vu(e));
}
function ha(e) {
  return Lo(e).getComputedStyle(e);
}
function f2(e) {
  return cl(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function J0(e) {
  if (vu(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Kw(e) && e.host || // Fallback.
    vl(e)
  );
  return Kw(t) ? t.host : t;
}
function qO(e) {
  const t = J0(e);
  return p2(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : hs(t) && _f(t) ? t : qO(t);
}
function af(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = qO(e), o = i === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Lo(i);
  return o ? t.concat(a, a.visualViewport || [], _f(i) ? i : [], a.frameElement && n ? af(a.frameElement) : []) : t.concat(i, af(i, [], n));
}
function $O(e) {
  const t = ha(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = hs(e), o = i ? e.offsetWidth : n, a = i ? e.offsetHeight : r, s = Pm(n) !== o || Pm(r) !== a;
  return s && (n = o, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function yy(e) {
  return cl(e) ? e : e.contextElement;
}
function z0(e) {
  const t = yy(e);
  if (!hs(t))
    return gu(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = $O(t);
  let a = (o ? Pm(n.width) : n.width) / r, s = (o ? Pm(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const wie = /* @__PURE__ */ gu(0);
function HO(e) {
  const t = Lo(e);
  return !vy() || !t.visualViewport ? wie : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Cie(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Lo(e) ? !1 : t;
}
function Nc(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), o = yy(e);
  let a = gu(1);
  t && (r ? cl(r) && (a = z0(r)) : a = z0(e));
  const s = Cie(o, n, r) ? HO(o) : gu(0);
  let l = (i.left + s.x) / a.x, u = (i.top + s.y) / a.y, d = i.width / a.x, p = i.height / a.y;
  if (o) {
    const f = Lo(o), m = r && cl(r) ? Lo(r) : r;
    let y = f.frameElement;
    for (; y && r && m !== f; ) {
      const g = z0(y), x = y.getBoundingClientRect(), E = ha(y), b = x.left + (y.clientLeft + parseFloat(E.paddingLeft)) * g.x, C = x.top + (y.clientTop + parseFloat(E.paddingTop)) * g.y;
      l *= g.x, u *= g.y, d *= g.x, p *= g.y, l += b, u += C, y = Lo(y).frameElement;
    }
  }
  return qm({
    width: d,
    height: p,
    x: l,
    y: u
  });
}
function kie(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const i = hs(n), o = vl(n);
  if (n === o)
    return t;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = gu(1);
  const l = gu(0);
  if ((i || !i && r !== "fixed") && ((vu(n) !== "body" || _f(o)) && (a = f2(n)), hs(n))) {
    const u = Nc(n);
    s = z0(n), l.x = u.x + n.clientLeft, l.y = u.y + n.clientTop;
  }
  return {
    width: t.width * s.x,
    height: t.height * s.y,
    x: t.x * s.x - a.scrollLeft * s.x + l.x,
    y: t.y * s.y - a.scrollTop * s.y + l.y
  };
}
function Eie(e) {
  return Array.from(e.getClientRects());
}
function VO(e) {
  return Nc(vl(e)).left + f2(e).scrollLeft;
}
function Sie(e) {
  const t = vl(e), n = f2(e), r = e.ownerDocument.body, i = Eo(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = Eo(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + VO(e);
  const s = -n.scrollTop;
  return ha(r).direction === "rtl" && (a += Eo(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: a,
    y: s
  };
}
function Die(e, t) {
  const n = Lo(e), r = vl(e), i = n.visualViewport;
  let o = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (i) {
    o = i.width, a = i.height;
    const u = vy();
    (!u || u && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: o,
    height: a,
    x: s,
    y: l
  };
}
function Aie(e, t) {
  const n = Nc(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, o = hs(e) ? z0(e) : gu(1), a = e.clientWidth * o.x, s = e.clientHeight * o.y, l = i * o.x, u = r * o.y;
  return {
    width: a,
    height: s,
    x: l,
    y: u
  };
}
function Xw(e, t, n) {
  let r;
  if (t === "viewport")
    r = Die(e, n);
  else if (t === "document")
    r = Sie(vl(e));
  else if (cl(t))
    r = Aie(t, n);
  else {
    const i = HO(e);
    r = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return qm(r);
}
function UO(e, t) {
  const n = J0(e);
  return n === t || !cl(n) || p2(n) ? !1 : ha(n).position === "fixed" || UO(n, t);
}
function Tie(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = af(e, [], !1).filter((s) => cl(s) && vu(s) !== "body"), i = null;
  const o = ha(e).position === "fixed";
  let a = o ? J0(e) : e;
  for (; cl(a) && !p2(a); ) {
    const s = ha(a), l = gy(a);
    !l && s.position === "fixed" && (i = null), (o ? !l && !i : !l && s.position === "static" && i && ["absolute", "fixed"].includes(i.position) || _f(a) && !l && UO(e, a)) ? r = r.filter((u) => u !== a) : i = s, a = J0(a);
  }
  return t.set(e, r), r;
}
function jie(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const o = [...n === "clippingAncestors" ? Tie(t, this._c) : [].concat(n), r], a = o[0], s = o.reduce((l, u) => {
    const d = Xw(t, u, i);
    return l.top = Eo(d.top, l.top), l.right = mu(d.right, l.right), l.bottom = mu(d.bottom, l.bottom), l.left = Eo(d.left, l.left), l;
  }, Xw(t, a, i));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function Nie(e) {
  return $O(e);
}
function Oie(e, t, n) {
  const r = hs(t), i = vl(t), o = n === "fixed", a = Nc(e, !0, o, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = gu(0);
  if (r || !r && !o)
    if ((vu(t) !== "body" || _f(i)) && (s = f2(t)), r) {
      const u = Nc(t, !0, o, t);
      l.x = u.x + t.clientLeft, l.y = u.y + t.clientTop;
    } else i && (l.x = VO(i));
  return {
    x: a.left + s.scrollLeft - l.x,
    y: a.top + s.scrollTop - l.y,
    width: a.width,
    height: a.height
  };
}
function Qw(e, t) {
  return !hs(e) || ha(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function WO(e, t) {
  const n = Lo(e);
  if (!hs(e))
    return n;
  let r = Qw(e, t);
  for (; r && xie(r) && ha(r).position === "static"; )
    r = Qw(r, t);
  return r && (vu(r) === "html" || vu(r) === "body" && ha(r).position === "static" && !gy(r)) ? n : r || bie(e) || n;
}
const zie = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: r
  } = e;
  const i = this.getOffsetParent || WO, o = this.getDimensions;
  return {
    reference: Oie(t, await i(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await o(n)
    }
  };
};
function Fie(e) {
  return ha(e).direction === "rtl";
}
const Lie = {
  convertOffsetParentRelativeRectToViewportRelativeRect: kie,
  getDocumentElement: vl,
  getClippingRect: jie,
  getOffsetParent: WO,
  getElementRects: zie,
  getClientRects: Eie,
  getDimensions: Nie,
  getScale: z0,
  isElement: cl,
  isRTL: Fie
};
function Mie(e, t) {
  let n = null, r;
  const i = vl(e);
  function o() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), o();
    const {
      left: u,
      top: d,
      width: p,
      height: f
    } = e.getBoundingClientRect();
    if (s || t(), !p || !f)
      return;
    const m = Uh(d), y = Uh(i.clientWidth - (u + p)), g = Uh(i.clientHeight - (d + f)), x = Uh(u), E = {
      rootMargin: -m + "px " + -y + "px " + -g + "px " + -x + "px",
      threshold: Eo(0, mu(1, l)) || 1
    };
    let b = !0;
    function C(T) {
      const z = T[0].intersectionRatio;
      if (z !== l) {
        if (!b)
          return a();
        z ? a(!1, z) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 100);
      }
      b = !1;
    }
    try {
      n = new IntersectionObserver(C, {
        ...E,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(C, E);
    }
    n.observe(e);
  }
  return a(!0), o;
}
function Bie(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, u = yy(e), d = i || o ? [...u ? af(u) : [], ...af(t)] : [];
  d.forEach((E) => {
    i && E.addEventListener("scroll", n, {
      passive: !0
    }), o && E.addEventListener("resize", n);
  });
  const p = u && s ? Mie(u, n) : null;
  let f = -1, m = null;
  a && (m = new ResizeObserver((E) => {
    let [b] = E;
    b && b.target === u && m && (m.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      m && m.observe(t);
    })), n();
  }), u && !l && m.observe(u), m.observe(t));
  let y, g = l ? Nc(e) : null;
  l && x();
  function x() {
    const E = Nc(e);
    g && (E.x !== g.x || E.y !== g.y || E.width !== g.width || E.height !== g.height) && n(), g = E, y = requestAnimationFrame(x);
  }
  return n(), () => {
    d.forEach((E) => {
      i && E.removeEventListener("scroll", n), o && E.removeEventListener("resize", n);
    }), p && p(), m && m.disconnect(), m = null, l && cancelAnimationFrame(y);
  };
}
const Iie = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: Lie,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return die(e, t, {
    ...i,
    platform: o
  });
}, Rie = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Ww({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? Ww({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
};
var R1 = typeof document < "u" ? v.useLayoutEffect : v.useEffect;
function $m(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!$m(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = i[r];
      if (!(o === "_owner" && e.$$typeof) && !$m(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function ZO(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Yw(e, t) {
  const n = ZO(e);
  return Math.round(t * n) / n;
}
function Jw(e) {
  const t = v.useRef(e);
  return R1(() => {
    t.current = e;
  }), t;
}
function Pie(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: o,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: u
  } = e, [d, p] = v.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, m] = v.useState(r);
  $m(f, r) || m(r);
  const [y, g] = v.useState(null), [x, E] = v.useState(null), b = v.useCallback((D) => {
    D != I.current && (I.current = D, g(D));
  }, [g]), C = v.useCallback((D) => {
    D !== w.current && (w.current = D, E(D));
  }, [E]), T = o || y, z = a || x, I = v.useRef(null), w = v.useRef(null), M = v.useRef(d), R = Jw(l), F = Jw(i), W = v.useCallback(() => {
    if (!I.current || !w.current)
      return;
    const D = {
      placement: t,
      strategy: n,
      middleware: f
    };
    F.current && (D.platform = F.current), Iie(I.current, w.current, D).then((j) => {
      const de = {
        ...j,
        isPositioned: !0
      };
      X.current && !$m(M.current, de) && (M.current = de, ms.flushSync(() => {
        p(de);
      }));
    });
  }, [f, t, n, F]);
  R1(() => {
    u === !1 && M.current.isPositioned && (M.current.isPositioned = !1, p((D) => ({
      ...D,
      isPositioned: !1
    })));
  }, [u]);
  const X = v.useRef(!1);
  R1(() => (X.current = !0, () => {
    X.current = !1;
  }), []), R1(() => {
    if (T && (I.current = T), z && (w.current = z), T && z) {
      if (R.current)
        return R.current(T, z, W);
      W();
    }
  }, [T, z, W, R]);
  const le = v.useMemo(() => ({
    reference: I,
    floating: w,
    setReference: b,
    setFloating: C
  }), [b, C]), ne = v.useMemo(() => ({
    reference: T,
    floating: z
  }), [T, z]), fe = v.useMemo(() => {
    const D = {
      position: n,
      left: 0,
      top: 0
    };
    if (!ne.floating)
      return D;
    const j = Yw(ne.floating, d.x), de = Yw(ne.floating, d.y);
    return s ? {
      ...D,
      transform: "translate(" + j + "px, " + de + "px)",
      ...ZO(ne.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: j,
      top: de
    };
  }, [n, s, ne.floating, d.x, d.y]);
  return v.useMemo(() => ({
    ...d,
    update: W,
    refs: le,
    elements: ne,
    floatingStyles: fe
  }), [d, W, le, ne, fe]);
}
function _ie(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function qie(...e) {
  return (t) => e.forEach((n) => _ie(n, t));
}
var GO = v.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = v.Children.toArray(n), o = i.find(Hie);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? v.Children.count(a) > 1 ? v.Children.only(null) : v.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ c.jsx(x5, { ...r, ref: t, children: v.isValidElement(a) ? v.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ c.jsx(x5, { ...r, ref: t, children: n });
});
GO.displayName = "Slot";
var x5 = v.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (v.isValidElement(n)) {
    const i = Uie(n);
    return v.cloneElement(n, {
      ...Vie(r, n.props),
      // @ts-ignore
      ref: t ? qie(t, i) : i
    });
  }
  return v.Children.count(n) > 1 ? v.Children.only(null) : null;
});
x5.displayName = "SlotClone";
var $ie = ({ children: e }) => /* @__PURE__ */ c.jsx(c.Fragment, { children: e });
function Hie(e) {
  return v.isValidElement(e) && e.type === $ie;
}
function Vie(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...a) => {
      o(...a), i(...a);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Uie(e) {
  var t, n;
  let r = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, i = r && "isReactWarning" in r && r.isReactWarning;
  return i ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, i = r && "isReactWarning" in r && r.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var Wie = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Zie = Wie.reduce((e, t) => {
  const n = v.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? GO : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c.jsx(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Gie = "Arrow", KO = v.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = e;
  return /* @__PURE__ */ c.jsx(
    Zie.svg,
    {
      ...o,
      ref: t,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ c.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
KO.displayName = Gie;
var Kie = KO;
function Xie(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = v.createContext(a), l = n.length;
    n = [...n, a];
    function u(p) {
      const { scope: f, children: m, ...y } = p, g = (f == null ? void 0 : f[e][l]) || s, x = v.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ c.jsx(g.Provider, { value: x, children: m });
    }
    function d(p, f) {
      const m = (f == null ? void 0 : f[e][l]) || s, y = v.useContext(m);
      if (y) return y;
      if (a !== void 0) return a;
      throw new Error(`\`${p}\` must be used within \`${o}\``);
    }
    return u.displayName = o + "Provider", [u, d];
  }
  const i = () => {
    const o = n.map((a) => v.createContext(a));
    return function(a) {
      const s = (a == null ? void 0 : a[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: s } }),
        [a, s]
      );
    };
  };
  return i.scopeName = e, [r, Qie(i, ...t)];
}
function Qie(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(i) {
      const o = r.reduce((a, { useScope: s, scopeName: l }) => {
        const u = s(i)[`__scope${l}`];
        return { ...a, ...u };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var xy = v.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = v.Children.toArray(n), o = i.find(Jie);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? v.Children.count(a) > 1 ? v.Children.only(null) : v.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ c.jsx(b5, { ...r, ref: t, children: v.isValidElement(a) ? v.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ c.jsx(b5, { ...r, ref: t, children: n });
});
xy.displayName = "Slot";
var b5 = v.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (v.isValidElement(n)) {
    const i = toe(n);
    return v.cloneElement(n, {
      ...eoe(r, n.props),
      // @ts-ignore
      ref: t ? RO(t, i) : i
    });
  }
  return v.Children.count(n) > 1 ? v.Children.only(null) : null;
});
b5.displayName = "SlotClone";
var Yie = ({ children: e }) => /* @__PURE__ */ c.jsx(c.Fragment, { children: e });
function Jie(e) {
  return v.isValidElement(e) && e.type === Yie;
}
function eoe(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...a) => {
      o(...a), i(...a);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function toe(e) {
  var t, n;
  let r = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, i = r && "isReactWarning" in r && r.isReactWarning;
  return i ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, i = r && "isReactWarning" in r && r.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var noe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], so = noe.reduce((e, t) => {
  const n = v.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? xy : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c.jsx(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function roe(e) {
  const [t, n] = v.useState(void 0);
  return gr(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let a, s;
        if ("borderBoxSize" in o) {
          const l = o.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          a = u.inlineSize, s = u.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({ width: a, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var by = "Popper", [XO, QO] = Xie(by), [ioe, YO] = XO(by), JO = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = v.useState(null);
  return /* @__PURE__ */ c.jsx(ioe, { scope: t, anchor: r, onAnchorChange: i, children: n });
};
JO.displayName = by;
var ez = "PopperAnchor", tz = v.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...i } = e, o = YO(ez, n), a = v.useRef(null), s = xa(t, a);
    return v.useEffect(() => {
      o.onAnchorChange((r == null ? void 0 : r.current) || a.current);
    }), r ? null : /* @__PURE__ */ c.jsx(so.div, { ...i, ref: s });
  }
);
tz.displayName = ez;
var wy = "PopperContent", [ooe, aoe] = XO(wy), nz = v.forwardRef(
  (e, t) => {
    var n, r, i, o, a, s;
    const {
      __scopePopper: l,
      side: u = "bottom",
      sideOffset: d = 0,
      align: p = "center",
      alignOffset: f = 0,
      arrowPadding: m = 0,
      avoidCollisions: y = !0,
      collisionBoundary: g = [],
      collisionPadding: x = 0,
      sticky: E = "partial",
      hideWhenDetached: b = !1,
      updatePositionStrategy: C = "optimized",
      onPlaced: T,
      ...z
    } = e, I = YO(wy, l), [w, M] = v.useState(null), R = xa(t, (pt) => M(pt)), [F, W] = v.useState(null), X = roe(F), le = (X == null ? void 0 : X.width) ?? 0, ne = (X == null ? void 0 : X.height) ?? 0, fe = u + (p !== "center" ? "-" + p : ""), D = typeof x == "number" ? x : { top: 0, right: 0, bottom: 0, left: 0, ...x }, j = Array.isArray(g) ? g : [g], de = j.length > 0, ye = {
      padding: D,
      boundary: j.filter(loe),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: de
    }, { refs: Ne, floatingStyles: Me, placement: Ie, isPositioned: at, middlewareData: Ve } = Pie({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: fe,
      whileElementsMounted: (...pt) => Bie(...pt, {
        animationFrame: C === "always"
      }),
      elements: {
        reference: I.anchor
      },
      middleware: [
        mie({ mainAxis: d + ne, alignmentAxis: f }),
        y && gie({
          mainAxis: !0,
          crossAxis: !1,
          limiter: E === "partial" ? vie() : void 0,
          ...ye
        }),
        y && pie({ ...ye }),
        yie({
          ...ye,
          apply: ({ elements: pt, rects: Tt, availableWidth: Wt, availableHeight: et }) => {
            const { width: At, height: Gt } = Tt.reference, Lt = pt.floating.style;
            Lt.setProperty("--radix-popper-available-width", `${Wt}px`), Lt.setProperty("--radix-popper-available-height", `${et}px`), Lt.setProperty("--radix-popper-anchor-width", `${At}px`), Lt.setProperty("--radix-popper-anchor-height", `${Gt}px`);
          }
        }),
        F && Rie({ element: F, padding: m }),
        uoe({ arrowWidth: le, arrowHeight: ne }),
        b && fie({ strategy: "referenceHidden", ...ye })
      ]
    }), [mt, ae] = oz(Ie), Se = Nr(T);
    gr(() => {
      at && (Se == null || Se());
    }, [at, Se]);
    const Ae = (n = Ve.arrow) == null ? void 0 : n.x, Be = (r = Ve.arrow) == null ? void 0 : r.y, Ze = ((i = Ve.arrow) == null ? void 0 : i.centerOffset) !== 0, [We, St] = v.useState();
    return gr(() => {
      w && St(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ c.jsx(
      "div",
      {
        ref: Ne.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...Me,
          transform: at ? Me.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: We,
          "--radix-popper-transform-origin": [
            (o = Ve.transformOrigin) == null ? void 0 : o.x,
            (a = Ve.transformOrigin) == null ? void 0 : a.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((s = Ve.hide) == null ? void 0 : s.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ c.jsx(
          ooe,
          {
            scope: l,
            placedSide: mt,
            onArrowChange: W,
            arrowX: Ae,
            arrowY: Be,
            shouldHideArrow: Ze,
            children: /* @__PURE__ */ c.jsx(
              so.div,
              {
                "data-side": mt,
                "data-align": ae,
                ...z,
                ref: R,
                style: {
                  ...z.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: at ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
nz.displayName = wy;
var rz = "PopperArrow", soe = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, iz = v.forwardRef(function(e, t) {
  const { __scopePopper: n, ...r } = e, i = aoe(rz, n), o = soe[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ c.jsx(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [o]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ c.jsx(
          Kie,
          {
            ...r,
            ref: t,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
iz.displayName = rz;
function loe(e) {
  return e !== null;
}
var uoe = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, i;
    const { placement: o, rects: a, middlewareData: s } = t, l = ((n = s.arrow) == null ? void 0 : n.centerOffset) !== 0, u = l ? 0 : e.arrowWidth, d = l ? 0 : e.arrowHeight, [p, f] = oz(o), m = { start: "0%", center: "50%", end: "100%" }[f], y = (((r = s.arrow) == null ? void 0 : r.x) ?? 0) + u / 2, g = (((i = s.arrow) == null ? void 0 : i.y) ?? 0) + d / 2;
    let x = "", E = "";
    return p === "bottom" ? (x = l ? m : `${y}px`, E = `${-d}px`) : p === "top" ? (x = l ? m : `${y}px`, E = `${a.floating.height + d}px`) : p === "right" ? (x = `${-d}px`, E = l ? m : `${g}px`) : p === "left" && (x = `${a.floating.width + d}px`, E = l ? m : `${g}px`), { data: { x, y: E } };
  }
});
function oz(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var coe = JO, doe = tz, poe = nz, foe = iz;
function e9({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, i] = hoe({ defaultProp: t, onChange: n }), o = e !== void 0, a = o ? e : r, s = Nr(n), l = v.useCallback(
    (u) => {
      if (o) {
        const d = typeof u == "function" ? u(e) : u;
        d !== e && s(d);
      } else
        i(u);
    },
    [o, e, i, s]
  );
  return [a, l];
}
function hoe({
  defaultProp: e,
  onChange: t
}) {
  const n = v.useState(e), [r] = n, i = v.useRef(r), o = Nr(t);
  return v.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [r, i, o]), n;
}
var moe = [" ", "Enter", "ArrowUp", "ArrowDown"], goe = [" ", "Enter"], qf = "Select", [h2, m2, voe] = $7(qf), [vd, d7e] = Jre(qf, [
  voe,
  QO
]), g2 = QO(), [yoe, ju] = vd(qf), [xoe, boe] = vd(qf), az = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    value: a,
    defaultValue: s,
    onValueChange: l,
    dir: u,
    name: d,
    autoComplete: p,
    disabled: f,
    required: m,
    form: y
  } = e, g = g2(t), [x, E] = v.useState(null), [b, C] = v.useState(null), [T, z] = v.useState(!1), I = Qj(u), [w = !1, M] = e9({
    prop: r,
    defaultProp: i,
    onChange: o
  }), [R, F] = e9({
    prop: a,
    defaultProp: s,
    onChange: l
  }), W = v.useRef(null), X = x ? y || !!x.closest("form") : !0, [le, ne] = v.useState(/* @__PURE__ */ new Set()), fe = Array.from(le).map((D) => D.props.value).join(";");
  return /* @__PURE__ */ c.jsx(coe, { ...g, children: /* @__PURE__ */ c.jsxs(
    yoe,
    {
      required: m,
      scope: t,
      trigger: x,
      onTriggerChange: E,
      valueNode: b,
      onValueNodeChange: C,
      valueNodeHasChildren: T,
      onValueNodeHasChildrenChange: z,
      contentId: py(),
      value: R,
      onValueChange: F,
      open: w,
      onOpenChange: M,
      dir: I,
      triggerPointerDownPosRef: W,
      disabled: f,
      children: [
        /* @__PURE__ */ c.jsx(h2.Provider, { scope: t, children: /* @__PURE__ */ c.jsx(
          xoe,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: v.useCallback((D) => {
              ne((j) => new Set(j).add(D));
            }, []),
            onNativeOptionRemove: v.useCallback((D) => {
              ne((j) => {
                const de = new Set(j);
                return de.delete(D), de;
              });
            }, []),
            children: n
          }
        ) }),
        X ? /* @__PURE__ */ c.jsxs(
          Sz,
          {
            "aria-hidden": !0,
            required: m,
            tabIndex: -1,
            name: d,
            autoComplete: p,
            value: R,
            onChange: (D) => F(D.target.value),
            disabled: f,
            form: y,
            children: [
              R === void 0 ? /* @__PURE__ */ c.jsx("option", { value: "" }) : null,
              Array.from(le)
            ]
          },
          fe
        ) : null
      ]
    }
  ) });
};
az.displayName = qf;
var sz = "SelectTrigger", lz = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...i } = e, o = g2(n), a = ju(sz, n), s = a.disabled || r, l = xa(t, a.onTriggerChange), u = m2(n), d = v.useRef("touch"), [p, f, m] = Dz((g) => {
      const x = u().filter((C) => !C.disabled), E = x.find((C) => C.value === a.value), b = Az(x, g, E);
      b !== void 0 && a.onValueChange(b.value);
    }), y = (g) => {
      s || (a.onOpenChange(!0), m()), g && (a.triggerPointerDownPosRef.current = {
        x: Math.round(g.pageX),
        y: Math.round(g.pageY)
      });
    };
    return /* @__PURE__ */ c.jsx(doe, { asChild: !0, ...o, children: /* @__PURE__ */ c.jsx(
      so.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": Ez(a.value) ? "" : void 0,
        ...i,
        ref: l,
        onClick: ni(i.onClick, (g) => {
          g.currentTarget.focus(), d.current !== "mouse" && y(g);
        }),
        onPointerDown: ni(i.onPointerDown, (g) => {
          d.current = g.pointerType;
          const x = g.target;
          x.hasPointerCapture(g.pointerId) && x.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && g.pointerType === "mouse" && (y(g), g.preventDefault());
        }),
        onKeyDown: ni(i.onKeyDown, (g) => {
          const x = p.current !== "";
          !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && f(g.key), !(x && g.key === " ") && moe.includes(g.key) && (y(), g.preventDefault());
        })
      }
    ) });
  }
);
lz.displayName = sz;
var uz = "SelectValue", cz = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: i, children: o, placeholder: a = "", ...s } = e, l = ju(uz, n), { onValueNodeHasChildrenChange: u } = l, d = o !== void 0, p = xa(t, l.onValueNodeChange);
    return gr(() => {
      u(d);
    }, [u, d]), /* @__PURE__ */ c.jsx(
      so.span,
      {
        ...s,
        ref: p,
        style: { pointerEvents: "none" },
        children: Ez(l.value) ? /* @__PURE__ */ c.jsx(c.Fragment, { children: a }) : o
      }
    );
  }
);
cz.displayName = uz;
var woe = "SelectIcon", dz = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...i } = e;
    return /* @__PURE__ */ c.jsx(so.span, { "aria-hidden": !0, ...i, ref: t, children: r || "▼" });
  }
);
dz.displayName = woe;
var Oc = "SelectContent", pz = v.forwardRef(
  (e, t) => {
    const n = ju(Oc, e.__scopeSelect), [r, i] = v.useState();
    if (gr(() => {
      i(new DocumentFragment());
    }, []), !n.open) {
      const o = r;
      return o ? ms.createPortal(
        /* @__PURE__ */ c.jsx(fz, { scope: e.__scopeSelect, children: /* @__PURE__ */ c.jsx(h2.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ c.jsx("div", { children: e.children }) }) }),
        o
      ) : null;
    }
    return /* @__PURE__ */ c.jsx(hz, { ...e, ref: t });
  }
);
pz.displayName = Oc;
var Na = 10, [fz, Nu] = vd(Oc), Coe = "SelectContentImpl", hz = v.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: i,
      onEscapeKeyDown: o,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: u,
      alignOffset: d,
      arrowPadding: p,
      collisionBoundary: f,
      collisionPadding: m,
      sticky: y,
      hideWhenDetached: g,
      avoidCollisions: x,
      //
      ...E
    } = e, b = ju(Oc, n), [C, T] = v.useState(null), [z, I] = v.useState(null), w = xa(t, (Se) => T(Se)), [M, R] = v.useState(null), [F, W] = v.useState(
      null
    ), X = m2(n), [le, ne] = v.useState(!1), fe = v.useRef(!1);
    v.useEffect(() => {
      if (C) return zj(C);
    }, [C]), kj();
    const D = v.useCallback(
      (Se) => {
        const [Ae, ...Be] = X().map((St) => St.ref.current), [Ze] = Be.slice(-1), We = document.activeElement;
        for (const St of Se)
          if (St === We || (St == null || St.scrollIntoView({ block: "nearest" }), St === Ae && z && (z.scrollTop = 0), St === Ze && z && (z.scrollTop = z.scrollHeight), St == null || St.focus(), document.activeElement !== We)) return;
      },
      [X, z]
    ), j = v.useCallback(
      () => D([M, C]),
      [D, M, C]
    );
    v.useEffect(() => {
      le && j();
    }, [le, j]);
    const { onOpenChange: de, triggerPointerDownPosRef: ye } = b;
    v.useEffect(() => {
      if (C) {
        let Se = { x: 0, y: 0 };
        const Ae = (Ze) => {
          var We, St;
          Se = {
            x: Math.abs(Math.round(Ze.pageX) - (((We = ye.current) == null ? void 0 : We.x) ?? 0)),
            y: Math.abs(Math.round(Ze.pageY) - (((St = ye.current) == null ? void 0 : St.y) ?? 0))
          };
        }, Be = (Ze) => {
          Se.x <= 10 && Se.y <= 10 ? Ze.preventDefault() : C.contains(Ze.target) || de(!1), document.removeEventListener("pointermove", Ae), ye.current = null;
        };
        return ye.current !== null && (document.addEventListener("pointermove", Ae), document.addEventListener("pointerup", Be, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Ae), document.removeEventListener("pointerup", Be, { capture: !0 });
        };
      }
    }, [C, de, ye]), v.useEffect(() => {
      const Se = () => de(!1);
      return window.addEventListener("blur", Se), window.addEventListener("resize", Se), () => {
        window.removeEventListener("blur", Se), window.removeEventListener("resize", Se);
      };
    }, [de]);
    const [Ne, Me] = Dz((Se) => {
      const Ae = X().filter((We) => !We.disabled), Be = Ae.find((We) => We.ref.current === document.activeElement), Ze = Az(Ae, Se, Be);
      Ze && setTimeout(() => Ze.ref.current.focus());
    }), Ie = v.useCallback(
      (Se, Ae, Be) => {
        const Ze = !fe.current && !Be;
        (b.value !== void 0 && b.value === Ae || Ze) && (R(Se), Ze && (fe.current = !0));
      },
      [b.value]
    ), at = v.useCallback(() => C == null ? void 0 : C.focus(), [C]), Ve = v.useCallback(
      (Se, Ae, Be) => {
        const Ze = !fe.current && !Be;
        (b.value !== void 0 && b.value === Ae || Ze) && W(Se);
      },
      [b.value]
    ), mt = r === "popper" ? w5 : mz, ae = mt === w5 ? {
      side: s,
      sideOffset: l,
      align: u,
      alignOffset: d,
      arrowPadding: p,
      collisionBoundary: f,
      collisionPadding: m,
      sticky: y,
      hideWhenDetached: g,
      avoidCollisions: x
    } : {};
    return /* @__PURE__ */ c.jsx(
      fz,
      {
        scope: n,
        content: C,
        viewport: z,
        onViewportChange: I,
        itemRefCallback: Ie,
        selectedItem: M,
        onItemLeave: at,
        itemTextRefCallback: Ve,
        focusSelectedItem: j,
        selectedItemText: F,
        position: r,
        isPositioned: le,
        searchRef: Ne,
        children: /* @__PURE__ */ c.jsx(B7, { as: xy, allowPinchZoom: !0, children: /* @__PURE__ */ c.jsx(
          L7,
          {
            asChild: !0,
            trapped: b.open,
            onMountAutoFocus: (Se) => {
              Se.preventDefault();
            },
            onUnmountAutoFocus: ni(i, (Se) => {
              var Ae;
              (Ae = b.trigger) == null || Ae.focus({ preventScroll: !0 }), Se.preventDefault();
            }),
            children: /* @__PURE__ */ c.jsx(
              Zg,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: o,
                onPointerDownOutside: a,
                onFocusOutside: (Se) => Se.preventDefault(),
                onDismiss: () => b.onOpenChange(!1),
                children: /* @__PURE__ */ c.jsx(
                  mt,
                  {
                    role: "listbox",
                    id: b.contentId,
                    "data-state": b.open ? "open" : "closed",
                    dir: b.dir,
                    onContextMenu: (Se) => Se.preventDefault(),
                    ...E,
                    ...ae,
                    onPlaced: () => ne(!0),
                    ref: w,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...E.style
                    },
                    onKeyDown: ni(E.onKeyDown, (Se) => {
                      const Ae = Se.ctrlKey || Se.altKey || Se.metaKey;
                      if (Se.key === "Tab" && Se.preventDefault(), !Ae && Se.key.length === 1 && Me(Se.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(Se.key)) {
                        let Be = X().filter((Ze) => !Ze.disabled).map((Ze) => Ze.ref.current);
                        if (["ArrowUp", "End"].includes(Se.key) && (Be = Be.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(Se.key)) {
                          const Ze = Se.target, We = Be.indexOf(Ze);
                          Be = Be.slice(We + 1);
                        }
                        setTimeout(() => D(Be)), Se.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
hz.displayName = Coe;
var koe = "SelectItemAlignedPosition", mz = v.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...i } = e, o = ju(Oc, n), a = Nu(Oc, n), [s, l] = v.useState(null), [u, d] = v.useState(null), p = xa(t, (w) => d(w)), f = m2(n), m = v.useRef(!1), y = v.useRef(!0), { viewport: g, selectedItem: x, selectedItemText: E, focusSelectedItem: b } = a, C = v.useCallback(() => {
    if (o.trigger && o.valueNode && s && u && g && x && E) {
      const w = o.trigger.getBoundingClientRect(), M = u.getBoundingClientRect(), R = o.valueNode.getBoundingClientRect(), F = E.getBoundingClientRect();
      if (o.dir !== "rtl") {
        const Ze = F.left - M.left, We = R.left - Ze, St = w.left - We, pt = w.width + St, Tt = Math.max(pt, M.width), Wt = window.innerWidth - Na, et = Vw(We, [
          Na,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Na, Wt - Tt)
        ]);
        s.style.minWidth = pt + "px", s.style.left = et + "px";
      } else {
        const Ze = M.right - F.right, We = window.innerWidth - R.right - Ze, St = window.innerWidth - w.right - We, pt = w.width + St, Tt = Math.max(pt, M.width), Wt = window.innerWidth - Na, et = Vw(We, [
          Na,
          Math.max(Na, Wt - Tt)
        ]);
        s.style.minWidth = pt + "px", s.style.right = et + "px";
      }
      const W = f(), X = window.innerHeight - Na * 2, le = g.scrollHeight, ne = window.getComputedStyle(u), fe = parseInt(ne.borderTopWidth, 10), D = parseInt(ne.paddingTop, 10), j = parseInt(ne.borderBottomWidth, 10), de = parseInt(ne.paddingBottom, 10), ye = fe + D + le + de + j, Ne = Math.min(x.offsetHeight * 5, ye), Me = window.getComputedStyle(g), Ie = parseInt(Me.paddingTop, 10), at = parseInt(Me.paddingBottom, 10), Ve = w.top + w.height / 2 - Na, mt = X - Ve, ae = x.offsetHeight / 2, Se = x.offsetTop + ae, Ae = fe + D + Se, Be = ye - Ae;
      if (Ae <= Ve) {
        const Ze = W.length > 0 && x === W[W.length - 1].ref.current;
        s.style.bottom = "0px";
        const We = u.clientHeight - g.offsetTop - g.offsetHeight, St = Math.max(
          mt,
          ae + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (Ze ? at : 0) + We + j
        ), pt = Ae + St;
        s.style.height = pt + "px";
      } else {
        const Ze = W.length > 0 && x === W[0].ref.current;
        s.style.top = "0px";
        const We = Math.max(
          Ve,
          fe + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (Ze ? Ie : 0) + ae
        ) + Be;
        s.style.height = We + "px", g.scrollTop = Ae - Ve + g.offsetTop;
      }
      s.style.margin = `${Na}px 0`, s.style.minHeight = Ne + "px", s.style.maxHeight = X + "px", r == null || r(), requestAnimationFrame(() => m.current = !0);
    }
  }, [
    f,
    o.trigger,
    o.valueNode,
    s,
    u,
    g,
    x,
    E,
    o.dir,
    r
  ]);
  gr(() => C(), [C]);
  const [T, z] = v.useState();
  gr(() => {
    u && z(window.getComputedStyle(u).zIndex);
  }, [u]);
  const I = v.useCallback(
    (w) => {
      w && y.current === !0 && (C(), b == null || b(), y.current = !1);
    },
    [C, b]
  );
  return /* @__PURE__ */ c.jsx(
    Soe,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: m,
      onScrollButtonChange: I,
      children: /* @__PURE__ */ c.jsx(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: T
          },
          children: /* @__PURE__ */ c.jsx(
            so.div,
            {
              ...i,
              ref: p,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...i.style
              }
            }
          )
        }
      )
    }
  );
});
mz.displayName = koe;
var Eoe = "SelectPopperPosition", w5 = v.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: i = Na,
    ...o
  } = e, a = g2(n);
  return /* @__PURE__ */ c.jsx(
    poe,
    {
      ...a,
      ...o,
      ref: t,
      align: r,
      collisionPadding: i,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...o.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
w5.displayName = Eoe;
var [Soe, Cy] = vd(Oc, {}), C5 = "SelectViewport", gz = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...i } = e, o = Nu(C5, n), a = Cy(C5, n), s = xa(t, o.onViewportChange), l = v.useRef(0);
    return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ c.jsx(h2.Slot, { scope: n, children: /* @__PURE__ */ c.jsx(
        so.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...i,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...i.style
          },
          onScroll: ni(i.onScroll, (u) => {
            const d = u.currentTarget, { contentWrapper: p, shouldExpandOnScrollRef: f } = a;
            if (f != null && f.current && p) {
              const m = Math.abs(l.current - d.scrollTop);
              if (m > 0) {
                const y = window.innerHeight - Na * 2, g = parseFloat(p.style.minHeight), x = parseFloat(p.style.height), E = Math.max(g, x);
                if (E < y) {
                  const b = E + m, C = Math.min(y, b), T = b - C;
                  p.style.height = C + "px", p.style.bottom === "0px" && (d.scrollTop = T > 0 ? T : 0, p.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = d.scrollTop;
          })
        }
      ) })
    ] });
  }
);
gz.displayName = C5;
var vz = "SelectGroup", [Doe, Aoe] = vd(vz), Toe = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = py();
    return /* @__PURE__ */ c.jsx(Doe, { scope: n, id: i, children: /* @__PURE__ */ c.jsx(so.div, { role: "group", "aria-labelledby": i, ...r, ref: t }) });
  }
);
Toe.displayName = vz;
var yz = "SelectLabel", joe = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = Aoe(yz, n);
    return /* @__PURE__ */ c.jsx(so.div, { id: i.id, ...r, ref: t });
  }
);
joe.displayName = yz;
var Hm = "SelectItem", [Noe, xz] = vd(Hm), bz = v.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: i = !1,
      textValue: o,
      ...a
    } = e, s = ju(Hm, n), l = Nu(Hm, n), u = s.value === r, [d, p] = v.useState(o ?? ""), [f, m] = v.useState(!1), y = xa(
      t,
      (b) => {
        var C;
        return (C = l.itemRefCallback) == null ? void 0 : C.call(l, b, r, i);
      }
    ), g = py(), x = v.useRef("touch"), E = () => {
      i || (s.onValueChange(r), s.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ c.jsx(
      Noe,
      {
        scope: n,
        value: r,
        disabled: i,
        textId: g,
        isSelected: u,
        onItemTextChange: v.useCallback((b) => {
          p((C) => C || ((b == null ? void 0 : b.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ c.jsx(
          h2.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: i,
            textValue: d,
            children: /* @__PURE__ */ c.jsx(
              so.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": f ? "" : void 0,
                "aria-selected": u && f,
                "data-state": u ? "checked" : "unchecked",
                "aria-disabled": i || void 0,
                "data-disabled": i ? "" : void 0,
                tabIndex: i ? void 0 : -1,
                ...a,
                ref: y,
                onFocus: ni(a.onFocus, () => m(!0)),
                onBlur: ni(a.onBlur, () => m(!1)),
                onClick: ni(a.onClick, () => {
                  x.current !== "mouse" && E();
                }),
                onPointerUp: ni(a.onPointerUp, () => {
                  x.current === "mouse" && E();
                }),
                onPointerDown: ni(a.onPointerDown, (b) => {
                  x.current = b.pointerType;
                }),
                onPointerMove: ni(a.onPointerMove, (b) => {
                  var C;
                  x.current = b.pointerType, i ? (C = l.onItemLeave) == null || C.call(l) : x.current === "mouse" && b.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: ni(a.onPointerLeave, (b) => {
                  var C;
                  b.currentTarget === document.activeElement && ((C = l.onItemLeave) == null || C.call(l));
                }),
                onKeyDown: ni(a.onKeyDown, (b) => {
                  var C;
                  ((C = l.searchRef) == null ? void 0 : C.current) !== "" && b.key === " " || (goe.includes(b.key) && E(), b.key === " " && b.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
bz.displayName = Hm;
var np = "SelectItemText", wz = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: i, ...o } = e, a = ju(np, n), s = Nu(np, n), l = xz(np, n), u = boe(np, n), [d, p] = v.useState(null), f = xa(
      t,
      (E) => p(E),
      l.onItemTextChange,
      (E) => {
        var b;
        return (b = s.itemTextRefCallback) == null ? void 0 : b.call(s, E, l.value, l.disabled);
      }
    ), m = d == null ? void 0 : d.textContent, y = v.useMemo(
      () => /* @__PURE__ */ c.jsx("option", { value: l.value, disabled: l.disabled, children: m }, l.value),
      [l.disabled, l.value, m]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: x } = u;
    return gr(() => (g(y), () => x(y)), [g, x, y]), /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx(so.span, { id: l.textId, ...o, ref: f }),
      l.isSelected && a.valueNode && !a.valueNodeHasChildren ? ms.createPortal(o.children, a.valueNode) : null
    ] });
  }
);
wz.displayName = np;
var Cz = "SelectItemIndicator", Ooe = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return xz(Cz, n).isSelected ? /* @__PURE__ */ c.jsx(so.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
Ooe.displayName = Cz;
var k5 = "SelectScrollUpButton", zoe = v.forwardRef((e, t) => {
  const n = Nu(k5, e.__scopeSelect), r = Cy(k5, e.__scopeSelect), [i, o] = v.useState(!1), a = xa(t, r.onScrollButtonChange);
  return gr(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const u = l.scrollTop > 0;
        o(u);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ c.jsx(
    kz,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
zoe.displayName = k5;
var E5 = "SelectScrollDownButton", Foe = v.forwardRef((e, t) => {
  const n = Nu(E5, e.__scopeSelect), r = Cy(E5, e.__scopeSelect), [i, o] = v.useState(!1), a = xa(t, r.onScrollButtonChange);
  return gr(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const u = l.scrollHeight - l.clientHeight, d = Math.ceil(l.scrollTop) < u;
        o(d);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ c.jsx(
    kz,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
Foe.displayName = E5;
var kz = v.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...i } = e, o = Nu("SelectScrollButton", n), a = v.useRef(null), s = m2(n), l = v.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return v.useEffect(() => () => l(), [l]), gr(() => {
    var u;
    const d = s().find((p) => p.ref.current === document.activeElement);
    (u = d == null ? void 0 : d.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ c.jsx(
    so.div,
    {
      "aria-hidden": !0,
      ...i,
      ref: t,
      style: { flexShrink: 0, ...i.style },
      onPointerDown: ni(i.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerMove: ni(i.onPointerMove, () => {
        var u;
        (u = o.onItemLeave) == null || u.call(o), a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerLeave: ni(i.onPointerLeave, () => {
        l();
      })
    }
  );
}), Loe = "SelectSeparator", Moe = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ c.jsx(so.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
Moe.displayName = Loe;
var S5 = "SelectArrow", Boe = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = g2(n), o = ju(S5, n), a = Nu(S5, n);
    return o.open && a.position === "popper" ? /* @__PURE__ */ c.jsx(foe, { ...i, ...r, ref: t }) : null;
  }
);
Boe.displayName = S5;
function Ez(e) {
  return e === "" || e === void 0;
}
var Sz = v.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, i = v.useRef(null), o = xa(t, i), a = eN(n);
    return v.useEffect(() => {
      const s = i.current, l = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (a !== n && u) {
        const d = new Event("change", { bubbles: !0 });
        u.call(s, n), s.dispatchEvent(d);
      }
    }, [a, n]), /* @__PURE__ */ c.jsx(H7, { asChild: !0, children: /* @__PURE__ */ c.jsx("select", { ...r, ref: o, defaultValue: n }) });
  }
);
Sz.displayName = "BubbleSelect";
function Dz(e) {
  const t = Nr(e), n = v.useRef(""), r = v.useRef(0), i = v.useCallback(
    (a) => {
      const s = n.current + a;
      t(s), function l(u) {
        n.current = u, window.clearTimeout(r.current), u !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(s);
    },
    [t]
  ), o = v.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return v.useEffect(() => () => window.clearTimeout(r.current), []), [n, i, o];
}
function Az(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((s) => s === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let o = Ioe(e, Math.max(i, 0));
  r.length === 1 && (o = o.filter((s) => s !== n));
  const a = o.find(
    (s) => s.textValue.toLowerCase().startsWith(r.toLowerCase())
  );
  return a !== n ? a : void 0;
}
function Ioe(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Roe = az, Poe = lz, _oe = cz, qoe = dz, $oe = pz, Hoe = gz, Voe = bz, Uoe = wz;
const Woe = ({
  label: e,
  helpText: t,
  onChange: n,
  defaultValue: r,
  options: i,
  className: o,
  isConfirmed: a,
  showConfirmation: s
}) => {
  const [l, u] = v.useState(r), [d, p] = v.useState(!1), [f, m] = v.useState(0), [y, g] = v.useState(a ?? !1), [x, E] = v.useState(!1), b = v.useRef(null), C = (T) => {
    u(T), n == null || n(T), g(!0);
  };
  return v.useEffect(() => {
    b.current && m(b.current.offsetWidth);
  }, []), v.useEffect(() => {
    d && !x ? E(!0) : !d && x && g(!0);
  }, [d, x]), v.useEffect(() => {
    u(r);
  }, [r]), /* @__PURE__ */ c.jsxs(
    "label",
    {
      className: Le(
        "h-100 mx-auto mb-0 mt-5 flex items-center text-almost-black",
        o
      ),
      children: [
        /* @__PURE__ */ c.jsxs("span", { className: "serlo-tooltip-trigger flex w-1/4 justify-between pr-[15px]", children: [
          e,
          /* @__PURE__ */ c.jsx(ot, { className: "ml-2", icon: dj }),
          /* @__PURE__ */ c.jsx(vn, { text: t })
        ] }),
        /* @__PURE__ */ c.jsx("span", { className: "flex w-1/2 flex-row border-2 border-transparent", children: /* @__PURE__ */ c.jsxs(
          Roe,
          {
            onValueChange: C,
            defaultValue: r,
            onOpenChange: p,
            value: l,
            children: [
              /* @__PURE__ */ c.jsxs(
                Poe,
                {
                  ref: b,
                  onKeyDown: (T) => T.stopPropagation(),
                  className: Le(
                    "serlo-input-font-reset rounded-md border-2 bg-editor-primary-100 px-2 text-left focus:border-2 focus:border-editor-primary",
                    "flex w-full flex-row justify-between",
                    d ? "rounded-b-none border-b-0 border-editor-primary" : "border-editor-primary-100"
                  ),
                  style: { height: "1.75em" },
                  children: [
                    /* @__PURE__ */ c.jsx(_oe, {}),
                    /* @__PURE__ */ c.jsx(qoe, { className: "ml-2 text-almost-black", children: /* @__PURE__ */ c.jsx(ot, { icon: d ? fV : NV }) })
                  ]
                }
              ),
              /* @__PURE__ */ c.jsx(
                $oe,
                {
                  className: "mx-auto mt-[-2px] rounded-md rounded-t-none border-2 border-editor-primary bg-white",
                  side: "bottom",
                  position: "popper",
                  onKeyDown: (T) => T.stopPropagation(),
                  style: { width: f, borderTop: "none" },
                  children: /* @__PURE__ */ c.jsx(Hoe, { children: i.map(({ label: T, value: z }) => /* @__PURE__ */ c.jsx(
                    Voe,
                    {
                      value: z.toString(),
                      className: "my-0 px-3 hover:bg-editor-primary-100 focus:bg-editor-primary-100",
                      children: /* @__PURE__ */ c.jsx(Uoe, { children: T })
                    },
                    z.toString()
                  )) })
                }
              )
            ]
          }
        ) }),
        s && y && /* @__PURE__ */ c.jsx("span", { className: "pointer-events-none ml-2 inline-flex items-center pr-3 text-green-500", children: "✓" })
      ]
    }
  );
};
var D5 = /* @__PURE__ */ ((e) => (e.CCBYSA4 = "CC BY-SA 4.0", e.CCBYSA3 = "CC BY-SA 3.0", e.CCBYSA2 = "CC BY-SA 2.0", e.CCBY = "CC BY", e.CCO = "CCO", e.Pixabay = "Pixabay License", e.PublicDomain = "Public Domain", e))(D5 || {});
const Tz = ({
  onLicenseChange: e,
  src: t,
  currentLicence: n
}) => {
  const { licence: r, licenceHelpText: i } = nt().plugins.image, [o, a] = v.useState(!!(t != null && t.includes("pixabay"))), [s, l] = v.useState(
    n || "CCBYSA4"
  ), u = (d) => {
    d && (l(d), e == null || e(d), a(!0));
  };
  return /* @__PURE__ */ c.jsx(
    Woe,
    {
      options: Object.keys(D5).map((d) => ({
        label: D5[d],
        value: d
      })),
      onChange: u,
      label: r,
      helpText: i,
      defaultValue: s,
      isConfirmed: o,
      showConfirmation: !0
    }
  );
};
function Zoe({ id: e }) {
  const t = nt().plugins.image, n = Ur(), r = yn((p) => bi(p, e));
  if (!r) return null;
  const i = r.state, { alt: o, src: a, imageSource: s, licence: l } = i;
  function u(p, f) {
    if (!e) return;
    const m = Object.hasOwn(i[p], "defined") ? f.length ? { defined: !0, value: f } : { defined: !1, value: null } : f;
    n(
      ad({
        id: e,
        state: { initial: () => ({ ...i, [p]: m }) }
      })
    );
  }
  const d = a ? String(a) : "";
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      Rm,
      {
        label: t.imageUrl,
        autoFocus: !0,
        placeholder: t.placeholderEmpty,
        value: d,
        onChange: (p) => u("src", p.target.value)
      }
    ),
    /* @__PURE__ */ c.jsx(
      Rm,
      {
        label: t.imageSource,
        placeholder: t.placeholderSource,
        value: s.defined ? s.value : "",
        onChange: (p) => u("imageSource", p.target.value),
        tooltip: /* @__PURE__ */ c.jsxs("span", { className: "serlo-tooltip-trigger w-1/4", children: [
          /* @__PURE__ */ c.jsx(ot, { className: "ml-2", icon: fT }),
          /* @__PURE__ */ c.jsx(vn, { text: t.imageSourceHelpText })
        ] })
      }
    ),
    /* @__PURE__ */ c.jsx(
      Tz,
      {
        currentLicence: l != null && l.defined ? l == null ? void 0 : l.value : void 0,
        onLicenseChange: (p) => u("licence", p),
        src: d
      }
    ),
    /* @__PURE__ */ c.jsxs("label", { className: "mx-auto mb-0 mt-5 flex flex-row justify-between", children: [
      /* @__PURE__ */ c.jsx("span", { className: "w-[20%]", children: t.alt }),
      /* @__PURE__ */ c.jsx(
        "textarea",
        {
          placeholder: t.altPlaceholder,
          value: o.defined ? o.value : "",
          onChange: (p) => u("alt", p.target.value),
          className: Le(`
            serlo-input-font-reset
            mt-1.5 min-h-[100px] w-3/4 resize-none rounded-md
            border-2 border-editor-primary-100  bg-editor-primary-100 p-2.5 
            focus:border-editor-primary-300 focus:outline-none
          `)
        }
      )
    ] })
  ] });
}
function Goe({
  backgroundImage: e,
  showSettings: t,
  showSettingsButton: n = !1,
  dropzoneVisibility: r,
  containerRef: i
}) {
  const [o, a] = v.useState(!1), s = nt(), l = s.plugins.dropzoneImage, u = s.plugins.image, d = Object.entries(l.visibilityOptions), p = Ur(), f = v.useCallback(() => {
    e != null && e.defined && p(
      ad({
        id: e.id,
        state: { initial: (g) => ({ ...g, src: "" }) }
      })
    );
  }, [e, p]);
  return t ? /* @__PURE__ */ c.jsx(Yg, { containerRef: i, children: m() }) : null;
  function m() {
    if (!(!r && !n))
      return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
        n ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
          /* @__PURE__ */ c.jsxs(
            "button",
            {
              onClick: () => a(!0),
              className: Le(`
                mr-2 rounded-md border border-gray-500 px-1 text-sm transition-all
                hover:bg-editor-primary-200 focus-visible:bg-editor-primary-200
                `),
              children: [
                s.edtrIo.settings,
                " ",
                /* @__PURE__ */ c.jsx(ot, { icon: jf })
              ]
            }
          ),
          y()
        ] }) : null,
        r ? /* @__PURE__ */ c.jsx(
          fs,
          {
            tooltipText: l.dropzoneVisibility,
            value: r.value,
            changeValue: (g) => r.set(g),
            options: d.map(([g, x]) => ({
              text: x.charAt(0).toUpperCase() + x.slice(1),
              value: g
            }))
          }
        ) : null
      ] });
  }
  function y() {
    return e != null && e.defined ? /* @__PURE__ */ c.jsxs(
      qo,
      {
        isOpen: o,
        setIsOpen: (g) => {
          !g && a(!1);
        },
        title: `${s.edtrIo.settings}: ${s.plugins.dropzoneImage.title}`,
        extraTitleClassName: "serlo-h3 mt-4",
        className: "top-8 max-w-xl translate-y-0 sm:top-20",
        children: [
          /* @__PURE__ */ c.jsx("div", { className: "mx-side my-3", children: /* @__PURE__ */ c.jsx(Zoe, { id: e.id }) }),
          /* @__PURE__ */ c.jsx("div", { className: "mx-side my-3", children: /* @__PURE__ */ c.jsxs(
            "button",
            {
              onClick: f,
              className: "serlo-button-edit-primary mr-2 mt-6",
              children: [
                u.change,
                " ",
                /* @__PURE__ */ c.jsx(ot, { className: "ml-1", icon: xT })
              ]
            }
          ) })
        ]
      }
    ) : null;
  }
}
function Koe({
  state: e,
  id: t,
  containerRef: n
}) {
  const { backgroundImage: r, dropzoneVisibility: i } = e, o = Jg(), a = yn(
    (g) => li(g, t)
  ), s = a.state.backgroundImage, l = !!(s != null && s.state.src), { backgroundType: u, canvasShape: d } = e, p = u.value === nf.Blank, f = u.value === nf.Image;
  if (!(p || f && l) && r.defined)
    return r.render();
  const m = u.value === "", y = !d.value && p;
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      Goe,
      {
        showSettings: !m && !y,
        showSettingsButton: f,
        backgroundImage: r,
        dropzoneVisibility: i,
        containerRef: n
      }
    ),
    m ? /* @__PURE__ */ c.jsx(tne, { ...e }) : y ? /* @__PURE__ */ c.jsx(Jte, { ...e }) : /* @__PURE__ */ c.jsx(
      Qre,
      {
        state: e,
        previewActive: o,
        staticDocument: a
      }
    )
  ] });
}
const jz = ln({
  id: rn(""),
  image: Vn({ plugin: Y.Image }),
  text: Vn({
    plugin: Y.Text,
    config: {
      formattingOptions: [
        tt.richTextBold,
        tt.richTextItalic,
        tt.colors,
        tt.math,
        tt.code
      ]
    }
  })
}), Xoe = ln({
  id: rn(""),
  name: rn(""),
  position: ln({
    top: oa(rf.top),
    left: oa(rf.left)
  }),
  layout: ln({
    width: oa(g5.width),
    height: oa(g5.height)
  }),
  answers: $a(jz)
}), Qoe = ln({
  answerZones: $a(Xoe),
  canvasShape: rn(zo.Unset),
  canvasDimensions: ln({
    height: oa(uc),
    width: oa(uc)
  }),
  backgroundType: rn(""),
  backgroundImage: qr(Vn({ plugin: Y.Image })),
  dropzoneVisibility: rn(Ic.Full),
  extraDraggableAnswers: $a(jz)
});
function Yoe() {
  return {
    Component: Koe,
    state: Qoe,
    config: {}
  };
}
const Joe = (e) => /* @__PURE__ */ v.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 30", xmlSpace: "preserve", ...e }, /* @__PURE__ */ v.createElement("path", { fill: "#58819B", d: "m18.214 21.509-3.708-6.426 3.708-6.426h7.417l3.708 6.426-3.708 6.426z" }), /* @__PURE__ */ v.createElement("path", { fill: "#9AC4D8", d: "M5.208 13.853 1.5 7.426 5.208 1h7.417l3.708 6.426-3.708 6.427z" }), /* @__PURE__ */ v.createElement("path", { fill: "#2F5775", d: "M5.208 29.167 1.5 22.738l3.708-6.425h7.417l3.708 6.425-3.708 6.429z" }));
function Nz({ text: e, noText: t }) {
  const n = Un();
  return /* @__PURE__ */ c.jsx("div", { className: Le("mt-12 text-brand", t && "text-center"), children: /* @__PURE__ */ c.jsxs("p", { className: "serlo-p", children: [
    /* @__PURE__ */ c.jsx(
      ot,
      {
        icon: bT,
        className: Le("animate-spin-slow", t && "h-8")
      }
    ),
    " ",
    (!t && e) ?? n.misc.loading
  ] }) });
}
const ky = () => typeof window < "u", eae = () => window.self !== window.top, t9 = (e) => e instanceof HTMLIFrameElement, tae = (e, t) => {
  e.document.readyState === "complete" ? t() : e.addEventListener("load", t);
}, nae = (e, t) => {
  t(), e.addEventListener("load", t);
}, rae = (e, t) => {
  var n, r;
  const i = ((n = e.contentWindow) == null ? void 0 : n.document.readyState) === "complete";
  return e.src !== "about:blank" && ((r = e.contentWindow) == null ? void 0 : r.location.href) !== "about:blank" && i ? t() : e.addEventListener("load", t);
}, iae = () => ({ offsetSize: 0, checkOrigin: !0, enableLegacyLibSupport: !1 }), oae = (e) => {
  try {
    return new URL(e.src).origin === window.location.origin;
  } catch {
    return !1;
  }
}, aae = (e) => {
  try {
    const t = new URL(e.src).origin;
    if (t !== "about:blank")
      return t;
  } catch {
  }
  return null;
}, sae = (e) => (Object.keys(e).forEach((t) => e[t] === void 0 && delete e[t]), e), Oz = (e) => {
  const { height: t } = e.documentElement.getBoundingClientRect();
  return Math.ceil(t);
};
function lae(e) {
  nae(
    e,
    () => {
      var t;
      return (t = e.contentWindow) == null ? void 0 : t.postMessage("[iFrameSizer]ID:0:false:false:32:true:true::auto:::0:false:child:auto:true:::true:::false", "*");
    }
  );
}
function uae(e) {
  if (typeof e.data == "string" && e.data.startsWith("[iFrameSizer]")) {
    const [t, n] = e.data.split(":"), r = +n;
    return r > 0 ? r : null;
  }
  return null;
}
const Wh = ky() ? vae() : null;
let P1 = [];
const cae = (e, t) => {
  if (!ky())
    return [];
  const n = { ...iae(), ...sae(e ?? {}) }, r = dae(t), i = pae(n, r);
  return r.map((o) => {
    const a = { iframe: o, settings: n, interactionState: { isHovered: !1 } }, s = fae(a, i);
    return P1.push(a), {
      unsubscribe: () => {
        s(), P1 = P1.filter((l) => l.iframe !== o);
      }
    };
  });
};
function dae(e) {
  return typeof e == "string" ? Array.from(document.querySelectorAll(e)).filter(t9) : e ? t9(e) ? [e] : [] : Array.from(document.getElementsByTagName("iframe"));
}
function pae(e, t) {
  if (Array.isArray(e.checkOrigin))
    return e.checkOrigin;
  if (!e.checkOrigin)
    return [];
  const n = [];
  for (const r of t) {
    const i = aae(r);
    i && n.push(i);
  }
  return n;
}
function fae(e, t) {
  const n = oae(e.iframe) ? mae(e) : hae(e, t), r = gae(e);
  return () => {
    n(), r();
  };
}
function hae(e, t) {
  const { iframe: n, settings: r } = e, i = (o) => {
    var a;
    const s = !r.checkOrigin || t.includes(o.origin);
    if (!(n.contentWindow !== o.source || !s)) {
      if (((a = o.data) == null ? void 0 : a.type) === "iframe-resized") {
        const { height: l } = o.data;
        l && A5({ newHeight: l, registeredElement: e });
        return;
      }
      if (r.enableLegacyLibSupport) {
        const l = uae(o);
        l !== null && A5({ newHeight: l, registeredElement: e });
        return;
      }
    }
  };
  return window.addEventListener("message", i), r.enableLegacyLibSupport && lae(n), () => window.removeEventListener("message", i);
}
function mae({ iframe: e }) {
  const t = () => {
    var n;
    const r = (n = e.contentDocument) == null ? void 0 : n.body;
    r && (Wh == null || Wh.observe(r));
  };
  return rae(e, t), () => {
    var n;
    (n = e.contentDocument) != null && n.body && (Wh == null || Wh.unobserve(e.contentDocument.body)), e.removeEventListener("load", t);
  };
}
function gae({ iframe: e, interactionState: t }) {
  const n = () => {
    t.isHovered = !0;
  }, r = () => {
    t.isHovered = !1;
  };
  return e.addEventListener("mouseenter", n), e.addEventListener("mouseleave", r), () => {
    e.removeEventListener("mouseenter", n), e.removeEventListener("mouseleave", r);
  };
}
function vae() {
  const e = ({ target: t }) => {
    const n = P1.find((o) => {
      var a;
      return ((a = o.iframe.contentDocument) == null ? void 0 : a.body) === t;
    });
    if (!n)
      return;
    const { iframe: r } = n;
    if (!r.contentDocument)
      return;
    const i = Oz(r.contentDocument);
    i && A5({ newHeight: i, registeredElement: n });
  };
  return new ResizeObserver((t) => t.forEach(e));
}
function A5({ registeredElement: e, newHeight: t }) {
  const { iframe: n, settings: r, interactionState: i } = e, o = n.getBoundingClientRect(), a = t + r.offsetSize;
  if (n.style.height = `${a}px`, !r.onIframeResize)
    return;
  const s = {
    iframe: n,
    settings: { ...r },
    interactionState: { ...i },
    previousRenderState: { rect: o },
    nextRenderState: { rect: n.getBoundingClientRect() }
  };
  r.onIframeResize(s);
}
yae();
function yae() {
  !ky() || !eae() || tae(window, () => {
    const e = () => {
      const t = {
        type: "iframe-resized",
        width: document.documentElement.scrollWidth,
        height: Oz(document)
      };
      window.parent.postMessage(t, "*");
    };
    new ResizeObserver(e).observe(document.body);
  });
}
function zz(e) {
  const t = v.useRef(null), { settings: n, iframeAttributes: r } = xae(e);
  return v.useEffect(() => {
    if (!t.current)
      return;
    const i = cae(n, t.current);
    return () => i.forEach((o) => o.unsubscribe());
  }, []), /* @__PURE__ */ c.jsx("iframe", { ...r, ref: t });
}
function xae(e) {
  const { offsetSize: t, enableLegacyLibSupport: n, checkOrigin: r, onIframeResize: i, ...o } = e;
  return { iframeAttributes: o, settings: { offsetSize: t, enableLegacyLibSupport: n, checkOrigin: r, onIframeResize: i } };
}
/*! @license DOMPurify 3.2.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.3/LICENSE */
var Q4, n9;
function r9() {
  if (n9) return Q4;
  n9 = 1;
  const {
    entries: e,
    setPrototypeOf: t,
    isFrozen: n,
    getPrototypeOf: r,
    getOwnPropertyDescriptor: i
  } = Object;
  let {
    freeze: o,
    seal: a,
    create: s
  } = Object, {
    apply: l,
    construct: u
  } = typeof Reflect < "u" && Reflect;
  o || (o = function(ct) {
    return ct;
  }), a || (a = function(ct) {
    return ct;
  }), l || (l = function(ct, re, $e) {
    return ct.apply(re, $e);
  }), u || (u = function(ct, re) {
    return new ct(...re);
  });
  const d = I(Array.prototype.forEach), p = I(Array.prototype.pop), f = I(Array.prototype.push), m = I(String.prototype.toLowerCase), y = I(String.prototype.toString), g = I(String.prototype.match), x = I(String.prototype.replace), E = I(String.prototype.indexOf), b = I(String.prototype.trim), C = I(Object.prototype.hasOwnProperty), T = I(RegExp.prototype.test), z = w(TypeError);
  function I(ct) {
    return function(re) {
      for (var $e = arguments.length, vt = new Array($e > 1 ? $e - 1 : 0), rt = 1; rt < $e; rt++)
        vt[rt - 1] = arguments[rt];
      return l(ct, re, vt);
    };
  }
  function w(ct) {
    return function() {
      for (var re = arguments.length, $e = new Array(re), vt = 0; vt < re; vt++)
        $e[vt] = arguments[vt];
      return u(ct, $e);
    };
  }
  function M(ct, re) {
    let $e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : m;
    t && t(ct, null);
    let vt = re.length;
    for (; vt--; ) {
      let rt = re[vt];
      if (typeof rt == "string") {
        const Dt = $e(rt);
        Dt !== rt && (n(re) || (re[vt] = Dt), rt = Dt);
      }
      ct[rt] = !0;
    }
    return ct;
  }
  function R(ct) {
    for (let re = 0; re < ct.length; re++)
      C(ct, re) || (ct[re] = null);
    return ct;
  }
  function F(ct) {
    const re = s(null);
    for (const [$e, vt] of e(ct))
      C(ct, $e) && (Array.isArray(vt) ? re[$e] = R(vt) : vt && typeof vt == "object" && vt.constructor === Object ? re[$e] = F(vt) : re[$e] = vt);
    return re;
  }
  function W(ct, re) {
    for (; ct !== null; ) {
      const vt = i(ct, re);
      if (vt) {
        if (vt.get)
          return I(vt.get);
        if (typeof vt.value == "function")
          return I(vt.value);
      }
      ct = r(ct);
    }
    function $e() {
      return null;
    }
    return $e;
  }
  const X = o(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), le = o(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), ne = o(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), fe = o(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), D = o(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), j = o(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), de = o(["#text"]), ye = o(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Ne = o(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Me = o(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Ie = o(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), at = a(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Ve = a(/<%[\w\W]*|[\w\W]*%>/gm), mt = a(/\$\{[\w\W]*}/gm), ae = a(/^data-[\-\w.\u00B7-\uFFFF]+$/), Se = a(/^aria-[\-\w]+$/), Ae = a(
    /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
    // eslint-disable-line no-useless-escape
  ), Be = a(/^(?:\w+script|data):/i), Ze = a(
    /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
    // eslint-disable-line no-control-regex
  ), We = a(/^html$/i), St = a(/^[a-z][.\w]*(-[.\w]+)+$/i);
  var pt = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    ARIA_ATTR: Se,
    ATTR_WHITESPACE: Ze,
    CUSTOM_ELEMENT: St,
    DATA_ATTR: ae,
    DOCTYPE_NAME: We,
    ERB_EXPR: Ve,
    IS_ALLOWED_URI: Ae,
    IS_SCRIPT_OR_DATA: Be,
    MUSTACHE_EXPR: at,
    TMPLIT_EXPR: mt
  });
  const Tt = {
    element: 1,
    attribute: 2,
    text: 3,
    cdataSection: 4,
    entityReference: 5,
    // Deprecated
    entityNode: 6,
    // Deprecated
    progressingInstruction: 7,
    comment: 8,
    document: 9,
    documentType: 10,
    documentFragment: 11,
    notation: 12
    // Deprecated
  }, Wt = function() {
    return typeof window > "u" ? null : window;
  }, et = function(ct, re) {
    if (typeof ct != "object" || typeof ct.createPolicy != "function")
      return null;
    let $e = null;
    const vt = "data-tt-policy-suffix";
    re && re.hasAttribute(vt) && ($e = re.getAttribute(vt));
    const rt = "dompurify" + ($e ? "#" + $e : "");
    try {
      return ct.createPolicy(rt, {
        createHTML(Dt) {
          return Dt;
        },
        createScriptURL(Dt) {
          return Dt;
        }
      });
    } catch {
      return console.warn("TrustedTypes policy " + rt + " could not be created."), null;
    }
  }, At = function() {
    return {
      afterSanitizeAttributes: [],
      afterSanitizeElements: [],
      afterSanitizeShadowDOM: [],
      beforeSanitizeAttributes: [],
      beforeSanitizeElements: [],
      beforeSanitizeShadowDOM: [],
      uponSanitizeAttribute: [],
      uponSanitizeElement: [],
      uponSanitizeShadowNode: []
    };
  };
  function Gt() {
    let ct = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Wt();
    const re = (se) => Gt(se);
    if (re.version = "3.2.3", re.removed = [], !ct || !ct.document || ct.document.nodeType !== Tt.document)
      return re.isSupported = !1, re;
    let {
      document: $e
    } = ct;
    const vt = $e, rt = vt.currentScript, {
      DocumentFragment: Dt,
      HTMLTemplateElement: tn,
      Node: Xn,
      Element: In,
      NodeFilter: Qn,
      NamedNodeMap: Yn = ct.NamedNodeMap || ct.MozNamedAttrMap,
      HTMLFormElement: Ce,
      DOMParser: xe,
      trustedTypes: Oe
    } = ct, Ft = In.prototype, on = W(Ft, "cloneNode"), yr = W(Ft, "remove"), Ho = W(Ft, "nextSibling"), cn = W(Ft, "childNodes"), Jn = W(Ft, "parentNode");
    if (typeof tn == "function") {
      const se = $e.createElement("template");
      se.content && se.content.ownerDocument && ($e = se.content.ownerDocument);
    }
    let un, Vo = "";
    const {
      implementation: Ca,
      createNodeIterator: Lu,
      createDocumentFragment: Mu,
      getElementsByTagName: Fn
    } = $e, {
      importNode: fr
    } = vt;
    let xr = At();
    re.isSupported = typeof e == "function" && typeof Jn == "function" && Ca && Ca.createHTMLDocument !== void 0;
    const {
      MUSTACHE_EXPR: Bu,
      ERB_EXPR: Cl,
      TMPLIT_EXPR: kl,
      DATA_ATTR: Rn,
      ARIA_ATTR: Br,
      IS_SCRIPT_OR_DATA: Iu,
      ATTR_WHITESPACE: ui,
      CUSTOM_ELEMENT: El
    } = pt;
    let {
      IS_ALLOWED_URI: Ru
    } = pt, er = null;
    const Ga = M({}, [...X, ...le, ...ne, ...D, ...de]);
    let Dn = null;
    const Es = M({}, [...ye, ...Ne, ...Me, ...Ie]);
    let bn = Object.seal(s(null, {
      tagNameCheck: {
        writable: !0,
        configurable: !1,
        enumerable: !0,
        value: null
      },
      attributeNameCheck: {
        writable: !0,
        configurable: !1,
        enumerable: !0,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: !0,
        configurable: !1,
        enumerable: !0,
        value: !1
      }
    })), ka = null, Sl = null, Uo = !0, Ka = !0, Ss = !1, _ = !0, H = !1, S = !0, A = !1, P = !1, Q = !1, ie = !1, pe = !1, ce = !1, ze = !0, Xe = !1;
    const wt = "user-content-";
    let jt = !0, Kt = !1, ut = {}, Yt = null;
    const Rt = M({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
    let wn = null;
    const br = M({}, ["audio", "video", "img", "source", "image", "track"]);
    let Pu = null;
    const Ds = M({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), uo = "http://www.w3.org/1998/Math/MathML", _u = "http://www.w3.org/2000/svg", $i = "http://www.w3.org/1999/xhtml";
    let As = $i, ki = !1, Hc = null;
    const qu = M({}, [uo, _u, $i], y);
    let Vc = M({}, ["mi", "mo", "mn", "ms", "mtext"]), Uc = M({}, ["annotation-xml"]);
    const Ts = M({}, ["title", "style", "font", "a", "script"]);
    let co = null;
    const kd = ["application/xhtml+xml", "text/html"], F2 = "text/html";
    let wr = null, js = null;
    const $u = $e.createElement("form"), Ed = function(se) {
      return se instanceof RegExp || se instanceof Function;
    }, Hu = function() {
      let se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (!(js && js === se)) {
        if ((!se || typeof se != "object") && (se = {}), se = F(se), co = // eslint-disable-next-line unicorn/prefer-includes
        kd.indexOf(se.PARSER_MEDIA_TYPE) === -1 ? F2 : se.PARSER_MEDIA_TYPE, wr = co === "application/xhtml+xml" ? y : m, er = C(se, "ALLOWED_TAGS") ? M({}, se.ALLOWED_TAGS, wr) : Ga, Dn = C(se, "ALLOWED_ATTR") ? M({}, se.ALLOWED_ATTR, wr) : Es, Hc = C(se, "ALLOWED_NAMESPACES") ? M({}, se.ALLOWED_NAMESPACES, y) : qu, Pu = C(se, "ADD_URI_SAFE_ATTR") ? M(F(Ds), se.ADD_URI_SAFE_ATTR, wr) : Ds, wn = C(se, "ADD_DATA_URI_TAGS") ? M(F(br), se.ADD_DATA_URI_TAGS, wr) : br, Yt = C(se, "FORBID_CONTENTS") ? M({}, se.FORBID_CONTENTS, wr) : Rt, ka = C(se, "FORBID_TAGS") ? M({}, se.FORBID_TAGS, wr) : {}, Sl = C(se, "FORBID_ATTR") ? M({}, se.FORBID_ATTR, wr) : {}, ut = C(se, "USE_PROFILES") ? se.USE_PROFILES : !1, Uo = se.ALLOW_ARIA_ATTR !== !1, Ka = se.ALLOW_DATA_ATTR !== !1, Ss = se.ALLOW_UNKNOWN_PROTOCOLS || !1, _ = se.ALLOW_SELF_CLOSE_IN_ATTR !== !1, H = se.SAFE_FOR_TEMPLATES || !1, S = se.SAFE_FOR_XML !== !1, A = se.WHOLE_DOCUMENT || !1, ie = se.RETURN_DOM || !1, pe = se.RETURN_DOM_FRAGMENT || !1, ce = se.RETURN_TRUSTED_TYPE || !1, Q = se.FORCE_BODY || !1, ze = se.SANITIZE_DOM !== !1, Xe = se.SANITIZE_NAMED_PROPS || !1, jt = se.KEEP_CONTENT !== !1, Kt = se.IN_PLACE || !1, Ru = se.ALLOWED_URI_REGEXP || Ae, As = se.NAMESPACE || $i, Vc = se.MATHML_TEXT_INTEGRATION_POINTS || Vc, Uc = se.HTML_INTEGRATION_POINTS || Uc, bn = se.CUSTOM_ELEMENT_HANDLING || {}, se.CUSTOM_ELEMENT_HANDLING && Ed(se.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (bn.tagNameCheck = se.CUSTOM_ELEMENT_HANDLING.tagNameCheck), se.CUSTOM_ELEMENT_HANDLING && Ed(se.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (bn.attributeNameCheck = se.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), se.CUSTOM_ELEMENT_HANDLING && typeof se.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (bn.allowCustomizedBuiltInElements = se.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), H && (Ka = !1), pe && (ie = !0), ut && (er = M({}, de), Dn = [], ut.html === !0 && (M(er, X), M(Dn, ye)), ut.svg === !0 && (M(er, le), M(Dn, Ne), M(Dn, Ie)), ut.svgFilters === !0 && (M(er, ne), M(Dn, Ne), M(Dn, Ie)), ut.mathMl === !0 && (M(er, D), M(Dn, Me), M(Dn, Ie))), se.ADD_TAGS && (er === Ga && (er = F(er)), M(er, se.ADD_TAGS, wr)), se.ADD_ATTR && (Dn === Es && (Dn = F(Dn)), M(Dn, se.ADD_ATTR, wr)), se.ADD_URI_SAFE_ATTR && M(Pu, se.ADD_URI_SAFE_ATTR, wr), se.FORBID_CONTENTS && (Yt === Rt && (Yt = F(Yt)), M(Yt, se.FORBID_CONTENTS, wr)), jt && (er["#text"] = !0), A && M(er, ["html", "head", "body"]), er.table && (M(er, ["tbody"]), delete ka.tbody), se.TRUSTED_TYPES_POLICY) {
          if (typeof se.TRUSTED_TYPES_POLICY.createHTML != "function")
            throw z('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
          if (typeof se.TRUSTED_TYPES_POLICY.createScriptURL != "function")
            throw z('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
          un = se.TRUSTED_TYPES_POLICY, Vo = un.createHTML("");
        } else
          un === void 0 && (un = et(Oe, rt)), un !== null && typeof Vo == "string" && (Vo = un.createHTML(""));
        o && o(se), js = se;
      }
    }, eh = M({}, [...le, ...ne, ...fe]), Sd = M({}, [...D, ...j]), L2 = function(se) {
      let yt = Jn(se);
      (!yt || !yt.tagName) && (yt = {
        namespaceURI: As,
        tagName: "template"
      });
      const lt = m(se.tagName), hn = m(yt.tagName);
      return Hc[se.namespaceURI] ? se.namespaceURI === _u ? yt.namespaceURI === $i ? lt === "svg" : yt.namespaceURI === uo ? lt === "svg" && (hn === "annotation-xml" || Vc[hn]) : !!eh[lt] : se.namespaceURI === uo ? yt.namespaceURI === $i ? lt === "math" : yt.namespaceURI === _u ? lt === "math" && Uc[hn] : !!Sd[lt] : se.namespaceURI === $i ? yt.namespaceURI === _u && !Uc[hn] || yt.namespaceURI === uo && !Vc[hn] ? !1 : !Sd[lt] && (Ts[lt] || !eh[lt]) : !!(co === "application/xhtml+xml" && Hc[se.namespaceURI]) : !1;
    }, Ns = function(se) {
      f(re.removed, {
        element: se
      });
      try {
        Jn(se).removeChild(se);
      } catch {
        yr(se);
      }
    }, Dl = function(se, yt) {
      try {
        f(re.removed, {
          attribute: yt.getAttributeNode(se),
          from: yt
        });
      } catch {
        f(re.removed, {
          attribute: null,
          from: yt
        });
      }
      if (yt.removeAttribute(se), se === "is")
        if (ie || pe)
          try {
            Ns(yt);
          } catch {
          }
        else
          try {
            yt.setAttribute(se, "");
          } catch {
          }
    }, th = function(se) {
      let yt = null, lt = null;
      if (Q)
        se = "<remove></remove>" + se;
      else {
        const nr = g(se, /^[\r\n\t ]+/);
        lt = nr && nr[0];
      }
      co === "application/xhtml+xml" && As === $i && (se = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + se + "</body></html>");
      const hn = un ? un.createHTML(se) : se;
      if (As === $i)
        try {
          yt = new xe().parseFromString(hn, co);
        } catch {
        }
      if (!yt || !yt.documentElement) {
        yt = Ca.createDocument(As, "template", null);
        try {
          yt.documentElement.innerHTML = ki ? Vo : hn;
        } catch {
        }
      }
      const tr = yt.body || yt.documentElement;
      return se && lt && tr.insertBefore($e.createTextNode(lt), tr.childNodes[0] || null), As === $i ? Fn.call(yt, A ? "html" : "body")[0] : A ? yt.documentElement : tr;
    }, nh = function(se) {
      return Lu.call(
        se.ownerDocument || se,
        se,
        // eslint-disable-next-line no-bitwise
        Qn.SHOW_ELEMENT | Qn.SHOW_COMMENT | Qn.SHOW_TEXT | Qn.SHOW_PROCESSING_INSTRUCTION | Qn.SHOW_CDATA_SECTION,
        null
      );
    }, Dd = function(se) {
      return se instanceof Ce && (typeof se.nodeName != "string" || typeof se.textContent != "string" || typeof se.removeChild != "function" || !(se.attributes instanceof Yn) || typeof se.removeAttribute != "function" || typeof se.setAttribute != "function" || typeof se.namespaceURI != "string" || typeof se.insertBefore != "function" || typeof se.hasChildNodes != "function");
    }, rh = function(se) {
      return typeof Xn == "function" && se instanceof Xn;
    };
    function Ea(se, yt, lt) {
      d(se, (hn) => {
        hn.call(re, yt, lt, js);
      });
    }
    const ih = function(se) {
      let yt = null;
      if (Ea(xr.beforeSanitizeElements, se, null), Dd(se))
        return Ns(se), !0;
      const lt = wr(se.nodeName);
      if (Ea(xr.uponSanitizeElement, se, {
        tagName: lt,
        allowedTags: er
      }), se.hasChildNodes() && !rh(se.firstElementChild) && T(/<[/\w]/g, se.innerHTML) && T(/<[/\w]/g, se.textContent) || se.nodeType === Tt.progressingInstruction || S && se.nodeType === Tt.comment && T(/<[/\w]/g, se.data))
        return Ns(se), !0;
      if (!er[lt] || ka[lt]) {
        if (!ka[lt] && Wc(lt) && (bn.tagNameCheck instanceof RegExp && T(bn.tagNameCheck, lt) || bn.tagNameCheck instanceof Function && bn.tagNameCheck(lt)))
          return !1;
        if (jt && !Yt[lt]) {
          const hn = Jn(se) || se.parentNode, tr = cn(se) || se.childNodes;
          if (tr && hn) {
            const nr = tr.length;
            for (let Wo = nr - 1; Wo >= 0; --Wo) {
              const ci = on(tr[Wo], !0);
              ci.__removalCount = (se.__removalCount || 0) + 1, hn.insertBefore(ci, Ho(se));
            }
          }
        }
        return Ns(se), !0;
      }
      return se instanceof In && !L2(se) || (lt === "noscript" || lt === "noembed" || lt === "noframes") && T(/<\/no(script|embed|frames)/i, se.innerHTML) ? (Ns(se), !0) : (H && se.nodeType === Tt.text && (yt = se.textContent, d([Bu, Cl, kl], (hn) => {
        yt = x(yt, hn, " ");
      }), se.textContent !== yt && (f(re.removed, {
        element: se.cloneNode()
      }), se.textContent = yt)), Ea(xr.afterSanitizeElements, se, null), !1);
    }, Ad = function(se, yt, lt) {
      if (ze && (yt === "id" || yt === "name") && (lt in $e || lt in $u))
        return !1;
      if (!(Ka && !Sl[yt] && T(Rn, yt)) && !(Uo && T(Br, yt))) {
        if (!Dn[yt] || Sl[yt]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Wc(se) && (bn.tagNameCheck instanceof RegExp && T(bn.tagNameCheck, se) || bn.tagNameCheck instanceof Function && bn.tagNameCheck(se)) && (bn.attributeNameCheck instanceof RegExp && T(bn.attributeNameCheck, yt) || bn.attributeNameCheck instanceof Function && bn.attributeNameCheck(yt)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            yt === "is" && bn.allowCustomizedBuiltInElements && (bn.tagNameCheck instanceof RegExp && T(bn.tagNameCheck, lt) || bn.tagNameCheck instanceof Function && bn.tagNameCheck(lt)))
          ) return !1;
        } else if (!Pu[yt] && !T(Ru, x(lt, ui, "")) && !((yt === "src" || yt === "xlink:href" || yt === "href") && se !== "script" && E(lt, "data:") === 0 && wn[se]) && !(Ss && !T(Iu, x(lt, ui, ""))) && lt)
          return !1;
      }
      return !0;
    }, Wc = function(se) {
      return se !== "annotation-xml" && g(se, El);
    }, Td = function(se) {
      Ea(xr.beforeSanitizeAttributes, se, null);
      const {
        attributes: yt
      } = se;
      if (!yt || Dd(se))
        return;
      const lt = {
        attrName: "",
        attrValue: "",
        keepAttr: !0,
        allowedAttributes: Dn,
        forceKeepAttr: void 0
      };
      let hn = yt.length;
      for (; hn--; ) {
        const tr = yt[hn], {
          name: nr,
          namespaceURI: Wo,
          value: ci
        } = tr, Zo = wr(nr);
        let Xr = nr === "value" ? ci : b(ci);
        if (lt.attrName = Zo, lt.attrValue = Xr, lt.keepAttr = !0, lt.forceKeepAttr = void 0, Ea(xr.uponSanitizeAttribute, se, lt), Xr = lt.attrValue, Xe && (Zo === "id" || Zo === "name") && (Dl(nr, se), Xr = wt + Xr), S && T(/((--!?|])>)|<\/(style|title)/i, Xr)) {
          Dl(nr, se);
          continue;
        }
        if (lt.forceKeepAttr || (Dl(nr, se), !lt.keepAttr))
          continue;
        if (!_ && T(/\/>/i, Xr)) {
          Dl(nr, se);
          continue;
        }
        H && d([Bu, Cl, kl], (h) => {
          Xr = x(Xr, h, " ");
        });
        const oh = wr(se.nodeName);
        if (Ad(oh, Zo, Xr)) {
          if (un && typeof Oe == "object" && typeof Oe.getAttributeType == "function" && !Wo)
            switch (Oe.getAttributeType(oh, Zo)) {
              case "TrustedHTML": {
                Xr = un.createHTML(Xr);
                break;
              }
              case "TrustedScriptURL": {
                Xr = un.createScriptURL(Xr);
                break;
              }
            }
          try {
            Wo ? se.setAttributeNS(Wo, nr, Xr) : se.setAttribute(nr, Xr), Dd(se) ? Ns(se) : p(re.removed);
          } catch {
          }
        }
      }
      Ea(xr.afterSanitizeAttributes, se, null);
    }, jd = function se(yt) {
      let lt = null;
      const hn = nh(yt);
      for (Ea(xr.beforeSanitizeShadowDOM, yt, null); lt = hn.nextNode(); )
        Ea(xr.uponSanitizeShadowNode, lt, null), ih(lt), Td(lt), lt.content instanceof Dt && se(lt.content);
      Ea(xr.afterSanitizeShadowDOM, yt, null);
    };
    return re.sanitize = function(se) {
      let yt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, lt = null, hn = null, tr = null, nr = null;
      if (ki = !se, ki && (se = "<!-->"), typeof se != "string" && !rh(se))
        if (typeof se.toString == "function") {
          if (se = se.toString(), typeof se != "string")
            throw z("dirty is not a string, aborting");
        } else
          throw z("toString is not a function");
      if (!re.isSupported)
        return se;
      if (P || Hu(yt), re.removed = [], typeof se == "string" && (Kt = !1), Kt) {
        if (se.nodeName) {
          const Zo = wr(se.nodeName);
          if (!er[Zo] || ka[Zo])
            throw z("root node is forbidden and cannot be sanitized in-place");
        }
      } else if (se instanceof Xn)
        lt = th("<!---->"), hn = lt.ownerDocument.importNode(se, !0), hn.nodeType === Tt.element && hn.nodeName === "BODY" || hn.nodeName === "HTML" ? lt = hn : lt.appendChild(hn);
      else {
        if (!ie && !H && !A && // eslint-disable-next-line unicorn/prefer-includes
        se.indexOf("<") === -1)
          return un && ce ? un.createHTML(se) : se;
        if (lt = th(se), !lt)
          return ie ? null : ce ? Vo : "";
      }
      lt && Q && Ns(lt.firstChild);
      const Wo = nh(Kt ? se : lt);
      for (; tr = Wo.nextNode(); )
        ih(tr), Td(tr), tr.content instanceof Dt && jd(tr.content);
      if (Kt)
        return se;
      if (ie) {
        if (pe)
          for (nr = Mu.call(lt.ownerDocument); lt.firstChild; )
            nr.appendChild(lt.firstChild);
        else
          nr = lt;
        return (Dn.shadowroot || Dn.shadowrootmode) && (nr = fr.call(vt, nr, !0)), nr;
      }
      let ci = A ? lt.outerHTML : lt.innerHTML;
      return A && er["!doctype"] && lt.ownerDocument && lt.ownerDocument.doctype && lt.ownerDocument.doctype.name && T(We, lt.ownerDocument.doctype.name) && (ci = "<!DOCTYPE " + lt.ownerDocument.doctype.name + `>
` + ci), H && d([Bu, Cl, kl], (Zo) => {
        ci = x(ci, Zo, " ");
      }), un && ce ? un.createHTML(ci) : ci;
    }, re.setConfig = function() {
      let se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      Hu(se), P = !0;
    }, re.clearConfig = function() {
      js = null, P = !1;
    }, re.isValidAttribute = function(se, yt, lt) {
      js || Hu({});
      const hn = wr(se), tr = wr(yt);
      return Ad(hn, tr, lt);
    }, re.addHook = function(se, yt) {
      typeof yt == "function" && f(xr[se], yt);
    }, re.removeHook = function(se) {
      return p(xr[se]);
    }, re.removeHooks = function(se) {
      xr[se] = [];
    }, re.removeAllHooks = function() {
      xr = At();
    }, re;
  }
  var Lt = Gt();
  return Q4 = Lt, Q4;
}
var bae = window.DOMPurify || (window.DOMPurify = r9().default || r9());
const Ey = /* @__PURE__ */ wi(bae), wae = '<script type="module" src="https://cdn.jsdelivr.net/npm/@open-iframe-resizer/core@1.2.1/dist/index.min.js"><\/script>', T5 = "padding: 0; margin: 0; border: 0;", Cae = Do({
  detailsSnippet: Cr,
  node: Do({
    mediatype: Cr,
    remote: i0([
      $d,
      Do({
        repository: Do({
          repositoryType: Cr
        })
      })
    ]),
    name: i0([y0, $d, Cr]),
    iconURL: i0([y0, $d, Cr]),
    downloadUrl: i0([y0, $d, Cr]),
    content: i0([y0, $d, Do({ url: Cr })])
  })
});
function kae({
  nodeId: e,
  repositoryId: t,
  ltik: n
}) {
  const [r, i] = v.useState({
    type: "unknown",
    defineContainerHeight: !1
  });
  return v.useEffect(() => {
    async function o() {
      if (e === void 0 || t === void 0) return;
      const a = new URL(window.location.origin);
      a.pathname = "/edusharing-embed/get", a.searchParams.append("nodeId", e), a.searchParams.append("repositoryId", t);
      const s = await fetch(a.href, {
        headers: { Authorization: `Bearer ${n}` }
      });
      if (!s.ok) {
        console.error(
          `Request to /lit/get-embed-html failed. Status code ${s.status}.`
        ), yi(
          "Der Edu-sharing server konnte nicht erreicht werden. Bitte versuche es später noch einmal.",
          "warning"
        ), i({
          type: "error",
          defineContainerHeight: !1
        });
        return;
      }
      const l = await s.json();
      if (!Cae.is(l)) {
        console.log(JSON.stringify(l)), console.error(
          "Request to /lit/get-embed-html failed. Response json was malformed."
        ), yi(
          "Der Inhalt konnte nicht eingebunden werden. Bitte wende dich an den Support.",
          "warning"
        ), i({
          type: "error",
          defineContainerHeight: !1
        });
        return;
      }
      const {
        type: u,
        html: d,
        component: p,
        defineContainerHeight: f
      } = Eae(l, e), m = Sae(d ?? "", f), y = Ey.sanitize(m, {
        // We allow <script> and <iframe> elements.
        // Those are part of the html snippet we get from edu-sharing and cannot be removed or the embed will break.
        // <script> elements cannot be manipulated by the user and we can trust them.
        ADD_TAGS: ["script", "iframe"],
        // Return entire html document including <html>, <body>, ...
        WHOLE_DOCUMENT: !0
      });
      i({
        type: u,
        html: y,
        component: p,
        defineContainerHeight: f
      });
    }
    o();
  }, [e, t, n]), { embedData: r };
}
function Eae(e, t) {
  var n, r, i;
  if (e.node.mediatype === "file-word") {
    console.log(e.node);
    const { iconURL: m, downloadUrl: y, name: g } = e.node, x = (n = e.node.content) == null ? void 0 : n.url;
    return !m || !g || !y ? { type: "error" } : {
      type: "word",
      component: /* @__PURE__ */ c.jsx(
        iy,
        {
          boxType: "blank",
          title: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
            /* @__PURE__ */ c.jsx(
              "img",
              {
                src: m,
                alt: "Word-File icon",
                className: "-mt-1 inline-block h-4 w-4 opacity-50"
              }
            ),
            " ",
            "Word-Datei: ",
            g
          ] }),
          anchorId: t ?? "",
          children: /* @__PURE__ */ c.jsx(c.Fragment, { children: /* @__PURE__ */ c.jsxs("div", { className: "mx-side my-3 flex gap-2", children: [
            /* @__PURE__ */ c.jsx(
              "a",
              {
                href: x,
                target: "_blank",
                className: "serlo-button-learner-primary",
                rel: "noreferrer",
                children: "Dokument anzeigen"
              }
            ),
            /* @__PURE__ */ c.jsx("a", { href: y, className: "serlo-button-learner-secondary", children: "Datei herunterladen" })
          ] }) })
        }
      )
    };
  }
  let { detailsSnippet: o } = e;
  o = o.replaceAll(/min-width[^;]*;/g, ""), o = o.replaceAll(
    /edusharing_rendering_content_footer \{/g,
    "edusharing_rendering_content_footer { display: none;"
  );
  const a = new DOMParser().parseFromString(o, "text/html"), s = ((r = e.node.remote) == null ? void 0 : r.repository.repositoryType) === "BROCKHAUS", l = e.node.mediatype === "link" && !e.node.remote;
  if (l || s) {
    const m = a.querySelector(
      ".edusharing_rendering_content_footer a"
    );
    return m ? {
      type: l ? "link" : s ? "brockhaus" : "unknown",
      component: /* @__PURE__ */ c.jsx(
        "a",
        {
          className: "serlo-link",
          target: "_blank",
          rel: "noopener noreferrer",
          href: m.href,
          children: m.innerText ? m.innerText : m.href
        }
      )
    } : { type: "error" };
  }
  const u = Dae(a);
  if (u && e.node.mediatype === "file-image" && ((i = e.node.remote) == null ? void 0 : i.repository.repositoryType) === "PIXABAY") {
    const m = i9(u), y = a.querySelector(
      "#edusharing_rendering_content_href"
    ), g = y ? y.outerHTML + `
      <style>
        #edusharing_rendering_content_href {
            margin-left: 0px !important;
            text-align: left !important;
            margin-top: 5px !important;
            display: block !important;
            width: fit-content !important;
            background-color: transparent !important;
            padding: 0px !important;
            color: #007bff !important;
            font-size: 0.7rem !important;
        }
        </style>
        ` : "";
    return {
      type: "pixabay",
      html: m + g
    };
  }
  if (u && !e.node.remote)
    return {
      type: "image",
      html: i9(u)
    };
  if (u && u.classList.contains("edusharing_rendering_content_preview"))
    return o = o.replace('width="0"', "").replace('height="0"', ""), {
      type: "file",
      html: o
    };
  if (o.includes("get_resource"))
    return o = o.replace(
      "get_resource = function(authstring)",
      "function get_resource(authstring)"
    ), { type: "audio", html: o };
  if (a.querySelector("video") !== null)
    return o = o + `
        <style>
        .edusharing_rendering_content_video_wrapper {
          display: block !important;
        }
        .edusharing_rendering_content_video_wrapper video {
          width: 100% !important;
        }
        </style>
        `, { type: "video", html: o };
  const d = a.querySelector("iframe");
  if (d && e.node.mediatype === "file-h5p") return { type: "h5p", html: o };
  const p = (d == null ? void 0 : d.id) === "docFrame", f = d && o.includes("learningapps.org/");
  return f || p ? {
    type: f ? "learning-app" : p ? "pdf" : "unknown",
    html: `<iframe style="${T5} height: 100%; width: 100%;" src="${d.src}" sandbox="allow-scripts"></iframe>`,
    defineContainerHeight: !0
  } : { type: "error", html: o };
}
function Sae(e, t) {
  return `
      <html style="${T5}${t ? "height: 97%;" : "overflow-y: hidden;"}">
        <head>
          ${t ? "" : wae}
        </head>
        <body style="${T5}${t ? "height: 100%;" : ""}">
          ${e}
        </body>
      </html> 
    `;
}
function Dae(e) {
  const t = e.querySelector(
    ".edusharing_rendering_content_wrapper > img"
  ) ?? e.querySelector(
    ".edusharing_rendering_content"
  );
  return t && t.nodeName === "IMG" ? t : void 0;
}
function i9(e) {
  return `<img style="width: 100%; object-fit: contain;" src="${e.getAttribute("src")}" alt="${e.getAttribute("alt")}" title="${e.getAttribute("title")}">`;
}
function Fz(e) {
  const { nodeId: t, repositoryId: n, ltik: r, contentWidth: i } = e, { embedData: o } = kae({
    nodeId: t,
    repositoryId: n,
    ltik: r
  });
  if (o.type === "error") return null;
  const a = o.type === "unknown";
  return /* @__PURE__ */ c.jsx("figure", { className: "relative z-[15] w-full", children: /* @__PURE__ */ c.jsx("div", { className: "mx-side", children: a ? /* @__PURE__ */ c.jsx(Nz, { noText: !0 }) : o.component ?? s() }) });
  function s() {
    if (!o.html) return;
    const l = i || "100%", u = o.defineContainerHeight ? "16/9" : void 0;
    return /* @__PURE__ */ c.jsx(
      "div",
      {
        className: "z-15 max-w-full",
        style: { width: l, aspectRatio: u },
        "data-embed-type": o.type,
        children: o.defineContainerHeight ? /* @__PURE__ */ c.jsx(
          "iframe",
          {
            srcDoc: o.html,
            style: { width: "100%", height: "100%" }
          }
        ) : /* @__PURE__ */ c.jsx(
          Aae,
          {
            checkOrigin: !1,
            srcDoc: o.html,
            style: { width: "100%" }
          }
        )
      }
    );
  }
}
const Aae = v.memo(
  zz,
  (e, t) => e.srcDoc === t.srcDoc
), Tae = Do({
  nodeId: Cr,
  repositoryId: Cr
});
function jae({
  state: e,
  focused: t,
  id: n
}) {
  const [r, i] = v.useState(!1), o = v.useRef(null), a = nt().plugins.edusharingAsset, { edusharingAsset: s, contentWidth: l } = e;
  v.useEffect(() => {
    function m({ data: y, source: g }) {
      var x;
      if (g === ((x = o.current) == null ? void 0 : x.contentWindow) && typeof y == "object" && Tae.is(y)) {
        const E = {
          nodeId: y.nodeId,
          repositoryId: y.repositoryId
        };
        s.defined === !1 ? s.create(E) : (s.nodeId.set(E.nodeId), s.repositoryId.set(E.repositoryId)), i(!1);
      }
    }
    return window.addEventListener("message", m), () => window.removeEventListener("message", m);
  }, [s]);
  const { ltik: u } = v.useContext(zf);
  if (!u) return /* @__PURE__ */ c.jsx("p", { children: "Error: ltik missing" });
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    p(),
    f(u),
    /* @__PURE__ */ c.jsxs("div", { className: "relative", children: [
      s.defined ? /* @__PURE__ */ c.jsx(
        Fz,
        {
          nodeId: e.edusharingAsset.defined ? e.edusharingAsset.nodeId.value : void 0,
          repositoryId: e.edusharingAsset.defined ? e.edusharingAsset.repositoryId.value : void 0,
          ltik: u,
          contentWidth: l.defined ? l.value : void 0
        }
      ) : /* @__PURE__ */ c.jsx(Joe, { style: { width: "5rem", height: "5rem" } }),
      d()
    ] })
  ] });
  function d() {
    const m = !t;
    return /* @__PURE__ */ c.jsx(
      "div",
      {
        className: Le(
          "absolute left-0 top-0 z-[15] h-full w-full",
          m ? "pointer-events-auto" : "pointer-events-none"
        )
      }
    );
  }
  function p() {
    if (!t) return null;
    return /* @__PURE__ */ c.jsx(
      Ci,
      {
        pluginType: a.title,
        pluginControls: /* @__PURE__ */ c.jsx(Pi, { pluginId: n }),
        pluginSettings: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
          /* @__PURE__ */ c.jsx(
            "button",
            {
              onClick: () => i(!0),
              className: "mr-2 rounded-md border border-gray-500 px-1 text-sm transition-all hover:bg-editor-primary-200 focus-visible:bg-editor-primary-200",
              "data-qa": "plugin-edusharing-select-content-button",
              children: "Inhalt wählen"
            }
          ),
          s.defined && !l.defined ? /* @__PURE__ */ c.jsx(
            "button",
            {
              onClick: () => {
                l.defined === !1 && l.create("30rem");
              },
              className: "mr-2 rounded-md border border-gray-500 px-1 text-sm transition-all hover:bg-editor-primary-200 focus-visible:bg-editor-primary-200",
              "data-qa": "plugin-edusharing-change-size-button",
              children: "Größe verändern"
            }
          ) : null,
          s.defined && l.defined ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
            /* @__PURE__ */ c.jsx(
              "button",
              {
                onClick: () => l.set(
                  (y) => m(y, 2)
                ),
                className: "mr-2 rounded-md border border-gray-500 px-1 text-sm transition-all hover:bg-editor-primary-200 focus-visible:bg-editor-primary-200",
                "data-qa": "plugin-edusharing-bigger-button",
                children: "Größer"
              }
            ),
            /* @__PURE__ */ c.jsx(
              "button",
              {
                onClick: () => l.set(
                  (y) => m(y, -2)
                ),
                className: "mr-2 rounded-md border border-gray-500 px-1 text-sm transition-all hover:bg-editor-primary-200 focus-visible:bg-editor-primary-200",
                "data-qa": "plugin-edusharing-smaller-button",
                children: "Kleiner"
              }
            )
          ] }) : null
        ] })
      }
    );
    function m(y, g) {
      const x = parseFloat(
        y.replace("rem", "")
      );
      return `${Math.max(x + g, 4)}rem`;
    }
  }
  function f(m) {
    const y = new URL(window.location.origin);
    return y.pathname = "/edusharing-embed/start", y.searchParams.append("ltik", m), /* @__PURE__ */ c.jsx(
      qo,
      {
        isOpen: r,
        setIsOpen: () => i(!1),
        className: "top-[50%] h-full w-full max-w-[95%]",
        title: "Edusharing-Inhalt auswählen",
        extraTitleClassName: "sr-only",
        children: /* @__PURE__ */ c.jsx("iframe", { src: y.href, className: "h-full w-full", ref: o })
      }
    );
  }
}
const Nae = ln({
  edusharingAsset: qr(
    ln({
      repositoryId: rn(""),
      nodeId: rn("")
    })
  ),
  contentWidth: qr(rn())
  // Contains values like '40rem'. Possible values ['4rem', '6rem', ...]
});
function Oae() {
  return {
    Component: jae,
    state: Nae,
    config: {}
  };
}
var Bi = /* @__PURE__ */ ((e) => (e.Equation = "equation", e.Term = "term", e))(Bi || {});
function zae(e) {
  return Fae(e) ? e : "equation";
}
function Fae(e) {
  return Object.values(Bi).includes(e);
}
var $n = /* @__PURE__ */ ((e) => (e[e.Left = 0] = "Left", e[e.Right = 1] = "Right", e[e.Transform = 2] = "Transform", e[e.Explanation = 3] = "Explanation", e))($n || {});
function Lae({
  rows: e,
  columns: t,
  focusNext: n,
  focusPrevious: r,
  onFocusChanged: i,
  transformationTarget: o
}) {
  const [a, s] = v.useState(null), l = (d) => {
    i(d), s(d);
  }, u = (d) => a === null ? !1 : a === "firstExplanation" ? d === a : d !== "firstExplanation" && a.row === (d == null ? void 0 : d.row) && a.column === d.column;
  return {
    focus: a,
    isFocused: u,
    setFocus(d) {
      u(d) || l(d);
    },
    moveRight() {
      if (a !== null) {
        if (a === "firstExplanation") {
          l({ row: 0, column: o9(o) });
          return;
        }
        a.row === e - 1 && a.column === Mae(o) ? n() : o === Bi.Term ? a.column === $n.Right ? l({ row: a.row, column: $n.Explanation }) : l({
          row: a.row + 1,
          column: o9(o)
        }) : a.column === t - 1 ? l({ row: a.row + 1, column: $n.Left }) : l({ row: a.row, column: a.column + 1 });
      }
    },
    moveLeft() {
      if (a !== null) {
        if (a === "firstExplanation") {
          r();
          return;
        }
        o === Bi.Term ? a.row === 0 && a.column === $n.Right ? r() : a.column === $n.Right ? l({ row: a.row - 1, column: $n.Explanation }) : l({ row: a.row, column: $n.Right }) : a.column === 0 ? a.row === 0 ? l("firstExplanation") : l({ row: a.row - 1, column: t - 1 }) : l({ row: a.row, column: a.column - 1 });
      }
    }
  };
}
function o9(e) {
  return e === Bi.Term ? $n.Right : $n.Left;
}
function Mae(e) {
  return e === Bi.Term ? $n.Right : $n.Transform;
}
const Bae = ({
  state: e,
  onChange: t,
  onMoveOutLeft: n,
  onMoveOutRight: r
}) => {
  const [i, o] = v.useState(e), a = v.createRef();
  return v.useEffect(() => {
    const s = a.current;
    s && setTimeout(() => s.focus());
  }, []), /* @__PURE__ */ c.jsx(
    "textarea",
    {
      className: Le(
        `mx-0 my-1 h-24 w-[80vw] max-w-[600px] resize-none rounded-md
        border-2 border-transparent p-2.5 font-mono
        text-black outline-none focus:border-editor-primary`
      ),
      ref: a,
      onChange: (s) => {
        o(s.currentTarget.value), t(s.currentTarget.value);
      },
      onCopy: (s) => s.stopPropagation(),
      onCut: (s) => s.stopPropagation(),
      value: i,
      "data-qa": "plugin-math-latex-editor",
      onKeyDown: (s) => {
        const { selectionStart: l, selectionEnd: u, value: d } = s.currentTarget;
        if (l !== u) return;
        const p = u === d.length, f = l === 0;
        s.shiftKey || (s.key === "ArrowRight" && p && (r == null || r()), s.key === "ArrowLeft" && f && (n == null || n()));
      }
    }
  );
};
function Iae({
  hasError: e,
  isVisualMode: t,
  ...n
}) {
  const r = nt().plugins.text.math;
  return /* @__PURE__ */ c.jsxs(
    "div",
    {
      className: "fixed bottom-0 left-1/2 z-50 -translate-x-1/2 rounded-t-xl bg-editor-primary-100 p-3 shadow-menu",
      onClick: (i) => i.stopPropagation(),
      children: [
        /* @__PURE__ */ c.jsxs("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ c.jsx("p", { className: "mr-0.5 mt-1 text-right text-sm font-bold text-gray-600", children: e ? r.onlyLatex : r.latexEditorTitle }),
          /* @__PURE__ */ c.jsx(
            "button",
            {
              onClick: n.closeMathEditorOverlay,
              className: "mr-0.5 mt-1 text-sm font-bold text-gray-600 hover:bg-gray-200 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-700",
              "aria-label": "Close math formula editor",
              "data-qa": "plugin-math-close-formula-editor",
              children: /* @__PURE__ */ c.jsx(ot, { icon: Fg })
            }
          )
        ] }),
        !t && /* @__PURE__ */ c.jsx(Bae, { ...n })
      ]
    }
  );
}
const Rae = ({
  isHelpOpen: e,
  setIsHelpOpen: t
}) => {
  const n = nt().plugins.text.math;
  return /* @__PURE__ */ c.jsx(
    qo,
    {
      isOpen: e,
      setIsOpen: t,
      title: n.shortcuts,
      extraTitleClassName: "serlo-h3 mt-4",
      children: /* @__PURE__ */ c.jsxs("div", { className: "mx-side", children: [
        /* @__PURE__ */ c.jsxs("p", { children: [
          n.fraction,
          ": ",
          r("/")
        ] }),
        /* @__PURE__ */ c.jsxs("p", { children: [
          n.superscript,
          ": ",
          r("↑"),
          " ",
          n.or,
          " ",
          r("^")
        ] }),
        /* @__PURE__ */ c.jsxs("p", { children: [
          n.subscript,
          ": ",
          r("↓"),
          " ",
          n.or,
          " ",
          r("_")
        ] }),
        /* @__PURE__ */ c.jsxs("p", { children: [
          "π, α, β, γ: ",
          r("pi"),
          ", ",
          r("alpha"),
          ",",
          " ",
          r("beta"),
          ",",
          r("gamma")
        ] }),
        /* @__PURE__ */ c.jsxs("p", { children: [
          "≤, ≥: ",
          r("<="),
          ", ",
          r(">=")
        ] }),
        /* @__PURE__ */ c.jsxs("p", { children: [
          n.root,
          ": ",
          r("\\sqrt"),
          ", ",
          r("\\nthroot")
        ] }),
        /* @__PURE__ */ c.jsxs("p", { children: [
          n.mathSymbols,
          ": ",
          r("\\<NAME>"),
          ", ",
          n.eG,
          " ",
          r("\\neq"),
          " (≠), ",
          r("\\pm"),
          " (±), …"
        ] }),
        /* @__PURE__ */ c.jsxs("p", { children: [
          n.functions,
          ": ",
          r("sin"),
          ", ",
          r("cos"),
          ",",
          " ",
          r("ln"),
          ", …"
        ] })
      ] })
    }
  );
  function r(i) {
    return /* @__PURE__ */ c.jsx("span", { className: "min-w-[20px] rounded-md bg-[#ddd] px-1 py-0.5 text-center text-almost-black", children: i });
  }
};
function Pae() {
  return typeof window < "u" && ("ontouchstart" in window || navigator.maxTouchPoints > 0);
}
var j5 = { exports: {} }, a9 = { exports: {} }, s9;
function _ae() {
  return s9 || (s9 = 1, function(e, t) {
    var n = {};
    /*! For license information please see react-mathquill.min.js.LICENSE.txt */
    (function(r, i) {
      e.exports = i(dt);
    })(n, function(r) {
      return (() => {
        var i = { 991: (l, u, d) => {
          d.d(u, { Z: () => I });
          var p = d(156), f = d.n(p), m = d(697), y = d.n(m), g = d(700), x = ["latex", "onChange", "config", "mathquillDidMount"];
          function E() {
            return E = Object.assign || function(w) {
              for (var M = 1; M < arguments.length; M++) {
                var R = arguments[M];
                for (var F in R) Object.prototype.hasOwnProperty.call(R, F) && (w[F] = R[F]);
              }
              return w;
            }, E.apply(this, arguments);
          }
          function b(w, M) {
            var R = Object.keys(w);
            if (Object.getOwnPropertySymbols) {
              var F = Object.getOwnPropertySymbols(w);
              M && (F = F.filter(function(W) {
                return Object.getOwnPropertyDescriptor(w, W).enumerable;
              })), R.push.apply(R, F);
            }
            return R;
          }
          function C(w) {
            for (var M = 1; M < arguments.length; M++) {
              var R = arguments[M] != null ? arguments[M] : {};
              M % 2 ? b(Object(R), !0).forEach(function(F) {
                T(w, F, R[F]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(w, Object.getOwnPropertyDescriptors(R)) : b(Object(R)).forEach(function(F) {
                Object.defineProperty(w, F, Object.getOwnPropertyDescriptor(R, F));
              });
            }
            return w;
          }
          function T(w, M, R) {
            return M in w ? Object.defineProperty(w, M, { value: R, enumerable: !0, configurable: !0, writable: !0 }) : w[M] = R, w;
          }
          var z = function(w) {
            var M = w.latex, R = w.onChange, F = w.config, W = w.mathquillDidMount, X = function(j, de) {
              if (j == null) return {};
              var ye, Ne, Me = function(at, Ve) {
                if (at == null) return {};
                var mt, ae, Se = {}, Ae = Object.keys(at);
                for (ae = 0; ae < Ae.length; ae++) mt = Ae[ae], Ve.indexOf(mt) >= 0 || (Se[mt] = at[mt]);
                return Se;
              }(j, de);
              if (Object.getOwnPropertySymbols) {
                var Ie = Object.getOwnPropertySymbols(j);
                for (Ne = 0; Ne < Ie.length; Ne++) ye = Ie[Ne], de.indexOf(ye) >= 0 || Object.prototype.propertyIsEnumerable.call(j, ye) && (Me[ye] = j[ye]);
              }
              return Me;
            }(w, x), le = (0, p.useRef)(2), ne = (0, p.useRef)(null), fe = (0, p.useRef)(null), D = (0, p.useRef)(R);
            return (0, p.useEffect)(function() {
              D.current = R;
            }, [R]), (0, p.useEffect)(function() {
              if (fe.current) {
                var j = { restrictMismatchedBrackets: !0, handlers: {} };
                F && (j = C(C({}, j), F));
                var de = j.handlers.edit;
                j.handlers.edit = function(ye) {
                  de && de(), le.current > 0 ? le.current -= 1 : D.current && D.current(ye);
                }, ne.current = g.Z.MathField(fe.current, j), ne.current.latex(M || ""), W && W(ne.current);
              }
            }, [fe]), (0, p.useEffect)(function() {
              ne.current && ne.current.latex() !== M && ne.current.latex(M);
            }, [M]), f().createElement("span", E({}, X, { ref: fe }));
          };
          z.propTypes = { latex: y().string, onChange: y().func, config: y().object, mathquillDidMount: y().func };
          const I = z;
        }, 717: (l, u, d) => {
          d.d(u, { Z: () => C });
          var p = d(156), f = d.n(p), m = d(697), y = d.n(m), g = d(700), x = ["mathquillDidMount", "children"];
          function E() {
            return E = Object.assign || function(T) {
              for (var z = 1; z < arguments.length; z++) {
                var I = arguments[z];
                for (var w in I) Object.prototype.hasOwnProperty.call(I, w) && (T[w] = I[w]);
              }
              return T;
            }, E.apply(this, arguments);
          }
          var b = function(T) {
            var z = T.mathquillDidMount, I = T.children, w = function(F, W) {
              if (F == null) return {};
              var X, le, ne = function(D, j) {
                if (D == null) return {};
                var de, ye, Ne = {}, Me = Object.keys(D);
                for (ye = 0; ye < Me.length; ye++) de = Me[ye], j.indexOf(de) >= 0 || (Ne[de] = D[de]);
                return Ne;
              }(F, W);
              if (Object.getOwnPropertySymbols) {
                var fe = Object.getOwnPropertySymbols(F);
                for (le = 0; le < fe.length; le++) X = fe[le], W.indexOf(X) >= 0 || Object.prototype.propertyIsEnumerable.call(F, X) && (ne[X] = F[X]);
              }
              return ne;
            }(T, x), M = (0, p.useRef)(null), R = (0, p.useRef)(null);
            return (0, p.useLayoutEffect)(function() {
              M && (R.current = g.Z.StaticMath(M.current), z && z(R.current));
            }, [M, I]), f().createElement("span", E({}, w, { ref: M }), I);
          };
          b.propTypes = { children: y().string, mathquillDidMount: y().func };
          const C = b;
        }, 700: (l, u, d) => {
          d.d(u, { Z: () => p });
          const p = d(338).getInterface(2);
        }, 527: (l, u, d) => {
          d.d(u, { Z: () => g });
          var p = d(81), f = d.n(p), m = d(645), y = d.n(m)()(f());
          y.push([l.id, `/*
 * MathQuill v0.11.0, by Han, Jeanine, and Mary
 * http://mathquill.com | maintainers@mathquill.com
 *
 * This Source Code Form is subject to the terms of the
 * Mozilla Public License, v. 2.0. If a copy of the MPL
 * was not distributed with this file, You can obtain
 * one at http://mozilla.org/MPL/2.0/.
 */
@font-face {
  /* Heavy fonts have been removed */
  font-family: Symbola;
}
.mq-editable-field {
  display: -moz-inline-box;
  display: inline-block;
}
.mq-editable-field .mq-cursor {
  border-left: 1px solid black;
  margin-left: -1px;
  position: relative;
  z-index: 1;
  padding: 0;
  display: -moz-inline-box;
  display: inline-block;
}
.mq-editable-field .mq-cursor.mq-blink {
  visibility: hidden;
}
.mq-editable-field,
.mq-math-mode .mq-editable-field {
  border: 1px solid gray;
}
.mq-editable-field.mq-focused,
.mq-math-mode .mq-editable-field.mq-focused {
  -webkit-box-shadow: #8bd 0 0 1px 2px, inset #6ae 0 0 2px 0;
  -moz-box-shadow: #8bd 0 0 1px 2px, inset #6ae 0 0 2px 0;
  box-shadow: #8bd 0 0 1px 2px, inset #6ae 0 0 2px 0;
  border-color: #709AC0;
  border-radius: 1px;
}
.mq-math-mode .mq-editable-field {
  margin: 1px;
}
.mq-editable-field .mq-latex-command-input {
  color: inherit;
  font-family: "Courier New", monospace;
  border: 1px solid gray;
  padding-right: 1px;
  margin-right: 1px;
  margin-left: 2px;
}
.mq-editable-field .mq-latex-command-input.mq-empty {
  background: transparent;
}
.mq-editable-field .mq-latex-command-input.mq-hasCursor {
  border-color: ActiveBorder;
}
.mq-editable-field.mq-empty:after,
.mq-editable-field.mq-text-mode:after,
.mq-math-mode .mq-empty:after {
  visibility: hidden;
  content: 'c';
}
.mq-editable-field .mq-cursor:only-child:after,
.mq-editable-field .mq-textarea + .mq-cursor:last-child:after {
  visibility: hidden;
  content: 'c';
}
.mq-editable-field .mq-text-mode .mq-cursor:only-child:after {
  content: '';
}
.mq-editable-field.mq-text-mode {
  overflow-x: auto;
  overflow-y: hidden;
}
.mq-root-block,
.mq-math-mode .mq-root-block {
  display: -moz-inline-box;
  display: inline-block;
  width: 100%;
  padding: 2px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  vertical-align: middle;
}
.mq-math-mode {
  font-variant: normal;
  font-weight: normal;
  font-style: normal;
  font-size: 115%;
  line-height: 1;
  display: -moz-inline-box;
  display: inline-block;
}
.mq-math-mode .mq-non-leaf,
.mq-math-mode .mq-scaled {
  display: -moz-inline-box;
  display: inline-block;
}
.mq-math-mode var,
.mq-math-mode .mq-text-mode,
.mq-math-mode .mq-nonSymbola {
  font-family: "Times New Roman", Symbola, serif;
  line-height: 0.9;
}
.mq-math-mode * {
  font-size: inherit;
  line-height: inherit;
  margin: 0;
  padding: 0;
  border-color: black;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  box-sizing: border-box;
}
.mq-math-mode .mq-empty {
  background: #ccc;
}
.mq-math-mode .mq-empty.mq-root-block {
  background: transparent;
}
.mq-math-mode.mq-empty {
  background: transparent;
}
.mq-math-mode .mq-text-mode {
  display: inline-block;
  white-space: pre;
}
.mq-math-mode .mq-text-mode.mq-hasCursor {
  box-shadow: inset darkgray 0 0.1em 0.2em;
  padding: 0 0.1em;
  margin: 0 -0.1em;
  min-width: 1ex;
}
.mq-math-mode .mq-font {
  font: 1em "Times New Roman", Symbola, serif;
}
.mq-math-mode .mq-font * {
  font-family: inherit;
  font-style: inherit;
}
.mq-math-mode b,
.mq-math-mode b.mq-font {
  font-weight: bolder;
}
.mq-math-mode var,
.mq-math-mode i,
.mq-math-mode i.mq-font {
  font-style: italic;
}
.mq-math-mode var.mq-f {
  margin-right: 0.2em;
  margin-left: 0.1em;
}
.mq-math-mode .mq-roman var.mq-f {
  margin: 0;
}
.mq-math-mode big {
  font-size: 200%;
}
.mq-math-mode .mq-int > big {
  display: inline-block;
  -webkit-transform: scaleX(0.7);
  -moz-transform: scaleX(0.7);
  -ms-transform: scaleX(0.7);
  -o-transform: scaleX(0.7);
  transform: scaleX(0.7);
  vertical-align: -0.16em;
}
.mq-math-mode .mq-int > .mq-supsub {
  font-size: 80%;
  vertical-align: -1.1em;
  padding-right: 0.2em;
}
.mq-math-mode .mq-int > .mq-supsub > .mq-sup > .mq-sup-inner {
  vertical-align: 1.3em;
}
.mq-math-mode .mq-int > .mq-supsub > .mq-sub {
  margin-left: -0.35em;
}
.mq-math-mode .mq-roman {
  font-style: normal;
}
.mq-math-mode .mq-sans-serif {
  font-family: sans-serif, Symbola, serif;
}
.mq-math-mode .mq-monospace {
  font-family: monospace, Symbola, serif;
}
.mq-math-mode .mq-overline {
  border-top: 1px solid black;
  margin-top: 1px;
}
.mq-math-mode .mq-underline {
  border-bottom: 1px solid black;
  margin-bottom: 1px;
}
.mq-math-mode .mq-binary-operator {
  padding: 0 0.2em;
  display: -moz-inline-box;
  display: inline-block;
}
.mq-math-mode .mq-supsub {
  text-align: left;
  font-size: 90%;
  vertical-align: -0.5em;
}
.mq-math-mode .mq-supsub.mq-sup-only {
  vertical-align: 0.5em;
}
.mq-math-mode .mq-supsub.mq-sup-only .mq-sup {
  display: inline-block;
  vertical-align: text-bottom;
}
.mq-math-mode .mq-supsub .mq-sup {
  display: block;
}
.mq-math-mode .mq-supsub .mq-sub {
  display: block;
  float: left;
}
.mq-math-mode .mq-supsub .mq-binary-operator {
  padding: 0 0.1em;
}
.mq-math-mode .mq-supsub .mq-fraction {
  font-size: 70%;
}
.mq-math-mode sup.mq-nthroot {
  font-size: 80%;
  vertical-align: 0.8em;
  margin-right: -0.6em;
  margin-left: 0.2em;
  min-width: 0.5em;
}
.mq-math-mode .mq-paren {
  padding: 0 0.1em;
  vertical-align: top;
  -webkit-transform-origin: center 0.06em;
  -moz-transform-origin: center 0.06em;
  -ms-transform-origin: center 0.06em;
  -o-transform-origin: center 0.06em;
  transform-origin: center 0.06em;
}
.mq-math-mode .mq-paren.mq-ghost {
  color: silver;
}
.mq-math-mode .mq-paren + span {
  margin-top: 0.1em;
  margin-bottom: 0.1em;
}
.mq-math-mode .mq-array {
  vertical-align: middle;
  text-align: center;
}
.mq-math-mode .mq-array > span {
  display: block;
}
.mq-math-mode .mq-operator-name {
  font-family: Symbola, "Times New Roman", serif;
  line-height: 0.9;
  font-style: normal;
}
.mq-math-mode var.mq-operator-name.mq-first {
  padding-left: 0.2em;
}
.mq-math-mode var.mq-operator-name.mq-last,
.mq-math-mode .mq-supsub.mq-after-operator-name {
  padding-right: 0.2em;
}
.mq-math-mode .mq-fraction {
  font-size: 90%;
  text-align: center;
  vertical-align: -0.4em;
  padding: 0 0.2em;
}
.mq-math-mode .mq-fraction,
.mq-math-mode .mq-large-operator,
.mq-math-mode x:-moz-any-link {
  display: -moz-groupbox;
}
.mq-math-mode .mq-fraction,
.mq-math-mode .mq-large-operator,
.mq-math-mode x:-moz-any-link,
.mq-math-mode x:default {
  display: inline-block;
}
.mq-math-mode .mq-numerator,
.mq-math-mode .mq-denominator,
.mq-math-mode .mq-dot-recurring {
  display: block;
}
.mq-math-mode .mq-numerator {
  padding: 0 0.1em;
}
.mq-math-mode .mq-denominator {
  border-top: 1px solid;
  float: right;
  width: 100%;
  padding: 0.1em;
}
.mq-math-mode .mq-dot-recurring {
  text-align: center;
  height: 0.3em;
}
.mq-math-mode .mq-sqrt-prefix {
  padding-top: 0;
  position: relative;
  top: 0.1em;
  vertical-align: top;
  -webkit-transform-origin: top;
  -moz-transform-origin: top;
  -ms-transform-origin: top;
  -o-transform-origin: top;
  transform-origin: top;
}
.mq-math-mode .mq-sqrt-stem {
  border-top: 1px solid;
  margin-top: 1px;
  padding-left: 0.15em;
  padding-right: 0.2em;
  margin-right: 0.1em;
  padding-top: 1px;
}
.mq-math-mode .mq-diacritic-above {
  display: block;
  text-align: center;
  line-height: 0.4em;
}
.mq-math-mode .mq-diacritic-stem {
  display: block;
  text-align: center;
}
.mq-math-mode .mq-hat-prefix {
  display: block;
  text-align: center;
  line-height: 0.95em;
  margin-bottom: -0.7em;
  transform: scaleX(1.5);
  -moz-transform: scaleX(1.5);
  -o-transform: scaleX(1.5);
  -webkit-transform: scaleX(1.5);
}
.mq-math-mode .mq-hat-stem {
  display: block;
}
.mq-math-mode .mq-large-operator {
  vertical-align: -0.2em;
  padding: 0.2em;
  text-align: center;
}
.mq-math-mode .mq-large-operator .mq-from,
.mq-math-mode .mq-large-operator big,
.mq-math-mode .mq-large-operator .mq-to {
  display: block;
}
.mq-math-mode .mq-large-operator .mq-from,
.mq-math-mode .mq-large-operator .mq-to {
  font-size: 80%;
}
.mq-math-mode .mq-large-operator .mq-from {
  float: right;
  /* take out of normal flow to manipulate baseline */
  width: 100%;
}
.mq-math-mode,
.mq-math-mode .mq-editable-field {
  cursor: text;
  font-family: Symbola, "Times New Roman", serif;
}
.mq-math-mode .mq-overarc {
  border-top: 1px solid black;
  -webkit-border-top-right-radius: 50% 0.3em;
  -moz-border-radius-topright: 50% 0.3em;
  border-top-right-radius: 50% 0.3em;
  -webkit-border-top-left-radius: 50% 0.3em;
  -moz-border-radius-topleft: 50% 0.3em;
  border-top-left-radius: 50% 0.3em;
  margin-top: 1px;
  padding-top: 0.15em;
}
.mq-math-mode .mq-overarrow {
  min-width: 0.5em;
  border-top: 1px solid black;
  margin-top: 1px;
  padding-top: 0.2em;
  text-align: center;
}
.mq-math-mode .mq-overarrow:before {
  display: block;
  position: relative;
  top: -0.34em;
  font-size: 0.5em;
  line-height: 0em;
  content: '\\27A4';
  text-align: right;
}
.mq-math-mode .mq-overarrow.mq-arrow-left:before {
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}
.mq-math-mode .mq-overarrow.mq-arrow-both {
  vertical-align: text-bottom;
}
.mq-math-mode .mq-overarrow.mq-arrow-both.mq-empty {
  min-height: 1.23em;
}
.mq-math-mode .mq-overarrow.mq-arrow-both.mq-empty:after {
  top: -0.34em;
}
.mq-math-mode .mq-overarrow.mq-arrow-both:before {
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}
.mq-math-mode .mq-overarrow.mq-arrow-both:after {
  display: block;
  position: relative;
  top: -2.3em;
  font-size: 0.5em;
  line-height: 0em;
  content: '\\27A4';
  visibility: visible;
  text-align: right;
}
.mq-math-mode .mq-selection,
.mq-editable-field .mq-selection,
.mq-math-mode .mq-selection .mq-non-leaf,
.mq-editable-field .mq-selection .mq-non-leaf,
.mq-math-mode .mq-selection .mq-scaled,
.mq-editable-field .mq-selection .mq-scaled {
  background: #B4D5FE !important;
  background: Highlight !important;
  color: HighlightText;
  border-color: HighlightText;
}
.mq-math-mode .mq-selection .mq-matrixed,
.mq-editable-field .mq-selection .mq-matrixed {
  background: #39F !important;
}
.mq-math-mode .mq-selection .mq-matrixed-container,
.mq-editable-field .mq-selection .mq-matrixed-container {
  filter: progid:DXImageTransform.Microsoft.Chroma(color='#3399FF') !important;
}
.mq-math-mode .mq-selection.mq-blur,
.mq-editable-field .mq-selection.mq-blur,
.mq-math-mode .mq-selection.mq-blur .mq-non-leaf,
.mq-editable-field .mq-selection.mq-blur .mq-non-leaf,
.mq-math-mode .mq-selection.mq-blur .mq-scaled,
.mq-editable-field .mq-selection.mq-blur .mq-scaled,
.mq-math-mode .mq-selection.mq-blur .mq-matrixed,
.mq-editable-field .mq-selection.mq-blur .mq-matrixed {
  background: #D4D4D4 !important;
  color: black;
  border-color: black;
}
.mq-math-mode .mq-selection.mq-blur .mq-matrixed-container,
.mq-editable-field .mq-selection.mq-blur .mq-matrixed-container {
  filter: progid:DXImageTransform.Microsoft.Chroma(color='#D4D4D4') !important;
}
.mq-editable-field .mq-textarea,
.mq-math-mode .mq-textarea {
  position: relative;
  -webkit-user-select: text;
  -moz-user-select: text;
  user-select: text;
}
.mq-editable-field .mq-textarea *,
.mq-math-mode .mq-textarea *,
.mq-editable-field .mq-selectable,
.mq-math-mode .mq-selectable {
  -webkit-user-select: text;
  -moz-user-select: text;
  user-select: text;
  position: absolute;
  clip: rect(1em 1em 1em 1em);
  -webkit-transform: scale(0);
  -moz-transform: scale(0);
  -ms-transform: scale(0);
  -o-transform: scale(0);
  transform: scale(0);
  resize: none;
  width: 1px;
  height: 1px;
  box-sizing: content-box;
}
.mq-math-mode .mq-matrixed {
  background: white;
  display: -moz-inline-box;
  display: inline-block;
}
.mq-math-mode .mq-matrixed-container {
  filter: progid:DXImageTransform.Microsoft.Chroma(color='white');
  margin-top: -0.1em;
}
`, ""]);
          const g = y;
        }, 645: (l) => {
          l.exports = function(u) {
            var d = [];
            return d.toString = function() {
              return this.map(function(p) {
                var f = "", m = p[5] !== void 0;
                return p[4] && (f += "@supports (".concat(p[4], ") {")), p[2] && (f += "@media ".concat(p[2], " {")), m && (f += "@layer".concat(p[5].length > 0 ? " ".concat(p[5]) : "", " {")), f += u(p), m && (f += "}"), p[2] && (f += "}"), p[4] && (f += "}"), f;
              }).join("");
            }, d.i = function(p, f, m, y, g) {
              typeof p == "string" && (p = [[null, p, void 0]]);
              var x = {};
              if (m) for (var E = 0; E < this.length; E++) {
                var b = this[E][0];
                b != null && (x[b] = !0);
              }
              for (var C = 0; C < p.length; C++) {
                var T = [].concat(p[C]);
                m && x[T[0]] || (g !== void 0 && (T[5] === void 0 || (T[1] = "@layer".concat(T[5].length > 0 ? " ".concat(T[5]) : "", " {").concat(T[1], "}")), T[5] = g), f && (T[2] && (T[1] = "@media ".concat(T[2], " {").concat(T[1], "}")), T[2] = f), y && (T[4] ? (T[1] = "@supports (".concat(T[4], ") {").concat(T[1], "}"), T[4] = y) : T[4] = "".concat(y)), d.push(T));
              }
            }, d;
          };
        }, 81: (l) => {
          l.exports = function(u) {
            return u[1];
          };
        }, 338: (l, u, d) => {
          var p = d(755);
          window.jQuery = p, function() {
            var f, m = window.jQuery, y = "mathquill-command-id", g = "mathquill-block-id", x = Math.min, E = Math.max;
            if (!m) throw "MathQuill requires jQuery 1.5.2+ to be loaded first";
            function b() {
            }
            var C = [].slice;
            function T(_) {
              var H = _.length - 1;
              return function() {
                var S = C.call(arguments, 0, H), A = C.call(arguments, H);
                return _.apply(this, S.concat([A]));
              };
            }
            var z = T(function(_, H) {
              return T(function(S, A) {
                if (_ in S) return S[_].apply(S, H.concat(A));
              });
            });
            function I(_) {
              return T(function(H, S) {
                return typeof H != "function" && (H = z(H)), _.call(this, function(A) {
                  return H.apply(A, [A].concat(S));
                });
              });
            }
            function w(_) {
              var H = C.call(arguments, 1);
              return function() {
                return _.apply(this, H);
              };
            }
            function M(_, H) {
              if (!H) throw new Error("prayer failed: " + _);
            }
            var R = /* @__PURE__ */ function(_, H, S) {
              function A(ie) {
                return typeof ie == "object";
              }
              function P(ie) {
                return typeof ie == "function";
              }
              function Q() {
              }
              return function ie(pe, ce) {
                function ze() {
                  var ut = new Xe();
                  return P(ut.init) && ut.init.apply(ut, arguments), ut;
                }
                function Xe() {
                }
                ce === void 0 && (ce = pe, pe = Object), ze.Bare = Xe;
                var wt, jt = Q.prototype = pe.prototype, Kt = Xe.prototype = ze.prototype = ze.p = new Q();
                return Kt.constructor = ze, ze.extend = function(ut) {
                  return ie(ze, ut);
                }, (ze.open = function(ut) {
                  if (wt = {}, P(ut) ? wt = ut.call(ze, Kt, jt, ze, pe) : A(ut) && (wt = ut), A(wt)) for (var Yt in wt) H.call(wt, Yt) && (Kt[Yt] = wt[Yt]);
                  return P(Kt.init) || (Kt.init = pe), ze;
                })(ce);
              };
            }(0, {}.hasOwnProperty), F = -1;
            function W(_) {
              M("a direction was passed", _ === F || _ === 1);
            }
            var X = R(m, function(_) {
              _.insDirOf = function(H, S) {
                return H === F ? this.insertBefore(S.first()) : this.insertAfter(S.last());
              }, _.insAtDirEnd = function(H, S) {
                return H === F ? this.prependTo(S) : this.appendTo(S);
              };
            }), le = R(function(_) {
              _.parent = 0, _[F] = 0, _[1] = 0, _.init = function(H, S, A) {
                this.parent = H, this[F] = S, this[1] = A;
              }, this.copy = function(H) {
                return le(H.parent, H[F], H[1]);
              };
            }), ne = R(function(_) {
              _[F] = 0, _[1] = 0, _.parent = 0;
              var H = 0;
              this.byId = {}, _.init = function() {
                this.id = H += 1, ne.byId[this.id] = this, this.ends = {}, this.ends[F] = 0, this.ends[1] = 0;
              }, _.dispose = function() {
                delete ne.byId[this.id];
              }, _.toString = function() {
                return "{{ MathQuill Node #" + this.id + " }}";
              }, _.jQ = X(), _.jQadd = function(S) {
                return this.jQ = this.jQ.add(S);
              }, _.jQize = function(S) {
                function A(Q) {
                  if (Q.getAttribute) {
                    var ie = Q.getAttribute("mathquill-command-id"), pe = Q.getAttribute("mathquill-block-id");
                    ie && ne.byId[ie].jQadd(Q), pe && ne.byId[pe].jQadd(Q);
                  }
                  for (Q = Q.firstChild; Q; Q = Q.nextSibling) A(Q);
                }
                S = X(S || this.html());
                for (var P = 0; P < S.length; P += 1) A(S[P]);
                return S;
              }, _.createDir = function(S, A) {
                W(S);
                var P = this;
                return P.jQize(), P.jQ.insDirOf(S, A.jQ), A[S] = P.adopt(A.parent, A[F], A[1]), P;
              }, _.createLeftOf = function(S) {
                return this.createDir(F, S);
              }, _.selectChildren = function(S, A) {
                return Ne(S, A);
              }, _.bubble = I(function(S) {
                for (var A = this; A && S(A) !== !1; A = A.parent) ;
                return this;
              }), _.postOrder = I(function(S) {
                return function A(P) {
                  P.eachChild(A), S(P);
                }(this), this;
              }), _.isEmpty = function() {
                return this.ends[F] === 0 && this.ends[1] === 0;
              }, _.isStyleBlock = function() {
                return !1;
              }, _.children = function() {
                return D(this.ends[F], this.ends[1]);
              }, _.eachChild = function() {
                var S = this.children();
                return S.each.apply(S, arguments), this;
              }, _.foldChildren = function(S, A) {
                return this.children().fold(S, A);
              }, _.withDirAdopt = function(S, A, P, Q) {
                return D(this, this).withDirAdopt(S, A, P, Q), this;
              }, _.adopt = function(S, A, P) {
                return D(this, this).adopt(S, A, P), this;
              }, _.disown = function() {
                return D(this, this).disown(), this;
              }, _.remove = function() {
                return this.jQ.remove(), this.postOrder("dispose"), this.disown();
              };
            });
            function fe(_, H, S) {
              M("a parent is always present", _), M("leftward is properly set up", H ? H[1] === S && H.parent === _ : _.ends[F] === S), M("rightward is properly set up", S ? S[F] === H && S.parent === _ : _.ends[1] === H);
            }
            var D = R(function(_) {
              _.init = function(H, S, A) {
                if (A === f && (A = F), W(A), M("no half-empty fragments", !H == !S), this.ends = {}, H) {
                  M("withDir is passed to Fragment", H instanceof ne), M("oppDir is passed to Fragment", S instanceof ne), M("withDir and oppDir have the same parent", H.parent === S.parent), this.ends[A] = H, this.ends[-A] = S;
                  var P = this.fold([], function(Q, ie) {
                    return Q.push.apply(Q, ie.jQ.get()), Q;
                  });
                  this.jQ = this.jQ.add(P);
                }
              }, _.jQ = X(), _.withDirAdopt = function(H, S, A, P) {
                return H === F ? this.adopt(S, A, P) : this.adopt(S, P, A);
              }, _.adopt = function(H, S, A) {
                fe(H, S, A);
                var P = this;
                P.disowned = !1;
                var Q = P.ends[F];
                if (!Q) return this;
                var ie = P.ends[1];
                return S || (H.ends[F] = Q), A ? A[F] = ie : H.ends[1] = ie, P.ends[1][1] = A, P.each(function(pe) {
                  pe[F] = S, pe.parent = H, S && (S[1] = pe), S = pe;
                }), P;
              }, _.disown = function() {
                var H = this, S = H.ends[F];
                if (!S || H.disowned) return H;
                H.disowned = !0;
                var A = H.ends[1], P = S.parent;
                return fe(P, S[F], S), fe(P, A, A[1]), S[F] ? S[F][1] = A[1] : P.ends[F] = A[1], A[1] ? A[1][F] = S[F] : P.ends[1] = S[F], H;
              }, _.remove = function() {
                return this.jQ.remove(), this.each("postOrder", "dispose"), this.disown();
              }, _.each = I(function(H) {
                var S = this, A = S.ends[F];
                if (!A) return S;
                for (; A !== S.ends[1][1] && H(A) !== !1; A = A[1]) ;
                return S;
              }), _.fold = function(H, S) {
                return this.each(function(A) {
                  H = S.call(this, H, A);
                }), H;
              };
            }), j = {}, de = {}, ye = R(le, function(_) {
              _.init = function(H, S) {
                this.parent = H, this.options = S;
                var A = this.jQ = this._jQ = X('<span class="mq-cursor">&#8203;</span>');
                this.blink = function() {
                  A.toggleClass("mq-blink");
                }, this.upDownCache = {};
              }, _.show = function() {
                return this.jQ = this._jQ.removeClass("mq-blink"), "intervalId" in this ? clearInterval(this.intervalId) : (this[1] ? this.selection && this.selection.ends[F][F] === this[F] ? this.jQ.insertBefore(this.selection.jQ) : this.jQ.insertBefore(this[1].jQ.first()) : this.jQ.appendTo(this.parent.jQ), this.parent.focus()), this.intervalId = setInterval(this.blink, 500), this;
              }, _.hide = function() {
                return "intervalId" in this && clearInterval(this.intervalId), delete this.intervalId, this.jQ.detach(), this.jQ = X(), this;
              }, _.withDirInsertAt = function(H, S, A, P) {
                var Q = this.parent;
                this.parent = S, this[H] = A, this[-H] = P, Q !== S && Q.blur && Q.blur(this);
              }, _.insDirOf = function(H, S) {
                return W(H), this.jQ.insDirOf(H, S.jQ), this.withDirInsertAt(H, S.parent, S[H], S), this.parent.jQ.addClass("mq-hasCursor"), this;
              }, _.insLeftOf = function(H) {
                return this.insDirOf(F, H);
              }, _.insRightOf = function(H) {
                return this.insDirOf(1, H);
              }, _.insAtDirEnd = function(H, S) {
                return W(H), this.jQ.insAtDirEnd(H, S.jQ), this.withDirInsertAt(H, S, 0, S.ends[H]), S.focus(), this;
              }, _.insAtLeftEnd = function(H) {
                return this.insAtDirEnd(F, H);
              }, _.insAtRightEnd = function(H) {
                return this.insAtDirEnd(1, H);
              }, _.jumpUpDown = function(H, S) {
                var A = this;
                A.upDownCache[H.id] = le.copy(A);
                var P = A.upDownCache[S.id];
                if (P) P[1] ? A.insLeftOf(P[1]) : A.insAtRightEnd(P.parent);
                else {
                  var Q = A.offset().left;
                  S.seek(Q, A);
                }
              }, _.offset = function() {
                var H = this.jQ.removeClass("mq-cursor").offset();
                return this.jQ.addClass("mq-cursor"), H;
              }, _.unwrapGramp = function() {
                var H = this.parent.parent, S = H.parent, A = H[1], P = H[F];
                if (H.disown().eachChild(function(Q) {
                  Q.isEmpty() || (Q.children().adopt(S, P, A).each(function(ie) {
                    ie.jQ.insertBefore(H.jQ.first());
                  }), P = Q.ends[1]);
                }), !this[1]) if (this[F]) this[1] = this[F][1];
                else for (; !this[1]; ) {
                  if (this.parent = this.parent[1], !this.parent) {
                    this[1] = H[1], this.parent = S;
                    break;
                  }
                  this[1] = this.parent.ends[F];
                }
                this[1] ? this.insLeftOf(this[1]) : this.insAtRightEnd(S), H.jQ.remove(), H[F].siblingDeleted && H[F].siblingDeleted(this.options, 1), H[1].siblingDeleted && H[1].siblingDeleted(this.options, F);
              }, _.startSelection = function() {
                for (var H = this.anticursor = le.copy(this), S = H.ancestors = {}, A = H; A.parent; A = A.parent) S[A.parent.id] = A;
              }, _.endSelection = function() {
                delete this.anticursor;
              }, _.select = function() {
                var H = this.anticursor;
                if (this[F] === H[F] && this.parent === H.parent) return !1;
                for (var S = this; S.parent; S = S.parent) if (S.parent.id in H.ancestors) {
                  var A = S.parent;
                  break;
                }
                M("cursor and anticursor in the same tree", A);
                var P, Q, ie = H.ancestors[A.id], pe = 1;
                if (S[F] !== ie) {
                  for (var ce = S; ce; ce = ce[1]) if (ce[1] === ie[1]) {
                    pe = F, P = S, Q = ie;
                    break;
                  }
                }
                return pe === 1 && (P = ie, Q = S), P instanceof le && (P = P[1]), Q instanceof le && (Q = Q[F]), this.hide().selection = A.selectChildren(P, Q), this.insDirOf(pe, this.selection.ends[pe]), this.selectionChanged(), !0;
              }, _.clearSelection = function() {
                return this.selection && (this.selection.clear(), delete this.selection, this.selectionChanged()), this;
              }, _.deleteSelection = function() {
                this.selection && (this[F] = this.selection.ends[F][F], this[1] = this.selection.ends[1][1], this.selection.remove(), this.selectionChanged(), delete this.selection);
              }, _.replaceSelection = function() {
                var H = this.selection;
                return H && (this[F] = H.ends[F][F], this[1] = H.ends[1][1], delete this.selection), H;
              }, _.depth = function() {
                for (var H = this, S = 0; H = H.parent; ) S += H instanceof vt ? 1 : 0;
                return S;
              }, _.isTooDeep = function(H) {
                if (this.options.maxDepth !== f) return this.depth() + (H || 0) > this.options.maxDepth;
              };
            }), Ne = R(D, function(_, H) {
              _.init = function() {
                H.init.apply(this, arguments), this.jQ = this.jQ.wrapAll('<span class="mq-selection"></span>').parent();
              }, _.adopt = function() {
                return this.jQ.replaceWith(this.jQ = this.jQ.children()), H.adopt.apply(this, arguments);
              }, _.clear = function() {
                return this.jQ.replaceWith(this.jQ[0].childNodes), this;
              }, _.join = function(S) {
                return this.fold("", function(A, P) {
                  return A + P[S]();
                });
              };
            }), Me = R(function(_) {
              _.init = function(S, A, P) {
                this.id = S.id, this.data = {}, this.root = S, this.container = A, this.options = P, S.controller = this, this.cursor = S.cursor = ye(S, P);
              }, _.handle = function(S, A) {
                var P = this.options.handlers;
                if (P && P.fns[S]) {
                  var Q = P.APIClasses[this.KIND_OF_MQ](this);
                  A === F || A === 1 ? P.fns[S](A, Q) : P.fns[S](Q);
                }
              };
              var H = [];
              this.onNotify = function(S) {
                H.push(S);
              }, _.notify = function() {
                for (var S = 0; S < H.length; S += 1) H[S].apply(this.cursor, arguments);
                return this;
              };
            }), Ie = {}, at = R(), Ve = {}, mt = R(), ae = {};
            function Se() {
              window.console && console.warn(`You are using the MathQuill API without specifying an interface version, which will fail in v1.0.0. Easiest fix is to do the following before doing anything else:

    MathQuill = MathQuill.getInterface(1);
    // now MathQuill.MathField() works like it used to

See also the "\`dev\` branch (2014–2015) → v0.10.0 Migration Guide" at
  https://github.com/mathquill/mathquill/wiki/%60dev%60-branch-(2014%E2%80%932015)-%E2%86%92-v0.10.0-Migration-Guide`);
            }
            function Ae(_) {
              return Se(), Ka(_);
            }
            Ae.prototype = mt.p, Ae.VERSION = "v0.11.0", Ae.interfaceVersion = function(_) {
              if (_ !== 1) throw "Only interface version 1 supported. You specified: " + _;
              return (Se = function() {
                window.console && console.warn(`You called MathQuill.interfaceVersion(1); to specify the interface version, which will fail in v1.0.0. You can fix this easily by doing this before doing anything else:

    MathQuill = MathQuill.getInterface(1);
    // now MathQuill.MathField() works like it used to

See also the "\`dev\` branch (2014–2015) → v0.10.0 Migration Guide" at
  https://github.com/mathquill/mathquill/wiki/%60dev%60-branch-(2014%E2%80%932015)-%E2%86%92-v0.10.0-Migration-Guide`);
              })(), Ae;
            }, Ae.getInterface = We;
            var Be = We.MIN = 1, Ze = We.MAX = 2;
            function We(_) {
              if (!(Be <= _ && _ <= Ze)) throw "Only interface versions between " + Be + " and " + Ze + " supported. You specified: " + _;
              function H(ie) {
                if (!ie || !ie.nodeType) return null;
                var pe = X(ie).children(".mq-root-block").attr(g), ce = pe && ne.byId[pe].controller;
                return ce ? S[ce.KIND_OF_MQ](ce) : null;
              }
              var S = {};
              function A(ie, pe) {
                for (var ce in pe && pe.handlers && (pe.handlers = { fns: pe.handlers, APIClasses: S }), pe) if (pe.hasOwnProperty(ce)) {
                  var ze = pe[ce], Xe = Ve[ce];
                  ie[ce] = Xe ? Xe(ze) : ze;
                }
              }
              H.L = F, H.R = 1, H.saneKeyboardEvents = Wt, H.config = function(ie) {
                return A(at.p, ie), this;
              }, H.registerEmbed = function(ie, pe) {
                if (!/^[a-z][a-z0-9]*$/i.test(ie)) throw "Embed name must start with letter and be only letters and digits";
                ae[ie] = pe;
              };
              var P = S.AbstractMathQuill = R(mt, function(ie) {
                ie.init = function(pe) {
                  this.__controller = pe, this.__options = pe.options, this.id = pe.id, this.data = pe.data;
                }, ie.__mathquillify = function(pe) {
                  var ce = this.__controller, ze = ce.root, Xe = ce.container;
                  ce.createTextarea();
                  var wt = Xe.addClass(pe).contents().detach();
                  ze.jQ = X('<span class="mq-root-block"/>').attr(g, ze.id).appendTo(Xe), this.latex(wt.text()), this.revert = function() {
                    return Xe.empty().unbind(".mathquill").removeClass("mq-editable-field mq-math-mode mq-text-mode").append(wt);
                  };
                }, ie.config = function(pe) {
                  return A(this.__options, pe), this;
                }, ie.el = function() {
                  return this.__controller.container[0];
                }, ie.text = function() {
                  return this.__controller.exportText();
                }, ie.latex = function(pe) {
                  return arguments.length > 0 ? (this.__controller.renderLatexMath(pe), this.__controller.blurred && this.__controller.cursor.hide().parent.blur(), this) : this.__controller.exportLatex();
                }, ie.html = function() {
                  return this.__controller.root.jQ.html().replace(/ mathquill-(?:command|block)-id="?\d+"?/g, "").replace(/<span class="?mq-cursor( mq-blink)?"?>.?<\/span>/i, "").replace(/ mq-hasCursor|mq-hasCursor ?/, "").replace(/ class=(""|(?= |>))/g, "");
                }, ie.reflow = function() {
                  return this.__controller.root.postOrder("reflow"), this;
                };
              });
              for (var Q in H.prototype = P.prototype, S.EditableField = R(P, function(ie, pe) {
                ie.__mathquillify = function() {
                  return pe.__mathquillify.apply(this, arguments), this.__controller.editable = !0, this.__controller.delegateMouseEvents(), this.__controller.editablesTextareaEvents(), this;
                }, ie.focus = function() {
                  return this.__controller.textarea.focus(), this;
                }, ie.blur = function() {
                  return this.__controller.textarea.blur(), this;
                }, ie.write = function(ce) {
                  return this.__controller.writeLatex(ce), this.__controller.scrollHoriz(), this.__controller.blurred && this.__controller.cursor.hide().parent.blur(), this;
                }, ie.empty = function() {
                  var ce = this.__controller.root, ze = this.__controller.cursor;
                  return ce.eachChild("postOrder", "dispose"), ce.ends[F] = ce.ends[1] = 0, ce.jQ.empty(), delete ze.selection, ze.insAtRightEnd(ce), this;
                }, ie.cmd = function(ce) {
                  var ze = this.__controller.notify(), Xe = ze.cursor;
                  if (/^\\[a-z]+$/i.test(ce) && !Xe.isTooDeep()) {
                    ce = ce.slice(1);
                    var wt = j[ce];
                    wt && (ce = wt(ce), Xe.selection && ce.replaces(Xe.replaceSelection()), ce.createLeftOf(Xe.show()), this.__controller.scrollHoriz());
                  } else Xe.parent.write(Xe, ce);
                  return ze.blurred && Xe.hide().parent.blur(), this;
                }, ie.select = function() {
                  var ce = this.__controller;
                  for (ce.notify("move").cursor.insAtRightEnd(ce.root); ce.cursor[F]; ) ce.selectLeft();
                  return this;
                }, ie.clearSelection = function() {
                  return this.__controller.cursor.clearSelection(), this;
                }, ie.moveToDirEnd = function(ce) {
                  return this.__controller.notify("move").cursor.insAtDirEnd(ce, this.__controller.root), this;
                }, ie.moveToLeftEnd = function() {
                  return this.moveToDirEnd(F);
                }, ie.moveToRightEnd = function() {
                  return this.moveToDirEnd(1);
                }, ie.keystroke = function(ce) {
                  ce = ce.replace(/^\s+|\s+$/g, "").split(/\s+/);
                  for (var ze = 0; ze < ce.length; ze += 1) this.__controller.keystroke(ce[ze], { preventDefault: b });
                  return this;
                }, ie.typedText = function(ce) {
                  for (var ze = 0; ze < ce.length; ze += 1) this.__controller.typedText(ce.charAt(ze));
                  return this;
                }, ie.dropEmbedded = function(ce, ze, Xe) {
                  var wt = ce - X(window).scrollLeft(), jt = ze - X(window).scrollTop(), Kt = document.elementFromPoint(wt, jt);
                  this.__controller.seek(X(Kt), ce, ze), Cl().setOptions(Xe).createLeftOf(this.__controller.cursor);
                }, ie.clickAt = function(ce, ze, Xe) {
                  Xe = Xe || document.elementFromPoint(ce, ze);
                  var wt = this.__controller, jt = wt.root;
                  return m.contains(jt.jQ[0], Xe) || (Xe = jt.jQ[0]), wt.seek(X(Xe), ce + pageXOffset, ze + pageYOffset), wt.blurred && this.focus(), this;
                }, ie.ignoreNextMousedown = function(ce) {
                  return this.__controller.cursor.options.ignoreNextMousedown = ce, this;
                };
              }), H.EditableField = function() {
                throw "wtf don't call me, I'm 'abstract'";
              }, H.EditableField.prototype = S.EditableField.prototype, Ie) (function(ie, pe) {
                var ce = S[ie] = pe(S);
                H[ie] = function(ze, Xe) {
                  var wt = H(ze);
                  if (wt instanceof ce || !ze || !ze.nodeType) return wt;
                  var jt = Me(ce.RootBlock(), X(ze), at());
                  return jt.KIND_OF_MQ = ie, ce(jt).__mathquillify(Xe, _);
                }, H[ie].prototype = ce.prototype;
              })(Q, Ie[Q]);
              return H;
            }
            Ae.noConflict = function() {
              return window.MathQuill = St, Ae;
            };
            var St = window.MathQuill;
            function pt(_) {
              for (var H = "moveOutOf deleteOutOf selectOutOf upOutOf downOutOf".split(" "), S = 0; S < H.length; S += 1) (function(A) {
                _[A] = function(P) {
                  this.controller.handle(A, P);
                };
              })(H[S]);
              _.reflow = function() {
                this.controller.handle("reflow"), this.controller.handle("edited"), this.controller.handle("edit");
              };
            }
            window.MathQuill = Ae;
            var Tt, Wt = (Tt = { 8: "Backspace", 9: "Tab", 10: "Enter", 13: "Enter", 16: "Shift", 17: "Control", 18: "Alt", 20: "CapsLock", 27: "Esc", 32: "Spacebar", 33: "PageUp", 34: "PageDown", 35: "End", 36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 45: "Insert", 46: "Del", 144: "NumLock" }, function(_, H) {
              var S, A = null, P = null, Q = m(_), ie = m(H.container || Q), pe = b;
              function ce(ut) {
                pe = ut, clearTimeout(S), S = setTimeout(ut);
              }
              function ze(ut) {
                ce(function(Yt) {
                  pe = b, clearTimeout(S), ut(Yt);
                });
              }
              ie.bind("keydown keypress input keyup focusout paste", function(ut) {
                pe(ut);
              });
              var Xe = !1;
              function wt() {
                H.keystroke(function(ut) {
                  var Yt, Rt = ut.which || ut.keyCode, wn = Tt[Rt], br = [];
                  return ut.ctrlKey && br.push("Ctrl"), ut.originalEvent && ut.originalEvent.metaKey && br.push("Meta"), ut.altKey && br.push("Alt"), ut.shiftKey && br.push("Shift"), Yt = wn || String.fromCharCode(Rt), br.length || wn ? (br.push(Yt), br.join("-")) : Yt;
                }(A), A);
              }
              function jt() {
                if (!("selectionStart" in (ut = Q[0])) || ut.selectionStart === ut.selectionEnd) {
                  var ut, Yt = Q.val();
                  Yt.length === 1 ? (Q.val(""), H.typedText(Yt)) : Yt && Q[0].select && Q[0].select();
                }
              }
              function Kt() {
                var ut = Q.val();
                Q.val(""), ut && H.paste(ut);
              }
              return ie.bind({ keydown: function(ut) {
                A = ut, P = null, Xe && ze(function(Yt) {
                  Yt && Yt.type === "focusout" || !Q[0].select || Q[0].select();
                }), wt();
              }, keypress: function(ut) {
                A && P && wt(), P = ut, ce(jt);
              }, keyup: function(ut) {
                A && !P && ce(jt);
              }, focusout: function() {
                A = P = null;
              }, cut: function() {
                ze(function() {
                  H.cut();
                });
              }, copy: function() {
                ze(function() {
                  H.copy();
                });
              }, paste: function(ut) {
                Q.focus(), ce(Kt);
              } }), { select: function(ut) {
                pe(), pe = b, clearTimeout(S), Q.val(ut), ut && Q[0].select && Q[0].select(), Xe = !!ut;
              } };
            }), et = R(function(_, H, S) {
              function A(pe, ce) {
                throw "Parse Error: " + ce + " at " + (pe ? "'" + pe + "'" : "EOF");
              }
              _.init = function(pe) {
                this._ = pe;
              }, _.parse = function(pe) {
                return this.skip(ie)._("" + pe, function(ce, ze) {
                  return ze;
                }, A);
              }, _.or = function(pe) {
                M("or is passed a parser", pe instanceof S);
                var ce = this;
                return S(function(ze, Xe, wt) {
                  return ce._(ze, Xe, function(jt) {
                    return pe._(ze, Xe, wt);
                  });
                });
              }, _.then = function(pe) {
                var ce = this;
                return S(function(ze, Xe, wt) {
                  return ce._(ze, function(jt, Kt) {
                    var ut = pe instanceof S ? pe : pe(Kt);
                    return M("a parser is returned", ut instanceof S), ut._(jt, Xe, wt);
                  }, wt);
                });
              }, _.many = function() {
                var pe = this;
                return S(function(ce, ze, Xe) {
                  for (var wt = []; pe._(ce, jt, Kt); ) ;
                  return ze(ce, wt);
                  function jt(ut, Yt) {
                    return ce = ut, wt.push(Yt), !0;
                  }
                  function Kt() {
                    return !1;
                  }
                });
              }, _.times = function(pe, ce) {
                arguments.length < 2 && (ce = pe);
                var ze = this;
                return S(function(Xe, wt, jt) {
                  for (var Kt, ut = [], Yt = !0, Rt = 0; Rt < pe; Rt += 1) if (!(Yt = ze._(Xe, wn, br))) return jt(Xe, Kt);
                  for (; Rt < ce && Yt; Rt += 1) Yt = ze._(Xe, wn, Pu);
                  return wt(Xe, ut);
                  function wn(Ds, uo) {
                    return ut.push(uo), Xe = Ds, !0;
                  }
                  function br(Ds, uo) {
                    return Kt = uo, Xe = Ds, !1;
                  }
                  function Pu(Ds, uo) {
                    return !1;
                  }
                });
              }, _.result = function(pe) {
                return this.then(Q(pe));
              }, _.atMost = function(pe) {
                return this.times(0, pe);
              }, _.atLeast = function(pe) {
                var ce = this;
                return ce.times(pe).then(function(ze) {
                  return ce.many().map(function(Xe) {
                    return ze.concat(Xe);
                  });
                });
              }, _.map = function(pe) {
                return this.then(function(ce) {
                  return Q(pe(ce));
                });
              }, _.skip = function(pe) {
                return this.then(function(ce) {
                  return pe.result(ce);
                });
              }, this.string = function(pe) {
                var ce = pe.length, ze = "expected '" + pe + "'";
                return S(function(Xe, wt, jt) {
                  var Kt = Xe.slice(0, ce);
                  return Kt === pe ? wt(Xe.slice(ce), Kt) : jt(Xe, ze);
                });
              };
              var P = this.regex = function(pe) {
                M("regexp parser is anchored", pe.toString().charAt(1) === "^");
                var ce = "expected " + pe;
                return S(function(ze, Xe, wt) {
                  var jt = pe.exec(ze);
                  if (jt) {
                    var Kt = jt[0];
                    return Xe(ze.slice(Kt.length), Kt);
                  }
                  return wt(ze, ce);
                });
              }, Q = S.succeed = function(pe) {
                return S(function(ce, ze) {
                  return ze(ce, pe);
                });
              }, ie = (S.fail = function(pe) {
                return S(function(ce, ze, Xe) {
                  return Xe(ce, pe);
                });
              }, S.letter = P(/^[a-z]/i), S.letters = P(/^[a-z]*/i), S.digit = P(/^[0-9]/), S.digits = P(/^[0-9]*/), S.whitespace = P(/^\s+/), S.optWhitespace = P(/^\s*/), S.any = S(function(pe, ce, ze) {
                return pe ? ce(pe.slice(1), pe.charAt(0)) : ze(pe, "expected any character");
              }), S.all = S(function(pe, ce, ze) {
                return ce("", pe);
              }), S.eof = S(function(pe, ce, ze) {
                return pe ? ze(pe, "expected EOF") : ce(pe, pe);
              }));
            });
            Me.open(function(_) {
              _.focusBlurEvents = function() {
                var H, S = this, A = S.root, P = S.cursor;
                function Q() {
                  clearTimeout(H), P.selection && P.selection.jQ.addClass("mq-blur"), ie();
                }
                function ie() {
                  P.hide().parent.blur(), S.container.removeClass("mq-focused"), X(window).unbind("blur", Q);
                }
                S.textarea.focus(function() {
                  S.blurred = !1, clearTimeout(H), S.container.addClass("mq-focused"), P.parent || P.insAtRightEnd(A), P.selection ? (P.selection.jQ.removeClass("mq-blur"), S.selectionChanged()) : P.show();
                }).blur(function() {
                  S.blurred = !0, H = setTimeout(function() {
                    A.postOrder("intentionalBlur"), P.clearSelection().endSelection(), ie();
                  }), X(window).bind("blur", Q);
                }), S.blurred = !0, P.hide().parent.blur();
              };
            }), Me.open(function(_, H) {
              _.exportText = function() {
                return this.root.foldChildren("", function(S, A) {
                  return S + A.text();
                });
              };
            }), Me.open(function(_) {
              at.p.ignoreNextMousedown = b, _.delegateMouseEvents = function() {
                var H = this.root.jQ;
                this.container.bind("mousedown.mathquill", function(S) {
                  var A, P = X(S.target).closest(".mq-root-block"), Q = ne.byId[P.attr(g) || H.attr(g)].controller, ie = Q.cursor, pe = ie.blink, ce = Q.textareaSpan, ze = Q.textarea;
                  function Xe(jt) {
                    A = X(jt.target);
                  }
                  function wt(jt) {
                    ie.anticursor || ie.startSelection(), Q.seek(A, jt.pageX, jt.pageY).cursor.select(), A = f;
                  }
                  S.preventDefault(), S.target.unselectable = !0, ie.options.ignoreNextMousedown(S) || (ie.options.ignoreNextMousedown = b, Q.blurred && (Q.editable || P.prepend(ce), ze.focus()), ie.blink = b, Q.seek(X(S.target), S.pageX, S.pageY).cursor.startSelection(), P.mousemove(Xe), X(S.target.ownerDocument).mousemove(wt).mouseup(function jt(Kt) {
                    ie.blink = pe, ie.selection || (Q.editable ? ie.show() : ce.detach()), P.unbind("mousemove", Xe), X(Kt.target.ownerDocument).unbind("mousemove", wt).unbind("mouseup", jt);
                  }));
                });
              };
            }), Me.open(function(_) {
              _.seek = function(H, S, A) {
                var P = this.notify("select").cursor;
                if (H) {
                  var Q = H.attr(g) || H.attr(y);
                  if (!Q) {
                    var ie = H.parent();
                    Q = ie.attr(g) || ie.attr(y);
                  }
                }
                var pe = Q ? ne.byId[Q] : this.root;
                return M("nodeId is the id of some Node that exists", pe), P.clearSelection().show(), pe.seek(S, P), this.scrollHoriz(), this;
              };
            }), Me.open(function(_) {
              _.keystroke = function(H, S) {
                this.cursor.parent.keystroke(H, S, this);
              };
            }), ne.open(function(_) {
              _.keystroke = function(H, S, A) {
                var P = A.cursor;
                switch (H) {
                  case "Ctrl-Shift-Backspace":
                  case "Ctrl-Backspace":
                    A.ctrlDeleteDir(F);
                    break;
                  case "Shift-Backspace":
                  case "Backspace":
                    A.backspace();
                    break;
                  case "Esc":
                  case "Tab":
                    return void A.escapeDir(1, H, S);
                  case "Shift-Tab":
                  case "Shift-Esc":
                    return void A.escapeDir(F, H, S);
                  case "End":
                    A.notify("move").cursor.insAtRightEnd(P.parent);
                    break;
                  case "Ctrl-End":
                    A.notify("move").cursor.insAtRightEnd(A.root);
                    break;
                  case "Shift-End":
                    for (; P[1]; ) A.selectRight();
                    break;
                  case "Ctrl-Shift-End":
                    for (; P[1] || P.parent !== A.root; ) A.selectRight();
                    break;
                  case "Home":
                    A.notify("move").cursor.insAtLeftEnd(P.parent);
                    break;
                  case "Ctrl-Home":
                    A.notify("move").cursor.insAtLeftEnd(A.root);
                    break;
                  case "Shift-Home":
                    for (; P[F]; ) A.selectLeft();
                    break;
                  case "Ctrl-Shift-Home":
                    for (; P[F] || P.parent !== A.root; ) A.selectLeft();
                    break;
                  case "Left":
                    A.moveLeft();
                    break;
                  case "Shift-Left":
                    A.selectLeft();
                    break;
                  case "Ctrl-Left":
                    break;
                  case "Right":
                    A.moveRight();
                    break;
                  case "Shift-Right":
                    A.selectRight();
                    break;
                  case "Ctrl-Right":
                    break;
                  case "Up":
                    A.moveUp();
                    break;
                  case "Down":
                    A.moveDown();
                    break;
                  case "Shift-Up":
                    if (P[F]) for (; P[F]; ) A.selectLeft();
                    else A.selectLeft();
                  case "Shift-Down":
                    if (P[1]) for (; P[1]; ) A.selectRight();
                    else A.selectRight();
                  case "Ctrl-Up":
                  case "Ctrl-Down":
                    break;
                  case "Ctrl-Shift-Del":
                  case "Ctrl-Del":
                    A.ctrlDeleteDir(1);
                    break;
                  case "Shift-Del":
                  case "Del":
                    A.deleteForward();
                    break;
                  case "Meta-A":
                  case "Ctrl-A":
                    for (A.notify("move").cursor.insAtRightEnd(A.root); P[F]; ) A.selectLeft();
                    break;
                  default:
                    return;
                }
                S.preventDefault(), A.scrollHoriz();
              }, _.moveOutOf = _.moveTowards = _.deleteOutOf = _.deleteTowards = _.unselectInto = _.selectOutOf = _.selectTowards = function() {
                M("overridden or never called on this node");
              };
            }), Me.open(function(_) {
              function H(S, A) {
                var P = S.notify("upDown").cursor, Q = A + "Into", ie = A + "OutOf";
                return P[1][Q] ? P.insAtLeftEnd(P[1][Q]) : P[F][Q] ? P.insAtRightEnd(P[F][Q]) : P.parent.bubble(function(pe) {
                  var ce = pe[ie];
                  if (ce && (typeof ce == "function" && (ce = pe[ie](P)), ce instanceof ne && P.jumpUpDown(pe, ce), ce !== !0)) return !1;
                }), S;
              }
              this.onNotify(function(S) {
                S !== "move" && S !== "upDown" || this.show().clearSelection();
              }), _.escapeDir = function(S, A, P) {
                W(S);
                var Q = this.cursor;
                if (Q.parent !== this.root && P.preventDefault(), Q.parent !== this.root) return Q.parent.moveOutOf(S, Q), this.notify("move");
              }, Ve.leftRightIntoCmdGoes = function(S) {
                if (S && S !== "up" && S !== "down") throw '"up" or "down" required for leftRightIntoCmdGoes option, got "' + S + '"';
                return S;
              }, _.moveDir = function(S) {
                W(S);
                var A = this.cursor, P = A.options.leftRightIntoCmdGoes;
                return A.selection ? A.insDirOf(S, A.selection.ends[S]) : A[S] ? A[S].moveTowards(S, A, P) : A.parent.moveOutOf(S, A, P), this.notify("move");
              }, _.moveLeft = function() {
                return this.moveDir(F);
              }, _.moveRight = function() {
                return this.moveDir(1);
              }, _.moveUp = function() {
                return H(this, "up");
              }, _.moveDown = function() {
                return H(this, "down");
              }, this.onNotify(function(S) {
                S !== "upDown" && (this.upDownCache = {});
              }), this.onNotify(function(S) {
                S === "edit" && this.show().deleteSelection();
              }), _.deleteDir = function(S) {
                W(S);
                var A = this.cursor, P = A.selection;
                return this.notify("edit"), P || (A[S] ? A[S].deleteTowards(S, A) : A.parent.deleteOutOf(S, A)), A[F].siblingDeleted && A[F].siblingDeleted(A.options, 1), A[1].siblingDeleted && A[1].siblingDeleted(A.options, F), A.parent.bubble("reflow"), this;
              }, _.ctrlDeleteDir = function(S) {
                W(S);
                var A = this.cursor;
                return !A[S] || A.selection ? this.deleteDir(S) : (this.notify("edit"), S === F ? D(A.parent.ends[F], A[F]).remove() : D(A[1], A.parent.ends[1]).remove(), A.insAtDirEnd(S, A.parent), A[F].siblingDeleted && A[F].siblingDeleted(A.options, 1), A[1].siblingDeleted && A[1].siblingDeleted(A.options, F), A.parent.bubble("reflow"), this);
              }, _.backspace = function() {
                return this.deleteDir(F);
              }, _.deleteForward = function() {
                return this.deleteDir(1);
              }, this.onNotify(function(S) {
                S !== "select" && this.endSelection();
              }), _.selectDir = function(S) {
                var A = this.notify("select").cursor, P = A.selection;
                W(S), A.anticursor || A.startSelection();
                var Q = A[S];
                Q ? P && P.ends[S] === Q && A.anticursor[-S] !== Q ? Q.unselectInto(S, A) : Q.selectTowards(S, A) : A.parent.selectOutOf(S, A), A.clearSelection(), A.select() || A.show();
              }, _.selectLeft = function() {
                return this.selectDir(F);
              }, _.selectRight = function() {
                return this.selectDir(1);
              };
            }), Me.open(function(_) {
              at.p.substituteTextarea = function() {
                return X("<textarea autocapitalize=off autocomplete=off autocorrect=off spellcheck=false x-palm-disable-ste-all=true />")[0];
              }, _.createTextarea = function() {
                var H = this.textareaSpan = X('<span class="mq-textarea"></span>'), S = this.options.substituteTextarea();
                if (!S.nodeType) throw "substituteTextarea() must return a DOM element, got " + S;
                S = this.textarea = X(S).appendTo(H);
                var A = this;
                A.cursor.selectionChanged = function() {
                  A.selectionChanged();
                };
              }, _.selectionChanged = function() {
                var H = this;
                xe(H.container[0]), H.textareaSelectionTimeout === f && (H.textareaSelectionTimeout = setTimeout(function() {
                  H.setTextareaSelection();
                }));
              }, _.setTextareaSelection = function() {
                this.textareaSelectionTimeout = f;
                var H = "";
                this.cursor.selection && (H = this.cursor.selection.join("latex"), this.options.statelessClipboard && (H = "$" + H + "$")), this.selectFn(H);
              }, _.staticMathTextareaEvents = function() {
                var H = this, S = (H.root, H.cursor), A = H.textarea, P = H.textareaSpan;
                function Q() {
                  P.detach(), H.blurred = !0;
                }
                this.container.prepend(m('<span class="mq-selectable">').text("$" + H.exportLatex() + "$")), H.blurred = !0, A.bind("cut paste", !1).bind("copy", function() {
                  H.setTextareaSelection();
                }).focus(function() {
                  H.blurred = !1;
                }).blur(function() {
                  S.selection && S.selection.clear(), setTimeout(Q);
                }), H.selectFn = function(ie) {
                  A.val(ie), ie && A.select();
                };
              }, at.p.substituteKeyboardEvents = Wt, _.editablesTextareaEvents = function() {
                var H = this.textarea, S = this.textareaSpan, A = this.options.substituteKeyboardEvents(H, this);
                this.selectFn = function(P) {
                  A.select(P);
                }, this.container.prepend(S), this.focusBlurEvents();
              }, _.typedText = function(H) {
                if (H === `
`) return this.handle("enter");
                var S = this.notify().cursor;
                S.parent.write(S, H), this.scrollHoriz();
              }, _.cut = function() {
                var H = this, S = H.cursor;
                S.selection && setTimeout(function() {
                  H.notify("edit"), S.parent.bubble("reflow");
                });
              }, _.copy = function() {
                this.setTextareaSelection();
              }, _.paste = function(H) {
                this.options.statelessClipboard && (H = H.slice(0, 1) === "$" && H.slice(-1) === "$" ? H.slice(1, -1) : "\\text{" + H + "}"), this.writeLatex(H).cursor.show();
              };
            });
            var At = function() {
              function _(Rt) {
                for (var wn = Rt[0] || vt(), br = 1; br < Rt.length; br += 1) Rt[br].children().adopt(wn, wn.ends[1], 0);
                return wn;
              }
              var H = et.string, S = et.regex, A = et.letter, P = et.any, Q = et.optWhitespace, ie = et.succeed, pe = et.fail, ce = A.map(function(Rt) {
                return Br(Rt);
              }), ze = S(/^[^${}\\_^]/).map(function(Rt) {
                return re(Rt);
              }), Xe = S(/^[^\\a-eg-zA-Z]/).or(H("\\").then(S(/^[a-z]+/i).or(S(/^\s+/).result(" ")).or(P))).then(function(Rt) {
                var wn = j[Rt];
                return wn ? wn(Rt).parser() : pe("unknown command: \\" + Rt);
              }).or(ce).or(ze), wt = H("{").then(function() {
                return Kt;
              }).skip(H("}")), jt = Q.then(wt.or(Xe.map(function(Rt) {
                var wn = vt();
                return Rt.adopt(wn, 0, 0), wn;
              }))), Kt = jt.many().map(_).skip(Q), ut = H("[").then(jt.then(function(Rt) {
                return Rt.join("latex") !== "]" ? ie(Rt) : pe();
              }).many().map(_).skip(Q)).skip(H("]")), Yt = Kt;
              return Yt.block = jt, Yt.optBlock = ut, Yt;
            }();
            Me.open(function(_, H) {
              _.exportLatex = function() {
                return this.root.latex().replace(/(\\[a-z]+) (?![a-z])/gi, "$1");
              }, Ve.maxDepth = function(S) {
                return typeof S == "number" ? S : f;
              }, _.writeLatex = function(S) {
                var A = this.notify("edit").cursor, P = et.all, Q = et.eof, ie = At.skip(Q).or(P.result(!1)).parse(S);
                return ie && !ie.isEmpty() && ie.prepareInsertionAt(A) && (ie.children().adopt(A.parent, A[F], A[1]), ie.jQize().insertBefore(A.jQ), A[F] = ie.ends[1], ie.finalizeInsert(A.options, A), ie.ends[1][1].siblingCreated && ie.ends[1][1].siblingCreated(A.options, F), ie.ends[F][F].siblingCreated && ie.ends[F][F].siblingCreated(A.options, 1), A.parent.bubble("reflow")), this;
              }, _.renderLatexMath = function(S) {
                var A = this.root, P = this.cursor, Q = (P.options, A.jQ), ie = et.all, pe = et.eof, ce = At.skip(pe).or(ie.result(!1)).parse(S);
                if (A.eachChild("postOrder", "dispose"), A.ends[F] = A.ends[1] = 0, ce && ce.prepareInsertionAt(P)) {
                  ce.children().adopt(A, 0, 0);
                  var ze = ce.join("html");
                  Q.html(ze), A.jQize(Q.children()), A.finalizeInsert(P.options);
                } else Q.empty();
                delete P.selection, P.insAtRightEnd(A);
              }, _.renderLatexText = function(S) {
                var A = this.root, P = this.cursor;
                A.jQ.children().slice(1).remove(), A.eachChild("postOrder", "dispose"), A.ends[F] = A.ends[1] = 0, delete P.selection, P.show().insAtRightEnd(A);
                var Q = et.regex, ie = et.string, pe = et.eof, ce = et.all, ze = ie("$").then(At).skip(ie("$").or(pe)).map(function(Kt) {
                  var ut = In(P);
                  ut.createBlocks();
                  var Yt = ut.ends[F];
                  return Kt.children().adopt(Yt, 0, 0), ut;
                }), Xe = ie("\\$").result("$").or(Q(/^[^$]/)).map(re), wt = ze.or(Xe).many().skip(pe).or(ce.result(!1)).parse(S);
                if (wt) {
                  for (var jt = 0; jt < wt.length; jt += 1) wt[jt].adopt(A, A.ends[1], 0);
                  A.jQize().appendTo(A.jQ), A.finalizeInsert(P.options);
                }
              };
            }), Me.open(function(_) {
              _.scrollHoriz = function() {
                var H = this.cursor, S = H.selection, A = this.root.jQ[0].getBoundingClientRect();
                if (S) {
                  var P = S.jQ[0].getBoundingClientRect(), Q = P.left - (A.left + 20), ie = P.right - (A.right - 20);
                  if (S.ends[F] === H[1]) if (Q < 0) ce = Q;
                  else {
                    if (!(ie > 0)) return;
                    ce = P.left - ie < A.left + 20 ? Q : ie;
                  }
                  else if (ie > 0) ce = ie;
                  else {
                    if (!(Q < 0)) return;
                    ce = P.right - Q > A.right - 20 ? ie : Q;
                  }
                } else {
                  var pe = H.jQ[0].getBoundingClientRect().left;
                  if (pe > A.right - 20) var ce = pe - (A.right - 20);
                  else {
                    if (!(pe < A.left + 20)) return;
                    ce = pe - (A.left + 20);
                  }
                }
                this.root.jQ.stop().animate({ scrollLeft: "+=" + ce }, 100);
              };
            });
            var Gt = R(ne, function(_, H) {
              _.finalizeInsert = function(S, A) {
                var P = this;
                P.postOrder("finalizeTree", S), P.postOrder("contactWeld", A), P.postOrder("blur"), P.postOrder("reflow"), P[1].siblingCreated && P[1].siblingCreated(S, F), P[F].siblingCreated && P[F].siblingCreated(S, 1), P.bubble("reflow");
              }, _.prepareInsertionAt = function(S) {
                var A = S.options.maxDepth;
                if (A !== f) {
                  var P = S.depth();
                  if (P > A) return !1;
                  this.removeNodesDeeperThan(A - P);
                }
                return !0;
              }, _.removeNodesDeeperThan = function(S) {
                for (var A, P = 0, Q = [[this, P]]; Q.length; ) (A = Q.shift())[0].children().each(function(ie) {
                  var pe = ie instanceof vt ? 1 : 0;
                  (P = A[1] + pe) <= S ? Q.push([ie, P]) : (pe ? ie.children() : ie).remove();
                });
              };
            }), Lt = R(Gt, function(_, H) {
              _.init = function(S, A, P) {
                var Q = this;
                H.init.call(Q), Q.ctrlSeq || (Q.ctrlSeq = S), A && (Q.htmlTemplate = A), P && (Q.textTemplate = P);
              }, _.replaces = function(S) {
                S.disown(), this.replacedFragment = S;
              }, _.isEmpty = function() {
                return this.foldChildren(!0, function(S, A) {
                  return S && A.isEmpty();
                });
              }, _.parser = function() {
                var S = At.block, A = this;
                return S.times(A.numBlocks()).map(function(P) {
                  A.blocks = P;
                  for (var Q = 0; Q < P.length; Q += 1) P[Q].adopt(A, A.ends[1], 0);
                  return A;
                });
              }, _.createLeftOf = function(S) {
                var A = this, P = A.replacedFragment;
                A.createBlocks(), H.createLeftOf.call(A, S), P && (P.adopt(A.ends[F], 0, 0), P.jQ.appendTo(A.ends[F].jQ), A.placeCursor(S), A.prepareInsertionAt(S)), A.finalizeInsert(S.options), A.placeCursor(S);
              }, _.createBlocks = function() {
                for (var S = this, A = S.numBlocks(), P = S.blocks = Array(A), Q = 0; Q < A; Q += 1) (P[Q] = vt()).adopt(S, S.ends[1], 0);
              }, _.placeCursor = function(S) {
                S.insAtRightEnd(this.foldChildren(this.ends[F], function(A, P) {
                  return A.isEmpty() ? A : P;
                }));
              }, _.moveTowards = function(S, A, P) {
                var Q = P && this[P + "Into"];
                A.insAtDirEnd(-S, Q || this.ends[-S]);
              }, _.deleteTowards = function(S, A) {
                this.isEmpty() ? A[S] = this.remove()[S] : this.moveTowards(S, A, null);
              }, _.selectTowards = function(S, A) {
                A[-S] = this, A[S] = this[S];
              }, _.selectChildren = function() {
                return Ne(this, this);
              }, _.unselectInto = function(S, A) {
                A.insAtDirEnd(-S, A.anticursor.ancestors[this.id]);
              }, _.seek = function(S, A) {
                function P(ce) {
                  var ze = {};
                  return ze[F] = ce.jQ.offset().left, ze[1] = ze[F] + ce.jQ.outerWidth(), ze;
                }
                var Q = this, ie = P(Q);
                if (S < ie[F]) return A.insLeftOf(Q);
                if (S > ie[1]) return A.insRightOf(Q);
                var pe = ie[F];
                Q.eachChild(function(ce) {
                  var ze = P(ce);
                  return S < ze[F] ? (S - pe < ze[F] - S ? ce[F] ? A.insAtRightEnd(ce[F]) : A.insLeftOf(Q) : A.insAtLeftEnd(ce), !1) : S > ze[1] ? void (ce[1] ? pe = ze[1] : ie[1] - S < S - ze[1] ? A.insRightOf(Q) : A.insAtRightEnd(ce)) : (ce.seek(S, A), !1);
                });
              }, _.numBlocks = function() {
                var S = this.htmlTemplate.match(/&\d+/g);
                return S ? S.length : 0;
              }, _.html = function() {
                var S = this, A = S.blocks, P = " mathquill-command-id=" + S.id, Q = S.htmlTemplate.match(/<[^<>]+>|[^<>]+/g);
                M("no unmatched angle brackets", Q.join("") === this.htmlTemplate);
                for (var ie = 0, pe = Q[0]; pe; pe = Q[ie += 1]) if (pe.slice(-2) === "/>") Q[ie] = pe.slice(0, -2) + P + "/>";
                else if (pe.charAt(0) === "<") {
                  M("not an unmatched top-level close tag", pe.charAt(1) !== "/"), Q[ie] = pe.slice(0, -1) + P + ">";
                  var ce = 1;
                  do
                    M("no missing close tags", pe = Q[ie += 1]), pe.slice(0, 2) === "</" ? ce -= 1 : pe.charAt(0) === "<" && pe.slice(-2) !== "/>" && (ce += 1);
                  while (ce > 0);
                }
                return Q.join("").replace(/>&(\d+)/g, function(ze, Xe) {
                  return " mathquill-block-id=" + A[Xe].id + ">" + A[Xe].join("html");
                });
              }, _.latex = function() {
                return this.foldChildren(this.ctrlSeq, function(S, A) {
                  return S + "{" + (A.latex() || " ") + "}";
                });
              }, _.textTemplate = [""], _.text = function() {
                var S = this, A = 0;
                return S.foldChildren(S.textTemplate[A], function(P, Q) {
                  A += 1;
                  var ie = Q.text();
                  return P && S.textTemplate[A] === "(" && ie[0] === "(" && ie.slice(-1) === ")" ? P + ie.slice(1, -1) + S.textTemplate[A] : P + ie + (S.textTemplate[A] || "");
                });
              };
            }), ct = R(Lt, function(_, H) {
              _.init = function(S, A, P) {
                P || (P = S && S.length > 1 ? S.slice(1) : S), H.init.call(this, S, A, [P]);
              }, _.parser = function() {
                return et.succeed(this);
              }, _.numBlocks = function() {
                return 0;
              }, _.replaces = function(S) {
                S.remove();
              }, _.createBlocks = b, _.moveTowards = function(S, A) {
                A.jQ.insDirOf(S, this.jQ), A[-S] = this, A[S] = this[S];
              }, _.deleteTowards = function(S, A) {
                A[S] = this.remove()[S];
              }, _.seek = function(S, A) {
                S - this.jQ.offset().left < this.jQ.outerWidth() / 2 ? A.insLeftOf(this) : A.insRightOf(this);
              }, _.latex = function() {
                return this.ctrlSeq;
              }, _.text = function() {
                return this.textTemplate;
              }, _.placeCursor = b, _.isEmpty = function() {
                return !0;
              };
            }), re = R(ct, function(_, H) {
              _.init = function(S, A) {
                H.init.call(this, S, "<span>" + (A || S) + "</span>");
              };
            }), $e = R(ct, function(_, H) {
              _.init = function(S, A, P) {
                H.init.call(this, S, '<span class="mq-binary-operator">' + A + "</span>", P);
              };
            }), vt = R(Gt, function(_, H) {
              _.join = function(S) {
                return this.foldChildren("", function(A, P) {
                  return A + P[S]();
                });
              }, _.html = function() {
                return this.join("html");
              }, _.latex = function() {
                return this.join("latex");
              }, _.text = function() {
                return this.ends[F] === this.ends[1] && this.ends[F] !== 0 ? this.ends[F].text() : this.join("text");
              }, _.keystroke = function(S, A, P) {
                return !P.options.spaceBehavesLikeTab || S !== "Spacebar" && S !== "Shift-Spacebar" ? H.keystroke.apply(this, arguments) : (A.preventDefault(), void P.escapeDir(S === "Shift-Spacebar" ? F : 1, S, A));
              }, _.moveOutOf = function(S, A, P) {
                P && this.parent[P + "Into"] || !this[S] ? A.insDirOf(S, this.parent) : A.insAtDirEnd(-S, this[S]);
              }, _.selectOutOf = function(S, A) {
                A.insDirOf(S, this.parent);
              }, _.deleteOutOf = function(S, A) {
                A.unwrapGramp();
              }, _.seek = function(S, A) {
                var P = this.ends[1];
                if (!P || P.jQ.offset().left + P.jQ.outerWidth() < S) return A.insAtRightEnd(this);
                if (S < this.ends[F].jQ.offset().left) return A.insAtLeftEnd(this);
                for (; S < P.jQ.offset().left; ) P = P[F];
                return P.seek(S, A);
              }, _.chToCmd = function(S, A) {
                var P;
                return S.match(/^[a-eg-zA-Z]$/) ? Br(S) : /^\d$/.test(S) ? kl(S) : A && A.typingSlashWritesDivisionSymbol && S === "/" ? j["÷"](S) : A && A.typingAsteriskWritesTimesSymbol && S === "*" ? j["×"](S) : (P = de[S] || j[S]) ? P(S) : re(S);
              }, _.write = function(S, A) {
                var P = this.chToCmd(A, S.options);
                S.selection && P.replaces(S.replaceSelection()), S.isTooDeep() || P.createLeftOf(S.show());
              }, _.focus = function() {
                return this.jQ.addClass("mq-hasCursor"), this.jQ.removeClass("mq-empty"), this;
              }, _.blur = function() {
                return this.jQ.removeClass("mq-hasCursor"), this.isEmpty() && this.jQ.addClass("mq-empty"), this;
              };
            });
            at.p.mouseEvents = !0, Ie.StaticMath = function(_) {
              return R(_.AbstractMathQuill, function(H, S) {
                this.RootBlock = vt, H.__mathquillify = function(A, P) {
                  return this.config(A), S.__mathquillify.call(this, "mq-math-mode"), this.__options.mouseEvents && (this.__controller.delegateMouseEvents(), this.__controller.staticMathTextareaEvents()), this;
                }, H.init = function() {
                  S.init.apply(this, arguments), this.__controller.root.postOrder("registerInnerField", this.innerFields = [], _.MathField);
                }, H.latex = function() {
                  var A = S.latex.apply(this, arguments);
                  return arguments.length > 0 && this.__controller.root.postOrder("registerInnerField", this.innerFields = [], _.MathField), A;
                };
              });
            };
            var rt = R(vt, pt);
            Ie.MathField = function(_) {
              return R(_.EditableField, function(H, S) {
                this.RootBlock = rt, H.__mathquillify = function(A, P) {
                  return this.config(A), P > 1 && (this.__controller.root.reflow = b), S.__mathquillify.call(this, "mq-editable-field mq-math-mode"), delete this.__controller.root.reflow, this;
                };
              });
            };
            var Dt = R(ne, function(_, H) {
              function S(A) {
                A.jQ[0].normalize();
                var P = A.jQ[0].firstChild;
                if (P) {
                  M("only node in TextBlock span is Text node", P.nodeType === 3);
                  var Q = tn(P.data);
                  return Q.jQadd(P), A.children().disown(), Q.adopt(A, 0, 0);
                }
              }
              _.ctrlSeq = "\\text", _.replaces = function(A) {
                A instanceof D ? this.replacedText = A.remove().jQ.text() : typeof A == "string" && (this.replacedText = A);
              }, _.jQadd = function(A) {
                H.jQadd.call(this, A), this.ends[F] && this.ends[F].jQadd(this.jQ[0].firstChild);
              }, _.createLeftOf = function(A) {
                var P = this;
                if (H.createLeftOf.call(this, A), P[1].siblingCreated && P[1].siblingCreated(A.options, F), P[F].siblingCreated && P[F].siblingCreated(A.options, 1), P.bubble("reflow"), A.insAtRightEnd(P), P.replacedText) for (var Q = 0; Q < P.replacedText.length; Q += 1) P.write(A, P.replacedText.charAt(Q));
              }, _.parser = function() {
                var A = this, P = et.string, Q = et.regex;
                return et.optWhitespace.then(P("{")).then(Q(/^[^}]*/)).skip(P("}")).map(function(ie) {
                  return ie.length === 0 ? D() : (tn(ie).adopt(A, 0, 0), A);
                });
              }, _.textContents = function() {
                return this.foldChildren("", function(A, P) {
                  return A + P.text;
                });
              }, _.text = function() {
                return '"' + this.textContents() + '"';
              }, _.latex = function() {
                var A = this.textContents();
                return A.length === 0 ? "" : "\\text{" + A.replace(/\\/g, "\\backslash ").replace(/[{}]/g, "\\$&") + "}";
              }, _.html = function() {
                return '<span class="mq-text-mode" mathquill-command-id=' + this.id + ">" + this.textContents() + "</span>";
              }, _.moveTowards = function(A, P) {
                P.insAtDirEnd(-A, this);
              }, _.moveOutOf = function(A, P) {
                P.insDirOf(A, this);
              }, _.unselectInto = _.moveTowards, _.selectTowards = Lt.prototype.selectTowards, _.deleteTowards = Lt.prototype.deleteTowards, _.selectOutOf = function(A, P) {
                P.insDirOf(A, this);
              }, _.deleteOutOf = function(A, P) {
                this.isEmpty() && P.insRightOf(this);
              }, _.write = function(A, P) {
                if (A.show().deleteSelection(), P !== "$") A[F] ? A[F].appendText(P) : tn(P).createLeftOf(A);
                else if (this.isEmpty()) A.insRightOf(this), re("\\$", "$").createLeftOf(A);
                else if (A[1]) if (A[F]) {
                  var Q = Dt(), ie = this.ends[F];
                  ie.disown().jQ.detach(), ie.adopt(Q, 0, 0), A.insLeftOf(this), H.createLeftOf.call(Q, A);
                } else A.insLeftOf(this);
                else A.insRightOf(this);
              }, _.seek = function(A, P) {
                P.hide();
                var Q = S(this), ie = this.jQ.width() / this.text.length, pe = Math.round((A - this.jQ.offset().left) / ie);
                pe <= 0 ? P.insAtLeftEnd(this) : pe >= Q.text.length ? P.insAtRightEnd(this) : P.insLeftOf(Q.splitRight(pe));
                for (var ce = A - P.show().offset().left, ze = ce && ce < 0 ? F : 1, Xe = ze; P[ze] && ce * Xe > 0; ) P[ze].moveTowards(ze, P), Xe = ce, ce = A - P.offset().left;
                if (ze * ce < -ze * Xe && P[-ze].moveTowards(-ze, P), P.anticursor) {
                  if (P.anticursor.parent === this) {
                    var wt = P[F] && P[F].text.length;
                    if (this.anticursorPosition === wt) P.anticursor = le.copy(P);
                    else {
                      if (this.anticursorPosition < wt) {
                        var jt = P[F].splitRight(this.anticursorPosition);
                        P[F] = jt;
                      } else jt = P[1].splitRight(this.anticursorPosition - wt);
                      P.anticursor = le(this, jt[F], jt);
                    }
                  }
                } else this.anticursorPosition = P[F] && P[F].text.length;
              }, _.blur = function(A) {
                vt.prototype.blur.call(this), A && (this.textContents() === "" ? (this.remove(), A[F] === this ? A[F] = this[F] : A[1] === this && (A[1] = this[1])) : S(this));
              }, _.focus = vt.prototype.focus;
            }), tn = R(ne, function(_, H) {
              function S(A, P) {
                return P.charAt(A === F ? 0 : -1 + P.length);
              }
              _.init = function(A) {
                H.init.call(this), this.text = A;
              }, _.jQadd = function(A) {
                this.dom = A, this.jQ = X(A);
              }, _.jQize = function() {
                return this.jQadd(document.createTextNode(this.text));
              }, _.appendText = function(A) {
                this.text += A, this.dom.appendData(A);
              }, _.prependText = function(A) {
                this.text = A + this.text, this.dom.insertData(0, A);
              }, _.insTextAtDirEnd = function(A, P) {
                W(P), P === 1 ? this.appendText(A) : this.prependText(A);
              }, _.splitRight = function(A) {
                var P = tn(this.text.slice(A)).adopt(this.parent, this, this[1]);
                return P.jQadd(this.dom.splitText(A)), this.text = this.text.slice(0, A), P;
              }, _.moveTowards = function(A, P) {
                W(A);
                var Q = S(-A, this.text), ie = this[-A];
                return ie ? ie.insTextAtDirEnd(Q, A) : tn(Q).createDir(-A, P), this.deleteTowards(A, P);
              }, _.latex = function() {
                return this.text;
              }, _.deleteTowards = function(A, P) {
                this.text.length > 1 ? A === 1 ? (this.dom.deleteData(0, 1), this.text = this.text.slice(1)) : (this.dom.deleteData(-1 + this.text.length, 1), this.text = this.text.slice(0, -1)) : (this.remove(), this.jQ.remove(), P[A] = this[A]);
              }, _.selectTowards = function(A, P) {
                W(A);
                var Q = P.anticursor, ie = S(-A, this.text);
                if (Q[A] === this) {
                  var pe = tn(ie).createDir(A, P);
                  Q[A] = pe, P.insDirOf(A, pe);
                } else {
                  var ce = this[-A];
                  ce ? ce.insTextAtDirEnd(ie, A) : (pe = tn(ie).createDir(-A, P)).jQ.insDirOf(-A, P.selection.jQ), this.text.length === 1 && Q[-A] === this && (Q[-A] = this[-A]);
                }
                return this.deleteTowards(A, P);
              };
            });
            function Xn(_, H, S) {
              return R(Dt, { ctrlSeq: _, htmlTemplate: "<" + H + " " + S + ">&0</" + H + ">" });
            }
            j.text = j.textnormal = j.textrm = j.textup = j.textmd = Dt, j.em = j.italic = j.italics = j.emph = j.textit = j.textsl = Xn("\\textit", "i", 'class="mq-text-mode"'), j.strong = j.bold = j.textbf = Xn("\\textbf", "b", 'class="mq-text-mode"'), j.sf = j.textsf = Xn("\\textsf", "span", 'class="mq-sans-serif mq-text-mode"'), j.tt = j.texttt = Xn("\\texttt", "span", 'class="mq-monospace mq-text-mode"'), j.textsc = Xn("\\textsc", "span", 'style="font-variant:small-caps" class="mq-text-mode"'), j.uppercase = Xn("\\uppercase", "span", 'style="text-transform:uppercase" class="mq-text-mode"'), j.lowercase = Xn("\\lowercase", "span", 'style="text-transform:lowercase" class="mq-text-mode"');
            var In = R(Lt, function(_, H) {
              _.init = function(S) {
                H.init.call(this, "$"), this.cursor = S;
              }, _.htmlTemplate = '<span class="mq-math-mode">&0</span>', _.createBlocks = function() {
                H.createBlocks.call(this), this.ends[F].cursor = this.cursor, this.ends[F].write = function(S, A) {
                  A !== "$" ? vt.prototype.write.call(this, S, A) : this.isEmpty() ? (S.insRightOf(this.parent), this.parent.deleteTowards(dir, S), re("\\$", "$").createLeftOf(S.show())) : S[1] ? S[F] ? vt.prototype.write.call(this, S, A) : S.insLeftOf(this.parent) : S.insRightOf(this.parent);
                };
              }, _.latex = function() {
                return "$" + this.ends[F].latex() + "$";
              };
            }), Qn = R(rt, function(_, H) {
              _.keystroke = function(S) {
                if (S !== "Spacebar" && S !== "Shift-Spacebar") return H.keystroke.apply(this, arguments);
              }, _.write = function(S, A) {
                var P;
                S.show().deleteSelection(), A === "$" ? In(S).createLeftOf(S) : (A === "<" ? P = "&lt;" : A === ">" && (P = "&gt;"), re(A, P).createLeftOf(S));
              };
            });
            Ie.TextField = function(_) {
              return R(_.EditableField, function(H, S) {
                this.RootBlock = Qn, H.__mathquillify = function() {
                  return S.__mathquillify.call(this, "mq-editable-field mq-text-mode");
                }, H.latex = function(A) {
                  return arguments.length > 0 ? (this.__controller.renderLatexText(A), this.__controller.blurred && this.__controller.cursor.hide().parent.blur(), this) : this.__controller.exportLatex();
                };
              });
            }, de["\\"] = R(Lt, function(_, H) {
              _.ctrlSeq = "\\", _.replaces = function(S) {
                this._replacedFragment = S.disown(), this.isEmpty = function() {
                  return !1;
                };
              }, _.htmlTemplate = '<span class="mq-latex-command-input mq-non-leaf">\\<span>&0</span></span>', _.textTemplate = ["\\"], _.createBlocks = function() {
                H.createBlocks.call(this), this.ends[F].focus = function() {
                  return this.parent.jQ.addClass("mq-hasCursor"), this.isEmpty() && this.parent.jQ.removeClass("mq-empty"), this;
                }, this.ends[F].blur = function() {
                  return this.parent.jQ.removeClass("mq-hasCursor"), this.isEmpty() && this.parent.jQ.addClass("mq-empty"), this;
                }, this.ends[F].write = function(S, A) {
                  S.show().deleteSelection(), A.match(/[a-z]/i) ? re(A).createLeftOf(S) : (this.parent.renderCommand(S), A === "\\" && this.isEmpty() || S.parent.write(S, A));
                }, this.ends[F].keystroke = function(S, A, P) {
                  return S === "Tab" || S === "Enter" || S === "Spacebar" ? (this.parent.renderCommand(P.cursor), void A.preventDefault()) : H.keystroke.apply(this, arguments);
                };
              }, _.createLeftOf = function(S) {
                if (H.createLeftOf.call(this, S), this._replacedFragment) {
                  var A = this.jQ[0];
                  this.jQ = this._replacedFragment.jQ.addClass("mq-blur").bind("mousedown mousemove", function(P) {
                    return X(P.target = A).trigger(P), !1;
                  }).insertBefore(this.jQ).add(this.jQ);
                }
              }, _.latex = function() {
                return "\\" + this.ends[F].latex() + " ";
              }, _.renderCommand = function(S) {
                this.jQ = this.jQ.last(), this.remove(), this[1] ? S.insLeftOf(this[1]) : S.insAtRightEnd(this.parent);
                var A = this.ends[F].latex();
                A || (A = " ");
                var P = j[A];
                P ? (P = P(A), this._replacedFragment && P.replaces(this._replacedFragment), P.createLeftOf(S)) : ((P = Dt()).replaces(A), P.createLeftOf(S), S.insRightOf(P), this._replacedFragment && this._replacedFragment.remove());
              };
            });
            var Yn, Ce, xe = b, Oe = document.createElement("div").style;
            for (var Ft in { transform: 1, WebkitTransform: 1, MozTransform: 1, OTransform: 1, msTransform: 1 }) if (Ft in Oe) {
              Ce = Ft;
              break;
            }
            Ce ? Yn = function(_, H, S) {
              _.css(Ce, "scale(" + H + "," + S + ")");
            } : "filter" in Oe ? (xe = function(_) {
              _.className = _.className;
            }, Yn = function(_, H, S) {
              H /= 1 + (S - 1) / 2, _.css("fontSize", S + "em"), _.hasClass("mq-matrixed-container") || _.addClass("mq-matrixed-container").wrapInner('<span class="mq-matrixed"></span>');
              var A = _.children().css("filter", "progid:DXImageTransform.Microsoft.Matrix(M11=" + H + ",SizingMethod='auto expand')");
              function P() {
                _.css("marginRight", (A.width() - 1) * (H - 1) / H + "px");
              }
              P();
              var Q = setInterval(P);
              X(window).load(function() {
                clearTimeout(Q), P();
              });
            }) : Yn = function(_, H, S) {
              _.css("fontSize", S + "em");
            };
            var on = R(Lt, function(_, H) {
              _.init = function(S, A, P) {
                H.init.call(this, S, "<" + A + " " + P + ">&0</" + A + ">");
              };
            });
            j.mathrm = w(on, "\\mathrm", "span", 'class="mq-roman mq-font"'), j.mathit = w(on, "\\mathit", "i", 'class="mq-font"'), j.mathbf = w(on, "\\mathbf", "b", 'class="mq-font"'), j.mathsf = w(on, "\\mathsf", "span", 'class="mq-sans-serif mq-font"'), j.mathtt = w(on, "\\mathtt", "span", 'class="mq-monospace mq-font"'), j.underline = w(on, "\\underline", "span", 'class="mq-non-leaf mq-underline"'), j.overline = j.bar = w(on, "\\overline", "span", 'class="mq-non-leaf mq-overline"'), j.overrightarrow = w(on, "\\overrightarrow", "span", 'class="mq-non-leaf mq-overarrow mq-arrow-right"'), j.overleftarrow = w(on, "\\overleftarrow", "span", 'class="mq-non-leaf mq-overarrow mq-arrow-left"'), j.overleftrightarrow = w(on, "\\overleftrightarrow", "span", 'class="mq-non-leaf mq-overarrow mq-arrow-both"'), j.overarc = w(on, "\\overarc", "span", 'class="mq-non-leaf mq-overarc"'), j.dot = R(Lt, function(_, H) {
              _.init = function() {
                H.init.call(this, "\\dot", '<span class="mq-non-leaf"><span class="mq-dot-recurring-inner"><span class="mq-dot-recurring">&#x2d9;</span><span class="mq-empty-box">&0</span></span></span>');
              };
            }), j.textcolor = R(Lt, function(_, H) {
              _.setColor = function(S) {
                this.color = S, this.htmlTemplate = '<span class="mq-textcolor" style="color:' + S + '">&0</span>';
              }, _.latex = function() {
                return "\\textcolor{" + this.color + "}{" + this.blocks[0].latex() + "}";
              }, _.parser = function() {
                var S = this, A = et.optWhitespace, P = et.string, Q = et.regex;
                return A.then(P("{")).then(Q(/^[#\w\s.,()%-]*/)).skip(P("}")).then(function(ie) {
                  return S.setColor(ie), H.parser.call(S);
                });
              }, _.isStyleBlock = function() {
                return !0;
              };
            }), j.class = R(Lt, function(_, H) {
              _.parser = function() {
                var S = this, A = et.string, P = et.regex;
                return et.optWhitespace.then(A("{")).then(P(/^[-\w\s\\\xA0-\xFF]*/)).skip(A("}")).then(function(Q) {
                  return S.cls = Q || "", S.htmlTemplate = '<span class="mq-class ' + Q + '">&0</span>', H.parser.call(S);
                });
              }, _.latex = function() {
                return "\\class{" + this.cls + "}{" + this.blocks[0].latex() + "}";
              }, _.isStyleBlock = function() {
                return !0;
              };
            });
            var yr = R(Lt, function(_, H) {
              _.ctrlSeq = "_{...}^{...}", _.createLeftOf = function(S) {
                if (this.replacedFragment || S[F] || !S.options.supSubsRequireOperand) return H.createLeftOf.apply(this, arguments);
              }, _.contactWeld = function(S) {
                for (var A = F; A; A = A === F && 1) if (this[A] instanceof yr) {
                  for (var P = "sub"; P; P = P === "sub" && "sup") {
                    var Q = this[P], ie = this[A][P];
                    if (Q) {
                      if (ie) if (Q.isEmpty()) ce = le(ie, 0, ie.ends[F]);
                      else {
                        Q.jQ.children().insAtDirEnd(-A, ie.jQ);
                        var pe = Q.children().disown(), ce = le(ie, pe.ends[1], ie.ends[F]);
                        A === F ? pe.adopt(ie, ie.ends[1], 0) : pe.adopt(ie, 0, ie.ends[F]);
                      }
                      else this[A].addBlock(Q.disown());
                      this.placeCursor = /* @__PURE__ */ function(ze, Xe) {
                        return function(wt) {
                          wt.insAtDirEnd(-A, ze || Xe);
                        };
                      }(ie, Q);
                    }
                  }
                  this.remove(), S && S[F] === this && (A === 1 && ce ? ce[F] ? S.insRightOf(ce[F]) : S.insAtLeftEnd(ce.parent) : S.insRightOf(this[A]));
                  break;
                }
              }, at.p.charsThatBreakOutOfSupSub = "", _.finalizeTree = function() {
                this.ends[F].write = function(S, A) {
                  if (S.options.autoSubscriptNumerals && this === this.parent.sub) {
                    if (A === "_") return;
                    var P = this.chToCmd(A, S.options);
                    return P instanceof ct ? S.deleteSelection() : S.clearSelection().insRightOf(this.parent), P.createLeftOf(S.show());
                  }
                  S[F] && !S[1] && !S.selection && S.options.charsThatBreakOutOfSupSub.indexOf(A) > -1 && S.insRightOf(this.parent), vt.p.write.apply(this, arguments);
                };
              }, _.moveTowards = function(S, A, P) {
                A.options.autoSubscriptNumerals && !this.sup ? A.insDirOf(S, this) : H.moveTowards.apply(this, arguments);
              }, _.deleteTowards = function(S, A) {
                if (A.options.autoSubscriptNumerals && this.sub) {
                  var P = this.sub.ends[-S];
                  P instanceof ct ? P.remove() : P && P.deleteTowards(S, A.insAtDirEnd(-S, this.sub)), this.sub.isEmpty() && (this.sub.deleteOutOf(F, A.insAtLeftEnd(this.sub)), this.sup && A.insDirOf(-S, this));
                } else H.deleteTowards.apply(this, arguments);
              }, _.latex = function() {
                function S(A, P) {
                  var Q = P && P.latex();
                  return P ? A + (Q.length === 1 ? Q : "{" + (Q || " ") + "}") : "";
                }
                return S("_", this.sub) + S("^", this.sup);
              }, _.addBlock = function(S) {
                this.supsub === "sub" ? (this.sup = this.upInto = this.sub.upOutOf = S, S.adopt(this, this.sub, 0).downOutOf = this.sub, S.jQ = X('<span class="mq-sup"/>').append(S.jQ.children()).attr(g, S.id).prependTo(this.jQ)) : (this.sub = this.downInto = this.sup.downOutOf = S, S.adopt(this, 0, this.sup).upOutOf = this.sup, S.jQ = X('<span class="mq-sub"></span>').append(S.jQ.children()).attr(g, S.id).appendTo(this.jQ.removeClass("mq-sup-only")), this.jQ.append('<span style="display:inline-block;width:0">&#8203;</span>'));
                for (var A = 0; A < 2; A += 1) (function(P, Q, ie, pe) {
                  P[Q].deleteOutOf = function(ce, ze) {
                    if (ze.insDirOf(this[ce] ? -ce : ce, this.parent), !this.isEmpty()) {
                      var Xe = this.ends[ce];
                      this.children().disown().withDirAdopt(ce, ze.parent, ze[ce], ze[-ce]).jQ.insDirOf(-ce, ze.jQ), ze[-ce] = Xe;
                    }
                    P.supsub = ie, delete P[Q], delete P[pe + "Into"], P[ie][pe + "OutOf"] = Ho, delete P[ie].deleteOutOf, Q === "sub" && X(P.jQ.addClass("mq-sup-only")[0].lastChild).remove(), this.remove();
                  };
                })(this, "sub sup".split(" ")[A], "sup sub".split(" ")[A], "down up".split(" ")[A]);
              }, _.reflow = function() {
                var S = this.jQ, A = S.prev();
                if (A.length) {
                  var P = S.children(".mq-sup");
                  if (P.length) {
                    var Q = parseInt(P.css("font-size")), ie = P.offset().top + P.height() - A.offset().top - 0.7 * Q, pe = parseInt(P.css("margin-bottom"));
                    P.css("margin-bottom", pe + ie);
                  }
                }
              };
            });
            function Ho(_) {
              var H = this.parent, S = _;
              do {
                if (S[1]) return _.insLeftOf(H);
                S = S.parent.parent;
              } while (S !== H);
              _.insRightOf(H);
            }
            j.subscript = j._ = R(yr, function(_, H) {
              _.supsub = "sub", _.htmlTemplate = '<span class="mq-supsub mq-non-leaf"><span class="mq-sub">&0</span><span style="display:inline-block;width:0">&#8203;</span></span>', _.textTemplate = ["_"], _.finalizeTree = function() {
                this.downInto = this.sub = this.ends[F], this.sub.upOutOf = Ho, H.finalizeTree.call(this);
              };
            }), j.superscript = j.supscript = j["^"] = R(yr, function(_, H) {
              _.supsub = "sup", _.htmlTemplate = '<span class="mq-supsub mq-non-leaf mq-sup-only"><span class="mq-sup">&0</span></span>', _.textTemplate = ["^"], _.finalizeTree = function() {
                this.upInto = this.sup = this.ends[1], this.sup.downOutOf = Ho, H.finalizeTree.call(this);
              };
            });
            var cn = R(Lt, function(_, H) {
              _.init = function(S, A) {
                var P = '<span class="mq-large-operator mq-non-leaf"><span class="mq-to"><span>&1</span></span><big>' + A + '</big><span class="mq-from"><span>&0</span></span></span>';
                ct.prototype.init.call(this, S, P);
              }, _.createLeftOf = function(S) {
                H.createLeftOf.apply(this, arguments), S.options.sumStartsWithNEquals && (Br("n").createLeftOf(S), Uo().createLeftOf(S));
              }, _.latex = function() {
                function S(A) {
                  return A.length === 1 ? A : "{" + (A || " ") + "}";
                }
                return this.ctrlSeq + "_" + S(this.ends[F].latex()) + "^" + S(this.ends[1].latex());
              }, _.parser = function() {
                for (var S = et.string, A = et.optWhitespace, P = et.succeed, Q = At.block, ie = this, pe = ie.blocks = [vt(), vt()], ce = 0; ce < pe.length; ce += 1) pe[ce].adopt(ie, ie.ends[1], 0);
                return A.then(S("_").or(S("^"))).then(function(ze) {
                  var Xe = pe[ze === "_" ? 0 : 1];
                  return Q.then(function(wt) {
                    return wt.children().adopt(Xe, Xe.ends[1], 0), P(ie);
                  });
                }).many().result(ie);
              }, _.finalizeTree = function() {
                this.downInto = this.ends[F], this.upInto = this.ends[1], this.ends[F].upOutOf = this.ends[1], this.ends[1].downOutOf = this.ends[F];
              };
            });
            j["∑"] = j.sum = j.summation = w(cn, "\\sum ", "&sum;"), j["∏"] = j.prod = j.product = w(cn, "\\prod ", "&prod;"), j.coprod = j.coproduct = w(cn, "\\coprod ", "&#8720;"), j["∫"] = j.int = j.integral = R(cn, function(_, H) {
              _.init = function() {
                ct.prototype.init.call(this, "\\int ", '<span class="mq-int mq-non-leaf"><big>&int;</big><span class="mq-supsub mq-non-leaf"><span class="mq-sup"><span class="mq-sup-inner">&1</span></span><span class="mq-sub">&0</span><span style="display:inline-block;width:0">&#8203</span></span></span>');
              }, _.createLeftOf = Lt.p.createLeftOf;
            });
            var Jn = j.frac = j.dfrac = j.cfrac = j.fraction = R(Lt, function(_, H) {
              _.ctrlSeq = "\\frac", _.htmlTemplate = '<span class="mq-fraction mq-non-leaf"><span class="mq-numerator">&0</span><span class="mq-denominator">&1</span><span style="display:inline-block;width:0">&#8203;</span></span>', _.textTemplate = ["(", ")/(", ")"], _.finalizeTree = function() {
                this.upInto = this.ends[1].upOutOf = this.ends[F], this.downInto = this.ends[F].downOutOf = this.ends[1];
              };
            }), un = j.over = de["/"] = R(Jn, function(_, H) {
              _.createLeftOf = function(S) {
                if (!this.replacedFragment) {
                  for (var A = S[F]; A && !(A instanceof $e || A instanceof (j.text || b) || A instanceof cn || A.ctrlSeq === "\\ " || /^[,;:]$/.test(A.ctrlSeq)); ) A = A[F];
                  A instanceof cn && A[1] instanceof yr && (A = A[1])[1] instanceof yr && A[1].ctrlSeq != A.ctrlSeq && (A = A[1]), A === S[F] || S.isTooDeep(1) || (this.replaces(D(A[1] || S.parent.ends[F], S[F])), S[F] = A);
                }
                H.createLeftOf.call(this, S);
              };
            }), Vo = j.sqrt = j["√"] = R(Lt, function(_, H) {
              _.ctrlSeq = "\\sqrt", _.htmlTemplate = '<span class="mq-non-leaf"><span class="mq-scaled mq-sqrt-prefix">&radic;</span><span class="mq-non-leaf mq-sqrt-stem">&0</span></span>', _.textTemplate = ["sqrt(", ")"], _.parser = function() {
                return At.optBlock.then(function(S) {
                  return At.block.map(function(A) {
                    var P = Ca();
                    return P.blocks = [S, A], S.adopt(P, 0, 0), A.adopt(P, S, 0), P;
                  });
                }).or(H.parser.call(this));
              }, _.reflow = function() {
                var S = this.ends[1].jQ;
                Yn(S.prev(), 1, S.innerHeight() / +S.css("fontSize").slice(0, -2) - 0.1);
              };
            }), Ca = (j.hat = R(Lt, function(_, H) {
              _.ctrlSeq = "\\hat", _.htmlTemplate = '<span class="mq-non-leaf"><span class="mq-hat-prefix">^</span><span class="mq-hat-stem">&0</span></span>', _.textTemplate = ["hat(", ")"];
            }), j.nthroot = R(Vo, function(_, H) {
              _.htmlTemplate = '<sup class="mq-nthroot mq-non-leaf">&0</sup><span class="mq-scaled"><span class="mq-sqrt-prefix mq-scaled">&radic;</span><span class="mq-sqrt-stem mq-non-leaf">&1</span></span>', _.textTemplate = ["sqrt[", "](", ")"], _.latex = function() {
                return "\\sqrt[" + this.ends[F].latex() + "]{" + this.ends[1].latex() + "}";
              };
            })), Lu = R(Lt, function(_, H) {
              _.init = function(S, A, P) {
                var Q = '<span class="mq-non-leaf"><span class="mq-diacritic-above">' + A + '</span><span class="mq-diacritic-stem">&0</span></span>';
                H.init.call(this, S, Q, P);
              };
            });
            function Mu(_, H) {
              _.jQadd = function() {
                H.jQadd.apply(this, arguments), this.delimjQs = this.jQ.children(":first").add(this.jQ.children(":last")), this.contentjQ = this.jQ.children(":eq(1)");
              }, _.reflow = function() {
                var S = this.contentjQ.outerHeight() / parseFloat(this.contentjQ.css("fontSize"));
                Yn(this.delimjQs, x(1 + 0.2 * (S - 1), 1.2), 1.2 * S);
              };
            }
            j.vec = w(Lu, "\\vec", "&rarr;", ["vec(", ")"]), j.tilde = w(Lu, "\\tilde", "~", ["tilde(", ")"]);
            var Fn = R(R(Lt, Mu), function(_, H) {
              _.init = function(S, A, P, Q, ie) {
                H.init.call(this, "\\left" + Q, f, [A, P]), this.side = S, this.sides = {}, this.sides[F] = { ch: A, ctrlSeq: Q }, this.sides[1] = { ch: P, ctrlSeq: ie };
              }, _.numBlocks = function() {
                return 1;
              }, _.html = function() {
                return this.htmlTemplate = '<span class="mq-non-leaf"><span class="mq-scaled mq-paren' + (this.side === 1 ? " mq-ghost" : "") + '">' + this.sides[F].ch + '</span><span class="mq-non-leaf">&0</span><span class="mq-scaled mq-paren' + (this.side === F ? " mq-ghost" : "") + '">' + this.sides[1].ch + "</span></span>", H.html.call(this);
              }, _.latex = function() {
                return "\\left" + this.sides[F].ctrlSeq + this.ends[F].latex() + "\\right" + this.sides[1].ctrlSeq;
              }, _.matchBrack = function(S, A, P) {
                return P instanceof Fn && P.side && P.side !== -A && (!S.restrictMismatchedBrackets || fr[this.sides[this.side].ch] === P.sides[P.side].ch || { "(": "]", "[": ")" }[this.sides[F].ch] === P.sides[1].ch) && P;
              }, _.closeOpposing = function(S) {
                S.side = 0, S.sides[this.side] = this.sides[this.side], S.delimjQs.eq(this.side === F ? 0 : 1).removeClass("mq-ghost").html(this.sides[this.side].ch);
              }, _.createLeftOf = function(S) {
                if (!this.replacedFragment) {
                  var A = S.options;
                  if (this.sides[F].ch === "|") var P = this.matchBrack(A, 1, S[1]) || this.matchBrack(A, F, S[F]) || this.matchBrack(A, 0, S.parent.parent);
                  else P = this.matchBrack(A, -this.side, S[-this.side]) || this.matchBrack(A, -this.side, S.parent.parent);
                }
                if (P) {
                  var Q = this.side = -P.side;
                  this.closeOpposing(P), P === S.parent.parent && S[Q] && D(S[Q], S.parent.ends[Q], -Q).disown().withDirAdopt(-Q, P.parent, P, P[Q]).jQ.insDirOf(Q, P.jQ), P.bubble("reflow");
                } else Q = (P = this).side, P.replacedFragment ? P.side = 0 : S[-Q] && (P.replaces(D(S[-Q], S.parent.ends[-Q], Q)), S[-Q] = 0), H.createLeftOf.call(P, S);
                Q === F ? S.insAtLeftEnd(P.ends[F]) : S.insRightOf(P);
              }, _.placeCursor = b, _.unwrap = function() {
                this.ends[F].children().disown().adopt(this.parent, this, this[1]).jQ.insertAfter(this.jQ), this.remove();
              }, _.deleteSide = function(S, A, P) {
                var Q = this.parent, ie = this[S], pe = Q.ends[S];
                if (S === this.side) return this.unwrap(), void (ie ? P.insDirOf(-S, ie) : P.insAtDirEnd(S, Q));
                var ce = P.options, ze = !this.side;
                if (this.side = -S, this.matchBrack(ce, S, this.ends[F].ends[this.side])) {
                  this.closeOpposing(this.ends[F].ends[this.side]);
                  var Xe = this.ends[F].ends[S];
                  this.unwrap(), Xe.siblingCreated && Xe.siblingCreated(P.options, S), ie ? P.insDirOf(-S, ie) : P.insAtDirEnd(S, Q);
                } else {
                  if (this.matchBrack(ce, S, this.parent.parent)) this.parent.parent.closeOpposing(this), this.parent.parent.unwrap();
                  else {
                    if (A && ze) return this.unwrap(), void (ie ? P.insDirOf(-S, ie) : P.insAtDirEnd(S, Q));
                    this.sides[S] = { ch: fr[this.sides[this.side].ch], ctrlSeq: fr[this.sides[this.side].ctrlSeq] }, this.delimjQs.removeClass("mq-ghost").eq(S === F ? 0 : 1).addClass("mq-ghost").html(this.sides[S].ch);
                  }
                  ie ? (Xe = this.ends[F].ends[S], D(ie, pe, -S).disown().withDirAdopt(-S, this.ends[F], Xe, 0).jQ.insAtDirEnd(S, this.ends[F].jQ.removeClass("mq-empty")), Xe.siblingCreated && Xe.siblingCreated(P.options, S), P.insDirOf(-S, ie)) : A ? P.insDirOf(S, this) : P.insAtDirEnd(S, this.ends[F]);
                }
              }, _.deleteTowards = function(S, A) {
                this.deleteSide(-S, !1, A);
              }, _.finalizeTree = function() {
                this.ends[F].deleteOutOf = function(S, A) {
                  this.parent.deleteSide(S, !0, A);
                }, this.finalizeTree = this.intentionalBlur = function() {
                  this.delimjQs.eq(this.side === F ? 1 : 0).removeClass("mq-ghost"), this.side = 0;
                };
              }, _.siblingCreated = function(S, A) {
                A === -this.side && this.finalizeTree();
              };
            }), fr = { "(": ")", ")": "(", "[": "]", "]": "[", "{": "}", "}": "{", "\\{": "\\}", "\\}": "\\{", "&lang;": "&rang;", "&rang;": "&lang;", "\\langle ": "\\rangle ", "\\rangle ": "\\langle ", "|": "|", "\\lVert ": "\\rVert ", "\\rVert ": "\\lVert " };
            function xr(_, H) {
              H = H || _;
              var S = fr[_], A = fr[H];
              de[_] = w(Fn, F, _, S, H, A), de[S] = w(Fn, 1, _, S, H, A);
            }
            xr("("), xr("["), xr("{", "\\{"), j.langle = w(Fn, F, "&lang;", "&rang;", "\\langle ", "\\rangle "), j.rangle = w(Fn, 1, "&lang;", "&rang;", "\\langle ", "\\rangle "), de["|"] = w(Fn, F, "|", "|", "|", "|"), j.lVert = w(Fn, F, "&#8741;", "&#8741;", "\\lVert ", "\\rVert "), j.rVert = w(Fn, 1, "&#8741;", "&#8741;", "\\lVert ", "\\rVert "), j.left = R(Lt, function(_) {
              _.parser = function() {
                var H = et.regex, S = et.string, A = (et.succeed, et.optWhitespace);
                return A.then(H(/^(?:[([|]|\\\{|\\langle(?![a-zA-Z])|\\lVert(?![a-zA-Z]))/)).then(function(P) {
                  var Q = P.charAt(0) === "\\" ? P.slice(1) : P;
                  return P == "\\langle" && (Q = "&lang;", P += " "), P == "\\lVert" && (Q = "&#8741;", P += " "), At.then(function(ie) {
                    return S("\\right").skip(A).then(H(/^(?:[\])|]|\\\}|\\rangle(?![a-zA-Z])|\\rVert(?![a-zA-Z]))/)).map(function(pe) {
                      var ce = pe.charAt(0) === "\\" ? pe.slice(1) : pe;
                      pe == "\\rangle" && (ce = "&rang;", pe += " "), pe == "\\rVert" && (ce = "&#8741;", pe += " ");
                      var ze = Fn(0, Q, ce, P, pe);
                      return ze.blocks = [ie], ie.adopt(ze, 0, 0), ze;
                    });
                  });
                });
              };
            }), j.right = R(Lt, function(_) {
              _.parser = function() {
                return et.fail("unmatched \\right");
              };
            });
            var Bu = j.binom = j.binomial = R(R(Lt, Mu), function(_, H) {
              _.ctrlSeq = "\\binom", _.htmlTemplate = '<span class="mq-non-leaf"><span class="mq-paren mq-scaled">(</span><span class="mq-non-leaf"><span class="mq-array mq-non-leaf"><span>&0</span><span>&1</span></span></span><span class="mq-paren mq-scaled">)</span></span>', _.textTemplate = ["choose(", ",", ")"];
            });
            j.choose = R(Bu, function(_) {
              _.createLeftOf = un.prototype.createLeftOf;
            }), j.editable = j.MathQuillMathField = R(Lt, function(_, H) {
              _.ctrlSeq = "\\MathQuillMathField", _.htmlTemplate = '<span class="mq-editable-field"><span class="mq-root-block">&0</span></span>', _.parser = function() {
                var S = this, A = et.string, P = et.regex, Q = et.succeed;
                return A("[").then(P(/^[a-z][a-z0-9]*/i)).skip(A("]")).map(function(ie) {
                  S.name = ie;
                }).or(Q()).then(H.parser.call(S));
              }, _.finalizeTree = function(S) {
                var A = Me(this.ends[F], this.jQ, S);
                A.KIND_OF_MQ = "MathField", A.editable = !0, A.createTextarea(), A.editablesTextareaEvents(), A.cursor.insAtRightEnd(A.root), pt(A.root);
              }, _.registerInnerField = function(S, A) {
                S.push(S[this.name] = A(this.ends[F].controller));
              }, _.latex = function() {
                return this.ends[F].latex();
              }, _.text = function() {
                return this.ends[F].text();
              };
            });
            var Cl = j.embed = R(ct, function(_, H) {
              _.setOptions = function(S) {
                function A() {
                  return "";
                }
                return this.text = S.text || A, this.htmlTemplate = S.htmlString || "", this.latex = S.latex || A, this;
              }, _.parser = function() {
                var S = this, A = et.string, P = et.regex, Q = et.succeed;
                return A("{").then(P(/^[a-z][a-z0-9]*/i)).skip(A("}")).then(function(ie) {
                  return A("[").then(P(/^[-\w\s]*/)).skip(A("]")).or(Q()).map(function(pe) {
                    return S.setOptions(ae[ie](pe));
                  });
                });
              };
            });
            j.notin = j.cong = j.equiv = j.oplus = j.otimes = R($e, function(_, H) {
              _.init = function(S) {
                H.init.call(this, "\\" + S + " ", "&" + S + ";");
              };
            }), j["≠"] = j.ne = j.neq = w($e, "\\ne ", "&ne;"), j["∗"] = j.ast = j.star = j.loast = j.lowast = w($e, "\\ast ", "&lowast;"), j.therefor = j.therefore = w($e, "\\therefore ", "&there4;"), j.cuz = j.because = w($e, "\\because ", "&#8757;"), j.prop = j.propto = w($e, "\\propto ", "&prop;"), j["≈"] = j.asymp = j.approx = w($e, "\\approx ", "&asymp;"), j.isin = j.in = w($e, "\\in ", "&isin;"), j.ni = j.contains = w($e, "\\ni ", "&ni;"), j.notni = j.niton = j.notcontains = j.doesnotcontain = w($e, "\\not\\ni ", "&#8716;"), j.sub = j.subset = w($e, "\\subset ", "&sub;"), j.sup = j.supset = j.superset = w($e, "\\supset ", "&sup;"), j.nsub = j.notsub = j.nsubset = j.notsubset = w($e, "\\not\\subset ", "&#8836;"), j.nsup = j.notsup = j.nsupset = j.notsupset = j.nsuperset = j.notsuperset = w($e, "\\not\\supset ", "&#8837;"), j.sube = j.subeq = j.subsete = j.subseteq = w($e, "\\subseteq ", "&sube;"), j.supe = j.supeq = j.supsete = j.supseteq = j.supersete = j.superseteq = w($e, "\\supseteq ", "&supe;"), j.nsube = j.nsubeq = j.notsube = j.notsubeq = j.nsubsete = j.nsubseteq = j.notsubsete = j.notsubseteq = w($e, "\\not\\subseteq ", "&#8840;"), j.nsupe = j.nsupeq = j.notsupe = j.notsupeq = j.nsupsete = j.nsupseteq = j.notsupsete = j.notsupseteq = j.nsupersete = j.nsuperseteq = j.notsupersete = j.notsuperseteq = w($e, "\\not\\supseteq ", "&#8841;"), j.N = j.naturals = j.Naturals = w(re, "\\mathbb{N}", "&#8469;"), j.P = j.primes = j.Primes = j.projective = j.Projective = j.probability = j.Probability = w(re, "\\mathbb{P}", "&#8473;"), j.Z = j.integers = j.Integers = w(re, "\\mathbb{Z}", "&#8484;"), j.Q = j.rationals = j.Rationals = w(re, "\\mathbb{Q}", "&#8474;"), j.R = j.reals = j.Reals = w(re, "\\mathbb{R}", "&#8477;"), j.C = j.complex = j.Complex = j.complexes = j.Complexes = j.complexplane = j.Complexplane = j.ComplexPlane = w(re, "\\mathbb{C}", "&#8450;"), j.H = j.Hamiltonian = j.quaternions = j.Quaternions = w(re, "\\mathbb{H}", "&#8461;"), j.quad = j.emsp = w(re, "\\quad ", "    "), j.qquad = w(re, "\\qquad ", "        "), j.diamond = w(re, "\\diamond ", "&#9671;"), j.bigtriangleup = w(re, "\\bigtriangleup ", "&#9651;"), j.ominus = w(re, "\\ominus ", "&#8854;"), j.uplus = w(re, "\\uplus ", "&#8846;"), j.bigtriangledown = w(re, "\\bigtriangledown ", "&#9661;"), j.sqcap = w(re, "\\sqcap ", "&#8851;"), j.triangleleft = w(re, "\\triangleleft ", "&#8882;"), j.sqcup = w(re, "\\sqcup ", "&#8852;"), j.triangleright = w(re, "\\triangleright ", "&#8883;"), j.odot = j.circledot = w(re, "\\odot ", "&#8857;"), j.bigcirc = w(re, "\\bigcirc ", "&#9711;"), j.dagger = w(re, "\\dagger ", "&#0134;"), j.ddagger = w(re, "\\ddagger ", "&#135;"), j.wr = w(re, "\\wr ", "&#8768;"), j.amalg = w(re, "\\amalg ", "&#8720;"), j.models = w(re, "\\models ", "&#8872;"), j.prec = w(re, "\\prec ", "&#8826;"), j.succ = w(re, "\\succ ", "&#8827;"), j.preceq = w(re, "\\preceq ", "&#8828;"), j.succeq = w(re, "\\succeq ", "&#8829;"), j.simeq = w(re, "\\simeq ", "&#8771;"), j.mid = w(re, "\\mid ", "&#8739;"), j.ll = w(re, "\\ll ", "&#8810;"), j.gg = w(re, "\\gg ", "&#8811;"), j.parallel = w(re, "\\parallel ", "&#8741;"), j.nparallel = w(re, "\\nparallel ", "&#8742;"), j.bowtie = w(re, "\\bowtie ", "&#8904;"), j.sqsubset = w(re, "\\sqsubset ", "&#8847;"), j.sqsupset = w(re, "\\sqsupset ", "&#8848;"), j.smile = w(re, "\\smile ", "&#8995;"), j.sqsubseteq = w(re, "\\sqsubseteq ", "&#8849;"), j.sqsupseteq = w(re, "\\sqsupseteq ", "&#8850;"), j.doteq = w(re, "\\doteq ", "&#8784;"), j.frown = w(re, "\\frown ", "&#8994;"), j.vdash = w(re, "\\vdash ", "&#8870;"), j.dashv = w(re, "\\dashv ", "&#8867;"), j.nless = w(re, "\\nless ", "&#8814;"), j.ngtr = w(re, "\\ngtr ", "&#8815;"), j.longleftarrow = w(re, "\\longleftarrow ", "&#8592;"), j.longrightarrow = w(re, "\\longrightarrow ", "&#8594;"), j.Longleftarrow = w(re, "\\Longleftarrow ", "&#8656;"), j.Longrightarrow = w(re, "\\Longrightarrow ", "&#8658;"), j.longleftrightarrow = w(re, "\\longleftrightarrow ", "&#8596;"), j.updownarrow = w(re, "\\updownarrow ", "&#8597;"), j.Longleftrightarrow = w(re, "\\Longleftrightarrow ", "&#8660;"), j.Updownarrow = w(re, "\\Updownarrow ", "&#8661;"), j.mapsto = w(re, "\\mapsto ", "&#8614;"), j.nearrow = w(re, "\\nearrow ", "&#8599;"), j.hookleftarrow = w(re, "\\hookleftarrow ", "&#8617;"), j.hookrightarrow = w(re, "\\hookrightarrow ", "&#8618;"), j.searrow = w(re, "\\searrow ", "&#8600;"), j.leftharpoonup = w(re, "\\leftharpoonup ", "&#8636;"), j.rightharpoonup = w(re, "\\rightharpoonup ", "&#8640;"), j.swarrow = w(re, "\\swarrow ", "&#8601;"), j.leftharpoondown = w(re, "\\leftharpoondown ", "&#8637;"), j.rightharpoondown = w(re, "\\rightharpoondown ", "&#8641;"), j.nwarrow = w(re, "\\nwarrow ", "&#8598;"), j.ldots = w(re, "\\ldots ", "&#8230;"), j.cdots = w(re, "\\cdots ", "&#8943;"), j.vdots = w(re, "\\vdots ", "&#8942;"), j.ddots = w(re, "\\ddots ", "&#8945;"), j.surd = w(re, "\\surd ", "&#8730;"), j.triangle = w(re, "\\triangle ", "&#9651;"), j.ell = w(re, "\\ell ", "&#8467;"), j.top = w(re, "\\top ", "&#8868;"), j.flat = w(re, "\\flat ", "&#9837;"), j.natural = w(re, "\\natural ", "&#9838;"), j.sharp = w(re, "\\sharp ", "&#9839;"), j.wp = w(re, "\\wp ", "&#8472;"), j.bot = w(re, "\\bot ", "&#8869;"), j.clubsuit = w(re, "\\clubsuit ", "&#9827;"), j.diamondsuit = w(re, "\\diamondsuit ", "&#9826;"), j.heartsuit = w(re, "\\heartsuit ", "&#9825;"), j.spadesuit = w(re, "\\spadesuit ", "&#9824;"), j.parallelogram = w(re, "\\parallelogram ", "&#9649;"), j.square = w(re, "\\square ", "&#11036;"), j.oint = w(re, "\\oint ", "&#8750;"), j.bigcap = w(re, "\\bigcap ", "&#8745;"), j.bigcup = w(re, "\\bigcup ", "&#8746;"), j.bigsqcup = w(re, "\\bigsqcup ", "&#8852;"), j.bigvee = w(re, "\\bigvee ", "&#8744;"), j.bigwedge = w(re, "\\bigwedge ", "&#8743;"), j.bigodot = w(re, "\\bigodot ", "&#8857;"), j.bigotimes = w(re, "\\bigotimes ", "&#8855;"), j.bigoplus = w(re, "\\bigoplus ", "&#8853;"), j.biguplus = w(re, "\\biguplus ", "&#8846;"), j.lfloor = w(re, "\\lfloor ", "&#8970;"), j.rfloor = w(re, "\\rfloor ", "&#8971;"), j.lceil = w(re, "\\lceil ", "&#8968;"), j.rceil = w(re, "\\rceil ", "&#8969;"), j.opencurlybrace = j.lbrace = w(re, "\\lbrace ", "{"), j.closecurlybrace = j.rbrace = w(re, "\\rbrace ", "}"), j.lbrack = w(re, "["), j.rbrack = w(re, "]"), j.slash = w(re, "/"), j.vert = w(re, "|"), j.perp = j.perpendicular = w(re, "\\perp ", "&perp;"), j.nabla = j.del = w(re, "\\nabla ", "&nabla;"), j.hbar = w(re, "\\hbar ", "&#8463;"), j.AA = j.Angstrom = j.angstrom = w(re, "\\text\\AA ", "&#8491;"), j.ring = j.circ = j.circle = w(re, "\\circ ", "&#8728;"), j.bull = j.bullet = w(re, "\\bullet ", "&bull;"), j.setminus = j.smallsetminus = w(re, "\\setminus ", "&#8726;"), j.not = j["¬"] = j.neg = w(re, "\\neg ", "&not;"), j["…"] = j.dots = j.ellip = j.hellip = j.ellipsis = j.hellipsis = w(re, "\\dots ", "&hellip;"), j.converges = j.darr = j.dnarr = j.dnarrow = j.downarrow = w(re, "\\downarrow ", "&darr;"), j.dArr = j.dnArr = j.dnArrow = j.Downarrow = w(re, "\\Downarrow ", "&dArr;"), j.diverges = j.uarr = j.uparrow = w(re, "\\uparrow ", "&uarr;"), j.uArr = j.Uparrow = w(re, "\\Uparrow ", "&uArr;"), j.to = w($e, "\\to ", "&rarr;"), j.rarr = j.rightarrow = w(re, "\\rightarrow ", "&rarr;"), j.implies = w($e, "\\Rightarrow ", "&rArr;"), j.rArr = j.Rightarrow = w(re, "\\Rightarrow ", "&rArr;"), j.gets = w($e, "\\gets ", "&larr;"), j.larr = j.leftarrow = w(re, "\\leftarrow ", "&larr;"), j.impliedby = w($e, "\\Leftarrow ", "&lArr;"), j.lArr = j.Leftarrow = w(re, "\\Leftarrow ", "&lArr;"), j.harr = j.lrarr = j.leftrightarrow = w(re, "\\leftrightarrow ", "&harr;"), j.iff = w($e, "\\Leftrightarrow ", "&hArr;"), j.hArr = j.lrArr = j.Leftrightarrow = w(re, "\\Leftrightarrow ", "&hArr;"), j.Re = j.Real = j.real = w(re, "\\Re ", "&real;"), j.Im = j.imag = j.image = j.imagin = j.imaginary = j.Imaginary = w(re, "\\Im ", "&image;"), j.part = j.partial = w(re, "\\partial ", "&part;"), j.infty = j.infin = j.infinity = w(re, "\\infty ", "&infin;"), j.pounds = w(re, "\\pounds ", "&pound;"), j.alef = j.alefsym = j.aleph = j.alephsym = w(re, "\\aleph ", "&alefsym;"), j.xist = j.xists = j.exist = j.exists = w(re, "\\exists ", "&exist;"), j.nexists = j.nexist = w(re, "\\nexists ", "&#8708;"), j.and = j.land = j.wedge = w($e, "\\wedge ", "&and;"), j.or = j.lor = j.vee = w($e, "\\vee ", "&or;"), j.o = j.O = j.empty = j.emptyset = j.oslash = j.Oslash = j.nothing = j.varnothing = w($e, "\\varnothing ", "&empty;"), j.cup = j.union = w($e, "\\cup ", "&cup;"), j.cap = j.intersect = j.intersection = w($e, "\\cap ", "&cap;"), j.deg = j.degree = w(re, "\\degree ", "&deg;"), j.ang = j.angle = w(re, "\\angle ", "&ang;"), j.measuredangle = w(re, "\\measuredangle ", "&#8737;");
            var kl = R(re, function(_, H) {
              _.createLeftOf = function(S) {
                S.options.autoSubscriptNumerals && S.parent !== S.parent.parent.sub && (S[F] instanceof Rn && S[F].isItalic !== !1 || S[F] instanceof yr && S[F][F] instanceof Rn && S[F][F].isItalic !== !1) ? (j._().createLeftOf(S), H.createLeftOf.call(this, S), S.insRightOf(S.parent.parent)) : H.createLeftOf.call(this, S);
              };
            }), Rn = R(ct, function(_, H) {
              _.init = function(S, A) {
                H.init.call(this, S, "<var>" + (A || S) + "</var>");
              }, _.text = function() {
                var S = this.ctrlSeq;
                return this.isPartOfOperator ? S[0] == "\\" ? S = S.slice(1, S.length) : S[S.length - 1] == " " && (S = S.slice(0, -1)) : (!this[F] || this[F] instanceof Rn || this[F] instanceof $e || this[F].ctrlSeq === "\\ " || (S = "*" + S), !this[1] || this[1] instanceof $e || this[1] instanceof yr || (S += "*")), S;
              };
            });
            at.p.autoCommands = { _maxLength: 0 }, Ve.autoCommands = function(_) {
              if (!/^[a-z]+(?: [a-z]+)*$/i.test(_)) throw '"' + _ + '" not a space-delimited list of only letters';
              for (var H = _.split(" "), S = {}, A = 0, P = 0; P < H.length; P += 1) {
                var Q = H[P];
                if (Q.length < 2) throw 'autocommand "' + Q + '" not minimum length of 2';
                if (j[Q] === Ru) throw '"' + Q + '" is a built-in operator name';
                S[Q] = 1, A = E(A, Q.length);
              }
              return S._maxLength = A, S;
            };
            var Br = R(Rn, function(_, H) {
              function S(A) {
                return !A || A instanceof $e || A instanceof cn;
              }
              _.init = function(A) {
                return H.init.call(this, this.letter = A);
              }, _.createLeftOf = function(A) {
                H.createLeftOf.apply(this, arguments);
                var P = A.options.autoCommands, Q = P._maxLength;
                if (Q > 0) {
                  for (var ie = "", pe = this, ce = 0; pe instanceof Br && pe.ctrlSeq === pe.letter && ce < Q; ) ie = pe.letter + ie, pe = pe[F], ce += 1;
                  for (; ie.length; ) {
                    if (P.hasOwnProperty(ie)) {
                      for (ce = 1, pe = this; ce < ie.length; ce += 1, pe = pe[F]) ;
                      return D(pe, this).remove(), A[F] = pe[F], j[ie](ie).createLeftOf(A);
                    }
                    ie = ie.slice(1);
                  }
                }
              }, _.italicize = function(A) {
                return this.isItalic = A, this.isPartOfOperator = !A, this.jQ.toggleClass("mq-operator-name", !A), this;
              }, _.finalizeTree = _.siblingDeleted = _.siblingCreated = function(A, P) {
                P !== F && this[1] instanceof Br || this.autoUnItalicize(A);
              }, _.autoUnItalicize = function(A) {
                var P = A.autoOperatorNames;
                if (P._maxLength !== 0) {
                  for (var Q = this.letter, ie = this[F]; ie instanceof Br; ie = ie[F]) Q = ie.letter + Q;
                  for (var pe = this[1]; pe instanceof Br; pe = pe[1]) Q += pe.letter;
                  D(ie[1] || this.parent.ends[F], pe[F] || this.parent.ends[1]).each(function(wn) {
                    wn.italicize(!0).jQ.removeClass("mq-first mq-last mq-followed-by-supsub"), wn.ctrlSeq = wn.letter;
                  });
                  e: for (var ce = 0, ze = ie[1] || this.parent.ends[F]; ce < Q.length; ce += 1, ze = ze[1]) for (var Xe = x(P._maxLength, Q.length - ce); Xe > 0; Xe -= 1) {
                    var wt = Q.slice(ce, ce + Xe);
                    if (P.hasOwnProperty(wt)) {
                      for (var jt = 0, Kt = ze; jt < Xe; jt += 1, Kt = Kt[1]) {
                        Kt.italicize(!1);
                        var ut = Kt;
                      }
                      var Yt = Iu.hasOwnProperty(wt);
                      if (ze.ctrlSeq = (Yt ? "\\" : "\\operatorname{") + ze.ctrlSeq, ut.ctrlSeq += Yt ? " " : "}", El.hasOwnProperty(wt) && ut[F][F][F].jQ.addClass("mq-last"), S(ze[F]) || ze.jQ.addClass("mq-first"), !S(ut[1])) if (ut[1] instanceof yr) {
                        var Rt = ut[1];
                        (Rt.siblingCreated = Rt.siblingDeleted = function() {
                          Rt.jQ.toggleClass("mq-after-operator-name", !(Rt[1] instanceof Fn));
                        })();
                      } else ut.jQ.toggleClass("mq-last", !(ut[1] instanceof Fn));
                      ce += Xe - 1, ze = ut;
                      continue e;
                    }
                  }
                }
              };
            }), Iu = {}, ui = at.p.autoOperatorNames = { _maxLength: 9 }, El = { limsup: 1, liminf: 1, projlim: 1, injlim: 1 };
            (function() {
              for (var _ = "arg deg det dim exp gcd hom inf ker lg lim ln log max min sup limsup liminf injlim projlim Pr".split(" "), H = 0; H < _.length; H += 1) Iu[_[H]] = ui[_[H]] = 1;
              var S = "sin cos tan arcsin arccos arctan sinh cosh tanh sec csc cot coth".split(" ");
              for (H = 0; H < S.length; H += 1) Iu[S[H]] = 1;
              var A = "sin cos tan sec cosec csc cotan cot ctg".split(" ");
              for (H = 0; H < A.length; H += 1) ui[A[H]] = ui["arc" + A[H]] = ui[A[H] + "h"] = ui["ar" + A[H] + "h"] = ui["arc" + A[H] + "h"] = 1;
              var P = "gcf hcf lcm proj span".split(" ");
              for (H = 0; H < P.length; H += 1) ui[P[H]] = 1;
            })(), Ve.autoOperatorNames = function(_) {
              if (!/^[a-z]+(?: [a-z]+)*$/i.test(_)) throw '"' + _ + '" not a space-delimited list of only letters';
              for (var H = _.split(" "), S = {}, A = 0, P = 0; P < H.length; P += 1) {
                var Q = H[P];
                if (Q.length < 2) throw '"' + Q + '" not minimum length of 2';
                S[Q] = 1, A = E(A, Q.length);
              }
              return S._maxLength = A, S;
            };
            var Ru = R(ct, function(_, H) {
              _.init = function(S) {
                this.ctrlSeq = S;
              }, _.createLeftOf = function(S) {
                for (var A = this.ctrlSeq, P = 0; P < A.length; P += 1) Br(A.charAt(P)).createLeftOf(S);
              }, _.parser = function() {
                for (var S = this.ctrlSeq, A = vt(), P = 0; P < S.length; P += 1) Br(S.charAt(P)).adopt(A, A.ends[1], 0);
                return et.succeed(A.children());
              };
            });
            for (var er in ui) ui.hasOwnProperty(er) && (j[er] = Ru);
            j.operatorname = R(Lt, function(_) {
              _.createLeftOf = b, _.numBlocks = function() {
                return 1;
              }, _.parser = function() {
                return At.block.map(function(H) {
                  return H.children();
                });
              };
            }), j.f = R(Br, function(_, H) {
              _.init = function() {
                ct.p.init.call(this, this.letter = "f", '<var class="mq-f">f</var>');
              }, _.italicize = function(S) {
                return this.jQ.html("f").toggleClass("mq-f", S), H.italicize.apply(this, arguments);
              };
            }), j[" "] = j.space = w(re, "\\ ", "&nbsp;"), j["'"] = j.prime = w(re, "'", "&prime;"), j["″"] = j.dprime = w(re, "″", "&Prime;"), j.backslash = w(re, "\\backslash ", "\\"), de["\\"] || (de["\\"] = j.backslash), j.$ = w(re, "\\$", "$");
            var Ga = R(ct, function(_, H) {
              _.init = function(S, A) {
                H.init.call(this, S, '<span class="mq-nonSymbola">' + (A || S) + "</span>");
              };
            });
            j["@"] = Ga, j["&"] = w(Ga, "\\&", "&amp;"), j["%"] = w(Ga, "\\%", "%"), j.alpha = j.beta = j.gamma = j.delta = j.zeta = j.eta = j.theta = j.iota = j.kappa = j.mu = j.nu = j.xi = j.rho = j.sigma = j.tau = j.chi = j.psi = j.omega = R(Rn, function(_, H) {
              _.init = function(S) {
                H.init.call(this, "\\" + S + " ", "&" + S + ";");
              };
            }), j.phi = w(Rn, "\\phi ", "&#981;"), j.phiv = j.varphi = w(Rn, "\\varphi ", "&phi;"), j.epsilon = w(Rn, "\\epsilon ", "&#1013;"), j.epsiv = j.varepsilon = w(Rn, "\\varepsilon ", "&epsilon;"), j.piv = j.varpi = w(Rn, "\\varpi ", "&piv;"), j.sigmaf = j.sigmav = j.varsigma = w(Rn, "\\varsigma ", "&sigmaf;"), j.thetav = j.vartheta = j.thetasym = w(Rn, "\\vartheta ", "&thetasym;"), j.upsilon = j.upsi = w(Rn, "\\upsilon ", "&upsilon;"), j.gammad = j.Gammad = j.digamma = w(Rn, "\\digamma ", "&#989;"), j.kappav = j.varkappa = w(Rn, "\\varkappa ", "&#1008;"), j.rhov = j.varrho = w(Rn, "\\varrho ", "&#1009;"), j.pi = j.π = w(Ga, "\\pi ", "&pi;"), j.lambda = w(Ga, "\\lambda ", "&lambda;"), j.Upsilon = j.Upsi = j.upsih = j.Upsih = w(ct, "\\Upsilon ", '<var style="font-family: serif">&upsih;</var>'), j.Gamma = j.Delta = j.Theta = j.Lambda = j.Xi = j.Pi = j.Sigma = j.Phi = j.Psi = j.Omega = j.forall = R(re, function(_, H) {
              _.init = function(S) {
                H.init.call(this, "\\" + S + " ", "&" + S + ";");
              };
            });
            var Dn = R(Lt, function(_) {
              _.init = function(H) {
                this.latex = H;
              }, _.createLeftOf = function(H) {
                var S = At.parse(this.latex);
                S.children().adopt(H.parent, H[F], H[1]), H[F] = S.ends[1], S.jQize().insertBefore(H.jQ), S.finalizeInsert(H.options, H), S.ends[1][1].siblingCreated && S.ends[1][1].siblingCreated(H.options, F), S.ends[F][F].siblingCreated && S.ends[F][F].siblingCreated(H.options, 1), H.parent.bubble("reflow");
              }, _.parser = function() {
                var H = At.parse(this.latex).children();
                return et.succeed(H);
              };
            });
            j["¹"] = w(Dn, "^1"), j["²"] = w(Dn, "^2"), j["³"] = w(Dn, "^3"), j["¼"] = w(Dn, "\\frac14"), j["½"] = w(Dn, "\\frac12"), j["¾"] = w(Dn, "\\frac34");
            var Es = R($e, function(_) {
              _.init = re.prototype.init, _.contactWeld = _.siblingCreated = _.siblingDeleted = function(H, S) {
                if (S !== 1) return this.jQ[0].className = function A(P) {
                  return P[F] ? P[F] instanceof $e || /^[,;:\(\[]$/.test(P[F].ctrlSeq) ? "" : "mq-binary-operator" : P.parent && P.parent.parent && P.parent.parent.isStyleBlock() ? A(P.parent.parent) : "";
                }(this), this;
              };
            });
            j["+"] = w(Es, "+", "+"), j["–"] = j["-"] = w(Es, "-", "&minus;"), j["±"] = j.pm = j.plusmn = j.plusminus = w(Es, "\\pm ", "&plusmn;"), j.mp = j.mnplus = j.minusplus = w(Es, "\\mp ", "&#8723;"), de["*"] = j.sdot = j.cdot = w($e, "\\cdot ", "&middot;", "*");
            var bn = R($e, function(_, H) {
              _.init = function(S, A) {
                this.data = S, this.strict = A;
                var P = A ? "Strict" : "";
                H.init.call(this, S["ctrlSeq" + P], S["html" + P], S["text" + P]);
              }, _.swap = function(S) {
                this.strict = S;
                var A = S ? "Strict" : "";
                this.ctrlSeq = this.data["ctrlSeq" + A], this.jQ.html(this.data["html" + A]), this.textTemplate = [this.data["text" + A]];
              }, _.deleteTowards = function(S, A) {
                if (S === F && !this.strict) return this.swap(!0), void this.bubble("reflow");
                H.deleteTowards.apply(this, arguments);
              };
            }), ka = { ctrlSeq: "\\le ", html: "&le;", text: "≤", ctrlSeqStrict: "<", htmlStrict: "&lt;", textStrict: "<" }, Sl = { ctrlSeq: "\\ge ", html: "&ge;", text: "≥", ctrlSeqStrict: ">", htmlStrict: "&gt;", textStrict: ">" };
            j["<"] = j.lt = w(bn, ka, !0), j[">"] = j.gt = w(bn, Sl, !0), j["≤"] = j.le = j.leq = w(bn, ka, !1), j["≥"] = j.ge = j.geq = w(bn, Sl, !1);
            var Uo = R($e, function(_, H) {
              _.init = function() {
                H.init.call(this, "=", "=");
              }, _.createLeftOf = function(S) {
                if (S[F] instanceof bn && S[F].strict) return S[F].swap(!1), void S[F].bubble("reflow");
                H.createLeftOf.apply(this, arguments);
              };
            });
            j["="] = Uo, j["×"] = j.times = w($e, "\\times ", "&times;", "[x]"), j["÷"] = j.div = j.divide = j.divides = w($e, "\\div ", "&divide;", "[/]"), de["~"] = j.sim = w($e, "\\sim ", "~", "~");
            var Ka = We(1);
            for (var Ss in Ka) (function(_, H) {
              typeof H == "function" ? (Ae[_] = function() {
                return Se(), H.apply(this, arguments);
              }, Ae[_].prototype = H.prototype) : Ae[_] = H;
            })(Ss, Ka[Ss]);
          }(), l.exports = window.MathQuill;
        }, 755: function(l, u) {
          var d;
          (function(p, f) {
            typeof l.exports == "object" ? l.exports = p.document ? f(p, !0) : function(m) {
              if (!m.document) throw new Error("jQuery requires a window with a document");
              return f(m);
            } : f(p);
          })(typeof window < "u" ? window : this, function(p, f) {
            var m = [], y = Object.getPrototypeOf, g = m.slice, x = m.flat ? function(h) {
              return m.flat.call(h);
            } : function(h) {
              return m.concat.apply([], h);
            }, E = m.push, b = m.indexOf, C = {}, T = C.toString, z = C.hasOwnProperty, I = z.toString, w = I.call(Object), M = {}, R = function(h) {
              return typeof h == "function" && typeof h.nodeType != "number" && typeof h.item != "function";
            }, F = function(h) {
              return h != null && h === h.window;
            }, W = p.document, X = { type: !0, src: !0, nonce: !0, noModule: !0 };
            function le(h, k, O) {
              var L, $, U = (O = O || W).createElement("script");
              if (U.text = h, k) for (L in X) ($ = k[L] || k.getAttribute && k.getAttribute(L)) && U.setAttribute(L, $);
              O.head.appendChild(U).parentNode.removeChild(U);
            }
            function ne(h) {
              return h == null ? h + "" : typeof h == "object" || typeof h == "function" ? C[T.call(h)] || "object" : typeof h;
            }
            var fe = "3.6.0", D = function(h, k) {
              return new D.fn.init(h, k);
            };
            function j(h) {
              var k = !!h && "length" in h && h.length, O = ne(h);
              return !R(h) && !F(h) && (O === "array" || k === 0 || typeof k == "number" && k > 0 && k - 1 in h);
            }
            D.fn = D.prototype = { jquery: fe, constructor: D, length: 0, toArray: function() {
              return g.call(this);
            }, get: function(h) {
              return h == null ? g.call(this) : h < 0 ? this[h + this.length] : this[h];
            }, pushStack: function(h) {
              var k = D.merge(this.constructor(), h);
              return k.prevObject = this, k;
            }, each: function(h) {
              return D.each(this, h);
            }, map: function(h) {
              return this.pushStack(D.map(this, function(k, O) {
                return h.call(k, O, k);
              }));
            }, slice: function() {
              return this.pushStack(g.apply(this, arguments));
            }, first: function() {
              return this.eq(0);
            }, last: function() {
              return this.eq(-1);
            }, even: function() {
              return this.pushStack(D.grep(this, function(h, k) {
                return (k + 1) % 2;
              }));
            }, odd: function() {
              return this.pushStack(D.grep(this, function(h, k) {
                return k % 2;
              }));
            }, eq: function(h) {
              var k = this.length, O = +h + (h < 0 ? k : 0);
              return this.pushStack(O >= 0 && O < k ? [this[O]] : []);
            }, end: function() {
              return this.prevObject || this.constructor();
            }, push: E, sort: m.sort, splice: m.splice }, D.extend = D.fn.extend = function() {
              var h, k, O, L, $, U, G = arguments[0] || {}, ue = 1, he = arguments.length, we = !1;
              for (typeof G == "boolean" && (we = G, G = arguments[ue] || {}, ue++), typeof G == "object" || R(G) || (G = {}), ue === he && (G = this, ue--); ue < he; ue++) if ((h = arguments[ue]) != null) for (k in h) L = h[k], k !== "__proto__" && G !== L && (we && L && (D.isPlainObject(L) || ($ = Array.isArray(L))) ? (O = G[k], U = $ && !Array.isArray(O) ? [] : $ || D.isPlainObject(O) ? O : {}, $ = !1, G[k] = D.extend(we, U, L)) : L !== void 0 && (G[k] = L));
              return G;
            }, D.extend({ expando: "jQuery" + (fe + Math.random()).replace(/\D/g, ""), isReady: !0, error: function(h) {
              throw new Error(h);
            }, noop: function() {
            }, isPlainObject: function(h) {
              var k, O;
              return !(!h || T.call(h) !== "[object Object]" || (k = y(h)) && (typeof (O = z.call(k, "constructor") && k.constructor) != "function" || I.call(O) !== w));
            }, isEmptyObject: function(h) {
              var k;
              for (k in h) return !1;
              return !0;
            }, globalEval: function(h, k, O) {
              le(h, { nonce: k && k.nonce }, O);
            }, each: function(h, k) {
              var O, L = 0;
              if (j(h)) for (O = h.length; L < O && k.call(h[L], L, h[L]) !== !1; L++) ;
              else for (L in h) if (k.call(h[L], L, h[L]) === !1) break;
              return h;
            }, makeArray: function(h, k) {
              var O = k || [];
              return h != null && (j(Object(h)) ? D.merge(O, typeof h == "string" ? [h] : h) : E.call(O, h)), O;
            }, inArray: function(h, k, O) {
              return k == null ? -1 : b.call(k, h, O);
            }, merge: function(h, k) {
              for (var O = +k.length, L = 0, $ = h.length; L < O; L++) h[$++] = k[L];
              return h.length = $, h;
            }, grep: function(h, k, O) {
              for (var L = [], $ = 0, U = h.length, G = !O; $ < U; $++) !k(h[$], $) !== G && L.push(h[$]);
              return L;
            }, map: function(h, k, O) {
              var L, $, U = 0, G = [];
              if (j(h)) for (L = h.length; U < L; U++) ($ = k(h[U], U, O)) != null && G.push($);
              else for (U in h) ($ = k(h[U], U, O)) != null && G.push($);
              return x(G);
            }, guid: 1, support: M }), typeof Symbol == "function" && (D.fn[Symbol.iterator] = m[Symbol.iterator]), D.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(h, k) {
              C["[object " + k + "]"] = k.toLowerCase();
            });
            var de = function(h) {
              var k, O, L, $, U, G, ue, he, we, Fe, Re, De, je, Ct, Mt, kt, rr, Ir, po, En = "sizzle" + 1 * /* @__PURE__ */ new Date(), Ht = h.document, Hi = 0, fn = 0, ir = uh(), Nd = uh(), ah = uh(), fo = uh(), Vu = function(K, oe) {
                return K === oe && (Re = !0), 0;
              }, Zc = {}.hasOwnProperty, Vi = [], Gc = Vi.pop, Go = Vi.push, or = Vi.push, ho = Vi.slice, mo = function(K, oe) {
                for (var ve = 0, Pe = K.length; ve < Pe; ve++) if (K[ve] === oe) return ve;
                return -1;
              }, Xa = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", Dr = "[\\x20\\t\\r\\n\\f]", mn = "(?:\\\\[\\da-fA-F]{1,6}[\\x20\\t\\r\\n\\f]?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", Rr = "\\[[\\x20\\t\\r\\n\\f]*(" + mn + ")(?:" + Dr + "*([*^$|!~]?=)" + Dr + `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + mn + "))|)" + Dr + "*\\]", go = ":(" + mn + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + Rr + ")*)|.*)\\)|)", Ar = new RegExp(Dr + "+", "g"), vo = new RegExp("^[\\x20\\t\\r\\n\\f]+|((?:^|[^\\\\])(?:\\\\.)*)[\\x20\\t\\r\\n\\f]+$", "g"), Kc = new RegExp("^[\\x20\\t\\r\\n\\f]*,[\\x20\\t\\r\\n\\f]*"), sh = new RegExp("^[\\x20\\t\\r\\n\\f]*([>+~]|[\\x20\\t\\r\\n\\f])[\\x20\\t\\r\\n\\f]*"), ZB = new RegExp(Dr + "|>"), GB = new RegExp(go), KB = new RegExp("^" + mn + "$"), lh = { ID: new RegExp("^#(" + mn + ")"), CLASS: new RegExp("^\\.(" + mn + ")"), TAG: new RegExp("^(" + mn + "|[*])"), ATTR: new RegExp("^" + Rr), PSEUDO: new RegExp("^" + go), CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\([\\x20\\t\\r\\n\\f]*(even|odd|(([+-]|)(\\d*)n|)[\\x20\\t\\r\\n\\f]*(?:([+-]|)[\\x20\\t\\r\\n\\f]*(\\d+)|))[\\x20\\t\\r\\n\\f]*\\)|)", "i"), bool: new RegExp("^(?:" + Xa + ")$", "i"), needsContext: new RegExp("^[\\x20\\t\\r\\n\\f]*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\([\\x20\\t\\r\\n\\f]*((?:-\\d)?\\d*)[\\x20\\t\\r\\n\\f]*\\)|)(?=[^-]|$)", "i") }, XB = /HTML$/i, QB = /^(?:input|select|textarea|button)$/i, YB = /^h\d$/i, Od = /^[^{]+\{\s*\[native \w/, JB = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, M2 = /[+~]/, Os = new RegExp("\\\\[\\da-fA-F]{1,6}[\\x20\\t\\r\\n\\f]?|\\\\([^\\r\\n\\f])", "g"), zs = function(K, oe) {
                var ve = "0x" + K.slice(1) - 65536;
                return oe || (ve < 0 ? String.fromCharCode(ve + 65536) : String.fromCharCode(ve >> 10 | 55296, 1023 & ve | 56320));
              }, B8 = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, I8 = function(K, oe) {
                return oe ? K === "\0" ? "�" : K.slice(0, -1) + "\\" + K.charCodeAt(K.length - 1).toString(16) + " " : "\\" + K;
              }, R8 = function() {
                De();
              }, eI = dh(function(K) {
                return K.disabled === !0 && K.nodeName.toLowerCase() === "fieldset";
              }, { dir: "parentNode", next: "legend" });
              try {
                or.apply(Vi = ho.call(Ht.childNodes), Ht.childNodes), Vi[Ht.childNodes.length].nodeType;
              } catch {
                or = { apply: Vi.length ? function(K, oe) {
                  Go.apply(K, ho.call(oe));
                } : function(K, oe) {
                  for (var ve = K.length, Pe = 0; K[ve++] = oe[Pe++]; ) ;
                  K.length = ve - 1;
                } };
              }
              function An(K, oe, ve, Pe) {
                var be, qe, Ke, st, ft, Pt, _t, Bt = oe && oe.ownerDocument, sn = oe ? oe.nodeType : 9;
                if (ve = ve || [], typeof K != "string" || !K || sn !== 1 && sn !== 9 && sn !== 11) return ve;
                if (!Pe && (De(oe), oe = oe || je, Mt)) {
                  if (sn !== 11 && (ft = JB.exec(K))) if (be = ft[1]) {
                    if (sn === 9) {
                      if (!(Ke = oe.getElementById(be))) return ve;
                      if (Ke.id === be) return ve.push(Ke), ve;
                    } else if (Bt && (Ke = Bt.getElementById(be)) && po(oe, Ke) && Ke.id === be) return ve.push(Ke), ve;
                  } else {
                    if (ft[2]) return or.apply(ve, oe.getElementsByTagName(K)), ve;
                    if ((be = ft[3]) && O.getElementsByClassName && oe.getElementsByClassName) return or.apply(ve, oe.getElementsByClassName(be)), ve;
                  }
                  if (O.qsa && !fo[K + " "] && (!kt || !kt.test(K)) && (sn !== 1 || oe.nodeName.toLowerCase() !== "object")) {
                    if (_t = K, Bt = oe, sn === 1 && (ZB.test(K) || sh.test(K))) {
                      for ((Bt = M2.test(K) && I2(oe.parentNode) || oe) === oe && O.scope || ((st = oe.getAttribute("id")) ? st = st.replace(B8, I8) : oe.setAttribute("id", st = En)), qe = (Pt = G(K)).length; qe--; ) Pt[qe] = (st ? "#" + st : ":scope") + " " + ch(Pt[qe]);
                      _t = Pt.join(",");
                    }
                    try {
                      return or.apply(ve, Bt.querySelectorAll(_t)), ve;
                    } catch {
                      fo(K, !0);
                    } finally {
                      st === En && oe.removeAttribute("id");
                    }
                  }
                }
                return he(K.replace(vo, "$1"), oe, ve, Pe);
              }
              function uh() {
                var K = [];
                return function oe(ve, Pe) {
                  return K.push(ve + " ") > L.cacheLength && delete oe[K.shift()], oe[ve + " "] = Pe;
                };
              }
              function Sa(K) {
                return K[En] = !0, K;
              }
              function Da(K) {
                var oe = je.createElement("fieldset");
                try {
                  return !!K(oe);
                } catch {
                  return !1;
                } finally {
                  oe.parentNode && oe.parentNode.removeChild(oe), oe = null;
                }
              }
              function B2(K, oe) {
                for (var ve = K.split("|"), Pe = ve.length; Pe--; ) L.attrHandle[ve[Pe]] = oe;
              }
              function P8(K, oe) {
                var ve = oe && K, Pe = ve && K.nodeType === 1 && oe.nodeType === 1 && K.sourceIndex - oe.sourceIndex;
                if (Pe) return Pe;
                if (ve) {
                  for (; ve = ve.nextSibling; ) if (ve === oe) return -1;
                }
                return K ? 1 : -1;
              }
              function tI(K) {
                return function(oe) {
                  return oe.nodeName.toLowerCase() === "input" && oe.type === K;
                };
              }
              function nI(K) {
                return function(oe) {
                  var ve = oe.nodeName.toLowerCase();
                  return (ve === "input" || ve === "button") && oe.type === K;
                };
              }
              function _8(K) {
                return function(oe) {
                  return "form" in oe ? oe.parentNode && oe.disabled === !1 ? "label" in oe ? "label" in oe.parentNode ? oe.parentNode.disabled === K : oe.disabled === K : oe.isDisabled === K || oe.isDisabled !== !K && eI(oe) === K : oe.disabled === K : "label" in oe && oe.disabled === K;
                };
              }
              function Uu(K) {
                return Sa(function(oe) {
                  return oe = +oe, Sa(function(ve, Pe) {
                    for (var be, qe = K([], ve.length, oe), Ke = qe.length; Ke--; ) ve[be = qe[Ke]] && (ve[be] = !(Pe[be] = ve[be]));
                  });
                });
              }
              function I2(K) {
                return K && K.getElementsByTagName !== void 0 && K;
              }
              for (k in O = An.support = {}, U = An.isXML = function(K) {
                var oe = K && K.namespaceURI, ve = K && (K.ownerDocument || K).documentElement;
                return !XB.test(oe || ve && ve.nodeName || "HTML");
              }, De = An.setDocument = function(K) {
                var oe, ve, Pe = K ? K.ownerDocument || K : Ht;
                return Pe != je && Pe.nodeType === 9 && Pe.documentElement && (Ct = (je = Pe).documentElement, Mt = !U(je), Ht != je && (ve = je.defaultView) && ve.top !== ve && (ve.addEventListener ? ve.addEventListener("unload", R8, !1) : ve.attachEvent && ve.attachEvent("onunload", R8)), O.scope = Da(function(be) {
                  return Ct.appendChild(be).appendChild(je.createElement("div")), be.querySelectorAll !== void 0 && !be.querySelectorAll(":scope fieldset div").length;
                }), O.attributes = Da(function(be) {
                  return be.className = "i", !be.getAttribute("className");
                }), O.getElementsByTagName = Da(function(be) {
                  return be.appendChild(je.createComment("")), !be.getElementsByTagName("*").length;
                }), O.getElementsByClassName = Od.test(je.getElementsByClassName), O.getById = Da(function(be) {
                  return Ct.appendChild(be).id = En, !je.getElementsByName || !je.getElementsByName(En).length;
                }), O.getById ? (L.filter.ID = function(be) {
                  var qe = be.replace(Os, zs);
                  return function(Ke) {
                    return Ke.getAttribute("id") === qe;
                  };
                }, L.find.ID = function(be, qe) {
                  if (qe.getElementById !== void 0 && Mt) {
                    var Ke = qe.getElementById(be);
                    return Ke ? [Ke] : [];
                  }
                }) : (L.filter.ID = function(be) {
                  var qe = be.replace(Os, zs);
                  return function(Ke) {
                    var st = Ke.getAttributeNode !== void 0 && Ke.getAttributeNode("id");
                    return st && st.value === qe;
                  };
                }, L.find.ID = function(be, qe) {
                  if (qe.getElementById !== void 0 && Mt) {
                    var Ke, st, ft, Pt = qe.getElementById(be);
                    if (Pt) {
                      if ((Ke = Pt.getAttributeNode("id")) && Ke.value === be) return [Pt];
                      for (ft = qe.getElementsByName(be), st = 0; Pt = ft[st++]; ) if ((Ke = Pt.getAttributeNode("id")) && Ke.value === be) return [Pt];
                    }
                    return [];
                  }
                }), L.find.TAG = O.getElementsByTagName ? function(be, qe) {
                  return qe.getElementsByTagName !== void 0 ? qe.getElementsByTagName(be) : O.qsa ? qe.querySelectorAll(be) : void 0;
                } : function(be, qe) {
                  var Ke, st = [], ft = 0, Pt = qe.getElementsByTagName(be);
                  if (be === "*") {
                    for (; Ke = Pt[ft++]; ) Ke.nodeType === 1 && st.push(Ke);
                    return st;
                  }
                  return Pt;
                }, L.find.CLASS = O.getElementsByClassName && function(be, qe) {
                  if (qe.getElementsByClassName !== void 0 && Mt) return qe.getElementsByClassName(be);
                }, rr = [], kt = [], (O.qsa = Od.test(je.querySelectorAll)) && (Da(function(be) {
                  var qe;
                  Ct.appendChild(be).innerHTML = "<a id='" + En + "'></a><select id='" + En + "-\r\\' msallowcapture=''><option selected=''></option></select>", be.querySelectorAll("[msallowcapture^='']").length && kt.push(`[*^$]=[\\x20\\t\\r\\n\\f]*(?:''|"")`), be.querySelectorAll("[selected]").length || kt.push("\\[[\\x20\\t\\r\\n\\f]*(?:value|" + Xa + ")"), be.querySelectorAll("[id~=" + En + "-]").length || kt.push("~="), (qe = je.createElement("input")).setAttribute("name", ""), be.appendChild(qe), be.querySelectorAll("[name='']").length || kt.push(`\\[[\\x20\\t\\r\\n\\f]*name[\\x20\\t\\r\\n\\f]*=[\\x20\\t\\r\\n\\f]*(?:''|"")`), be.querySelectorAll(":checked").length || kt.push(":checked"), be.querySelectorAll("a#" + En + "+*").length || kt.push(".#.+[+~]"), be.querySelectorAll("\\\f"), kt.push("[\\r\\n\\f]");
                }), Da(function(be) {
                  be.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                  var qe = je.createElement("input");
                  qe.setAttribute("type", "hidden"), be.appendChild(qe).setAttribute("name", "D"), be.querySelectorAll("[name=d]").length && kt.push("name[\\x20\\t\\r\\n\\f]*[*^$|!~]?="), be.querySelectorAll(":enabled").length !== 2 && kt.push(":enabled", ":disabled"), Ct.appendChild(be).disabled = !0, be.querySelectorAll(":disabled").length !== 2 && kt.push(":enabled", ":disabled"), be.querySelectorAll("*,:x"), kt.push(",.*:");
                })), (O.matchesSelector = Od.test(Ir = Ct.matches || Ct.webkitMatchesSelector || Ct.mozMatchesSelector || Ct.oMatchesSelector || Ct.msMatchesSelector)) && Da(function(be) {
                  O.disconnectedMatch = Ir.call(be, "*"), Ir.call(be, "[s!='']:x"), rr.push("!=", go);
                }), kt = kt.length && new RegExp(kt.join("|")), rr = rr.length && new RegExp(rr.join("|")), oe = Od.test(Ct.compareDocumentPosition), po = oe || Od.test(Ct.contains) ? function(be, qe) {
                  var Ke = be.nodeType === 9 ? be.documentElement : be, st = qe && qe.parentNode;
                  return be === st || !(!st || st.nodeType !== 1 || !(Ke.contains ? Ke.contains(st) : be.compareDocumentPosition && 16 & be.compareDocumentPosition(st)));
                } : function(be, qe) {
                  if (qe) {
                    for (; qe = qe.parentNode; ) if (qe === be) return !0;
                  }
                  return !1;
                }, Vu = oe ? function(be, qe) {
                  if (be === qe) return Re = !0, 0;
                  var Ke = !be.compareDocumentPosition - !qe.compareDocumentPosition;
                  return Ke || (1 & (Ke = (be.ownerDocument || be) == (qe.ownerDocument || qe) ? be.compareDocumentPosition(qe) : 1) || !O.sortDetached && qe.compareDocumentPosition(be) === Ke ? be == je || be.ownerDocument == Ht && po(Ht, be) ? -1 : qe == je || qe.ownerDocument == Ht && po(Ht, qe) ? 1 : Fe ? mo(Fe, be) - mo(Fe, qe) : 0 : 4 & Ke ? -1 : 1);
                } : function(be, qe) {
                  if (be === qe) return Re = !0, 0;
                  var Ke, st = 0, ft = be.parentNode, Pt = qe.parentNode, _t = [be], Bt = [qe];
                  if (!ft || !Pt) return be == je ? -1 : qe == je ? 1 : ft ? -1 : Pt ? 1 : Fe ? mo(Fe, be) - mo(Fe, qe) : 0;
                  if (ft === Pt) return P8(be, qe);
                  for (Ke = be; Ke = Ke.parentNode; ) _t.unshift(Ke);
                  for (Ke = qe; Ke = Ke.parentNode; ) Bt.unshift(Ke);
                  for (; _t[st] === Bt[st]; ) st++;
                  return st ? P8(_t[st], Bt[st]) : _t[st] == Ht ? -1 : Bt[st] == Ht ? 1 : 0;
                }), je;
              }, An.matches = function(K, oe) {
                return An(K, null, null, oe);
              }, An.matchesSelector = function(K, oe) {
                if (De(K), O.matchesSelector && Mt && !fo[oe + " "] && (!rr || !rr.test(oe)) && (!kt || !kt.test(oe))) try {
                  var ve = Ir.call(K, oe);
                  if (ve || O.disconnectedMatch || K.document && K.document.nodeType !== 11) return ve;
                } catch {
                  fo(oe, !0);
                }
                return An(oe, je, null, [K]).length > 0;
              }, An.contains = function(K, oe) {
                return (K.ownerDocument || K) != je && De(K), po(K, oe);
              }, An.attr = function(K, oe) {
                (K.ownerDocument || K) != je && De(K);
                var ve = L.attrHandle[oe.toLowerCase()], Pe = ve && Zc.call(L.attrHandle, oe.toLowerCase()) ? ve(K, oe, !Mt) : void 0;
                return Pe !== void 0 ? Pe : O.attributes || !Mt ? K.getAttribute(oe) : (Pe = K.getAttributeNode(oe)) && Pe.specified ? Pe.value : null;
              }, An.escape = function(K) {
                return (K + "").replace(B8, I8);
              }, An.error = function(K) {
                throw new Error("Syntax error, unrecognized expression: " + K);
              }, An.uniqueSort = function(K) {
                var oe, ve = [], Pe = 0, be = 0;
                if (Re = !O.detectDuplicates, Fe = !O.sortStable && K.slice(0), K.sort(Vu), Re) {
                  for (; oe = K[be++]; ) oe === K[be] && (Pe = ve.push(be));
                  for (; Pe--; ) K.splice(ve[Pe], 1);
                }
                return Fe = null, K;
              }, $ = An.getText = function(K) {
                var oe, ve = "", Pe = 0, be = K.nodeType;
                if (be) {
                  if (be === 1 || be === 9 || be === 11) {
                    if (typeof K.textContent == "string") return K.textContent;
                    for (K = K.firstChild; K; K = K.nextSibling) ve += $(K);
                  } else if (be === 3 || be === 4) return K.nodeValue;
                } else for (; oe = K[Pe++]; ) ve += $(oe);
                return ve;
              }, L = An.selectors = { cacheLength: 50, createPseudo: Sa, match: lh, attrHandle: {}, find: {}, relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } }, preFilter: { ATTR: function(K) {
                return K[1] = K[1].replace(Os, zs), K[3] = (K[3] || K[4] || K[5] || "").replace(Os, zs), K[2] === "~=" && (K[3] = " " + K[3] + " "), K.slice(0, 4);
              }, CHILD: function(K) {
                return K[1] = K[1].toLowerCase(), K[1].slice(0, 3) === "nth" ? (K[3] || An.error(K[0]), K[4] = +(K[4] ? K[5] + (K[6] || 1) : 2 * (K[3] === "even" || K[3] === "odd")), K[5] = +(K[7] + K[8] || K[3] === "odd")) : K[3] && An.error(K[0]), K;
              }, PSEUDO: function(K) {
                var oe, ve = !K[6] && K[2];
                return lh.CHILD.test(K[0]) ? null : (K[3] ? K[2] = K[4] || K[5] || "" : ve && GB.test(ve) && (oe = G(ve, !0)) && (oe = ve.indexOf(")", ve.length - oe) - ve.length) && (K[0] = K[0].slice(0, oe), K[2] = ve.slice(0, oe)), K.slice(0, 3));
              } }, filter: { TAG: function(K) {
                var oe = K.replace(Os, zs).toLowerCase();
                return K === "*" ? function() {
                  return !0;
                } : function(ve) {
                  return ve.nodeName && ve.nodeName.toLowerCase() === oe;
                };
              }, CLASS: function(K) {
                var oe = ir[K + " "];
                return oe || (oe = new RegExp("(^|[\\x20\\t\\r\\n\\f])" + K + "(" + Dr + "|$)")) && ir(K, function(ve) {
                  return oe.test(typeof ve.className == "string" && ve.className || ve.getAttribute !== void 0 && ve.getAttribute("class") || "");
                });
              }, ATTR: function(K, oe, ve) {
                return function(Pe) {
                  var be = An.attr(Pe, K);
                  return be == null ? oe === "!=" : !oe || (be += "", oe === "=" ? be === ve : oe === "!=" ? be !== ve : oe === "^=" ? ve && be.indexOf(ve) === 0 : oe === "*=" ? ve && be.indexOf(ve) > -1 : oe === "$=" ? ve && be.slice(-ve.length) === ve : oe === "~=" ? (" " + be.replace(Ar, " ") + " ").indexOf(ve) > -1 : oe === "|=" && (be === ve || be.slice(0, ve.length + 1) === ve + "-"));
                };
              }, CHILD: function(K, oe, ve, Pe, be) {
                var qe = K.slice(0, 3) !== "nth", Ke = K.slice(-4) !== "last", st = oe === "of-type";
                return Pe === 1 && be === 0 ? function(ft) {
                  return !!ft.parentNode;
                } : function(ft, Pt, _t) {
                  var Bt, sn, Tr, Zt, Pr, Wr, Ei = qe !== Ke ? "nextSibling" : "previousSibling", Tn = ft.parentNode, Qa = st && ft.nodeName.toLowerCase(), di = !_t && !st, jr = !1;
                  if (Tn) {
                    if (qe) {
                      for (; Ei; ) {
                        for (Zt = ft; Zt = Zt[Ei]; ) if (st ? Zt.nodeName.toLowerCase() === Qa : Zt.nodeType === 1) return !1;
                        Wr = Ei = K === "only" && !Wr && "nextSibling";
                      }
                      return !0;
                    }
                    if (Wr = [Ke ? Tn.firstChild : Tn.lastChild], Ke && di) {
                      for (jr = (Pr = (Bt = (sn = (Tr = (Zt = Tn)[En] || (Zt[En] = {}))[Zt.uniqueID] || (Tr[Zt.uniqueID] = {}))[K] || [])[0] === Hi && Bt[1]) && Bt[2], Zt = Pr && Tn.childNodes[Pr]; Zt = ++Pr && Zt && Zt[Ei] || (jr = Pr = 0) || Wr.pop(); ) if (Zt.nodeType === 1 && ++jr && Zt === ft) {
                        sn[K] = [Hi, Pr, jr];
                        break;
                      }
                    } else if (di && (jr = Pr = (Bt = (sn = (Tr = (Zt = ft)[En] || (Zt[En] = {}))[Zt.uniqueID] || (Tr[Zt.uniqueID] = {}))[K] || [])[0] === Hi && Bt[1]), jr === !1) for (; (Zt = ++Pr && Zt && Zt[Ei] || (jr = Pr = 0) || Wr.pop()) && ((st ? Zt.nodeName.toLowerCase() !== Qa : Zt.nodeType !== 1) || !++jr || (di && ((sn = (Tr = Zt[En] || (Zt[En] = {}))[Zt.uniqueID] || (Tr[Zt.uniqueID] = {}))[K] = [Hi, jr]), Zt !== ft)); ) ;
                    return (jr -= be) === Pe || jr % Pe == 0 && jr / Pe >= 0;
                  }
                };
              }, PSEUDO: function(K, oe) {
                var ve, Pe = L.pseudos[K] || L.setFilters[K.toLowerCase()] || An.error("unsupported pseudo: " + K);
                return Pe[En] ? Pe(oe) : Pe.length > 1 ? (ve = [K, K, "", oe], L.setFilters.hasOwnProperty(K.toLowerCase()) ? Sa(function(be, qe) {
                  for (var Ke, st = Pe(be, oe), ft = st.length; ft--; ) be[Ke = mo(be, st[ft])] = !(qe[Ke] = st[ft]);
                }) : function(be) {
                  return Pe(be, 0, ve);
                }) : Pe;
              } }, pseudos: { not: Sa(function(K) {
                var oe = [], ve = [], Pe = ue(K.replace(vo, "$1"));
                return Pe[En] ? Sa(function(be, qe, Ke, st) {
                  for (var ft, Pt = Pe(be, null, st, []), _t = be.length; _t--; ) (ft = Pt[_t]) && (be[_t] = !(qe[_t] = ft));
                }) : function(be, qe, Ke) {
                  return oe[0] = be, Pe(oe, null, Ke, ve), oe[0] = null, !ve.pop();
                };
              }), has: Sa(function(K) {
                return function(oe) {
                  return An(K, oe).length > 0;
                };
              }), contains: Sa(function(K) {
                return K = K.replace(Os, zs), function(oe) {
                  return (oe.textContent || $(oe)).indexOf(K) > -1;
                };
              }), lang: Sa(function(K) {
                return KB.test(K || "") || An.error("unsupported lang: " + K), K = K.replace(Os, zs).toLowerCase(), function(oe) {
                  var ve;
                  do
                    if (ve = Mt ? oe.lang : oe.getAttribute("xml:lang") || oe.getAttribute("lang")) return (ve = ve.toLowerCase()) === K || ve.indexOf(K + "-") === 0;
                  while ((oe = oe.parentNode) && oe.nodeType === 1);
                  return !1;
                };
              }), target: function(K) {
                var oe = h.location && h.location.hash;
                return oe && oe.slice(1) === K.id;
              }, root: function(K) {
                return K === Ct;
              }, focus: function(K) {
                return K === je.activeElement && (!je.hasFocus || je.hasFocus()) && !!(K.type || K.href || ~K.tabIndex);
              }, enabled: _8(!1), disabled: _8(!0), checked: function(K) {
                var oe = K.nodeName.toLowerCase();
                return oe === "input" && !!K.checked || oe === "option" && !!K.selected;
              }, selected: function(K) {
                return K.parentNode && K.parentNode.selectedIndex, K.selected === !0;
              }, empty: function(K) {
                for (K = K.firstChild; K; K = K.nextSibling) if (K.nodeType < 6) return !1;
                return !0;
              }, parent: function(K) {
                return !L.pseudos.empty(K);
              }, header: function(K) {
                return YB.test(K.nodeName);
              }, input: function(K) {
                return QB.test(K.nodeName);
              }, button: function(K) {
                var oe = K.nodeName.toLowerCase();
                return oe === "input" && K.type === "button" || oe === "button";
              }, text: function(K) {
                var oe;
                return K.nodeName.toLowerCase() === "input" && K.type === "text" && ((oe = K.getAttribute("type")) == null || oe.toLowerCase() === "text");
              }, first: Uu(function() {
                return [0];
              }), last: Uu(function(K, oe) {
                return [oe - 1];
              }), eq: Uu(function(K, oe, ve) {
                return [ve < 0 ? ve + oe : ve];
              }), even: Uu(function(K, oe) {
                for (var ve = 0; ve < oe; ve += 2) K.push(ve);
                return K;
              }), odd: Uu(function(K, oe) {
                for (var ve = 1; ve < oe; ve += 2) K.push(ve);
                return K;
              }), lt: Uu(function(K, oe, ve) {
                for (var Pe = ve < 0 ? ve + oe : ve > oe ? oe : ve; --Pe >= 0; ) K.push(Pe);
                return K;
              }), gt: Uu(function(K, oe, ve) {
                for (var Pe = ve < 0 ? ve + oe : ve; ++Pe < oe; ) K.push(Pe);
                return K;
              }) } }, L.pseudos.nth = L.pseudos.eq, { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) L.pseudos[k] = tI(k);
              for (k in { submit: !0, reset: !0 }) L.pseudos[k] = nI(k);
              function q8() {
              }
              function ch(K) {
                for (var oe = 0, ve = K.length, Pe = ""; oe < ve; oe++) Pe += K[oe].value;
                return Pe;
              }
              function dh(K, oe, ve) {
                var Pe = oe.dir, be = oe.next, qe = be || Pe, Ke = ve && qe === "parentNode", st = fn++;
                return oe.first ? function(ft, Pt, _t) {
                  for (; ft = ft[Pe]; ) if (ft.nodeType === 1 || Ke) return K(ft, Pt, _t);
                  return !1;
                } : function(ft, Pt, _t) {
                  var Bt, sn, Tr, Zt = [Hi, st];
                  if (_t) {
                    for (; ft = ft[Pe]; ) if ((ft.nodeType === 1 || Ke) && K(ft, Pt, _t)) return !0;
                  } else for (; ft = ft[Pe]; ) if (ft.nodeType === 1 || Ke) if (sn = (Tr = ft[En] || (ft[En] = {}))[ft.uniqueID] || (Tr[ft.uniqueID] = {}), be && be === ft.nodeName.toLowerCase()) ft = ft[Pe] || ft;
                  else {
                    if ((Bt = sn[qe]) && Bt[0] === Hi && Bt[1] === st) return Zt[2] = Bt[2];
                    if (sn[qe] = Zt, Zt[2] = K(ft, Pt, _t)) return !0;
                  }
                  return !1;
                };
              }
              function R2(K) {
                return K.length > 1 ? function(oe, ve, Pe) {
                  for (var be = K.length; be--; ) if (!K[be](oe, ve, Pe)) return !1;
                  return !0;
                } : K[0];
              }
              function ph(K, oe, ve, Pe, be) {
                for (var qe, Ke = [], st = 0, ft = K.length, Pt = oe != null; st < ft; st++) (qe = K[st]) && (ve && !ve(qe, Pe, be) || (Ke.push(qe), Pt && oe.push(st)));
                return Ke;
              }
              function P2(K, oe, ve, Pe, be, qe) {
                return Pe && !Pe[En] && (Pe = P2(Pe)), be && !be[En] && (be = P2(be, qe)), Sa(function(Ke, st, ft, Pt) {
                  var _t, Bt, sn, Tr = [], Zt = [], Pr = st.length, Wr = Ke || function(Qa, di, jr) {
                    for (var Aa = 0, fh = di.length; Aa < fh; Aa++) An(Qa, di[Aa], jr);
                    return jr;
                  }(oe || "*", ft.nodeType ? [ft] : ft, []), Ei = !K || !Ke && oe ? Wr : ph(Wr, Tr, K, ft, Pt), Tn = ve ? be || (Ke ? K : Pr || Pe) ? [] : st : Ei;
                  if (ve && ve(Ei, Tn, ft, Pt), Pe) for (_t = ph(Tn, Zt), Pe(_t, [], ft, Pt), Bt = _t.length; Bt--; ) (sn = _t[Bt]) && (Tn[Zt[Bt]] = !(Ei[Zt[Bt]] = sn));
                  if (Ke) {
                    if (be || K) {
                      if (be) {
                        for (_t = [], Bt = Tn.length; Bt--; ) (sn = Tn[Bt]) && _t.push(Ei[Bt] = sn);
                        be(null, Tn = [], _t, Pt);
                      }
                      for (Bt = Tn.length; Bt--; ) (sn = Tn[Bt]) && (_t = be ? mo(Ke, sn) : Tr[Bt]) > -1 && (Ke[_t] = !(st[_t] = sn));
                    }
                  } else Tn = ph(Tn === st ? Tn.splice(Pr, Tn.length) : Tn), be ? be(null, st, Tn, Pt) : or.apply(st, Tn);
                });
              }
              function _2(K) {
                for (var oe, ve, Pe, be = K.length, qe = L.relative[K[0].type], Ke = qe || L.relative[" "], st = qe ? 1 : 0, ft = dh(function(Bt) {
                  return Bt === oe;
                }, Ke, !0), Pt = dh(function(Bt) {
                  return mo(oe, Bt) > -1;
                }, Ke, !0), _t = [function(Bt, sn, Tr) {
                  var Zt = !qe && (Tr || sn !== we) || ((oe = sn).nodeType ? ft(Bt, sn, Tr) : Pt(Bt, sn, Tr));
                  return oe = null, Zt;
                }]; st < be; st++) if (ve = L.relative[K[st].type]) _t = [dh(R2(_t), ve)];
                else {
                  if ((ve = L.filter[K[st].type].apply(null, K[st].matches))[En]) {
                    for (Pe = ++st; Pe < be && !L.relative[K[Pe].type]; Pe++) ;
                    return P2(st > 1 && R2(_t), st > 1 && ch(K.slice(0, st - 1).concat({ value: K[st - 2].type === " " ? "*" : "" })).replace(vo, "$1"), ve, st < Pe && _2(K.slice(st, Pe)), Pe < be && _2(K = K.slice(Pe)), Pe < be && ch(K));
                  }
                  _t.push(ve);
                }
                return R2(_t);
              }
              return q8.prototype = L.filters = L.pseudos, L.setFilters = new q8(), G = An.tokenize = function(K, oe) {
                var ve, Pe, be, qe, Ke, st, ft, Pt = Nd[K + " "];
                if (Pt) return oe ? 0 : Pt.slice(0);
                for (Ke = K, st = [], ft = L.preFilter; Ke; ) {
                  for (qe in ve && !(Pe = Kc.exec(Ke)) || (Pe && (Ke = Ke.slice(Pe[0].length) || Ke), st.push(be = [])), ve = !1, (Pe = sh.exec(Ke)) && (ve = Pe.shift(), be.push({ value: ve, type: Pe[0].replace(vo, " ") }), Ke = Ke.slice(ve.length)), L.filter) !(Pe = lh[qe].exec(Ke)) || ft[qe] && !(Pe = ft[qe](Pe)) || (ve = Pe.shift(), be.push({ value: ve, type: qe, matches: Pe }), Ke = Ke.slice(ve.length));
                  if (!ve) break;
                }
                return oe ? Ke.length : Ke ? An.error(K) : Nd(K, st).slice(0);
              }, ue = An.compile = function(K, oe) {
                var ve, Pe = [], be = [], qe = ah[K + " "];
                if (!qe) {
                  for (oe || (oe = G(K)), ve = oe.length; ve--; ) (qe = _2(oe[ve]))[En] ? Pe.push(qe) : be.push(qe);
                  qe = ah(K, function(Ke, st) {
                    var ft = st.length > 0, Pt = Ke.length > 0, _t = function(Bt, sn, Tr, Zt, Pr) {
                      var Wr, Ei, Tn, Qa = 0, di = "0", jr = Bt && [], Aa = [], fh = we, $8 = Bt || Pt && L.find.TAG("*", Pr), H8 = Hi += fh == null ? 1 : Math.random() || 0.1, rI = $8.length;
                      for (Pr && (we = sn == je || sn || Pr); di !== rI && (Wr = $8[di]) != null; di++) {
                        if (Pt && Wr) {
                          for (Ei = 0, sn || Wr.ownerDocument == je || (De(Wr), Tr = !Mt); Tn = Ke[Ei++]; ) if (Tn(Wr, sn || je, Tr)) {
                            Zt.push(Wr);
                            break;
                          }
                          Pr && (Hi = H8);
                        }
                        ft && ((Wr = !Tn && Wr) && Qa--, Bt && jr.push(Wr));
                      }
                      if (Qa += di, ft && di !== Qa) {
                        for (Ei = 0; Tn = st[Ei++]; ) Tn(jr, Aa, sn, Tr);
                        if (Bt) {
                          if (Qa > 0) for (; di--; ) jr[di] || Aa[di] || (Aa[di] = Gc.call(Zt));
                          Aa = ph(Aa);
                        }
                        or.apply(Zt, Aa), Pr && !Bt && Aa.length > 0 && Qa + st.length > 1 && An.uniqueSort(Zt);
                      }
                      return Pr && (Hi = H8, we = fh), jr;
                    };
                    return ft ? Sa(_t) : _t;
                  }(be, Pe)), qe.selector = K;
                }
                return qe;
              }, he = An.select = function(K, oe, ve, Pe) {
                var be, qe, Ke, st, ft, Pt = typeof K == "function" && K, _t = !Pe && G(K = Pt.selector || K);
                if (ve = ve || [], _t.length === 1) {
                  if ((qe = _t[0] = _t[0].slice(0)).length > 2 && (Ke = qe[0]).type === "ID" && oe.nodeType === 9 && Mt && L.relative[qe[1].type]) {
                    if (!(oe = (L.find.ID(Ke.matches[0].replace(Os, zs), oe) || [])[0])) return ve;
                    Pt && (oe = oe.parentNode), K = K.slice(qe.shift().value.length);
                  }
                  for (be = lh.needsContext.test(K) ? 0 : qe.length; be-- && (Ke = qe[be], !L.relative[st = Ke.type]); ) if ((ft = L.find[st]) && (Pe = ft(Ke.matches[0].replace(Os, zs), M2.test(qe[0].type) && I2(oe.parentNode) || oe))) {
                    if (qe.splice(be, 1), !(K = Pe.length && ch(qe))) return or.apply(ve, Pe), ve;
                    break;
                  }
                }
                return (Pt || ue(K, _t))(Pe, oe, !Mt, ve, !oe || M2.test(K) && I2(oe.parentNode) || oe), ve;
              }, O.sortStable = En.split("").sort(Vu).join("") === En, O.detectDuplicates = !!Re, De(), O.sortDetached = Da(function(K) {
                return 1 & K.compareDocumentPosition(je.createElement("fieldset"));
              }), Da(function(K) {
                return K.innerHTML = "<a href='#'></a>", K.firstChild.getAttribute("href") === "#";
              }) || B2("type|href|height|width", function(K, oe, ve) {
                if (!ve) return K.getAttribute(oe, oe.toLowerCase() === "type" ? 1 : 2);
              }), O.attributes && Da(function(K) {
                return K.innerHTML = "<input/>", K.firstChild.setAttribute("value", ""), K.firstChild.getAttribute("value") === "";
              }) || B2("value", function(K, oe, ve) {
                if (!ve && K.nodeName.toLowerCase() === "input") return K.defaultValue;
              }), Da(function(K) {
                return K.getAttribute("disabled") == null;
              }) || B2(Xa, function(K, oe, ve) {
                var Pe;
                if (!ve) return K[oe] === !0 ? oe.toLowerCase() : (Pe = K.getAttributeNode(oe)) && Pe.specified ? Pe.value : null;
              }), An;
            }(p);
            D.find = de, D.expr = de.selectors, D.expr[":"] = D.expr.pseudos, D.uniqueSort = D.unique = de.uniqueSort, D.text = de.getText, D.isXMLDoc = de.isXML, D.contains = de.contains, D.escapeSelector = de.escape;
            var ye = function(h, k, O) {
              for (var L = [], $ = O !== void 0; (h = h[k]) && h.nodeType !== 9; ) if (h.nodeType === 1) {
                if ($ && D(h).is(O)) break;
                L.push(h);
              }
              return L;
            }, Ne = function(h, k) {
              for (var O = []; h; h = h.nextSibling) h.nodeType === 1 && h !== k && O.push(h);
              return O;
            }, Me = D.expr.match.needsContext;
            function Ie(h, k) {
              return h.nodeName && h.nodeName.toLowerCase() === k.toLowerCase();
            }
            var at = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
            function Ve(h, k, O) {
              return R(k) ? D.grep(h, function(L, $) {
                return !!k.call(L, $, L) !== O;
              }) : k.nodeType ? D.grep(h, function(L) {
                return L === k !== O;
              }) : typeof k != "string" ? D.grep(h, function(L) {
                return b.call(k, L) > -1 !== O;
              }) : D.filter(k, h, O);
            }
            D.filter = function(h, k, O) {
              var L = k[0];
              return O && (h = ":not(" + h + ")"), k.length === 1 && L.nodeType === 1 ? D.find.matchesSelector(L, h) ? [L] : [] : D.find.matches(h, D.grep(k, function($) {
                return $.nodeType === 1;
              }));
            }, D.fn.extend({ find: function(h) {
              var k, O, L = this.length, $ = this;
              if (typeof h != "string") return this.pushStack(D(h).filter(function() {
                for (k = 0; k < L; k++) if (D.contains($[k], this)) return !0;
              }));
              for (O = this.pushStack([]), k = 0; k < L; k++) D.find(h, $[k], O);
              return L > 1 ? D.uniqueSort(O) : O;
            }, filter: function(h) {
              return this.pushStack(Ve(this, h || [], !1));
            }, not: function(h) {
              return this.pushStack(Ve(this, h || [], !0));
            }, is: function(h) {
              return !!Ve(this, typeof h == "string" && Me.test(h) ? D(h) : h || [], !1).length;
            } });
            var mt, ae = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
            (D.fn.init = function(h, k, O) {
              var L, $;
              if (!h) return this;
              if (O = O || mt, typeof h == "string") {
                if (!(L = h[0] === "<" && h[h.length - 1] === ">" && h.length >= 3 ? [null, h, null] : ae.exec(h)) || !L[1] && k) return !k || k.jquery ? (k || O).find(h) : this.constructor(k).find(h);
                if (L[1]) {
                  if (k = k instanceof D ? k[0] : k, D.merge(this, D.parseHTML(L[1], k && k.nodeType ? k.ownerDocument || k : W, !0)), at.test(L[1]) && D.isPlainObject(k)) for (L in k) R(this[L]) ? this[L](k[L]) : this.attr(L, k[L]);
                  return this;
                }
                return ($ = W.getElementById(L[2])) && (this[0] = $, this.length = 1), this;
              }
              return h.nodeType ? (this[0] = h, this.length = 1, this) : R(h) ? O.ready !== void 0 ? O.ready(h) : h(D) : D.makeArray(h, this);
            }).prototype = D.fn, mt = D(W);
            var Se = /^(?:parents|prev(?:Until|All))/, Ae = { children: !0, contents: !0, next: !0, prev: !0 };
            function Be(h, k) {
              for (; (h = h[k]) && h.nodeType !== 1; ) ;
              return h;
            }
            D.fn.extend({ has: function(h) {
              var k = D(h, this), O = k.length;
              return this.filter(function() {
                for (var L = 0; L < O; L++) if (D.contains(this, k[L])) return !0;
              });
            }, closest: function(h, k) {
              var O, L = 0, $ = this.length, U = [], G = typeof h != "string" && D(h);
              if (!Me.test(h)) {
                for (; L < $; L++) for (O = this[L]; O && O !== k; O = O.parentNode) if (O.nodeType < 11 && (G ? G.index(O) > -1 : O.nodeType === 1 && D.find.matchesSelector(O, h))) {
                  U.push(O);
                  break;
                }
              }
              return this.pushStack(U.length > 1 ? D.uniqueSort(U) : U);
            }, index: function(h) {
              return h ? typeof h == "string" ? b.call(D(h), this[0]) : b.call(this, h.jquery ? h[0] : h) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            }, add: function(h, k) {
              return this.pushStack(D.uniqueSort(D.merge(this.get(), D(h, k))));
            }, addBack: function(h) {
              return this.add(h == null ? this.prevObject : this.prevObject.filter(h));
            } }), D.each({ parent: function(h) {
              var k = h.parentNode;
              return k && k.nodeType !== 11 ? k : null;
            }, parents: function(h) {
              return ye(h, "parentNode");
            }, parentsUntil: function(h, k, O) {
              return ye(h, "parentNode", O);
            }, next: function(h) {
              return Be(h, "nextSibling");
            }, prev: function(h) {
              return Be(h, "previousSibling");
            }, nextAll: function(h) {
              return ye(h, "nextSibling");
            }, prevAll: function(h) {
              return ye(h, "previousSibling");
            }, nextUntil: function(h, k, O) {
              return ye(h, "nextSibling", O);
            }, prevUntil: function(h, k, O) {
              return ye(h, "previousSibling", O);
            }, siblings: function(h) {
              return Ne((h.parentNode || {}).firstChild, h);
            }, children: function(h) {
              return Ne(h.firstChild);
            }, contents: function(h) {
              return h.contentDocument != null && y(h.contentDocument) ? h.contentDocument : (Ie(h, "template") && (h = h.content || h), D.merge([], h.childNodes));
            } }, function(h, k) {
              D.fn[h] = function(O, L) {
                var $ = D.map(this, k, O);
                return h.slice(-5) !== "Until" && (L = O), L && typeof L == "string" && ($ = D.filter(L, $)), this.length > 1 && (Ae[h] || D.uniqueSort($), Se.test(h) && $.reverse()), this.pushStack($);
              };
            });
            var Ze = /[^\x20\t\r\n\f]+/g;
            function We(h) {
              return h;
            }
            function St(h) {
              throw h;
            }
            function pt(h, k, O, L) {
              var $;
              try {
                h && R($ = h.promise) ? $.call(h).done(k).fail(O) : h && R($ = h.then) ? $.call(h, k, O) : k.apply(void 0, [h].slice(L));
              } catch (U) {
                O.apply(void 0, [U]);
              }
            }
            D.Callbacks = function(h) {
              h = typeof h == "string" ? function(Fe) {
                var Re = {};
                return D.each(Fe.match(Ze) || [], function(De, je) {
                  Re[je] = !0;
                }), Re;
              }(h) : D.extend({}, h);
              var k, O, L, $, U = [], G = [], ue = -1, he = function() {
                for ($ = $ || h.once, L = k = !0; G.length; ue = -1) for (O = G.shift(); ++ue < U.length; ) U[ue].apply(O[0], O[1]) === !1 && h.stopOnFalse && (ue = U.length, O = !1);
                h.memory || (O = !1), k = !1, $ && (U = O ? [] : "");
              }, we = { add: function() {
                return U && (O && !k && (ue = U.length - 1, G.push(O)), function Fe(Re) {
                  D.each(Re, function(De, je) {
                    R(je) ? h.unique && we.has(je) || U.push(je) : je && je.length && ne(je) !== "string" && Fe(je);
                  });
                }(arguments), O && !k && he()), this;
              }, remove: function() {
                return D.each(arguments, function(Fe, Re) {
                  for (var De; (De = D.inArray(Re, U, De)) > -1; ) U.splice(De, 1), De <= ue && ue--;
                }), this;
              }, has: function(Fe) {
                return Fe ? D.inArray(Fe, U) > -1 : U.length > 0;
              }, empty: function() {
                return U && (U = []), this;
              }, disable: function() {
                return $ = G = [], U = O = "", this;
              }, disabled: function() {
                return !U;
              }, lock: function() {
                return $ = G = [], O || k || (U = O = ""), this;
              }, locked: function() {
                return !!$;
              }, fireWith: function(Fe, Re) {
                return $ || (Re = [Fe, (Re = Re || []).slice ? Re.slice() : Re], G.push(Re), k || he()), this;
              }, fire: function() {
                return we.fireWith(this, arguments), this;
              }, fired: function() {
                return !!L;
              } };
              return we;
            }, D.extend({ Deferred: function(h) {
              var k = [["notify", "progress", D.Callbacks("memory"), D.Callbacks("memory"), 2], ["resolve", "done", D.Callbacks("once memory"), D.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", D.Callbacks("once memory"), D.Callbacks("once memory"), 1, "rejected"]], O = "pending", L = { state: function() {
                return O;
              }, always: function() {
                return $.done(arguments).fail(arguments), this;
              }, catch: function(U) {
                return L.then(null, U);
              }, pipe: function() {
                var U = arguments;
                return D.Deferred(function(G) {
                  D.each(k, function(ue, he) {
                    var we = R(U[he[4]]) && U[he[4]];
                    $[he[1]](function() {
                      var Fe = we && we.apply(this, arguments);
                      Fe && R(Fe.promise) ? Fe.promise().progress(G.notify).done(G.resolve).fail(G.reject) : G[he[0] + "With"](this, we ? [Fe] : arguments);
                    });
                  }), U = null;
                }).promise();
              }, then: function(U, G, ue) {
                var he = 0;
                function we(Fe, Re, De, je) {
                  return function() {
                    var Ct = this, Mt = arguments, kt = function() {
                      var Ir, po;
                      if (!(Fe < he)) {
                        if ((Ir = De.apply(Ct, Mt)) === Re.promise()) throw new TypeError("Thenable self-resolution");
                        po = Ir && (typeof Ir == "object" || typeof Ir == "function") && Ir.then, R(po) ? je ? po.call(Ir, we(he, Re, We, je), we(he, Re, St, je)) : (he++, po.call(Ir, we(he, Re, We, je), we(he, Re, St, je), we(he, Re, We, Re.notifyWith))) : (De !== We && (Ct = void 0, Mt = [Ir]), (je || Re.resolveWith)(Ct, Mt));
                      }
                    }, rr = je ? kt : function() {
                      try {
                        kt();
                      } catch (Ir) {
                        D.Deferred.exceptionHook && D.Deferred.exceptionHook(Ir, rr.stackTrace), Fe + 1 >= he && (De !== St && (Ct = void 0, Mt = [Ir]), Re.rejectWith(Ct, Mt));
                      }
                    };
                    Fe ? rr() : (D.Deferred.getStackHook && (rr.stackTrace = D.Deferred.getStackHook()), p.setTimeout(rr));
                  };
                }
                return D.Deferred(function(Fe) {
                  k[0][3].add(we(0, Fe, R(ue) ? ue : We, Fe.notifyWith)), k[1][3].add(we(0, Fe, R(U) ? U : We)), k[2][3].add(we(0, Fe, R(G) ? G : St));
                }).promise();
              }, promise: function(U) {
                return U != null ? D.extend(U, L) : L;
              } }, $ = {};
              return D.each(k, function(U, G) {
                var ue = G[2], he = G[5];
                L[G[1]] = ue.add, he && ue.add(function() {
                  O = he;
                }, k[3 - U][2].disable, k[3 - U][3].disable, k[0][2].lock, k[0][3].lock), ue.add(G[3].fire), $[G[0]] = function() {
                  return $[G[0] + "With"](this === $ ? void 0 : this, arguments), this;
                }, $[G[0] + "With"] = ue.fireWith;
              }), L.promise($), h && h.call($, $), $;
            }, when: function(h) {
              var k = arguments.length, O = k, L = Array(O), $ = g.call(arguments), U = D.Deferred(), G = function(ue) {
                return function(he) {
                  L[ue] = this, $[ue] = arguments.length > 1 ? g.call(arguments) : he, --k || U.resolveWith(L, $);
                };
              };
              if (k <= 1 && (pt(h, U.done(G(O)).resolve, U.reject, !k), U.state() === "pending" || R($[O] && $[O].then))) return U.then();
              for (; O--; ) pt($[O], G(O), U.reject);
              return U.promise();
            } });
            var Tt = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
            D.Deferred.exceptionHook = function(h, k) {
              p.console && p.console.warn && h && Tt.test(h.name) && p.console.warn("jQuery.Deferred exception: " + h.message, h.stack, k);
            }, D.readyException = function(h) {
              p.setTimeout(function() {
                throw h;
              });
            };
            var Wt = D.Deferred();
            function et() {
              W.removeEventListener("DOMContentLoaded", et), p.removeEventListener("load", et), D.ready();
            }
            D.fn.ready = function(h) {
              return Wt.then(h).catch(function(k) {
                D.readyException(k);
              }), this;
            }, D.extend({ isReady: !1, readyWait: 1, ready: function(h) {
              (h === !0 ? --D.readyWait : D.isReady) || (D.isReady = !0, h !== !0 && --D.readyWait > 0 || Wt.resolveWith(W, [D]));
            } }), D.ready.then = Wt.then, W.readyState === "complete" || W.readyState !== "loading" && !W.documentElement.doScroll ? p.setTimeout(D.ready) : (W.addEventListener("DOMContentLoaded", et), p.addEventListener("load", et));
            var At = function(h, k, O, L, $, U, G) {
              var ue = 0, he = h.length, we = O == null;
              if (ne(O) === "object") for (ue in $ = !0, O) At(h, k, ue, O[ue], !0, U, G);
              else if (L !== void 0 && ($ = !0, R(L) || (G = !0), we && (G ? (k.call(h, L), k = null) : (we = k, k = function(Fe, Re, De) {
                return we.call(D(Fe), De);
              })), k)) for (; ue < he; ue++) k(h[ue], O, G ? L : L.call(h[ue], ue, k(h[ue], O)));
              return $ ? h : we ? k.call(h) : he ? k(h[0], O) : U;
            }, Gt = /^-ms-/, Lt = /-([a-z])/g;
            function ct(h, k) {
              return k.toUpperCase();
            }
            function re(h) {
              return h.replace(Gt, "ms-").replace(Lt, ct);
            }
            var $e = function(h) {
              return h.nodeType === 1 || h.nodeType === 9 || !+h.nodeType;
            };
            function vt() {
              this.expando = D.expando + vt.uid++;
            }
            vt.uid = 1, vt.prototype = { cache: function(h) {
              var k = h[this.expando];
              return k || (k = {}, $e(h) && (h.nodeType ? h[this.expando] = k : Object.defineProperty(h, this.expando, { value: k, configurable: !0 }))), k;
            }, set: function(h, k, O) {
              var L, $ = this.cache(h);
              if (typeof k == "string") $[re(k)] = O;
              else for (L in k) $[re(L)] = k[L];
              return $;
            }, get: function(h, k) {
              return k === void 0 ? this.cache(h) : h[this.expando] && h[this.expando][re(k)];
            }, access: function(h, k, O) {
              return k === void 0 || k && typeof k == "string" && O === void 0 ? this.get(h, k) : (this.set(h, k, O), O !== void 0 ? O : k);
            }, remove: function(h, k) {
              var O, L = h[this.expando];
              if (L !== void 0) {
                if (k !== void 0)
                  for (O = (k = Array.isArray(k) ? k.map(re) : (k = re(k)) in L ? [k] : k.match(Ze) || []).length; O--; ) delete L[k[O]];
                (k === void 0 || D.isEmptyObject(L)) && (h.nodeType ? h[this.expando] = void 0 : delete h[this.expando]);
              }
            }, hasData: function(h) {
              var k = h[this.expando];
              return k !== void 0 && !D.isEmptyObject(k);
            } };
            var rt = new vt(), Dt = new vt(), tn = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, Xn = /[A-Z]/g;
            function In(h, k, O) {
              var L;
              if (O === void 0 && h.nodeType === 1) if (L = "data-" + k.replace(Xn, "-$&").toLowerCase(), typeof (O = h.getAttribute(L)) == "string") {
                try {
                  O = function($) {
                    return $ === "true" || $ !== "false" && ($ === "null" ? null : $ === +$ + "" ? +$ : tn.test($) ? JSON.parse($) : $);
                  }(O);
                } catch {
                }
                Dt.set(h, k, O);
              } else O = void 0;
              return O;
            }
            D.extend({ hasData: function(h) {
              return Dt.hasData(h) || rt.hasData(h);
            }, data: function(h, k, O) {
              return Dt.access(h, k, O);
            }, removeData: function(h, k) {
              Dt.remove(h, k);
            }, _data: function(h, k, O) {
              return rt.access(h, k, O);
            }, _removeData: function(h, k) {
              rt.remove(h, k);
            } }), D.fn.extend({ data: function(h, k) {
              var O, L, $, U = this[0], G = U && U.attributes;
              if (h === void 0) {
                if (this.length && ($ = Dt.get(U), U.nodeType === 1 && !rt.get(U, "hasDataAttrs"))) {
                  for (O = G.length; O--; ) G[O] && (L = G[O].name).indexOf("data-") === 0 && (L = re(L.slice(5)), In(U, L, $[L]));
                  rt.set(U, "hasDataAttrs", !0);
                }
                return $;
              }
              return typeof h == "object" ? this.each(function() {
                Dt.set(this, h);
              }) : At(this, function(ue) {
                var he;
                if (U && ue === void 0) return (he = Dt.get(U, h)) !== void 0 || (he = In(U, h)) !== void 0 ? he : void 0;
                this.each(function() {
                  Dt.set(this, h, ue);
                });
              }, null, k, arguments.length > 1, null, !0);
            }, removeData: function(h) {
              return this.each(function() {
                Dt.remove(this, h);
              });
            } }), D.extend({ queue: function(h, k, O) {
              var L;
              if (h) return k = (k || "fx") + "queue", L = rt.get(h, k), O && (!L || Array.isArray(O) ? L = rt.access(h, k, D.makeArray(O)) : L.push(O)), L || [];
            }, dequeue: function(h, k) {
              k = k || "fx";
              var O = D.queue(h, k), L = O.length, $ = O.shift(), U = D._queueHooks(h, k);
              $ === "inprogress" && ($ = O.shift(), L--), $ && (k === "fx" && O.unshift("inprogress"), delete U.stop, $.call(h, function() {
                D.dequeue(h, k);
              }, U)), !L && U && U.empty.fire();
            }, _queueHooks: function(h, k) {
              var O = k + "queueHooks";
              return rt.get(h, O) || rt.access(h, O, { empty: D.Callbacks("once memory").add(function() {
                rt.remove(h, [k + "queue", O]);
              }) });
            } }), D.fn.extend({ queue: function(h, k) {
              var O = 2;
              return typeof h != "string" && (k = h, h = "fx", O--), arguments.length < O ? D.queue(this[0], h) : k === void 0 ? this : this.each(function() {
                var L = D.queue(this, h, k);
                D._queueHooks(this, h), h === "fx" && L[0] !== "inprogress" && D.dequeue(this, h);
              });
            }, dequeue: function(h) {
              return this.each(function() {
                D.dequeue(this, h);
              });
            }, clearQueue: function(h) {
              return this.queue(h || "fx", []);
            }, promise: function(h, k) {
              var O, L = 1, $ = D.Deferred(), U = this, G = this.length, ue = function() {
                --L || $.resolveWith(U, [U]);
              };
              for (typeof h != "string" && (k = h, h = void 0), h = h || "fx"; G--; ) (O = rt.get(U[G], h + "queueHooks")) && O.empty && (L++, O.empty.add(ue));
              return ue(), $.promise(k);
            } });
            var Qn = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, Yn = new RegExp("^(?:([+-])=|)(" + Qn + ")([a-z%]*)$", "i"), Ce = ["Top", "Right", "Bottom", "Left"], xe = W.documentElement, Oe = function(h) {
              return D.contains(h.ownerDocument, h);
            }, Ft = { composed: !0 };
            xe.getRootNode && (Oe = function(h) {
              return D.contains(h.ownerDocument, h) || h.getRootNode(Ft) === h.ownerDocument;
            });
            var on = function(h, k) {
              return (h = k || h).style.display === "none" || h.style.display === "" && Oe(h) && D.css(h, "display") === "none";
            };
            function yr(h, k, O, L) {
              var $, U, G = 20, ue = L ? function() {
                return L.cur();
              } : function() {
                return D.css(h, k, "");
              }, he = ue(), we = O && O[3] || (D.cssNumber[k] ? "" : "px"), Fe = h.nodeType && (D.cssNumber[k] || we !== "px" && +he) && Yn.exec(D.css(h, k));
              if (Fe && Fe[3] !== we) {
                for (he /= 2, we = we || Fe[3], Fe = +he || 1; G--; ) D.style(h, k, Fe + we), (1 - U) * (1 - (U = ue() / he || 0.5)) <= 0 && (G = 0), Fe /= U;
                Fe *= 2, D.style(h, k, Fe + we), O = O || [];
              }
              return O && (Fe = +Fe || +he || 0, $ = O[1] ? Fe + (O[1] + 1) * O[2] : +O[2], L && (L.unit = we, L.start = Fe, L.end = $)), $;
            }
            var Ho = {};
            function cn(h) {
              var k, O = h.ownerDocument, L = h.nodeName, $ = Ho[L];
              return $ || (k = O.body.appendChild(O.createElement(L)), $ = D.css(k, "display"), k.parentNode.removeChild(k), $ === "none" && ($ = "block"), Ho[L] = $, $);
            }
            function Jn(h, k) {
              for (var O, L, $ = [], U = 0, G = h.length; U < G; U++) (L = h[U]).style && (O = L.style.display, k ? (O === "none" && ($[U] = rt.get(L, "display") || null, $[U] || (L.style.display = "")), L.style.display === "" && on(L) && ($[U] = cn(L))) : O !== "none" && ($[U] = "none", rt.set(L, "display", O)));
              for (U = 0; U < G; U++) $[U] != null && (h[U].style.display = $[U]);
              return h;
            }
            D.fn.extend({ show: function() {
              return Jn(this, !0);
            }, hide: function() {
              return Jn(this);
            }, toggle: function(h) {
              return typeof h == "boolean" ? h ? this.show() : this.hide() : this.each(function() {
                on(this) ? D(this).show() : D(this).hide();
              });
            } });
            var un, Vo, Ca = /^(?:checkbox|radio)$/i, Lu = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, Mu = /^$|^module$|\/(?:java|ecma)script/i;
            un = W.createDocumentFragment().appendChild(W.createElement("div")), (Vo = W.createElement("input")).setAttribute("type", "radio"), Vo.setAttribute("checked", "checked"), Vo.setAttribute("name", "t"), un.appendChild(Vo), M.checkClone = un.cloneNode(!0).cloneNode(!0).lastChild.checked, un.innerHTML = "<textarea>x</textarea>", M.noCloneChecked = !!un.cloneNode(!0).lastChild.defaultValue, un.innerHTML = "<option></option>", M.option = !!un.lastChild;
            var Fn = { thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] };
            function fr(h, k) {
              var O;
              return O = h.getElementsByTagName !== void 0 ? h.getElementsByTagName(k || "*") : h.querySelectorAll !== void 0 ? h.querySelectorAll(k || "*") : [], k === void 0 || k && Ie(h, k) ? D.merge([h], O) : O;
            }
            function xr(h, k) {
              for (var O = 0, L = h.length; O < L; O++) rt.set(h[O], "globalEval", !k || rt.get(k[O], "globalEval"));
            }
            Fn.tbody = Fn.tfoot = Fn.colgroup = Fn.caption = Fn.thead, Fn.th = Fn.td, M.option || (Fn.optgroup = Fn.option = [1, "<select multiple='multiple'>", "</select>"]);
            var Bu = /<|&#?\w+;/;
            function Cl(h, k, O, L, $) {
              for (var U, G, ue, he, we, Fe, Re = k.createDocumentFragment(), De = [], je = 0, Ct = h.length; je < Ct; je++) if ((U = h[je]) || U === 0) if (ne(U) === "object") D.merge(De, U.nodeType ? [U] : U);
              else if (Bu.test(U)) {
                for (G = G || Re.appendChild(k.createElement("div")), ue = (Lu.exec(U) || ["", ""])[1].toLowerCase(), he = Fn[ue] || Fn._default, G.innerHTML = he[1] + D.htmlPrefilter(U) + he[2], Fe = he[0]; Fe--; ) G = G.lastChild;
                D.merge(De, G.childNodes), (G = Re.firstChild).textContent = "";
              } else De.push(k.createTextNode(U));
              for (Re.textContent = "", je = 0; U = De[je++]; ) if (L && D.inArray(U, L) > -1) $ && $.push(U);
              else if (we = Oe(U), G = fr(Re.appendChild(U), "script"), we && xr(G), O) for (Fe = 0; U = G[Fe++]; ) Mu.test(U.type || "") && O.push(U);
              return Re;
            }
            var kl = /^([^.]*)(?:\.(.+)|)/;
            function Rn() {
              return !0;
            }
            function Br() {
              return !1;
            }
            function Iu(h, k) {
              return h === function() {
                try {
                  return W.activeElement;
                } catch {
                }
              }() == (k === "focus");
            }
            function ui(h, k, O, L, $, U) {
              var G, ue;
              if (typeof k == "object") {
                for (ue in typeof O != "string" && (L = L || O, O = void 0), k) ui(h, ue, O, L, k[ue], U);
                return h;
              }
              if (L == null && $ == null ? ($ = O, L = O = void 0) : $ == null && (typeof O == "string" ? ($ = L, L = void 0) : ($ = L, L = O, O = void 0)), $ === !1) $ = Br;
              else if (!$) return h;
              return U === 1 && (G = $, $ = function(he) {
                return D().off(he), G.apply(this, arguments);
              }, $.guid = G.guid || (G.guid = D.guid++)), h.each(function() {
                D.event.add(this, k, $, L, O);
              });
            }
            function El(h, k, O) {
              O ? (rt.set(h, k, !1), D.event.add(h, k, { namespace: !1, handler: function(L) {
                var $, U, G = rt.get(this, k);
                if (1 & L.isTrigger && this[k]) {
                  if (G.length) (D.event.special[k] || {}).delegateType && L.stopPropagation();
                  else if (G = g.call(arguments), rt.set(this, k, G), $ = O(this, k), this[k](), G !== (U = rt.get(this, k)) || $ ? rt.set(this, k, !1) : U = {}, G !== U) return L.stopImmediatePropagation(), L.preventDefault(), U && U.value;
                } else G.length && (rt.set(this, k, { value: D.event.trigger(D.extend(G[0], D.Event.prototype), G.slice(1), this) }), L.stopImmediatePropagation());
              } })) : rt.get(h, k) === void 0 && D.event.add(h, k, Rn);
            }
            D.event = { global: {}, add: function(h, k, O, L, $) {
              var U, G, ue, he, we, Fe, Re, De, je, Ct, Mt, kt = rt.get(h);
              if ($e(h)) for (O.handler && (O = (U = O).handler, $ = U.selector), $ && D.find.matchesSelector(xe, $), O.guid || (O.guid = D.guid++), (he = kt.events) || (he = kt.events = /* @__PURE__ */ Object.create(null)), (G = kt.handle) || (G = kt.handle = function(rr) {
                return D !== void 0 && D.event.triggered !== rr.type ? D.event.dispatch.apply(h, arguments) : void 0;
              }), we = (k = (k || "").match(Ze) || [""]).length; we--; ) je = Mt = (ue = kl.exec(k[we]) || [])[1], Ct = (ue[2] || "").split(".").sort(), je && (Re = D.event.special[je] || {}, je = ($ ? Re.delegateType : Re.bindType) || je, Re = D.event.special[je] || {}, Fe = D.extend({ type: je, origType: Mt, data: L, handler: O, guid: O.guid, selector: $, needsContext: $ && D.expr.match.needsContext.test($), namespace: Ct.join(".") }, U), (De = he[je]) || ((De = he[je] = []).delegateCount = 0, Re.setup && Re.setup.call(h, L, Ct, G) !== !1 || h.addEventListener && h.addEventListener(je, G)), Re.add && (Re.add.call(h, Fe), Fe.handler.guid || (Fe.handler.guid = O.guid)), $ ? De.splice(De.delegateCount++, 0, Fe) : De.push(Fe), D.event.global[je] = !0);
            }, remove: function(h, k, O, L, $) {
              var U, G, ue, he, we, Fe, Re, De, je, Ct, Mt, kt = rt.hasData(h) && rt.get(h);
              if (kt && (he = kt.events)) {
                for (we = (k = (k || "").match(Ze) || [""]).length; we--; ) if (je = Mt = (ue = kl.exec(k[we]) || [])[1], Ct = (ue[2] || "").split(".").sort(), je) {
                  for (Re = D.event.special[je] || {}, De = he[je = (L ? Re.delegateType : Re.bindType) || je] || [], ue = ue[2] && new RegExp("(^|\\.)" + Ct.join("\\.(?:.*\\.|)") + "(\\.|$)"), G = U = De.length; U--; ) Fe = De[U], !$ && Mt !== Fe.origType || O && O.guid !== Fe.guid || ue && !ue.test(Fe.namespace) || L && L !== Fe.selector && (L !== "**" || !Fe.selector) || (De.splice(U, 1), Fe.selector && De.delegateCount--, Re.remove && Re.remove.call(h, Fe));
                  G && !De.length && (Re.teardown && Re.teardown.call(h, Ct, kt.handle) !== !1 || D.removeEvent(h, je, kt.handle), delete he[je]);
                } else for (je in he) D.event.remove(h, je + k[we], O, L, !0);
                D.isEmptyObject(he) && rt.remove(h, "handle events");
              }
            }, dispatch: function(h) {
              var k, O, L, $, U, G, ue = new Array(arguments.length), he = D.event.fix(h), we = (rt.get(this, "events") || /* @__PURE__ */ Object.create(null))[he.type] || [], Fe = D.event.special[he.type] || {};
              for (ue[0] = he, k = 1; k < arguments.length; k++) ue[k] = arguments[k];
              if (he.delegateTarget = this, !Fe.preDispatch || Fe.preDispatch.call(this, he) !== !1) {
                for (G = D.event.handlers.call(this, he, we), k = 0; ($ = G[k++]) && !he.isPropagationStopped(); ) for (he.currentTarget = $.elem, O = 0; (U = $.handlers[O++]) && !he.isImmediatePropagationStopped(); ) he.rnamespace && U.namespace !== !1 && !he.rnamespace.test(U.namespace) || (he.handleObj = U, he.data = U.data, (L = ((D.event.special[U.origType] || {}).handle || U.handler).apply($.elem, ue)) !== void 0 && (he.result = L) === !1 && (he.preventDefault(), he.stopPropagation()));
                return Fe.postDispatch && Fe.postDispatch.call(this, he), he.result;
              }
            }, handlers: function(h, k) {
              var O, L, $, U, G, ue = [], he = k.delegateCount, we = h.target;
              if (he && we.nodeType && !(h.type === "click" && h.button >= 1)) {
                for (; we !== this; we = we.parentNode || this) if (we.nodeType === 1 && (h.type !== "click" || we.disabled !== !0)) {
                  for (U = [], G = {}, O = 0; O < he; O++) G[$ = (L = k[O]).selector + " "] === void 0 && (G[$] = L.needsContext ? D($, this).index(we) > -1 : D.find($, this, null, [we]).length), G[$] && U.push(L);
                  U.length && ue.push({ elem: we, handlers: U });
                }
              }
              return we = this, he < k.length && ue.push({ elem: we, handlers: k.slice(he) }), ue;
            }, addProp: function(h, k) {
              Object.defineProperty(D.Event.prototype, h, { enumerable: !0, configurable: !0, get: R(k) ? function() {
                if (this.originalEvent) return k(this.originalEvent);
              } : function() {
                if (this.originalEvent) return this.originalEvent[h];
              }, set: function(O) {
                Object.defineProperty(this, h, { enumerable: !0, configurable: !0, writable: !0, value: O });
              } });
            }, fix: function(h) {
              return h[D.expando] ? h : new D.Event(h);
            }, special: { load: { noBubble: !0 }, click: { setup: function(h) {
              var k = this || h;
              return Ca.test(k.type) && k.click && Ie(k, "input") && El(k, "click", Rn), !1;
            }, trigger: function(h) {
              var k = this || h;
              return Ca.test(k.type) && k.click && Ie(k, "input") && El(k, "click"), !0;
            }, _default: function(h) {
              var k = h.target;
              return Ca.test(k.type) && k.click && Ie(k, "input") && rt.get(k, "click") || Ie(k, "a");
            } }, beforeunload: { postDispatch: function(h) {
              h.result !== void 0 && h.originalEvent && (h.originalEvent.returnValue = h.result);
            } } } }, D.removeEvent = function(h, k, O) {
              h.removeEventListener && h.removeEventListener(k, O);
            }, D.Event = function(h, k) {
              if (!(this instanceof D.Event)) return new D.Event(h, k);
              h && h.type ? (this.originalEvent = h, this.type = h.type, this.isDefaultPrevented = h.defaultPrevented || h.defaultPrevented === void 0 && h.returnValue === !1 ? Rn : Br, this.target = h.target && h.target.nodeType === 3 ? h.target.parentNode : h.target, this.currentTarget = h.currentTarget, this.relatedTarget = h.relatedTarget) : this.type = h, k && D.extend(this, k), this.timeStamp = h && h.timeStamp || Date.now(), this[D.expando] = !0;
            }, D.Event.prototype = { constructor: D.Event, isDefaultPrevented: Br, isPropagationStopped: Br, isImmediatePropagationStopped: Br, isSimulated: !1, preventDefault: function() {
              var h = this.originalEvent;
              this.isDefaultPrevented = Rn, h && !this.isSimulated && h.preventDefault();
            }, stopPropagation: function() {
              var h = this.originalEvent;
              this.isPropagationStopped = Rn, h && !this.isSimulated && h.stopPropagation();
            }, stopImmediatePropagation: function() {
              var h = this.originalEvent;
              this.isImmediatePropagationStopped = Rn, h && !this.isSimulated && h.stopImmediatePropagation(), this.stopPropagation();
            } }, D.each({ altKey: !0, bubbles: !0, cancelable: !0, changedTouches: !0, ctrlKey: !0, detail: !0, eventPhase: !0, metaKey: !0, pageX: !0, pageY: !0, shiftKey: !0, view: !0, char: !0, code: !0, charCode: !0, key: !0, keyCode: !0, button: !0, buttons: !0, clientX: !0, clientY: !0, offsetX: !0, offsetY: !0, pointerId: !0, pointerType: !0, screenX: !0, screenY: !0, targetTouches: !0, toElement: !0, touches: !0, which: !0 }, D.event.addProp), D.each({ focus: "focusin", blur: "focusout" }, function(h, k) {
              D.event.special[h] = { setup: function() {
                return El(this, h, Iu), !1;
              }, trigger: function() {
                return El(this, h), !0;
              }, _default: function() {
                return !0;
              }, delegateType: k };
            }), D.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function(h, k) {
              D.event.special[h] = { delegateType: k, bindType: k, handle: function(O) {
                var L, $ = this, U = O.relatedTarget, G = O.handleObj;
                return U && (U === $ || D.contains($, U)) || (O.type = G.origType, L = G.handler.apply(this, arguments), O.type = k), L;
              } };
            }), D.fn.extend({ on: function(h, k, O, L) {
              return ui(this, h, k, O, L);
            }, one: function(h, k, O, L) {
              return ui(this, h, k, O, L, 1);
            }, off: function(h, k, O) {
              var L, $;
              if (h && h.preventDefault && h.handleObj) return L = h.handleObj, D(h.delegateTarget).off(L.namespace ? L.origType + "." + L.namespace : L.origType, L.selector, L.handler), this;
              if (typeof h == "object") {
                for ($ in h) this.off($, k, h[$]);
                return this;
              }
              return k !== !1 && typeof k != "function" || (O = k, k = void 0), O === !1 && (O = Br), this.each(function() {
                D.event.remove(this, h, O, k);
              });
            } });
            var Ru = /<script|<style|<link/i, er = /checked\s*(?:[^=]|=\s*.checked.)/i, Ga = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
            function Dn(h, k) {
              return Ie(h, "table") && Ie(k.nodeType !== 11 ? k : k.firstChild, "tr") && D(h).children("tbody")[0] || h;
            }
            function Es(h) {
              return h.type = (h.getAttribute("type") !== null) + "/" + h.type, h;
            }
            function bn(h) {
              return (h.type || "").slice(0, 5) === "true/" ? h.type = h.type.slice(5) : h.removeAttribute("type"), h;
            }
            function ka(h, k) {
              var O, L, $, U, G, ue;
              if (k.nodeType === 1) {
                if (rt.hasData(h) && (ue = rt.get(h).events)) for ($ in rt.remove(k, "handle events"), ue) for (O = 0, L = ue[$].length; O < L; O++) D.event.add(k, $, ue[$][O]);
                Dt.hasData(h) && (U = Dt.access(h), G = D.extend({}, U), Dt.set(k, G));
              }
            }
            function Sl(h, k) {
              var O = k.nodeName.toLowerCase();
              O === "input" && Ca.test(h.type) ? k.checked = h.checked : O !== "input" && O !== "textarea" || (k.defaultValue = h.defaultValue);
            }
            function Uo(h, k, O, L) {
              k = x(k);
              var $, U, G, ue, he, we, Fe = 0, Re = h.length, De = Re - 1, je = k[0], Ct = R(je);
              if (Ct || Re > 1 && typeof je == "string" && !M.checkClone && er.test(je)) return h.each(function(Mt) {
                var kt = h.eq(Mt);
                Ct && (k[0] = je.call(this, Mt, kt.html())), Uo(kt, k, O, L);
              });
              if (Re && (U = ($ = Cl(k, h[0].ownerDocument, !1, h, L)).firstChild, $.childNodes.length === 1 && ($ = U), U || L)) {
                for (ue = (G = D.map(fr($, "script"), Es)).length; Fe < Re; Fe++) he = $, Fe !== De && (he = D.clone(he, !0, !0), ue && D.merge(G, fr(he, "script"))), O.call(h[Fe], he, Fe);
                if (ue) for (we = G[G.length - 1].ownerDocument, D.map(G, bn), Fe = 0; Fe < ue; Fe++) he = G[Fe], Mu.test(he.type || "") && !rt.access(he, "globalEval") && D.contains(we, he) && (he.src && (he.type || "").toLowerCase() !== "module" ? D._evalUrl && !he.noModule && D._evalUrl(he.src, { nonce: he.nonce || he.getAttribute("nonce") }, we) : le(he.textContent.replace(Ga, ""), he, we));
              }
              return h;
            }
            function Ka(h, k, O) {
              for (var L, $ = k ? D.filter(k, h) : h, U = 0; (L = $[U]) != null; U++) O || L.nodeType !== 1 || D.cleanData(fr(L)), L.parentNode && (O && Oe(L) && xr(fr(L, "script")), L.parentNode.removeChild(L));
              return h;
            }
            D.extend({ htmlPrefilter: function(h) {
              return h;
            }, clone: function(h, k, O) {
              var L, $, U, G, ue = h.cloneNode(!0), he = Oe(h);
              if (!(M.noCloneChecked || h.nodeType !== 1 && h.nodeType !== 11 || D.isXMLDoc(h))) for (G = fr(ue), L = 0, $ = (U = fr(h)).length; L < $; L++) Sl(U[L], G[L]);
              if (k) if (O) for (U = U || fr(h), G = G || fr(ue), L = 0, $ = U.length; L < $; L++) ka(U[L], G[L]);
              else ka(h, ue);
              return (G = fr(ue, "script")).length > 0 && xr(G, !he && fr(h, "script")), ue;
            }, cleanData: function(h) {
              for (var k, O, L, $ = D.event.special, U = 0; (O = h[U]) !== void 0; U++) if ($e(O)) {
                if (k = O[rt.expando]) {
                  if (k.events) for (L in k.events) $[L] ? D.event.remove(O, L) : D.removeEvent(O, L, k.handle);
                  O[rt.expando] = void 0;
                }
                O[Dt.expando] && (O[Dt.expando] = void 0);
              }
            } }), D.fn.extend({ detach: function(h) {
              return Ka(this, h, !0);
            }, remove: function(h) {
              return Ka(this, h);
            }, text: function(h) {
              return At(this, function(k) {
                return k === void 0 ? D.text(this) : this.empty().each(function() {
                  this.nodeType !== 1 && this.nodeType !== 11 && this.nodeType !== 9 || (this.textContent = k);
                });
              }, null, h, arguments.length);
            }, append: function() {
              return Uo(this, arguments, function(h) {
                this.nodeType !== 1 && this.nodeType !== 11 && this.nodeType !== 9 || Dn(this, h).appendChild(h);
              });
            }, prepend: function() {
              return Uo(this, arguments, function(h) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                  var k = Dn(this, h);
                  k.insertBefore(h, k.firstChild);
                }
              });
            }, before: function() {
              return Uo(this, arguments, function(h) {
                this.parentNode && this.parentNode.insertBefore(h, this);
              });
            }, after: function() {
              return Uo(this, arguments, function(h) {
                this.parentNode && this.parentNode.insertBefore(h, this.nextSibling);
              });
            }, empty: function() {
              for (var h, k = 0; (h = this[k]) != null; k++) h.nodeType === 1 && (D.cleanData(fr(h, !1)), h.textContent = "");
              return this;
            }, clone: function(h, k) {
              return h = h != null && h, k = k ?? h, this.map(function() {
                return D.clone(this, h, k);
              });
            }, html: function(h) {
              return At(this, function(k) {
                var O = this[0] || {}, L = 0, $ = this.length;
                if (k === void 0 && O.nodeType === 1) return O.innerHTML;
                if (typeof k == "string" && !Ru.test(k) && !Fn[(Lu.exec(k) || ["", ""])[1].toLowerCase()]) {
                  k = D.htmlPrefilter(k);
                  try {
                    for (; L < $; L++) (O = this[L] || {}).nodeType === 1 && (D.cleanData(fr(O, !1)), O.innerHTML = k);
                    O = 0;
                  } catch {
                  }
                }
                O && this.empty().append(k);
              }, null, h, arguments.length);
            }, replaceWith: function() {
              var h = [];
              return Uo(this, arguments, function(k) {
                var O = this.parentNode;
                D.inArray(this, h) < 0 && (D.cleanData(fr(this)), O && O.replaceChild(k, this));
              }, h);
            } }), D.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function(h, k) {
              D.fn[h] = function(O) {
                for (var L, $ = [], U = D(O), G = U.length - 1, ue = 0; ue <= G; ue++) L = ue === G ? this : this.clone(!0), D(U[ue])[k](L), E.apply($, L.get());
                return this.pushStack($);
              };
            });
            var Ss = new RegExp("^(" + Qn + ")(?!px)[a-z%]+$", "i"), _ = function(h) {
              var k = h.ownerDocument.defaultView;
              return k && k.opener || (k = p), k.getComputedStyle(h);
            }, H = function(h, k, O) {
              var L, $, U = {};
              for ($ in k) U[$] = h.style[$], h.style[$] = k[$];
              for ($ in L = O.call(h), k) h.style[$] = U[$];
              return L;
            }, S = new RegExp(Ce.join("|"), "i");
            function A(h, k, O) {
              var L, $, U, G, ue = h.style;
              return (O = O || _(h)) && ((G = O.getPropertyValue(k) || O[k]) !== "" || Oe(h) || (G = D.style(h, k)), !M.pixelBoxStyles() && Ss.test(G) && S.test(k) && (L = ue.width, $ = ue.minWidth, U = ue.maxWidth, ue.minWidth = ue.maxWidth = ue.width = G, G = O.width, ue.width = L, ue.minWidth = $, ue.maxWidth = U)), G !== void 0 ? G + "" : G;
            }
            function P(h, k) {
              return { get: function() {
                if (!h()) return (this.get = k).apply(this, arguments);
                delete this.get;
              } };
            }
            (function() {
              function h() {
                if (we) {
                  he.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", we.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", xe.appendChild(he).appendChild(we);
                  var Fe = p.getComputedStyle(we);
                  O = Fe.top !== "1%", ue = k(Fe.marginLeft) === 12, we.style.right = "60%", U = k(Fe.right) === 36, L = k(Fe.width) === 36, we.style.position = "absolute", $ = k(we.offsetWidth / 3) === 12, xe.removeChild(he), we = null;
                }
              }
              function k(Fe) {
                return Math.round(parseFloat(Fe));
              }
              var O, L, $, U, G, ue, he = W.createElement("div"), we = W.createElement("div");
              we.style && (we.style.backgroundClip = "content-box", we.cloneNode(!0).style.backgroundClip = "", M.clearCloneStyle = we.style.backgroundClip === "content-box", D.extend(M, { boxSizingReliable: function() {
                return h(), L;
              }, pixelBoxStyles: function() {
                return h(), U;
              }, pixelPosition: function() {
                return h(), O;
              }, reliableMarginLeft: function() {
                return h(), ue;
              }, scrollboxSize: function() {
                return h(), $;
              }, reliableTrDimensions: function() {
                var Fe, Re, De, je;
                return G == null && (Fe = W.createElement("table"), Re = W.createElement("tr"), De = W.createElement("div"), Fe.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", Re.style.cssText = "border:1px solid", Re.style.height = "1px", De.style.height = "9px", De.style.display = "block", xe.appendChild(Fe).appendChild(Re).appendChild(De), je = p.getComputedStyle(Re), G = parseInt(je.height, 10) + parseInt(je.borderTopWidth, 10) + parseInt(je.borderBottomWidth, 10) === Re.offsetHeight, xe.removeChild(Fe)), G;
              } }));
            })();
            var Q = ["Webkit", "Moz", "ms"], ie = W.createElement("div").style, pe = {};
            function ce(h) {
              return D.cssProps[h] || pe[h] || (h in ie ? h : pe[h] = function(k) {
                for (var O = k[0].toUpperCase() + k.slice(1), L = Q.length; L--; ) if ((k = Q[L] + O) in ie) return k;
              }(h) || h);
            }
            var ze = /^(none|table(?!-c[ea]).+)/, Xe = /^--/, wt = { position: "absolute", visibility: "hidden", display: "block" }, jt = { letterSpacing: "0", fontWeight: "400" };
            function Kt(h, k, O) {
              var L = Yn.exec(k);
              return L ? Math.max(0, L[2] - (O || 0)) + (L[3] || "px") : k;
            }
            function ut(h, k, O, L, $, U) {
              var G = k === "width" ? 1 : 0, ue = 0, he = 0;
              if (O === (L ? "border" : "content")) return 0;
              for (; G < 4; G += 2) O === "margin" && (he += D.css(h, O + Ce[G], !0, $)), L ? (O === "content" && (he -= D.css(h, "padding" + Ce[G], !0, $)), O !== "margin" && (he -= D.css(h, "border" + Ce[G] + "Width", !0, $))) : (he += D.css(h, "padding" + Ce[G], !0, $), O !== "padding" ? he += D.css(h, "border" + Ce[G] + "Width", !0, $) : ue += D.css(h, "border" + Ce[G] + "Width", !0, $));
              return !L && U >= 0 && (he += Math.max(0, Math.ceil(h["offset" + k[0].toUpperCase() + k.slice(1)] - U - he - ue - 0.5)) || 0), he;
            }
            function Yt(h, k, O) {
              var L = _(h), $ = (!M.boxSizingReliable() || O) && D.css(h, "boxSizing", !1, L) === "border-box", U = $, G = A(h, k, L), ue = "offset" + k[0].toUpperCase() + k.slice(1);
              if (Ss.test(G)) {
                if (!O) return G;
                G = "auto";
              }
              return (!M.boxSizingReliable() && $ || !M.reliableTrDimensions() && Ie(h, "tr") || G === "auto" || !parseFloat(G) && D.css(h, "display", !1, L) === "inline") && h.getClientRects().length && ($ = D.css(h, "boxSizing", !1, L) === "border-box", (U = ue in h) && (G = h[ue])), (G = parseFloat(G) || 0) + ut(h, k, O || ($ ? "border" : "content"), U, L, G) + "px";
            }
            function Rt(h, k, O, L, $) {
              return new Rt.prototype.init(h, k, O, L, $);
            }
            D.extend({ cssHooks: { opacity: { get: function(h, k) {
              if (k) {
                var O = A(h, "opacity");
                return O === "" ? "1" : O;
              }
            } } }, cssNumber: { animationIterationCount: !0, columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, gridArea: !0, gridColumn: !0, gridColumnEnd: !0, gridColumnStart: !0, gridRow: !0, gridRowEnd: !0, gridRowStart: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 }, cssProps: {}, style: function(h, k, O, L) {
              if (h && h.nodeType !== 3 && h.nodeType !== 8 && h.style) {
                var $, U, G, ue = re(k), he = Xe.test(k), we = h.style;
                if (he || (k = ce(ue)), G = D.cssHooks[k] || D.cssHooks[ue], O === void 0) return G && "get" in G && ($ = G.get(h, !1, L)) !== void 0 ? $ : we[k];
                (U = typeof O) == "string" && ($ = Yn.exec(O)) && $[1] && (O = yr(h, k, $), U = "number"), O != null && O == O && (U !== "number" || he || (O += $ && $[3] || (D.cssNumber[ue] ? "" : "px")), M.clearCloneStyle || O !== "" || k.indexOf("background") !== 0 || (we[k] = "inherit"), G && "set" in G && (O = G.set(h, O, L)) === void 0 || (he ? we.setProperty(k, O) : we[k] = O));
              }
            }, css: function(h, k, O, L) {
              var $, U, G, ue = re(k);
              return Xe.test(k) || (k = ce(ue)), (G = D.cssHooks[k] || D.cssHooks[ue]) && "get" in G && ($ = G.get(h, !0, O)), $ === void 0 && ($ = A(h, k, L)), $ === "normal" && k in jt && ($ = jt[k]), O === "" || O ? (U = parseFloat($), O === !0 || isFinite(U) ? U || 0 : $) : $;
            } }), D.each(["height", "width"], function(h, k) {
              D.cssHooks[k] = { get: function(O, L, $) {
                if (L) return !ze.test(D.css(O, "display")) || O.getClientRects().length && O.getBoundingClientRect().width ? Yt(O, k, $) : H(O, wt, function() {
                  return Yt(O, k, $);
                });
              }, set: function(O, L, $) {
                var U, G = _(O), ue = !M.scrollboxSize() && G.position === "absolute", he = (ue || $) && D.css(O, "boxSizing", !1, G) === "border-box", we = $ ? ut(O, k, $, he, G) : 0;
                return he && ue && (we -= Math.ceil(O["offset" + k[0].toUpperCase() + k.slice(1)] - parseFloat(G[k]) - ut(O, k, "border", !1, G) - 0.5)), we && (U = Yn.exec(L)) && (U[3] || "px") !== "px" && (O.style[k] = L, L = D.css(O, k)), Kt(0, L, we);
              } };
            }), D.cssHooks.marginLeft = P(M.reliableMarginLeft, function(h, k) {
              if (k) return (parseFloat(A(h, "marginLeft")) || h.getBoundingClientRect().left - H(h, { marginLeft: 0 }, function() {
                return h.getBoundingClientRect().left;
              })) + "px";
            }), D.each({ margin: "", padding: "", border: "Width" }, function(h, k) {
              D.cssHooks[h + k] = { expand: function(O) {
                for (var L = 0, $ = {}, U = typeof O == "string" ? O.split(" ") : [O]; L < 4; L++) $[h + Ce[L] + k] = U[L] || U[L - 2] || U[0];
                return $;
              } }, h !== "margin" && (D.cssHooks[h + k].set = Kt);
            }), D.fn.extend({ css: function(h, k) {
              return At(this, function(O, L, $) {
                var U, G, ue = {}, he = 0;
                if (Array.isArray(L)) {
                  for (U = _(O), G = L.length; he < G; he++) ue[L[he]] = D.css(O, L[he], !1, U);
                  return ue;
                }
                return $ !== void 0 ? D.style(O, L, $) : D.css(O, L);
              }, h, k, arguments.length > 1);
            } }), D.Tween = Rt, Rt.prototype = { constructor: Rt, init: function(h, k, O, L, $, U) {
              this.elem = h, this.prop = O, this.easing = $ || D.easing._default, this.options = k, this.start = this.now = this.cur(), this.end = L, this.unit = U || (D.cssNumber[O] ? "" : "px");
            }, cur: function() {
              var h = Rt.propHooks[this.prop];
              return h && h.get ? h.get(this) : Rt.propHooks._default.get(this);
            }, run: function(h) {
              var k, O = Rt.propHooks[this.prop];
              return this.options.duration ? this.pos = k = D.easing[this.easing](h, this.options.duration * h, 0, 1, this.options.duration) : this.pos = k = h, this.now = (this.end - this.start) * k + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), O && O.set ? O.set(this) : Rt.propHooks._default.set(this), this;
            } }, Rt.prototype.init.prototype = Rt.prototype, Rt.propHooks = { _default: { get: function(h) {
              var k;
              return h.elem.nodeType !== 1 || h.elem[h.prop] != null && h.elem.style[h.prop] == null ? h.elem[h.prop] : (k = D.css(h.elem, h.prop, "")) && k !== "auto" ? k : 0;
            }, set: function(h) {
              D.fx.step[h.prop] ? D.fx.step[h.prop](h) : h.elem.nodeType !== 1 || !D.cssHooks[h.prop] && h.elem.style[ce(h.prop)] == null ? h.elem[h.prop] = h.now : D.style(h.elem, h.prop, h.now + h.unit);
            } } }, Rt.propHooks.scrollTop = Rt.propHooks.scrollLeft = { set: function(h) {
              h.elem.nodeType && h.elem.parentNode && (h.elem[h.prop] = h.now);
            } }, D.easing = { linear: function(h) {
              return h;
            }, swing: function(h) {
              return 0.5 - Math.cos(h * Math.PI) / 2;
            }, _default: "swing" }, D.fx = Rt.prototype.init, D.fx.step = {};
            var wn, br, Pu = /^(?:toggle|show|hide)$/, Ds = /queueHooks$/;
            function uo() {
              br && (W.hidden === !1 && p.requestAnimationFrame ? p.requestAnimationFrame(uo) : p.setTimeout(uo, D.fx.interval), D.fx.tick());
            }
            function _u() {
              return p.setTimeout(function() {
                wn = void 0;
              }), wn = Date.now();
            }
            function $i(h, k) {
              var O, L = 0, $ = { height: h };
              for (k = k ? 1 : 0; L < 4; L += 2 - k) $["margin" + (O = Ce[L])] = $["padding" + O] = h;
              return k && ($.opacity = $.width = h), $;
            }
            function As(h, k, O) {
              for (var L, $ = (ki.tweeners[k] || []).concat(ki.tweeners["*"]), U = 0, G = $.length; U < G; U++) if (L = $[U].call(O, k, h)) return L;
            }
            function ki(h, k, O) {
              var L, $, U = 0, G = ki.prefilters.length, ue = D.Deferred().always(function() {
                delete he.elem;
              }), he = function() {
                if ($) return !1;
                for (var Re = wn || _u(), De = Math.max(0, we.startTime + we.duration - Re), je = 1 - (De / we.duration || 0), Ct = 0, Mt = we.tweens.length; Ct < Mt; Ct++) we.tweens[Ct].run(je);
                return ue.notifyWith(h, [we, je, De]), je < 1 && Mt ? De : (Mt || ue.notifyWith(h, [we, 1, 0]), ue.resolveWith(h, [we]), !1);
              }, we = ue.promise({ elem: h, props: D.extend({}, k), opts: D.extend(!0, { specialEasing: {}, easing: D.easing._default }, O), originalProperties: k, originalOptions: O, startTime: wn || _u(), duration: O.duration, tweens: [], createTween: function(Re, De) {
                var je = D.Tween(h, we.opts, Re, De, we.opts.specialEasing[Re] || we.opts.easing);
                return we.tweens.push(je), je;
              }, stop: function(Re) {
                var De = 0, je = Re ? we.tweens.length : 0;
                if ($) return this;
                for ($ = !0; De < je; De++) we.tweens[De].run(1);
                return Re ? (ue.notifyWith(h, [we, 1, 0]), ue.resolveWith(h, [we, Re])) : ue.rejectWith(h, [we, Re]), this;
              } }), Fe = we.props;
              for (function(Re, De) {
                var je, Ct, Mt, kt, rr;
                for (je in Re) if (Mt = De[Ct = re(je)], kt = Re[je], Array.isArray(kt) && (Mt = kt[1], kt = Re[je] = kt[0]), je !== Ct && (Re[Ct] = kt, delete Re[je]), (rr = D.cssHooks[Ct]) && "expand" in rr) for (je in kt = rr.expand(kt), delete Re[Ct], kt) je in Re || (Re[je] = kt[je], De[je] = Mt);
                else De[Ct] = Mt;
              }(Fe, we.opts.specialEasing); U < G; U++) if (L = ki.prefilters[U].call(we, h, Fe, we.opts)) return R(L.stop) && (D._queueHooks(we.elem, we.opts.queue).stop = L.stop.bind(L)), L;
              return D.map(Fe, As, we), R(we.opts.start) && we.opts.start.call(h, we), we.progress(we.opts.progress).done(we.opts.done, we.opts.complete).fail(we.opts.fail).always(we.opts.always), D.fx.timer(D.extend(he, { elem: h, anim: we, queue: we.opts.queue })), we;
            }
            D.Animation = D.extend(ki, { tweeners: { "*": [function(h, k) {
              var O = this.createTween(h, k);
              return yr(O.elem, h, Yn.exec(k), O), O;
            }] }, tweener: function(h, k) {
              R(h) ? (k = h, h = ["*"]) : h = h.match(Ze);
              for (var O, L = 0, $ = h.length; L < $; L++) O = h[L], ki.tweeners[O] = ki.tweeners[O] || [], ki.tweeners[O].unshift(k);
            }, prefilters: [function(h, k, O) {
              var L, $, U, G, ue, he, we, Fe, Re = "width" in k || "height" in k, De = this, je = {}, Ct = h.style, Mt = h.nodeType && on(h), kt = rt.get(h, "fxshow");
              for (L in O.queue || ((G = D._queueHooks(h, "fx")).unqueued == null && (G.unqueued = 0, ue = G.empty.fire, G.empty.fire = function() {
                G.unqueued || ue();
              }), G.unqueued++, De.always(function() {
                De.always(function() {
                  G.unqueued--, D.queue(h, "fx").length || G.empty.fire();
                });
              })), k) if ($ = k[L], Pu.test($)) {
                if (delete k[L], U = U || $ === "toggle", $ === (Mt ? "hide" : "show")) {
                  if ($ !== "show" || !kt || kt[L] === void 0) continue;
                  Mt = !0;
                }
                je[L] = kt && kt[L] || D.style(h, L);
              }
              if ((he = !D.isEmptyObject(k)) || !D.isEmptyObject(je)) for (L in Re && h.nodeType === 1 && (O.overflow = [Ct.overflow, Ct.overflowX, Ct.overflowY], (we = kt && kt.display) == null && (we = rt.get(h, "display")), (Fe = D.css(h, "display")) === "none" && (we ? Fe = we : (Jn([h], !0), we = h.style.display || we, Fe = D.css(h, "display"), Jn([h]))), (Fe === "inline" || Fe === "inline-block" && we != null) && D.css(h, "float") === "none" && (he || (De.done(function() {
                Ct.display = we;
              }), we == null && (Fe = Ct.display, we = Fe === "none" ? "" : Fe)), Ct.display = "inline-block")), O.overflow && (Ct.overflow = "hidden", De.always(function() {
                Ct.overflow = O.overflow[0], Ct.overflowX = O.overflow[1], Ct.overflowY = O.overflow[2];
              })), he = !1, je) he || (kt ? "hidden" in kt && (Mt = kt.hidden) : kt = rt.access(h, "fxshow", { display: we }), U && (kt.hidden = !Mt), Mt && Jn([h], !0), De.done(function() {
                for (L in Mt || Jn([h]), rt.remove(h, "fxshow"), je) D.style(h, L, je[L]);
              })), he = As(Mt ? kt[L] : 0, L, De), L in kt || (kt[L] = he.start, Mt && (he.end = he.start, he.start = 0));
            }], prefilter: function(h, k) {
              k ? ki.prefilters.unshift(h) : ki.prefilters.push(h);
            } }), D.speed = function(h, k, O) {
              var L = h && typeof h == "object" ? D.extend({}, h) : { complete: O || !O && k || R(h) && h, duration: h, easing: O && k || k && !R(k) && k };
              return D.fx.off ? L.duration = 0 : typeof L.duration != "number" && (L.duration in D.fx.speeds ? L.duration = D.fx.speeds[L.duration] : L.duration = D.fx.speeds._default), L.queue != null && L.queue !== !0 || (L.queue = "fx"), L.old = L.complete, L.complete = function() {
                R(L.old) && L.old.call(this), L.queue && D.dequeue(this, L.queue);
              }, L;
            }, D.fn.extend({ fadeTo: function(h, k, O, L) {
              return this.filter(on).css("opacity", 0).show().end().animate({ opacity: k }, h, O, L);
            }, animate: function(h, k, O, L) {
              var $ = D.isEmptyObject(h), U = D.speed(k, O, L), G = function() {
                var ue = ki(this, D.extend({}, h), U);
                ($ || rt.get(this, "finish")) && ue.stop(!0);
              };
              return G.finish = G, $ || U.queue === !1 ? this.each(G) : this.queue(U.queue, G);
            }, stop: function(h, k, O) {
              var L = function($) {
                var U = $.stop;
                delete $.stop, U(O);
              };
              return typeof h != "string" && (O = k, k = h, h = void 0), k && this.queue(h || "fx", []), this.each(function() {
                var $ = !0, U = h != null && h + "queueHooks", G = D.timers, ue = rt.get(this);
                if (U) ue[U] && ue[U].stop && L(ue[U]);
                else for (U in ue) ue[U] && ue[U].stop && Ds.test(U) && L(ue[U]);
                for (U = G.length; U--; ) G[U].elem !== this || h != null && G[U].queue !== h || (G[U].anim.stop(O), $ = !1, G.splice(U, 1));
                !$ && O || D.dequeue(this, h);
              });
            }, finish: function(h) {
              return h !== !1 && (h = h || "fx"), this.each(function() {
                var k, O = rt.get(this), L = O[h + "queue"], $ = O[h + "queueHooks"], U = D.timers, G = L ? L.length : 0;
                for (O.finish = !0, D.queue(this, h, []), $ && $.stop && $.stop.call(this, !0), k = U.length; k--; ) U[k].elem === this && U[k].queue === h && (U[k].anim.stop(!0), U.splice(k, 1));
                for (k = 0; k < G; k++) L[k] && L[k].finish && L[k].finish.call(this);
                delete O.finish;
              });
            } }), D.each(["toggle", "show", "hide"], function(h, k) {
              var O = D.fn[k];
              D.fn[k] = function(L, $, U) {
                return L == null || typeof L == "boolean" ? O.apply(this, arguments) : this.animate($i(k, !0), L, $, U);
              };
            }), D.each({ slideDown: $i("show"), slideUp: $i("hide"), slideToggle: $i("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function(h, k) {
              D.fn[h] = function(O, L, $) {
                return this.animate(k, O, L, $);
              };
            }), D.timers = [], D.fx.tick = function() {
              var h, k = 0, O = D.timers;
              for (wn = Date.now(); k < O.length; k++) (h = O[k])() || O[k] !== h || O.splice(k--, 1);
              O.length || D.fx.stop(), wn = void 0;
            }, D.fx.timer = function(h) {
              D.timers.push(h), D.fx.start();
            }, D.fx.interval = 13, D.fx.start = function() {
              br || (br = !0, uo());
            }, D.fx.stop = function() {
              br = null;
            }, D.fx.speeds = { slow: 600, fast: 200, _default: 400 }, D.fn.delay = function(h, k) {
              return h = D.fx && D.fx.speeds[h] || h, k = k || "fx", this.queue(k, function(O, L) {
                var $ = p.setTimeout(O, h);
                L.stop = function() {
                  p.clearTimeout($);
                };
              });
            }, function() {
              var h = W.createElement("input"), k = W.createElement("select").appendChild(W.createElement("option"));
              h.type = "checkbox", M.checkOn = h.value !== "", M.optSelected = k.selected, (h = W.createElement("input")).value = "t", h.type = "radio", M.radioValue = h.value === "t";
            }();
            var Hc, qu = D.expr.attrHandle;
            D.fn.extend({ attr: function(h, k) {
              return At(this, D.attr, h, k, arguments.length > 1);
            }, removeAttr: function(h) {
              return this.each(function() {
                D.removeAttr(this, h);
              });
            } }), D.extend({ attr: function(h, k, O) {
              var L, $, U = h.nodeType;
              if (U !== 3 && U !== 8 && U !== 2) return h.getAttribute === void 0 ? D.prop(h, k, O) : (U === 1 && D.isXMLDoc(h) || ($ = D.attrHooks[k.toLowerCase()] || (D.expr.match.bool.test(k) ? Hc : void 0)), O !== void 0 ? O === null ? void D.removeAttr(h, k) : $ && "set" in $ && (L = $.set(h, O, k)) !== void 0 ? L : (h.setAttribute(k, O + ""), O) : $ && "get" in $ && (L = $.get(h, k)) !== null ? L : (L = D.find.attr(h, k)) == null ? void 0 : L);
            }, attrHooks: { type: { set: function(h, k) {
              if (!M.radioValue && k === "radio" && Ie(h, "input")) {
                var O = h.value;
                return h.setAttribute("type", k), O && (h.value = O), k;
              }
            } } }, removeAttr: function(h, k) {
              var O, L = 0, $ = k && k.match(Ze);
              if ($ && h.nodeType === 1) for (; O = $[L++]; ) h.removeAttribute(O);
            } }), Hc = { set: function(h, k, O) {
              return k === !1 ? D.removeAttr(h, O) : h.setAttribute(O, O), O;
            } }, D.each(D.expr.match.bool.source.match(/\w+/g), function(h, k) {
              var O = qu[k] || D.find.attr;
              qu[k] = function(L, $, U) {
                var G, ue, he = $.toLowerCase();
                return U || (ue = qu[he], qu[he] = G, G = O(L, $, U) != null ? he : null, qu[he] = ue), G;
              };
            });
            var Vc = /^(?:input|select|textarea|button)$/i, Uc = /^(?:a|area)$/i;
            function Ts(h) {
              return (h.match(Ze) || []).join(" ");
            }
            function co(h) {
              return h.getAttribute && h.getAttribute("class") || "";
            }
            function kd(h) {
              return Array.isArray(h) ? h : typeof h == "string" && h.match(Ze) || [];
            }
            D.fn.extend({ prop: function(h, k) {
              return At(this, D.prop, h, k, arguments.length > 1);
            }, removeProp: function(h) {
              return this.each(function() {
                delete this[D.propFix[h] || h];
              });
            } }), D.extend({ prop: function(h, k, O) {
              var L, $, U = h.nodeType;
              if (U !== 3 && U !== 8 && U !== 2) return U === 1 && D.isXMLDoc(h) || (k = D.propFix[k] || k, $ = D.propHooks[k]), O !== void 0 ? $ && "set" in $ && (L = $.set(h, O, k)) !== void 0 ? L : h[k] = O : $ && "get" in $ && (L = $.get(h, k)) !== null ? L : h[k];
            }, propHooks: { tabIndex: { get: function(h) {
              var k = D.find.attr(h, "tabindex");
              return k ? parseInt(k, 10) : Vc.test(h.nodeName) || Uc.test(h.nodeName) && h.href ? 0 : -1;
            } } }, propFix: { for: "htmlFor", class: "className" } }), M.optSelected || (D.propHooks.selected = { get: function(h) {
              var k = h.parentNode;
              return k && k.parentNode && k.parentNode.selectedIndex, null;
            }, set: function(h) {
              var k = h.parentNode;
              k && (k.selectedIndex, k.parentNode && k.parentNode.selectedIndex);
            } }), D.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
              D.propFix[this.toLowerCase()] = this;
            }), D.fn.extend({ addClass: function(h) {
              var k, O, L, $, U, G, ue, he = 0;
              if (R(h)) return this.each(function(we) {
                D(this).addClass(h.call(this, we, co(this)));
              });
              if ((k = kd(h)).length) {
                for (; O = this[he++]; ) if ($ = co(O), L = O.nodeType === 1 && " " + Ts($) + " ") {
                  for (G = 0; U = k[G++]; ) L.indexOf(" " + U + " ") < 0 && (L += U + " ");
                  $ !== (ue = Ts(L)) && O.setAttribute("class", ue);
                }
              }
              return this;
            }, removeClass: function(h) {
              var k, O, L, $, U, G, ue, he = 0;
              if (R(h)) return this.each(function(we) {
                D(this).removeClass(h.call(this, we, co(this)));
              });
              if (!arguments.length) return this.attr("class", "");
              if ((k = kd(h)).length) {
                for (; O = this[he++]; ) if ($ = co(O), L = O.nodeType === 1 && " " + Ts($) + " ") {
                  for (G = 0; U = k[G++]; ) for (; L.indexOf(" " + U + " ") > -1; ) L = L.replace(" " + U + " ", " ");
                  $ !== (ue = Ts(L)) && O.setAttribute("class", ue);
                }
              }
              return this;
            }, toggleClass: function(h, k) {
              var O = typeof h, L = O === "string" || Array.isArray(h);
              return typeof k == "boolean" && L ? k ? this.addClass(h) : this.removeClass(h) : R(h) ? this.each(function($) {
                D(this).toggleClass(h.call(this, $, co(this), k), k);
              }) : this.each(function() {
                var $, U, G, ue;
                if (L) for (U = 0, G = D(this), ue = kd(h); $ = ue[U++]; ) G.hasClass($) ? G.removeClass($) : G.addClass($);
                else h !== void 0 && O !== "boolean" || (($ = co(this)) && rt.set(this, "__className__", $), this.setAttribute && this.setAttribute("class", $ || h === !1 ? "" : rt.get(this, "__className__") || ""));
              });
            }, hasClass: function(h) {
              var k, O, L = 0;
              for (k = " " + h + " "; O = this[L++]; ) if (O.nodeType === 1 && (" " + Ts(co(O)) + " ").indexOf(k) > -1) return !0;
              return !1;
            } });
            var F2 = /\r/g;
            D.fn.extend({ val: function(h) {
              var k, O, L, $ = this[0];
              return arguments.length ? (L = R(h), this.each(function(U) {
                var G;
                this.nodeType === 1 && ((G = L ? h.call(this, U, D(this).val()) : h) == null ? G = "" : typeof G == "number" ? G += "" : Array.isArray(G) && (G = D.map(G, function(ue) {
                  return ue == null ? "" : ue + "";
                })), (k = D.valHooks[this.type] || D.valHooks[this.nodeName.toLowerCase()]) && "set" in k && k.set(this, G, "value") !== void 0 || (this.value = G));
              })) : $ ? (k = D.valHooks[$.type] || D.valHooks[$.nodeName.toLowerCase()]) && "get" in k && (O = k.get($, "value")) !== void 0 ? O : typeof (O = $.value) == "string" ? O.replace(F2, "") : O ?? "" : void 0;
            } }), D.extend({ valHooks: { option: { get: function(h) {
              var k = D.find.attr(h, "value");
              return k ?? Ts(D.text(h));
            } }, select: { get: function(h) {
              var k, O, L, $ = h.options, U = h.selectedIndex, G = h.type === "select-one", ue = G ? null : [], he = G ? U + 1 : $.length;
              for (L = U < 0 ? he : G ? U : 0; L < he; L++) if (((O = $[L]).selected || L === U) && !O.disabled && (!O.parentNode.disabled || !Ie(O.parentNode, "optgroup"))) {
                if (k = D(O).val(), G) return k;
                ue.push(k);
              }
              return ue;
            }, set: function(h, k) {
              for (var O, L, $ = h.options, U = D.makeArray(k), G = $.length; G--; ) ((L = $[G]).selected = D.inArray(D.valHooks.option.get(L), U) > -1) && (O = !0);
              return O || (h.selectedIndex = -1), U;
            } } } }), D.each(["radio", "checkbox"], function() {
              D.valHooks[this] = { set: function(h, k) {
                if (Array.isArray(k)) return h.checked = D.inArray(D(h).val(), k) > -1;
              } }, M.checkOn || (D.valHooks[this].get = function(h) {
                return h.getAttribute("value") === null ? "on" : h.value;
              });
            }), M.focusin = "onfocusin" in p;
            var wr = /^(?:focusinfocus|focusoutblur)$/, js = function(h) {
              h.stopPropagation();
            };
            D.extend(D.event, { trigger: function(h, k, O, L) {
              var $, U, G, ue, he, we, Fe, Re, De = [O || W], je = z.call(h, "type") ? h.type : h, Ct = z.call(h, "namespace") ? h.namespace.split(".") : [];
              if (U = Re = G = O = O || W, O.nodeType !== 3 && O.nodeType !== 8 && !wr.test(je + D.event.triggered) && (je.indexOf(".") > -1 && (Ct = je.split("."), je = Ct.shift(), Ct.sort()), he = je.indexOf(":") < 0 && "on" + je, (h = h[D.expando] ? h : new D.Event(je, typeof h == "object" && h)).isTrigger = L ? 2 : 3, h.namespace = Ct.join("."), h.rnamespace = h.namespace ? new RegExp("(^|\\.)" + Ct.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, h.result = void 0, h.target || (h.target = O), k = k == null ? [h] : D.makeArray(k, [h]), Fe = D.event.special[je] || {}, L || !Fe.trigger || Fe.trigger.apply(O, k) !== !1)) {
                if (!L && !Fe.noBubble && !F(O)) {
                  for (ue = Fe.delegateType || je, wr.test(ue + je) || (U = U.parentNode); U; U = U.parentNode) De.push(U), G = U;
                  G === (O.ownerDocument || W) && De.push(G.defaultView || G.parentWindow || p);
                }
                for ($ = 0; (U = De[$++]) && !h.isPropagationStopped(); ) Re = U, h.type = $ > 1 ? ue : Fe.bindType || je, (we = (rt.get(U, "events") || /* @__PURE__ */ Object.create(null))[h.type] && rt.get(U, "handle")) && we.apply(U, k), (we = he && U[he]) && we.apply && $e(U) && (h.result = we.apply(U, k), h.result === !1 && h.preventDefault());
                return h.type = je, L || h.isDefaultPrevented() || Fe._default && Fe._default.apply(De.pop(), k) !== !1 || !$e(O) || he && R(O[je]) && !F(O) && ((G = O[he]) && (O[he] = null), D.event.triggered = je, h.isPropagationStopped() && Re.addEventListener(je, js), O[je](), h.isPropagationStopped() && Re.removeEventListener(je, js), D.event.triggered = void 0, G && (O[he] = G)), h.result;
              }
            }, simulate: function(h, k, O) {
              var L = D.extend(new D.Event(), O, { type: h, isSimulated: !0 });
              D.event.trigger(L, null, k);
            } }), D.fn.extend({ trigger: function(h, k) {
              return this.each(function() {
                D.event.trigger(h, k, this);
              });
            }, triggerHandler: function(h, k) {
              var O = this[0];
              if (O) return D.event.trigger(h, k, O, !0);
            } }), M.focusin || D.each({ focus: "focusin", blur: "focusout" }, function(h, k) {
              var O = function(L) {
                D.event.simulate(k, L.target, D.event.fix(L));
              };
              D.event.special[k] = { setup: function() {
                var L = this.ownerDocument || this.document || this, $ = rt.access(L, k);
                $ || L.addEventListener(h, O, !0), rt.access(L, k, ($ || 0) + 1);
              }, teardown: function() {
                var L = this.ownerDocument || this.document || this, $ = rt.access(L, k) - 1;
                $ ? rt.access(L, k, $) : (L.removeEventListener(h, O, !0), rt.remove(L, k));
              } };
            });
            var $u = p.location, Ed = { guid: Date.now() }, Hu = /\?/;
            D.parseXML = function(h) {
              var k, O;
              if (!h || typeof h != "string") return null;
              try {
                k = new p.DOMParser().parseFromString(h, "text/xml");
              } catch {
              }
              return O = k && k.getElementsByTagName("parsererror")[0], k && !O || D.error("Invalid XML: " + (O ? D.map(O.childNodes, function(L) {
                return L.textContent;
              }).join(`
`) : h)), k;
            };
            var eh = /\[\]$/, Sd = /\r?\n/g, L2 = /^(?:submit|button|image|reset|file)$/i, Ns = /^(?:input|select|textarea|keygen)/i;
            function Dl(h, k, O, L) {
              var $;
              if (Array.isArray(k)) D.each(k, function(U, G) {
                O || eh.test(h) ? L(h, G) : Dl(h + "[" + (typeof G == "object" && G != null ? U : "") + "]", G, O, L);
              });
              else if (O || ne(k) !== "object") L(h, k);
              else for ($ in k) Dl(h + "[" + $ + "]", k[$], O, L);
            }
            D.param = function(h, k) {
              var O, L = [], $ = function(U, G) {
                var ue = R(G) ? G() : G;
                L[L.length] = encodeURIComponent(U) + "=" + encodeURIComponent(ue ?? "");
              };
              if (h == null) return "";
              if (Array.isArray(h) || h.jquery && !D.isPlainObject(h)) D.each(h, function() {
                $(this.name, this.value);
              });
              else for (O in h) Dl(O, h[O], k, $);
              return L.join("&");
            }, D.fn.extend({ serialize: function() {
              return D.param(this.serializeArray());
            }, serializeArray: function() {
              return this.map(function() {
                var h = D.prop(this, "elements");
                return h ? D.makeArray(h) : this;
              }).filter(function() {
                var h = this.type;
                return this.name && !D(this).is(":disabled") && Ns.test(this.nodeName) && !L2.test(h) && (this.checked || !Ca.test(h));
              }).map(function(h, k) {
                var O = D(this).val();
                return O == null ? null : Array.isArray(O) ? D.map(O, function(L) {
                  return { name: k.name, value: L.replace(Sd, `\r
`) };
                }) : { name: k.name, value: O.replace(Sd, `\r
`) };
              }).get();
            } });
            var th = /%20/g, nh = /#.*$/, Dd = /([?&])_=[^&]*/, rh = /^(.*?):[ \t]*([^\r\n]*)$/gm, Ea = /^(?:GET|HEAD)$/, ih = /^\/\//, Ad = {}, Wc = {}, Td = "*/".concat("*"), jd = W.createElement("a");
            function se(h) {
              return function(k, O) {
                typeof k != "string" && (O = k, k = "*");
                var L, $ = 0, U = k.toLowerCase().match(Ze) || [];
                if (R(O)) for (; L = U[$++]; ) L[0] === "+" ? (L = L.slice(1) || "*", (h[L] = h[L] || []).unshift(O)) : (h[L] = h[L] || []).push(O);
              };
            }
            function yt(h, k, O, L) {
              var $ = {}, U = h === Wc;
              function G(ue) {
                var he;
                return $[ue] = !0, D.each(h[ue] || [], function(we, Fe) {
                  var Re = Fe(k, O, L);
                  return typeof Re != "string" || U || $[Re] ? U ? !(he = Re) : void 0 : (k.dataTypes.unshift(Re), G(Re), !1);
                }), he;
              }
              return G(k.dataTypes[0]) || !$["*"] && G("*");
            }
            function lt(h, k) {
              var O, L, $ = D.ajaxSettings.flatOptions || {};
              for (O in k) k[O] !== void 0 && (($[O] ? h : L || (L = {}))[O] = k[O]);
              return L && D.extend(!0, h, L), h;
            }
            jd.href = $u.href, D.extend({ active: 0, lastModified: {}, etag: {}, ajaxSettings: { url: $u.href, type: "GET", isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test($u.protocol), global: !0, processData: !0, async: !0, contentType: "application/x-www-form-urlencoded; charset=UTF-8", accepts: { "*": Td, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" }, contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ }, responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" }, converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": D.parseXML }, flatOptions: { url: !0, context: !0 } }, ajaxSetup: function(h, k) {
              return k ? lt(lt(h, D.ajaxSettings), k) : lt(D.ajaxSettings, h);
            }, ajaxPrefilter: se(Ad), ajaxTransport: se(Wc), ajax: function(h, k) {
              typeof h == "object" && (k = h, h = void 0), k = k || {};
              var O, L, $, U, G, ue, he, we, Fe, Re, De = D.ajaxSetup({}, k), je = De.context || De, Ct = De.context && (je.nodeType || je.jquery) ? D(je) : D.event, Mt = D.Deferred(), kt = D.Callbacks("once memory"), rr = De.statusCode || {}, Ir = {}, po = {}, En = "canceled", Ht = { readyState: 0, getResponseHeader: function(fn) {
                var ir;
                if (he) {
                  if (!U) for (U = {}; ir = rh.exec($); ) U[ir[1].toLowerCase() + " "] = (U[ir[1].toLowerCase() + " "] || []).concat(ir[2]);
                  ir = U[fn.toLowerCase() + " "];
                }
                return ir == null ? null : ir.join(", ");
              }, getAllResponseHeaders: function() {
                return he ? $ : null;
              }, setRequestHeader: function(fn, ir) {
                return he == null && (fn = po[fn.toLowerCase()] = po[fn.toLowerCase()] || fn, Ir[fn] = ir), this;
              }, overrideMimeType: function(fn) {
                return he == null && (De.mimeType = fn), this;
              }, statusCode: function(fn) {
                var ir;
                if (fn) if (he) Ht.always(fn[Ht.status]);
                else for (ir in fn) rr[ir] = [rr[ir], fn[ir]];
                return this;
              }, abort: function(fn) {
                var ir = fn || En;
                return O && O.abort(ir), Hi(0, ir), this;
              } };
              if (Mt.promise(Ht), De.url = ((h || De.url || $u.href) + "").replace(ih, $u.protocol + "//"), De.type = k.method || k.type || De.method || De.type, De.dataTypes = (De.dataType || "*").toLowerCase().match(Ze) || [""], De.crossDomain == null) {
                ue = W.createElement("a");
                try {
                  ue.href = De.url, ue.href = ue.href, De.crossDomain = jd.protocol + "//" + jd.host != ue.protocol + "//" + ue.host;
                } catch {
                  De.crossDomain = !0;
                }
              }
              if (De.data && De.processData && typeof De.data != "string" && (De.data = D.param(De.data, De.traditional)), yt(Ad, De, k, Ht), he) return Ht;
              for (Fe in (we = D.event && De.global) && D.active++ == 0 && D.event.trigger("ajaxStart"), De.type = De.type.toUpperCase(), De.hasContent = !Ea.test(De.type), L = De.url.replace(nh, ""), De.hasContent ? De.data && De.processData && (De.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && (De.data = De.data.replace(th, "+")) : (Re = De.url.slice(L.length), De.data && (De.processData || typeof De.data == "string") && (L += (Hu.test(L) ? "&" : "?") + De.data, delete De.data), De.cache === !1 && (L = L.replace(Dd, "$1"), Re = (Hu.test(L) ? "&" : "?") + "_=" + Ed.guid++ + Re), De.url = L + Re), De.ifModified && (D.lastModified[L] && Ht.setRequestHeader("If-Modified-Since", D.lastModified[L]), D.etag[L] && Ht.setRequestHeader("If-None-Match", D.etag[L])), (De.data && De.hasContent && De.contentType !== !1 || k.contentType) && Ht.setRequestHeader("Content-Type", De.contentType), Ht.setRequestHeader("Accept", De.dataTypes[0] && De.accepts[De.dataTypes[0]] ? De.accepts[De.dataTypes[0]] + (De.dataTypes[0] !== "*" ? ", " + Td + "; q=0.01" : "") : De.accepts["*"]), De.headers) Ht.setRequestHeader(Fe, De.headers[Fe]);
              if (De.beforeSend && (De.beforeSend.call(je, Ht, De) === !1 || he)) return Ht.abort();
              if (En = "abort", kt.add(De.complete), Ht.done(De.success), Ht.fail(De.error), O = yt(Wc, De, k, Ht)) {
                if (Ht.readyState = 1, we && Ct.trigger("ajaxSend", [Ht, De]), he) return Ht;
                De.async && De.timeout > 0 && (G = p.setTimeout(function() {
                  Ht.abort("timeout");
                }, De.timeout));
                try {
                  he = !1, O.send(Ir, Hi);
                } catch (fn) {
                  if (he) throw fn;
                  Hi(-1, fn);
                }
              } else Hi(-1, "No Transport");
              function Hi(fn, ir, Nd, ah) {
                var fo, Vu, Zc, Vi, Gc, Go = ir;
                he || (he = !0, G && p.clearTimeout(G), O = void 0, $ = ah || "", Ht.readyState = fn > 0 ? 4 : 0, fo = fn >= 200 && fn < 300 || fn === 304, Nd && (Vi = function(or, ho, mo) {
                  for (var Xa, Dr, mn, Rr, go = or.contents, Ar = or.dataTypes; Ar[0] === "*"; ) Ar.shift(), Xa === void 0 && (Xa = or.mimeType || ho.getResponseHeader("Content-Type"));
                  if (Xa) {
                    for (Dr in go) if (go[Dr] && go[Dr].test(Xa)) {
                      Ar.unshift(Dr);
                      break;
                    }
                  }
                  if (Ar[0] in mo) mn = Ar[0];
                  else {
                    for (Dr in mo) {
                      if (!Ar[0] || or.converters[Dr + " " + Ar[0]]) {
                        mn = Dr;
                        break;
                      }
                      Rr || (Rr = Dr);
                    }
                    mn = mn || Rr;
                  }
                  if (mn) return mn !== Ar[0] && Ar.unshift(mn), mo[mn];
                }(De, Ht, Nd)), !fo && D.inArray("script", De.dataTypes) > -1 && D.inArray("json", De.dataTypes) < 0 && (De.converters["text script"] = function() {
                }), Vi = function(or, ho, mo, Xa) {
                  var Dr, mn, Rr, go, Ar, vo = {}, Kc = or.dataTypes.slice();
                  if (Kc[1]) for (Rr in or.converters) vo[Rr.toLowerCase()] = or.converters[Rr];
                  for (mn = Kc.shift(); mn; ) if (or.responseFields[mn] && (mo[or.responseFields[mn]] = ho), !Ar && Xa && or.dataFilter && (ho = or.dataFilter(ho, or.dataType)), Ar = mn, mn = Kc.shift()) {
                    if (mn === "*") mn = Ar;
                    else if (Ar !== "*" && Ar !== mn) {
                      if (!(Rr = vo[Ar + " " + mn] || vo["* " + mn])) {
                        for (Dr in vo) if ((go = Dr.split(" "))[1] === mn && (Rr = vo[Ar + " " + go[0]] || vo["* " + go[0]])) {
                          Rr === !0 ? Rr = vo[Dr] : vo[Dr] !== !0 && (mn = go[0], Kc.unshift(go[1]));
                          break;
                        }
                      }
                      if (Rr !== !0) if (Rr && or.throws) ho = Rr(ho);
                      else try {
                        ho = Rr(ho);
                      } catch (sh) {
                        return { state: "parsererror", error: Rr ? sh : "No conversion from " + Ar + " to " + mn };
                      }
                    }
                  }
                  return { state: "success", data: ho };
                }(De, Vi, Ht, fo), fo ? (De.ifModified && ((Gc = Ht.getResponseHeader("Last-Modified")) && (D.lastModified[L] = Gc), (Gc = Ht.getResponseHeader("etag")) && (D.etag[L] = Gc)), fn === 204 || De.type === "HEAD" ? Go = "nocontent" : fn === 304 ? Go = "notmodified" : (Go = Vi.state, Vu = Vi.data, fo = !(Zc = Vi.error))) : (Zc = Go, !fn && Go || (Go = "error", fn < 0 && (fn = 0))), Ht.status = fn, Ht.statusText = (ir || Go) + "", fo ? Mt.resolveWith(je, [Vu, Go, Ht]) : Mt.rejectWith(je, [Ht, Go, Zc]), Ht.statusCode(rr), rr = void 0, we && Ct.trigger(fo ? "ajaxSuccess" : "ajaxError", [Ht, De, fo ? Vu : Zc]), kt.fireWith(je, [Ht, Go]), we && (Ct.trigger("ajaxComplete", [Ht, De]), --D.active || D.event.trigger("ajaxStop")));
              }
              return Ht;
            }, getJSON: function(h, k, O) {
              return D.get(h, k, O, "json");
            }, getScript: function(h, k) {
              return D.get(h, void 0, k, "script");
            } }), D.each(["get", "post"], function(h, k) {
              D[k] = function(O, L, $, U) {
                return R(L) && (U = U || $, $ = L, L = void 0), D.ajax(D.extend({ url: O, type: k, dataType: U, data: L, success: $ }, D.isPlainObject(O) && O));
              };
            }), D.ajaxPrefilter(function(h) {
              var k;
              for (k in h.headers) k.toLowerCase() === "content-type" && (h.contentType = h.headers[k] || "");
            }), D._evalUrl = function(h, k, O) {
              return D.ajax({ url: h, type: "GET", dataType: "script", cache: !0, async: !1, global: !1, converters: { "text script": function() {
              } }, dataFilter: function(L) {
                D.globalEval(L, k, O);
              } });
            }, D.fn.extend({ wrapAll: function(h) {
              var k;
              return this[0] && (R(h) && (h = h.call(this[0])), k = D(h, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && k.insertBefore(this[0]), k.map(function() {
                for (var O = this; O.firstElementChild; ) O = O.firstElementChild;
                return O;
              }).append(this)), this;
            }, wrapInner: function(h) {
              return R(h) ? this.each(function(k) {
                D(this).wrapInner(h.call(this, k));
              }) : this.each(function() {
                var k = D(this), O = k.contents();
                O.length ? O.wrapAll(h) : k.append(h);
              });
            }, wrap: function(h) {
              var k = R(h);
              return this.each(function(O) {
                D(this).wrapAll(k ? h.call(this, O) : h);
              });
            }, unwrap: function(h) {
              return this.parent(h).not("body").each(function() {
                D(this).replaceWith(this.childNodes);
              }), this;
            } }), D.expr.pseudos.hidden = function(h) {
              return !D.expr.pseudos.visible(h);
            }, D.expr.pseudos.visible = function(h) {
              return !!(h.offsetWidth || h.offsetHeight || h.getClientRects().length);
            }, D.ajaxSettings.xhr = function() {
              try {
                return new p.XMLHttpRequest();
              } catch {
              }
            };
            var hn = { 0: 200, 1223: 204 }, tr = D.ajaxSettings.xhr();
            M.cors = !!tr && "withCredentials" in tr, M.ajax = tr = !!tr, D.ajaxTransport(function(h) {
              var k, O;
              if (M.cors || tr && !h.crossDomain) return { send: function(L, $) {
                var U, G = h.xhr();
                if (G.open(h.type, h.url, h.async, h.username, h.password), h.xhrFields) for (U in h.xhrFields) G[U] = h.xhrFields[U];
                for (U in h.mimeType && G.overrideMimeType && G.overrideMimeType(h.mimeType), h.crossDomain || L["X-Requested-With"] || (L["X-Requested-With"] = "XMLHttpRequest"), L) G.setRequestHeader(U, L[U]);
                k = function(ue) {
                  return function() {
                    k && (k = O = G.onload = G.onerror = G.onabort = G.ontimeout = G.onreadystatechange = null, ue === "abort" ? G.abort() : ue === "error" ? typeof G.status != "number" ? $(0, "error") : $(G.status, G.statusText) : $(hn[G.status] || G.status, G.statusText, (G.responseType || "text") !== "text" || typeof G.responseText != "string" ? { binary: G.response } : { text: G.responseText }, G.getAllResponseHeaders()));
                  };
                }, G.onload = k(), O = G.onerror = G.ontimeout = k("error"), G.onabort !== void 0 ? G.onabort = O : G.onreadystatechange = function() {
                  G.readyState === 4 && p.setTimeout(function() {
                    k && O();
                  });
                }, k = k("abort");
                try {
                  G.send(h.hasContent && h.data || null);
                } catch (ue) {
                  if (k) throw ue;
                }
              }, abort: function() {
                k && k();
              } };
            }), D.ajaxPrefilter(function(h) {
              h.crossDomain && (h.contents.script = !1);
            }), D.ajaxSetup({ accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" }, contents: { script: /\b(?:java|ecma)script\b/ }, converters: { "text script": function(h) {
              return D.globalEval(h), h;
            } } }), D.ajaxPrefilter("script", function(h) {
              h.cache === void 0 && (h.cache = !1), h.crossDomain && (h.type = "GET");
            }), D.ajaxTransport("script", function(h) {
              var k, O;
              if (h.crossDomain || h.scriptAttrs) return { send: function(L, $) {
                k = D("<script>").attr(h.scriptAttrs || {}).prop({ charset: h.scriptCharset, src: h.url }).on("load error", O = function(U) {
                  k.remove(), O = null, U && $(U.type === "error" ? 404 : 200, U.type);
                }), W.head.appendChild(k[0]);
              }, abort: function() {
                O && O();
              } };
            });
            var nr, Wo = [], ci = /(=)\?(?=&|$)|\?\?/;
            D.ajaxSetup({ jsonp: "callback", jsonpCallback: function() {
              var h = Wo.pop() || D.expando + "_" + Ed.guid++;
              return this[h] = !0, h;
            } }), D.ajaxPrefilter("json jsonp", function(h, k, O) {
              var L, $, U, G = h.jsonp !== !1 && (ci.test(h.url) ? "url" : typeof h.data == "string" && (h.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && ci.test(h.data) && "data");
              if (G || h.dataTypes[0] === "jsonp") return L = h.jsonpCallback = R(h.jsonpCallback) ? h.jsonpCallback() : h.jsonpCallback, G ? h[G] = h[G].replace(ci, "$1" + L) : h.jsonp !== !1 && (h.url += (Hu.test(h.url) ? "&" : "?") + h.jsonp + "=" + L), h.converters["script json"] = function() {
                return U || D.error(L + " was not called"), U[0];
              }, h.dataTypes[0] = "json", $ = p[L], p[L] = function() {
                U = arguments;
              }, O.always(function() {
                $ === void 0 ? D(p).removeProp(L) : p[L] = $, h[L] && (h.jsonpCallback = k.jsonpCallback, Wo.push(L)), U && R($) && $(U[0]), U = $ = void 0;
              }), "script";
            }), M.createHTMLDocument = ((nr = W.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", nr.childNodes.length === 2), D.parseHTML = function(h, k, O) {
              return typeof h != "string" ? [] : (typeof k == "boolean" && (O = k, k = !1), k || (M.createHTMLDocument ? ((L = (k = W.implementation.createHTMLDocument("")).createElement("base")).href = W.location.href, k.head.appendChild(L)) : k = W), U = !O && [], ($ = at.exec(h)) ? [k.createElement($[1])] : ($ = Cl([h], k, U), U && U.length && D(U).remove(), D.merge([], $.childNodes)));
              var L, $, U;
            }, D.fn.load = function(h, k, O) {
              var L, $, U, G = this, ue = h.indexOf(" ");
              return ue > -1 && (L = Ts(h.slice(ue)), h = h.slice(0, ue)), R(k) ? (O = k, k = void 0) : k && typeof k == "object" && ($ = "POST"), G.length > 0 && D.ajax({ url: h, type: $ || "GET", dataType: "html", data: k }).done(function(he) {
                U = arguments, G.html(L ? D("<div>").append(D.parseHTML(he)).find(L) : he);
              }).always(O && function(he, we) {
                G.each(function() {
                  O.apply(this, U || [he.responseText, we, he]);
                });
              }), this;
            }, D.expr.pseudos.animated = function(h) {
              return D.grep(D.timers, function(k) {
                return h === k.elem;
              }).length;
            }, D.offset = { setOffset: function(h, k, O) {
              var L, $, U, G, ue, he, we = D.css(h, "position"), Fe = D(h), Re = {};
              we === "static" && (h.style.position = "relative"), ue = Fe.offset(), U = D.css(h, "top"), he = D.css(h, "left"), (we === "absolute" || we === "fixed") && (U + he).indexOf("auto") > -1 ? (G = (L = Fe.position()).top, $ = L.left) : (G = parseFloat(U) || 0, $ = parseFloat(he) || 0), R(k) && (k = k.call(h, O, D.extend({}, ue))), k.top != null && (Re.top = k.top - ue.top + G), k.left != null && (Re.left = k.left - ue.left + $), "using" in k ? k.using.call(h, Re) : Fe.css(Re);
            } }, D.fn.extend({ offset: function(h) {
              if (arguments.length) return h === void 0 ? this : this.each(function($) {
                D.offset.setOffset(this, h, $);
              });
              var k, O, L = this[0];
              return L ? L.getClientRects().length ? (k = L.getBoundingClientRect(), O = L.ownerDocument.defaultView, { top: k.top + O.pageYOffset, left: k.left + O.pageXOffset }) : { top: 0, left: 0 } : void 0;
            }, position: function() {
              if (this[0]) {
                var h, k, O, L = this[0], $ = { top: 0, left: 0 };
                if (D.css(L, "position") === "fixed") k = L.getBoundingClientRect();
                else {
                  for (k = this.offset(), O = L.ownerDocument, h = L.offsetParent || O.documentElement; h && (h === O.body || h === O.documentElement) && D.css(h, "position") === "static"; ) h = h.parentNode;
                  h && h !== L && h.nodeType === 1 && (($ = D(h).offset()).top += D.css(h, "borderTopWidth", !0), $.left += D.css(h, "borderLeftWidth", !0));
                }
                return { top: k.top - $.top - D.css(L, "marginTop", !0), left: k.left - $.left - D.css(L, "marginLeft", !0) };
              }
            }, offsetParent: function() {
              return this.map(function() {
                for (var h = this.offsetParent; h && D.css(h, "position") === "static"; ) h = h.offsetParent;
                return h || xe;
              });
            } }), D.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(h, k) {
              var O = k === "pageYOffset";
              D.fn[h] = function(L) {
                return At(this, function($, U, G) {
                  var ue;
                  if (F($) ? ue = $ : $.nodeType === 9 && (ue = $.defaultView), G === void 0) return ue ? ue[k] : $[U];
                  ue ? ue.scrollTo(O ? ue.pageXOffset : G, O ? G : ue.pageYOffset) : $[U] = G;
                }, h, L, arguments.length);
              };
            }), D.each(["top", "left"], function(h, k) {
              D.cssHooks[k] = P(M.pixelPosition, function(O, L) {
                if (L) return L = A(O, k), Ss.test(L) ? D(O).position()[k] + "px" : L;
              });
            }), D.each({ Height: "height", Width: "width" }, function(h, k) {
              D.each({ padding: "inner" + h, content: k, "": "outer" + h }, function(O, L) {
                D.fn[L] = function($, U) {
                  var G = arguments.length && (O || typeof $ != "boolean"), ue = O || ($ === !0 || U === !0 ? "margin" : "border");
                  return At(this, function(he, we, Fe) {
                    var Re;
                    return F(he) ? L.indexOf("outer") === 0 ? he["inner" + h] : he.document.documentElement["client" + h] : he.nodeType === 9 ? (Re = he.documentElement, Math.max(he.body["scroll" + h], Re["scroll" + h], he.body["offset" + h], Re["offset" + h], Re["client" + h])) : Fe === void 0 ? D.css(he, we, ue) : D.style(he, we, Fe, ue);
                  }, k, G ? $ : void 0, G);
                };
              });
            }), D.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(h, k) {
              D.fn[k] = function(O) {
                return this.on(k, O);
              };
            }), D.fn.extend({ bind: function(h, k, O) {
              return this.on(h, null, k, O);
            }, unbind: function(h, k) {
              return this.off(h, null, k);
            }, delegate: function(h, k, O, L) {
              return this.on(k, h, O, L);
            }, undelegate: function(h, k, O) {
              return arguments.length === 1 ? this.off(h, "**") : this.off(k, h || "**", O);
            }, hover: function(h, k) {
              return this.mouseenter(h).mouseleave(k || h);
            } }), D.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(h, k) {
              D.fn[k] = function(O, L) {
                return arguments.length > 0 ? this.on(k, null, O, L) : this.trigger(k);
              };
            });
            var Zo = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
            D.proxy = function(h, k) {
              var O, L, $;
              if (typeof k == "string" && (O = h[k], k = h, h = O), R(h)) return L = g.call(arguments, 2), $ = function() {
                return h.apply(k || this, L.concat(g.call(arguments)));
              }, $.guid = h.guid = h.guid || D.guid++, $;
            }, D.holdReady = function(h) {
              h ? D.readyWait++ : D.ready(!0);
            }, D.isArray = Array.isArray, D.parseJSON = JSON.parse, D.nodeName = Ie, D.isFunction = R, D.isWindow = F, D.camelCase = re, D.type = ne, D.now = Date.now, D.isNumeric = function(h) {
              var k = D.type(h);
              return (k === "number" || k === "string") && !isNaN(h - parseFloat(h));
            }, D.trim = function(h) {
              return h == null ? "" : (h + "").replace(Zo, "");
            }, (d = (function() {
              return D;
            }).apply(u, [])) === void 0 || (l.exports = d);
            var Xr = p.jQuery, oh = p.$;
            return D.noConflict = function(h) {
              return p.$ === D && (p.$ = oh), h && p.jQuery === D && (p.jQuery = Xr), D;
            }, f === void 0 && (p.jQuery = p.$ = D), D;
          });
        }, 703: (l, u, d) => {
          var p = d(414);
          function f() {
          }
          function m() {
          }
          m.resetWarningCache = f, l.exports = function() {
            function y(E, b, C, T, z, I) {
              if (I !== p) {
                var w = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw w.name = "Invariant Violation", w;
              }
            }
            function g() {
              return y;
            }
            y.isRequired = y;
            var x = { array: y, bool: y, func: y, number: y, object: y, string: y, symbol: y, any: y, arrayOf: g, element: y, elementType: y, instanceOf: g, node: y, objectOf: g, oneOf: g, oneOfType: g, shape: g, exact: g, checkPropTypes: m, resetWarningCache: f };
            return x.PropTypes = x, x;
          };
        }, 697: (l, u, d) => {
          l.exports = d(703)();
        }, 414: (l) => {
          l.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        }, 156: (l) => {
          l.exports = r;
        } }, o = {};
        function a(l) {
          var u = o[l];
          if (u !== void 0) return u.exports;
          var d = o[l] = { id: l, exports: {} };
          return i[l].call(d.exports, d, d.exports, a), d.exports;
        }
        a.n = (l) => {
          var u = l && l.__esModule ? () => l.default : () => l;
          return a.d(u, { a: u }), u;
        }, a.d = (l, u) => {
          for (var d in u) a.o(u, d) && !a.o(l, d) && Object.defineProperty(l, d, { enumerable: !0, get: u[d] });
        }, a.o = (l, u) => Object.prototype.hasOwnProperty.call(l, u), a.r = (l) => {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(l, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(l, "__esModule", { value: !0 });
        };
        var s = {};
        return (() => {
          a.r(s), a.d(s, { addStyles: () => u, EditableMathField: () => d, StaticMathField: () => p, default: () => f });
          var l = a(527);
          function u() {
            if (document.getElementById("react-mathquill-styles") == null) {
              var m = document.createElement("style");
              m.setAttribute("id", "react-mathquill-styles"), m.innerHTML = l.Z[0][1], document.getElementsByTagName("head")[0].appendChild(m);
            }
          }
          var d = a(991).Z, p = a(717).Z;
          const f = d;
        })(), s;
      })();
    });
  }(a9)), a9.exports;
}
typeof window > "u" ? j5.exports = {} : j5.exports = _ae();
var Lz = j5.exports;
typeof window < "u" && Lz.addStyles();
function qae() {
  return Pae() && navigator && /(android)/i.test(navigator.userAgent);
}
function $ae() {
  const e = document.createElement("input");
  return e.setAttribute("type", "password"), e;
}
function Hae(e, t) {
  const n = e[0];
  n.value = " ", n.addEventListener("input", () => {
    const r = n.value;
    r.length === 2 ? t.typedText(r.charAt(1)) : r.length === 0 && t.keystroke("Backspace", { preventDefault: () => null }), setTimeout(() => {
      n.value = " ";
    });
  });
}
function Vae(e) {
  const t = {
    supSubsRequireOperand: !0,
    autoCommands: "pi alpha beta gamma delta",
    handlers: {
      moveOutOf: (r) => {
        r === 1 && typeof e.onMoveOutRight == "function" ? e.onMoveOutRight() : r === -1 && typeof e.onMoveOutLeft == "function" && e.onMoveOutLeft();
      },
      deleteOutOf: (r) => {
        r === 1 && typeof e.onDeleteOutRight == "function" ? e.onDeleteOutRight() : r === -1 && typeof e.onDeleteOutLeft == "function" && e.onDeleteOutLeft();
      },
      upOutOf: (r) => {
        r.typedText("^");
      },
      downOutOf: (r) => {
        r.typedText("_");
      }
    },
    ...qae() ? {
      substituteTextarea: $ae,
      substituteKeyboardEvents: Hae
    } : {}
  };
  return /* @__PURE__ */ c.jsx(
    "div",
    {
      className: Le(`
        [&_textarea]:!focus:border-none [&_textarea]:!focus:outline-none
        rounded-sm focus-within:outline focus-within:outline-2
        focus-within:outline-offset-1 focus-within:outline-editor-primary
        [&_.mq-editable-field]:!border-none
        [&_.mq-editable-field]:!shadow-none
        [&_textarea]:focus-within:!outline-none
        [&_textarea]:focus:!outline-none
      `),
      children: /* @__PURE__ */ c.jsx(
        Lz.EditableMathField,
        {
          latex: e.state,
          onChange: (r) => {
            r != null && r.latex && e.onChange(r.latex());
          },
          onCopy: (r) => {
            r.stopPropagation();
          },
          onCut: (r) => {
            r.stopPropagation();
          },
          config: t,
          mathquillDidMount: n,
          className: "[&_textarea]:focus-within:!outline-none [&_textarea]:focus:!outline-none"
        }
      )
    }
  );
  function n(r) {
    r.latex() === "" && e.state !== "" && e.onError(), setTimeout(() => {
      r.focus();
    });
  }
}
const Uae = /\\begin{align}/gm, Wae = /\\end{align}/gm, Zae = /([\d]),([\d])/gm, Gae = /\\\\([\s]*\\end{)/gm;
function Kae(e) {
  return !e || !e.trim() || (e = e.replace(Uae, "\\begin{aligned}"), e = e.replace(Wae, "\\end{aligned}"), e = e.replace(Gae, (t, n) => n), e = e.replace(
    Zae,
    (t, n, r) => `${n}{,}${r}`
  ), (e.includes("\\begin{aligned}") || e.includes("\\begin{array}")) && ((e.includes("\\dfrac") || e.includes("\\int")) && !e.includes("\\begin{pmatrix}") ? e = `\\def\\arraystretch{2} ${e}` : e = `\\def\\arraystretch{1.25} ${e}`)), e;
}
class ko {
  // The + prefix indicates that these fields aren't writeable
  // Lexer holding the input string.
  // Start offset, zero-based inclusive.
  // End offset, zero-based exclusive.
  constructor(t, n, r) {
    this.lexer = void 0, this.start = void 0, this.end = void 0, this.lexer = t, this.start = n, this.end = r;
  }
  /**
   * Merges two `SourceLocation`s from location providers, given they are
   * provided in order of appearance.
   * - Returns the first one's location if only the first is provided.
   * - Returns a merged range of the first and the last if both are provided
   *   and their lexers match.
   * - Otherwise, returns null.
   */
  static range(t, n) {
    return n ? !t || !t.loc || !n.loc || t.loc.lexer !== n.loc.lexer ? null : new ko(t.loc.lexer, t.loc.start, n.loc.end) : t && t.loc;
  }
}
class ca {
  // don't expand the token
  // used in \noexpand
  constructor(t, n) {
    this.text = void 0, this.loc = void 0, this.noexpand = void 0, this.treatAsRelax = void 0, this.text = t, this.loc = n;
  }
  /**
   * Given a pair of tokens (this and endToken), compute a `Token` encompassing
   * the whole input range enclosed by these two.
   */
  range(t, n) {
    return new ca(n, ko.range(this, t));
  }
}
class Ye {
  // Error start position based on passed-in Token or ParseNode.
  // Length of affected text based on passed-in Token or ParseNode.
  // The underlying error message without any context added.
  constructor(t, n) {
    this.name = void 0, this.position = void 0, this.length = void 0, this.rawMessage = void 0;
    var r = "KaTeX parse error: " + t, i, o, a = n && n.loc;
    if (a && a.start <= a.end) {
      var s = a.lexer.input;
      i = a.start, o = a.end, i === s.length ? r += " at end of input: " : r += " at position " + (i + 1) + ": ";
      var l = s.slice(i, o).replace(/[^]/g, "$&̲"), u;
      i > 15 ? u = "…" + s.slice(i - 15, i) : u = s.slice(0, i);
      var d;
      o + 15 < s.length ? d = s.slice(o, o + 15) + "…" : d = s.slice(o), r += u + l + d;
    }
    var p = new Error(r);
    return p.name = "ParseError", p.__proto__ = Ye.prototype, p.position = i, i != null && o != null && (p.length = o - i), p.rawMessage = t, p;
  }
}
Ye.prototype.__proto__ = Error.prototype;
var Xae = function(e, t) {
  return e.indexOf(t) !== -1;
}, Qae = function(e, t) {
  return e === void 0 ? t : e;
}, Yae = /([A-Z])/g, Jae = function(e) {
  return e.replace(Yae, "-$1").toLowerCase();
}, ese = {
  "&": "&amp;",
  ">": "&gt;",
  "<": "&lt;",
  '"': "&quot;",
  "'": "&#x27;"
}, tse = /[&><"']/g;
function nse(e) {
  return String(e).replace(tse, (t) => ese[t]);
}
var Mz = function e(t) {
  return t.type === "ordgroup" || t.type === "color" ? t.body.length === 1 ? e(t.body[0]) : t : t.type === "font" ? e(t.body) : t;
}, rse = function(e) {
  var t = Mz(e);
  return t.type === "mathord" || t.type === "textord" || t.type === "atom";
}, ise = function(e) {
  if (!e)
    throw new Error("Expected non-null, but got " + String(e));
  return e;
}, ose = function(e) {
  var t = /^[\x00-\x20]*([^\\/#?]*?)(:|&#0*58|&#x0*3a|&colon)/i.exec(e);
  return t ? t[2] !== ":" || !/^[a-zA-Z][a-zA-Z0-9+\-.]*$/.test(t[1]) ? null : t[1].toLowerCase() : "_relative";
}, Nt = {
  contains: Xae,
  deflt: Qae,
  escape: nse,
  hyphenate: Jae,
  getBaseElem: Mz,
  isCharacterBox: rse,
  protocolFromUrl: ose
}, _1 = {
  displayMode: {
    type: "boolean",
    description: "Render math in display mode, which puts the math in display style (so \\int and \\sum are large, for example), and centers the math on the page on its own line.",
    cli: "-d, --display-mode"
  },
  output: {
    type: {
      enum: ["htmlAndMathml", "html", "mathml"]
    },
    description: "Determines the markup language of the output.",
    cli: "-F, --format <type>"
  },
  leqno: {
    type: "boolean",
    description: "Render display math in leqno style (left-justified tags)."
  },
  fleqn: {
    type: "boolean",
    description: "Render display math flush left."
  },
  throwOnError: {
    type: "boolean",
    default: !0,
    cli: "-t, --no-throw-on-error",
    cliDescription: "Render errors (in the color given by --error-color) instead of throwing a ParseError exception when encountering an error."
  },
  errorColor: {
    type: "string",
    default: "#cc0000",
    cli: "-c, --error-color <color>",
    cliDescription: "A color string given in the format 'rgb' or 'rrggbb' (no #). This option determines the color of errors rendered by the -t option.",
    cliProcessor: (e) => "#" + e
  },
  macros: {
    type: "object",
    cli: "-m, --macro <def>",
    cliDescription: "Define custom macro of the form '\\foo:expansion' (use multiple -m arguments for multiple macros).",
    cliDefault: [],
    cliProcessor: (e, t) => (t.push(e), t)
  },
  minRuleThickness: {
    type: "number",
    description: "Specifies a minimum thickness, in ems, for fraction lines, `\\sqrt` top lines, `{array}` vertical lines, `\\hline`, `\\hdashline`, `\\underline`, `\\overline`, and the borders of `\\fbox`, `\\boxed`, and `\\fcolorbox`.",
    processor: (e) => Math.max(0, e),
    cli: "--min-rule-thickness <size>",
    cliProcessor: parseFloat
  },
  colorIsTextColor: {
    type: "boolean",
    description: "Makes \\color behave like LaTeX's 2-argument \\textcolor, instead of LaTeX's one-argument \\color mode change.",
    cli: "-b, --color-is-text-color"
  },
  strict: {
    type: [{
      enum: ["warn", "ignore", "error"]
    }, "boolean", "function"],
    description: "Turn on strict / LaTeX faithfulness mode, which throws an error if the input uses features that are not supported by LaTeX.",
    cli: "-S, --strict",
    cliDefault: !1
  },
  trust: {
    type: ["boolean", "function"],
    description: "Trust the input, enabling all HTML features such as \\url.",
    cli: "-T, --trust"
  },
  maxSize: {
    type: "number",
    default: 1 / 0,
    description: "If non-zero, all user-specified sizes, e.g. in \\rule{500em}{500em}, will be capped to maxSize ems. Otherwise, elements and spaces can be arbitrarily large",
    processor: (e) => Math.max(0, e),
    cli: "-s, --max-size <n>",
    cliProcessor: parseInt
  },
  maxExpand: {
    type: "number",
    default: 1e3,
    description: "Limit the number of macro expansions to the specified number, to prevent e.g. infinite macro loops. If set to Infinity, the macro expander will try to fully expand as in LaTeX.",
    processor: (e) => Math.max(0, e),
    cli: "-e, --max-expand <n>",
    cliProcessor: (e) => e === "Infinity" ? 1 / 0 : parseInt(e)
  },
  globalGroup: {
    type: "boolean",
    cli: !1
  }
};
function ase(e) {
  if (e.default)
    return e.default;
  var t = e.type, n = Array.isArray(t) ? t[0] : t;
  if (typeof n != "string")
    return n.enum[0];
  switch (n) {
    case "boolean":
      return !1;
    case "string":
      return "";
    case "number":
      return 0;
    case "object":
      return {};
  }
}
class Sy {
  constructor(t) {
    this.displayMode = void 0, this.output = void 0, this.leqno = void 0, this.fleqn = void 0, this.throwOnError = void 0, this.errorColor = void 0, this.macros = void 0, this.minRuleThickness = void 0, this.colorIsTextColor = void 0, this.strict = void 0, this.trust = void 0, this.maxSize = void 0, this.maxExpand = void 0, this.globalGroup = void 0, t = t || {};
    for (var n in _1)
      if (_1.hasOwnProperty(n)) {
        var r = _1[n];
        this[n] = t[n] !== void 0 ? r.processor ? r.processor(t[n]) : t[n] : ase(r);
      }
  }
  /**
   * Report nonstrict (non-LaTeX-compatible) input.
   * Can safely not be called if `this.strict` is false in JavaScript.
   */
  reportNonstrict(t, n, r) {
    var i = this.strict;
    if (typeof i == "function" && (i = i(t, n, r)), !(!i || i === "ignore")) {
      if (i === !0 || i === "error")
        throw new Ye("LaTeX-incompatible input and strict mode is set to 'error': " + (n + " [" + t + "]"), r);
      i === "warn" ? typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (n + " [" + t + "]")) : typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + i + "': " + n + " [" + t + "]"));
    }
  }
  /**
   * Check whether to apply strict (LaTeX-adhering) behavior for unusual
   * input (like `\\`).  Unlike `nonstrict`, will not throw an error;
   * instead, "error" translates to a return value of `true`, while "ignore"
   * translates to a return value of `false`.  May still print a warning:
   * "warn" prints a warning and returns `false`.
   * This is for the second category of `errorCode`s listed in the README.
   */
  useStrictBehavior(t, n, r) {
    var i = this.strict;
    if (typeof i == "function")
      try {
        i = i(t, n, r);
      } catch {
        i = "error";
      }
    return !i || i === "ignore" ? !1 : i === !0 || i === "error" ? !0 : i === "warn" ? (typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (n + " [" + t + "]")), !1) : (typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + i + "': " + n + " [" + t + "]")), !1);
  }
  /**
   * Check whether to test potentially dangerous input, and return
   * `true` (trusted) or `false` (untrusted).  The sole argument `context`
   * should be an object with `command` field specifying the relevant LaTeX
   * command (as a string starting with `\`), and any other arguments, etc.
   * If `context` has a `url` field, a `protocol` field will automatically
   * get added by this function (changing the specified object).
   */
  isTrusted(t) {
    if (t.url && !t.protocol) {
      var n = Nt.protocolFromUrl(t.url);
      if (n == null)
        return !1;
      t.protocol = n;
    }
    var r = typeof this.trust == "function" ? this.trust(t) : this.trust;
    return !!r;
  }
}
class Nl {
  constructor(t, n, r) {
    this.id = void 0, this.size = void 0, this.cramped = void 0, this.id = t, this.size = n, this.cramped = r;
  }
  /**
   * Get the style of a superscript given a base in the current style.
   */
  sup() {
    return rs[sse[this.id]];
  }
  /**
   * Get the style of a subscript given a base in the current style.
   */
  sub() {
    return rs[lse[this.id]];
  }
  /**
   * Get the style of a fraction numerator given the fraction in the current
   * style.
   */
  fracNum() {
    return rs[use[this.id]];
  }
  /**
   * Get the style of a fraction denominator given the fraction in the current
   * style.
   */
  fracDen() {
    return rs[cse[this.id]];
  }
  /**
   * Get the cramped version of a style (in particular, cramping a cramped style
   * doesn't change the style).
   */
  cramp() {
    return rs[dse[this.id]];
  }
  /**
   * Get a text or display version of this style.
   */
  text() {
    return rs[pse[this.id]];
  }
  /**
   * Return true if this style is tightly spaced (scriptstyle/scriptscriptstyle)
   */
  isTight() {
    return this.size >= 2;
  }
}
var Dy = 0, Vm = 1, F0 = 2, Xs = 3, sf = 4, aa = 5, ed = 6, Fi = 7, rs = [new Nl(Dy, 0, !1), new Nl(Vm, 0, !0), new Nl(F0, 1, !1), new Nl(Xs, 1, !0), new Nl(sf, 2, !1), new Nl(aa, 2, !0), new Nl(ed, 3, !1), new Nl(Fi, 3, !0)], sse = [sf, aa, sf, aa, ed, Fi, ed, Fi], lse = [aa, aa, aa, aa, Fi, Fi, Fi, Fi], use = [F0, Xs, sf, aa, ed, Fi, ed, Fi], cse = [Xs, Xs, aa, aa, Fi, Fi, Fi, Fi], dse = [Vm, Vm, Xs, Xs, aa, aa, Fi, Fi], pse = [Dy, Vm, F0, Xs, F0, Xs, F0, Xs], zt = {
  DISPLAY: rs[Dy],
  TEXT: rs[F0],
  SCRIPT: rs[sf],
  SCRIPTSCRIPT: rs[ed]
}, N5 = [{
  // Latin characters beyond the Latin-1 characters we have metrics for.
  // Needed for Czech, Hungarian and Turkish text, for example.
  name: "latin",
  blocks: [
    [256, 591],
    // Latin Extended-A and Latin Extended-B
    [768, 879]
    // Combining Diacritical marks
  ]
}, {
  // The Cyrillic script used by Russian and related languages.
  // A Cyrillic subset used to be supported as explicitly defined
  // symbols in symbols.js
  name: "cyrillic",
  blocks: [[1024, 1279]]
}, {
  // Armenian
  name: "armenian",
  blocks: [[1328, 1423]]
}, {
  // The Brahmic scripts of South and Southeast Asia
  // Devanagari (0900–097F)
  // Bengali (0980–09FF)
  // Gurmukhi (0A00–0A7F)
  // Gujarati (0A80–0AFF)
  // Oriya (0B00–0B7F)
  // Tamil (0B80–0BFF)
  // Telugu (0C00–0C7F)
  // Kannada (0C80–0CFF)
  // Malayalam (0D00–0D7F)
  // Sinhala (0D80–0DFF)
  // Thai (0E00–0E7F)
  // Lao (0E80–0EFF)
  // Tibetan (0F00–0FFF)
  // Myanmar (1000–109F)
  name: "brahmic",
  blocks: [[2304, 4255]]
}, {
  name: "georgian",
  blocks: [[4256, 4351]]
}, {
  // Chinese and Japanese.
  // The "k" in cjk is for Korean, but we've separated Korean out
  name: "cjk",
  blocks: [
    [12288, 12543],
    // CJK symbols and punctuation, Hiragana, Katakana
    [19968, 40879],
    // CJK ideograms
    [65280, 65376]
    // Fullwidth punctuation
    // TODO: add halfwidth Katakana and Romanji glyphs
  ]
}, {
  // Korean
  name: "hangul",
  blocks: [[44032, 55215]]
}];
function fse(e) {
  for (var t = 0; t < N5.length; t++)
    for (var n = N5[t], r = 0; r < n.blocks.length; r++) {
      var i = n.blocks[r];
      if (e >= i[0] && e <= i[1])
        return n.name;
    }
  return null;
}
var q1 = [];
N5.forEach((e) => e.blocks.forEach((t) => q1.push(...t)));
function Bz(e) {
  for (var t = 0; t < q1.length; t += 2)
    if (e >= q1[t] && e <= q1[t + 1])
      return !0;
  return !1;
}
var t0 = 80, hse = function(e, t) {
  return "M95," + (622 + e + t) + `
c-2.7,0,-7.17,-2.7,-13.5,-8c-5.8,-5.3,-9.5,-10,-9.5,-14
c0,-2,0.3,-3.3,1,-4c1.3,-2.7,23.83,-20.7,67.5,-54
c44.2,-33.3,65.8,-50.3,66.5,-51c1.3,-1.3,3,-2,5,-2c4.7,0,8.7,3.3,12,10
s173,378,173,378c0.7,0,35.3,-71,104,-213c68.7,-142,137.5,-285,206.5,-429
c69,-144,104.5,-217.7,106.5,-221
l` + e / 2.075 + " -" + e + `
c5.3,-9.3,12,-14,20,-14
H400000v` + (40 + e) + `H845.2724
s-225.272,467,-225.272,467s-235,486,-235,486c-2.7,4.7,-9,7,-19,7
c-6,0,-10,-1,-12,-3s-194,-422,-194,-422s-65,47,-65,47z
M` + (834 + e) + " " + t + "h400000v" + (40 + e) + "h-400000z";
}, mse = function(e, t) {
  return "M263," + (601 + e + t) + `c0.7,0,18,39.7,52,119
c34,79.3,68.167,158.7,102.5,238c34.3,79.3,51.8,119.3,52.5,120
c340,-704.7,510.7,-1060.3,512,-1067
l` + e / 2.084 + " -" + e + `
c4.7,-7.3,11,-11,19,-11
H40000v` + (40 + e) + `H1012.3
s-271.3,567,-271.3,567c-38.7,80.7,-84,175,-136,283c-52,108,-89.167,185.3,-111.5,232
c-22.3,46.7,-33.8,70.3,-34.5,71c-4.7,4.7,-12.3,7,-23,7s-12,-1,-12,-1
s-109,-253,-109,-253c-72.7,-168,-109.3,-252,-110,-252c-10.7,8,-22,16.7,-34,26
c-22,17.3,-33.3,26,-34,26s-26,-26,-26,-26s76,-59,76,-59s76,-60,76,-60z
M` + (1001 + e) + " " + t + "h400000v" + (40 + e) + "h-400000z";
}, gse = function(e, t) {
  return "M983 " + (10 + e + t) + `
l` + e / 3.13 + " -" + e + `
c4,-6.7,10,-10,18,-10 H400000v` + (40 + e) + `
H1013.1s-83.4,268,-264.1,840c-180.7,572,-277,876.3,-289,913c-4.7,4.7,-12.7,7,-24,7
s-12,0,-12,0c-1.3,-3.3,-3.7,-11.7,-7,-25c-35.3,-125.3,-106.7,-373.3,-214,-744
c-10,12,-21,25,-33,39s-32,39,-32,39c-6,-5.3,-15,-14,-27,-26s25,-30,25,-30
c26.7,-32.7,52,-63,76,-91s52,-60,52,-60s208,722,208,722
c56,-175.3,126.3,-397.3,211,-666c84.7,-268.7,153.8,-488.2,207.5,-658.5
c53.7,-170.3,84.5,-266.8,92.5,-289.5z
M` + (1001 + e) + " " + t + "h400000v" + (40 + e) + "h-400000z";
}, vse = function(e, t) {
  return "M424," + (2398 + e + t) + `
c-1.3,-0.7,-38.5,-172,-111.5,-514c-73,-342,-109.8,-513.3,-110.5,-514
c0,-2,-10.7,14.3,-32,49c-4.7,7.3,-9.8,15.7,-15.5,25c-5.7,9.3,-9.8,16,-12.5,20
s-5,7,-5,7c-4,-3.3,-8.3,-7.7,-13,-13s-13,-13,-13,-13s76,-122,76,-122s77,-121,77,-121
s209,968,209,968c0,-2,84.7,-361.7,254,-1079c169.3,-717.3,254.7,-1077.7,256,-1081
l` + e / 4.223 + " -" + e + `c4,-6.7,10,-10,18,-10 H400000
v` + (40 + e) + `H1014.6
s-87.3,378.7,-272.6,1166c-185.3,787.3,-279.3,1182.3,-282,1185
c-2,6,-10,9,-24,9
c-8,0,-12,-0.7,-12,-2z M` + (1001 + e) + " " + t + `
h400000v` + (40 + e) + "h-400000z";
}, yse = function(e, t) {
  return "M473," + (2713 + e + t) + `
c339.3,-1799.3,509.3,-2700,510,-2702 l` + e / 5.298 + " -" + e + `
c3.3,-7.3,9.3,-11,18,-11 H400000v` + (40 + e) + `H1017.7
s-90.5,478,-276.2,1466c-185.7,988,-279.5,1483,-281.5,1485c-2,6,-10,9,-24,9
c-8,0,-12,-0.7,-12,-2c0,-1.3,-5.3,-32,-16,-92c-50.7,-293.3,-119.7,-693.3,-207,-1200
c0,-1.3,-5.3,8.7,-16,30c-10.7,21.3,-21.3,42.7,-32,64s-16,33,-16,33s-26,-26,-26,-26
s76,-153,76,-153s77,-151,77,-151c0.7,0.7,35.7,202,105,604c67.3,400.7,102,602.7,104,
606zM` + (1001 + e) + " " + t + "h400000v" + (40 + e) + "H1017.7z";
}, xse = function(e) {
  var t = e / 2;
  return "M400000 " + e + " H0 L" + t + " 0 l65 45 L145 " + (e - 80) + " H400000z";
}, bse = function(e, t, n) {
  var r = n - 54 - t - e;
  return "M702 " + (e + t) + "H400000" + (40 + e) + `
H742v` + r + `l-4 4-4 4c-.667.7 -2 1.5-4 2.5s-4.167 1.833-6.5 2.5-5.5 1-9.5 1
h-12l-28-84c-16.667-52-96.667 -294.333-240-727l-212 -643 -85 170
c-4-3.333-8.333-7.667-13 -13l-13-13l77-155 77-156c66 199.333 139 419.667
219 661 l218 661zM702 ` + t + "H400000v" + (40 + e) + "H742z";
}, wse = function(e, t, n) {
  t = 1e3 * t;
  var r = "";
  switch (e) {
    case "sqrtMain":
      r = hse(t, t0);
      break;
    case "sqrtSize1":
      r = mse(t, t0);
      break;
    case "sqrtSize2":
      r = gse(t, t0);
      break;
    case "sqrtSize3":
      r = vse(t, t0);
      break;
    case "sqrtSize4":
      r = yse(t, t0);
      break;
    case "sqrtTall":
      r = bse(t, t0, n);
  }
  return r;
}, Cse = function(e, t) {
  switch (e) {
    case "⎜":
      return "M291 0 H417 V" + t + " H291z M291 0 H417 V" + t + " H291z";
    case "∣":
      return "M145 0 H188 V" + t + " H145z M145 0 H188 V" + t + " H145z";
    case "∥":
      return "M145 0 H188 V" + t + " H145z M145 0 H188 V" + t + " H145z" + ("M367 0 H410 V" + t + " H367z M367 0 H410 V" + t + " H367z");
    case "⎟":
      return "M457 0 H583 V" + t + " H457z M457 0 H583 V" + t + " H457z";
    case "⎢":
      return "M319 0 H403 V" + t + " H319z M319 0 H403 V" + t + " H319z";
    case "⎥":
      return "M263 0 H347 V" + t + " H263z M263 0 H347 V" + t + " H263z";
    case "⎪":
      return "M384 0 H504 V" + t + " H384z M384 0 H504 V" + t + " H384z";
    case "⏐":
      return "M312 0 H355 V" + t + " H312z M312 0 H355 V" + t + " H312z";
    case "‖":
      return "M257 0 H300 V" + t + " H257z M257 0 H300 V" + t + " H257z" + ("M478 0 H521 V" + t + " H478z M478 0 H521 V" + t + " H478z");
    default:
      return "";
  }
}, l9 = {
  // The doubleleftarrow geometry is from glyph U+21D0 in the font KaTeX Main
  doubleleftarrow: `M262 157
l10-10c34-36 62.7-77 86-123 3.3-8 5-13.3 5-16 0-5.3-6.7-8-20-8-7.3
 0-12.2.5-14.5 1.5-2.3 1-4.8 4.5-7.5 10.5-49.3 97.3-121.7 169.3-217 216-28
 14-57.3 25-88 33-6.7 2-11 3.8-13 5.5-2 1.7-3 4.2-3 7.5s1 5.8 3 7.5
c2 1.7 6.3 3.5 13 5.5 68 17.3 128.2 47.8 180.5 91.5 52.3 43.7 93.8 96.2 124.5
 157.5 9.3 8 15.3 12.3 18 13h6c12-.7 18-4 18-10 0-2-1.7-7-5-15-23.3-46-52-87
-86-123l-10-10h399738v-40H218c328 0 0 0 0 0l-10-8c-26.7-20-65.7-43-117-69 2.7
-2 6-3.7 10-5 36.7-16 72.3-37.3 107-64l10-8h399782v-40z
m8 0v40h399730v-40zm0 194v40h399730v-40z`,
  // doublerightarrow is from glyph U+21D2 in font KaTeX Main
  doublerightarrow: `M399738 392l
-10 10c-34 36-62.7 77-86 123-3.3 8-5 13.3-5 16 0 5.3 6.7 8 20 8 7.3 0 12.2-.5
 14.5-1.5 2.3-1 4.8-4.5 7.5-10.5 49.3-97.3 121.7-169.3 217-216 28-14 57.3-25 88
-33 6.7-2 11-3.8 13-5.5 2-1.7 3-4.2 3-7.5s-1-5.8-3-7.5c-2-1.7-6.3-3.5-13-5.5-68
-17.3-128.2-47.8-180.5-91.5-52.3-43.7-93.8-96.2-124.5-157.5-9.3-8-15.3-12.3-18
-13h-6c-12 .7-18 4-18 10 0 2 1.7 7 5 15 23.3 46 52 87 86 123l10 10H0v40h399782
c-328 0 0 0 0 0l10 8c26.7 20 65.7 43 117 69-2.7 2-6 3.7-10 5-36.7 16-72.3 37.3
-107 64l-10 8H0v40zM0 157v40h399730v-40zm0 194v40h399730v-40z`,
  // leftarrow is from glyph U+2190 in font KaTeX Main
  leftarrow: `M400000 241H110l3-3c68.7-52.7 113.7-120
 135-202 4-14.7 6-23 6-25 0-7.3-7-11-21-11-8 0-13.2.8-15.5 2.5-2.3 1.7-4.2 5.8
-5.5 12.5-1.3 4.7-2.7 10.3-4 17-12 48.7-34.8 92-68.5 130S65.3 228.3 18 247
c-10 4-16 7.7-18 11 0 8.7 6 14.3 18 17 47.3 18.7 87.8 47 121.5 85S196 441.3 208
 490c.7 2 1.3 5 2 9s1.2 6.7 1.5 8c.3 1.3 1 3.3 2 6s2.2 4.5 3.5 5.5c1.3 1 3.3
 1.8 6 2.5s6 1 10 1c14 0 21-3.7 21-11 0-2-2-10.3-6-25-20-79.3-65-146.7-135-202
 l-3-3h399890zM100 241v40h399900v-40z`,
  // overbrace is from glyphs U+23A9/23A8/23A7 in font KaTeX_Size4-Regular
  leftbrace: `M6 548l-6-6v-35l6-11c56-104 135.3-181.3 238-232 57.3-28.7 117
-45 179-50h399577v120H403c-43.3 7-81 15-113 26-100.7 33-179.7 91-237 174-2.7
 5-6 9-10 13-.7 1-7.3 1-20 1H6z`,
  leftbraceunder: `M0 6l6-6h17c12.688 0 19.313.3 20 1 4 4 7.313 8.3 10 13
 35.313 51.3 80.813 93.8 136.5 127.5 55.688 33.7 117.188 55.8 184.5 66.5.688
 0 2 .3 4 1 18.688 2.7 76 4.3 172 5h399450v120H429l-6-1c-124.688-8-235-61.7
-331-161C60.687 138.7 32.312 99.3 7 54L0 41V6z`,
  // overgroup is from the MnSymbol package (public domain)
  leftgroup: `M400000 80
H435C64 80 168.3 229.4 21 260c-5.9 1.2-18 0-18 0-2 0-3-1-3-3v-38C76 61 257 0
 435 0h399565z`,
  leftgroupunder: `M400000 262
H435C64 262 168.3 112.6 21 82c-5.9-1.2-18 0-18 0-2 0-3 1-3 3v38c76 158 257 219
 435 219h399565z`,
  // Harpoons are from glyph U+21BD in font KaTeX Main
  leftharpoon: `M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3
-3.3 10.2-9.5 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5
-18.3 3-21-1.3-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7
-196 228-6.7 4.7-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40z`,
  leftharpoonplus: `M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3-3.3 10.2-9.5
 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5-18.3 3-21-1.3
-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7-196 228-6.7 4.7
-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40zM0 435v40h400000v-40z
m0 0v40h400000v-40z`,
  leftharpoondown: `M7 241c-4 4-6.333 8.667-7 14 0 5.333.667 9 2 11s5.333
 5.333 12 10c90.667 54 156 130 196 228 3.333 10.667 6.333 16.333 9 17 2 .667 5
 1 9 1h5c10.667 0 16.667-2 18-6 2-2.667 1-9.667-3-21-32-87.333-82.667-157.667
-152-211l-3-3h399907v-40zM93 281 H400000 v-40L7 241z`,
  leftharpoondownplus: `M7 435c-4 4-6.3 8.7-7 14 0 5.3.7 9 2 11s5.3 5.3 12
 10c90.7 54 156 130 196 228 3.3 10.7 6.3 16.3 9 17 2 .7 5 1 9 1h5c10.7 0 16.7
-2 18-6 2-2.7 1-9.7-3-21-32-87.3-82.7-157.7-152-211l-3-3h399907v-40H7zm93 0
v40h399900v-40zM0 241v40h399900v-40zm0 0v40h399900v-40z`,
  // hook is from glyph U+21A9 in font KaTeX Main
  lefthook: `M400000 281 H103s-33-11.2-61-33.5S0 197.3 0 164s14.2-61.2 42.5
-83.5C70.8 58.2 104 47 142 47 c16.7 0 25 6.7 25 20 0 12-8.7 18.7-26 20-40 3.3
-68.7 15.7-86 37-10 12-15 25.3-15 40 0 22.7 9.8 40.7 29.5 54 19.7 13.3 43.5 21
 71.5 23h399859zM103 281v-40h399897v40z`,
  leftlinesegment: `M40 281 V428 H0 V94 H40 V241 H400000 v40z
M40 281 V428 H0 V94 H40 V241 H400000 v40z`,
  leftmapsto: `M40 281 V448H0V74H40V241H400000v40z
M40 281 V448H0V74H40V241H400000v40z`,
  // tofrom is from glyph U+21C4 in font KaTeX AMS Regular
  leftToFrom: `M0 147h400000v40H0zm0 214c68 40 115.7 95.7 143 167h22c15.3 0 23
-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69-70-101l-7-8h399905v-40H95l7-8
c28.7-32 52-65.7 70-101 10.7-23.3 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 265.3
 68 321 0 361zm0-174v-40h399900v40zm100 154v40h399900v-40z`,
  longequal: `M0 50 h400000 v40H0z m0 194h40000v40H0z
M0 50 h400000 v40H0z m0 194h40000v40H0z`,
  midbrace: `M200428 334
c-100.7-8.3-195.3-44-280-108-55.3-42-101.7-93-139-153l-9-14c-2.7 4-5.7 8.7-9 14
-53.3 86.7-123.7 153-211 199-66.7 36-137.3 56.3-212 62H0V214h199568c178.3-11.7
 311.7-78.3 403-201 6-8 9.7-12 11-12 .7-.7 6.7-1 18-1s17.3.3 18 1c1.3 0 5 4 11
 12 44.7 59.3 101.3 106.3 170 141s145.3 54.3 229 60h199572v120z`,
  midbraceunder: `M199572 214
c100.7 8.3 195.3 44 280 108 55.3 42 101.7 93 139 153l9 14c2.7-4 5.7-8.7 9-14
 53.3-86.7 123.7-153 211-199 66.7-36 137.3-56.3 212-62h199568v120H200432c-178.3
 11.7-311.7 78.3-403 201-6 8-9.7 12-11 12-.7.7-6.7 1-18 1s-17.3-.3-18-1c-1.3 0
-5-4-11-12-44.7-59.3-101.3-106.3-170-141s-145.3-54.3-229-60H0V214z`,
  oiintSize1: `M512.6 71.6c272.6 0 320.3 106.8 320.3 178.2 0 70.8-47.7 177.6
-320.3 177.6S193.1 320.6 193.1 249.8c0-71.4 46.9-178.2 319.5-178.2z
m368.1 178.2c0-86.4-60.9-215.4-368.1-215.4-306.4 0-367.3 129-367.3 215.4 0 85.8
60.9 214.8 367.3 214.8 307.2 0 368.1-129 368.1-214.8z`,
  oiintSize2: `M757.8 100.1c384.7 0 451.1 137.6 451.1 230 0 91.3-66.4 228.8
-451.1 228.8-386.3 0-452.7-137.5-452.7-228.8 0-92.4 66.4-230 452.7-230z
m502.4 230c0-111.2-82.4-277.2-502.4-277.2s-504 166-504 277.2
c0 110 84 276 504 276s502.4-166 502.4-276z`,
  oiiintSize1: `M681.4 71.6c408.9 0 480.5 106.8 480.5 178.2 0 70.8-71.6 177.6
-480.5 177.6S202.1 320.6 202.1 249.8c0-71.4 70.5-178.2 479.3-178.2z
m525.8 178.2c0-86.4-86.8-215.4-525.7-215.4-437.9 0-524.7 129-524.7 215.4 0
85.8 86.8 214.8 524.7 214.8 438.9 0 525.7-129 525.7-214.8z`,
  oiiintSize2: `M1021.2 53c603.6 0 707.8 165.8 707.8 277.2 0 110-104.2 275.8
-707.8 275.8-606 0-710.2-165.8-710.2-275.8C311 218.8 415.2 53 1021.2 53z
m770.4 277.1c0-131.2-126.4-327.6-770.5-327.6S248.4 198.9 248.4 330.1
c0 130 128.8 326.4 772.7 326.4s770.5-196.4 770.5-326.4z`,
  rightarrow: `M0 241v40h399891c-47.3 35.3-84 78-110 128
-16.7 32-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20
 11 8 0 13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7
 39-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85
-40.5-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5
-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67
 151.7 139 205zm0 0v40h399900v-40z`,
  rightbrace: `M400000 542l
-6 6h-17c-12.7 0-19.3-.3-20-1-4-4-7.3-8.3-10-13-35.3-51.3-80.8-93.8-136.5-127.5
s-117.2-55.8-184.5-66.5c-.7 0-2-.3-4-1-18.7-2.7-76-4.3-172-5H0V214h399571l6 1
c124.7 8 235 61.7 331 161 31.3 33.3 59.7 72.7 85 118l7 13v35z`,
  rightbraceunder: `M399994 0l6 6v35l-6 11c-56 104-135.3 181.3-238 232-57.3
 28.7-117 45-179 50H-300V214h399897c43.3-7 81-15 113-26 100.7-33 179.7-91 237
-174 2.7-5 6-9 10-13 .7-1 7.3-1 20-1h17z`,
  rightgroup: `M0 80h399565c371 0 266.7 149.4 414 180 5.9 1.2 18 0 18 0 2 0
 3-1 3-3v-38c-76-158-257-219-435-219H0z`,
  rightgroupunder: `M0 262h399565c371 0 266.7-149.4 414-180 5.9-1.2 18 0 18
 0 2 0 3 1 3 3v38c-76 158-257 219-435 219H0z`,
  rightharpoon: `M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3
-3.7-15.3-11-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2
-10.7 0-16.7 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58
 69.2 92 94.5zm0 0v40h399900v-40z`,
  rightharpoonplus: `M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3-3.7-15.3-11
-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2-10.7 0-16.7
 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58 69.2 92 94.5z
m0 0v40h399900v-40z m100 194v40h399900v-40zm0 0v40h399900v-40z`,
  rightharpoondown: `M399747 511c0 7.3 6.7 11 20 11 8 0 13-.8 15-2.5s4.7-6.8
 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3 8.5-5.8 9.5
-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3-64.7 57-92 95
-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 241v40h399900v-40z`,
  rightharpoondownplus: `M399747 705c0 7.3 6.7 11 20 11 8 0 13-.8
 15-2.5s4.7-6.8 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3
 8.5-5.8 9.5-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3
-64.7 57-92 95-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 435v40h399900v-40z
m0-194v40h400000v-40zm0 0v40h400000v-40z`,
  righthook: `M399859 241c-764 0 0 0 0 0 40-3.3 68.7-15.7 86-37 10-12 15-25.3
 15-40 0-22.7-9.8-40.7-29.5-54-19.7-13.3-43.5-21-71.5-23-17.3-1.3-26-8-26-20 0
-13.3 8.7-20 26-20 38 0 71 11.2 99 33.5 0 0 7 5.6 21 16.7 14 11.2 21 33.5 21
 66.8s-14 61.2-42 83.5c-28 22.3-61 33.5-99 33.5L0 241z M0 281v-40h399859v40z`,
  rightlinesegment: `M399960 241 V94 h40 V428 h-40 V281 H0 v-40z
M399960 241 V94 h40 V428 h-40 V281 H0 v-40z`,
  rightToFrom: `M400000 167c-70.7-42-118-97.7-142-167h-23c-15.3 0-23 .3-23
 1 0 1.3 5.3 13.7 16 37 18 35.3 41.3 69 70 101l7 8H0v40h399905l-7 8c-28.7 32
-52 65.7-70 101-10.7 23.3-16 35.7-16 37 0 .7 7.7 1 23 1h23c24-69.3 71.3-125 142
-167z M100 147v40h399900v-40zM0 341v40h399900v-40z`,
  // twoheadleftarrow is from glyph U+219E in font KaTeX AMS Regular
  twoheadleftarrow: `M0 167c68 40
 115.7 95.7 143 167h22c15.3 0 23-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69
-70-101l-7-8h125l9 7c50.7 39.3 85 86 103 140h46c0-4.7-6.3-18.7-19-42-18-35.3
-40-67.3-66-96l-9-9h399716v-40H284l9-9c26-28.7 48-60.7 66-96 12.7-23.333 19
-37.333 19-42h-46c-18 54-52.3 100.7-103 140l-9 7H95l7-8c28.7-32 52-65.7 70-101
 10.7-23.333 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 71.3 68 127 0 167z`,
  twoheadrightarrow: `M400000 167
c-68-40-115.7-95.7-143-167h-22c-15.3 0-23 .3-23 1 0 1.3 5.3 13.7 16 37 18 35.3
 41.3 69 70 101l7 8h-125l-9-7c-50.7-39.3-85-86-103-140h-46c0 4.7 6.3 18.7 19 42
 18 35.3 40 67.3 66 96l9 9H0v40h399716l-9 9c-26 28.7-48 60.7-66 96-12.7 23.333
-19 37.333-19 42h46c18-54 52.3-100.7 103-140l9-7h125l-7 8c-28.7 32-52 65.7-70
 101-10.7 23.333-16 35.7-16 37 0 .7 7.7 1 23 1h22c27.3-71.3 75-127 143-167z`,
  // tilde1 is a modified version of a glyph from the MnSymbol package
  tilde1: `M200 55.538c-77 0-168 73.953-177 73.953-3 0-7
-2.175-9-5.437L2 97c-1-2-2-4-2-6 0-4 2-7 5-9l20-12C116 12 171 0 207 0c86 0
 114 68 191 68 78 0 168-68 177-68 4 0 7 2 9 5l12 19c1 2.175 2 4.35 2 6.525 0
 4.35-2 7.613-5 9.788l-19 13.05c-92 63.077-116.937 75.308-183 76.128
-68.267.847-113-73.952-191-73.952z`,
  // ditto tilde2, tilde3, & tilde4
  tilde2: `M344 55.266c-142 0-300.638 81.316-311.5 86.418
-8.01 3.762-22.5 10.91-23.5 5.562L1 120c-1-2-1-3-1-4 0-5 3-9 8-10l18.4-9C160.9
 31.9 283 0 358 0c148 0 188 122 331 122s314-97 326-97c4 0 8 2 10 7l7 21.114
c1 2.14 1 3.21 1 4.28 0 5.347-3 9.626-7 10.696l-22.3 12.622C852.6 158.372 751
 181.476 676 181.476c-149 0-189-126.21-332-126.21z`,
  tilde3: `M786 59C457 59 32 175.242 13 175.242c-6 0-10-3.457
-11-10.37L.15 138c-1-7 3-12 10-13l19.2-6.4C378.4 40.7 634.3 0 804.3 0c337 0
 411.8 157 746.8 157 328 0 754-112 773-112 5 0 10 3 11 9l1 14.075c1 8.066-.697
 16.595-6.697 17.492l-21.052 7.31c-367.9 98.146-609.15 122.696-778.15 122.696
 -338 0-409-156.573-744-156.573z`,
  tilde4: `M786 58C457 58 32 177.487 13 177.487c-6 0-10-3.345
-11-10.035L.15 143c-1-7 3-12 10-13l22-6.7C381.2 35 637.15 0 807.15 0c337 0 409
 177 744 177 328 0 754-127 773-127 5 0 10 3 11 9l1 14.794c1 7.805-3 13.38-9
 14.495l-20.7 5.574c-366.85 99.79-607.3 139.372-776.3 139.372-338 0-409
 -175.236-744-175.236z`,
  // vec is from glyph U+20D7 in font KaTeX Main
  vec: `M377 20c0-5.333 1.833-10 5.5-14S391 0 397 0c4.667 0 8.667 1.667 12 5
3.333 2.667 6.667 9 10 19 6.667 24.667 20.333 43.667 41 57 7.333 4.667 11
10.667 11 18 0 6-1 10-3 12s-6.667 5-14 9c-28.667 14.667-53.667 35.667-75 63
-1.333 1.333-3.167 3.5-5.5 6.5s-4 4.833-5 5.5c-1 .667-2.5 1.333-4.5 2s-4.333 1
-7 1c-4.667 0-9.167-1.833-13.5-5.5S337 184 337 178c0-12.667 15.667-32.333 47-59
H213l-171-1c-8.667-6-13-12.333-13-19 0-4.667 4.333-11.333 13-20h359
c-16-25.333-24-45-24-59z`,
  // widehat1 is a modified version of a glyph from the MnSymbol package
  widehat1: `M529 0h5l519 115c5 1 9 5 9 10 0 1-1 2-1 3l-4 22
c-1 5-5 9-11 9h-2L532 67 19 159h-2c-5 0-9-4-11-9l-5-22c-1-6 2-12 8-13z`,
  // ditto widehat2, widehat3, & widehat4
  widehat2: `M1181 0h2l1171 176c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 220h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  widehat3: `M1181 0h2l1171 236c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 280h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  widehat4: `M1181 0h2l1171 296c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 340h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  // widecheck paths are all inverted versions of widehat
  widecheck1: `M529,159h5l519,-115c5,-1,9,-5,9,-10c0,-1,-1,-2,-1,-3l-4,-22c-1,
-5,-5,-9,-11,-9h-2l-512,92l-513,-92h-2c-5,0,-9,4,-11,9l-5,22c-1,6,2,12,8,13z`,
  widecheck2: `M1181,220h2l1171,-176c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,153l-1167,-153h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  widecheck3: `M1181,280h2l1171,-236c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,213l-1167,-213h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  widecheck4: `M1181,340h2l1171,-296c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,273l-1167,-273h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  // The next ten paths support reaction arrows from the mhchem package.
  // Arrows for \ce{<-->} are offset from xAxis by 0.22ex, per mhchem in LaTeX
  // baraboveleftarrow is mostly from glyph U+2190 in font KaTeX Main
  baraboveleftarrow: `M400000 620h-399890l3 -3c68.7 -52.7 113.7 -120 135 -202
c4 -14.7 6 -23 6 -25c0 -7.3 -7 -11 -21 -11c-8 0 -13.2 0.8 -15.5 2.5
c-2.3 1.7 -4.2 5.8 -5.5 12.5c-1.3 4.7 -2.7 10.3 -4 17c-12 48.7 -34.8 92 -68.5 130
s-74.2 66.3 -121.5 85c-10 4 -16 7.7 -18 11c0 8.7 6 14.3 18 17c47.3 18.7 87.8 47
121.5 85s56.5 81.3 68.5 130c0.7 2 1.3 5 2 9s1.2 6.7 1.5 8c0.3 1.3 1 3.3 2 6
s2.2 4.5 3.5 5.5c1.3 1 3.3 1.8 6 2.5s6 1 10 1c14 0 21 -3.7 21 -11
c0 -2 -2 -10.3 -6 -25c-20 -79.3 -65 -146.7 -135 -202l-3 -3h399890z
M100 620v40h399900v-40z M0 241v40h399900v-40zM0 241v40h399900v-40z`,
  // rightarrowabovebar is mostly from glyph U+2192, KaTeX Main
  rightarrowabovebar: `M0 241v40h399891c-47.3 35.3-84 78-110 128-16.7 32
-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20 11 8 0
13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7 39
-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85-40.5
-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5
-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67
151.7 139 205zm96 379h399894v40H0zm0 0h399904v40H0z`,
  // The short left harpoon has 0.5em (i.e. 500 units) kern on the left end.
  // Ref from mhchem.sty: \rlap{\raisebox{-.22ex}{$\kern0.5em
  baraboveshortleftharpoon: `M507,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11
c1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17
c2,0.7,5,1,9,1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21
c-32,-87.3,-82.7,-157.7,-152,-211c0,0,-3,-3,-3,-3l399351,0l0,-40
c-398570,0,-399437,0,-399437,0z M593 435 v40 H399500 v-40z
M0 281 v-40 H399908 v40z M0 281 v-40 H399908 v40z`,
  rightharpoonaboveshortbar: `M0,241 l0,40c399126,0,399993,0,399993,0
c4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,
-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6
c-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z
M0 241 v40 H399908 v-40z M0 475 v-40 H399500 v40z M0 475 v-40 H399500 v40z`,
  shortbaraboveleftharpoon: `M7,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11
c1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17c2,0.7,5,1,9,
1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21c-32,-87.3,-82.7,-157.7,
-152,-211c0,0,-3,-3,-3,-3l399907,0l0,-40c-399126,0,-399993,0,-399993,0z
M93 435 v40 H400000 v-40z M500 241 v40 H400000 v-40z M500 241 v40 H400000 v-40z`,
  shortrightharpoonabovebar: `M53,241l0,40c398570,0,399437,0,399437,0
c4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,
-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6
c-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z
M500 241 v40 H399408 v-40z M500 435 v40 H400000 v-40z`
}, kse = function(e, t) {
  switch (e) {
    case "lbrack":
      return "M403 1759 V84 H666 V0 H319 V1759 v" + t + ` v1759 h347 v-84
H403z M403 1759 V0 H319 V1759 v` + t + " v1759 h84z";
    case "rbrack":
      return "M347 1759 V0 H0 V84 H263 V1759 v" + t + ` v1759 H0 v84 H347z
M347 1759 V0 H263 V1759 v` + t + " v1759 h84z";
    case "vert":
      return "M145 15 v585 v" + t + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -t + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M188 15 H145 v585 v` + t + " v585 h43z";
    case "doublevert":
      return "M145 15 v585 v" + t + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -t + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M188 15 H145 v585 v` + t + ` v585 h43z
M367 15 v585 v` + t + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -t + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M410 15 H367 v585 v` + t + " v585 h43z";
    case "lfloor":
      return "M319 602 V0 H403 V602 v" + t + ` v1715 h263 v84 H319z
MM319 602 V0 H403 V602 v` + t + " v1715 H319z";
    case "rfloor":
      return "M319 602 V0 H403 V602 v" + t + ` v1799 H0 v-84 H319z
MM319 602 V0 H403 V602 v` + t + " v1715 H319z";
    case "lceil":
      return "M403 1759 V84 H666 V0 H319 V1759 v" + t + ` v602 h84z
M403 1759 V0 H319 V1759 v` + t + " v602 h84z";
    case "rceil":
      return "M347 1759 V0 H0 V84 H263 V1759 v" + t + ` v602 h84z
M347 1759 V0 h-84 V1759 v` + t + " v602 h84z";
    case "lparen":
      return `M863,9c0,-2,-2,-5,-6,-9c0,0,-17,0,-17,0c-12.7,0,-19.3,0.3,-20,1
c-5.3,5.3,-10.3,11,-15,17c-242.7,294.7,-395.3,682,-458,1162c-21.3,163.3,-33.3,349,
-36,557 l0,` + (t + 84) + `c0.2,6,0,26,0,60c2,159.3,10,310.7,24,454c53.3,528,210,
949.7,470,1265c4.7,6,9.7,11.7,15,17c0.7,0.7,7,1,19,1c0,0,18,0,18,0c4,-4,6,-7,6,-9
c0,-2.7,-3.3,-8.7,-10,-18c-135.3,-192.7,-235.5,-414.3,-300.5,-665c-65,-250.7,-102.5,
-544.7,-112.5,-882c-2,-104,-3,-167,-3,-189
l0,-` + (t + 92) + `c0,-162.7,5.7,-314,17,-454c20.7,-272,63.7,-513,129,-723c65.3,
-210,155.3,-396.3,270,-559c6.7,-9.3,10,-15.3,10,-18z`;
    case "rparen":
      return `M76,0c-16.7,0,-25,3,-25,9c0,2,2,6.3,6,13c21.3,28.7,42.3,60.3,
63,95c96.7,156.7,172.8,332.5,228.5,527.5c55.7,195,92.8,416.5,111.5,664.5
c11.3,139.3,17,290.7,17,454c0,28,1.7,43,3.3,45l0,` + (t + 9) + `
c-3,4,-3.3,16.7,-3.3,38c0,162,-5.7,313.7,-17,455c-18.7,248,-55.8,469.3,-111.5,664
c-55.7,194.7,-131.8,370.3,-228.5,527c-20.7,34.7,-41.7,66.3,-63,95c-2,3.3,-4,7,-6,11
c0,7.3,5.7,11,17,11c0,0,11,0,11,0c9.3,0,14.3,-0.3,15,-1c5.3,-5.3,10.3,-11,15,-17
c242.7,-294.7,395.3,-681.7,458,-1161c21.3,-164.7,33.3,-350.7,36,-558
l0,-` + (t + 144) + `c-2,-159.3,-10,-310.7,-24,-454c-53.3,-528,-210,-949.7,
-470,-1265c-4.7,-6,-9.7,-11.7,-15,-17c-0.7,-0.7,-6.7,-1,-18,-1z`;
    default:
      throw new Error("Unknown stretchy delimiter.");
  }
};
let $f = class {
  // HtmlDomNode
  // Never used; needed for satisfying interface.
  constructor(e) {
    this.children = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, this.children = e, this.classes = [], this.height = 0, this.depth = 0, this.maxFontSize = 0, this.style = {};
  }
  hasClass(e) {
    return Nt.contains(this.classes, e);
  }
  /** Convert the fragment into a node. */
  toNode() {
    for (var e = document.createDocumentFragment(), t = 0; t < this.children.length; t++)
      e.appendChild(this.children[t].toNode());
    return e;
  }
  /** Convert the fragment into HTML markup. */
  toMarkup() {
    for (var e = "", t = 0; t < this.children.length; t++)
      e += this.children[t].toMarkup();
    return e;
  }
  /**
   * Converts the math node into a string, similar to innerText. Applies to
   * MathDomNode's only.
   */
  toText() {
    var e = (t) => t.toText();
    return this.children.map(e).join("");
  }
};
var as = {
  "AMS-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.68889, 0, 0, 0.72222],
    66: [0, 0.68889, 0, 0, 0.66667],
    67: [0, 0.68889, 0, 0, 0.72222],
    68: [0, 0.68889, 0, 0, 0.72222],
    69: [0, 0.68889, 0, 0, 0.66667],
    70: [0, 0.68889, 0, 0, 0.61111],
    71: [0, 0.68889, 0, 0, 0.77778],
    72: [0, 0.68889, 0, 0, 0.77778],
    73: [0, 0.68889, 0, 0, 0.38889],
    74: [0.16667, 0.68889, 0, 0, 0.5],
    75: [0, 0.68889, 0, 0, 0.77778],
    76: [0, 0.68889, 0, 0, 0.66667],
    77: [0, 0.68889, 0, 0, 0.94445],
    78: [0, 0.68889, 0, 0, 0.72222],
    79: [0.16667, 0.68889, 0, 0, 0.77778],
    80: [0, 0.68889, 0, 0, 0.61111],
    81: [0.16667, 0.68889, 0, 0, 0.77778],
    82: [0, 0.68889, 0, 0, 0.72222],
    83: [0, 0.68889, 0, 0, 0.55556],
    84: [0, 0.68889, 0, 0, 0.66667],
    85: [0, 0.68889, 0, 0, 0.72222],
    86: [0, 0.68889, 0, 0, 0.72222],
    87: [0, 0.68889, 0, 0, 1],
    88: [0, 0.68889, 0, 0, 0.72222],
    89: [0, 0.68889, 0, 0, 0.72222],
    90: [0, 0.68889, 0, 0, 0.66667],
    107: [0, 0.68889, 0, 0, 0.55556],
    160: [0, 0, 0, 0, 0.25],
    165: [0, 0.675, 0.025, 0, 0.75],
    174: [0.15559, 0.69224, 0, 0, 0.94666],
    240: [0, 0.68889, 0, 0, 0.55556],
    295: [0, 0.68889, 0, 0, 0.54028],
    710: [0, 0.825, 0, 0, 2.33334],
    732: [0, 0.9, 0, 0, 2.33334],
    770: [0, 0.825, 0, 0, 2.33334],
    771: [0, 0.9, 0, 0, 2.33334],
    989: [0.08167, 0.58167, 0, 0, 0.77778],
    1008: [0, 0.43056, 0.04028, 0, 0.66667],
    8245: [0, 0.54986, 0, 0, 0.275],
    8463: [0, 0.68889, 0, 0, 0.54028],
    8487: [0, 0.68889, 0, 0, 0.72222],
    8498: [0, 0.68889, 0, 0, 0.55556],
    8502: [0, 0.68889, 0, 0, 0.66667],
    8503: [0, 0.68889, 0, 0, 0.44445],
    8504: [0, 0.68889, 0, 0, 0.66667],
    8513: [0, 0.68889, 0, 0, 0.63889],
    8592: [-0.03598, 0.46402, 0, 0, 0.5],
    8594: [-0.03598, 0.46402, 0, 0, 0.5],
    8602: [-0.13313, 0.36687, 0, 0, 1],
    8603: [-0.13313, 0.36687, 0, 0, 1],
    8606: [0.01354, 0.52239, 0, 0, 1],
    8608: [0.01354, 0.52239, 0, 0, 1],
    8610: [0.01354, 0.52239, 0, 0, 1.11111],
    8611: [0.01354, 0.52239, 0, 0, 1.11111],
    8619: [0, 0.54986, 0, 0, 1],
    8620: [0, 0.54986, 0, 0, 1],
    8621: [-0.13313, 0.37788, 0, 0, 1.38889],
    8622: [-0.13313, 0.36687, 0, 0, 1],
    8624: [0, 0.69224, 0, 0, 0.5],
    8625: [0, 0.69224, 0, 0, 0.5],
    8630: [0, 0.43056, 0, 0, 1],
    8631: [0, 0.43056, 0, 0, 1],
    8634: [0.08198, 0.58198, 0, 0, 0.77778],
    8635: [0.08198, 0.58198, 0, 0, 0.77778],
    8638: [0.19444, 0.69224, 0, 0, 0.41667],
    8639: [0.19444, 0.69224, 0, 0, 0.41667],
    8642: [0.19444, 0.69224, 0, 0, 0.41667],
    8643: [0.19444, 0.69224, 0, 0, 0.41667],
    8644: [0.1808, 0.675, 0, 0, 1],
    8646: [0.1808, 0.675, 0, 0, 1],
    8647: [0.1808, 0.675, 0, 0, 1],
    8648: [0.19444, 0.69224, 0, 0, 0.83334],
    8649: [0.1808, 0.675, 0, 0, 1],
    8650: [0.19444, 0.69224, 0, 0, 0.83334],
    8651: [0.01354, 0.52239, 0, 0, 1],
    8652: [0.01354, 0.52239, 0, 0, 1],
    8653: [-0.13313, 0.36687, 0, 0, 1],
    8654: [-0.13313, 0.36687, 0, 0, 1],
    8655: [-0.13313, 0.36687, 0, 0, 1],
    8666: [0.13667, 0.63667, 0, 0, 1],
    8667: [0.13667, 0.63667, 0, 0, 1],
    8669: [-0.13313, 0.37788, 0, 0, 1],
    8672: [-0.064, 0.437, 0, 0, 1.334],
    8674: [-0.064, 0.437, 0, 0, 1.334],
    8705: [0, 0.825, 0, 0, 0.5],
    8708: [0, 0.68889, 0, 0, 0.55556],
    8709: [0.08167, 0.58167, 0, 0, 0.77778],
    8717: [0, 0.43056, 0, 0, 0.42917],
    8722: [-0.03598, 0.46402, 0, 0, 0.5],
    8724: [0.08198, 0.69224, 0, 0, 0.77778],
    8726: [0.08167, 0.58167, 0, 0, 0.77778],
    8733: [0, 0.69224, 0, 0, 0.77778],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8737: [0, 0.69224, 0, 0, 0.72222],
    8738: [0.03517, 0.52239, 0, 0, 0.72222],
    8739: [0.08167, 0.58167, 0, 0, 0.22222],
    8740: [0.25142, 0.74111, 0, 0, 0.27778],
    8741: [0.08167, 0.58167, 0, 0, 0.38889],
    8742: [0.25142, 0.74111, 0, 0, 0.5],
    8756: [0, 0.69224, 0, 0, 0.66667],
    8757: [0, 0.69224, 0, 0, 0.66667],
    8764: [-0.13313, 0.36687, 0, 0, 0.77778],
    8765: [-0.13313, 0.37788, 0, 0, 0.77778],
    8769: [-0.13313, 0.36687, 0, 0, 0.77778],
    8770: [-0.03625, 0.46375, 0, 0, 0.77778],
    8774: [0.30274, 0.79383, 0, 0, 0.77778],
    8776: [-0.01688, 0.48312, 0, 0, 0.77778],
    8778: [0.08167, 0.58167, 0, 0, 0.77778],
    8782: [0.06062, 0.54986, 0, 0, 0.77778],
    8783: [0.06062, 0.54986, 0, 0, 0.77778],
    8785: [0.08198, 0.58198, 0, 0, 0.77778],
    8786: [0.08198, 0.58198, 0, 0, 0.77778],
    8787: [0.08198, 0.58198, 0, 0, 0.77778],
    8790: [0, 0.69224, 0, 0, 0.77778],
    8791: [0.22958, 0.72958, 0, 0, 0.77778],
    8796: [0.08198, 0.91667, 0, 0, 0.77778],
    8806: [0.25583, 0.75583, 0, 0, 0.77778],
    8807: [0.25583, 0.75583, 0, 0, 0.77778],
    8808: [0.25142, 0.75726, 0, 0, 0.77778],
    8809: [0.25142, 0.75726, 0, 0, 0.77778],
    8812: [0.25583, 0.75583, 0, 0, 0.5],
    8814: [0.20576, 0.70576, 0, 0, 0.77778],
    8815: [0.20576, 0.70576, 0, 0, 0.77778],
    8816: [0.30274, 0.79383, 0, 0, 0.77778],
    8817: [0.30274, 0.79383, 0, 0, 0.77778],
    8818: [0.22958, 0.72958, 0, 0, 0.77778],
    8819: [0.22958, 0.72958, 0, 0, 0.77778],
    8822: [0.1808, 0.675, 0, 0, 0.77778],
    8823: [0.1808, 0.675, 0, 0, 0.77778],
    8828: [0.13667, 0.63667, 0, 0, 0.77778],
    8829: [0.13667, 0.63667, 0, 0, 0.77778],
    8830: [0.22958, 0.72958, 0, 0, 0.77778],
    8831: [0.22958, 0.72958, 0, 0, 0.77778],
    8832: [0.20576, 0.70576, 0, 0, 0.77778],
    8833: [0.20576, 0.70576, 0, 0, 0.77778],
    8840: [0.30274, 0.79383, 0, 0, 0.77778],
    8841: [0.30274, 0.79383, 0, 0, 0.77778],
    8842: [0.13597, 0.63597, 0, 0, 0.77778],
    8843: [0.13597, 0.63597, 0, 0, 0.77778],
    8847: [0.03517, 0.54986, 0, 0, 0.77778],
    8848: [0.03517, 0.54986, 0, 0, 0.77778],
    8858: [0.08198, 0.58198, 0, 0, 0.77778],
    8859: [0.08198, 0.58198, 0, 0, 0.77778],
    8861: [0.08198, 0.58198, 0, 0, 0.77778],
    8862: [0, 0.675, 0, 0, 0.77778],
    8863: [0, 0.675, 0, 0, 0.77778],
    8864: [0, 0.675, 0, 0, 0.77778],
    8865: [0, 0.675, 0, 0, 0.77778],
    8872: [0, 0.69224, 0, 0, 0.61111],
    8873: [0, 0.69224, 0, 0, 0.72222],
    8874: [0, 0.69224, 0, 0, 0.88889],
    8876: [0, 0.68889, 0, 0, 0.61111],
    8877: [0, 0.68889, 0, 0, 0.61111],
    8878: [0, 0.68889, 0, 0, 0.72222],
    8879: [0, 0.68889, 0, 0, 0.72222],
    8882: [0.03517, 0.54986, 0, 0, 0.77778],
    8883: [0.03517, 0.54986, 0, 0, 0.77778],
    8884: [0.13667, 0.63667, 0, 0, 0.77778],
    8885: [0.13667, 0.63667, 0, 0, 0.77778],
    8888: [0, 0.54986, 0, 0, 1.11111],
    8890: [0.19444, 0.43056, 0, 0, 0.55556],
    8891: [0.19444, 0.69224, 0, 0, 0.61111],
    8892: [0.19444, 0.69224, 0, 0, 0.61111],
    8901: [0, 0.54986, 0, 0, 0.27778],
    8903: [0.08167, 0.58167, 0, 0, 0.77778],
    8905: [0.08167, 0.58167, 0, 0, 0.77778],
    8906: [0.08167, 0.58167, 0, 0, 0.77778],
    8907: [0, 0.69224, 0, 0, 0.77778],
    8908: [0, 0.69224, 0, 0, 0.77778],
    8909: [-0.03598, 0.46402, 0, 0, 0.77778],
    8910: [0, 0.54986, 0, 0, 0.76042],
    8911: [0, 0.54986, 0, 0, 0.76042],
    8912: [0.03517, 0.54986, 0, 0, 0.77778],
    8913: [0.03517, 0.54986, 0, 0, 0.77778],
    8914: [0, 0.54986, 0, 0, 0.66667],
    8915: [0, 0.54986, 0, 0, 0.66667],
    8916: [0, 0.69224, 0, 0, 0.66667],
    8918: [0.0391, 0.5391, 0, 0, 0.77778],
    8919: [0.0391, 0.5391, 0, 0, 0.77778],
    8920: [0.03517, 0.54986, 0, 0, 1.33334],
    8921: [0.03517, 0.54986, 0, 0, 1.33334],
    8922: [0.38569, 0.88569, 0, 0, 0.77778],
    8923: [0.38569, 0.88569, 0, 0, 0.77778],
    8926: [0.13667, 0.63667, 0, 0, 0.77778],
    8927: [0.13667, 0.63667, 0, 0, 0.77778],
    8928: [0.30274, 0.79383, 0, 0, 0.77778],
    8929: [0.30274, 0.79383, 0, 0, 0.77778],
    8934: [0.23222, 0.74111, 0, 0, 0.77778],
    8935: [0.23222, 0.74111, 0, 0, 0.77778],
    8936: [0.23222, 0.74111, 0, 0, 0.77778],
    8937: [0.23222, 0.74111, 0, 0, 0.77778],
    8938: [0.20576, 0.70576, 0, 0, 0.77778],
    8939: [0.20576, 0.70576, 0, 0, 0.77778],
    8940: [0.30274, 0.79383, 0, 0, 0.77778],
    8941: [0.30274, 0.79383, 0, 0, 0.77778],
    8994: [0.19444, 0.69224, 0, 0, 0.77778],
    8995: [0.19444, 0.69224, 0, 0, 0.77778],
    9416: [0.15559, 0.69224, 0, 0, 0.90222],
    9484: [0, 0.69224, 0, 0, 0.5],
    9488: [0, 0.69224, 0, 0, 0.5],
    9492: [0, 0.37788, 0, 0, 0.5],
    9496: [0, 0.37788, 0, 0, 0.5],
    9585: [0.19444, 0.68889, 0, 0, 0.88889],
    9586: [0.19444, 0.74111, 0, 0, 0.88889],
    9632: [0, 0.675, 0, 0, 0.77778],
    9633: [0, 0.675, 0, 0, 0.77778],
    9650: [0, 0.54986, 0, 0, 0.72222],
    9651: [0, 0.54986, 0, 0, 0.72222],
    9654: [0.03517, 0.54986, 0, 0, 0.77778],
    9660: [0, 0.54986, 0, 0, 0.72222],
    9661: [0, 0.54986, 0, 0, 0.72222],
    9664: [0.03517, 0.54986, 0, 0, 0.77778],
    9674: [0.11111, 0.69224, 0, 0, 0.66667],
    9733: [0.19444, 0.69224, 0, 0, 0.94445],
    10003: [0, 0.69224, 0, 0, 0.83334],
    10016: [0, 0.69224, 0, 0, 0.83334],
    10731: [0.11111, 0.69224, 0, 0, 0.66667],
    10846: [0.19444, 0.75583, 0, 0, 0.61111],
    10877: [0.13667, 0.63667, 0, 0, 0.77778],
    10878: [0.13667, 0.63667, 0, 0, 0.77778],
    10885: [0.25583, 0.75583, 0, 0, 0.77778],
    10886: [0.25583, 0.75583, 0, 0, 0.77778],
    10887: [0.13597, 0.63597, 0, 0, 0.77778],
    10888: [0.13597, 0.63597, 0, 0, 0.77778],
    10889: [0.26167, 0.75726, 0, 0, 0.77778],
    10890: [0.26167, 0.75726, 0, 0, 0.77778],
    10891: [0.48256, 0.98256, 0, 0, 0.77778],
    10892: [0.48256, 0.98256, 0, 0, 0.77778],
    10901: [0.13667, 0.63667, 0, 0, 0.77778],
    10902: [0.13667, 0.63667, 0, 0, 0.77778],
    10933: [0.25142, 0.75726, 0, 0, 0.77778],
    10934: [0.25142, 0.75726, 0, 0, 0.77778],
    10935: [0.26167, 0.75726, 0, 0, 0.77778],
    10936: [0.26167, 0.75726, 0, 0, 0.77778],
    10937: [0.26167, 0.75726, 0, 0, 0.77778],
    10938: [0.26167, 0.75726, 0, 0, 0.77778],
    10949: [0.25583, 0.75583, 0, 0, 0.77778],
    10950: [0.25583, 0.75583, 0, 0, 0.77778],
    10955: [0.28481, 0.79383, 0, 0, 0.77778],
    10956: [0.28481, 0.79383, 0, 0, 0.77778],
    57350: [0.08167, 0.58167, 0, 0, 0.22222],
    57351: [0.08167, 0.58167, 0, 0, 0.38889],
    57352: [0.08167, 0.58167, 0, 0, 0.77778],
    57353: [0, 0.43056, 0.04028, 0, 0.66667],
    57356: [0.25142, 0.75726, 0, 0, 0.77778],
    57357: [0.25142, 0.75726, 0, 0, 0.77778],
    57358: [0.41951, 0.91951, 0, 0, 0.77778],
    57359: [0.30274, 0.79383, 0, 0, 0.77778],
    57360: [0.30274, 0.79383, 0, 0, 0.77778],
    57361: [0.41951, 0.91951, 0, 0, 0.77778],
    57366: [0.25142, 0.75726, 0, 0, 0.77778],
    57367: [0.25142, 0.75726, 0, 0, 0.77778],
    57368: [0.25142, 0.75726, 0, 0, 0.77778],
    57369: [0.25142, 0.75726, 0, 0, 0.77778],
    57370: [0.13597, 0.63597, 0, 0, 0.77778],
    57371: [0.13597, 0.63597, 0, 0, 0.77778]
  },
  "Caligraphic-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.68333, 0, 0.19445, 0.79847],
    66: [0, 0.68333, 0.03041, 0.13889, 0.65681],
    67: [0, 0.68333, 0.05834, 0.13889, 0.52653],
    68: [0, 0.68333, 0.02778, 0.08334, 0.77139],
    69: [0, 0.68333, 0.08944, 0.11111, 0.52778],
    70: [0, 0.68333, 0.09931, 0.11111, 0.71875],
    71: [0.09722, 0.68333, 0.0593, 0.11111, 0.59487],
    72: [0, 0.68333, 965e-5, 0.11111, 0.84452],
    73: [0, 0.68333, 0.07382, 0, 0.54452],
    74: [0.09722, 0.68333, 0.18472, 0.16667, 0.67778],
    75: [0, 0.68333, 0.01445, 0.05556, 0.76195],
    76: [0, 0.68333, 0, 0.13889, 0.68972],
    77: [0, 0.68333, 0, 0.13889, 1.2009],
    78: [0, 0.68333, 0.14736, 0.08334, 0.82049],
    79: [0, 0.68333, 0.02778, 0.11111, 0.79611],
    80: [0, 0.68333, 0.08222, 0.08334, 0.69556],
    81: [0.09722, 0.68333, 0, 0.11111, 0.81667],
    82: [0, 0.68333, 0, 0.08334, 0.8475],
    83: [0, 0.68333, 0.075, 0.13889, 0.60556],
    84: [0, 0.68333, 0.25417, 0, 0.54464],
    85: [0, 0.68333, 0.09931, 0.08334, 0.62583],
    86: [0, 0.68333, 0.08222, 0, 0.61278],
    87: [0, 0.68333, 0.08222, 0.08334, 0.98778],
    88: [0, 0.68333, 0.14643, 0.13889, 0.7133],
    89: [0.09722, 0.68333, 0.08222, 0.08334, 0.66834],
    90: [0, 0.68333, 0.07944, 0.13889, 0.72473],
    160: [0, 0, 0, 0, 0.25]
  },
  "Fraktur-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69141, 0, 0, 0.29574],
    34: [0, 0.69141, 0, 0, 0.21471],
    38: [0, 0.69141, 0, 0, 0.73786],
    39: [0, 0.69141, 0, 0, 0.21201],
    40: [0.24982, 0.74947, 0, 0, 0.38865],
    41: [0.24982, 0.74947, 0, 0, 0.38865],
    42: [0, 0.62119, 0, 0, 0.27764],
    43: [0.08319, 0.58283, 0, 0, 0.75623],
    44: [0, 0.10803, 0, 0, 0.27764],
    45: [0.08319, 0.58283, 0, 0, 0.75623],
    46: [0, 0.10803, 0, 0, 0.27764],
    47: [0.24982, 0.74947, 0, 0, 0.50181],
    48: [0, 0.47534, 0, 0, 0.50181],
    49: [0, 0.47534, 0, 0, 0.50181],
    50: [0, 0.47534, 0, 0, 0.50181],
    51: [0.18906, 0.47534, 0, 0, 0.50181],
    52: [0.18906, 0.47534, 0, 0, 0.50181],
    53: [0.18906, 0.47534, 0, 0, 0.50181],
    54: [0, 0.69141, 0, 0, 0.50181],
    55: [0.18906, 0.47534, 0, 0, 0.50181],
    56: [0, 0.69141, 0, 0, 0.50181],
    57: [0.18906, 0.47534, 0, 0, 0.50181],
    58: [0, 0.47534, 0, 0, 0.21606],
    59: [0.12604, 0.47534, 0, 0, 0.21606],
    61: [-0.13099, 0.36866, 0, 0, 0.75623],
    63: [0, 0.69141, 0, 0, 0.36245],
    65: [0, 0.69141, 0, 0, 0.7176],
    66: [0, 0.69141, 0, 0, 0.88397],
    67: [0, 0.69141, 0, 0, 0.61254],
    68: [0, 0.69141, 0, 0, 0.83158],
    69: [0, 0.69141, 0, 0, 0.66278],
    70: [0.12604, 0.69141, 0, 0, 0.61119],
    71: [0, 0.69141, 0, 0, 0.78539],
    72: [0.06302, 0.69141, 0, 0, 0.7203],
    73: [0, 0.69141, 0, 0, 0.55448],
    74: [0.12604, 0.69141, 0, 0, 0.55231],
    75: [0, 0.69141, 0, 0, 0.66845],
    76: [0, 0.69141, 0, 0, 0.66602],
    77: [0, 0.69141, 0, 0, 1.04953],
    78: [0, 0.69141, 0, 0, 0.83212],
    79: [0, 0.69141, 0, 0, 0.82699],
    80: [0.18906, 0.69141, 0, 0, 0.82753],
    81: [0.03781, 0.69141, 0, 0, 0.82699],
    82: [0, 0.69141, 0, 0, 0.82807],
    83: [0, 0.69141, 0, 0, 0.82861],
    84: [0, 0.69141, 0, 0, 0.66899],
    85: [0, 0.69141, 0, 0, 0.64576],
    86: [0, 0.69141, 0, 0, 0.83131],
    87: [0, 0.69141, 0, 0, 1.04602],
    88: [0, 0.69141, 0, 0, 0.71922],
    89: [0.18906, 0.69141, 0, 0, 0.83293],
    90: [0.12604, 0.69141, 0, 0, 0.60201],
    91: [0.24982, 0.74947, 0, 0, 0.27764],
    93: [0.24982, 0.74947, 0, 0, 0.27764],
    94: [0, 0.69141, 0, 0, 0.49965],
    97: [0, 0.47534, 0, 0, 0.50046],
    98: [0, 0.69141, 0, 0, 0.51315],
    99: [0, 0.47534, 0, 0, 0.38946],
    100: [0, 0.62119, 0, 0, 0.49857],
    101: [0, 0.47534, 0, 0, 0.40053],
    102: [0.18906, 0.69141, 0, 0, 0.32626],
    103: [0.18906, 0.47534, 0, 0, 0.5037],
    104: [0.18906, 0.69141, 0, 0, 0.52126],
    105: [0, 0.69141, 0, 0, 0.27899],
    106: [0, 0.69141, 0, 0, 0.28088],
    107: [0, 0.69141, 0, 0, 0.38946],
    108: [0, 0.69141, 0, 0, 0.27953],
    109: [0, 0.47534, 0, 0, 0.76676],
    110: [0, 0.47534, 0, 0, 0.52666],
    111: [0, 0.47534, 0, 0, 0.48885],
    112: [0.18906, 0.52396, 0, 0, 0.50046],
    113: [0.18906, 0.47534, 0, 0, 0.48912],
    114: [0, 0.47534, 0, 0, 0.38919],
    115: [0, 0.47534, 0, 0, 0.44266],
    116: [0, 0.62119, 0, 0, 0.33301],
    117: [0, 0.47534, 0, 0, 0.5172],
    118: [0, 0.52396, 0, 0, 0.5118],
    119: [0, 0.52396, 0, 0, 0.77351],
    120: [0.18906, 0.47534, 0, 0, 0.38865],
    121: [0.18906, 0.47534, 0, 0, 0.49884],
    122: [0.18906, 0.47534, 0, 0, 0.39054],
    160: [0, 0, 0, 0, 0.25],
    8216: [0, 0.69141, 0, 0, 0.21471],
    8217: [0, 0.69141, 0, 0, 0.21471],
    58112: [0, 0.62119, 0, 0, 0.49749],
    58113: [0, 0.62119, 0, 0, 0.4983],
    58114: [0.18906, 0.69141, 0, 0, 0.33328],
    58115: [0.18906, 0.69141, 0, 0, 0.32923],
    58116: [0.18906, 0.47534, 0, 0, 0.50343],
    58117: [0, 0.69141, 0, 0, 0.33301],
    58118: [0, 0.62119, 0, 0, 0.33409],
    58119: [0, 0.47534, 0, 0, 0.50073]
  },
  "Main-Bold": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.35],
    34: [0, 0.69444, 0, 0, 0.60278],
    35: [0.19444, 0.69444, 0, 0, 0.95833],
    36: [0.05556, 0.75, 0, 0, 0.575],
    37: [0.05556, 0.75, 0, 0, 0.95833],
    38: [0, 0.69444, 0, 0, 0.89444],
    39: [0, 0.69444, 0, 0, 0.31944],
    40: [0.25, 0.75, 0, 0, 0.44722],
    41: [0.25, 0.75, 0, 0, 0.44722],
    42: [0, 0.75, 0, 0, 0.575],
    43: [0.13333, 0.63333, 0, 0, 0.89444],
    44: [0.19444, 0.15556, 0, 0, 0.31944],
    45: [0, 0.44444, 0, 0, 0.38333],
    46: [0, 0.15556, 0, 0, 0.31944],
    47: [0.25, 0.75, 0, 0, 0.575],
    48: [0, 0.64444, 0, 0, 0.575],
    49: [0, 0.64444, 0, 0, 0.575],
    50: [0, 0.64444, 0, 0, 0.575],
    51: [0, 0.64444, 0, 0, 0.575],
    52: [0, 0.64444, 0, 0, 0.575],
    53: [0, 0.64444, 0, 0, 0.575],
    54: [0, 0.64444, 0, 0, 0.575],
    55: [0, 0.64444, 0, 0, 0.575],
    56: [0, 0.64444, 0, 0, 0.575],
    57: [0, 0.64444, 0, 0, 0.575],
    58: [0, 0.44444, 0, 0, 0.31944],
    59: [0.19444, 0.44444, 0, 0, 0.31944],
    60: [0.08556, 0.58556, 0, 0, 0.89444],
    61: [-0.10889, 0.39111, 0, 0, 0.89444],
    62: [0.08556, 0.58556, 0, 0, 0.89444],
    63: [0, 0.69444, 0, 0, 0.54305],
    64: [0, 0.69444, 0, 0, 0.89444],
    65: [0, 0.68611, 0, 0, 0.86944],
    66: [0, 0.68611, 0, 0, 0.81805],
    67: [0, 0.68611, 0, 0, 0.83055],
    68: [0, 0.68611, 0, 0, 0.88194],
    69: [0, 0.68611, 0, 0, 0.75555],
    70: [0, 0.68611, 0, 0, 0.72361],
    71: [0, 0.68611, 0, 0, 0.90416],
    72: [0, 0.68611, 0, 0, 0.9],
    73: [0, 0.68611, 0, 0, 0.43611],
    74: [0, 0.68611, 0, 0, 0.59444],
    75: [0, 0.68611, 0, 0, 0.90138],
    76: [0, 0.68611, 0, 0, 0.69166],
    77: [0, 0.68611, 0, 0, 1.09166],
    78: [0, 0.68611, 0, 0, 0.9],
    79: [0, 0.68611, 0, 0, 0.86388],
    80: [0, 0.68611, 0, 0, 0.78611],
    81: [0.19444, 0.68611, 0, 0, 0.86388],
    82: [0, 0.68611, 0, 0, 0.8625],
    83: [0, 0.68611, 0, 0, 0.63889],
    84: [0, 0.68611, 0, 0, 0.8],
    85: [0, 0.68611, 0, 0, 0.88472],
    86: [0, 0.68611, 0.01597, 0, 0.86944],
    87: [0, 0.68611, 0.01597, 0, 1.18888],
    88: [0, 0.68611, 0, 0, 0.86944],
    89: [0, 0.68611, 0.02875, 0, 0.86944],
    90: [0, 0.68611, 0, 0, 0.70277],
    91: [0.25, 0.75, 0, 0, 0.31944],
    92: [0.25, 0.75, 0, 0, 0.575],
    93: [0.25, 0.75, 0, 0, 0.31944],
    94: [0, 0.69444, 0, 0, 0.575],
    95: [0.31, 0.13444, 0.03194, 0, 0.575],
    97: [0, 0.44444, 0, 0, 0.55902],
    98: [0, 0.69444, 0, 0, 0.63889],
    99: [0, 0.44444, 0, 0, 0.51111],
    100: [0, 0.69444, 0, 0, 0.63889],
    101: [0, 0.44444, 0, 0, 0.52708],
    102: [0, 0.69444, 0.10903, 0, 0.35139],
    103: [0.19444, 0.44444, 0.01597, 0, 0.575],
    104: [0, 0.69444, 0, 0, 0.63889],
    105: [0, 0.69444, 0, 0, 0.31944],
    106: [0.19444, 0.69444, 0, 0, 0.35139],
    107: [0, 0.69444, 0, 0, 0.60694],
    108: [0, 0.69444, 0, 0, 0.31944],
    109: [0, 0.44444, 0, 0, 0.95833],
    110: [0, 0.44444, 0, 0, 0.63889],
    111: [0, 0.44444, 0, 0, 0.575],
    112: [0.19444, 0.44444, 0, 0, 0.63889],
    113: [0.19444, 0.44444, 0, 0, 0.60694],
    114: [0, 0.44444, 0, 0, 0.47361],
    115: [0, 0.44444, 0, 0, 0.45361],
    116: [0, 0.63492, 0, 0, 0.44722],
    117: [0, 0.44444, 0, 0, 0.63889],
    118: [0, 0.44444, 0.01597, 0, 0.60694],
    119: [0, 0.44444, 0.01597, 0, 0.83055],
    120: [0, 0.44444, 0, 0, 0.60694],
    121: [0.19444, 0.44444, 0.01597, 0, 0.60694],
    122: [0, 0.44444, 0, 0, 0.51111],
    123: [0.25, 0.75, 0, 0, 0.575],
    124: [0.25, 0.75, 0, 0, 0.31944],
    125: [0.25, 0.75, 0, 0, 0.575],
    126: [0.35, 0.34444, 0, 0, 0.575],
    160: [0, 0, 0, 0, 0.25],
    163: [0, 0.69444, 0, 0, 0.86853],
    168: [0, 0.69444, 0, 0, 0.575],
    172: [0, 0.44444, 0, 0, 0.76666],
    176: [0, 0.69444, 0, 0, 0.86944],
    177: [0.13333, 0.63333, 0, 0, 0.89444],
    184: [0.17014, 0, 0, 0, 0.51111],
    198: [0, 0.68611, 0, 0, 1.04166],
    215: [0.13333, 0.63333, 0, 0, 0.89444],
    216: [0.04861, 0.73472, 0, 0, 0.89444],
    223: [0, 0.69444, 0, 0, 0.59722],
    230: [0, 0.44444, 0, 0, 0.83055],
    247: [0.13333, 0.63333, 0, 0, 0.89444],
    248: [0.09722, 0.54167, 0, 0, 0.575],
    305: [0, 0.44444, 0, 0, 0.31944],
    338: [0, 0.68611, 0, 0, 1.16944],
    339: [0, 0.44444, 0, 0, 0.89444],
    567: [0.19444, 0.44444, 0, 0, 0.35139],
    710: [0, 0.69444, 0, 0, 0.575],
    711: [0, 0.63194, 0, 0, 0.575],
    713: [0, 0.59611, 0, 0, 0.575],
    714: [0, 0.69444, 0, 0, 0.575],
    715: [0, 0.69444, 0, 0, 0.575],
    728: [0, 0.69444, 0, 0, 0.575],
    729: [0, 0.69444, 0, 0, 0.31944],
    730: [0, 0.69444, 0, 0, 0.86944],
    732: [0, 0.69444, 0, 0, 0.575],
    733: [0, 0.69444, 0, 0, 0.575],
    915: [0, 0.68611, 0, 0, 0.69166],
    916: [0, 0.68611, 0, 0, 0.95833],
    920: [0, 0.68611, 0, 0, 0.89444],
    923: [0, 0.68611, 0, 0, 0.80555],
    926: [0, 0.68611, 0, 0, 0.76666],
    928: [0, 0.68611, 0, 0, 0.9],
    931: [0, 0.68611, 0, 0, 0.83055],
    933: [0, 0.68611, 0, 0, 0.89444],
    934: [0, 0.68611, 0, 0, 0.83055],
    936: [0, 0.68611, 0, 0, 0.89444],
    937: [0, 0.68611, 0, 0, 0.83055],
    8211: [0, 0.44444, 0.03194, 0, 0.575],
    8212: [0, 0.44444, 0.03194, 0, 1.14999],
    8216: [0, 0.69444, 0, 0, 0.31944],
    8217: [0, 0.69444, 0, 0, 0.31944],
    8220: [0, 0.69444, 0, 0, 0.60278],
    8221: [0, 0.69444, 0, 0, 0.60278],
    8224: [0.19444, 0.69444, 0, 0, 0.51111],
    8225: [0.19444, 0.69444, 0, 0, 0.51111],
    8242: [0, 0.55556, 0, 0, 0.34444],
    8407: [0, 0.72444, 0.15486, 0, 0.575],
    8463: [0, 0.69444, 0, 0, 0.66759],
    8465: [0, 0.69444, 0, 0, 0.83055],
    8467: [0, 0.69444, 0, 0, 0.47361],
    8472: [0.19444, 0.44444, 0, 0, 0.74027],
    8476: [0, 0.69444, 0, 0, 0.83055],
    8501: [0, 0.69444, 0, 0, 0.70277],
    8592: [-0.10889, 0.39111, 0, 0, 1.14999],
    8593: [0.19444, 0.69444, 0, 0, 0.575],
    8594: [-0.10889, 0.39111, 0, 0, 1.14999],
    8595: [0.19444, 0.69444, 0, 0, 0.575],
    8596: [-0.10889, 0.39111, 0, 0, 1.14999],
    8597: [0.25, 0.75, 0, 0, 0.575],
    8598: [0.19444, 0.69444, 0, 0, 1.14999],
    8599: [0.19444, 0.69444, 0, 0, 1.14999],
    8600: [0.19444, 0.69444, 0, 0, 1.14999],
    8601: [0.19444, 0.69444, 0, 0, 1.14999],
    8636: [-0.10889, 0.39111, 0, 0, 1.14999],
    8637: [-0.10889, 0.39111, 0, 0, 1.14999],
    8640: [-0.10889, 0.39111, 0, 0, 1.14999],
    8641: [-0.10889, 0.39111, 0, 0, 1.14999],
    8656: [-0.10889, 0.39111, 0, 0, 1.14999],
    8657: [0.19444, 0.69444, 0, 0, 0.70277],
    8658: [-0.10889, 0.39111, 0, 0, 1.14999],
    8659: [0.19444, 0.69444, 0, 0, 0.70277],
    8660: [-0.10889, 0.39111, 0, 0, 1.14999],
    8661: [0.25, 0.75, 0, 0, 0.70277],
    8704: [0, 0.69444, 0, 0, 0.63889],
    8706: [0, 0.69444, 0.06389, 0, 0.62847],
    8707: [0, 0.69444, 0, 0, 0.63889],
    8709: [0.05556, 0.75, 0, 0, 0.575],
    8711: [0, 0.68611, 0, 0, 0.95833],
    8712: [0.08556, 0.58556, 0, 0, 0.76666],
    8715: [0.08556, 0.58556, 0, 0, 0.76666],
    8722: [0.13333, 0.63333, 0, 0, 0.89444],
    8723: [0.13333, 0.63333, 0, 0, 0.89444],
    8725: [0.25, 0.75, 0, 0, 0.575],
    8726: [0.25, 0.75, 0, 0, 0.575],
    8727: [-0.02778, 0.47222, 0, 0, 0.575],
    8728: [-0.02639, 0.47361, 0, 0, 0.575],
    8729: [-0.02639, 0.47361, 0, 0, 0.575],
    8730: [0.18, 0.82, 0, 0, 0.95833],
    8733: [0, 0.44444, 0, 0, 0.89444],
    8734: [0, 0.44444, 0, 0, 1.14999],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8739: [0.25, 0.75, 0, 0, 0.31944],
    8741: [0.25, 0.75, 0, 0, 0.575],
    8743: [0, 0.55556, 0, 0, 0.76666],
    8744: [0, 0.55556, 0, 0, 0.76666],
    8745: [0, 0.55556, 0, 0, 0.76666],
    8746: [0, 0.55556, 0, 0, 0.76666],
    8747: [0.19444, 0.69444, 0.12778, 0, 0.56875],
    8764: [-0.10889, 0.39111, 0, 0, 0.89444],
    8768: [0.19444, 0.69444, 0, 0, 0.31944],
    8771: [222e-5, 0.50222, 0, 0, 0.89444],
    8773: [0.027, 0.638, 0, 0, 0.894],
    8776: [0.02444, 0.52444, 0, 0, 0.89444],
    8781: [222e-5, 0.50222, 0, 0, 0.89444],
    8801: [222e-5, 0.50222, 0, 0, 0.89444],
    8804: [0.19667, 0.69667, 0, 0, 0.89444],
    8805: [0.19667, 0.69667, 0, 0, 0.89444],
    8810: [0.08556, 0.58556, 0, 0, 1.14999],
    8811: [0.08556, 0.58556, 0, 0, 1.14999],
    8826: [0.08556, 0.58556, 0, 0, 0.89444],
    8827: [0.08556, 0.58556, 0, 0, 0.89444],
    8834: [0.08556, 0.58556, 0, 0, 0.89444],
    8835: [0.08556, 0.58556, 0, 0, 0.89444],
    8838: [0.19667, 0.69667, 0, 0, 0.89444],
    8839: [0.19667, 0.69667, 0, 0, 0.89444],
    8846: [0, 0.55556, 0, 0, 0.76666],
    8849: [0.19667, 0.69667, 0, 0, 0.89444],
    8850: [0.19667, 0.69667, 0, 0, 0.89444],
    8851: [0, 0.55556, 0, 0, 0.76666],
    8852: [0, 0.55556, 0, 0, 0.76666],
    8853: [0.13333, 0.63333, 0, 0, 0.89444],
    8854: [0.13333, 0.63333, 0, 0, 0.89444],
    8855: [0.13333, 0.63333, 0, 0, 0.89444],
    8856: [0.13333, 0.63333, 0, 0, 0.89444],
    8857: [0.13333, 0.63333, 0, 0, 0.89444],
    8866: [0, 0.69444, 0, 0, 0.70277],
    8867: [0, 0.69444, 0, 0, 0.70277],
    8868: [0, 0.69444, 0, 0, 0.89444],
    8869: [0, 0.69444, 0, 0, 0.89444],
    8900: [-0.02639, 0.47361, 0, 0, 0.575],
    8901: [-0.02639, 0.47361, 0, 0, 0.31944],
    8902: [-0.02778, 0.47222, 0, 0, 0.575],
    8968: [0.25, 0.75, 0, 0, 0.51111],
    8969: [0.25, 0.75, 0, 0, 0.51111],
    8970: [0.25, 0.75, 0, 0, 0.51111],
    8971: [0.25, 0.75, 0, 0, 0.51111],
    8994: [-0.13889, 0.36111, 0, 0, 1.14999],
    8995: [-0.13889, 0.36111, 0, 0, 1.14999],
    9651: [0.19444, 0.69444, 0, 0, 1.02222],
    9657: [-0.02778, 0.47222, 0, 0, 0.575],
    9661: [0.19444, 0.69444, 0, 0, 1.02222],
    9667: [-0.02778, 0.47222, 0, 0, 0.575],
    9711: [0.19444, 0.69444, 0, 0, 1.14999],
    9824: [0.12963, 0.69444, 0, 0, 0.89444],
    9825: [0.12963, 0.69444, 0, 0, 0.89444],
    9826: [0.12963, 0.69444, 0, 0, 0.89444],
    9827: [0.12963, 0.69444, 0, 0, 0.89444],
    9837: [0, 0.75, 0, 0, 0.44722],
    9838: [0.19444, 0.69444, 0, 0, 0.44722],
    9839: [0.19444, 0.69444, 0, 0, 0.44722],
    10216: [0.25, 0.75, 0, 0, 0.44722],
    10217: [0.25, 0.75, 0, 0, 0.44722],
    10815: [0, 0.68611, 0, 0, 0.9],
    10927: [0.19667, 0.69667, 0, 0, 0.89444],
    10928: [0.19667, 0.69667, 0, 0, 0.89444],
    57376: [0.19444, 0.69444, 0, 0, 0]
  },
  "Main-BoldItalic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.11417, 0, 0.38611],
    34: [0, 0.69444, 0.07939, 0, 0.62055],
    35: [0.19444, 0.69444, 0.06833, 0, 0.94444],
    37: [0.05556, 0.75, 0.12861, 0, 0.94444],
    38: [0, 0.69444, 0.08528, 0, 0.88555],
    39: [0, 0.69444, 0.12945, 0, 0.35555],
    40: [0.25, 0.75, 0.15806, 0, 0.47333],
    41: [0.25, 0.75, 0.03306, 0, 0.47333],
    42: [0, 0.75, 0.14333, 0, 0.59111],
    43: [0.10333, 0.60333, 0.03306, 0, 0.88555],
    44: [0.19444, 0.14722, 0, 0, 0.35555],
    45: [0, 0.44444, 0.02611, 0, 0.41444],
    46: [0, 0.14722, 0, 0, 0.35555],
    47: [0.25, 0.75, 0.15806, 0, 0.59111],
    48: [0, 0.64444, 0.13167, 0, 0.59111],
    49: [0, 0.64444, 0.13167, 0, 0.59111],
    50: [0, 0.64444, 0.13167, 0, 0.59111],
    51: [0, 0.64444, 0.13167, 0, 0.59111],
    52: [0.19444, 0.64444, 0.13167, 0, 0.59111],
    53: [0, 0.64444, 0.13167, 0, 0.59111],
    54: [0, 0.64444, 0.13167, 0, 0.59111],
    55: [0.19444, 0.64444, 0.13167, 0, 0.59111],
    56: [0, 0.64444, 0.13167, 0, 0.59111],
    57: [0, 0.64444, 0.13167, 0, 0.59111],
    58: [0, 0.44444, 0.06695, 0, 0.35555],
    59: [0.19444, 0.44444, 0.06695, 0, 0.35555],
    61: [-0.10889, 0.39111, 0.06833, 0, 0.88555],
    63: [0, 0.69444, 0.11472, 0, 0.59111],
    64: [0, 0.69444, 0.09208, 0, 0.88555],
    65: [0, 0.68611, 0, 0, 0.86555],
    66: [0, 0.68611, 0.0992, 0, 0.81666],
    67: [0, 0.68611, 0.14208, 0, 0.82666],
    68: [0, 0.68611, 0.09062, 0, 0.87555],
    69: [0, 0.68611, 0.11431, 0, 0.75666],
    70: [0, 0.68611, 0.12903, 0, 0.72722],
    71: [0, 0.68611, 0.07347, 0, 0.89527],
    72: [0, 0.68611, 0.17208, 0, 0.8961],
    73: [0, 0.68611, 0.15681, 0, 0.47166],
    74: [0, 0.68611, 0.145, 0, 0.61055],
    75: [0, 0.68611, 0.14208, 0, 0.89499],
    76: [0, 0.68611, 0, 0, 0.69777],
    77: [0, 0.68611, 0.17208, 0, 1.07277],
    78: [0, 0.68611, 0.17208, 0, 0.8961],
    79: [0, 0.68611, 0.09062, 0, 0.85499],
    80: [0, 0.68611, 0.0992, 0, 0.78721],
    81: [0.19444, 0.68611, 0.09062, 0, 0.85499],
    82: [0, 0.68611, 0.02559, 0, 0.85944],
    83: [0, 0.68611, 0.11264, 0, 0.64999],
    84: [0, 0.68611, 0.12903, 0, 0.7961],
    85: [0, 0.68611, 0.17208, 0, 0.88083],
    86: [0, 0.68611, 0.18625, 0, 0.86555],
    87: [0, 0.68611, 0.18625, 0, 1.15999],
    88: [0, 0.68611, 0.15681, 0, 0.86555],
    89: [0, 0.68611, 0.19803, 0, 0.86555],
    90: [0, 0.68611, 0.14208, 0, 0.70888],
    91: [0.25, 0.75, 0.1875, 0, 0.35611],
    93: [0.25, 0.75, 0.09972, 0, 0.35611],
    94: [0, 0.69444, 0.06709, 0, 0.59111],
    95: [0.31, 0.13444, 0.09811, 0, 0.59111],
    97: [0, 0.44444, 0.09426, 0, 0.59111],
    98: [0, 0.69444, 0.07861, 0, 0.53222],
    99: [0, 0.44444, 0.05222, 0, 0.53222],
    100: [0, 0.69444, 0.10861, 0, 0.59111],
    101: [0, 0.44444, 0.085, 0, 0.53222],
    102: [0.19444, 0.69444, 0.21778, 0, 0.4],
    103: [0.19444, 0.44444, 0.105, 0, 0.53222],
    104: [0, 0.69444, 0.09426, 0, 0.59111],
    105: [0, 0.69326, 0.11387, 0, 0.35555],
    106: [0.19444, 0.69326, 0.1672, 0, 0.35555],
    107: [0, 0.69444, 0.11111, 0, 0.53222],
    108: [0, 0.69444, 0.10861, 0, 0.29666],
    109: [0, 0.44444, 0.09426, 0, 0.94444],
    110: [0, 0.44444, 0.09426, 0, 0.64999],
    111: [0, 0.44444, 0.07861, 0, 0.59111],
    112: [0.19444, 0.44444, 0.07861, 0, 0.59111],
    113: [0.19444, 0.44444, 0.105, 0, 0.53222],
    114: [0, 0.44444, 0.11111, 0, 0.50167],
    115: [0, 0.44444, 0.08167, 0, 0.48694],
    116: [0, 0.63492, 0.09639, 0, 0.385],
    117: [0, 0.44444, 0.09426, 0, 0.62055],
    118: [0, 0.44444, 0.11111, 0, 0.53222],
    119: [0, 0.44444, 0.11111, 0, 0.76777],
    120: [0, 0.44444, 0.12583, 0, 0.56055],
    121: [0.19444, 0.44444, 0.105, 0, 0.56166],
    122: [0, 0.44444, 0.13889, 0, 0.49055],
    126: [0.35, 0.34444, 0.11472, 0, 0.59111],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.69444, 0.11473, 0, 0.59111],
    176: [0, 0.69444, 0, 0, 0.94888],
    184: [0.17014, 0, 0, 0, 0.53222],
    198: [0, 0.68611, 0.11431, 0, 1.02277],
    216: [0.04861, 0.73472, 0.09062, 0, 0.88555],
    223: [0.19444, 0.69444, 0.09736, 0, 0.665],
    230: [0, 0.44444, 0.085, 0, 0.82666],
    248: [0.09722, 0.54167, 0.09458, 0, 0.59111],
    305: [0, 0.44444, 0.09426, 0, 0.35555],
    338: [0, 0.68611, 0.11431, 0, 1.14054],
    339: [0, 0.44444, 0.085, 0, 0.82666],
    567: [0.19444, 0.44444, 0.04611, 0, 0.385],
    710: [0, 0.69444, 0.06709, 0, 0.59111],
    711: [0, 0.63194, 0.08271, 0, 0.59111],
    713: [0, 0.59444, 0.10444, 0, 0.59111],
    714: [0, 0.69444, 0.08528, 0, 0.59111],
    715: [0, 0.69444, 0, 0, 0.59111],
    728: [0, 0.69444, 0.10333, 0, 0.59111],
    729: [0, 0.69444, 0.12945, 0, 0.35555],
    730: [0, 0.69444, 0, 0, 0.94888],
    732: [0, 0.69444, 0.11472, 0, 0.59111],
    733: [0, 0.69444, 0.11472, 0, 0.59111],
    915: [0, 0.68611, 0.12903, 0, 0.69777],
    916: [0, 0.68611, 0, 0, 0.94444],
    920: [0, 0.68611, 0.09062, 0, 0.88555],
    923: [0, 0.68611, 0, 0, 0.80666],
    926: [0, 0.68611, 0.15092, 0, 0.76777],
    928: [0, 0.68611, 0.17208, 0, 0.8961],
    931: [0, 0.68611, 0.11431, 0, 0.82666],
    933: [0, 0.68611, 0.10778, 0, 0.88555],
    934: [0, 0.68611, 0.05632, 0, 0.82666],
    936: [0, 0.68611, 0.10778, 0, 0.88555],
    937: [0, 0.68611, 0.0992, 0, 0.82666],
    8211: [0, 0.44444, 0.09811, 0, 0.59111],
    8212: [0, 0.44444, 0.09811, 0, 1.18221],
    8216: [0, 0.69444, 0.12945, 0, 0.35555],
    8217: [0, 0.69444, 0.12945, 0, 0.35555],
    8220: [0, 0.69444, 0.16772, 0, 0.62055],
    8221: [0, 0.69444, 0.07939, 0, 0.62055]
  },
  "Main-Italic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.12417, 0, 0.30667],
    34: [0, 0.69444, 0.06961, 0, 0.51444],
    35: [0.19444, 0.69444, 0.06616, 0, 0.81777],
    37: [0.05556, 0.75, 0.13639, 0, 0.81777],
    38: [0, 0.69444, 0.09694, 0, 0.76666],
    39: [0, 0.69444, 0.12417, 0, 0.30667],
    40: [0.25, 0.75, 0.16194, 0, 0.40889],
    41: [0.25, 0.75, 0.03694, 0, 0.40889],
    42: [0, 0.75, 0.14917, 0, 0.51111],
    43: [0.05667, 0.56167, 0.03694, 0, 0.76666],
    44: [0.19444, 0.10556, 0, 0, 0.30667],
    45: [0, 0.43056, 0.02826, 0, 0.35778],
    46: [0, 0.10556, 0, 0, 0.30667],
    47: [0.25, 0.75, 0.16194, 0, 0.51111],
    48: [0, 0.64444, 0.13556, 0, 0.51111],
    49: [0, 0.64444, 0.13556, 0, 0.51111],
    50: [0, 0.64444, 0.13556, 0, 0.51111],
    51: [0, 0.64444, 0.13556, 0, 0.51111],
    52: [0.19444, 0.64444, 0.13556, 0, 0.51111],
    53: [0, 0.64444, 0.13556, 0, 0.51111],
    54: [0, 0.64444, 0.13556, 0, 0.51111],
    55: [0.19444, 0.64444, 0.13556, 0, 0.51111],
    56: [0, 0.64444, 0.13556, 0, 0.51111],
    57: [0, 0.64444, 0.13556, 0, 0.51111],
    58: [0, 0.43056, 0.0582, 0, 0.30667],
    59: [0.19444, 0.43056, 0.0582, 0, 0.30667],
    61: [-0.13313, 0.36687, 0.06616, 0, 0.76666],
    63: [0, 0.69444, 0.1225, 0, 0.51111],
    64: [0, 0.69444, 0.09597, 0, 0.76666],
    65: [0, 0.68333, 0, 0, 0.74333],
    66: [0, 0.68333, 0.10257, 0, 0.70389],
    67: [0, 0.68333, 0.14528, 0, 0.71555],
    68: [0, 0.68333, 0.09403, 0, 0.755],
    69: [0, 0.68333, 0.12028, 0, 0.67833],
    70: [0, 0.68333, 0.13305, 0, 0.65277],
    71: [0, 0.68333, 0.08722, 0, 0.77361],
    72: [0, 0.68333, 0.16389, 0, 0.74333],
    73: [0, 0.68333, 0.15806, 0, 0.38555],
    74: [0, 0.68333, 0.14028, 0, 0.525],
    75: [0, 0.68333, 0.14528, 0, 0.76888],
    76: [0, 0.68333, 0, 0, 0.62722],
    77: [0, 0.68333, 0.16389, 0, 0.89666],
    78: [0, 0.68333, 0.16389, 0, 0.74333],
    79: [0, 0.68333, 0.09403, 0, 0.76666],
    80: [0, 0.68333, 0.10257, 0, 0.67833],
    81: [0.19444, 0.68333, 0.09403, 0, 0.76666],
    82: [0, 0.68333, 0.03868, 0, 0.72944],
    83: [0, 0.68333, 0.11972, 0, 0.56222],
    84: [0, 0.68333, 0.13305, 0, 0.71555],
    85: [0, 0.68333, 0.16389, 0, 0.74333],
    86: [0, 0.68333, 0.18361, 0, 0.74333],
    87: [0, 0.68333, 0.18361, 0, 0.99888],
    88: [0, 0.68333, 0.15806, 0, 0.74333],
    89: [0, 0.68333, 0.19383, 0, 0.74333],
    90: [0, 0.68333, 0.14528, 0, 0.61333],
    91: [0.25, 0.75, 0.1875, 0, 0.30667],
    93: [0.25, 0.75, 0.10528, 0, 0.30667],
    94: [0, 0.69444, 0.06646, 0, 0.51111],
    95: [0.31, 0.12056, 0.09208, 0, 0.51111],
    97: [0, 0.43056, 0.07671, 0, 0.51111],
    98: [0, 0.69444, 0.06312, 0, 0.46],
    99: [0, 0.43056, 0.05653, 0, 0.46],
    100: [0, 0.69444, 0.10333, 0, 0.51111],
    101: [0, 0.43056, 0.07514, 0, 0.46],
    102: [0.19444, 0.69444, 0.21194, 0, 0.30667],
    103: [0.19444, 0.43056, 0.08847, 0, 0.46],
    104: [0, 0.69444, 0.07671, 0, 0.51111],
    105: [0, 0.65536, 0.1019, 0, 0.30667],
    106: [0.19444, 0.65536, 0.14467, 0, 0.30667],
    107: [0, 0.69444, 0.10764, 0, 0.46],
    108: [0, 0.69444, 0.10333, 0, 0.25555],
    109: [0, 0.43056, 0.07671, 0, 0.81777],
    110: [0, 0.43056, 0.07671, 0, 0.56222],
    111: [0, 0.43056, 0.06312, 0, 0.51111],
    112: [0.19444, 0.43056, 0.06312, 0, 0.51111],
    113: [0.19444, 0.43056, 0.08847, 0, 0.46],
    114: [0, 0.43056, 0.10764, 0, 0.42166],
    115: [0, 0.43056, 0.08208, 0, 0.40889],
    116: [0, 0.61508, 0.09486, 0, 0.33222],
    117: [0, 0.43056, 0.07671, 0, 0.53666],
    118: [0, 0.43056, 0.10764, 0, 0.46],
    119: [0, 0.43056, 0.10764, 0, 0.66444],
    120: [0, 0.43056, 0.12042, 0, 0.46389],
    121: [0.19444, 0.43056, 0.08847, 0, 0.48555],
    122: [0, 0.43056, 0.12292, 0, 0.40889],
    126: [0.35, 0.31786, 0.11585, 0, 0.51111],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.66786, 0.10474, 0, 0.51111],
    176: [0, 0.69444, 0, 0, 0.83129],
    184: [0.17014, 0, 0, 0, 0.46],
    198: [0, 0.68333, 0.12028, 0, 0.88277],
    216: [0.04861, 0.73194, 0.09403, 0, 0.76666],
    223: [0.19444, 0.69444, 0.10514, 0, 0.53666],
    230: [0, 0.43056, 0.07514, 0, 0.71555],
    248: [0.09722, 0.52778, 0.09194, 0, 0.51111],
    338: [0, 0.68333, 0.12028, 0, 0.98499],
    339: [0, 0.43056, 0.07514, 0, 0.71555],
    710: [0, 0.69444, 0.06646, 0, 0.51111],
    711: [0, 0.62847, 0.08295, 0, 0.51111],
    713: [0, 0.56167, 0.10333, 0, 0.51111],
    714: [0, 0.69444, 0.09694, 0, 0.51111],
    715: [0, 0.69444, 0, 0, 0.51111],
    728: [0, 0.69444, 0.10806, 0, 0.51111],
    729: [0, 0.66786, 0.11752, 0, 0.30667],
    730: [0, 0.69444, 0, 0, 0.83129],
    732: [0, 0.66786, 0.11585, 0, 0.51111],
    733: [0, 0.69444, 0.1225, 0, 0.51111],
    915: [0, 0.68333, 0.13305, 0, 0.62722],
    916: [0, 0.68333, 0, 0, 0.81777],
    920: [0, 0.68333, 0.09403, 0, 0.76666],
    923: [0, 0.68333, 0, 0, 0.69222],
    926: [0, 0.68333, 0.15294, 0, 0.66444],
    928: [0, 0.68333, 0.16389, 0, 0.74333],
    931: [0, 0.68333, 0.12028, 0, 0.71555],
    933: [0, 0.68333, 0.11111, 0, 0.76666],
    934: [0, 0.68333, 0.05986, 0, 0.71555],
    936: [0, 0.68333, 0.11111, 0, 0.76666],
    937: [0, 0.68333, 0.10257, 0, 0.71555],
    8211: [0, 0.43056, 0.09208, 0, 0.51111],
    8212: [0, 0.43056, 0.09208, 0, 1.02222],
    8216: [0, 0.69444, 0.12417, 0, 0.30667],
    8217: [0, 0.69444, 0.12417, 0, 0.30667],
    8220: [0, 0.69444, 0.1685, 0, 0.51444],
    8221: [0, 0.69444, 0.06961, 0, 0.51444],
    8463: [0, 0.68889, 0, 0, 0.54028]
  },
  "Main-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.27778],
    34: [0, 0.69444, 0, 0, 0.5],
    35: [0.19444, 0.69444, 0, 0, 0.83334],
    36: [0.05556, 0.75, 0, 0, 0.5],
    37: [0.05556, 0.75, 0, 0, 0.83334],
    38: [0, 0.69444, 0, 0, 0.77778],
    39: [0, 0.69444, 0, 0, 0.27778],
    40: [0.25, 0.75, 0, 0, 0.38889],
    41: [0.25, 0.75, 0, 0, 0.38889],
    42: [0, 0.75, 0, 0, 0.5],
    43: [0.08333, 0.58333, 0, 0, 0.77778],
    44: [0.19444, 0.10556, 0, 0, 0.27778],
    45: [0, 0.43056, 0, 0, 0.33333],
    46: [0, 0.10556, 0, 0, 0.27778],
    47: [0.25, 0.75, 0, 0, 0.5],
    48: [0, 0.64444, 0, 0, 0.5],
    49: [0, 0.64444, 0, 0, 0.5],
    50: [0, 0.64444, 0, 0, 0.5],
    51: [0, 0.64444, 0, 0, 0.5],
    52: [0, 0.64444, 0, 0, 0.5],
    53: [0, 0.64444, 0, 0, 0.5],
    54: [0, 0.64444, 0, 0, 0.5],
    55: [0, 0.64444, 0, 0, 0.5],
    56: [0, 0.64444, 0, 0, 0.5],
    57: [0, 0.64444, 0, 0, 0.5],
    58: [0, 0.43056, 0, 0, 0.27778],
    59: [0.19444, 0.43056, 0, 0, 0.27778],
    60: [0.0391, 0.5391, 0, 0, 0.77778],
    61: [-0.13313, 0.36687, 0, 0, 0.77778],
    62: [0.0391, 0.5391, 0, 0, 0.77778],
    63: [0, 0.69444, 0, 0, 0.47222],
    64: [0, 0.69444, 0, 0, 0.77778],
    65: [0, 0.68333, 0, 0, 0.75],
    66: [0, 0.68333, 0, 0, 0.70834],
    67: [0, 0.68333, 0, 0, 0.72222],
    68: [0, 0.68333, 0, 0, 0.76389],
    69: [0, 0.68333, 0, 0, 0.68056],
    70: [0, 0.68333, 0, 0, 0.65278],
    71: [0, 0.68333, 0, 0, 0.78472],
    72: [0, 0.68333, 0, 0, 0.75],
    73: [0, 0.68333, 0, 0, 0.36111],
    74: [0, 0.68333, 0, 0, 0.51389],
    75: [0, 0.68333, 0, 0, 0.77778],
    76: [0, 0.68333, 0, 0, 0.625],
    77: [0, 0.68333, 0, 0, 0.91667],
    78: [0, 0.68333, 0, 0, 0.75],
    79: [0, 0.68333, 0, 0, 0.77778],
    80: [0, 0.68333, 0, 0, 0.68056],
    81: [0.19444, 0.68333, 0, 0, 0.77778],
    82: [0, 0.68333, 0, 0, 0.73611],
    83: [0, 0.68333, 0, 0, 0.55556],
    84: [0, 0.68333, 0, 0, 0.72222],
    85: [0, 0.68333, 0, 0, 0.75],
    86: [0, 0.68333, 0.01389, 0, 0.75],
    87: [0, 0.68333, 0.01389, 0, 1.02778],
    88: [0, 0.68333, 0, 0, 0.75],
    89: [0, 0.68333, 0.025, 0, 0.75],
    90: [0, 0.68333, 0, 0, 0.61111],
    91: [0.25, 0.75, 0, 0, 0.27778],
    92: [0.25, 0.75, 0, 0, 0.5],
    93: [0.25, 0.75, 0, 0, 0.27778],
    94: [0, 0.69444, 0, 0, 0.5],
    95: [0.31, 0.12056, 0.02778, 0, 0.5],
    97: [0, 0.43056, 0, 0, 0.5],
    98: [0, 0.69444, 0, 0, 0.55556],
    99: [0, 0.43056, 0, 0, 0.44445],
    100: [0, 0.69444, 0, 0, 0.55556],
    101: [0, 0.43056, 0, 0, 0.44445],
    102: [0, 0.69444, 0.07778, 0, 0.30556],
    103: [0.19444, 0.43056, 0.01389, 0, 0.5],
    104: [0, 0.69444, 0, 0, 0.55556],
    105: [0, 0.66786, 0, 0, 0.27778],
    106: [0.19444, 0.66786, 0, 0, 0.30556],
    107: [0, 0.69444, 0, 0, 0.52778],
    108: [0, 0.69444, 0, 0, 0.27778],
    109: [0, 0.43056, 0, 0, 0.83334],
    110: [0, 0.43056, 0, 0, 0.55556],
    111: [0, 0.43056, 0, 0, 0.5],
    112: [0.19444, 0.43056, 0, 0, 0.55556],
    113: [0.19444, 0.43056, 0, 0, 0.52778],
    114: [0, 0.43056, 0, 0, 0.39167],
    115: [0, 0.43056, 0, 0, 0.39445],
    116: [0, 0.61508, 0, 0, 0.38889],
    117: [0, 0.43056, 0, 0, 0.55556],
    118: [0, 0.43056, 0.01389, 0, 0.52778],
    119: [0, 0.43056, 0.01389, 0, 0.72222],
    120: [0, 0.43056, 0, 0, 0.52778],
    121: [0.19444, 0.43056, 0.01389, 0, 0.52778],
    122: [0, 0.43056, 0, 0, 0.44445],
    123: [0.25, 0.75, 0, 0, 0.5],
    124: [0.25, 0.75, 0, 0, 0.27778],
    125: [0.25, 0.75, 0, 0, 0.5],
    126: [0.35, 0.31786, 0, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    163: [0, 0.69444, 0, 0, 0.76909],
    167: [0.19444, 0.69444, 0, 0, 0.44445],
    168: [0, 0.66786, 0, 0, 0.5],
    172: [0, 0.43056, 0, 0, 0.66667],
    176: [0, 0.69444, 0, 0, 0.75],
    177: [0.08333, 0.58333, 0, 0, 0.77778],
    182: [0.19444, 0.69444, 0, 0, 0.61111],
    184: [0.17014, 0, 0, 0, 0.44445],
    198: [0, 0.68333, 0, 0, 0.90278],
    215: [0.08333, 0.58333, 0, 0, 0.77778],
    216: [0.04861, 0.73194, 0, 0, 0.77778],
    223: [0, 0.69444, 0, 0, 0.5],
    230: [0, 0.43056, 0, 0, 0.72222],
    247: [0.08333, 0.58333, 0, 0, 0.77778],
    248: [0.09722, 0.52778, 0, 0, 0.5],
    305: [0, 0.43056, 0, 0, 0.27778],
    338: [0, 0.68333, 0, 0, 1.01389],
    339: [0, 0.43056, 0, 0, 0.77778],
    567: [0.19444, 0.43056, 0, 0, 0.30556],
    710: [0, 0.69444, 0, 0, 0.5],
    711: [0, 0.62847, 0, 0, 0.5],
    713: [0, 0.56778, 0, 0, 0.5],
    714: [0, 0.69444, 0, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0, 0, 0.5],
    729: [0, 0.66786, 0, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.75],
    732: [0, 0.66786, 0, 0, 0.5],
    733: [0, 0.69444, 0, 0, 0.5],
    915: [0, 0.68333, 0, 0, 0.625],
    916: [0, 0.68333, 0, 0, 0.83334],
    920: [0, 0.68333, 0, 0, 0.77778],
    923: [0, 0.68333, 0, 0, 0.69445],
    926: [0, 0.68333, 0, 0, 0.66667],
    928: [0, 0.68333, 0, 0, 0.75],
    931: [0, 0.68333, 0, 0, 0.72222],
    933: [0, 0.68333, 0, 0, 0.77778],
    934: [0, 0.68333, 0, 0, 0.72222],
    936: [0, 0.68333, 0, 0, 0.77778],
    937: [0, 0.68333, 0, 0, 0.72222],
    8211: [0, 0.43056, 0.02778, 0, 0.5],
    8212: [0, 0.43056, 0.02778, 0, 1],
    8216: [0, 0.69444, 0, 0, 0.27778],
    8217: [0, 0.69444, 0, 0, 0.27778],
    8220: [0, 0.69444, 0, 0, 0.5],
    8221: [0, 0.69444, 0, 0, 0.5],
    8224: [0.19444, 0.69444, 0, 0, 0.44445],
    8225: [0.19444, 0.69444, 0, 0, 0.44445],
    8230: [0, 0.123, 0, 0, 1.172],
    8242: [0, 0.55556, 0, 0, 0.275],
    8407: [0, 0.71444, 0.15382, 0, 0.5],
    8463: [0, 0.68889, 0, 0, 0.54028],
    8465: [0, 0.69444, 0, 0, 0.72222],
    8467: [0, 0.69444, 0, 0.11111, 0.41667],
    8472: [0.19444, 0.43056, 0, 0.11111, 0.63646],
    8476: [0, 0.69444, 0, 0, 0.72222],
    8501: [0, 0.69444, 0, 0, 0.61111],
    8592: [-0.13313, 0.36687, 0, 0, 1],
    8593: [0.19444, 0.69444, 0, 0, 0.5],
    8594: [-0.13313, 0.36687, 0, 0, 1],
    8595: [0.19444, 0.69444, 0, 0, 0.5],
    8596: [-0.13313, 0.36687, 0, 0, 1],
    8597: [0.25, 0.75, 0, 0, 0.5],
    8598: [0.19444, 0.69444, 0, 0, 1],
    8599: [0.19444, 0.69444, 0, 0, 1],
    8600: [0.19444, 0.69444, 0, 0, 1],
    8601: [0.19444, 0.69444, 0, 0, 1],
    8614: [0.011, 0.511, 0, 0, 1],
    8617: [0.011, 0.511, 0, 0, 1.126],
    8618: [0.011, 0.511, 0, 0, 1.126],
    8636: [-0.13313, 0.36687, 0, 0, 1],
    8637: [-0.13313, 0.36687, 0, 0, 1],
    8640: [-0.13313, 0.36687, 0, 0, 1],
    8641: [-0.13313, 0.36687, 0, 0, 1],
    8652: [0.011, 0.671, 0, 0, 1],
    8656: [-0.13313, 0.36687, 0, 0, 1],
    8657: [0.19444, 0.69444, 0, 0, 0.61111],
    8658: [-0.13313, 0.36687, 0, 0, 1],
    8659: [0.19444, 0.69444, 0, 0, 0.61111],
    8660: [-0.13313, 0.36687, 0, 0, 1],
    8661: [0.25, 0.75, 0, 0, 0.61111],
    8704: [0, 0.69444, 0, 0, 0.55556],
    8706: [0, 0.69444, 0.05556, 0.08334, 0.5309],
    8707: [0, 0.69444, 0, 0, 0.55556],
    8709: [0.05556, 0.75, 0, 0, 0.5],
    8711: [0, 0.68333, 0, 0, 0.83334],
    8712: [0.0391, 0.5391, 0, 0, 0.66667],
    8715: [0.0391, 0.5391, 0, 0, 0.66667],
    8722: [0.08333, 0.58333, 0, 0, 0.77778],
    8723: [0.08333, 0.58333, 0, 0, 0.77778],
    8725: [0.25, 0.75, 0, 0, 0.5],
    8726: [0.25, 0.75, 0, 0, 0.5],
    8727: [-0.03472, 0.46528, 0, 0, 0.5],
    8728: [-0.05555, 0.44445, 0, 0, 0.5],
    8729: [-0.05555, 0.44445, 0, 0, 0.5],
    8730: [0.2, 0.8, 0, 0, 0.83334],
    8733: [0, 0.43056, 0, 0, 0.77778],
    8734: [0, 0.43056, 0, 0, 1],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8739: [0.25, 0.75, 0, 0, 0.27778],
    8741: [0.25, 0.75, 0, 0, 0.5],
    8743: [0, 0.55556, 0, 0, 0.66667],
    8744: [0, 0.55556, 0, 0, 0.66667],
    8745: [0, 0.55556, 0, 0, 0.66667],
    8746: [0, 0.55556, 0, 0, 0.66667],
    8747: [0.19444, 0.69444, 0.11111, 0, 0.41667],
    8764: [-0.13313, 0.36687, 0, 0, 0.77778],
    8768: [0.19444, 0.69444, 0, 0, 0.27778],
    8771: [-0.03625, 0.46375, 0, 0, 0.77778],
    8773: [-0.022, 0.589, 0, 0, 0.778],
    8776: [-0.01688, 0.48312, 0, 0, 0.77778],
    8781: [-0.03625, 0.46375, 0, 0, 0.77778],
    8784: [-0.133, 0.673, 0, 0, 0.778],
    8801: [-0.03625, 0.46375, 0, 0, 0.77778],
    8804: [0.13597, 0.63597, 0, 0, 0.77778],
    8805: [0.13597, 0.63597, 0, 0, 0.77778],
    8810: [0.0391, 0.5391, 0, 0, 1],
    8811: [0.0391, 0.5391, 0, 0, 1],
    8826: [0.0391, 0.5391, 0, 0, 0.77778],
    8827: [0.0391, 0.5391, 0, 0, 0.77778],
    8834: [0.0391, 0.5391, 0, 0, 0.77778],
    8835: [0.0391, 0.5391, 0, 0, 0.77778],
    8838: [0.13597, 0.63597, 0, 0, 0.77778],
    8839: [0.13597, 0.63597, 0, 0, 0.77778],
    8846: [0, 0.55556, 0, 0, 0.66667],
    8849: [0.13597, 0.63597, 0, 0, 0.77778],
    8850: [0.13597, 0.63597, 0, 0, 0.77778],
    8851: [0, 0.55556, 0, 0, 0.66667],
    8852: [0, 0.55556, 0, 0, 0.66667],
    8853: [0.08333, 0.58333, 0, 0, 0.77778],
    8854: [0.08333, 0.58333, 0, 0, 0.77778],
    8855: [0.08333, 0.58333, 0, 0, 0.77778],
    8856: [0.08333, 0.58333, 0, 0, 0.77778],
    8857: [0.08333, 0.58333, 0, 0, 0.77778],
    8866: [0, 0.69444, 0, 0, 0.61111],
    8867: [0, 0.69444, 0, 0, 0.61111],
    8868: [0, 0.69444, 0, 0, 0.77778],
    8869: [0, 0.69444, 0, 0, 0.77778],
    8872: [0.249, 0.75, 0, 0, 0.867],
    8900: [-0.05555, 0.44445, 0, 0, 0.5],
    8901: [-0.05555, 0.44445, 0, 0, 0.27778],
    8902: [-0.03472, 0.46528, 0, 0, 0.5],
    8904: [5e-3, 0.505, 0, 0, 0.9],
    8942: [0.03, 0.903, 0, 0, 0.278],
    8943: [-0.19, 0.313, 0, 0, 1.172],
    8945: [-0.1, 0.823, 0, 0, 1.282],
    8968: [0.25, 0.75, 0, 0, 0.44445],
    8969: [0.25, 0.75, 0, 0, 0.44445],
    8970: [0.25, 0.75, 0, 0, 0.44445],
    8971: [0.25, 0.75, 0, 0, 0.44445],
    8994: [-0.14236, 0.35764, 0, 0, 1],
    8995: [-0.14236, 0.35764, 0, 0, 1],
    9136: [0.244, 0.744, 0, 0, 0.412],
    9137: [0.244, 0.745, 0, 0, 0.412],
    9651: [0.19444, 0.69444, 0, 0, 0.88889],
    9657: [-0.03472, 0.46528, 0, 0, 0.5],
    9661: [0.19444, 0.69444, 0, 0, 0.88889],
    9667: [-0.03472, 0.46528, 0, 0, 0.5],
    9711: [0.19444, 0.69444, 0, 0, 1],
    9824: [0.12963, 0.69444, 0, 0, 0.77778],
    9825: [0.12963, 0.69444, 0, 0, 0.77778],
    9826: [0.12963, 0.69444, 0, 0, 0.77778],
    9827: [0.12963, 0.69444, 0, 0, 0.77778],
    9837: [0, 0.75, 0, 0, 0.38889],
    9838: [0.19444, 0.69444, 0, 0, 0.38889],
    9839: [0.19444, 0.69444, 0, 0, 0.38889],
    10216: [0.25, 0.75, 0, 0, 0.38889],
    10217: [0.25, 0.75, 0, 0, 0.38889],
    10222: [0.244, 0.744, 0, 0, 0.412],
    10223: [0.244, 0.745, 0, 0, 0.412],
    10229: [0.011, 0.511, 0, 0, 1.609],
    10230: [0.011, 0.511, 0, 0, 1.638],
    10231: [0.011, 0.511, 0, 0, 1.859],
    10232: [0.024, 0.525, 0, 0, 1.609],
    10233: [0.024, 0.525, 0, 0, 1.638],
    10234: [0.024, 0.525, 0, 0, 1.858],
    10236: [0.011, 0.511, 0, 0, 1.638],
    10815: [0, 0.68333, 0, 0, 0.75],
    10927: [0.13597, 0.63597, 0, 0, 0.77778],
    10928: [0.13597, 0.63597, 0, 0, 0.77778],
    57376: [0.19444, 0.69444, 0, 0, 0]
  },
  "Math-BoldItalic": {
    32: [0, 0, 0, 0, 0.25],
    48: [0, 0.44444, 0, 0, 0.575],
    49: [0, 0.44444, 0, 0, 0.575],
    50: [0, 0.44444, 0, 0, 0.575],
    51: [0.19444, 0.44444, 0, 0, 0.575],
    52: [0.19444, 0.44444, 0, 0, 0.575],
    53: [0.19444, 0.44444, 0, 0, 0.575],
    54: [0, 0.64444, 0, 0, 0.575],
    55: [0.19444, 0.44444, 0, 0, 0.575],
    56: [0, 0.64444, 0, 0, 0.575],
    57: [0.19444, 0.44444, 0, 0, 0.575],
    65: [0, 0.68611, 0, 0, 0.86944],
    66: [0, 0.68611, 0.04835, 0, 0.8664],
    67: [0, 0.68611, 0.06979, 0, 0.81694],
    68: [0, 0.68611, 0.03194, 0, 0.93812],
    69: [0, 0.68611, 0.05451, 0, 0.81007],
    70: [0, 0.68611, 0.15972, 0, 0.68889],
    71: [0, 0.68611, 0, 0, 0.88673],
    72: [0, 0.68611, 0.08229, 0, 0.98229],
    73: [0, 0.68611, 0.07778, 0, 0.51111],
    74: [0, 0.68611, 0.10069, 0, 0.63125],
    75: [0, 0.68611, 0.06979, 0, 0.97118],
    76: [0, 0.68611, 0, 0, 0.75555],
    77: [0, 0.68611, 0.11424, 0, 1.14201],
    78: [0, 0.68611, 0.11424, 0, 0.95034],
    79: [0, 0.68611, 0.03194, 0, 0.83666],
    80: [0, 0.68611, 0.15972, 0, 0.72309],
    81: [0.19444, 0.68611, 0, 0, 0.86861],
    82: [0, 0.68611, 421e-5, 0, 0.87235],
    83: [0, 0.68611, 0.05382, 0, 0.69271],
    84: [0, 0.68611, 0.15972, 0, 0.63663],
    85: [0, 0.68611, 0.11424, 0, 0.80027],
    86: [0, 0.68611, 0.25555, 0, 0.67778],
    87: [0, 0.68611, 0.15972, 0, 1.09305],
    88: [0, 0.68611, 0.07778, 0, 0.94722],
    89: [0, 0.68611, 0.25555, 0, 0.67458],
    90: [0, 0.68611, 0.06979, 0, 0.77257],
    97: [0, 0.44444, 0, 0, 0.63287],
    98: [0, 0.69444, 0, 0, 0.52083],
    99: [0, 0.44444, 0, 0, 0.51342],
    100: [0, 0.69444, 0, 0, 0.60972],
    101: [0, 0.44444, 0, 0, 0.55361],
    102: [0.19444, 0.69444, 0.11042, 0, 0.56806],
    103: [0.19444, 0.44444, 0.03704, 0, 0.5449],
    104: [0, 0.69444, 0, 0, 0.66759],
    105: [0, 0.69326, 0, 0, 0.4048],
    106: [0.19444, 0.69326, 0.0622, 0, 0.47083],
    107: [0, 0.69444, 0.01852, 0, 0.6037],
    108: [0, 0.69444, 88e-4, 0, 0.34815],
    109: [0, 0.44444, 0, 0, 1.0324],
    110: [0, 0.44444, 0, 0, 0.71296],
    111: [0, 0.44444, 0, 0, 0.58472],
    112: [0.19444, 0.44444, 0, 0, 0.60092],
    113: [0.19444, 0.44444, 0.03704, 0, 0.54213],
    114: [0, 0.44444, 0.03194, 0, 0.5287],
    115: [0, 0.44444, 0, 0, 0.53125],
    116: [0, 0.63492, 0, 0, 0.41528],
    117: [0, 0.44444, 0, 0, 0.68102],
    118: [0, 0.44444, 0.03704, 0, 0.56666],
    119: [0, 0.44444, 0.02778, 0, 0.83148],
    120: [0, 0.44444, 0, 0, 0.65903],
    121: [0.19444, 0.44444, 0.03704, 0, 0.59028],
    122: [0, 0.44444, 0.04213, 0, 0.55509],
    160: [0, 0, 0, 0, 0.25],
    915: [0, 0.68611, 0.15972, 0, 0.65694],
    916: [0, 0.68611, 0, 0, 0.95833],
    920: [0, 0.68611, 0.03194, 0, 0.86722],
    923: [0, 0.68611, 0, 0, 0.80555],
    926: [0, 0.68611, 0.07458, 0, 0.84125],
    928: [0, 0.68611, 0.08229, 0, 0.98229],
    931: [0, 0.68611, 0.05451, 0, 0.88507],
    933: [0, 0.68611, 0.15972, 0, 0.67083],
    934: [0, 0.68611, 0, 0, 0.76666],
    936: [0, 0.68611, 0.11653, 0, 0.71402],
    937: [0, 0.68611, 0.04835, 0, 0.8789],
    945: [0, 0.44444, 0, 0, 0.76064],
    946: [0.19444, 0.69444, 0.03403, 0, 0.65972],
    947: [0.19444, 0.44444, 0.06389, 0, 0.59003],
    948: [0, 0.69444, 0.03819, 0, 0.52222],
    949: [0, 0.44444, 0, 0, 0.52882],
    950: [0.19444, 0.69444, 0.06215, 0, 0.50833],
    951: [0.19444, 0.44444, 0.03704, 0, 0.6],
    952: [0, 0.69444, 0.03194, 0, 0.5618],
    953: [0, 0.44444, 0, 0, 0.41204],
    954: [0, 0.44444, 0, 0, 0.66759],
    955: [0, 0.69444, 0, 0, 0.67083],
    956: [0.19444, 0.44444, 0, 0, 0.70787],
    957: [0, 0.44444, 0.06898, 0, 0.57685],
    958: [0.19444, 0.69444, 0.03021, 0, 0.50833],
    959: [0, 0.44444, 0, 0, 0.58472],
    960: [0, 0.44444, 0.03704, 0, 0.68241],
    961: [0.19444, 0.44444, 0, 0, 0.6118],
    962: [0.09722, 0.44444, 0.07917, 0, 0.42361],
    963: [0, 0.44444, 0.03704, 0, 0.68588],
    964: [0, 0.44444, 0.13472, 0, 0.52083],
    965: [0, 0.44444, 0.03704, 0, 0.63055],
    966: [0.19444, 0.44444, 0, 0, 0.74722],
    967: [0.19444, 0.44444, 0, 0, 0.71805],
    968: [0.19444, 0.69444, 0.03704, 0, 0.75833],
    969: [0, 0.44444, 0.03704, 0, 0.71782],
    977: [0, 0.69444, 0, 0, 0.69155],
    981: [0.19444, 0.69444, 0, 0, 0.7125],
    982: [0, 0.44444, 0.03194, 0, 0.975],
    1009: [0.19444, 0.44444, 0, 0, 0.6118],
    1013: [0, 0.44444, 0, 0, 0.48333],
    57649: [0, 0.44444, 0, 0, 0.39352],
    57911: [0.19444, 0.44444, 0, 0, 0.43889]
  },
  "Math-Italic": {
    32: [0, 0, 0, 0, 0.25],
    48: [0, 0.43056, 0, 0, 0.5],
    49: [0, 0.43056, 0, 0, 0.5],
    50: [0, 0.43056, 0, 0, 0.5],
    51: [0.19444, 0.43056, 0, 0, 0.5],
    52: [0.19444, 0.43056, 0, 0, 0.5],
    53: [0.19444, 0.43056, 0, 0, 0.5],
    54: [0, 0.64444, 0, 0, 0.5],
    55: [0.19444, 0.43056, 0, 0, 0.5],
    56: [0, 0.64444, 0, 0, 0.5],
    57: [0.19444, 0.43056, 0, 0, 0.5],
    65: [0, 0.68333, 0, 0.13889, 0.75],
    66: [0, 0.68333, 0.05017, 0.08334, 0.75851],
    67: [0, 0.68333, 0.07153, 0.08334, 0.71472],
    68: [0, 0.68333, 0.02778, 0.05556, 0.82792],
    69: [0, 0.68333, 0.05764, 0.08334, 0.7382],
    70: [0, 0.68333, 0.13889, 0.08334, 0.64306],
    71: [0, 0.68333, 0, 0.08334, 0.78625],
    72: [0, 0.68333, 0.08125, 0.05556, 0.83125],
    73: [0, 0.68333, 0.07847, 0.11111, 0.43958],
    74: [0, 0.68333, 0.09618, 0.16667, 0.55451],
    75: [0, 0.68333, 0.07153, 0.05556, 0.84931],
    76: [0, 0.68333, 0, 0.02778, 0.68056],
    77: [0, 0.68333, 0.10903, 0.08334, 0.97014],
    78: [0, 0.68333, 0.10903, 0.08334, 0.80347],
    79: [0, 0.68333, 0.02778, 0.08334, 0.76278],
    80: [0, 0.68333, 0.13889, 0.08334, 0.64201],
    81: [0.19444, 0.68333, 0, 0.08334, 0.79056],
    82: [0, 0.68333, 773e-5, 0.08334, 0.75929],
    83: [0, 0.68333, 0.05764, 0.08334, 0.6132],
    84: [0, 0.68333, 0.13889, 0.08334, 0.58438],
    85: [0, 0.68333, 0.10903, 0.02778, 0.68278],
    86: [0, 0.68333, 0.22222, 0, 0.58333],
    87: [0, 0.68333, 0.13889, 0, 0.94445],
    88: [0, 0.68333, 0.07847, 0.08334, 0.82847],
    89: [0, 0.68333, 0.22222, 0, 0.58056],
    90: [0, 0.68333, 0.07153, 0.08334, 0.68264],
    97: [0, 0.43056, 0, 0, 0.52859],
    98: [0, 0.69444, 0, 0, 0.42917],
    99: [0, 0.43056, 0, 0.05556, 0.43276],
    100: [0, 0.69444, 0, 0.16667, 0.52049],
    101: [0, 0.43056, 0, 0.05556, 0.46563],
    102: [0.19444, 0.69444, 0.10764, 0.16667, 0.48959],
    103: [0.19444, 0.43056, 0.03588, 0.02778, 0.47697],
    104: [0, 0.69444, 0, 0, 0.57616],
    105: [0, 0.65952, 0, 0, 0.34451],
    106: [0.19444, 0.65952, 0.05724, 0, 0.41181],
    107: [0, 0.69444, 0.03148, 0, 0.5206],
    108: [0, 0.69444, 0.01968, 0.08334, 0.29838],
    109: [0, 0.43056, 0, 0, 0.87801],
    110: [0, 0.43056, 0, 0, 0.60023],
    111: [0, 0.43056, 0, 0.05556, 0.48472],
    112: [0.19444, 0.43056, 0, 0.08334, 0.50313],
    113: [0.19444, 0.43056, 0.03588, 0.08334, 0.44641],
    114: [0, 0.43056, 0.02778, 0.05556, 0.45116],
    115: [0, 0.43056, 0, 0.05556, 0.46875],
    116: [0, 0.61508, 0, 0.08334, 0.36111],
    117: [0, 0.43056, 0, 0.02778, 0.57246],
    118: [0, 0.43056, 0.03588, 0.02778, 0.48472],
    119: [0, 0.43056, 0.02691, 0.08334, 0.71592],
    120: [0, 0.43056, 0, 0.02778, 0.57153],
    121: [0.19444, 0.43056, 0.03588, 0.05556, 0.49028],
    122: [0, 0.43056, 0.04398, 0.05556, 0.46505],
    160: [0, 0, 0, 0, 0.25],
    915: [0, 0.68333, 0.13889, 0.08334, 0.61528],
    916: [0, 0.68333, 0, 0.16667, 0.83334],
    920: [0, 0.68333, 0.02778, 0.08334, 0.76278],
    923: [0, 0.68333, 0, 0.16667, 0.69445],
    926: [0, 0.68333, 0.07569, 0.08334, 0.74236],
    928: [0, 0.68333, 0.08125, 0.05556, 0.83125],
    931: [0, 0.68333, 0.05764, 0.08334, 0.77986],
    933: [0, 0.68333, 0.13889, 0.05556, 0.58333],
    934: [0, 0.68333, 0, 0.08334, 0.66667],
    936: [0, 0.68333, 0.11, 0.05556, 0.61222],
    937: [0, 0.68333, 0.05017, 0.08334, 0.7724],
    945: [0, 0.43056, 37e-4, 0.02778, 0.6397],
    946: [0.19444, 0.69444, 0.05278, 0.08334, 0.56563],
    947: [0.19444, 0.43056, 0.05556, 0, 0.51773],
    948: [0, 0.69444, 0.03785, 0.05556, 0.44444],
    949: [0, 0.43056, 0, 0.08334, 0.46632],
    950: [0.19444, 0.69444, 0.07378, 0.08334, 0.4375],
    951: [0.19444, 0.43056, 0.03588, 0.05556, 0.49653],
    952: [0, 0.69444, 0.02778, 0.08334, 0.46944],
    953: [0, 0.43056, 0, 0.05556, 0.35394],
    954: [0, 0.43056, 0, 0, 0.57616],
    955: [0, 0.69444, 0, 0, 0.58334],
    956: [0.19444, 0.43056, 0, 0.02778, 0.60255],
    957: [0, 0.43056, 0.06366, 0.02778, 0.49398],
    958: [0.19444, 0.69444, 0.04601, 0.11111, 0.4375],
    959: [0, 0.43056, 0, 0.05556, 0.48472],
    960: [0, 0.43056, 0.03588, 0, 0.57003],
    961: [0.19444, 0.43056, 0, 0.08334, 0.51702],
    962: [0.09722, 0.43056, 0.07986, 0.08334, 0.36285],
    963: [0, 0.43056, 0.03588, 0, 0.57141],
    964: [0, 0.43056, 0.1132, 0.02778, 0.43715],
    965: [0, 0.43056, 0.03588, 0.02778, 0.54028],
    966: [0.19444, 0.43056, 0, 0.08334, 0.65417],
    967: [0.19444, 0.43056, 0, 0.05556, 0.62569],
    968: [0.19444, 0.69444, 0.03588, 0.11111, 0.65139],
    969: [0, 0.43056, 0.03588, 0, 0.62245],
    977: [0, 0.69444, 0, 0.08334, 0.59144],
    981: [0.19444, 0.69444, 0, 0.08334, 0.59583],
    982: [0, 0.43056, 0.02778, 0, 0.82813],
    1009: [0.19444, 0.43056, 0, 0.08334, 0.51702],
    1013: [0, 0.43056, 0, 0.05556, 0.4059],
    57649: [0, 0.43056, 0, 0.02778, 0.32246],
    57911: [0.19444, 0.43056, 0, 0.08334, 0.38403]
  },
  "SansSerif-Bold": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.36667],
    34: [0, 0.69444, 0, 0, 0.55834],
    35: [0.19444, 0.69444, 0, 0, 0.91667],
    36: [0.05556, 0.75, 0, 0, 0.55],
    37: [0.05556, 0.75, 0, 0, 1.02912],
    38: [0, 0.69444, 0, 0, 0.83056],
    39: [0, 0.69444, 0, 0, 0.30556],
    40: [0.25, 0.75, 0, 0, 0.42778],
    41: [0.25, 0.75, 0, 0, 0.42778],
    42: [0, 0.75, 0, 0, 0.55],
    43: [0.11667, 0.61667, 0, 0, 0.85556],
    44: [0.10556, 0.13056, 0, 0, 0.30556],
    45: [0, 0.45833, 0, 0, 0.36667],
    46: [0, 0.13056, 0, 0, 0.30556],
    47: [0.25, 0.75, 0, 0, 0.55],
    48: [0, 0.69444, 0, 0, 0.55],
    49: [0, 0.69444, 0, 0, 0.55],
    50: [0, 0.69444, 0, 0, 0.55],
    51: [0, 0.69444, 0, 0, 0.55],
    52: [0, 0.69444, 0, 0, 0.55],
    53: [0, 0.69444, 0, 0, 0.55],
    54: [0, 0.69444, 0, 0, 0.55],
    55: [0, 0.69444, 0, 0, 0.55],
    56: [0, 0.69444, 0, 0, 0.55],
    57: [0, 0.69444, 0, 0, 0.55],
    58: [0, 0.45833, 0, 0, 0.30556],
    59: [0.10556, 0.45833, 0, 0, 0.30556],
    61: [-0.09375, 0.40625, 0, 0, 0.85556],
    63: [0, 0.69444, 0, 0, 0.51945],
    64: [0, 0.69444, 0, 0, 0.73334],
    65: [0, 0.69444, 0, 0, 0.73334],
    66: [0, 0.69444, 0, 0, 0.73334],
    67: [0, 0.69444, 0, 0, 0.70278],
    68: [0, 0.69444, 0, 0, 0.79445],
    69: [0, 0.69444, 0, 0, 0.64167],
    70: [0, 0.69444, 0, 0, 0.61111],
    71: [0, 0.69444, 0, 0, 0.73334],
    72: [0, 0.69444, 0, 0, 0.79445],
    73: [0, 0.69444, 0, 0, 0.33056],
    74: [0, 0.69444, 0, 0, 0.51945],
    75: [0, 0.69444, 0, 0, 0.76389],
    76: [0, 0.69444, 0, 0, 0.58056],
    77: [0, 0.69444, 0, 0, 0.97778],
    78: [0, 0.69444, 0, 0, 0.79445],
    79: [0, 0.69444, 0, 0, 0.79445],
    80: [0, 0.69444, 0, 0, 0.70278],
    81: [0.10556, 0.69444, 0, 0, 0.79445],
    82: [0, 0.69444, 0, 0, 0.70278],
    83: [0, 0.69444, 0, 0, 0.61111],
    84: [0, 0.69444, 0, 0, 0.73334],
    85: [0, 0.69444, 0, 0, 0.76389],
    86: [0, 0.69444, 0.01528, 0, 0.73334],
    87: [0, 0.69444, 0.01528, 0, 1.03889],
    88: [0, 0.69444, 0, 0, 0.73334],
    89: [0, 0.69444, 0.0275, 0, 0.73334],
    90: [0, 0.69444, 0, 0, 0.67223],
    91: [0.25, 0.75, 0, 0, 0.34306],
    93: [0.25, 0.75, 0, 0, 0.34306],
    94: [0, 0.69444, 0, 0, 0.55],
    95: [0.35, 0.10833, 0.03056, 0, 0.55],
    97: [0, 0.45833, 0, 0, 0.525],
    98: [0, 0.69444, 0, 0, 0.56111],
    99: [0, 0.45833, 0, 0, 0.48889],
    100: [0, 0.69444, 0, 0, 0.56111],
    101: [0, 0.45833, 0, 0, 0.51111],
    102: [0, 0.69444, 0.07639, 0, 0.33611],
    103: [0.19444, 0.45833, 0.01528, 0, 0.55],
    104: [0, 0.69444, 0, 0, 0.56111],
    105: [0, 0.69444, 0, 0, 0.25556],
    106: [0.19444, 0.69444, 0, 0, 0.28611],
    107: [0, 0.69444, 0, 0, 0.53056],
    108: [0, 0.69444, 0, 0, 0.25556],
    109: [0, 0.45833, 0, 0, 0.86667],
    110: [0, 0.45833, 0, 0, 0.56111],
    111: [0, 0.45833, 0, 0, 0.55],
    112: [0.19444, 0.45833, 0, 0, 0.56111],
    113: [0.19444, 0.45833, 0, 0, 0.56111],
    114: [0, 0.45833, 0.01528, 0, 0.37222],
    115: [0, 0.45833, 0, 0, 0.42167],
    116: [0, 0.58929, 0, 0, 0.40417],
    117: [0, 0.45833, 0, 0, 0.56111],
    118: [0, 0.45833, 0.01528, 0, 0.5],
    119: [0, 0.45833, 0.01528, 0, 0.74445],
    120: [0, 0.45833, 0, 0, 0.5],
    121: [0.19444, 0.45833, 0.01528, 0, 0.5],
    122: [0, 0.45833, 0, 0, 0.47639],
    126: [0.35, 0.34444, 0, 0, 0.55],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.69444, 0, 0, 0.55],
    176: [0, 0.69444, 0, 0, 0.73334],
    180: [0, 0.69444, 0, 0, 0.55],
    184: [0.17014, 0, 0, 0, 0.48889],
    305: [0, 0.45833, 0, 0, 0.25556],
    567: [0.19444, 0.45833, 0, 0, 0.28611],
    710: [0, 0.69444, 0, 0, 0.55],
    711: [0, 0.63542, 0, 0, 0.55],
    713: [0, 0.63778, 0, 0, 0.55],
    728: [0, 0.69444, 0, 0, 0.55],
    729: [0, 0.69444, 0, 0, 0.30556],
    730: [0, 0.69444, 0, 0, 0.73334],
    732: [0, 0.69444, 0, 0, 0.55],
    733: [0, 0.69444, 0, 0, 0.55],
    915: [0, 0.69444, 0, 0, 0.58056],
    916: [0, 0.69444, 0, 0, 0.91667],
    920: [0, 0.69444, 0, 0, 0.85556],
    923: [0, 0.69444, 0, 0, 0.67223],
    926: [0, 0.69444, 0, 0, 0.73334],
    928: [0, 0.69444, 0, 0, 0.79445],
    931: [0, 0.69444, 0, 0, 0.79445],
    933: [0, 0.69444, 0, 0, 0.85556],
    934: [0, 0.69444, 0, 0, 0.79445],
    936: [0, 0.69444, 0, 0, 0.85556],
    937: [0, 0.69444, 0, 0, 0.79445],
    8211: [0, 0.45833, 0.03056, 0, 0.55],
    8212: [0, 0.45833, 0.03056, 0, 1.10001],
    8216: [0, 0.69444, 0, 0, 0.30556],
    8217: [0, 0.69444, 0, 0, 0.30556],
    8220: [0, 0.69444, 0, 0, 0.55834],
    8221: [0, 0.69444, 0, 0, 0.55834]
  },
  "SansSerif-Italic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.05733, 0, 0.31945],
    34: [0, 0.69444, 316e-5, 0, 0.5],
    35: [0.19444, 0.69444, 0.05087, 0, 0.83334],
    36: [0.05556, 0.75, 0.11156, 0, 0.5],
    37: [0.05556, 0.75, 0.03126, 0, 0.83334],
    38: [0, 0.69444, 0.03058, 0, 0.75834],
    39: [0, 0.69444, 0.07816, 0, 0.27778],
    40: [0.25, 0.75, 0.13164, 0, 0.38889],
    41: [0.25, 0.75, 0.02536, 0, 0.38889],
    42: [0, 0.75, 0.11775, 0, 0.5],
    43: [0.08333, 0.58333, 0.02536, 0, 0.77778],
    44: [0.125, 0.08333, 0, 0, 0.27778],
    45: [0, 0.44444, 0.01946, 0, 0.33333],
    46: [0, 0.08333, 0, 0, 0.27778],
    47: [0.25, 0.75, 0.13164, 0, 0.5],
    48: [0, 0.65556, 0.11156, 0, 0.5],
    49: [0, 0.65556, 0.11156, 0, 0.5],
    50: [0, 0.65556, 0.11156, 0, 0.5],
    51: [0, 0.65556, 0.11156, 0, 0.5],
    52: [0, 0.65556, 0.11156, 0, 0.5],
    53: [0, 0.65556, 0.11156, 0, 0.5],
    54: [0, 0.65556, 0.11156, 0, 0.5],
    55: [0, 0.65556, 0.11156, 0, 0.5],
    56: [0, 0.65556, 0.11156, 0, 0.5],
    57: [0, 0.65556, 0.11156, 0, 0.5],
    58: [0, 0.44444, 0.02502, 0, 0.27778],
    59: [0.125, 0.44444, 0.02502, 0, 0.27778],
    61: [-0.13, 0.37, 0.05087, 0, 0.77778],
    63: [0, 0.69444, 0.11809, 0, 0.47222],
    64: [0, 0.69444, 0.07555, 0, 0.66667],
    65: [0, 0.69444, 0, 0, 0.66667],
    66: [0, 0.69444, 0.08293, 0, 0.66667],
    67: [0, 0.69444, 0.11983, 0, 0.63889],
    68: [0, 0.69444, 0.07555, 0, 0.72223],
    69: [0, 0.69444, 0.11983, 0, 0.59722],
    70: [0, 0.69444, 0.13372, 0, 0.56945],
    71: [0, 0.69444, 0.11983, 0, 0.66667],
    72: [0, 0.69444, 0.08094, 0, 0.70834],
    73: [0, 0.69444, 0.13372, 0, 0.27778],
    74: [0, 0.69444, 0.08094, 0, 0.47222],
    75: [0, 0.69444, 0.11983, 0, 0.69445],
    76: [0, 0.69444, 0, 0, 0.54167],
    77: [0, 0.69444, 0.08094, 0, 0.875],
    78: [0, 0.69444, 0.08094, 0, 0.70834],
    79: [0, 0.69444, 0.07555, 0, 0.73611],
    80: [0, 0.69444, 0.08293, 0, 0.63889],
    81: [0.125, 0.69444, 0.07555, 0, 0.73611],
    82: [0, 0.69444, 0.08293, 0, 0.64584],
    83: [0, 0.69444, 0.09205, 0, 0.55556],
    84: [0, 0.69444, 0.13372, 0, 0.68056],
    85: [0, 0.69444, 0.08094, 0, 0.6875],
    86: [0, 0.69444, 0.1615, 0, 0.66667],
    87: [0, 0.69444, 0.1615, 0, 0.94445],
    88: [0, 0.69444, 0.13372, 0, 0.66667],
    89: [0, 0.69444, 0.17261, 0, 0.66667],
    90: [0, 0.69444, 0.11983, 0, 0.61111],
    91: [0.25, 0.75, 0.15942, 0, 0.28889],
    93: [0.25, 0.75, 0.08719, 0, 0.28889],
    94: [0, 0.69444, 0.0799, 0, 0.5],
    95: [0.35, 0.09444, 0.08616, 0, 0.5],
    97: [0, 0.44444, 981e-5, 0, 0.48056],
    98: [0, 0.69444, 0.03057, 0, 0.51667],
    99: [0, 0.44444, 0.08336, 0, 0.44445],
    100: [0, 0.69444, 0.09483, 0, 0.51667],
    101: [0, 0.44444, 0.06778, 0, 0.44445],
    102: [0, 0.69444, 0.21705, 0, 0.30556],
    103: [0.19444, 0.44444, 0.10836, 0, 0.5],
    104: [0, 0.69444, 0.01778, 0, 0.51667],
    105: [0, 0.67937, 0.09718, 0, 0.23889],
    106: [0.19444, 0.67937, 0.09162, 0, 0.26667],
    107: [0, 0.69444, 0.08336, 0, 0.48889],
    108: [0, 0.69444, 0.09483, 0, 0.23889],
    109: [0, 0.44444, 0.01778, 0, 0.79445],
    110: [0, 0.44444, 0.01778, 0, 0.51667],
    111: [0, 0.44444, 0.06613, 0, 0.5],
    112: [0.19444, 0.44444, 0.0389, 0, 0.51667],
    113: [0.19444, 0.44444, 0.04169, 0, 0.51667],
    114: [0, 0.44444, 0.10836, 0, 0.34167],
    115: [0, 0.44444, 0.0778, 0, 0.38333],
    116: [0, 0.57143, 0.07225, 0, 0.36111],
    117: [0, 0.44444, 0.04169, 0, 0.51667],
    118: [0, 0.44444, 0.10836, 0, 0.46111],
    119: [0, 0.44444, 0.10836, 0, 0.68334],
    120: [0, 0.44444, 0.09169, 0, 0.46111],
    121: [0.19444, 0.44444, 0.10836, 0, 0.46111],
    122: [0, 0.44444, 0.08752, 0, 0.43472],
    126: [0.35, 0.32659, 0.08826, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.67937, 0.06385, 0, 0.5],
    176: [0, 0.69444, 0, 0, 0.73752],
    184: [0.17014, 0, 0, 0, 0.44445],
    305: [0, 0.44444, 0.04169, 0, 0.23889],
    567: [0.19444, 0.44444, 0.04169, 0, 0.26667],
    710: [0, 0.69444, 0.0799, 0, 0.5],
    711: [0, 0.63194, 0.08432, 0, 0.5],
    713: [0, 0.60889, 0.08776, 0, 0.5],
    714: [0, 0.69444, 0.09205, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0.09483, 0, 0.5],
    729: [0, 0.67937, 0.07774, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.73752],
    732: [0, 0.67659, 0.08826, 0, 0.5],
    733: [0, 0.69444, 0.09205, 0, 0.5],
    915: [0, 0.69444, 0.13372, 0, 0.54167],
    916: [0, 0.69444, 0, 0, 0.83334],
    920: [0, 0.69444, 0.07555, 0, 0.77778],
    923: [0, 0.69444, 0, 0, 0.61111],
    926: [0, 0.69444, 0.12816, 0, 0.66667],
    928: [0, 0.69444, 0.08094, 0, 0.70834],
    931: [0, 0.69444, 0.11983, 0, 0.72222],
    933: [0, 0.69444, 0.09031, 0, 0.77778],
    934: [0, 0.69444, 0.04603, 0, 0.72222],
    936: [0, 0.69444, 0.09031, 0, 0.77778],
    937: [0, 0.69444, 0.08293, 0, 0.72222],
    8211: [0, 0.44444, 0.08616, 0, 0.5],
    8212: [0, 0.44444, 0.08616, 0, 1],
    8216: [0, 0.69444, 0.07816, 0, 0.27778],
    8217: [0, 0.69444, 0.07816, 0, 0.27778],
    8220: [0, 0.69444, 0.14205, 0, 0.5],
    8221: [0, 0.69444, 316e-5, 0, 0.5]
  },
  "SansSerif-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.31945],
    34: [0, 0.69444, 0, 0, 0.5],
    35: [0.19444, 0.69444, 0, 0, 0.83334],
    36: [0.05556, 0.75, 0, 0, 0.5],
    37: [0.05556, 0.75, 0, 0, 0.83334],
    38: [0, 0.69444, 0, 0, 0.75834],
    39: [0, 0.69444, 0, 0, 0.27778],
    40: [0.25, 0.75, 0, 0, 0.38889],
    41: [0.25, 0.75, 0, 0, 0.38889],
    42: [0, 0.75, 0, 0, 0.5],
    43: [0.08333, 0.58333, 0, 0, 0.77778],
    44: [0.125, 0.08333, 0, 0, 0.27778],
    45: [0, 0.44444, 0, 0, 0.33333],
    46: [0, 0.08333, 0, 0, 0.27778],
    47: [0.25, 0.75, 0, 0, 0.5],
    48: [0, 0.65556, 0, 0, 0.5],
    49: [0, 0.65556, 0, 0, 0.5],
    50: [0, 0.65556, 0, 0, 0.5],
    51: [0, 0.65556, 0, 0, 0.5],
    52: [0, 0.65556, 0, 0, 0.5],
    53: [0, 0.65556, 0, 0, 0.5],
    54: [0, 0.65556, 0, 0, 0.5],
    55: [0, 0.65556, 0, 0, 0.5],
    56: [0, 0.65556, 0, 0, 0.5],
    57: [0, 0.65556, 0, 0, 0.5],
    58: [0, 0.44444, 0, 0, 0.27778],
    59: [0.125, 0.44444, 0, 0, 0.27778],
    61: [-0.13, 0.37, 0, 0, 0.77778],
    63: [0, 0.69444, 0, 0, 0.47222],
    64: [0, 0.69444, 0, 0, 0.66667],
    65: [0, 0.69444, 0, 0, 0.66667],
    66: [0, 0.69444, 0, 0, 0.66667],
    67: [0, 0.69444, 0, 0, 0.63889],
    68: [0, 0.69444, 0, 0, 0.72223],
    69: [0, 0.69444, 0, 0, 0.59722],
    70: [0, 0.69444, 0, 0, 0.56945],
    71: [0, 0.69444, 0, 0, 0.66667],
    72: [0, 0.69444, 0, 0, 0.70834],
    73: [0, 0.69444, 0, 0, 0.27778],
    74: [0, 0.69444, 0, 0, 0.47222],
    75: [0, 0.69444, 0, 0, 0.69445],
    76: [0, 0.69444, 0, 0, 0.54167],
    77: [0, 0.69444, 0, 0, 0.875],
    78: [0, 0.69444, 0, 0, 0.70834],
    79: [0, 0.69444, 0, 0, 0.73611],
    80: [0, 0.69444, 0, 0, 0.63889],
    81: [0.125, 0.69444, 0, 0, 0.73611],
    82: [0, 0.69444, 0, 0, 0.64584],
    83: [0, 0.69444, 0, 0, 0.55556],
    84: [0, 0.69444, 0, 0, 0.68056],
    85: [0, 0.69444, 0, 0, 0.6875],
    86: [0, 0.69444, 0.01389, 0, 0.66667],
    87: [0, 0.69444, 0.01389, 0, 0.94445],
    88: [0, 0.69444, 0, 0, 0.66667],
    89: [0, 0.69444, 0.025, 0, 0.66667],
    90: [0, 0.69444, 0, 0, 0.61111],
    91: [0.25, 0.75, 0, 0, 0.28889],
    93: [0.25, 0.75, 0, 0, 0.28889],
    94: [0, 0.69444, 0, 0, 0.5],
    95: [0.35, 0.09444, 0.02778, 0, 0.5],
    97: [0, 0.44444, 0, 0, 0.48056],
    98: [0, 0.69444, 0, 0, 0.51667],
    99: [0, 0.44444, 0, 0, 0.44445],
    100: [0, 0.69444, 0, 0, 0.51667],
    101: [0, 0.44444, 0, 0, 0.44445],
    102: [0, 0.69444, 0.06944, 0, 0.30556],
    103: [0.19444, 0.44444, 0.01389, 0, 0.5],
    104: [0, 0.69444, 0, 0, 0.51667],
    105: [0, 0.67937, 0, 0, 0.23889],
    106: [0.19444, 0.67937, 0, 0, 0.26667],
    107: [0, 0.69444, 0, 0, 0.48889],
    108: [0, 0.69444, 0, 0, 0.23889],
    109: [0, 0.44444, 0, 0, 0.79445],
    110: [0, 0.44444, 0, 0, 0.51667],
    111: [0, 0.44444, 0, 0, 0.5],
    112: [0.19444, 0.44444, 0, 0, 0.51667],
    113: [0.19444, 0.44444, 0, 0, 0.51667],
    114: [0, 0.44444, 0.01389, 0, 0.34167],
    115: [0, 0.44444, 0, 0, 0.38333],
    116: [0, 0.57143, 0, 0, 0.36111],
    117: [0, 0.44444, 0, 0, 0.51667],
    118: [0, 0.44444, 0.01389, 0, 0.46111],
    119: [0, 0.44444, 0.01389, 0, 0.68334],
    120: [0, 0.44444, 0, 0, 0.46111],
    121: [0.19444, 0.44444, 0.01389, 0, 0.46111],
    122: [0, 0.44444, 0, 0, 0.43472],
    126: [0.35, 0.32659, 0, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.67937, 0, 0, 0.5],
    176: [0, 0.69444, 0, 0, 0.66667],
    184: [0.17014, 0, 0, 0, 0.44445],
    305: [0, 0.44444, 0, 0, 0.23889],
    567: [0.19444, 0.44444, 0, 0, 0.26667],
    710: [0, 0.69444, 0, 0, 0.5],
    711: [0, 0.63194, 0, 0, 0.5],
    713: [0, 0.60889, 0, 0, 0.5],
    714: [0, 0.69444, 0, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0, 0, 0.5],
    729: [0, 0.67937, 0, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.66667],
    732: [0, 0.67659, 0, 0, 0.5],
    733: [0, 0.69444, 0, 0, 0.5],
    915: [0, 0.69444, 0, 0, 0.54167],
    916: [0, 0.69444, 0, 0, 0.83334],
    920: [0, 0.69444, 0, 0, 0.77778],
    923: [0, 0.69444, 0, 0, 0.61111],
    926: [0, 0.69444, 0, 0, 0.66667],
    928: [0, 0.69444, 0, 0, 0.70834],
    931: [0, 0.69444, 0, 0, 0.72222],
    933: [0, 0.69444, 0, 0, 0.77778],
    934: [0, 0.69444, 0, 0, 0.72222],
    936: [0, 0.69444, 0, 0, 0.77778],
    937: [0, 0.69444, 0, 0, 0.72222],
    8211: [0, 0.44444, 0.02778, 0, 0.5],
    8212: [0, 0.44444, 0.02778, 0, 1],
    8216: [0, 0.69444, 0, 0, 0.27778],
    8217: [0, 0.69444, 0, 0, 0.27778],
    8220: [0, 0.69444, 0, 0, 0.5],
    8221: [0, 0.69444, 0, 0, 0.5]
  },
  "Script-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.7, 0.22925, 0, 0.80253],
    66: [0, 0.7, 0.04087, 0, 0.90757],
    67: [0, 0.7, 0.1689, 0, 0.66619],
    68: [0, 0.7, 0.09371, 0, 0.77443],
    69: [0, 0.7, 0.18583, 0, 0.56162],
    70: [0, 0.7, 0.13634, 0, 0.89544],
    71: [0, 0.7, 0.17322, 0, 0.60961],
    72: [0, 0.7, 0.29694, 0, 0.96919],
    73: [0, 0.7, 0.19189, 0, 0.80907],
    74: [0.27778, 0.7, 0.19189, 0, 1.05159],
    75: [0, 0.7, 0.31259, 0, 0.91364],
    76: [0, 0.7, 0.19189, 0, 0.87373],
    77: [0, 0.7, 0.15981, 0, 1.08031],
    78: [0, 0.7, 0.3525, 0, 0.9015],
    79: [0, 0.7, 0.08078, 0, 0.73787],
    80: [0, 0.7, 0.08078, 0, 1.01262],
    81: [0, 0.7, 0.03305, 0, 0.88282],
    82: [0, 0.7, 0.06259, 0, 0.85],
    83: [0, 0.7, 0.19189, 0, 0.86767],
    84: [0, 0.7, 0.29087, 0, 0.74697],
    85: [0, 0.7, 0.25815, 0, 0.79996],
    86: [0, 0.7, 0.27523, 0, 0.62204],
    87: [0, 0.7, 0.27523, 0, 0.80532],
    88: [0, 0.7, 0.26006, 0, 0.94445],
    89: [0, 0.7, 0.2939, 0, 0.70961],
    90: [0, 0.7, 0.24037, 0, 0.8212],
    160: [0, 0, 0, 0, 0.25]
  },
  "Size1-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.35001, 0.85, 0, 0, 0.45834],
    41: [0.35001, 0.85, 0, 0, 0.45834],
    47: [0.35001, 0.85, 0, 0, 0.57778],
    91: [0.35001, 0.85, 0, 0, 0.41667],
    92: [0.35001, 0.85, 0, 0, 0.57778],
    93: [0.35001, 0.85, 0, 0, 0.41667],
    123: [0.35001, 0.85, 0, 0, 0.58334],
    125: [0.35001, 0.85, 0, 0, 0.58334],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.72222, 0, 0, 0.55556],
    732: [0, 0.72222, 0, 0, 0.55556],
    770: [0, 0.72222, 0, 0, 0.55556],
    771: [0, 0.72222, 0, 0, 0.55556],
    8214: [-99e-5, 0.601, 0, 0, 0.77778],
    8593: [1e-5, 0.6, 0, 0, 0.66667],
    8595: [1e-5, 0.6, 0, 0, 0.66667],
    8657: [1e-5, 0.6, 0, 0, 0.77778],
    8659: [1e-5, 0.6, 0, 0, 0.77778],
    8719: [0.25001, 0.75, 0, 0, 0.94445],
    8720: [0.25001, 0.75, 0, 0, 0.94445],
    8721: [0.25001, 0.75, 0, 0, 1.05556],
    8730: [0.35001, 0.85, 0, 0, 1],
    8739: [-599e-5, 0.606, 0, 0, 0.33333],
    8741: [-599e-5, 0.606, 0, 0, 0.55556],
    8747: [0.30612, 0.805, 0.19445, 0, 0.47222],
    8748: [0.306, 0.805, 0.19445, 0, 0.47222],
    8749: [0.306, 0.805, 0.19445, 0, 0.47222],
    8750: [0.30612, 0.805, 0.19445, 0, 0.47222],
    8896: [0.25001, 0.75, 0, 0, 0.83334],
    8897: [0.25001, 0.75, 0, 0, 0.83334],
    8898: [0.25001, 0.75, 0, 0, 0.83334],
    8899: [0.25001, 0.75, 0, 0, 0.83334],
    8968: [0.35001, 0.85, 0, 0, 0.47222],
    8969: [0.35001, 0.85, 0, 0, 0.47222],
    8970: [0.35001, 0.85, 0, 0, 0.47222],
    8971: [0.35001, 0.85, 0, 0, 0.47222],
    9168: [-99e-5, 0.601, 0, 0, 0.66667],
    10216: [0.35001, 0.85, 0, 0, 0.47222],
    10217: [0.35001, 0.85, 0, 0, 0.47222],
    10752: [0.25001, 0.75, 0, 0, 1.11111],
    10753: [0.25001, 0.75, 0, 0, 1.11111],
    10754: [0.25001, 0.75, 0, 0, 1.11111],
    10756: [0.25001, 0.75, 0, 0, 0.83334],
    10758: [0.25001, 0.75, 0, 0, 0.83334]
  },
  "Size2-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.65002, 1.15, 0, 0, 0.59722],
    41: [0.65002, 1.15, 0, 0, 0.59722],
    47: [0.65002, 1.15, 0, 0, 0.81111],
    91: [0.65002, 1.15, 0, 0, 0.47222],
    92: [0.65002, 1.15, 0, 0, 0.81111],
    93: [0.65002, 1.15, 0, 0, 0.47222],
    123: [0.65002, 1.15, 0, 0, 0.66667],
    125: [0.65002, 1.15, 0, 0, 0.66667],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.75, 0, 0, 1],
    732: [0, 0.75, 0, 0, 1],
    770: [0, 0.75, 0, 0, 1],
    771: [0, 0.75, 0, 0, 1],
    8719: [0.55001, 1.05, 0, 0, 1.27778],
    8720: [0.55001, 1.05, 0, 0, 1.27778],
    8721: [0.55001, 1.05, 0, 0, 1.44445],
    8730: [0.65002, 1.15, 0, 0, 1],
    8747: [0.86225, 1.36, 0.44445, 0, 0.55556],
    8748: [0.862, 1.36, 0.44445, 0, 0.55556],
    8749: [0.862, 1.36, 0.44445, 0, 0.55556],
    8750: [0.86225, 1.36, 0.44445, 0, 0.55556],
    8896: [0.55001, 1.05, 0, 0, 1.11111],
    8897: [0.55001, 1.05, 0, 0, 1.11111],
    8898: [0.55001, 1.05, 0, 0, 1.11111],
    8899: [0.55001, 1.05, 0, 0, 1.11111],
    8968: [0.65002, 1.15, 0, 0, 0.52778],
    8969: [0.65002, 1.15, 0, 0, 0.52778],
    8970: [0.65002, 1.15, 0, 0, 0.52778],
    8971: [0.65002, 1.15, 0, 0, 0.52778],
    10216: [0.65002, 1.15, 0, 0, 0.61111],
    10217: [0.65002, 1.15, 0, 0, 0.61111],
    10752: [0.55001, 1.05, 0, 0, 1.51112],
    10753: [0.55001, 1.05, 0, 0, 1.51112],
    10754: [0.55001, 1.05, 0, 0, 1.51112],
    10756: [0.55001, 1.05, 0, 0, 1.11111],
    10758: [0.55001, 1.05, 0, 0, 1.11111]
  },
  "Size3-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.95003, 1.45, 0, 0, 0.73611],
    41: [0.95003, 1.45, 0, 0, 0.73611],
    47: [0.95003, 1.45, 0, 0, 1.04445],
    91: [0.95003, 1.45, 0, 0, 0.52778],
    92: [0.95003, 1.45, 0, 0, 1.04445],
    93: [0.95003, 1.45, 0, 0, 0.52778],
    123: [0.95003, 1.45, 0, 0, 0.75],
    125: [0.95003, 1.45, 0, 0, 0.75],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.75, 0, 0, 1.44445],
    732: [0, 0.75, 0, 0, 1.44445],
    770: [0, 0.75, 0, 0, 1.44445],
    771: [0, 0.75, 0, 0, 1.44445],
    8730: [0.95003, 1.45, 0, 0, 1],
    8968: [0.95003, 1.45, 0, 0, 0.58334],
    8969: [0.95003, 1.45, 0, 0, 0.58334],
    8970: [0.95003, 1.45, 0, 0, 0.58334],
    8971: [0.95003, 1.45, 0, 0, 0.58334],
    10216: [0.95003, 1.45, 0, 0, 0.75],
    10217: [0.95003, 1.45, 0, 0, 0.75]
  },
  "Size4-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [1.25003, 1.75, 0, 0, 0.79167],
    41: [1.25003, 1.75, 0, 0, 0.79167],
    47: [1.25003, 1.75, 0, 0, 1.27778],
    91: [1.25003, 1.75, 0, 0, 0.58334],
    92: [1.25003, 1.75, 0, 0, 1.27778],
    93: [1.25003, 1.75, 0, 0, 0.58334],
    123: [1.25003, 1.75, 0, 0, 0.80556],
    125: [1.25003, 1.75, 0, 0, 0.80556],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.825, 0, 0, 1.8889],
    732: [0, 0.825, 0, 0, 1.8889],
    770: [0, 0.825, 0, 0, 1.8889],
    771: [0, 0.825, 0, 0, 1.8889],
    8730: [1.25003, 1.75, 0, 0, 1],
    8968: [1.25003, 1.75, 0, 0, 0.63889],
    8969: [1.25003, 1.75, 0, 0, 0.63889],
    8970: [1.25003, 1.75, 0, 0, 0.63889],
    8971: [1.25003, 1.75, 0, 0, 0.63889],
    9115: [0.64502, 1.155, 0, 0, 0.875],
    9116: [1e-5, 0.6, 0, 0, 0.875],
    9117: [0.64502, 1.155, 0, 0, 0.875],
    9118: [0.64502, 1.155, 0, 0, 0.875],
    9119: [1e-5, 0.6, 0, 0, 0.875],
    9120: [0.64502, 1.155, 0, 0, 0.875],
    9121: [0.64502, 1.155, 0, 0, 0.66667],
    9122: [-99e-5, 0.601, 0, 0, 0.66667],
    9123: [0.64502, 1.155, 0, 0, 0.66667],
    9124: [0.64502, 1.155, 0, 0, 0.66667],
    9125: [-99e-5, 0.601, 0, 0, 0.66667],
    9126: [0.64502, 1.155, 0, 0, 0.66667],
    9127: [1e-5, 0.9, 0, 0, 0.88889],
    9128: [0.65002, 1.15, 0, 0, 0.88889],
    9129: [0.90001, 0, 0, 0, 0.88889],
    9130: [0, 0.3, 0, 0, 0.88889],
    9131: [1e-5, 0.9, 0, 0, 0.88889],
    9132: [0.65002, 1.15, 0, 0, 0.88889],
    9133: [0.90001, 0, 0, 0, 0.88889],
    9143: [0.88502, 0.915, 0, 0, 1.05556],
    10216: [1.25003, 1.75, 0, 0, 0.80556],
    10217: [1.25003, 1.75, 0, 0, 0.80556],
    57344: [-499e-5, 0.605, 0, 0, 1.05556],
    57345: [-499e-5, 0.605, 0, 0, 1.05556],
    57680: [0, 0.12, 0, 0, 0.45],
    57681: [0, 0.12, 0, 0, 0.45],
    57682: [0, 0.12, 0, 0, 0.45],
    57683: [0, 0.12, 0, 0, 0.45]
  },
  "Typewriter-Regular": {
    32: [0, 0, 0, 0, 0.525],
    33: [0, 0.61111, 0, 0, 0.525],
    34: [0, 0.61111, 0, 0, 0.525],
    35: [0, 0.61111, 0, 0, 0.525],
    36: [0.08333, 0.69444, 0, 0, 0.525],
    37: [0.08333, 0.69444, 0, 0, 0.525],
    38: [0, 0.61111, 0, 0, 0.525],
    39: [0, 0.61111, 0, 0, 0.525],
    40: [0.08333, 0.69444, 0, 0, 0.525],
    41: [0.08333, 0.69444, 0, 0, 0.525],
    42: [0, 0.52083, 0, 0, 0.525],
    43: [-0.08056, 0.53055, 0, 0, 0.525],
    44: [0.13889, 0.125, 0, 0, 0.525],
    45: [-0.08056, 0.53055, 0, 0, 0.525],
    46: [0, 0.125, 0, 0, 0.525],
    47: [0.08333, 0.69444, 0, 0, 0.525],
    48: [0, 0.61111, 0, 0, 0.525],
    49: [0, 0.61111, 0, 0, 0.525],
    50: [0, 0.61111, 0, 0, 0.525],
    51: [0, 0.61111, 0, 0, 0.525],
    52: [0, 0.61111, 0, 0, 0.525],
    53: [0, 0.61111, 0, 0, 0.525],
    54: [0, 0.61111, 0, 0, 0.525],
    55: [0, 0.61111, 0, 0, 0.525],
    56: [0, 0.61111, 0, 0, 0.525],
    57: [0, 0.61111, 0, 0, 0.525],
    58: [0, 0.43056, 0, 0, 0.525],
    59: [0.13889, 0.43056, 0, 0, 0.525],
    60: [-0.05556, 0.55556, 0, 0, 0.525],
    61: [-0.19549, 0.41562, 0, 0, 0.525],
    62: [-0.05556, 0.55556, 0, 0, 0.525],
    63: [0, 0.61111, 0, 0, 0.525],
    64: [0, 0.61111, 0, 0, 0.525],
    65: [0, 0.61111, 0, 0, 0.525],
    66: [0, 0.61111, 0, 0, 0.525],
    67: [0, 0.61111, 0, 0, 0.525],
    68: [0, 0.61111, 0, 0, 0.525],
    69: [0, 0.61111, 0, 0, 0.525],
    70: [0, 0.61111, 0, 0, 0.525],
    71: [0, 0.61111, 0, 0, 0.525],
    72: [0, 0.61111, 0, 0, 0.525],
    73: [0, 0.61111, 0, 0, 0.525],
    74: [0, 0.61111, 0, 0, 0.525],
    75: [0, 0.61111, 0, 0, 0.525],
    76: [0, 0.61111, 0, 0, 0.525],
    77: [0, 0.61111, 0, 0, 0.525],
    78: [0, 0.61111, 0, 0, 0.525],
    79: [0, 0.61111, 0, 0, 0.525],
    80: [0, 0.61111, 0, 0, 0.525],
    81: [0.13889, 0.61111, 0, 0, 0.525],
    82: [0, 0.61111, 0, 0, 0.525],
    83: [0, 0.61111, 0, 0, 0.525],
    84: [0, 0.61111, 0, 0, 0.525],
    85: [0, 0.61111, 0, 0, 0.525],
    86: [0, 0.61111, 0, 0, 0.525],
    87: [0, 0.61111, 0, 0, 0.525],
    88: [0, 0.61111, 0, 0, 0.525],
    89: [0, 0.61111, 0, 0, 0.525],
    90: [0, 0.61111, 0, 0, 0.525],
    91: [0.08333, 0.69444, 0, 0, 0.525],
    92: [0.08333, 0.69444, 0, 0, 0.525],
    93: [0.08333, 0.69444, 0, 0, 0.525],
    94: [0, 0.61111, 0, 0, 0.525],
    95: [0.09514, 0, 0, 0, 0.525],
    96: [0, 0.61111, 0, 0, 0.525],
    97: [0, 0.43056, 0, 0, 0.525],
    98: [0, 0.61111, 0, 0, 0.525],
    99: [0, 0.43056, 0, 0, 0.525],
    100: [0, 0.61111, 0, 0, 0.525],
    101: [0, 0.43056, 0, 0, 0.525],
    102: [0, 0.61111, 0, 0, 0.525],
    103: [0.22222, 0.43056, 0, 0, 0.525],
    104: [0, 0.61111, 0, 0, 0.525],
    105: [0, 0.61111, 0, 0, 0.525],
    106: [0.22222, 0.61111, 0, 0, 0.525],
    107: [0, 0.61111, 0, 0, 0.525],
    108: [0, 0.61111, 0, 0, 0.525],
    109: [0, 0.43056, 0, 0, 0.525],
    110: [0, 0.43056, 0, 0, 0.525],
    111: [0, 0.43056, 0, 0, 0.525],
    112: [0.22222, 0.43056, 0, 0, 0.525],
    113: [0.22222, 0.43056, 0, 0, 0.525],
    114: [0, 0.43056, 0, 0, 0.525],
    115: [0, 0.43056, 0, 0, 0.525],
    116: [0, 0.55358, 0, 0, 0.525],
    117: [0, 0.43056, 0, 0, 0.525],
    118: [0, 0.43056, 0, 0, 0.525],
    119: [0, 0.43056, 0, 0, 0.525],
    120: [0, 0.43056, 0, 0, 0.525],
    121: [0.22222, 0.43056, 0, 0, 0.525],
    122: [0, 0.43056, 0, 0, 0.525],
    123: [0.08333, 0.69444, 0, 0, 0.525],
    124: [0.08333, 0.69444, 0, 0, 0.525],
    125: [0.08333, 0.69444, 0, 0, 0.525],
    126: [0, 0.61111, 0, 0, 0.525],
    127: [0, 0.61111, 0, 0, 0.525],
    160: [0, 0, 0, 0, 0.525],
    176: [0, 0.61111, 0, 0, 0.525],
    184: [0.19445, 0, 0, 0, 0.525],
    305: [0, 0.43056, 0, 0, 0.525],
    567: [0.22222, 0.43056, 0, 0, 0.525],
    711: [0, 0.56597, 0, 0, 0.525],
    713: [0, 0.56555, 0, 0, 0.525],
    714: [0, 0.61111, 0, 0, 0.525],
    715: [0, 0.61111, 0, 0, 0.525],
    728: [0, 0.61111, 0, 0, 0.525],
    730: [0, 0.61111, 0, 0, 0.525],
    770: [0, 0.61111, 0, 0, 0.525],
    771: [0, 0.61111, 0, 0, 0.525],
    776: [0, 0.61111, 0, 0, 0.525],
    915: [0, 0.61111, 0, 0, 0.525],
    916: [0, 0.61111, 0, 0, 0.525],
    920: [0, 0.61111, 0, 0, 0.525],
    923: [0, 0.61111, 0, 0, 0.525],
    926: [0, 0.61111, 0, 0, 0.525],
    928: [0, 0.61111, 0, 0, 0.525],
    931: [0, 0.61111, 0, 0, 0.525],
    933: [0, 0.61111, 0, 0, 0.525],
    934: [0, 0.61111, 0, 0, 0.525],
    936: [0, 0.61111, 0, 0, 0.525],
    937: [0, 0.61111, 0, 0, 0.525],
    8216: [0, 0.61111, 0, 0, 0.525],
    8217: [0, 0.61111, 0, 0, 0.525],
    8242: [0, 0.61111, 0, 0, 0.525],
    9251: [0.11111, 0.21944, 0, 0, 0.525]
  }
}, Zh = {
  slant: [0.25, 0.25, 0.25],
  // sigma1
  space: [0, 0, 0],
  // sigma2
  stretch: [0, 0, 0],
  // sigma3
  shrink: [0, 0, 0],
  // sigma4
  xHeight: [0.431, 0.431, 0.431],
  // sigma5
  quad: [1, 1.171, 1.472],
  // sigma6
  extraSpace: [0, 0, 0],
  // sigma7
  num1: [0.677, 0.732, 0.925],
  // sigma8
  num2: [0.394, 0.384, 0.387],
  // sigma9
  num3: [0.444, 0.471, 0.504],
  // sigma10
  denom1: [0.686, 0.752, 1.025],
  // sigma11
  denom2: [0.345, 0.344, 0.532],
  // sigma12
  sup1: [0.413, 0.503, 0.504],
  // sigma13
  sup2: [0.363, 0.431, 0.404],
  // sigma14
  sup3: [0.289, 0.286, 0.294],
  // sigma15
  sub1: [0.15, 0.143, 0.2],
  // sigma16
  sub2: [0.247, 0.286, 0.4],
  // sigma17
  supDrop: [0.386, 0.353, 0.494],
  // sigma18
  subDrop: [0.05, 0.071, 0.1],
  // sigma19
  delim1: [2.39, 1.7, 1.98],
  // sigma20
  delim2: [1.01, 1.157, 1.42],
  // sigma21
  axisHeight: [0.25, 0.25, 0.25],
  // sigma22
  // These font metrics are extracted from TeX by using tftopl on cmex10.tfm;
  // they correspond to the font parameters of the extension fonts (family 3).
  // See the TeXbook, page 441. In AMSTeX, the extension fonts scale; to
  // match cmex7, we'd use cmex7.tfm values for script and scriptscript
  // values.
  defaultRuleThickness: [0.04, 0.049, 0.049],
  // xi8; cmex7: 0.049
  bigOpSpacing1: [0.111, 0.111, 0.111],
  // xi9
  bigOpSpacing2: [0.166, 0.166, 0.166],
  // xi10
  bigOpSpacing3: [0.2, 0.2, 0.2],
  // xi11
  bigOpSpacing4: [0.6, 0.611, 0.611],
  // xi12; cmex7: 0.611
  bigOpSpacing5: [0.1, 0.143, 0.143],
  // xi13; cmex7: 0.143
  // The \sqrt rule width is taken from the height of the surd character.
  // Since we use the same font at all sizes, this thickness doesn't scale.
  sqrtRuleThickness: [0.04, 0.04, 0.04],
  // This value determines how large a pt is, for metrics which are defined
  // in terms of pts.
  // This value is also used in katex.scss; if you change it make sure the
  // values match.
  ptPerEm: [10, 10, 10],
  // The space between adjacent `|` columns in an array definition. From
  // `\showthe\doublerulesep` in LaTeX. Equals 2.0 / ptPerEm.
  doubleRuleSep: [0.2, 0.2, 0.2],
  // The width of separator lines in {array} environments. From
  // `\showthe\arrayrulewidth` in LaTeX. Equals 0.4 / ptPerEm.
  arrayRuleWidth: [0.04, 0.04, 0.04],
  // Two values from LaTeX source2e:
  fboxsep: [0.3, 0.3, 0.3],
  //        3 pt / ptPerEm
  fboxrule: [0.04, 0.04, 0.04]
  // 0.4 pt / ptPerEm
}, u9 = {
  // Latin-1
  Å: "A",
  Ð: "D",
  Þ: "o",
  å: "a",
  ð: "d",
  þ: "o",
  // Cyrillic
  А: "A",
  Б: "B",
  В: "B",
  Г: "F",
  Д: "A",
  Е: "E",
  Ж: "K",
  З: "3",
  И: "N",
  Й: "N",
  К: "K",
  Л: "N",
  М: "M",
  Н: "H",
  О: "O",
  П: "N",
  Р: "P",
  С: "C",
  Т: "T",
  У: "y",
  Ф: "O",
  Х: "X",
  Ц: "U",
  Ч: "h",
  Ш: "W",
  Щ: "W",
  Ъ: "B",
  Ы: "X",
  Ь: "B",
  Э: "3",
  Ю: "X",
  Я: "R",
  а: "a",
  б: "b",
  в: "a",
  г: "r",
  д: "y",
  е: "e",
  ж: "m",
  з: "e",
  и: "n",
  й: "n",
  к: "n",
  л: "n",
  м: "m",
  н: "n",
  о: "o",
  п: "n",
  р: "p",
  с: "c",
  т: "o",
  у: "y",
  ф: "b",
  х: "x",
  ц: "n",
  ч: "n",
  ш: "w",
  щ: "w",
  ъ: "a",
  ы: "m",
  ь: "a",
  э: "e",
  ю: "m",
  я: "r"
};
function Ese(e, t) {
  as[e] = t;
}
function Ay(e, t, n) {
  if (!as[t])
    throw new Error("Font metrics not found for font: " + t + ".");
  var r = e.charCodeAt(0), i = as[t][r];
  if (!i && e[0] in u9 && (r = u9[e[0]].charCodeAt(0), i = as[t][r]), !i && n === "text" && Bz(r) && (i = as[t][77]), i)
    return {
      depth: i[0],
      height: i[1],
      italic: i[2],
      skew: i[3],
      width: i[4]
    };
}
var Y4 = {};
function Sse(e) {
  var t;
  if (e >= 5 ? t = 0 : e >= 3 ? t = 1 : t = 2, !Y4[t]) {
    var n = Y4[t] = {
      cssEmPerMu: Zh.quad[t] / 18
    };
    for (var r in Zh)
      Zh.hasOwnProperty(r) && (n[r] = Zh[r][t]);
  }
  return Y4[t];
}
var Dse = [
  // Each element contains [textsize, scriptsize, scriptscriptsize].
  // The size mappings are taken from TeX with \normalsize=10pt.
  [1, 1, 1],
  // size1: [5, 5, 5]              \tiny
  [2, 1, 1],
  // size2: [6, 5, 5]
  [3, 1, 1],
  // size3: [7, 5, 5]              \scriptsize
  [4, 2, 1],
  // size4: [8, 6, 5]              \footnotesize
  [5, 2, 1],
  // size5: [9, 6, 5]              \small
  [6, 3, 1],
  // size6: [10, 7, 5]             \normalsize
  [7, 4, 2],
  // size7: [12, 8, 6]             \large
  [8, 6, 3],
  // size8: [14.4, 10, 7]          \Large
  [9, 7, 6],
  // size9: [17.28, 12, 10]        \LARGE
  [10, 8, 7],
  // size10: [20.74, 14.4, 12]     \huge
  [11, 10, 9]
  // size11: [24.88, 20.74, 17.28] \HUGE
], c9 = [
  // fontMetrics.js:getGlobalMetrics also uses size indexes, so if
  // you change size indexes, change that function.
  0.5,
  0.6,
  0.7,
  0.8,
  0.9,
  1,
  1.2,
  1.44,
  1.728,
  2.074,
  2.488
], d9 = function(e, t) {
  return t.size < 2 ? e : Dse[e - 1][t.size - 1];
};
class Ps {
  // A font family applies to a group of fonts (i.e. SansSerif), while a font
  // represents a specific font (i.e. SansSerif Bold).
  // See: https://tex.stackexchange.com/questions/22350/difference-between-textrm-and-mathrm
  /**
   * The base size index.
   */
  constructor(t) {
    this.style = void 0, this.color = void 0, this.size = void 0, this.textSize = void 0, this.phantom = void 0, this.font = void 0, this.fontFamily = void 0, this.fontWeight = void 0, this.fontShape = void 0, this.sizeMultiplier = void 0, this.maxSize = void 0, this.minRuleThickness = void 0, this._fontMetrics = void 0, this.style = t.style, this.color = t.color, this.size = t.size || Ps.BASESIZE, this.textSize = t.textSize || this.size, this.phantom = !!t.phantom, this.font = t.font || "", this.fontFamily = t.fontFamily || "", this.fontWeight = t.fontWeight || "", this.fontShape = t.fontShape || "", this.sizeMultiplier = c9[this.size - 1], this.maxSize = t.maxSize, this.minRuleThickness = t.minRuleThickness, this._fontMetrics = void 0;
  }
  /**
   * Returns a new options object with the same properties as "this".  Properties
   * from "extension" will be copied to the new options object.
   */
  extend(t) {
    var n = {
      style: this.style,
      size: this.size,
      textSize: this.textSize,
      color: this.color,
      phantom: this.phantom,
      font: this.font,
      fontFamily: this.fontFamily,
      fontWeight: this.fontWeight,
      fontShape: this.fontShape,
      maxSize: this.maxSize,
      minRuleThickness: this.minRuleThickness
    };
    for (var r in t)
      t.hasOwnProperty(r) && (n[r] = t[r]);
    return new Ps(n);
  }
  /**
   * Return an options object with the given style. If `this.style === style`,
   * returns `this`.
   */
  havingStyle(t) {
    return this.style === t ? this : this.extend({
      style: t,
      size: d9(this.textSize, t)
    });
  }
  /**
   * Return an options object with a cramped version of the current style. If
   * the current style is cramped, returns `this`.
   */
  havingCrampedStyle() {
    return this.havingStyle(this.style.cramp());
  }
  /**
   * Return an options object with the given size and in at least `\textstyle`.
   * Returns `this` if appropriate.
   */
  havingSize(t) {
    return this.size === t && this.textSize === t ? this : this.extend({
      style: this.style.text(),
      size: t,
      textSize: t,
      sizeMultiplier: c9[t - 1]
    });
  }
  /**
   * Like `this.havingSize(BASESIZE).havingStyle(style)`. If `style` is omitted,
   * changes to at least `\textstyle`.
   */
  havingBaseStyle(t) {
    t = t || this.style.text();
    var n = d9(Ps.BASESIZE, t);
    return this.size === n && this.textSize === Ps.BASESIZE && this.style === t ? this : this.extend({
      style: t,
      size: n
    });
  }
  /**
   * Remove the effect of sizing changes such as \Huge.
   * Keep the effect of the current style, such as \scriptstyle.
   */
  havingBaseSizing() {
    var t;
    switch (this.style.id) {
      case 4:
      case 5:
        t = 3;
        break;
      case 6:
      case 7:
        t = 1;
        break;
      default:
        t = 6;
    }
    return this.extend({
      style: this.style.text(),
      size: t
    });
  }
  /**
   * Create a new options object with the given color.
   */
  withColor(t) {
    return this.extend({
      color: t
    });
  }
  /**
   * Create a new options object with "phantom" set to true.
   */
  withPhantom() {
    return this.extend({
      phantom: !0
    });
  }
  /**
   * Creates a new options object with the given math font or old text font.
   * @type {[type]}
   */
  withFont(t) {
    return this.extend({
      font: t
    });
  }
  /**
   * Create a new options objects with the given fontFamily.
   */
  withTextFontFamily(t) {
    return this.extend({
      fontFamily: t,
      font: ""
    });
  }
  /**
   * Creates a new options object with the given font weight
   */
  withTextFontWeight(t) {
    return this.extend({
      fontWeight: t,
      font: ""
    });
  }
  /**
   * Creates a new options object with the given font weight
   */
  withTextFontShape(t) {
    return this.extend({
      fontShape: t,
      font: ""
    });
  }
  /**
   * Return the CSS sizing classes required to switch from enclosing options
   * `oldOptions` to `this`. Returns an array of classes.
   */
  sizingClasses(t) {
    return t.size !== this.size ? ["sizing", "reset-size" + t.size, "size" + this.size] : [];
  }
  /**
   * Return the CSS sizing classes required to switch to the base size. Like
   * `this.havingSize(BASESIZE).sizingClasses(this)`.
   */
  baseSizingClasses() {
    return this.size !== Ps.BASESIZE ? ["sizing", "reset-size" + this.size, "size" + Ps.BASESIZE] : [];
  }
  /**
   * Return the font metrics for this size.
   */
  fontMetrics() {
    return this._fontMetrics || (this._fontMetrics = Sse(this.size)), this._fontMetrics;
  }
  /**
   * Gets the CSS color of the current options object
   */
  getColor() {
    return this.phantom ? "transparent" : this.color;
  }
}
Ps.BASESIZE = 6;
var O5 = {
  // https://en.wikibooks.org/wiki/LaTeX/Lengths and
  // https://tex.stackexchange.com/a/8263
  pt: 1,
  // TeX point
  mm: 7227 / 2540,
  // millimeter
  cm: 7227 / 254,
  // centimeter
  in: 72.27,
  // inch
  bp: 803 / 800,
  // big (PostScript) points
  pc: 12,
  // pica
  dd: 1238 / 1157,
  // didot
  cc: 14856 / 1157,
  // cicero (12 didot)
  nd: 685 / 642,
  // new didot
  nc: 1370 / 107,
  // new cicero (12 new didot)
  sp: 1 / 65536,
  // scaled point (TeX's internal smallest unit)
  // https://tex.stackexchange.com/a/41371
  px: 803 / 800
  // \pdfpxdimen defaults to 1 bp in pdfTeX and LuaTeX
}, Ase = {
  ex: !0,
  em: !0,
  mu: !0
}, Iz = function(e) {
  return typeof e != "string" && (e = e.unit), e in O5 || e in Ase || e === "ex";
}, cr = function(e, t) {
  var n;
  if (e.unit in O5)
    n = O5[e.unit] / t.fontMetrics().ptPerEm / t.sizeMultiplier;
  else if (e.unit === "mu")
    n = t.fontMetrics().cssEmPerMu;
  else {
    var r;
    if (t.style.isTight() ? r = t.havingStyle(t.style.text()) : r = t, e.unit === "ex")
      n = r.fontMetrics().xHeight;
    else if (e.unit === "em")
      n = r.fontMetrics().quad;
    else
      throw new Ye("Invalid unit: '" + e.unit + "'");
    r !== t && (n *= r.sizeMultiplier / t.sizeMultiplier);
  }
  return Math.min(e.number * n, t.maxSize);
}, it = function(e) {
  return +e.toFixed(4) + "em";
}, yu = function(e) {
  return e.filter((t) => t).join(" ");
}, Rz = function(e, t, n) {
  if (this.classes = e || [], this.attributes = {}, this.height = 0, this.depth = 0, this.maxFontSize = 0, this.style = n || {}, t) {
    t.style.isTight() && this.classes.push("mtight");
    var r = t.getColor();
    r && (this.style.color = r);
  }
}, Pz = function(e) {
  var t = document.createElement(e);
  t.className = yu(this.classes);
  for (var n in this.style)
    this.style.hasOwnProperty(n) && (t.style[n] = this.style[n]);
  for (var r in this.attributes)
    this.attributes.hasOwnProperty(r) && t.setAttribute(r, this.attributes[r]);
  for (var i = 0; i < this.children.length; i++)
    t.appendChild(this.children[i].toNode());
  return t;
}, _z = function(e) {
  var t = "<" + e;
  this.classes.length && (t += ' class="' + Nt.escape(yu(this.classes)) + '"');
  var n = "";
  for (var r in this.style)
    this.style.hasOwnProperty(r) && (n += Nt.hyphenate(r) + ":" + this.style[r] + ";");
  n && (t += ' style="' + Nt.escape(n) + '"');
  for (var i in this.attributes)
    this.attributes.hasOwnProperty(i) && (t += " " + i + '="' + Nt.escape(this.attributes[i]) + '"');
  t += ">";
  for (var o = 0; o < this.children.length; o++)
    t += this.children[o].toMarkup();
  return t += "</" + e + ">", t;
};
let Hf = class {
  constructor(e, t, n, r) {
    this.children = void 0, this.attributes = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.width = void 0, this.maxFontSize = void 0, this.style = void 0, Rz.call(this, e, n, r), this.children = t || [];
  }
  /**
   * Sets an arbitrary attribute on the span. Warning: use this wisely. Not
   * all browsers support attributes the same, and having too many custom
   * attributes is probably bad.
   */
  setAttribute(e, t) {
    this.attributes[e] = t;
  }
  hasClass(e) {
    return Nt.contains(this.classes, e);
  }
  toNode() {
    return Pz.call(this, "span");
  }
  toMarkup() {
    return _z.call(this, "span");
  }
};
class Ty {
  constructor(t, n, r, i) {
    this.children = void 0, this.attributes = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, Rz.call(this, n, i), this.children = r || [], this.setAttribute("href", t);
  }
  setAttribute(t, n) {
    this.attributes[t] = n;
  }
  hasClass(t) {
    return Nt.contains(this.classes, t);
  }
  toNode() {
    return Pz.call(this, "a");
  }
  toMarkup() {
    return _z.call(this, "a");
  }
}
class Tse {
  constructor(t, n, r) {
    this.src = void 0, this.alt = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, this.alt = n, this.src = t, this.classes = ["mord"], this.style = r;
  }
  hasClass(t) {
    return Nt.contains(this.classes, t);
  }
  toNode() {
    var t = document.createElement("img");
    t.src = this.src, t.alt = this.alt, t.className = "mord";
    for (var n in this.style)
      this.style.hasOwnProperty(n) && (t.style[n] = this.style[n]);
    return t;
  }
  toMarkup() {
    var t = '<img src="' + Nt.escape(this.src) + '"' + (' alt="' + Nt.escape(this.alt) + '"'), n = "";
    for (var r in this.style)
      this.style.hasOwnProperty(r) && (n += Nt.hyphenate(r) + ":" + this.style[r] + ";");
    return n && (t += ' style="' + Nt.escape(n) + '"'), t += "'/>", t;
  }
}
var jse = {
  î: "ı̂",
  ï: "ı̈",
  í: "ı́",
  // 'ī': '\u0131\u0304', // enable when we add Extended Latin
  ì: "ı̀"
};
class ma {
  constructor(t, n, r, i, o, a, s, l) {
    this.text = void 0, this.height = void 0, this.depth = void 0, this.italic = void 0, this.skew = void 0, this.width = void 0, this.maxFontSize = void 0, this.classes = void 0, this.style = void 0, this.text = t, this.height = n || 0, this.depth = r || 0, this.italic = i || 0, this.skew = o || 0, this.width = a || 0, this.classes = s || [], this.style = l || {}, this.maxFontSize = 0;
    var u = fse(this.text.charCodeAt(0));
    u && this.classes.push(u + "_fallback"), /[îïíì]/.test(this.text) && (this.text = jse[this.text]);
  }
  hasClass(t) {
    return Nt.contains(this.classes, t);
  }
  /**
   * Creates a text node or span from a symbol node. Note that a span is only
   * created if it is needed.
   */
  toNode() {
    var t = document.createTextNode(this.text), n = null;
    this.italic > 0 && (n = document.createElement("span"), n.style.marginRight = it(this.italic)), this.classes.length > 0 && (n = n || document.createElement("span"), n.className = yu(this.classes));
    for (var r in this.style)
      this.style.hasOwnProperty(r) && (n = n || document.createElement("span"), n.style[r] = this.style[r]);
    return n ? (n.appendChild(t), n) : t;
  }
  /**
   * Creates markup for a symbol node.
   */
  toMarkup() {
    var t = !1, n = "<span";
    this.classes.length && (t = !0, n += ' class="', n += Nt.escape(yu(this.classes)), n += '"');
    var r = "";
    this.italic > 0 && (r += "margin-right:" + this.italic + "em;");
    for (var i in this.style)
      this.style.hasOwnProperty(i) && (r += Nt.hyphenate(i) + ":" + this.style[i] + ";");
    r && (t = !0, n += ' style="' + Nt.escape(r) + '"');
    var o = Nt.escape(this.text);
    return t ? (n += ">", n += o, n += "</span>", n) : o;
  }
}
class dl {
  constructor(t, n) {
    this.children = void 0, this.attributes = void 0, this.children = t || [], this.attributes = n || {};
  }
  toNode() {
    var t = "http://www.w3.org/2000/svg", n = document.createElementNS(t, "svg");
    for (var r in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, r) && n.setAttribute(r, this.attributes[r]);
    for (var i = 0; i < this.children.length; i++)
      n.appendChild(this.children[i].toNode());
    return n;
  }
  toMarkup() {
    var t = '<svg xmlns="http://www.w3.org/2000/svg"';
    for (var n in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, n) && (t += " " + n + '="' + Nt.escape(this.attributes[n]) + '"');
    t += ">";
    for (var r = 0; r < this.children.length; r++)
      t += this.children[r].toMarkup();
    return t += "</svg>", t;
  }
}
class xu {
  constructor(t, n) {
    this.pathName = void 0, this.alternate = void 0, this.pathName = t, this.alternate = n;
  }
  toNode() {
    var t = "http://www.w3.org/2000/svg", n = document.createElementNS(t, "path");
    return this.alternate ? n.setAttribute("d", this.alternate) : n.setAttribute("d", l9[this.pathName]), n;
  }
  toMarkup() {
    return this.alternate ? '<path d="' + Nt.escape(this.alternate) + '"/>' : '<path d="' + Nt.escape(l9[this.pathName]) + '"/>';
  }
}
class z5 {
  constructor(t) {
    this.attributes = void 0, this.attributes = t || {};
  }
  toNode() {
    var t = "http://www.w3.org/2000/svg", n = document.createElementNS(t, "line");
    for (var r in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, r) && n.setAttribute(r, this.attributes[r]);
    return n;
  }
  toMarkup() {
    var t = "<line";
    for (var n in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, n) && (t += " " + n + '="' + Nt.escape(this.attributes[n]) + '"');
    return t += "/>", t;
  }
}
function p9(e) {
  if (e instanceof ma)
    return e;
  throw new Error("Expected symbolNode but got " + String(e) + ".");
}
function Nse(e) {
  if (e instanceof Hf)
    return e;
  throw new Error("Expected span<HtmlDomNode> but got " + String(e) + ".");
}
var Ose = {
  bin: 1,
  close: 1,
  inner: 1,
  open: 1,
  punct: 1,
  rel: 1
}, zse = {
  "accent-token": 1,
  mathord: 1,
  "op-token": 1,
  spacing: 1,
  textord: 1
}, Bn = {
  math: {},
  text: {}
};
function N(e, t, n, r, i, o) {
  Bn[e][i] = {
    font: t,
    group: n,
    replace: r
  }, o && r && (Bn[e][r] = Bn[e][i]);
}
var B = "math", He = "text", V = "main", J = "ams", Kn = "accent-token", gt = "bin", _i = "close", yd = "inner", Ot = "mathord", Mr = "op-token", $o = "open", v2 = "punct", te = "rel", yl = "spacing", me = "textord";
N(B, V, te, "≡", "\\equiv", !0);
N(B, V, te, "≺", "\\prec", !0);
N(B, V, te, "≻", "\\succ", !0);
N(B, V, te, "∼", "\\sim", !0);
N(B, V, te, "⊥", "\\perp");
N(B, V, te, "⪯", "\\preceq", !0);
N(B, V, te, "⪰", "\\succeq", !0);
N(B, V, te, "≃", "\\simeq", !0);
N(B, V, te, "∣", "\\mid", !0);
N(B, V, te, "≪", "\\ll", !0);
N(B, V, te, "≫", "\\gg", !0);
N(B, V, te, "≍", "\\asymp", !0);
N(B, V, te, "∥", "\\parallel");
N(B, V, te, "⋈", "\\bowtie", !0);
N(B, V, te, "⌣", "\\smile", !0);
N(B, V, te, "⊑", "\\sqsubseteq", !0);
N(B, V, te, "⊒", "\\sqsupseteq", !0);
N(B, V, te, "≐", "\\doteq", !0);
N(B, V, te, "⌢", "\\frown", !0);
N(B, V, te, "∋", "\\ni", !0);
N(B, V, te, "∝", "\\propto", !0);
N(B, V, te, "⊢", "\\vdash", !0);
N(B, V, te, "⊣", "\\dashv", !0);
N(B, V, te, "∋", "\\owns");
N(B, V, v2, ".", "\\ldotp");
N(B, V, v2, "⋅", "\\cdotp");
N(B, V, me, "#", "\\#");
N(He, V, me, "#", "\\#");
N(B, V, me, "&", "\\&");
N(He, V, me, "&", "\\&");
N(B, V, me, "ℵ", "\\aleph", !0);
N(B, V, me, "∀", "\\forall", !0);
N(B, V, me, "ℏ", "\\hbar", !0);
N(B, V, me, "∃", "\\exists", !0);
N(B, V, me, "∇", "\\nabla", !0);
N(B, V, me, "♭", "\\flat", !0);
N(B, V, me, "ℓ", "\\ell", !0);
N(B, V, me, "♮", "\\natural", !0);
N(B, V, me, "♣", "\\clubsuit", !0);
N(B, V, me, "℘", "\\wp", !0);
N(B, V, me, "♯", "\\sharp", !0);
N(B, V, me, "♢", "\\diamondsuit", !0);
N(B, V, me, "ℜ", "\\Re", !0);
N(B, V, me, "♡", "\\heartsuit", !0);
N(B, V, me, "ℑ", "\\Im", !0);
N(B, V, me, "♠", "\\spadesuit", !0);
N(B, V, me, "§", "\\S", !0);
N(He, V, me, "§", "\\S");
N(B, V, me, "¶", "\\P", !0);
N(He, V, me, "¶", "\\P");
N(B, V, me, "†", "\\dag");
N(He, V, me, "†", "\\dag");
N(He, V, me, "†", "\\textdagger");
N(B, V, me, "‡", "\\ddag");
N(He, V, me, "‡", "\\ddag");
N(He, V, me, "‡", "\\textdaggerdbl");
N(B, V, _i, "⎱", "\\rmoustache", !0);
N(B, V, $o, "⎰", "\\lmoustache", !0);
N(B, V, _i, "⟯", "\\rgroup", !0);
N(B, V, $o, "⟮", "\\lgroup", !0);
N(B, V, gt, "∓", "\\mp", !0);
N(B, V, gt, "⊖", "\\ominus", !0);
N(B, V, gt, "⊎", "\\uplus", !0);
N(B, V, gt, "⊓", "\\sqcap", !0);
N(B, V, gt, "∗", "\\ast");
N(B, V, gt, "⊔", "\\sqcup", !0);
N(B, V, gt, "◯", "\\bigcirc", !0);
N(B, V, gt, "∙", "\\bullet", !0);
N(B, V, gt, "‡", "\\ddagger");
N(B, V, gt, "≀", "\\wr", !0);
N(B, V, gt, "⨿", "\\amalg");
N(B, V, gt, "&", "\\And");
N(B, V, te, "⟵", "\\longleftarrow", !0);
N(B, V, te, "⇐", "\\Leftarrow", !0);
N(B, V, te, "⟸", "\\Longleftarrow", !0);
N(B, V, te, "⟶", "\\longrightarrow", !0);
N(B, V, te, "⇒", "\\Rightarrow", !0);
N(B, V, te, "⟹", "\\Longrightarrow", !0);
N(B, V, te, "↔", "\\leftrightarrow", !0);
N(B, V, te, "⟷", "\\longleftrightarrow", !0);
N(B, V, te, "⇔", "\\Leftrightarrow", !0);
N(B, V, te, "⟺", "\\Longleftrightarrow", !0);
N(B, V, te, "↦", "\\mapsto", !0);
N(B, V, te, "⟼", "\\longmapsto", !0);
N(B, V, te, "↗", "\\nearrow", !0);
N(B, V, te, "↩", "\\hookleftarrow", !0);
N(B, V, te, "↪", "\\hookrightarrow", !0);
N(B, V, te, "↘", "\\searrow", !0);
N(B, V, te, "↼", "\\leftharpoonup", !0);
N(B, V, te, "⇀", "\\rightharpoonup", !0);
N(B, V, te, "↙", "\\swarrow", !0);
N(B, V, te, "↽", "\\leftharpoondown", !0);
N(B, V, te, "⇁", "\\rightharpoondown", !0);
N(B, V, te, "↖", "\\nwarrow", !0);
N(B, V, te, "⇌", "\\rightleftharpoons", !0);
N(B, J, te, "≮", "\\nless", !0);
N(B, J, te, "", "\\@nleqslant");
N(B, J, te, "", "\\@nleqq");
N(B, J, te, "⪇", "\\lneq", !0);
N(B, J, te, "≨", "\\lneqq", !0);
N(B, J, te, "", "\\@lvertneqq");
N(B, J, te, "⋦", "\\lnsim", !0);
N(B, J, te, "⪉", "\\lnapprox", !0);
N(B, J, te, "⊀", "\\nprec", !0);
N(B, J, te, "⋠", "\\npreceq", !0);
N(B, J, te, "⋨", "\\precnsim", !0);
N(B, J, te, "⪹", "\\precnapprox", !0);
N(B, J, te, "≁", "\\nsim", !0);
N(B, J, te, "", "\\@nshortmid");
N(B, J, te, "∤", "\\nmid", !0);
N(B, J, te, "⊬", "\\nvdash", !0);
N(B, J, te, "⊭", "\\nvDash", !0);
N(B, J, te, "⋪", "\\ntriangleleft");
N(B, J, te, "⋬", "\\ntrianglelefteq", !0);
N(B, J, te, "⊊", "\\subsetneq", !0);
N(B, J, te, "", "\\@varsubsetneq");
N(B, J, te, "⫋", "\\subsetneqq", !0);
N(B, J, te, "", "\\@varsubsetneqq");
N(B, J, te, "≯", "\\ngtr", !0);
N(B, J, te, "", "\\@ngeqslant");
N(B, J, te, "", "\\@ngeqq");
N(B, J, te, "⪈", "\\gneq", !0);
N(B, J, te, "≩", "\\gneqq", !0);
N(B, J, te, "", "\\@gvertneqq");
N(B, J, te, "⋧", "\\gnsim", !0);
N(B, J, te, "⪊", "\\gnapprox", !0);
N(B, J, te, "⊁", "\\nsucc", !0);
N(B, J, te, "⋡", "\\nsucceq", !0);
N(B, J, te, "⋩", "\\succnsim", !0);
N(B, J, te, "⪺", "\\succnapprox", !0);
N(B, J, te, "≆", "\\ncong", !0);
N(B, J, te, "", "\\@nshortparallel");
N(B, J, te, "∦", "\\nparallel", !0);
N(B, J, te, "⊯", "\\nVDash", !0);
N(B, J, te, "⋫", "\\ntriangleright");
N(B, J, te, "⋭", "\\ntrianglerighteq", !0);
N(B, J, te, "", "\\@nsupseteqq");
N(B, J, te, "⊋", "\\supsetneq", !0);
N(B, J, te, "", "\\@varsupsetneq");
N(B, J, te, "⫌", "\\supsetneqq", !0);
N(B, J, te, "", "\\@varsupsetneqq");
N(B, J, te, "⊮", "\\nVdash", !0);
N(B, J, te, "⪵", "\\precneqq", !0);
N(B, J, te, "⪶", "\\succneqq", !0);
N(B, J, te, "", "\\@nsubseteqq");
N(B, J, gt, "⊴", "\\unlhd");
N(B, J, gt, "⊵", "\\unrhd");
N(B, J, te, "↚", "\\nleftarrow", !0);
N(B, J, te, "↛", "\\nrightarrow", !0);
N(B, J, te, "⇍", "\\nLeftarrow", !0);
N(B, J, te, "⇏", "\\nRightarrow", !0);
N(B, J, te, "↮", "\\nleftrightarrow", !0);
N(B, J, te, "⇎", "\\nLeftrightarrow", !0);
N(B, J, te, "△", "\\vartriangle");
N(B, J, me, "ℏ", "\\hslash");
N(B, J, me, "▽", "\\triangledown");
N(B, J, me, "◊", "\\lozenge");
N(B, J, me, "Ⓢ", "\\circledS");
N(B, J, me, "®", "\\circledR");
N(He, J, me, "®", "\\circledR");
N(B, J, me, "∡", "\\measuredangle", !0);
N(B, J, me, "∄", "\\nexists");
N(B, J, me, "℧", "\\mho");
N(B, J, me, "Ⅎ", "\\Finv", !0);
N(B, J, me, "⅁", "\\Game", !0);
N(B, J, me, "‵", "\\backprime");
N(B, J, me, "▲", "\\blacktriangle");
N(B, J, me, "▼", "\\blacktriangledown");
N(B, J, me, "■", "\\blacksquare");
N(B, J, me, "⧫", "\\blacklozenge");
N(B, J, me, "★", "\\bigstar");
N(B, J, me, "∢", "\\sphericalangle", !0);
N(B, J, me, "∁", "\\complement", !0);
N(B, J, me, "ð", "\\eth", !0);
N(He, V, me, "ð", "ð");
N(B, J, me, "╱", "\\diagup");
N(B, J, me, "╲", "\\diagdown");
N(B, J, me, "□", "\\square");
N(B, J, me, "□", "\\Box");
N(B, J, me, "◊", "\\Diamond");
N(B, J, me, "¥", "\\yen", !0);
N(He, J, me, "¥", "\\yen", !0);
N(B, J, me, "✓", "\\checkmark", !0);
N(He, J, me, "✓", "\\checkmark");
N(B, J, me, "ℶ", "\\beth", !0);
N(B, J, me, "ℸ", "\\daleth", !0);
N(B, J, me, "ℷ", "\\gimel", !0);
N(B, J, me, "ϝ", "\\digamma", !0);
N(B, J, me, "ϰ", "\\varkappa");
N(B, J, $o, "┌", "\\@ulcorner", !0);
N(B, J, _i, "┐", "\\@urcorner", !0);
N(B, J, $o, "└", "\\@llcorner", !0);
N(B, J, _i, "┘", "\\@lrcorner", !0);
N(B, J, te, "≦", "\\leqq", !0);
N(B, J, te, "⩽", "\\leqslant", !0);
N(B, J, te, "⪕", "\\eqslantless", !0);
N(B, J, te, "≲", "\\lesssim", !0);
N(B, J, te, "⪅", "\\lessapprox", !0);
N(B, J, te, "≊", "\\approxeq", !0);
N(B, J, gt, "⋖", "\\lessdot");
N(B, J, te, "⋘", "\\lll", !0);
N(B, J, te, "≶", "\\lessgtr", !0);
N(B, J, te, "⋚", "\\lesseqgtr", !0);
N(B, J, te, "⪋", "\\lesseqqgtr", !0);
N(B, J, te, "≑", "\\doteqdot");
N(B, J, te, "≓", "\\risingdotseq", !0);
N(B, J, te, "≒", "\\fallingdotseq", !0);
N(B, J, te, "∽", "\\backsim", !0);
N(B, J, te, "⋍", "\\backsimeq", !0);
N(B, J, te, "⫅", "\\subseteqq", !0);
N(B, J, te, "⋐", "\\Subset", !0);
N(B, J, te, "⊏", "\\sqsubset", !0);
N(B, J, te, "≼", "\\preccurlyeq", !0);
N(B, J, te, "⋞", "\\curlyeqprec", !0);
N(B, J, te, "≾", "\\precsim", !0);
N(B, J, te, "⪷", "\\precapprox", !0);
N(B, J, te, "⊲", "\\vartriangleleft");
N(B, J, te, "⊴", "\\trianglelefteq");
N(B, J, te, "⊨", "\\vDash", !0);
N(B, J, te, "⊪", "\\Vvdash", !0);
N(B, J, te, "⌣", "\\smallsmile");
N(B, J, te, "⌢", "\\smallfrown");
N(B, J, te, "≏", "\\bumpeq", !0);
N(B, J, te, "≎", "\\Bumpeq", !0);
N(B, J, te, "≧", "\\geqq", !0);
N(B, J, te, "⩾", "\\geqslant", !0);
N(B, J, te, "⪖", "\\eqslantgtr", !0);
N(B, J, te, "≳", "\\gtrsim", !0);
N(B, J, te, "⪆", "\\gtrapprox", !0);
N(B, J, gt, "⋗", "\\gtrdot");
N(B, J, te, "⋙", "\\ggg", !0);
N(B, J, te, "≷", "\\gtrless", !0);
N(B, J, te, "⋛", "\\gtreqless", !0);
N(B, J, te, "⪌", "\\gtreqqless", !0);
N(B, J, te, "≖", "\\eqcirc", !0);
N(B, J, te, "≗", "\\circeq", !0);
N(B, J, te, "≜", "\\triangleq", !0);
N(B, J, te, "∼", "\\thicksim");
N(B, J, te, "≈", "\\thickapprox");
N(B, J, te, "⫆", "\\supseteqq", !0);
N(B, J, te, "⋑", "\\Supset", !0);
N(B, J, te, "⊐", "\\sqsupset", !0);
N(B, J, te, "≽", "\\succcurlyeq", !0);
N(B, J, te, "⋟", "\\curlyeqsucc", !0);
N(B, J, te, "≿", "\\succsim", !0);
N(B, J, te, "⪸", "\\succapprox", !0);
N(B, J, te, "⊳", "\\vartriangleright");
N(B, J, te, "⊵", "\\trianglerighteq");
N(B, J, te, "⊩", "\\Vdash", !0);
N(B, J, te, "∣", "\\shortmid");
N(B, J, te, "∥", "\\shortparallel");
N(B, J, te, "≬", "\\between", !0);
N(B, J, te, "⋔", "\\pitchfork", !0);
N(B, J, te, "∝", "\\varpropto");
N(B, J, te, "◀", "\\blacktriangleleft");
N(B, J, te, "∴", "\\therefore", !0);
N(B, J, te, "∍", "\\backepsilon");
N(B, J, te, "▶", "\\blacktriangleright");
N(B, J, te, "∵", "\\because", !0);
N(B, J, te, "⋘", "\\llless");
N(B, J, te, "⋙", "\\gggtr");
N(B, J, gt, "⊲", "\\lhd");
N(B, J, gt, "⊳", "\\rhd");
N(B, J, te, "≂", "\\eqsim", !0);
N(B, V, te, "⋈", "\\Join");
N(B, J, te, "≑", "\\Doteq", !0);
N(B, J, gt, "∔", "\\dotplus", !0);
N(B, J, gt, "∖", "\\smallsetminus");
N(B, J, gt, "⋒", "\\Cap", !0);
N(B, J, gt, "⋓", "\\Cup", !0);
N(B, J, gt, "⩞", "\\doublebarwedge", !0);
N(B, J, gt, "⊟", "\\boxminus", !0);
N(B, J, gt, "⊞", "\\boxplus", !0);
N(B, J, gt, "⋇", "\\divideontimes", !0);
N(B, J, gt, "⋉", "\\ltimes", !0);
N(B, J, gt, "⋊", "\\rtimes", !0);
N(B, J, gt, "⋋", "\\leftthreetimes", !0);
N(B, J, gt, "⋌", "\\rightthreetimes", !0);
N(B, J, gt, "⋏", "\\curlywedge", !0);
N(B, J, gt, "⋎", "\\curlyvee", !0);
N(B, J, gt, "⊝", "\\circleddash", !0);
N(B, J, gt, "⊛", "\\circledast", !0);
N(B, J, gt, "⋅", "\\centerdot");
N(B, J, gt, "⊺", "\\intercal", !0);
N(B, J, gt, "⋒", "\\doublecap");
N(B, J, gt, "⋓", "\\doublecup");
N(B, J, gt, "⊠", "\\boxtimes", !0);
N(B, J, te, "⇢", "\\dashrightarrow", !0);
N(B, J, te, "⇠", "\\dashleftarrow", !0);
N(B, J, te, "⇇", "\\leftleftarrows", !0);
N(B, J, te, "⇆", "\\leftrightarrows", !0);
N(B, J, te, "⇚", "\\Lleftarrow", !0);
N(B, J, te, "↞", "\\twoheadleftarrow", !0);
N(B, J, te, "↢", "\\leftarrowtail", !0);
N(B, J, te, "↫", "\\looparrowleft", !0);
N(B, J, te, "⇋", "\\leftrightharpoons", !0);
N(B, J, te, "↶", "\\curvearrowleft", !0);
N(B, J, te, "↺", "\\circlearrowleft", !0);
N(B, J, te, "↰", "\\Lsh", !0);
N(B, J, te, "⇈", "\\upuparrows", !0);
N(B, J, te, "↿", "\\upharpoonleft", !0);
N(B, J, te, "⇃", "\\downharpoonleft", !0);
N(B, V, te, "⊶", "\\origof", !0);
N(B, V, te, "⊷", "\\imageof", !0);
N(B, J, te, "⊸", "\\multimap", !0);
N(B, J, te, "↭", "\\leftrightsquigarrow", !0);
N(B, J, te, "⇉", "\\rightrightarrows", !0);
N(B, J, te, "⇄", "\\rightleftarrows", !0);
N(B, J, te, "↠", "\\twoheadrightarrow", !0);
N(B, J, te, "↣", "\\rightarrowtail", !0);
N(B, J, te, "↬", "\\looparrowright", !0);
N(B, J, te, "↷", "\\curvearrowright", !0);
N(B, J, te, "↻", "\\circlearrowright", !0);
N(B, J, te, "↱", "\\Rsh", !0);
N(B, J, te, "⇊", "\\downdownarrows", !0);
N(B, J, te, "↾", "\\upharpoonright", !0);
N(B, J, te, "⇂", "\\downharpoonright", !0);
N(B, J, te, "⇝", "\\rightsquigarrow", !0);
N(B, J, te, "⇝", "\\leadsto");
N(B, J, te, "⇛", "\\Rrightarrow", !0);
N(B, J, te, "↾", "\\restriction");
N(B, V, me, "‘", "`");
N(B, V, me, "$", "\\$");
N(He, V, me, "$", "\\$");
N(He, V, me, "$", "\\textdollar");
N(B, V, me, "%", "\\%");
N(He, V, me, "%", "\\%");
N(B, V, me, "_", "\\_");
N(He, V, me, "_", "\\_");
N(He, V, me, "_", "\\textunderscore");
N(B, V, me, "∠", "\\angle", !0);
N(B, V, me, "∞", "\\infty", !0);
N(B, V, me, "′", "\\prime");
N(B, V, me, "△", "\\triangle");
N(B, V, me, "Γ", "\\Gamma", !0);
N(B, V, me, "Δ", "\\Delta", !0);
N(B, V, me, "Θ", "\\Theta", !0);
N(B, V, me, "Λ", "\\Lambda", !0);
N(B, V, me, "Ξ", "\\Xi", !0);
N(B, V, me, "Π", "\\Pi", !0);
N(B, V, me, "Σ", "\\Sigma", !0);
N(B, V, me, "Υ", "\\Upsilon", !0);
N(B, V, me, "Φ", "\\Phi", !0);
N(B, V, me, "Ψ", "\\Psi", !0);
N(B, V, me, "Ω", "\\Omega", !0);
N(B, V, me, "A", "Α");
N(B, V, me, "B", "Β");
N(B, V, me, "E", "Ε");
N(B, V, me, "Z", "Ζ");
N(B, V, me, "H", "Η");
N(B, V, me, "I", "Ι");
N(B, V, me, "K", "Κ");
N(B, V, me, "M", "Μ");
N(B, V, me, "N", "Ν");
N(B, V, me, "O", "Ο");
N(B, V, me, "P", "Ρ");
N(B, V, me, "T", "Τ");
N(B, V, me, "X", "Χ");
N(B, V, me, "¬", "\\neg", !0);
N(B, V, me, "¬", "\\lnot");
N(B, V, me, "⊤", "\\top");
N(B, V, me, "⊥", "\\bot");
N(B, V, me, "∅", "\\emptyset");
N(B, J, me, "∅", "\\varnothing");
N(B, V, Ot, "α", "\\alpha", !0);
N(B, V, Ot, "β", "\\beta", !0);
N(B, V, Ot, "γ", "\\gamma", !0);
N(B, V, Ot, "δ", "\\delta", !0);
N(B, V, Ot, "ϵ", "\\epsilon", !0);
N(B, V, Ot, "ζ", "\\zeta", !0);
N(B, V, Ot, "η", "\\eta", !0);
N(B, V, Ot, "θ", "\\theta", !0);
N(B, V, Ot, "ι", "\\iota", !0);
N(B, V, Ot, "κ", "\\kappa", !0);
N(B, V, Ot, "λ", "\\lambda", !0);
N(B, V, Ot, "μ", "\\mu", !0);
N(B, V, Ot, "ν", "\\nu", !0);
N(B, V, Ot, "ξ", "\\xi", !0);
N(B, V, Ot, "ο", "\\omicron", !0);
N(B, V, Ot, "π", "\\pi", !0);
N(B, V, Ot, "ρ", "\\rho", !0);
N(B, V, Ot, "σ", "\\sigma", !0);
N(B, V, Ot, "τ", "\\tau", !0);
N(B, V, Ot, "υ", "\\upsilon", !0);
N(B, V, Ot, "ϕ", "\\phi", !0);
N(B, V, Ot, "χ", "\\chi", !0);
N(B, V, Ot, "ψ", "\\psi", !0);
N(B, V, Ot, "ω", "\\omega", !0);
N(B, V, Ot, "ε", "\\varepsilon", !0);
N(B, V, Ot, "ϑ", "\\vartheta", !0);
N(B, V, Ot, "ϖ", "\\varpi", !0);
N(B, V, Ot, "ϱ", "\\varrho", !0);
N(B, V, Ot, "ς", "\\varsigma", !0);
N(B, V, Ot, "φ", "\\varphi", !0);
N(B, V, gt, "∗", "*", !0);
N(B, V, gt, "+", "+");
N(B, V, gt, "−", "-", !0);
N(B, V, gt, "⋅", "\\cdot", !0);
N(B, V, gt, "∘", "\\circ", !0);
N(B, V, gt, "÷", "\\div", !0);
N(B, V, gt, "±", "\\pm", !0);
N(B, V, gt, "×", "\\times", !0);
N(B, V, gt, "∩", "\\cap", !0);
N(B, V, gt, "∪", "\\cup", !0);
N(B, V, gt, "∖", "\\setminus", !0);
N(B, V, gt, "∧", "\\land");
N(B, V, gt, "∨", "\\lor");
N(B, V, gt, "∧", "\\wedge", !0);
N(B, V, gt, "∨", "\\vee", !0);
N(B, V, me, "√", "\\surd");
N(B, V, $o, "⟨", "\\langle", !0);
N(B, V, $o, "∣", "\\lvert");
N(B, V, $o, "∥", "\\lVert");
N(B, V, _i, "?", "?");
N(B, V, _i, "!", "!");
N(B, V, _i, "⟩", "\\rangle", !0);
N(B, V, _i, "∣", "\\rvert");
N(B, V, _i, "∥", "\\rVert");
N(B, V, te, "=", "=");
N(B, V, te, ":", ":");
N(B, V, te, "≈", "\\approx", !0);
N(B, V, te, "≅", "\\cong", !0);
N(B, V, te, "≥", "\\ge");
N(B, V, te, "≥", "\\geq", !0);
N(B, V, te, "←", "\\gets");
N(B, V, te, ">", "\\gt", !0);
N(B, V, te, "∈", "\\in", !0);
N(B, V, te, "", "\\@not");
N(B, V, te, "⊂", "\\subset", !0);
N(B, V, te, "⊃", "\\supset", !0);
N(B, V, te, "⊆", "\\subseteq", !0);
N(B, V, te, "⊇", "\\supseteq", !0);
N(B, J, te, "⊈", "\\nsubseteq", !0);
N(B, J, te, "⊉", "\\nsupseteq", !0);
N(B, V, te, "⊨", "\\models");
N(B, V, te, "←", "\\leftarrow", !0);
N(B, V, te, "≤", "\\le");
N(B, V, te, "≤", "\\leq", !0);
N(B, V, te, "<", "\\lt", !0);
N(B, V, te, "→", "\\rightarrow", !0);
N(B, V, te, "→", "\\to");
N(B, J, te, "≱", "\\ngeq", !0);
N(B, J, te, "≰", "\\nleq", !0);
N(B, V, yl, " ", "\\ ");
N(B, V, yl, " ", "\\space");
N(B, V, yl, " ", "\\nobreakspace");
N(He, V, yl, " ", "\\ ");
N(He, V, yl, " ", " ");
N(He, V, yl, " ", "\\space");
N(He, V, yl, " ", "\\nobreakspace");
N(B, V, yl, null, "\\nobreak");
N(B, V, yl, null, "\\allowbreak");
N(B, V, v2, ",", ",");
N(B, V, v2, ";", ";");
N(B, J, gt, "⊼", "\\barwedge", !0);
N(B, J, gt, "⊻", "\\veebar", !0);
N(B, V, gt, "⊙", "\\odot", !0);
N(B, V, gt, "⊕", "\\oplus", !0);
N(B, V, gt, "⊗", "\\otimes", !0);
N(B, V, me, "∂", "\\partial", !0);
N(B, V, gt, "⊘", "\\oslash", !0);
N(B, J, gt, "⊚", "\\circledcirc", !0);
N(B, J, gt, "⊡", "\\boxdot", !0);
N(B, V, gt, "△", "\\bigtriangleup");
N(B, V, gt, "▽", "\\bigtriangledown");
N(B, V, gt, "†", "\\dagger");
N(B, V, gt, "⋄", "\\diamond");
N(B, V, gt, "⋆", "\\star");
N(B, V, gt, "◃", "\\triangleleft");
N(B, V, gt, "▹", "\\triangleright");
N(B, V, $o, "{", "\\{");
N(He, V, me, "{", "\\{");
N(He, V, me, "{", "\\textbraceleft");
N(B, V, _i, "}", "\\}");
N(He, V, me, "}", "\\}");
N(He, V, me, "}", "\\textbraceright");
N(B, V, $o, "{", "\\lbrace");
N(B, V, _i, "}", "\\rbrace");
N(B, V, $o, "[", "\\lbrack", !0);
N(He, V, me, "[", "\\lbrack", !0);
N(B, V, _i, "]", "\\rbrack", !0);
N(He, V, me, "]", "\\rbrack", !0);
N(B, V, $o, "(", "\\lparen", !0);
N(B, V, _i, ")", "\\rparen", !0);
N(He, V, me, "<", "\\textless", !0);
N(He, V, me, ">", "\\textgreater", !0);
N(B, V, $o, "⌊", "\\lfloor", !0);
N(B, V, _i, "⌋", "\\rfloor", !0);
N(B, V, $o, "⌈", "\\lceil", !0);
N(B, V, _i, "⌉", "\\rceil", !0);
N(B, V, me, "\\", "\\backslash");
N(B, V, me, "∣", "|");
N(B, V, me, "∣", "\\vert");
N(He, V, me, "|", "\\textbar", !0);
N(B, V, me, "∥", "\\|");
N(B, V, me, "∥", "\\Vert");
N(He, V, me, "∥", "\\textbardbl");
N(He, V, me, "~", "\\textasciitilde");
N(He, V, me, "\\", "\\textbackslash");
N(He, V, me, "^", "\\textasciicircum");
N(B, V, te, "↑", "\\uparrow", !0);
N(B, V, te, "⇑", "\\Uparrow", !0);
N(B, V, te, "↓", "\\downarrow", !0);
N(B, V, te, "⇓", "\\Downarrow", !0);
N(B, V, te, "↕", "\\updownarrow", !0);
N(B, V, te, "⇕", "\\Updownarrow", !0);
N(B, V, Mr, "∐", "\\coprod");
N(B, V, Mr, "⋁", "\\bigvee");
N(B, V, Mr, "⋀", "\\bigwedge");
N(B, V, Mr, "⨄", "\\biguplus");
N(B, V, Mr, "⋂", "\\bigcap");
N(B, V, Mr, "⋃", "\\bigcup");
N(B, V, Mr, "∫", "\\int");
N(B, V, Mr, "∫", "\\intop");
N(B, V, Mr, "∬", "\\iint");
N(B, V, Mr, "∭", "\\iiint");
N(B, V, Mr, "∏", "\\prod");
N(B, V, Mr, "∑", "\\sum");
N(B, V, Mr, "⨂", "\\bigotimes");
N(B, V, Mr, "⨁", "\\bigoplus");
N(B, V, Mr, "⨀", "\\bigodot");
N(B, V, Mr, "∮", "\\oint");
N(B, V, Mr, "∯", "\\oiint");
N(B, V, Mr, "∰", "\\oiiint");
N(B, V, Mr, "⨆", "\\bigsqcup");
N(B, V, Mr, "∫", "\\smallint");
N(He, V, yd, "…", "\\textellipsis");
N(B, V, yd, "…", "\\mathellipsis");
N(He, V, yd, "…", "\\ldots", !0);
N(B, V, yd, "…", "\\ldots", !0);
N(B, V, yd, "⋯", "\\@cdots", !0);
N(B, V, yd, "⋱", "\\ddots", !0);
N(B, V, me, "⋮", "\\varvdots");
N(B, V, Kn, "ˊ", "\\acute");
N(B, V, Kn, "ˋ", "\\grave");
N(B, V, Kn, "¨", "\\ddot");
N(B, V, Kn, "~", "\\tilde");
N(B, V, Kn, "ˉ", "\\bar");
N(B, V, Kn, "˘", "\\breve");
N(B, V, Kn, "ˇ", "\\check");
N(B, V, Kn, "^", "\\hat");
N(B, V, Kn, "⃗", "\\vec");
N(B, V, Kn, "˙", "\\dot");
N(B, V, Kn, "˚", "\\mathring");
N(B, V, Ot, "", "\\@imath");
N(B, V, Ot, "", "\\@jmath");
N(B, V, me, "ı", "ı");
N(B, V, me, "ȷ", "ȷ");
N(He, V, me, "ı", "\\i", !0);
N(He, V, me, "ȷ", "\\j", !0);
N(He, V, me, "ß", "\\ss", !0);
N(He, V, me, "æ", "\\ae", !0);
N(He, V, me, "œ", "\\oe", !0);
N(He, V, me, "ø", "\\o", !0);
N(He, V, me, "Æ", "\\AE", !0);
N(He, V, me, "Œ", "\\OE", !0);
N(He, V, me, "Ø", "\\O", !0);
N(He, V, Kn, "ˊ", "\\'");
N(He, V, Kn, "ˋ", "\\`");
N(He, V, Kn, "ˆ", "\\^");
N(He, V, Kn, "˜", "\\~");
N(He, V, Kn, "ˉ", "\\=");
N(He, V, Kn, "˘", "\\u");
N(He, V, Kn, "˙", "\\.");
N(He, V, Kn, "¸", "\\c");
N(He, V, Kn, "˚", "\\r");
N(He, V, Kn, "ˇ", "\\v");
N(He, V, Kn, "¨", '\\"');
N(He, V, Kn, "˝", "\\H");
N(He, V, Kn, "◯", "\\textcircled");
var qz = {
  "--": !0,
  "---": !0,
  "``": !0,
  "''": !0
};
N(He, V, me, "–", "--", !0);
N(He, V, me, "–", "\\textendash");
N(He, V, me, "—", "---", !0);
N(He, V, me, "—", "\\textemdash");
N(He, V, me, "‘", "`", !0);
N(He, V, me, "‘", "\\textquoteleft");
N(He, V, me, "’", "'", !0);
N(He, V, me, "’", "\\textquoteright");
N(He, V, me, "“", "``", !0);
N(He, V, me, "“", "\\textquotedblleft");
N(He, V, me, "”", "''", !0);
N(He, V, me, "”", "\\textquotedblright");
N(B, V, me, "°", "\\degree", !0);
N(He, V, me, "°", "\\degree");
N(He, V, me, "°", "\\textdegree", !0);
N(B, V, me, "£", "\\pounds");
N(B, V, me, "£", "\\mathsterling", !0);
N(He, V, me, "£", "\\pounds");
N(He, V, me, "£", "\\textsterling", !0);
N(B, J, me, "✠", "\\maltese");
N(He, J, me, "✠", "\\maltese");
var f9 = '0123456789/@."';
for (var J4 = 0; J4 < f9.length; J4++) {
  var h9 = f9.charAt(J4);
  N(B, V, me, h9, h9);
}
var m9 = '0123456789!@*()-=+";:?/.,';
for (var e3 = 0; e3 < m9.length; e3++) {
  var g9 = m9.charAt(e3);
  N(He, V, me, g9, g9);
}
var Um = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
for (var t3 = 0; t3 < Um.length; t3++) {
  var Gh = Um.charAt(t3);
  N(B, V, Ot, Gh, Gh), N(He, V, me, Gh, Gh);
}
N(B, J, me, "C", "ℂ");
N(He, J, me, "C", "ℂ");
N(B, J, me, "H", "ℍ");
N(He, J, me, "H", "ℍ");
N(B, J, me, "N", "ℕ");
N(He, J, me, "N", "ℕ");
N(B, J, me, "P", "ℙ");
N(He, J, me, "P", "ℙ");
N(B, J, me, "Q", "ℚ");
N(He, J, me, "Q", "ℚ");
N(B, J, me, "R", "ℝ");
N(He, J, me, "R", "ℝ");
N(B, J, me, "Z", "ℤ");
N(He, J, me, "Z", "ℤ");
N(B, V, Ot, "h", "ℎ");
N(He, V, Ot, "h", "ℎ");
var It = "";
for (var Si = 0; Si < Um.length; Si++) {
  var hr = Um.charAt(Si);
  It = String.fromCharCode(55349, 56320 + Si), N(B, V, Ot, hr, It), N(He, V, me, hr, It), It = String.fromCharCode(55349, 56372 + Si), N(B, V, Ot, hr, It), N(He, V, me, hr, It), It = String.fromCharCode(55349, 56424 + Si), N(B, V, Ot, hr, It), N(He, V, me, hr, It), It = String.fromCharCode(55349, 56580 + Si), N(B, V, Ot, hr, It), N(He, V, me, hr, It), It = String.fromCharCode(55349, 56684 + Si), N(B, V, Ot, hr, It), N(He, V, me, hr, It), It = String.fromCharCode(55349, 56736 + Si), N(B, V, Ot, hr, It), N(He, V, me, hr, It), It = String.fromCharCode(55349, 56788 + Si), N(B, V, Ot, hr, It), N(He, V, me, hr, It), It = String.fromCharCode(55349, 56840 + Si), N(B, V, Ot, hr, It), N(He, V, me, hr, It), It = String.fromCharCode(55349, 56944 + Si), N(B, V, Ot, hr, It), N(He, V, me, hr, It), Si < 26 && (It = String.fromCharCode(55349, 56632 + Si), N(B, V, Ot, hr, It), N(He, V, me, hr, It), It = String.fromCharCode(55349, 56476 + Si), N(B, V, Ot, hr, It), N(He, V, me, hr, It));
}
It = "𝕜";
N(B, V, Ot, "k", It);
N(He, V, me, "k", It);
for (var Zu = 0; Zu < 10; Zu++) {
  var Ol = Zu.toString();
  It = String.fromCharCode(55349, 57294 + Zu), N(B, V, Ot, Ol, It), N(He, V, me, Ol, It), It = String.fromCharCode(55349, 57314 + Zu), N(B, V, Ot, Ol, It), N(He, V, me, Ol, It), It = String.fromCharCode(55349, 57324 + Zu), N(B, V, Ot, Ol, It), N(He, V, me, Ol, It), It = String.fromCharCode(55349, 57334 + Zu), N(B, V, Ot, Ol, It), N(He, V, me, Ol, It);
}
var F5 = "ÐÞþ";
for (var n3 = 0; n3 < F5.length; n3++) {
  var Kh = F5.charAt(n3);
  N(B, V, Ot, Kh, Kh), N(He, V, me, Kh, Kh);
}
var Xh = [
  ["mathbf", "textbf", "Main-Bold"],
  // A-Z bold upright
  ["mathbf", "textbf", "Main-Bold"],
  // a-z bold upright
  ["mathnormal", "textit", "Math-Italic"],
  // A-Z italic
  ["mathnormal", "textit", "Math-Italic"],
  // a-z italic
  ["boldsymbol", "boldsymbol", "Main-BoldItalic"],
  // A-Z bold italic
  ["boldsymbol", "boldsymbol", "Main-BoldItalic"],
  // a-z bold italic
  // Map fancy A-Z letters to script, not calligraphic.
  // This aligns with unicode-math and math fonts (except Cambria Math).
  ["mathscr", "textscr", "Script-Regular"],
  // A-Z script
  ["", "", ""],
  // a-z script.  No font
  ["", "", ""],
  // A-Z bold script. No font
  ["", "", ""],
  // a-z bold script. No font
  ["mathfrak", "textfrak", "Fraktur-Regular"],
  // A-Z Fraktur
  ["mathfrak", "textfrak", "Fraktur-Regular"],
  // a-z Fraktur
  ["mathbb", "textbb", "AMS-Regular"],
  // A-Z double-struck
  ["mathbb", "textbb", "AMS-Regular"],
  // k double-struck
  // Note that we are using a bold font, but font metrics for regular Fraktur.
  ["mathboldfrak", "textboldfrak", "Fraktur-Regular"],
  // A-Z bold Fraktur
  ["mathboldfrak", "textboldfrak", "Fraktur-Regular"],
  // a-z bold Fraktur
  ["mathsf", "textsf", "SansSerif-Regular"],
  // A-Z sans-serif
  ["mathsf", "textsf", "SansSerif-Regular"],
  // a-z sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // A-Z bold sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // a-z bold sans-serif
  ["mathitsf", "textitsf", "SansSerif-Italic"],
  // A-Z italic sans-serif
  ["mathitsf", "textitsf", "SansSerif-Italic"],
  // a-z italic sans-serif
  ["", "", ""],
  // A-Z bold italic sans. No font
  ["", "", ""],
  // a-z bold italic sans. No font
  ["mathtt", "texttt", "Typewriter-Regular"],
  // A-Z monospace
  ["mathtt", "texttt", "Typewriter-Regular"]
  // a-z monospace
], v9 = [
  ["mathbf", "textbf", "Main-Bold"],
  // 0-9 bold
  ["", "", ""],
  // 0-9 double-struck. No KaTeX font.
  ["mathsf", "textsf", "SansSerif-Regular"],
  // 0-9 sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // 0-9 bold sans-serif
  ["mathtt", "texttt", "Typewriter-Regular"]
  // 0-9 monospace
], Fse = function(e, t) {
  var n = e.charCodeAt(0), r = e.charCodeAt(1), i = (n - 55296) * 1024 + (r - 56320) + 65536, o = t === "math" ? 0 : 1;
  if (119808 <= i && i < 120484) {
    var a = Math.floor((i - 119808) / 26);
    return [Xh[a][2], Xh[a][o]];
  } else if (120782 <= i && i <= 120831) {
    var s = Math.floor((i - 120782) / 10);
    return [v9[s][2], v9[s][o]];
  } else {
    if (i === 120485 || i === 120486)
      return [Xh[0][2], Xh[0][o]];
    if (120486 < i && i < 120782)
      return ["", ""];
    throw new Ye("Unsupported character: " + e);
  }
}, y2 = function(e, t, n) {
  return Bn[n][e] && Bn[n][e].replace && (e = Bn[n][e].replace), {
    value: e,
    metrics: Ay(e, t, n)
  };
}, Fa = function(e, t, n, r, i) {
  var o = y2(e, t, n), a = o.metrics;
  e = o.value;
  var s;
  if (a) {
    var l = a.italic;
    (n === "text" || r && r.font === "mathit") && (l = 0), s = new ma(e, a.height, a.depth, l, a.skew, a.width, i);
  } else
    typeof console < "u" && console.warn("No character metrics " + ("for '" + e + "' in style '" + t + "' and mode '" + n + "'")), s = new ma(e, 0, 0, 0, 0, 0, i);
  if (r) {
    s.maxFontSize = r.sizeMultiplier, r.style.isTight() && s.classes.push("mtight");
    var u = r.getColor();
    u && (s.style.color = u);
  }
  return s;
}, Lse = function(e, t, n, r) {
  return r === void 0 && (r = []), n.font === "boldsymbol" && y2(e, "Main-Bold", t).metrics ? Fa(e, "Main-Bold", t, n, r.concat(["mathbf"])) : e === "\\" || Bn[t][e].font === "main" ? Fa(e, "Main-Regular", t, n, r) : Fa(e, "AMS-Regular", t, n, r.concat(["amsrm"]));
}, Mse = function(e, t, n, r, i) {
  return i !== "textord" && y2(e, "Math-BoldItalic", t).metrics ? {
    fontName: "Math-BoldItalic",
    fontClass: "boldsymbol"
  } : {
    fontName: "Main-Bold",
    fontClass: "mathbf"
  };
}, Bse = function(e, t, n) {
  var r = e.mode, i = e.text, o = ["mord"], a = r === "math" || r === "text" && t.font, s = a ? t.font : t.fontFamily, l = "", u = "";
  if (i.charCodeAt(0) === 55349 && ([l, u] = Fse(i, r)), l.length > 0)
    return Fa(i, l, r, t, o.concat(u));
  if (s) {
    var d, p;
    if (s === "boldsymbol") {
      var f = Mse(i, r, t, o, n);
      d = f.fontName, p = [f.fontClass];
    } else a ? (d = Vz[s].fontName, p = [s]) : (d = Qh(s, t.fontWeight, t.fontShape), p = [s, t.fontWeight, t.fontShape]);
    if (y2(i, d, r).metrics)
      return Fa(i, d, r, t, o.concat(p));
    if (qz.hasOwnProperty(i) && d.slice(0, 10) === "Typewriter") {
      for (var m = [], y = 0; y < i.length; y++)
        m.push(Fa(i[y], d, r, t, o.concat(p)));
      return Hz(m);
    }
  }
  if (n === "mathord")
    return Fa(i, "Math-Italic", r, t, o.concat(["mathnormal"]));
  if (n === "textord") {
    var g = Bn[r][i] && Bn[r][i].font;
    if (g === "ams") {
      var x = Qh("amsrm", t.fontWeight, t.fontShape);
      return Fa(i, x, r, t, o.concat("amsrm", t.fontWeight, t.fontShape));
    } else if (g === "main" || !g) {
      var E = Qh("textrm", t.fontWeight, t.fontShape);
      return Fa(i, E, r, t, o.concat(t.fontWeight, t.fontShape));
    } else {
      var b = Qh(g, t.fontWeight, t.fontShape);
      return Fa(i, b, r, t, o.concat(b, t.fontWeight, t.fontShape));
    }
  } else
    throw new Error("unexpected type: " + n + " in makeOrd");
}, Ise = (e, t) => {
  if (yu(e.classes) !== yu(t.classes) || e.skew !== t.skew || e.maxFontSize !== t.maxFontSize)
    return !1;
  if (e.classes.length === 1) {
    var n = e.classes[0];
    if (n === "mbin" || n === "mord")
      return !1;
  }
  for (var r in e.style)
    if (e.style.hasOwnProperty(r) && e.style[r] !== t.style[r])
      return !1;
  for (var i in t.style)
    if (t.style.hasOwnProperty(i) && e.style[i] !== t.style[i])
      return !1;
  return !0;
}, Rse = (e) => {
  for (var t = 0; t < e.length - 1; t++) {
    var n = e[t], r = e[t + 1];
    n instanceof ma && r instanceof ma && Ise(n, r) && (n.text += r.text, n.height = Math.max(n.height, r.height), n.depth = Math.max(n.depth, r.depth), n.italic = r.italic, e.splice(t + 1, 1), t--);
  }
  return e;
}, jy = function(e) {
  for (var t = 0, n = 0, r = 0, i = 0; i < e.children.length; i++) {
    var o = e.children[i];
    o.height > t && (t = o.height), o.depth > n && (n = o.depth), o.maxFontSize > r && (r = o.maxFontSize);
  }
  e.height = t, e.depth = n, e.maxFontSize = r;
}, Gi = function(e, t, n, r) {
  var i = new Hf(e, t, n, r);
  return jy(i), i;
}, $z = (e, t, n, r) => new Hf(e, t, n, r), Pse = function(e, t, n) {
  var r = Gi([e], [], t);
  return r.height = Math.max(n || t.fontMetrics().defaultRuleThickness, t.minRuleThickness), r.style.borderBottomWidth = it(r.height), r.maxFontSize = 1, r;
}, _se = function(e, t, n, r) {
  var i = new Ty(e, t, n, r);
  return jy(i), i;
}, Hz = function(e) {
  var t = new $f(e);
  return jy(t), t;
}, qse = function(e, t) {
  return e instanceof $f ? Gi([], [e], t) : e;
}, $se = function(e) {
  if (e.positionType === "individualShift") {
    for (var t = e.children, n = [t[0]], r = -t[0].shift - t[0].elem.depth, i = r, o = 1; o < t.length; o++) {
      var a = -t[o].shift - i - t[o].elem.depth, s = a - (t[o - 1].elem.height + t[o - 1].elem.depth);
      i = i + a, n.push({
        type: "kern",
        size: s
      }), n.push(t[o]);
    }
    return {
      children: n,
      depth: r
    };
  }
  var l;
  if (e.positionType === "top") {
    for (var u = e.positionData, d = 0; d < e.children.length; d++) {
      var p = e.children[d];
      u -= p.type === "kern" ? p.size : p.elem.height + p.elem.depth;
    }
    l = u;
  } else if (e.positionType === "bottom")
    l = -e.positionData;
  else {
    var f = e.children[0];
    if (f.type !== "elem")
      throw new Error('First child must have type "elem".');
    if (e.positionType === "shift")
      l = -f.elem.depth - e.positionData;
    else if (e.positionType === "firstBaseline")
      l = -f.elem.depth;
    else
      throw new Error("Invalid positionType " + e.positionType + ".");
  }
  return {
    children: e.children,
    depth: l
  };
}, Hse = function(e, t) {
  for (var {
    children: n,
    depth: r
  } = $se(e), i = 0, o = 0; o < n.length; o++) {
    var a = n[o];
    if (a.type === "elem") {
      var s = a.elem;
      i = Math.max(i, s.maxFontSize, s.height);
    }
  }
  i += 2;
  var l = Gi(["pstrut"], []);
  l.style.height = it(i);
  for (var u = [], d = r, p = r, f = r, m = 0; m < n.length; m++) {
    var y = n[m];
    if (y.type === "kern")
      f += y.size;
    else {
      var g = y.elem, x = y.wrapperClasses || [], E = y.wrapperStyle || {}, b = Gi(x, [l, g], void 0, E);
      b.style.top = it(-i - f - g.depth), y.marginLeft && (b.style.marginLeft = y.marginLeft), y.marginRight && (b.style.marginRight = y.marginRight), u.push(b), f += g.height + g.depth;
    }
    d = Math.min(d, f), p = Math.max(p, f);
  }
  var C = Gi(["vlist"], u);
  C.style.height = it(p);
  var T;
  if (d < 0) {
    var z = Gi([], []), I = Gi(["vlist"], [z]);
    I.style.height = it(-d);
    var w = Gi(["vlist-s"], [new ma("​")]);
    T = [Gi(["vlist-r"], [C, w]), Gi(["vlist-r"], [I])];
  } else
    T = [Gi(["vlist-r"], [C])];
  var M = Gi(["vlist-t"], T);
  return T.length === 2 && M.classes.push("vlist-t2"), M.height = p, M.depth = -d, M;
}, Vse = (e, t) => {
  var n = Gi(["mspace"], [], t), r = cr(e, t);
  return n.style.marginRight = it(r), n;
}, Qh = function(e, t, n) {
  var r = "";
  switch (e) {
    case "amsrm":
      r = "AMS";
      break;
    case "textrm":
      r = "Main";
      break;
    case "textsf":
      r = "SansSerif";
      break;
    case "texttt":
      r = "Typewriter";
      break;
    default:
      r = e;
  }
  var i;
  return t === "textbf" && n === "textit" ? i = "BoldItalic" : t === "textbf" ? i = "Bold" : t === "textit" ? i = "Italic" : i = "Regular", r + "-" + i;
}, Vz = {
  // styles
  mathbf: {
    variant: "bold",
    fontName: "Main-Bold"
  },
  mathrm: {
    variant: "normal",
    fontName: "Main-Regular"
  },
  textit: {
    variant: "italic",
    fontName: "Main-Italic"
  },
  mathit: {
    variant: "italic",
    fontName: "Main-Italic"
  },
  mathnormal: {
    variant: "italic",
    fontName: "Math-Italic"
  },
  // "boldsymbol" is missing because they require the use of multiple fonts:
  // Math-BoldItalic and Main-Bold.  This is handled by a special case in
  // makeOrd which ends up calling boldsymbol.
  // families
  mathbb: {
    variant: "double-struck",
    fontName: "AMS-Regular"
  },
  mathcal: {
    variant: "script",
    fontName: "Caligraphic-Regular"
  },
  mathfrak: {
    variant: "fraktur",
    fontName: "Fraktur-Regular"
  },
  mathscr: {
    variant: "script",
    fontName: "Script-Regular"
  },
  mathsf: {
    variant: "sans-serif",
    fontName: "SansSerif-Regular"
  },
  mathtt: {
    variant: "monospace",
    fontName: "Typewriter-Regular"
  }
}, Uz = {
  //   path, width, height
  vec: ["vec", 0.471, 0.714],
  // values from the font glyph
  oiintSize1: ["oiintSize1", 0.957, 0.499],
  // oval to overlay the integrand
  oiintSize2: ["oiintSize2", 1.472, 0.659],
  oiiintSize1: ["oiiintSize1", 1.304, 0.499],
  oiiintSize2: ["oiiintSize2", 1.98, 0.659]
}, Use = function(e, t) {
  var [n, r, i] = Uz[e], o = new xu(n), a = new dl([o], {
    width: it(r),
    height: it(i),
    // Override CSS rule `.katex svg { width: 100% }`
    style: "width:" + it(r),
    viewBox: "0 0 " + 1e3 * r + " " + 1e3 * i,
    preserveAspectRatio: "xMinYMin"
  }), s = $z(["overlay"], [a], t);
  return s.height = i, s.style.height = it(i), s.style.width = it(r), s;
}, Ee = {
  fontMap: Vz,
  makeSymbol: Fa,
  mathsym: Lse,
  makeSpan: Gi,
  makeSvgSpan: $z,
  makeLineSpan: Pse,
  makeAnchor: _se,
  makeFragment: Hz,
  wrapFragment: qse,
  makeVList: Hse,
  makeOrd: Bse,
  makeGlue: Vse,
  staticSvg: Use,
  svgData: Uz,
  tryCombineChars: Rse
}, sr = {
  number: 3,
  unit: "mu"
}, Gu = {
  number: 4,
  unit: "mu"
}, Ls = {
  number: 5,
  unit: "mu"
}, Wse = {
  mord: {
    mop: sr,
    mbin: Gu,
    mrel: Ls,
    minner: sr
  },
  mop: {
    mord: sr,
    mop: sr,
    mrel: Ls,
    minner: sr
  },
  mbin: {
    mord: Gu,
    mop: Gu,
    mopen: Gu,
    minner: Gu
  },
  mrel: {
    mord: Ls,
    mop: Ls,
    mopen: Ls,
    minner: Ls
  },
  mopen: {},
  mclose: {
    mop: sr,
    mbin: Gu,
    mrel: Ls,
    minner: sr
  },
  mpunct: {
    mord: sr,
    mop: sr,
    mrel: Ls,
    mopen: sr,
    mclose: sr,
    mpunct: sr,
    minner: sr
  },
  minner: {
    mord: sr,
    mop: sr,
    mbin: Gu,
    mrel: Ls,
    mopen: sr,
    mpunct: sr,
    minner: sr
  }
}, Zse = {
  mord: {
    mop: sr
  },
  mop: {
    mord: sr,
    mop: sr
  },
  mbin: {},
  mrel: {},
  mopen: {},
  mclose: {
    mop: sr
  },
  mpunct: {},
  minner: {
    mop: sr
  }
}, Wz = {}, Wm = {}, Zm = {};
function ht(e) {
  for (var {
    type: t,
    names: n,
    props: r,
    handler: i,
    htmlBuilder: o,
    mathmlBuilder: a
  } = e, s = {
    type: t,
    numArgs: r.numArgs,
    argTypes: r.argTypes,
    allowedInArgument: !!r.allowedInArgument,
    allowedInText: !!r.allowedInText,
    allowedInMath: r.allowedInMath === void 0 ? !0 : r.allowedInMath,
    numOptionalArgs: r.numOptionalArgs || 0,
    infix: !!r.infix,
    primitive: !!r.primitive,
    handler: i
  }, l = 0; l < n.length; ++l)
    Wz[n[l]] = s;
  t && (o && (Wm[t] = o), a && (Zm[t] = a));
}
function Pc(e) {
  var {
    type: t,
    htmlBuilder: n,
    mathmlBuilder: r
  } = e;
  ht({
    type: t,
    names: [],
    props: {
      numArgs: 0
    },
    handler() {
      throw new Error("Should never be called.");
    },
    htmlBuilder: n,
    mathmlBuilder: r
  });
}
var Gm = function(e) {
  return e.type === "ordgroup" && e.body.length === 1 ? e.body[0] : e;
}, Sr = function(e) {
  return e.type === "ordgroup" ? e.body : [e];
}, pl = Ee.makeSpan, Gse = ["leftmost", "mbin", "mopen", "mrel", "mop", "mpunct"], Kse = ["rightmost", "mrel", "mclose", "mpunct"], Xse = {
  display: zt.DISPLAY,
  text: zt.TEXT,
  script: zt.SCRIPT,
  scriptscript: zt.SCRIPTSCRIPT
}, Qse = {
  mord: "mord",
  mop: "mop",
  mbin: "mbin",
  mrel: "mrel",
  mopen: "mopen",
  mclose: "mclose",
  mpunct: "mpunct",
  minner: "minner"
}, Hr = function(e, t, n, r) {
  r === void 0 && (r = [null, null]);
  for (var i = [], o = 0; o < e.length; o++) {
    var a = pn(e[o], t);
    if (a instanceof $f) {
      var s = a.children;
      i.push(...s);
    } else
      i.push(a);
  }
  if (Ee.tryCombineChars(i), !n)
    return i;
  var l = t;
  if (e.length === 1) {
    var u = e[0];
    u.type === "sizing" ? l = t.havingSize(u.size) : u.type === "styling" && (l = t.havingStyle(Xse[u.style]));
  }
  var d = pl([r[0] || "leftmost"], [], t), p = pl([r[1] || "rightmost"], [], t), f = n === "root";
  return y9(i, (m, y) => {
    var g = y.classes[0], x = m.classes[0];
    g === "mbin" && Nt.contains(Kse, x) ? y.classes[0] = "mord" : x === "mbin" && Nt.contains(Gse, g) && (m.classes[0] = "mord");
  }, {
    node: d
  }, p, f), y9(i, (m, y) => {
    var g = L5(y), x = L5(m), E = g && x ? m.hasClass("mtight") ? Zse[g][x] : Wse[g][x] : null;
    if (E)
      return Ee.makeGlue(E, l);
  }, {
    node: d
  }, p, f), i;
}, y9 = function e(t, n, r, i, o) {
  i && t.push(i);
  for (var a = 0; a < t.length; a++) {
    var s = t[a], l = Zz(s);
    if (l) {
      e(l.children, n, r, null, o);
      continue;
    }
    var u = !s.hasClass("mspace");
    if (u) {
      var d = n(s, r.node);
      d && (r.insertAfter ? r.insertAfter(d) : (t.unshift(d), a++));
    }
    u ? r.node = s : o && s.hasClass("newline") && (r.node = pl(["leftmost"])), r.insertAfter = /* @__PURE__ */ ((p) => (f) => {
      t.splice(p + 1, 0, f), a++;
    })(a);
  }
  i && t.pop();
}, Zz = function(e) {
  return e instanceof $f || e instanceof Ty || e instanceof Hf && e.hasClass("enclosing") ? e : null;
}, Yse = function e(t, n) {
  var r = Zz(t);
  if (r) {
    var i = r.children;
    if (i.length) {
      if (n === "right")
        return e(i[i.length - 1], "right");
      if (n === "left")
        return e(i[0], "left");
    }
  }
  return t;
}, L5 = function(e, t) {
  return e ? (t && (e = Yse(e, t)), Qse[e.classes[0]] || null) : null;
}, lf = function(e, t) {
  var n = ["nulldelimiter"].concat(e.baseSizingClasses());
  return pl(t.concat(n));
}, pn = function(e, t, n) {
  if (!e)
    return pl();
  if (Wm[e.type]) {
    var r = Wm[e.type](e, t);
    if (n && t.size !== n.size) {
      r = pl(t.sizingClasses(n), [r], t);
      var i = t.sizeMultiplier / n.sizeMultiplier;
      r.height *= i, r.depth *= i;
    }
    return r;
  } else
    throw new Ye("Got group of unknown type: '" + e.type + "'");
};
function Yh(e, t) {
  var n = pl(["base"], e, t), r = pl(["strut"]);
  return r.style.height = it(n.height + n.depth), n.depth && (r.style.verticalAlign = it(-n.depth)), n.children.unshift(r), n;
}
function M5(e, t) {
  var n = null;
  e.length === 1 && e[0].type === "tag" && (n = e[0].tag, e = e[0].body);
  var r = Hr(e, t, "root"), i;
  r.length === 2 && r[1].hasClass("tag") && (i = r.pop());
  for (var o = [], a = [], s = 0; s < r.length; s++)
    if (a.push(r[s]), r[s].hasClass("mbin") || r[s].hasClass("mrel") || r[s].hasClass("allowbreak")) {
      for (var l = !1; s < r.length - 1 && r[s + 1].hasClass("mspace") && !r[s + 1].hasClass("newline"); )
        s++, a.push(r[s]), r[s].hasClass("nobreak") && (l = !0);
      l || (o.push(Yh(a, t)), a = []);
    } else r[s].hasClass("newline") && (a.pop(), a.length > 0 && (o.push(Yh(a, t)), a = []), o.push(r[s]));
  a.length > 0 && o.push(Yh(a, t));
  var u;
  n ? (u = Yh(Hr(n, t, !0)), u.classes = ["tag"], o.push(u)) : i && o.push(i);
  var d = pl(["katex-html"], o);
  if (d.setAttribute("aria-hidden", "true"), u) {
    var p = u.children[0];
    p.style.height = it(d.height + d.depth), d.depth && (p.style.verticalAlign = it(-d.depth));
  }
  return d;
}
function Gz(e) {
  return new $f(e);
}
class na {
  constructor(t, n, r) {
    this.type = void 0, this.attributes = void 0, this.children = void 0, this.classes = void 0, this.type = t, this.attributes = {}, this.children = n || [], this.classes = r || [];
  }
  /**
   * Sets an attribute on a MathML node. MathML depends on attributes to convey a
   * semantic content, so this is used heavily.
   */
  setAttribute(t, n) {
    this.attributes[t] = n;
  }
  /**
   * Gets an attribute on a MathML node.
   */
  getAttribute(t) {
    return this.attributes[t];
  }
  /**
   * Converts the math node into a MathML-namespaced DOM element.
   */
  toNode() {
    var t = document.createElementNS("http://www.w3.org/1998/Math/MathML", this.type);
    for (var n in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, n) && t.setAttribute(n, this.attributes[n]);
    this.classes.length > 0 && (t.className = yu(this.classes));
    for (var r = 0; r < this.children.length; r++)
      t.appendChild(this.children[r].toNode());
    return t;
  }
  /**
   * Converts the math node into an HTML markup string.
   */
  toMarkup() {
    var t = "<" + this.type;
    for (var n in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, n) && (t += " " + n + '="', t += Nt.escape(this.attributes[n]), t += '"');
    this.classes.length > 0 && (t += ' class ="' + Nt.escape(yu(this.classes)) + '"'), t += ">";
    for (var r = 0; r < this.children.length; r++)
      t += this.children[r].toMarkup();
    return t += "</" + this.type + ">", t;
  }
  /**
   * Converts the math node into a string, similar to innerText, but escaped.
   */
  toText() {
    return this.children.map((t) => t.toText()).join("");
  }
}
class kp {
  constructor(t) {
    this.text = void 0, this.text = t;
  }
  /**
   * Converts the text node into a DOM text node.
   */
  toNode() {
    return document.createTextNode(this.text);
  }
  /**
   * Converts the text node into escaped HTML markup
   * (representing the text itself).
   */
  toMarkup() {
    return Nt.escape(this.toText());
  }
  /**
   * Converts the text node into a string
   * (representing the text itself).
   */
  toText() {
    return this.text;
  }
}
class Jse {
  /**
   * Create a Space node with width given in CSS ems.
   */
  constructor(t) {
    this.width = void 0, this.character = void 0, this.width = t, t >= 0.05555 && t <= 0.05556 ? this.character = " " : t >= 0.1666 && t <= 0.1667 ? this.character = " " : t >= 0.2222 && t <= 0.2223 ? this.character = " " : t >= 0.2777 && t <= 0.2778 ? this.character = "  " : t >= -0.05556 && t <= -0.05555 ? this.character = " ⁣" : t >= -0.1667 && t <= -0.1666 ? this.character = " ⁣" : t >= -0.2223 && t <= -0.2222 ? this.character = " ⁣" : t >= -0.2778 && t <= -0.2777 ? this.character = " ⁣" : this.character = null;
  }
  /**
   * Converts the math node into a MathML-namespaced DOM element.
   */
  toNode() {
    if (this.character)
      return document.createTextNode(this.character);
    var t = document.createElementNS("http://www.w3.org/1998/Math/MathML", "mspace");
    return t.setAttribute("width", it(this.width)), t;
  }
  /**
   * Converts the math node into an HTML markup string.
   */
  toMarkup() {
    return this.character ? "<mtext>" + this.character + "</mtext>" : '<mspace width="' + it(this.width) + '"/>';
  }
  /**
   * Converts the math node into a string, similar to innerText.
   */
  toText() {
    return this.character ? this.character : " ";
  }
}
var Ge = {
  MathNode: na,
  TextNode: kp,
  SpaceNode: Jse,
  newDocumentFragment: Gz
}, ga = function(e, t, n) {
  return Bn[t][e] && Bn[t][e].replace && e.charCodeAt(0) !== 55349 && !(qz.hasOwnProperty(e) && n && (n.fontFamily && n.fontFamily.slice(4, 6) === "tt" || n.font && n.font.slice(4, 6) === "tt")) && (e = Bn[t][e].replace), new Ge.TextNode(e);
}, Ny = function(e) {
  return e.length === 1 ? e[0] : new Ge.MathNode("mrow", e);
}, Oy = function(e, t) {
  if (t.fontFamily === "texttt")
    return "monospace";
  if (t.fontFamily === "textsf")
    return t.fontShape === "textit" && t.fontWeight === "textbf" ? "sans-serif-bold-italic" : t.fontShape === "textit" ? "sans-serif-italic" : t.fontWeight === "textbf" ? "bold-sans-serif" : "sans-serif";
  if (t.fontShape === "textit" && t.fontWeight === "textbf")
    return "bold-italic";
  if (t.fontShape === "textit")
    return "italic";
  if (t.fontWeight === "textbf")
    return "bold";
  var n = t.font;
  if (!n || n === "mathnormal")
    return null;
  var r = e.mode;
  if (n === "mathit")
    return "italic";
  if (n === "boldsymbol")
    return e.type === "textord" ? "bold" : "bold-italic";
  if (n === "mathbf")
    return "bold";
  if (n === "mathbb")
    return "double-struck";
  if (n === "mathfrak")
    return "fraktur";
  if (n === "mathscr" || n === "mathcal")
    return "script";
  if (n === "mathsf")
    return "sans-serif";
  if (n === "mathtt")
    return "monospace";
  var i = e.text;
  if (Nt.contains(["\\imath", "\\jmath"], i))
    return null;
  Bn[r][i] && Bn[r][i].replace && (i = Bn[r][i].replace);
  var o = Ee.fontMap[n].fontName;
  return Ay(i, o, r) ? Ee.fontMap[n].variant : null;
}, lo = function(e, t, n) {
  if (e.length === 1) {
    var r = On(e[0], t);
    return n && r instanceof na && r.type === "mo" && (r.setAttribute("lspace", "0em"), r.setAttribute("rspace", "0em")), [r];
  }
  for (var i = [], o, a = 0; a < e.length; a++) {
    var s = On(e[a], t);
    if (s instanceof na && o instanceof na) {
      if (s.type === "mtext" && o.type === "mtext" && s.getAttribute("mathvariant") === o.getAttribute("mathvariant")) {
        o.children.push(...s.children);
        continue;
      } else if (s.type === "mn" && o.type === "mn") {
        o.children.push(...s.children);
        continue;
      } else if (s.type === "mi" && s.children.length === 1 && o.type === "mn") {
        var l = s.children[0];
        if (l instanceof kp && l.text === ".") {
          o.children.push(...s.children);
          continue;
        }
      } else if (o.type === "mi" && o.children.length === 1) {
        var u = o.children[0];
        if (u instanceof kp && u.text === "̸" && (s.type === "mo" || s.type === "mi" || s.type === "mn")) {
          var d = s.children[0];
          d instanceof kp && d.text.length > 0 && (d.text = d.text.slice(0, 1) + "̸" + d.text.slice(1), i.pop());
        }
      }
    }
    i.push(s), o = s;
  }
  return i;
}, bu = function(e, t, n) {
  return Ny(lo(e, t, n));
}, On = function(e, t) {
  if (!e)
    return new Ge.MathNode("mrow");
  if (Zm[e.type]) {
    var n = Zm[e.type](e, t);
    return n;
  } else
    throw new Ye("Got group of unknown type: '" + e.type + "'");
};
function x9(e, t, n, r, i) {
  var o = lo(e, n), a;
  o.length === 1 && o[0] instanceof na && Nt.contains(["mrow", "mtable"], o[0].type) ? a = o[0] : a = new Ge.MathNode("mrow", o);
  var s = new Ge.MathNode("annotation", [new Ge.TextNode(t)]);
  s.setAttribute("encoding", "application/x-tex");
  var l = new Ge.MathNode("semantics", [a, s]), u = new Ge.MathNode("math", [l]);
  u.setAttribute("xmlns", "http://www.w3.org/1998/Math/MathML"), r && u.setAttribute("display", "block");
  var d = i ? "katex" : "katex-mathml";
  return Ee.makeSpan([d], [u]);
}
var Kz = function(e) {
  return new Ps({
    style: e.displayMode ? zt.DISPLAY : zt.TEXT,
    maxSize: e.maxSize,
    minRuleThickness: e.minRuleThickness
  });
}, Xz = function(e, t) {
  if (t.displayMode) {
    var n = ["katex-display"];
    t.leqno && n.push("leqno"), t.fleqn && n.push("fleqn"), e = Ee.makeSpan(n, [e]);
  }
  return e;
}, ele = function(e, t, n) {
  var r = Kz(n), i;
  if (n.output === "mathml")
    return x9(e, t, r, n.displayMode, !0);
  if (n.output === "html") {
    var o = M5(e, r);
    i = Ee.makeSpan(["katex"], [o]);
  } else {
    var a = x9(e, t, r, n.displayMode, !1), s = M5(e, r);
    i = Ee.makeSpan(["katex"], [a, s]);
  }
  return Xz(i, n);
}, tle = function(e, t, n) {
  var r = Kz(n), i = M5(e, r), o = Ee.makeSpan(["katex"], [i]);
  return Xz(o, n);
}, nle = {
  widehat: "^",
  widecheck: "ˇ",
  widetilde: "~",
  utilde: "~",
  overleftarrow: "←",
  underleftarrow: "←",
  xleftarrow: "←",
  overrightarrow: "→",
  underrightarrow: "→",
  xrightarrow: "→",
  underbrace: "⏟",
  overbrace: "⏞",
  overgroup: "⏠",
  undergroup: "⏡",
  overleftrightarrow: "↔",
  underleftrightarrow: "↔",
  xleftrightarrow: "↔",
  Overrightarrow: "⇒",
  xRightarrow: "⇒",
  overleftharpoon: "↼",
  xleftharpoonup: "↼",
  overrightharpoon: "⇀",
  xrightharpoonup: "⇀",
  xLeftarrow: "⇐",
  xLeftrightarrow: "⇔",
  xhookleftarrow: "↩",
  xhookrightarrow: "↪",
  xmapsto: "↦",
  xrightharpoondown: "⇁",
  xleftharpoondown: "↽",
  xrightleftharpoons: "⇌",
  xleftrightharpoons: "⇋",
  xtwoheadleftarrow: "↞",
  xtwoheadrightarrow: "↠",
  xlongequal: "=",
  xtofrom: "⇄",
  xrightleftarrows: "⇄",
  xrightequilibrium: "⇌",
  // Not a perfect match.
  xleftequilibrium: "⇋",
  // None better available.
  "\\cdrightarrow": "→",
  "\\cdleftarrow": "←",
  "\\cdlongequal": "="
}, rle = function(e) {
  var t = new Ge.MathNode("mo", [new Ge.TextNode(nle[e.replace(/^\\/, "")])]);
  return t.setAttribute("stretchy", "true"), t;
}, ile = {
  //   path(s), minWidth, height, align
  overrightarrow: [["rightarrow"], 0.888, 522, "xMaxYMin"],
  overleftarrow: [["leftarrow"], 0.888, 522, "xMinYMin"],
  underrightarrow: [["rightarrow"], 0.888, 522, "xMaxYMin"],
  underleftarrow: [["leftarrow"], 0.888, 522, "xMinYMin"],
  xrightarrow: [["rightarrow"], 1.469, 522, "xMaxYMin"],
  "\\cdrightarrow": [["rightarrow"], 3, 522, "xMaxYMin"],
  // CD minwwidth2.5pc
  xleftarrow: [["leftarrow"], 1.469, 522, "xMinYMin"],
  "\\cdleftarrow": [["leftarrow"], 3, 522, "xMinYMin"],
  Overrightarrow: [["doublerightarrow"], 0.888, 560, "xMaxYMin"],
  xRightarrow: [["doublerightarrow"], 1.526, 560, "xMaxYMin"],
  xLeftarrow: [["doubleleftarrow"], 1.526, 560, "xMinYMin"],
  overleftharpoon: [["leftharpoon"], 0.888, 522, "xMinYMin"],
  xleftharpoonup: [["leftharpoon"], 0.888, 522, "xMinYMin"],
  xleftharpoondown: [["leftharpoondown"], 0.888, 522, "xMinYMin"],
  overrightharpoon: [["rightharpoon"], 0.888, 522, "xMaxYMin"],
  xrightharpoonup: [["rightharpoon"], 0.888, 522, "xMaxYMin"],
  xrightharpoondown: [["rightharpoondown"], 0.888, 522, "xMaxYMin"],
  xlongequal: [["longequal"], 0.888, 334, "xMinYMin"],
  "\\cdlongequal": [["longequal"], 3, 334, "xMinYMin"],
  xtwoheadleftarrow: [["twoheadleftarrow"], 0.888, 334, "xMinYMin"],
  xtwoheadrightarrow: [["twoheadrightarrow"], 0.888, 334, "xMaxYMin"],
  overleftrightarrow: [["leftarrow", "rightarrow"], 0.888, 522],
  overbrace: [["leftbrace", "midbrace", "rightbrace"], 1.6, 548],
  underbrace: [["leftbraceunder", "midbraceunder", "rightbraceunder"], 1.6, 548],
  underleftrightarrow: [["leftarrow", "rightarrow"], 0.888, 522],
  xleftrightarrow: [["leftarrow", "rightarrow"], 1.75, 522],
  xLeftrightarrow: [["doubleleftarrow", "doublerightarrow"], 1.75, 560],
  xrightleftharpoons: [["leftharpoondownplus", "rightharpoonplus"], 1.75, 716],
  xleftrightharpoons: [["leftharpoonplus", "rightharpoondownplus"], 1.75, 716],
  xhookleftarrow: [["leftarrow", "righthook"], 1.08, 522],
  xhookrightarrow: [["lefthook", "rightarrow"], 1.08, 522],
  overlinesegment: [["leftlinesegment", "rightlinesegment"], 0.888, 522],
  underlinesegment: [["leftlinesegment", "rightlinesegment"], 0.888, 522],
  overgroup: [["leftgroup", "rightgroup"], 0.888, 342],
  undergroup: [["leftgroupunder", "rightgroupunder"], 0.888, 342],
  xmapsto: [["leftmapsto", "rightarrow"], 1.5, 522],
  xtofrom: [["leftToFrom", "rightToFrom"], 1.75, 528],
  // The next three arrows are from the mhchem package.
  // In mhchem.sty, min-length is 2.0em. But these arrows might appear in the
  // document as \xrightarrow or \xrightleftharpoons. Those have
  // min-length = 1.75em, so we set min-length on these next three to match.
  xrightleftarrows: [["baraboveleftarrow", "rightarrowabovebar"], 1.75, 901],
  xrightequilibrium: [["baraboveshortleftharpoon", "rightharpoonaboveshortbar"], 1.75, 716],
  xleftequilibrium: [["shortbaraboveleftharpoon", "shortrightharpoonabovebar"], 1.75, 716]
}, ole = function(e) {
  return e.type === "ordgroup" ? e.body.length : 1;
}, ale = function(e, t) {
  function n() {
    var a = 4e5, s = e.label.slice(1);
    if (Nt.contains(["widehat", "widecheck", "widetilde", "utilde"], s)) {
      var l = e, u = ole(l.base), d, p, f;
      if (u > 5)
        s === "widehat" || s === "widecheck" ? (d = 420, a = 2364, f = 0.42, p = s + "4") : (d = 312, a = 2340, f = 0.34, p = "tilde4");
      else {
        var m = [1, 1, 2, 2, 3, 3][u];
        s === "widehat" || s === "widecheck" ? (a = [0, 1062, 2364, 2364, 2364][m], d = [0, 239, 300, 360, 420][m], f = [0, 0.24, 0.3, 0.3, 0.36, 0.42][m], p = s + m) : (a = [0, 600, 1033, 2339, 2340][m], d = [0, 260, 286, 306, 312][m], f = [0, 0.26, 0.286, 0.3, 0.306, 0.34][m], p = "tilde" + m);
      }
      var y = new xu(p), g = new dl([y], {
        width: "100%",
        height: it(f),
        viewBox: "0 0 " + a + " " + d,
        preserveAspectRatio: "none"
      });
      return {
        span: Ee.makeSvgSpan([], [g], t),
        minWidth: 0,
        height: f
      };
    } else {
      var x = [], E = ile[s], [b, C, T] = E, z = T / 1e3, I = b.length, w, M;
      if (I === 1) {
        var R = E[3];
        w = ["hide-tail"], M = [R];
      } else if (I === 2)
        w = ["halfarrow-left", "halfarrow-right"], M = ["xMinYMin", "xMaxYMin"];
      else if (I === 3)
        w = ["brace-left", "brace-center", "brace-right"], M = ["xMinYMin", "xMidYMin", "xMaxYMin"];
      else
        throw new Error(`Correct katexImagesData or update code here to support
                    ` + I + " children.");
      for (var F = 0; F < I; F++) {
        var W = new xu(b[F]), X = new dl([W], {
          width: "400em",
          height: it(z),
          viewBox: "0 0 " + a + " " + T,
          preserveAspectRatio: M[F] + " slice"
        }), le = Ee.makeSvgSpan([w[F]], [X], t);
        if (I === 1)
          return {
            span: le,
            minWidth: C,
            height: z
          };
        le.style.height = it(z), x.push(le);
      }
      return {
        span: Ee.makeSpan(["stretchy"], x, t),
        minWidth: C,
        height: z
      };
    }
  }
  var {
    span: r,
    minWidth: i,
    height: o
  } = n();
  return r.height = o, r.style.height = it(o), i > 0 && (r.style.minWidth = it(i)), r;
}, sle = function(e, t, n, r, i) {
  var o, a = e.height + e.depth + n + r;
  if (/fbox|color|angl/.test(t)) {
    if (o = Ee.makeSpan(["stretchy", t], [], i), t === "fbox") {
      var s = i.color && i.getColor();
      s && (o.style.borderColor = s);
    }
  } else {
    var l = [];
    /^[bx]cancel$/.test(t) && l.push(new z5({
      x1: "0",
      y1: "0",
      x2: "100%",
      y2: "100%",
      "stroke-width": "0.046em"
    })), /^x?cancel$/.test(t) && l.push(new z5({
      x1: "0",
      y1: "100%",
      x2: "100%",
      y2: "0",
      "stroke-width": "0.046em"
    }));
    var u = new dl(l, {
      width: "100%",
      height: it(a)
    });
    o = Ee.makeSvgSpan([], [u], i);
  }
  return o.height = a, o.style.height = it(a), o;
}, fl = {
  encloseSpan: sle,
  mathMLnode: rle,
  svgSpan: ale
};
function en(e, t) {
  if (!e || e.type !== t)
    throw new Error("Expected node of type " + t + ", but got " + (e ? "node of type " + e.type : String(e)));
  return e;
}
function zy(e) {
  var t = x2(e);
  if (!t)
    throw new Error("Expected node of symbol group type, but got " + (e ? "node of type " + e.type : String(e)));
  return t;
}
function x2(e) {
  return e && (e.type === "atom" || zse.hasOwnProperty(e.type)) ? e : null;
}
var Fy = (e, t) => {
  var n, r, i;
  e && e.type === "supsub" ? (r = en(e.base, "accent"), n = r.base, e.base = n, i = Nse(pn(e, t)), e.base = r) : (r = en(e, "accent"), n = r.base);
  var o = pn(n, t.havingCrampedStyle()), a = r.isShifty && Nt.isCharacterBox(n), s = 0;
  if (a) {
    var l = Nt.getBaseElem(n), u = pn(l, t.havingCrampedStyle());
    s = p9(u).skew;
  }
  var d = r.label === "\\c", p = d ? o.height + o.depth : Math.min(o.height, t.fontMetrics().xHeight), f;
  if (r.isStretchy)
    f = fl.svgSpan(r, t), f = Ee.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: o
      }, {
        type: "elem",
        elem: f,
        wrapperClasses: ["svg-align"],
        wrapperStyle: s > 0 ? {
          width: "calc(100% - " + it(2 * s) + ")",
          marginLeft: it(2 * s)
        } : void 0
      }]
    }, t);
  else {
    var m, y;
    r.label === "\\vec" ? (m = Ee.staticSvg("vec", t), y = Ee.svgData.vec[1]) : (m = Ee.makeOrd({
      mode: r.mode,
      text: r.label
    }, t, "textord"), m = p9(m), m.italic = 0, y = m.width, d && (p += m.depth)), f = Ee.makeSpan(["accent-body"], [m]);
    var g = r.label === "\\textcircled";
    g && (f.classes.push("accent-full"), p = o.height);
    var x = s;
    g || (x -= y / 2), f.style.left = it(x), r.label === "\\textcircled" && (f.style.top = ".2em"), f = Ee.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: o
      }, {
        type: "kern",
        size: -p
      }, {
        type: "elem",
        elem: f
      }]
    }, t);
  }
  var E = Ee.makeSpan(["mord", "accent"], [f], t);
  return i ? (i.children[0] = E, i.height = Math.max(E.height, i.height), i.classes[0] = "mord", i) : E;
}, Qz = (e, t) => {
  var n = e.isStretchy ? fl.mathMLnode(e.label) : new Ge.MathNode("mo", [ga(e.label, e.mode)]), r = new Ge.MathNode("mover", [On(e.base, t), n]);
  return r.setAttribute("accent", "true"), r;
}, lle = new RegExp(["\\acute", "\\grave", "\\ddot", "\\tilde", "\\bar", "\\breve", "\\check", "\\hat", "\\vec", "\\dot", "\\mathring"].map((e) => "\\" + e).join("|"));
ht({
  type: "accent",
  names: ["\\acute", "\\grave", "\\ddot", "\\tilde", "\\bar", "\\breve", "\\check", "\\hat", "\\vec", "\\dot", "\\mathring", "\\widecheck", "\\widehat", "\\widetilde", "\\overrightarrow", "\\overleftarrow", "\\Overrightarrow", "\\overleftrightarrow", "\\overgroup", "\\overlinesegment", "\\overleftharpoon", "\\overrightharpoon"],
  props: {
    numArgs: 1
  },
  handler: (e, t) => {
    var n = Gm(t[0]), r = !lle.test(e.funcName), i = !r || e.funcName === "\\widehat" || e.funcName === "\\widetilde" || e.funcName === "\\widecheck";
    return {
      type: "accent",
      mode: e.parser.mode,
      label: e.funcName,
      isStretchy: r,
      isShifty: i,
      base: n
    };
  },
  htmlBuilder: Fy,
  mathmlBuilder: Qz
});
ht({
  type: "accent",
  names: ["\\'", "\\`", "\\^", "\\~", "\\=", "\\u", "\\.", '\\"', "\\c", "\\r", "\\H", "\\v", "\\textcircled"],
  props: {
    numArgs: 1,
    allowedInText: !0,
    allowedInMath: !0,
    // unless in strict mode
    argTypes: ["primitive"]
  },
  handler: (e, t) => {
    var n = t[0], r = e.parser.mode;
    return r === "math" && (e.parser.settings.reportNonstrict("mathVsTextAccents", "LaTeX's accent " + e.funcName + " works only in text mode"), r = "text"), {
      type: "accent",
      mode: r,
      label: e.funcName,
      isStretchy: !1,
      isShifty: !0,
      base: n
    };
  },
  htmlBuilder: Fy,
  mathmlBuilder: Qz
});
ht({
  type: "accentUnder",
  names: ["\\underleftarrow", "\\underrightarrow", "\\underleftrightarrow", "\\undergroup", "\\underlinesegment", "\\utilde"],
  props: {
    numArgs: 1
  },
  handler: (e, t) => {
    var {
      parser: n,
      funcName: r
    } = e, i = t[0];
    return {
      type: "accentUnder",
      mode: n.mode,
      label: r,
      base: i
    };
  },
  htmlBuilder: (e, t) => {
    var n = pn(e.base, t), r = fl.svgSpan(e, t), i = e.label === "\\utilde" ? 0.12 : 0, o = Ee.makeVList({
      positionType: "top",
      positionData: n.height,
      children: [{
        type: "elem",
        elem: r,
        wrapperClasses: ["svg-align"]
      }, {
        type: "kern",
        size: i
      }, {
        type: "elem",
        elem: n
      }]
    }, t);
    return Ee.makeSpan(["mord", "accentunder"], [o], t);
  },
  mathmlBuilder: (e, t) => {
    var n = fl.mathMLnode(e.label), r = new Ge.MathNode("munder", [On(e.base, t), n]);
    return r.setAttribute("accentunder", "true"), r;
  }
});
var Jh = (e) => {
  var t = new Ge.MathNode("mpadded", e ? [e] : []);
  return t.setAttribute("width", "+0.6em"), t.setAttribute("lspace", "0.3em"), t;
};
ht({
  type: "xArrow",
  names: [
    "\\xleftarrow",
    "\\xrightarrow",
    "\\xLeftarrow",
    "\\xRightarrow",
    "\\xleftrightarrow",
    "\\xLeftrightarrow",
    "\\xhookleftarrow",
    "\\xhookrightarrow",
    "\\xmapsto",
    "\\xrightharpoondown",
    "\\xrightharpoonup",
    "\\xleftharpoondown",
    "\\xleftharpoonup",
    "\\xrightleftharpoons",
    "\\xleftrightharpoons",
    "\\xlongequal",
    "\\xtwoheadrightarrow",
    "\\xtwoheadleftarrow",
    "\\xtofrom",
    // The next 3 functions are here to support the mhchem extension.
    // Direct use of these functions is discouraged and may break someday.
    "\\xrightleftarrows",
    "\\xrightequilibrium",
    "\\xleftequilibrium",
    // The next 3 functions are here only to support the {CD} environment.
    "\\\\cdrightarrow",
    "\\\\cdleftarrow",
    "\\\\cdlongequal"
  ],
  props: {
    numArgs: 1,
    numOptionalArgs: 1
  },
  handler(e, t, n) {
    var {
      parser: r,
      funcName: i
    } = e;
    return {
      type: "xArrow",
      mode: r.mode,
      label: i,
      body: t[0],
      below: n[0]
    };
  },
  // Flow is unable to correctly infer the type of `group`, even though it's
  // unambiguously determined from the passed-in `type` above.
  htmlBuilder(e, t) {
    var n = t.style, r = t.havingStyle(n.sup()), i = Ee.wrapFragment(pn(e.body, r, t), t), o = e.label.slice(0, 2) === "\\x" ? "x" : "cd";
    i.classes.push(o + "-arrow-pad");
    var a;
    e.below && (r = t.havingStyle(n.sub()), a = Ee.wrapFragment(pn(e.below, r, t), t), a.classes.push(o + "-arrow-pad"));
    var s = fl.svgSpan(e, t), l = -t.fontMetrics().axisHeight + 0.5 * s.height, u = -t.fontMetrics().axisHeight - 0.5 * s.height - 0.111;
    (i.depth > 0.25 || e.label === "\\xleftequilibrium") && (u -= i.depth);
    var d;
    if (a) {
      var p = -t.fontMetrics().axisHeight + a.height + 0.5 * s.height + 0.111;
      d = Ee.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: i,
          shift: u
        }, {
          type: "elem",
          elem: s,
          shift: l
        }, {
          type: "elem",
          elem: a,
          shift: p
        }]
      }, t);
    } else
      d = Ee.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: i,
          shift: u
        }, {
          type: "elem",
          elem: s,
          shift: l
        }]
      }, t);
    return d.children[0].children[0].children[1].classes.push("svg-align"), Ee.makeSpan(["mrel", "x-arrow"], [d], t);
  },
  mathmlBuilder(e, t) {
    var n = fl.mathMLnode(e.label);
    n.setAttribute("minsize", e.label.charAt(0) === "x" ? "1.75em" : "3.0em");
    var r;
    if (e.body) {
      var i = Jh(On(e.body, t));
      if (e.below) {
        var o = Jh(On(e.below, t));
        r = new Ge.MathNode("munderover", [n, o, i]);
      } else
        r = new Ge.MathNode("mover", [n, i]);
    } else if (e.below) {
      var a = Jh(On(e.below, t));
      r = new Ge.MathNode("munder", [n, a]);
    } else
      r = Jh(), r = new Ge.MathNode("mover", [n, r]);
    return r;
  }
});
var ule = Ee.makeSpan;
function Yz(e, t) {
  var n = Hr(e.body, t, !0);
  return ule([e.mclass], n, t);
}
function Jz(e, t) {
  var n, r = lo(e.body, t);
  return e.mclass === "minner" ? n = new Ge.MathNode("mpadded", r) : e.mclass === "mord" ? e.isCharacterBox ? (n = r[0], n.type = "mi") : n = new Ge.MathNode("mi", r) : (e.isCharacterBox ? (n = r[0], n.type = "mo") : n = new Ge.MathNode("mo", r), e.mclass === "mbin" ? (n.attributes.lspace = "0.22em", n.attributes.rspace = "0.22em") : e.mclass === "mpunct" ? (n.attributes.lspace = "0em", n.attributes.rspace = "0.17em") : e.mclass === "mopen" || e.mclass === "mclose" ? (n.attributes.lspace = "0em", n.attributes.rspace = "0em") : e.mclass === "minner" && (n.attributes.lspace = "0.0556em", n.attributes.width = "+0.1111em")), n;
}
ht({
  type: "mclass",
  names: ["\\mathord", "\\mathbin", "\\mathrel", "\\mathopen", "\\mathclose", "\\mathpunct", "\\mathinner"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler(e, t) {
    var {
      parser: n,
      funcName: r
    } = e, i = t[0];
    return {
      type: "mclass",
      mode: n.mode,
      mclass: "m" + r.slice(5),
      // TODO(kevinb): don't prefix with 'm'
      body: Sr(i),
      isCharacterBox: Nt.isCharacterBox(i)
    };
  },
  htmlBuilder: Yz,
  mathmlBuilder: Jz
});
var b2 = (e) => {
  var t = e.type === "ordgroup" && e.body.length ? e.body[0] : e;
  return t.type === "atom" && (t.family === "bin" || t.family === "rel") ? "m" + t.family : "mord";
};
ht({
  type: "mclass",
  names: ["\\@binrel"],
  props: {
    numArgs: 2
  },
  handler(e, t) {
    var {
      parser: n
    } = e;
    return {
      type: "mclass",
      mode: n.mode,
      mclass: b2(t[0]),
      body: Sr(t[1]),
      isCharacterBox: Nt.isCharacterBox(t[1])
    };
  }
});
ht({
  type: "mclass",
  names: ["\\stackrel", "\\overset", "\\underset"],
  props: {
    numArgs: 2
  },
  handler(e, t) {
    var {
      parser: n,
      funcName: r
    } = e, i = t[1], o = t[0], a;
    r !== "\\stackrel" ? a = b2(i) : a = "mrel";
    var s = {
      type: "op",
      mode: i.mode,
      limits: !0,
      alwaysHandleSupSub: !0,
      parentIsSupSub: !1,
      symbol: !1,
      suppressBaseShift: r !== "\\stackrel",
      body: Sr(i)
    }, l = {
      type: "supsub",
      mode: o.mode,
      base: s,
      sup: r === "\\underset" ? null : o,
      sub: r === "\\underset" ? o : null
    };
    return {
      type: "mclass",
      mode: n.mode,
      mclass: a,
      body: [l],
      isCharacterBox: Nt.isCharacterBox(l)
    };
  },
  htmlBuilder: Yz,
  mathmlBuilder: Jz
});
ht({
  type: "pmb",
  names: ["\\pmb"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(e, t) {
    var {
      parser: n
    } = e;
    return {
      type: "pmb",
      mode: n.mode,
      mclass: b2(t[0]),
      body: Sr(t[0])
    };
  },
  htmlBuilder(e, t) {
    var n = Hr(e.body, t, !0), r = Ee.makeSpan([e.mclass], n, t);
    return r.style.textShadow = "0.02em 0.01em 0.04px", r;
  },
  mathmlBuilder(e, t) {
    var n = lo(e.body, t), r = new Ge.MathNode("mstyle", n);
    return r.setAttribute("style", "text-shadow: 0.02em 0.01em 0.04px"), r;
  }
});
var cle = {
  ">": "\\\\cdrightarrow",
  "<": "\\\\cdleftarrow",
  "=": "\\\\cdlongequal",
  A: "\\uparrow",
  V: "\\downarrow",
  "|": "\\Vert",
  ".": "no arrow"
}, b9 = () => ({
  type: "styling",
  body: [],
  mode: "math",
  style: "display"
}), w9 = (e) => e.type === "textord" && e.text === "@", dle = (e, t) => (e.type === "mathord" || e.type === "atom") && e.text === t;
function ple(e, t, n) {
  var r = cle[e];
  switch (r) {
    case "\\\\cdrightarrow":
    case "\\\\cdleftarrow":
      return n.callFunction(r, [t[0]], [t[1]]);
    case "\\uparrow":
    case "\\downarrow": {
      var i = n.callFunction("\\\\cdleft", [t[0]], []), o = {
        type: "atom",
        text: r,
        mode: "math",
        family: "rel"
      }, a = n.callFunction("\\Big", [o], []), s = n.callFunction("\\\\cdright", [t[1]], []), l = {
        type: "ordgroup",
        mode: "math",
        body: [i, a, s]
      };
      return n.callFunction("\\\\cdparent", [l], []);
    }
    case "\\\\cdlongequal":
      return n.callFunction("\\\\cdlongequal", [], []);
    case "\\Vert": {
      var u = {
        type: "textord",
        text: "\\Vert",
        mode: "math"
      };
      return n.callFunction("\\Big", [u], []);
    }
    default:
      return {
        type: "textord",
        text: " ",
        mode: "math"
      };
  }
}
function fle(e) {
  var t = [];
  for (e.gullet.beginGroup(), e.gullet.macros.set("\\cr", "\\\\\\relax"), e.gullet.beginGroup(); ; ) {
    t.push(e.parseExpression(!1, "\\\\")), e.gullet.endGroup(), e.gullet.beginGroup();
    var n = e.fetch().text;
    if (n === "&" || n === "\\\\")
      e.consume();
    else if (n === "\\end") {
      t[t.length - 1].length === 0 && t.pop();
      break;
    } else
      throw new Ye("Expected \\\\ or \\cr or \\end", e.nextToken);
  }
  for (var r = [], i = [r], o = 0; o < t.length; o++) {
    for (var a = t[o], s = b9(), l = 0; l < a.length; l++)
      if (!w9(a[l]))
        s.body.push(a[l]);
      else {
        r.push(s), l += 1;
        var u = zy(a[l]).text, d = new Array(2);
        if (d[0] = {
          type: "ordgroup",
          mode: "math",
          body: []
        }, d[1] = {
          type: "ordgroup",
          mode: "math",
          body: []
        }, !("=|.".indexOf(u) > -1)) if ("<>AV".indexOf(u) > -1)
          for (var p = 0; p < 2; p++) {
            for (var f = !0, m = l + 1; m < a.length; m++) {
              if (dle(a[m], u)) {
                f = !1, l = m;
                break;
              }
              if (w9(a[m]))
                throw new Ye("Missing a " + u + " character to complete a CD arrow.", a[m]);
              d[p].body.push(a[m]);
            }
            if (f)
              throw new Ye("Missing a " + u + " character to complete a CD arrow.", a[l]);
          }
        else
          throw new Ye('Expected one of "<>AV=|." after @', a[l]);
        var y = ple(u, d, e), g = {
          type: "styling",
          body: [y],
          mode: "math",
          style: "display"
          // CD is always displaystyle.
        };
        r.push(g), s = b9();
      }
    o % 2 === 0 ? r.push(s) : r.shift(), r = [], i.push(r);
  }
  e.gullet.endGroup(), e.gullet.endGroup();
  var x = new Array(i[0].length).fill({
    type: "align",
    align: "c",
    pregap: 0.25,
    // CD package sets \enskip between columns.
    postgap: 0.25
    // So pre and post each get half an \enskip, i.e. 0.25em.
  });
  return {
    type: "array",
    mode: "math",
    body: i,
    arraystretch: 1,
    addJot: !0,
    rowGaps: [null],
    cols: x,
    colSeparationType: "CD",
    hLinesBeforeRow: new Array(i.length + 1).fill([])
  };
}
ht({
  type: "cdlabel",
  names: ["\\\\cdleft", "\\\\cdright"],
  props: {
    numArgs: 1
  },
  handler(e, t) {
    var {
      parser: n,
      funcName: r
    } = e;
    return {
      type: "cdlabel",
      mode: n.mode,
      side: r.slice(4),
      label: t[0]
    };
  },
  htmlBuilder(e, t) {
    var n = t.havingStyle(t.style.sup()), r = Ee.wrapFragment(pn(e.label, n, t), t);
    return r.classes.push("cd-label-" + e.side), r.style.bottom = it(0.8 - r.depth), r.height = 0, r.depth = 0, r;
  },
  mathmlBuilder(e, t) {
    var n = new Ge.MathNode("mrow", [On(e.label, t)]);
    return n = new Ge.MathNode("mpadded", [n]), n.setAttribute("width", "0"), e.side === "left" && n.setAttribute("lspace", "-1width"), n.setAttribute("voffset", "0.7em"), n = new Ge.MathNode("mstyle", [n]), n.setAttribute("displaystyle", "false"), n.setAttribute("scriptlevel", "1"), n;
  }
});
ht({
  type: "cdlabelparent",
  names: ["\\\\cdparent"],
  props: {
    numArgs: 1
  },
  handler(e, t) {
    var {
      parser: n
    } = e;
    return {
      type: "cdlabelparent",
      mode: n.mode,
      fragment: t[0]
    };
  },
  htmlBuilder(e, t) {
    var n = Ee.wrapFragment(pn(e.fragment, t), t);
    return n.classes.push("cd-vert-arrow"), n;
  },
  mathmlBuilder(e, t) {
    return new Ge.MathNode("mrow", [On(e.fragment, t)]);
  }
});
ht({
  type: "textord",
  names: ["\\@char"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(e, t) {
    for (var {
      parser: n
    } = e, r = en(t[0], "ordgroup"), i = r.body, o = "", a = 0; a < i.length; a++) {
      var s = en(i[a], "textord");
      o += s.text;
    }
    var l = parseInt(o), u;
    if (isNaN(l))
      throw new Ye("\\@char has non-numeric argument " + o);
    if (l < 0 || l >= 1114111)
      throw new Ye("\\@char with invalid code point " + o);
    return l <= 65535 ? u = String.fromCharCode(l) : (l -= 65536, u = String.fromCharCode((l >> 10) + 55296, (l & 1023) + 56320)), {
      type: "textord",
      mode: n.mode,
      text: u
    };
  }
});
var eF = (e, t) => {
  var n = Hr(e.body, t.withColor(e.color), !1);
  return Ee.makeFragment(n);
}, tF = (e, t) => {
  var n = lo(e.body, t.withColor(e.color)), r = new Ge.MathNode("mstyle", n);
  return r.setAttribute("mathcolor", e.color), r;
};
ht({
  type: "color",
  names: ["\\textcolor"],
  props: {
    numArgs: 2,
    allowedInText: !0,
    argTypes: ["color", "original"]
  },
  handler(e, t) {
    var {
      parser: n
    } = e, r = en(t[0], "color-token").color, i = t[1];
    return {
      type: "color",
      mode: n.mode,
      color: r,
      body: Sr(i)
    };
  },
  htmlBuilder: eF,
  mathmlBuilder: tF
});
ht({
  type: "color",
  names: ["\\color"],
  props: {
    numArgs: 1,
    allowedInText: !0,
    argTypes: ["color"]
  },
  handler(e, t) {
    var {
      parser: n,
      breakOnTokenText: r
    } = e, i = en(t[0], "color-token").color;
    n.gullet.macros.set("\\current@color", i);
    var o = n.parseExpression(!0, r);
    return {
      type: "color",
      mode: n.mode,
      color: i,
      body: o
    };
  },
  htmlBuilder: eF,
  mathmlBuilder: tF
});
ht({
  type: "cr",
  names: ["\\\\"],
  props: {
    numArgs: 0,
    numOptionalArgs: 0,
    allowedInText: !0
  },
  handler(e, t, n) {
    var {
      parser: r
    } = e, i = r.gullet.future().text === "[" ? r.parseSizeGroup(!0) : null, o = !r.settings.displayMode || !r.settings.useStrictBehavior("newLineInDisplayMode", "In LaTeX, \\\\ or \\newline does nothing in display mode");
    return {
      type: "cr",
      mode: r.mode,
      newLine: o,
      size: i && en(i, "size").value
    };
  },
  // The following builders are called only at the top level,
  // not within tabular/array environments.
  htmlBuilder(e, t) {
    var n = Ee.makeSpan(["mspace"], [], t);
    return e.newLine && (n.classes.push("newline"), e.size && (n.style.marginTop = it(cr(e.size, t)))), n;
  },
  mathmlBuilder(e, t) {
    var n = new Ge.MathNode("mspace");
    return e.newLine && (n.setAttribute("linebreak", "newline"), e.size && n.setAttribute("height", it(cr(e.size, t)))), n;
  }
});
var B5 = {
  "\\global": "\\global",
  "\\long": "\\\\globallong",
  "\\\\globallong": "\\\\globallong",
  "\\def": "\\gdef",
  "\\gdef": "\\gdef",
  "\\edef": "\\xdef",
  "\\xdef": "\\xdef",
  "\\let": "\\\\globallet",
  "\\futurelet": "\\\\globalfuture"
}, nF = (e) => {
  var t = e.text;
  if (/^(?:[\\{}$&#^_]|EOF)$/.test(t))
    throw new Ye("Expected a control sequence", e);
  return t;
}, hle = (e) => {
  var t = e.gullet.popToken();
  return t.text === "=" && (t = e.gullet.popToken(), t.text === " " && (t = e.gullet.popToken())), t;
}, rF = (e, t, n, r) => {
  var i = e.gullet.macros.get(n.text);
  i == null && (n.noexpand = !0, i = {
    tokens: [n],
    numArgs: 0,
    // reproduce the same behavior in expansion
    unexpandable: !e.gullet.isExpandable(n.text)
  }), e.gullet.macros.set(t, i, r);
};
ht({
  type: "internal",
  names: [
    "\\global",
    "\\long",
    "\\\\globallong"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler(e) {
    var {
      parser: t,
      funcName: n
    } = e;
    t.consumeSpaces();
    var r = t.fetch();
    if (B5[r.text])
      return (n === "\\global" || n === "\\\\globallong") && (r.text = B5[r.text]), en(t.parseFunction(), "internal");
    throw new Ye("Invalid token after macro prefix", r);
  }
});
ht({
  type: "internal",
  names: ["\\def", "\\gdef", "\\edef", "\\xdef"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(e) {
    var {
      parser: t,
      funcName: n
    } = e, r = t.gullet.popToken(), i = r.text;
    if (/^(?:[\\{}$&#^_]|EOF)$/.test(i))
      throw new Ye("Expected a control sequence", r);
    for (var o = 0, a, s = [[]]; t.gullet.future().text !== "{"; )
      if (r = t.gullet.popToken(), r.text === "#") {
        if (t.gullet.future().text === "{") {
          a = t.gullet.future(), s[o].push("{");
          break;
        }
        if (r = t.gullet.popToken(), !/^[1-9]$/.test(r.text))
          throw new Ye('Invalid argument number "' + r.text + '"');
        if (parseInt(r.text) !== o + 1)
          throw new Ye('Argument number "' + r.text + '" out of order');
        o++, s.push([]);
      } else {
        if (r.text === "EOF")
          throw new Ye("Expected a macro definition");
        s[o].push(r.text);
      }
    var {
      tokens: l
    } = t.gullet.consumeArg();
    return a && l.unshift(a), (n === "\\edef" || n === "\\xdef") && (l = t.gullet.expandTokens(l), l.reverse()), t.gullet.macros.set(i, {
      tokens: l,
      numArgs: o,
      delimiters: s
    }, n === B5[n]), {
      type: "internal",
      mode: t.mode
    };
  }
});
ht({
  type: "internal",
  names: [
    "\\let",
    "\\\\globallet"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(e) {
    var {
      parser: t,
      funcName: n
    } = e, r = nF(t.gullet.popToken());
    t.gullet.consumeSpaces();
    var i = hle(t);
    return rF(t, r, i, n === "\\\\globallet"), {
      type: "internal",
      mode: t.mode
    };
  }
});
ht({
  type: "internal",
  names: [
    "\\futurelet",
    "\\\\globalfuture"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(e) {
    var {
      parser: t,
      funcName: n
    } = e, r = nF(t.gullet.popToken()), i = t.gullet.popToken(), o = t.gullet.popToken();
    return rF(t, r, o, n === "\\\\globalfuture"), t.gullet.pushToken(o), t.gullet.pushToken(i), {
      type: "internal",
      mode: t.mode
    };
  }
});
var rp = function(e, t, n) {
  var r = Bn.math[e] && Bn.math[e].replace, i = Ay(r || e, t, n);
  if (!i)
    throw new Error("Unsupported symbol " + e + " and font size " + t + ".");
  return i;
}, Ly = function(e, t, n, r) {
  var i = n.havingBaseStyle(t), o = Ee.makeSpan(r.concat(i.sizingClasses(n)), [e], n), a = i.sizeMultiplier / n.sizeMultiplier;
  return o.height *= a, o.depth *= a, o.maxFontSize = i.sizeMultiplier, o;
}, iF = function(e, t, n) {
  var r = t.havingBaseStyle(n), i = (1 - t.sizeMultiplier / r.sizeMultiplier) * t.fontMetrics().axisHeight;
  e.classes.push("delimcenter"), e.style.top = it(i), e.height -= i, e.depth += i;
}, mle = function(e, t, n, r, i, o) {
  var a = Ee.makeSymbol(e, "Main-Regular", i, r), s = Ly(a, t, r, o);
  return n && iF(s, r, t), s;
}, gle = function(e, t, n, r) {
  return Ee.makeSymbol(e, "Size" + t + "-Regular", n, r);
}, oF = function(e, t, n, r, i, o) {
  var a = gle(e, t, i, r), s = Ly(Ee.makeSpan(["delimsizing", "size" + t], [a], r), zt.TEXT, r, o);
  return n && iF(s, r, zt.TEXT), s;
}, r3 = function(e, t, n) {
  var r;
  t === "Size1-Regular" ? r = "delim-size1" : r = "delim-size4";
  var i = Ee.makeSpan(["delimsizinginner", r], [Ee.makeSpan([], [Ee.makeSymbol(e, t, n)])]);
  return {
    type: "elem",
    elem: i
  };
}, i3 = function(e, t, n) {
  var r = as["Size4-Regular"][e.charCodeAt(0)] ? as["Size4-Regular"][e.charCodeAt(0)][4] : as["Size1-Regular"][e.charCodeAt(0)][4], i = new xu("inner", Cse(e, Math.round(1e3 * t))), o = new dl([i], {
    width: it(r),
    height: it(t),
    // Override CSS rule `.katex svg { width: 100% }`
    style: "width:" + it(r),
    viewBox: "0 0 " + 1e3 * r + " " + Math.round(1e3 * t),
    preserveAspectRatio: "xMinYMin"
  }), a = Ee.makeSvgSpan([], [o], n);
  return a.height = t, a.style.height = it(t), a.style.width = it(r), {
    type: "elem",
    elem: a
  };
}, I5 = 8e-3, e1 = {
  type: "kern",
  size: -1 * I5
}, vle = ["|", "\\lvert", "\\rvert", "\\vert"], yle = ["\\|", "\\lVert", "\\rVert", "\\Vert"], aF = function(e, t, n, r, i, o) {
  var a, s, l, u, d = "", p = 0;
  a = l = u = e, s = null;
  var f = "Size1-Regular";
  e === "\\uparrow" ? l = u = "⏐" : e === "\\Uparrow" ? l = u = "‖" : e === "\\downarrow" ? a = l = "⏐" : e === "\\Downarrow" ? a = l = "‖" : e === "\\updownarrow" ? (a = "\\uparrow", l = "⏐", u = "\\downarrow") : e === "\\Updownarrow" ? (a = "\\Uparrow", l = "‖", u = "\\Downarrow") : Nt.contains(vle, e) ? (l = "∣", d = "vert", p = 333) : Nt.contains(yle, e) ? (l = "∥", d = "doublevert", p = 556) : e === "[" || e === "\\lbrack" ? (a = "⎡", l = "⎢", u = "⎣", f = "Size4-Regular", d = "lbrack", p = 667) : e === "]" || e === "\\rbrack" ? (a = "⎤", l = "⎥", u = "⎦", f = "Size4-Regular", d = "rbrack", p = 667) : e === "\\lfloor" || e === "⌊" ? (l = a = "⎢", u = "⎣", f = "Size4-Regular", d = "lfloor", p = 667) : e === "\\lceil" || e === "⌈" ? (a = "⎡", l = u = "⎢", f = "Size4-Regular", d = "lceil", p = 667) : e === "\\rfloor" || e === "⌋" ? (l = a = "⎥", u = "⎦", f = "Size4-Regular", d = "rfloor", p = 667) : e === "\\rceil" || e === "⌉" ? (a = "⎤", l = u = "⎥", f = "Size4-Regular", d = "rceil", p = 667) : e === "(" || e === "\\lparen" ? (a = "⎛", l = "⎜", u = "⎝", f = "Size4-Regular", d = "lparen", p = 875) : e === ")" || e === "\\rparen" ? (a = "⎞", l = "⎟", u = "⎠", f = "Size4-Regular", d = "rparen", p = 875) : e === "\\{" || e === "\\lbrace" ? (a = "⎧", s = "⎨", u = "⎩", l = "⎪", f = "Size4-Regular") : e === "\\}" || e === "\\rbrace" ? (a = "⎫", s = "⎬", u = "⎭", l = "⎪", f = "Size4-Regular") : e === "\\lgroup" || e === "⟮" ? (a = "⎧", u = "⎩", l = "⎪", f = "Size4-Regular") : e === "\\rgroup" || e === "⟯" ? (a = "⎫", u = "⎭", l = "⎪", f = "Size4-Regular") : e === "\\lmoustache" || e === "⎰" ? (a = "⎧", u = "⎭", l = "⎪", f = "Size4-Regular") : (e === "\\rmoustache" || e === "⎱") && (a = "⎫", u = "⎩", l = "⎪", f = "Size4-Regular");
  var m = rp(a, f, i), y = m.height + m.depth, g = rp(l, f, i), x = g.height + g.depth, E = rp(u, f, i), b = E.height + E.depth, C = 0, T = 1;
  if (s !== null) {
    var z = rp(s, f, i);
    C = z.height + z.depth, T = 2;
  }
  var I = y + b + C, w = Math.max(0, Math.ceil((t - I) / (T * x))), M = I + w * T * x, R = r.fontMetrics().axisHeight;
  n && (R *= r.sizeMultiplier);
  var F = M / 2 - R, W = [];
  if (d.length > 0) {
    var X = M - y - b, le = Math.round(M * 1e3), ne = kse(d, Math.round(X * 1e3)), fe = new xu(d, ne), D = (p / 1e3).toFixed(3) + "em", j = (le / 1e3).toFixed(3) + "em", de = new dl([fe], {
      width: D,
      height: j,
      viewBox: "0 0 " + p + " " + le
    }), ye = Ee.makeSvgSpan([], [de], r);
    ye.height = le / 1e3, ye.style.width = D, ye.style.height = j, W.push({
      type: "elem",
      elem: ye
    });
  } else {
    if (W.push(r3(u, f, i)), W.push(e1), s === null) {
      var Ne = M - y - b + 2 * I5;
      W.push(i3(l, Ne, r));
    } else {
      var Me = (M - y - b - C) / 2 + 2 * I5;
      W.push(i3(l, Me, r)), W.push(e1), W.push(r3(s, f, i)), W.push(e1), W.push(i3(l, Me, r));
    }
    W.push(e1), W.push(r3(a, f, i));
  }
  var Ie = r.havingBaseStyle(zt.TEXT), at = Ee.makeVList({
    positionType: "bottom",
    positionData: F,
    children: W
  }, Ie);
  return Ly(Ee.makeSpan(["delimsizing", "mult"], [at], Ie), zt.TEXT, r, o);
}, o3 = 80, a3 = 0.08, s3 = function(e, t, n, r, i) {
  var o = wse(e, r, n), a = new xu(e, o), s = new dl([a], {
    // Note: 1000:1 ratio of viewBox to document em width.
    width: "400em",
    height: it(t),
    viewBox: "0 0 400000 " + n,
    preserveAspectRatio: "xMinYMin slice"
  });
  return Ee.makeSvgSpan(["hide-tail"], [s], i);
}, xle = function(e, t) {
  var n = t.havingBaseSizing(), r = cF("\\surd", e * n.sizeMultiplier, uF, n), i = n.sizeMultiplier, o = Math.max(0, t.minRuleThickness - t.fontMetrics().sqrtRuleThickness), a, s = 0, l = 0, u = 0, d;
  return r.type === "small" ? (u = 1e3 + 1e3 * o + o3, e < 1 ? i = 1 : e < 1.4 && (i = 0.7), s = (1 + o + a3) / i, l = (1 + o) / i, a = s3("sqrtMain", s, u, o, t), a.style.minWidth = "0.853em", d = 0.833 / i) : r.type === "large" ? (u = (1e3 + o3) * Ep[r.size], l = (Ep[r.size] + o) / i, s = (Ep[r.size] + o + a3) / i, a = s3("sqrtSize" + r.size, s, u, o, t), a.style.minWidth = "1.02em", d = 1 / i) : (s = e + o + a3, l = e + o, u = Math.floor(1e3 * e + o) + o3, a = s3("sqrtTall", s, u, o, t), a.style.minWidth = "0.742em", d = 1.056), a.height = l, a.style.height = it(s), {
    span: a,
    advanceWidth: d,
    // Calculate the actual line width.
    // This actually should depend on the chosen font -- e.g. \boldmath
    // should use the thicker surd symbols from e.g. KaTeX_Main-Bold, and
    // have thicker rules.
    ruleWidth: (t.fontMetrics().sqrtRuleThickness + o) * i
  };
}, sF = ["(", "\\lparen", ")", "\\rparen", "[", "\\lbrack", "]", "\\rbrack", "\\{", "\\lbrace", "\\}", "\\rbrace", "\\lfloor", "\\rfloor", "⌊", "⌋", "\\lceil", "\\rceil", "⌈", "⌉", "\\surd"], ble = ["\\uparrow", "\\downarrow", "\\updownarrow", "\\Uparrow", "\\Downarrow", "\\Updownarrow", "|", "\\|", "\\vert", "\\Vert", "\\lvert", "\\rvert", "\\lVert", "\\rVert", "\\lgroup", "\\rgroup", "⟮", "⟯", "\\lmoustache", "\\rmoustache", "⎰", "⎱"], lF = ["<", ">", "\\langle", "\\rangle", "/", "\\backslash", "\\lt", "\\gt"], Ep = [0, 1.2, 1.8, 2.4, 3], wle = function(e, t, n, r, i) {
  if (e === "<" || e === "\\lt" || e === "⟨" ? e = "\\langle" : (e === ">" || e === "\\gt" || e === "⟩") && (e = "\\rangle"), Nt.contains(sF, e) || Nt.contains(lF, e))
    return oF(e, t, !1, n, r, i);
  if (Nt.contains(ble, e))
    return aF(e, Ep[t], !1, n, r, i);
  throw new Ye("Illegal delimiter: '" + e + "'");
}, Cle = [{
  type: "small",
  style: zt.SCRIPTSCRIPT
}, {
  type: "small",
  style: zt.SCRIPT
}, {
  type: "small",
  style: zt.TEXT
}, {
  type: "large",
  size: 1
}, {
  type: "large",
  size: 2
}, {
  type: "large",
  size: 3
}, {
  type: "large",
  size: 4
}], kle = [{
  type: "small",
  style: zt.SCRIPTSCRIPT
}, {
  type: "small",
  style: zt.SCRIPT
}, {
  type: "small",
  style: zt.TEXT
}, {
  type: "stack"
}], uF = [{
  type: "small",
  style: zt.SCRIPTSCRIPT
}, {
  type: "small",
  style: zt.SCRIPT
}, {
  type: "small",
  style: zt.TEXT
}, {
  type: "large",
  size: 1
}, {
  type: "large",
  size: 2
}, {
  type: "large",
  size: 3
}, {
  type: "large",
  size: 4
}, {
  type: "stack"
}], Ele = function(e) {
  if (e.type === "small")
    return "Main-Regular";
  if (e.type === "large")
    return "Size" + e.size + "-Regular";
  if (e.type === "stack")
    return "Size4-Regular";
  throw new Error("Add support for delim type '" + e.type + "' here.");
}, cF = function(e, t, n, r) {
  for (var i = Math.min(2, 3 - r.style.size), o = i; o < n.length && n[o].type !== "stack"; o++) {
    var a = rp(e, Ele(n[o]), "math"), s = a.height + a.depth;
    if (n[o].type === "small") {
      var l = r.havingBaseStyle(n[o].style);
      s *= l.sizeMultiplier;
    }
    if (s > t)
      return n[o];
  }
  return n[n.length - 1];
}, dF = function(e, t, n, r, i, o) {
  e === "<" || e === "\\lt" || e === "⟨" ? e = "\\langle" : (e === ">" || e === "\\gt" || e === "⟩") && (e = "\\rangle");
  var a;
  Nt.contains(lF, e) ? a = Cle : Nt.contains(sF, e) ? a = uF : a = kle;
  var s = cF(e, t, a, r);
  return s.type === "small" ? mle(e, s.style, n, r, i, o) : s.type === "large" ? oF(e, s.size, n, r, i, o) : aF(e, t, n, r, i, o);
}, Sle = function(e, t, n, r, i, o) {
  var a = r.fontMetrics().axisHeight * r.sizeMultiplier, s = 901, l = 5 / r.fontMetrics().ptPerEm, u = Math.max(t - a, n + a), d = Math.max(
    // In real TeX, calculations are done using integral values which are
    // 65536 per pt, or 655360 per em. So, the division here truncates in
    // TeX but doesn't here, producing different results. If we wanted to
    // exactly match TeX's calculation, we could do
    //   Math.floor(655360 * maxDistFromAxis / 500) *
    //    delimiterFactor / 655360
    // (To see the difference, compare
    //    x^{x^{\left(\rule{0.1em}{0.68em}\right)}}
    // in TeX and KaTeX)
    u / 500 * s,
    2 * u - l
  );
  return dF(e, d, !0, r, i, o);
}, Qs = {
  sqrtImage: xle,
  sizedDelim: wle,
  sizeToMaxHeight: Ep,
  customSizedDelim: dF,
  leftRightDelim: Sle
}, C9 = {
  "\\bigl": {
    mclass: "mopen",
    size: 1
  },
  "\\Bigl": {
    mclass: "mopen",
    size: 2
  },
  "\\biggl": {
    mclass: "mopen",
    size: 3
  },
  "\\Biggl": {
    mclass: "mopen",
    size: 4
  },
  "\\bigr": {
    mclass: "mclose",
    size: 1
  },
  "\\Bigr": {
    mclass: "mclose",
    size: 2
  },
  "\\biggr": {
    mclass: "mclose",
    size: 3
  },
  "\\Biggr": {
    mclass: "mclose",
    size: 4
  },
  "\\bigm": {
    mclass: "mrel",
    size: 1
  },
  "\\Bigm": {
    mclass: "mrel",
    size: 2
  },
  "\\biggm": {
    mclass: "mrel",
    size: 3
  },
  "\\Biggm": {
    mclass: "mrel",
    size: 4
  },
  "\\big": {
    mclass: "mord",
    size: 1
  },
  "\\Big": {
    mclass: "mord",
    size: 2
  },
  "\\bigg": {
    mclass: "mord",
    size: 3
  },
  "\\Bigg": {
    mclass: "mord",
    size: 4
  }
}, Dle = ["(", "\\lparen", ")", "\\rparen", "[", "\\lbrack", "]", "\\rbrack", "\\{", "\\lbrace", "\\}", "\\rbrace", "\\lfloor", "\\rfloor", "⌊", "⌋", "\\lceil", "\\rceil", "⌈", "⌉", "<", ">", "\\langle", "⟨", "\\rangle", "⟩", "\\lt", "\\gt", "\\lvert", "\\rvert", "\\lVert", "\\rVert", "\\lgroup", "\\rgroup", "⟮", "⟯", "\\lmoustache", "\\rmoustache", "⎰", "⎱", "/", "\\backslash", "|", "\\vert", "\\|", "\\Vert", "\\uparrow", "\\Uparrow", "\\downarrow", "\\Downarrow", "\\updownarrow", "\\Updownarrow", "."];
function w2(e, t) {
  var n = x2(e);
  if (n && Nt.contains(Dle, n.text))
    return n;
  throw n ? new Ye("Invalid delimiter '" + n.text + "' after '" + t.funcName + "'", e) : new Ye("Invalid delimiter type '" + e.type + "'", e);
}
ht({
  type: "delimsizing",
  names: ["\\bigl", "\\Bigl", "\\biggl", "\\Biggl", "\\bigr", "\\Bigr", "\\biggr", "\\Biggr", "\\bigm", "\\Bigm", "\\biggm", "\\Biggm", "\\big", "\\Big", "\\bigg", "\\Bigg"],
  props: {
    numArgs: 1,
    argTypes: ["primitive"]
  },
  handler: (e, t) => {
    var n = w2(t[0], e);
    return {
      type: "delimsizing",
      mode: e.parser.mode,
      size: C9[e.funcName].size,
      mclass: C9[e.funcName].mclass,
      delim: n.text
    };
  },
  htmlBuilder: (e, t) => e.delim === "." ? Ee.makeSpan([e.mclass]) : Qs.sizedDelim(e.delim, e.size, t, e.mode, [e.mclass]),
  mathmlBuilder: (e) => {
    var t = [];
    e.delim !== "." && t.push(ga(e.delim, e.mode));
    var n = new Ge.MathNode("mo", t);
    e.mclass === "mopen" || e.mclass === "mclose" ? n.setAttribute("fence", "true") : n.setAttribute("fence", "false"), n.setAttribute("stretchy", "true");
    var r = it(Qs.sizeToMaxHeight[e.size]);
    return n.setAttribute("minsize", r), n.setAttribute("maxsize", r), n;
  }
});
function k9(e) {
  if (!e.body)
    throw new Error("Bug: The leftright ParseNode wasn't fully parsed.");
}
ht({
  type: "leftright-right",
  names: ["\\right"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (e, t) => {
    var n = e.parser.gullet.macros.get("\\current@color");
    if (n && typeof n != "string")
      throw new Ye("\\current@color set to non-string in \\right");
    return {
      type: "leftright-right",
      mode: e.parser.mode,
      delim: w2(t[0], e).text,
      color: n
      // undefined if not set via \color
    };
  }
});
ht({
  type: "leftright",
  names: ["\\left"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (e, t) => {
    var n = w2(t[0], e), r = e.parser;
    ++r.leftrightDepth;
    var i = r.parseExpression(!1);
    --r.leftrightDepth, r.expect("\\right", !1);
    var o = en(r.parseFunction(), "leftright-right");
    return {
      type: "leftright",
      mode: r.mode,
      body: i,
      left: n.text,
      right: o.delim,
      rightColor: o.color
    };
  },
  htmlBuilder: (e, t) => {
    k9(e);
    for (var n = Hr(e.body, t, !0, ["mopen", "mclose"]), r = 0, i = 0, o = !1, a = 0; a < n.length; a++)
      n[a].isMiddle ? o = !0 : (r = Math.max(n[a].height, r), i = Math.max(n[a].depth, i));
    r *= t.sizeMultiplier, i *= t.sizeMultiplier;
    var s;
    if (e.left === "." ? s = lf(t, ["mopen"]) : s = Qs.leftRightDelim(e.left, r, i, t, e.mode, ["mopen"]), n.unshift(s), o)
      for (var l = 1; l < n.length; l++) {
        var u = n[l], d = u.isMiddle;
        d && (n[l] = Qs.leftRightDelim(d.delim, r, i, d.options, e.mode, []));
      }
    var p;
    if (e.right === ".")
      p = lf(t, ["mclose"]);
    else {
      var f = e.rightColor ? t.withColor(e.rightColor) : t;
      p = Qs.leftRightDelim(e.right, r, i, f, e.mode, ["mclose"]);
    }
    return n.push(p), Ee.makeSpan(["minner"], n, t);
  },
  mathmlBuilder: (e, t) => {
    k9(e);
    var n = lo(e.body, t);
    if (e.left !== ".") {
      var r = new Ge.MathNode("mo", [ga(e.left, e.mode)]);
      r.setAttribute("fence", "true"), n.unshift(r);
    }
    if (e.right !== ".") {
      var i = new Ge.MathNode("mo", [ga(e.right, e.mode)]);
      i.setAttribute("fence", "true"), e.rightColor && i.setAttribute("mathcolor", e.rightColor), n.push(i);
    }
    return Ny(n);
  }
});
ht({
  type: "middle",
  names: ["\\middle"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (e, t) => {
    var n = w2(t[0], e);
    if (!e.parser.leftrightDepth)
      throw new Ye("\\middle without preceding \\left", n);
    return {
      type: "middle",
      mode: e.parser.mode,
      delim: n.text
    };
  },
  htmlBuilder: (e, t) => {
    var n;
    if (e.delim === ".")
      n = lf(t, []);
    else {
      n = Qs.sizedDelim(e.delim, 1, t, e.mode, []);
      var r = {
        delim: e.delim,
        options: t
      };
      n.isMiddle = r;
    }
    return n;
  },
  mathmlBuilder: (e, t) => {
    var n = e.delim === "\\vert" || e.delim === "|" ? ga("|", "text") : ga(e.delim, e.mode), r = new Ge.MathNode("mo", [n]);
    return r.setAttribute("fence", "true"), r.setAttribute("lspace", "0.05em"), r.setAttribute("rspace", "0.05em"), r;
  }
});
var My = (e, t) => {
  var n = Ee.wrapFragment(pn(e.body, t), t), r = e.label.slice(1), i = t.sizeMultiplier, o, a = 0, s = Nt.isCharacterBox(e.body);
  if (r === "sout")
    o = Ee.makeSpan(["stretchy", "sout"]), o.height = t.fontMetrics().defaultRuleThickness / i, a = -0.5 * t.fontMetrics().xHeight;
  else if (r === "phase") {
    var l = cr({
      number: 0.6,
      unit: "pt"
    }, t), u = cr({
      number: 0.35,
      unit: "ex"
    }, t), d = t.havingBaseSizing();
    i = i / d.sizeMultiplier;
    var p = n.height + n.depth + l + u;
    n.style.paddingLeft = it(p / 2 + l);
    var f = Math.floor(1e3 * p * i), m = xse(f), y = new dl([new xu("phase", m)], {
      width: "400em",
      height: it(f / 1e3),
      viewBox: "0 0 400000 " + f,
      preserveAspectRatio: "xMinYMin slice"
    });
    o = Ee.makeSvgSpan(["hide-tail"], [y], t), o.style.height = it(p), a = n.depth + l + u;
  } else {
    /cancel/.test(r) ? s || n.classes.push("cancel-pad") : r === "angl" ? n.classes.push("anglpad") : n.classes.push("boxpad");
    var g = 0, x = 0, E = 0;
    /box/.test(r) ? (E = Math.max(
      t.fontMetrics().fboxrule,
      // default
      t.minRuleThickness
      // User override.
    ), g = t.fontMetrics().fboxsep + (r === "colorbox" ? 0 : E), x = g) : r === "angl" ? (E = Math.max(t.fontMetrics().defaultRuleThickness, t.minRuleThickness), g = 4 * E, x = Math.max(0, 0.25 - n.depth)) : (g = s ? 0.2 : 0, x = g), o = fl.encloseSpan(n, r, g, x, t), /fbox|boxed|fcolorbox/.test(r) ? (o.style.borderStyle = "solid", o.style.borderWidth = it(E)) : r === "angl" && E !== 0.049 && (o.style.borderTopWidth = it(E), o.style.borderRightWidth = it(E)), a = n.depth + x, e.backgroundColor && (o.style.backgroundColor = e.backgroundColor, e.borderColor && (o.style.borderColor = e.borderColor));
  }
  var b;
  if (e.backgroundColor)
    b = Ee.makeVList({
      positionType: "individualShift",
      children: [
        // Put the color background behind inner;
        {
          type: "elem",
          elem: o,
          shift: a
        },
        {
          type: "elem",
          elem: n,
          shift: 0
        }
      ]
    }, t);
  else {
    var C = /cancel|phase/.test(r) ? ["svg-align"] : [];
    b = Ee.makeVList({
      positionType: "individualShift",
      children: [
        // Write the \cancel stroke on top of inner.
        {
          type: "elem",
          elem: n,
          shift: 0
        },
        {
          type: "elem",
          elem: o,
          shift: a,
          wrapperClasses: C
        }
      ]
    }, t);
  }
  return /cancel/.test(r) && (b.height = n.height, b.depth = n.depth), /cancel/.test(r) && !s ? Ee.makeSpan(["mord", "cancel-lap"], [b], t) : Ee.makeSpan(["mord"], [b], t);
}, By = (e, t) => {
  var n = 0, r = new Ge.MathNode(e.label.indexOf("colorbox") > -1 ? "mpadded" : "menclose", [On(e.body, t)]);
  switch (e.label) {
    case "\\cancel":
      r.setAttribute("notation", "updiagonalstrike");
      break;
    case "\\bcancel":
      r.setAttribute("notation", "downdiagonalstrike");
      break;
    case "\\phase":
      r.setAttribute("notation", "phasorangle");
      break;
    case "\\sout":
      r.setAttribute("notation", "horizontalstrike");
      break;
    case "\\fbox":
      r.setAttribute("notation", "box");
      break;
    case "\\angl":
      r.setAttribute("notation", "actuarial");
      break;
    case "\\fcolorbox":
    case "\\colorbox":
      if (n = t.fontMetrics().fboxsep * t.fontMetrics().ptPerEm, r.setAttribute("width", "+" + 2 * n + "pt"), r.setAttribute("height", "+" + 2 * n + "pt"), r.setAttribute("lspace", n + "pt"), r.setAttribute("voffset", n + "pt"), e.label === "\\fcolorbox") {
        var i = Math.max(
          t.fontMetrics().fboxrule,
          // default
          t.minRuleThickness
          // user override
        );
        r.setAttribute("style", "border: " + i + "em solid " + String(e.borderColor));
      }
      break;
    case "\\xcancel":
      r.setAttribute("notation", "updiagonalstrike downdiagonalstrike");
      break;
  }
  return e.backgroundColor && r.setAttribute("mathbackground", e.backgroundColor), r;
};
ht({
  type: "enclose",
  names: ["\\colorbox"],
  props: {
    numArgs: 2,
    allowedInText: !0,
    argTypes: ["color", "text"]
  },
  handler(e, t, n) {
    var {
      parser: r,
      funcName: i
    } = e, o = en(t[0], "color-token").color, a = t[1];
    return {
      type: "enclose",
      mode: r.mode,
      label: i,
      backgroundColor: o,
      body: a
    };
  },
  htmlBuilder: My,
  mathmlBuilder: By
});
ht({
  type: "enclose",
  names: ["\\fcolorbox"],
  props: {
    numArgs: 3,
    allowedInText: !0,
    argTypes: ["color", "color", "text"]
  },
  handler(e, t, n) {
    var {
      parser: r,
      funcName: i
    } = e, o = en(t[0], "color-token").color, a = en(t[1], "color-token").color, s = t[2];
    return {
      type: "enclose",
      mode: r.mode,
      label: i,
      backgroundColor: a,
      borderColor: o,
      body: s
    };
  },
  htmlBuilder: My,
  mathmlBuilder: By
});
ht({
  type: "enclose",
  names: ["\\fbox"],
  props: {
    numArgs: 1,
    argTypes: ["hbox"],
    allowedInText: !0
  },
  handler(e, t) {
    var {
      parser: n
    } = e;
    return {
      type: "enclose",
      mode: n.mode,
      label: "\\fbox",
      body: t[0]
    };
  }
});
ht({
  type: "enclose",
  names: ["\\cancel", "\\bcancel", "\\xcancel", "\\sout", "\\phase"],
  props: {
    numArgs: 1
  },
  handler(e, t) {
    var {
      parser: n,
      funcName: r
    } = e, i = t[0];
    return {
      type: "enclose",
      mode: n.mode,
      label: r,
      body: i
    };
  },
  htmlBuilder: My,
  mathmlBuilder: By
});
ht({
  type: "enclose",
  names: ["\\angl"],
  props: {
    numArgs: 1,
    argTypes: ["hbox"],
    allowedInText: !1
  },
  handler(e, t) {
    var {
      parser: n
    } = e;
    return {
      type: "enclose",
      mode: n.mode,
      label: "\\angl",
      body: t[0]
    };
  }
});
var pF = {};
function ys(e) {
  for (var {
    type: t,
    names: n,
    props: r,
    handler: i,
    htmlBuilder: o,
    mathmlBuilder: a
  } = e, s = {
    type: t,
    numArgs: r.numArgs || 0,
    allowedInText: !1,
    numOptionalArgs: 0,
    handler: i
  }, l = 0; l < n.length; ++l)
    pF[n[l]] = s;
  o && (Wm[t] = o), a && (Zm[t] = a);
}
var fF = {};
function Z(e, t) {
  fF[e] = t;
}
function E9(e) {
  var t = [];
  e.consumeSpaces();
  var n = e.fetch().text;
  for (n === "\\relax" && (e.consume(), e.consumeSpaces(), n = e.fetch().text); n === "\\hline" || n === "\\hdashline"; )
    e.consume(), t.push(n === "\\hdashline"), e.consumeSpaces(), n = e.fetch().text;
  return t;
}
var C2 = (e) => {
  var t = e.parser.settings;
  if (!t.displayMode)
    throw new Ye("{" + e.envName + "} can be used only in display mode.");
};
function Iy(e) {
  if (e.indexOf("ed") === -1)
    return e.indexOf("*") === -1;
}
function Ou(e, t, n) {
  var {
    hskipBeforeAndAfter: r,
    addJot: i,
    cols: o,
    arraystretch: a,
    colSeparationType: s,
    autoTag: l,
    singleRow: u,
    emptySingleRow: d,
    maxNumCols: p,
    leqno: f
  } = t;
  if (e.gullet.beginGroup(), u || e.gullet.macros.set("\\cr", "\\\\\\relax"), !a) {
    var m = e.gullet.expandMacroAsText("\\arraystretch");
    if (m == null)
      a = 1;
    else if (a = parseFloat(m), !a || a < 0)
      throw new Ye("Invalid \\arraystretch: " + m);
  }
  e.gullet.beginGroup();
  var y = [], g = [y], x = [], E = [], b = l != null ? [] : void 0;
  function C() {
    l && e.gullet.macros.set("\\@eqnsw", "1", !0);
  }
  function T() {
    b && (e.gullet.macros.get("\\df@tag") ? (b.push(e.subparse([new ca("\\df@tag")])), e.gullet.macros.set("\\df@tag", void 0, !0)) : b.push(!!l && e.gullet.macros.get("\\@eqnsw") === "1"));
  }
  for (C(), E.push(E9(e)); ; ) {
    var z = e.parseExpression(!1, u ? "\\end" : "\\\\");
    e.gullet.endGroup(), e.gullet.beginGroup(), z = {
      type: "ordgroup",
      mode: e.mode,
      body: z
    }, n && (z = {
      type: "styling",
      mode: e.mode,
      style: n,
      body: [z]
    }), y.push(z);
    var I = e.fetch().text;
    if (I === "&") {
      if (p && y.length === p) {
        if (u || s)
          throw new Ye("Too many tab characters: &", e.nextToken);
        e.settings.reportNonstrict("textEnv", "Too few columns specified in the {array} column argument.");
      }
      e.consume();
    } else if (I === "\\end") {
      T(), y.length === 1 && z.type === "styling" && z.body[0].body.length === 0 && (g.length > 1 || !d) && g.pop(), E.length < g.length + 1 && E.push([]);
      break;
    } else if (I === "\\\\") {
      e.consume();
      var w = void 0;
      e.gullet.future().text !== " " && (w = e.parseSizeGroup(!0)), x.push(w ? w.value : null), T(), E.push(E9(e)), y = [], g.push(y), C();
    } else
      throw new Ye("Expected & or \\\\ or \\cr or \\end", e.nextToken);
  }
  return e.gullet.endGroup(), e.gullet.endGroup(), {
    type: "array",
    mode: e.mode,
    addJot: i,
    arraystretch: a,
    body: g,
    cols: o,
    rowGaps: x,
    hskipBeforeAndAfter: r,
    hLinesBeforeRow: E,
    colSeparationType: s,
    tags: b,
    leqno: f
  };
}
function Ry(e) {
  return e.slice(0, 1) === "d" ? "display" : "text";
}
var xs = function(e, t) {
  var n, r, i = e.body.length, o = e.hLinesBeforeRow, a = 0, s = new Array(i), l = [], u = Math.max(
    // From LaTeX \showthe\arrayrulewidth. Equals 0.04 em.
    t.fontMetrics().arrayRuleWidth,
    t.minRuleThickness
    // User override.
  ), d = 1 / t.fontMetrics().ptPerEm, p = 5 * d;
  if (e.colSeparationType && e.colSeparationType === "small") {
    var f = t.havingStyle(zt.SCRIPT).sizeMultiplier;
    p = 0.2778 * (f / t.sizeMultiplier);
  }
  var m = e.colSeparationType === "CD" ? cr({
    number: 3,
    unit: "ex"
  }, t) : 12 * d, y = 3 * d, g = e.arraystretch * m, x = 0.7 * g, E = 0.3 * g, b = 0;
  function C(At) {
    for (var Gt = 0; Gt < At.length; ++Gt)
      Gt > 0 && (b += 0.25), l.push({
        pos: b,
        isDashed: At[Gt]
      });
  }
  for (C(o[0]), n = 0; n < e.body.length; ++n) {
    var T = e.body[n], z = x, I = E;
    a < T.length && (a = T.length);
    var w = new Array(T.length);
    for (r = 0; r < T.length; ++r) {
      var M = pn(T[r], t);
      I < M.depth && (I = M.depth), z < M.height && (z = M.height), w[r] = M;
    }
    var R = e.rowGaps[n], F = 0;
    R && (F = cr(R, t), F > 0 && (F += E, I < F && (I = F), F = 0)), e.addJot && (I += y), w.height = z, w.depth = I, b += z, w.pos = b, b += I + F, s[n] = w, C(o[n + 1]);
  }
  var W = b / 2 + t.fontMetrics().axisHeight, X = e.cols || [], le = [], ne, fe, D = [];
  if (e.tags && e.tags.some((At) => At))
    for (n = 0; n < i; ++n) {
      var j = s[n], de = j.pos - W, ye = e.tags[n], Ne = void 0;
      ye === !0 ? Ne = Ee.makeSpan(["eqn-num"], [], t) : ye === !1 ? Ne = Ee.makeSpan([], [], t) : Ne = Ee.makeSpan([], Hr(ye, t, !0), t), Ne.depth = j.depth, Ne.height = j.height, D.push({
        type: "elem",
        elem: Ne,
        shift: de
      });
    }
  for (
    r = 0, fe = 0;
    // Continue while either there are more columns or more column
    // descriptions, so trailing separators don't get lost.
    r < a || fe < X.length;
    ++r, ++fe
  ) {
    for (var Me = X[fe] || {}, Ie = !0; Me.type === "separator"; ) {
      if (Ie || (ne = Ee.makeSpan(["arraycolsep"], []), ne.style.width = it(t.fontMetrics().doubleRuleSep), le.push(ne)), Me.separator === "|" || Me.separator === ":") {
        var at = Me.separator === "|" ? "solid" : "dashed", Ve = Ee.makeSpan(["vertical-separator"], [], t);
        Ve.style.height = it(b), Ve.style.borderRightWidth = it(u), Ve.style.borderRightStyle = at, Ve.style.margin = "0 " + it(-u / 2);
        var mt = b - W;
        mt && (Ve.style.verticalAlign = it(-mt)), le.push(Ve);
      } else
        throw new Ye("Invalid separator type: " + Me.separator);
      fe++, Me = X[fe] || {}, Ie = !1;
    }
    if (!(r >= a)) {
      var ae = void 0;
      (r > 0 || e.hskipBeforeAndAfter) && (ae = Nt.deflt(Me.pregap, p), ae !== 0 && (ne = Ee.makeSpan(["arraycolsep"], []), ne.style.width = it(ae), le.push(ne)));
      var Se = [];
      for (n = 0; n < i; ++n) {
        var Ae = s[n], Be = Ae[r];
        if (Be) {
          var Ze = Ae.pos - W;
          Be.depth = Ae.depth, Be.height = Ae.height, Se.push({
            type: "elem",
            elem: Be,
            shift: Ze
          });
        }
      }
      Se = Ee.makeVList({
        positionType: "individualShift",
        children: Se
      }, t), Se = Ee.makeSpan(["col-align-" + (Me.align || "c")], [Se]), le.push(Se), (r < a - 1 || e.hskipBeforeAndAfter) && (ae = Nt.deflt(Me.postgap, p), ae !== 0 && (ne = Ee.makeSpan(["arraycolsep"], []), ne.style.width = it(ae), le.push(ne)));
    }
  }
  if (s = Ee.makeSpan(["mtable"], le), l.length > 0) {
    for (var We = Ee.makeLineSpan("hline", t, u), St = Ee.makeLineSpan("hdashline", t, u), pt = [{
      type: "elem",
      elem: s,
      shift: 0
    }]; l.length > 0; ) {
      var Tt = l.pop(), Wt = Tt.pos - W;
      Tt.isDashed ? pt.push({
        type: "elem",
        elem: St,
        shift: Wt
      }) : pt.push({
        type: "elem",
        elem: We,
        shift: Wt
      });
    }
    s = Ee.makeVList({
      positionType: "individualShift",
      children: pt
    }, t);
  }
  if (D.length === 0)
    return Ee.makeSpan(["mord"], [s], t);
  var et = Ee.makeVList({
    positionType: "individualShift",
    children: D
  }, t);
  return et = Ee.makeSpan(["tag"], [et], t), Ee.makeFragment([s, et]);
}, Ale = {
  c: "center ",
  l: "left ",
  r: "right "
}, bs = function(e, t) {
  for (var n = [], r = new Ge.MathNode("mtd", [], ["mtr-glue"]), i = new Ge.MathNode("mtd", [], ["mml-eqn-num"]), o = 0; o < e.body.length; o++) {
    for (var a = e.body[o], s = [], l = 0; l < a.length; l++)
      s.push(new Ge.MathNode("mtd", [On(a[l], t)]));
    e.tags && e.tags[o] && (s.unshift(r), s.push(r), e.leqno ? s.unshift(i) : s.push(i)), n.push(new Ge.MathNode("mtr", s));
  }
  var u = new Ge.MathNode("mtable", n), d = e.arraystretch === 0.5 ? 0.1 : 0.16 + e.arraystretch - 1 + (e.addJot ? 0.09 : 0);
  u.setAttribute("rowspacing", it(d));
  var p = "", f = "";
  if (e.cols && e.cols.length > 0) {
    var m = e.cols, y = "", g = !1, x = 0, E = m.length;
    m[0].type === "separator" && (p += "top ", x = 1), m[m.length - 1].type === "separator" && (p += "bottom ", E -= 1);
    for (var b = x; b < E; b++)
      m[b].type === "align" ? (f += Ale[m[b].align], g && (y += "none "), g = !0) : m[b].type === "separator" && g && (y += m[b].separator === "|" ? "solid " : "dashed ", g = !1);
    u.setAttribute("columnalign", f.trim()), /[sd]/.test(y) && u.setAttribute("columnlines", y.trim());
  }
  if (e.colSeparationType === "align") {
    for (var C = e.cols || [], T = "", z = 1; z < C.length; z++)
      T += z % 2 ? "0em " : "1em ";
    u.setAttribute("columnspacing", T.trim());
  } else e.colSeparationType === "alignat" || e.colSeparationType === "gather" ? u.setAttribute("columnspacing", "0em") : e.colSeparationType === "small" ? u.setAttribute("columnspacing", "0.2778em") : e.colSeparationType === "CD" ? u.setAttribute("columnspacing", "0.5em") : u.setAttribute("columnspacing", "1em");
  var I = "", w = e.hLinesBeforeRow;
  p += w[0].length > 0 ? "left " : "", p += w[w.length - 1].length > 0 ? "right " : "";
  for (var M = 1; M < w.length - 1; M++)
    I += w[M].length === 0 ? "none " : w[M][0] ? "dashed " : "solid ";
  return /[sd]/.test(I) && u.setAttribute("rowlines", I.trim()), p !== "" && (u = new Ge.MathNode("menclose", [u]), u.setAttribute("notation", p.trim())), e.arraystretch && e.arraystretch < 1 && (u = new Ge.MathNode("mstyle", [u]), u.setAttribute("scriptlevel", "1")), u;
}, hF = function(e, t) {
  e.envName.indexOf("ed") === -1 && C2(e);
  var n = [], r = e.envName.indexOf("at") > -1 ? "alignat" : "align", i = e.envName === "split", o = Ou(e.parser, {
    cols: n,
    addJot: !0,
    autoTag: i ? void 0 : Iy(e.envName),
    emptySingleRow: !0,
    colSeparationType: r,
    maxNumCols: i ? 2 : void 0,
    leqno: e.parser.settings.leqno
  }, "display"), a, s = 0, l = {
    type: "ordgroup",
    mode: e.mode,
    body: []
  };
  if (t[0] && t[0].type === "ordgroup") {
    for (var u = "", d = 0; d < t[0].body.length; d++) {
      var p = en(t[0].body[d], "textord");
      u += p.text;
    }
    a = Number(u), s = a * 2;
  }
  var f = !s;
  o.body.forEach(function(x) {
    for (var E = 1; E < x.length; E += 2) {
      var b = en(x[E], "styling"), C = en(b.body[0], "ordgroup");
      C.body.unshift(l);
    }
    if (f)
      s < x.length && (s = x.length);
    else {
      var T = x.length / 2;
      if (a < T)
        throw new Ye("Too many math in a row: " + ("expected " + a + ", but got " + T), x[0]);
    }
  });
  for (var m = 0; m < s; ++m) {
    var y = "r", g = 0;
    m % 2 === 1 ? y = "l" : m > 0 && f && (g = 1), n[m] = {
      type: "align",
      align: y,
      pregap: g,
      postgap: 0
    };
  }
  return o.colSeparationType = f ? "align" : "alignat", o;
};
ys({
  type: "array",
  names: ["array", "darray"],
  props: {
    numArgs: 1
  },
  handler(e, t) {
    var n = x2(t[0]), r = n ? [t[0]] : en(t[0], "ordgroup").body, i = r.map(function(a) {
      var s = zy(a), l = s.text;
      if ("lcr".indexOf(l) !== -1)
        return {
          type: "align",
          align: l
        };
      if (l === "|")
        return {
          type: "separator",
          separator: "|"
        };
      if (l === ":")
        return {
          type: "separator",
          separator: ":"
        };
      throw new Ye("Unknown column alignment: " + l, a);
    }), o = {
      cols: i,
      hskipBeforeAndAfter: !0,
      // \@preamble in lttab.dtx
      maxNumCols: i.length
    };
    return Ou(e.parser, o, Ry(e.envName));
  },
  htmlBuilder: xs,
  mathmlBuilder: bs
});
ys({
  type: "array",
  names: ["matrix", "pmatrix", "bmatrix", "Bmatrix", "vmatrix", "Vmatrix", "matrix*", "pmatrix*", "bmatrix*", "Bmatrix*", "vmatrix*", "Vmatrix*"],
  props: {
    numArgs: 0
  },
  handler(e) {
    var t = {
      matrix: null,
      pmatrix: ["(", ")"],
      bmatrix: ["[", "]"],
      Bmatrix: ["\\{", "\\}"],
      vmatrix: ["|", "|"],
      Vmatrix: ["\\Vert", "\\Vert"]
    }[e.envName.replace("*", "")], n = "c", r = {
      hskipBeforeAndAfter: !1,
      cols: [{
        type: "align",
        align: n
      }]
    };
    if (e.envName.charAt(e.envName.length - 1) === "*") {
      var i = e.parser;
      if (i.consumeSpaces(), i.fetch().text === "[") {
        if (i.consume(), i.consumeSpaces(), n = i.fetch().text, "lcr".indexOf(n) === -1)
          throw new Ye("Expected l or c or r", i.nextToken);
        i.consume(), i.consumeSpaces(), i.expect("]"), i.consume(), r.cols = [{
          type: "align",
          align: n
        }];
      }
    }
    var o = Ou(e.parser, r, Ry(e.envName)), a = Math.max(0, ...o.body.map((s) => s.length));
    return o.cols = new Array(a).fill({
      type: "align",
      align: n
    }), t ? {
      type: "leftright",
      mode: e.mode,
      body: [o],
      left: t[0],
      right: t[1],
      rightColor: void 0
      // \right uninfluenced by \color in array
    } : o;
  },
  htmlBuilder: xs,
  mathmlBuilder: bs
});
ys({
  type: "array",
  names: ["smallmatrix"],
  props: {
    numArgs: 0
  },
  handler(e) {
    var t = {
      arraystretch: 0.5
    }, n = Ou(e.parser, t, "script");
    return n.colSeparationType = "small", n;
  },
  htmlBuilder: xs,
  mathmlBuilder: bs
});
ys({
  type: "array",
  names: ["subarray"],
  props: {
    numArgs: 1
  },
  handler(e, t) {
    var n = x2(t[0]), r = n ? [t[0]] : en(t[0], "ordgroup").body, i = r.map(function(a) {
      var s = zy(a), l = s.text;
      if ("lc".indexOf(l) !== -1)
        return {
          type: "align",
          align: l
        };
      throw new Ye("Unknown column alignment: " + l, a);
    });
    if (i.length > 1)
      throw new Ye("{subarray} can contain only one column");
    var o = {
      cols: i,
      hskipBeforeAndAfter: !1,
      arraystretch: 0.5
    };
    if (o = Ou(e.parser, o, "script"), o.body.length > 0 && o.body[0].length > 1)
      throw new Ye("{subarray} can contain only one column");
    return o;
  },
  htmlBuilder: xs,
  mathmlBuilder: bs
});
ys({
  type: "array",
  names: ["cases", "dcases", "rcases", "drcases"],
  props: {
    numArgs: 0
  },
  handler(e) {
    var t = {
      arraystretch: 1.2,
      cols: [{
        type: "align",
        align: "l",
        pregap: 0,
        // TODO(kevinb) get the current style.
        // For now we use the metrics for TEXT style which is what we were
        // doing before.  Before attempting to get the current style we
        // should look at TeX's behavior especially for \over and matrices.
        postgap: 1
        /* 1em quad */
      }, {
        type: "align",
        align: "l",
        pregap: 0,
        postgap: 0
      }]
    }, n = Ou(e.parser, t, Ry(e.envName));
    return {
      type: "leftright",
      mode: e.mode,
      body: [n],
      left: e.envName.indexOf("r") > -1 ? "." : "\\{",
      right: e.envName.indexOf("r") > -1 ? "\\}" : ".",
      rightColor: void 0
    };
  },
  htmlBuilder: xs,
  mathmlBuilder: bs
});
ys({
  type: "array",
  names: ["align", "align*", "aligned", "split"],
  props: {
    numArgs: 0
  },
  handler: hF,
  htmlBuilder: xs,
  mathmlBuilder: bs
});
ys({
  type: "array",
  names: ["gathered", "gather", "gather*"],
  props: {
    numArgs: 0
  },
  handler(e) {
    Nt.contains(["gather", "gather*"], e.envName) && C2(e);
    var t = {
      cols: [{
        type: "align",
        align: "c"
      }],
      addJot: !0,
      colSeparationType: "gather",
      autoTag: Iy(e.envName),
      emptySingleRow: !0,
      leqno: e.parser.settings.leqno
    };
    return Ou(e.parser, t, "display");
  },
  htmlBuilder: xs,
  mathmlBuilder: bs
});
ys({
  type: "array",
  names: ["alignat", "alignat*", "alignedat"],
  props: {
    numArgs: 1
  },
  handler: hF,
  htmlBuilder: xs,
  mathmlBuilder: bs
});
ys({
  type: "array",
  names: ["equation", "equation*"],
  props: {
    numArgs: 0
  },
  handler(e) {
    C2(e);
    var t = {
      autoTag: Iy(e.envName),
      emptySingleRow: !0,
      singleRow: !0,
      maxNumCols: 1,
      leqno: e.parser.settings.leqno
    };
    return Ou(e.parser, t, "display");
  },
  htmlBuilder: xs,
  mathmlBuilder: bs
});
ys({
  type: "array",
  names: ["CD"],
  props: {
    numArgs: 0
  },
  handler(e) {
    return C2(e), fle(e.parser);
  },
  htmlBuilder: xs,
  mathmlBuilder: bs
});
Z("\\nonumber", "\\gdef\\@eqnsw{0}");
Z("\\notag", "\\nonumber");
ht({
  type: "text",
  // Doesn't matter what this is.
  names: ["\\hline", "\\hdashline"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !0
  },
  handler(e, t) {
    throw new Ye(e.funcName + " valid only within array environment");
  }
});
var S9 = pF;
ht({
  type: "environment",
  names: ["\\begin", "\\end"],
  props: {
    numArgs: 1,
    argTypes: ["text"]
  },
  handler(e, t) {
    var {
      parser: n,
      funcName: r
    } = e, i = t[0];
    if (i.type !== "ordgroup")
      throw new Ye("Invalid environment name", i);
    for (var o = "", a = 0; a < i.body.length; ++a)
      o += en(i.body[a], "textord").text;
    if (r === "\\begin") {
      if (!S9.hasOwnProperty(o))
        throw new Ye("No such environment: " + o, i);
      var s = S9[o], {
        args: l,
        optArgs: u
      } = n.parseArguments("\\begin{" + o + "}", s), d = {
        mode: n.mode,
        envName: o,
        parser: n
      }, p = s.handler(d, l, u);
      n.expect("\\end", !1);
      var f = n.nextToken, m = en(n.parseFunction(), "environment");
      if (m.name !== o)
        throw new Ye("Mismatch: \\begin{" + o + "} matched by \\end{" + m.name + "}", f);
      return p;
    }
    return {
      type: "environment",
      mode: n.mode,
      name: o,
      nameGroup: i
    };
  }
});
var mF = (e, t) => {
  var n = e.font, r = t.withFont(n);
  return pn(e.body, r);
}, gF = (e, t) => {
  var n = e.font, r = t.withFont(n);
  return On(e.body, r);
}, D9 = {
  "\\Bbb": "\\mathbb",
  "\\bold": "\\mathbf",
  "\\frak": "\\mathfrak",
  "\\bm": "\\boldsymbol"
};
ht({
  type: "font",
  names: [
    // styles, except \boldsymbol defined below
    "\\mathrm",
    "\\mathit",
    "\\mathbf",
    "\\mathnormal",
    // families
    "\\mathbb",
    "\\mathcal",
    "\\mathfrak",
    "\\mathscr",
    "\\mathsf",
    "\\mathtt",
    // aliases, except \bm defined below
    "\\Bbb",
    "\\bold",
    "\\frak"
  ],
  props: {
    numArgs: 1,
    allowedInArgument: !0
  },
  handler: (e, t) => {
    var {
      parser: n,
      funcName: r
    } = e, i = Gm(t[0]), o = r;
    return o in D9 && (o = D9[o]), {
      type: "font",
      mode: n.mode,
      font: o.slice(1),
      body: i
    };
  },
  htmlBuilder: mF,
  mathmlBuilder: gF
});
ht({
  type: "mclass",
  names: ["\\boldsymbol", "\\bm"],
  props: {
    numArgs: 1
  },
  handler: (e, t) => {
    var {
      parser: n
    } = e, r = t[0], i = Nt.isCharacterBox(r);
    return {
      type: "mclass",
      mode: n.mode,
      mclass: b2(r),
      body: [{
        type: "font",
        mode: n.mode,
        font: "boldsymbol",
        body: r
      }],
      isCharacterBox: i
    };
  }
});
ht({
  type: "font",
  names: ["\\rm", "\\sf", "\\tt", "\\bf", "\\it", "\\cal"],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: n,
      funcName: r,
      breakOnTokenText: i
    } = e, {
      mode: o
    } = n, a = n.parseExpression(!0, i), s = "math" + r.slice(1);
    return {
      type: "font",
      mode: o,
      font: s,
      body: {
        type: "ordgroup",
        mode: n.mode,
        body: a
      }
    };
  },
  htmlBuilder: mF,
  mathmlBuilder: gF
});
var vF = (e, t) => {
  var n = t;
  return e === "display" ? n = n.id >= zt.SCRIPT.id ? n.text() : zt.DISPLAY : e === "text" && n.size === zt.DISPLAY.size ? n = zt.TEXT : e === "script" ? n = zt.SCRIPT : e === "scriptscript" && (n = zt.SCRIPTSCRIPT), n;
}, Py = (e, t) => {
  var n = vF(e.size, t.style), r = n.fracNum(), i = n.fracDen(), o;
  o = t.havingStyle(r);
  var a = pn(e.numer, o, t);
  if (e.continued) {
    var s = 8.5 / t.fontMetrics().ptPerEm, l = 3.5 / t.fontMetrics().ptPerEm;
    a.height = a.height < s ? s : a.height, a.depth = a.depth < l ? l : a.depth;
  }
  o = t.havingStyle(i);
  var u = pn(e.denom, o, t), d, p, f;
  e.hasBarLine ? (e.barSize ? (p = cr(e.barSize, t), d = Ee.makeLineSpan("frac-line", t, p)) : d = Ee.makeLineSpan("frac-line", t), p = d.height, f = d.height) : (d = null, p = 0, f = t.fontMetrics().defaultRuleThickness);
  var m, y, g;
  n.size === zt.DISPLAY.size || e.size === "display" ? (m = t.fontMetrics().num1, p > 0 ? y = 3 * f : y = 7 * f, g = t.fontMetrics().denom1) : (p > 0 ? (m = t.fontMetrics().num2, y = f) : (m = t.fontMetrics().num3, y = 3 * f), g = t.fontMetrics().denom2);
  var x;
  if (d) {
    var E = t.fontMetrics().axisHeight;
    m - a.depth - (E + 0.5 * p) < y && (m += y - (m - a.depth - (E + 0.5 * p))), E - 0.5 * p - (u.height - g) < y && (g += y - (E - 0.5 * p - (u.height - g)));
    var b = -(E - 0.5 * p);
    x = Ee.makeVList({
      positionType: "individualShift",
      children: [{
        type: "elem",
        elem: u,
        shift: g
      }, {
        type: "elem",
        elem: d,
        shift: b
      }, {
        type: "elem",
        elem: a,
        shift: -m
      }]
    }, t);
  } else {
    var C = m - a.depth - (u.height - g);
    C < y && (m += 0.5 * (y - C), g += 0.5 * (y - C)), x = Ee.makeVList({
      positionType: "individualShift",
      children: [{
        type: "elem",
        elem: u,
        shift: g
      }, {
        type: "elem",
        elem: a,
        shift: -m
      }]
    }, t);
  }
  o = t.havingStyle(n), x.height *= o.sizeMultiplier / t.sizeMultiplier, x.depth *= o.sizeMultiplier / t.sizeMultiplier;
  var T;
  n.size === zt.DISPLAY.size ? T = t.fontMetrics().delim1 : n.size === zt.SCRIPTSCRIPT.size ? T = t.havingStyle(zt.SCRIPT).fontMetrics().delim2 : T = t.fontMetrics().delim2;
  var z, I;
  return e.leftDelim == null ? z = lf(t, ["mopen"]) : z = Qs.customSizedDelim(e.leftDelim, T, !0, t.havingStyle(n), e.mode, ["mopen"]), e.continued ? I = Ee.makeSpan([]) : e.rightDelim == null ? I = lf(t, ["mclose"]) : I = Qs.customSizedDelim(e.rightDelim, T, !0, t.havingStyle(n), e.mode, ["mclose"]), Ee.makeSpan(["mord"].concat(o.sizingClasses(t)), [z, Ee.makeSpan(["mfrac"], [x]), I], t);
}, _y = (e, t) => {
  var n = new Ge.MathNode("mfrac", [On(e.numer, t), On(e.denom, t)]);
  if (!e.hasBarLine)
    n.setAttribute("linethickness", "0px");
  else if (e.barSize) {
    var r = cr(e.barSize, t);
    n.setAttribute("linethickness", it(r));
  }
  var i = vF(e.size, t.style);
  if (i.size !== t.style.size) {
    n = new Ge.MathNode("mstyle", [n]);
    var o = i.size === zt.DISPLAY.size ? "true" : "false";
    n.setAttribute("displaystyle", o), n.setAttribute("scriptlevel", "0");
  }
  if (e.leftDelim != null || e.rightDelim != null) {
    var a = [];
    if (e.leftDelim != null) {
      var s = new Ge.MathNode("mo", [new Ge.TextNode(e.leftDelim.replace("\\", ""))]);
      s.setAttribute("fence", "true"), a.push(s);
    }
    if (a.push(n), e.rightDelim != null) {
      var l = new Ge.MathNode("mo", [new Ge.TextNode(e.rightDelim.replace("\\", ""))]);
      l.setAttribute("fence", "true"), a.push(l);
    }
    return Ny(a);
  }
  return n;
};
ht({
  type: "genfrac",
  names: [
    "\\dfrac",
    "\\frac",
    "\\tfrac",
    "\\dbinom",
    "\\binom",
    "\\tbinom",
    "\\\\atopfrac",
    // can’t be entered directly
    "\\\\bracefrac",
    "\\\\brackfrac"
    // ditto
  ],
  props: {
    numArgs: 2,
    allowedInArgument: !0
  },
  handler: (e, t) => {
    var {
      parser: n,
      funcName: r
    } = e, i = t[0], o = t[1], a, s = null, l = null, u = "auto";
    switch (r) {
      case "\\dfrac":
      case "\\frac":
      case "\\tfrac":
        a = !0;
        break;
      case "\\\\atopfrac":
        a = !1;
        break;
      case "\\dbinom":
      case "\\binom":
      case "\\tbinom":
        a = !1, s = "(", l = ")";
        break;
      case "\\\\bracefrac":
        a = !1, s = "\\{", l = "\\}";
        break;
      case "\\\\brackfrac":
        a = !1, s = "[", l = "]";
        break;
      default:
        throw new Error("Unrecognized genfrac command");
    }
    switch (r) {
      case "\\dfrac":
      case "\\dbinom":
        u = "display";
        break;
      case "\\tfrac":
      case "\\tbinom":
        u = "text";
        break;
    }
    return {
      type: "genfrac",
      mode: n.mode,
      continued: !1,
      numer: i,
      denom: o,
      hasBarLine: a,
      leftDelim: s,
      rightDelim: l,
      size: u,
      barSize: null
    };
  },
  htmlBuilder: Py,
  mathmlBuilder: _y
});
ht({
  type: "genfrac",
  names: ["\\cfrac"],
  props: {
    numArgs: 2
  },
  handler: (e, t) => {
    var {
      parser: n,
      funcName: r
    } = e, i = t[0], o = t[1];
    return {
      type: "genfrac",
      mode: n.mode,
      continued: !0,
      numer: i,
      denom: o,
      hasBarLine: !0,
      leftDelim: null,
      rightDelim: null,
      size: "display",
      barSize: null
    };
  }
});
ht({
  type: "infix",
  names: ["\\over", "\\choose", "\\atop", "\\brace", "\\brack"],
  props: {
    numArgs: 0,
    infix: !0
  },
  handler(e) {
    var {
      parser: t,
      funcName: n,
      token: r
    } = e, i;
    switch (n) {
      case "\\over":
        i = "\\frac";
        break;
      case "\\choose":
        i = "\\binom";
        break;
      case "\\atop":
        i = "\\\\atopfrac";
        break;
      case "\\brace":
        i = "\\\\bracefrac";
        break;
      case "\\brack":
        i = "\\\\brackfrac";
        break;
      default:
        throw new Error("Unrecognized infix genfrac command");
    }
    return {
      type: "infix",
      mode: t.mode,
      replaceWith: i,
      token: r
    };
  }
});
var A9 = ["display", "text", "script", "scriptscript"], T9 = function(e) {
  var t = null;
  return e.length > 0 && (t = e, t = t === "." ? null : t), t;
};
ht({
  type: "genfrac",
  names: ["\\genfrac"],
  props: {
    numArgs: 6,
    allowedInArgument: !0,
    argTypes: ["math", "math", "size", "text", "math", "math"]
  },
  handler(e, t) {
    var {
      parser: n
    } = e, r = t[4], i = t[5], o = Gm(t[0]), a = o.type === "atom" && o.family === "open" ? T9(o.text) : null, s = Gm(t[1]), l = s.type === "atom" && s.family === "close" ? T9(s.text) : null, u = en(t[2], "size"), d, p = null;
    u.isBlank ? d = !0 : (p = u.value, d = p.number > 0);
    var f = "auto", m = t[3];
    if (m.type === "ordgroup") {
      if (m.body.length > 0) {
        var y = en(m.body[0], "textord");
        f = A9[Number(y.text)];
      }
    } else
      m = en(m, "textord"), f = A9[Number(m.text)];
    return {
      type: "genfrac",
      mode: n.mode,
      numer: r,
      denom: i,
      continued: !1,
      hasBarLine: d,
      barSize: p,
      leftDelim: a,
      rightDelim: l,
      size: f
    };
  },
  htmlBuilder: Py,
  mathmlBuilder: _y
});
ht({
  type: "infix",
  names: ["\\above"],
  props: {
    numArgs: 1,
    argTypes: ["size"],
    infix: !0
  },
  handler(e, t) {
    var {
      parser: n,
      funcName: r,
      token: i
    } = e;
    return {
      type: "infix",
      mode: n.mode,
      replaceWith: "\\\\abovefrac",
      size: en(t[0], "size").value,
      token: i
    };
  }
});
ht({
  type: "genfrac",
  names: ["\\\\abovefrac"],
  props: {
    numArgs: 3,
    argTypes: ["math", "size", "math"]
  },
  handler: (e, t) => {
    var {
      parser: n,
      funcName: r
    } = e, i = t[0], o = ise(en(t[1], "infix").size), a = t[2], s = o.number > 0;
    return {
      type: "genfrac",
      mode: n.mode,
      numer: i,
      denom: a,
      continued: !1,
      hasBarLine: s,
      barSize: o,
      leftDelim: null,
      rightDelim: null,
      size: "auto"
    };
  },
  htmlBuilder: Py,
  mathmlBuilder: _y
});
var yF = (e, t) => {
  var n = t.style, r, i;
  e.type === "supsub" ? (r = e.sup ? pn(e.sup, t.havingStyle(n.sup()), t) : pn(e.sub, t.havingStyle(n.sub()), t), i = en(e.base, "horizBrace")) : i = en(e, "horizBrace");
  var o = pn(i.base, t.havingBaseStyle(zt.DISPLAY)), a = fl.svgSpan(i, t), s;
  if (i.isOver ? (s = Ee.makeVList({
    positionType: "firstBaseline",
    children: [{
      type: "elem",
      elem: o
    }, {
      type: "kern",
      size: 0.1
    }, {
      type: "elem",
      elem: a
    }]
  }, t), s.children[0].children[0].children[1].classes.push("svg-align")) : (s = Ee.makeVList({
    positionType: "bottom",
    positionData: o.depth + 0.1 + a.height,
    children: [{
      type: "elem",
      elem: a
    }, {
      type: "kern",
      size: 0.1
    }, {
      type: "elem",
      elem: o
    }]
  }, t), s.children[0].children[0].children[0].classes.push("svg-align")), r) {
    var l = Ee.makeSpan(["mord", i.isOver ? "mover" : "munder"], [s], t);
    i.isOver ? s = Ee.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: l
      }, {
        type: "kern",
        size: 0.2
      }, {
        type: "elem",
        elem: r
      }]
    }, t) : s = Ee.makeVList({
      positionType: "bottom",
      positionData: l.depth + 0.2 + r.height + r.depth,
      children: [{
        type: "elem",
        elem: r
      }, {
        type: "kern",
        size: 0.2
      }, {
        type: "elem",
        elem: l
      }]
    }, t);
  }
  return Ee.makeSpan(["mord", i.isOver ? "mover" : "munder"], [s], t);
}, Tle = (e, t) => {
  var n = fl.mathMLnode(e.label);
  return new Ge.MathNode(e.isOver ? "mover" : "munder", [On(e.base, t), n]);
};
ht({
  type: "horizBrace",
  names: ["\\overbrace", "\\underbrace"],
  props: {
    numArgs: 1
  },
  handler(e, t) {
    var {
      parser: n,
      funcName: r
    } = e;
    return {
      type: "horizBrace",
      mode: n.mode,
      label: r,
      isOver: /^\\over/.test(r),
      base: t[0]
    };
  },
  htmlBuilder: yF,
  mathmlBuilder: Tle
});
ht({
  type: "href",
  names: ["\\href"],
  props: {
    numArgs: 2,
    argTypes: ["url", "original"],
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: n
    } = e, r = t[1], i = en(t[0], "url").url;
    return n.settings.isTrusted({
      command: "\\href",
      url: i
    }) ? {
      type: "href",
      mode: n.mode,
      href: i,
      body: Sr(r)
    } : n.formatUnsupportedCmd("\\href");
  },
  htmlBuilder: (e, t) => {
    var n = Hr(e.body, t, !1);
    return Ee.makeAnchor(e.href, [], n, t);
  },
  mathmlBuilder: (e, t) => {
    var n = bu(e.body, t);
    return n instanceof na || (n = new na("mrow", [n])), n.setAttribute("href", e.href), n;
  }
});
ht({
  type: "href",
  names: ["\\url"],
  props: {
    numArgs: 1,
    argTypes: ["url"],
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: n
    } = e, r = en(t[0], "url").url;
    if (!n.settings.isTrusted({
      command: "\\url",
      url: r
    }))
      return n.formatUnsupportedCmd("\\url");
    for (var i = [], o = 0; o < r.length; o++) {
      var a = r[o];
      a === "~" && (a = "\\textasciitilde"), i.push({
        type: "textord",
        mode: "text",
        text: a
      });
    }
    var s = {
      type: "text",
      mode: n.mode,
      font: "\\texttt",
      body: i
    };
    return {
      type: "href",
      mode: n.mode,
      href: r,
      body: Sr(s)
    };
  }
});
ht({
  type: "hbox",
  names: ["\\hbox"],
  props: {
    numArgs: 1,
    argTypes: ["text"],
    allowedInText: !0,
    primitive: !0
  },
  handler(e, t) {
    var {
      parser: n
    } = e;
    return {
      type: "hbox",
      mode: n.mode,
      body: Sr(t[0])
    };
  },
  htmlBuilder(e, t) {
    var n = Hr(e.body, t, !1);
    return Ee.makeFragment(n);
  },
  mathmlBuilder(e, t) {
    return new Ge.MathNode("mrow", lo(e.body, t));
  }
});
ht({
  type: "html",
  names: ["\\htmlClass", "\\htmlId", "\\htmlStyle", "\\htmlData"],
  props: {
    numArgs: 2,
    argTypes: ["raw", "original"],
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: n,
      funcName: r,
      token: i
    } = e, o = en(t[0], "raw").string, a = t[1];
    n.settings.strict && n.settings.reportNonstrict("htmlExtension", "HTML extension is disabled on strict mode");
    var s, l = {};
    switch (r) {
      case "\\htmlClass":
        l.class = o, s = {
          command: "\\htmlClass",
          class: o
        };
        break;
      case "\\htmlId":
        l.id = o, s = {
          command: "\\htmlId",
          id: o
        };
        break;
      case "\\htmlStyle":
        l.style = o, s = {
          command: "\\htmlStyle",
          style: o
        };
        break;
      case "\\htmlData": {
        for (var u = o.split(","), d = 0; d < u.length; d++) {
          var p = u[d].split("=");
          if (p.length !== 2)
            throw new Ye("Error parsing key-value for \\htmlData");
          l["data-" + p[0].trim()] = p[1].trim();
        }
        s = {
          command: "\\htmlData",
          attributes: l
        };
        break;
      }
      default:
        throw new Error("Unrecognized html command");
    }
    return n.settings.isTrusted(s) ? {
      type: "html",
      mode: n.mode,
      attributes: l,
      body: Sr(a)
    } : n.formatUnsupportedCmd(r);
  },
  htmlBuilder: (e, t) => {
    var n = Hr(e.body, t, !1), r = ["enclosing"];
    e.attributes.class && r.push(...e.attributes.class.trim().split(/\s+/));
    var i = Ee.makeSpan(r, n, t);
    for (var o in e.attributes)
      o !== "class" && e.attributes.hasOwnProperty(o) && i.setAttribute(o, e.attributes[o]);
    return i;
  },
  mathmlBuilder: (e, t) => bu(e.body, t)
});
ht({
  type: "htmlmathml",
  names: ["\\html@mathml"],
  props: {
    numArgs: 2,
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: n
    } = e;
    return {
      type: "htmlmathml",
      mode: n.mode,
      html: Sr(t[0]),
      mathml: Sr(t[1])
    };
  },
  htmlBuilder: (e, t) => {
    var n = Hr(e.html, t, !1);
    return Ee.makeFragment(n);
  },
  mathmlBuilder: (e, t) => bu(e.mathml, t)
});
var l3 = function(e) {
  if (/^[-+]? *(\d+(\.\d*)?|\.\d+)$/.test(e))
    return {
      number: +e,
      unit: "bp"
    };
  var t = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(e);
  if (!t)
    throw new Ye("Invalid size: '" + e + "' in \\includegraphics");
  var n = {
    number: +(t[1] + t[2]),
    // sign + magnitude, cast to number
    unit: t[3]
  };
  if (!Iz(n))
    throw new Ye("Invalid unit: '" + n.unit + "' in \\includegraphics.");
  return n;
};
ht({
  type: "includegraphics",
  names: ["\\includegraphics"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1,
    argTypes: ["raw", "url"],
    allowedInText: !1
  },
  handler: (e, t, n) => {
    var {
      parser: r
    } = e, i = {
      number: 0,
      unit: "em"
    }, o = {
      number: 0.9,
      unit: "em"
    }, a = {
      number: 0,
      unit: "em"
    }, s = "";
    if (n[0])
      for (var l = en(n[0], "raw").string, u = l.split(","), d = 0; d < u.length; d++) {
        var p = u[d].split("=");
        if (p.length === 2) {
          var f = p[1].trim();
          switch (p[0].trim()) {
            case "alt":
              s = f;
              break;
            case "width":
              i = l3(f);
              break;
            case "height":
              o = l3(f);
              break;
            case "totalheight":
              a = l3(f);
              break;
            default:
              throw new Ye("Invalid key: '" + p[0] + "' in \\includegraphics.");
          }
        }
      }
    var m = en(t[0], "url").url;
    return s === "" && (s = m, s = s.replace(/^.*[\\/]/, ""), s = s.substring(0, s.lastIndexOf("."))), r.settings.isTrusted({
      command: "\\includegraphics",
      url: m
    }) ? {
      type: "includegraphics",
      mode: r.mode,
      alt: s,
      width: i,
      height: o,
      totalheight: a,
      src: m
    } : r.formatUnsupportedCmd("\\includegraphics");
  },
  htmlBuilder: (e, t) => {
    var n = cr(e.height, t), r = 0;
    e.totalheight.number > 0 && (r = cr(e.totalheight, t) - n);
    var i = 0;
    e.width.number > 0 && (i = cr(e.width, t));
    var o = {
      height: it(n + r)
    };
    i > 0 && (o.width = it(i)), r > 0 && (o.verticalAlign = it(-r));
    var a = new Tse(e.src, e.alt, o);
    return a.height = n, a.depth = r, a;
  },
  mathmlBuilder: (e, t) => {
    var n = new Ge.MathNode("mglyph", []);
    n.setAttribute("alt", e.alt);
    var r = cr(e.height, t), i = 0;
    if (e.totalheight.number > 0 && (i = cr(e.totalheight, t) - r, n.setAttribute("valign", it(-i))), n.setAttribute("height", it(r + i)), e.width.number > 0) {
      var o = cr(e.width, t);
      n.setAttribute("width", it(o));
    }
    return n.setAttribute("src", e.src), n;
  }
});
ht({
  type: "kern",
  names: ["\\kern", "\\mkern", "\\hskip", "\\mskip"],
  props: {
    numArgs: 1,
    argTypes: ["size"],
    primitive: !0,
    allowedInText: !0
  },
  handler(e, t) {
    var {
      parser: n,
      funcName: r
    } = e, i = en(t[0], "size");
    if (n.settings.strict) {
      var o = r[1] === "m", a = i.value.unit === "mu";
      o ? (a || n.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + r + " supports only mu units, " + ("not " + i.value.unit + " units")), n.mode !== "math" && n.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + r + " works only in math mode")) : a && n.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + r + " doesn't support mu units");
    }
    return {
      type: "kern",
      mode: n.mode,
      dimension: i.value
    };
  },
  htmlBuilder(e, t) {
    return Ee.makeGlue(e.dimension, t);
  },
  mathmlBuilder(e, t) {
    var n = cr(e.dimension, t);
    return new Ge.SpaceNode(n);
  }
});
ht({
  type: "lap",
  names: ["\\mathllap", "\\mathrlap", "\\mathclap"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: n,
      funcName: r
    } = e, i = t[0];
    return {
      type: "lap",
      mode: n.mode,
      alignment: r.slice(5),
      body: i
    };
  },
  htmlBuilder: (e, t) => {
    var n;
    e.alignment === "clap" ? (n = Ee.makeSpan([], [pn(e.body, t)]), n = Ee.makeSpan(["inner"], [n], t)) : n = Ee.makeSpan(["inner"], [pn(e.body, t)]);
    var r = Ee.makeSpan(["fix"], []), i = Ee.makeSpan([e.alignment], [n, r], t), o = Ee.makeSpan(["strut"]);
    return o.style.height = it(i.height + i.depth), i.depth && (o.style.verticalAlign = it(-i.depth)), i.children.unshift(o), i = Ee.makeSpan(["thinbox"], [i], t), Ee.makeSpan(["mord", "vbox"], [i], t);
  },
  mathmlBuilder: (e, t) => {
    var n = new Ge.MathNode("mpadded", [On(e.body, t)]);
    if (e.alignment !== "rlap") {
      var r = e.alignment === "llap" ? "-1" : "-0.5";
      n.setAttribute("lspace", r + "width");
    }
    return n.setAttribute("width", "0px"), n;
  }
});
ht({
  type: "styling",
  names: ["\\(", "$"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !1
  },
  handler(e, t) {
    var {
      funcName: n,
      parser: r
    } = e, i = r.mode;
    r.switchMode("math");
    var o = n === "\\(" ? "\\)" : "$", a = r.parseExpression(!1, o);
    return r.expect(o), r.switchMode(i), {
      type: "styling",
      mode: r.mode,
      style: "text",
      body: a
    };
  }
});
ht({
  type: "text",
  // Doesn't matter what this is.
  names: ["\\)", "\\]"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !1
  },
  handler(e, t) {
    throw new Ye("Mismatched " + e.funcName);
  }
});
var j9 = (e, t) => {
  switch (t.style.size) {
    case zt.DISPLAY.size:
      return e.display;
    case zt.TEXT.size:
      return e.text;
    case zt.SCRIPT.size:
      return e.script;
    case zt.SCRIPTSCRIPT.size:
      return e.scriptscript;
    default:
      return e.text;
  }
};
ht({
  type: "mathchoice",
  names: ["\\mathchoice"],
  props: {
    numArgs: 4,
    primitive: !0
  },
  handler: (e, t) => {
    var {
      parser: n
    } = e;
    return {
      type: "mathchoice",
      mode: n.mode,
      display: Sr(t[0]),
      text: Sr(t[1]),
      script: Sr(t[2]),
      scriptscript: Sr(t[3])
    };
  },
  htmlBuilder: (e, t) => {
    var n = j9(e, t), r = Hr(n, t, !1);
    return Ee.makeFragment(r);
  },
  mathmlBuilder: (e, t) => {
    var n = j9(e, t);
    return bu(n, t);
  }
});
var xF = (e, t, n, r, i, o, a) => {
  e = Ee.makeSpan([], [e]);
  var s = n && Nt.isCharacterBox(n), l, u;
  if (t) {
    var d = pn(t, r.havingStyle(i.sup()), r);
    u = {
      elem: d,
      kern: Math.max(r.fontMetrics().bigOpSpacing1, r.fontMetrics().bigOpSpacing3 - d.depth)
    };
  }
  if (n) {
    var p = pn(n, r.havingStyle(i.sub()), r);
    l = {
      elem: p,
      kern: Math.max(r.fontMetrics().bigOpSpacing2, r.fontMetrics().bigOpSpacing4 - p.height)
    };
  }
  var f;
  if (u && l) {
    var m = r.fontMetrics().bigOpSpacing5 + l.elem.height + l.elem.depth + l.kern + e.depth + a;
    f = Ee.makeVList({
      positionType: "bottom",
      positionData: m,
      children: [{
        type: "kern",
        size: r.fontMetrics().bigOpSpacing5
      }, {
        type: "elem",
        elem: l.elem,
        marginLeft: it(-o)
      }, {
        type: "kern",
        size: l.kern
      }, {
        type: "elem",
        elem: e
      }, {
        type: "kern",
        size: u.kern
      }, {
        type: "elem",
        elem: u.elem,
        marginLeft: it(o)
      }, {
        type: "kern",
        size: r.fontMetrics().bigOpSpacing5
      }]
    }, r);
  } else if (l) {
    var y = e.height - a;
    f = Ee.makeVList({
      positionType: "top",
      positionData: y,
      children: [{
        type: "kern",
        size: r.fontMetrics().bigOpSpacing5
      }, {
        type: "elem",
        elem: l.elem,
        marginLeft: it(-o)
      }, {
        type: "kern",
        size: l.kern
      }, {
        type: "elem",
        elem: e
      }]
    }, r);
  } else if (u) {
    var g = e.depth + a;
    f = Ee.makeVList({
      positionType: "bottom",
      positionData: g,
      children: [{
        type: "elem",
        elem: e
      }, {
        type: "kern",
        size: u.kern
      }, {
        type: "elem",
        elem: u.elem,
        marginLeft: it(o)
      }, {
        type: "kern",
        size: r.fontMetrics().bigOpSpacing5
      }]
    }, r);
  } else
    return e;
  var x = [f];
  if (l && o !== 0 && !s) {
    var E = Ee.makeSpan(["mspace"], [], r);
    E.style.marginRight = it(o), x.unshift(E);
  }
  return Ee.makeSpan(["mop", "op-limits"], x, r);
}, bF = ["\\smallint"], xd = (e, t) => {
  var n, r, i = !1, o;
  e.type === "supsub" ? (n = e.sup, r = e.sub, o = en(e.base, "op"), i = !0) : o = en(e, "op");
  var a = t.style, s = !1;
  a.size === zt.DISPLAY.size && o.symbol && !Nt.contains(bF, o.name) && (s = !0);
  var l;
  if (o.symbol) {
    var u = s ? "Size2-Regular" : "Size1-Regular", d = "";
    if ((o.name === "\\oiint" || o.name === "\\oiiint") && (d = o.name.slice(1), o.name = d === "oiint" ? "\\iint" : "\\iiint"), l = Ee.makeSymbol(o.name, u, "math", t, ["mop", "op-symbol", s ? "large-op" : "small-op"]), d.length > 0) {
      var p = l.italic, f = Ee.staticSvg(d + "Size" + (s ? "2" : "1"), t);
      l = Ee.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: l,
          shift: 0
        }, {
          type: "elem",
          elem: f,
          shift: s ? 0.08 : 0
        }]
      }, t), o.name = "\\" + d, l.classes.unshift("mop"), l.italic = p;
    }
  } else if (o.body) {
    var m = Hr(o.body, t, !0);
    m.length === 1 && m[0] instanceof ma ? (l = m[0], l.classes[0] = "mop") : l = Ee.makeSpan(["mop"], m, t);
  } else {
    for (var y = [], g = 1; g < o.name.length; g++)
      y.push(Ee.mathsym(o.name[g], o.mode, t));
    l = Ee.makeSpan(["mop"], y, t);
  }
  var x = 0, E = 0;
  return (l instanceof ma || o.name === "\\oiint" || o.name === "\\oiiint") && !o.suppressBaseShift && (x = (l.height - l.depth) / 2 - t.fontMetrics().axisHeight, E = l.italic), i ? xF(l, n, r, t, a, E, x) : (x && (l.style.position = "relative", l.style.top = it(x)), l);
}, Vf = (e, t) => {
  var n;
  if (e.symbol)
    n = new na("mo", [ga(e.name, e.mode)]), Nt.contains(bF, e.name) && n.setAttribute("largeop", "false");
  else if (e.body)
    n = new na("mo", lo(e.body, t));
  else {
    n = new na("mi", [new kp(e.name.slice(1))]);
    var r = new na("mo", [ga("⁡", "text")]);
    e.parentIsSupSub ? n = new na("mrow", [n, r]) : n = Gz([n, r]);
  }
  return n;
}, jle = {
  "∏": "\\prod",
  "∐": "\\coprod",
  "∑": "\\sum",
  "⋀": "\\bigwedge",
  "⋁": "\\bigvee",
  "⋂": "\\bigcap",
  "⋃": "\\bigcup",
  "⨀": "\\bigodot",
  "⨁": "\\bigoplus",
  "⨂": "\\bigotimes",
  "⨄": "\\biguplus",
  "⨆": "\\bigsqcup"
};
ht({
  type: "op",
  names: ["\\coprod", "\\bigvee", "\\bigwedge", "\\biguplus", "\\bigcap", "\\bigcup", "\\intop", "\\prod", "\\sum", "\\bigotimes", "\\bigoplus", "\\bigodot", "\\bigsqcup", "\\smallint", "∏", "∐", "∑", "⋀", "⋁", "⋂", "⋃", "⨀", "⨁", "⨂", "⨄", "⨆"],
  props: {
    numArgs: 0
  },
  handler: (e, t) => {
    var {
      parser: n,
      funcName: r
    } = e, i = r;
    return i.length === 1 && (i = jle[i]), {
      type: "op",
      mode: n.mode,
      limits: !0,
      parentIsSupSub: !1,
      symbol: !0,
      name: i
    };
  },
  htmlBuilder: xd,
  mathmlBuilder: Vf
});
ht({
  type: "op",
  names: ["\\mathop"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (e, t) => {
    var {
      parser: n
    } = e, r = t[0];
    return {
      type: "op",
      mode: n.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !1,
      body: Sr(r)
    };
  },
  htmlBuilder: xd,
  mathmlBuilder: Vf
});
var Nle = {
  "∫": "\\int",
  "∬": "\\iint",
  "∭": "\\iiint",
  "∮": "\\oint",
  "∯": "\\oiint",
  "∰": "\\oiiint"
};
ht({
  type: "op",
  names: ["\\arcsin", "\\arccos", "\\arctan", "\\arctg", "\\arcctg", "\\arg", "\\ch", "\\cos", "\\cosec", "\\cosh", "\\cot", "\\cotg", "\\coth", "\\csc", "\\ctg", "\\cth", "\\deg", "\\dim", "\\exp", "\\hom", "\\ker", "\\lg", "\\ln", "\\log", "\\sec", "\\sin", "\\sinh", "\\sh", "\\tan", "\\tanh", "\\tg", "\\th"],
  props: {
    numArgs: 0
  },
  handler(e) {
    var {
      parser: t,
      funcName: n
    } = e;
    return {
      type: "op",
      mode: t.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !1,
      name: n
    };
  },
  htmlBuilder: xd,
  mathmlBuilder: Vf
});
ht({
  type: "op",
  names: ["\\det", "\\gcd", "\\inf", "\\lim", "\\max", "\\min", "\\Pr", "\\sup"],
  props: {
    numArgs: 0
  },
  handler(e) {
    var {
      parser: t,
      funcName: n
    } = e;
    return {
      type: "op",
      mode: t.mode,
      limits: !0,
      parentIsSupSub: !1,
      symbol: !1,
      name: n
    };
  },
  htmlBuilder: xd,
  mathmlBuilder: Vf
});
ht({
  type: "op",
  names: ["\\int", "\\iint", "\\iiint", "\\oint", "\\oiint", "\\oiiint", "∫", "∬", "∭", "∮", "∯", "∰"],
  props: {
    numArgs: 0
  },
  handler(e) {
    var {
      parser: t,
      funcName: n
    } = e, r = n;
    return r.length === 1 && (r = Nle[r]), {
      type: "op",
      mode: t.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !0,
      name: r
    };
  },
  htmlBuilder: xd,
  mathmlBuilder: Vf
});
var wF = (e, t) => {
  var n, r, i = !1, o;
  e.type === "supsub" ? (n = e.sup, r = e.sub, o = en(e.base, "operatorname"), i = !0) : o = en(e, "operatorname");
  var a;
  if (o.body.length > 0) {
    for (var s = o.body.map((p) => {
      var f = p.text;
      return typeof f == "string" ? {
        type: "textord",
        mode: p.mode,
        text: f
      } : p;
    }), l = Hr(s, t.withFont("mathrm"), !0), u = 0; u < l.length; u++) {
      var d = l[u];
      d instanceof ma && (d.text = d.text.replace(/\u2212/, "-").replace(/\u2217/, "*"));
    }
    a = Ee.makeSpan(["mop"], l, t);
  } else
    a = Ee.makeSpan(["mop"], [], t);
  return i ? xF(a, n, r, t, t.style, 0, 0) : a;
}, Ole = (e, t) => {
  for (var n = lo(e.body, t.withFont("mathrm")), r = !0, i = 0; i < n.length; i++) {
    var o = n[i];
    if (!(o instanceof Ge.SpaceNode)) if (o instanceof Ge.MathNode)
      switch (o.type) {
        case "mi":
        case "mn":
        case "ms":
        case "mspace":
        case "mtext":
          break;
        case "mo": {
          var a = o.children[0];
          o.children.length === 1 && a instanceof Ge.TextNode ? a.text = a.text.replace(/\u2212/, "-").replace(/\u2217/, "*") : r = !1;
          break;
        }
        default:
          r = !1;
      }
    else
      r = !1;
  }
  if (r) {
    var s = n.map((d) => d.toText()).join("");
    n = [new Ge.TextNode(s)];
  }
  var l = new Ge.MathNode("mi", n);
  l.setAttribute("mathvariant", "normal");
  var u = new Ge.MathNode("mo", [ga("⁡", "text")]);
  return e.parentIsSupSub ? new Ge.MathNode("mrow", [l, u]) : Ge.newDocumentFragment([l, u]);
};
ht({
  type: "operatorname",
  names: ["\\operatorname@", "\\operatornamewithlimits"],
  props: {
    numArgs: 1
  },
  handler: (e, t) => {
    var {
      parser: n,
      funcName: r
    } = e, i = t[0];
    return {
      type: "operatorname",
      mode: n.mode,
      body: Sr(i),
      alwaysHandleSupSub: r === "\\operatornamewithlimits",
      limits: !1,
      parentIsSupSub: !1
    };
  },
  htmlBuilder: wF,
  mathmlBuilder: Ole
});
Z("\\operatorname", "\\@ifstar\\operatornamewithlimits\\operatorname@");
Pc({
  type: "ordgroup",
  htmlBuilder(e, t) {
    return e.semisimple ? Ee.makeFragment(Hr(e.body, t, !1)) : Ee.makeSpan(["mord"], Hr(e.body, t, !0), t);
  },
  mathmlBuilder(e, t) {
    return bu(e.body, t, !0);
  }
});
ht({
  type: "overline",
  names: ["\\overline"],
  props: {
    numArgs: 1
  },
  handler(e, t) {
    var {
      parser: n
    } = e, r = t[0];
    return {
      type: "overline",
      mode: n.mode,
      body: r
    };
  },
  htmlBuilder(e, t) {
    var n = pn(e.body, t.havingCrampedStyle()), r = Ee.makeLineSpan("overline-line", t), i = t.fontMetrics().defaultRuleThickness, o = Ee.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: n
      }, {
        type: "kern",
        size: 3 * i
      }, {
        type: "elem",
        elem: r
      }, {
        type: "kern",
        size: i
      }]
    }, t);
    return Ee.makeSpan(["mord", "overline"], [o], t);
  },
  mathmlBuilder(e, t) {
    var n = new Ge.MathNode("mo", [new Ge.TextNode("‾")]);
    n.setAttribute("stretchy", "true");
    var r = new Ge.MathNode("mover", [On(e.body, t), n]);
    return r.setAttribute("accent", "true"), r;
  }
});
ht({
  type: "phantom",
  names: ["\\phantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: n
    } = e, r = t[0];
    return {
      type: "phantom",
      mode: n.mode,
      body: Sr(r)
    };
  },
  htmlBuilder: (e, t) => {
    var n = Hr(e.body, t.withPhantom(), !1);
    return Ee.makeFragment(n);
  },
  mathmlBuilder: (e, t) => {
    var n = lo(e.body, t);
    return new Ge.MathNode("mphantom", n);
  }
});
ht({
  type: "hphantom",
  names: ["\\hphantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: n
    } = e, r = t[0];
    return {
      type: "hphantom",
      mode: n.mode,
      body: r
    };
  },
  htmlBuilder: (e, t) => {
    var n = Ee.makeSpan([], [pn(e.body, t.withPhantom())]);
    if (n.height = 0, n.depth = 0, n.children)
      for (var r = 0; r < n.children.length; r++)
        n.children[r].height = 0, n.children[r].depth = 0;
    return n = Ee.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: n
      }]
    }, t), Ee.makeSpan(["mord"], [n], t);
  },
  mathmlBuilder: (e, t) => {
    var n = lo(Sr(e.body), t), r = new Ge.MathNode("mphantom", n), i = new Ge.MathNode("mpadded", [r]);
    return i.setAttribute("height", "0px"), i.setAttribute("depth", "0px"), i;
  }
});
ht({
  type: "vphantom",
  names: ["\\vphantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: n
    } = e, r = t[0];
    return {
      type: "vphantom",
      mode: n.mode,
      body: r
    };
  },
  htmlBuilder: (e, t) => {
    var n = Ee.makeSpan(["inner"], [pn(e.body, t.withPhantom())]), r = Ee.makeSpan(["fix"], []);
    return Ee.makeSpan(["mord", "rlap"], [n, r], t);
  },
  mathmlBuilder: (e, t) => {
    var n = lo(Sr(e.body), t), r = new Ge.MathNode("mphantom", n), i = new Ge.MathNode("mpadded", [r]);
    return i.setAttribute("width", "0px"), i;
  }
});
ht({
  type: "raisebox",
  names: ["\\raisebox"],
  props: {
    numArgs: 2,
    argTypes: ["size", "hbox"],
    allowedInText: !0
  },
  handler(e, t) {
    var {
      parser: n
    } = e, r = en(t[0], "size").value, i = t[1];
    return {
      type: "raisebox",
      mode: n.mode,
      dy: r,
      body: i
    };
  },
  htmlBuilder(e, t) {
    var n = pn(e.body, t), r = cr(e.dy, t);
    return Ee.makeVList({
      positionType: "shift",
      positionData: -r,
      children: [{
        type: "elem",
        elem: n
      }]
    }, t);
  },
  mathmlBuilder(e, t) {
    var n = new Ge.MathNode("mpadded", [On(e.body, t)]), r = e.dy.number + e.dy.unit;
    return n.setAttribute("voffset", r), n;
  }
});
ht({
  type: "internal",
  names: ["\\relax"],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler(e) {
    var {
      parser: t
    } = e;
    return {
      type: "internal",
      mode: t.mode
    };
  }
});
ht({
  type: "rule",
  names: ["\\rule"],
  props: {
    numArgs: 2,
    numOptionalArgs: 1,
    argTypes: ["size", "size", "size"]
  },
  handler(e, t, n) {
    var {
      parser: r
    } = e, i = n[0], o = en(t[0], "size"), a = en(t[1], "size");
    return {
      type: "rule",
      mode: r.mode,
      shift: i && en(i, "size").value,
      width: o.value,
      height: a.value
    };
  },
  htmlBuilder(e, t) {
    var n = Ee.makeSpan(["mord", "rule"], [], t), r = cr(e.width, t), i = cr(e.height, t), o = e.shift ? cr(e.shift, t) : 0;
    return n.style.borderRightWidth = it(r), n.style.borderTopWidth = it(i), n.style.bottom = it(o), n.width = r, n.height = i + o, n.depth = -o, n.maxFontSize = i * 1.125 * t.sizeMultiplier, n;
  },
  mathmlBuilder(e, t) {
    var n = cr(e.width, t), r = cr(e.height, t), i = e.shift ? cr(e.shift, t) : 0, o = t.color && t.getColor() || "black", a = new Ge.MathNode("mspace");
    a.setAttribute("mathbackground", o), a.setAttribute("width", it(n)), a.setAttribute("height", it(r));
    var s = new Ge.MathNode("mpadded", [a]);
    return i >= 0 ? s.setAttribute("height", it(i)) : (s.setAttribute("height", it(i)), s.setAttribute("depth", it(-i))), s.setAttribute("voffset", it(i)), s;
  }
});
function CF(e, t, n) {
  for (var r = Hr(e, t, !1), i = t.sizeMultiplier / n.sizeMultiplier, o = 0; o < r.length; o++) {
    var a = r[o].classes.indexOf("sizing");
    a < 0 ? Array.prototype.push.apply(r[o].classes, t.sizingClasses(n)) : r[o].classes[a + 1] === "reset-size" + t.size && (r[o].classes[a + 1] = "reset-size" + n.size), r[o].height *= i, r[o].depth *= i;
  }
  return Ee.makeFragment(r);
}
var N9 = ["\\tiny", "\\sixptsize", "\\scriptsize", "\\footnotesize", "\\small", "\\normalsize", "\\large", "\\Large", "\\LARGE", "\\huge", "\\Huge"], zle = (e, t) => {
  var n = t.havingSize(e.size);
  return CF(e.body, n, t);
};
ht({
  type: "sizing",
  names: N9,
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      breakOnTokenText: n,
      funcName: r,
      parser: i
    } = e, o = i.parseExpression(!1, n);
    return {
      type: "sizing",
      mode: i.mode,
      // Figure out what size to use based on the list of functions above
      size: N9.indexOf(r) + 1,
      body: o
    };
  },
  htmlBuilder: zle,
  mathmlBuilder: (e, t) => {
    var n = t.havingSize(e.size), r = lo(e.body, n), i = new Ge.MathNode("mstyle", r);
    return i.setAttribute("mathsize", it(n.sizeMultiplier)), i;
  }
});
ht({
  type: "smash",
  names: ["\\smash"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1,
    allowedInText: !0
  },
  handler: (e, t, n) => {
    var {
      parser: r
    } = e, i = !1, o = !1, a = n[0] && en(n[0], "ordgroup");
    if (a)
      for (var s = "", l = 0; l < a.body.length; ++l) {
        var u = a.body[l];
        if (s = u.text, s === "t")
          i = !0;
        else if (s === "b")
          o = !0;
        else {
          i = !1, o = !1;
          break;
        }
      }
    else
      i = !0, o = !0;
    var d = t[0];
    return {
      type: "smash",
      mode: r.mode,
      body: d,
      smashHeight: i,
      smashDepth: o
    };
  },
  htmlBuilder: (e, t) => {
    var n = Ee.makeSpan([], [pn(e.body, t)]);
    if (!e.smashHeight && !e.smashDepth)
      return n;
    if (e.smashHeight && (n.height = 0, n.children))
      for (var r = 0; r < n.children.length; r++)
        n.children[r].height = 0;
    if (e.smashDepth && (n.depth = 0, n.children))
      for (var i = 0; i < n.children.length; i++)
        n.children[i].depth = 0;
    var o = Ee.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: n
      }]
    }, t);
    return Ee.makeSpan(["mord"], [o], t);
  },
  mathmlBuilder: (e, t) => {
    var n = new Ge.MathNode("mpadded", [On(e.body, t)]);
    return e.smashHeight && n.setAttribute("height", "0px"), e.smashDepth && n.setAttribute("depth", "0px"), n;
  }
});
ht({
  type: "sqrt",
  names: ["\\sqrt"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1
  },
  handler(e, t, n) {
    var {
      parser: r
    } = e, i = n[0], o = t[0];
    return {
      type: "sqrt",
      mode: r.mode,
      body: o,
      index: i
    };
  },
  htmlBuilder(e, t) {
    var n = pn(e.body, t.havingCrampedStyle());
    n.height === 0 && (n.height = t.fontMetrics().xHeight), n = Ee.wrapFragment(n, t);
    var r = t.fontMetrics(), i = r.defaultRuleThickness, o = i;
    t.style.id < zt.TEXT.id && (o = t.fontMetrics().xHeight);
    var a = i + o / 4, s = n.height + n.depth + a + i, {
      span: l,
      ruleWidth: u,
      advanceWidth: d
    } = Qs.sqrtImage(s, t), p = l.height - u;
    p > n.height + n.depth + a && (a = (a + p - n.height - n.depth) / 2);
    var f = l.height - n.height - a - u;
    n.style.paddingLeft = it(d);
    var m = Ee.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: n,
        wrapperClasses: ["svg-align"]
      }, {
        type: "kern",
        size: -(n.height + f)
      }, {
        type: "elem",
        elem: l
      }, {
        type: "kern",
        size: u
      }]
    }, t);
    if (e.index) {
      var y = t.havingStyle(zt.SCRIPTSCRIPT), g = pn(e.index, y, t), x = 0.6 * (m.height - m.depth), E = Ee.makeVList({
        positionType: "shift",
        positionData: -x,
        children: [{
          type: "elem",
          elem: g
        }]
      }, t), b = Ee.makeSpan(["root"], [E]);
      return Ee.makeSpan(["mord", "sqrt"], [b, m], t);
    } else
      return Ee.makeSpan(["mord", "sqrt"], [m], t);
  },
  mathmlBuilder(e, t) {
    var {
      body: n,
      index: r
    } = e;
    return r ? new Ge.MathNode("mroot", [On(n, t), On(r, t)]) : new Ge.MathNode("msqrt", [On(n, t)]);
  }
});
var O9 = {
  display: zt.DISPLAY,
  text: zt.TEXT,
  script: zt.SCRIPT,
  scriptscript: zt.SCRIPTSCRIPT
};
ht({
  type: "styling",
  names: ["\\displaystyle", "\\textstyle", "\\scriptstyle", "\\scriptscriptstyle"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(e, t) {
    var {
      breakOnTokenText: n,
      funcName: r,
      parser: i
    } = e, o = i.parseExpression(!0, n), a = r.slice(1, r.length - 5);
    return {
      type: "styling",
      mode: i.mode,
      // Figure out what style to use by pulling out the style from
      // the function name
      style: a,
      body: o
    };
  },
  htmlBuilder(e, t) {
    var n = O9[e.style], r = t.havingStyle(n).withFont("");
    return CF(e.body, r, t);
  },
  mathmlBuilder(e, t) {
    var n = O9[e.style], r = t.havingStyle(n), i = lo(e.body, r), o = new Ge.MathNode("mstyle", i), a = {
      display: ["0", "true"],
      text: ["0", "false"],
      script: ["1", "false"],
      scriptscript: ["2", "false"]
    }, s = a[e.style];
    return o.setAttribute("scriptlevel", s[0]), o.setAttribute("displaystyle", s[1]), o;
  }
});
var Fle = function(e, t) {
  var n = e.base;
  if (n)
    if (n.type === "op") {
      var r = n.limits && (t.style.size === zt.DISPLAY.size || n.alwaysHandleSupSub);
      return r ? xd : null;
    } else if (n.type === "operatorname") {
      var i = n.alwaysHandleSupSub && (t.style.size === zt.DISPLAY.size || n.limits);
      return i ? wF : null;
    } else {
      if (n.type === "accent")
        return Nt.isCharacterBox(n.base) ? Fy : null;
      if (n.type === "horizBrace") {
        var o = !e.sub;
        return o === n.isOver ? yF : null;
      } else
        return null;
    }
  else return null;
};
Pc({
  type: "supsub",
  htmlBuilder(e, t) {
    var n = Fle(e, t);
    if (n)
      return n(e, t);
    var {
      base: r,
      sup: i,
      sub: o
    } = e, a = pn(r, t), s, l, u = t.fontMetrics(), d = 0, p = 0, f = r && Nt.isCharacterBox(r);
    if (i) {
      var m = t.havingStyle(t.style.sup());
      s = pn(i, m, t), f || (d = a.height - m.fontMetrics().supDrop * m.sizeMultiplier / t.sizeMultiplier);
    }
    if (o) {
      var y = t.havingStyle(t.style.sub());
      l = pn(o, y, t), f || (p = a.depth + y.fontMetrics().subDrop * y.sizeMultiplier / t.sizeMultiplier);
    }
    var g;
    t.style === zt.DISPLAY ? g = u.sup1 : t.style.cramped ? g = u.sup3 : g = u.sup2;
    var x = t.sizeMultiplier, E = it(0.5 / u.ptPerEm / x), b = null;
    if (l) {
      var C = e.base && e.base.type === "op" && e.base.name && (e.base.name === "\\oiint" || e.base.name === "\\oiiint");
      (a instanceof ma || C) && (b = it(-a.italic));
    }
    var T;
    if (s && l) {
      d = Math.max(d, g, s.depth + 0.25 * u.xHeight), p = Math.max(p, u.sub2);
      var z = u.defaultRuleThickness, I = 4 * z;
      if (d - s.depth - (l.height - p) < I) {
        p = I - (d - s.depth) + l.height;
        var w = 0.8 * u.xHeight - (d - s.depth);
        w > 0 && (d += w, p -= w);
      }
      var M = [{
        type: "elem",
        elem: l,
        shift: p,
        marginRight: E,
        marginLeft: b
      }, {
        type: "elem",
        elem: s,
        shift: -d,
        marginRight: E
      }];
      T = Ee.makeVList({
        positionType: "individualShift",
        children: M
      }, t);
    } else if (l) {
      p = Math.max(p, u.sub1, l.height - 0.8 * u.xHeight);
      var R = [{
        type: "elem",
        elem: l,
        marginLeft: b,
        marginRight: E
      }];
      T = Ee.makeVList({
        positionType: "shift",
        positionData: p,
        children: R
      }, t);
    } else if (s)
      d = Math.max(d, g, s.depth + 0.25 * u.xHeight), T = Ee.makeVList({
        positionType: "shift",
        positionData: -d,
        children: [{
          type: "elem",
          elem: s,
          marginRight: E
        }]
      }, t);
    else
      throw new Error("supsub must have either sup or sub.");
    var F = L5(a, "right") || "mord";
    return Ee.makeSpan([F], [a, Ee.makeSpan(["msupsub"], [T])], t);
  },
  mathmlBuilder(e, t) {
    var n = !1, r, i;
    e.base && e.base.type === "horizBrace" && (i = !!e.sup, i === e.base.isOver && (n = !0, r = e.base.isOver)), e.base && (e.base.type === "op" || e.base.type === "operatorname") && (e.base.parentIsSupSub = !0);
    var o = [On(e.base, t)];
    e.sub && o.push(On(e.sub, t)), e.sup && o.push(On(e.sup, t));
    var a;
    if (n)
      a = r ? "mover" : "munder";
    else if (e.sub)
      if (e.sup) {
        var s = e.base;
        s && s.type === "op" && s.limits && t.style === zt.DISPLAY || s && s.type === "operatorname" && s.alwaysHandleSupSub && (t.style === zt.DISPLAY || s.limits) ? a = "munderover" : a = "msubsup";
      } else {
        var l = e.base;
        l && l.type === "op" && l.limits && (t.style === zt.DISPLAY || l.alwaysHandleSupSub) || l && l.type === "operatorname" && l.alwaysHandleSupSub && (l.limits || t.style === zt.DISPLAY) ? a = "munder" : a = "msub";
      }
    else {
      var u = e.base;
      u && u.type === "op" && u.limits && (t.style === zt.DISPLAY || u.alwaysHandleSupSub) || u && u.type === "operatorname" && u.alwaysHandleSupSub && (u.limits || t.style === zt.DISPLAY) ? a = "mover" : a = "msup";
    }
    return new Ge.MathNode(a, o);
  }
});
Pc({
  type: "atom",
  htmlBuilder(e, t) {
    return Ee.mathsym(e.text, e.mode, t, ["m" + e.family]);
  },
  mathmlBuilder(e, t) {
    var n = new Ge.MathNode("mo", [ga(e.text, e.mode)]);
    if (e.family === "bin") {
      var r = Oy(e, t);
      r === "bold-italic" && n.setAttribute("mathvariant", r);
    } else e.family === "punct" ? n.setAttribute("separator", "true") : (e.family === "open" || e.family === "close") && n.setAttribute("stretchy", "false");
    return n;
  }
});
var kF = {
  mi: "italic",
  mn: "normal",
  mtext: "normal"
};
Pc({
  type: "mathord",
  htmlBuilder(e, t) {
    return Ee.makeOrd(e, t, "mathord");
  },
  mathmlBuilder(e, t) {
    var n = new Ge.MathNode("mi", [ga(e.text, e.mode, t)]), r = Oy(e, t) || "italic";
    return r !== kF[n.type] && n.setAttribute("mathvariant", r), n;
  }
});
Pc({
  type: "textord",
  htmlBuilder(e, t) {
    return Ee.makeOrd(e, t, "textord");
  },
  mathmlBuilder(e, t) {
    var n = ga(e.text, e.mode, t), r = Oy(e, t) || "normal", i;
    return e.mode === "text" ? i = new Ge.MathNode("mtext", [n]) : /[0-9]/.test(e.text) ? i = new Ge.MathNode("mn", [n]) : e.text === "\\prime" ? i = new Ge.MathNode("mo", [n]) : i = new Ge.MathNode("mi", [n]), r !== kF[i.type] && i.setAttribute("mathvariant", r), i;
  }
});
var u3 = {
  "\\nobreak": "nobreak",
  "\\allowbreak": "allowbreak"
}, c3 = {
  " ": {},
  "\\ ": {},
  "~": {
    className: "nobreak"
  },
  "\\space": {},
  "\\nobreakspace": {
    className: "nobreak"
  }
};
Pc({
  type: "spacing",
  htmlBuilder(e, t) {
    if (c3.hasOwnProperty(e.text)) {
      var n = c3[e.text].className || "";
      if (e.mode === "text") {
        var r = Ee.makeOrd(e, t, "textord");
        return r.classes.push(n), r;
      } else
        return Ee.makeSpan(["mspace", n], [Ee.mathsym(e.text, e.mode, t)], t);
    } else {
      if (u3.hasOwnProperty(e.text))
        return Ee.makeSpan(["mspace", u3[e.text]], [], t);
      throw new Ye('Unknown type of space "' + e.text + '"');
    }
  },
  mathmlBuilder(e, t) {
    var n;
    if (c3.hasOwnProperty(e.text))
      n = new Ge.MathNode("mtext", [new Ge.TextNode(" ")]);
    else {
      if (u3.hasOwnProperty(e.text))
        return new Ge.MathNode("mspace");
      throw new Ye('Unknown type of space "' + e.text + '"');
    }
    return n;
  }
});
var z9 = () => {
  var e = new Ge.MathNode("mtd", []);
  return e.setAttribute("width", "50%"), e;
};
Pc({
  type: "tag",
  mathmlBuilder(e, t) {
    var n = new Ge.MathNode("mtable", [new Ge.MathNode("mtr", [z9(), new Ge.MathNode("mtd", [bu(e.body, t)]), z9(), new Ge.MathNode("mtd", [bu(e.tag, t)])])]);
    return n.setAttribute("width", "100%"), n;
  }
});
var F9 = {
  "\\text": void 0,
  "\\textrm": "textrm",
  "\\textsf": "textsf",
  "\\texttt": "texttt",
  "\\textnormal": "textrm"
}, L9 = {
  "\\textbf": "textbf",
  "\\textmd": "textmd"
}, Lle = {
  "\\textit": "textit",
  "\\textup": "textup"
}, M9 = (e, t) => {
  var n = e.font;
  if (n) {
    if (F9[n])
      return t.withTextFontFamily(F9[n]);
    if (L9[n])
      return t.withTextFontWeight(L9[n]);
    if (n === "\\emph")
      return t.fontShape === "textit" ? t.withTextFontShape("textup") : t.withTextFontShape("textit");
  } else return t;
  return t.withTextFontShape(Lle[n]);
};
ht({
  type: "text",
  names: [
    // Font families
    "\\text",
    "\\textrm",
    "\\textsf",
    "\\texttt",
    "\\textnormal",
    // Font weights
    "\\textbf",
    "\\textmd",
    // Font Shapes
    "\\textit",
    "\\textup",
    "\\emph"
  ],
  props: {
    numArgs: 1,
    argTypes: ["text"],
    allowedInArgument: !0,
    allowedInText: !0
  },
  handler(e, t) {
    var {
      parser: n,
      funcName: r
    } = e, i = t[0];
    return {
      type: "text",
      mode: n.mode,
      body: Sr(i),
      font: r
    };
  },
  htmlBuilder(e, t) {
    var n = M9(e, t), r = Hr(e.body, n, !0);
    return Ee.makeSpan(["mord", "text"], r, n);
  },
  mathmlBuilder(e, t) {
    var n = M9(e, t);
    return bu(e.body, n);
  }
});
ht({
  type: "underline",
  names: ["\\underline"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(e, t) {
    var {
      parser: n
    } = e;
    return {
      type: "underline",
      mode: n.mode,
      body: t[0]
    };
  },
  htmlBuilder(e, t) {
    var n = pn(e.body, t), r = Ee.makeLineSpan("underline-line", t), i = t.fontMetrics().defaultRuleThickness, o = Ee.makeVList({
      positionType: "top",
      positionData: n.height,
      children: [{
        type: "kern",
        size: i
      }, {
        type: "elem",
        elem: r
      }, {
        type: "kern",
        size: 3 * i
      }, {
        type: "elem",
        elem: n
      }]
    }, t);
    return Ee.makeSpan(["mord", "underline"], [o], t);
  },
  mathmlBuilder(e, t) {
    var n = new Ge.MathNode("mo", [new Ge.TextNode("‾")]);
    n.setAttribute("stretchy", "true");
    var r = new Ge.MathNode("munder", [On(e.body, t), n]);
    return r.setAttribute("accentunder", "true"), r;
  }
});
ht({
  type: "vcenter",
  names: ["\\vcenter"],
  props: {
    numArgs: 1,
    argTypes: ["original"],
    // In LaTeX, \vcenter can act only on a box.
    allowedInText: !1
  },
  handler(e, t) {
    var {
      parser: n
    } = e;
    return {
      type: "vcenter",
      mode: n.mode,
      body: t[0]
    };
  },
  htmlBuilder(e, t) {
    var n = pn(e.body, t), r = t.fontMetrics().axisHeight, i = 0.5 * (n.height - r - (n.depth + r));
    return Ee.makeVList({
      positionType: "shift",
      positionData: i,
      children: [{
        type: "elem",
        elem: n
      }]
    }, t);
  },
  mathmlBuilder(e, t) {
    return new Ge.MathNode("mpadded", [On(e.body, t)], ["vcenter"]);
  }
});
ht({
  type: "verb",
  names: ["\\verb"],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler(e, t, n) {
    throw new Ye("\\verb ended by end of line instead of matching delimiter");
  },
  htmlBuilder(e, t) {
    for (var n = B9(e), r = [], i = t.havingStyle(t.style.text()), o = 0; o < n.length; o++) {
      var a = n[o];
      a === "~" && (a = "\\textasciitilde"), r.push(Ee.makeSymbol(a, "Typewriter-Regular", e.mode, i, ["mord", "texttt"]));
    }
    return Ee.makeSpan(["mord", "text"].concat(i.sizingClasses(t)), Ee.tryCombineChars(r), i);
  },
  mathmlBuilder(e, t) {
    var n = new Ge.TextNode(B9(e)), r = new Ge.MathNode("mtext", [n]);
    return r.setAttribute("mathvariant", "monospace"), r;
  }
});
var B9 = (e) => e.body.replace(/ /g, e.star ? "␣" : " "), Gl = Wz, EF = `[ \r
	]`, Mle = "\\\\[a-zA-Z@]+", Ble = "\\\\[^\uD800-\uDFFF]", Ile = "(" + Mle + ")" + EF + "*", Rle = `\\\\(
|[ \r	]+
?)[ \r	]*`, R5 = "[̀-ͯ]", Ple = new RegExp(R5 + "+$"), _le = "(" + EF + "+)|" + // whitespace
(Rle + "|") + // \whitespace
"([!-\\[\\]-‧‪-퟿豈-￿]" + // single codepoint
(R5 + "*") + // ...plus accents
"|[\uD800-\uDBFF][\uDC00-\uDFFF]" + // surrogate pair
(R5 + "*") + // ...plus accents
"|\\\\verb\\*([^]).*?\\4|\\\\verb([^*a-zA-Z]).*?\\5" + // \verb unstarred
("|" + Ile) + // \macroName + spaces
("|" + Ble + ")");
class I9 {
  // Category codes. The lexer only supports comment characters (14) for now.
  // MacroExpander additionally distinguishes active (13).
  constructor(t, n) {
    this.input = void 0, this.settings = void 0, this.tokenRegex = void 0, this.catcodes = void 0, this.input = t, this.settings = n, this.tokenRegex = new RegExp(_le, "g"), this.catcodes = {
      "%": 14,
      // comment character
      "~": 13
      // active character
    };
  }
  setCatcode(t, n) {
    this.catcodes[t] = n;
  }
  /**
   * This function lexes a single token.
   */
  lex() {
    var t = this.input, n = this.tokenRegex.lastIndex;
    if (n === t.length)
      return new ca("EOF", new ko(this, n, n));
    var r = this.tokenRegex.exec(t);
    if (r === null || r.index !== n)
      throw new Ye("Unexpected character: '" + t[n] + "'", new ca(t[n], new ko(this, n, n + 1)));
    var i = r[6] || r[3] || (r[2] ? "\\ " : " ");
    if (this.catcodes[i] === 14) {
      var o = t.indexOf(`
`, this.tokenRegex.lastIndex);
      return o === -1 ? (this.tokenRegex.lastIndex = t.length, this.settings.reportNonstrict("commentAtEnd", "% comment has no terminating newline; LaTeX would fail because of commenting the end of math mode (e.g. $)")) : this.tokenRegex.lastIndex = o + 1, this.lex();
    }
    return new ca(i, new ko(this, n, this.tokenRegex.lastIndex));
  }
}
class qle {
  /**
   * Both arguments are optional.  The first argument is an object of
   * built-in mappings which never change.  The second argument is an object
   * of initial (global-level) mappings, which will constantly change
   * according to any global/top-level `set`s done.
   */
  constructor(t, n) {
    t === void 0 && (t = {}), n === void 0 && (n = {}), this.current = void 0, this.builtins = void 0, this.undefStack = void 0, this.current = n, this.builtins = t, this.undefStack = [];
  }
  /**
   * Start a new nested group, affecting future local `set`s.
   */
  beginGroup() {
    this.undefStack.push({});
  }
  /**
   * End current nested group, restoring values before the group began.
   */
  endGroup() {
    if (this.undefStack.length === 0)
      throw new Ye("Unbalanced namespace destruction: attempt to pop global namespace; please report this as a bug");
    var t = this.undefStack.pop();
    for (var n in t)
      t.hasOwnProperty(n) && (t[n] == null ? delete this.current[n] : this.current[n] = t[n]);
  }
  /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */
  endGroups() {
    for (; this.undefStack.length > 0; )
      this.endGroup();
  }
  /**
   * Detect whether `name` has a definition.  Equivalent to
   * `get(name) != null`.
   */
  has(t) {
    return this.current.hasOwnProperty(t) || this.builtins.hasOwnProperty(t);
  }
  /**
   * Get the current value of a name, or `undefined` if there is no value.
   *
   * Note: Do not use `if (namespace.get(...))` to detect whether a macro
   * is defined, as the definition may be the empty string which evaluates
   * to `false` in JavaScript.  Use `if (namespace.get(...) != null)` or
   * `if (namespace.has(...))`.
   */
  get(t) {
    return this.current.hasOwnProperty(t) ? this.current[t] : this.builtins[t];
  }
  /**
   * Set the current value of a name, and optionally set it globally too.
   * Local set() sets the current value and (when appropriate) adds an undo
   * operation to the undo stack.  Global set() may change the undo
   * operation at every level, so takes time linear in their number.
   * A value of undefined means to delete existing definitions.
   */
  set(t, n, r) {
    if (r === void 0 && (r = !1), r) {
      for (var i = 0; i < this.undefStack.length; i++)
        delete this.undefStack[i][t];
      this.undefStack.length > 0 && (this.undefStack[this.undefStack.length - 1][t] = n);
    } else {
      var o = this.undefStack[this.undefStack.length - 1];
      o && !o.hasOwnProperty(t) && (o[t] = this.current[t]);
    }
    n == null ? delete this.current[t] : this.current[t] = n;
  }
}
var $le = fF;
Z("\\noexpand", function(e) {
  var t = e.popToken();
  return e.isExpandable(t.text) && (t.noexpand = !0, t.treatAsRelax = !0), {
    tokens: [t],
    numArgs: 0
  };
});
Z("\\expandafter", function(e) {
  var t = e.popToken();
  return e.expandOnce(!0), {
    tokens: [t],
    numArgs: 0
  };
});
Z("\\@firstoftwo", function(e) {
  var t = e.consumeArgs(2);
  return {
    tokens: t[0],
    numArgs: 0
  };
});
Z("\\@secondoftwo", function(e) {
  var t = e.consumeArgs(2);
  return {
    tokens: t[1],
    numArgs: 0
  };
});
Z("\\@ifnextchar", function(e) {
  var t = e.consumeArgs(3);
  e.consumeSpaces();
  var n = e.future();
  return t[0].length === 1 && t[0][0].text === n.text ? {
    tokens: t[1],
    numArgs: 0
  } : {
    tokens: t[2],
    numArgs: 0
  };
});
Z("\\@ifstar", "\\@ifnextchar *{\\@firstoftwo{#1}}");
Z("\\TextOrMath", function(e) {
  var t = e.consumeArgs(2);
  return e.mode === "text" ? {
    tokens: t[0],
    numArgs: 0
  } : {
    tokens: t[1],
    numArgs: 0
  };
});
var R9 = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  a: 10,
  A: 10,
  b: 11,
  B: 11,
  c: 12,
  C: 12,
  d: 13,
  D: 13,
  e: 14,
  E: 14,
  f: 15,
  F: 15
};
Z("\\char", function(e) {
  var t = e.popToken(), n, r = "";
  if (t.text === "'")
    n = 8, t = e.popToken();
  else if (t.text === '"')
    n = 16, t = e.popToken();
  else if (t.text === "`")
    if (t = e.popToken(), t.text[0] === "\\")
      r = t.text.charCodeAt(1);
    else {
      if (t.text === "EOF")
        throw new Ye("\\char` missing argument");
      r = t.text.charCodeAt(0);
    }
  else
    n = 10;
  if (n) {
    if (r = R9[t.text], r == null || r >= n)
      throw new Ye("Invalid base-" + n + " digit " + t.text);
    for (var i; (i = R9[e.future().text]) != null && i < n; )
      r *= n, r += i, e.popToken();
  }
  return "\\@char{" + r + "}";
});
var qy = (e, t, n) => {
  var r = e.consumeArg().tokens;
  if (r.length !== 1)
    throw new Ye("\\newcommand's first argument must be a macro name");
  var i = r[0].text, o = e.isDefined(i);
  if (o && !t)
    throw new Ye("\\newcommand{" + i + "} attempting to redefine " + (i + "; use \\renewcommand"));
  if (!o && !n)
    throw new Ye("\\renewcommand{" + i + "} when command " + i + " does not yet exist; use \\newcommand");
  var a = 0;
  if (r = e.consumeArg().tokens, r.length === 1 && r[0].text === "[") {
    for (var s = "", l = e.expandNextToken(); l.text !== "]" && l.text !== "EOF"; )
      s += l.text, l = e.expandNextToken();
    if (!s.match(/^\s*[0-9]+\s*$/))
      throw new Ye("Invalid number of arguments: " + s);
    a = parseInt(s), r = e.consumeArg().tokens;
  }
  return e.macros.set(i, {
    tokens: r,
    numArgs: a
  }), "";
};
Z("\\newcommand", (e) => qy(e, !1, !0));
Z("\\renewcommand", (e) => qy(e, !0, !1));
Z("\\providecommand", (e) => qy(e, !0, !0));
Z("\\message", (e) => {
  var t = e.consumeArgs(1)[0];
  return console.log(t.reverse().map((n) => n.text).join("")), "";
});
Z("\\errmessage", (e) => {
  var t = e.consumeArgs(1)[0];
  return console.error(t.reverse().map((n) => n.text).join("")), "";
});
Z("\\show", (e) => {
  var t = e.popToken(), n = t.text;
  return console.log(t, e.macros.get(n), Gl[n], Bn.math[n], Bn.text[n]), "";
});
Z("\\bgroup", "{");
Z("\\egroup", "}");
Z("~", "\\nobreakspace");
Z("\\lq", "`");
Z("\\rq", "'");
Z("\\aa", "\\r a");
Z("\\AA", "\\r A");
Z("\\textcopyright", "\\html@mathml{\\textcircled{c}}{\\char`©}");
Z("\\copyright", "\\TextOrMath{\\textcopyright}{\\text{\\textcopyright}}");
Z("\\textregistered", "\\html@mathml{\\textcircled{\\scriptsize R}}{\\char`®}");
Z("ℬ", "\\mathscr{B}");
Z("ℰ", "\\mathscr{E}");
Z("ℱ", "\\mathscr{F}");
Z("ℋ", "\\mathscr{H}");
Z("ℐ", "\\mathscr{I}");
Z("ℒ", "\\mathscr{L}");
Z("ℳ", "\\mathscr{M}");
Z("ℛ", "\\mathscr{R}");
Z("ℭ", "\\mathfrak{C}");
Z("ℌ", "\\mathfrak{H}");
Z("ℨ", "\\mathfrak{Z}");
Z("\\Bbbk", "\\Bbb{k}");
Z("·", "\\cdotp");
Z("\\llap", "\\mathllap{\\textrm{#1}}");
Z("\\rlap", "\\mathrlap{\\textrm{#1}}");
Z("\\clap", "\\mathclap{\\textrm{#1}}");
Z("\\mathstrut", "\\vphantom{(}");
Z("\\underbar", "\\underline{\\text{#1}}");
Z("\\not", '\\html@mathml{\\mathrel{\\mathrlap\\@not}}{\\char"338}');
Z("\\neq", "\\html@mathml{\\mathrel{\\not=}}{\\mathrel{\\char`≠}}");
Z("\\ne", "\\neq");
Z("≠", "\\neq");
Z("\\notin", "\\html@mathml{\\mathrel{{\\in}\\mathllap{/\\mskip1mu}}}{\\mathrel{\\char`∉}}");
Z("∉", "\\notin");
Z("≘", "\\html@mathml{\\mathrel{=\\kern{-1em}\\raisebox{0.4em}{$\\scriptsize\\frown$}}}{\\mathrel{\\char`≘}}");
Z("≙", "\\html@mathml{\\stackrel{\\tiny\\wedge}{=}}{\\mathrel{\\char`≘}}");
Z("≚", "\\html@mathml{\\stackrel{\\tiny\\vee}{=}}{\\mathrel{\\char`≚}}");
Z("≛", "\\html@mathml{\\stackrel{\\scriptsize\\star}{=}}{\\mathrel{\\char`≛}}");
Z("≝", "\\html@mathml{\\stackrel{\\tiny\\mathrm{def}}{=}}{\\mathrel{\\char`≝}}");
Z("≞", "\\html@mathml{\\stackrel{\\tiny\\mathrm{m}}{=}}{\\mathrel{\\char`≞}}");
Z("≟", "\\html@mathml{\\stackrel{\\tiny?}{=}}{\\mathrel{\\char`≟}}");
Z("⟂", "\\perp");
Z("‼", "\\mathclose{!\\mkern-0.8mu!}");
Z("∌", "\\notni");
Z("⌜", "\\ulcorner");
Z("⌝", "\\urcorner");
Z("⌞", "\\llcorner");
Z("⌟", "\\lrcorner");
Z("©", "\\copyright");
Z("®", "\\textregistered");
Z("️", "\\textregistered");
Z("\\ulcorner", '\\html@mathml{\\@ulcorner}{\\mathop{\\char"231c}}');
Z("\\urcorner", '\\html@mathml{\\@urcorner}{\\mathop{\\char"231d}}');
Z("\\llcorner", '\\html@mathml{\\@llcorner}{\\mathop{\\char"231e}}');
Z("\\lrcorner", '\\html@mathml{\\@lrcorner}{\\mathop{\\char"231f}}');
Z("\\vdots", "\\mathord{\\varvdots\\rule{0pt}{15pt}}");
Z("⋮", "\\vdots");
Z("\\varGamma", "\\mathit{\\Gamma}");
Z("\\varDelta", "\\mathit{\\Delta}");
Z("\\varTheta", "\\mathit{\\Theta}");
Z("\\varLambda", "\\mathit{\\Lambda}");
Z("\\varXi", "\\mathit{\\Xi}");
Z("\\varPi", "\\mathit{\\Pi}");
Z("\\varSigma", "\\mathit{\\Sigma}");
Z("\\varUpsilon", "\\mathit{\\Upsilon}");
Z("\\varPhi", "\\mathit{\\Phi}");
Z("\\varPsi", "\\mathit{\\Psi}");
Z("\\varOmega", "\\mathit{\\Omega}");
Z("\\substack", "\\begin{subarray}{c}#1\\end{subarray}");
Z("\\colon", "\\nobreak\\mskip2mu\\mathpunct{}\\mathchoice{\\mkern-3mu}{\\mkern-3mu}{}{}{:}\\mskip6mu\\relax");
Z("\\boxed", "\\fbox{$\\displaystyle{#1}$}");
Z("\\iff", "\\DOTSB\\;\\Longleftrightarrow\\;");
Z("\\implies", "\\DOTSB\\;\\Longrightarrow\\;");
Z("\\impliedby", "\\DOTSB\\;\\Longleftarrow\\;");
var P9 = {
  ",": "\\dotsc",
  "\\not": "\\dotsb",
  // \keybin@ checks for the following:
  "+": "\\dotsb",
  "=": "\\dotsb",
  "<": "\\dotsb",
  ">": "\\dotsb",
  "-": "\\dotsb",
  "*": "\\dotsb",
  ":": "\\dotsb",
  // Symbols whose definition starts with \DOTSB:
  "\\DOTSB": "\\dotsb",
  "\\coprod": "\\dotsb",
  "\\bigvee": "\\dotsb",
  "\\bigwedge": "\\dotsb",
  "\\biguplus": "\\dotsb",
  "\\bigcap": "\\dotsb",
  "\\bigcup": "\\dotsb",
  "\\prod": "\\dotsb",
  "\\sum": "\\dotsb",
  "\\bigotimes": "\\dotsb",
  "\\bigoplus": "\\dotsb",
  "\\bigodot": "\\dotsb",
  "\\bigsqcup": "\\dotsb",
  "\\And": "\\dotsb",
  "\\longrightarrow": "\\dotsb",
  "\\Longrightarrow": "\\dotsb",
  "\\longleftarrow": "\\dotsb",
  "\\Longleftarrow": "\\dotsb",
  "\\longleftrightarrow": "\\dotsb",
  "\\Longleftrightarrow": "\\dotsb",
  "\\mapsto": "\\dotsb",
  "\\longmapsto": "\\dotsb",
  "\\hookrightarrow": "\\dotsb",
  "\\doteq": "\\dotsb",
  // Symbols whose definition starts with \mathbin:
  "\\mathbin": "\\dotsb",
  // Symbols whose definition starts with \mathrel:
  "\\mathrel": "\\dotsb",
  "\\relbar": "\\dotsb",
  "\\Relbar": "\\dotsb",
  "\\xrightarrow": "\\dotsb",
  "\\xleftarrow": "\\dotsb",
  // Symbols whose definition starts with \DOTSI:
  "\\DOTSI": "\\dotsi",
  "\\int": "\\dotsi",
  "\\oint": "\\dotsi",
  "\\iint": "\\dotsi",
  "\\iiint": "\\dotsi",
  "\\iiiint": "\\dotsi",
  "\\idotsint": "\\dotsi",
  // Symbols whose definition starts with \DOTSX:
  "\\DOTSX": "\\dotsx"
};
Z("\\dots", function(e) {
  var t = "\\dotso", n = e.expandAfterFuture().text;
  return n in P9 ? t = P9[n] : (n.slice(0, 4) === "\\not" || n in Bn.math && Nt.contains(["bin", "rel"], Bn.math[n].group)) && (t = "\\dotsb"), t;
});
var $y = {
  // \rightdelim@ checks for the following:
  ")": !0,
  "]": !0,
  "\\rbrack": !0,
  "\\}": !0,
  "\\rbrace": !0,
  "\\rangle": !0,
  "\\rceil": !0,
  "\\rfloor": !0,
  "\\rgroup": !0,
  "\\rmoustache": !0,
  "\\right": !0,
  "\\bigr": !0,
  "\\biggr": !0,
  "\\Bigr": !0,
  "\\Biggr": !0,
  // \extra@ also tests for the following:
  $: !0,
  // \extrap@ checks for the following:
  ";": !0,
  ".": !0,
  ",": !0
};
Z("\\dotso", function(e) {
  var t = e.future().text;
  return t in $y ? "\\ldots\\," : "\\ldots";
});
Z("\\dotsc", function(e) {
  var t = e.future().text;
  return t in $y && t !== "," ? "\\ldots\\," : "\\ldots";
});
Z("\\cdots", function(e) {
  var t = e.future().text;
  return t in $y ? "\\@cdots\\," : "\\@cdots";
});
Z("\\dotsb", "\\cdots");
Z("\\dotsm", "\\cdots");
Z("\\dotsi", "\\!\\cdots");
Z("\\dotsx", "\\ldots\\,");
Z("\\DOTSI", "\\relax");
Z("\\DOTSB", "\\relax");
Z("\\DOTSX", "\\relax");
Z("\\tmspace", "\\TextOrMath{\\kern#1#3}{\\mskip#1#2}\\relax");
Z("\\,", "\\tmspace+{3mu}{.1667em}");
Z("\\thinspace", "\\,");
Z("\\>", "\\mskip{4mu}");
Z("\\:", "\\tmspace+{4mu}{.2222em}");
Z("\\medspace", "\\:");
Z("\\;", "\\tmspace+{5mu}{.2777em}");
Z("\\thickspace", "\\;");
Z("\\!", "\\tmspace-{3mu}{.1667em}");
Z("\\negthinspace", "\\!");
Z("\\negmedspace", "\\tmspace-{4mu}{.2222em}");
Z("\\negthickspace", "\\tmspace-{5mu}{.277em}");
Z("\\enspace", "\\kern.5em ");
Z("\\enskip", "\\hskip.5em\\relax");
Z("\\quad", "\\hskip1em\\relax");
Z("\\qquad", "\\hskip2em\\relax");
Z("\\tag", "\\@ifstar\\tag@literal\\tag@paren");
Z("\\tag@paren", "\\tag@literal{({#1})}");
Z("\\tag@literal", (e) => {
  if (e.macros.get("\\df@tag"))
    throw new Ye("Multiple \\tag");
  return "\\gdef\\df@tag{\\text{#1}}";
});
Z("\\bmod", "\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}\\mathbin{\\rm mod}\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}");
Z("\\pod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern8mu}{\\mkern8mu}{\\mkern8mu}(#1)");
Z("\\pmod", "\\pod{{\\rm mod}\\mkern6mu#1}");
Z("\\mod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern12mu}{\\mkern12mu}{\\mkern12mu}{\\rm mod}\\,\\,#1");
Z("\\newline", "\\\\\\relax");
Z("\\TeX", "\\textrm{\\html@mathml{T\\kern-.1667em\\raisebox{-.5ex}{E}\\kern-.125emX}{TeX}}");
var SF = it(as["Main-Regular"][84][1] - 0.7 * as["Main-Regular"][65][1]);
Z("\\LaTeX", "\\textrm{\\html@mathml{" + ("L\\kern-.36em\\raisebox{" + SF + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{LaTeX}}");
Z("\\KaTeX", "\\textrm{\\html@mathml{" + ("K\\kern-.17em\\raisebox{" + SF + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{KaTeX}}");
Z("\\hspace", "\\@ifstar\\@hspacer\\@hspace");
Z("\\@hspace", "\\hskip #1\\relax");
Z("\\@hspacer", "\\rule{0pt}{0pt}\\hskip #1\\relax");
Z("\\ordinarycolon", ":");
Z("\\vcentcolon", "\\mathrel{\\mathop\\ordinarycolon}");
Z("\\dblcolon", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-.9mu}\\vcentcolon}}{\\mathop{\\char"2237}}');
Z("\\coloneqq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2254}}');
Z("\\Coloneqq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2237\\char"3d}}');
Z("\\coloneq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"3a\\char"2212}}');
Z("\\Coloneq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"2237\\char"2212}}');
Z("\\eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2255}}');
Z("\\Eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"3d\\char"2237}}');
Z("\\eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2239}}');
Z("\\Eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"2212\\char"2237}}');
Z("\\colonapprox", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"3a\\char"2248}}');
Z("\\Colonapprox", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"2237\\char"2248}}');
Z("\\colonsim", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"3a\\char"223c}}');
Z("\\Colonsim", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"2237\\char"223c}}');
Z("∷", "\\dblcolon");
Z("∹", "\\eqcolon");
Z("≔", "\\coloneqq");
Z("≕", "\\eqqcolon");
Z("⩴", "\\Coloneqq");
Z("\\ratio", "\\vcentcolon");
Z("\\coloncolon", "\\dblcolon");
Z("\\colonequals", "\\coloneqq");
Z("\\coloncolonequals", "\\Coloneqq");
Z("\\equalscolon", "\\eqqcolon");
Z("\\equalscoloncolon", "\\Eqqcolon");
Z("\\colonminus", "\\coloneq");
Z("\\coloncolonminus", "\\Coloneq");
Z("\\minuscolon", "\\eqcolon");
Z("\\minuscoloncolon", "\\Eqcolon");
Z("\\coloncolonapprox", "\\Colonapprox");
Z("\\coloncolonsim", "\\Colonsim");
Z("\\simcolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
Z("\\simcoloncolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\dblcolon}");
Z("\\approxcolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
Z("\\approxcoloncolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\dblcolon}");
Z("\\notni", "\\html@mathml{\\not\\ni}{\\mathrel{\\char`∌}}");
Z("\\limsup", "\\DOTSB\\operatorname*{lim\\,sup}");
Z("\\liminf", "\\DOTSB\\operatorname*{lim\\,inf}");
Z("\\injlim", "\\DOTSB\\operatorname*{inj\\,lim}");
Z("\\projlim", "\\DOTSB\\operatorname*{proj\\,lim}");
Z("\\varlimsup", "\\DOTSB\\operatorname*{\\overline{lim}}");
Z("\\varliminf", "\\DOTSB\\operatorname*{\\underline{lim}}");
Z("\\varinjlim", "\\DOTSB\\operatorname*{\\underrightarrow{lim}}");
Z("\\varprojlim", "\\DOTSB\\operatorname*{\\underleftarrow{lim}}");
Z("\\gvertneqq", "\\html@mathml{\\@gvertneqq}{≩}");
Z("\\lvertneqq", "\\html@mathml{\\@lvertneqq}{≨}");
Z("\\ngeqq", "\\html@mathml{\\@ngeqq}{≱}");
Z("\\ngeqslant", "\\html@mathml{\\@ngeqslant}{≱}");
Z("\\nleqq", "\\html@mathml{\\@nleqq}{≰}");
Z("\\nleqslant", "\\html@mathml{\\@nleqslant}{≰}");
Z("\\nshortmid", "\\html@mathml{\\@nshortmid}{∤}");
Z("\\nshortparallel", "\\html@mathml{\\@nshortparallel}{∦}");
Z("\\nsubseteqq", "\\html@mathml{\\@nsubseteqq}{⊈}");
Z("\\nsupseteqq", "\\html@mathml{\\@nsupseteqq}{⊉}");
Z("\\varsubsetneq", "\\html@mathml{\\@varsubsetneq}{⊊}");
Z("\\varsubsetneqq", "\\html@mathml{\\@varsubsetneqq}{⫋}");
Z("\\varsupsetneq", "\\html@mathml{\\@varsupsetneq}{⊋}");
Z("\\varsupsetneqq", "\\html@mathml{\\@varsupsetneqq}{⫌}");
Z("\\imath", "\\html@mathml{\\@imath}{ı}");
Z("\\jmath", "\\html@mathml{\\@jmath}{ȷ}");
Z("\\llbracket", "\\html@mathml{\\mathopen{[\\mkern-3.2mu[}}{\\mathopen{\\char`⟦}}");
Z("\\rrbracket", "\\html@mathml{\\mathclose{]\\mkern-3.2mu]}}{\\mathclose{\\char`⟧}}");
Z("⟦", "\\llbracket");
Z("⟧", "\\rrbracket");
Z("\\lBrace", "\\html@mathml{\\mathopen{\\{\\mkern-3.2mu[}}{\\mathopen{\\char`⦃}}");
Z("\\rBrace", "\\html@mathml{\\mathclose{]\\mkern-3.2mu\\}}}{\\mathclose{\\char`⦄}}");
Z("⦃", "\\lBrace");
Z("⦄", "\\rBrace");
Z("\\minuso", "\\mathbin{\\html@mathml{{\\mathrlap{\\mathchoice{\\kern{0.145em}}{\\kern{0.145em}}{\\kern{0.1015em}}{\\kern{0.0725em}}\\circ}{-}}}{\\char`⦵}}");
Z("⦵", "\\minuso");
Z("\\darr", "\\downarrow");
Z("\\dArr", "\\Downarrow");
Z("\\Darr", "\\Downarrow");
Z("\\lang", "\\langle");
Z("\\rang", "\\rangle");
Z("\\uarr", "\\uparrow");
Z("\\uArr", "\\Uparrow");
Z("\\Uarr", "\\Uparrow");
Z("\\N", "\\mathbb{N}");
Z("\\R", "\\mathbb{R}");
Z("\\Z", "\\mathbb{Z}");
Z("\\alef", "\\aleph");
Z("\\alefsym", "\\aleph");
Z("\\Alpha", "\\mathrm{A}");
Z("\\Beta", "\\mathrm{B}");
Z("\\bull", "\\bullet");
Z("\\Chi", "\\mathrm{X}");
Z("\\clubs", "\\clubsuit");
Z("\\cnums", "\\mathbb{C}");
Z("\\Complex", "\\mathbb{C}");
Z("\\Dagger", "\\ddagger");
Z("\\diamonds", "\\diamondsuit");
Z("\\empty", "\\emptyset");
Z("\\Epsilon", "\\mathrm{E}");
Z("\\Eta", "\\mathrm{H}");
Z("\\exist", "\\exists");
Z("\\harr", "\\leftrightarrow");
Z("\\hArr", "\\Leftrightarrow");
Z("\\Harr", "\\Leftrightarrow");
Z("\\hearts", "\\heartsuit");
Z("\\image", "\\Im");
Z("\\infin", "\\infty");
Z("\\Iota", "\\mathrm{I}");
Z("\\isin", "\\in");
Z("\\Kappa", "\\mathrm{K}");
Z("\\larr", "\\leftarrow");
Z("\\lArr", "\\Leftarrow");
Z("\\Larr", "\\Leftarrow");
Z("\\lrarr", "\\leftrightarrow");
Z("\\lrArr", "\\Leftrightarrow");
Z("\\Lrarr", "\\Leftrightarrow");
Z("\\Mu", "\\mathrm{M}");
Z("\\natnums", "\\mathbb{N}");
Z("\\Nu", "\\mathrm{N}");
Z("\\Omicron", "\\mathrm{O}");
Z("\\plusmn", "\\pm");
Z("\\rarr", "\\rightarrow");
Z("\\rArr", "\\Rightarrow");
Z("\\Rarr", "\\Rightarrow");
Z("\\real", "\\Re");
Z("\\reals", "\\mathbb{R}");
Z("\\Reals", "\\mathbb{R}");
Z("\\Rho", "\\mathrm{P}");
Z("\\sdot", "\\cdot");
Z("\\sect", "\\S");
Z("\\spades", "\\spadesuit");
Z("\\sub", "\\subset");
Z("\\sube", "\\subseteq");
Z("\\supe", "\\supseteq");
Z("\\Tau", "\\mathrm{T}");
Z("\\thetasym", "\\vartheta");
Z("\\weierp", "\\wp");
Z("\\Zeta", "\\mathrm{Z}");
Z("\\argmin", "\\DOTSB\\operatorname*{arg\\,min}");
Z("\\argmax", "\\DOTSB\\operatorname*{arg\\,max}");
Z("\\plim", "\\DOTSB\\mathop{\\operatorname{plim}}\\limits");
Z("\\bra", "\\mathinner{\\langle{#1}|}");
Z("\\ket", "\\mathinner{|{#1}\\rangle}");
Z("\\braket", "\\mathinner{\\langle{#1}\\rangle}");
Z("\\Bra", "\\left\\langle#1\\right|");
Z("\\Ket", "\\left|#1\\right\\rangle");
var DF = (e) => (t) => {
  var n = t.consumeArg().tokens, r = t.consumeArg().tokens, i = t.consumeArg().tokens, o = t.consumeArg().tokens, a = t.macros.get("|"), s = t.macros.get("\\|");
  t.macros.beginGroup();
  var l = (p) => (f) => {
    e && (f.macros.set("|", a), i.length && f.macros.set("\\|", s));
    var m = p;
    if (!p && i.length) {
      var y = f.future();
      y.text === "|" && (f.popToken(), m = !0);
    }
    return {
      tokens: m ? i : r,
      numArgs: 0
    };
  };
  t.macros.set("|", l(!1)), i.length && t.macros.set("\\|", l(!0));
  var u = t.consumeArg().tokens, d = t.expandTokens([
    ...o,
    ...u,
    ...n
    // reversed
  ]);
  return t.macros.endGroup(), {
    tokens: d.reverse(),
    numArgs: 0
  };
};
Z("\\bra@ket", DF(!1));
Z("\\bra@set", DF(!0));
Z("\\Braket", "\\bra@ket{\\left\\langle}{\\,\\middle\\vert\\,}{\\,\\middle\\vert\\,}{\\right\\rangle}");
Z("\\Set", "\\bra@set{\\left\\{\\:}{\\;\\middle\\vert\\;}{\\;\\middle\\Vert\\;}{\\:\\right\\}}");
Z("\\set", "\\bra@set{\\{\\,}{\\mid}{}{\\,\\}}");
Z("\\angln", "{\\angl n}");
Z("\\blue", "\\textcolor{##6495ed}{#1}");
Z("\\orange", "\\textcolor{##ffa500}{#1}");
Z("\\pink", "\\textcolor{##ff00af}{#1}");
Z("\\red", "\\textcolor{##df0030}{#1}");
Z("\\green", "\\textcolor{##28ae7b}{#1}");
Z("\\gray", "\\textcolor{gray}{#1}");
Z("\\purple", "\\textcolor{##9d38bd}{#1}");
Z("\\blueA", "\\textcolor{##ccfaff}{#1}");
Z("\\blueB", "\\textcolor{##80f6ff}{#1}");
Z("\\blueC", "\\textcolor{##63d9ea}{#1}");
Z("\\blueD", "\\textcolor{##11accd}{#1}");
Z("\\blueE", "\\textcolor{##0c7f99}{#1}");
Z("\\tealA", "\\textcolor{##94fff5}{#1}");
Z("\\tealB", "\\textcolor{##26edd5}{#1}");
Z("\\tealC", "\\textcolor{##01d1c1}{#1}");
Z("\\tealD", "\\textcolor{##01a995}{#1}");
Z("\\tealE", "\\textcolor{##208170}{#1}");
Z("\\greenA", "\\textcolor{##b6ffb0}{#1}");
Z("\\greenB", "\\textcolor{##8af281}{#1}");
Z("\\greenC", "\\textcolor{##74cf70}{#1}");
Z("\\greenD", "\\textcolor{##1fab54}{#1}");
Z("\\greenE", "\\textcolor{##0d923f}{#1}");
Z("\\goldA", "\\textcolor{##ffd0a9}{#1}");
Z("\\goldB", "\\textcolor{##ffbb71}{#1}");
Z("\\goldC", "\\textcolor{##ff9c39}{#1}");
Z("\\goldD", "\\textcolor{##e07d10}{#1}");
Z("\\goldE", "\\textcolor{##a75a05}{#1}");
Z("\\redA", "\\textcolor{##fca9a9}{#1}");
Z("\\redB", "\\textcolor{##ff8482}{#1}");
Z("\\redC", "\\textcolor{##f9685d}{#1}");
Z("\\redD", "\\textcolor{##e84d39}{#1}");
Z("\\redE", "\\textcolor{##bc2612}{#1}");
Z("\\maroonA", "\\textcolor{##ffbde0}{#1}");
Z("\\maroonB", "\\textcolor{##ff92c6}{#1}");
Z("\\maroonC", "\\textcolor{##ed5fa6}{#1}");
Z("\\maroonD", "\\textcolor{##ca337c}{#1}");
Z("\\maroonE", "\\textcolor{##9e034e}{#1}");
Z("\\purpleA", "\\textcolor{##ddd7ff}{#1}");
Z("\\purpleB", "\\textcolor{##c6b9fc}{#1}");
Z("\\purpleC", "\\textcolor{##aa87ff}{#1}");
Z("\\purpleD", "\\textcolor{##7854ab}{#1}");
Z("\\purpleE", "\\textcolor{##543b78}{#1}");
Z("\\mintA", "\\textcolor{##f5f9e8}{#1}");
Z("\\mintB", "\\textcolor{##edf2df}{#1}");
Z("\\mintC", "\\textcolor{##e0e5cc}{#1}");
Z("\\grayA", "\\textcolor{##f6f7f7}{#1}");
Z("\\grayB", "\\textcolor{##f0f1f2}{#1}");
Z("\\grayC", "\\textcolor{##e3e5e6}{#1}");
Z("\\grayD", "\\textcolor{##d6d8da}{#1}");
Z("\\grayE", "\\textcolor{##babec2}{#1}");
Z("\\grayF", "\\textcolor{##888d93}{#1}");
Z("\\grayG", "\\textcolor{##626569}{#1}");
Z("\\grayH", "\\textcolor{##3b3e40}{#1}");
Z("\\grayI", "\\textcolor{##21242c}{#1}");
Z("\\kaBlue", "\\textcolor{##314453}{#1}");
Z("\\kaGreen", "\\textcolor{##71B307}{#1}");
var AF = {
  "^": !0,
  // Parser.js
  _: !0,
  // Parser.js
  "\\limits": !0,
  // Parser.js
  "\\nolimits": !0
  // Parser.js
};
class Hle {
  constructor(t, n, r) {
    this.settings = void 0, this.expansionCount = void 0, this.lexer = void 0, this.macros = void 0, this.stack = void 0, this.mode = void 0, this.settings = n, this.expansionCount = 0, this.feed(t), this.macros = new qle($le, n.macros), this.mode = r, this.stack = [];
  }
  /**
   * Feed a new input string to the same MacroExpander
   * (with existing macros etc.).
   */
  feed(t) {
    this.lexer = new I9(t, this.settings);
  }
  /**
   * Switches between "text" and "math" modes.
   */
  switchMode(t) {
    this.mode = t;
  }
  /**
   * Start a new group nesting within all namespaces.
   */
  beginGroup() {
    this.macros.beginGroup();
  }
  /**
   * End current group nesting within all namespaces.
   */
  endGroup() {
    this.macros.endGroup();
  }
  /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */
  endGroups() {
    this.macros.endGroups();
  }
  /**
   * Returns the topmost token on the stack, without expanding it.
   * Similar in behavior to TeX's `\futurelet`.
   */
  future() {
    return this.stack.length === 0 && this.pushToken(this.lexer.lex()), this.stack[this.stack.length - 1];
  }
  /**
   * Remove and return the next unexpanded token.
   */
  popToken() {
    return this.future(), this.stack.pop();
  }
  /**
   * Add a given token to the token stack.  In particular, this get be used
   * to put back a token returned from one of the other methods.
   */
  pushToken(t) {
    this.stack.push(t);
  }
  /**
   * Append an array of tokens to the token stack.
   */
  pushTokens(t) {
    this.stack.push(...t);
  }
  /**
   * Find an macro argument without expanding tokens and append the array of
   * tokens to the token stack. Uses Token as a container for the result.
   */
  scanArgument(t) {
    var n, r, i;
    if (t) {
      if (this.consumeSpaces(), this.future().text !== "[")
        return null;
      n = this.popToken(), {
        tokens: i,
        end: r
      } = this.consumeArg(["]"]);
    } else
      ({
        tokens: i,
        start: n,
        end: r
      } = this.consumeArg());
    return this.pushToken(new ca("EOF", r.loc)), this.pushTokens(i), n.range(r, "");
  }
  /**
   * Consume all following space tokens, without expansion.
   */
  consumeSpaces() {
    for (; ; ) {
      var t = this.future();
      if (t.text === " ")
        this.stack.pop();
      else
        break;
    }
  }
  /**
   * Consume an argument from the token stream, and return the resulting array
   * of tokens and start/end token.
   */
  consumeArg(t) {
    var n = [], r = t && t.length > 0;
    r || this.consumeSpaces();
    var i = this.future(), o, a = 0, s = 0;
    do {
      if (o = this.popToken(), n.push(o), o.text === "{")
        ++a;
      else if (o.text === "}") {
        if (--a, a === -1)
          throw new Ye("Extra }", o);
      } else if (o.text === "EOF")
        throw new Ye("Unexpected end of input in a macro argument, expected '" + (t && r ? t[s] : "}") + "'", o);
      if (t && r)
        if ((a === 0 || a === 1 && t[s] === "{") && o.text === t[s]) {
          if (++s, s === t.length) {
            n.splice(-s, s);
            break;
          }
        } else
          s = 0;
    } while (a !== 0 || r);
    return i.text === "{" && n[n.length - 1].text === "}" && (n.pop(), n.shift()), n.reverse(), {
      tokens: n,
      start: i,
      end: o
    };
  }
  /**
   * Consume the specified number of (delimited) arguments from the token
   * stream and return the resulting array of arguments.
   */
  consumeArgs(t, n) {
    if (n) {
      if (n.length !== t + 1)
        throw new Ye("The length of delimiters doesn't match the number of args!");
      for (var r = n[0], i = 0; i < r.length; i++) {
        var o = this.popToken();
        if (r[i] !== o.text)
          throw new Ye("Use of the macro doesn't match its definition", o);
      }
    }
    for (var a = [], s = 0; s < t; s++)
      a.push(this.consumeArg(n && n[s + 1]).tokens);
    return a;
  }
  /**
   * Increment `expansionCount` by the specified amount.
   * Throw an error if it exceeds `maxExpand`.
   */
  countExpansion(t) {
    if (this.expansionCount += t, this.expansionCount > this.settings.maxExpand)
      throw new Ye("Too many expansions: infinite loop or need to increase maxExpand setting");
  }
  /**
   * Expand the next token only once if possible.
   *
   * If the token is expanded, the resulting tokens will be pushed onto
   * the stack in reverse order, and the number of such tokens will be
   * returned.  This number might be zero or positive.
   *
   * If not, the return value is `false`, and the next token remains at the
   * top of the stack.
   *
   * In either case, the next token will be on the top of the stack,
   * or the stack will be empty (in case of empty expansion
   * and no other tokens).
   *
   * Used to implement `expandAfterFuture` and `expandNextToken`.
   *
   * If expandableOnly, only expandable tokens are expanded and
   * an undefined control sequence results in an error.
   */
  expandOnce(t) {
    var n = this.popToken(), r = n.text, i = n.noexpand ? null : this._getExpansion(r);
    if (i == null || t && i.unexpandable) {
      if (t && i == null && r[0] === "\\" && !this.isDefined(r))
        throw new Ye("Undefined control sequence: " + r);
      return this.pushToken(n), !1;
    }
    this.countExpansion(1);
    var o = i.tokens, a = this.consumeArgs(i.numArgs, i.delimiters);
    if (i.numArgs) {
      o = o.slice();
      for (var s = o.length - 1; s >= 0; --s) {
        var l = o[s];
        if (l.text === "#") {
          if (s === 0)
            throw new Ye("Incomplete placeholder at end of macro body", l);
          if (l = o[--s], l.text === "#")
            o.splice(s + 1, 1);
          else if (/^[1-9]$/.test(l.text))
            o.splice(s, 2, ...a[+l.text - 1]);
          else
            throw new Ye("Not a valid argument number", l);
        }
      }
    }
    return this.pushTokens(o), o.length;
  }
  /**
   * Expand the next token only once (if possible), and return the resulting
   * top token on the stack (without removing anything from the stack).
   * Similar in behavior to TeX's `\expandafter\futurelet`.
   * Equivalent to expandOnce() followed by future().
   */
  expandAfterFuture() {
    return this.expandOnce(), this.future();
  }
  /**
   * Recursively expand first token, then return first non-expandable token.
   */
  expandNextToken() {
    for (; ; )
      if (this.expandOnce() === !1) {
        var t = this.stack.pop();
        return t.treatAsRelax && (t.text = "\\relax"), t;
      }
    throw new Error();
  }
  /**
   * Fully expand the given macro name and return the resulting list of
   * tokens, or return `undefined` if no such macro is defined.
   */
  expandMacro(t) {
    return this.macros.has(t) ? this.expandTokens([new ca(t)]) : void 0;
  }
  /**
   * Fully expand the given token stream and return the resulting list of
   * tokens.  Note that the input tokens are in reverse order, but the
   * output tokens are in forward order.
   */
  expandTokens(t) {
    var n = [], r = this.stack.length;
    for (this.pushTokens(t); this.stack.length > r; )
      if (this.expandOnce(!0) === !1) {
        var i = this.stack.pop();
        i.treatAsRelax && (i.noexpand = !1, i.treatAsRelax = !1), n.push(i);
      }
    return this.countExpansion(n.length), n;
  }
  /**
   * Fully expand the given macro name and return the result as a string,
   * or return `undefined` if no such macro is defined.
   */
  expandMacroAsText(t) {
    var n = this.expandMacro(t);
    return n && n.map((r) => r.text).join("");
  }
  /**
   * Returns the expanded macro as a reversed array of tokens and a macro
   * argument count.  Or returns `null` if no such macro.
   */
  _getExpansion(t) {
    var n = this.macros.get(t);
    if (n == null)
      return n;
    if (t.length === 1) {
      var r = this.lexer.catcodes[t];
      if (r != null && r !== 13)
        return;
    }
    var i = typeof n == "function" ? n(this) : n;
    if (typeof i == "string") {
      var o = 0;
      if (i.indexOf("#") !== -1)
        for (var a = i.replace(/##/g, ""); a.indexOf("#" + (o + 1)) !== -1; )
          ++o;
      for (var s = new I9(i, this.settings), l = [], u = s.lex(); u.text !== "EOF"; )
        l.push(u), u = s.lex();
      l.reverse();
      var d = {
        tokens: l,
        numArgs: o
      };
      return d;
    }
    return i;
  }
  /**
   * Determine whether a command is currently "defined" (has some
   * functionality), meaning that it's a macro (in the current group),
   * a function, a symbol, or one of the special commands listed in
   * `implicitCommands`.
   */
  isDefined(t) {
    return this.macros.has(t) || Gl.hasOwnProperty(t) || Bn.math.hasOwnProperty(t) || Bn.text.hasOwnProperty(t) || AF.hasOwnProperty(t);
  }
  /**
   * Determine whether a command is expandable.
   */
  isExpandable(t) {
    var n = this.macros.get(t);
    return n != null ? typeof n == "string" || typeof n == "function" || !n.unexpandable : Gl.hasOwnProperty(t) && !Gl[t].primitive;
  }
}
var _9 = /^[₊₋₌₍₎₀₁₂₃₄₅₆₇₈₉ₐₑₕᵢⱼₖₗₘₙₒₚᵣₛₜᵤᵥₓᵦᵧᵨᵩᵪ]/, t1 = Object.freeze({
  "₊": "+",
  "₋": "-",
  "₌": "=",
  "₍": "(",
  "₎": ")",
  "₀": "0",
  "₁": "1",
  "₂": "2",
  "₃": "3",
  "₄": "4",
  "₅": "5",
  "₆": "6",
  "₇": "7",
  "₈": "8",
  "₉": "9",
  "ₐ": "a",
  "ₑ": "e",
  "ₕ": "h",
  "ᵢ": "i",
  "ⱼ": "j",
  "ₖ": "k",
  "ₗ": "l",
  "ₘ": "m",
  "ₙ": "n",
  "ₒ": "o",
  "ₚ": "p",
  "ᵣ": "r",
  "ₛ": "s",
  "ₜ": "t",
  "ᵤ": "u",
  "ᵥ": "v",
  "ₓ": "x",
  "ᵦ": "β",
  "ᵧ": "γ",
  "ᵨ": "ρ",
  "ᵩ": "ϕ",
  "ᵪ": "χ",
  "⁺": "+",
  "⁻": "-",
  "⁼": "=",
  "⁽": "(",
  "⁾": ")",
  "⁰": "0",
  "¹": "1",
  "²": "2",
  "³": "3",
  "⁴": "4",
  "⁵": "5",
  "⁶": "6",
  "⁷": "7",
  "⁸": "8",
  "⁹": "9",
  "ᴬ": "A",
  "ᴮ": "B",
  "ᴰ": "D",
  "ᴱ": "E",
  "ᴳ": "G",
  "ᴴ": "H",
  "ᴵ": "I",
  "ᴶ": "J",
  "ᴷ": "K",
  "ᴸ": "L",
  "ᴹ": "M",
  "ᴺ": "N",
  "ᴼ": "O",
  "ᴾ": "P",
  "ᴿ": "R",
  "ᵀ": "T",
  "ᵁ": "U",
  "ⱽ": "V",
  "ᵂ": "W",
  "ᵃ": "a",
  "ᵇ": "b",
  "ᶜ": "c",
  "ᵈ": "d",
  "ᵉ": "e",
  "ᶠ": "f",
  "ᵍ": "g",
  ʰ: "h",
  "ⁱ": "i",
  ʲ: "j",
  "ᵏ": "k",
  ˡ: "l",
  "ᵐ": "m",
  ⁿ: "n",
  "ᵒ": "o",
  "ᵖ": "p",
  ʳ: "r",
  ˢ: "s",
  "ᵗ": "t",
  "ᵘ": "u",
  "ᵛ": "v",
  ʷ: "w",
  ˣ: "x",
  ʸ: "y",
  "ᶻ": "z",
  "ᵝ": "β",
  "ᵞ": "γ",
  "ᵟ": "δ",
  "ᵠ": "ϕ",
  "ᵡ": "χ",
  "ᶿ": "θ"
}), d3 = {
  "́": {
    text: "\\'",
    math: "\\acute"
  },
  "̀": {
    text: "\\`",
    math: "\\grave"
  },
  "̈": {
    text: '\\"',
    math: "\\ddot"
  },
  "̃": {
    text: "\\~",
    math: "\\tilde"
  },
  "̄": {
    text: "\\=",
    math: "\\bar"
  },
  "̆": {
    text: "\\u",
    math: "\\breve"
  },
  "̌": {
    text: "\\v",
    math: "\\check"
  },
  "̂": {
    text: "\\^",
    math: "\\hat"
  },
  "̇": {
    text: "\\.",
    math: "\\dot"
  },
  "̊": {
    text: "\\r",
    math: "\\mathring"
  },
  "̋": {
    text: "\\H"
  },
  "̧": {
    text: "\\c"
  }
}, q9 = {
  á: "á",
  à: "à",
  ä: "ä",
  ǟ: "ǟ",
  ã: "ã",
  ā: "ā",
  ă: "ă",
  ắ: "ắ",
  ằ: "ằ",
  ẵ: "ẵ",
  ǎ: "ǎ",
  â: "â",
  ấ: "ấ",
  ầ: "ầ",
  ẫ: "ẫ",
  ȧ: "ȧ",
  ǡ: "ǡ",
  å: "å",
  ǻ: "ǻ",
  ḃ: "ḃ",
  ć: "ć",
  ḉ: "ḉ",
  č: "č",
  ĉ: "ĉ",
  ċ: "ċ",
  ç: "ç",
  ď: "ď",
  ḋ: "ḋ",
  ḑ: "ḑ",
  é: "é",
  è: "è",
  ë: "ë",
  ẽ: "ẽ",
  ē: "ē",
  ḗ: "ḗ",
  ḕ: "ḕ",
  ĕ: "ĕ",
  ḝ: "ḝ",
  ě: "ě",
  ê: "ê",
  ế: "ế",
  ề: "ề",
  ễ: "ễ",
  ė: "ė",
  ȩ: "ȩ",
  ḟ: "ḟ",
  ǵ: "ǵ",
  ḡ: "ḡ",
  ğ: "ğ",
  ǧ: "ǧ",
  ĝ: "ĝ",
  ġ: "ġ",
  ģ: "ģ",
  ḧ: "ḧ",
  ȟ: "ȟ",
  ĥ: "ĥ",
  ḣ: "ḣ",
  ḩ: "ḩ",
  í: "í",
  ì: "ì",
  ï: "ï",
  ḯ: "ḯ",
  ĩ: "ĩ",
  ī: "ī",
  ĭ: "ĭ",
  ǐ: "ǐ",
  î: "î",
  ǰ: "ǰ",
  ĵ: "ĵ",
  ḱ: "ḱ",
  ǩ: "ǩ",
  ķ: "ķ",
  ĺ: "ĺ",
  ľ: "ľ",
  ļ: "ļ",
  ḿ: "ḿ",
  ṁ: "ṁ",
  ń: "ń",
  ǹ: "ǹ",
  ñ: "ñ",
  ň: "ň",
  ṅ: "ṅ",
  ņ: "ņ",
  ó: "ó",
  ò: "ò",
  ö: "ö",
  ȫ: "ȫ",
  õ: "õ",
  ṍ: "ṍ",
  ṏ: "ṏ",
  ȭ: "ȭ",
  ō: "ō",
  ṓ: "ṓ",
  ṑ: "ṑ",
  ŏ: "ŏ",
  ǒ: "ǒ",
  ô: "ô",
  ố: "ố",
  ồ: "ồ",
  ỗ: "ỗ",
  ȯ: "ȯ",
  ȱ: "ȱ",
  ő: "ő",
  ṕ: "ṕ",
  ṗ: "ṗ",
  ŕ: "ŕ",
  ř: "ř",
  ṙ: "ṙ",
  ŗ: "ŗ",
  ś: "ś",
  ṥ: "ṥ",
  š: "š",
  ṧ: "ṧ",
  ŝ: "ŝ",
  ṡ: "ṡ",
  ş: "ş",
  ẗ: "ẗ",
  ť: "ť",
  ṫ: "ṫ",
  ţ: "ţ",
  ú: "ú",
  ù: "ù",
  ü: "ü",
  ǘ: "ǘ",
  ǜ: "ǜ",
  ǖ: "ǖ",
  ǚ: "ǚ",
  ũ: "ũ",
  ṹ: "ṹ",
  ū: "ū",
  ṻ: "ṻ",
  ŭ: "ŭ",
  ǔ: "ǔ",
  û: "û",
  ů: "ů",
  ű: "ű",
  ṽ: "ṽ",
  ẃ: "ẃ",
  ẁ: "ẁ",
  ẅ: "ẅ",
  ŵ: "ŵ",
  ẇ: "ẇ",
  ẘ: "ẘ",
  ẍ: "ẍ",
  ẋ: "ẋ",
  ý: "ý",
  ỳ: "ỳ",
  ÿ: "ÿ",
  ỹ: "ỹ",
  ȳ: "ȳ",
  ŷ: "ŷ",
  ẏ: "ẏ",
  ẙ: "ẙ",
  ź: "ź",
  ž: "ž",
  ẑ: "ẑ",
  ż: "ż",
  Á: "Á",
  À: "À",
  Ä: "Ä",
  Ǟ: "Ǟ",
  Ã: "Ã",
  Ā: "Ā",
  Ă: "Ă",
  Ắ: "Ắ",
  Ằ: "Ằ",
  Ẵ: "Ẵ",
  Ǎ: "Ǎ",
  Â: "Â",
  Ấ: "Ấ",
  Ầ: "Ầ",
  Ẫ: "Ẫ",
  Ȧ: "Ȧ",
  Ǡ: "Ǡ",
  Å: "Å",
  Ǻ: "Ǻ",
  Ḃ: "Ḃ",
  Ć: "Ć",
  Ḉ: "Ḉ",
  Č: "Č",
  Ĉ: "Ĉ",
  Ċ: "Ċ",
  Ç: "Ç",
  Ď: "Ď",
  Ḋ: "Ḋ",
  Ḑ: "Ḑ",
  É: "É",
  È: "È",
  Ë: "Ë",
  Ẽ: "Ẽ",
  Ē: "Ē",
  Ḗ: "Ḗ",
  Ḕ: "Ḕ",
  Ĕ: "Ĕ",
  Ḝ: "Ḝ",
  Ě: "Ě",
  Ê: "Ê",
  Ế: "Ế",
  Ề: "Ề",
  Ễ: "Ễ",
  Ė: "Ė",
  Ȩ: "Ȩ",
  Ḟ: "Ḟ",
  Ǵ: "Ǵ",
  Ḡ: "Ḡ",
  Ğ: "Ğ",
  Ǧ: "Ǧ",
  Ĝ: "Ĝ",
  Ġ: "Ġ",
  Ģ: "Ģ",
  Ḧ: "Ḧ",
  Ȟ: "Ȟ",
  Ĥ: "Ĥ",
  Ḣ: "Ḣ",
  Ḩ: "Ḩ",
  Í: "Í",
  Ì: "Ì",
  Ï: "Ï",
  Ḯ: "Ḯ",
  Ĩ: "Ĩ",
  Ī: "Ī",
  Ĭ: "Ĭ",
  Ǐ: "Ǐ",
  Î: "Î",
  İ: "İ",
  Ĵ: "Ĵ",
  Ḱ: "Ḱ",
  Ǩ: "Ǩ",
  Ķ: "Ķ",
  Ĺ: "Ĺ",
  Ľ: "Ľ",
  Ļ: "Ļ",
  Ḿ: "Ḿ",
  Ṁ: "Ṁ",
  Ń: "Ń",
  Ǹ: "Ǹ",
  Ñ: "Ñ",
  Ň: "Ň",
  Ṅ: "Ṅ",
  Ņ: "Ņ",
  Ó: "Ó",
  Ò: "Ò",
  Ö: "Ö",
  Ȫ: "Ȫ",
  Õ: "Õ",
  Ṍ: "Ṍ",
  Ṏ: "Ṏ",
  Ȭ: "Ȭ",
  Ō: "Ō",
  Ṓ: "Ṓ",
  Ṑ: "Ṑ",
  Ŏ: "Ŏ",
  Ǒ: "Ǒ",
  Ô: "Ô",
  Ố: "Ố",
  Ồ: "Ồ",
  Ỗ: "Ỗ",
  Ȯ: "Ȯ",
  Ȱ: "Ȱ",
  Ő: "Ő",
  Ṕ: "Ṕ",
  Ṗ: "Ṗ",
  Ŕ: "Ŕ",
  Ř: "Ř",
  Ṙ: "Ṙ",
  Ŗ: "Ŗ",
  Ś: "Ś",
  Ṥ: "Ṥ",
  Š: "Š",
  Ṧ: "Ṧ",
  Ŝ: "Ŝ",
  Ṡ: "Ṡ",
  Ş: "Ş",
  Ť: "Ť",
  Ṫ: "Ṫ",
  Ţ: "Ţ",
  Ú: "Ú",
  Ù: "Ù",
  Ü: "Ü",
  Ǘ: "Ǘ",
  Ǜ: "Ǜ",
  Ǖ: "Ǖ",
  Ǚ: "Ǚ",
  Ũ: "Ũ",
  Ṹ: "Ṹ",
  Ū: "Ū",
  Ṻ: "Ṻ",
  Ŭ: "Ŭ",
  Ǔ: "Ǔ",
  Û: "Û",
  Ů: "Ů",
  Ű: "Ű",
  Ṽ: "Ṽ",
  Ẃ: "Ẃ",
  Ẁ: "Ẁ",
  Ẅ: "Ẅ",
  Ŵ: "Ŵ",
  Ẇ: "Ẇ",
  Ẍ: "Ẍ",
  Ẋ: "Ẋ",
  Ý: "Ý",
  Ỳ: "Ỳ",
  Ÿ: "Ÿ",
  Ỹ: "Ỹ",
  Ȳ: "Ȳ",
  Ŷ: "Ŷ",
  Ẏ: "Ẏ",
  Ź: "Ź",
  Ž: "Ž",
  Ẑ: "Ẑ",
  Ż: "Ż",
  ά: "ά",
  ὰ: "ὰ",
  ᾱ: "ᾱ",
  ᾰ: "ᾰ",
  έ: "έ",
  ὲ: "ὲ",
  ή: "ή",
  ὴ: "ὴ",
  ί: "ί",
  ὶ: "ὶ",
  ϊ: "ϊ",
  ΐ: "ΐ",
  ῒ: "ῒ",
  ῑ: "ῑ",
  ῐ: "ῐ",
  ό: "ό",
  ὸ: "ὸ",
  ύ: "ύ",
  ὺ: "ὺ",
  ϋ: "ϋ",
  ΰ: "ΰ",
  ῢ: "ῢ",
  ῡ: "ῡ",
  ῠ: "ῠ",
  ώ: "ώ",
  ὼ: "ὼ",
  Ύ: "Ύ",
  Ὺ: "Ὺ",
  Ϋ: "Ϋ",
  Ῡ: "Ῡ",
  Ῠ: "Ῠ",
  Ώ: "Ώ",
  Ὼ: "Ὼ"
};
class k2 {
  constructor(t, n) {
    this.mode = void 0, this.gullet = void 0, this.settings = void 0, this.leftrightDepth = void 0, this.nextToken = void 0, this.mode = "math", this.gullet = new Hle(t, n, this.mode), this.settings = n, this.leftrightDepth = 0;
  }
  /**
   * Checks a result to make sure it has the right type, and throws an
   * appropriate error otherwise.
   */
  expect(t, n) {
    if (n === void 0 && (n = !0), this.fetch().text !== t)
      throw new Ye("Expected '" + t + "', got '" + this.fetch().text + "'", this.fetch());
    n && this.consume();
  }
  /**
   * Discards the current lookahead token, considering it consumed.
   */
  consume() {
    this.nextToken = null;
  }
  /**
   * Return the current lookahead token, or if there isn't one (at the
   * beginning, or if the previous lookahead token was consume()d),
   * fetch the next token as the new lookahead token and return it.
   */
  fetch() {
    return this.nextToken == null && (this.nextToken = this.gullet.expandNextToken()), this.nextToken;
  }
  /**
   * Switches between "text" and "math" modes.
   */
  switchMode(t) {
    this.mode = t, this.gullet.switchMode(t);
  }
  /**
   * Main parsing function, which parses an entire input.
   */
  parse() {
    this.settings.globalGroup || this.gullet.beginGroup(), this.settings.colorIsTextColor && this.gullet.macros.set("\\color", "\\textcolor");
    try {
      var t = this.parseExpression(!1);
      return this.expect("EOF"), this.settings.globalGroup || this.gullet.endGroup(), t;
    } finally {
      this.gullet.endGroups();
    }
  }
  /**
   * Fully parse a separate sequence of tokens as a separate job.
   * Tokens should be specified in reverse order, as in a MacroDefinition.
   */
  subparse(t) {
    var n = this.nextToken;
    this.consume(), this.gullet.pushToken(new ca("}")), this.gullet.pushTokens(t);
    var r = this.parseExpression(!1);
    return this.expect("}"), this.nextToken = n, r;
  }
  /**
   * Parses an "expression", which is a list of atoms.
   *
   * `breakOnInfix`: Should the parsing stop when we hit infix nodes? This
   *                 happens when functions have higher precedence han infix
   *                 nodes in implicit parses.
   *
   * `breakOnTokenText`: The text of the token that the expression should end
   *                     with, or `null` if something else should end the
   *                     expression.
   */
  parseExpression(t, n) {
    for (var r = []; ; ) {
      this.mode === "math" && this.consumeSpaces();
      var i = this.fetch();
      if (k2.endOfExpression.indexOf(i.text) !== -1 || n && i.text === n || t && Gl[i.text] && Gl[i.text].infix)
        break;
      var o = this.parseAtom(n);
      if (o) {
        if (o.type === "internal")
          continue;
      } else break;
      r.push(o);
    }
    return this.mode === "text" && this.formLigatures(r), this.handleInfixNodes(r);
  }
  /**
   * Rewrites infix operators such as \over with corresponding commands such
   * as \frac.
   *
   * There can only be one infix operator per group.  If there's more than one
   * then the expression is ambiguous.  This can be resolved by adding {}.
   */
  handleInfixNodes(t) {
    for (var n = -1, r, i = 0; i < t.length; i++)
      if (t[i].type === "infix") {
        if (n !== -1)
          throw new Ye("only one infix operator per group", t[i].token);
        n = i, r = t[i].replaceWith;
      }
    if (n !== -1 && r) {
      var o, a, s = t.slice(0, n), l = t.slice(n + 1);
      s.length === 1 && s[0].type === "ordgroup" ? o = s[0] : o = {
        type: "ordgroup",
        mode: this.mode,
        body: s
      }, l.length === 1 && l[0].type === "ordgroup" ? a = l[0] : a = {
        type: "ordgroup",
        mode: this.mode,
        body: l
      };
      var u;
      return r === "\\\\abovefrac" ? u = this.callFunction(r, [o, t[n], a], []) : u = this.callFunction(r, [o, a], []), [u];
    } else
      return t;
  }
  /**
   * Handle a subscript or superscript with nice errors.
   */
  handleSupSubscript(t) {
    var n = this.fetch(), r = n.text;
    this.consume(), this.consumeSpaces();
    var i = this.parseGroup(t);
    if (!i)
      throw new Ye("Expected group after '" + r + "'", n);
    return i;
  }
  /**
   * Converts the textual input of an unsupported command into a text node
   * contained within a color node whose color is determined by errorColor
   */
  formatUnsupportedCmd(t) {
    for (var n = [], r = 0; r < t.length; r++)
      n.push({
        type: "textord",
        mode: "text",
        text: t[r]
      });
    var i = {
      type: "text",
      mode: this.mode,
      body: n
    }, o = {
      type: "color",
      mode: this.mode,
      color: this.settings.errorColor,
      body: [i]
    };
    return o;
  }
  /**
   * Parses a group with optional super/subscripts.
   */
  parseAtom(t) {
    var n = this.parseGroup("atom", t);
    if (this.mode === "text")
      return n;
    for (var r, i; ; ) {
      this.consumeSpaces();
      var o = this.fetch();
      if (o.text === "\\limits" || o.text === "\\nolimits") {
        if (n && n.type === "op") {
          var a = o.text === "\\limits";
          n.limits = a, n.alwaysHandleSupSub = !0;
        } else if (n && n.type === "operatorname")
          n.alwaysHandleSupSub && (n.limits = o.text === "\\limits");
        else
          throw new Ye("Limit controls must follow a math operator", o);
        this.consume();
      } else if (o.text === "^") {
        if (r)
          throw new Ye("Double superscript", o);
        r = this.handleSupSubscript("superscript");
      } else if (o.text === "_") {
        if (i)
          throw new Ye("Double subscript", o);
        i = this.handleSupSubscript("subscript");
      } else if (o.text === "'") {
        if (r)
          throw new Ye("Double superscript", o);
        var s = {
          type: "textord",
          mode: this.mode,
          text: "\\prime"
        }, l = [s];
        for (this.consume(); this.fetch().text === "'"; )
          l.push(s), this.consume();
        this.fetch().text === "^" && l.push(this.handleSupSubscript("superscript")), r = {
          type: "ordgroup",
          mode: this.mode,
          body: l
        };
      } else if (t1[o.text]) {
        var u = _9.test(o.text), d = [];
        for (d.push(new ca(t1[o.text])), this.consume(); ; ) {
          var p = this.fetch().text;
          if (!t1[p] || _9.test(p) !== u)
            break;
          d.unshift(new ca(t1[p])), this.consume();
        }
        var f = this.subparse(d);
        u ? i = {
          type: "ordgroup",
          mode: "math",
          body: f
        } : r = {
          type: "ordgroup",
          mode: "math",
          body: f
        };
      } else
        break;
    }
    return r || i ? {
      type: "supsub",
      mode: this.mode,
      base: n,
      sup: r,
      sub: i
    } : n;
  }
  /**
   * Parses an entire function, including its base and all of its arguments.
   */
  parseFunction(t, n) {
    var r = this.fetch(), i = r.text, o = Gl[i];
    if (!o)
      return null;
    if (this.consume(), n && n !== "atom" && !o.allowedInArgument)
      throw new Ye("Got function '" + i + "' with no arguments" + (n ? " as " + n : ""), r);
    if (this.mode === "text" && !o.allowedInText)
      throw new Ye("Can't use function '" + i + "' in text mode", r);
    if (this.mode === "math" && o.allowedInMath === !1)
      throw new Ye("Can't use function '" + i + "' in math mode", r);
    var {
      args: a,
      optArgs: s
    } = this.parseArguments(i, o);
    return this.callFunction(i, a, s, r, t);
  }
  /**
   * Call a function handler with a suitable context and arguments.
   */
  callFunction(t, n, r, i, o) {
    var a = {
      funcName: t,
      parser: this,
      token: i,
      breakOnTokenText: o
    }, s = Gl[t];
    if (s && s.handler)
      return s.handler(a, n, r);
    throw new Ye("No function handler for " + t);
  }
  /**
   * Parses the arguments of a function or environment
   */
  parseArguments(t, n) {
    var r = n.numArgs + n.numOptionalArgs;
    if (r === 0)
      return {
        args: [],
        optArgs: []
      };
    for (var i = [], o = [], a = 0; a < r; a++) {
      var s = n.argTypes && n.argTypes[a], l = a < n.numOptionalArgs;
      (n.primitive && s == null || // \sqrt expands into primitive if optional argument doesn't exist
      n.type === "sqrt" && a === 1 && o[0] == null) && (s = "primitive");
      var u = this.parseGroupOfType("argument to '" + t + "'", s, l);
      if (l)
        o.push(u);
      else if (u != null)
        i.push(u);
      else
        throw new Ye("Null argument, please report this as a bug");
    }
    return {
      args: i,
      optArgs: o
    };
  }
  /**
   * Parses a group when the mode is changing.
   */
  parseGroupOfType(t, n, r) {
    switch (n) {
      case "color":
        return this.parseColorGroup(r);
      case "size":
        return this.parseSizeGroup(r);
      case "url":
        return this.parseUrlGroup(r);
      case "math":
      case "text":
        return this.parseArgumentGroup(r, n);
      case "hbox": {
        var i = this.parseArgumentGroup(r, "text");
        return i != null ? {
          type: "styling",
          mode: i.mode,
          body: [i],
          style: "text"
          // simulate \textstyle
        } : null;
      }
      case "raw": {
        var o = this.parseStringGroup("raw", r);
        return o != null ? {
          type: "raw",
          mode: "text",
          string: o.text
        } : null;
      }
      case "primitive": {
        if (r)
          throw new Ye("A primitive argument cannot be optional");
        var a = this.parseGroup(t);
        if (a == null)
          throw new Ye("Expected group as " + t, this.fetch());
        return a;
      }
      case "original":
      case null:
      case void 0:
        return this.parseArgumentGroup(r);
      default:
        throw new Ye("Unknown group type as " + t, this.fetch());
    }
  }
  /**
   * Discard any space tokens, fetching the next non-space token.
   */
  consumeSpaces() {
    for (; this.fetch().text === " "; )
      this.consume();
  }
  /**
   * Parses a group, essentially returning the string formed by the
   * brace-enclosed tokens plus some position information.
   */
  parseStringGroup(t, n) {
    var r = this.gullet.scanArgument(n);
    if (r == null)
      return null;
    for (var i = "", o; (o = this.fetch()).text !== "EOF"; )
      i += o.text, this.consume();
    return this.consume(), r.text = i, r;
  }
  /**
   * Parses a regex-delimited group: the largest sequence of tokens
   * whose concatenated strings match `regex`. Returns the string
   * formed by the tokens plus some position information.
   */
  parseRegexGroup(t, n) {
    for (var r = this.fetch(), i = r, o = "", a; (a = this.fetch()).text !== "EOF" && t.test(o + a.text); )
      i = a, o += i.text, this.consume();
    if (o === "")
      throw new Ye("Invalid " + n + ": '" + r.text + "'", r);
    return r.range(i, o);
  }
  /**
   * Parses a color description.
   */
  parseColorGroup(t) {
    var n = this.parseStringGroup("color", t);
    if (n == null)
      return null;
    var r = /^(#[a-f0-9]{3}|#?[a-f0-9]{6}|[a-z]+)$/i.exec(n.text);
    if (!r)
      throw new Ye("Invalid color: '" + n.text + "'", n);
    var i = r[0];
    return /^[0-9a-f]{6}$/i.test(i) && (i = "#" + i), {
      type: "color-token",
      mode: this.mode,
      color: i
    };
  }
  /**
   * Parses a size specification, consisting of magnitude and unit.
   */
  parseSizeGroup(t) {
    var n, r = !1;
    if (this.gullet.consumeSpaces(), !t && this.gullet.future().text !== "{" ? n = this.parseRegexGroup(/^[-+]? *(?:$|\d+|\d+\.\d*|\.\d*) *[a-z]{0,2} *$/, "size") : n = this.parseStringGroup("size", t), !n)
      return null;
    !t && n.text.length === 0 && (n.text = "0pt", r = !0);
    var i = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(n.text);
    if (!i)
      throw new Ye("Invalid size: '" + n.text + "'", n);
    var o = {
      number: +(i[1] + i[2]),
      // sign + magnitude, cast to number
      unit: i[3]
    };
    if (!Iz(o))
      throw new Ye("Invalid unit: '" + o.unit + "'", n);
    return {
      type: "size",
      mode: this.mode,
      value: o,
      isBlank: r
    };
  }
  /**
   * Parses an URL, checking escaped letters and allowed protocols,
   * and setting the catcode of % as an active character (as in \hyperref).
   */
  parseUrlGroup(t) {
    this.gullet.lexer.setCatcode("%", 13), this.gullet.lexer.setCatcode("~", 12);
    var n = this.parseStringGroup("url", t);
    if (this.gullet.lexer.setCatcode("%", 14), this.gullet.lexer.setCatcode("~", 13), n == null)
      return null;
    var r = n.text.replace(/\\([#$%&~_^{}])/g, "$1");
    return {
      type: "url",
      mode: this.mode,
      url: r
    };
  }
  /**
   * Parses an argument with the mode specified.
   */
  parseArgumentGroup(t, n) {
    var r = this.gullet.scanArgument(t);
    if (r == null)
      return null;
    var i = this.mode;
    n && this.switchMode(n), this.gullet.beginGroup();
    var o = this.parseExpression(!1, "EOF");
    this.expect("EOF"), this.gullet.endGroup();
    var a = {
      type: "ordgroup",
      mode: this.mode,
      loc: r.loc,
      body: o
    };
    return n && this.switchMode(i), a;
  }
  /**
   * Parses an ordinary group, which is either a single nucleus (like "x")
   * or an expression in braces (like "{x+y}") or an implicit group, a group
   * that starts at the current position, and ends right before a higher explicit
   * group ends, or at EOF.
   */
  parseGroup(t, n) {
    var r = this.fetch(), i = r.text, o;
    if (i === "{" || i === "\\begingroup") {
      this.consume();
      var a = i === "{" ? "}" : "\\endgroup";
      this.gullet.beginGroup();
      var s = this.parseExpression(!1, a), l = this.fetch();
      this.expect(a), this.gullet.endGroup(), o = {
        type: "ordgroup",
        mode: this.mode,
        loc: ko.range(r, l),
        body: s,
        // A group formed by \begingroup...\endgroup is a semi-simple group
        // which doesn't affect spacing in math mode, i.e., is transparent.
        // https://tex.stackexchange.com/questions/1930/when-should-one-
        // use-begingroup-instead-of-bgroup
        semisimple: i === "\\begingroup" || void 0
      };
    } else if (o = this.parseFunction(n, t) || this.parseSymbol(), o == null && i[0] === "\\" && !AF.hasOwnProperty(i)) {
      if (this.settings.throwOnError)
        throw new Ye("Undefined control sequence: " + i, r);
      o = this.formatUnsupportedCmd(i), this.consume();
    }
    return o;
  }
  /**
   * Form ligature-like combinations of characters for text mode.
   * This includes inputs like "--", "---", "``" and "''".
   * The result will simply replace multiple textord nodes with a single
   * character in each value by a single textord node having multiple
   * characters in its value.  The representation is still ASCII source.
   * The group will be modified in place.
   */
  formLigatures(t) {
    for (var n = t.length - 1, r = 0; r < n; ++r) {
      var i = t[r], o = i.text;
      o === "-" && t[r + 1].text === "-" && (r + 1 < n && t[r + 2].text === "-" ? (t.splice(r, 3, {
        type: "textord",
        mode: "text",
        loc: ko.range(i, t[r + 2]),
        text: "---"
      }), n -= 2) : (t.splice(r, 2, {
        type: "textord",
        mode: "text",
        loc: ko.range(i, t[r + 1]),
        text: "--"
      }), n -= 1)), (o === "'" || o === "`") && t[r + 1].text === o && (t.splice(r, 2, {
        type: "textord",
        mode: "text",
        loc: ko.range(i, t[r + 1]),
        text: o + o
      }), n -= 1);
    }
  }
  /**
   * Parse a single symbol out of the string. Here, we handle single character
   * symbols and special functions like \verb.
   */
  parseSymbol() {
    var t = this.fetch(), n = t.text;
    if (/^\\verb[^a-zA-Z]/.test(n)) {
      this.consume();
      var r = n.slice(5), i = r.charAt(0) === "*";
      if (i && (r = r.slice(1)), r.length < 2 || r.charAt(0) !== r.slice(-1))
        throw new Ye(`\\verb assertion failed --
                    please report what input caused this bug`);
      return r = r.slice(1, -1), {
        type: "verb",
        mode: "text",
        body: r,
        star: i
      };
    }
    q9.hasOwnProperty(n[0]) && !Bn[this.mode][n[0]] && (this.settings.strict && this.mode === "math" && this.settings.reportNonstrict("unicodeTextInMathMode", 'Accented Unicode text character "' + n[0] + '" used in math mode', t), n = q9[n[0]] + n.slice(1));
    var o = Ple.exec(n);
    o && (n = n.substring(0, o.index), n === "i" ? n = "ı" : n === "j" && (n = "ȷ"));
    var a;
    if (Bn[this.mode][n]) {
      this.settings.strict && this.mode === "math" && F5.indexOf(n) >= 0 && this.settings.reportNonstrict("unicodeTextInMathMode", 'Latin-1/Unicode text character "' + n[0] + '" used in math mode', t);
      var s = Bn[this.mode][n].group, l = ko.range(t), u;
      if (Ose.hasOwnProperty(s)) {
        var d = s;
        u = {
          type: "atom",
          mode: this.mode,
          family: d,
          loc: l,
          text: n
        };
      } else
        u = {
          type: s,
          mode: this.mode,
          loc: l,
          text: n
        };
      a = u;
    } else if (n.charCodeAt(0) >= 128)
      this.settings.strict && (Bz(n.charCodeAt(0)) ? this.mode === "math" && this.settings.reportNonstrict("unicodeTextInMathMode", 'Unicode text character "' + n[0] + '" used in math mode', t) : this.settings.reportNonstrict("unknownSymbol", 'Unrecognized Unicode character "' + n[0] + '"' + (" (" + n.charCodeAt(0) + ")"), t)), a = {
        type: "textord",
        mode: "text",
        loc: ko.range(t),
        text: n
      };
    else
      return null;
    if (this.consume(), o)
      for (var p = 0; p < o[0].length; p++) {
        var f = o[0][p];
        if (!d3[f])
          throw new Ye("Unknown accent ' " + f + "'", t);
        var m = d3[f][this.mode] || d3[f].text;
        if (!m)
          throw new Ye("Accent " + f + " unsupported in " + this.mode + " mode", t);
        a = {
          type: "accent",
          mode: this.mode,
          loc: ko.range(t),
          label: m,
          isStretchy: !1,
          isShifty: !0,
          // $FlowFixMe
          base: a
        };
      }
    return a;
  }
}
k2.endOfExpression = ["}", "\\endgroup", "\\end", "\\right", "&"];
var Hy = function(e, t) {
  if (!(typeof e == "string" || e instanceof String))
    throw new TypeError("KaTeX can only parse string typed expression");
  var n = new k2(e, t);
  delete n.gullet.macros.current["\\df@tag"];
  var r = n.parse();
  if (delete n.gullet.macros.current["\\current@color"], delete n.gullet.macros.current["\\color"], n.gullet.macros.get("\\df@tag")) {
    if (!t.displayMode)
      throw new Ye("\\tag works only in display equations");
    r = [{
      type: "tag",
      mode: "text",
      body: r,
      tag: n.subparse([new ca("\\df@tag")])
    }];
  }
  return r;
}, TF = function(e, t, n) {
  t.textContent = "";
  var r = Vy(e, n).toNode();
  t.appendChild(r);
};
typeof document < "u" && document.compatMode !== "CSS1Compat" && (typeof console < "u" && console.warn("Warning: KaTeX doesn't work in quirks mode. Make sure your website has a suitable doctype."), TF = function() {
  throw new Ye("KaTeX doesn't work in quirks mode.");
});
var Vle = function(e, t) {
  var n = Vy(e, t).toMarkup();
  return n;
}, Ule = function(e, t) {
  var n = new Sy(t);
  return Hy(e, n);
}, jF = function(e, t, n) {
  if (n.throwOnError || !(e instanceof Ye))
    throw e;
  var r = Ee.makeSpan(["katex-error"], [new ma(t)]);
  return r.setAttribute("title", e.toString()), r.setAttribute("style", "color:" + n.errorColor), r;
}, Vy = function(e, t) {
  var n = new Sy(t);
  try {
    var r = Hy(e, n);
    return ele(r, e, n);
  } catch (i) {
    return jF(i, e, n);
  }
}, Wle = function(e, t) {
  var n = new Sy(t);
  try {
    var r = Hy(e, n);
    return tle(r, e, n);
  } catch (i) {
    return jF(i, e, n);
  }
}, E2 = {
  /**
   * Current KaTeX version
   */
  version: "0.16.11",
  /**
   * Renders the given LaTeX into an HTML+MathML combination, and adds
   * it as a child to the specified DOM node.
   */
  render: TF,
  /**
   * Renders the given LaTeX into an HTML+MathML combination string,
   * for sending to the client.
   */
  renderToString: Vle,
  /**
   * KaTeX error, usually during parsing.
   */
  ParseError: Ye,
  /**
   * The shema of Settings
   */
  SETTINGS_SCHEMA: _1,
  /**
   * Parses the given LaTeX into KaTeX's internal parse tree structure,
   * without rendering to HTML or MathML.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __parse: Ule,
  /**
   * Renders the given LaTeX into an HTML+MathML internal DOM tree
   * representation, without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __renderToDomTree: Vy,
  /**
   * Renders the given LaTeX into an HTML internal DOM tree representation,
   * without MathML and without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __renderToHTMLTree: Wle,
  /**
   * extends internal font metrics object with a new object
   * each key in the new object represents a font name
  */
  __setFontMetrics: Ese,
  /**
   * adds a new symbol to builtin symbols table
   */
  __defineSymbol: N,
  /**
   * adds a new function to builtin function list,
   * which directly produce parse tree elements
   * and have their own html/mathml builders
   */
  __defineFunction: ht,
  /**
   * adds a new macro to builtin macro list
   */
  __defineMacro: Z,
  /**
   * Expose the dom tree node types, which can be useful for type checking nodes.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __domTree: {
    Span: Hf,
    Anchor: Ty,
    SymbolNode: ma,
    SvgNode: dl,
    PathNode: xu,
    LineNode: z5
  }
};
E2.__defineMacro("\\ce", function(e) {
  return NF(e.consumeArgs(1)[0], "ce");
});
E2.__defineMacro("\\pu", function(e) {
  return NF(e.consumeArgs(1)[0], "pu");
});
E2.__defineMacro("\\tripledash", "{\\vphantom{-}\\raisebox{2.56mu}{$\\mkern2mu\\tiny\\text{-}\\mkern1mu\\text{-}\\mkern1mu\\text{-}\\mkern2mu$}}");
var NF = function(e, t) {
  for (var n = "", r = e.length && e[e.length - 1].loc.start, i = e.length - 1; i >= 0; i--)
    e[i].loc.start > r && (n += " ", r = e[i].loc.start), n += e[i].text, r += e[i].text.length;
  var o = jn.go(_e.go(n, t));
  return o;
}, _e = {
  //
  // Parses mchem \ce syntax
  //
  // Call like
  //   go("H2O");
  //
  go: function(e, t) {
    if (!e)
      return [];
    t === void 0 && (t = "ce");
    var n = "0", r = {};
    r.parenthesisLevel = 0, e = e.replace(/\n/g, " "), e = e.replace(/[\u2212\u2013\u2014\u2010]/g, "-"), e = e.replace(/[\u2026]/g, "...");
    for (var i, o = 10, a = []; ; ) {
      i !== e ? (o = 10, i = e) : o--;
      var s = _e.stateMachines[t], l = s.transitions[n] || s.transitions["*"];
      e: for (var u = 0; u < l.length; u++) {
        var d = _e.patterns.match_(l[u].pattern, e);
        if (d) {
          for (var p = l[u].task, f = 0; f < p.action_.length; f++) {
            var m;
            if (s.actions[p.action_[f].type_])
              m = s.actions[p.action_[f].type_](r, d.match_, p.action_[f].option);
            else if (_e.actions[p.action_[f].type_])
              m = _e.actions[p.action_[f].type_](r, d.match_, p.action_[f].option);
            else
              throw ["MhchemBugA", "mhchem bug A. Please report. (" + p.action_[f].type_ + ")"];
            _e.concatArray(a, m);
          }
          if (n = p.nextState || n, e.length > 0) {
            if (p.revisit || (e = d.remainder), !p.toContinue)
              break e;
          } else
            return a;
        }
      }
      if (o <= 0)
        throw ["MhchemBugU", "mhchem bug U. Please report."];
    }
  },
  concatArray: function(e, t) {
    if (t)
      if (Array.isArray(t))
        for (var n = 0; n < t.length; n++)
          e.push(t[n]);
      else
        e.push(t);
  },
  patterns: {
    //
    // Matching patterns
    // either regexps or function that return null or {match_:"a", remainder:"bc"}
    //
    patterns: {
      // property names must not look like integers ("2") for correct property traversal order, later on
      empty: /^$/,
      else: /^./,
      else2: /^./,
      space: /^\s/,
      "space A": /^\s(?=[A-Z\\$])/,
      space$: /^\s$/,
      "a-z": /^[a-z]/,
      x: /^x/,
      x$: /^x$/,
      i$: /^i$/,
      letters: /^(?:[a-zA-Z\u03B1-\u03C9\u0391-\u03A9?@]|(?:\\(?:alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|omicron|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega|Gamma|Delta|Theta|Lambda|Xi|Pi|Sigma|Upsilon|Phi|Psi|Omega)(?:\s+|\{\}|(?![a-zA-Z]))))+/,
      "\\greek": /^\\(?:alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|omicron|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega|Gamma|Delta|Theta|Lambda|Xi|Pi|Sigma|Upsilon|Phi|Psi|Omega)(?:\s+|\{\}|(?![a-zA-Z]))/,
      "one lowercase latin letter $": /^(?:([a-z])(?:$|[^a-zA-Z]))$/,
      "$one lowercase latin letter$ $": /^\$(?:([a-z])(?:$|[^a-zA-Z]))\$$/,
      "one lowercase greek letter $": /^(?:\$?[\u03B1-\u03C9]\$?|\$?\\(?:alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|omicron|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega)\s*\$?)(?:\s+|\{\}|(?![a-zA-Z]))$/,
      digits: /^[0-9]+/,
      "-9.,9": /^[+\-]?(?:[0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+))/,
      "-9.,9 no missing 0": /^[+\-]?[0-9]+(?:[.,][0-9]+)?/,
      "(-)(9.,9)(e)(99)": function(e) {
        var t = e.match(/^(\+\-|\+\/\-|\+|\-|\\pm\s?)?([0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+))?(\((?:[0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+))\))?(?:([eE]|\s*(\*|x|\\times|\u00D7)\s*10\^)([+\-]?[0-9]+|\{[+\-]?[0-9]+\}))?/);
        return t && t[0] ? {
          match_: t.splice(1),
          remainder: e.substr(t[0].length)
        } : null;
      },
      "(-)(9)^(-9)": function(e) {
        var t = e.match(/^(\+\-|\+\/\-|\+|\-|\\pm\s?)?([0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+)?)\^([+\-]?[0-9]+|\{[+\-]?[0-9]+\})/);
        return t && t[0] ? {
          match_: t.splice(1),
          remainder: e.substr(t[0].length)
        } : null;
      },
      "state of aggregation $": function(e) {
        var t = _e.patterns.findObserveGroups(e, "", /^\([a-z]{1,3}(?=[\),])/, ")", "");
        if (t && t.remainder.match(/^($|[\s,;\)\]\}])/))
          return t;
        var n = e.match(/^(?:\((?:\\ca\s?)?\$[amothc]\$\))/);
        return n ? {
          match_: n[0],
          remainder: e.substr(n[0].length)
        } : null;
      },
      "_{(state of aggregation)}$": /^_\{(\([a-z]{1,3}\))\}/,
      "{[(": /^(?:\\\{|\[|\()/,
      ")]}": /^(?:\)|\]|\\\})/,
      ", ": /^[,;]\s*/,
      ",": /^[,;]/,
      ".": /^[.]/,
      ". ": /^([.\u22C5\u00B7\u2022])\s*/,
      "...": /^\.\.\.(?=$|[^.])/,
      "* ": /^([*])\s*/,
      "^{(...)}": function(e) {
        return _e.patterns.findObserveGroups(e, "^{", "", "", "}");
      },
      "^($...$)": function(e) {
        return _e.patterns.findObserveGroups(e, "^", "$", "$", "");
      },
      "^a": /^\^([0-9]+|[^\\_])/,
      "^\\x{}{}": function(e) {
        return _e.patterns.findObserveGroups(e, "^", /^\\[a-zA-Z]+\{/, "}", "", "", "{", "}", "", !0);
      },
      "^\\x{}": function(e) {
        return _e.patterns.findObserveGroups(e, "^", /^\\[a-zA-Z]+\{/, "}", "");
      },
      "^\\x": /^\^(\\[a-zA-Z]+)\s*/,
      "^(-1)": /^\^(-?\d+)/,
      "'": /^'/,
      "_{(...)}": function(e) {
        return _e.patterns.findObserveGroups(e, "_{", "", "", "}");
      },
      "_($...$)": function(e) {
        return _e.patterns.findObserveGroups(e, "_", "$", "$", "");
      },
      _9: /^_([+\-]?[0-9]+|[^\\])/,
      "_\\x{}{}": function(e) {
        return _e.patterns.findObserveGroups(e, "_", /^\\[a-zA-Z]+\{/, "}", "", "", "{", "}", "", !0);
      },
      "_\\x{}": function(e) {
        return _e.patterns.findObserveGroups(e, "_", /^\\[a-zA-Z]+\{/, "}", "");
      },
      "_\\x": /^_(\\[a-zA-Z]+)\s*/,
      "^_": /^(?:\^(?=_)|\_(?=\^)|[\^_]$)/,
      "{}": /^\{\}/,
      "{...}": function(e) {
        return _e.patterns.findObserveGroups(e, "", "{", "}", "");
      },
      "{(...)}": function(e) {
        return _e.patterns.findObserveGroups(e, "{", "", "", "}");
      },
      "$...$": function(e) {
        return _e.patterns.findObserveGroups(e, "", "$", "$", "");
      },
      "${(...)}$": function(e) {
        return _e.patterns.findObserveGroups(e, "${", "", "", "}$");
      },
      "$(...)$": function(e) {
        return _e.patterns.findObserveGroups(e, "$", "", "", "$");
      },
      "=<>": /^[=<>]/,
      "#": /^[#\u2261]/,
      "+": /^\+/,
      "-$": /^-(?=[\s_},;\]/]|$|\([a-z]+\))/,
      // -space -, -; -] -/ -$ -state-of-aggregation
      "-9": /^-(?=[0-9])/,
      "- orbital overlap": /^-(?=(?:[spd]|sp)(?:$|[\s,;\)\]\}]))/,
      "-": /^-/,
      "pm-operator": /^(?:\\pm|\$\\pm\$|\+-|\+\/-)/,
      operator: /^(?:\+|(?:[\-=<>]|<<|>>|\\approx|\$\\approx\$)(?=\s|$|-?[0-9]))/,
      arrowUpDown: /^(?:v|\(v\)|\^|\(\^\))(?=$|[\s,;\)\]\}])/,
      "\\bond{(...)}": function(e) {
        return _e.patterns.findObserveGroups(e, "\\bond{", "", "", "}");
      },
      "->": /^(?:<->|<-->|->|<-|<=>>|<<=>|<=>|[\u2192\u27F6\u21CC])/,
      CMT: /^[CMT](?=\[)/,
      "[(...)]": function(e) {
        return _e.patterns.findObserveGroups(e, "[", "", "", "]");
      },
      "1st-level escape": /^(&|\\\\|\\hline)\s*/,
      "\\,": /^(?:\\[,\ ;:])/,
      // \\x - but output no space before
      "\\x{}{}": function(e) {
        return _e.patterns.findObserveGroups(e, "", /^\\[a-zA-Z]+\{/, "}", "", "", "{", "}", "", !0);
      },
      "\\x{}": function(e) {
        return _e.patterns.findObserveGroups(e, "", /^\\[a-zA-Z]+\{/, "}", "");
      },
      "\\ca": /^\\ca(?:\s+|(?![a-zA-Z]))/,
      "\\x": /^(?:\\[a-zA-Z]+\s*|\\[_&{}%])/,
      orbital: /^(?:[0-9]{1,2}[spdfgh]|[0-9]{0,2}sp)(?=$|[^a-zA-Z])/,
      // only those with numbers in front, because the others will be formatted correctly anyway
      others: /^[\/~|]/,
      "\\frac{(...)}": function(e) {
        return _e.patterns.findObserveGroups(e, "\\frac{", "", "", "}", "{", "", "", "}");
      },
      "\\overset{(...)}": function(e) {
        return _e.patterns.findObserveGroups(e, "\\overset{", "", "", "}", "{", "", "", "}");
      },
      "\\underset{(...)}": function(e) {
        return _e.patterns.findObserveGroups(e, "\\underset{", "", "", "}", "{", "", "", "}");
      },
      "\\underbrace{(...)}": function(e) {
        return _e.patterns.findObserveGroups(e, "\\underbrace{", "", "", "}_", "{", "", "", "}");
      },
      "\\color{(...)}0": function(e) {
        return _e.patterns.findObserveGroups(e, "\\color{", "", "", "}");
      },
      "\\color{(...)}{(...)}1": function(e) {
        return _e.patterns.findObserveGroups(e, "\\color{", "", "", "}", "{", "", "", "}");
      },
      "\\color(...){(...)}2": function(e) {
        return _e.patterns.findObserveGroups(e, "\\color", "\\", "", /^(?=\{)/, "{", "", "", "}");
      },
      "\\ce{(...)}": function(e) {
        return _e.patterns.findObserveGroups(e, "\\ce{", "", "", "}");
      },
      oxidation$: /^(?:[+-][IVX]+|\\pm\s*0|\$\\pm\$\s*0)$/,
      "d-oxidation$": /^(?:[+-]?\s?[IVX]+|\\pm\s*0|\$\\pm\$\s*0)$/,
      // 0 could be oxidation or charge
      "roman numeral": /^[IVX]+/,
      "1/2$": /^[+\-]?(?:[0-9]+|\$[a-z]\$|[a-z])\/[0-9]+(?:\$[a-z]\$|[a-z])?$/,
      amount: function(e) {
        var t;
        if (t = e.match(/^(?:(?:(?:\([+\-]?[0-9]+\/[0-9]+\)|[+\-]?(?:[0-9]+|\$[a-z]\$|[a-z])\/[0-9]+|[+\-]?[0-9]+[.,][0-9]+|[+\-]?\.[0-9]+|[+\-]?[0-9]+)(?:[a-z](?=\s*[A-Z]))?)|[+\-]?[a-z](?=\s*[A-Z])|\+(?!\s))/), t)
          return {
            match_: t[0],
            remainder: e.substr(t[0].length)
          };
        var n = _e.patterns.findObserveGroups(e, "", "$", "$", "");
        return n && (t = n.match_.match(/^\$(?:\(?[+\-]?(?:[0-9]*[a-z]?[+\-])?[0-9]*[a-z](?:[+\-][0-9]*[a-z]?)?\)?|\+|-)\$$/), t) ? {
          match_: t[0],
          remainder: e.substr(t[0].length)
        } : null;
      },
      amount2: function(e) {
        return this.amount(e);
      },
      "(KV letters),": /^(?:[A-Z][a-z]{0,2}|i)(?=,)/,
      formula$: function(e) {
        if (e.match(/^\([a-z]+\)$/))
          return null;
        var t = e.match(/^(?:[a-z]|(?:[0-9\ \+\-\,\.\(\)]+[a-z])+[0-9\ \+\-\,\.\(\)]*|(?:[a-z][0-9\ \+\-\,\.\(\)]+)+[a-z]?)$/);
        return t ? {
          match_: t[0],
          remainder: e.substr(t[0].length)
        } : null;
      },
      uprightEntities: /^(?:pH|pOH|pC|pK|iPr|iBu)(?=$|[^a-zA-Z])/,
      "/": /^\s*(\/)\s*/,
      "//": /^\s*(\/\/)\s*/,
      "*": /^\s*[*.]\s*/
    },
    findObserveGroups: function(e, t, n, r, i, o, a, s, l, u) {
      var d = function(E, b) {
        if (typeof b == "string")
          return E.indexOf(b) !== 0 ? null : b;
        var C = E.match(b);
        return C ? C[0] : null;
      }, p = function(E, b, C) {
        for (var T = 0; b < E.length; ) {
          var z = E.charAt(b), I = d(E.substr(b), C);
          if (I !== null && T === 0)
            return {
              endMatchBegin: b,
              endMatchEnd: b + I.length
            };
          if (z === "{")
            T++;
          else if (z === "}") {
            if (T === 0)
              throw ["ExtraCloseMissingOpen", "Extra close brace or missing open brace"];
            T--;
          }
          b++;
        }
        return null;
      }, f = d(e, t);
      if (f === null || (e = e.substr(f.length), f = d(e, n), f === null))
        return null;
      var m = p(e, f.length, r || i);
      if (m === null)
        return null;
      var y = e.substring(0, r ? m.endMatchEnd : m.endMatchBegin);
      if (o || a) {
        var g = this.findObserveGroups(e.substr(m.endMatchEnd), o, a, s, l);
        if (g === null)
          return null;
        var x = [y, g.match_];
        return {
          match_: u ? x.join("") : x,
          remainder: g.remainder
        };
      } else
        return {
          match_: y,
          remainder: e.substr(m.endMatchEnd)
        };
    },
    //
    // Matching function
    // e.g. match("a", input) will look for the regexp called "a" and see if it matches
    // returns null or {match_:"a", remainder:"bc"}
    //
    match_: function(e, t) {
      var n = _e.patterns.patterns[e];
      if (n === void 0)
        throw ["MhchemBugP", "mhchem bug P. Please report. (" + e + ")"];
      if (typeof n == "function")
        return _e.patterns.patterns[e](t);
      var r = t.match(n);
      if (r) {
        var i;
        return r[2] ? i = [r[1], r[2]] : r[1] ? i = r[1] : i = r[0], {
          match_: i,
          remainder: t.substr(r[0].length)
        };
      }
      return null;
    }
  },
  //
  // Generic state machine actions
  //
  actions: {
    "a=": function(e, t) {
      e.a = (e.a || "") + t;
    },
    "b=": function(e, t) {
      e.b = (e.b || "") + t;
    },
    "p=": function(e, t) {
      e.p = (e.p || "") + t;
    },
    "o=": function(e, t) {
      e.o = (e.o || "") + t;
    },
    "q=": function(e, t) {
      e.q = (e.q || "") + t;
    },
    "d=": function(e, t) {
      e.d = (e.d || "") + t;
    },
    "rm=": function(e, t) {
      e.rm = (e.rm || "") + t;
    },
    "text=": function(e, t) {
      e.text_ = (e.text_ || "") + t;
    },
    insert: function(e, t, n) {
      return {
        type_: n
      };
    },
    "insert+p1": function(e, t, n) {
      return {
        type_: n,
        p1: t
      };
    },
    "insert+p1+p2": function(e, t, n) {
      return {
        type_: n,
        p1: t[0],
        p2: t[1]
      };
    },
    copy: function(e, t) {
      return t;
    },
    rm: function(e, t) {
      return {
        type_: "rm",
        p1: t || ""
      };
    },
    text: function(e, t) {
      return _e.go(t, "text");
    },
    "{text}": function(e, t) {
      var n = ["{"];
      return _e.concatArray(n, _e.go(t, "text")), n.push("}"), n;
    },
    "tex-math": function(e, t) {
      return _e.go(t, "tex-math");
    },
    "tex-math tight": function(e, t) {
      return _e.go(t, "tex-math tight");
    },
    bond: function(e, t, n) {
      return {
        type_: "bond",
        kind_: n || t
      };
    },
    "color0-output": function(e, t) {
      return {
        type_: "color0",
        color: t[0]
      };
    },
    ce: function(e, t) {
      return _e.go(t);
    },
    "1/2": function(e, t) {
      var n = [];
      t.match(/^[+\-]/) && (n.push(t.substr(0, 1)), t = t.substr(1));
      var r = t.match(/^([0-9]+|\$[a-z]\$|[a-z])\/([0-9]+)(\$[a-z]\$|[a-z])?$/);
      return r[1] = r[1].replace(/\$/g, ""), n.push({
        type_: "frac",
        p1: r[1],
        p2: r[2]
      }), r[3] && (r[3] = r[3].replace(/\$/g, ""), n.push({
        type_: "tex-math",
        p1: r[3]
      })), n;
    },
    "9,9": function(e, t) {
      return _e.go(t, "9,9");
    }
  },
  //
  // createTransitions
  // convert  { 'letter': { 'state': { action_: 'output' } } }  to  { 'state' => [ { pattern: 'letter', task: { action_: [{type_: 'output'}] } } ] }
  // with expansion of 'a|b' to 'a' and 'b' (at 2 places)
  //
  createTransitions: function(e) {
    var t, n, r, i, o = {};
    for (t in e)
      for (n in e[t])
        for (r = n.split("|"), e[t][n].stateArray = r, i = 0; i < r.length; i++)
          o[r[i]] = [];
    for (t in e)
      for (n in e[t])
        for (r = e[t][n].stateArray || [], i = 0; i < r.length; i++) {
          var a = e[t][n];
          if (a.action_) {
            a.action_ = [].concat(a.action_);
            for (var s = 0; s < a.action_.length; s++)
              typeof a.action_[s] == "string" && (a.action_[s] = {
                type_: a.action_[s]
              });
          } else
            a.action_ = [];
          for (var l = t.split("|"), u = 0; u < l.length; u++)
            if (r[i] === "*")
              for (var d in o)
                o[d].push({
                  pattern: l[u],
                  task: a
                });
            else
              o[r[i]].push({
                pattern: l[u],
                task: a
              });
        }
    return o;
  },
  stateMachines: {}
};
_e.stateMachines = {
  //
  // \ce state machines
  //
  //#region ce
  ce: {
    // main parser
    transitions: _e.createTransitions({
      empty: {
        "*": {
          action_: "output"
        }
      },
      else: {
        "0|1|2": {
          action_: "beginsWithBond=false",
          revisit: !0,
          toContinue: !0
        }
      },
      oxidation$: {
        0: {
          action_: "oxidation-output"
        }
      },
      CMT: {
        r: {
          action_: "rdt=",
          nextState: "rt"
        },
        rd: {
          action_: "rqt=",
          nextState: "rdt"
        }
      },
      arrowUpDown: {
        "0|1|2|as": {
          action_: ["sb=false", "output", "operator"],
          nextState: "1"
        }
      },
      uprightEntities: {
        "0|1|2": {
          action_: ["o=", "output"],
          nextState: "1"
        }
      },
      orbital: {
        "0|1|2|3": {
          action_: "o=",
          nextState: "o"
        }
      },
      "->": {
        "0|1|2|3": {
          action_: "r=",
          nextState: "r"
        },
        "a|as": {
          action_: ["output", "r="],
          nextState: "r"
        },
        "*": {
          action_: ["output", "r="],
          nextState: "r"
        }
      },
      "+": {
        o: {
          action_: "d= kv",
          nextState: "d"
        },
        "d|D": {
          action_: "d=",
          nextState: "d"
        },
        q: {
          action_: "d=",
          nextState: "qd"
        },
        "qd|qD": {
          action_: "d=",
          nextState: "qd"
        },
        dq: {
          action_: ["output", "d="],
          nextState: "d"
        },
        3: {
          action_: ["sb=false", "output", "operator"],
          nextState: "0"
        }
      },
      amount: {
        "0|2": {
          action_: "a=",
          nextState: "a"
        }
      },
      "pm-operator": {
        "0|1|2|a|as": {
          action_: ["sb=false", "output", {
            type_: "operator",
            option: "\\pm"
          }],
          nextState: "0"
        }
      },
      operator: {
        "0|1|2|a|as": {
          action_: ["sb=false", "output", "operator"],
          nextState: "0"
        }
      },
      "-$": {
        "o|q": {
          action_: ["charge or bond", "output"],
          nextState: "qd"
        },
        d: {
          action_: "d=",
          nextState: "d"
        },
        D: {
          action_: ["output", {
            type_: "bond",
            option: "-"
          }],
          nextState: "3"
        },
        q: {
          action_: "d=",
          nextState: "qd"
        },
        qd: {
          action_: "d=",
          nextState: "qd"
        },
        "qD|dq": {
          action_: ["output", {
            type_: "bond",
            option: "-"
          }],
          nextState: "3"
        }
      },
      "-9": {
        "3|o": {
          action_: ["output", {
            type_: "insert",
            option: "hyphen"
          }],
          nextState: "3"
        }
      },
      "- orbital overlap": {
        o: {
          action_: ["output", {
            type_: "insert",
            option: "hyphen"
          }],
          nextState: "2"
        },
        d: {
          action_: ["output", {
            type_: "insert",
            option: "hyphen"
          }],
          nextState: "2"
        }
      },
      "-": {
        "0|1|2": {
          action_: [{
            type_: "output",
            option: 1
          }, "beginsWithBond=true", {
            type_: "bond",
            option: "-"
          }],
          nextState: "3"
        },
        3: {
          action_: {
            type_: "bond",
            option: "-"
          }
        },
        a: {
          action_: ["output", {
            type_: "insert",
            option: "hyphen"
          }],
          nextState: "2"
        },
        as: {
          action_: [{
            type_: "output",
            option: 2
          }, {
            type_: "bond",
            option: "-"
          }],
          nextState: "3"
        },
        b: {
          action_: "b="
        },
        o: {
          action_: {
            type_: "- after o/d",
            option: !1
          },
          nextState: "2"
        },
        q: {
          action_: {
            type_: "- after o/d",
            option: !1
          },
          nextState: "2"
        },
        "d|qd|dq": {
          action_: {
            type_: "- after o/d",
            option: !0
          },
          nextState: "2"
        },
        "D|qD|p": {
          action_: ["output", {
            type_: "bond",
            option: "-"
          }],
          nextState: "3"
        }
      },
      amount2: {
        "1|3": {
          action_: "a=",
          nextState: "a"
        }
      },
      letters: {
        "0|1|2|3|a|as|b|p|bp|o": {
          action_: "o=",
          nextState: "o"
        },
        "q|dq": {
          action_: ["output", "o="],
          nextState: "o"
        },
        "d|D|qd|qD": {
          action_: "o after d",
          nextState: "o"
        }
      },
      digits: {
        o: {
          action_: "q=",
          nextState: "q"
        },
        "d|D": {
          action_: "q=",
          nextState: "dq"
        },
        q: {
          action_: ["output", "o="],
          nextState: "o"
        },
        a: {
          action_: "o=",
          nextState: "o"
        }
      },
      "space A": {
        "b|p|bp": {}
      },
      space: {
        a: {
          nextState: "as"
        },
        0: {
          action_: "sb=false"
        },
        "1|2": {
          action_: "sb=true"
        },
        "r|rt|rd|rdt|rdq": {
          action_: "output",
          nextState: "0"
        },
        "*": {
          action_: ["output", "sb=true"],
          nextState: "1"
        }
      },
      "1st-level escape": {
        "1|2": {
          action_: ["output", {
            type_: "insert+p1",
            option: "1st-level escape"
          }]
        },
        "*": {
          action_: ["output", {
            type_: "insert+p1",
            option: "1st-level escape"
          }],
          nextState: "0"
        }
      },
      "[(...)]": {
        "r|rt": {
          action_: "rd=",
          nextState: "rd"
        },
        "rd|rdt": {
          action_: "rq=",
          nextState: "rdq"
        }
      },
      "...": {
        "o|d|D|dq|qd|qD": {
          action_: ["output", {
            type_: "bond",
            option: "..."
          }],
          nextState: "3"
        },
        "*": {
          action_: [{
            type_: "output",
            option: 1
          }, {
            type_: "insert",
            option: "ellipsis"
          }],
          nextState: "1"
        }
      },
      ". |* ": {
        "*": {
          action_: ["output", {
            type_: "insert",
            option: "addition compound"
          }],
          nextState: "1"
        }
      },
      "state of aggregation $": {
        "*": {
          action_: ["output", "state of aggregation"],
          nextState: "1"
        }
      },
      "{[(": {
        "a|as|o": {
          action_: ["o=", "output", "parenthesisLevel++"],
          nextState: "2"
        },
        "0|1|2|3": {
          action_: ["o=", "output", "parenthesisLevel++"],
          nextState: "2"
        },
        "*": {
          action_: ["output", "o=", "output", "parenthesisLevel++"],
          nextState: "2"
        }
      },
      ")]}": {
        "0|1|2|3|b|p|bp|o": {
          action_: ["o=", "parenthesisLevel--"],
          nextState: "o"
        },
        "a|as|d|D|q|qd|qD|dq": {
          action_: ["output", "o=", "parenthesisLevel--"],
          nextState: "o"
        }
      },
      ", ": {
        "*": {
          action_: ["output", "comma"],
          nextState: "0"
        }
      },
      "^_": {
        // ^ and _ without a sensible argument
        "*": {}
      },
      "^{(...)}|^($...$)": {
        "0|1|2|as": {
          action_: "b=",
          nextState: "b"
        },
        p: {
          action_: "b=",
          nextState: "bp"
        },
        "3|o": {
          action_: "d= kv",
          nextState: "D"
        },
        q: {
          action_: "d=",
          nextState: "qD"
        },
        "d|D|qd|qD|dq": {
          action_: ["output", "d="],
          nextState: "D"
        }
      },
      "^a|^\\x{}{}|^\\x{}|^\\x|'": {
        "0|1|2|as": {
          action_: "b=",
          nextState: "b"
        },
        p: {
          action_: "b=",
          nextState: "bp"
        },
        "3|o": {
          action_: "d= kv",
          nextState: "d"
        },
        q: {
          action_: "d=",
          nextState: "qd"
        },
        "d|qd|D|qD": {
          action_: "d="
        },
        dq: {
          action_: ["output", "d="],
          nextState: "d"
        }
      },
      "_{(state of aggregation)}$": {
        "d|D|q|qd|qD|dq": {
          action_: ["output", "q="],
          nextState: "q"
        }
      },
      "_{(...)}|_($...$)|_9|_\\x{}{}|_\\x{}|_\\x": {
        "0|1|2|as": {
          action_: "p=",
          nextState: "p"
        },
        b: {
          action_: "p=",
          nextState: "bp"
        },
        "3|o": {
          action_: "q=",
          nextState: "q"
        },
        "d|D": {
          action_: "q=",
          nextState: "dq"
        },
        "q|qd|qD|dq": {
          action_: ["output", "q="],
          nextState: "q"
        }
      },
      "=<>": {
        "0|1|2|3|a|as|o|q|d|D|qd|qD|dq": {
          action_: [{
            type_: "output",
            option: 2
          }, "bond"],
          nextState: "3"
        }
      },
      "#": {
        "0|1|2|3|a|as|o": {
          action_: [{
            type_: "output",
            option: 2
          }, {
            type_: "bond",
            option: "#"
          }],
          nextState: "3"
        }
      },
      "{}": {
        "*": {
          action_: {
            type_: "output",
            option: 1
          },
          nextState: "1"
        }
      },
      "{...}": {
        "0|1|2|3|a|as|b|p|bp": {
          action_: "o=",
          nextState: "o"
        },
        "o|d|D|q|qd|qD|dq": {
          action_: ["output", "o="],
          nextState: "o"
        }
      },
      "$...$": {
        a: {
          action_: "a="
        },
        // 2$n$
        "0|1|2|3|as|b|p|bp|o": {
          action_: "o=",
          nextState: "o"
        },
        // not 'amount'
        "as|o": {
          action_: "o="
        },
        "q|d|D|qd|qD|dq": {
          action_: ["output", "o="],
          nextState: "o"
        }
      },
      "\\bond{(...)}": {
        "*": {
          action_: [{
            type_: "output",
            option: 2
          }, "bond"],
          nextState: "3"
        }
      },
      "\\frac{(...)}": {
        "*": {
          action_: [{
            type_: "output",
            option: 1
          }, "frac-output"],
          nextState: "3"
        }
      },
      "\\overset{(...)}": {
        "*": {
          action_: [{
            type_: "output",
            option: 2
          }, "overset-output"],
          nextState: "3"
        }
      },
      "\\underset{(...)}": {
        "*": {
          action_: [{
            type_: "output",
            option: 2
          }, "underset-output"],
          nextState: "3"
        }
      },
      "\\underbrace{(...)}": {
        "*": {
          action_: [{
            type_: "output",
            option: 2
          }, "underbrace-output"],
          nextState: "3"
        }
      },
      "\\color{(...)}{(...)}1|\\color(...){(...)}2": {
        "*": {
          action_: [{
            type_: "output",
            option: 2
          }, "color-output"],
          nextState: "3"
        }
      },
      "\\color{(...)}0": {
        "*": {
          action_: [{
            type_: "output",
            option: 2
          }, "color0-output"]
        }
      },
      "\\ce{(...)}": {
        "*": {
          action_: [{
            type_: "output",
            option: 2
          }, "ce"],
          nextState: "3"
        }
      },
      "\\,": {
        "*": {
          action_: [{
            type_: "output",
            option: 1
          }, "copy"],
          nextState: "1"
        }
      },
      "\\x{}{}|\\x{}|\\x": {
        "0|1|2|3|a|as|b|p|bp|o|c0": {
          action_: ["o=", "output"],
          nextState: "3"
        },
        "*": {
          action_: ["output", "o=", "output"],
          nextState: "3"
        }
      },
      others: {
        "*": {
          action_: [{
            type_: "output",
            option: 1
          }, "copy"],
          nextState: "3"
        }
      },
      else2: {
        a: {
          action_: "a to o",
          nextState: "o",
          revisit: !0
        },
        as: {
          action_: ["output", "sb=true"],
          nextState: "1",
          revisit: !0
        },
        "r|rt|rd|rdt|rdq": {
          action_: ["output"],
          nextState: "0",
          revisit: !0
        },
        "*": {
          action_: ["output", "copy"],
          nextState: "3"
        }
      }
    }),
    actions: {
      "o after d": function(e, t) {
        var n;
        if ((e.d || "").match(/^[0-9]+$/)) {
          var r = e.d;
          e.d = void 0, n = this.output(e), e.b = r;
        } else
          n = this.output(e);
        return _e.actions["o="](e, t), n;
      },
      "d= kv": function(e, t) {
        e.d = t, e.dType = "kv";
      },
      "charge or bond": function(e, t) {
        if (e.beginsWithBond) {
          var n = [];
          return _e.concatArray(n, this.output(e)), _e.concatArray(n, _e.actions.bond(e, t, "-")), n;
        } else
          e.d = t;
      },
      "- after o/d": function(e, t, n) {
        var r = _e.patterns.match_("orbital", e.o || ""), i = _e.patterns.match_("one lowercase greek letter $", e.o || ""), o = _e.patterns.match_("one lowercase latin letter $", e.o || ""), a = _e.patterns.match_("$one lowercase latin letter$ $", e.o || ""), s = t === "-" && (r && r.remainder === "" || i || o || a);
        s && !e.a && !e.b && !e.p && !e.d && !e.q && !r && o && (e.o = "$" + e.o + "$");
        var l = [];
        return s ? (_e.concatArray(l, this.output(e)), l.push({
          type_: "hyphen"
        })) : (r = _e.patterns.match_("digits", e.d || ""), n && r && r.remainder === "" ? (_e.concatArray(l, _e.actions["d="](e, t)), _e.concatArray(l, this.output(e))) : (_e.concatArray(l, this.output(e)), _e.concatArray(l, _e.actions.bond(e, t, "-")))), l;
      },
      "a to o": function(e) {
        e.o = e.a, e.a = void 0;
      },
      "sb=true": function(e) {
        e.sb = !0;
      },
      "sb=false": function(e) {
        e.sb = !1;
      },
      "beginsWithBond=true": function(e) {
        e.beginsWithBond = !0;
      },
      "beginsWithBond=false": function(e) {
        e.beginsWithBond = !1;
      },
      "parenthesisLevel++": function(e) {
        e.parenthesisLevel++;
      },
      "parenthesisLevel--": function(e) {
        e.parenthesisLevel--;
      },
      "state of aggregation": function(e, t) {
        return {
          type_: "state of aggregation",
          p1: _e.go(t, "o")
        };
      },
      comma: function(e, t) {
        var n = t.replace(/\s*$/, ""), r = n !== t;
        return r && e.parenthesisLevel === 0 ? {
          type_: "comma enumeration L",
          p1: n
        } : {
          type_: "comma enumeration M",
          p1: n
        };
      },
      output: function(e, t, n) {
        var r;
        if (!e.r)
          r = [], !e.a && !e.b && !e.p && !e.o && !e.q && !e.d && !n || (e.sb && r.push({
            type_: "entitySkip"
          }), !e.o && !e.q && !e.d && !e.b && !e.p && n !== 2 ? (e.o = e.a, e.a = void 0) : !e.o && !e.q && !e.d && (e.b || e.p) ? (e.o = e.a, e.d = e.b, e.q = e.p, e.a = e.b = e.p = void 0) : e.o && e.dType === "kv" && _e.patterns.match_("d-oxidation$", e.d || "") ? e.dType = "oxidation" : e.o && e.dType === "kv" && !e.q && (e.dType = void 0), r.push({
            type_: "chemfive",
            a: _e.go(e.a, "a"),
            b: _e.go(e.b, "bd"),
            p: _e.go(e.p, "pq"),
            o: _e.go(e.o, "o"),
            q: _e.go(e.q, "pq"),
            d: _e.go(e.d, e.dType === "oxidation" ? "oxidation" : "bd"),
            dType: e.dType
          }));
        else {
          var i;
          e.rdt === "M" ? i = _e.go(e.rd, "tex-math") : e.rdt === "T" ? i = [{
            type_: "text",
            p1: e.rd || ""
          }] : i = _e.go(e.rd);
          var o;
          e.rqt === "M" ? o = _e.go(e.rq, "tex-math") : e.rqt === "T" ? o = [{
            type_: "text",
            p1: e.rq || ""
          }] : o = _e.go(e.rq), r = {
            type_: "arrow",
            r: e.r,
            rd: i,
            rq: o
          };
        }
        for (var a in e)
          a !== "parenthesisLevel" && a !== "beginsWithBond" && delete e[a];
        return r;
      },
      "oxidation-output": function(e, t) {
        var n = ["{"];
        return _e.concatArray(n, _e.go(t, "oxidation")), n.push("}"), n;
      },
      "frac-output": function(e, t) {
        return {
          type_: "frac-ce",
          p1: _e.go(t[0]),
          p2: _e.go(t[1])
        };
      },
      "overset-output": function(e, t) {
        return {
          type_: "overset",
          p1: _e.go(t[0]),
          p2: _e.go(t[1])
        };
      },
      "underset-output": function(e, t) {
        return {
          type_: "underset",
          p1: _e.go(t[0]),
          p2: _e.go(t[1])
        };
      },
      "underbrace-output": function(e, t) {
        return {
          type_: "underbrace",
          p1: _e.go(t[0]),
          p2: _e.go(t[1])
        };
      },
      "color-output": function(e, t) {
        return {
          type_: "color",
          color1: t[0],
          color2: _e.go(t[1])
        };
      },
      "r=": function(e, t) {
        e.r = t;
      },
      "rdt=": function(e, t) {
        e.rdt = t;
      },
      "rd=": function(e, t) {
        e.rd = t;
      },
      "rqt=": function(e, t) {
        e.rqt = t;
      },
      "rq=": function(e, t) {
        e.rq = t;
      },
      operator: function(e, t, n) {
        return {
          type_: "operator",
          kind_: n || t
        };
      }
    }
  },
  a: {
    transitions: _e.createTransitions({
      empty: {
        "*": {}
      },
      "1/2$": {
        0: {
          action_: "1/2"
        }
      },
      else: {
        0: {
          nextState: "1",
          revisit: !0
        }
      },
      "$(...)$": {
        "*": {
          action_: "tex-math tight",
          nextState: "1"
        }
      },
      ",": {
        "*": {
          action_: {
            type_: "insert",
            option: "commaDecimal"
          }
        }
      },
      else2: {
        "*": {
          action_: "copy"
        }
      }
    }),
    actions: {}
  },
  o: {
    transitions: _e.createTransitions({
      empty: {
        "*": {}
      },
      "1/2$": {
        0: {
          action_: "1/2"
        }
      },
      else: {
        0: {
          nextState: "1",
          revisit: !0
        }
      },
      letters: {
        "*": {
          action_: "rm"
        }
      },
      "\\ca": {
        "*": {
          action_: {
            type_: "insert",
            option: "circa"
          }
        }
      },
      "\\x{}{}|\\x{}|\\x": {
        "*": {
          action_: "copy"
        }
      },
      "${(...)}$|$(...)$": {
        "*": {
          action_: "tex-math"
        }
      },
      "{(...)}": {
        "*": {
          action_: "{text}"
        }
      },
      else2: {
        "*": {
          action_: "copy"
        }
      }
    }),
    actions: {}
  },
  text: {
    transitions: _e.createTransitions({
      empty: {
        "*": {
          action_: "output"
        }
      },
      "{...}": {
        "*": {
          action_: "text="
        }
      },
      "${(...)}$|$(...)$": {
        "*": {
          action_: "tex-math"
        }
      },
      "\\greek": {
        "*": {
          action_: ["output", "rm"]
        }
      },
      "\\,|\\x{}{}|\\x{}|\\x": {
        "*": {
          action_: ["output", "copy"]
        }
      },
      else: {
        "*": {
          action_: "text="
        }
      }
    }),
    actions: {
      output: function(e) {
        if (e.text_) {
          var t = {
            type_: "text",
            p1: e.text_
          };
          for (var n in e)
            delete e[n];
          return t;
        }
      }
    }
  },
  pq: {
    transitions: _e.createTransitions({
      empty: {
        "*": {}
      },
      "state of aggregation $": {
        "*": {
          action_: "state of aggregation"
        }
      },
      i$: {
        0: {
          nextState: "!f",
          revisit: !0
        }
      },
      "(KV letters),": {
        0: {
          action_: "rm",
          nextState: "0"
        }
      },
      formula$: {
        0: {
          nextState: "f",
          revisit: !0
        }
      },
      "1/2$": {
        0: {
          action_: "1/2"
        }
      },
      else: {
        0: {
          nextState: "!f",
          revisit: !0
        }
      },
      "${(...)}$|$(...)$": {
        "*": {
          action_: "tex-math"
        }
      },
      "{(...)}": {
        "*": {
          action_: "text"
        }
      },
      "a-z": {
        f: {
          action_: "tex-math"
        }
      },
      letters: {
        "*": {
          action_: "rm"
        }
      },
      "-9.,9": {
        "*": {
          action_: "9,9"
        }
      },
      ",": {
        "*": {
          action_: {
            type_: "insert+p1",
            option: "comma enumeration S"
          }
        }
      },
      "\\color{(...)}{(...)}1|\\color(...){(...)}2": {
        "*": {
          action_: "color-output"
        }
      },
      "\\color{(...)}0": {
        "*": {
          action_: "color0-output"
        }
      },
      "\\ce{(...)}": {
        "*": {
          action_: "ce"
        }
      },
      "\\,|\\x{}{}|\\x{}|\\x": {
        "*": {
          action_: "copy"
        }
      },
      else2: {
        "*": {
          action_: "copy"
        }
      }
    }),
    actions: {
      "state of aggregation": function(e, t) {
        return {
          type_: "state of aggregation subscript",
          p1: _e.go(t, "o")
        };
      },
      "color-output": function(e, t) {
        return {
          type_: "color",
          color1: t[0],
          color2: _e.go(t[1], "pq")
        };
      }
    }
  },
  bd: {
    transitions: _e.createTransitions({
      empty: {
        "*": {}
      },
      x$: {
        0: {
          nextState: "!f",
          revisit: !0
        }
      },
      formula$: {
        0: {
          nextState: "f",
          revisit: !0
        }
      },
      else: {
        0: {
          nextState: "!f",
          revisit: !0
        }
      },
      "-9.,9 no missing 0": {
        "*": {
          action_: "9,9"
        }
      },
      ".": {
        "*": {
          action_: {
            type_: "insert",
            option: "electron dot"
          }
        }
      },
      "a-z": {
        f: {
          action_: "tex-math"
        }
      },
      x: {
        "*": {
          action_: {
            type_: "insert",
            option: "KV x"
          }
        }
      },
      letters: {
        "*": {
          action_: "rm"
        }
      },
      "'": {
        "*": {
          action_: {
            type_: "insert",
            option: "prime"
          }
        }
      },
      "${(...)}$|$(...)$": {
        "*": {
          action_: "tex-math"
        }
      },
      "{(...)}": {
        "*": {
          action_: "text"
        }
      },
      "\\color{(...)}{(...)}1|\\color(...){(...)}2": {
        "*": {
          action_: "color-output"
        }
      },
      "\\color{(...)}0": {
        "*": {
          action_: "color0-output"
        }
      },
      "\\ce{(...)}": {
        "*": {
          action_: "ce"
        }
      },
      "\\,|\\x{}{}|\\x{}|\\x": {
        "*": {
          action_: "copy"
        }
      },
      else2: {
        "*": {
          action_: "copy"
        }
      }
    }),
    actions: {
      "color-output": function(e, t) {
        return {
          type_: "color",
          color1: t[0],
          color2: _e.go(t[1], "bd")
        };
      }
    }
  },
  oxidation: {
    transitions: _e.createTransitions({
      empty: {
        "*": {}
      },
      "roman numeral": {
        "*": {
          action_: "roman-numeral"
        }
      },
      "${(...)}$|$(...)$": {
        "*": {
          action_: "tex-math"
        }
      },
      else: {
        "*": {
          action_: "copy"
        }
      }
    }),
    actions: {
      "roman-numeral": function(e, t) {
        return {
          type_: "roman numeral",
          p1: t || ""
        };
      }
    }
  },
  "tex-math": {
    transitions: _e.createTransitions({
      empty: {
        "*": {
          action_: "output"
        }
      },
      "\\ce{(...)}": {
        "*": {
          action_: ["output", "ce"]
        }
      },
      "{...}|\\,|\\x{}{}|\\x{}|\\x": {
        "*": {
          action_: "o="
        }
      },
      else: {
        "*": {
          action_: "o="
        }
      }
    }),
    actions: {
      output: function(e) {
        if (e.o) {
          var t = {
            type_: "tex-math",
            p1: e.o
          };
          for (var n in e)
            delete e[n];
          return t;
        }
      }
    }
  },
  "tex-math tight": {
    transitions: _e.createTransitions({
      empty: {
        "*": {
          action_: "output"
        }
      },
      "\\ce{(...)}": {
        "*": {
          action_: ["output", "ce"]
        }
      },
      "{...}|\\,|\\x{}{}|\\x{}|\\x": {
        "*": {
          action_: "o="
        }
      },
      "-|+": {
        "*": {
          action_: "tight operator"
        }
      },
      else: {
        "*": {
          action_: "o="
        }
      }
    }),
    actions: {
      "tight operator": function(e, t) {
        e.o = (e.o || "") + "{" + t + "}";
      },
      output: function(e) {
        if (e.o) {
          var t = {
            type_: "tex-math",
            p1: e.o
          };
          for (var n in e)
            delete e[n];
          return t;
        }
      }
    }
  },
  "9,9": {
    transitions: _e.createTransitions({
      empty: {
        "*": {}
      },
      ",": {
        "*": {
          action_: "comma"
        }
      },
      else: {
        "*": {
          action_: "copy"
        }
      }
    }),
    actions: {
      comma: function() {
        return {
          type_: "commaDecimal"
        };
      }
    }
  },
  //#endregion
  //
  // \pu state machines
  //
  //#region pu
  pu: {
    transitions: _e.createTransitions({
      empty: {
        "*": {
          action_: "output"
        }
      },
      space$: {
        "*": {
          action_: ["output", "space"]
        }
      },
      "{[(|)]}": {
        "0|a": {
          action_: "copy"
        }
      },
      "(-)(9)^(-9)": {
        0: {
          action_: "number^",
          nextState: "a"
        }
      },
      "(-)(9.,9)(e)(99)": {
        0: {
          action_: "enumber",
          nextState: "a"
        }
      },
      space: {
        "0|a": {}
      },
      "pm-operator": {
        "0|a": {
          action_: {
            type_: "operator",
            option: "\\pm"
          },
          nextState: "0"
        }
      },
      operator: {
        "0|a": {
          action_: "copy",
          nextState: "0"
        }
      },
      "//": {
        d: {
          action_: "o=",
          nextState: "/"
        }
      },
      "/": {
        d: {
          action_: "o=",
          nextState: "/"
        }
      },
      "{...}|else": {
        "0|d": {
          action_: "d=",
          nextState: "d"
        },
        a: {
          action_: ["space", "d="],
          nextState: "d"
        },
        "/|q": {
          action_: "q=",
          nextState: "q"
        }
      }
    }),
    actions: {
      enumber: function(e, t) {
        var n = [];
        return t[0] === "+-" || t[0] === "+/-" ? n.push("\\pm ") : t[0] && n.push(t[0]), t[1] && (_e.concatArray(n, _e.go(t[1], "pu-9,9")), t[2] && (t[2].match(/[,.]/) ? _e.concatArray(n, _e.go(t[2], "pu-9,9")) : n.push(t[2])), t[3] = t[4] || t[3], t[3] && (t[3] = t[3].trim(), t[3] === "e" || t[3].substr(0, 1) === "*" ? n.push({
          type_: "cdot"
        }) : n.push({
          type_: "times"
        }))), t[3] && n.push("10^{" + t[5] + "}"), n;
      },
      "number^": function(e, t) {
        var n = [];
        return t[0] === "+-" || t[0] === "+/-" ? n.push("\\pm ") : t[0] && n.push(t[0]), _e.concatArray(n, _e.go(t[1], "pu-9,9")), n.push("^{" + t[2] + "}"), n;
      },
      operator: function(e, t, n) {
        return {
          type_: "operator",
          kind_: n || t
        };
      },
      space: function() {
        return {
          type_: "pu-space-1"
        };
      },
      output: function(e) {
        var t, n = _e.patterns.match_("{(...)}", e.d || "");
        n && n.remainder === "" && (e.d = n.match_);
        var r = _e.patterns.match_("{(...)}", e.q || "");
        if (r && r.remainder === "" && (e.q = r.match_), e.d && (e.d = e.d.replace(/\u00B0C|\^oC|\^{o}C/g, "{}^{\\circ}C"), e.d = e.d.replace(/\u00B0F|\^oF|\^{o}F/g, "{}^{\\circ}F")), e.q) {
          e.q = e.q.replace(/\u00B0C|\^oC|\^{o}C/g, "{}^{\\circ}C"), e.q = e.q.replace(/\u00B0F|\^oF|\^{o}F/g, "{}^{\\circ}F");
          var i = {
            d: _e.go(e.d, "pu"),
            q: _e.go(e.q, "pu")
          };
          e.o === "//" ? t = {
            type_: "pu-frac",
            p1: i.d,
            p2: i.q
          } : (t = i.d, i.d.length > 1 || i.q.length > 1 ? t.push({
            type_: " / "
          }) : t.push({
            type_: "/"
          }), _e.concatArray(t, i.q));
        } else
          t = _e.go(e.d, "pu-2");
        for (var o in e)
          delete e[o];
        return t;
      }
    }
  },
  "pu-2": {
    transitions: _e.createTransitions({
      empty: {
        "*": {
          action_: "output"
        }
      },
      "*": {
        "*": {
          action_: ["output", "cdot"],
          nextState: "0"
        }
      },
      "\\x": {
        "*": {
          action_: "rm="
        }
      },
      space: {
        "*": {
          action_: ["output", "space"],
          nextState: "0"
        }
      },
      "^{(...)}|^(-1)": {
        1: {
          action_: "^(-1)"
        }
      },
      "-9.,9": {
        0: {
          action_: "rm=",
          nextState: "0"
        },
        1: {
          action_: "^(-1)",
          nextState: "0"
        }
      },
      "{...}|else": {
        "*": {
          action_: "rm=",
          nextState: "1"
        }
      }
    }),
    actions: {
      cdot: function() {
        return {
          type_: "tight cdot"
        };
      },
      "^(-1)": function(e, t) {
        e.rm += "^{" + t + "}";
      },
      space: function() {
        return {
          type_: "pu-space-2"
        };
      },
      output: function(e) {
        var t = [];
        if (e.rm) {
          var n = _e.patterns.match_("{(...)}", e.rm || "");
          n && n.remainder === "" ? t = _e.go(n.match_, "pu") : t = {
            type_: "rm",
            p1: e.rm
          };
        }
        for (var r in e)
          delete e[r];
        return t;
      }
    }
  },
  "pu-9,9": {
    transitions: _e.createTransitions({
      empty: {
        0: {
          action_: "output-0"
        },
        o: {
          action_: "output-o"
        }
      },
      ",": {
        0: {
          action_: ["output-0", "comma"],
          nextState: "o"
        }
      },
      ".": {
        0: {
          action_: ["output-0", "copy"],
          nextState: "o"
        }
      },
      else: {
        "*": {
          action_: "text="
        }
      }
    }),
    actions: {
      comma: function() {
        return {
          type_: "commaDecimal"
        };
      },
      "output-0": function(e) {
        var t = [];
        if (e.text_ = e.text_ || "", e.text_.length > 4) {
          var n = e.text_.length % 3;
          n === 0 && (n = 3);
          for (var r = e.text_.length - 3; r > 0; r -= 3)
            t.push(e.text_.substr(r, 3)), t.push({
              type_: "1000 separator"
            });
          t.push(e.text_.substr(0, n)), t.reverse();
        } else
          t.push(e.text_);
        for (var i in e)
          delete e[i];
        return t;
      },
      "output-o": function(e) {
        var t = [];
        if (e.text_ = e.text_ || "", e.text_.length > 4) {
          for (var n = e.text_.length - 3, r = 0; r < n; r += 3)
            t.push(e.text_.substr(r, 3)), t.push({
              type_: "1000 separator"
            });
          t.push(e.text_.substr(r));
        } else
          t.push(e.text_);
        for (var i in e)
          delete e[i];
        return t;
      }
    }
  }
  //#endregion
};
var jn = {
  go: function(e, t) {
    if (!e)
      return "";
    for (var n = "", r = !1, i = 0; i < e.length; i++) {
      var o = e[i];
      typeof o == "string" ? n += o : (n += jn._go2(o), o.type_ === "1st-level escape" && (r = !0));
    }
    return !t && !r && n && (n = "{" + n + "}"), n;
  },
  _goInner: function(e) {
    return e && jn.go(e, !0);
  },
  _go2: function(e) {
    var t;
    switch (e.type_) {
      case "chemfive":
        t = "";
        var n = {
          a: jn._goInner(e.a),
          b: jn._goInner(e.b),
          p: jn._goInner(e.p),
          o: jn._goInner(e.o),
          q: jn._goInner(e.q),
          d: jn._goInner(e.d)
        };
        n.a && (n.a.match(/^[+\-]/) && (n.a = "{" + n.a + "}"), t += n.a + "\\,"), (n.b || n.p) && (t += "{\\vphantom{X}}", t += "^{\\hphantom{" + (n.b || "") + "}}_{\\hphantom{" + (n.p || "") + "}}", t += "{\\vphantom{X}}", t += "^{\\smash[t]{\\vphantom{2}}\\mathllap{" + (n.b || "") + "}}", t += "_{\\vphantom{2}\\mathllap{\\smash[t]{" + (n.p || "") + "}}}"), n.o && (n.o.match(/^[+\-]/) && (n.o = "{" + n.o + "}"), t += n.o), e.dType === "kv" ? ((n.d || n.q) && (t += "{\\vphantom{X}}"), n.d && (t += "^{" + n.d + "}"), n.q && (t += "_{\\smash[t]{" + n.q + "}}")) : e.dType === "oxidation" ? (n.d && (t += "{\\vphantom{X}}", t += "^{" + n.d + "}"), n.q && (t += "{\\vphantom{X}}", t += "_{\\smash[t]{" + n.q + "}}")) : (n.q && (t += "{\\vphantom{X}}", t += "_{\\smash[t]{" + n.q + "}}"), n.d && (t += "{\\vphantom{X}}", t += "^{" + n.d + "}"));
        break;
      case "rm":
        t = "\\mathrm{" + e.p1 + "}";
        break;
      case "text":
        e.p1.match(/[\^_]/) ? (e.p1 = e.p1.replace(" ", "~").replace("-", "\\text{-}"), t = "\\mathrm{" + e.p1 + "}") : t = "\\text{" + e.p1 + "}";
        break;
      case "roman numeral":
        t = "\\mathrm{" + e.p1 + "}";
        break;
      case "state of aggregation":
        t = "\\mskip2mu " + jn._goInner(e.p1);
        break;
      case "state of aggregation subscript":
        t = "\\mskip1mu " + jn._goInner(e.p1);
        break;
      case "bond":
        if (t = jn._getBond(e.kind_), !t)
          throw ["MhchemErrorBond", "mhchem Error. Unknown bond type (" + e.kind_ + ")"];
        break;
      case "frac":
        var r = "\\frac{" + e.p1 + "}{" + e.p2 + "}";
        t = "\\mathchoice{\\textstyle" + r + "}{" + r + "}{" + r + "}{" + r + "}";
        break;
      case "pu-frac":
        var i = "\\frac{" + jn._goInner(e.p1) + "}{" + jn._goInner(e.p2) + "}";
        t = "\\mathchoice{\\textstyle" + i + "}{" + i + "}{" + i + "}{" + i + "}";
        break;
      case "tex-math":
        t = e.p1 + " ";
        break;
      case "frac-ce":
        t = "\\frac{" + jn._goInner(e.p1) + "}{" + jn._goInner(e.p2) + "}";
        break;
      case "overset":
        t = "\\overset{" + jn._goInner(e.p1) + "}{" + jn._goInner(e.p2) + "}";
        break;
      case "underset":
        t = "\\underset{" + jn._goInner(e.p1) + "}{" + jn._goInner(e.p2) + "}";
        break;
      case "underbrace":
        t = "\\underbrace{" + jn._goInner(e.p1) + "}_{" + jn._goInner(e.p2) + "}";
        break;
      case "color":
        t = "{\\color{" + e.color1 + "}{" + jn._goInner(e.color2) + "}}";
        break;
      case "color0":
        t = "\\color{" + e.color + "}";
        break;
      case "arrow":
        var o = {
          rd: jn._goInner(e.rd),
          rq: jn._goInner(e.rq)
        }, a = "\\x" + jn._getArrow(e.r);
        o.rq && (a += "[{" + o.rq + "}]"), o.rd ? a += "{" + o.rd + "}" : a += "{}", t = a;
        break;
      case "operator":
        t = jn._getOperator(e.kind_);
        break;
      case "1st-level escape":
        t = e.p1 + " ";
        break;
      case "space":
        t = " ";
        break;
      case "entitySkip":
        t = "~";
        break;
      case "pu-space-1":
        t = "~";
        break;
      case "pu-space-2":
        t = "\\mkern3mu ";
        break;
      case "1000 separator":
        t = "\\mkern2mu ";
        break;
      case "commaDecimal":
        t = "{,}";
        break;
      case "comma enumeration L":
        t = "{" + e.p1 + "}\\mkern6mu ";
        break;
      case "comma enumeration M":
        t = "{" + e.p1 + "}\\mkern3mu ";
        break;
      case "comma enumeration S":
        t = "{" + e.p1 + "}\\mkern1mu ";
        break;
      case "hyphen":
        t = "\\text{-}";
        break;
      case "addition compound":
        t = "\\,{\\cdot}\\,";
        break;
      case "electron dot":
        t = "\\mkern1mu \\bullet\\mkern1mu ";
        break;
      case "KV x":
        t = "{\\times}";
        break;
      case "prime":
        t = "\\prime ";
        break;
      case "cdot":
        t = "\\cdot ";
        break;
      case "tight cdot":
        t = "\\mkern1mu{\\cdot}\\mkern1mu ";
        break;
      case "times":
        t = "\\times ";
        break;
      case "circa":
        t = "{\\sim}";
        break;
      case "^":
        t = "uparrow";
        break;
      case "v":
        t = "downarrow";
        break;
      case "ellipsis":
        t = "\\ldots ";
        break;
      case "/":
        t = "/";
        break;
      case " / ":
        t = "\\,/\\,";
        break;
      default:
        throw ["MhchemBugT", "mhchem bug T. Please report."];
    }
    return t;
  },
  _getArrow: function(e) {
    switch (e) {
      case "->":
        return "rightarrow";
      case "→":
        return "rightarrow";
      case "⟶":
        return "rightarrow";
      case "<-":
        return "leftarrow";
      case "<->":
        return "leftrightarrow";
      case "<-->":
        return "rightleftarrows";
      case "<=>":
        return "rightleftharpoons";
      case "⇌":
        return "rightleftharpoons";
      case "<=>>":
        return "rightequilibrium";
      case "<<=>":
        return "leftequilibrium";
      default:
        throw ["MhchemBugT", "mhchem bug T. Please report."];
    }
  },
  _getBond: function(e) {
    switch (e) {
      case "-":
        return "{-}";
      case "1":
        return "{-}";
      case "=":
        return "{=}";
      case "2":
        return "{=}";
      case "#":
        return "{\\equiv}";
      case "3":
        return "{\\equiv}";
      case "~":
        return "{\\tripledash}";
      case "~-":
        return "{\\mathrlap{\\raisebox{-.1em}{$-$}}\\raisebox{.1em}{$\\tripledash$}}";
      case "~=":
        return "{\\mathrlap{\\raisebox{-.2em}{$-$}}\\mathrlap{\\raisebox{.2em}{$\\tripledash$}}-}";
      case "~--":
        return "{\\mathrlap{\\raisebox{-.2em}{$-$}}\\mathrlap{\\raisebox{.2em}{$\\tripledash$}}-}";
      case "-~-":
        return "{\\mathrlap{\\raisebox{-.2em}{$-$}}\\mathrlap{\\raisebox{.2em}{$-$}}\\tripledash}";
      case "...":
        return "{{\\cdot}{\\cdot}{\\cdot}}";
      case "....":
        return "{{\\cdot}{\\cdot}{\\cdot}{\\cdot}}";
      case "->":
        return "{\\rightarrow}";
      case "<-":
        return "{\\leftarrow}";
      case "<":
        return "{<}";
      case ">":
        return "{>}";
      default:
        throw ["MhchemBugT", "mhchem bug T. Please report."];
    }
  },
  _getOperator: function(e) {
    switch (e) {
      case "+":
        return " {}+{} ";
      case "-":
        return " {}-{} ";
      case "=":
        return " {}={} ";
      case "<":
        return " {}<{} ";
      case ">":
        return " {}>{} ";
      case "<<":
        return " {}\\ll{} ";
      case ">>":
        return " {}\\gg{} ";
      case "\\pm":
        return " {}\\pm{} ";
      case "\\approx":
        return " {}\\approx{} ";
      case "$\\approx$":
        return " {}\\approx{} ";
      case "v":
        return " \\downarrow{} ";
      case "(v)":
        return " \\downarrow{} ";
      case "^":
        return " \\uparrow{} ";
      case "(^)":
        return " \\uparrow{} ";
      default:
        throw ["MhchemBugT", "mhchem bug T. Please report."];
    }
  }
};
function Km({ src: e, inline: t }) {
  if (!e) return null;
  const n = Kae(e);
  if (t) return o(n);
  const r = /\\begin *{(array|aligned)}/.test(n), i = !/\\displaystyle[^a-z]/.test(n);
  return /* @__PURE__ */ c.jsx(
    "div",
    {
      className: Le(
        "serlo-math-wrapper text-center",
        r && "whitespace-nowrap"
      ),
      children: o(
        i ? "\\displaystyle " + n : n
      )
    }
  );
  function o(a) {
    const s = a ? E2.renderToString(a, {
      displayMode: !1,
      throwOnError: !1,
      strict: !1,
      macros: {
        "\\Q": "\\mathbb{Q}",
        "\\C": "\\mathbb{C}",
        "\\and": "\\wedge",
        "\\euro": "€",
        "\\or": "\\vee",
        "\\arccot": "\\operatorname{arccot}",
        "\\sgn": "\\operatorname{sgn}",
        "\\m": "\\text{ m}",
        "\\cm": "\\text{ cm}",
        "\\mm": "\\text{ mm}",
        "\\km": "\\text{ km}",
        "\\dm": "\\text{ dm}",
        "\\l": "\\text{ l}",
        "\\dl": "\\text{ dl}",
        "\\cl": "\\text{ cl}",
        "\\ml": "\\text{ ml}",
        "\\s": "\\text{ s}",
        "\\h": "\\text{ h}",
        "\\D": "\\mathbb{D}",
        "\\W": "\\mathbb{W}",
        "\\L": "\\mathbb{L}"
      }
    }) : "", l = Ey.sanitize(s);
    return /* @__PURE__ */ c.jsx(
      "span",
      {
        className: "inline-block py-1 [page-break-inside:avoid]",
        dangerouslySetInnerHTML: { __html: l }
      }
    );
  }
}
function OF(e) {
  const [t, n] = v.useState(!1), [r, i] = v.useState(!1), o = v.useRef(null), a = nt().plugins.text.math, { visual: s, readOnly: l, state: u, disableBlock: d } = e;
  ua(
    Yo.Key.Escape,
    (y) => {
      y.preventDefault(), e.closeMathEditorOverlay();
    },
    {
      enableOnFormTags: !0
    }
  );
  const p = s && !r || !1;
  return /* @__PURE__ */ c.jsxs("div", { ref: o, className: e.inline ? "inline-block" : "", children: [
    /* @__PURE__ */ c.jsx(Rae, { isHelpOpen: t, setIsHelpOpen: n }),
    f()
  ] });
  function f() {
    return l ? u ? /* @__PURE__ */ c.jsx(Km, { type: "math", src: e.state, inline: !!e.inline }) : /* @__PURE__ */ c.jsx(
      "span",
      {
        className: "bg-gray-300",
        ...e.additionalContainerProps,
        "data-qa": "plugin-math-renderer",
        children: a.formula
      }
    ) : /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      p ? /* @__PURE__ */ c.jsx(
        "div",
        {
          onClick: (y) => y.stopPropagation(),
          ...e.additionalContainerProps,
          className: Le(
            e.inline ? "inline-block" : "my-[1.45em] flex flex-col items-center"
          ),
          children: /* @__PURE__ */ c.jsx(
            Vae,
            {
              ...e,
              onError: () => {
                i(!0);
              }
            }
          )
        }
      ) : /* @__PURE__ */ c.jsx(
        "div",
        {
          className: Le(
            e.inline ? "inline-block" : "",
            "rounded-md bg-editor-primary-200"
          ),
          children: /* @__PURE__ */ c.jsx(Km, { type: "math", src: e.state, inline: !!e.inline })
        }
      ),
      m(
        /* @__PURE__ */ c.jsxs(
          "div",
          {
            onMouseDown: (y) => y.stopPropagation(),
            className: "ml-3 inline-block",
            children: [
              /* @__PURE__ */ c.jsx(
                fs,
                {
                  tooltipText: "",
                  value: p ? "visual" : "latex",
                  dataQa: "plugin-toolbar-math-type-switch",
                  changeValue: (y) => {
                    r && i(!1), e.onEditorChange(y === "visual");
                  },
                  options: [
                    { value: "visual", text: a.visual },
                    { value: "latex", text: a.latex }
                  ]
                }
              ),
              !d && /* @__PURE__ */ c.jsxs(
                "button",
                {
                  className: "mr-2 rounded-md border border-gray-500 px-1 py-0.25 text-sm text-almost-black transition-all hover:bg-editor-primary-200 focus-visible:bg-editor-primary-200",
                  onClick: () => {
                    e.onInlineChange && e.onInlineChange(!e.inline);
                  },
                  children: [
                    a.displayAsBlock,
                    " ",
                    /* @__PURE__ */ c.jsx(ot, { icon: e.inline ? Ug : uj })
                  ]
                }
              ),
              p && /* @__PURE__ */ c.jsx(
                "button",
                {
                  onMouseDown: () => void n(!0),
                  className: "mx-2 text-almost-black hover:text-editor-primary",
                  children: /* @__PURE__ */ c.jsx(ot, { icon: fT })
                }
              )
            ]
          }
        )
      ),
      r || !p ? /* @__PURE__ */ c.jsx(
        Iae,
        {
          hasError: r,
          isVisualMode: p,
          ...e
        }
      ) : null
    ] });
  }
  function m(y) {
    var g;
    const x = (g = o.current) == null ? void 0 : g.getRootNode(), E = (x instanceof Document ? x.querySelector(
      // Either equations and toolbar, or plugin-text and toolbar (for
      // nested math plugins)
      ".plugin-text .toolbar-controls-target, .plugin-equations .toolbar-controls-target"
    ) : document.body) ?? document.body;
    return ms.createPortal(y, E);
  }
}
function p3(e) {
  const {
    focused: t,
    onFocusNext: n,
    onFocusPrevious: r,
    closeMathEditorOverlay: i,
    onChange: o,
    state: a,
    prefix: s = "",
    suffix: l = ""
  } = e, u = v.useContext(z7);
  return /* @__PURE__ */ c.jsx(
    OF,
    {
      readOnly: !t,
      state: `${s}${a.value}${l}`,
      inline: !0,
      disableBlock: !0,
      visual: u.get("visualMath"),
      onEditorChange: (d) => {
        u.set("visualMath", d);
      },
      onInlineChange: () => {
      },
      onChange: o,
      onMoveOutRight: n,
      onMoveOutLeft: r,
      closeMathEditorOverlay: i || n
    }
  );
}
var Uy = /* @__PURE__ */ ((e) => (e.AlmostEqualTo = "almost-equal-to", e.Equals = "equals", e.Estimates = "estimates", e.GreaterThan = "greater-than", e.GreaterThanOrEqual = "greater-than-or-equal", e.LessThan = "less-than", e.LessThanOrEqual = "less-than-or-equal", e.NotEqualTo = "not-equal-to", e))(Uy || {});
const zF = {
  "almost-equal-to": "≈",
  equals: "=",
  estimates: "≙",
  "greater-than": ">",
  "greater-than-or-equal": "≥",
  "less-than": "<",
  "less-than-or-equal": "≤",
  "not-equal-to": "≠"
};
function Zle(e) {
  const t = nt().plugins.equations, { gridFocus: n, resetFocus: r, row: i, state: o, transformationTarget: a } = e;
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    a === Bi.Equation && /* @__PURE__ */ c.jsx(
      "td",
      {
        className: "text-right",
        onClick: () => n.setFocus({ row: i, column: $n.Left }),
        children: /* @__PURE__ */ c.jsx(
          p3,
          {
            focused: n.isFocused({ row: i, column: $n.Left }),
            placeholder: i === 0 ? "3x+1" : `[${t.leftHandSide}]`,
            state: o.left,
            onChange: (s) => o.left.set(s),
            onFocusNext: () => n.moveRight(),
            onFocusPrevious: () => n.moveLeft(),
            closeMathEditorOverlay: r
          }
        )
      }
    ),
    /* @__PURE__ */ c.jsx("td", { className: "px-[3px] py-0 text-center align-baseline", children: (a === "equation" || i !== 0) && /* @__PURE__ */ c.jsx(
      "select",
      {
        className: "ml-4 mr-2.5 h-8 w-9 rounded-md border-[1px] border-gray-200 bg-gray-200",
        tabIndex: -1,
        onChange: (s) => {
          o.sign.set(s.target.value);
        },
        value: o.sign.value,
        children: Object.values(Uy).map((s) => /* @__PURE__ */ c.jsx("option", { value: s, children: zF[s] }, s))
      }
    ) }),
    /* @__PURE__ */ c.jsx(
      "td",
      {
        className: "align-baseline",
        onClick: () => n.setFocus({ row: i, column: $n.Right }),
        children: /* @__PURE__ */ c.jsx(
          p3,
          {
            focused: n.isFocused({ row: i, column: $n.Right }),
            placeholder: i === 0 ? "4x+3x" : a === Bi.Term ? `[${t.term}]` : `[${t.rightHandSide}]`,
            state: o.right,
            onChange: (s) => o.right.set(s),
            onFocusNext: () => n.moveRight(),
            onFocusPrevious: () => n.moveLeft(),
            closeMathEditorOverlay: r
          }
        )
      }
    ),
    a === Bi.Equation && /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx("td", { children: "| " }),
      /* @__PURE__ */ c.jsx(
        "td",
        {
          className: "pl-[5px] align-baseline",
          onClick: () => n.setFocus({ row: i, column: $n.Transform }),
          children: /* @__PURE__ */ c.jsx(
            p3,
            {
              focused: n.isFocused({
                row: i,
                column: $n.Transform
              }),
              placeholder: i === 0 ? t.transformationExample : `[${t.transformation}]`,
              state: o.transform,
              onChange: (s) => o.transform.set(s),
              onFocusNext: () => n.moveRight(),
              onFocusPrevious: () => n.moveLeft(),
              closeMathEditorOverlay: r
            }
          )
        }
      )
    ] })
  ] });
}
function Gle({
  steps: e,
  firstExplanation: t,
  formulaRenderer: n,
  transformationTarget: r
}) {
  return /* @__PURE__ */ c.jsx("div", { className: "mx-side mb-7 overflow-x-auto py-2.5", children: /* @__PURE__ */ c.jsx("table", { children: /* @__PURE__ */ c.jsxs("tbody", { className: "whitespace-nowrap", children: [
    o(),
    e.map(i)
  ] }) }) });
  function i(a, s) {
    return /* @__PURE__ */ c.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ c.jsxs("tr", { children: [
        r !== "term" && l(
          a.left ? u("left") : null,
          "text-right"
        ),
        r !== "term" || s !== 0 ? l(n(zF[a.sign]), "text-center") : /* @__PURE__ */ c.jsx("td", {}),
        l(
          a.right ? u("right") : null,
          "text-left"
        ),
        l(
          r !== "term" && a.transform ? /* @__PURE__ */ c.jsx("span", { className: "border-l border-black pl-1", children: u("transform") }) : null
        )
      ] }),
      a.explanation ? /* @__PURE__ */ c.jsxs("tr", { className: "text-brandgreen-darker whitespace-normal", children: [
        /* @__PURE__ */ c.jsx("td", {}),
        r === "term" ? /* @__PURE__ */ c.jsx("td", { colSpan: 2, children: /* @__PURE__ */ c.jsxs("span", { className: "flex", children: [
          Sp(),
          a.explanation
        ] }) }) : /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
          /* @__PURE__ */ c.jsx("td", { className: "text-center", children: Sp() }),
          /* @__PURE__ */ c.jsx("td", { colSpan: 2, children: a.explanation })
        ] })
      ] }) : null
    ] }, s);
    function l(d, p) {
      return /* @__PURE__ */ c.jsx("td", { className: Le("px-1 pb-3 pt-1 align-baseline text-lg", p), children: d });
    }
    function u(d) {
      return n("\\displaystyle " + a[d]);
    }
  }
  function o() {
    return r === "term" || !t ? null : /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx("tr", { className: "text-brandgreen-darker whitespace-normal text-center", children: /* @__PURE__ */ c.jsx("td", { className: "relative -left-side pb-4", colSpan: 3, children: t }) }),
      /* @__PURE__ */ c.jsxs("tr", { className: "text-brandgreen-darker", children: [
        /* @__PURE__ */ c.jsx("td", {}),
        /* @__PURE__ */ c.jsx("td", { className: "text-center", children: Sp() })
      ] })
    ] });
  }
}
function Sp() {
  return /* @__PURE__ */ c.jsx("span", { className: "self-center font-[serif] text-4xl", children: "↓" });
}
function FF({ state: e }) {
  const { steps: t, firstExplanation: n, transformationTarget: r } = e, i = hu.getMathRenderer();
  return /* @__PURE__ */ c.jsx(
    Gle,
    {
      firstExplanation: o(),
      steps: a(),
      transformationTarget: r,
      formulaRenderer: s
    }
  );
  function o() {
    return io(n) ? null : /* @__PURE__ */ c.jsx(Nn, { document: n });
  }
  function a() {
    return t.map((l) => {
      const u = io(l.explanation) ? null : /* @__PURE__ */ c.jsx(Nn, { document: l.explanation });
      return {
        ...l,
        explanation: u
      };
    });
  }
  function s(l) {
    return /* @__PURE__ */ c.jsx(
      i,
      {
        src: l,
        type: "math",
        inline: !0,
        children: [{ text: "" }]
      }
    );
  }
}
const Kle = ({ id: e, state: t }) => {
  const n = nt().plugins.equations;
  return /* @__PURE__ */ c.jsx(
    Ci,
    {
      pluginType: Y.Equations,
      pluginSettings: /* @__PURE__ */ c.jsx(
        fs,
        {
          tooltipText: "",
          value: t.transformationTarget.value,
          changeValue: (r) => t.transformationTarget.set(r),
          options: [
            {
              value: Bi.Equation,
              text: n.transformationOfEquations
            },
            {
              value: Bi.Term,
              text: n.transformationOfTerms
            }
          ]
        }
      ),
      pluginControls: /* @__PURE__ */ c.jsx(Pi, { pluginId: e })
    }
  );
};
function Xle(e) {
  const { focused: t, state: n, id: r } = e, i = Ur(), o = zn(), a = yn(Sf), s = t || g_(
    a,
    e.state.steps.map((w) => w.explanation.id)
  ) || a === n.firstExplanation.id, l = yn(
    (w) => li(w, r)
  ), u = zae(
    n.transformationTarget.value
  ), d = Lae({
    rows: n.steps.length,
    columns: 4,
    focusNext: () => {
      const w = rl(o.getState());
      i(Dg(w));
    },
    focusPrevious: () => {
      const w = rl(o.getState());
      i(Ag(w));
    },
    transformationTarget: u,
    onFocusChanged: (w) => {
      w === "firstExplanation" ? i(Ji(e.state.firstExplanation.id)) : (w == null ? void 0 : w.column) === $n.Explanation ? i(Ji(e.state.steps[w.row].explanation.id)) : i(Ji(e.id));
    }
  }), { setFocus: p } = d, f = v.useRef(null), m = v.useCallback(() => {
    var w;
    p(null), (w = f == null ? void 0 : f.current) == null || w.focus();
  }, [p]);
  ua(
    "tab",
    (w) => {
      b(w, () => {
        if (f.current === document.activeElement) {
          d.setFocus("firstExplanation");
          return;
        }
        if (d.isFocused({
          row: n.steps.length - 1,
          column: Qle(u)
        })) {
          const M = n.steps.length;
          C(M), d.setFocus({
            row: M - 1,
            column: $n.Explanation
          });
        } else
          d.moveRight();
      });
    },
    {
      scopes: ["global"],
      enabled: t
    }
  ), ua(
    "shift+tab",
    (w) => {
      b(w, () => {
        if (f.current === document.activeElement) {
          d.setFocus("firstExplanation");
          return;
        }
        d.moveLeft();
      });
    },
    {
      scopes: ["global"],
      enabled: t
    }
  ), ua(
    "return",
    (w) => {
      b(w, () => {
        !d.focus || d.focus === "firstExplanation" || T(d.focus.row + 1);
      });
    },
    {
      scopes: ["global"],
      enabled: t
    }
  ), v.useEffect(() => {
    s && (d.setFocus({
      row: 0,
      column: $9(u)
    }), i(Ji(e.id)));
  }, [s]);
  const y = nt().templatePlugins.entity, g = nt().plugins.equations;
  if (!s)
    return /* @__PURE__ */ c.jsx(
      FF,
      {
        ...l
      }
    );
  const x = typeof window < "u" && f.current ? f.current.contains(document.activeElement) : !1;
  return /* @__PURE__ */ c.jsxs("div", { ref: f, className: "outline-none", tabIndex: -1, children: [
    e.focused || x ? /* @__PURE__ */ c.jsx(Kle, { ...e }) : null,
    /* @__PURE__ */ c.jsxs("div", { className: "mx-side py-2.5", children: [
      /* @__PURE__ */ c.jsxs("table", { className: "whitespace-nowrap", children: [
        E(),
        n.steps.map((w, M) => {
          return /* @__PURE__ */ c.jsxs("tbody", { children: [
            /* @__PURE__ */ c.jsxs("tr", { children: [
              /* @__PURE__ */ c.jsx(
                Zle,
                {
                  gridFocus: d,
                  resetFocus: m,
                  row: M,
                  state: w,
                  transformationTarget: u
                }
              ),
              /* @__PURE__ */ c.jsx("td", { children: I(M) })
            ] }),
            R()
          ] }, w.explanation.id);
          function R() {
            return M === n.steps.length - 1 ? null : /* @__PURE__ */ c.jsxs(
              "tr",
              {
                className: "[&_div]:m-0",
                onFocus: () => d.setFocus({
                  row: M,
                  column: $n.Explanation
                }),
                children: [
                  /* @__PURE__ */ c.jsx("td", {}),
                  u === "term" ? /* @__PURE__ */ c.jsx("td", { colSpan: 2, children: /* @__PURE__ */ c.jsxs("span", { className: "flex", children: [
                    F(),
                    W()
                  ] }) }) : /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
                    /* @__PURE__ */ c.jsx("td", { children: F() }),
                    /* @__PURE__ */ c.jsx("td", { colSpan: 2, children: W() })
                  ] })
                ]
              }
            );
          }
          function F() {
            return ou(o.getState(), w.explanation.id) ? null : /* @__PURE__ */ c.jsx("span", { className: "text-center", children: Sp() });
          }
          function W() {
            return /* @__PURE__ */ c.jsx("span", { className: " min-w-[10rem]", children: w.explanation.render({
              config: {
                isInlineChildEditor: !0,
                placeholder: M === 0 && u === Bi.Term ? g.combineLikeTerms : g.explanation
              }
            }) });
          }
        })
      ] }),
      z()
    ] })
  ] });
  function E() {
    if (u !== Bi.Term)
      return /* @__PURE__ */ c.jsxs("tbody", { onFocus: () => d.setFocus("firstExplanation"), children: [
        /* @__PURE__ */ c.jsx("tr", { className: "text-center [&_div]:m-0", children: /* @__PURE__ */ c.jsx("td", { colSpan: 3, children: n.firstExplanation.render({
          config: {
            placeholder: g.firstExplanation,
            isInlineChildEditor: !0
          }
        }) }) }),
        /* @__PURE__ */ c.jsx("tr", { className: "h-8", children: /* @__PURE__ */ c.jsx("td", { children: ou(
          o.getState(),
          n.firstExplanation.id
        ) ? null : /* @__PURE__ */ c.jsx("span", { className: "text-center", children: Sp() }) }) })
      ] });
  }
  function b(w, M) {
    w == null || w.preventDefault(), M();
  }
  function C(w) {
    n.steps.insert(w, {
      left: "",
      sign: n.steps[w - 1].sign.value,
      right: "",
      transform: "",
      explanation: { plugin: Y.Text }
    });
  }
  function T(w) {
    C(w), d.setFocus({
      row: w,
      column: $9(u)
    });
  }
  function z() {
    if (s)
      return /* @__PURE__ */ c.jsxs(
        "button",
        {
          className: "serlo-button-edit-secondary mt-6 text-base",
          onClick: () => T(n.steps.length),
          children: [
            /* @__PURE__ */ c.jsx(ot, { icon: UV }),
            " ",
            g.addNewRow
          ]
        }
      );
  }
  function I(w) {
    if (!s) return;
    const M = Le(
      "serlo-button-edit-secondary serlo-tooltip-trigger mr-2 h-8 w-8"
    );
    return /* @__PURE__ */ c.jsxs("span", { className: "ml-6 text-right", children: [
      w === 0 ? null : /* @__PURE__ */ c.jsxs(
        "button",
        {
          onClick: () => n.steps.move(w, w - 1),
          className: M,
          children: [
            /* @__PURE__ */ c.jsx(vn, { text: y.moveUpLabel }),
            /* @__PURE__ */ c.jsx(ot, { icon: pV, className: "-ml-0.25 align-[-3px]" })
          ]
        }
      ),
      /* @__PURE__ */ c.jsxs("button", { className: M, onClick: () => n.steps.remove(w), children: [
        /* @__PURE__ */ c.jsx(vn, { text: g.removeRowLabel }),
        /* @__PURE__ */ c.jsx(ot, { icon: ld, className: "align-baseline text-[15px]" })
      ] })
    ] });
  }
}
function $9(e) {
  return e === Bi.Term ? $n.Right : $n.Left;
}
function Qle(e) {
  return e === Bi.Term ? $n.Right : $n.Transform;
}
const Yle = ln({
  left: rn(""),
  sign: rn(Uy.Equals),
  right: rn(""),
  transform: rn(""),
  explanation: Vn({
    plugin: Y.Text,
    config: { registry: [] }
  })
}), Jle = ln({
  steps: $a(Yle, 2),
  firstExplanation: Vn({
    plugin: Y.Text,
    config: { registry: [] }
  }),
  transformationTarget: rn("equation")
}), eue = {
  Component: Xle,
  config: {},
  state: Jle
};
function LF({
  isRadio: e,
  isActive: t,
  answer: n,
  feedback: r,
  remove: i,
  handleChange: o
}) {
  const a = Un().plugins.exercise, s = e ? t ? cT : Ug : t ? E7 : F7;
  return /* @__PURE__ */ c.jsxs("div", { className: "relative mb-2.5 flex items-center border-t-2 border-editor-primary", children: [
    /* @__PURE__ */ c.jsxs("div", { className: "mr-2.5 w-[10%] text-center font-bold", children: [
      a.correct,
      "?",
      /* @__PURE__ */ c.jsx("button", { className: "p-2", onClick: o, children: /* @__PURE__ */ c.jsx(ot, { icon: s, className: "mt-0.5 text-xl text-brand" }) })
    ] }),
    /* @__PURE__ */ c.jsxs("div", { className: "ml-2.5 w-full rounded-sm", children: [
      /* @__PURE__ */ c.jsxs("div", { className: "pl-5 pt-2.5", children: [
        /* @__PURE__ */ c.jsx("label", { className: "ml-side block text-sm font-bold", children: a.answer }),
        /* @__PURE__ */ c.jsx(c.Fragment, { children: n })
      ] }),
      /* @__PURE__ */ c.jsx(
        "button",
        {
          onClick: i,
          className: "serlo-button-round serlo-button-edit-secondary absolute right-1 top-2 z-20",
          children: /* @__PURE__ */ c.jsx(ot, { icon: ld })
        }
      ),
      /* @__PURE__ */ c.jsxs("div", { className: "mt-1.5 py-2.5 pl-5", children: [
        /* @__PURE__ */ c.jsx("label", { className: "ml-side block text-sm font-bold", children: a.feedback }),
        /* @__PURE__ */ c.jsx("div", { className: "ml-0.5", children: r })
      ] })
    ] })
  ] });
}
function Wy({
  title: e,
  onClick: t,
  children: n,
  secondary: r,
  dataQa: i
}) {
  return /* @__PURE__ */ c.jsxs(
    "button",
    {
      title: e,
      onMouseDown: t,
      className: Le(
        r ? "serlo-button-edit-secondary" : "serlo-button-edit-primary",
        "mr-2"
      ),
      "data-qa": i,
      children: [
        /* @__PURE__ */ c.jsx(ot, { icon: Dc }),
        " ",
        n
      ]
    }
  );
}
function tue(e) {
  const [t, n] = v.useState(!1), { onChange: r } = e, i = v.useCallback(
    (o) => {
      typeof r == "function" && r(o), n(o);
    },
    [r]
  );
  return v.useEffect(() => {
    !e.focused && t && i(!1);
  }, [e.focused, t, i]), /* @__PURE__ */ c.jsxs("div", { className: Le("relative pl-1", t ? "" : "pb-[5px]"), children: [
    /* @__PURE__ */ c.jsx(
      "div",
      {
        className: Le(
          "absolute top-0 z-20 h-[calc(100%_-_5px)] w-[calc(100%_-_0.25rem)]",
          e.focused && "bg-white bg-opacity-80",
          t && "hidden"
        ),
        children: e.focused ? /* @__PURE__ */ c.jsx("div", { className: "flex h-full w-full text-center", children: /* @__PURE__ */ c.jsx(
          "button",
          {
            className: "pointer-events-[all] serlo-button-edit-primary z-10 m-auto",
            onClick: () => i(!0),
            children: "Aktivieren"
          }
        ) }) : null
      }
    ),
    e.children,
    t ? /* @__PURE__ */ c.jsx("div", { className: "flex h-full w-full text-center", children: /* @__PURE__ */ c.jsx(
      "button",
      {
        className: "pointer-events-[all] serlo-button-edit-primary z-10 m-auto",
        onClick: () => i(!1),
        children: "Editieren"
      }
    ) }) : null
  ] });
}
function MF({
  previewActive: e,
  fullOpacity: t,
  children: n
}) {
  return /* @__PURE__ */ c.jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ c.jsx(
      "div",
      {
        className: Le(
          "absolute top-0 z-20 h-full w-full",
          e ? "hidden" : "bg-[#fefefe] bg-opacity-80",
          t ? "bg-opacity-0" : ""
        )
      }
    ),
    n
  ] });
}
function ip({ pathData: e, className: t }) {
  return /* @__PURE__ */ c.jsx(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      className: Le("inline-block overflow-hidden align-middle", t),
      children: /* @__PURE__ */ c.jsx("path", { fill: "currentcolor", d: e })
    }
  );
}
const nue = "M2.5 5.5C2.5 6.33 3.17 7 4 7h3.5v10.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V7H14c.83 0 1.5-.67 1.5-1.5S14.83 4 14 4H4c-.83 0-1.5.67-1.5 1.5zM20 9h-6c-.83 0-1.5.67-1.5 1.5S13.17 12 14 12h1.5v5.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V12H20c.83 0 1.5-.67 1.5-1.5S20.83 9 20 9z", rue = "M17 7h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c1.65 0 3 1.35 3 3s-1.35 3-3 3h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-9 5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1zm2 3H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h3c.55 0 1-.45 1-1s-.45-1-1-1H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h3c.55 0 1-.45 1-1s-.45-1-1-1z", iue = "M10 5.5c0 .83.67 1.5 1.5 1.5h.71l-3.42 8H7.5c-.83 0-1.5.67-1.5 1.5S6.67 18 7.5 18h5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-.71l3.42-8h1.29c.83 0 1.5-.67 1.5-1.5S17.33 4 16.5 4h-5c-.83 0-1.5.67-1.5 1.5z", oue = "M10.63 3.93L6.06 15.58c-.27.68.23 1.42.97 1.42.43 0 .82-.27.98-.68L8.87 14h6.25l.87 2.32c.15.41.54.68.98.68.73 0 1.24-.74.97-1.42L13.37 3.93C13.14 3.37 12.6 3 12 3c-.6 0-1.15.37-1.37.93zM9.62 12L12 5.67 14.38 12H9.62z", aue = "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H8c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h5.78c2.07 0 3.96-1.69 3.97-3.77.01-1.53-.85-2.84-2.15-3.44zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z";
function sue({
  interactive: e
}) {
  const t = nt(), n = t.plugins.exercise, r = v.useMemo(() => i2(t).map((a) => {
    if (!LN(a.initialState)) return !1;
    const s = a.initialState.state.interactive;
    return !s || !si.isSupported(s.plugin) ? !1 : { ...a, initialState: s };
  }).filter(Boolean), [t]);
  function i(a) {
    const s = a % 4 === 3;
    return a % 4 === 0 ? "left-0" : s ? "right-0" : "-left-24";
  }
  function o(a) {
    e.defined || e.create({
      plugin: a.plugin,
      state: a.state
    });
  }
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx("p", { className: "mb-2 text-gray-400", children: n.addOptionalInteractiveEx }),
    /* @__PURE__ */ c.jsx("div", { className: "grid grid-cols-4 items-start gap-2 pb-10", children: r.map(
      ({ type: a, title: s, IconComponent: l, description: u, initialState: d }, p) => /* @__PURE__ */ c.jsxs(
        "button",
        {
          "data-qa": `add-exercise-${d.plugin}`,
          onClick: () => o(d),
          className: "serlo-tooltip-trigger w-32 rounded-md p-1 hover:shadow-xl focus:shadow-xl",
          children: [
            /* @__PURE__ */ c.jsx(
              vn,
              {
                className: i(p),
                text: u
              }
            ),
            /* @__PURE__ */ c.jsx(l, {}),
            /* @__PURE__ */ c.jsx("b", { className: "mt-2 block text-sm", children: s })
          ]
        },
        a
      )
    ) })
  ] });
}
const lue = ({
  id: e,
  state: t,
  previewActive: n,
  setPreviewActive: r
}) => {
  const { interactive: i, hideInteractiveInitially: o } = t, a = nt().plugins, s = zn(), l = a.exercise, u = v.useMemo(() => {
    if (i.defined)
      return li(s.getState(), i.id).plugin;
  }, [i]);
  function d() {
    return u ? `${wp(a, "exercise")}: ${wp(a, u)}` : wp(a, "exercise");
  }
  const p = i.defined ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      rY,
      {
        previewActive: n,
        setPreviewActive: r
      }
    ),
    /* @__PURE__ */ c.jsx("div", { className: "exercise-toolbar-interactive-target" })
  ] }) : void 0;
  return /* @__PURE__ */ c.jsx(
    Ci,
    {
      pluginType: Y.Exercise,
      interactiveExerciseType: u,
      pluginTitle: d(),
      pluginControls: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
        /* @__PURE__ */ c.jsx(Pi, { pluginId: e }),
        i.defined ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
          /* @__PURE__ */ c.jsx(
            Y0,
            {
              separatorTop: !0,
              onClick: () => {
                window.confirm(l.confirmRemoveInteractive) && i.remove();
              },
              label: l.changeInteractive,
              icon: gV,
              dataQa: "change-interactive-button"
            }
          ),
          /* @__PURE__ */ c.jsx(
            Y0,
            {
              onClick: () => {
                o.defined ? o.remove() : o.create(!0);
              },
              label: l.hideInteractiveInitially[o.defined ? "deactivate" : "activate"],
              icon: o.defined ? hT : uV,
              dataQa: "toggle-interactive-default-visibility"
            }
          )
        ] }) : null
      ] }),
      pluginSettings: p,
      className: "-top-[33px] !z-[22]"
    }
  );
}, uue = v.lazy(
  () => import("./serlo-license-chooser-D1OnJUZ6-Dju-dLgM.js").then((e) => ({
    default: e.SerloLicenseChooser
  }))
);
function cue(e) {
  const { state: t, focused: n, id: r } = e, {
    content: i,
    interactive: o,
    solution: a,
    licenseId: s,
    hideInteractiveInitially: l
  } = t, u = gl(), d = nt().plugins.exercise, [p, f] = v.useState(!1), m = yn((x) => sA(x, r)), y = n || m, g = Ur();
  return v.useEffect(() => {
    o.defined && g(Ji(o.id));
  }, [t.interactive.defined]), /* @__PURE__ */ c.jsx(oJ, { value: p, children: /* @__PURE__ */ c.jsx("div", { className: "-mt-2 pl-0.5", children: /* @__PURE__ */ c.jsxs(
    "div",
    {
      "data-qa": "plugin-exercise",
      className: Le(
        "plugin-exercise group/exercise rounded-b-lg border-3 border-transparent pb-6",
        "focus-within:!border-gray-100 focus-within:border-gray-100",
        y && "!border-gray-100"
      ),
      children: [
        u ? /* @__PURE__ */ c.jsx(v.Suspense, { children: /* @__PURE__ */ c.jsx(
          uue,
          {
            licenseId: s,
            className: "!right-[84px] !top-[-30px]"
          }
        ) }) : null,
        /* @__PURE__ */ c.jsx(
          "div",
          {
            className: Le(
              "group-focus-within/exercise:block",
              y ? "block" : "hidden"
            ),
            children: /* @__PURE__ */ c.jsx(
              lue,
              {
                ...e,
                previewActive: p,
                setPreviewActive: f
              }
            )
          }
        ),
        /* @__PURE__ */ c.jsx("div", { className: "h-10" }),
        /* @__PURE__ */ c.jsxs("div", { className: "mx-side", children: [
          /* @__PURE__ */ c.jsx(
            "div",
            {
              className: Le(
                "group-has-[.blanks-child-plugin-selection]/exercise:hidden",
                "[&_.plugin-rows]:pl-[7px]"
              ),
              children: i.render({
                config: {
                  textPluginPlaceholder: d.placeholder
                }
              })
            }
          ),
          o.defined ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
            o.render(),
            l.defined ? /* @__PURE__ */ c.jsxs("small", { className: "bg-editor-primary-200 p-1", children: [
              "[",
              d.hideInteractiveInitially.info,
              "]"
            ] }) : null
          ] }) : /* @__PURE__ */ c.jsx(sue, { interactive: o }),
          a.defined ? /* @__PURE__ */ c.jsxs("div", { className: "-ml-side mt-block", children: [
            /* @__PURE__ */ c.jsx("nav", { className: "flex justify-end", children: /* @__PURE__ */ c.jsxs(
              "button",
              {
                className: "serlo-button-round serlo-button-edit-secondary serlo-tooltip-trigger relative top-[31px] z-20 mr-side",
                onClick: () => a.remove(),
                children: [
                  /* @__PURE__ */ c.jsx(vn, { text: d.removeSolution }),
                  /* @__PURE__ */ c.jsx(ot, { icon: ld })
                ]
              }
            ) }),
            a.render()
          ] }) : /* @__PURE__ */ c.jsx(
            "div",
            {
              className: Le(
                "mt-12 hidden max-w-[50%] group-focus-within/exercise:block",
                y ? "block" : "hidden"
              ),
              children: /* @__PURE__ */ c.jsx(Wy, { onClick: () => a.create(), children: d.createSolution })
            }
          )
        ] })
      ]
    }
  ) }) });
}
const due = [
  Y.Text,
  Y.Image,
  Y.ImageGallery,
  Y.Multimedia,
  Y.Spoiler,
  Y.Box,
  Y.SerloTable,
  Y.Injection,
  Y.Equations,
  Y.Geogebra,
  Y.Highlight,
  Y.Video,
  Y.Audio,
  Y.EdusharingAsset
], pue = ln({
  content: Vn({ plugin: Y.Rows, config: { allowedPlugins: due } }),
  interactive: qr(
    Vn({
      plugin: Y.ScMcExercise
    })
  ),
  solution: qr(Vn({ plugin: Y.Solution })),
  licenseId: qr(oa()),
  hideInteractiveInitially: qr(Z0())
}), fue = {
  Component: cue,
  state: pue,
  config: {}
};
function BF({
  children: e,
  className: t,
  type: n,
  embedUrl: r
}) {
  const [i, o] = v.useState(!1);
  v.useEffect(() => {
    o(!1);
  }, [r]);
  const a = Un().embed, s = () => {
    i || o(!0);
  };
  function l(d) {
    !i && (d.key === "Enter" || d.key === " ") && (d.preventDefault(), s());
  }
  return /* @__PURE__ */ c.jsx(
    "div",
    {
      className: Le(
        `
        group relative mb-block block cursor-pointer
        bg-cover bg-center pl-0.5 [contain:content]
        `,
        t
      ),
      children: i ? e : u()
    }
  );
  function u() {
    const d = `https://embed.${AO}/thumbnail?url=${encodeURIComponent(
      r || ""
    )}`;
    return /* @__PURE__ */ c.jsxs("div", { className: "w-full", children: [
      /* @__PURE__ */ c.jsx("div", { className: "relative flex aspect-[16/9] w-full justify-center rounded-lg bg-editor-primary-100", children: /* @__PURE__ */ c.jsx(
        "img",
        {
          className: "w-full object-contain opacity-50",
          src: d,
          alt: `${a.previewImage}`
        }
      ) }),
      /* @__PURE__ */ c.jsx(
        "div",
        {
          className: "absolute inset-0 flex items-center justify-around",
          onClick: s,
          children: /* @__PURE__ */ c.jsxs(
            "button",
            {
              className: "serlo-button-edit-primary group-hover:bg-editor-primary",
              onKeyDown: l,
              children: [
                /* @__PURE__ */ c.jsx(
                  ot,
                  {
                    className: "py-0.5",
                    icon: n === "video" ? uT : mT
                  }
                ),
                " ",
                a.activateEmbed
              ]
            }
          )
        }
      )
    ] });
  }
}
const IF = v.memo(
  hue,
  (e, t) => e.geogebraId === t.geogebraId
);
function hue({ geogebraId: e }) {
  const [t] = v.useState(fa()), n = `ggb-element-${t}`, r = `${n}-container`;
  return v.useEffect(() => {
    Object.hasOwn(globalThis, "GGBApplet") ? i() : o().then(i).catch(
      () => (
        // eslint-disable-next-line no-console
        console.error(
          "Failed to fetch Geogebra script deployggb.js. Geogebra applet will not be visible."
        )
      )
    );
    function i() {
      const a = {
        appName: "…",
        showToolBar: !1,
        showAlgebraInput: !1,
        showMenuBar: !1,
        material_id: e,
        showResetIcon: !0,
        enableLabelDrags: !1,
        enableShiftDragZoom: !1,
        enableRightClick: !1,
        capturingThreshold: null,
        showToolBarHelp: !1,
        errorDialogsActive: !0,
        useBrowserForJS: !1,
        enableFileFeatures: !1,
        borderColor: "transparent",
        scaleContainerClass: r
      };
      new globalThis.GGBApplet(a, !0).inject(n);
    }
    async function o() {
      return new Promise((a, s) => {
        const l = document.createElement("script");
        l.src = "https://www.geogebra.org/apps/deployggb.js", l.addEventListener("load", () => {
          a();
        }), l.addEventListener("error", () => {
          s();
        }), document.body.appendChild(l);
      });
    }
  }, [e, r, n]), /* @__PURE__ */ c.jsx(c.Fragment, { children: /* @__PURE__ */ c.jsx("div", { className: "aspect-[16/9] w-full overflow-hidden rounded-xl bg-brand-50 p-1", children: /* @__PURE__ */ c.jsx(
    "div",
    {
      className: Le(
        r,
        "flex h-full w-full flex-col justify-center"
      ),
      children: /* @__PURE__ */ c.jsx(
        "div",
        {
          id: n,
          "data-ggb-id": e,
          className: "mx-auto"
        }
      )
    }
  ) }) });
}
function RF(e) {
  const t = e.replace("https://www.geogebra.org/m/", ""), n = "https://www.geogebra.org/material/iframe/id/" + t;
  return { cleanId: t, url: n };
}
const mue = ({
  id: e,
  state: t,
  showSettingsModal: n,
  setShowSettingsModal: r
}) => {
  const i = nt(), o = i.plugins.geogebra;
  return /* @__PURE__ */ c.jsx(
    Ci,
    {
      pluginType: Y.Geogebra,
      pluginSettings: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
        /* @__PURE__ */ c.jsxs(
          "button",
          {
            onClick: () => r(!0),
            className: "mr-2 rounded-md border border-gray-500 px-1 text-sm transition-all hover:bg-editor-primary-200 focus-visible:bg-editor-primary-200",
            children: [
              o.chooseApplet,
              " ",
              /* @__PURE__ */ c.jsx(ot, { icon: W0 })
            ]
          }
        ),
        /* @__PURE__ */ c.jsx(
          qo,
          {
            isOpen: n,
            setIsOpen: r,
            className: "top-8 max-w-xl translate-y-0 sm:top-24",
            title: `${i.edtrIo.settings}: ${o.title}`,
            extraTitleClassName: "serlo-h3 mt-4",
            children: /* @__PURE__ */ c.jsx("div", { className: "mx-side mb-3", children: /* @__PURE__ */ c.jsx(
              tf,
              {
                autoFocus: !0,
                label: `${o.urlOrId}: `,
                placeholder: "z.B. N5ktHvtW",
                value: t.value,
                onChange: (a) => t.set(a.target.value),
                inputWidth: "100%",
                width: "100%",
                className: "block"
              }
            ) })
          }
        )
      ] }),
      pluginControls: /* @__PURE__ */ c.jsx(Pi, { pluginId: e })
    }
  );
};
function gue(e) {
  const { focused: t, state: n } = e, [r, i] = v.useState(!1), { cleanId: o, url: a } = RF(n.value), s = o.length === 8;
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    t && /* @__PURE__ */ c.jsx(
      mue,
      {
        ...e,
        showSettingsModal: r,
        setShowSettingsModal: i
      }
    ),
    s ? /* @__PURE__ */ c.jsx(
      BF,
      {
        type: "applet",
        provider: "GeoGebra",
        embedUrl: a,
        className: Le(!t && "pointer-events-none"),
        children: /* @__PURE__ */ c.jsx(IF, { geogebraId: o })
      }
    ) : /* @__PURE__ */ c.jsx(
      "div",
      {
        className: "mx-side cursor-pointer rounded-lg bg-editor-primary-50 py-32 text-center",
        "data-qa": "plugin-geogebra-placeholder",
        onClick: () => i(!0),
        children: /* @__PURE__ */ c.jsx(ot, { icon: mT, className: "text-7xl text-editor-primary-200" })
      }
    )
  ] });
}
const vue = rn(), yue = {
  Component: gue,
  state: vue,
  config: {},
  onText(e) {
    if (/geogebra\.org\/m\/(.+)/.test(e))
      return { state: e };
  }
}, xue = ["text", "c", "javascript", "jsx", "markup", "java", "python"], bue = ({ id: e, state: t }) => {
  const n = nt().plugins.highlight;
  return /* @__PURE__ */ c.jsx(
    Ci,
    {
      pluginType: Y.Highlight,
      pluginSettings: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
        /* @__PURE__ */ c.jsx(
          fs,
          {
            tooltipText: n.languageTooltip,
            value: t.language.value,
            changeValue: (r) => t.language.set(r),
            options: xue.map((r) => ({
              value: r,
              text: r.charAt(0).toUpperCase() + r.slice(1)
            }))
          }
        ),
        /* @__PURE__ */ c.jsxs(
          "button",
          {
            onClick: () => {
              t.showLineNumbers.set(!t.showLineNumbers.value);
            },
            className: "serlo-tooltip-trigger mr-2 rounded-md border border-gray-500 px-1 text-sm transition-all hover:bg-editor-primary-200 focus-visible:bg-editor-primary-200",
            children: [
              /* @__PURE__ */ c.jsx(
                vn,
                {
                  text: n.lineNumbersTooltip,
                  className: "-ml-5 !pb-1"
                }
              ),
              n.showLineNumbers,
              " ",
              /* @__PURE__ */ c.jsx(
                ot,
                {
                  icon: t.showLineNumbers.value ? uj : Ug
                }
              )
            ]
          }
        )
      ] }),
      pluginControls: /* @__PURE__ */ c.jsx(Pi, { pluginId: e })
    }
  );
};
function wue(e) {
  const { config: t, state: n, focused: r } = e, { Renderer: i } = t, [o, a] = v.useState(r), s = v.useRef(null), l = nt();
  v.useEffect(() => {
    r && setTimeout(() => {
      var d;
      (d = s.current) == null || d.focus();
    });
  }, [r]), r !== o && (r ? a(!0) : setTimeout(() => a(!1), 100));
  const u = n.code.value.split(/\r\n|\r|\n/).length;
  return !o && !r ? /* @__PURE__ */ c.jsx("div", { className: "px-2 py-4", children: /* @__PURE__ */ c.jsx(
    i,
    {
      language: n.language.value,
      showLineNumbers: n.showLineNumbers.value,
      code: n.code.value
    }
  ) }) : /* @__PURE__ */ c.jsxs("div", { className: "mx-side px-2 py-4", children: [
    r && /* @__PURE__ */ c.jsx(bue, { ...e }),
    /* @__PURE__ */ c.jsx(
      "textarea",
      {
        value: n.code.value,
        name: "text",
        placeholder: l.plugins.highlight.enterHere,
        spellCheck: !1,
        onChange: (d) => {
          n.code.set(d.target.value);
        },
        ref: s,
        onKeyDown: (d) => d.stopPropagation(),
        className: Le(`
            m-auto block w-full items-center rounded-xl border-3 border-brand-200
            p-side pt-6 font-mono
            focus-within:border-brand-200 focus-within:outline-none
        `),
        style: { height: `${50 + u * 26}px` },
        children: n.code.value
      }
    )
  ] });
}
function Cue(e, t) {
  if (e == null) return {};
  var n = TA(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function P5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function kue(e) {
  if (Array.isArray(e)) return P5(e);
}
function Eue(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Sue(e, t) {
  if (e) {
    if (typeof e == "string") return P5(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return P5(e, t);
  }
}
function Due() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _5(e) {
  return kue(e) || Eue(e) || Sue(e) || Due();
}
function H9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function b0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? H9(Object(n), !0).forEach(function(r) {
      UT(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : H9(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Aue(e) {
  var t = e.length;
  if (t === 0 || t === 1) return e;
  if (t === 2)
    return [e[0], e[1], "".concat(e[0], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0])];
  if (t === 3)
    return [e[0], e[1], e[2], "".concat(e[0], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2]), "".concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0])];
  if (t >= 4)
    return [e[0], e[1], e[2], e[3], "".concat(e[0], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2]), "".concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2]), "".concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1]), "".concat(e[2], ".").concat(e[3]), "".concat(e[3], ".").concat(e[0]), "".concat(e[3], ".").concat(e[1]), "".concat(e[3], ".").concat(e[2]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[1], ".").concat(e[3]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2], ".").concat(e[3]), "".concat(e[0], ".").concat(e[3], ".").concat(e[1]), "".concat(e[0], ".").concat(e[3], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2], ".").concat(e[3]), "".concat(e[1], ".").concat(e[3], ".").concat(e[0]), "".concat(e[1], ".").concat(e[3], ".").concat(e[2]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[0], ".").concat(e[3]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[3], ".").concat(e[0]), "".concat(e[2], ".").concat(e[3], ".").concat(e[1]), "".concat(e[3], ".").concat(e[0], ".").concat(e[1]), "".concat(e[3], ".").concat(e[0], ".").concat(e[2]), "".concat(e[3], ".").concat(e[1], ".").concat(e[0]), "".concat(e[3], ".").concat(e[1], ".").concat(e[2]), "".concat(e[3], ".").concat(e[2], ".").concat(e[0]), "".concat(e[3], ".").concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2], ".").concat(e[3]), "".concat(e[0], ".").concat(e[1], ".").concat(e[3], ".").concat(e[2]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1], ".").concat(e[3]), "".concat(e[0], ".").concat(e[2], ".").concat(e[3], ".").concat(e[1]), "".concat(e[0], ".").concat(e[3], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[3], ".").concat(e[2], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2], ".").concat(e[3]), "".concat(e[1], ".").concat(e[0], ".").concat(e[3], ".").concat(e[2]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[2], ".").concat(e[3], ".").concat(e[0]), "".concat(e[1], ".").concat(e[3], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[3], ".").concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[0], ".").concat(e[3], ".").concat(e[1]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0], ".").concat(e[3]), "".concat(e[2], ".").concat(e[1], ".").concat(e[3], ".").concat(e[0]), "".concat(e[2], ".").concat(e[3], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[3], ".").concat(e[1], ".").concat(e[0]), "".concat(e[3], ".").concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[3], ".").concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[3], ".").concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[3], ".").concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[3], ".").concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[3], ".").concat(e[2], ".").concat(e[1], ".").concat(e[0])];
}
var f3 = {};
function Tue(e) {
  if (e.length === 0 || e.length === 1) return e;
  var t = e.join(".");
  return f3[t] || (f3[t] = Aue(e)), f3[t];
}
function jue(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0, r = e.filter(function(o) {
    return o !== "token";
  }), i = Tue(r);
  return i.reduce(function(o, a) {
    return b0(b0({}, o), n[a]);
  }, t);
}
function V9(e) {
  return e.join(" ");
}
function Nue(e, t) {
  var n = 0;
  return function(r) {
    return n += 1, r.map(function(i, o) {
      return PF({
        node: i,
        stylesheet: e,
        useInlineStyles: t,
        key: "code-segment-".concat(n, "-").concat(o)
      });
    });
  };
}
function PF(e) {
  var t = e.node, n = e.stylesheet, r = e.style, i = r === void 0 ? {} : r, o = e.useInlineStyles, a = e.key, s = t.properties, l = t.type, u = t.tagName, d = t.value;
  if (l === "text")
    return d;
  if (u) {
    var p = Nue(n, o), f;
    if (!o)
      f = b0(b0({}, s), {}, {
        className: V9(s.className)
      });
    else {
      var m = Object.keys(n).reduce(function(E, b) {
        return b.split(".").forEach(function(C) {
          E.includes(C) || E.push(C);
        }), E;
      }, []), y = s.className && s.className.includes("token") ? ["token"] : [], g = s.className && y.concat(s.className.filter(function(E) {
        return !m.includes(E);
      }));
      f = b0(b0({}, s), {}, {
        className: V9(g) || void 0,
        style: jue(s.className, Object.assign({}, s.style, i), n)
      });
    }
    var x = p(t.children);
    return /* @__PURE__ */ dt.createElement(u, Yp({
      key: a
    }, f), x);
  }
}
const Oue = function(e, t) {
  var n = e.listLanguages();
  return n.indexOf(t) !== -1;
};
var zue = ["language", "children", "style", "customStyle", "codeTagProps", "useInlineStyles", "showLineNumbers", "showInlineLineNumbers", "startingLineNumber", "lineNumberContainerStyle", "lineNumberStyle", "wrapLines", "wrapLongLines", "lineProps", "renderer", "PreTag", "CodeTag", "code", "astGenerator"];
function U9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Kl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? U9(Object(n), !0).forEach(function(r) {
      UT(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : U9(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Fue = /\n/g;
function Lue(e) {
  return e.match(Fue);
}
function Mue(e) {
  var t = e.lines, n = e.startingLineNumber, r = e.style;
  return t.map(function(i, o) {
    var a = o + n;
    return /* @__PURE__ */ dt.createElement("span", {
      key: "line-".concat(o),
      className: "react-syntax-highlighter-line-number",
      style: typeof r == "function" ? r(a) : r
    }, "".concat(a, `
`));
  });
}
function Bue(e) {
  var t = e.codeString, n = e.codeStyle, r = e.containerStyle, i = r === void 0 ? {
    float: "left",
    paddingRight: "10px"
  } : r, o = e.numberStyle, a = o === void 0 ? {} : o, s = e.startingLineNumber;
  return /* @__PURE__ */ dt.createElement("code", {
    style: Object.assign({}, n, i)
  }, Mue({
    lines: t.replace(/\n$/, "").split(`
`),
    style: a,
    startingLineNumber: s
  }));
}
function Iue(e) {
  return "".concat(e.toString().length, ".25em");
}
function _F(e, t) {
  return {
    type: "element",
    tagName: "span",
    properties: {
      key: "line-number--".concat(e),
      className: ["comment", "linenumber", "react-syntax-highlighter-line-number"],
      style: t
    },
    children: [{
      type: "text",
      value: e
    }]
  };
}
function qF(e, t, n) {
  var r = {
    display: "inline-block",
    minWidth: Iue(n),
    paddingRight: "1em",
    textAlign: "right",
    userSelect: "none"
  }, i = typeof e == "function" ? e(t) : e, o = Kl(Kl({}, r), i);
  return o;
}
function $1(e) {
  var t = e.children, n = e.lineNumber, r = e.lineNumberStyle, i = e.largestLineNumber, o = e.showInlineLineNumbers, a = e.lineProps, s = a === void 0 ? {} : a, l = e.className, u = l === void 0 ? [] : l, d = e.showLineNumbers, p = e.wrapLongLines, f = e.wrapLines, m = f === void 0 ? !1 : f, y = m ? Kl({}, typeof s == "function" ? s(n) : s) : {};
  if (y.className = y.className ? [].concat(_5(y.className.trim().split(/\s+/)), _5(u)) : u, n && o) {
    var g = qF(r, n, i);
    t.unshift(_F(n, g));
  }
  return p & d && (y.style = Kl({
    display: "flex"
  }, y.style)), {
    type: "element",
    tagName: "span",
    properties: y,
    children: t
  };
}
function $F(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = 0; r < e.length; r++) {
    var i = e[r];
    if (i.type === "text")
      n.push($1({
        children: [i],
        className: _5(new Set(t))
      }));
    else if (i.children) {
      var o = t.concat(i.properties.className);
      $F(i.children, o).forEach(function(a) {
        return n.push(a);
      });
    }
  }
  return n;
}
function Rue(e, t, n, r, i, o, a, s, l) {
  var u, d = $F(e.value), p = [], f = -1, m = 0;
  function y(z, I) {
    var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return $1({
      children: z,
      lineNumber: I,
      lineNumberStyle: s,
      largestLineNumber: a,
      showInlineLineNumbers: i,
      lineProps: n,
      className: w,
      showLineNumbers: r,
      wrapLongLines: l,
      wrapLines: t
    });
  }
  function g(z, I) {
    if (r && I && i) {
      var w = qF(s, I, a);
      z.unshift(_F(I, w));
    }
    return z;
  }
  function x(z, I) {
    var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return t || w.length > 0 ? y(z, I, w) : g(z, I);
  }
  for (var E = function() {
    var z = d[m], I = z.children[0].value, w = Lue(I);
    if (w) {
      var M = I.split(`
`);
      M.forEach(function(R, F) {
        var W = r && p.length + o, X = {
          type: "text",
          value: "".concat(R, `
`)
        };
        if (F === 0) {
          var le = d.slice(f + 1, m).concat($1({
            children: [X],
            className: z.properties.className
          })), ne = x(le, W);
          p.push(ne);
        } else if (F === M.length - 1) {
          var fe = d[m + 1] && d[m + 1].children && d[m + 1].children[0], D = {
            type: "text",
            value: "".concat(R)
          };
          if (fe) {
            var j = $1({
              children: [D],
              className: z.properties.className
            });
            d.splice(m + 1, 0, j);
          } else {
            var de = [D], ye = x(de, W, z.properties.className);
            p.push(ye);
          }
        } else {
          var Ne = [X], Me = x(Ne, W, z.properties.className);
          p.push(Me);
        }
      }), f = m;
    }
    m++;
  }; m < d.length; )
    E();
  if (f !== d.length - 1) {
    var b = d.slice(f + 1, d.length);
    if (b && b.length) {
      var C = r && p.length + o, T = x(b, C);
      p.push(T);
    }
  }
  return t ? p : (u = []).concat.apply(u, p);
}
function Pue(e) {
  var t = e.rows, n = e.stylesheet, r = e.useInlineStyles;
  return t.map(function(i, o) {
    return PF({
      node: i,
      stylesheet: n,
      useInlineStyles: r,
      key: "code-segement".concat(o)
    });
  });
}
function HF(e) {
  return e && typeof e.highlightAuto < "u";
}
function _ue(e) {
  var t = e.astGenerator, n = e.language, r = e.code, i = e.defaultCodeValue;
  if (HF(t)) {
    var o = Oue(t, n);
    return n === "text" ? {
      value: i,
      language: "text"
    } : o ? t.highlight(n, r) : t.highlightAuto(r);
  }
  try {
    return n && n !== "text" ? {
      value: t.highlight(r, n)
    } : {
      value: i
    };
  } catch {
    return {
      value: i
    };
  }
}
function que(e, t) {
  return function(n) {
    var r = n.language, i = n.children, o = n.style, a = o === void 0 ? t : o, s = n.customStyle, l = s === void 0 ? {} : s, u = n.codeTagProps, d = u === void 0 ? {
      className: r ? "language-".concat(r) : void 0,
      style: Kl(Kl({}, a['code[class*="language-"]']), a['code[class*="language-'.concat(r, '"]')])
    } : u, p = n.useInlineStyles, f = p === void 0 ? !0 : p, m = n.showLineNumbers, y = m === void 0 ? !1 : m, g = n.showInlineLineNumbers, x = g === void 0 ? !0 : g, E = n.startingLineNumber, b = E === void 0 ? 1 : E, C = n.lineNumberContainerStyle, T = n.lineNumberStyle, z = T === void 0 ? {} : T, I = n.wrapLines, w = n.wrapLongLines, M = w === void 0 ? !1 : w, R = n.lineProps, F = R === void 0 ? {} : R, W = n.renderer, X = n.PreTag, le = X === void 0 ? "pre" : X, ne = n.CodeTag, fe = ne === void 0 ? "code" : ne, D = n.code, j = D === void 0 ? (Array.isArray(i) ? i[0] : i) || "" : D, de = n.astGenerator, ye = Cue(n, zue);
    de = de || e;
    var Ne = y ? /* @__PURE__ */ dt.createElement(Bue, {
      containerStyle: C,
      codeStyle: d.style || {},
      numberStyle: z,
      startingLineNumber: b,
      codeString: j
    }) : null, Me = a.hljs || a['pre[class*="language-"]'] || {
      backgroundColor: "#fff"
    }, Ie = HF(de) ? "hljs" : "prismjs", at = f ? Object.assign({}, ye, {
      style: Object.assign({}, Me, l)
    }) : Object.assign({}, ye, {
      className: ye.className ? "".concat(Ie, " ").concat(ye.className) : Ie,
      style: Object.assign({}, l)
    });
    if (M ? d.style = Kl({
      whiteSpace: "pre-wrap"
    }, d.style) : d.style = Kl({
      whiteSpace: "pre"
    }, d.style), !de)
      return /* @__PURE__ */ dt.createElement(le, at, Ne, /* @__PURE__ */ dt.createElement(fe, d, j));
    (I === void 0 && W || M) && (I = !0), W = W || Pue;
    var Ve = [{
      type: "text",
      value: j
    }], mt = _ue({
      astGenerator: de,
      language: r,
      code: j,
      defaultCodeValue: Ve
    });
    mt.language === null && (mt.value = Ve);
    var ae = mt.value.length;
    ae === 1 && mt.value[0].type === "text" && (ae = mt.value[0].value.split(`
`).length);
    var Se = ae + b, Ae = Rue(mt, I, F, y, x, b, Se, z, M);
    return /* @__PURE__ */ dt.createElement(le, at, /* @__PURE__ */ dt.createElement(fe, d, !x && Ne, W({
      rows: Ae,
      stylesheet: a,
      useInlineStyles: f
    })));
  };
}
var $ue = Vue, Hue = Object.prototype.hasOwnProperty;
function Vue() {
  for (var e = {}, t = 0; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Hue.call(n, r) && (e[r] = n[r]);
  }
  return e;
}
var VF = UF, Zy = UF.prototype;
Zy.space = null;
Zy.normal = {};
Zy.property = {};
function UF(e, t, n) {
  this.property = e, this.normal = t, n && (this.space = n);
}
var W9 = $ue, Uue = VF, Wue = Zue;
function Zue(e) {
  for (var t = e.length, n = [], r = [], i = -1, o, a; ++i < t; )
    o = e[i], n.push(o.property), r.push(o.normal), a = o.space;
  return new Uue(
    W9.apply(null, n),
    W9.apply(null, r),
    a
  );
}
var Gy = Gue;
function Gue(e) {
  return e.toLowerCase();
}
var WF = ZF, ba = ZF.prototype;
ba.space = null;
ba.attribute = null;
ba.property = null;
ba.boolean = !1;
ba.booleanish = !1;
ba.overloadedBoolean = !1;
ba.number = !1;
ba.commaSeparated = !1;
ba.spaceSeparated = !1;
ba.commaOrSpaceSeparated = !1;
ba.mustUseProperty = !1;
ba.defined = !1;
function ZF(e, t) {
  this.property = e, this.attribute = t;
}
var ws = {}, Kue = 0;
ws.boolean = _c();
ws.booleanish = _c();
ws.overloadedBoolean = _c();
ws.number = _c();
ws.spaceSeparated = _c();
ws.commaSeparated = _c();
ws.commaOrSpaceSeparated = _c();
function _c() {
  return Math.pow(2, ++Kue);
}
var GF = WF, Z9 = ws, KF = Ky;
Ky.prototype = new GF();
Ky.prototype.defined = !0;
var XF = [
  "boolean",
  "booleanish",
  "overloadedBoolean",
  "number",
  "commaSeparated",
  "spaceSeparated",
  "commaOrSpaceSeparated"
], Xue = XF.length;
function Ky(e, t, n, r) {
  var i = -1, o;
  for (G9(this, "space", r), GF.call(this, e, t); ++i < Xue; )
    o = XF[i], G9(this, o, (n & Z9[o]) === Z9[o]);
}
function G9(e, t, n) {
  n && (e[t] = n);
}
var K9 = Gy, Que = VF, Yue = KF, Uf = Jue;
function Jue(e) {
  var t = e.space, n = e.mustUseProperty || [], r = e.attributes || {}, i = e.properties, o = e.transform, a = {}, s = {}, l, u;
  for (l in i)
    u = new Yue(
      l,
      o(r, l),
      i[l],
      t
    ), n.indexOf(l) !== -1 && (u.mustUseProperty = !0), a[l] = u, s[K9(l)] = l, s[K9(u.attribute)] = l;
  return new Que(a, s, t);
}
var ece = Uf, tce = ece({
  space: "xlink",
  transform: nce,
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
});
function nce(e, t) {
  return "xlink:" + t.slice(5).toLowerCase();
}
var rce = Uf, ice = rce({
  space: "xml",
  transform: oce,
  properties: {
    xmlLang: null,
    xmlBase: null,
    xmlSpace: null
  }
});
function oce(e, t) {
  return "xml:" + t.slice(3).toLowerCase();
}
var ace = sce;
function sce(e, t) {
  return t in e ? e[t] : t;
}
var lce = ace, QF = uce;
function uce(e, t) {
  return lce(e, t.toLowerCase());
}
var cce = Uf, dce = QF, pce = cce({
  space: "xmlns",
  attributes: {
    xmlnsxlink: "xmlns:xlink"
  },
  transform: dce,
  properties: {
    xmlns: null,
    xmlnsXLink: null
  }
}), Xy = ws, fce = Uf, Wi = Xy.booleanish, Xo = Xy.number, Ku = Xy.spaceSeparated, hce = fce({
  transform: mce,
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Wi,
    ariaAutoComplete: null,
    ariaBusy: Wi,
    ariaChecked: Wi,
    ariaColCount: Xo,
    ariaColIndex: Xo,
    ariaColSpan: Xo,
    ariaControls: Ku,
    ariaCurrent: null,
    ariaDescribedBy: Ku,
    ariaDetails: null,
    ariaDisabled: Wi,
    ariaDropEffect: Ku,
    ariaErrorMessage: null,
    ariaExpanded: Wi,
    ariaFlowTo: Ku,
    ariaGrabbed: Wi,
    ariaHasPopup: null,
    ariaHidden: Wi,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Ku,
    ariaLevel: Xo,
    ariaLive: null,
    ariaModal: Wi,
    ariaMultiLine: Wi,
    ariaMultiSelectable: Wi,
    ariaOrientation: null,
    ariaOwns: Ku,
    ariaPlaceholder: null,
    ariaPosInSet: Xo,
    ariaPressed: Wi,
    ariaReadOnly: Wi,
    ariaRelevant: null,
    ariaRequired: Wi,
    ariaRoleDescription: Ku,
    ariaRowCount: Xo,
    ariaRowIndex: Xo,
    ariaRowSpan: Xo,
    ariaSelected: Wi,
    ariaSetSize: Xo,
    ariaSort: null,
    ariaValueMax: Xo,
    ariaValueMin: Xo,
    ariaValueNow: Xo,
    ariaValueText: null,
    role: null
  }
});
function mce(e, t) {
  return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
}
var bd = ws, gce = Uf, vce = QF, nn = bd.boolean, yce = bd.overloadedBoolean, Ud = bd.booleanish, Pn = bd.number, Di = bd.spaceSeparated, n1 = bd.commaSeparated, xce = gce({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: vce,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: n1,
    acceptCharset: Di,
    accessKey: Di,
    action: null,
    allow: null,
    allowFullScreen: nn,
    allowPaymentRequest: nn,
    allowUserMedia: nn,
    alt: null,
    as: null,
    async: nn,
    autoCapitalize: null,
    autoComplete: Di,
    autoFocus: nn,
    autoPlay: nn,
    capture: nn,
    charSet: null,
    checked: nn,
    cite: null,
    className: Di,
    cols: Pn,
    colSpan: null,
    content: null,
    contentEditable: Ud,
    controls: nn,
    controlsList: Di,
    coords: Pn | n1,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: nn,
    defer: nn,
    dir: null,
    dirName: null,
    disabled: nn,
    download: yce,
    draggable: Ud,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: nn,
    formTarget: null,
    headers: Di,
    height: Pn,
    hidden: nn,
    high: Pn,
    href: null,
    hrefLang: null,
    htmlFor: Di,
    httpEquiv: Di,
    id: null,
    imageSizes: null,
    imageSrcSet: n1,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: nn,
    itemId: null,
    itemProp: Di,
    itemRef: Di,
    itemScope: nn,
    itemType: Di,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: nn,
    low: Pn,
    manifest: null,
    max: null,
    maxLength: Pn,
    media: null,
    method: null,
    min: null,
    minLength: Pn,
    multiple: nn,
    muted: nn,
    name: null,
    nonce: null,
    noModule: nn,
    noValidate: nn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextMenu: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: nn,
    optimum: Pn,
    pattern: null,
    ping: Di,
    placeholder: null,
    playsInline: nn,
    poster: null,
    preload: null,
    readOnly: nn,
    referrerPolicy: null,
    rel: Di,
    required: nn,
    reversed: nn,
    rows: Pn,
    rowSpan: Pn,
    sandbox: Di,
    scope: null,
    scoped: nn,
    seamless: nn,
    selected: nn,
    shape: null,
    size: Pn,
    sizes: null,
    slot: null,
    span: Pn,
    spellCheck: Ud,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: n1,
    start: Pn,
    step: null,
    style: null,
    tabIndex: Pn,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: nn,
    useMap: null,
    value: Ud,
    width: Pn,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Di,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Pn,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Pn,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: nn,
    // Lists. Use CSS to reduce space between items instead
    declare: nn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Pn,
    // `<img>` and `<object>`
    leftMargin: Pn,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Pn,
    // `<body>`
    marginWidth: Pn,
    // `<body>`
    noResize: nn,
    // `<frame>`
    noHref: nn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: nn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: nn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Pn,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Ud,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Pn,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Pn,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: nn,
    disableRemotePlayback: nn,
    prefix: null,
    property: null,
    results: Pn,
    security: null,
    unselectable: null
  }
}), bce = Wue, wce = tce, Cce = ice, kce = pce, Ece = hce, Sce = xce, Dce = bce([Cce, wce, kce, Ece, Sce]), Ace = Gy, Tce = KF, jce = WF, Qy = "data", Nce = Fce, Oce = /^data[-\w.:]+$/i, YF = /-[a-z]/g, zce = /[A-Z]/g;
function Fce(e, t) {
  var n = Ace(t), r = t, i = jce;
  return n in e.normal ? e.property[e.normal[n]] : (n.length > 4 && n.slice(0, 4) === Qy && Oce.test(t) && (t.charAt(4) === "-" ? r = Lce(t) : t = Mce(t), i = Tce), new i(r, t));
}
function Lce(e) {
  var t = e.slice(5).replace(YF, Ice);
  return Qy + t.charAt(0).toUpperCase() + t.slice(1);
}
function Mce(e) {
  var t = e.slice(4);
  return YF.test(t) ? e : (t = t.replace(zce, Bce), t.charAt(0) !== "-" && (t = "-" + t), Qy + t);
}
function Bce(e) {
  return "-" + e.toLowerCase();
}
function Ice(e) {
  return e.charAt(1).toUpperCase();
}
var Rce = Pce, X9 = /[#.]/g;
function Pce(e, t) {
  for (var n = e || "", r = t || "div", i = {}, o = 0, a, s, l; o < n.length; )
    X9.lastIndex = o, l = X9.exec(n), a = n.slice(o, l ? l.index : n.length), a && (s ? s === "#" ? i.id = a : i.className ? i.className.push(a) : i.className = [a] : r = a, o += a.length), l && (s = l[0], o++);
  return { type: "element", tagName: r, properties: i, children: [] };
}
var Yy = {};
Yy.parse = $ce;
Yy.stringify = Hce;
var Q9 = "", _ce = " ", qce = /[ \t\n\r\f]+/g;
function $ce(e) {
  var t = String(e || Q9).trim();
  return t === Q9 ? [] : t.split(qce);
}
function Hce(e) {
  return e.join(_ce).trim();
}
var Jy = {};
Jy.parse = Vce;
Jy.stringify = Uce;
var q5 = ",", Y9 = " ", op = "";
function Vce(e) {
  for (var t = [], n = String(e || op), r = n.indexOf(q5), i = 0, o = !1, a; !o; )
    r === -1 && (r = n.length, o = !0), a = n.slice(i, r).trim(), (a || !o) && t.push(a), i = r + 1, r = n.indexOf(q5, i);
  return t;
}
function Uce(e, t) {
  var n = t || {}, r = n.padLeft === !1 ? op : Y9, i = n.padRight ? Y9 : op;
  return e[e.length - 1] === op && (e = e.concat(op)), e.join(i + q5 + r).trim();
}
var Wce = Nce, J9 = Gy, Zce = Rce, eC = Yy.parse, tC = Jy.parse, Gce = Xce, Kce = {}.hasOwnProperty;
function Xce(e, t, n) {
  var r = n ? t0e(n) : null;
  return i;
  function i(a, s) {
    var l = Zce(a, t), u = Array.prototype.slice.call(arguments, 2), d = l.tagName.toLowerCase(), p;
    if (l.tagName = r && Kce.call(r, d) ? r[d] : d, s && Qce(s, l) && (u.unshift(s), s = null), s)
      for (p in s)
        o(l.properties, p, s[p]);
    return JF(l.children, u), l.tagName === "template" && (l.content = { type: "root", children: l.children }, l.children = []), l;
  }
  function o(a, s, l) {
    var u, d, p;
    l == null || l !== l || (u = Wce(e, s), d = u.property, p = l, typeof p == "string" && (u.spaceSeparated ? p = eC(p) : u.commaSeparated ? p = tC(p) : u.commaOrSpaceSeparated && (p = eC(tC(p).join(" ")))), d === "style" && typeof l != "string" && (p = e0e(p)), d === "className" && a.className && (p = a.className.concat(p)), a[d] = Jce(u, d, p));
  }
}
function Qce(e, t) {
  return typeof e == "string" || "length" in e || Yce(t.tagName, e);
}
function Yce(e, t) {
  var n = t.type;
  return e === "input" || !n || typeof n != "string" ? !1 : typeof t.children == "object" && "length" in t.children ? !0 : (n = n.toLowerCase(), e === "button" ? n !== "menu" && n !== "submit" && n !== "reset" && n !== "button" : "value" in t);
}
function JF(e, t) {
  var n, r;
  if (typeof t == "string" || typeof t == "number") {
    e.push({ type: "text", value: String(t) });
    return;
  }
  if (typeof t == "object" && "length" in t) {
    for (n = -1, r = t.length; ++n < r; )
      JF(e, t[n]);
    return;
  }
  if (typeof t != "object" || !("type" in t))
    throw new Error("Expected node, nodes, or string, got `" + t + "`");
  e.push(t);
}
function Jce(e, t, n) {
  var r, i, o;
  if (typeof n != "object" || !("length" in n))
    return nC(e, t, n);
  for (i = n.length, r = -1, o = []; ++r < i; )
    o[r] = nC(e, t, n[r]);
  return o;
}
function nC(e, t, n) {
  var r = n;
  return e.number || e.positiveNumber ? !isNaN(r) && r !== "" && (r = Number(r)) : (e.boolean || e.overloadedBoolean) && typeof r == "string" && (r === "" || J9(n) === J9(t)) && (r = !0), r;
}
function e0e(e) {
  var t = [], n;
  for (n in e)
    t.push([n, e[n]].join(": "));
  return t.join("; ");
}
function t0e(e) {
  for (var t = e.length, n = -1, r = {}, i; ++n < t; )
    i = e[n], r[i.toLowerCase()] = i;
  return r;
}
var n0e = Dce, r0e = Gce, eL = r0e(n0e, "div");
eL.displayName = "html";
var i0e = eL, o0e = i0e;
const a0e = "Æ", s0e = "&", l0e = "Á", u0e = "Â", c0e = "À", d0e = "Å", p0e = "Ã", f0e = "Ä", h0e = "©", m0e = "Ç", g0e = "Ð", v0e = "É", y0e = "Ê", x0e = "È", b0e = "Ë", w0e = ">", C0e = "Í", k0e = "Î", E0e = "Ì", S0e = "Ï", D0e = "<", A0e = "Ñ", T0e = "Ó", j0e = "Ô", N0e = "Ò", O0e = "Ø", z0e = "Õ", F0e = "Ö", L0e = '"', M0e = "®", B0e = "Þ", I0e = "Ú", R0e = "Û", P0e = "Ù", _0e = "Ü", q0e = "Ý", $0e = "á", H0e = "â", V0e = "´", U0e = "æ", W0e = "à", Z0e = "&", G0e = "å", K0e = "ã", X0e = "ä", Q0e = "¦", Y0e = "ç", J0e = "¸", ede = "¢", tde = "©", nde = "¤", rde = "°", ide = "÷", ode = "é", ade = "ê", sde = "è", lde = "ð", ude = "ë", cde = "½", dde = "¼", pde = "¾", fde = ">", hde = "í", mde = "î", gde = "¡", vde = "ì", yde = "¿", xde = "ï", bde = "«", wde = "<", Cde = "¯", kde = "µ", Ede = "·", Sde = " ", Dde = "¬", Ade = "ñ", Tde = "ó", jde = "ô", Nde = "ò", Ode = "ª", zde = "º", Fde = "ø", Lde = "õ", Mde = "ö", Bde = "¶", Ide = "±", Rde = "£", Pde = '"', _de = "»", qde = "®", $de = "§", Hde = "­", Vde = "¹", Ude = "²", Wde = "³", Zde = "ß", Gde = "þ", Kde = "×", Xde = "ú", Qde = "û", Yde = "ù", Jde = "¨", epe = "ü", tpe = "ý", npe = "¥", rpe = "ÿ", ipe = {
  AElig: a0e,
  AMP: s0e,
  Aacute: l0e,
  Acirc: u0e,
  Agrave: c0e,
  Aring: d0e,
  Atilde: p0e,
  Auml: f0e,
  COPY: h0e,
  Ccedil: m0e,
  ETH: g0e,
  Eacute: v0e,
  Ecirc: y0e,
  Egrave: x0e,
  Euml: b0e,
  GT: w0e,
  Iacute: C0e,
  Icirc: k0e,
  Igrave: E0e,
  Iuml: S0e,
  LT: D0e,
  Ntilde: A0e,
  Oacute: T0e,
  Ocirc: j0e,
  Ograve: N0e,
  Oslash: O0e,
  Otilde: z0e,
  Ouml: F0e,
  QUOT: L0e,
  REG: M0e,
  THORN: B0e,
  Uacute: I0e,
  Ucirc: R0e,
  Ugrave: P0e,
  Uuml: _0e,
  Yacute: q0e,
  aacute: $0e,
  acirc: H0e,
  acute: V0e,
  aelig: U0e,
  agrave: W0e,
  amp: Z0e,
  aring: G0e,
  atilde: K0e,
  auml: X0e,
  brvbar: Q0e,
  ccedil: Y0e,
  cedil: J0e,
  cent: ede,
  copy: tde,
  curren: nde,
  deg: rde,
  divide: ide,
  eacute: ode,
  ecirc: ade,
  egrave: sde,
  eth: lde,
  euml: ude,
  frac12: cde,
  frac14: dde,
  frac34: pde,
  gt: fde,
  iacute: hde,
  icirc: mde,
  iexcl: gde,
  igrave: vde,
  iquest: yde,
  iuml: xde,
  laquo: bde,
  lt: wde,
  macr: Cde,
  micro: kde,
  middot: Ede,
  nbsp: Sde,
  not: Dde,
  ntilde: Ade,
  oacute: Tde,
  ocirc: jde,
  ograve: Nde,
  ordf: Ode,
  ordm: zde,
  oslash: Fde,
  otilde: Lde,
  ouml: Mde,
  para: Bde,
  plusmn: Ide,
  pound: Rde,
  quot: Pde,
  raquo: _de,
  reg: qde,
  sect: $de,
  shy: Hde,
  sup1: Vde,
  sup2: Ude,
  sup3: Wde,
  szlig: Zde,
  thorn: Gde,
  times: Kde,
  uacute: Xde,
  ucirc: Qde,
  ugrave: Yde,
  uml: Jde,
  uuml: epe,
  yacute: tpe,
  yen: npe,
  yuml: rpe
}, ope = {
  0: "�",
  128: "€",
  130: "‚",
  131: "ƒ",
  132: "„",
  133: "…",
  134: "†",
  135: "‡",
  136: "ˆ",
  137: "‰",
  138: "Š",
  139: "‹",
  140: "Œ",
  142: "Ž",
  145: "‘",
  146: "’",
  147: "“",
  148: "”",
  149: "•",
  150: "–",
  151: "—",
  152: "˜",
  153: "™",
  154: "š",
  155: "›",
  156: "œ",
  158: "ž",
  159: "Ÿ"
};
var tL = ape;
function ape(e) {
  var t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 48 && t <= 57;
}
var spe = lpe;
function lpe(e) {
  var t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 97 && t <= 102 || t >= 65 && t <= 70 || t >= 48 && t <= 57;
}
var upe = cpe;
function cpe(e) {
  var t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 97 && t <= 122 || t >= 65 && t <= 90;
}
var dpe = upe, ppe = tL, fpe = hpe;
function hpe(e) {
  return dpe(e) || ppe(e);
}
var r1, mpe = 59, gpe = vpe;
function vpe(e) {
  var t = "&" + e + ";", n;
  return r1 = r1 || document.createElement("i"), r1.innerHTML = t, n = r1.textContent, n.charCodeAt(n.length - 1) === mpe && e !== "semi" || n === t ? !1 : n;
}
var rC = ipe, iC = ope, ype = tL, xpe = spe, nL = fpe, bpe = gpe, wpe = Lpe, Cpe = {}.hasOwnProperty, n0 = String.fromCharCode, kpe = Function.prototype, oC = {
  warning: null,
  reference: null,
  text: null,
  warningContext: null,
  referenceContext: null,
  textContext: null,
  position: {},
  additional: null,
  attribute: !1,
  nonTerminated: !0
}, Epe = 9, aC = 10, Spe = 12, Dpe = 32, sC = 38, Ape = 59, Tpe = 60, jpe = 61, Npe = 35, Ope = 88, zpe = 120, Fpe = 65533, o0 = "named", e8 = "hexadecimal", t8 = "decimal", n8 = {};
n8[e8] = 16;
n8[t8] = 10;
var S2 = {};
S2[o0] = nL;
S2[t8] = ype;
S2[e8] = xpe;
var rL = 1, iL = 2, oL = 3, aL = 4, sL = 5, $5 = 6, lL = 7, zu = {};
zu[rL] = "Named character references must be terminated by a semicolon";
zu[iL] = "Numeric character references must be terminated by a semicolon";
zu[oL] = "Named character references cannot be empty";
zu[aL] = "Numeric character references cannot be empty";
zu[sL] = "Named character references must be known";
zu[$5] = "Numeric character references cannot be disallowed";
zu[lL] = "Numeric character references cannot be outside the permissible Unicode range";
function Lpe(e, t) {
  var n = {}, r, i;
  t || (t = {});
  for (i in oC)
    r = t[i], n[i] = r ?? oC[i];
  return (n.position.indent || n.position.start) && (n.indent = n.position.indent || [], n.position = n.position.start), Mpe(e, n);
}
function Mpe(e, t) {
  var n = t.additional, r = t.nonTerminated, i = t.text, o = t.reference, a = t.warning, s = t.textContext, l = t.referenceContext, u = t.warningContext, d = t.position, p = t.indent || [], f = e.length, m = 0, y = -1, g = d.column || 1, x = d.line || 1, E = "", b = [], C, T, z, I, w, M, R, F, W, X, le, ne, fe, D, j, de, ye, Ne, Me;
  for (typeof n == "string" && (n = n.charCodeAt(0)), de = Ie(), F = a ? at : kpe, m--, f++; ++m < f; )
    if (w === aC && (g = p[y] || 1), w = e.charCodeAt(m), w === sC) {
      if (R = e.charCodeAt(m + 1), R === Epe || R === aC || R === Spe || R === Dpe || R === sC || R === Tpe || R !== R || n && R === n) {
        E += n0(w), g++;
        continue;
      }
      for (fe = m + 1, ne = fe, Me = fe, R === Npe ? (Me = ++ne, R = e.charCodeAt(Me), R === Ope || R === zpe ? (D = e8, Me = ++ne) : D = t8) : D = o0, C = "", le = "", I = "", j = S2[D], Me--; ++Me < f && (R = e.charCodeAt(Me), !!j(R)); )
        I += n0(R), D === o0 && Cpe.call(rC, I) && (C = I, le = rC[I]);
      z = e.charCodeAt(Me) === Ape, z && (Me++, T = D === o0 ? bpe(I) : !1, T && (C = I, le = T)), Ne = 1 + Me - fe, !z && !r || (I ? D === o0 ? (z && !le ? F(sL, 1) : (C !== I && (Me = ne + C.length, Ne = 1 + Me - ne, z = !1), z || (W = C ? rL : oL, t.attribute ? (R = e.charCodeAt(Me), R === jpe ? (F(W, Ne), le = null) : nL(R) ? le = null : F(W, Ne)) : F(W, Ne))), M = le) : (z || F(iL, Ne), M = parseInt(I, n8[D]), Bpe(M) ? (F(lL, Ne), M = n0(Fpe)) : M in iC ? (F($5, Ne), M = iC[M]) : (X = "", Ipe(M) && F($5, Ne), M > 65535 && (M -= 65536, X += n0(M >>> 10 | 55296), M = 56320 | M & 1023), M = X + n0(M))) : D !== o0 && F(aL, Ne)), M ? (Ve(), de = Ie(), m = Me - 1, g += Me - fe + 1, b.push(M), ye = Ie(), ye.offset++, o && o.call(
        l,
        M,
        { start: de, end: ye },
        e.slice(fe - 1, Me)
      ), de = ye) : (I = e.slice(fe - 1, Me), E += I, g += I.length, m = Me - 1);
    } else
      w === 10 && (x++, y++, g = 0), w === w ? (E += n0(w), g++) : Ve();
  return b.join("");
  function Ie() {
    return {
      line: x,
      column: g,
      offset: m + (d.offset || 0)
    };
  }
  function at(mt, ae) {
    var Se = Ie();
    Se.column += ae, Se.offset += ae, a.call(u, zu[mt], Se, mt);
  }
  function Ve() {
    E && (b.push(E), i && i.call(s, E, { start: de, end: Ie() }), E = "");
  }
}
function Bpe(e) {
  return e >= 55296 && e <= 57343 || e > 1114111;
}
function Ipe(e) {
  return e >= 1 && e <= 8 || e === 11 || e >= 13 && e <= 31 || e >= 127 && e <= 159 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 || (e & 65535) === 65534;
}
var uL = { exports: {} };
(function(e) {
  var t = typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {};
  /**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   */
  var n = function(r) {
    var i = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, o = 0, a = {}, s = {
      /**
       * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
       * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
       * additional languages or plugins yourself.
       *
       * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
       *
       * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
       * empty Prism object into the global scope before loading the Prism script like this:
       *
       * ```js
       * window.Prism = window.Prism || {};
       * Prism.manual = true;
       * // add a new <script> to load Prism's script
       * ```
       *
       * @default false
       * @type {boolean}
       * @memberof Prism
       * @public
       */
      manual: r.Prism && r.Prism.manual,
      /**
       * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
       * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
       * own worker, you don't want it to do this.
       *
       * By setting this value to `true`, Prism will not add its own listeners to the worker.
       *
       * You obviously have to change this value before Prism executes. To do this, you can add an
       * empty Prism object into the global scope before loading the Prism script like this:
       *
       * ```js
       * window.Prism = window.Prism || {};
       * Prism.disableWorkerMessageHandler = true;
       * // Load Prism's script
       * ```
       *
       * @default false
       * @type {boolean}
       * @memberof Prism
       * @public
       */
      disableWorkerMessageHandler: r.Prism && r.Prism.disableWorkerMessageHandler,
      /**
       * A namespace for utility methods.
       *
       * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
       * change or disappear at any time.
       *
       * @namespace
       * @memberof Prism
       */
      util: {
        encode: function b(C) {
          return C instanceof l ? new l(C.type, b(C.content), C.alias) : Array.isArray(C) ? C.map(b) : C.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
        },
        /**
         * Returns the name of the type of the given value.
         *
         * @param {any} o
         * @returns {string}
         * @example
         * type(null)      === 'Null'
         * type(undefined) === 'Undefined'
         * type(123)       === 'Number'
         * type('foo')     === 'String'
         * type(true)      === 'Boolean'
         * type([1, 2])    === 'Array'
         * type({})        === 'Object'
         * type(String)    === 'Function'
         * type(/abc+/)    === 'RegExp'
         */
        type: function(b) {
          return Object.prototype.toString.call(b).slice(8, -1);
        },
        /**
         * Returns a unique number for the given object. Later calls will still return the same number.
         *
         * @param {Object} obj
         * @returns {number}
         */
        objId: function(b) {
          return b.__id || Object.defineProperty(b, "__id", { value: ++o }), b.__id;
        },
        /**
         * Creates a deep clone of the given object.
         *
         * The main intended use of this function is to clone language definitions.
         *
         * @param {T} o
         * @param {Record<number, any>} [visited]
         * @returns {T}
         * @template T
         */
        clone: function b(C, T) {
          T = T || {};
          var z, I;
          switch (s.util.type(C)) {
            case "Object":
              if (I = s.util.objId(C), T[I])
                return T[I];
              z = /** @type {Record<string, any>} */
              {}, T[I] = z;
              for (var w in C)
                C.hasOwnProperty(w) && (z[w] = b(C[w], T));
              return (
                /** @type {any} */
                z
              );
            case "Array":
              return I = s.util.objId(C), T[I] ? T[I] : (z = [], T[I] = z, C.forEach(function(M, R) {
                z[R] = b(M, T);
              }), /** @type {any} */
              z);
            default:
              return C;
          }
        },
        /**
         * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
         *
         * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
         *
         * @param {Element} element
         * @returns {string}
         */
        getLanguage: function(b) {
          for (; b; ) {
            var C = i.exec(b.className);
            if (C)
              return C[1].toLowerCase();
            b = b.parentElement;
          }
          return "none";
        },
        /**
         * Sets the Prism `language-xxxx` class of the given element.
         *
         * @param {Element} element
         * @param {string} language
         * @returns {void}
         */
        setLanguage: function(b, C) {
          b.className = b.className.replace(RegExp(i, "gi"), ""), b.classList.add("language-" + C);
        },
        /**
         * Returns the script element that is currently executing.
         *
         * This does __not__ work for line script element.
         *
         * @returns {HTMLScriptElement | null}
         */
        currentScript: function() {
          if (typeof document > "u")
            return null;
          if ("currentScript" in document)
            return (
              /** @type {any} */
              document.currentScript
            );
          try {
            throw new Error();
          } catch (z) {
            var b = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(z.stack) || [])[1];
            if (b) {
              var C = document.getElementsByTagName("script");
              for (var T in C)
                if (C[T].src == b)
                  return C[T];
            }
            return null;
          }
        },
        /**
         * Returns whether a given class is active for `element`.
         *
         * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
         * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
         * given class is just the given class with a `no-` prefix.
         *
         * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
         * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
         * ancestors have the given class or the negated version of it, then the default activation will be returned.
         *
         * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
         * version of it, the class is considered active.
         *
         * @param {Element} element
         * @param {string} className
         * @param {boolean} [defaultActivation=false]
         * @returns {boolean}
         */
        isActive: function(b, C, T) {
          for (var z = "no-" + C; b; ) {
            var I = b.classList;
            if (I.contains(C))
              return !0;
            if (I.contains(z))
              return !1;
            b = b.parentElement;
          }
          return !!T;
        }
      },
      /**
       * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
       *
       * @namespace
       * @memberof Prism
       * @public
       */
      languages: {
        /**
         * The grammar for plain, unformatted text.
         */
        plain: a,
        plaintext: a,
        text: a,
        txt: a,
        /**
         * Creates a deep copy of the language with the given id and appends the given tokens.
         *
         * If a token in `redef` also appears in the copied language, then the existing token in the copied language
         * will be overwritten at its original position.
         *
         * ## Best practices
         *
         * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
         * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
         * understand the language definition because, normally, the order of tokens matters in Prism grammars.
         *
         * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
         * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
         *
         * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
         * @param {Grammar} redef The new tokens to append.
         * @returns {Grammar} The new language created.
         * @public
         * @example
         * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
         *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
         *     // at its original position
         *     'comment': { ... },
         *     // CSS doesn't have a 'color' token, so this token will be appended
         *     'color': /\b(?:red|green|blue)\b/
         * });
         */
        extend: function(b, C) {
          var T = s.util.clone(s.languages[b]);
          for (var z in C)
            T[z] = C[z];
          return T;
        },
        /**
         * Inserts tokens _before_ another token in a language definition or any other grammar.
         *
         * ## Usage
         *
         * This helper method makes it easy to modify existing languages. For example, the CSS language definition
         * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
         * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
         * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
         * this:
         *
         * ```js
         * Prism.languages.markup.style = {
         *     // token
         * };
         * ```
         *
         * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
         * before existing tokens. For the CSS example above, you would use it like this:
         *
         * ```js
         * Prism.languages.insertBefore('markup', 'cdata', {
         *     'style': {
         *         // token
         *     }
         * });
         * ```
         *
         * ## Special cases
         *
         * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
         * will be ignored.
         *
         * This behavior can be used to insert tokens after `before`:
         *
         * ```js
         * Prism.languages.insertBefore('markup', 'comment', {
         *     'comment': Prism.languages.markup.comment,
         *     // tokens after 'comment'
         * });
         * ```
         *
         * ## Limitations
         *
         * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
         * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
         * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
         * deleting properties which is necessary to insert at arbitrary positions.
         *
         * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
         * Instead, it will create a new object and replace all references to the target object with the new one. This
         * can be done without temporarily deleting properties, so the iteration order is well-defined.
         *
         * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
         * you hold the target object in a variable, then the value of the variable will not change.
         *
         * ```js
         * var oldMarkup = Prism.languages.markup;
         * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
         *
         * assert(oldMarkup !== Prism.languages.markup);
         * assert(newMarkup === Prism.languages.markup);
         * ```
         *
         * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
         * object to be modified.
         * @param {string} before The key to insert before.
         * @param {Grammar} insert An object containing the key-value pairs to be inserted.
         * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
         * object to be modified.
         *
         * Defaults to `Prism.languages`.
         * @returns {Grammar} The new grammar object.
         * @public
         */
        insertBefore: function(b, C, T, z) {
          z = z || /** @type {any} */
          s.languages;
          var I = z[b], w = {};
          for (var M in I)
            if (I.hasOwnProperty(M)) {
              if (M == C)
                for (var R in T)
                  T.hasOwnProperty(R) && (w[R] = T[R]);
              T.hasOwnProperty(M) || (w[M] = I[M]);
            }
          var F = z[b];
          return z[b] = w, s.languages.DFS(s.languages, function(W, X) {
            X === F && W != b && (this[W] = w);
          }), w;
        },
        // Traverse a language definition with Depth First Search
        DFS: function b(C, T, z, I) {
          I = I || {};
          var w = s.util.objId;
          for (var M in C)
            if (C.hasOwnProperty(M)) {
              T.call(C, M, C[M], z || M);
              var R = C[M], F = s.util.type(R);
              F === "Object" && !I[w(R)] ? (I[w(R)] = !0, b(R, T, null, I)) : F === "Array" && !I[w(R)] && (I[w(R)] = !0, b(R, T, M, I));
            }
        }
      },
      plugins: {},
      /**
       * This is the most high-level function in Prism’s API.
       * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
       * each one of them.
       *
       * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
       *
       * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
       * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
       * @memberof Prism
       * @public
       */
      highlightAll: function(b, C) {
        s.highlightAllUnder(document, b, C);
      },
      /**
       * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
       * {@link Prism.highlightElement} on each one of them.
       *
       * The following hooks will be run:
       * 1. `before-highlightall`
       * 2. `before-all-elements-highlight`
       * 3. All hooks of {@link Prism.highlightElement} for each element.
       *
       * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
       * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
       * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
       * @memberof Prism
       * @public
       */
      highlightAllUnder: function(b, C, T) {
        var z = {
          callback: T,
          container: b,
          selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
        };
        s.hooks.run("before-highlightall", z), z.elements = Array.prototype.slice.apply(z.container.querySelectorAll(z.selector)), s.hooks.run("before-all-elements-highlight", z);
        for (var I = 0, w; w = z.elements[I++]; )
          s.highlightElement(w, C === !0, z.callback);
      },
      /**
       * Highlights the code inside a single element.
       *
       * The following hooks will be run:
       * 1. `before-sanity-check`
       * 2. `before-highlight`
       * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
       * 4. `before-insert`
       * 5. `after-highlight`
       * 6. `complete`
       *
       * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
       * the element's language.
       *
       * @param {Element} element The element containing the code.
       * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
       * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
       * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
       * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
       *
       * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
       * asynchronous highlighting to work. You can build your own bundle on the
       * [Download page](https://prismjs.com/download.html).
       * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
       * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
       * @memberof Prism
       * @public
       */
      highlightElement: function(b, C, T) {
        var z = s.util.getLanguage(b), I = s.languages[z];
        s.util.setLanguage(b, z);
        var w = b.parentElement;
        w && w.nodeName.toLowerCase() === "pre" && s.util.setLanguage(w, z);
        var M = b.textContent, R = {
          element: b,
          language: z,
          grammar: I,
          code: M
        };
        function F(X) {
          R.highlightedCode = X, s.hooks.run("before-insert", R), R.element.innerHTML = R.highlightedCode, s.hooks.run("after-highlight", R), s.hooks.run("complete", R), T && T.call(R.element);
        }
        if (s.hooks.run("before-sanity-check", R), w = R.element.parentElement, w && w.nodeName.toLowerCase() === "pre" && !w.hasAttribute("tabindex") && w.setAttribute("tabindex", "0"), !R.code) {
          s.hooks.run("complete", R), T && T.call(R.element);
          return;
        }
        if (s.hooks.run("before-highlight", R), !R.grammar) {
          F(s.util.encode(R.code));
          return;
        }
        if (C && r.Worker) {
          var W = new Worker(s.filename);
          W.onmessage = function(X) {
            F(X.data);
          }, W.postMessage(JSON.stringify({
            language: R.language,
            code: R.code,
            immediateClose: !0
          }));
        } else
          F(s.highlight(R.code, R.grammar, R.language));
      },
      /**
       * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
       * and the language definitions to use, and returns a string with the HTML produced.
       *
       * The following hooks will be run:
       * 1. `before-tokenize`
       * 2. `after-tokenize`
       * 3. `wrap`: On each {@link Token}.
       *
       * @param {string} text A string with the code to be highlighted.
       * @param {Grammar} grammar An object containing the tokens to use.
       *
       * Usually a language definition like `Prism.languages.markup`.
       * @param {string} language The name of the language definition passed to `grammar`.
       * @returns {string} The highlighted HTML.
       * @memberof Prism
       * @public
       * @example
       * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
       */
      highlight: function(b, C, T) {
        var z = {
          code: b,
          grammar: C,
          language: T
        };
        if (s.hooks.run("before-tokenize", z), !z.grammar)
          throw new Error('The language "' + z.language + '" has no grammar.');
        return z.tokens = s.tokenize(z.code, z.grammar), s.hooks.run("after-tokenize", z), l.stringify(s.util.encode(z.tokens), z.language);
      },
      /**
       * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
       * and the language definitions to use, and returns an array with the tokenized code.
       *
       * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
       *
       * This method could be useful in other contexts as well, as a very crude parser.
       *
       * @param {string} text A string with the code to be highlighted.
       * @param {Grammar} grammar An object containing the tokens to use.
       *
       * Usually a language definition like `Prism.languages.markup`.
       * @returns {TokenStream} An array of strings and tokens, a token stream.
       * @memberof Prism
       * @public
       * @example
       * let code = `var foo = 0;`;
       * let tokens = Prism.tokenize(code, Prism.languages.javascript);
       * tokens.forEach(token => {
       *     if (token instanceof Prism.Token && token.type === 'number') {
       *         console.log(`Found numeric literal: ${token.content}`);
       *     }
       * });
       */
      tokenize: function(b, C) {
        var T = C.rest;
        if (T) {
          for (var z in T)
            C[z] = T[z];
          delete C.rest;
        }
        var I = new p();
        return f(I, I.head, b), d(b, I, C, I.head, 0), y(I);
      },
      /**
       * @namespace
       * @memberof Prism
       * @public
       */
      hooks: {
        all: {},
        /**
         * Adds the given callback to the list of callbacks for the given hook.
         *
         * The callback will be invoked when the hook it is registered for is run.
         * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
         *
         * One callback function can be registered to multiple hooks and the same hook multiple times.
         *
         * @param {string} name The name of the hook.
         * @param {HookCallback} callback The callback function which is given environment variables.
         * @public
         */
        add: function(b, C) {
          var T = s.hooks.all;
          T[b] = T[b] || [], T[b].push(C);
        },
        /**
         * Runs a hook invoking all registered callbacks with the given environment variables.
         *
         * Callbacks will be invoked synchronously and in the order in which they were registered.
         *
         * @param {string} name The name of the hook.
         * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
         * @public
         */
        run: function(b, C) {
          var T = s.hooks.all[b];
          if (!(!T || !T.length))
            for (var z = 0, I; I = T[z++]; )
              I(C);
        }
      },
      Token: l
    };
    r.Prism = s;
    function l(b, C, T, z) {
      this.type = b, this.content = C, this.alias = T, this.length = (z || "").length | 0;
    }
    l.stringify = function b(C, T) {
      if (typeof C == "string")
        return C;
      if (Array.isArray(C)) {
        var z = "";
        return C.forEach(function(F) {
          z += b(F, T);
        }), z;
      }
      var I = {
        type: C.type,
        content: b(C.content, T),
        tag: "span",
        classes: ["token", C.type],
        attributes: {},
        language: T
      }, w = C.alias;
      w && (Array.isArray(w) ? Array.prototype.push.apply(I.classes, w) : I.classes.push(w)), s.hooks.run("wrap", I);
      var M = "";
      for (var R in I.attributes)
        M += " " + R + '="' + (I.attributes[R] || "").replace(/"/g, "&quot;") + '"';
      return "<" + I.tag + ' class="' + I.classes.join(" ") + '"' + M + ">" + I.content + "</" + I.tag + ">";
    };
    function u(b, C, T, z) {
      b.lastIndex = C;
      var I = b.exec(T);
      if (I && z && I[1]) {
        var w = I[1].length;
        I.index += w, I[0] = I[0].slice(w);
      }
      return I;
    }
    function d(b, C, T, z, I, w) {
      for (var M in T)
        if (!(!T.hasOwnProperty(M) || !T[M])) {
          var R = T[M];
          R = Array.isArray(R) ? R : [R];
          for (var F = 0; F < R.length; ++F) {
            if (w && w.cause == M + "," + F)
              return;
            var W = R[F], X = W.inside, le = !!W.lookbehind, ne = !!W.greedy, fe = W.alias;
            if (ne && !W.pattern.global) {
              var D = W.pattern.toString().match(/[imsuy]*$/)[0];
              W.pattern = RegExp(W.pattern.source, D + "g");
            }
            for (var j = W.pattern || W, de = z.next, ye = I; de !== C.tail && !(w && ye >= w.reach); ye += de.value.length, de = de.next) {
              var Ne = de.value;
              if (C.length > b.length)
                return;
              if (!(Ne instanceof l)) {
                var Me = 1, Ie;
                if (ne) {
                  if (Ie = u(j, ye, b, le), !Ie || Ie.index >= b.length)
                    break;
                  var ae = Ie.index, at = Ie.index + Ie[0].length, Ve = ye;
                  for (Ve += de.value.length; ae >= Ve; )
                    de = de.next, Ve += de.value.length;
                  if (Ve -= de.value.length, ye = Ve, de.value instanceof l)
                    continue;
                  for (var mt = de; mt !== C.tail && (Ve < at || typeof mt.value == "string"); mt = mt.next)
                    Me++, Ve += mt.value.length;
                  Me--, Ne = b.slice(ye, Ve), Ie.index -= ye;
                } else if (Ie = u(j, 0, Ne, le), !Ie)
                  continue;
                var ae = Ie.index, Se = Ie[0], Ae = Ne.slice(0, ae), Be = Ne.slice(ae + Se.length), Ze = ye + Ne.length;
                w && Ze > w.reach && (w.reach = Ze);
                var We = de.prev;
                Ae && (We = f(C, We, Ae), ye += Ae.length), m(C, We, Me);
                var St = new l(M, X ? s.tokenize(Se, X) : Se, fe, Se);
                if (de = f(C, We, St), Be && f(C, de, Be), Me > 1) {
                  var pt = {
                    cause: M + "," + F,
                    reach: Ze
                  };
                  d(b, C, T, de.prev, ye, pt), w && pt.reach > w.reach && (w.reach = pt.reach);
                }
              }
            }
          }
        }
    }
    function p() {
      var b = { value: null, prev: null, next: null }, C = { value: null, prev: b, next: null };
      b.next = C, this.head = b, this.tail = C, this.length = 0;
    }
    function f(b, C, T) {
      var z = C.next, I = { value: T, prev: C, next: z };
      return C.next = I, z.prev = I, b.length++, I;
    }
    function m(b, C, T) {
      for (var z = C.next, I = 0; I < T && z !== b.tail; I++)
        z = z.next;
      C.next = z, z.prev = C, b.length -= I;
    }
    function y(b) {
      for (var C = [], T = b.head.next; T !== b.tail; )
        C.push(T.value), T = T.next;
      return C;
    }
    if (!r.document)
      return r.addEventListener && (s.disableWorkerMessageHandler || r.addEventListener("message", function(b) {
        var C = JSON.parse(b.data), T = C.language, z = C.code, I = C.immediateClose;
        r.postMessage(s.highlight(z, s.languages[T], T)), I && r.close();
      }, !1)), s;
    var g = s.util.currentScript();
    g && (s.filename = g.src, g.hasAttribute("data-manual") && (s.manual = !0));
    function x() {
      s.manual || s.highlightAll();
    }
    if (!s.manual) {
      var E = document.readyState;
      E === "loading" || E === "interactive" && g && g.defer ? document.addEventListener("DOMContentLoaded", x) : window.requestAnimationFrame ? window.requestAnimationFrame(x) : window.setTimeout(x, 16);
    }
    return s;
  }(t);
  e.exports && (e.exports = n);
})(uL);
var Rpe = uL.exports, h3, lC;
function cL() {
  if (lC) return h3;
  lC = 1, h3 = e, e.displayName = "markup", e.aliases = ["html", "mathml", "svg", "xml", "ssml", "atom", "rss"];
  function e(t) {
    t.languages.markup = {
      comment: {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: !0
      },
      prolog: {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: !0
      },
      doctype: {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: !0,
        inside: {
          "internal-subset": {
            pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
            lookbehind: !0,
            greedy: !0,
            inside: null
            // see below
          },
          string: {
            pattern: /"[^"]*"|'[^']*'/,
            greedy: !0
          },
          punctuation: /^<!|>$|[[\]]/,
          "doctype-tag": /^DOCTYPE/i,
          name: /[^\s<>'"]+/
        }
      },
      cdata: {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: !0
      },
      tag: {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: !0,
        inside: {
          tag: {
            pattern: /^<\/?[^\s>\/]+/,
            inside: {
              punctuation: /^<\/?/,
              namespace: /^[^\s>\/:]+:/
            }
          },
          "special-attr": [],
          "attr-value": {
            pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
            inside: {
              punctuation: [
                {
                  pattern: /^=/,
                  alias: "attr-equals"
                },
                /"|'/
              ]
            }
          },
          punctuation: /\/?>/,
          "attr-name": {
            pattern: /[^\s>\/]+/,
            inside: {
              namespace: /^[^\s>\/:]+:/
            }
          }
        }
      },
      entity: [
        {
          pattern: /&[\da-z]{1,8};/i,
          alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
      ]
    }, t.languages.markup.tag.inside["attr-value"].inside.entity = t.languages.markup.entity, t.languages.markup.doctype.inside["internal-subset"].inside = t.languages.markup, t.hooks.add("wrap", function(n) {
      n.type === "entity" && (n.attributes.title = n.content.value.replace(/&amp;/, "&"));
    }), Object.defineProperty(t.languages.markup.tag, "addInlined", {
      /**
       * Adds an inlined language to markup.
       *
       * An example of an inlined language is CSS with `<style>` tags.
       *
       * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
       * case insensitive.
       * @param {string} lang The language key.
       * @example
       * addInlined('style', 'css');
       */
      value: function(n, r) {
        var i = {};
        i["language-" + r] = {
          pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
          lookbehind: !0,
          inside: t.languages[r]
        }, i.cdata = /^<!\[CDATA\[|\]\]>$/i;
        var o = {
          "included-cdata": {
            pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
            inside: i
          }
        };
        o["language-" + r] = {
          pattern: /[\s\S]+/,
          inside: t.languages[r]
        };
        var a = {};
        a[n] = {
          pattern: RegExp(
            /(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(
              /__/g,
              function() {
                return n;
              }
            ),
            "i"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: o
        }, t.languages.insertBefore("markup", "cdata", a);
      }
    }), Object.defineProperty(t.languages.markup.tag, "addAttribute", {
      /**
       * Adds an pattern to highlight languages embedded in HTML attributes.
       *
       * An example of an inlined language is CSS with `style` attributes.
       *
       * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
       * case insensitive.
       * @param {string} lang The language key.
       * @example
       * addAttribute('style', 'css');
       */
      value: function(n, r) {
        t.languages.markup.tag.inside["special-attr"].push({
          pattern: RegExp(
            /(^|["'\s])/.source + "(?:" + n + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
            "i"
          ),
          lookbehind: !0,
          inside: {
            "attr-name": /^[^\s=]+/,
            "attr-value": {
              pattern: /=[\s\S]+/,
              inside: {
                value: {
                  pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                  lookbehind: !0,
                  alias: [r, "language-" + r],
                  inside: t.languages[r]
                },
                punctuation: [
                  {
                    pattern: /^=/,
                    alias: "attr-equals"
                  },
                  /"|'/
                ]
              }
            }
          }
        });
      }
    }), t.languages.html = t.languages.markup, t.languages.mathml = t.languages.markup, t.languages.svg = t.languages.markup, t.languages.xml = t.languages.extend("markup", {}), t.languages.ssml = t.languages.xml, t.languages.atom = t.languages.xml, t.languages.rss = t.languages.xml;
  }
  return h3;
}
var m3, uC;
function dL() {
  if (uC) return m3;
  uC = 1, m3 = e, e.displayName = "css", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
      n.languages.css = {
        comment: /\/\*[\s\S]*?\*\//,
        atrule: {
          pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
          inside: {
            rule: /^@[\w-]+/,
            "selector-function-argument": {
              pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
              lookbehind: !0,
              alias: "selector"
            },
            keyword: {
              pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
              lookbehind: !0
            }
            // See rest below
          }
        },
        url: {
          // https://drafts.csswg.org/css-values-3/#urls
          pattern: RegExp(
            "\\burl\\((?:" + r.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)",
            "i"
          ),
          greedy: !0,
          inside: {
            function: /^url/i,
            punctuation: /^\(|\)$/,
            string: {
              pattern: RegExp("^" + r.source + "$"),
              alias: "url"
            }
          }
        },
        selector: {
          pattern: RegExp(
            `(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + r.source + ")*(?=\\s*\\{)"
          ),
          lookbehind: !0
        },
        string: {
          pattern: r,
          greedy: !0
        },
        property: {
          pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
          lookbehind: !0
        },
        important: /!important\b/i,
        function: {
          pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
          lookbehind: !0
        },
        punctuation: /[(){};:,]/
      }, n.languages.css.atrule.inside.rest = n.languages.css;
      var i = n.languages.markup;
      i && (i.tag.addInlined("style", "css"), i.tag.addAttribute("style", "css"));
    })(t);
  }
  return m3;
}
var Ppe = r8;
r8.displayName = "clike";
r8.aliases = [];
function r8(e) {
  e.languages.clike = {
    comment: [
      {
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: !0,
        greedy: !0
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
      lookbehind: !0,
      inside: {
        punctuation: /[.\\]/
      }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
  };
}
var g3, cC;
function pL() {
  if (cC) return g3;
  cC = 1, g3 = e, e.displayName = "javascript", e.aliases = ["js"];
  function e(t) {
    t.languages.javascript = t.languages.extend("clike", {
      "class-name": [
        t.languages.clike["class-name"],
        {
          pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
          lookbehind: !0
        }
      ],
      keyword: [
        {
          pattern: /((?:^|\})\s*)catch\b/,
          lookbehind: !0
        },
        {
          pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
          lookbehind: !0
        }
      ],
      // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
      function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
      number: {
        pattern: RegExp(
          /(^|[^\w$])/.source + "(?:" + // constant
          (/NaN|Infinity/.source + "|" + // binary integer
          /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
          /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
          /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
          /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
          /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
        ),
        lookbehind: !0
      },
      operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
    }), t.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, t.languages.insertBefore("javascript", "keyword", {
      regex: {
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          "regex-source": {
            pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
            lookbehind: !0,
            alias: "language-regex",
            inside: t.languages.regex
          },
          "regex-delimiter": /^\/|\/$/,
          "regex-flags": /^[a-z]+$/
        }
      },
      // This must be declared before keyword because we use "function" inside the look-forward
      "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
      },
      parameter: [
        {
          pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
          lookbehind: !0,
          inside: t.languages.javascript
        },
        {
          pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
          lookbehind: !0,
          inside: t.languages.javascript
        },
        {
          pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
          lookbehind: !0,
          inside: t.languages.javascript
        },
        {
          pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
          lookbehind: !0,
          inside: t.languages.javascript
        }
      ],
      constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
    }), t.languages.insertBefore("javascript", "string", {
      hashbang: {
        pattern: /^#!.*/,
        greedy: !0,
        alias: "comment"
      },
      "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: !0,
        inside: {
          "template-punctuation": {
            pattern: /^`|`$/,
            alias: "string"
          },
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
            lookbehind: !0,
            inside: {
              "interpolation-punctuation": {
                pattern: /^\$\{|\}$/,
                alias: "punctuation"
              },
              rest: t.languages.javascript
            }
          },
          string: /[\s\S]+/
        }
      },
      "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      }
    }), t.languages.insertBefore("javascript", "operator", {
      "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: !0,
        alias: "property"
      }
    }), t.languages.markup && (t.languages.markup.tag.addInlined("script", "javascript"), t.languages.markup.tag.addAttribute(
      /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
      "javascript"
    )), t.languages.js = t.languages.javascript;
  }
  return g3;
}
var dC = {}, ap = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof dC == "object" ? dC : {}, _pe = nfe();
ap.Prism = { manual: !0, disableWorkerMessageHandler: !0 };
var qpe = o0e, $pe = wpe, fL = Rpe, Hpe = cL(), Vpe = dL(), Upe = Ppe, Wpe = pL();
_pe();
var i8 = {}.hasOwnProperty;
function hL() {
}
hL.prototype = fL;
var Fr = new hL(), Zpe = Fr;
Fr.highlight = Kpe;
Fr.register = Wf;
Fr.alias = Gpe;
Fr.registered = Xpe;
Fr.listLanguages = Qpe;
Wf(Hpe);
Wf(Vpe);
Wf(Upe);
Wf(Wpe);
Fr.util.encode = efe;
Fr.Token.stringify = Ype;
function Wf(e) {
  if (typeof e != "function" || !e.displayName)
    throw new Error("Expected `function` for `grammar`, got `" + e + "`");
  Fr.languages[e.displayName] === void 0 && e(Fr);
}
function Gpe(e, t) {
  var n = Fr.languages, r = e, i, o, a, s;
  t && (r = {}, r[e] = t);
  for (i in r)
    for (o = r[i], o = typeof o == "string" ? [o] : o, a = o.length, s = -1; ++s < a; )
      n[o[s]] = n[i];
}
function Kpe(e, t) {
  var n = fL.highlight, r;
  if (typeof e != "string")
    throw new Error("Expected `string` for `value`, got `" + e + "`");
  if (Fr.util.type(t) === "Object")
    r = t, t = null;
  else {
    if (typeof t != "string")
      throw new Error("Expected `string` for `name`, got `" + t + "`");
    if (i8.call(Fr.languages, t))
      r = Fr.languages[t];
    else
      throw new Error("Unknown language: `" + t + "` is not registered");
  }
  return n.call(this, e, r, t);
}
function Xpe(e) {
  if (typeof e != "string")
    throw new Error("Expected `string` for `language`, got `" + e + "`");
  return i8.call(Fr.languages, e);
}
function Qpe() {
  var e = Fr.languages, t = [], n;
  for (n in e)
    i8.call(e, n) && typeof e[n] == "object" && t.push(n);
  return t;
}
function Ype(e, t, n) {
  var r;
  return typeof e == "string" ? { type: "text", value: e } : Fr.util.type(e) === "Array" ? Jpe(e, t) : (r = {
    type: e.type,
    content: Fr.Token.stringify(e.content, t, n),
    tag: "span",
    classes: ["token", e.type],
    attributes: {},
    language: t,
    parent: n
  }, e.alias && (r.classes = r.classes.concat(e.alias)), Fr.hooks.run("wrap", r), qpe(
    r.tag + "." + r.classes.join("."),
    tfe(r.attributes),
    r.content
  ));
}
function Jpe(e, t) {
  for (var n = [], r = e.length, i = -1, o; ++i < r; )
    o = e[i], o !== "" && o !== null && o !== void 0 && n.push(o);
  for (i = -1, r = n.length; ++i < r; )
    o = n[i], n[i] = Fr.Token.stringify(o, t, n);
  return n;
}
function efe(e) {
  return e;
}
function tfe(e) {
  var t;
  for (t in e)
    e[t] = $pe(e[t]);
  return e;
}
function nfe() {
  var e = "Prism" in ap, t = e ? ap.Prism : void 0;
  return n;
  function n() {
    e ? ap.Prism = t : delete ap.Prism, e = void 0, t = void 0;
  }
}
const o8 = /* @__PURE__ */ wi(Zpe);
var wa = que(o8, {});
wa.registerLanguage = function(e, t) {
  return o8.register(t);
};
wa.alias = function(e, t) {
  return o8.alias(e, t);
};
var v3, pC;
function rfe() {
  if (pC) return v3;
  pC = 1, v3 = e, e.displayName = "sql", e.aliases = [];
  function e(t) {
    t.languages.sql = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: !0
      },
      variable: [
        {
          pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
          greedy: !0
        },
        /@[\w.$]+/
      ],
      string: {
        pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
        greedy: !0,
        lookbehind: !0
      },
      identifier: {
        pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
        greedy: !0,
        lookbehind: !0,
        inside: {
          punctuation: /^`|`$/
        }
      },
      function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
      // Should we highlight user defined functions too?
      keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
      boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
      number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
      operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
      punctuation: /[;[\]()`,.]/
    };
  }
  return v3;
}
var y3, fC;
function ife() {
  if (fC) return y3;
  fC = 1, y3 = e, e.displayName = "c", e.aliases = [];
  function e(t) {
    t.languages.c = t.languages.extend("clike", {
      comment: {
        pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: !0
      },
      string: {
        // https://en.cppreference.com/w/c/language/string_literal
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
        lookbehind: !0
      },
      keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
      operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
    }), t.languages.insertBefore("c", "string", {
      char: {
        // https://en.cppreference.com/w/c/language/character_constant
        pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
        greedy: !0
      }
    }), t.languages.insertBefore("c", "string", {
      macro: {
        // allow for multiline macro definitions
        // spaces after the # character compile fine with gcc
        pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: !0,
        greedy: !0,
        alias: "property",
        inside: {
          string: [
            {
              // highlight the path of the include statement as a string
              pattern: /^(#\s*include\s*)<[^>]+>/,
              lookbehind: !0
            },
            t.languages.c.string
          ],
          char: t.languages.c.char,
          comment: t.languages.c.comment,
          "macro-name": [
            {
              pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
              lookbehind: !0
            },
            {
              pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
              lookbehind: !0,
              alias: "function"
            }
          ],
          // highlight macro directives as keywords
          directive: {
            pattern: /^(#\s*)[a-z]+/,
            lookbehind: !0,
            alias: "keyword"
          },
          "directive-hash": /^#/,
          punctuation: /##|\\(?=[\r\n])/,
          expression: {
            pattern: /\S[\s\S]*/,
            inside: t.languages.c
          }
        }
      }
    }), t.languages.insertBefore("c", "function", {
      // highlight predefined macros as constants
      constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
    }), delete t.languages.c.boolean;
  }
  return y3;
}
var x3, hC;
function ofe() {
  if (hC) return x3;
  hC = 1, x3 = e, e.displayName = "bash", e.aliases = ["shell"];
  function e(t) {
    (function(n) {
      var r = "\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b", i = {
        pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
        lookbehind: !0,
        alias: "punctuation",
        // this looks reasonably well in all themes
        inside: null
        // see below
      }, o = {
        bash: i,
        environment: {
          pattern: RegExp("\\$" + r),
          alias: "constant"
        },
        variable: [
          // [0]: Arithmetic Environment
          {
            pattern: /\$?\(\([\s\S]+?\)\)/,
            greedy: !0,
            inside: {
              // If there is a $ sign at the beginning highlight $(( and )) as variable
              variable: [
                {
                  pattern: /(^\$\(\([\s\S]+)\)\)/,
                  lookbehind: !0
                },
                /^\$\(\(/
              ],
              number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
              // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
              operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
              // If there is no $ sign at the beginning highlight (( and )) as punctuation
              punctuation: /\(\(?|\)\)?|,|;/
            }
          },
          // [1]: Command Substitution
          {
            pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
            greedy: !0,
            inside: {
              variable: /^\$\(|^`|\)$|`$/
            }
          },
          // [2]: Brace expansion
          {
            pattern: /\$\{[^}]+\}/,
            greedy: !0,
            inside: {
              operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
              punctuation: /[\[\]]/,
              environment: {
                pattern: RegExp("(\\{)" + r),
                lookbehind: !0,
                alias: "constant"
              }
            }
          },
          /\$(?:\w+|[#?*!@$])/
        ],
        // Escape sequences from echo and printf's manuals, and escaped quotes.
        entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
      };
      n.languages.bash = {
        shebang: {
          pattern: /^#!\s*\/.*/,
          alias: "important"
        },
        comment: {
          pattern: /(^|[^"{\\$])#.*/,
          lookbehind: !0
        },
        "function-name": [
          // a) function foo {
          // b) foo() {
          // c) function foo() {
          // but not “foo {”
          {
            // a) and c)
            pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
            lookbehind: !0,
            alias: "function"
          },
          {
            // b)
            pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
            alias: "function"
          }
        ],
        // Highlight variable names as variables in for and select beginnings.
        "for-or-select": {
          pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
          alias: "variable",
          lookbehind: !0
        },
        // Highlight variable names as variables in the left-hand part
        // of assignments (“=” and “+=”).
        "assign-left": {
          pattern: /(^|[\s;|&]|[<>]\()\w+(?=\+?=)/,
          inside: {
            environment: {
              pattern: RegExp("(^|[\\s;|&]|[<>]\\()" + r),
              lookbehind: !0,
              alias: "constant"
            }
          },
          alias: "variable",
          lookbehind: !0
        },
        string: [
          // Support for Here-documents https://en.wikipedia.org/wiki/Here_document
          {
            pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
            lookbehind: !0,
            greedy: !0,
            inside: o
          },
          // Here-document with quotes around the tag
          // → No expansion (so no “inside”).
          {
            pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
            lookbehind: !0,
            greedy: !0,
            inside: {
              bash: i
            }
          },
          // “Normal” string
          {
            // https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
            pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
            lookbehind: !0,
            greedy: !0,
            inside: o
          },
          {
            // https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
            pattern: /(^|[^$\\])'[^']*'/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
            pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
            greedy: !0,
            inside: {
              entity: o.entity
            }
          }
        ],
        environment: {
          pattern: RegExp("\\$?" + r),
          alias: "constant"
        },
        variable: o.variable,
        function: {
          pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
          lookbehind: !0
        },
        keyword: {
          pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
          lookbehind: !0
        },
        // https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
        builtin: {
          pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
          lookbehind: !0,
          // Alias added to make those easier to distinguish from strings.
          alias: "class-name"
        },
        boolean: {
          pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
          lookbehind: !0
        },
        "file-descriptor": {
          pattern: /\B&\d\b/,
          alias: "important"
        },
        operator: {
          // Lots of redirections here, but not just that.
          pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
          inside: {
            "file-descriptor": {
              pattern: /^\d/,
              alias: "important"
            }
          }
        },
        punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
        number: {
          pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
          lookbehind: !0
        }
      }, i.inside = n.languages.bash;
      for (var a = [
        "comment",
        "function-name",
        "for-or-select",
        "assign-left",
        "string",
        "environment",
        "function",
        "keyword",
        "builtin",
        "boolean",
        "file-descriptor",
        "operator",
        "punctuation",
        "number"
      ], s = o.variable[1].inside, l = 0; l < a.length; l++)
        s[a[l]] = n.languages.bash[a[l]];
      n.languages.shell = n.languages.bash;
    })(t);
  }
  return x3;
}
var b3, mC;
function afe() {
  if (mC) return b3;
  mC = 1, b3 = e, e.displayName = "java", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/, i = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, o = {
        pattern: RegExp(i + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
        lookbehind: !0,
        inside: {
          namespace: {
            pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
            inside: {
              punctuation: /\./
            }
          },
          punctuation: /\./
        }
      };
      n.languages.java = n.languages.extend("clike", {
        string: {
          pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
          lookbehind: !0,
          greedy: !0
        },
        "class-name": [
          o,
          {
            // variables and parameters
            // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
            pattern: RegExp(
              i + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source
            ),
            lookbehind: !0,
            inside: o.inside
          }
        ],
        keyword: r,
        function: [
          n.languages.clike.function,
          {
            pattern: /(::\s*)[a-z_]\w*/,
            lookbehind: !0
          }
        ],
        number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
        operator: {
          pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
          lookbehind: !0
        }
      }), n.languages.insertBefore("java", "string", {
        "triple-quoted-string": {
          // http://openjdk.java.net/jeps/355#Description
          pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
          greedy: !0,
          alias: "string"
        },
        char: {
          pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
          greedy: !0
        }
      }), n.languages.insertBefore("java", "class-name", {
        annotation: {
          pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
          lookbehind: !0,
          alias: "punctuation"
        },
        generics: {
          pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
          inside: {
            "class-name": o,
            keyword: r,
            punctuation: /[<>(),.:]/,
            operator: /[?&|]/
          }
        },
        namespace: {
          pattern: RegExp(
            /(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(
              /<keyword>/g,
              function() {
                return r.source;
              }
            )
          ),
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        }
      });
    })(t);
  }
  return b3;
}
var w3, gC;
function sfe() {
  if (gC) return w3;
  gC = 1, w3 = e, e.displayName = "latex", e.aliases = ["tex", "context"];
  function e(t) {
    (function(n) {
      var r = /\\(?:[^a-z()[\]]|[a-z*]+)/i, i = {
        "equation-command": {
          pattern: r,
          alias: "regex"
        }
      };
      n.languages.latex = {
        comment: /%.*/,
        // the verbatim environment prints whitespace to the document
        cdata: {
          pattern: /(\\begin\{((?:lstlisting|verbatim)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
          lookbehind: !0
        },
        /*
         * equations can be between $$ $$ or $ $ or \( \) or \[ \]
         * (all are multiline)
         */
        equation: [
          {
            pattern: /\$\$(?:\\[\s\S]|[^\\$])+\$\$|\$(?:\\[\s\S]|[^\\$])+\$|\\\([\s\S]*?\\\)|\\\[[\s\S]*?\\\]/,
            inside: i,
            alias: "string"
          },
          {
            pattern: /(\\begin\{((?:align|eqnarray|equation|gather|math|multline)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
            lookbehind: !0,
            inside: i,
            alias: "string"
          }
        ],
        /*
         * arguments which are keywords or references are highlighted
         * as keywords
         */
        keyword: {
          pattern: /(\\(?:begin|cite|documentclass|end|label|ref|usepackage)(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
          lookbehind: !0
        },
        url: {
          pattern: /(\\url\{)[^}]+(?=\})/,
          lookbehind: !0
        },
        /*
         * section or chapter headlines are highlighted as bold so that
         * they stand out more
         */
        headline: {
          pattern: /(\\(?:chapter|frametitle|paragraph|part|section|subparagraph|subsection|subsubparagraph|subsubsection|subsubsubparagraph)\*?(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
          lookbehind: !0,
          alias: "class-name"
        },
        function: {
          pattern: r,
          alias: "selector"
        },
        punctuation: /[[\]{}&]/
      }, n.languages.tex = n.languages.latex, n.languages.context = n.languages.latex;
    })(t);
  }
  return w3;
}
var C3, vC;
function lfe() {
  if (vC) return C3;
  vC = 1, C3 = e, e.displayName = "python", e.aliases = ["py"];
  function e(t) {
    t.languages.python = {
      comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: !0,
        greedy: !0
      },
      "string-interpolation": {
        pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
        greedy: !0,
        inside: {
          interpolation: {
            // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
            pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
            lookbehind: !0,
            inside: {
              "format-spec": {
                pattern: /(:)[^:(){}]+(?=\}$)/,
                lookbehind: !0
              },
              "conversion-option": {
                pattern: /![sra](?=[:}]$)/,
                alias: "punctuation"
              },
              rest: null
            }
          },
          string: /[\s\S]+/
        }
      },
      "triple-quoted-string": {
        pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
        greedy: !0,
        alias: "string"
      },
      string: {
        pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
        greedy: !0
      },
      function: {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
        lookbehind: !0
      },
      "class-name": {
        pattern: /(\bclass\s+)\w+/i,
        lookbehind: !0
      },
      decorator: {
        pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
        lookbehind: !0,
        alias: ["annotation", "punctuation"],
        inside: {
          punctuation: /\./
        }
      },
      keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
      builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
      boolean: /\b(?:False|None|True)\b/,
      number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
      operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
      punctuation: /[{}[\];(),.:]/
    }, t.languages.python["string-interpolation"].inside.interpolation.inside.rest = t.languages.python, t.languages.py = t.languages.python;
  }
  return C3;
}
var mL = {}, gL = { exports: {} };
(function(e) {
  function t(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(gL);
var xl = gL.exports;
(function(e) {
  var t = xl;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = t(ofe());
  e.default = n.default;
})(mL);
const ufe = /* @__PURE__ */ wi(mL);
var vL = {};
(function(e) {
  var t = xl;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = t(ife());
  e.default = n.default;
})(vL);
const cfe = /* @__PURE__ */ wi(vL);
var yL = {};
(function(e) {
  var t = xl;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = t(dL());
  e.default = n.default;
})(yL);
const dfe = /* @__PURE__ */ wi(yL);
var xL = {};
(function(e) {
  var t = xl;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = t(afe());
  e.default = n.default;
})(xL);
const pfe = /* @__PURE__ */ wi(xL);
var bL = {};
(function(e) {
  var t = xl;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = t(pL());
  e.default = n.default;
})(bL);
const ffe = /* @__PURE__ */ wi(bL);
var wL = {};
(function(e) {
  var t = xl;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = t(sfe());
  e.default = n.default;
})(wL);
const hfe = /* @__PURE__ */ wi(wL);
var CL = {};
(function(e) {
  var t = xl;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = t(cL());
  e.default = n.default;
})(CL);
const mfe = /* @__PURE__ */ wi(CL);
var kL = {};
(function(e) {
  var t = xl;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = t(lfe());
  e.default = n.default;
})(kL);
const gfe = /* @__PURE__ */ wi(kL);
var EL = {};
(function(e) {
  var t = xl;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = t(rfe());
  e.default = n.default;
})(EL);
const vfe = /* @__PURE__ */ wi(EL);
var SL = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0, e.default = {
    'code[class*="language-"]': {
      color: "black",
      background: "none",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      maxHeight: "inherit",
      height: "inherit",
      padding: "0 1em",
      display: "block",
      overflow: "auto"
    },
    'pre[class*="language-"]': {
      color: "black",
      background: "none",
      fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      fontSize: "1em",
      textAlign: "left",
      whiteSpace: "pre",
      wordSpacing: "normal",
      wordBreak: "normal",
      wordWrap: "normal",
      lineHeight: "1.5",
      MozTabSize: "4",
      OTabSize: "4",
      tabSize: "4",
      WebkitHyphens: "none",
      MozHyphens: "none",
      msHyphens: "none",
      hyphens: "none",
      position: "relative",
      margin: ".5em 0",
      overflow: "visible",
      padding: "1px",
      backgroundColor: "#fdfdfd",
      WebkitBoxSizing: "border-box",
      MozBoxSizing: "border-box",
      boxSizing: "border-box",
      marginBottom: "1em"
    },
    'pre[class*="language-"] > code': {
      position: "relative",
      zIndex: "1",
      borderLeft: "10px solid #358ccb",
      boxShadow: "-1px 0px 0px 0px #358ccb, 0px 0px 0px 1px #dfdfdf",
      backgroundColor: "#fdfdfd",
      backgroundImage: "linear-gradient(transparent 50%, rgba(69, 142, 209, 0.04) 50%)",
      backgroundSize: "3em 3em",
      backgroundOrigin: "content-box",
      backgroundAttachment: "local"
    },
    ':not(pre) > code[class*="language-"]': {
      backgroundColor: "#fdfdfd",
      WebkitBoxSizing: "border-box",
      MozBoxSizing: "border-box",
      boxSizing: "border-box",
      marginBottom: "1em",
      position: "relative",
      padding: ".2em",
      borderRadius: "0.3em",
      color: "#c92c2c",
      border: "1px solid rgba(0, 0, 0, 0.1)",
      display: "inline",
      whiteSpace: "normal"
    },
    'pre[class*="language-"]:before': {
      content: "''",
      display: "block",
      position: "absolute",
      bottom: "0.75em",
      left: "0.18em",
      width: "40%",
      height: "20%",
      maxHeight: "13em",
      boxShadow: "0px 13px 8px #979797",
      WebkitTransform: "rotate(-2deg)",
      MozTransform: "rotate(-2deg)",
      msTransform: "rotate(-2deg)",
      OTransform: "rotate(-2deg)",
      transform: "rotate(-2deg)"
    },
    'pre[class*="language-"]:after': {
      content: "''",
      display: "block",
      position: "absolute",
      bottom: "0.75em",
      left: "auto",
      width: "40%",
      height: "20%",
      maxHeight: "13em",
      boxShadow: "0px 13px 8px #979797",
      WebkitTransform: "rotate(2deg)",
      MozTransform: "rotate(2deg)",
      msTransform: "rotate(2deg)",
      OTransform: "rotate(2deg)",
      transform: "rotate(2deg)",
      right: "0.75em"
    },
    comment: {
      color: "#7D8B99"
    },
    "block-comment": {
      color: "#7D8B99"
    },
    prolog: {
      color: "#7D8B99"
    },
    doctype: {
      color: "#7D8B99"
    },
    cdata: {
      color: "#7D8B99"
    },
    punctuation: {
      color: "#5F6364"
    },
    property: {
      color: "#c92c2c"
    },
    tag: {
      color: "#c92c2c"
    },
    boolean: {
      color: "#c92c2c"
    },
    number: {
      color: "#c92c2c"
    },
    "function-name": {
      color: "#c92c2c"
    },
    constant: {
      color: "#c92c2c"
    },
    symbol: {
      color: "#c92c2c"
    },
    deleted: {
      color: "#c92c2c"
    },
    selector: {
      color: "#2f9c0a"
    },
    "attr-name": {
      color: "#2f9c0a"
    },
    string: {
      color: "#2f9c0a"
    },
    char: {
      color: "#2f9c0a"
    },
    function: {
      color: "#2f9c0a"
    },
    builtin: {
      color: "#2f9c0a"
    },
    inserted: {
      color: "#2f9c0a"
    },
    operator: {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)"
    },
    entity: {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)",
      cursor: "help"
    },
    url: {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)"
    },
    variable: {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)"
    },
    atrule: {
      color: "#1990b8"
    },
    "attr-value": {
      color: "#1990b8"
    },
    keyword: {
      color: "#1990b8"
    },
    "class-name": {
      color: "#1990b8"
    },
    regex: {
      color: "#e90"
    },
    important: {
      color: "#e90",
      fontWeight: "normal"
    },
    ".language-css .token.string": {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)"
    },
    ".style .token.string": {
      color: "#a67f59",
      background: "rgba(255, 255, 255, 0.5)"
    },
    bold: {
      fontWeight: "bold"
    },
    italic: {
      fontStyle: "italic"
    },
    namespace: {
      Opacity: ".7"
    },
    'pre[class*="language-"].line-numbers.line-numbers': {
      paddingLeft: "0"
    },
    'pre[class*="language-"].line-numbers.line-numbers code': {
      paddingLeft: "3.8em"
    },
    'pre[class*="language-"].line-numbers.line-numbers .line-numbers-rows': {
      left: "0"
    },
    'pre[class*="language-"][data-line]': {
      paddingTop: "0",
      paddingBottom: "0",
      paddingLeft: "0"
    },
    "pre[data-line] code": {
      position: "relative",
      paddingLeft: "4em"
    },
    "pre .line-highlight": {
      marginTop: "0"
    }
  };
})(SL);
const yfe = /* @__PURE__ */ wi(SL);
wa.registerLanguage("java", pfe);
wa.registerLanguage("javascript", ffe);
wa.registerLanguage("python", gfe);
wa.registerLanguage("css", dfe);
wa.registerLanguage("latex", hfe);
wa.registerLanguage("markup", mfe);
wa.registerLanguage("c", cfe);
wa.registerLanguage("bash", ufe);
wa.registerLanguage("sql", vfe);
function DL({
  language: e,
  showLineNumbers: t,
  code: n,
  optionalElement: r
}) {
  return /* @__PURE__ */ c.jsxs("div", { className: "mx-side overflow-auto rounded-xl border-3 border-brand-150 pt-[0.8rem]", children: [
    /* @__PURE__ */ c.jsx(
      wa,
      {
        language: e.toLowerCase(),
        showLineNumbers: t,
        style: yfe,
        customStyle: {
          backgroundColor: "transparent"
        },
        children: n
      }
    ),
    r
  ] });
}
const xfe = ln({
  code: rn(""),
  language: rn("text"),
  showLineNumbers: Z0(!1)
});
function bfe(e = {}) {
  const { Renderer: t = DL } = e;
  return {
    Component: wue,
    state: xfe,
    config: { Renderer: t }
  };
}
const wfe = (e) => /* @__PURE__ */ v.createElement("svg", { width: 84, height: 64, viewBox: "0 0 84 64", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("rect", { x: 1, y: 1, width: 58, height: 38, rx: 3, fill: "#FFF5E9" }), /* @__PURE__ */ v.createElement("rect", { x: 1, y: 1, width: 58, height: 38, rx: 3, stroke: "#57534F", strokeWidth: 2 }), /* @__PURE__ */ v.createElement("rect", { x: 10, y: 4.73633, width: 42.9282, height: 2.63846, fill: "black", fillOpacity: 0.08 }), /* @__PURE__ */ v.createElement("rect", { x: 24.2109, y: 14.375, width: 13.9823, height: 12.0498, fill: "#57534F" }), /* @__PURE__ */ v.createElement("path", { d: "M25.0443 28.625C24.5401 28.625 24.1084 28.4372 23.749 28.0615C23.3897 27.6858 23.2103 27.2348 23.2109 26.7083V13.2917C23.2109 12.7646 23.3906 12.3132 23.7499 11.9375C24.1093 11.5619 24.5407 11.3744 25.0443 11.375H37.8776C38.3818 11.375 38.8135 11.5628 39.1729 11.9385C39.5322 12.3142 39.7115 12.7652 39.7109 13.2917V26.7083C39.7109 27.2354 39.5313 27.6868 39.1719 28.0625C38.8126 28.4381 38.3812 28.6256 37.8776 28.625H25.0443ZM25.9609 24.7917H36.9609L33.5234 20L30.7734 23.8333L28.7109 20.9583L25.9609 24.7917Z", fill: "#FFD59D" }), /* @__PURE__ */ v.createElement("rect", { x: 10, y: 32.625, width: 42.9282, height: 2.63846, fill: "black", fillOpacity: 0.08 }), /* @__PURE__ */ v.createElement("rect", { x: 13, y: 13, width: 58, height: 38, rx: 3, fill: "#FFF5E9" }), /* @__PURE__ */ v.createElement("rect", { x: 13, y: 13, width: 58, height: 38, rx: 3, stroke: "#57534F", strokeWidth: 2 }), /* @__PURE__ */ v.createElement("rect", { x: 22, y: 16.7363, width: 42.9282, height: 2.63846, fill: "black", fillOpacity: 0.08 }), /* @__PURE__ */ v.createElement("rect", { x: 36.2109, y: 26.375, width: 13.9823, height: 12.0498, fill: "#57534F" }), /* @__PURE__ */ v.createElement("path", { d: "M37.0443 40.625C36.5401 40.625 36.1084 40.4372 35.749 40.0615C35.3897 39.6858 35.2103 39.2348 35.2109 38.7083V25.2917C35.2109 24.7646 35.3906 24.3132 35.7499 23.9375C36.1093 23.5619 36.5407 23.3744 37.0443 23.375H49.8776C50.3818 23.375 50.8135 23.5628 51.1729 23.9385C51.5322 24.3142 51.7115 24.7652 51.7109 25.2917V38.7083C51.7109 39.2354 51.5313 39.6868 51.1719 40.0625C50.8126 40.4381 50.3812 40.6256 49.8776 40.625H37.0443ZM37.9609 36.7917H48.9609L45.5234 32L42.7734 35.8333L40.7109 32.9583L37.9609 36.7917Z", fill: "#FFD59D" }), /* @__PURE__ */ v.createElement("rect", { x: 22, y: 44.625, width: 42.9282, height: 2.63846, fill: "black", fillOpacity: 0.08 }), /* @__PURE__ */ v.createElement("rect", { x: 25, y: 25, width: 58, height: 38, rx: 3, fill: "#FFF5E9" }), /* @__PURE__ */ v.createElement("rect", { x: 25, y: 25, width: 58, height: 38, rx: 3, stroke: "#57534F", strokeWidth: 2 }), /* @__PURE__ */ v.createElement("rect", { x: 34, y: 28.7363, width: 42.9282, height: 2.63846, fill: "black", fillOpacity: 0.08 }), /* @__PURE__ */ v.createElement("rect", { x: 48.2109, y: 38.375, width: 13.9823, height: 12.0498, fill: "#57534F" }), /* @__PURE__ */ v.createElement("path", { d: "M49.0443 52.625C48.5401 52.625 48.1084 52.4372 47.749 52.0615C47.3897 51.6858 47.2103 51.2348 47.2109 50.7083V37.2917C47.2109 36.7646 47.3906 36.3132 47.7499 35.9375C48.1093 35.5619 48.5407 35.3744 49.0443 35.375H61.8776C62.3818 35.375 62.8135 35.5628 63.1729 35.9385C63.5322 36.3142 63.7115 36.7652 63.7109 37.2917V50.7083C63.7109 51.2354 63.5313 51.6868 63.1719 52.0625C62.8126 52.4381 62.3812 52.6256 61.8776 52.625H49.0443ZM49.9609 48.7917H60.9609L57.5234 44L54.7734 47.8333L52.7109 44.9583L49.9609 48.7917Z", fill: "#FFD59D" }), /* @__PURE__ */ v.createElement("rect", { x: 34, y: 56.625, width: 42.9282, height: 2.63846, fill: "black", fillOpacity: 0.08 }));
function Cfe(e) {
  const { onClick: t } = e, n = nt().plugins.imageGallery;
  return /* @__PURE__ */ c.jsx("div", { className: "flex rounded-md bg-yellow-50 p-8 shadow-md", children: /* @__PURE__ */ c.jsxs(
    "button",
    {
      className: "mx-auto my-8 rounded-md bg-editor-primary-100 px-16 pb-2 pt-4 hover:cursor-pointer hover:bg-editor-primary-200",
      "data-qa": "plugin-image-gallery-add-images-button",
      onClick: t,
      children: [
        /* @__PURE__ */ c.jsx(wfe, { className: "mx-auto" }),
        /* @__PURE__ */ c.jsx("div", { className: "mt-2 font-bold text-almost-black", children: n.addImages })
      ]
    }
  ) });
}
const yC = "imageGallery";
function kfe({
  index: e,
  onDrop: t,
  onClick: n,
  isLast: r
}) {
  const i = v.useRef(null), [{ isHovering: o }, a] = cd({
    accept: yC,
    collect: (u) => ({ isHovering: u.isOver() }),
    drop: (u) => t(u.index, e)
  }), [{ isDragging: s }, l] = Of({
    type: yC,
    item: { index: e },
    collect: (u) => ({ isDragging: u.isDragging() })
  });
  return l(a(i)), /* @__PURE__ */ c.jsx(
    "div",
    {
      ref: i,
      onClick: n,
      className: Le(
        "absolute inset-0 bg-[#fefefe] active:bg-opacity-60",
        s ? "cursor-grabbing bg-opacity-20" : "cursor-grab bg-opacity-0"
      ),
      children: /* @__PURE__ */ c.jsx(
        "div",
        {
          className: Le(
            "absolute bottom-0 top-0 w-1.5 bg-brand-500 transition-opacity",
            o ? "opacity-100" : "opacity-0",
            r ? "-right-2.5" : "-left-2.5"
          )
        }
      )
    }
  );
}
function xC({ dimensions: e }) {
  return { flex: `calc(${e.width} / ${e.height})` };
}
function AL({
  images: e,
  extraChildren: t,
  onImageClick: n,
  renderRemoveImageButton: r
}) {
  return /* @__PURE__ */ c.jsx("div", { children: e.map((o, a) => {
    if (a % 2 !== 0) return null;
    const s = a + 1, l = s === e.length, u = l ? void 0 : e[s];
    return /* @__PURE__ */ c.jsxs("div", { className: "mb-4 flex gap-4", children: [
      /* @__PURE__ */ c.jsxs(
        "div",
        {
          className: Le("group relative", l && "mx-auto"),
          style: l ? {} : xC(o),
          children: [
            /* @__PURE__ */ c.jsx("button", { onClick: () => n(a), children: /* @__PURE__ */ c.jsx(
              sl,
              {
                src: o.src,
                alt: o.alt,
                className: Le(l && "max-h-96")
              }
            ) }),
            t == null ? void 0 : t[a],
            i(o.caption, a)
          ]
        }
      ),
      u ? /* @__PURE__ */ c.jsxs("div", { className: "group relative", style: xC(u), children: [
        /* @__PURE__ */ c.jsx("button", { onClick: () => n(s), children: /* @__PURE__ */ c.jsx(
          sl,
          {
            src: u.src,
            alt: `Image ${u.src}`
          }
        ) }),
        t == null ? void 0 : t[s],
        i(u.caption, s)
      ] }) : null
    ] }, a + o.src);
  }) });
  function i(o, a) {
    return /* @__PURE__ */ c.jsxs(
      "div",
      {
        className: Le(
          "absolute inset-0 flex items-end justify-center p-3 italic text-white",
          "pointer-events-none opacity-0 transition-opacity duration-100 group-hover:opacity-100",
          o && "bg-gradient-to-b from-transparent via-[rgba(0,0,0,0.15)] via-70% to-[rgba(0,0,0,0.8)] to-85%"
        ),
        children: [
          o ? /* @__PURE__ */ c.jsx("div", { className: "pointer-events-auto text-center [&_a]:text-brand-400", children: o }) : null,
          r == null ? void 0 : r(a)
        ]
      }
    );
  }
}
const i1 = "flex items-center justify-center h-40 animate-pulse bg-gray-300";
function Efe({ className: e }) {
  return /* @__PURE__ */ c.jsxs("div", { className: Le(e, "flex flex-wrap gap-4"), children: [
    /* @__PURE__ */ c.jsx("div", { className: `${i1} w-[calc(34%-0.5rem)]`, children: t() }),
    /* @__PURE__ */ c.jsx("div", { className: `${i1} w-[calc(66%-0.5rem)]`, children: t() }),
    /* @__PURE__ */ c.jsx("div", { className: `${i1} w-[calc(60%-0.5rem)]`, children: t() }),
    /* @__PURE__ */ c.jsx("div", { className: `${i1} w-[calc(40%-0.5rem)]`, children: t() })
  ] });
  function t() {
    return /* @__PURE__ */ c.jsx(
      "svg",
      {
        className: "h-10 w-10 text-gray-200 dark:text-gray-600",
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 20 18",
        children: /* @__PURE__ */ c.jsx("path", { d: "M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" })
      }
    );
  }
}
function Sfe({ onClick: e }) {
  return /* @__PURE__ */ c.jsx(
    "button",
    {
      className: Le(
        "pointer-events-auto absolute right-4 top-4 h-8 w-8 rounded-full p-1",
        "bg-black bg-opacity-20 text-white hover:bg-opacity-50"
      ),
      onClick: e,
      children: /* @__PURE__ */ c.jsx(ot, { icon: sj, className: "text-sm" })
    }
  );
}
async function Dfe(e) {
  if (!e) return { width: 0, height: 0 };
  const t = new Image();
  return t.src = e, await t.decode(), {
    width: t.naturalWidth,
    height: t.naturalHeight
  };
}
function Afe({
  state: e,
  onImageClick: t,
  onRemoveImageButtonClick: n
}) {
  const r = e.images.map(({ imagePlugin: u }) => u.id), i = yn(
    (u) => Kq(u, r)
  ).filter(Bf).map(
    ({ state: { src: u, caption: d, alt: p } }, f) => {
      const m = d && !io(d);
      return {
        // eslint-disable-next-line @typescript-eslint/no-base-to-string
        src: String(u),
        alt: p ?? "",
        dimensions: {
          width: e.images[f].dimensions.width.value,
          height: e.images[f].dimensions.height.value
        },
        caption: m ? /* @__PURE__ */ c.jsx(Nn, { document: d }) : null
      };
    }
  ), [o, a] = v.useState(!0);
  v.useEffect(() => {
    const u = async (d, p) => {
      const f = await Dfe(d);
      e.images[p].dimensions.width.set(f.width), e.images[p].dimensions.height.set(f.height);
    };
    i.forEach((d, p) => {
      !d.src || d.dimensions.width !== 0 || u(d.src, p);
    });
  }, [JSON.stringify(i.map(({ src: u }) => u))]), v.useEffect(() => {
    i.some((u) => u.dimensions.width === 0) || setTimeout(() => a(!1), 1e3);
  }, [i]);
  function s(u, d) {
    if (u === d) return;
    const p = e.images.length === d ? d - 1 : d;
    e.images.move(u, p);
  }
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(Efe, { className: o ? "block" : "hidden" }),
    /* @__PURE__ */ c.jsx(
      "div",
      {
        className: Le(
          "transition-opacity duration-500",
          o ? "opacity-0" : "opacity-100"
        ),
        children: /* @__PURE__ */ c.jsx(
          AL,
          {
            images: i,
            extraChildren: i.map((u, d) => /* @__PURE__ */ c.jsx(
              kfe,
              {
                onDrop: s,
                onClick: () => t(d),
                index: d,
                isLast: d === i.length - 1
              },
              d
            )),
            onImageClick: t,
            renderRemoveImageButton: l
          }
        )
      }
    )
  ] });
  function l(u) {
    return /* @__PURE__ */ c.jsx(Sfe, { onClick: () => n(u) });
  }
}
const Tfe = (e) => {
  const { id: t, onAddImagesButtonClick: n } = e, r = nt().plugins.imageGallery, i = /* @__PURE__ */ c.jsxs(
    "button",
    {
      onClick: n,
      className: Le(
        "transition-al mr-2 rounded-md border border-gray-500 px-1 text-sm",
        "hover:bg-editor-primary-200 focus-visible:bg-editor-primary-200"
      ),
      children: [
        r.addImages,
        " ",
        " +"
      ]
    }
  );
  return /* @__PURE__ */ c.jsx(
    Ci,
    {
      pluginType: Y.ImageGallery,
      pluginSettings: i,
      pluginControls: /* @__PURE__ */ c.jsx(Pi, { pluginId: t })
    }
  );
}, H5 = 6;
function bC(e) {
  return e.replace("%max_images%", H5.toString());
}
function jfe(e) {
  const { id: t, focused: n, state: r } = e, i = zn(), [o, a] = v.useState(n), [s, l] = v.useState(r.images.length > 0), [u, d] = v.useState(!1), [p, f] = v.useState(0), m = nt().plugins.imageGallery, y = si.getByType(Y.Image), g = Ur(), x = yn(
    (w) => sA(w, t)
  );
  function E() {
    if (r.images.length >= H5) {
      yi(
        bC(m.alreadyMaxImagesMessage),
        "warning"
      );
      return;
    }
    r.images.insert(r.images.length, {
      imagePlugin: { plugin: Y.Image },
      dimensions: { width: 0, height: 0 }
    }), f(r.images.length), d(!0);
  }
  function b(w) {
    var M;
    if (r.images.length + w.length > H5)
      yi(
        bC(m.tooManyImagesMessage),
        "warning"
      );
    else
      for (const R of w) {
        const F = (M = y.onFiles) == null ? void 0 : M.call(y, [R]), W = {
          plugin: Y.Image,
          state: F == null ? void 0 : F.state
        };
        r.images.insert(p, {
          imagePlugin: W,
          dimensions: { width: 0, height: 0 }
        });
      }
    l(!0), d(!1), g(Ji(t));
  }
  function C() {
    const w = r.images[p].imagePlugin.id;
    ou(i.getState(), w) && r.images.remove(p);
  }
  function T() {
    C(), d(!1);
  }
  function z(w) {
    o && (f(w), d(!0));
  }
  function I(w) {
    r.images.remove(w);
  }
  return v.useEffect(() => {
    r.images.length === 0 && l(!1);
  }, [r.images.length]), v.useEffect(() => {
    n ? setTimeout(() => a(!0), 100) : a(!1);
  }, [n]), /* @__PURE__ */ c.jsxs("div", { "data-qa": "plugin-image-gallery-wrapper", children: [
    n || x ? /* @__PURE__ */ c.jsx(
      Tfe,
      {
        id: t,
        onAddImagesButtonClick: E
      }
    ) : null,
    s ? /* @__PURE__ */ c.jsx(
      Afe,
      {
        state: r,
        onImageClick: z,
        onRemoveImageButtonClick: I
      }
    ) : /* @__PURE__ */ c.jsx(Cfe, { onClick: E }),
    /* @__PURE__ */ c.jsx(
      qo,
      {
        className: "my-6 p-0 [&_.plugin-image]:!-ml-[5px] [&_img]:max-h-[70vh]",
        extraTitleClassName: "sr-only",
        extraCloseButtonClassName: "sr-only",
        isOpen: u,
        title: m.modalScreenReaderTitle,
        setIsOpen: (w) => {
          w || T();
        },
        children: r.images.map(({ imagePlugin: w }, M) => /* @__PURE__ */ c.jsx(
          "div",
          {
            className: `-mb-6 pt-10 ${M === p ? "" : "hidden"}`,
            children: w.render({
              config: { onMultipleUpload: b }
            })
          },
          w.id
        ))
      }
    )
  ] });
}
const Nfe = {};
function Ofe() {
  return ln({
    images: $a(
      ln({
        imagePlugin: Vn({ plugin: Y.Image }),
        dimensions: ln({ width: oa(0), height: oa(0) })
      })
    )
  });
}
function zfe(e = Nfe) {
  return {
    Component: jfe,
    config: e,
    state: Ofe()
  };
}
var L0 = /* @__PURE__ */ ((e) => (e.NumberExact = "input-number-exact-match-challenge", e.ExpressionEqual = "input-expression-equal-match-challenge", e.StringNormalized = "input-string-normalized-match-challenge", e))(L0 || {});
function wC(e, t, n) {
  const r = Ffe(e);
  switch (t) {
    case L0.NumberExact:
      return CC(r).replace(/\s/g, "");
    case L0.ExpressionEqual:
      return Number(n(CC(r)));
    case L0.StringNormalized:
      return r.toUpperCase();
  }
}
function Ffe(e) {
  return e.replace(/[\s\xa0]+/g, " ").trim();
}
function CC(e) {
  return e.replace(/,/g, ".").replace(/^[+]/, "");
}
function Lfe(e, t, n, r) {
  const i = e.filter((o) => {
    try {
      const a = wC(o.value, n, r), s = wC(t, n, r);
      return !a || !s ? !1 : n === "input-expression-equal-match-challenge" && typeof a == "number" && typeof s == "number" ? a - s === 0 : a === s;
    } catch (a) {
      return console.error(a), !1;
    }
  });
  return i.length > 0 ? i[0] : void 0;
}
function Mfe({
  type: e,
  unit: t,
  answers: n,
  onEvaluate: r
}) {
  const [i, o] = v.useState(null), [a, s] = v.useState(""), l = Un().plugins.exercise, [u, d] = v.useState(null);
  v.useEffect(() => void import("./index-JJhwGXE--D5U5lyUP.js").then((f) => d(f)), []);
  function p() {
    if (!u) return;
    const f = Lfe(n, a, e, u.evaluate), m = !!(f != null && f.isCorrect), y = (f == null ? void 0 : f.feedback) ?? null;
    r(m, a), o({
      correct: m,
      message: y ?? /* @__PURE__ */ c.jsx(c.Fragment, { children: l[m ? "correct" : "wrong"] })
    });
  }
  return /* @__PURE__ */ c.jsxs("div", { className: "mx-side mb-7", children: [
    /* @__PURE__ */ c.jsx(
      "input",
      {
        className: Le(`
            serlo-input-font-reset mb-5
            rounded-3xl border-3 border-brand-400 px-3
            py-2 font-bold text-brand placeholder-brand focus:border-brand focus:bg-white
            focus:text-brand focus:placeholder-opacity-0 focus:opacity-100 focus:outline-none
            active:border-brand print:hidden
          `),
        type: "text",
        value: a,
        onChange: (f) => {
          s(f.target.value), o(null);
        },
        "data-qa": "plugin-input-exercise-input",
        onKeyDown: (f) => {
          f.key === "Enter" && p();
        },
        placeholder: l.yourAnswer
      }
    ),
    " ",
    t,
    /* @__PURE__ */ c.jsx("br", {}),
    /* @__PURE__ */ c.jsxs("div", { className: "mt-4 flex", children: [
      /* @__PURE__ */ c.jsx(
        "button",
        {
          className: Le(
            "serlo-button-learner-primary h-8",
            a === "" && "pointer-events-none opacity-0"
          ),
          onClick: p,
          children: l.check
        }
      ),
      i && a ? /* @__PURE__ */ c.jsx(Lf, { correct: i.correct, children: i.message }) : null
    ] })
  ] });
}
function TL({
  id: e,
  state: t
}) {
  const n = t.answers.map((r) => {
    var i;
    const o = !io(r.feedback), a = (i = r.feedback.state) == null ? void 0 : i[0].children;
    return {
      ...r,
      feedback: o ? /* @__PURE__ */ c.jsx(Ki, { element: a }) : null
    };
  });
  return /* @__PURE__ */ c.jsx(
    Mfe,
    {
      type: t.type,
      unit: t.unit,
      answers: n,
      onEvaluate: (r, i) => {
        var o;
        (o = ii.trigger) == null || o.call(ii, {
          pluginId: e,
          verb: "answered",
          correct: r,
          value: i,
          contentType: "input-exercise"
        });
      }
    }
  );
}
const Bfe = ({
  state: e,
  containerRef: t
}) => {
  const n = nt().templatePlugins.inputExercise;
  return /* @__PURE__ */ c.jsx(Yg, { containerRef: t, children: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      fs,
      {
        tooltipText: n.chooseType,
        value: e.type.value,
        changeValue: (r) => e.type.set(r),
        options: Object.values(L0).map((r) => ({
          value: r,
          text: n.types[r]
        }))
      }
    ),
    /* @__PURE__ */ c.jsxs("label", { className: "serlo-tooltip-trigger", children: [
      /* @__PURE__ */ c.jsx(vn, { text: n.unit }),
      /* @__PURE__ */ c.jsx(
        "input",
        {
          placeholder: n.unit,
          value: e.unit.value,
          onChange: ({ target: r }) => {
            e.unit.set(r.value);
          },
          className: Le(`
            mr-2 w-20 cursor-pointer rounded-md !border border-gray-500
          bg-editor-primary-100 px-1 py-[1px] text-sm transition-all
          hover:bg-editor-primary-200 focus:bg-editor-primary-200 focus:outline-none
          `)
        }
      )
    ] })
  ] }) });
};
function Ife(e) {
  const { state: t, id: n, focused: r } = e, { answers: i } = t, o = nt().templatePlugins.inputExercise, a = zn(), s = Ur(), l = v.useRef(null), u = Jg(), d = yn(
    (y) => li(y, n)
  );
  function p(y) {
    setTimeout(() => {
      var g;
      y && s(Ji(n)), (g = l.current) == null || g.focus();
    }, 50);
  }
  v.useEffect(() => p, []);
  const f = i.some(
    ({ feedback: y }) => y.id === Sf(a.getState())
  ), m = r || f;
  return /* @__PURE__ */ c.jsxs("div", { className: "mb-12", children: [
    /* @__PURE__ */ c.jsx(Bfe, { ...e }),
    /* @__PURE__ */ c.jsx(MF, { previewActive: u, fullOpacity: !m, children: /* @__PURE__ */ c.jsx(TL, { ...d }) }),
    !u && m ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      i.map((y, g) => {
        const x = g === i.length - 1;
        return /* @__PURE__ */ c.jsx(
          LF,
          {
            answer: /* @__PURE__ */ c.jsx(
              "input",
              {
                ref: x ? l : void 0,
                className: "width-full ml-side border-none outline-none",
                value: y.value.value,
                placeholder: o.enterTheValue,
                type: "text",
                onChange: (E) => {
                  y.value.set(E.target.value);
                }
              }
            ),
            feedback: y.feedback.render({
              config: {
                placeholder: o.feedbackPlaceholder
              }
            }),
            feedbackID: y.feedback.id,
            isActive: y.isCorrect.value,
            handleChange: () => y.isCorrect.set(!y.isCorrect.value),
            remove: () => i.remove(g)
          },
          y.feedback.id
        );
      }),
      /* @__PURE__ */ c.jsx(
        Wy,
        {
          onClick: () => {
            const y = {
              value: "",
              isCorrect: !1,
              feedback: { plugin: Y.Text }
            };
            i.insert(void 0, y), p(!0);
          },
          children: o.addAnswer
        }
      )
    ] }) : null
  ] });
}
function Rfe() {
  const e = ln({
    value: rn(""),
    isCorrect: Z0(!0),
    feedback: Vn({ plugin: Y.Text })
  });
  return ln({
    type: rn(L0.NumberExact),
    unit: rn(""),
    answers: $a(e, 1)
  });
}
function Pfe() {
  return {
    Component: Ife,
    config: {},
    state: Rfe()
  };
}
function jL({
  media: e,
  explanation: t,
  mediaWidth: n,
  extraMediaClasses: r,
  onClick: i
}) {
  const o = a();
  return /* @__PURE__ */ c.jsxs("div", { className: Le("flex rounded-xl", o.wrapper), children: [
    /* @__PURE__ */ c.jsx(
      "div",
      {
        className: Le(
          "explanation-wrapper",
          "[&_div.my-block:last-child]:mb-0 [&_div.my-block]:mt-0",
          o.explanation
        ),
        children: t
      }
    ),
    /* @__PURE__ */ c.jsx(
      "div",
      {
        onClick: i,
        className: Le(
          "media-wrapper relative",
          o.media,
          r
        ),
        children: e
      }
    )
  ] });
  function a() {
    const s = Math.round(n / 25) * 25;
    return {
      wrapper: s === 25 ? "multimedia-renderer-wrapper-quarter" : "multimedia-renderer-wrapper-half",
      explanation: s === 25 ? "mobile:basis-3/4" : "mobile:basis-2/4",
      media: s === 25 ? "mobile:basis-1/4" : "mobile:basis-2/4"
    };
  }
}
function _fe(e, t, n) {
  return Le(
    // active border style in editor
    e && "[&>div]:border-editor-primary-100",
    // when a top toolbar is shown, do not round top border (for article intro, first rows child, media child)
    `
    [&:has(.explanation-wrapper>.plugin-wrapper-container:not(.plugin-rows):focus-within)>div]:rounded-t-none
    [&:has(.explanation-wrapper_.rows-child:first-child:focus-within)>div]:rounded-t-none
    [&:has(.media-wrapper:focus-within)>div]:rounded-t-none
    `,
    // for multimedia plugin itself
    e && "[&>div]:rounded-t-none",
    // also make top border yellow
    `
    [&:has(.explanation-wrapper>.plugin-wrapper-container:not(.plugin-rows):focus-within)>div]:border-t-transparent
    [&:has(.explanation-wrapper_.rows-child:first-child:focus-within)>div]:border-t-transparent
    [&:has(.media-wrapper:focus-within)>div]:border-t-transparent
    `,
    // fix add button position
    "[&_.add-trigger]:relative [&_.add-trigger]:-left-1/4",
    // Improve toolbars for multimedia children.
    // hacky but this way the complexity is contained in the parent plugin
    // make article intro toolbar full width and well positioned
    `
    [&_.explanation-wrapper>.plugin-wrapper-container_.plugin-toolbar]:left-[9px]
    [&_.explanation-wrapper>.plugin-wrapper-container_.plugin-toolbar]:!w-[196%]
    `,
    // put top child toolbars in position of multimedia toolbar (first rows child)
    `
    [&_.explanation-wrapper_.rows-child:first-child_.plugin-toolbar]:!-top-[48px]
    [&_.explanation-wrapper_.rows-child:first-child_.plugin-toolbar]:left-[-5px]
    `,
    // properly align non-top children toolbars
    `
    [&_.explanation-wrapper_.rows-child:not(:first-child)_.plugin-toolbar]:left-[-6px]
    `,
    // properly vertically align explanation
    `
    [&_.explanation-wrapper_.plugin-rows_>_div]:mt-0
    `,
    // make multimedia explanation children left aligned
    `
    [&_.explanation-wrapper_.rows-child]:!pl-[4rem]
    [&_.explanation-wrapper_.rows-child]:!pr-[0.75rem]
    `,
    // make multimedia explanation toolbars full width
    `
    [&_.multimedia-renderer-wrapper-half_.explanation-wrapper_.rows-child_.plugin-toolbar]:!w-[209.4%]
    [&_.multimedia-renderer-wrapper-quarter_.explanation-wrapper_.rows-child_.plugin-toolbar]:!w-[137.3%]
    `,
    // adapt to borders of parent
    `
    [&_.explanation-wrapper_.rows-child:not(:first-child)_.plugin-toolbar]:!ml-[1px]
    [&_.explanation-wrapper_.rows-child:not(:first-child)_.plugin-toolbar]:!mr-0
    [&_.explanation-wrapper_.rows-child:not(:first-child)_.plugin-toolbar]:rounded-t-none
    `,
    // make media-child's toolbar full width of multimedia plugin
    // also media-wrapper needs to be relative to be clickable (is float:right)
    // but needs to be static to not restrict toolbar width
    (t || n) && "[&_.media-wrapper]:!static [&_.media-wrapper_.plugin-wrapper-container]:!static",
    // top toolbars border radius right (for article intro, first rows child, media child)
    `
    [&_.explanation-wrapper>.plugin-wrapper-container_.plugin-toolbar]:rounded-tr-none
    [&_.explanation-wrapper_.rows-child:first-child_.plugin-toolbar]:rounded-tr-none
    [&_.media-wrapper_.plugin-toolbar]:rounded-tr-none
    `
  );
}
const kC = "m-1 bg-editor-primary-200 group-hover:bg-editor-primary group-focus:bg-editor-primary rounded-sm h-20", qfe = ({
  state: e,
  percent: t
}) => /* @__PURE__ */ c.jsxs(
  "button",
  {
    onClick: (n) => {
      n.preventDefault(), e.set(t);
    },
    className: Le(
      `
        group mr-2 flex h-24 w-24 flex-row rounded-lg bg-editor-primary-100 p-1
        opacity-75 hover:bg-editor-primary-200 focus:bg-editor-primary-200
      `,
      t === e.value && "bg-editor-primary-300"
    ),
    role: "option",
    "aria-selected": t === e.value,
    "data-qa": `plugin-multimedia-size-button-${t}`,
    children: [
      /* @__PURE__ */ c.jsx("div", { className: kC, style: { width: `${100 - t}%` }, children: " " }),
      /* @__PURE__ */ c.jsx("div", { className: kC, style: { width: `${t}%` }, children: " " })
    ]
  }
), $fe = [50, 25], Hfe = ({
  state: e,
  title: t
}) => /* @__PURE__ */ c.jsxs("div", { className: "mt-8", children: [
  /* @__PURE__ */ c.jsx("b", { className: "mb-4 ml-0 mt-6 block text-lg font-bold", children: t }),
  /* @__PURE__ */ c.jsx("ul", { className: "flex pb-8", role: "listbox", children: $fe.map((n) => /* @__PURE__ */ c.jsx("li", { children: /* @__PURE__ */ c.jsx(qfe, { state: e, percent: n }) }, n)) })
] }), Vfe = ({ id: e, children: t }) => {
  const [n, r] = v.useState(!1), i = nt();
  return /* @__PURE__ */ c.jsx(
    Ci,
    {
      pluginType: Y.Multimedia,
      pluginSettings: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
        /* @__PURE__ */ c.jsxs(
          "button",
          {
            onClick: () => r(!0),
            className: "mr-2 rounded-md border border-gray-500 px-1 text-sm transition-all hover:bg-editor-primary-200 focus-visible:bg-editor-primary-200",
            "data-qa": "plugin-multimedia-settings-button",
            children: [
              i.edtrIo.settings,
              " ",
              /* @__PURE__ */ c.jsx(ot, { icon: jf })
            ]
          }
        ),
        /* @__PURE__ */ c.jsx(
          qo,
          {
            isOpen: n,
            setIsOpen: r,
            className: "top-8 max-w-xl translate-y-0 sm:top-24",
            title: `${i.edtrIo.settings}: ${i.plugins.multimedia.title}`,
            extraTitleClassName: "serlo-h3 mt-4",
            children: /* @__PURE__ */ c.jsx("div", { className: "mx-side mb-3", children: t })
          }
        )
      ] }),
      pluginControls: /* @__PURE__ */ c.jsx(Pi, { pluginId: e })
    }
  );
}, Ufe = ({
  allowedPlugins: e,
  state: t,
  stateCache: n,
  setStateCache: r
}) => {
  var i;
  const o = zn(), a = nt().plugins, s = (i = yn(
    (u) => bi(u, t.id)
  )) == null ? void 0 : i.plugin;
  return /* @__PURE__ */ c.jsxs("div", { className: "mb-8 mt-3", children: [
    /* @__PURE__ */ c.jsx("strong", { children: a.multimedia.changeType }),
    /* @__PURE__ */ c.jsx("span", { className: "mr-4", children: ":" }),
    /* @__PURE__ */ c.jsx(
      "select",
      {
        value: s ?? e[0],
        onChange: (u) => l(u.target.value),
        className: Le(`
          mr-2 cursor-pointer rounded-md !border border-gray-500
        bg-editor-primary-100 px-1 py-[1px] text-sm transition-all
        hover:bg-editor-primary-200 focus:bg-editor-primary-200 focus:outline-none
        `),
        "data-qa": "plugin-multimedia-type-select",
        children: e.map((u) => /* @__PURE__ */ c.jsx("option", { value: u, children: wp(a, u) }, u))
      }
    )
  ] });
  function l(u) {
    r((d) => {
      const p = li(o.getState(), t.id);
      return p ? {
        ...d,
        [p.plugin]: p.state
      } : d;
    }), t.replace(u, n[u]);
  }
};
function Wfe(e) {
  const [t, n] = v.useState({}), { config: r, state: i, focused: o } = e, { explanation: a, multimedia: s, width: l } = i, u = zn(), d = nt().plugins.multimedia, p = yn(
    (g) => cs(g, s.id)
  ), f = yn((g) => {
    var x;
    const E = li(g, i.multimedia.id), b = cs(g, i.multimedia.id);
    if (E.plugin !== Y.Image) return b;
    const C = (x = E.state.caption) == null ? void 0 : x.id, T = C ? cs(g, C) : !1;
    return b || T;
  }), m = v.useMemo(() => {
    const g = Eg(
      u.getState(),
      e.id
    ), x = [Y.Video, Y.Geogebra];
    return g != null && g.includes(Y.Box) ? r.allowedPlugins.filter(
      (E) => !x.includes(E)
    ) : r.allowedPlugins;
  }, []), y = _fe(
    o,
    p,
    f
  );
  return /* @__PURE__ */ c.jsxs("div", { className: "group/multimedia", "data-qa": "plugin-multimedia-wrapper", children: [
    o ? /* @__PURE__ */ c.jsxs(Vfe, { id: e.id, children: [
      /* @__PURE__ */ c.jsx(
        Hfe,
        {
          state: i.width,
          title: d.chooseSize
        }
      ),
      m.length > 1 && /* @__PURE__ */ c.jsx(
        Ufe,
        {
          allowedPlugins: m,
          state: i.multimedia,
          stateCache: t,
          setStateCache: n
        }
      )
    ] }) : /* @__PURE__ */ c.jsx(
      "button",
      {
        className: Le(`
            absolute right-0 top-[-64px] z-[22] hidden h-6 rounded-t-md bg-gray-100
            px-2 pt-0.5 text-sm font-bold
            hover:bg-editor-primary-100 group-focus-within/multimedia:block
          `),
        "data-qa": "plugin-multimedia-parent-button",
        children: d.title
      }
    ),
    /* @__PURE__ */ c.jsx("div", { className: y, children: /* @__PURE__ */ c.jsx(
      jL,
      {
        media: /* @__PURE__ */ c.jsx(c.Fragment, { children: s.render() }),
        explanation: /* @__PURE__ */ c.jsx(c.Fragment, { children: a.render() }),
        mediaWidth: l.value
      }
    ) })
  ] });
}
const Zfe = [
  Y.Image,
  Y.EdusharingAsset,
  Y.Video,
  Y.Audio,
  Y.Geogebra
], NL = {
  plugin: Y.Rows,
  config: {
    allowedPlugins: [Y.Text]
  }
};
function Gfe(e) {
  return ln({
    explanation: Vn(NL),
    multimedia: Vn({ plugin: e[0] }),
    illustrating: Z0(!0),
    width: oa(50)
    // percent
  });
}
function Kfe(e) {
  const t = Zfe.filter(
    (n) => e.includes(n)
  );
  return {
    Component: Wfe,
    config: {
      allowedPlugins: t,
      explanation: NL
    },
    state: Gfe(t)
  };
}
function Xfe({
  id: e,
  answers: t,
  renderExtraAnswerContent: n
}) {
  const [r, i] = v.useState(!1), [o, a] = v.useState(t.map(() => !1)), s = Un().plugins.exercise, l = t.filter((y) => y.isCorrect).length, u = o.filter(Boolean).length, d = t.filter(
    (y, g) => y.isCorrect && o[g]
  ).length, p = u - d, f = d === l && p === 0, m = d > 0 && !f && p === 0;
  return /* @__PURE__ */ c.jsxs("div", { className: "mx-side mb-block", children: [
    /* @__PURE__ */ c.jsx("ul", { className: "unstyled-list m-0 flex list-none flex-col flex-wrap overflow-auto p-0", children: t.map((y, g) => {
      const { key: x } = y;
      return /* @__PURE__ */ c.jsxs("li", { children: [
        /* @__PURE__ */ c.jsxs("div", { className: "flex", children: [
          /* @__PURE__ */ c.jsx(
            "input",
            {
              className: "w-0.25 opacity-0",
              id: x,
              type: "checkbox",
              checked: o[g],
              onChange: () => {
                var E;
                i(!1);
                const b = o.slice(0);
                b[g] = !b[g], a(b), (E = ii.trigger) == null || E.call(ii, {
                  pluginId: e,
                  verb: "interacted",
                  value: g,
                  contentType: "mc-exercise"
                });
              }
            }
          ),
          /* @__PURE__ */ c.jsxs(
            "label",
            {
              className: Le(
                /* we override some styles in the answer content to show it inline */
                "flex cursor-pointer items-center [&_.slate-container]:mb-0 [&_.slate-p]:ml-2"
              ),
              htmlFor: x,
              children: [
                /* @__PURE__ */ c.jsx(
                  ot,
                  {
                    icon: o[g] ? E7 : F7,
                    className: "mt-0.5 text-xl text-brand"
                  }
                ),
                y.content
              ]
            }
          )
        ] }),
        /* @__PURE__ */ c.jsx("i", { className: "block min-h-8 text-gray-600", children: r && o[g] ? /* @__PURE__ */ c.jsx("span", { className: "animate-in slide-in-from-top", children: y.feedback }) : null }),
        n ? n(y, !!y.feedback) : null
      ] }, x);
    }) }),
    /* @__PURE__ */ c.jsxs("div", { className: "mt-2 flex", children: [
      /* @__PURE__ */ c.jsx(
        "button",
        {
          "data-qa": "plugin-exercise-check-answer-button",
          className: "serlo-button-learner-primary mr-3 h-8",
          onClick: () => {
            var y;
            i(!0), (y = ii.trigger) == null || y.call(ii, {
              pluginId: e,
              verb: "answered",
              correct: f,
              // value: selected,
              contentType: "mc-exercise"
            });
          },
          children: s.check
        }
      ),
      r && /* @__PURE__ */ c.jsx(Lf, { correct: f, missedSome: m })
    ] })
  ] });
}
function Qfe({
  id: e,
  answers: t,
  renderExtraAnswerContent: n,
  isPrintMode: r
}) {
  const [i, o] = v.useState(void 0), [a, s] = v.useState(!1), l = Un().plugins.exercise;
  return /* @__PURE__ */ c.jsxs("div", { className: "mx-side mb-block", children: [
    /* @__PURE__ */ c.jsx("ul", { className: "unstyled-list m-0 flex list-none flex-col flex-wrap overflow-auto p-0", children: t.map((u, d) => {
      const p = u.key;
      return /* @__PURE__ */ c.jsxs("li", { className: "mb-block", children: [
        /* @__PURE__ */ c.jsxs("div", { className: "flex", children: [
          /* @__PURE__ */ c.jsx(
            "input",
            {
              className: "w-0.25 opacity-0",
              id: p,
              type: "radio",
              checked: i === d,
              onChange: () => {
                var f;
                s(!1), o(d), (f = ii.trigger) == null || f.call(ii, {
                  pluginId: p,
                  verb: "interacted",
                  value: d,
                  contentType: "sc-exercise"
                });
              },
              onKeyDown: (f) => {
                f.key === "Enter" && s(!0);
              }
            }
          ),
          /* @__PURE__ */ c.jsxs(
            "label",
            {
              className: Le(
                /* we override some styles in the answer content to show it inline */
                "flex cursor-pointer items-center [&_.slate-container]:mb-0 [&_.slate-p]:ml-2"
              ),
              htmlFor: p,
              children: [
                /* @__PURE__ */ c.jsx(
                  ot,
                  {
                    icon: i === d ? cT : Ug,
                    className: "mt-0.5 text-xl text-brand"
                  }
                ),
                u.content
              ]
            }
          )
        ] }),
        n ? n(u, !0) : null
      ] }, p);
    }) }),
    /* @__PURE__ */ c.jsxs("div", { className: "mt-5 flex", children: [
      /* @__PURE__ */ c.jsx(
        "button",
        {
          className: Le(
            "serlo-button-learner-primary mb-5 mr-3 h-8",
            i === void 0 && "pointer-events-none bg-transparent text-gray-400 opacity-100"
          ),
          "data-qa": "plugin-exercise-check-answer-button",
          onClick: () => {
            var u;
            s(!0), (u = ii.trigger) == null || u.call(ii, {
              pluginId: e,
              verb: "answered",
              correct: t[i ?? 0].isCorrect,
              value: i,
              contentType: "sc-exercise"
            });
          },
          children: i !== void 0 ? l.check : r ? l.printModeChooseOption : l.chooseOption
        }
      ),
      a && i !== void 0 && t[i] ? /* @__PURE__ */ c.jsx(Lf, { correct: t[i].isCorrect, children: t[i].feedback }) : null
    ] })
  ] });
}
function Yfe(e) {
  return e.isSingleChoice ? /* @__PURE__ */ c.jsx(Qfe, { ...e }) : /* @__PURE__ */ c.jsx(Xfe, { ...e });
}
function OL({
  state: e,
  id: t,
  isPrintMode: n,
  renderExtraAnswerContent: r,
  noShuffle: i
}) {
  const [o, a] = v.useState(e.answers);
  v.useEffect(() => {
    a(
      r || i ? e.answers : BO(e.answers)
    );
  }, [e.answers, r, i]);
  const s = o.slice(0).map(({ isCorrect: l, feedback: u, content: d }, p) => {
    var f;
    const m = !io(u), y = m ? (f = u.state) == null ? void 0 : f[0].children : [];
    return {
      isCorrect: l,
      feedback: m ? /* @__PURE__ */ c.jsx(Ki, { element: y }) : null,
      content: io(d) ? null : /* @__PURE__ */ c.jsx(Nn, { document: d }),
      key: d.id ?? u.id ?? `sm-mc-answer-${t}-${p}`
    };
  });
  return /* @__PURE__ */ c.jsx(v.Fragment, { children: /* @__PURE__ */ c.jsx(
    Yfe,
    {
      id: t,
      isSingleChoice: !!e.isSingleChoice,
      answers: s,
      isPrintMode: n,
      renderExtraAnswerContent: r
    }
  ) }, t);
}
const Jfe = ({
  state: e,
  containerRef: t
}) => {
  const n = nt().templatePlugins.scMcExercise, r = (i) => {
    e.isSingleChoice.set(i === "sc"), e.isSingleChoice.value && e.answers.forEach((o) => o.isCorrect.set(!1));
  };
  return /* @__PURE__ */ c.jsx(Yg, { containerRef: t, children: /* @__PURE__ */ c.jsx(
    fs,
    {
      tooltipText: n.chooseType,
      value: e.isSingleChoice.value ? "sc" : "mc",
      changeValue: r,
      options: [
        { value: "mc", text: n.multipleChoice },
        { value: "sc", text: n.singleChoice }
      ]
    }
  ) });
};
function ehe(e) {
  const { state: t, id: n, focused: r } = e, { answers: i, isSingleChoice: o } = t, a = zn(), s = yn(
    (x) => li(x, n)
  ), l = nt(), u = (x) => () => {
    i[x].isCorrect.set((E) => !E);
  }, d = (x) => () => {
    i.forEach((E, b) => {
      E.isCorrect.set(b === x);
    });
  }, p = () => i.insert(), f = (x) => () => i.remove(x), m = Jg(), y = i.some(({ content: x, feedback: E }) => {
    const b = Sf(a.getState());
    return b === x.id || b === E.id;
  }), g = r || y;
  if (i.length === 0 && i.insert(), o.value && i.length > 0) {
    const x = t.answers.filter(
      (E) => E.isCorrect.value === !0
    );
    x.length === 0 && i[0].isCorrect.set(!0), x.length > 1 && (x.forEach((E) => E.isCorrect.set(!1)), x[0].isCorrect.set(!0));
  }
  return /* @__PURE__ */ c.jsxs("div", { className: "mb-12", children: [
    /* @__PURE__ */ c.jsx(Jfe, { ...e }),
    /* @__PURE__ */ c.jsx(MF, { previewActive: m, fullOpacity: !g, children: /* @__PURE__ */ c.jsx("div", { className: "[&_.ml-4.flex]:mb-block", children: /* @__PURE__ */ c.jsx(OL, { ...s, noShuffle: !0 }) }) }),
    !m && g ? /* @__PURE__ */ c.jsxs("div", { className: "[&_.plugin-toolbar]:left-side [&_.plugin-toolbar]:top-[-60px]", children: [
      i.map((x, E) => /* @__PURE__ */ c.jsx(
        LF,
        {
          answer: x.content.render(),
          answerID: x.content.id,
          feedback: x.feedback.render(),
          feedbackID: x.feedback.id,
          isRadio: o.value,
          isActive: x.isCorrect.value,
          remove: f(E),
          handleChange: o.value ? d(E) : u(E)
        },
        x.content.id
      )),
      /* @__PURE__ */ c.jsx(Wy, { onClick: p, children: l.templatePlugins.scMcExercise.addAnswer })
    ] }) : null
  ] });
}
const the = ln({
  isSingleChoice: Z0(!1),
  answers: $a(
    ln({
      content: Vn({ plugin: Y.Text }),
      isCorrect: Z0(!1),
      feedback: Vn({ plugin: Y.Text })
    }),
    2
  )
});
function nhe() {
  return {
    Component: ehe,
    config: {},
    state: the
  };
}
function rhe(e) {
  const { i18n: t = {} } = e;
  return {
    i18n: {
      label: 'URL von einem serlo.org Inhalt (z.B. "https://de.serlo.org/mathe/1717/gleichung")',
      placeholder: "https://de.serlo.org/mathe/1717/gleichung",
      ...t
    }
  };
}
function zL(e) {
  const t = ihe(e.contentId ?? "");
  return /* @__PURE__ */ c.jsx(
    zz,
    {
      src: t,
      checkOrigin: !1,
      style: {
        width: "1px",
        minWidth: "100%",
        border: "1px solid #ddd",
        borderRadius: "2px"
      }
    },
    t
  );
}
function ihe(e) {
  return `https://de.serlo.org/${e.startsWith("/") || e.startsWith("\\") ? e.substring(1) : e}?contentOnly`;
}
const ohe = (e) => {
  const { focused: t, id: n } = e, r = rhe(e.config), i = nt().plugins.injection, [o, a] = v.useState(e.state.value), [s, l] = v.useState(!1), [u, d] = v.useState(""), [p, f] = v.useState(!1);
  return v.useEffect(() => {
    const g = setTimeout(() => {
      a(e.state.value);
    }, 2e3);
    return () => {
      clearTimeout(g);
    };
  }, [e.focused, e.state.value]), /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    y(),
    o ? /* @__PURE__ */ c.jsx(
      tue,
      {
        focused: e.focused || !1,
        onChange: (g) => {
          l(g), g && a(e.state.value);
        },
        children: /* @__PURE__ */ c.jsx(zL, { contentId: o })
      }
    ) : /* @__PURE__ */ c.jsx("div", { className: "edusharing-relative edusharing-w-full edusharing-text-center", children: /* @__PURE__ */ c.jsx(
      ot,
      {
        icon: dT,
        className: "edusharing-relative edusharing-w-full edusharing-text-center edusharing-text-[5rem] edusharing-text-gray-400"
      }
    ) }),
    e.focused && !s ? /* @__PURE__ */ c.jsxs("div", { className: "edusharing-mt-4", children: [
      /* @__PURE__ */ c.jsx(
        tf,
        {
          label: r.i18n.label,
          placeholder: r.i18n.placeholder,
          value: u,
          onChange: (g) => {
            const x = g.target.value;
            d(x), m(x);
          },
          width: "30%",
          inputWidth: "100%"
        }
      ),
      p ? /* @__PURE__ */ c.jsx("div", { className: "my-1 p-1 text-red-500", children: "Eingabe ungültig" }) : null
    ] }) : null
  ] });
  function m(g) {
    const x = E();
    function E() {
      for (const b of [
        /de.serlo.org\/(?<id>\d+)/,
        /de.serlo.org\/entity\/view\/(?<id>\d+)$/,
        /de.serlo.org\/(?<subject>[^/]+\/)?(?<id>\d+)/,
        /de.serlo.org\/entity\/repository\/compare\/\d+\/(?<id>\d+)$/,
        /de.serlo.org\/user\/profile\/(?<id>\d+)$/
      ]) {
        const C = b.exec(g);
        if (C && C.groups !== void 0) return C.groups.id;
      }
      return null;
    }
    g.length > 0 && !x ? f(!0) : f(!1), x && e.state.set(x);
  }
  function y() {
    return t ? /* @__PURE__ */ c.jsx(
      Ci,
      {
        pluginType: i.title,
        pluginControls: /* @__PURE__ */ c.jsx(Pi, { pluginId: n })
      }
    ) : null;
  }
}, ahe = rn();
function she(e = {}) {
  return {
    Component: ohe,
    config: e,
    state: ahe
  };
}
function FL(e) {
  const t = e.state;
  return /* @__PURE__ */ c.jsx(zL, { contentId: t });
}
function lhe({
  cell: e,
  isHead: t,
  isClear: n
}) {
  const r = nt().plugins.serloTable, i = yn(
    (s) => cs(s, e.content.id)
  ), o = yn(
    (s) => bi(s, e.content.id)
  );
  if (!o || t || !i || !n) return null;
  const a = o.plugin === Y.Image;
  return /* @__PURE__ */ c.jsx(
    "button",
    {
      onMouseDown: (s) => s.stopPropagation(),
      onClick: () => {
        e.content.replace(
          a ? Y.Text : Y.Image
        );
      },
      className: "serlo-button-round serlo-button-edit-secondary absolute -mt-5 ml-3.5 block px-1 pb-0.25 pt-[3px] text-sm",
      title: a ? r.convertToText : r.convertToImage,
      children: /* @__PURE__ */ c.jsx(ot, { icon: a ? BV : gT })
    }
  );
}
var Ba = /* @__PURE__ */ ((e) => (e.OnlyColumnHeader = "OnlyColumnHeader", e.OnlyRowHeader = "OnlyRowHeader", e.ColumnAndRowHeader = "RowAndColumnHeader", e))(Ba || {});
function LL({
  tableType: e,
  rows: t
}) {
  const n = e === "OnlyRowHeader" || e === "RowAndColumnHeader", r = e === "OnlyColumnHeader" || e === "RowAndColumnHeader";
  return /* @__PURE__ */ c.jsx("table", { className: "serlo-table mb-8", children: r ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx("thead", { children: i([t[0]]) }),
    /* @__PURE__ */ c.jsx("tbody", { children: i(t.slice(1), 1) })
  ] }) : /* @__PURE__ */ c.jsx("tbody", { children: i(t) }) });
  function i(a, s = 0) {
    return a.map((l, u) => /* @__PURE__ */ c.jsx("tr", { children: l.cells.map(
      (d, p) => o(d, s + u, p)
    ) }, s + u));
  }
  function o(a, s, l) {
    const u = s === 0, d = s === t.length - 1, p = r && u, f = n && l === 0 || p, m = p ? "col" : "row", y = Le(
      "first:border-l-3",
      u && "border-t-3 first:rounded-tl-xl last:rounded-tr-xl",
      d && "first:rounded-bl-xl last:rounded-br-xl"
    );
    return /* @__PURE__ */ c.jsx(v.Fragment, { children: f ? /* @__PURE__ */ c.jsx(
      "th",
      {
        scope: m,
        className: Le("serlo-th px-0 align-top", y),
        children: a
      }
    ) : /* @__PURE__ */ c.jsx("td", { className: Le("serlo-td px-0", y), children: a }) }, l);
  }
}
function uhe(e) {
  return Object.values(Ba).includes(e);
}
function ML(e) {
  return uhe(e) ? e : Ba.OnlyColumnHeader;
}
const che = ({ id: e, state: t }) => {
  const n = nt().plugins.serloTable, r = ML(t.tableType.value);
  return /* @__PURE__ */ c.jsx(
    Ci,
    {
      pluginType: Y.SerloTable,
      pluginSettings: /* @__PURE__ */ c.jsx(
        fs,
        {
          tooltipText: "",
          value: r,
          changeValue: (i) => t.tableType.set(i),
          options: [
            {
              value: Ba.OnlyColumnHeader,
              text: n.columnHeaders
            },
            { value: Ba.OnlyRowHeader, text: n.rowHeaders },
            {
              value: Ba.ColumnAndRowHeader,
              text: n.columnAndRowHeaders
            }
          ]
        }
      ),
      pluginControls: /* @__PURE__ */ c.jsx(Pi, { pluginId: e })
    }
  );
}, wo = {}, EC = { content: { plugin: Y.Text } };
function dhe(e) {
  const t = zn(), { rows: n } = e.state, [, r] = v.useState(0), i = Ur(), o = yn(Sf), { focusedRowIndex: a, focusedColIndex: s, nestedFocus: l } = M(), u = nt().plugins.serloTable, d = ML(e.state.tableType.value), p = d === Ba.OnlyRowHeader || d === Ba.ColumnAndRowHeader, f = d === Ba.OnlyColumnHeader || d === Ba.ColumnAndRowHeader, m = y();
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    e.focused || l ? /* @__PURE__ */ c.jsx(che, { ...e }) : null,
    /* @__PURE__ */ c.jsx("div", { className: "relative pb-5 pl-4 pr-3 pt-6", children: /* @__PURE__ */ c.jsxs("div", { className: "flex", children: [
      /* @__PURE__ */ c.jsxs("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ c.jsx(LL, { rows: m, tableType: d }),
        l ? I() : null
      ] }),
      l ? w() : null
    ] }) })
  ] });
  function y() {
    return n.map((F, W) => ({
      cells: F.columns.map((X, le) => {
        const ne = p && le === 0 || f && W === 0, fe = W === n.length - 1 && le === n[0].columns.length - 1, D = ou(
          t.getState(),
          X.content.id
        ), j = (ye) => {
          ye.key === "Delete" || ye.key === "Backspace" ? D || r((Ne) => Ne + 1) : D && r((Ne) => Ne + 1);
        }, de = (ye) => {
          ye.key === "Tab" && ye.target.tagName === "BUTTON" && fe && x();
        };
        return /* @__PURE__ */ c.jsxs(
          "div",
          {
            onKeyUp: j,
            onKeyDown: de,
            className: Le(
              "[&>div>[data-slate-editor]]:pr-2",
              "[&>div>[data-slate-editor]]:pb-block",
              "[&>div>[data-slate-editor]]:focus:caret-visible"
            ),
            children: [
              g(W, le),
              X.content.render({
                config: {
                  isInlineChildEditor: !0,
                  placeholder: "",
                  formattingOptions: ne ? e.config.headerTextFormattingOptions : e.config.cellTextFormattingOptions
                }
              }),
              si.isSupported(Y.Image) ? /* @__PURE__ */ c.jsx(
                lhe,
                {
                  cell: X,
                  isHead: ne,
                  isClear: D
                }
              ) : null
            ]
          },
          le
        );
      })
    }));
  }
  function g(F, W) {
    const X = W === 0 && F === a && !(f && a === 0), le = F === 0 && W === s && !(p && s === 0);
    return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx("nav", { className: "absolute -ml-7 -mt-2 flex flex-col", children: X ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
        ne(!0),
        fe(!0)
      ] }) : null }),
      /* @__PURE__ */ c.jsx("nav", { className: "absolute top-0 z-20", children: le ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
        ne(!1),
        fe(!1)
      ] }) : null })
    ] });
    function ne(D) {
      const j = () => {
        D ? x(F) : E(W);
      };
      return /* @__PURE__ */ c.jsxs(
        "button",
        {
          className: Le(
            "serlo-tooltip-trigger text-gray-300 transition-colors hover:text-editor-primary focus:text-editor-primary",
            D ? "" : "mr-2"
          ),
          onMouseDown: (de) => de.stopPropagation(),
          onClick: j,
          children: [
            /* @__PURE__ */ c.jsx(
              vn,
              {
                text: R(u.addTypeBefore, D),
                className: "top-6"
              }
            ),
            /* @__PURE__ */ c.jsx(ot, { icon: Lg })
          ]
        }
      );
    }
    function fe(D) {
      if (D && n.length === 2 || !D && n[0].columns.length === 2 || D && f && a === 0 || !D && p && s === 0) return null;
      const j = R(u.confirmDelete, D), de = () => {
        if (!(D ? b(F) : C(W)) && !window.confirm(j)) {
          const Me = wo[n[a ?? 0].columns[s ?? 0].content.id];
          Me && Me.needRefocus++, r((Ie) => Ie + 1);
          return;
        }
        D ? z(F) : T(W);
        const ye = D ? F + 1 < n.length ? F + 1 : F - 1 : a ?? 0, Ne = D ? s ?? 0 : W + 1 < n[0].columns.length ? W + 1 : W - 1;
        i(
          Ji(n[ye].columns[Ne].content.id)
        );
      };
      return /* @__PURE__ */ c.jsxs(
        "button",
        {
          className: "serlo-tooltip-trigger text-gray-300 transition-colors hover:text-editor-primary focus:text-editor-primary",
          onMouseDown: (ye) => ye.stopPropagation(),
          onClick: de,
          children: [
            /* @__PURE__ */ c.jsx(
              vn,
              {
                text: R(u.deleteType, D),
                className: "top-6"
              }
            ),
            /* @__PURE__ */ c.jsx(ot, { icon: lT })
          ]
        }
      );
    }
  }
  function x(F) {
    const W = F ?? n.length;
    n.insert(W, {
      columns: n[0].columns.map(() => EC)
    });
  }
  function E(F) {
    for (const W of n) {
      const X = F ?? W.columns.length;
      W.columns.insert(X, EC);
    }
  }
  function b(F) {
    return n[F].columns.every(
      (W) => ou(t.getState(), W.content.id)
    );
  }
  function C(F) {
    return n.every((W) => {
      const X = W.columns[F];
      return ou(t.getState(), X.content.id);
    });
  }
  function T(F) {
    for (const W of n)
      W.columns.remove(F);
  }
  function z(F) {
    n.remove(F);
  }
  function I() {
    return /* @__PURE__ */ c.jsx("div", { className: "relative", children: /* @__PURE__ */ c.jsxs(
      "button",
      {
        className: Le(
          "serlo-button-edit-secondary serlo-tooltip-trigger",
          "absolute -bottom-1.5 z-20 mx-side w-[calc(100%-1.9rem)]"
        ),
        onClick: () => x(),
        children: [
          /* @__PURE__ */ c.jsx(
            vn,
            {
              text: R(u.addType, !0),
              className: "-left-0.5 -top-9"
            }
          ),
          "+"
        ]
      }
    ) });
  }
  function w() {
    return /* @__PURE__ */ c.jsxs(
      "button",
      {
        className: Le(
          "serlo-button-edit-secondary serlo-tooltip-trigger -ml-1 mb-8 px-2.5"
        ),
        onClick: () => E(),
        children: [
          /* @__PURE__ */ c.jsx(
            vn,
            {
              text: R(u.addType, !1),
              className: "left-8 top-0"
            }
          ),
          "+"
        ]
      }
    );
  }
  function M() {
    let F, W;
    n.some(
      (le, ne) => le.columns.some((fe, D) => {
        if (fe.content.id === o)
          return F = ne, W = D, !0;
      })
    );
    const X = e.focused || F !== void 0 && W !== void 0;
    return { focusedRowIndex: F, focusedColIndex: W, nestedFocus: X };
  }
  function R(F, W) {
    return F.replace("%type%", u[W ? "row" : "column"]);
  }
}
const phe = [
  tt.code,
  tt.links,
  tt.math
], fhe = [
  tt.code,
  tt.colors,
  tt.links,
  tt.lists,
  tt.math,
  tt.richTextBold,
  tt.richTextItalic
], hhe = ln({
  rows: $a(
    ln({
      columns: $a(
        ln({
          content: Vn({ plugin: Y.Text })
        }),
        2
      )
    }),
    4
  ),
  tableType: rn(Ba.OnlyColumnHeader)
}), mhe = {
  allowImageInTableCells: !0,
  headerTextFormattingOptions: phe,
  cellTextFormattingOptions: fhe
};
function ghe(e = mhe) {
  return {
    Component: dhe,
    config: e,
    state: hhe
  };
}
function BL({
  content: e
}) {
  return /* @__PURE__ */ c.jsx(c.Fragment, { children: e });
}
function vhe({
  state: e
}) {
  return /* @__PURE__ */ c.jsx(BL, { content: e.content.render() });
}
const yhe = ln({
  // Content is mandatory, everything else needs to be optional
  content: Vn({ plugin: Y.Rows })
}), xhe = {
  Component: vhe,
  state: yhe,
  config: {}
};
function bhe({
  onClick: e,
  className: t,
  text: n,
  noIcon: r
}) {
  return /* @__PURE__ */ c.jsxs(
    "button",
    {
      className: `serlo-button-edit-secondary ml-side text-base leading-browser ${t ?? ""}`,
      onClick: e,
      children: [
        r ? null : /* @__PURE__ */ c.jsx(ot, { icon: Dc }),
        " ",
        n
      ]
    }
  );
}
function IL({
  prerequisite: e,
  strategy: t,
  steps: n,
  solutionVisibleOnInit: r,
  hideToggle: i,
  onSolutionOpen: o,
  elementAfterToggle: a,
  elementBeforePrerequisite: s
}) {
  const l = Un().plugins.exercise, [u, d] = v.useState(
    r ? "solution" : !1
  );
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsxs("nav", { children: [
      i ? null : /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
        t ? f("strategy") : null,
        " ",
        f("solution")
      ] }),
      a
    ] }),
    /* @__PURE__ */ c.jsxs("div", { className: Le("serlo-solution-box", u ? "" : "hidden"), children: [
      /* @__PURE__ */ c.jsx("div", { className: Le(u === "solution" ? "" : "hidden"), children: p() }),
      /* @__PURE__ */ c.jsx("div", { className: Le(u === "strategy" ? "" : "hidden"), children: t })
    ] })
  ] });
  function p() {
    return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      s,
      e ? /* @__PURE__ */ c.jsxs("p", { className: "serlo-p", children: [
        l.prerequisite,
        " ",
        e
      ] }) : null,
      n
    ] });
  }
  function f(m) {
    const y = u === m;
    return /* @__PURE__ */ c.jsxs(
      "button",
      {
        className: Le(
          "serlo-button-learner-transparent mb-4 ml-side mr-auto pr-2 text-base hover:bg-brand-100 hover:text-brand-700",
          y && "bg-brand text-white"
        ),
        onClick: () => {
          y ? d(!1) : (d(m), m === "solution" && o && o());
        },
        children: [
          /* @__PURE__ */ c.jsxs("span", { className: "w-3.5", children: [
            /* @__PURE__ */ c.jsx(
              "span",
              {
                className: Le(
                  "inline-block transition-transform duration-300",
                  y && "translate-y-[1px] rotate-180"
                ),
                children: "▾"
              }
            ),
            " "
          ] }),
          l[m]
        ]
      }
    );
  }
}
function RL(e) {
  const { lang: t } = nt(), n = gl() && t === "de", [r, i] = v.useState(null);
  return v.useEffect(() => {
    !n || e || r || Che().then((o) => o && i(o)).catch(console.error);
  }, [r, n]), { quickbarData: r };
}
const whe = "https://de.serlo.org/api/stats/quickbar.json";
async function Che(e) {
  const t = await (await fetch(whe)).json();
  t.forEach((r) => {
    r.pathLower = r.path.map((i) => i.toLowerCase()), r.titleLower = r.title.toLowerCase();
  });
  const n = (e == null ? void 0 : e.toLowerCase()) ?? "";
  return e ? t.filter((r) => {
    var i;
    return (i = r.root) == null ? void 0 : i.toLowerCase().startsWith(n);
  }) : t;
}
function khe(e, t) {
  let n = [];
  const r = t.toLowerCase().split(" ");
  for (const i of e) {
    let o = 0;
    const a = (t.charAt(0) === "/" ? t.slice(1) : t).toLowerCase().trim();
    if (i.titleLower.includes(a) || a === i.id)
      o += 100, i.titleLower.startsWith(a) ? o += 10 : (i.titleLower.includes(" " + a) || a.includes(i.id)) && (o += 8);
    else {
      let s = 0, l = 0;
      for (const u of r)
        if (u) {
          if (l++, i.titleLower.includes(u)) {
            o += 10;
            continue;
          }
          let d = !1;
          for (const p of i.pathLower)
            if (p.includes(u)) {
              o += 2, d = !0;
              break;
            }
          if (d) continue;
          s++;
        }
      l > 0 && (s >= l / 2 ? o = 0 : o *= 1 - s / l);
    }
    o > 0 && (o += Math.log10(i.count), n.push({ entry: i, score: o }), n.sort((s, l) => l.score - s.score), n = n.slice(0, 7));
  }
  return n;
}
function PL(e, t, n) {
  var r;
  if (!t) return e;
  const i = parseInt(
    ((r = e.match(
      /https?:\/\/([a-z]{2}\.)?serlo\.org(\/[a-z]+)?\/([1-9]?[0-9]+)/
    )) == null ? void 0 : r[3]) ?? "NaN"
  ), o = e.split("#")[1], a = o ? `#${o}` : "";
  if (!isNaN(i)) return `/${i}${a}`;
  const s = n ? e.replace("https://serlo.org/", "").replace(`https://${n}.serlo.org/`, "").replace(/^serlo\.org\//, "") : e.replace(/(https:\/\/)?([a-z]+\.)?serlo.org/, "");
  return e !== s ? `/${s}${a}` : e;
}
function Ehe({
  query: e,
  setQuery: t,
  shouldFocus: n,
  value: r,
  onKeyDown: i,
  placeholder: o
}) {
  const a = v.useRef(null), { lang: s } = nt(), l = gl();
  v.useEffect(() => {
    if (!n) return;
    const d = setTimeout(() => {
      n && a.current && a.current.focus();
    });
    return () => {
      d && clearTimeout(d);
    };
  }, [r]);
  function u(d) {
    setTimeout(() => {
      const p = d.target.value, f = PL(p, l, s);
      f !== p && t(f);
    });
  }
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      "input",
      {
        type: "text",
        className: "align-end mx-side mt-2 h-12 w-[25rem] rounded-xl border-3 border-editor-primary-50 bg-editor-primary-100 pl-3 pr-12 outline-none hover:border-editor-primary-100 focus:border-editor-primary-200",
        value: e,
        onChange: (d) => t(d.target.value),
        placeholder: o,
        ref: a,
        onKeyDown: i,
        onPaste: u,
        spellCheck: !1
      }
    ),
    e ? /* @__PURE__ */ c.jsx(
      "div",
      {
        className: "serlo-button-round serlo-button-edit-secondary absolute right-6 top-4 flex h-8 w-8 cursor-pointer items-center justify-center text-gray-700",
        onClick: () => {
          t(""), setTimeout(() => {
            var d;
            (d = a.current) == null || d.focus();
          });
        },
        children: /* @__PURE__ */ c.jsx(ot, { icon: Fg })
      }
    ) : null
  ] });
}
function SC({
  selectedIndex: e,
  chooseEntry: t,
  title: n,
  index: r,
  pathHeader: i,
  isCustomLink: o
}) {
  return /* @__PURE__ */ c.jsxs(
    "a",
    {
      className: Le(
        "serlo-link flex cursor-pointer bg-white px-side py-2",
        "hover:!bg-editor-primary-100 hover:!no-underline",
        r === e && "!bg-editor-primary-100"
      ),
      "data-qa": `link-suggestion-${r}`,
      role: "option",
      "aria-selected": r === e,
      onClick: () => {
        t(r);
      },
      children: [
        o ? /* @__PURE__ */ c.jsx("span", { className: "mr-3 block h-12 w-12 bg-editor-primary-50 pt-3 text-center text-gray-800", children: /* @__PURE__ */ c.jsx(ot, { icon: pT }) }) : null,
        /* @__PURE__ */ c.jsxs("p", { className: "whitespace-normal text-lg leading-cozy", children: [
          /* @__PURE__ */ c.jsx("span", { className: "text-gray-700", children: i }),
          /* @__PURE__ */ c.jsx(
            "span",
            {
              className: Le(
                "block font-bold",
                o ? "text-gray-800" : "text-brand-800"
              ),
              children: n
            }
          )
        ] })
      ]
    },
    r
  );
}
function _L({
  isSerloLinkSearchActive: e,
  value: t,
  setHref: n,
  removeLink: r,
  shouldFocus: i,
  noAutocomplete: o
}) {
  const [a, s] = v.useState(t), [l, u] = v.useState(-1), d = nt(), { lang: p } = d, f = d.plugins.text.linkOverlay, m = gl(), { quickbarData: y } = RL(o);
  v.useEffect(() => {
    s(t);
  }, [t]), v.useEffect(() => {
    e && u(0);
  }, [a, y, t, e]);
  const g = y ? khe(y, a) : [];
  function x(C) {
    const T = C ?? l;
    if (T < 0 || T > g.length) return;
    const z = T < g.length, I = z ? `/${g[T].entry.id}` : a, w = PL(I, m, p), M = z ? g[T].entry.title : void 0;
    w.startsWith("/") || w.startsWith("#") || w.startsWith("http://") || w.startsWith("https://") ? n(w, M) : yi(f.invalidLinkWarning, "warning", 5e3);
  }
  const E = (C) => {
    if (C.key === "Escape" && (a ? s("") : r && r()), C.key === "ArrowDown" || C.key === "ArrowUp" || C.key === "Enter")
      return C.key === "ArrowDown" && l < g.length && u(l + 1), C.key === "ArrowUp" && l >= 0 && u(l - 1), C.key === "Enter" && x(), C.preventDefault(), !1;
  }, b = e && !y;
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx("label", { className: "block px-side pt-4", children: m ? f.inputLabel : f.inputLabelNonSerlo }),
    /* @__PURE__ */ c.jsx("div", { className: "relative w-[27rem]", children: /* @__PURE__ */ c.jsx(
      Ehe,
      {
        query: a,
        onKeyDown: E,
        setQuery: s,
        shouldFocus: i,
        value: t,
        placeholder: m ? f.placeholder : f.placeholderNonSerlo
      }
    ) }),
    a ? /* @__PURE__ */ c.jsxs("div", { className: "group mt-4", role: "listbox", children: [
      b ? /* @__PURE__ */ c.jsx("div", { className: Le("mt-12 text-brand"), children: /* @__PURE__ */ c.jsxs("p", { className: "serlo-p", children: [
        /* @__PURE__ */ c.jsx(ot, { icon: bT, className: "animate-spin-slow" }),
        " …"
      ] }) }) : null,
      g.map(({ entry: C }, T) => /* @__PURE__ */ c.jsx(
        SC,
        {
          selectedIndex: l,
          chooseEntry: x,
          title: C.title,
          pathHeader: C.path.join(" > "),
          index: T
        },
        C.id
      )),
      /* @__PURE__ */ c.jsx(
        "div",
        {
          className: Le("mt-2 text-lg text-gray-800", {
            "bg-brand-50": l === g.length
          }),
          children: /* @__PURE__ */ c.jsx(
            SC,
            {
              selectedIndex: l,
              chooseEntry: x,
              title: a,
              pathHeader: f.customLink,
              index: g.length,
              isCustomLink: !0
            }
          )
        }
      ),
      e && /* @__PURE__ */ c.jsxs("p", { className: "mx-side mt-5 whitespace-normal border-t-2 border-gray-100 pt-3 text-sm text-gray-600", children: [
        "Manche Inhalte lassen sich über die Suche nicht finden. ",
        /* @__PURE__ */ c.jsx("br", {}),
        "In dem Fall",
        " ",
        /* @__PURE__ */ c.jsx("a", { href: "/search", target: "_blank", rel: "noreferrer", children: "suche den Inhalt" }),
        " ",
        "und füge die URL hier ein."
      ] })
    ] }) : null,
    /* @__PURE__ */ c.jsx("br", {})
  ] });
}
function qL({
  value: e,
  removeLink: t,
  setIsEditMode: n,
  noAutocomplete: r
}) {
  const { quickbarData: i } = RL(r), o = e.startsWith("/") && e.slice(1).match(/^\d+$/) ? e.slice(1) : void 0, a = i == null ? void 0 : i.find((u) => u.id === o), s = !o && !e.includes("serlo.org/"), l = nt().plugins.text;
  return /* @__PURE__ */ c.jsxs("div", { className: "flex content-between items-center px-side py-2", children: [
    /* @__PURE__ */ c.jsxs(
      "a",
      {
        href: e,
        target: "_blank",
        className: Le(
          "serlo-link serlo-tooltip-trigger mr-auto max-w-[27rem] whitespace-normal font-bold outline-none focus:underline",
          s ? "!text-gray-800" : "text-brand"
        ),
        rel: "noreferrer",
        children: [
          /* @__PURE__ */ c.jsx(
            ot,
            {
              icon: s ? pT : dT,
              className: "mr-2"
            }
          ),
          a ? `${a.title} (${e})` : e,
          /* @__PURE__ */ c.jsx(
            vn,
            {
              text: l.openInNewTab,
              className: "!-ml-1 !pb-2"
            }
          )
        ]
      }
    ),
    n ? /* @__PURE__ */ c.jsxs(
      "button",
      {
        onClick: () => n(!0),
        className: "serlo-button-edit-secondary serlo-tooltip-trigger ml-4 h-10 w-10",
        "data-qa": "edit-link-button",
        children: [
          /* @__PURE__ */ c.jsx(ot, { icon: W0 }),
          /* @__PURE__ */ c.jsx(
            vn,
            {
              text: l.linkOverlay.edit,
              className: "!-ml-2 !pb-2"
            }
          )
        ]
      }
    ) : null,
    /* @__PURE__ */ c.jsxs(
      "button",
      {
        onClick: t,
        className: "serlo-button-edit-secondary serlo-tooltip-trigger ml-2 h-10 w-10",
        "data-qa": "remove-link-button",
        children: [
          /* @__PURE__ */ c.jsx(ot, { icon: ld }),
          /* @__PURE__ */ c.jsx("span", { className: "sr-only", children: l.linkOverlay.remove }),
          /* @__PURE__ */ c.jsx(
            vn,
            {
              text: l.linkOverlay.remove,
              className: "!-ml-2 !pb-2"
            }
          )
        ]
      }
    )
  ] });
}
const She = 460, Dhe = v.lazy(
  () => import("./serlo-license-chooser-D1OnJUZ6-Dju-dLgM.js").then((e) => ({
    default: e.SerloLicenseChooser
  }))
);
function Ahe({ state: e, focused: t }) {
  const { prerequisite: n, strategy: r, licenseId: i } = e, o = nt().templatePlugins.solution, a = gl(), [s, l] = v.useState(!1);
  return v.useEffect(() => {
    t || l(!1);
  }, [t]), /* @__PURE__ */ c.jsx(
    IL,
    {
      elementBeforePrerequisite: a ? /* @__PURE__ */ c.jsx(v.Suspense, { children: /* @__PURE__ */ c.jsx(Dhe, { licenseId: i }) }) : null,
      prerequisite: a ? u() : null,
      strategy: /* @__PURE__ */ c.jsx("div", { className: "-mx-2 px-side", children: r.render({
        config: {
          placeholder: o.optionalExplanation
        }
      }) }),
      steps: /* @__PURE__ */ c.jsx("div", { className: "ml-1", children: e.steps.render() }),
      solutionVisibleOnInit: !0
    }
  );
  function u() {
    return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      s ? d() : null,
      n.defined ? /* @__PURE__ */ c.jsx(
        "a",
        {
          className: "serlo-link",
          href: `/${n.id.value}`,
          onClick: (p) => {
            p.preventDefault(), l(!0);
          },
          children: n.title.value
        }
      ) : /* @__PURE__ */ c.jsx(
        bhe,
        {
          text: o.addPrerequisite,
          onClick: () => l(!0),
          className: "mb-8 mt-4"
        }
      )
    ] });
  }
  function d() {
    return /* @__PURE__ */ c.jsx(
      "div",
      {
        className: "absolute bottom-0 left-0 right-0 top-0",
        onClick: () => l(!1),
        children: /* @__PURE__ */ c.jsx(
          "div",
          {
            className: "absolute left-12 top-28 z-[95] whitespace-nowrap",
            onClick: (p) => p.stopPropagation(),
            children: /* @__PURE__ */ c.jsx(
              "div",
              {
                className: "w-[460px] rounded bg-white text-start not-italic shadow-menu",
                style: { width: `${She}px` },
                children: n.defined ? /* @__PURE__ */ c.jsx(
                  qL,
                  {
                    value: n.defined ? `/${n.id.value}` : "",
                    removeLink: () => {
                      n.remove(), l(!1);
                    }
                  }
                ) : /* @__PURE__ */ c.jsx(
                  _L,
                  {
                    isSerloLinkSearchActive: !0,
                    setHref: (p, f) => {
                      if (!f) {
                        yi("Please choose an existing serlo content");
                        return;
                      }
                      n.create({
                        id: p.replace("/", ""),
                        title: f,
                        alias: void 0
                      });
                    },
                    value: "",
                    shouldFocus: !0
                  }
                )
              }
            )
          }
        )
      }
    );
  }
}
const The = ln({
  strategy: Vn({ plugin: Y.Text }),
  steps: Vn({ plugin: Y.Rows }),
  prerequisite: qr(
    ln({
      id: rn(),
      title: rn(),
      alias: qr(rn())
    })
  ),
  licenseId: qr(oa())
}), jhe = {
  Component: Ahe,
  state: The,
  config: {}
};
function $L({
  title: e,
  children: t,
  openOverwrite: n,
  onOpen: r
}) {
  const [i, o] = v.useState(!1), a = n === void 0 ? i : n, s = () => {
    o(!i), r == null || r();
  };
  return /* @__PURE__ */ c.jsxs(
    "div",
    {
      className: Le(
        "mb-block flex flex-col rounded-lg border-3",
        "[&>div.my-block:first-of-type]:mt-5",
        a ? "border-brand-200" : "border-brand-100"
      ),
      children: [
        /* @__PURE__ */ c.jsx(
          "button",
          {
            onClick: () => s(),
            className: Le(
              `
            serlo-input-font-reset m-0 border-none px-side py-2.5
            text-left text-lg leading-normal text-almost-black transition-colors
          `,
              a ? "bg-brand-200" : "bg-brand-100"
            ),
            children: /* @__PURE__ */ c.jsxs("span", { className: "flex", children: [
              /* @__PURE__ */ c.jsxs("span", { className: "inline-block w-4", children: [
                a ? "▾ " : "▸ ",
                " "
              ] }),
              e
            ] })
          }
        ),
        a ? t : null
      ]
    }
  );
}
const Nhe = [
  tt.code,
  tt.math,
  tt.richTextBold,
  tt.richTextItalic
];
function Ohe(e) {
  const { state: t, id: n, focused: r } = e, { title: i, richTitle: o, content: a } = t, s = nt(), l = v.useMemo(() => o.defined ? o.id : "", [o.defined]), u = yn(
    (m) => cs(m, l)
  ), d = r || u;
  if (v.useEffect(() => {
    if (o.defined) return;
    const m = i.defined ? {
      plugin: Y.Text,
      state: [{ type: "p", children: [{ text: i.value }] }]
    } : { plugin: Y.Text };
    o.create(m);
  }), !o.defined) return null;
  const p = {
    config: {
      placeholder: s.plugins.spoiler.enterATitle,
      formattingOptions: Nhe,
      isInlineChildEditor: !0
    }
  };
  return /* @__PURE__ */ c.jsxs("div", { className: "pl-0.5", children: [
    f(),
    /* @__PURE__ */ c.jsx(
      "div",
      {
        className: Le(
          d && "[&>div]:rounded-t-none",
          // making space for first toolbar, not wysiwyg
          "[&>div>button]:!mb-[17px]",
          // toolbar finetuning
          "[&_.rows-child:first-child_.plugin-toolbar:before]:hidden",
          // shadow finetuning
          "-mt-2"
        ),
        children: /* @__PURE__ */ c.jsx(
          $L,
          {
            title: /* @__PURE__ */ c.jsx("div", { className: "grow", children: o.render(p) }),
            openOverwrite: !0,
            children: /* @__PURE__ */ c.jsx("div", { className: "mx-side", children: a.render({
              config: { isInlineChildEditor: !0 }
            }) })
          }
        )
      }
    )
  ] });
  function f() {
    return d ? /* @__PURE__ */ c.jsx(
      Ci,
      {
        pluginType: Y.Spoiler,
        pluginControls: /* @__PURE__ */ c.jsx(Pi, { pluginId: n }),
        className: "top-[-33px]"
      }
    ) : null;
  }
}
function zhe(e) {
  return ln({
    title: qr(rn("")),
    richTitle: qr(
      Vn({
        plugin: Y.Text,
        config: { noLinebreaks: !0 }
      })
    ),
    content: Vn({
      plugin: Y.Rows,
      config: {
        allowedPlugins: e
      }
    })
  });
}
const Fhe = [
  Y.Text,
  Y.Image,
  Y.ImageGallery,
  Y.Multimedia,
  Y.Spoiler,
  Y.Box,
  Y.SerloTable,
  Y.Injection,
  Y.Equations,
  Y.Geogebra,
  Y.Highlight,
  Y.Video,
  Y.Audio,
  Y.Exercise,
  Y.EdusharingAsset,
  Y.DropzoneImage,
  Y.H5p,
  Y.InputExercise,
  Y.ScMcExercise,
  Y.BlanksExercise,
  Y.TextAreaExercise
];
function Lhe(e) {
  const t = Fhe.filter(
    (n) => e.includes(n)
  );
  return {
    Component: Ohe,
    state: zhe(t),
    config: {
      allowedPlugins: t
    }
  };
}
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function DC(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function gi(e) {
  var t, n;
  return DC(e) === !1 ? !1 : (t = e.constructor, t === void 0 ? !0 : (n = t.prototype, !(DC(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1)));
}
var Mhe = {
  transform(e, t) {
    var {
      current: n,
      affinity: r
    } = e;
    if (n != null) {
      var i = ee.transform(n, t, {
        affinity: r
      });
      e.current = i, i == null && e.unref();
    }
  }
}, Bhe = {
  transform(e, t) {
    var {
      current: n,
      affinity: r
    } = e;
    if (n != null) {
      var i = Ut.transform(n, t, {
        affinity: r
      });
      e.current = i, i == null && e.unref();
    }
  }
}, Ihe = {
  transform(e, t) {
    var {
      current: n,
      affinity: r
    } = e;
    if (n != null) {
      var i = ke.transform(n, t, {
        affinity: r
      });
      e.current = i, i == null && e.unref();
    }
  }
}, Xm = /* @__PURE__ */ new WeakMap(), Qm = /* @__PURE__ */ new WeakMap(), Dp = /* @__PURE__ */ new WeakMap(), HL = /* @__PURE__ */ new WeakMap(), AC = /* @__PURE__ */ new WeakMap(), TC = /* @__PURE__ */ new WeakMap(), jC = /* @__PURE__ */ new WeakMap(), ee = {
  ancestors(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: n = !1
    } = t, r = ee.levels(e, t);
    return n ? r = r.slice(1) : r = r.slice(0, -1), r;
  },
  common(e, t) {
    for (var n = [], r = 0; r < e.length && r < t.length; r++) {
      var i = e[r], o = t[r];
      if (i !== o)
        break;
      n.push(i);
    }
    return n;
  },
  compare(e, t) {
    for (var n = Math.min(e.length, t.length), r = 0; r < n; r++) {
      if (e[r] < t[r]) return -1;
      if (e[r] > t[r]) return 1;
    }
    return 0;
  },
  endsAfter(e, t) {
    var n = e.length - 1, r = e.slice(0, n), i = t.slice(0, n), o = e[n], a = t[n];
    return ee.equals(r, i) && o > a;
  },
  endsAt(e, t) {
    var n = e.length, r = e.slice(0, n), i = t.slice(0, n);
    return ee.equals(r, i);
  },
  endsBefore(e, t) {
    var n = e.length - 1, r = e.slice(0, n), i = t.slice(0, n), o = e[n], a = t[n];
    return ee.equals(r, i) && o < a;
  },
  equals(e, t) {
    return e.length === t.length && e.every((n, r) => n === t[r]);
  },
  hasPrevious(e) {
    return e[e.length - 1] > 0;
  },
  isAfter(e, t) {
    return ee.compare(e, t) === 1;
  },
  isAncestor(e, t) {
    return e.length < t.length && ee.compare(e, t) === 0;
  },
  isBefore(e, t) {
    return ee.compare(e, t) === -1;
  },
  isChild(e, t) {
    return e.length === t.length + 1 && ee.compare(e, t) === 0;
  },
  isCommon(e, t) {
    return e.length <= t.length && ee.compare(e, t) === 0;
  },
  isDescendant(e, t) {
    return e.length > t.length && ee.compare(e, t) === 0;
  },
  isParent(e, t) {
    return e.length + 1 === t.length && ee.compare(e, t) === 0;
  },
  isPath(e) {
    return Array.isArray(e) && (e.length === 0 || typeof e[0] == "number");
  },
  isSibling(e, t) {
    if (e.length !== t.length)
      return !1;
    var n = e.slice(0, -1), r = t.slice(0, -1), i = e[e.length - 1], o = t[t.length - 1];
    return i !== o && ee.equals(n, r);
  },
  levels(e) {
    for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: n = !1
    } = t, r = [], i = 0; i <= e.length; i++)
      r.push(e.slice(0, i));
    return n && r.reverse(), r;
  },
  next(e) {
    if (e.length === 0)
      throw new Error("Cannot get the next path of a root path [".concat(e, "], because it has no next index."));
    var t = e[e.length - 1];
    return e.slice(0, -1).concat(t + 1);
  },
  operationCanTransformPath(e) {
    switch (e.type) {
      case "insert_node":
      case "remove_node":
      case "merge_node":
      case "split_node":
      case "move_node":
        return !0;
      default:
        return !1;
    }
  },
  parent(e) {
    if (e.length === 0)
      throw new Error("Cannot get the parent path of the root path [".concat(e, "]."));
    return e.slice(0, -1);
  },
  previous(e) {
    if (e.length === 0)
      throw new Error("Cannot get the previous path of a root path [".concat(e, "], because it has no previous index."));
    var t = e[e.length - 1];
    if (t <= 0)
      throw new Error("Cannot get the previous path of a first child path [".concat(e, "] because it would result in a negative index."));
    return e.slice(0, -1).concat(t - 1);
  },
  relative(e, t) {
    if (!ee.isAncestor(t, e) && !ee.equals(e, t))
      throw new Error("Cannot get the relative path of [".concat(e, "] inside ancestor [").concat(t, "], because it is not above or equal to the path."));
    return e.slice(t.length);
  },
  transform(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!e) return null;
    var r = [...e], {
      affinity: i = "forward"
    } = n;
    if (e.length === 0)
      return r;
    switch (t.type) {
      case "insert_node": {
        var {
          path: o
        } = t;
        (ee.equals(o, r) || ee.endsBefore(o, r) || ee.isAncestor(o, r)) && (r[o.length - 1] += 1);
        break;
      }
      case "remove_node": {
        var {
          path: a
        } = t;
        if (ee.equals(a, r) || ee.isAncestor(a, r))
          return null;
        ee.endsBefore(a, r) && (r[a.length - 1] -= 1);
        break;
      }
      case "merge_node": {
        var {
          path: s,
          position: l
        } = t;
        ee.equals(s, r) || ee.endsBefore(s, r) ? r[s.length - 1] -= 1 : ee.isAncestor(s, r) && (r[s.length - 1] -= 1, r[s.length] += l);
        break;
      }
      case "split_node": {
        var {
          path: u,
          position: d
        } = t;
        if (ee.equals(u, r)) {
          if (i === "forward")
            r[r.length - 1] += 1;
          else if (i !== "backward") return null;
        } else ee.endsBefore(u, r) ? r[u.length - 1] += 1 : ee.isAncestor(u, r) && e[u.length] >= d && (r[u.length - 1] += 1, r[u.length] -= d);
        break;
      }
      case "move_node": {
        var {
          path: p,
          newPath: f
        } = t;
        if (ee.equals(p, f))
          return r;
        if (ee.isAncestor(p, r) || ee.equals(p, r)) {
          var m = f.slice();
          return ee.endsBefore(p, f) && p.length < f.length && (m[p.length - 1] -= 1), m.concat(r.slice(p.length));
        } else ee.isSibling(p, f) && (ee.isAncestor(f, r) || ee.equals(f, r)) ? ee.endsBefore(p, r) ? r[p.length - 1] -= 1 : r[p.length - 1] += 1 : ee.endsBefore(f, r) || ee.equals(f, r) || ee.isAncestor(f, r) ? (ee.endsBefore(p, r) && (r[p.length - 1] -= 1), r[f.length - 1] += 1) : ee.endsBefore(p, r) && (ee.equals(f, r) && (r[f.length - 1] += 1), r[p.length - 1] -= 1);
        break;
      }
    }
    return r;
  }
};
function uf(e) {
  "@babel/helpers - typeof";
  return uf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, uf(e);
}
function Rhe(e, t) {
  if (uf(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (uf(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Phe(e) {
  var t = Rhe(e, "string");
  return uf(t) === "symbol" ? t : String(t);
}
function qi(e, t, n) {
  return t = Phe(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function NC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Wd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? NC(Object(n), !0).forEach(function(r) {
      qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : NC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var _he = (e, t, n) => {
  switch (n.type) {
    case "insert_node": {
      var {
        path: r,
        node: i
      } = n, o = Te.parent(e, r), a = r[r.length - 1];
      if (a > o.children.length)
        throw new Error('Cannot apply an "insert_node" operation at path ['.concat(r, "] because the destination is past the end of the node."));
      if (o.children.splice(a, 0, i), t)
        for (var [s, l] of ke.points(t))
          t[l] = Ut.transform(s, n);
      break;
    }
    case "insert_text": {
      var {
        path: u,
        offset: d,
        text: p
      } = n;
      if (p.length === 0) break;
      var f = Te.leaf(e, u), m = f.text.slice(0, d), y = f.text.slice(d);
      if (f.text = m + p + y, t)
        for (var [g, x] of ke.points(t))
          t[x] = Ut.transform(g, n);
      break;
    }
    case "merge_node": {
      var {
        path: E
      } = n, b = Te.get(e, E), C = ee.previous(E), T = Te.get(e, C), z = Te.parent(e, E), I = E[E.length - 1];
      if (xt.isText(b) && xt.isText(T))
        T.text += b.text;
      else if (!xt.isText(b) && !xt.isText(T))
        T.children.push(...b.children);
      else
        throw new Error('Cannot apply a "merge_node" operation at path ['.concat(E, "] to nodes of different interfaces: ").concat(Gr.stringify(b), " ").concat(Gr.stringify(T)));
      if (z.children.splice(I, 1), t)
        for (var [w, M] of ke.points(t))
          t[M] = Ut.transform(w, n);
      break;
    }
    case "move_node": {
      var {
        path: R,
        newPath: F
      } = n;
      if (ee.isAncestor(R, F))
        throw new Error("Cannot move a path [".concat(R, "] to new path [").concat(F, "] because the destination is inside itself."));
      var W = Te.get(e, R), X = Te.parent(e, R), le = R[R.length - 1];
      X.children.splice(le, 1);
      var ne = ee.transform(R, n), fe = Te.get(e, ee.parent(ne)), D = ne[ne.length - 1];
      if (fe.children.splice(D, 0, W), t)
        for (var [j, de] of ke.points(t))
          t[de] = Ut.transform(j, n);
      break;
    }
    case "remove_node": {
      var {
        path: ye
      } = n, Ne = ye[ye.length - 1], Me = Te.parent(e, ye);
      if (Me.children.splice(Ne, 1), t)
        for (var [Ie, at] of ke.points(t)) {
          var Ve = Ut.transform(Ie, n);
          if (t != null && Ve != null)
            t[at] = Ve;
          else {
            var mt = void 0, ae = void 0;
            for (var [Se, Ae] of Te.texts(e))
              if (ee.compare(Ae, ye) === -1)
                mt = [Se, Ae];
              else {
                ae = [Se, Ae];
                break;
              }
            var Be = !1;
            mt && ae && (ee.equals(ae[1], ye) ? Be = !ee.hasPrevious(ae[1]) : Be = ee.common(mt[1], ye).length < ee.common(ae[1], ye).length), mt && !Be ? (Ie.path = mt[1], Ie.offset = mt[0].text.length) : ae ? (Ie.path = ae[1], Ie.offset = 0) : t = null;
          }
        }
      break;
    }
    case "remove_text": {
      var {
        path: Ze,
        offset: We,
        text: St
      } = n;
      if (St.length === 0) break;
      var pt = Te.leaf(e, Ze), Tt = pt.text.slice(0, We), Wt = pt.text.slice(We + St.length);
      if (pt.text = Tt + Wt, t)
        for (var [et, At] of ke.points(t))
          t[At] = Ut.transform(et, n);
      break;
    }
    case "set_node": {
      var {
        path: Gt,
        properties: Lt,
        newProperties: ct
      } = n;
      if (Gt.length === 0)
        throw new Error("Cannot set properties on the root node!");
      var re = Te.get(e, Gt);
      for (var $e in ct) {
        if ($e === "children" || $e === "text")
          throw new Error('Cannot set the "'.concat($e, '" property of nodes!'));
        var vt = ct[$e];
        vt == null ? delete re[$e] : re[$e] = vt;
      }
      for (var rt in Lt)
        ct.hasOwnProperty(rt) || delete re[rt];
      break;
    }
    case "set_selection": {
      var {
        newProperties: Dt
      } = n;
      if (Dt == null)
        t = Dt;
      else {
        if (t == null) {
          if (!ke.isRange(Dt))
            throw new Error('Cannot apply an incomplete "set_selection" operation properties '.concat(Gr.stringify(Dt), " when there is no current selection."));
          t = Wd({}, Dt);
        }
        for (var tn in Dt) {
          var Xn = Dt[tn];
          if (Xn == null) {
            if (tn === "anchor" || tn === "focus")
              throw new Error('Cannot remove the "'.concat(tn, '" selection property'));
            delete t[tn];
          } else
            t[tn] = Xn;
        }
      }
      break;
    }
    case "split_node": {
      var {
        path: In,
        position: Qn,
        properties: Yn
      } = n;
      if (In.length === 0)
        throw new Error('Cannot apply a "split_node" operation at path ['.concat(In, "] because the root node cannot be split."));
      var Ce = Te.get(e, In), xe = Te.parent(e, In), Oe = In[In.length - 1], Ft;
      if (xt.isText(Ce)) {
        var on = Ce.text.slice(0, Qn), yr = Ce.text.slice(Qn);
        Ce.text = on, Ft = Wd(Wd({}, Yn), {}, {
          text: yr
        });
      } else {
        var Ho = Ce.children.slice(0, Qn), cn = Ce.children.slice(Qn);
        Ce.children = Ho, Ft = Wd(Wd({}, Yn), {}, {
          children: cn
        });
      }
      if (xe.children.splice(Oe + 1, 0, Ft), t)
        for (var [Jn, un] of ke.points(t))
          t[un] = Ut.transform(Jn, n);
      break;
    }
  }
  return t;
}, qhe = {
  transform(e, t) {
    e.children = vb(e.children);
    var n = e.selection && vb(e.selection);
    try {
      n = _he(e, n, t);
    } finally {
      e.children = yb(e.children), n ? e.selection = pu(n) ? yb(n) : n : e.selection = null;
    }
  }
}, $he = {
  insertNodes(e, t, n) {
    e.insertNodes(t, n);
  },
  liftNodes(e, t) {
    e.liftNodes(t);
  },
  mergeNodes(e, t) {
    e.mergeNodes(t);
  },
  moveNodes(e, t) {
    e.moveNodes(t);
  },
  removeNodes(e, t) {
    e.removeNodes(t);
  },
  setNodes(e, t, n) {
    e.setNodes(t, n);
  },
  splitNodes(e, t) {
    e.splitNodes(t);
  },
  unsetNodes(e, t, n) {
    e.unsetNodes(t, n);
  },
  unwrapNodes(e, t) {
    e.unwrapNodes(t);
  },
  wrapNodes(e, t, n) {
    e.wrapNodes(t, n);
  }
}, Hhe = {
  collapse(e, t) {
    e.collapse(t);
  },
  deselect(e) {
    e.deselect();
  },
  move(e, t) {
    e.move(t);
  },
  select(e, t) {
    e.select(t);
  },
  setPoint(e, t, n) {
    e.setPoint(t, n);
  },
  setSelection(e, t) {
    e.setSelection(t);
  }
}, VL = (e, t) => {
  for (var n in e) {
    var r = e[n], i = t[n];
    if (gi(r) && gi(i)) {
      if (!VL(r, i)) return !1;
    } else if (Array.isArray(r) && Array.isArray(i)) {
      if (r.length !== i.length) return !1;
      for (var o = 0; o < r.length; o++)
        if (r[o] !== i[o]) return !1;
    } else if (r !== i)
      return !1;
  }
  for (var a in t)
    if (e[a] === void 0 && t[a] !== void 0)
      return !1;
  return !0;
};
function Vhe(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function hl(e, t) {
  if (e == null) return {};
  var n = Vhe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
var Uhe = ["anchor", "focus"];
function OC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Whe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? OC(Object(n), !0).forEach(function(r) {
      qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : OC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var ke = {
  edges(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: n = !1
    } = t, {
      anchor: r,
      focus: i
    } = e;
    return ke.isBackward(e) === n ? [r, i] : [i, r];
  },
  end(e) {
    var [, t] = ke.edges(e);
    return t;
  },
  equals(e, t) {
    return Ut.equals(e.anchor, t.anchor) && Ut.equals(e.focus, t.focus);
  },
  surrounds(e, t) {
    var n = ke.intersection(e, t);
    return n ? ke.equals(n, t) : !1;
  },
  includes(e, t) {
    if (ke.isRange(t)) {
      if (ke.includes(e, t.anchor) || ke.includes(e, t.focus))
        return !0;
      var [n, r] = ke.edges(e), [i, o] = ke.edges(t);
      return Ut.isBefore(n, i) && Ut.isAfter(r, o);
    }
    var [a, s] = ke.edges(e), l = !1, u = !1;
    return Ut.isPoint(t) ? (l = Ut.compare(t, a) >= 0, u = Ut.compare(t, s) <= 0) : (l = ee.compare(t, a.path) >= 0, u = ee.compare(t, s.path) <= 0), l && u;
  },
  intersection(e, t) {
    var n = hl(e, Uhe), [r, i] = ke.edges(e), [o, a] = ke.edges(t), s = Ut.isBefore(r, o) ? o : r, l = Ut.isBefore(i, a) ? i : a;
    return Ut.isBefore(l, s) ? null : Whe({
      anchor: s,
      focus: l
    }, n);
  },
  isBackward(e) {
    var {
      anchor: t,
      focus: n
    } = e;
    return Ut.isAfter(t, n);
  },
  isCollapsed(e) {
    var {
      anchor: t,
      focus: n
    } = e;
    return Ut.equals(t, n);
  },
  isExpanded(e) {
    return !ke.isCollapsed(e);
  },
  isForward(e) {
    return !ke.isBackward(e);
  },
  isRange(e) {
    return gi(e) && Ut.isPoint(e.anchor) && Ut.isPoint(e.focus);
  },
  *points(e) {
    yield [e.anchor, "anchor"], yield [e.focus, "focus"];
  },
  start(e) {
    var [t] = ke.edges(e);
    return t;
  },
  transform(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return kf(e, (r) => {
      if (r === null)
        return null;
      var {
        affinity: i = "inward"
      } = n, o, a;
      if (i === "inward") {
        var s = ke.isCollapsed(r);
        ke.isForward(r) ? (o = "forward", a = s ? o : "backward") : (o = "backward", a = s ? o : "forward");
      } else i === "outward" ? ke.isForward(r) ? (o = "backward", a = "forward") : (o = "forward", a = "backward") : (o = i, a = i);
      var l = Ut.transform(r.anchor, t, {
        affinity: o
      }), u = Ut.transform(r.focus, t, {
        affinity: a
      });
      if (!l || !u)
        return null;
      r.anchor = l, r.focus = u;
    });
  }
}, zC = (e) => gi(e) && Te.isNodeList(e.children) && !q.isEditor(e), Je = {
  isAncestor(e) {
    return gi(e) && Te.isNodeList(e.children);
  },
  isElement: zC,
  isElementList(e) {
    return Array.isArray(e) && e.every((t) => Je.isElement(t));
  },
  isElementProps(e) {
    return e.children !== void 0;
  },
  isElementType: function(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "type";
    return zC(e) && e[n] === t;
  },
  matches(e, t) {
    for (var n in t)
      if (n !== "children" && e[n] !== t[n])
        return !1;
    return !0;
  }
}, Zhe = ["children"], Ghe = ["text"], FC = /* @__PURE__ */ new WeakMap(), Te = {
  ancestor(e, t) {
    var n = Te.get(e, t);
    if (xt.isText(n))
      throw new Error("Cannot get the ancestor node at path [".concat(t, "] because it refers to a text node instead: ").concat(Gr.stringify(n)));
    return n;
  },
  ancestors(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return function* () {
      for (var r of ee.ancestors(t, n)) {
        var i = Te.ancestor(e, r), o = [i, r];
        yield o;
      }
    }();
  },
  child(e, t) {
    if (xt.isText(e))
      throw new Error("Cannot get the child of a text node: ".concat(Gr.stringify(e)));
    var n = e.children[t];
    if (n == null)
      throw new Error("Cannot get child at index `".concat(t, "` in node: ").concat(Gr.stringify(e)));
    return n;
  },
  children(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return function* () {
      for (var {
        reverse: r = !1
      } = n, i = Te.ancestor(e, t), {
        children: o
      } = i, a = r ? o.length - 1 : 0; r ? a >= 0 : a < o.length; ) {
        var s = Te.child(i, a), l = t.concat(a);
        yield [s, l], a = r ? a - 1 : a + 1;
      }
    }();
  },
  common(e, t, n) {
    var r = ee.common(t, n), i = Te.get(e, r);
    return [i, r];
  },
  descendant(e, t) {
    var n = Te.get(e, t);
    if (q.isEditor(n))
      throw new Error("Cannot get the descendant node at path [".concat(t, "] because it refers to the root editor node instead: ").concat(Gr.stringify(n)));
    return n;
  },
  descendants(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function* () {
      for (var [n, r] of Te.nodes(e, t))
        r.length !== 0 && (yield [n, r]);
    }();
  },
  elements(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function* () {
      for (var [n, r] of Te.nodes(e, t))
        Je.isElement(n) && (yield [n, r]);
    }();
  },
  extractProps(e) {
    if (Je.isAncestor(e)) {
      var t = hl(e, Zhe);
      return t;
    } else {
      var t = hl(e, Ghe);
      return t;
    }
  },
  first(e, t) {
    for (var n = t.slice(), r = Te.get(e, n); r && !(xt.isText(r) || r.children.length === 0); )
      r = r.children[0], n.push(0);
    return [r, n];
  },
  fragment(e, t) {
    if (xt.isText(e))
      throw new Error("Cannot get a fragment starting from a root text node: ".concat(Gr.stringify(e)));
    var n = kf({
      children: e.children
    }, (r) => {
      var [i, o] = ke.edges(t), a = Te.nodes(r, {
        reverse: !0,
        pass: (f) => {
          var [, m] = f;
          return !ke.includes(t, m);
        }
      });
      for (var [, s] of a) {
        if (!ke.includes(t, s)) {
          var l = Te.parent(r, s), u = s[s.length - 1];
          l.children.splice(u, 1);
        }
        if (ee.equals(s, o.path)) {
          var d = Te.leaf(r, s);
          d.text = d.text.slice(0, o.offset);
        }
        if (ee.equals(s, i.path)) {
          var p = Te.leaf(r, s);
          p.text = p.text.slice(i.offset);
        }
      }
      q.isEditor(r) && (r.selection = null);
    });
    return n.children;
  },
  get(e, t) {
    var n = Te.getIf(e, t);
    if (n === void 0)
      throw new Error("Cannot find a descendant at path [".concat(t, "] in node: ").concat(Gr.stringify(e)));
    return n;
  },
  getIf(e, t) {
    for (var n = e, r = 0; r < t.length; r++) {
      var i = t[r];
      if (xt.isText(n) || !n.children[i])
        return;
      n = n.children[i];
    }
    return n;
  },
  has(e, t) {
    for (var n = e, r = 0; r < t.length; r++) {
      var i = t[r];
      if (xt.isText(n) || !n.children[i])
        return !1;
      n = n.children[i];
    }
    return !0;
  },
  isNode(e) {
    return xt.isText(e) || Je.isElement(e) || q.isEditor(e);
  },
  isNodeList(e) {
    if (!Array.isArray(e))
      return !1;
    var t = FC.get(e);
    if (t !== void 0)
      return t;
    var n = e.every((r) => Te.isNode(r));
    return FC.set(e, n), n;
  },
  last(e, t) {
    for (var n = t.slice(), r = Te.get(e, n); r && !(xt.isText(r) || r.children.length === 0); ) {
      var i = r.children.length - 1;
      r = r.children[i], n.push(i);
    }
    return [r, n];
  },
  leaf(e, t) {
    var n = Te.get(e, t);
    if (!xt.isText(n))
      throw new Error("Cannot get the leaf node at path [".concat(t, "] because it refers to a non-leaf node: ").concat(Gr.stringify(n)));
    return n;
  },
  levels(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return function* () {
      for (var r of ee.levels(t, n)) {
        var i = Te.get(e, r);
        yield [i, r];
      }
    }();
  },
  matches(e, t) {
    return Je.isElement(e) && Je.isElementProps(t) && Je.matches(e, t) || xt.isText(e) && xt.isTextProps(t) && xt.matches(e, t);
  },
  nodes(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function* () {
      for (var {
        pass: n,
        reverse: r = !1
      } = t, {
        from: i = [],
        to: o
      } = t, a = /* @__PURE__ */ new Set(), s = [], l = e; !(o && (r ? ee.isBefore(s, o) : ee.isAfter(s, o))); ) {
        if (a.has(l) || (yield [l, s]), !a.has(l) && !xt.isText(l) && l.children.length !== 0 && (n == null || n([l, s]) === !1)) {
          a.add(l);
          var u = r ? l.children.length - 1 : 0;
          ee.isAncestor(s, i) && (u = i[s.length]), s = s.concat(u), l = Te.get(e, s);
          continue;
        }
        if (s.length === 0)
          break;
        if (!r) {
          var d = ee.next(s);
          if (Te.has(e, d)) {
            s = d, l = Te.get(e, s);
            continue;
          }
        }
        if (r && s[s.length - 1] !== 0) {
          var p = ee.previous(s);
          s = p, l = Te.get(e, s);
          continue;
        }
        s = ee.parent(s), l = Te.get(e, s), a.add(l);
      }
    }();
  },
  parent(e, t) {
    var n = ee.parent(t), r = Te.get(e, n);
    if (xt.isText(r))
      throw new Error("Cannot get the parent of path [".concat(t, "] because it does not exist in the root."));
    return r;
  },
  string(e) {
    return xt.isText(e) ? e.text : e.children.map(Te.string).join("");
  },
  texts(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function* () {
      for (var [n, r] of Te.nodes(e, t))
        xt.isText(n) && (yield [n, r]);
    }();
  }
};
function LC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Wn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? LC(Object(n), !0).forEach(function(r) {
      qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : LC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var sp = {
  isNodeOperation(e) {
    return sp.isOperation(e) && e.type.endsWith("_node");
  },
  isOperation(e) {
    if (!gi(e))
      return !1;
    switch (e.type) {
      case "insert_node":
        return ee.isPath(e.path) && Te.isNode(e.node);
      case "insert_text":
        return typeof e.offset == "number" && typeof e.text == "string" && ee.isPath(e.path);
      case "merge_node":
        return typeof e.position == "number" && ee.isPath(e.path) && gi(e.properties);
      case "move_node":
        return ee.isPath(e.path) && ee.isPath(e.newPath);
      case "remove_node":
        return ee.isPath(e.path) && Te.isNode(e.node);
      case "remove_text":
        return typeof e.offset == "number" && typeof e.text == "string" && ee.isPath(e.path);
      case "set_node":
        return ee.isPath(e.path) && gi(e.properties) && gi(e.newProperties);
      case "set_selection":
        return e.properties === null && ke.isRange(e.newProperties) || e.newProperties === null && ke.isRange(e.properties) || gi(e.properties) && gi(e.newProperties);
      case "split_node":
        return ee.isPath(e.path) && typeof e.position == "number" && gi(e.properties);
      default:
        return !1;
    }
  },
  isOperationList(e) {
    return Array.isArray(e) && e.every((t) => sp.isOperation(t));
  },
  isSelectionOperation(e) {
    return sp.isOperation(e) && e.type.endsWith("_selection");
  },
  isTextOperation(e) {
    return sp.isOperation(e) && e.type.endsWith("_text");
  },
  inverse(e) {
    switch (e.type) {
      case "insert_node":
        return Wn(Wn({}, e), {}, {
          type: "remove_node"
        });
      case "insert_text":
        return Wn(Wn({}, e), {}, {
          type: "remove_text"
        });
      case "merge_node":
        return Wn(Wn({}, e), {}, {
          type: "split_node",
          path: ee.previous(e.path)
        });
      case "move_node": {
        var {
          newPath: t,
          path: n
        } = e;
        if (ee.equals(t, n))
          return e;
        if (ee.isSibling(n, t))
          return Wn(Wn({}, e), {}, {
            path: t,
            newPath: n
          });
        var r = ee.transform(n, e), i = ee.transform(ee.next(n), e);
        return Wn(Wn({}, e), {}, {
          path: r,
          newPath: i
        });
      }
      case "remove_node":
        return Wn(Wn({}, e), {}, {
          type: "insert_node"
        });
      case "remove_text":
        return Wn(Wn({}, e), {}, {
          type: "insert_text"
        });
      case "set_node": {
        var {
          properties: o,
          newProperties: a
        } = e;
        return Wn(Wn({}, e), {}, {
          properties: a,
          newProperties: o
        });
      }
      case "set_selection": {
        var {
          properties: s,
          newProperties: l
        } = e;
        return s == null ? Wn(Wn({}, e), {}, {
          properties: l,
          newProperties: null
        }) : l == null ? Wn(Wn({}, e), {}, {
          properties: null,
          newProperties: s
        }) : Wn(Wn({}, e), {}, {
          properties: l,
          newProperties: s
        });
      }
      case "split_node":
        return Wn(Wn({}, e), {}, {
          type: "merge_node",
          path: ee.next(e.path)
        });
    }
  }
}, MC = /* @__PURE__ */ new WeakMap(), Khe = (e) => {
  var t = MC.get(e);
  if (t !== void 0)
    return t;
  if (!gi(e))
    return !1;
  var n = typeof e.addMark == "function" && typeof e.apply == "function" && typeof e.deleteFragment == "function" && typeof e.insertBreak == "function" && typeof e.insertSoftBreak == "function" && typeof e.insertFragment == "function" && typeof e.insertNode == "function" && typeof e.insertText == "function" && typeof e.isElementReadOnly == "function" && typeof e.isInline == "function" && typeof e.isSelectable == "function" && typeof e.isVoid == "function" && typeof e.normalizeNode == "function" && typeof e.onChange == "function" && typeof e.removeMark == "function" && typeof e.getDirtyPaths == "function" && (e.marks === null || gi(e.marks)) && (e.selection === null || ke.isRange(e.selection)) && Te.isNodeList(e.children) && sp.isOperationList(e.operations);
  return MC.set(e, n), n;
}, q = {
  above(e, t) {
    return e.above(t);
  },
  addMark(e, t, n) {
    e.addMark(t, n);
  },
  after(e, t, n) {
    return e.after(t, n);
  },
  before(e, t, n) {
    return e.before(t, n);
  },
  deleteBackward(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      unit: n = "character"
    } = t;
    e.deleteBackward(n);
  },
  deleteForward(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      unit: n = "character"
    } = t;
    e.deleteForward(n);
  },
  deleteFragment(e, t) {
    e.deleteFragment(t);
  },
  edges(e, t) {
    return e.edges(t);
  },
  elementReadOnly(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return e.elementReadOnly(t);
  },
  end(e, t) {
    return e.end(t);
  },
  first(e, t) {
    return e.first(t);
  },
  fragment(e, t) {
    return e.fragment(t);
  },
  hasBlocks(e, t) {
    return e.hasBlocks(t);
  },
  hasInlines(e, t) {
    return e.hasInlines(t);
  },
  hasPath(e, t) {
    return e.hasPath(t);
  },
  hasTexts(e, t) {
    return e.hasTexts(t);
  },
  insertBreak(e) {
    e.insertBreak();
  },
  insertFragment(e, t, n) {
    e.insertFragment(t, n);
  },
  insertNode(e, t) {
    e.insertNode(t);
  },
  insertSoftBreak(e) {
    e.insertSoftBreak();
  },
  insertText(e, t) {
    e.insertText(t);
  },
  isBlock(e, t) {
    return e.isBlock(t);
  },
  isEdge(e, t, n) {
    return e.isEdge(t, n);
  },
  isEditor(e) {
    return Khe(e);
  },
  isElementReadOnly(e, t) {
    return e.isElementReadOnly(t);
  },
  isEmpty(e, t) {
    return e.isEmpty(t);
  },
  isEnd(e, t, n) {
    return e.isEnd(t, n);
  },
  isInline(e, t) {
    return e.isInline(t);
  },
  isNormalizing(e) {
    return e.isNormalizing();
  },
  isSelectable(e, t) {
    return e.isSelectable(t);
  },
  isStart(e, t, n) {
    return e.isStart(t, n);
  },
  isVoid(e, t) {
    return e.isVoid(t);
  },
  last(e, t) {
    return e.last(t);
  },
  leaf(e, t, n) {
    return e.leaf(t, n);
  },
  levels(e, t) {
    return e.levels(t);
  },
  marks(e) {
    return e.getMarks();
  },
  next(e, t) {
    return e.next(t);
  },
  node(e, t, n) {
    return e.node(t, n);
  },
  nodes(e, t) {
    return e.nodes(t);
  },
  normalize(e, t) {
    e.normalize(t);
  },
  parent(e, t, n) {
    return e.parent(t, n);
  },
  path(e, t, n) {
    return e.path(t, n);
  },
  pathRef(e, t, n) {
    return e.pathRef(t, n);
  },
  pathRefs(e) {
    return e.pathRefs();
  },
  point(e, t, n) {
    return e.point(t, n);
  },
  pointRef(e, t, n) {
    return e.pointRef(t, n);
  },
  pointRefs(e) {
    return e.pointRefs();
  },
  positions(e, t) {
    return e.positions(t);
  },
  previous(e, t) {
    return e.previous(t);
  },
  range(e, t, n) {
    return e.range(t, n);
  },
  rangeRef(e, t, n) {
    return e.rangeRef(t, n);
  },
  rangeRefs(e) {
    return e.rangeRefs();
  },
  removeMark(e, t) {
    e.removeMark(t);
  },
  setNormalizing(e, t) {
    e.setNormalizing(t);
  },
  start(e, t) {
    return e.start(t);
  },
  string(e, t, n) {
    return e.string(t, n);
  },
  unhangRange(e, t, n) {
    return e.unhangRange(t, n);
  },
  void(e, t) {
    return e.void(t);
  },
  withoutNormalizing(e, t) {
    e.withoutNormalizing(t);
  },
  shouldMergeNodesRemovePrevNode: (e, t, n) => e.shouldMergeNodesRemovePrevNode(t, n)
}, a8 = {
  isSpan(e) {
    return Array.isArray(e) && e.length === 2 && e.every(ee.isPath);
  }
};
function BC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function IC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? BC(Object(n), !0).forEach(function(r) {
      qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : BC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Ut = {
  compare(e, t) {
    var n = ee.compare(e.path, t.path);
    return n === 0 ? e.offset < t.offset ? -1 : e.offset > t.offset ? 1 : 0 : n;
  },
  isAfter(e, t) {
    return Ut.compare(e, t) === 1;
  },
  isBefore(e, t) {
    return Ut.compare(e, t) === -1;
  },
  equals(e, t) {
    return e.offset === t.offset && ee.equals(e.path, t.path);
  },
  isPoint(e) {
    return gi(e) && typeof e.offset == "number" && ee.isPath(e.path);
  },
  transform(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return kf(e, (r) => {
      if (r === null)
        return null;
      var {
        affinity: i = "forward"
      } = n, {
        path: o,
        offset: a
      } = r;
      switch (t.type) {
        case "insert_node":
        case "move_node": {
          r.path = ee.transform(o, t, n);
          break;
        }
        case "insert_text": {
          ee.equals(t.path, o) && (t.offset < a || t.offset === a && i === "forward") && (r.offset += t.text.length);
          break;
        }
        case "merge_node": {
          ee.equals(t.path, o) && (r.offset += t.position), r.path = ee.transform(o, t, n);
          break;
        }
        case "remove_text": {
          ee.equals(t.path, o) && t.offset <= a && (r.offset -= Math.min(a - t.offset, t.text.length));
          break;
        }
        case "remove_node": {
          if (ee.equals(t.path, o) || ee.isAncestor(t.path, o))
            return null;
          r.path = ee.transform(o, t, n);
          break;
        }
        case "split_node": {
          if (ee.equals(t.path, o)) {
            if (t.position === a && i == null)
              return null;
            (t.position < a || t.position === a && i === "forward") && (r.offset -= t.position, r.path = ee.transform(o, t, IC(IC({}, n), {}, {
              affinity: "forward"
            })));
          } else
            r.path = ee.transform(o, t, n);
          break;
        }
      }
    });
  }
}, RC = void 0, Gr = {
  setScrubber(e) {
    RC = e;
  },
  stringify(e) {
    return JSON.stringify(e, RC);
  }
}, Xhe = ["text"], Qhe = ["anchor", "focus"];
function PC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ms(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? PC(Object(n), !0).forEach(function(r) {
      qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : PC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var xt = {
  equals(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      loose: r = !1
    } = n;
    function i(o) {
      var a = hl(o, Xhe);
      return a;
    }
    return VL(r ? i(e) : e, r ? i(t) : t);
  },
  isText(e) {
    return gi(e) && typeof e.text == "string";
  },
  isTextList(e) {
    return Array.isArray(e) && e.every((t) => xt.isText(t));
  },
  isTextProps(e) {
    return e.text !== void 0;
  },
  matches(e, t) {
    for (var n in t)
      if (n !== "text" && (!e.hasOwnProperty(n) || e[n] !== t[n]))
        return !1;
    return !0;
  },
  decorations(e, t) {
    var n = [Ms({}, e)];
    for (var r of t) {
      var i = hl(r, Qhe), [o, a] = ke.edges(r), s = [], l = 0, u = o.offset, d = a.offset;
      for (var p of n) {
        var {
          length: f
        } = p.text, m = l;
        if (l += f, u <= m && l <= d) {
          Object.assign(p, i), s.push(p);
          continue;
        }
        if (u !== d && (u === l || d === m) || u > l || d < m || d === m && m !== 0) {
          s.push(p);
          continue;
        }
        var y = p, g = void 0, x = void 0;
        if (d < l) {
          var E = d - m;
          x = Ms(Ms({}, y), {}, {
            text: y.text.slice(E)
          }), y = Ms(Ms({}, y), {}, {
            text: y.text.slice(0, E)
          });
        }
        if (u > m) {
          var b = u - m;
          g = Ms(Ms({}, y), {}, {
            text: y.text.slice(0, b)
          }), y = Ms(Ms({}, y), {}, {
            text: y.text.slice(b)
          });
        }
        Object.assign(y, i), g && s.push(g), s.push(y), x && s.push(x);
      }
      n = s;
    }
    return n;
  }
}, s8 = (e) => e.selection ? e.selection : e.children.length > 0 ? q.end(e, []) : [0], wd = (e, t) => {
  var [n] = q.node(e, t);
  return (r) => r === n;
}, l8 = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = !t, r = t ? r1e(e) : e, i = Vt.None, o = Vt.None, a = 0, s = null, l = null;
  for (var u of r) {
    var d = u.codePointAt(0);
    if (!d) break;
    var p = m1e(u, d);
    if ([i, o] = n ? [o, p] : [p, i], w0(i, Vt.ZWJ) && w0(o, Vt.ExtPict) && (n ? s = _C(e.substring(0, a)) : s = _C(e.substring(0, e.length - a)), !s) || w0(i, Vt.RI) && w0(o, Vt.RI) && (l !== null ? l = !l : n ? l = !0 : l = b1e(e.substring(0, e.length - a)), !l) || i !== Vt.None && o !== Vt.None && v1e(i, o))
      break;
    a += u.length;
  }
  return a || 1;
}, Yhe = /\s/, Jhe = /[\u002B\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, e1e = /['\u2018\u2019]/, t1e = function(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = 0, r = !1; e.length > 0; ) {
    var i = l8(e, t), [o, a] = u8(e, i, t);
    if (n1e(o, a, t))
      r = !0, n += i;
    else if (!r)
      n += i;
    else
      break;
    e = a;
  }
  return n;
}, u8 = (e, t, n) => {
  if (n) {
    var r = e.length - t;
    return [e.slice(r, e.length), e.slice(0, r)];
  }
  return [e.slice(0, t), e.slice(t)];
}, n1e = function e(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (Yhe.test(t))
    return !1;
  if (e1e.test(t)) {
    var i = l8(n, r), [o, a] = u8(n, i, r);
    if (e(o, a, r))
      return !0;
  }
  return !Jhe.test(t);
}, r1e = function* (e) {
  for (var t = e.length - 1, n = 0; n < e.length; n++) {
    var r = e.charAt(t - n);
    if (o1e(r.charCodeAt(0))) {
      var i = e.charAt(t - n - 1);
      if (i1e(i.charCodeAt(0))) {
        yield i + r, n++;
        continue;
      }
    }
    yield r;
  }
}, i1e = (e) => e >= 55296 && e <= 56319, o1e = (e) => e >= 56320 && e <= 57343, Vt;
(function(e) {
  e[e.None = 0] = "None", e[e.Extend = 1] = "Extend", e[e.ZWJ = 2] = "ZWJ", e[e.RI = 4] = "RI", e[e.Prepend = 8] = "Prepend", e[e.SpacingMark = 16] = "SpacingMark", e[e.L = 32] = "L", e[e.V = 64] = "V", e[e.T = 128] = "T", e[e.LV = 256] = "LV", e[e.LVT = 512] = "LVT", e[e.ExtPict = 1024] = "ExtPict", e[e.Any = 2048] = "Any";
})(Vt || (Vt = {}));
var a1e = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3C\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732\u1733\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDE41\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4\uDF00\uDF01\uDF36-\uDF3A\uDF40\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/, s1e = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/, l1e = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/, u1e = /^[\u1100-\u115F\uA960-\uA97C]$/, c1e = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/, d1e = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/, p1e = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/, f1e = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/, h1e = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/, m1e = (e, t) => {
  var n = Vt.Any;
  return e.search(a1e) !== -1 && (n |= Vt.Extend), t === 8205 && (n |= Vt.ZWJ), t >= 127462 && t <= 127487 && (n |= Vt.RI), e.search(s1e) !== -1 && (n |= Vt.Prepend), e.search(l1e) !== -1 && (n |= Vt.SpacingMark), e.search(u1e) !== -1 && (n |= Vt.L), e.search(c1e) !== -1 && (n |= Vt.V), e.search(d1e) !== -1 && (n |= Vt.T), e.search(p1e) !== -1 && (n |= Vt.LV), e.search(f1e) !== -1 && (n |= Vt.LVT), e.search(h1e) !== -1 && (n |= Vt.ExtPict), n;
};
function w0(e, t) {
  return (e & t) !== 0;
}
var g1e = [
  // GB6
  [Vt.L, Vt.L | Vt.V | Vt.LV | Vt.LVT],
  // GB7
  [Vt.LV | Vt.V, Vt.V | Vt.T],
  // GB8
  [Vt.LVT | Vt.T, Vt.T],
  // GB9
  [Vt.Any, Vt.Extend | Vt.ZWJ],
  // GB9a
  [Vt.Any, Vt.SpacingMark],
  // GB9b
  [Vt.Prepend, Vt.Any],
  // GB11
  [Vt.ZWJ, Vt.ExtPict],
  // GB12 and GB13
  [Vt.RI, Vt.RI]
];
function v1e(e, t) {
  return g1e.findIndex((n) => w0(e, n[0]) && w0(t, n[1])) === -1;
}
var y1e = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3C\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732\u1733\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDE41\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4\uDF00\uDF01\uDF36-\uDF3A\uDF40\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/, _C = (e) => e.search(y1e) !== -1, x1e = /(?:\uD83C[\uDDE6-\uDDFF])+$/g, b1e = (e) => {
  var t = e.match(x1e);
  if (t === null)
    return !1;
  var n = t[0].length / 2;
  return n % 2 === 1;
}, w1e = {
  delete(e, t) {
    e.delete(t);
  },
  insertFragment(e, t, n) {
    e.insertFragment(t, n);
  },
  insertText(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    q.withoutNormalizing(e, () => {
      var {
        voids: r = !1
      } = n, {
        at: i = s8(e)
      } = n;
      if (ee.isPath(i) && (i = q.range(e, i)), ke.isRange(i))
        if (ke.isCollapsed(i))
          i = i.anchor;
        else {
          var o = ke.end(i);
          if (!r && q.void(e, {
            at: o
          }))
            return;
          var a = ke.start(i), s = q.pointRef(e, a), l = q.pointRef(e, o);
          ge.delete(e, {
            at: i,
            voids: r
          });
          var u = s.unref(), d = l.unref();
          i = u || d, ge.setSelection(e, {
            anchor: i,
            focus: i
          });
        }
      if (!(!r && q.void(e, {
        at: i
      }) || q.elementReadOnly(e, {
        at: i
      }))) {
        var {
          path: p,
          offset: f
        } = i;
        t.length > 0 && e.apply({
          type: "insert_text",
          path: p,
          offset: f,
          text: t
        });
      }
    });
  }
};
function qC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function o1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qC(Object(n), !0).forEach(function(r) {
      qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var ge = o1(o1(o1(o1({}, qhe), $he), Hhe), w1e), H1 = /* @__PURE__ */ new WeakMap(), C1e = (e) => H1.get(e) || !1, k1e = (e, t, n) => {
  var r = H1.get(e) || !1;
  H1.set(e, !0);
  try {
    t(), n();
  } finally {
    H1.set(e, r);
  }
};
function UL(e, t, n) {
  var r = Xm.get(e) || [], i = Qm.get(e) || /* @__PURE__ */ new Set(), o, a, s = (p) => {
    if (p) {
      var f = p.join(",");
      a.has(f) || (a.add(f), o.push(p));
    }
  };
  if (n) {
    o = [], a = /* @__PURE__ */ new Set();
    for (var l of r) {
      var u = n(l);
      s(u);
    }
  } else
    o = r, a = i;
  for (var d of t)
    s(d);
  Xm.set(e, o), Qm.set(e, a);
}
var E1e = (e, t) => {
  for (var n of q.pathRefs(e))
    Mhe.transform(n, t);
  for (var r of q.pointRefs(e))
    Bhe.transform(r, t);
  for (var i of q.rangeRefs(e))
    Ihe.transform(i, t);
  if (!C1e(e)) {
    var o = ee.operationCanTransformPath(t) ? (a) => ee.transform(a, t) : void 0;
    UL(e, e.getDirtyPaths(t), o);
  }
  ge.transform(e, t), e.operations.push(t), q.normalize(e, {
    operation: t
  }), t.type === "set_selection" && (e.marks = null), Dp.get(e) || (Dp.set(e, !0), Promise.resolve().then(() => {
    Dp.set(e, !1), e.onChange({
      operation: t
    }), e.operations = [];
  }));
}, S1e = (e, t) => {
  switch (t.type) {
    case "insert_text":
    case "remove_text":
    case "set_node": {
      var {
        path: n
      } = t;
      return ee.levels(n);
    }
    case "insert_node": {
      var {
        node: r,
        path: i
      } = t, o = ee.levels(i), a = xt.isText(r) ? [] : Array.from(Te.nodes(r), (F) => {
        var [, W] = F;
        return i.concat(W);
      });
      return [...o, ...a];
    }
    case "merge_node": {
      var {
        path: s
      } = t, l = ee.ancestors(s), u = ee.previous(s);
      return [...l, u];
    }
    case "move_node": {
      var {
        path: d,
        newPath: p
      } = t;
      if (ee.equals(d, p))
        return [];
      var f = [], m = [];
      for (var y of ee.ancestors(d)) {
        var g = ee.transform(y, t);
        f.push(g);
      }
      for (var x of ee.ancestors(p)) {
        var E = ee.transform(x, t);
        m.push(E);
      }
      var b = m[m.length - 1], C = p[p.length - 1], T = b.concat(C);
      return [...f, ...m, T];
    }
    case "remove_node": {
      var {
        path: z
      } = t, I = ee.ancestors(z);
      return [...I];
    }
    case "split_node": {
      var {
        path: w
      } = t, M = ee.levels(w), R = ee.next(w);
      return [...M, R];
    }
    default:
      return [];
  }
}, D1e = (e) => {
  var {
    selection: t
  } = e;
  return t ? Te.fragment(e, t) : [];
}, A1e = (e, t) => {
  var [n, r] = t;
  if (!xt.isText(n)) {
    if (Je.isElement(n) && n.children.length === 0) {
      var i = {
        text: ""
      };
      ge.insertNodes(e, i, {
        at: r.concat(0),
        voids: !0
      });
      return;
    }
    for (var o = q.isEditor(n) ? !1 : Je.isElement(n) && (e.isInline(n) || n.children.length === 0 || xt.isText(n.children[0]) || e.isInline(n.children[0])), a = 0, s = 0; s < n.children.length; s++, a++) {
      var l = Te.get(e, r);
      if (!xt.isText(l)) {
        var u = l.children[a], d = l.children[a - 1], p = s === n.children.length - 1, f = xt.isText(u) || Je.isElement(u) && e.isInline(u);
        if (f !== o)
          ge.removeNodes(e, {
            at: r.concat(a),
            voids: !0
          }), a--;
        else if (Je.isElement(u)) {
          if (e.isInline(u)) {
            if (d == null || !xt.isText(d)) {
              var m = {
                text: ""
              };
              ge.insertNodes(e, m, {
                at: r.concat(a),
                voids: !0
              }), a++;
            } else if (p) {
              var y = {
                text: ""
              };
              ge.insertNodes(e, y, {
                at: r.concat(a + 1),
                voids: !0
              }), a++;
            }
          }
        } else {
          if (!xt.isText(u) && !("children" in u)) {
            var g = u;
            g.children = [];
          }
          d != null && xt.isText(d) && (xt.equals(u, d, {
            loose: !0
          }) ? (ge.mergeNodes(e, {
            at: r.concat(a),
            voids: !0
          }), a--) : d.text === "" ? (ge.removeNodes(e, {
            at: r.concat(a - 1),
            voids: !0
          }), a--) : u.text === "" && (ge.removeNodes(e, {
            at: r.concat(a),
            voids: !0
          }), a--));
        }
      }
    }
  }
}, T1e = (e, t) => {
  var {
    iteration: n,
    initialDirtyPathsLength: r
  } = t, i = r * 42;
  if (n > i)
    throw new Error("Could not completely normalize the editor after ".concat(i, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state."));
  return !0;
}, j1e = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    voids: n = !1,
    mode: r = "lowest",
    at: i = e.selection,
    match: o
  } = t;
  if (i) {
    var a = q.path(e, i), s = r === "lowest";
    for (var [l, u] of q.levels(e, {
      at: a,
      voids: n,
      match: o,
      reverse: s
    }))
      if (!xt.isText(l)) {
        if (ke.isRange(i)) {
          if (ee.isAncestor(u, i.anchor.path) && ee.isAncestor(u, i.focus.path))
            return [l, u];
        } else if (!ee.equals(a, u))
          return [l, u];
      }
  }
};
function $C(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function HC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $C(Object(n), !0).forEach(function(r) {
      qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $C(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var N1e = (e, t, n) => {
  var {
    selection: r
  } = e;
  if (r) {
    var i = (p, f) => {
      if (!xt.isText(p))
        return !1;
      var [m, y] = q.parent(e, f);
      return !e.isVoid(m) || e.markableVoid(m);
    }, o = ke.isExpanded(r), a = !1;
    if (!o) {
      var [s, l] = q.node(e, r);
      if (s && i(s, l)) {
        var [u] = q.parent(e, l);
        a = u && e.markableVoid(u);
      }
    }
    if (o || a)
      ge.setNodes(e, {
        [t]: n
      }, {
        match: i,
        split: !0,
        voids: !0
      });
    else {
      var d = HC(HC({}, q.marks(e) || {}), {}, {
        [t]: n
      });
      e.marks = d, Dp.get(e) || e.onChange();
    }
  }
};
function VC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function UC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? VC(Object(n), !0).forEach(function(r) {
      qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : VC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var O1e = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = q.point(e, t, {
    edge: "end"
  }), i = q.end(e, []), o = {
    anchor: r,
    focus: i
  }, {
    distance: a = 1
  } = n, s = 0, l;
  for (var u of q.positions(e, UC(UC({}, n), {}, {
    at: o
  }))) {
    if (s > a)
      break;
    s !== 0 && (l = u), s++;
  }
  return l;
};
function WC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ZC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? WC(Object(n), !0).forEach(function(r) {
      qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : WC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var z1e = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = q.start(e, []), i = q.point(e, t, {
    edge: "start"
  }), o = {
    anchor: r,
    focus: i
  }, {
    distance: a = 1
  } = n, s = 0, l;
  for (var u of q.positions(e, ZC(ZC({}, n), {}, {
    at: o,
    reverse: !0
  }))) {
    if (s > a)
      break;
    s !== 0 && (l = u), s++;
  }
  return l;
}, F1e = (e, t) => {
  var {
    selection: n
  } = e;
  n && ke.isCollapsed(n) && ge.delete(e, {
    unit: t,
    reverse: !0
  });
}, L1e = (e, t) => {
  var {
    selection: n
  } = e;
  n && ke.isCollapsed(n) && ge.delete(e, {
    unit: t
  });
}, M1e = function(e) {
  var {
    direction: t = "forward"
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    selection: n
  } = e;
  n && ke.isExpanded(n) && ge.delete(e, {
    reverse: t === "backward"
  });
}, B1e = (e, t) => [q.start(e, t), q.end(e, t)];
function GC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function KC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? GC(Object(n), !0).forEach(function(r) {
      qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : GC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var I1e = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return q.above(e, KC(KC({}, t), {}, {
    match: (n) => Je.isElement(n) && q.isElementReadOnly(e, n)
  }));
}, R1e = (e, t) => q.point(e, t, {
  edge: "end"
}), P1e = (e, t) => {
  var n = q.path(e, t, {
    edge: "start"
  });
  return q.node(e, n);
}, _1e = (e, t) => {
  var n = q.range(e, t);
  return Te.fragment(e, n);
};
function XC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function QC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? XC(Object(n), !0).forEach(function(r) {
      qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : XC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var q1e = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return q.above(e, QC(QC({}, t), {}, {
    match: (n) => Je.isElement(n) && q.isVoid(e, n)
  }));
}, $1e = (e, t) => t.children.some((n) => Je.isElement(n) && q.isBlock(e, n)), H1e = (e, t) => t.children.some((n) => xt.isText(n) || q.isInline(e, n)), V1e = (e, t) => Te.has(e, t), U1e = (e, t) => t.children.every((n) => xt.isText(n)), W1e = (e) => {
  ge.splitNodes(e, {
    always: !0
  });
}, Z1e = (e, t, n) => {
  ge.insertNodes(e, t, n);
}, G1e = (e) => {
  ge.splitNodes(e, {
    always: !0
  });
};
function YC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function K1e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? YC(Object(n), !0).forEach(function(r) {
      qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : YC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var X1e = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    selection: r,
    marks: i
  } = e;
  if (r) {
    if (i) {
      var o = K1e({
        text: t
      }, i);
      ge.insertNodes(e, o, {
        at: n.at,
        voids: n.voids
      });
    } else
      ge.insertText(e, t, n);
    e.marks = null;
  }
}, Q1e = (e, t) => !e.isInline(t), Y1e = (e, t, n) => q.isStart(e, t, n) || q.isEnd(e, t, n), J1e = (e, t) => {
  var {
    children: n
  } = t, [r] = n;
  return n.length === 0 || n.length === 1 && xt.isText(r) && r.text === "" && !e.isVoid(t);
}, eme = (e, t, n) => {
  var r = q.end(e, n);
  return Ut.equals(t, r);
}, tme = (e) => {
  var t = HL.get(e);
  return t === void 0 ? !0 : t;
}, nme = (e, t, n) => {
  if (t.offset !== 0)
    return !1;
  var r = q.start(e, n);
  return Ut.equals(t, r);
}, rme = (e, t) => {
  var n = q.path(e, t, {
    edge: "end"
  });
  return q.node(e, n);
}, ime = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = q.path(e, t, n), i = Te.leaf(e, r);
  return [i, r];
};
function ome(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function* () {
    var {
      at: n = e.selection,
      reverse: r = !1,
      voids: i = !1
    } = t, {
      match: o
    } = t;
    if (o == null && (o = () => !0), !!n) {
      var a = [], s = q.path(e, n);
      for (var [l, u] of Te.levels(e, s))
        if (o(l, u) && (a.push([l, u]), !i && Je.isElement(l) && q.isVoid(e, l)))
          break;
      r && a.reverse(), yield* a;
    }
  }();
}
var ame = ["text"], sme = ["text"], lme = function(e) {
  var {
    marks: t,
    selection: n
  } = e;
  if (!n)
    return null;
  var {
    anchor: r,
    focus: i
  } = n;
  if (t)
    return t;
  if (ke.isExpanded(n)) {
    var o = ke.isBackward(n);
    o && ([i, r] = [r, i]);
    var a = q.isEnd(e, r, r.path);
    if (a) {
      var s = q.after(e, r);
      s && (r = s);
    }
    var [l] = q.nodes(e, {
      match: xt.isText,
      at: {
        anchor: r,
        focus: i
      }
    });
    if (l) {
      var [u] = l, d = hl(u, ame);
      return d;
    } else
      return {};
  }
  var {
    path: p
  } = r, [f] = q.leaf(e, p);
  if (r.offset === 0) {
    var m = q.previous(e, {
      at: p,
      match: xt.isText
    }), y = q.above(e, {
      match: (T) => Je.isElement(T) && q.isVoid(e, T) && e.markableVoid(T)
    });
    if (!y) {
      var g = q.above(e, {
        match: (T) => Je.isElement(T) && q.isBlock(e, T)
      });
      if (m && g) {
        var [x, E] = m, [, b] = g;
        ee.isAncestor(b, E) && (f = x);
      }
    }
  }
  var C = hl(f, sme);
  return C;
}, ume = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    mode: n = "lowest",
    voids: r = !1
  } = t, {
    match: i,
    at: o = e.selection
  } = t;
  if (o) {
    var a = q.after(e, o, {
      voids: r
    });
    if (a) {
      var [, s] = q.last(e, []), l = [a.path, s];
      if (ee.isPath(o) && o.length === 0)
        throw new Error("Cannot get the next node from the root node!");
      if (i == null)
        if (ee.isPath(o)) {
          var [u] = q.parent(e, o);
          i = (p) => u.children.includes(p);
        } else
          i = () => !0;
      var [d] = q.nodes(e, {
        at: l,
        match: i,
        mode: n,
        voids: r
      });
      return d;
    }
  }
}, cme = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = q.path(e, t, n), i = Te.get(e, r);
  return [i, r];
};
function dme(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function* () {
    var {
      at: n = e.selection,
      mode: r = "all",
      universal: i = !1,
      reverse: o = !1,
      voids: a = !1,
      ignoreNonSelectable: s = !1
    } = t, {
      match: l
    } = t;
    if (l || (l = () => !0), !!n) {
      var u, d;
      if (a8.isSpan(n))
        u = n[0], d = n[1];
      else {
        var p = q.path(e, n, {
          edge: "start"
        }), f = q.path(e, n, {
          edge: "end"
        });
        u = o ? f : p, d = o ? p : f;
      }
      var m = Te.nodes(e, {
        reverse: o,
        from: u,
        to: d,
        pass: (T) => {
          var [z] = T;
          return Je.isElement(z) ? !!(!a && (q.isVoid(e, z) || q.isElementReadOnly(e, z)) || s && !q.isSelectable(e, z)) : !1;
        }
      }), y = [], g;
      for (var [x, E] of m)
        if (!(s && Je.isElement(x) && !q.isSelectable(e, x))) {
          var b = g && ee.compare(E, g[1]) === 0;
          if (!(r === "highest" && b)) {
            if (!l(x, E)) {
              if (i && !b && xt.isText(x))
                return;
              continue;
            }
            if (r === "lowest" && b) {
              g = [x, E];
              continue;
            }
            var C = r === "lowest" ? g : [x, E];
            C && (i ? y.push(C) : yield C), g = [x, E];
          }
        }
      r === "lowest" && g && (i ? y.push(g) : yield g), i && (yield* y);
    }
  }();
}
var pme = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    force: n = !1,
    operation: r
  } = t, i = (u) => Xm.get(u) || [], o = (u) => Qm.get(u) || /* @__PURE__ */ new Set(), a = (u) => {
    var d = i(u).pop(), p = d.join(",");
    return o(u).delete(p), d;
  };
  if (q.isNormalizing(e)) {
    if (n) {
      var s = Array.from(Te.nodes(e), (u) => {
        var [, d] = u;
        return d;
      }), l = new Set(s.map((u) => u.join(",")));
      Xm.set(e, s), Qm.set(e, l);
    }
    i(e).length !== 0 && q.withoutNormalizing(e, () => {
      for (var u of i(e))
        if (Te.has(e, u)) {
          var d = q.node(e, u), [p, f] = d;
          Je.isElement(p) && p.children.length === 0 && e.normalizeNode(d, {
            operation: r
          });
        }
      for (var m = i(e), y = m.length, g = 0; m.length !== 0; ) {
        if (!e.shouldNormalize({
          dirtyPaths: m,
          iteration: g,
          initialDirtyPathsLength: y,
          operation: r
        }))
          return;
        var x = a(e);
        if (Te.has(e, x)) {
          var E = q.node(e, x);
          e.normalizeNode(E, {
            operation: r
          });
        }
        g++, m = i(e);
      }
    });
  }
}, fme = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = q.path(e, t, n), i = ee.parent(r), o = q.node(e, i);
  return o;
}, hme = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    affinity: r = "forward"
  } = n, i = {
    current: t,
    affinity: r,
    unref() {
      var {
        current: a
      } = i, s = q.pathRefs(e);
      return s.delete(i), i.current = null, a;
    }
  }, o = q.pathRefs(e);
  return o.add(i), i;
}, mme = (e) => {
  var t = AC.get(e);
  return t || (t = /* @__PURE__ */ new Set(), AC.set(e, t)), t;
}, gme = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    depth: r,
    edge: i
  } = n;
  if (ee.isPath(t)) {
    if (i === "start") {
      var [, o] = Te.first(e, t);
      t = o;
    } else if (i === "end") {
      var [, a] = Te.last(e, t);
      t = a;
    }
  }
  return ke.isRange(t) && (i === "start" ? t = ke.start(t) : i === "end" ? t = ke.end(t) : t = ee.common(t.anchor.path, t.focus.path)), Ut.isPoint(t) && (t = t.path), r != null && (t = t.slice(0, r)), t;
}, vme = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    affinity: r = "forward"
  } = n, i = {
    current: t,
    affinity: r,
    unref() {
      var {
        current: a
      } = i, s = q.pointRefs(e);
      return s.delete(i), i.current = null, a;
    }
  }, o = q.pointRefs(e);
  return o.add(i), i;
}, yme = (e) => {
  var t = TC.get(e);
  return t || (t = /* @__PURE__ */ new Set(), TC.set(e, t)), t;
}, xme = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    edge: r = "start"
  } = n;
  if (ee.isPath(t)) {
    var i;
    if (r === "end") {
      var [, o] = Te.last(e, t);
      i = o;
    } else {
      var [, a] = Te.first(e, t);
      i = a;
    }
    var s = Te.get(e, i);
    if (!xt.isText(s))
      throw new Error("Cannot get the ".concat(r, " point in the node at path [").concat(t, "] because it has no ").concat(r, " text node."));
    return {
      path: i,
      offset: r === "end" ? s.text.length : 0
    };
  }
  if (ke.isRange(t)) {
    var [l, u] = ke.edges(t);
    return r === "start" ? l : u;
  }
  return t;
};
function bme(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function* () {
    var {
      at: n = e.selection,
      unit: r = "offset",
      reverse: i = !1,
      voids: o = !1,
      ignoreNonSelectable: a = !1
    } = t;
    if (!n)
      return;
    var s = q.range(e, n), [l, u] = ke.edges(s), d = i ? u : l, p = !1, f = "", m = 0, y = 0, g = 0;
    for (var [x, E] of q.nodes(e, {
      at: n,
      reverse: i,
      voids: o,
      ignoreNonSelectable: a
    })) {
      if (Je.isElement(x)) {
        if (!o && (e.isVoid(x) || e.isElementReadOnly(x))) {
          yield q.start(e, E);
          continue;
        }
        if (e.isInline(x)) continue;
        if (q.hasInlines(e, x)) {
          var b = ee.isAncestor(E, u.path) ? u : q.end(e, E), C = ee.isAncestor(E, l.path) ? l : q.start(e, E);
          f = q.string(e, {
            anchor: C,
            focus: b
          }, {
            voids: o
          }), p = !0;
        }
      }
      if (xt.isText(x)) {
        var T = ee.equals(E, d.path);
        for (T ? (y = i ? d.offset : x.text.length - d.offset, g = d.offset) : (y = x.text.length, g = i ? y : 0), (T || p || r === "offset") && (yield {
          path: E,
          offset: g
        }, p = !1); ; ) {
          if (m === 0) {
            if (f === "") break;
            m = z(f, r, i), f = u8(f, m, i)[1];
          }
          if (g = i ? g - m : g + m, y = y - m, y < 0) {
            m = -y;
            break;
          }
          m = 0, yield {
            path: E,
            offset: g
          };
        }
      }
    }
    function z(I, w, M) {
      return w === "character" ? l8(I, M) : w === "word" ? t1e(I, M) : w === "line" || w === "block" ? I.length : 1;
    }
  }();
}
var wme = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    mode: n = "lowest",
    voids: r = !1
  } = t, {
    match: i,
    at: o = e.selection
  } = t;
  if (o) {
    var a = q.before(e, o, {
      voids: r
    });
    if (a) {
      var [, s] = q.first(e, []), l = [a.path, s];
      if (ee.isPath(o) && o.length === 0)
        throw new Error("Cannot get the previous node from the root node!");
      if (i == null)
        if (ee.isPath(o)) {
          var [u] = q.parent(e, o);
          i = (p) => u.children.includes(p);
        } else
          i = () => !0;
      var [d] = q.nodes(e, {
        reverse: !0,
        at: l,
        match: i,
        mode: n,
        voids: r
      });
      return d;
    }
  }
}, Cme = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    affinity: r = "forward"
  } = n, i = {
    current: t,
    affinity: r,
    unref() {
      var {
        current: a
      } = i, s = q.rangeRefs(e);
      return s.delete(i), i.current = null, a;
    }
  }, o = q.rangeRefs(e);
  return o.add(i), i;
}, kme = (e) => {
  var t = jC.get(e);
  return t || (t = /* @__PURE__ */ new Set(), jC.set(e, t)), t;
}, Eme = (e, t, n) => {
  if (ke.isRange(t) && !n)
    return t;
  var r = q.start(e, t), i = q.end(e, n || t);
  return {
    anchor: r,
    focus: i
  };
};
function JC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Sme(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? JC(Object(n), !0).forEach(function(r) {
      qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : JC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Dme = (e, t) => {
  var {
    selection: n
  } = e;
  if (n) {
    var r = (d, p) => {
      if (!xt.isText(d))
        return !1;
      var [f, m] = q.parent(e, p);
      return !e.isVoid(f) || e.markableVoid(f);
    }, i = ke.isExpanded(n), o = !1;
    if (!i) {
      var [a, s] = q.node(e, n);
      if (a && r(a, s)) {
        var [l] = q.parent(e, s);
        o = l && e.markableVoid(l);
      }
    }
    if (i || o)
      ge.unsetNodes(e, t, {
        match: r,
        split: !0,
        voids: !0
      });
    else {
      var u = Sme({}, q.marks(e) || {});
      delete u[t], e.marks = u, Dp.get(e) || e.onChange();
    }
  }
}, Ame = (e, t) => {
  HL.set(e, t);
}, Tme = (e, t) => q.point(e, t, {
  edge: "start"
}), jme = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    voids: r = !1
  } = n, i = q.range(e, t), [o, a] = ke.edges(i), s = "";
  for (var [l, u] of q.nodes(e, {
    at: i,
    match: xt.isText,
    voids: r
  })) {
    var d = l.text;
    ee.equals(u, a.path) && (d = d.slice(0, a.offset)), ee.equals(u, o.path) && (d = d.slice(o.offset)), s += d;
  }
  return s;
}, Nme = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    voids: r = !1
  } = n, [i, o] = ke.edges(t);
  if (i.offset !== 0 || o.offset !== 0 || ke.isCollapsed(t) || ee.hasPrevious(o.path))
    return t;
  var a = q.above(e, {
    at: o,
    match: (m) => Je.isElement(m) && q.isBlock(e, m),
    voids: r
  }), s = a ? a[1] : [], l = q.start(e, i), u = {
    anchor: l,
    focus: o
  }, d = !0;
  for (var [p, f] of q.nodes(e, {
    at: u,
    match: xt.isText,
    reverse: !0,
    voids: r
  })) {
    if (d) {
      d = !1;
      continue;
    }
    if (p.text !== "" || ee.isBefore(f, s)) {
      o = {
        path: f,
        offset: p.text.length
      };
      break;
    }
  }
  return {
    anchor: i,
    focus: o
  };
}, V5 = (e, t) => {
  var n = q.isNormalizing(e);
  q.setNormalizing(e, !1);
  try {
    t();
  } finally {
    q.setNormalizing(e, n);
  }
  q.normalize(e);
}, Ome = (e, t, n) => {
  var [r, i] = t;
  return Je.isElement(r) && q.isEmpty(e, r) || xt.isText(r) && r.text === "" && i[i.length - 1] !== 0;
}, zme = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  q.withoutNormalizing(e, () => {
    var n, r, {
      reverse: i = !1,
      unit: o = "character",
      distance: a = 1,
      voids: s = !1
    } = t, {
      at: l = e.selection,
      hanging: u = !1
    } = t;
    if (l) {
      var d = !1;
      if (ke.isRange(l) && ke.isCollapsed(l) && (d = !0, l = l.anchor), Ut.isPoint(l)) {
        var p = q.void(e, {
          at: l,
          mode: "highest"
        });
        if (!s && p) {
          var [, f] = p;
          l = f;
        } else {
          var m = {
            unit: o,
            distance: a
          }, y = i ? q.before(e, l, m) || q.start(e, []) : q.after(e, l, m) || q.end(e, []);
          l = {
            anchor: l,
            focus: y
          }, u = !0;
        }
      }
      if (ee.isPath(l)) {
        ge.removeNodes(e, {
          at: l,
          voids: s
        });
        return;
      }
      if (!ke.isCollapsed(l)) {
        if (!u) {
          var [, g] = ke.edges(l), x = q.end(e, []);
          Ut.equals(g, x) || (l = q.unhangRange(e, l, {
            voids: s
          }));
        }
        var [E, b] = ke.edges(l), C = q.above(e, {
          match: (pt) => Je.isElement(pt) && q.isBlock(e, pt),
          at: E,
          voids: s
        }), T = q.above(e, {
          match: (pt) => Je.isElement(pt) && q.isBlock(e, pt),
          at: b,
          voids: s
        }), z = C && T && !ee.equals(C[1], T[1]), I = ee.equals(E.path, b.path), w = s ? null : (n = q.void(e, {
          at: E,
          mode: "highest"
        })) !== null && n !== void 0 ? n : q.elementReadOnly(e, {
          at: E,
          mode: "highest"
        }), M = s ? null : (r = q.void(e, {
          at: b,
          mode: "highest"
        })) !== null && r !== void 0 ? r : q.elementReadOnly(e, {
          at: b,
          mode: "highest"
        });
        if (w) {
          var R = q.before(e, E);
          R && C && ee.isAncestor(C[1], R.path) && (E = R);
        }
        if (M) {
          var F = q.after(e, b);
          F && T && ee.isAncestor(T[1], F.path) && (b = F);
        }
        var W = [], X;
        for (var le of q.nodes(e, {
          at: l,
          voids: s
        })) {
          var [ne, fe] = le;
          X && ee.compare(fe, X) === 0 || (!s && Je.isElement(ne) && (q.isVoid(e, ne) || q.isElementReadOnly(e, ne)) || !ee.isCommon(fe, E.path) && !ee.isCommon(fe, b.path)) && (W.push(le), X = fe);
        }
        var D = Array.from(W, (pt) => {
          var [, Tt] = pt;
          return q.pathRef(e, Tt);
        }), j = q.pointRef(e, E), de = q.pointRef(e, b), ye = "";
        if (!I && !w) {
          var Ne = j.current, [Me] = q.leaf(e, Ne), {
            path: Ie
          } = Ne, {
            offset: at
          } = E, Ve = Me.text.slice(at);
          Ve.length > 0 && (e.apply({
            type: "remove_text",
            path: Ie,
            offset: at,
            text: Ve
          }), ye = Ve);
        }
        if (D.reverse().map((pt) => pt.unref()).filter((pt) => pt !== null).forEach((pt) => ge.removeNodes(e, {
          at: pt,
          voids: s
        })), !M) {
          var mt = de.current, [ae] = q.leaf(e, mt), {
            path: Se
          } = mt, Ae = I ? E.offset : 0, Be = ae.text.slice(Ae, b.offset);
          Be.length > 0 && (e.apply({
            type: "remove_text",
            path: Se,
            offset: Ae,
            text: Be
          }), ye = Be);
        }
        !I && z && de.current && j.current && ge.mergeNodes(e, {
          at: de.current,
          hanging: !0,
          voids: s
        }), d && i && o === "character" && ye.length > 1 && ye.match(/[\u0E00-\u0E7F]+/) && ge.insertText(e, ye.slice(0, ye.length - a));
        var Ze = j.unref(), We = de.unref(), St = i ? Ze || We : We || Ze;
        t.at == null && St && ge.select(e, St);
      }
    }
  });
}, Fme = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  q.withoutNormalizing(e, () => {
    var {
      hanging: r = !1,
      voids: i = !1
    } = n, {
      at: o = s8(e),
      batchDirty: a = !0
    } = n;
    if (t.length) {
      if (ke.isRange(o))
        if (r || (o = q.unhangRange(e, o, {
          voids: i
        })), ke.isCollapsed(o))
          o = o.anchor;
        else {
          var [, s] = ke.edges(o);
          if (!i && q.void(e, {
            at: s
          }))
            return;
          var l = q.pointRef(e, s);
          ge.delete(e, {
            at: o
          }), o = l.unref();
        }
      else ee.isPath(o) && (o = q.start(e, o));
      if (!(!i && q.void(e, {
        at: o
      }))) {
        var u = q.above(e, {
          at: o,
          match: (Ve) => Je.isElement(Ve) && q.isInline(e, Ve),
          mode: "highest",
          voids: i
        });
        if (u) {
          var [, d] = u;
          if (q.isEnd(e, o, d)) {
            var p = q.after(e, d);
            o = p;
          } else if (q.isStart(e, o, d)) {
            var f = q.before(e, d);
            o = f;
          }
        }
        var m = q.above(e, {
          match: (Ve) => Je.isElement(Ve) && q.isBlock(e, Ve),
          at: o,
          voids: i
        }), [, y] = m, g = q.isStart(e, o, y), x = q.isEnd(e, o, y), E = g && x, b = !g || g && x, C = !x, [, T] = Te.first({
          children: t
        }, []), [, z] = Te.last({
          children: t
        }, []), I = [], w = (Ve) => {
          var [mt, ae] = Ve, Se = ae.length === 0;
          return Se ? !1 : E ? !0 : !(b && ee.isAncestor(ae, T) && Je.isElement(mt) && !e.isVoid(mt) && !e.isInline(mt) || C && ee.isAncestor(ae, z) && Je.isElement(mt) && !e.isVoid(mt) && !e.isInline(mt));
        };
        for (var M of Te.nodes({
          children: t
        }, {
          pass: w
        }))
          w(M) && I.push(M);
        var R = [], F = [], W = [], X = !0, le = !1;
        for (var [ne] of I)
          Je.isElement(ne) && !e.isInline(ne) ? (X = !1, le = !0, F.push(ne)) : X ? R.push(ne) : W.push(ne);
        var [fe] = q.nodes(e, {
          at: o,
          match: (Ve) => xt.isText(Ve) || q.isInline(e, Ve),
          mode: "highest",
          voids: i
        }), [, D] = fe, j = q.isStart(e, o, D), de = q.isEnd(e, o, D), ye = q.pathRef(e, x && !W.length ? ee.next(y) : y), Ne = q.pathRef(e, de ? ee.next(D) : D);
        ge.splitNodes(e, {
          at: o,
          match: (Ve) => le ? Je.isElement(Ve) && q.isBlock(e, Ve) : xt.isText(Ve) || q.isInline(e, Ve),
          mode: le ? "lowest" : "highest",
          always: le && (!g || R.length > 0) && (!x || W.length > 0),
          voids: i
        });
        var Me = q.pathRef(e, !j || j && de ? ee.next(D) : D);
        if (ge.insertNodes(e, R, {
          at: Me.current,
          match: (Ve) => xt.isText(Ve) || q.isInline(e, Ve),
          mode: "highest",
          voids: i,
          batchDirty: a
        }), E && !R.length && F.length && !W.length && ge.delete(e, {
          at: y,
          voids: i
        }), ge.insertNodes(e, F, {
          at: ye.current,
          match: (Ve) => Je.isElement(Ve) && q.isBlock(e, Ve),
          mode: "lowest",
          voids: i,
          batchDirty: a
        }), ge.insertNodes(e, W, {
          at: Ne.current,
          match: (Ve) => xt.isText(Ve) || q.isInline(e, Ve),
          mode: "highest",
          voids: i,
          batchDirty: a
        }), !n.at) {
          var Ie;
          if (W.length > 0 && Ne.current ? Ie = ee.previous(Ne.current) : F.length > 0 && ye.current ? Ie = ee.previous(ye.current) : Me.current && (Ie = ee.previous(Me.current)), Ie) {
            var at = q.end(e, Ie);
            ge.select(e, at);
          }
        }
        Me.unref(), ye.unref(), Ne.unref();
      }
    }
  });
}, Lme = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    edge: n = "anchor"
  } = t, {
    selection: r
  } = e;
  if (r) {
    if (n === "anchor")
      ge.select(e, r.anchor);
    else if (n === "focus")
      ge.select(e, r.focus);
    else if (n === "start") {
      var [i] = ke.edges(r);
      ge.select(e, i);
    } else if (n === "end") {
      var [, o] = ke.edges(r);
      ge.select(e, o);
    }
  } else return;
}, Mme = (e) => {
  var {
    selection: t
  } = e;
  t && e.apply({
    type: "set_selection",
    properties: t,
    newProperties: null
  });
}, Bme = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    selection: n
  } = e, {
    distance: r = 1,
    unit: i = "character",
    reverse: o = !1
  } = t, {
    edge: a = null
  } = t;
  if (n) {
    a === "start" && (a = ke.isBackward(n) ? "focus" : "anchor"), a === "end" && (a = ke.isBackward(n) ? "anchor" : "focus");
    var {
      anchor: s,
      focus: l
    } = n, u = {
      distance: r,
      unit: i,
      ignoreNonSelectable: !0
    }, d = {};
    if (a == null || a === "anchor") {
      var p = o ? q.before(e, s, u) : q.after(e, s, u);
      p && (d.anchor = p);
    }
    if (a == null || a === "focus") {
      var f = o ? q.before(e, l, u) : q.after(e, l, u);
      f && (d.focus = f);
    }
    ge.setSelection(e, d);
  }
}, Ime = (e, t) => {
  var {
    selection: n
  } = e;
  if (t = q.range(e, t), n) {
    ge.setSelection(e, t);
    return;
  }
  if (!ke.isRange(t))
    throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(Gr.stringify(t)));
  e.apply({
    type: "set_selection",
    properties: n,
    newProperties: t
  });
};
function ek(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function tk(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ek(Object(n), !0).forEach(function(r) {
      qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ek(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Rme = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    selection: r
  } = e, {
    edge: i = "both"
  } = n;
  if (r) {
    i === "start" && (i = ke.isBackward(r) ? "focus" : "anchor"), i === "end" && (i = ke.isBackward(r) ? "anchor" : "focus");
    var {
      anchor: o,
      focus: a
    } = r, s = i === "anchor" ? o : a;
    ge.setSelection(e, {
      [i === "anchor" ? "anchor" : "focus"]: tk(tk({}, s), t)
    });
  }
}, Pme = (e, t) => {
  var {
    selection: n
  } = e, r = {}, i = {};
  if (n) {
    for (var o in t)
      (o === "anchor" && t.anchor != null && !Ut.equals(t.anchor, n.anchor) || o === "focus" && t.focus != null && !Ut.equals(t.focus, n.focus) || o !== "anchor" && o !== "focus" && t[o] !== n[o]) && (r[o] = n[o], i[o] = t[o]);
    Object.keys(r).length > 0 && e.apply({
      type: "set_selection",
      properties: r,
      newProperties: i
    });
  }
}, _me = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  q.withoutNormalizing(e, () => {
    var {
      hanging: r = !1,
      voids: i = !1,
      mode: o = "lowest",
      batchDirty: a = !0
    } = n, {
      at: s,
      match: l,
      select: u
    } = n;
    if (Te.isNode(t) && (t = [t]), t.length !== 0) {
      var [d] = t;
      if (s || (s = s8(e), u !== !1 && (u = !0)), u == null && (u = !1), ke.isRange(s))
        if (r || (s = q.unhangRange(e, s, {
          voids: i
        })), ke.isCollapsed(s))
          s = s.anchor;
        else {
          var [, p] = ke.edges(s), f = q.pointRef(e, p);
          ge.delete(e, {
            at: s
          }), s = f.unref();
        }
      if (Ut.isPoint(s)) {
        l == null && (xt.isText(d) ? l = (R) => xt.isText(R) : e.isInline(d) ? l = (R) => xt.isText(R) || q.isInline(e, R) : l = (R) => Je.isElement(R) && q.isBlock(e, R));
        var [m] = q.nodes(e, {
          at: s.path,
          match: l,
          mode: o,
          voids: i
        });
        if (m) {
          var [, y] = m, g = q.pathRef(e, y), x = q.isEnd(e, s, y);
          ge.splitNodes(e, {
            at: s,
            match: l,
            mode: o,
            voids: i
          });
          var E = g.unref();
          s = x ? ee.next(E) : E;
        } else
          return;
      }
      var b = ee.parent(s), C = s[s.length - 1];
      if (!(!i && q.void(e, {
        at: b
      }))) {
        if (a) {
          var T = [], z = ee.levels(b);
          k1e(e, () => {
            var R = function() {
              var W = b.concat(C);
              C++;
              var X = {
                type: "insert_node",
                path: W,
                node: F
              };
              e.apply(X), s = ee.next(s), T.push(X), xt.isText ? z.push(...Array.from(Te.nodes(F), (le) => {
                var [, ne] = le;
                return W.concat(ne);
              })) : z.push(W);
            };
            for (var F of t)
              R();
          }, () => {
            UL(e, z, (R) => {
              var F = R;
              for (var W of T)
                if (ee.operationCanTransformPath(W) && (F = ee.transform(F, W), !F))
                  return null;
              return F;
            });
          });
        } else
          for (var I of t) {
            var w = b.concat(C);
            C++, e.apply({
              type: "insert_node",
              path: w,
              node: I
            }), s = ee.next(s);
          }
        if (s = ee.previous(s), u) {
          var M = q.end(e, s);
          M && ge.select(e, M);
        }
      }
    }
  });
}, qme = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  q.withoutNormalizing(e, () => {
    var {
      at: n = e.selection,
      mode: r = "lowest",
      voids: i = !1
    } = t, {
      match: o
    } = t;
    if (o == null && (o = ee.isPath(n) ? wd(e, n) : (C) => Je.isElement(C) && q.isBlock(e, C)), !!n) {
      var a = q.nodes(e, {
        at: n,
        match: o,
        mode: r,
        voids: i
      }), s = Array.from(a, (C) => {
        var [, T] = C;
        return q.pathRef(e, T);
      });
      for (var l of s) {
        var u = l.unref();
        if (u.length < 2)
          throw new Error("Cannot lift node at a path [".concat(u, "] because it has a depth of less than `2`."));
        var d = q.node(e, ee.parent(u)), [p, f] = d, m = u[u.length - 1], {
          length: y
        } = p.children;
        if (y === 1) {
          var g = ee.next(f);
          ge.moveNodes(e, {
            at: u,
            to: g,
            voids: i
          }), ge.removeNodes(e, {
            at: f,
            voids: i
          });
        } else if (m === 0)
          ge.moveNodes(e, {
            at: u,
            to: f,
            voids: i
          });
        else if (m === y - 1) {
          var x = ee.next(f);
          ge.moveNodes(e, {
            at: u,
            to: x,
            voids: i
          });
        } else {
          var E = ee.next(u), b = ee.next(f);
          ge.splitNodes(e, {
            at: E,
            voids: i
          }), ge.moveNodes(e, {
            at: u,
            to: b,
            voids: i
          });
        }
      }
    }
  });
}, $me = ["text"], Hme = ["children"], WL = (e, t) => {
  if (Je.isElement(t)) {
    var n = t;
    return q.isVoid(e, t) ? !0 : n.children.length === 1 ? WL(e, n.children[0]) : !1;
  } else return !q.isEditor(t);
}, Vme = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  q.withoutNormalizing(e, () => {
    var {
      match: n,
      at: r = e.selection
    } = t, {
      hanging: i = !1,
      voids: o = !1,
      mode: a = "lowest"
    } = t;
    if (r) {
      if (n == null)
        if (ee.isPath(r)) {
          var [s] = q.parent(e, r);
          n = (R) => s.children.includes(R);
        } else
          n = (R) => Je.isElement(R) && q.isBlock(e, R);
      if (!i && ke.isRange(r) && (r = q.unhangRange(e, r, {
        voids: o
      })), ke.isRange(r))
        if (ke.isCollapsed(r))
          r = r.anchor;
        else {
          var [, l] = ke.edges(r), u = q.pointRef(e, l);
          ge.delete(e, {
            at: r
          }), r = u.unref(), t.at == null && ge.select(e, r);
        }
      var [d] = q.nodes(e, {
        at: r,
        match: n,
        voids: o,
        mode: a
      }), p = q.previous(e, {
        at: r,
        match: n,
        voids: o,
        mode: a
      });
      if (!(!d || !p)) {
        var [f, m] = d, [y, g] = p;
        if (!(m.length === 0 || g.length === 0)) {
          var x = ee.next(g), E = ee.common(m, g), b = ee.isSibling(m, g), C = Array.from(q.levels(e, {
            at: m
          }), (R) => {
            var [F] = R;
            return F;
          }).slice(E.length).slice(0, -1), T = q.above(e, {
            at: m,
            mode: "highest",
            match: (R) => C.includes(R) && WL(e, R)
          }), z = T && q.pathRef(e, T[1]), I, w;
          if (xt.isText(f) && xt.isText(y)) {
            var M = hl(f, $me);
            w = y.text.length, I = M;
          } else if (Je.isElement(f) && Je.isElement(y)) {
            var M = hl(f, Hme);
            w = y.children.length, I = M;
          } else
            throw new Error("Cannot merge the node at path [".concat(m, "] with the previous sibling because it is not the same kind: ").concat(Gr.stringify(f), " ").concat(Gr.stringify(y)));
          b || ge.moveNodes(e, {
            at: m,
            to: x,
            voids: o
          }), z && ge.removeNodes(e, {
            at: z.current,
            voids: o
          }), q.shouldMergeNodesRemovePrevNode(e, p, d) ? ge.removeNodes(e, {
            at: g,
            voids: o
          }) : e.apply({
            type: "merge_node",
            path: x,
            position: w,
            properties: I
          }), z && z.unref();
        }
      }
    }
  });
}, Ume = (e, t) => {
  q.withoutNormalizing(e, () => {
    var {
      to: n,
      at: r = e.selection,
      mode: i = "lowest",
      voids: o = !1
    } = t, {
      match: a
    } = t;
    if (r) {
      a == null && (a = ee.isPath(r) ? wd(e, r) : (m) => Je.isElement(m) && q.isBlock(e, m));
      var s = q.pathRef(e, n), l = q.nodes(e, {
        at: r,
        match: a,
        mode: i,
        voids: o
      }), u = Array.from(l, (m) => {
        var [, y] = m;
        return q.pathRef(e, y);
      });
      for (var d of u) {
        var p = d.unref(), f = s.current;
        p.length !== 0 && e.apply({
          type: "move_node",
          path: p,
          newPath: f
        }), s.current && ee.isSibling(f, p) && ee.isAfter(f, p) && (s.current = ee.next(s.current));
      }
      s.unref();
    }
  });
}, Wme = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  q.withoutNormalizing(e, () => {
    var {
      hanging: n = !1,
      voids: r = !1,
      mode: i = "lowest"
    } = t, {
      at: o = e.selection,
      match: a
    } = t;
    if (o) {
      a == null && (a = ee.isPath(o) ? wd(e, o) : (f) => Je.isElement(f) && q.isBlock(e, f)), !n && ke.isRange(o) && (o = q.unhangRange(e, o, {
        voids: r
      }));
      var s = q.nodes(e, {
        at: o,
        match: a,
        mode: i,
        voids: r
      }), l = Array.from(s, (f) => {
        var [, m] = f;
        return q.pathRef(e, m);
      });
      for (var u of l) {
        var d = u.unref();
        if (d) {
          var [p] = q.node(e, d);
          e.apply({
            type: "remove_node",
            path: d,
            node: p
          });
        }
      }
    }
  });
}, Zme = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  q.withoutNormalizing(e, () => {
    var {
      match: r,
      at: i = e.selection,
      compare: o,
      merge: a
    } = n, {
      hanging: s = !1,
      mode: l = "lowest",
      split: u = !1,
      voids: d = !1
    } = n;
    if (i) {
      if (r == null && (r = ee.isPath(i) ? wd(e, i) : (w) => Je.isElement(w) && q.isBlock(e, w)), !s && ke.isRange(i) && (i = q.unhangRange(e, i, {
        voids: d
      })), u && ke.isRange(i)) {
        if (ke.isCollapsed(i) && q.leaf(e, i.anchor)[0].text.length > 0)
          return;
        var p = q.rangeRef(e, i, {
          affinity: "inward"
        }), [f, m] = ke.edges(i), y = l === "lowest" ? "lowest" : "highest", g = q.isEnd(e, m, m.path);
        ge.splitNodes(e, {
          at: m,
          match: r,
          mode: y,
          voids: d,
          always: !g
        });
        var x = q.isStart(e, f, f.path);
        ge.splitNodes(e, {
          at: f,
          match: r,
          mode: y,
          voids: d,
          always: !x
        }), i = p.unref(), n.at == null && ge.select(e, i);
      }
      o || (o = (w, M) => w !== M);
      for (var [E, b] of q.nodes(e, {
        at: i,
        match: r,
        mode: l,
        voids: d
      })) {
        var C = {}, T = {};
        if (b.length !== 0) {
          var z = !1;
          for (var I in t)
            I === "children" || I === "text" || o(t[I], E[I]) && (z = !0, E.hasOwnProperty(I) && (C[I] = E[I]), a ? t[I] != null && (T[I] = a(E[I], t[I])) : t[I] != null && (T[I] = t[I]));
          z && e.apply({
            type: "set_node",
            path: b,
            properties: C,
            newProperties: T
          });
        }
      }
    }
  });
}, Gme = (e, t) => {
  if (ke.isCollapsed(t))
    return t.anchor;
  var [, n] = ke.edges(t), r = q.pointRef(e, n);
  return ge.delete(e, {
    at: t
  }), r.unref();
}, Kme = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  q.withoutNormalizing(e, () => {
    var {
      mode: n = "lowest",
      voids: r = !1
    } = t, {
      match: i,
      at: o = e.selection,
      height: a = 0,
      always: s = !1
    } = t;
    if (i == null && (i = (de) => Je.isElement(de) && q.isBlock(e, de)), ke.isRange(o) && (o = Gme(e, o)), ee.isPath(o)) {
      var l = o, u = q.point(e, l), [d] = q.parent(e, l);
      i = (de) => de === d, a = u.path.length - l.length + 1, o = u, s = !0;
    }
    if (o) {
      var p = q.pointRef(e, o, {
        affinity: "backward"
      }), f;
      try {
        var [m] = q.nodes(e, {
          at: o,
          match: i,
          mode: n,
          voids: r
        });
        if (!m)
          return;
        var y = q.void(e, {
          at: o,
          mode: "highest"
        }), g = 0;
        if (!r && y) {
          var [x, E] = y;
          if (Je.isElement(x) && e.isInline(x)) {
            var b = q.after(e, E);
            if (!b) {
              var C = {
                text: ""
              }, T = ee.next(E);
              ge.insertNodes(e, C, {
                at: T,
                voids: r
              }), b = q.point(e, T);
            }
            o = b, s = !0;
          }
          var z = o.path.length - E.length;
          a = z + 1, s = !0;
        }
        f = q.pointRef(e, o);
        var I = o.path.length - a, [, w] = m, M = o.path.slice(0, I), R = a === 0 ? o.offset : o.path[I] + g;
        for (var [F, W] of q.levels(e, {
          at: M,
          reverse: !0,
          voids: r
        })) {
          var X = !1;
          if (W.length < w.length || W.length === 0 || !r && Je.isElement(F) && q.isVoid(e, F))
            break;
          var le = p.current, ne = q.isEnd(e, le, W);
          if (s || !p || !q.isEdge(e, le, W)) {
            X = !0;
            var fe = Te.extractProps(F);
            e.apply({
              type: "split_node",
              path: W,
              position: R,
              properties: fe
            });
          }
          R = W[W.length - 1] + (X || ne ? 1 : 0);
        }
        if (t.at == null) {
          var D = f.current || q.end(e, []);
          ge.select(e, D);
        }
      } finally {
        var j;
        p.unref(), (j = f) === null || j === void 0 || j.unref();
      }
    }
  });
}, Xme = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Array.isArray(t) || (t = [t]);
  var r = {};
  for (var i of t)
    r[i] = null;
  ge.setNodes(e, r, n);
}, Qme = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  q.withoutNormalizing(e, () => {
    var {
      mode: n = "lowest",
      split: r = !1,
      voids: i = !1
    } = t, {
      at: o = e.selection,
      match: a
    } = t;
    if (o) {
      a == null && (a = ee.isPath(o) ? wd(e, o) : (f) => Je.isElement(f) && q.isBlock(e, f)), ee.isPath(o) && (o = q.range(e, o));
      var s = ke.isRange(o) ? q.rangeRef(e, o) : null, l = q.nodes(e, {
        at: o,
        match: a,
        mode: n,
        voids: i
      }), u = Array.from(
        l,
        (f) => {
          var [, m] = f;
          return q.pathRef(e, m);
        }
        // unwrapNode will call liftNode which does not support splitting the node when nested.
        // If we do not reverse the order and call it from top to the bottom, it will remove all blocks
        // that wrap target node. So we reverse the order.
      ).reverse(), d = function() {
        var f = p.unref(), [m] = q.node(e, f), y = q.range(e, f);
        r && s && (y = ke.intersection(s.current, y)), ge.liftNodes(e, {
          at: y,
          match: (g) => Je.isAncestor(m) && m.children.includes(g),
          voids: i
        });
      };
      for (var p of u)
        d();
      s && s.unref();
    }
  });
};
function nk(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function rk(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nk(Object(n), !0).forEach(function(r) {
      qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nk(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Yme = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  q.withoutNormalizing(e, () => {
    var {
      mode: r = "lowest",
      split: i = !1,
      voids: o = !1
    } = n, {
      match: a,
      at: s = e.selection
    } = n;
    if (s) {
      if (a == null && (ee.isPath(s) ? a = wd(e, s) : e.isInline(t) ? a = (y) => Je.isElement(y) && q.isInline(e, y) || xt.isText(y) : a = (y) => Je.isElement(y) && q.isBlock(e, y)), i && ke.isRange(s)) {
        var [l, u] = ke.edges(s), d = q.rangeRef(e, s, {
          affinity: "inward"
        });
        ge.splitNodes(e, {
          at: u,
          match: a,
          voids: o
        }), ge.splitNodes(e, {
          at: l,
          match: a,
          voids: o
        }), s = d.unref(), n.at == null && ge.select(e, s);
      }
      var p = Array.from(q.nodes(e, {
        at: s,
        match: e.isInline(t) ? (y) => Je.isElement(y) && q.isBlock(e, y) : (y) => q.isEditor(y),
        mode: "lowest",
        voids: o
      })), f = function() {
        var y = ke.isRange(s) ? ke.intersection(s, q.range(e, m)) : s;
        if (!y)
          return 0;
        var g = Array.from(q.nodes(e, {
          at: y,
          match: a,
          mode: r,
          voids: o
        }));
        if (g.length > 0) {
          var [x] = g, E = g[g.length - 1], [, b] = x, [, C] = E;
          if (b.length === 0 && C.length === 0)
            return 0;
          var T = ee.equals(b, C) ? ee.parent(b) : ee.common(b, C), z = q.range(e, b, C), I = q.node(e, T), [w] = I, M = T.length + 1, R = ee.next(C.slice(0, M)), F = rk(rk({}, t), {}, {
            children: []
          });
          ge.insertNodes(e, F, {
            at: R,
            voids: o
          }), ge.moveNodes(e, {
            at: z,
            match: (W) => Je.isAncestor(w) && w.children.includes(W),
            to: R.concat(0),
            voids: o
          });
        }
      };
      for (var [, m] of p)
        f();
    }
  });
}, Jme = () => {
  var e = {
    children: [],
    operations: [],
    selection: null,
    marks: null,
    isElementReadOnly: () => !1,
    isInline: () => !1,
    isSelectable: () => !0,
    isVoid: () => !1,
    markableVoid: () => !1,
    onChange: () => {
    },
    // Core
    apply: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return E1e(e, ...n);
    },
    // Editor
    addMark: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return N1e(e, ...n);
    },
    deleteBackward: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return F1e(e, ...n);
    },
    deleteForward: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return L1e(e, ...n);
    },
    deleteFragment: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return M1e(e, ...n);
    },
    getFragment: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return D1e(e, ...n);
    },
    insertBreak: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return W1e(e, ...n);
    },
    insertSoftBreak: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return G1e(e, ...n);
    },
    insertFragment: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Fme(e, ...n);
    },
    insertNode: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Z1e(e, ...n);
    },
    insertText: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return X1e(e, ...n);
    },
    normalizeNode: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return A1e(e, ...n);
    },
    removeMark: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Dme(e, ...n);
    },
    getDirtyPaths: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return S1e(e, ...n);
    },
    shouldNormalize: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return T1e(e, ...n);
    },
    // Editor interface
    above: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return j1e(e, ...n);
    },
    after: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return O1e(e, ...n);
    },
    before: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return z1e(e, ...n);
    },
    collapse: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Lme(e, ...n);
    },
    delete: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return zme(e, ...n);
    },
    deselect: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Mme(e, ...n);
    },
    edges: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return B1e(e, ...n);
    },
    elementReadOnly: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return I1e(e, ...n);
    },
    end: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return R1e(e, ...n);
    },
    first: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return P1e(e, ...n);
    },
    fragment: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return _1e(e, ...n);
    },
    getMarks: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return lme(e, ...n);
    },
    hasBlocks: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return $1e(e, ...n);
    },
    hasInlines: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return H1e(e, ...n);
    },
    hasPath: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return V1e(e, ...n);
    },
    hasTexts: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return U1e(e, ...n);
    },
    insertNodes: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return _me(e, ...n);
    },
    isBlock: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Q1e(e, ...n);
    },
    isEdge: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Y1e(e, ...n);
    },
    isEmpty: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return J1e(e, ...n);
    },
    isEnd: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return eme(e, ...n);
    },
    isNormalizing: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return tme(e, ...n);
    },
    isStart: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return nme(e, ...n);
    },
    last: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return rme(e, ...n);
    },
    leaf: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return ime(e, ...n);
    },
    levels: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return ome(e, ...n);
    },
    liftNodes: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return qme(e, ...n);
    },
    mergeNodes: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Vme(e, ...n);
    },
    move: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Bme(e, ...n);
    },
    moveNodes: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Ume(e, ...n);
    },
    next: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return ume(e, ...n);
    },
    node: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return cme(e, ...n);
    },
    nodes: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return dme(e, ...n);
    },
    normalize: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return pme(e, ...n);
    },
    parent: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return fme(e, ...n);
    },
    path: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return gme(e, ...n);
    },
    pathRef: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return hme(e, ...n);
    },
    pathRefs: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return mme(e, ...n);
    },
    point: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return xme(e, ...n);
    },
    pointRef: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return vme(e, ...n);
    },
    pointRefs: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return yme(e, ...n);
    },
    positions: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return bme(e, ...n);
    },
    previous: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return wme(e, ...n);
    },
    range: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Eme(e, ...n);
    },
    rangeRef: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Cme(e, ...n);
    },
    rangeRefs: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return kme(e, ...n);
    },
    removeNodes: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Wme(e, ...n);
    },
    select: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Ime(e, ...n);
    },
    setNodes: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Zme(e, ...n);
    },
    setNormalizing: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Ame(e, ...n);
    },
    setPoint: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Rme(e, ...n);
    },
    setSelection: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Pme(e, ...n);
    },
    splitNodes: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Kme(e, ...n);
    },
    start: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Tme(e, ...n);
    },
    string: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return jme(e, ...n);
    },
    unhangRange: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Nme(e, ...n);
    },
    unsetNodes: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Xme(e, ...n);
    },
    unwrapNodes: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Qme(e, ...n);
    },
    void: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return q1e(e, ...n);
    },
    withoutNormalizing: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return V5(e, ...n);
    },
    wrapNodes: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Yme(e, ...n);
    },
    shouldMergeNodesRemovePrevNode: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return Ome(e, ...n);
    }
  };
  return e;
}, ege = rge, ZL = "֑-߿יִ-﷽ﹰ-ﻼ", GL = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿", tge = new RegExp("^[^" + GL + "]*[" + ZL + "]"), nge = new RegExp("^[^" + ZL + "]*[" + GL + "]");
function rge(e) {
  return e = String(e || ""), tge.test(e) ? "rtl" : nge.test(e) ? "ltr" : "neutral";
}
const KL = /* @__PURE__ */ wi(ege);
function ige(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var c8 = ige, a1 = {}, oge = typeof a1 == "object" && a1 && a1.Object === Object && a1, age = oge, sge = age, lge = typeof self == "object" && self && self.Object === Object && self, uge = sge || lge || Function("return this")(), XL = uge, cge = XL, dge = function() {
  return cge.Date.now();
}, pge = dge, fge = /\s/;
function hge(e) {
  for (var t = e.length; t-- && fge.test(e.charAt(t)); )
    ;
  return t;
}
var mge = hge, gge = mge, vge = /^\s+/;
function yge(e) {
  return e && e.slice(0, gge(e) + 1).replace(vge, "");
}
var xge = yge, bge = XL, wge = bge.Symbol, QL = wge, ik = QL, YL = Object.prototype, Cge = YL.hasOwnProperty, kge = YL.toString, Zd = ik ? ik.toStringTag : void 0;
function Ege(e) {
  var t = Cge.call(e, Zd), n = e[Zd];
  try {
    e[Zd] = void 0;
    var r = !0;
  } catch {
  }
  var i = kge.call(e);
  return r && (t ? e[Zd] = n : delete e[Zd]), i;
}
var Sge = Ege, Dge = Object.prototype, Age = Dge.toString;
function Tge(e) {
  return Age.call(e);
}
var jge = Tge, ok = QL, Nge = Sge, Oge = jge, zge = "[object Null]", Fge = "[object Undefined]", ak = ok ? ok.toStringTag : void 0;
function Lge(e) {
  return e == null ? e === void 0 ? Fge : zge : ak && ak in Object(e) ? Nge(e) : Oge(e);
}
var Mge = Lge;
function Bge(e) {
  return e != null && typeof e == "object";
}
var Ige = Bge, Rge = Mge, Pge = Ige, _ge = "[object Symbol]";
function qge(e) {
  return typeof e == "symbol" || Pge(e) && Rge(e) == _ge;
}
var $ge = qge, Hge = xge, sk = c8, Vge = $ge, lk = NaN, Uge = /^[-+]0x[0-9a-f]+$/i, Wge = /^0b[01]+$/i, Zge = /^0o[0-7]+$/i, Gge = parseInt;
function Kge(e) {
  if (typeof e == "number")
    return e;
  if (Vge(e))
    return lk;
  if (sk(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = sk(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Hge(e);
  var n = Wge.test(e);
  return n || Zge.test(e) ? Gge(e.slice(2), n ? 2 : 8) : Uge.test(e) ? lk : +e;
}
var Xge = Kge, Qge = c8, k3 = pge, uk = Xge, Yge = "Expected a function", Jge = Math.max, e2e = Math.min;
function t2e(e, t, n) {
  var r, i, o, a, s, l, u = 0, d = !1, p = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(Yge);
  t = uk(t) || 0, Qge(n) && (d = !!n.leading, p = "maxWait" in n, o = p ? Jge(uk(n.maxWait) || 0, t) : o, f = "trailing" in n ? !!n.trailing : f);
  function m(I) {
    var w = r, M = i;
    return r = i = void 0, u = I, a = e.apply(M, w), a;
  }
  function y(I) {
    return u = I, s = setTimeout(E, t), d ? m(I) : a;
  }
  function g(I) {
    var w = I - l, M = I - u, R = t - w;
    return p ? e2e(R, o - M) : R;
  }
  function x(I) {
    var w = I - l, M = I - u;
    return l === void 0 || w >= t || w < 0 || p && M >= o;
  }
  function E() {
    var I = k3();
    if (x(I))
      return b(I);
    s = setTimeout(E, g(I));
  }
  function b(I) {
    return s = void 0, f && r ? m(I) : (r = i = void 0, a);
  }
  function C() {
    s !== void 0 && clearTimeout(s), u = 0, r = l = i = s = void 0;
  }
  function T() {
    return s === void 0 ? a : b(k3());
  }
  function z() {
    var I = k3(), w = x(I);
    if (r = arguments, i = this, l = I, w) {
      if (s === void 0)
        return y(l);
      if (p)
        return clearTimeout(s), s = setTimeout(E, t), m(l);
    }
    return s === void 0 && (s = setTimeout(E, t)), a;
  }
  return z.cancel = C, z.flush = T, z;
}
var JL = t2e;
const n2e = /* @__PURE__ */ wi(JL);
var r2e = JL, i2e = c8, o2e = "Expected a function";
function a2e(e, t, n) {
  var r = !0, i = !0;
  if (typeof e != "function")
    throw new TypeError(o2e);
  return i2e(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), r2e(e, t, {
    leading: r,
    maxWait: t,
    trailing: i
  });
}
var s2e = a2e;
const l2e = /* @__PURE__ */ wi(s2e), ck = (e) => typeof e == "object" && e != null && e.nodeType === 1, dk = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", E3 = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const n = getComputedStyle(e, null);
    return dk(n.overflowY, t) || dk(n.overflowX, t) || ((r) => {
      const i = ((o) => {
        if (!o.ownerDocument || !o.ownerDocument.defaultView) return null;
        try {
          return o.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(r);
      return !!i && (i.clientHeight < r.scrollHeight || i.clientWidth < r.scrollWidth);
    })(e);
  }
  return !1;
}, s1 = (e, t, n, r, i, o, a, s) => o < e && a > t || o > e && a < t ? 0 : o <= e && s <= n || a >= t && s >= n ? o - e - r : a > t && s < n || o < e && s > n ? a - t + i : 0, u2e = (e) => e.parentElement ?? (e.getRootNode().host || null), pk = (e, t) => {
  var n, r, i, o;
  if (typeof document > "u") return [];
  const { scrollMode: a, block: s, inline: l, boundary: u, skipOverflowHiddenElements: d } = t, p = typeof u == "function" ? u : (D) => D !== u;
  if (!ck(e)) throw new TypeError("Invalid target");
  const f = document.scrollingElement || document.documentElement, m = [];
  let y = e;
  for (; ck(y) && p(y); ) {
    if (y = u2e(y), y === f) {
      m.push(y);
      break;
    }
    y != null && y === document.body && E3(y) && !E3(document.documentElement) || y != null && E3(y, d) && m.push(y);
  }
  const g = (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ? r : innerWidth, x = (o = (i = window.visualViewport) == null ? void 0 : i.height) != null ? o : innerHeight, { scrollX: E, scrollY: b } = window, { height: C, width: T, top: z, right: I, bottom: w, left: M } = e.getBoundingClientRect(), { top: R, right: F, bottom: W, left: X } = ((D) => {
    const j = window.getComputedStyle(D);
    return { top: parseFloat(j.scrollMarginTop) || 0, right: parseFloat(j.scrollMarginRight) || 0, bottom: parseFloat(j.scrollMarginBottom) || 0, left: parseFloat(j.scrollMarginLeft) || 0 };
  })(e);
  let le = s === "start" || s === "nearest" ? z - R : s === "end" ? w + W : z + C / 2 - R + W, ne = l === "center" ? M + T / 2 - X + F : l === "end" ? I + F : M - X;
  const fe = [];
  for (let D = 0; D < m.length; D++) {
    const j = m[D], { height: de, width: ye, top: Ne, right: Me, bottom: Ie, left: at } = j.getBoundingClientRect();
    if (a === "if-needed" && z >= 0 && M >= 0 && w <= x && I <= g && z >= Ne && w <= Ie && M >= at && I <= Me) return fe;
    const Ve = getComputedStyle(j), mt = parseInt(Ve.borderLeftWidth, 10), ae = parseInt(Ve.borderTopWidth, 10), Se = parseInt(Ve.borderRightWidth, 10), Ae = parseInt(Ve.borderBottomWidth, 10);
    let Be = 0, Ze = 0;
    const We = "offsetWidth" in j ? j.offsetWidth - j.clientWidth - mt - Se : 0, St = "offsetHeight" in j ? j.offsetHeight - j.clientHeight - ae - Ae : 0, pt = "offsetWidth" in j ? j.offsetWidth === 0 ? 0 : ye / j.offsetWidth : 0, Tt = "offsetHeight" in j ? j.offsetHeight === 0 ? 0 : de / j.offsetHeight : 0;
    if (f === j) Be = s === "start" ? le : s === "end" ? le - x : s === "nearest" ? s1(b, b + x, x, ae, Ae, b + le, b + le + C, C) : le - x / 2, Ze = l === "start" ? ne : l === "center" ? ne - g / 2 : l === "end" ? ne - g : s1(E, E + g, g, mt, Se, E + ne, E + ne + T, T), Be = Math.max(0, Be + b), Ze = Math.max(0, Ze + E);
    else {
      Be = s === "start" ? le - Ne - ae : s === "end" ? le - Ie + Ae + St : s === "nearest" ? s1(Ne, Ie, de, ae, Ae + St, le, le + C, C) : le - (Ne + de / 2) + St / 2, Ze = l === "start" ? ne - at - mt : l === "center" ? ne - (at + ye / 2) + We / 2 : l === "end" ? ne - Me + Se + We : s1(at, Me, ye, mt, Se + We, ne, ne + T, T);
      const { scrollLeft: Wt, scrollTop: et } = j;
      Be = Tt === 0 ? 0 : Math.max(0, Math.min(et + Be / Tt, j.scrollHeight - de / Tt + St)), Ze = pt === 0 ? 0 : Math.max(0, Math.min(Wt + Ze / pt, j.scrollWidth - ye / pt + We)), le += et - Be, ne += Wt - Ze;
    }
    fe.push({ el: j, top: Be, left: Ze });
  }
  return fe;
}, c2e = (e) => e === !1 ? { block: "end", inline: "nearest" } : ((t) => t === Object(t) && Object.keys(t).length !== 0)(e) ? e : { block: "start", inline: "nearest" };
function d2e(e, t) {
  if (!e.isConnected || !((i) => {
    let o = i;
    for (; o && o.parentNode; ) {
      if (o.parentNode === document) return !0;
      o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
    }
    return !1;
  })(e)) return;
  const n = ((i) => {
    const o = window.getComputedStyle(i);
    return { top: parseFloat(o.scrollMarginTop) || 0, right: parseFloat(o.scrollMarginRight) || 0, bottom: parseFloat(o.scrollMarginBottom) || 0, left: parseFloat(o.scrollMarginLeft) || 0 };
  })(e);
  if (((i) => typeof i == "object" && typeof i.behavior == "function")(t)) return t.behavior(pk(e, t));
  const r = typeof t == "boolean" || t == null ? void 0 : t.behavior;
  for (const { el: i, top: o, left: a } of pk(e, c2e(t))) {
    const s = o - n.top + n.bottom, l = a - n.left + n.right;
    i.scroll({ top: s, left: l, behavior: r });
  }
}
var bl = {};
Object.defineProperty(bl, "__esModule", {
  value: !0
});
var p2e = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), S3 = {
  alt: "altKey",
  control: "ctrlKey",
  meta: "metaKey",
  shift: "shiftKey"
}, eM = {
  add: "+",
  break: "pause",
  cmd: "meta",
  command: "meta",
  ctl: "control",
  ctrl: "control",
  del: "delete",
  down: "arrowdown",
  esc: "escape",
  ins: "insert",
  left: "arrowleft",
  mod: p2e ? "meta" : "control",
  opt: "alt",
  option: "alt",
  return: "enter",
  right: "arrowright",
  space: " ",
  spacebar: " ",
  up: "arrowup",
  win: "meta",
  windows: "meta"
}, d8 = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  " ": 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ";": 186,
  "=": 187,
  ",": 188,
  "-": 189,
  ".": 190,
  "/": 191,
  "`": 192,
  "[": 219,
  "\\": 220,
  "]": 221,
  "'": 222
};
for (var l1 = 1; l1 < 20; l1++)
  d8["f" + l1] = 111 + l1;
function D2(e, t, n) {
  t && !("byKey" in t) && (n = t, t = null), Array.isArray(e) || (e = [e]);
  var r = e.map(function(a) {
    return tM(a, t);
  }), i = function(a) {
    return r.some(function(s) {
      return nM(s, a);
    });
  }, o = n == null ? i : i(n);
  return o;
}
function f2e(e, t) {
  return D2(e, t);
}
function h2e(e, t) {
  return D2(e, { byKey: !0 }, t);
}
function tM(e, t) {
  var n = t && t.byKey, r = {};
  e = e.replace("++", "+add");
  var i = e.split("+"), o = i.length;
  for (var a in S3)
    r[S3[a]] = !1;
  var s = !0, l = !1, u = void 0;
  try {
    for (var d = i[Symbol.iterator](), p; !(s = (p = d.next()).done); s = !0) {
      var f = p.value, m = f.endsWith("?") && f.length > 1;
      m && (f = f.slice(0, -1));
      var y = p8(f), g = S3[y];
      if (f.length > 1 && !g && !eM[f] && !d8[y])
        throw new TypeError('Unknown modifier: "' + f + '"');
      (o === 1 || !g) && (n ? r.key = y : r.which = rM(f)), g && (r[g] = m ? null : !0);
    }
  } catch (x) {
    l = !0, u = x;
  } finally {
    try {
      !s && d.return && d.return();
    } finally {
      if (l)
        throw u;
    }
  }
  return r;
}
function nM(e, t) {
  for (var n in e) {
    var r = e[n], i = void 0;
    if (r != null && (n === "key" && t.key != null ? i = t.key.toLowerCase() : n === "which" ? i = r === 91 && t.which === 93 ? 91 : t.which : i = t[n], !(i == null && r === !1) && i !== r))
      return !1;
  }
  return !0;
}
function rM(e) {
  e = p8(e);
  var t = d8[e] || e.toUpperCase().charCodeAt(0);
  return t;
}
function p8(e) {
  return e = e.toLowerCase(), e = eM[e] || e, e;
}
var _s = bl.default = D2, uu = bl.isHotkey = D2;
bl.isCodeHotkey = f2e;
bl.isKeyHotkey = h2e;
bl.parseHotkey = tM;
bl.compareHotkey = nM;
bl.toKeyCode = rM;
bl.toKeyName = p8;
var iM = globalThis.Node, m2e = globalThis.Text, f8 = (e) => e && e.ownerDocument && e.ownerDocument.defaultView || null, g2e = (e) => wu(e) && e.nodeType === 8, ra = (e) => wu(e) && e.nodeType === 1, wu = (e) => {
  var t = f8(e);
  return !!t && e instanceof t.Node;
}, U5 = (e) => {
  var t = e && e.anchorNode && f8(e.anchorNode);
  return !!t && e instanceof t.Selection;
}, oM = (e) => wu(e) && e.nodeType === 3, v2e = (e) => e.clipboardData && e.clipboardData.getData("text/plain") !== "" && e.clipboardData.types.length === 1, y2e = (e) => {
  var [t, n] = e;
  if (ra(t) && t.childNodes.length) {
    var r = n === t.childNodes.length, i = r ? n - 1 : n;
    for ([t, i] = aM(t, i, r ? "backward" : "forward"), r = i < n; ra(t) && t.childNodes.length; ) {
      var o = r ? t.childNodes.length - 1 : 0;
      t = b2e(t, o, r ? "backward" : "forward");
    }
    n = r && t.textContent != null ? t.textContent.length : 0;
  }
  return [t, n];
}, x2e = (e) => {
  for (var t = e && e.parentNode; t; ) {
    if (t.toString() === "[object ShadowRoot]")
      return !0;
    t = t.parentNode;
  }
  return !1;
}, aM = (e, t, n) => {
  for (var {
    childNodes: r
  } = e, i = r[t], o = t, a = !1, s = !1; (g2e(i) || ra(i) && i.childNodes.length === 0 || ra(i) && i.getAttribute("contenteditable") === "false") && !(a && s); ) {
    if (o >= r.length) {
      a = !0, o = t - 1, n = "backward";
      continue;
    }
    if (o < 0) {
      s = !0, o = t + 1, n = "forward";
      continue;
    }
    i = r[o], t = o, o += n === "forward" ? 1 : -1;
  }
  return [i, t];
}, b2e = (e, t, n) => {
  var [r] = aM(e, t, n);
  return r;
}, sM = (e) => {
  var t = "";
  if (oM(e) && e.nodeValue)
    return e.nodeValue;
  if (ra(e)) {
    for (var n of Array.from(e.childNodes))
      t += sM(n);
    var r = getComputedStyle(e).getPropertyValue("display");
    (r === "block" || r === "list" || e.tagName === "BR") && (t += `
`);
  }
  return t;
}, w2e = /data-slate-fragment="(.+?)"/m, C2e = (e) => {
  var t = e.getData("text/html"), [, n] = t.match(w2e) || [];
  return n;
}, Ap = (e) => e.getSelection != null ? e.getSelection() : document.getSelection(), h8 = (e, t, n) => {
  var {
    target: r
  } = t;
  if (ra(r) && r.matches('[contentEditable="false"]'))
    return !1;
  var {
    document: i
  } = Xt.getWindow(e);
  if (i.contains(r))
    return Xt.hasDOMNode(e, r, {
      editable: !0
    });
  var o = n.find((a) => {
    var {
      addedNodes: s,
      removedNodes: l
    } = a;
    for (var u of s)
      if (u === r || u.contains(r))
        return !0;
    for (var d of l)
      if (d === r || d.contains(r))
        return !0;
  });
  return !o || o === t ? !1 : h8(e, o, n);
}, k2e = () => {
  for (var e = document.activeElement; (t = e) !== null && t !== void 0 && t.shadowRoot && (n = e.shadowRoot) !== null && n !== void 0 && n.activeElement; ) {
    var t, n, r;
    e = (r = e) === null || r === void 0 || (r = r.shadowRoot) === null || r === void 0 ? void 0 : r.activeElement;
  }
  return e;
}, fk = (e, t) => !!(e.compareDocumentPosition(t) & iM.DOCUMENT_POSITION_PRECEDING), E2e = (e, t) => !!(e.compareDocumentPosition(t) & iM.DOCUMENT_POSITION_FOLLOWING), D3, A3, lM = typeof navigator < "u" && typeof window < "u" && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, hk = typeof navigator < "u" && /Mac OS X/.test(navigator.userAgent), zi = typeof navigator < "u" && /Android/.test(navigator.userAgent), C0 = typeof navigator < "u" && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), nc = typeof navigator < "u" && /AppleWebKit(?!.*Chrome)/i.test(navigator.userAgent), S2e = typeof navigator < "u" && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent), uM = typeof navigator < "u" && /Chrome/i.test(navigator.userAgent), D2e = typeof navigator < "u" && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent), A2e = zi && typeof navigator < "u" && /Chrome?\/(?:[0-5]?\d)(?:\.)/i.test(navigator.userAgent), T2e = typeof navigator < "u" && /^(?!.*Seamonkey)(?=.*Firefox\/(?:[0-7][0-9]|[0-8][0-6])(?:\.)).*/i.test(navigator.userAgent), j2e = typeof navigator < "u" && /.*UCBrowser/.test(navigator.userAgent), N2e = typeof navigator < "u" && /.*Wechat/.test(navigator.userAgent) && !/.*MacWechat/.test(navigator.userAgent), V1 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
typeof navigator < "u" && /Safari/.test(navigator.userAgent) && /Version\/(\d+)/.test(navigator.userAgent) && (D3 = navigator.userAgent.match(/Version\/(\d+)/)) !== null && D3 !== void 0 && D3[1] && parseInt((A3 = navigator.userAgent.match(/Version\/(\d+)/)) === null || A3 === void 0 ? void 0 : A3[1], 10) < 17;
var zl = (!D2e || !A2e) && !S2e && // globalThis is undefined in older browsers
typeof globalThis < "u" && globalThis.InputEvent && // @ts-ignore The `getTargetRanges` property isn't recognized.
typeof globalThis.InputEvent.prototype.getTargetRanges == "function";
function cf(e) {
  "@babel/helpers - typeof";
  return cf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, cf(e);
}
function O2e(e, t) {
  if (cf(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (cf(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function z2e(e) {
  var t = O2e(e, "string");
  return cf(t) === "symbol" ? t : String(t);
}
function cM(e, t, n) {
  return t = z2e(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var F2e = 0;
class L2e {
  constructor() {
    cM(this, "id", void 0), this.id = "".concat(F2e++);
  }
}
var M0 = /* @__PURE__ */ new WeakMap(), m8 = /* @__PURE__ */ new WeakMap(), g8 = /* @__PURE__ */ new WeakMap(), dM = /* @__PURE__ */ new WeakMap(), U1 = /* @__PURE__ */ new WeakMap(), W5 = /* @__PURE__ */ new WeakMap(), df = /* @__PURE__ */ new WeakMap(), hc = /* @__PURE__ */ new WeakMap(), Ym = /* @__PURE__ */ new WeakMap(), A2 = /* @__PURE__ */ new WeakMap(), Z5 = /* @__PURE__ */ new WeakMap(), Xl = /* @__PURE__ */ new WeakMap(), cc = /* @__PURE__ */ new WeakMap(), Tp = /* @__PURE__ */ new WeakMap(), G5 = /* @__PURE__ */ new WeakMap(), v8 = /* @__PURE__ */ new WeakMap(), Ia = /* @__PURE__ */ new WeakMap(), Ws = /* @__PURE__ */ new WeakMap(), Xi = /* @__PURE__ */ new WeakMap(), Rl = /* @__PURE__ */ new WeakMap(), Pl = /* @__PURE__ */ new WeakMap(), pM = /* @__PURE__ */ new WeakMap(), td = Symbol("placeholder"), fM = Symbol("mark-placeholder"), Xt = {
  androidPendingDiffs: (e) => Xi.get(e),
  androidScheduleFlush: (e) => {
    var t;
    (t = v8.get(e)) === null || t === void 0 || t();
  },
  blur: (e) => {
    var t = Xt.toDOMNode(e, e), n = Xt.findDocumentOrShadowRoot(e);
    Xl.set(e, !1), n.activeElement === t && t.blur();
  },
  deselect: (e) => {
    var {
      selection: t
    } = e, n = Xt.findDocumentOrShadowRoot(e), r = Ap(n);
    r && r.rangeCount > 0 && r.removeAllRanges(), t && ge.deselect(e);
  },
  findDocumentOrShadowRoot: (e) => {
    var t = Xt.toDOMNode(e, e), n = t.getRootNode();
    return n instanceof Document || n instanceof ShadowRoot ? n : t.ownerDocument;
  },
  findEventRange: (e, t) => {
    "nativeEvent" in t && (t = t.nativeEvent);
    var {
      clientX: n,
      clientY: r,
      target: i
    } = t;
    if (n == null || r == null)
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(t));
    var o = Xt.toSlateNode(e, t.target), a = Xt.findPath(e, o);
    if (Je.isElement(o) && q.isVoid(e, o)) {
      var s = i.getBoundingClientRect(), l = e.isInline(o) ? n - s.left < s.left + s.width - n : r - s.top < s.top + s.height - r, u = q.point(e, a, {
        edge: l ? "start" : "end"
      }), d = l ? q.before(e, u) : q.after(e, u);
      if (d) {
        var p = q.range(e, d);
        return p;
      }
    }
    var f, {
      document: m
    } = Xt.getWindow(e);
    if (m.caretRangeFromPoint)
      f = m.caretRangeFromPoint(n, r);
    else {
      var y = m.caretPositionFromPoint(n, r);
      y && (f = m.createRange(), f.setStart(y.offsetNode, y.offset), f.setEnd(y.offsetNode, y.offset));
    }
    if (!f)
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(t));
    var g = Xt.toSlateRange(e, f, {
      exactMatch: !1,
      suppressThrow: !1
    });
    return g;
  },
  findKey: (e, t) => {
    var n = Ym.get(t);
    return n || (n = new L2e(), Ym.set(t, n)), n;
  },
  findPath: (e, t) => {
    for (var n = [], r = t; ; ) {
      var i = g8.get(r);
      if (i == null) {
        if (q.isEditor(r))
          return n;
        break;
      }
      var o = m8.get(r);
      if (o == null)
        break;
      n.unshift(o), r = i;
    }
    throw new Error("Unable to find the path for Slate node: ".concat(Gr.stringify(t)));
  },
  focus: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      retries: 5
    };
    if (!Xl.get(e)) {
      if (t.retries <= 0)
        throw new Error("Could not set focus, editor seems stuck with pending operations");
      if (e.operations.length > 0) {
        setTimeout(() => {
          Xt.focus(e, {
            retries: t.retries - 1
          });
        }, 10);
        return;
      }
      var n = Xt.toDOMNode(e, e), r = Xt.findDocumentOrShadowRoot(e);
      if (r.activeElement !== n) {
        if (e.selection && r instanceof Document) {
          var i = Ap(r), o = Xt.toDOMRange(e, e.selection);
          i == null || i.removeAllRanges(), i == null || i.addRange(o);
        }
        e.selection || ge.select(e, q.start(e, [])), Xl.set(e, !0), n.focus({
          preventScroll: !0
        });
      }
    }
  },
  getWindow: (e) => {
    var t = dM.get(e);
    if (!t)
      throw new Error("Unable to find a host window element for this editor");
    return t;
  },
  hasDOMNode: function(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      editable: r = !1
    } = n, i = Xt.toDOMNode(e, e), o;
    try {
      o = ra(t) ? t : t.parentElement;
    } catch (a) {
      if (a instanceof Error && !a.message.includes('Permission denied to access property "nodeType"'))
        throw a;
    }
    return o ? o.closest("[data-slate-editor]") === i && (!r || o.isContentEditable ? !0 : typeof o.isContentEditable == "boolean" && // isContentEditable exists only on HTMLElement, and on other nodes it will be undefined
    // this is the core logic that lets you know you got the right editor.selection instead of null when editor is contenteditable="false"(readOnly)
    o.closest('[contenteditable="false"]') === i || !!o.getAttribute("data-slate-zero-width")) : !1;
  },
  hasEditableTarget: (e, t) => wu(t) && Xt.hasDOMNode(e, t, {
    editable: !0
  }),
  hasRange: (e, t) => {
    var {
      anchor: n,
      focus: r
    } = t;
    return q.hasPath(e, n.path) && q.hasPath(e, r.path);
  },
  hasSelectableTarget: (e, t) => Xt.hasEditableTarget(e, t) || Xt.isTargetInsideNonReadonlyVoid(e, t),
  hasTarget: (e, t) => wu(t) && Xt.hasDOMNode(e, t),
  insertData: (e, t) => {
    e.insertData(t);
  },
  insertFragmentData: (e, t) => e.insertFragmentData(t),
  insertTextData: (e, t) => e.insertTextData(t),
  isComposing: (e) => !!cc.get(e),
  isFocused: (e) => !!Xl.get(e),
  isReadOnly: (e) => !!Z5.get(e),
  isTargetInsideNonReadonlyVoid: (e, t) => {
    if (Z5.get(e)) return !1;
    var n = Xt.hasTarget(e, t) && Xt.toSlateNode(e, t);
    return Je.isElement(n) && q.isVoid(e, n);
  },
  setFragmentData: (e, t, n) => e.setFragmentData(t, n),
  toDOMNode: (e, t) => {
    var n = A2.get(e), r = q.isEditor(t) ? U1.get(e) : n == null ? void 0 : n.get(Xt.findKey(e, t));
    if (!r)
      throw new Error("Cannot resolve a DOM node from Slate node: ".concat(Gr.stringify(t)));
    return r;
  },
  toDOMPoint: (e, t) => {
    var [n] = q.node(e, t.path), r = Xt.toDOMNode(e, n), i;
    q.void(e, {
      at: t
    }) && (t = {
      path: t.path,
      offset: 0
    });
    for (var o = "[data-slate-string], [data-slate-zero-width]", a = Array.from(r.querySelectorAll(o)), s = 0, l = 0; l < a.length; l++) {
      var u = a[l], d = u.childNodes[0];
      if (!(d == null || d.textContent == null)) {
        var {
          length: p
        } = d.textContent, f = u.getAttribute("data-slate-length"), m = f == null ? p : parseInt(f, 10), y = s + m, g = a[l + 1];
        if (t.offset === y && g !== null && g !== void 0 && g.hasAttribute("data-slate-mark-placeholder")) {
          var x, E = g.childNodes[0];
          i = [
            // COMPAT: If we don't explicity set the dom point to be on the actual
            // dom text element, chrome will put the selection behind the actual dom
            // text element, causing domRange.getBoundingClientRect() calls on a collapsed
            // selection to return incorrect zero values (https://bugs.chromium.org/p/chromium/issues/detail?id=435438)
            // which will cause issues when scrolling to it.
            E instanceof m2e ? E : g,
            (x = g.textContent) !== null && x !== void 0 && x.startsWith("\uFEFF") ? 1 : 0
          ];
          break;
        }
        if (t.offset <= y) {
          var b = Math.min(p, Math.max(0, t.offset - s));
          i = [d, b];
          break;
        }
        s = y;
      }
    }
    if (!i)
      throw new Error("Cannot resolve a DOM point from Slate point: ".concat(Gr.stringify(t)));
    return i;
  },
  toDOMRange: (e, t) => {
    var {
      anchor: n,
      focus: r
    } = t, i = ke.isBackward(t), o = Xt.toDOMPoint(e, n), a = ke.isCollapsed(t) ? o : Xt.toDOMPoint(e, r), s = Xt.getWindow(e), l = s.document.createRange(), [u, d] = i ? a : o, [p, f] = i ? o : a, m = ra(u) ? u : u.parentElement, y = !!m.getAttribute("data-slate-zero-width"), g = ra(p) ? p : p.parentElement, x = !!g.getAttribute("data-slate-zero-width");
    return l.setStart(u, y ? 1 : d), l.setEnd(p, x ? 1 : f), l;
  },
  toSlateNode: (e, t) => {
    var n = ra(t) ? t : t.parentElement;
    n && !n.hasAttribute("data-slate-node") && (n = n.closest("[data-slate-node]"));
    var r = n ? df.get(n) : null;
    if (!r)
      throw new Error("Cannot resolve a Slate node from DOM node: ".concat(n));
    return r;
  },
  toSlatePoint: (e, t, n) => {
    var {
      exactMatch: r,
      suppressThrow: i,
      searchDirection: o = "backward"
    } = n, [a, s] = r ? t : y2e(t), l = a.parentNode, u = null, d = 0;
    if (l) {
      var p, f, m = Xt.toDOMNode(e, e), y = l.closest('[data-slate-void="true"]'), g = y && m.contains(y) ? y : null, x = l.closest('[contenteditable="false"]'), E = x && m.contains(x) ? x : null, b = l.closest("[data-slate-leaf]"), C = null;
      if (b) {
        if (u = b.closest('[data-slate-node="text"]'), u) {
          var T = Xt.getWindow(e), z = T.document.createRange();
          z.setStart(u, 0), z.setEnd(a, s);
          var I = z.cloneContents(), w = [...Array.prototype.slice.call(I.querySelectorAll("[data-slate-zero-width]")), ...Array.prototype.slice.call(I.querySelectorAll("[contenteditable=false]"))];
          w.forEach((at) => {
            if (zi && !r && at.hasAttribute("data-slate-zero-width") && at.textContent.length > 0 && at.textContext !== "\uFEFF") {
              at.textContent.startsWith("\uFEFF") && (at.textContent = at.textContent.slice(1));
              return;
            }
            at.parentNode.removeChild(at);
          }), d = I.textContent.length, C = u;
        }
      } else if (g) {
        for (var M = g.querySelectorAll("[data-slate-leaf]"), R = 0; R < M.length; R++) {
          var F = M[R];
          if (Xt.hasDOMNode(e, F)) {
            b = F;
            break;
          }
        }
        b ? (u = b.closest('[data-slate-node="text"]'), C = b, d = C.textContent.length, C.querySelectorAll("[data-slate-zero-width]").forEach((at) => {
          d -= at.textContent.length;
        })) : d = 1;
      } else if (E) {
        var W = (at) => at ? at.querySelectorAll(
          // Exclude leaf nodes in nested editors
          "[data-slate-leaf]:not(:scope [data-slate-editor] [data-slate-leaf])"
        ) : [], X = E.closest('[data-slate-node="element"]');
        if (o === "forward") {
          var le, ne = [...W(X), ...W(X == null ? void 0 : X.nextElementSibling)];
          b = (le = ne.find((at) => E2e(E, at))) !== null && le !== void 0 ? le : null;
        } else {
          var fe, D = [...W(X == null ? void 0 : X.previousElementSibling), ...W(X)];
          b = (fe = D.findLast((at) => fk(E, at))) !== null && fe !== void 0 ? fe : null;
        }
        b && (u = b.closest('[data-slate-node="text"]'), C = b, o === "forward" ? d = 0 : (d = C.textContent.length, C.querySelectorAll("[data-slate-zero-width]").forEach((at) => {
          d -= at.textContent.length;
        })));
      }
      C && d === C.textContent.length && // COMPAT: Android IMEs might remove the zero width space while composing,
      // and we don't add it for line-breaks.
      zi && C.getAttribute("data-slate-zero-width") === "z" && (p = C.textContent) !== null && p !== void 0 && p.startsWith("\uFEFF") && // COMPAT: If the parent node is a Slate zero-width space, editor is
      // because the text node should have no characters. However, during IME
      // composition the ASCII characters will be prepended to the zero-width
      // space, so subtract 1 from the offset to account for the zero-width
      // space character.
      (l.hasAttribute("data-slate-zero-width") || // COMPAT: In Firefox, `range.cloneContents()` returns an extra trailing '\n'
      // when the document ends with a new-line character. This results in the offset
      // length being off by one, so we need to subtract one to account for this.
      C0 && (f = C.textContent) !== null && f !== void 0 && f.endsWith(`

`)) && d--;
    }
    if (zi && !u && !r) {
      var j = l.hasAttribute("data-slate-node") ? l : l.closest("[data-slate-node]");
      if (j && Xt.hasDOMNode(e, j, {
        editable: !0
      })) {
        var de = Xt.toSlateNode(e, j), {
          path: ye,
          offset: Ne
        } = q.start(e, Xt.findPath(e, de));
        return j.querySelector("[data-slate-leaf]") || (Ne = s), {
          path: ye,
          offset: Ne
        };
      }
    }
    if (!u) {
      if (i)
        return null;
      throw new Error("Cannot resolve a Slate point from DOM point: ".concat(t));
    }
    var Me = Xt.toSlateNode(e, u), Ie = Xt.findPath(e, Me);
    return {
      path: Ie,
      offset: d
    };
  },
  toSlateRange: (e, t, n) => {
    var r, {
      exactMatch: i,
      suppressThrow: o
    } = n, a = U5(t) ? t.anchorNode : t.startContainer, s, l, u, d, p;
    if (a)
      if (U5(t)) {
        if (C0 && t.rangeCount > 1) {
          u = t.focusNode;
          var f = t.getRangeAt(0), m = t.getRangeAt(t.rangeCount - 1);
          if (u instanceof HTMLTableRowElement && f.startContainer instanceof HTMLTableRowElement && m.startContainer instanceof HTMLTableRowElement) {
            let I = function(w) {
              return w.childElementCount > 0 ? I(w.children[0]) : w;
            };
            var y = f.startContainer, g = m.startContainer, x = I(y.children[f.startOffset]), E = I(g.children[m.startOffset]);
            d = 0, E.childNodes.length > 0 ? s = E.childNodes[0] : s = E, x.childNodes.length > 0 ? u = x.childNodes[0] : u = x, E instanceof HTMLElement ? l = E.innerHTML.length : l = 0;
          } else
            f.startContainer === u ? (s = m.endContainer, l = m.endOffset, d = f.startOffset) : (s = f.startContainer, l = f.endOffset, d = m.startOffset);
        } else
          s = t.anchorNode, l = t.anchorOffset, u = t.focusNode, d = t.focusOffset;
        uM && x2e(s) || C0 ? p = t.anchorNode === t.focusNode && t.anchorOffset === t.focusOffset : p = t.isCollapsed;
      } else
        s = t.startContainer, l = t.startOffset, u = t.endContainer, d = t.endOffset, p = t.collapsed;
    if (s == null || u == null || l == null || d == null)
      throw new Error("Cannot resolve a Slate range from DOM range: ".concat(t));
    C0 && (r = u.textContent) !== null && r !== void 0 && r.endsWith(`

`) && d === u.textContent.length && d--;
    var b = Xt.toSlatePoint(e, [s, l], {
      exactMatch: i,
      suppressThrow: o
    });
    if (!b)
      return null;
    var C = fk(s, u) || s === u && d < l, T = p ? b : Xt.toSlatePoint(e, [u, d], {
      exactMatch: i,
      suppressThrow: o,
      searchDirection: C ? "forward" : "backward"
    });
    if (!T)
      return null;
    var z = {
      anchor: b,
      focus: T
    };
    return ke.isExpanded(z) && ke.isForward(z) && ra(u) && q.void(e, {
      at: z.focus,
      mode: "highest"
    }) && (z = q.unhangRange(e, z, {
      voids: !0
    })), z;
  }
};
function M2e(e, t) {
  var {
    path: n,
    diff: r
  } = t;
  if (!q.hasPath(e, n))
    return !1;
  var i = Te.get(e, n);
  if (!xt.isText(i))
    return !1;
  if (r.start !== i.text.length || r.text.length === 0)
    return i.text.slice(r.start, r.start + r.text.length) === r.text;
  var o = ee.next(n);
  if (!q.hasPath(e, o))
    return !1;
  var a = Te.get(e, o);
  return xt.isText(a) && a.text.startsWith(r.text);
}
function hM(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return n.reduce((i, o) => i.slice(0, o.start) + o.text + i.slice(o.end), e);
}
function B2e(e, t) {
  for (var n = Math.min(e.length, t.length), r = 0; r < n; r++)
    if (e.charAt(r) !== t.charAt(r))
      return r;
  return n;
}
function I2e(e, t, n) {
  for (var r = Math.min(e.length, t.length, n), i = 0; i < r; i++)
    if (e.charAt(e.length - i - 1) !== t.charAt(t.length - i - 1))
      return i;
  return r;
}
function mM(e, t) {
  var {
    start: n,
    end: r,
    text: i
  } = t, o = e.slice(n, r), a = B2e(o, i), s = Math.min(o.length - a, i.length - a), l = I2e(o, i, s), u = {
    start: n + a,
    end: r - l,
    text: i.slice(a, i.length - l)
  };
  return u.start === u.end && u.text.length === 0 ? null : u;
}
function R2e(e, t, n) {
  var r = Math.min(t.start, n.start), i = Math.max(0, Math.min(t.start + t.text.length, n.end) - n.start), o = hM(e, t, n), a = Math.max(n.start + n.text.length, t.start + t.text.length + (t.start + t.text.length > n.start ? n.text.length : 0) - i), s = o.slice(r, a), l = Math.max(t.end, n.end - t.text.length + (t.end - t.start));
  return mM(e, {
    start: r,
    end: l,
    text: s
  });
}
function P2e(e) {
  var {
    path: t,
    diff: n
  } = e;
  return {
    anchor: {
      path: t,
      offset: n.start
    },
    focus: {
      path: t,
      offset: n.end
    }
  };
}
function K5(e, t) {
  var {
    path: n,
    offset: r
  } = t;
  if (!q.hasPath(e, n))
    return null;
  var i = Te.get(e, n);
  if (!xt.isText(i))
    return null;
  var o = q.above(e, {
    match: (s) => Je.isElement(s) && q.isBlock(e, s),
    at: n
  });
  if (!o)
    return null;
  for (; r > i.text.length; ) {
    var a = q.next(e, {
      at: n,
      match: xt.isText
    });
    if (!a || !ee.isDescendant(a[1], o[1]))
      return null;
    r -= i.text.length, i = a[0], n = a[1];
  }
  return {
    path: n,
    offset: r
  };
}
function mk(e, t) {
  var n = K5(e, t.anchor);
  if (!n)
    return null;
  if (ke.isCollapsed(t))
    return {
      anchor: n,
      focus: n
    };
  var r = K5(e, t.focus);
  return r ? {
    anchor: n,
    focus: r
  } : null;
}
function X5(e, t, n) {
  var r = Xi.get(e), i = r == null ? void 0 : r.find((d) => {
    var {
      path: p
    } = d;
    return ee.equals(p, t.path);
  });
  if (!i || t.offset <= i.diff.start)
    return Ut.transform(t, n, {
      affinity: "backward"
    });
  var {
    diff: o
  } = i;
  if (t.offset <= o.start + o.text.length) {
    var a = {
      path: t.path,
      offset: o.start
    }, s = Ut.transform(a, n, {
      affinity: "backward"
    });
    return s ? {
      path: s.path,
      offset: s.offset + t.offset - o.start
    } : null;
  }
  var l = {
    path: t.path,
    offset: t.offset - o.text.length + o.end - o.start
  }, u = Ut.transform(l, n, {
    affinity: "backward"
  });
  return u ? n.type === "split_node" && ee.equals(n.path, t.path) && l.offset < n.position && o.start < n.position ? u : {
    path: u.path,
    offset: u.offset + o.text.length - o.end + o.start
  } : null;
}
function gk(e, t, n) {
  var r = X5(e, t.anchor, n);
  if (!r)
    return null;
  if (ke.isCollapsed(t))
    return {
      anchor: r,
      focus: r
    };
  var i = X5(e, t.focus, n);
  return i ? {
    anchor: r,
    focus: i
  } : null;
}
function _2e(e, t) {
  var {
    path: n,
    diff: r,
    id: i
  } = e;
  switch (t.type) {
    case "insert_text":
      return !ee.equals(t.path, n) || t.offset >= r.end ? e : t.offset <= r.start ? {
        diff: {
          start: t.text.length + r.start,
          end: t.text.length + r.end,
          text: r.text
        },
        id: i,
        path: n
      } : {
        diff: {
          start: r.start,
          end: r.end + t.text.length,
          text: r.text
        },
        id: i,
        path: n
      };
    case "remove_text":
      return !ee.equals(t.path, n) || t.offset >= r.end ? e : t.offset + t.text.length <= r.start ? {
        diff: {
          start: r.start - t.text.length,
          end: r.end - t.text.length,
          text: r.text
        },
        id: i,
        path: n
      } : {
        diff: {
          start: r.start,
          end: r.end - t.text.length,
          text: r.text
        },
        id: i,
        path: n
      };
    case "split_node":
      return !ee.equals(t.path, n) || t.position >= r.end ? {
        diff: r,
        id: i,
        path: ee.transform(n, t, {
          affinity: "backward"
        })
      } : t.position > r.start ? {
        diff: {
          start: r.start,
          end: Math.min(t.position, r.end),
          text: r.text
        },
        id: i,
        path: n
      } : {
        diff: {
          start: r.start - t.position,
          end: r.end - t.position,
          text: r.text
        },
        id: i,
        path: ee.transform(n, t, {
          affinity: "forward"
        })
      };
    case "merge_node":
      return ee.equals(t.path, n) ? {
        diff: {
          start: r.start + t.position,
          end: r.end + t.position,
          text: r.text
        },
        id: i,
        path: ee.transform(n, t)
      } : {
        diff: r,
        id: i,
        path: ee.transform(n, t)
      };
  }
  var o = ee.transform(n, t);
  return o ? {
    diff: r,
    path: o,
    id: i
  } : null;
}
var vk = (e, t) => {
  var n = (t.top + t.bottom) / 2;
  return e.top <= n && e.bottom >= n;
}, yk = (e, t, n) => {
  var r = Xt.toDOMRange(e, t).getBoundingClientRect(), i = Xt.toDOMRange(e, n).getBoundingClientRect();
  return vk(r, i) && vk(i, r);
}, q2e = (e, t) => {
  var n = q.range(e, ke.end(t)), r = Array.from(q.positions(e, {
    at: t
  })), i = 0, o = r.length, a = Math.floor(o / 2);
  if (yk(e, q.range(e, r[i]), n))
    return q.range(e, r[i], n);
  if (r.length < 2)
    return q.range(e, r[r.length - 1], n);
  for (; a !== r.length && a !== i; )
    yk(e, q.range(e, r[a]), n) ? o = a : i = a, a = Math.floor((i + o) / 2);
  return q.range(e, r[o], n);
};
function xk(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function bk(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xk(Object(n), !0).forEach(function(r) {
      cM(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xk(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var $2e = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x-slate-fragment", n = e, {
    apply: r,
    onChange: i,
    deleteBackward: o,
    addMark: a,
    removeMark: s
  } = n;
  return A2.set(n, /* @__PURE__ */ new WeakMap()), n.addMark = (l, u) => {
    var d, p;
    (d = v8.get(n)) === null || d === void 0 || d(), !Ia.get(n) && (p = Xi.get(n)) !== null && p !== void 0 && p.length && Ia.set(n, null), Ws.delete(n), a(l, u);
  }, n.removeMark = (l) => {
    var u;
    !Ia.get(n) && (u = Xi.get(n)) !== null && u !== void 0 && u.length && Ia.set(n, null), Ws.delete(n), s(l);
  }, n.deleteBackward = (l) => {
    if (l !== "line")
      return o(l);
    if (n.selection && ke.isCollapsed(n.selection)) {
      var u = q.above(n, {
        match: (m) => Je.isElement(m) && q.isBlock(n, m),
        at: n.selection
      });
      if (u) {
        var [, d] = u, p = q.range(n, d, n.selection.anchor), f = q2e(n, p);
        ke.isCollapsed(f) || ge.delete(n, {
          at: f
        });
      }
    }
  }, n.apply = (l) => {
    var u = [], d = [], p = Xi.get(n);
    if (p != null && p.length) {
      var f = p.map((le) => _2e(le, l)).filter(Boolean);
      Xi.set(n, f);
    }
    var m = Pl.get(n);
    m && Pl.set(n, gk(n, m, l));
    var y = Rl.get(n);
    if (y != null && y.at) {
      var g = Ut.isPoint(y == null ? void 0 : y.at) ? X5(n, y.at, l) : gk(n, y.at, l);
      Rl.set(n, g ? bk(bk({}, y), {}, {
        at: g
      }) : null);
    }
    switch (l.type) {
      case "insert_text":
      case "remove_text":
      case "set_node":
      case "split_node": {
        u.push(...r0(n, l.path));
        break;
      }
      case "set_selection": {
        var x;
        (x = Tp.get(n)) === null || x === void 0 || x.unref(), Tp.delete(n);
        break;
      }
      case "insert_node":
      case "remove_node": {
        u.push(...r0(n, ee.parent(l.path)));
        break;
      }
      case "merge_node": {
        var E = ee.previous(l.path);
        u.push(...r0(n, E));
        break;
      }
      case "move_node": {
        var b = ee.common(ee.parent(l.path), ee.parent(l.newPath));
        u.push(...r0(n, b));
        var C;
        ee.isBefore(l.path, l.newPath) ? (u.push(...r0(n, ee.parent(l.path))), C = l.newPath) : (u.push(...r0(n, ee.parent(l.newPath))), C = l.path);
        var T = Te.get(e, ee.parent(C)), z = Xt.findKey(n, T), I = q.pathRef(n, ee.parent(C));
        d.push([I, z]);
        break;
      }
    }
    switch (r(l), l.type) {
      case "insert_node":
      case "remove_node":
      case "merge_node":
      case "move_node":
      case "split_node":
        M0.set(n, !0);
    }
    for (var [w, M] of u) {
      var [R] = q.node(n, w);
      Ym.set(R, M);
    }
    for (var [F, W] of d) {
      if (F.current) {
        var [X] = q.node(n, F.current);
        Ym.set(X, W);
      }
      F.unref();
    }
  }, n.setFragmentData = (l) => {
    var {
      selection: u
    } = n;
    if (u) {
      var [d, p] = ke.edges(u), f = q.void(n, {
        at: d.path
      }), m = q.void(n, {
        at: p.path
      });
      if (!(ke.isCollapsed(u) && !f)) {
        var y = Xt.toDOMRange(n, u), g = y.cloneContents(), x = g.childNodes[0];
        if (g.childNodes.forEach((R) => {
          R.textContent && R.textContent.trim() !== "" && (x = R);
        }), m) {
          var [E] = m, b = y.cloneRange(), C = Xt.toDOMNode(n, E);
          b.setEndAfter(C), g = b.cloneContents();
        }
        if (f && (x = g.querySelector("[data-slate-spacer]")), Array.from(g.querySelectorAll("[data-slate-zero-width]")).forEach((R) => {
          var F = R.getAttribute("data-slate-zero-width") === "n";
          R.textContent = F ? `
` : "";
        }), oM(x)) {
          var T = x.ownerDocument.createElement("span");
          T.style.whiteSpace = "pre", T.appendChild(x), g.appendChild(T), x = T;
        }
        var z = n.getFragment(), I = JSON.stringify(z), w = window.btoa(encodeURIComponent(I));
        x.setAttribute("data-slate-fragment", w), l.setData("application/".concat(t), w);
        var M = g.ownerDocument.createElement("div");
        return M.appendChild(g), M.setAttribute("hidden", "true"), g.ownerDocument.body.appendChild(M), l.setData("text/html", M.innerHTML), l.setData("text/plain", sM(M)), g.ownerDocument.body.removeChild(M), l;
      }
    }
  }, n.insertData = (l) => {
    n.insertFragmentData(l) || n.insertTextData(l);
  }, n.insertFragmentData = (l) => {
    var u = l.getData("application/".concat(t)) || C2e(l);
    if (u) {
      var d = decodeURIComponent(window.atob(u)), p = JSON.parse(d);
      return n.insertFragment(p), !0;
    }
    return !1;
  }, n.insertTextData = (l) => {
    var u = l.getData("text/plain");
    if (u) {
      var d = u.split(/\r\n|\r|\n/), p = !1;
      for (var f of d)
        p && ge.splitNodes(n, {
          always: !0
        }), n.insertText(f), p = !0;
      return !0;
    }
    return !1;
  }, n.onChange = (l) => {
    var u = G5.get(n);
    u && u(l), i(l);
  }, n;
}, r0 = (e, t) => {
  var n = [];
  for (var [r, i] of q.levels(e, {
    at: t
  })) {
    var o = Xt.findKey(e, r);
    n.push([i, o]);
  }
  return n;
}, H2e = 3, V2e = {
  bold: "mod+b",
  compose: ["down", "left", "right", "up", "backspace", "enter"],
  moveBackward: "left",
  moveForward: "right",
  moveWordBackward: "ctrl+left",
  moveWordForward: "ctrl+right",
  deleteBackward: "shift?+backspace",
  deleteForward: "shift?+delete",
  extendBackward: "shift+left",
  extendForward: "shift+right",
  italic: "mod+i",
  insertSoftBreak: "shift+enter",
  splitBlock: "enter",
  undo: "mod+z"
}, U2e = {
  moveLineBackward: "opt+up",
  moveLineForward: "opt+down",
  moveWordBackward: "opt+left",
  moveWordForward: "opt+right",
  deleteBackward: ["ctrl+backspace", "ctrl+h"],
  deleteForward: ["ctrl+delete", "ctrl+d"],
  deleteLineBackward: "cmd+shift?+backspace",
  deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
  deleteWordBackward: "opt+shift?+backspace",
  deleteWordForward: "opt+shift?+delete",
  extendLineBackward: "opt+shift+up",
  extendLineForward: "opt+shift+down",
  redo: "cmd+shift+z",
  transposeCharacter: "ctrl+t"
}, W2e = {
  deleteWordBackward: "ctrl+shift?+backspace",
  deleteWordForward: "ctrl+shift?+delete",
  redo: ["ctrl+y", "ctrl+shift+z"]
}, Zn = (e) => {
  var t = V2e[e], n = U2e[e], r = W2e[e], i = t && uu(t), o = n && uu(n), a = r && uu(r);
  return (s) => !!(i && i(s) || hk && o && o(s) || !hk && a && a(s));
}, ar = {
  isBold: Zn("bold"),
  isCompose: Zn("compose"),
  isMoveBackward: Zn("moveBackward"),
  isMoveForward: Zn("moveForward"),
  isDeleteBackward: Zn("deleteBackward"),
  isDeleteForward: Zn("deleteForward"),
  isDeleteLineBackward: Zn("deleteLineBackward"),
  isDeleteLineForward: Zn("deleteLineForward"),
  isDeleteWordBackward: Zn("deleteWordBackward"),
  isDeleteWordForward: Zn("deleteWordForward"),
  isExtendBackward: Zn("extendBackward"),
  isExtendForward: Zn("extendForward"),
  isExtendLineBackward: Zn("extendLineBackward"),
  isExtendLineForward: Zn("extendLineForward"),
  isItalic: Zn("italic"),
  isMoveLineBackward: Zn("moveLineBackward"),
  isMoveLineForward: Zn("moveLineForward"),
  isMoveWordBackward: Zn("moveWordBackward"),
  isMoveWordForward: Zn("moveWordForward"),
  isRedo: Zn("redo"),
  isSoftBreak: Zn("insertSoftBreak"),
  isSplitBlock: Zn("splitBlock"),
  isTransposeCharacter: Zn("transposeCharacter"),
  isUndo: Zn("undo")
};
function Z2e(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function wk(e, t) {
  if (e == null) return {};
  var n = Z2e(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
var G2e = ["anchor", "focus"], K2e = ["anchor", "focus"], X2e = (e, t) => Object.keys(e).length === Object.keys(t).length && Object.keys(e).every((n) => t.hasOwnProperty(n) && e[n] === t[n]), gM = (e, t) => {
  var n = wk(e, G2e), r = wk(t, K2e);
  return e[td] === t[td] && X2e(n, r);
}, Q2e = (e, t) => {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++) {
    var r = e[n], i = t[n];
    if (!ke.equals(r, i) || !gM(r, i))
      return !1;
  }
  return !0;
}, Y2e = (e, t) => {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++) {
    var r = e[n], i = t[n];
    if (r.anchor.offset !== i.anchor.offset || r.focus.offset !== i.focus.offset || !gM(r, i))
      return !1;
  }
  return !0;
}, mc = [], J2e = function() {
  return mc.some(function(e) {
    return e.activeTargets.length > 0;
  });
}, e4e = function() {
  return mc.some(function(e) {
    return e.skippedTargets.length > 0;
  });
}, Ck = "ResizeObserver loop completed with undelivered notifications.", t4e = function() {
  var e;
  typeof ErrorEvent == "function" ? e = new ErrorEvent("error", {
    message: Ck
  }) : (e = document.createEvent("Event"), e.initEvent("error", !1, !1), e.message = Ck), window.dispatchEvent(e);
}, pf;
(function(e) {
  e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(pf || (pf = {}));
var gc = function(e) {
  return Object.freeze(e);
}, n4e = /* @__PURE__ */ function() {
  function e(t, n) {
    this.inlineSize = t, this.blockSize = n, gc(this);
  }
  return e;
}(), vM = function() {
  function e(t, n, r, i) {
    return this.x = t, this.y = n, this.width = r, this.height = i, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, gc(this);
  }
  return e.prototype.toJSON = function() {
    var t = this, n = t.x, r = t.y, i = t.top, o = t.right, a = t.bottom, s = t.left, l = t.width, u = t.height;
    return { x: n, y: r, top: i, right: o, bottom: a, left: s, width: l, height: u };
  }, e.fromRect = function(t) {
    return new e(t.x, t.y, t.width, t.height);
  }, e;
}(), y8 = function(e) {
  return e instanceof SVGElement && "getBBox" in e;
}, yM = function(e) {
  if (y8(e)) {
    var t = e.getBBox(), n = t.width, r = t.height;
    return !n && !r;
  }
  var i = e, o = i.offsetWidth, a = i.offsetHeight;
  return !(o || a || e.getClientRects().length);
}, kk = function(e) {
  var t;
  if (e instanceof Element)
    return !0;
  var n = (t = e == null ? void 0 : e.ownerDocument) === null || t === void 0 ? void 0 : t.defaultView;
  return !!(n && e instanceof n.Element);
}, r4e = function(e) {
  switch (e.tagName) {
    case "INPUT":
      if (e.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }
  return !1;
}, jp = typeof window < "u" ? window : {}, u1 = /* @__PURE__ */ new WeakMap(), Ek = /auto|scroll/, i4e = /^tb|vertical/, o4e = /msie|trident/i.test(jp.navigator && jp.navigator.userAgent), Ja = function(e) {
  return parseFloat(e || "0");
}, B0 = function(e, t, n) {
  return e === void 0 && (e = 0), t === void 0 && (t = 0), n === void 0 && (n = !1), new n4e((n ? t : e) || 0, (n ? e : t) || 0);
}, Sk = gc({
  devicePixelContentBoxSize: B0(),
  borderBoxSize: B0(),
  contentBoxSize: B0(),
  contentRect: new vM(0, 0, 0, 0)
}), xM = function(e, t) {
  if (t === void 0 && (t = !1), u1.has(e) && !t)
    return u1.get(e);
  if (yM(e))
    return u1.set(e, Sk), Sk;
  var n = getComputedStyle(e), r = y8(e) && e.ownerSVGElement && e.getBBox(), i = !o4e && n.boxSizing === "border-box", o = i4e.test(n.writingMode || ""), a = !r && Ek.test(n.overflowY || ""), s = !r && Ek.test(n.overflowX || ""), l = r ? 0 : Ja(n.paddingTop), u = r ? 0 : Ja(n.paddingRight), d = r ? 0 : Ja(n.paddingBottom), p = r ? 0 : Ja(n.paddingLeft), f = r ? 0 : Ja(n.borderTopWidth), m = r ? 0 : Ja(n.borderRightWidth), y = r ? 0 : Ja(n.borderBottomWidth), g = r ? 0 : Ja(n.borderLeftWidth), x = p + u, E = l + d, b = g + m, C = f + y, T = s ? e.offsetHeight - C - e.clientHeight : 0, z = a ? e.offsetWidth - b - e.clientWidth : 0, I = i ? x + b : 0, w = i ? E + C : 0, M = r ? r.width : Ja(n.width) - I - z, R = r ? r.height : Ja(n.height) - w - T, F = M + x + z + b, W = R + E + T + C, X = gc({
    devicePixelContentBoxSize: B0(Math.round(M * devicePixelRatio), Math.round(R * devicePixelRatio), o),
    borderBoxSize: B0(F, W, o),
    contentBoxSize: B0(M, R, o),
    contentRect: new vM(p, l, M, R)
  });
  return u1.set(e, X), X;
}, bM = function(e, t, n) {
  var r = xM(e, n), i = r.borderBoxSize, o = r.contentBoxSize, a = r.devicePixelContentBoxSize;
  switch (t) {
    case pf.DEVICE_PIXEL_CONTENT_BOX:
      return a;
    case pf.BORDER_BOX:
      return i;
    default:
      return o;
  }
}, a4e = /* @__PURE__ */ function() {
  function e(t) {
    var n = xM(t);
    this.target = t, this.contentRect = n.contentRect, this.borderBoxSize = gc([n.borderBoxSize]), this.contentBoxSize = gc([n.contentBoxSize]), this.devicePixelContentBoxSize = gc([n.devicePixelContentBoxSize]);
  }
  return e;
}(), wM = function(e) {
  if (yM(e))
    return 1 / 0;
  for (var t = 0, n = e.parentNode; n; )
    t += 1, n = n.parentNode;
  return t;
}, s4e = function() {
  var e = 1 / 0, t = [];
  mc.forEach(function(o) {
    if (o.activeTargets.length !== 0) {
      var a = [];
      o.activeTargets.forEach(function(s) {
        var l = new a4e(s.target), u = wM(s.target);
        a.push(l), s.lastReportedSize = bM(s.target, s.observedBox), u < e && (e = u);
      }), t.push(function() {
        o.callback.call(o.observer, a, o.observer);
      }), o.activeTargets.splice(0, o.activeTargets.length);
    }
  });
  for (var n = 0, r = t; n < r.length; n++) {
    var i = r[n];
    i();
  }
  return e;
}, Dk = function(e) {
  mc.forEach(function(t) {
    t.activeTargets.splice(0, t.activeTargets.length), t.skippedTargets.splice(0, t.skippedTargets.length), t.observationTargets.forEach(function(n) {
      n.isActive() && (wM(n.target) > e ? t.activeTargets.push(n) : t.skippedTargets.push(n));
    });
  });
}, l4e = function() {
  var e = 0;
  for (Dk(e); J2e(); )
    e = s4e(), Dk(e);
  return e4e() && t4e(), e > 0;
}, T3, CM = [], u4e = function() {
  return CM.splice(0).forEach(function(e) {
    return e();
  });
}, c4e = function(e) {
  if (!T3) {
    var t = 0, n = document.createTextNode(""), r = { characterData: !0 };
    new MutationObserver(function() {
      return u4e();
    }).observe(n, r), T3 = function() {
      n.textContent = "".concat(t ? t-- : t++);
    };
  }
  CM.push(e), T3();
}, d4e = function(e) {
  c4e(function() {
    requestAnimationFrame(e);
  });
}, W1 = 0, p4e = function() {
  return !!W1;
}, f4e = 250, h4e = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, Ak = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], Tk = function(e) {
  return e === void 0 && (e = 0), Date.now() + e;
}, j3 = !1, m4e = function() {
  function e() {
    var t = this;
    this.stopped = !0, this.listener = function() {
      return t.schedule();
    };
  }
  return e.prototype.run = function(t) {
    var n = this;
    if (t === void 0 && (t = f4e), !j3) {
      j3 = !0;
      var r = Tk(t);
      d4e(function() {
        var i = !1;
        try {
          i = l4e();
        } finally {
          if (j3 = !1, t = r - Tk(), !p4e())
            return;
          i ? n.run(1e3) : t > 0 ? n.run(t) : n.start();
        }
      });
    }
  }, e.prototype.schedule = function() {
    this.stop(), this.run();
  }, e.prototype.observe = function() {
    var t = this, n = function() {
      return t.observer && t.observer.observe(document.body, h4e);
    };
    document.body ? n() : jp.addEventListener("DOMContentLoaded", n);
  }, e.prototype.start = function() {
    var t = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), Ak.forEach(function(n) {
      return jp.addEventListener(n, t.listener, !0);
    }));
  }, e.prototype.stop = function() {
    var t = this;
    this.stopped || (this.observer && this.observer.disconnect(), Ak.forEach(function(n) {
      return jp.removeEventListener(n, t.listener, !0);
    }), this.stopped = !0);
  }, e;
}(), Q5 = new m4e(), jk = function(e) {
  !W1 && e > 0 && Q5.start(), W1 += e, !W1 && Q5.stop();
}, g4e = function(e) {
  return !y8(e) && !r4e(e) && getComputedStyle(e).display === "inline";
}, v4e = function() {
  function e(t, n) {
    this.target = t, this.observedBox = n || pf.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return e.prototype.isActive = function() {
    var t = bM(this.target, this.observedBox, !0);
    return g4e(this.target) && (this.lastReportedSize = t), this.lastReportedSize.inlineSize !== t.inlineSize || this.lastReportedSize.blockSize !== t.blockSize;
  }, e;
}(), y4e = /* @__PURE__ */ function() {
  function e(t, n) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = t, this.callback = n;
  }
  return e;
}(), c1 = /* @__PURE__ */ new WeakMap(), Nk = function(e, t) {
  for (var n = 0; n < e.length; n += 1)
    if (e[n].target === t)
      return n;
  return -1;
}, d1 = function() {
  function e() {
  }
  return e.connect = function(t, n) {
    var r = new y4e(t, n);
    c1.set(t, r);
  }, e.observe = function(t, n, r) {
    var i = c1.get(t), o = i.observationTargets.length === 0;
    Nk(i.observationTargets, n) < 0 && (o && mc.push(i), i.observationTargets.push(new v4e(n, r && r.box)), jk(1), Q5.schedule());
  }, e.unobserve = function(t, n) {
    var r = c1.get(t), i = Nk(r.observationTargets, n), o = r.observationTargets.length === 1;
    i >= 0 && (o && mc.splice(mc.indexOf(r), 1), r.observationTargets.splice(i, 1), jk(-1));
  }, e.disconnect = function(t) {
    var n = this, r = c1.get(t);
    r.observationTargets.slice().forEach(function(i) {
      return n.unobserve(t, i.target);
    }), r.activeTargets.splice(0, r.activeTargets.length);
  }, e;
}(), x4e = function() {
  function e(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof t != "function")
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    d1.connect(this, t);
  }
  return e.prototype.observe = function(t, n) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!kk(t))
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    d1.observe(this, t, n);
  }, e.prototype.unobserve = function(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!kk(t))
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    d1.unobserve(this, t);
  }, e.prototype.disconnect = function() {
    d1.disconnect(this);
  }, e.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  }, e;
}();
function b4e(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function Jm(e, t) {
  if (e == null) return {};
  var n = b4e(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function ff(e) {
  "@babel/helpers - typeof";
  return ff = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ff(e);
}
function w4e(e, t) {
  if (ff(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (ff(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function C4e(e) {
  var t = w4e(e, "string");
  return ff(t) === "symbol" ? t : String(t);
}
function ds(e, t, n) {
  return t = C4e(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var x8 = /* @__PURE__ */ v.createContext(null), Fu = () => {
  var e = v.useContext(x8);
  if (!e)
    throw new Error("The `useSlateStatic` hook must be used inside the <Slate> component's context.");
  return e;
}, Ue = Xt;
function Ok(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function p1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ok(Object(n), !0).forEach(function(r) {
      ds(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ok(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var k4e = 25, E4e = 200, S4e = function() {
}, D4e = (e) => (e == null ? void 0 : e.constructor.name) === "DataTransfer";
function A4e(e) {
  var {
    editor: t,
    scheduleOnDOMSelectionChange: n,
    onDOMSelectionChange: r
  } = e, i = !1, o = null, a = null, s = null, l = 0, u = !1, d = () => {
    var X = Pl.get(t);
    if (Pl.delete(t), X) {
      var {
        selection: le
      } = t, ne = mk(t, X);
      ne && (!le || !ke.equals(ne, le)) && ge.select(t, ne);
    }
  }, p = () => {
    var X = Rl.get(t);
    if (Rl.delete(t), !!X) {
      if (X.at) {
        var le = Ut.isPoint(X.at) ? K5(t, X.at) : mk(t, X.at);
        if (!le)
          return;
        var ne = q.range(t, le);
        (!t.selection || !ke.equals(t.selection, ne)) && ge.select(t, le);
      }
      X.run();
    }
  }, f = () => {
    if (a && (clearTimeout(a), a = null), s && (clearTimeout(s), s = null), !T() && !C()) {
      d();
      return;
    }
    i || (i = !0, setTimeout(() => i = !1)), C() && (i = "action");
    var X = t.selection && q.rangeRef(t, t.selection, {
      affinity: "forward"
    });
    Ws.set(t, t.marks), S4e("flush", Rl.get(t), Xi.get(t));
    for (var le = T(), ne; ne = (fe = Xi.get(t)) === null || fe === void 0 ? void 0 : fe[0]; ) {
      var fe, D, j = Ia.get(t);
      j !== void 0 && (Ia.delete(t), t.marks = j), j && u === !1 && (u = null);
      var de = P2e(ne);
      (!t.selection || !ke.equals(t.selection, de)) && ge.select(t, de), ne.diff.text ? q.insertText(t, ne.diff.text) : q.deleteFragment(t), Xi.set(t, (D = Xi.get(t)) === null || D === void 0 ? void 0 : D.filter((Me) => {
        var {
          id: Ie
        } = Me;
        return Ie !== ne.id;
      })), M2e(t, ne) || (le = !1, Rl.delete(t), Ws.delete(t), i = "action", Pl.delete(t), n.cancel(), r.cancel(), X == null || X.unref());
    }
    var ye = X == null ? void 0 : X.unref();
    if (ye && !Pl.get(t) && (!t.selection || !ke.equals(ye, t.selection)) && ge.select(t, ye), C()) {
      p();
      return;
    }
    le && n(), n.flush(), r.flush(), d();
    var Ne = Ws.get(t);
    Ws.delete(t), Ne !== void 0 && (t.marks = Ne, t.onChange());
  }, m = (X) => {
    o && clearTimeout(o), o = setTimeout(() => {
      cc.set(t, !1), f();
    }, k4e);
  }, y = (X) => {
    cc.set(t, !0), o && (clearTimeout(o), o = null);
  }, g = function() {
    var X = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, le = W5.get(t);
    if (le) {
      if (T() || X) {
        le.style.display = "none";
        return;
      }
      le.style.removeProperty("display");
    }
  }, x = (X, le) => {
    var ne, fe = (ne = Xi.get(t)) !== null && ne !== void 0 ? ne : [];
    Xi.set(t, fe);
    var D = Te.leaf(t, X), j = fe.findIndex((Ne) => ee.equals(Ne.path, X));
    if (j < 0) {
      var de = mM(D.text, le);
      de && fe.push({
        path: X,
        diff: le,
        id: l++
      }), g();
      return;
    }
    var ye = R2e(D.text, fe[j].diff, le);
    if (!ye) {
      fe.splice(j, 1), g();
      return;
    }
    fe[j] = p1(p1({}, fe[j]), {}, {
      diff: ye
    });
  }, E = function(X) {
    var {
      at: le
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    u = !1, Pl.delete(t), n.cancel(), r.cancel(), C() && f(), Rl.set(t, {
      at: le,
      run: X
    }), s = setTimeout(f);
  }, b = (X) => {
    var le;
    if (a && (clearTimeout(a), a = null), !M0.get(t)) {
      var {
        inputType: ne
      } = X, fe = null, D = X.dataTransfer || X.data || void 0;
      u !== !1 && ne !== "insertText" && ne !== "insertCompositionText" && (u = !1);
      var [j] = X.getTargetRanges();
      j && (fe = Ue.toSlateRange(t, j, {
        exactMatch: !1,
        suppressThrow: !0
      }));
      var de = Ue.getWindow(t), ye = de.getSelection();
      if (!fe && ye && (j = ye, fe = Ue.toSlateRange(t, ye, {
        exactMatch: !1,
        suppressThrow: !0
      })), fe = (le = fe) !== null && le !== void 0 ? le : t.selection, !!fe) {
        var Ne = !0;
        if (ne.startsWith("delete")) {
          if (ke.isExpanded(fe)) {
            var [Me, Ie] = ke.edges(fe), at = Te.leaf(t, Me.path);
            if (at.text.length === Me.offset && Ie.offset === 0) {
              var Ve = q.next(t, {
                at: Me.path,
                match: xt.isText
              });
              Ve && ee.equals(Ve[1], Ie.path) && (fe = {
                anchor: Ie,
                focus: Ie
              });
            }
          }
          var mt = ne.endsWith("Backward") ? "backward" : "forward", [ae, Se] = ke.edges(fe), [Ae, Be] = q.leaf(t, ae.path), Ze = {
            text: "",
            start: ae.offset,
            end: Se.offset
          }, We = Xi.get(t), St = We == null ? void 0 : We.find((In) => ee.equals(In.path, Be)), pt = St ? [St.diff, Ze] : [Ze], Tt = hM(Ae.text, ...pt);
          if (Tt.length === 0 && (Ne = !1), ke.isExpanded(fe)) {
            if (Ne && ee.equals(fe.anchor.path, fe.focus.path)) {
              var Wt = {
                path: fe.anchor.path,
                offset: ae.offset
              }, et = q.range(t, Wt, Wt);
              return w(et), x(fe.anchor.path, {
                text: "",
                end: Se.offset,
                start: ae.offset
              });
            }
            return E(() => q.deleteFragment(t, {
              direction: mt
            }), {
              at: fe
            });
          }
        }
        switch (ne) {
          case "deleteByComposition":
          case "deleteByCut":
          case "deleteByDrag":
            return E(() => q.deleteFragment(t), {
              at: fe
            });
          case "deleteContent":
          case "deleteContentForward": {
            var {
              anchor: At
            } = fe;
            if (Ne && ke.isCollapsed(fe)) {
              var Gt = Te.leaf(t, At.path);
              if (At.offset < Gt.text.length)
                return x(At.path, {
                  text: "",
                  start: At.offset,
                  end: At.offset + 1
                });
            }
            return E(() => q.deleteForward(t), {
              at: fe
            });
          }
          case "deleteContentBackward": {
            var Lt, {
              anchor: ct
            } = fe, re = U5(j) ? j.isCollapsed : !!((Lt = j) !== null && Lt !== void 0 && Lt.collapsed);
            return Ne && re && ke.isCollapsed(fe) && ct.offset > 0 ? x(ct.path, {
              text: "",
              start: ct.offset - 1,
              end: ct.offset
            }) : E(() => q.deleteBackward(t), {
              at: fe
            });
          }
          case "deleteEntireSoftLine":
            return E(() => {
              q.deleteBackward(t, {
                unit: "line"
              }), q.deleteForward(t, {
                unit: "line"
              });
            }, {
              at: fe
            });
          case "deleteHardLineBackward":
            return E(() => q.deleteBackward(t, {
              unit: "block"
            }), {
              at: fe
            });
          case "deleteSoftLineBackward":
            return E(() => q.deleteBackward(t, {
              unit: "line"
            }), {
              at: fe
            });
          case "deleteHardLineForward":
            return E(() => q.deleteForward(t, {
              unit: "block"
            }), {
              at: fe
            });
          case "deleteSoftLineForward":
            return E(() => q.deleteForward(t, {
              unit: "line"
            }), {
              at: fe
            });
          case "deleteWordBackward":
            return E(() => q.deleteBackward(t, {
              unit: "word"
            }), {
              at: fe
            });
          case "deleteWordForward":
            return E(() => q.deleteForward(t, {
              unit: "word"
            }), {
              at: fe
            });
          case "insertLineBreak":
            return E(() => q.insertSoftBreak(t), {
              at: fe
            });
          case "insertParagraph":
            return E(() => q.insertBreak(t), {
              at: fe
            });
          case "insertCompositionText":
          case "deleteCompositionText":
          case "insertFromComposition":
          case "insertFromDrop":
          case "insertFromPaste":
          case "insertFromYank":
          case "insertReplacementText":
          case "insertText": {
            if (D4e(D))
              return E(() => Ue.insertData(t, D), {
                at: fe
              });
            var $e = D ?? "";
            if (Ia.get(t) && ($e = $e.replace("\uFEFF", "")), ne === "insertText" && /.*\n.*\n$/.test($e) && ($e = $e.slice(0, -1)), $e.includes(`
`))
              return E(() => {
                var In = $e.split(`
`);
                In.forEach((Qn, Yn) => {
                  Qn && q.insertText(t, Qn), Yn !== In.length - 1 && q.insertSoftBreak(t);
                });
              }, {
                at: fe
              });
            if (ee.equals(fe.anchor.path, fe.focus.path)) {
              var [vt, rt] = ke.edges(fe), Dt = {
                start: vt.offset,
                end: rt.offset,
                text: $e
              };
              if ($e && u && ne === "insertCompositionText") {
                var tn = u.start + u.text.search(/\S|$/), Xn = Dt.start + Dt.text.search(/\S|$/);
                Xn === tn + 1 && Dt.end === u.start + u.text.length ? (Dt.start -= 1, u = null, F()) : u = !1;
              } else ne === "insertText" ? u === null ? u = Dt : u && ke.isCollapsed(fe) && u.end + u.text.length === vt.offset ? u = p1(p1({}, u), {}, {
                text: u.text + $e
              }) : u = !1 : u = !1;
              if (Ne) {
                x(vt.path, Dt);
                return;
              }
            }
            return E(() => q.insertText(t, $e), {
              at: fe
            });
          }
        }
      }
    }
  }, C = () => !!Rl.get(t), T = () => {
    var X;
    return !!((X = Xi.get(t)) !== null && X !== void 0 && X.length);
  }, z = () => C() || T(), I = () => i, w = (X) => {
    Pl.set(t, X), a && (clearTimeout(a), a = null);
    var {
      selection: le
    } = t;
    if (X) {
      var ne = !le || !ee.equals(le.anchor.path, X.anchor.path), fe = !le || !ee.equals(le.anchor.path.slice(0, -1), X.anchor.path.slice(0, -1));
      (ne && u || fe) && (u = !1), (ne || T()) && (a = setTimeout(f, E4e));
    }
  }, M = () => {
    (C() || !T()) && f();
  }, R = (X) => {
    T() || (g(!0), setTimeout(g));
  }, F = () => {
    C() || (s = setTimeout(f));
  }, W = (X) => {
    if (!(T() || C()) && X.some((ne) => h8(t, ne, X))) {
      var le;
      (le = pM.get(t)) === null || le === void 0 || le();
    }
  };
  return {
    flush: f,
    scheduleFlush: F,
    hasPendingDiffs: T,
    hasPendingAction: C,
    hasPendingChanges: z,
    isFlushing: I,
    handleUserSelect: w,
    handleCompositionEnd: m,
    handleCompositionStart: y,
    handleDOMBeforeInput: b,
    handleKeyDown: R,
    handleDomMutations: W,
    handleInput: M
  };
}
function T4e() {
  var e = v.useRef(!1);
  return v.useEffect(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e.current;
}
var hf = V1 ? v.useLayoutEffect : v.useEffect;
function j4e(e, t, n) {
  var [r] = v.useState(() => new MutationObserver(t));
  hf(() => {
    r.takeRecords();
  }), v.useEffect(() => {
    if (!e.current)
      throw new Error("Failed to attach MutationObserver, `node` is undefined");
    return r.observe(e.current, n), () => r.disconnect();
  }, [r, e, n]);
}
var N4e = ["node"];
function zk(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function O4e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zk(Object(n), !0).forEach(function(r) {
      ds(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zk(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var z4e = {
  subtree: !0,
  childList: !0,
  characterData: !0
}, F4e = zi ? (e) => {
  var {
    node: t
  } = e, n = Jm(e, N4e);
  if (!zi)
    return null;
  var r = Fu(), i = T4e(), [o] = v.useState(() => A4e(O4e({
    editor: r
  }, n)));
  return j4e(t, o.handleDomMutations, z4e), v8.set(r, o.scheduleFlush), i && o.flush(), o;
} : () => null;
function Fk(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function L4e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Fk(Object(n), !0).forEach(function(r) {
      ds(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Fk(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var M4e = (e) => {
  var {
    isLast: t,
    leaf: n,
    parent: r,
    text: i
  } = e, o = Fu(), a = Ue.findPath(o, i), s = ee.parent(a), l = !!n[fM];
  return o.isVoid(r) ? /* @__PURE__ */ dt.createElement(N3, {
    length: Te.string(r).length
  }) : n.text === "" && r.children[r.children.length - 1] === i && !o.isInline(r) && q.string(o, s) === "" ? /* @__PURE__ */ dt.createElement(N3, {
    isLineBreak: !0,
    isMarkPlaceholder: l
  }) : n.text === "" ? /* @__PURE__ */ dt.createElement(N3, {
    isMarkPlaceholder: l
  }) : t && n.text.slice(-1) === `
` ? /* @__PURE__ */ dt.createElement(Lk, {
    isTrailing: !0,
    text: n.text
  }) : /* @__PURE__ */ dt.createElement(Lk, {
    text: n.text
  });
}, Lk = (e) => {
  var {
    text: t,
    isTrailing: n = !1
  } = e, r = v.useRef(null), i = () => "".concat(t ?? "").concat(n ? `
` : ""), [o] = v.useState(i);
  return hf(() => {
    var a = i();
    r.current && r.current.textContent !== a && (r.current.textContent = a);
  }), /* @__PURE__ */ dt.createElement(B4e, {
    ref: r
  }, o);
}, B4e = /* @__PURE__ */ v.memo(/* @__PURE__ */ v.forwardRef((e, t) => /* @__PURE__ */ dt.createElement("span", {
  "data-slate-string": !0,
  ref: t
}, e.children))), N3 = (e) => {
  var {
    length: t = 0,
    isLineBreak: n = !1,
    isMarkPlaceholder: r = !1
  } = e, i = {
    "data-slate-zero-width": n ? "n" : "z",
    "data-slate-length": t
  };
  return r && (i["data-slate-mark-placeholder"] = !0), /* @__PURE__ */ dt.createElement("span", L4e({}, i), !(zi || lM) || !n ? "\uFEFF" : null, n ? /* @__PURE__ */ dt.createElement("br", null) : null);
};
function Mk(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function kM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mk(Object(n), !0).forEach(function(r) {
      ds(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mk(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var I4e = zi ? 300 : 0;
function R4e(e, t) {
  e.current && (e.current.disconnect(), t && (e.current = null));
}
function Bk(e) {
  e.current && (clearTimeout(e.current), e.current = null);
}
var P4e = (e) => {
  var {
    leaf: t,
    isLast: n,
    text: r,
    parent: i,
    renderPlaceholder: o,
    renderLeaf: a = (b) => /* @__PURE__ */ dt.createElement(q4e, kM({}, b))
  } = e, s = Fu(), l = v.useRef(null), u = v.useRef(null), [d, p] = v.useState(!1), f = v.useRef(null), m = v.useCallback((b) => {
    if (R4e(l, b == null), b == null) {
      var C;
      W5.delete(s), (C = t.onPlaceholderResize) === null || C === void 0 || C.call(t, null);
    } else {
      if (W5.set(s, b), !l.current) {
        var T = window.ResizeObserver || x4e;
        l.current = new T(() => {
          var z;
          (z = t.onPlaceholderResize) === null || z === void 0 || z.call(t, b);
        });
      }
      l.current.observe(b), u.current = b;
    }
  }, [u, t, s]), y = /* @__PURE__ */ dt.createElement(M4e, {
    isLast: n,
    leaf: t,
    parent: i,
    text: r
  }), g = !!t[td];
  if (v.useEffect(() => (g ? f.current || (f.current = setTimeout(() => {
    p(!0), f.current = null;
  }, I4e)) : (Bk(f), p(!1)), () => Bk(f)), [g, p]), g && d) {
    var x = {
      children: t.placeholder,
      attributes: {
        "data-slate-placeholder": !0,
        style: {
          position: "absolute",
          top: 0,
          pointerEvents: "none",
          width: "100%",
          maxWidth: "100%",
          display: "block",
          opacity: "0.333",
          userSelect: "none",
          textDecoration: "none",
          // Fixes https://github.com/udecode/plate/issues/2315
          WebkitUserModify: nc ? "inherit" : void 0
        },
        contentEditable: !1,
        ref: m
      }
    };
    y = /* @__PURE__ */ dt.createElement(dt.Fragment, null, o(x), y);
  }
  var E = {
    "data-slate-leaf": !0
  };
  return a({
    attributes: E,
    children: y,
    leaf: t,
    text: r
  });
}, _4e = /* @__PURE__ */ dt.memo(P4e, (e, t) => t.parent === e.parent && t.isLast === e.isLast && t.renderLeaf === e.renderLeaf && t.renderPlaceholder === e.renderPlaceholder && t.text === e.text && xt.equals(t.leaf, e.leaf) && t.leaf[td] === e.leaf[td]), q4e = (e) => {
  var {
    attributes: t,
    children: n
  } = e;
  return /* @__PURE__ */ dt.createElement("span", kM({}, t), n);
}, $4e = (e) => {
  for (var {
    decorations: t,
    isLast: n,
    parent: r,
    renderPlaceholder: i,
    renderLeaf: o,
    text: a
  } = e, s = Fu(), l = v.useRef(null), u = xt.decorations(a, t), d = Ue.findKey(s, a), p = [], f = 0; f < u.length; f++) {
    var m = u[f];
    p.push(/* @__PURE__ */ dt.createElement(_4e, {
      isLast: n && f === u.length - 1,
      key: "".concat(d.id, "-").concat(f),
      renderPlaceholder: i,
      leaf: m,
      text: a,
      parent: r,
      renderLeaf: o
    }));
  }
  var y = v.useCallback((g) => {
    var x = A2.get(s);
    g ? (x == null || x.set(d, g), hc.set(a, g), df.set(g, a)) : (x == null || x.delete(d), hc.delete(a), l.current && df.delete(l.current)), l.current = g;
  }, [l, s, d, a]);
  return /* @__PURE__ */ dt.createElement("span", {
    "data-slate-node": "text",
    ref: y
  }, p);
}, EM = /* @__PURE__ */ dt.memo($4e, (e, t) => t.parent === e.parent && t.isLast === e.isLast && t.renderLeaf === e.renderLeaf && t.renderPlaceholder === e.renderPlaceholder && t.text === e.text && Y2e(t.decorations, e.decorations));
function Ik(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Y5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ik(Object(n), !0).forEach(function(r) {
      ds(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ik(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var H4e = (e) => {
  var {
    decorations: t,
    element: n,
    renderElement: r = (b) => /* @__PURE__ */ dt.createElement(U4e, Y5({}, b)),
    renderPlaceholder: i,
    renderLeaf: o,
    selection: a
  } = e, s = Fu(), l = Z4e(), u = s.isInline(n), d = Ue.findKey(s, n), p = v.useCallback((b) => {
    var C = A2.get(s);
    b ? (C == null || C.set(d, b), hc.set(n, b), df.set(b, n)) : (C == null || C.delete(d), hc.delete(n));
  }, [s, d, n]), f = TM({
    decorations: t,
    node: n,
    renderElement: r,
    renderPlaceholder: i,
    renderLeaf: o,
    selection: a
  }), m = {
    "data-slate-node": "element",
    ref: p
  };
  if (u && (m["data-slate-inline"] = !0), !u && q.hasInlines(s, n)) {
    var y = Te.string(n), g = KL(y);
    g === "rtl" && (m.dir = g);
  }
  if (q.isVoid(s, n)) {
    m["data-slate-void"] = !0, !l && u && (m.contentEditable = !1);
    var x = u ? "span" : "div", [[E]] = Te.texts(n);
    f = /* @__PURE__ */ dt.createElement(x, {
      "data-slate-spacer": !0,
      style: {
        height: "0",
        color: "transparent",
        outline: "none",
        position: "absolute"
      }
    }, /* @__PURE__ */ dt.createElement(EM, {
      renderPlaceholder: i,
      decorations: [],
      isLast: !1,
      parent: n,
      text: E
    })), m8.set(E, 0), g8.set(E, n);
  }
  return r({
    attributes: m,
    children: f,
    element: n
  });
}, V4e = /* @__PURE__ */ dt.memo(H4e, (e, t) => e.element === t.element && e.renderElement === t.renderElement && e.renderLeaf === t.renderLeaf && e.renderPlaceholder === t.renderPlaceholder && Q2e(e.decorations, t.decorations) && (e.selection === t.selection || !!e.selection && !!t.selection && ke.equals(e.selection, t.selection))), U4e = (e) => {
  var {
    attributes: t,
    children: n,
    element: r
  } = e, i = Fu(), o = i.isInline(r) ? "span" : "div";
  return /* @__PURE__ */ dt.createElement(o, Y5(Y5({}, t), {}, {
    style: {
      position: "relative"
    }
  }), n);
}, SM = /* @__PURE__ */ v.createContext(() => []), W4e = () => v.useContext(SM), DM = /* @__PURE__ */ v.createContext(!1), AM = () => v.useContext(DM), TM = (e) => {
  var {
    decorations: t,
    node: n,
    renderElement: r,
    renderPlaceholder: i,
    renderLeaf: o,
    selection: a
  } = e, s = W4e(), l = Fu();
  M0.set(l, !1);
  for (var u = Ue.findPath(l, n), d = [], p = Je.isElement(n) && !l.isInline(n) && q.hasInlines(l, n), f = 0; f < n.children.length; f++) {
    var m = u.concat(f), y = n.children[f], g = Ue.findKey(l, y), x = q.range(l, m), E = a && ke.intersection(x, a), b = s([y, m]);
    for (var C of t) {
      var T = ke.intersection(C, x);
      T && b.push(T);
    }
    Je.isElement(y) ? d.push(/* @__PURE__ */ dt.createElement(DM.Provider, {
      key: "provider-".concat(g.id),
      value: !!E
    }, /* @__PURE__ */ dt.createElement(V4e, {
      decorations: b,
      element: y,
      key: g.id,
      renderElement: r,
      renderPlaceholder: i,
      renderLeaf: o,
      selection: E
    }))) : d.push(/* @__PURE__ */ dt.createElement(EM, {
      decorations: b,
      key: g.id,
      isLast: p && f === n.children.length - 1,
      parent: n,
      renderPlaceholder: i,
      renderLeaf: o,
      text: y
    })), m8.set(y, f), g8.set(y, n);
  }
  return d;
}, jM = /* @__PURE__ */ v.createContext(!1), Z4e = () => v.useContext(jM), NM = /* @__PURE__ */ v.createContext(null), qc = () => {
  var e = v.useContext(NM);
  if (!e)
    throw new Error("The `useSlate` hook must be used inside the <Slate> component's context.");
  var {
    editor: t
  } = e;
  return t;
};
function G4e() {
  var e = Fu(), t = v.useRef(!1), n = v.useRef(0), r = v.useCallback(() => {
    if (!t.current) {
      t.current = !0;
      var i = Ue.getWindow(e);
      i.cancelAnimationFrame(n.current), n.current = i.requestAnimationFrame(() => {
        t.current = !1;
      });
    }
  }, [e]);
  return v.useEffect(() => () => cancelAnimationFrame(n.current), []), {
    receivedUserInput: t,
    onUserInput: r
  };
}
var K4e = (e, t) => {
  var n = [], r = () => {
    n = [];
  }, i = (a) => {
    if (t.current) {
      var s = a.filter((l) => h8(e, l, a));
      n.push(...s);
    }
  };
  function o() {
    n.length > 0 && (n.reverse().forEach((a) => {
      a.type !== "characterData" && (a.removedNodes.forEach((s) => {
        a.target.insertBefore(s, a.nextSibling);
      }), a.addedNodes.forEach((s) => {
        a.target.removeChild(s);
      }));
    }), r());
  }
  return {
    registerMutations: i,
    restoreDOM: o,
    clear: r
  };
}, X4e = {
  subtree: !0,
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0
};
class OM extends v.Component {
  constructor() {
    super(...arguments), ds(this, "context", null), ds(this, "manager", null), ds(this, "mutationObserver", null);
  }
  observe() {
    var t, {
      node: n
    } = this.props;
    if (!n.current)
      throw new Error("Failed to attach MutationObserver, `node` is undefined");
    (t = this.mutationObserver) === null || t === void 0 || t.observe(n.current, X4e);
  }
  componentDidMount() {
    var {
      receivedUserInput: t
    } = this.props, n = this.context;
    this.manager = K4e(n, t), this.mutationObserver = new MutationObserver(this.manager.registerMutations), this.observe();
  }
  getSnapshotBeforeUpdate() {
    var t, n, r, i = (t = this.mutationObserver) === null || t === void 0 ? void 0 : t.takeRecords();
    if (i != null && i.length) {
      var o;
      (o = this.manager) === null || o === void 0 || o.registerMutations(i);
    }
    return (n = this.mutationObserver) === null || n === void 0 || n.disconnect(), (r = this.manager) === null || r === void 0 || r.restoreDOM(), null;
  }
  componentDidUpdate() {
    var t;
    (t = this.manager) === null || t === void 0 || t.clear(), this.observe();
  }
  componentWillUnmount() {
    var t;
    (t = this.mutationObserver) === null || t === void 0 || t.disconnect();
  }
  render() {
    return this.props.children;
  }
}
ds(OM, "contextType", x8);
var Q4e = zi ? OM : (e) => {
  var {
    children: t
  } = e;
  return /* @__PURE__ */ dt.createElement(dt.Fragment, null, t);
}, Y4e = /* @__PURE__ */ v.createContext(!1), J4e = ["autoFocus", "decorate", "onDOMBeforeInput", "placeholder", "readOnly", "renderElement", "renderLeaf", "renderPlaceholder", "scrollSelectionIntoView", "style", "as", "disableDefaultStyles"], e3e = ["text"];
function Rk(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function es(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Rk(Object(n), !0).forEach(function(r) {
      ds(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Rk(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var t3e = (e) => /* @__PURE__ */ dt.createElement(dt.Fragment, null, TM(e)), n3e = /* @__PURE__ */ v.forwardRef((e, t) => {
  var n = v.useCallback((ae) => /* @__PURE__ */ dt.createElement(r3e, es({}, ae)), []), {
    autoFocus: r,
    decorate: i = i3e,
    onDOMBeforeInput: o,
    placeholder: a,
    readOnly: s = !1,
    renderElement: l,
    renderLeaf: u,
    renderPlaceholder: d = n,
    scrollSelectionIntoView: p = o3e,
    style: f = {},
    as: m = "div",
    disableDefaultStyles: y = !1
  } = e, g = Jm(e, J4e), x = qc(), [E, b] = v.useState(!1), C = v.useRef(null), T = v.useRef([]), [z, I] = v.useState(), w = v.useRef(!1), {
    onUserInput: M,
    receivedUserInput: R
  } = G4e(), [, F] = v.useReducer((ae) => ae + 1, 0);
  pM.set(x, F), Z5.set(x, s);
  var W = v.useMemo(() => ({
    isDraggingInternally: !1,
    isUpdatingSelection: !1,
    latestElement: null,
    hasMarkPlaceholder: !1
  }), []);
  v.useEffect(() => {
    C.current && r && C.current.focus();
  }, [r]);
  var X = v.useRef(), le = v.useMemo(() => l2e(() => {
    if (M0.get(x)) {
      le();
      return;
    }
    var ae = Ue.toDOMNode(x, x), Se = ae.getRootNode();
    if (!w.current && nc && Se instanceof ShadowRoot) {
      w.current = !0;
      var Ae = k2e();
      Ae ? document.execCommand("indent") : ge.deselect(x), w.current = !1;
      return;
    }
    var Be = X.current;
    if ((zi || !Ue.isComposing(x)) && (!W.isUpdatingSelection || Be != null && Be.isFlushing()) && !W.isDraggingInternally) {
      var Ze = Ue.findDocumentOrShadowRoot(x), {
        activeElement: We
      } = Ze, St = Ue.toDOMNode(x, x), pt = Ap(Ze);
      if (We === St ? (W.latestElement = We, Xl.set(x, !0)) : Xl.delete(x), !pt)
        return ge.deselect(x);
      var {
        anchorNode: Tt,
        focusNode: Wt
      } = pt, et = Ue.hasEditableTarget(x, Tt) || Ue.isTargetInsideNonReadonlyVoid(x, Tt), At = Ue.hasTarget(x, Wt);
      if (et && At) {
        var Gt = Ue.toSlateRange(x, pt, {
          exactMatch: !1,
          suppressThrow: !0
        });
        Gt && (!Ue.isComposing(x) && !(Be != null && Be.hasPendingChanges()) && !(Be != null && Be.isFlushing()) ? ge.select(x, Gt) : Be == null || Be.handleUserSelect(Gt));
      }
      s && (!et || !At) && ge.deselect(x);
    }
  }, 100), [x, s, W]), ne = v.useMemo(() => n2e(le, 0), [le]);
  X.current = F4e({
    node: C,
    onDOMSelectionChange: le,
    scheduleOnDOMSelectionChange: ne
  }), hf(() => {
    var ae, Se, Ae;
    C.current && (Ae = f8(C.current)) ? (dM.set(x, Ae), U1.set(x, C.current), hc.set(x, C.current), df.set(C.current, x)) : hc.delete(x);
    var {
      selection: Be
    } = x, Ze = Ue.findDocumentOrShadowRoot(x), We = Ap(Ze);
    if (!(!We || !Ue.isFocused(x) || (ae = X.current) !== null && ae !== void 0 && ae.hasPendingAction())) {
      var St = (et) => {
        var At = We.type !== "None";
        if (!(!Be && !At)) {
          var Gt = We.focusNode, Lt;
          if (C0 && We.rangeCount > 1) {
            var ct = We.getRangeAt(0), re = We.getRangeAt(We.rangeCount - 1);
            ct.startContainer === Gt ? Lt = re.endContainer : Lt = ct.startContainer;
          } else
            Lt = We.anchorNode;
          var $e = U1.get(x), vt = !1;
          if ($e.contains(Lt) && $e.contains(Gt) && (vt = !0), At && vt && Be && !et) {
            var rt = Ue.toSlateRange(x, We, {
              exactMatch: !0,
              // domSelection is not necessarily a valid Slate range
              // (e.g. when clicking on contentEditable:false element)
              suppressThrow: !0
            });
            if (rt && ke.equals(rt, Be)) {
              var Dt;
              if (!W.hasMarkPlaceholder || (Dt = Lt) !== null && Dt !== void 0 && (Dt = Dt.parentElement) !== null && Dt !== void 0 && Dt.hasAttribute("data-slate-mark-placeholder"))
                return;
            }
          }
          if (Be && !Ue.hasRange(x, Be)) {
            x.selection = Ue.toSlateRange(x, We, {
              exactMatch: !1,
              suppressThrow: !0
            });
            return;
          }
          W.isUpdatingSelection = !0;
          var tn = Be && Ue.toDOMRange(x, Be);
          return tn ? (Ue.isComposing(x) && !zi ? We.collapseToEnd() : ke.isBackward(Be) ? We.setBaseAndExtent(tn.endContainer, tn.endOffset, tn.startContainer, tn.startOffset) : We.setBaseAndExtent(tn.startContainer, tn.startOffset, tn.endContainer, tn.endOffset), p(x, tn)) : We.removeAllRanges(), tn;
        }
      };
      We.rangeCount <= 1 && St();
      var pt = ((Se = X.current) === null || Se === void 0 ? void 0 : Se.isFlushing()) === "action";
      if (!zi || !pt) {
        setTimeout(() => {
          W.isUpdatingSelection = !1;
        });
        return;
      }
      var Tt = null, Wt = requestAnimationFrame(() => {
        if (pt) {
          var et = (At) => {
            try {
              var Gt = Ue.toDOMNode(x, x);
              Gt.focus(), St(At);
            } catch {
            }
          };
          et(), Tt = setTimeout(() => {
            et(!0), W.isUpdatingSelection = !1;
          });
        }
      });
      return () => {
        cancelAnimationFrame(Wt), Tt && clearTimeout(Tt);
      };
    }
  });
  var fe = v.useCallback((ae) => {
    var Se = Ue.toDOMNode(x, x), Ae = Se.getRootNode();
    if (w != null && w.current && nc && Ae instanceof ShadowRoot) {
      var Be = ae.getTargetRanges(), Ze = Be[0], We = new window.Range();
      We.setStart(Ze.startContainer, Ze.startOffset), We.setEnd(Ze.endContainer, Ze.endOffset);
      var St = Ue.toSlateRange(x, We, {
        exactMatch: !1,
        suppressThrow: !1
      });
      ge.select(x, St), ae.preventDefault(), ae.stopImmediatePropagation();
      return;
    }
    if (M(), !s && Ue.hasEditableTarget(x, ae.target) && !a3e(ae, o)) {
      var pt;
      if (X.current)
        return X.current.handleDOMBeforeInput(ae);
      ne.flush(), le.flush();
      var {
        selection: Tt
      } = x, {
        inputType: Wt
      } = ae, et = ae.dataTransfer || ae.data || void 0, At = Wt === "insertCompositionText" || Wt === "deleteCompositionText";
      if (At && Ue.isComposing(x))
        return;
      var Gt = !1;
      if (Wt === "insertText" && Tt && ke.isCollapsed(Tt) && // Only use native character insertion for single characters a-z or space for now.
      // Long-press events (hold a + press 4 = ä) to choose a special character otherwise
      // causes duplicate inserts.
      ae.data && ae.data.length === 1 && /[a-z ]/i.test(ae.data) && // Chrome has issues correctly editing the start of nodes: https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
      // When there is an inline element, e.g. a link, and you select
      // right after it (the start of the next node).
      Tt.anchor.offset !== 0 && (Gt = !0, x.marks && (Gt = !1), !M0.get(x))) {
        var Lt, ct, {
          anchor: re
        } = Tt, [$e, vt] = Ue.toDOMPoint(x, re), rt = (Lt = $e.parentElement) === null || Lt === void 0 ? void 0 : Lt.closest("a"), Dt = Ue.getWindow(x);
        if (Gt && rt && Ue.hasDOMNode(x, rt)) {
          var tn, Xn = Dt == null ? void 0 : Dt.document.createTreeWalker(rt, NodeFilter.SHOW_TEXT).lastChild();
          Xn === $e && ((tn = Xn.textContent) === null || tn === void 0 ? void 0 : tn.length) === vt && (Gt = !1);
        }
        if (Gt && $e.parentElement && (Dt == null || (ct = Dt.getComputedStyle($e.parentElement)) === null || ct === void 0 ? void 0 : ct.whiteSpace) === "pre") {
          var In = q.above(x, {
            at: re.path,
            match: (Ft) => Je.isElement(Ft) && q.isBlock(x, Ft)
          });
          In && Te.string(In[0]).includes("	") && (Gt = !1);
        }
      }
      if ((!Wt.startsWith("delete") || Wt.startsWith("deleteBy")) && !M0.get(x)) {
        var [Qn] = ae.getTargetRanges();
        if (Qn) {
          var Yn = Ue.toSlateRange(x, Qn, {
            exactMatch: !1,
            suppressThrow: !1
          });
          if (!Tt || !ke.equals(Tt, Yn)) {
            Gt = !1;
            var Ce = !At && x.selection && q.rangeRef(x, x.selection);
            ge.select(x, Yn), Ce && Tp.set(x, Ce);
          }
        }
      }
      if (At)
        return;
      if (Gt || ae.preventDefault(), Tt && ke.isExpanded(Tt) && Wt.startsWith("delete")) {
        var xe = Wt.endsWith("Backward") ? "backward" : "forward";
        q.deleteFragment(x, {
          direction: xe
        });
        return;
      }
      switch (Wt) {
        case "deleteByComposition":
        case "deleteByCut":
        case "deleteByDrag": {
          q.deleteFragment(x);
          break;
        }
        case "deleteContent":
        case "deleteContentForward": {
          q.deleteForward(x);
          break;
        }
        case "deleteContentBackward": {
          q.deleteBackward(x);
          break;
        }
        case "deleteEntireSoftLine": {
          q.deleteBackward(x, {
            unit: "line"
          }), q.deleteForward(x, {
            unit: "line"
          });
          break;
        }
        case "deleteHardLineBackward": {
          q.deleteBackward(x, {
            unit: "block"
          });
          break;
        }
        case "deleteSoftLineBackward": {
          q.deleteBackward(x, {
            unit: "line"
          });
          break;
        }
        case "deleteHardLineForward": {
          q.deleteForward(x, {
            unit: "block"
          });
          break;
        }
        case "deleteSoftLineForward": {
          q.deleteForward(x, {
            unit: "line"
          });
          break;
        }
        case "deleteWordBackward": {
          q.deleteBackward(x, {
            unit: "word"
          });
          break;
        }
        case "deleteWordForward": {
          q.deleteForward(x, {
            unit: "word"
          });
          break;
        }
        case "insertLineBreak":
          q.insertSoftBreak(x);
          break;
        case "insertParagraph": {
          q.insertBreak(x);
          break;
        }
        case "insertFromComposition":
        case "insertFromDrop":
        case "insertFromPaste":
        case "insertFromYank":
        case "insertReplacementText":
        case "insertText": {
          Wt === "insertFromComposition" && Ue.isComposing(x) && (b(!1), cc.set(x, !1)), (et == null ? void 0 : et.constructor.name) === "DataTransfer" ? Ue.insertData(x, et) : typeof et == "string" && (Gt ? T.current.push(() => q.insertText(x, et)) : q.insertText(x, et));
          break;
        }
      }
      var Oe = (pt = Tp.get(x)) === null || pt === void 0 ? void 0 : pt.unref();
      Tp.delete(x), Oe && (!x.selection || !ke.equals(x.selection, Oe)) && ge.select(x, Oe);
    }
  }, [x, le, M, o, s, ne]), D = v.useCallback((ae) => {
    ae == null ? (le.cancel(), ne.cancel(), U1.delete(x), hc.delete(x), C.current && zl && C.current.removeEventListener("beforeinput", fe)) : zl && ae.addEventListener("beforeinput", fe), C.current = ae, typeof t == "function" ? t(ae) : t && (t.current = ae);
  }, [le, ne, x, fe, t]);
  hf(() => {
    var ae = Ue.getWindow(x);
    ae.document.addEventListener("selectionchange", ne);
    var Se = () => {
      W.isDraggingInternally = !1;
    };
    return ae.document.addEventListener("dragend", Se), ae.document.addEventListener("drop", Se), () => {
      ae.document.removeEventListener("selectionchange", ne), ae.document.removeEventListener("dragend", Se), ae.document.removeEventListener("drop", Se);
    };
  }, [ne, W]);
  var j = i([x, []]), de = a && x.children.length === 1 && Array.from(Te.texts(x)).length === 1 && Te.string(x) === "" && !E, ye = v.useCallback((ae) => {
    if (ae && de) {
      var Se;
      I((Se = ae.getBoundingClientRect()) === null || Se === void 0 ? void 0 : Se.height);
    } else
      I(void 0);
  }, [de]);
  if (de) {
    var Ne = q.start(x, []);
    j.push({
      [td]: !0,
      placeholder: a,
      onPlaceholderResize: ye,
      anchor: Ne,
      focus: Ne
    });
  }
  var {
    marks: Me
  } = x;
  if (W.hasMarkPlaceholder = !1, x.selection && ke.isCollapsed(x.selection) && Me) {
    var {
      anchor: Ie
    } = x.selection, at = Te.leaf(x, Ie.path), Ve = Jm(at, e3e);
    if (!xt.equals(at, Me, {
      loose: !0
    })) {
      W.hasMarkPlaceholder = !0;
      var mt = Object.fromEntries(Object.keys(Ve).map((ae) => [ae, null]));
      j.push(es(es(es({
        [fM]: !0
      }, mt), Me), {}, {
        anchor: Ie,
        focus: Ie
      }));
    }
  }
  return v.useEffect(() => {
    setTimeout(() => {
      var {
        selection: ae
      } = x;
      if (ae) {
        var {
          anchor: Se
        } = ae, Ae = Te.leaf(x, Se.path);
        if (Me && !xt.equals(Ae, Me, {
          loose: !0
        })) {
          Ia.set(x, Me);
          return;
        }
      }
      Ia.delete(x);
    });
  }), /* @__PURE__ */ dt.createElement(jM.Provider, {
    value: s
  }, /* @__PURE__ */ dt.createElement(Y4e.Provider, {
    value: E
  }, /* @__PURE__ */ dt.createElement(SM.Provider, {
    value: i
  }, /* @__PURE__ */ dt.createElement(Q4e, {
    node: C,
    receivedUserInput: R
  }, /* @__PURE__ */ dt.createElement(m, es(es({
    role: s ? void 0 : "textbox",
    "aria-multiline": s ? void 0 : !0
  }, g), {}, {
    // COMPAT: Certain browsers don't support the `beforeinput` event, so we'd
    // have to use hacks to make these replacement-based features work.
    // For SSR situations HAS_BEFORE_INPUT_SUPPORT is false and results in prop
    // mismatch warning app moves to browser. Pass-through consumer props when
    // not CAN_USE_DOM (SSR) and default to falsy value
    spellCheck: zl || !V1 ? g.spellCheck : !1,
    autoCorrect: zl || !V1 ? g.autoCorrect : "false",
    autoCapitalize: zl || !V1 ? g.autoCapitalize : "false",
    "data-slate-editor": !0,
    "data-slate-node": "value",
    // explicitly set this
    contentEditable: !s,
    // in some cases, a decoration needs access to the range / selection to decorate a text node,
    // then you will select the whole text node when you select part the of text
    // this magic zIndex="-1" will fix it
    zindex: -1,
    suppressContentEditableWarning: !0,
    ref: D,
    style: es(es({}, y ? {} : es({
      // Allow positioning relative to the editable element.
      position: "relative",
      // Preserve adjacent whitespace and new lines.
      whiteSpace: "pre-wrap",
      // Allow words to break if they are too long.
      wordWrap: "break-word"
    }, z ? {
      minHeight: z
    } : {})), f),
    onBeforeInput: v.useCallback((ae) => {
      if (!zl && !s && !Ai(ae, g.onBeforeInput) && Ue.hasSelectableTarget(x, ae.target) && (ae.preventDefault(), !Ue.isComposing(x))) {
        var Se = ae.data;
        q.insertText(x, Se);
      }
    }, [g.onBeforeInput, x, s]),
    onInput: v.useCallback((ae) => {
      if (!Ai(ae, g.onInput)) {
        if (X.current) {
          X.current.handleInput();
          return;
        }
        for (var Se of T.current)
          Se();
        if (T.current = [], !Ue.isFocused(x)) {
          var Ae = ae.nativeEvent, Be = x;
          if (Ae.inputType === "historyUndo" && typeof Be.undo == "function") {
            Be.undo();
            return;
          }
          if (Ae.inputType === "historyRedo" && typeof Be.redo == "function") {
            Be.redo();
            return;
          }
        }
      }
    }, [g.onInput, x]),
    onBlur: v.useCallback((ae) => {
      if (!(s || W.isUpdatingSelection || !Ue.hasSelectableTarget(x, ae.target) || Ai(ae, g.onBlur))) {
        var Se = Ue.findDocumentOrShadowRoot(x);
        if (W.latestElement !== Se.activeElement) {
          var {
            relatedTarget: Ae
          } = ae, Be = Ue.toDOMNode(x, x);
          if (Ae !== Be && !(ra(Ae) && Ae.hasAttribute("data-slate-spacer"))) {
            if (Ae != null && wu(Ae) && Ue.hasDOMNode(x, Ae)) {
              var Ze = Ue.toSlateNode(x, Ae);
              if (Je.isElement(Ze) && !x.isVoid(Ze))
                return;
            }
            if (nc) {
              var We = Ap(Se);
              We == null || We.removeAllRanges();
            }
            Xl.delete(x);
          }
        }
      }
    }, [s, W.isUpdatingSelection, W.latestElement, x, g.onBlur]),
    onClick: v.useCallback((ae) => {
      if (Ue.hasTarget(x, ae.target) && !Ai(ae, g.onClick) && wu(ae.target)) {
        var Se = Ue.toSlateNode(x, ae.target), Ae = Ue.findPath(x, Se);
        if (!q.hasPath(x, Ae) || Te.get(x, Ae) !== Se)
          return;
        if (ae.detail === H2e && Ae.length >= 1) {
          var Be = Ae;
          if (!(Je.isElement(Se) && q.isBlock(x, Se))) {
            var Ze, We = q.above(x, {
              match: (Gt) => Je.isElement(Gt) && q.isBlock(x, Gt),
              at: Ae
            });
            Be = (Ze = We == null ? void 0 : We[1]) !== null && Ze !== void 0 ? Ze : Ae.slice(0, 1);
          }
          var St = q.range(x, Be);
          ge.select(x, St);
          return;
        }
        if (s)
          return;
        var pt = q.start(x, Ae), Tt = q.end(x, Ae), Wt = q.void(x, {
          at: pt
        }), et = q.void(x, {
          at: Tt
        });
        if (Wt && et && ee.equals(Wt[1], et[1])) {
          var At = q.range(x, pt);
          ge.select(x, At);
        }
      }
    }, [x, g.onClick, s]),
    onCompositionEnd: v.useCallback((ae) => {
      if (Ue.hasSelectableTarget(x, ae.target)) {
        var Se;
        if (Ue.isComposing(x) && Promise.resolve().then(() => {
          b(!1), cc.set(x, !1);
        }), (Se = X.current) === null || Se === void 0 || Se.handleCompositionEnd(ae), Ai(ae, g.onCompositionEnd) || zi)
          return;
        if (!nc && !T2e && !lM && !N2e && !j2e && ae.data) {
          var Ae = Ia.get(x);
          Ia.delete(x), Ae !== void 0 && (Ws.set(x, x.marks), x.marks = Ae), q.insertText(x, ae.data);
          var Be = Ws.get(x);
          Ws.delete(x), Be !== void 0 && (x.marks = Be);
        }
      }
    }, [g.onCompositionEnd, x]),
    onCompositionUpdate: v.useCallback((ae) => {
      Ue.hasSelectableTarget(x, ae.target) && !Ai(ae, g.onCompositionUpdate) && (Ue.isComposing(x) || (b(!0), cc.set(x, !0)));
    }, [g.onCompositionUpdate, x]),
    onCompositionStart: v.useCallback((ae) => {
      if (Ue.hasSelectableTarget(x, ae.target)) {
        var Se;
        if ((Se = X.current) === null || Se === void 0 || Se.handleCompositionStart(ae), Ai(ae, g.onCompositionStart) || zi)
          return;
        b(!0);
        var {
          selection: Ae
        } = x;
        if (Ae && ke.isExpanded(Ae)) {
          q.deleteFragment(x);
          return;
        }
      }
    }, [g.onCompositionStart, x]),
    onCopy: v.useCallback((ae) => {
      Ue.hasSelectableTarget(x, ae.target) && !Ai(ae, g.onCopy) && !Pk(ae) && (ae.preventDefault(), Ue.setFragmentData(x, ae.clipboardData, "copy"));
    }, [g.onCopy, x]),
    onCut: v.useCallback((ae) => {
      if (!s && Ue.hasSelectableTarget(x, ae.target) && !Ai(ae, g.onCut) && !Pk(ae)) {
        ae.preventDefault(), Ue.setFragmentData(x, ae.clipboardData, "cut");
        var {
          selection: Se
        } = x;
        if (Se)
          if (ke.isExpanded(Se))
            q.deleteFragment(x);
          else {
            var Ae = Te.parent(x, Se.anchor.path);
            q.isVoid(x, Ae) && ge.delete(x);
          }
      }
    }, [s, x, g.onCut]),
    onDragOver: v.useCallback((ae) => {
      if (Ue.hasTarget(x, ae.target) && !Ai(ae, g.onDragOver)) {
        var Se = Ue.toSlateNode(x, ae.target);
        Je.isElement(Se) && q.isVoid(x, Se) && ae.preventDefault();
      }
    }, [g.onDragOver, x]),
    onDragStart: v.useCallback((ae) => {
      if (!s && Ue.hasTarget(x, ae.target) && !Ai(ae, g.onDragStart)) {
        var Se = Ue.toSlateNode(x, ae.target), Ae = Ue.findPath(x, Se), Be = Je.isElement(Se) && q.isVoid(x, Se) || q.void(x, {
          at: Ae,
          voids: !0
        });
        if (Be) {
          var Ze = q.range(x, Ae);
          ge.select(x, Ze);
        }
        W.isDraggingInternally = !0, Ue.setFragmentData(x, ae.dataTransfer, "drag");
      }
    }, [s, x, g.onDragStart, W]),
    onDrop: v.useCallback((ae) => {
      if (!s && Ue.hasTarget(x, ae.target) && !Ai(ae, g.onDrop)) {
        ae.preventDefault();
        var Se = x.selection, Ae = Ue.findEventRange(x, ae), Be = ae.dataTransfer;
        ge.select(x, Ae), W.isDraggingInternally && Se && !ke.equals(Se, Ae) && !q.void(x, {
          at: Ae,
          voids: !0
        }) && ge.delete(x, {
          at: Se
        }), Ue.insertData(x, Be), Ue.isFocused(x) || Ue.focus(x);
      }
    }, [s, x, g.onDrop, W]),
    onDragEnd: v.useCallback((ae) => {
      !s && W.isDraggingInternally && g.onDragEnd && Ue.hasTarget(x, ae.target) && g.onDragEnd(ae);
    }, [s, W, g, x]),
    onFocus: v.useCallback((ae) => {
      if (!s && !W.isUpdatingSelection && Ue.hasEditableTarget(x, ae.target) && !Ai(ae, g.onFocus)) {
        var Se = Ue.toDOMNode(x, x), Ae = Ue.findDocumentOrShadowRoot(x);
        if (W.latestElement = Ae.activeElement, C0 && ae.target !== Se) {
          Se.focus();
          return;
        }
        Xl.set(x, !0);
      }
    }, [s, W, x, g.onFocus]),
    onKeyDown: v.useCallback((ae) => {
      if (!s && Ue.hasEditableTarget(x, ae.target)) {
        var Se;
        (Se = X.current) === null || Se === void 0 || Se.handleKeyDown(ae);
        var {
          nativeEvent: Ae
        } = ae;
        if (Ue.isComposing(x) && Ae.isComposing === !1 && (cc.set(x, !1), b(!1)), Ai(ae, g.onKeyDown) || Ue.isComposing(x))
          return;
        var {
          selection: Be
        } = x, Ze = x.children[Be !== null ? Be.focus.path[0] : 0], We = KL(Te.string(Ze)) === "rtl";
        if (ar.isRedo(Ae)) {
          ae.preventDefault();
          var St = x;
          typeof St.redo == "function" && St.redo();
          return;
        }
        if (ar.isUndo(Ae)) {
          ae.preventDefault();
          var pt = x;
          typeof pt.undo == "function" && pt.undo();
          return;
        }
        if (ar.isMoveLineBackward(Ae)) {
          ae.preventDefault(), ge.move(x, {
            unit: "line",
            reverse: !0
          });
          return;
        }
        if (ar.isMoveLineForward(Ae)) {
          ae.preventDefault(), ge.move(x, {
            unit: "line"
          });
          return;
        }
        if (ar.isExtendLineBackward(Ae)) {
          ae.preventDefault(), ge.move(x, {
            unit: "line",
            edge: "focus",
            reverse: !0
          });
          return;
        }
        if (ar.isExtendLineForward(Ae)) {
          ae.preventDefault(), ge.move(x, {
            unit: "line",
            edge: "focus"
          });
          return;
        }
        if (ar.isMoveBackward(Ae)) {
          ae.preventDefault(), Be && ke.isCollapsed(Be) ? ge.move(x, {
            reverse: !We
          }) : ge.collapse(x, {
            edge: We ? "end" : "start"
          });
          return;
        }
        if (ar.isMoveForward(Ae)) {
          ae.preventDefault(), Be && ke.isCollapsed(Be) ? ge.move(x, {
            reverse: We
          }) : ge.collapse(x, {
            edge: We ? "start" : "end"
          });
          return;
        }
        if (ar.isMoveWordBackward(Ae)) {
          ae.preventDefault(), Be && ke.isExpanded(Be) && ge.collapse(x, {
            edge: "focus"
          }), ge.move(x, {
            unit: "word",
            reverse: !We
          });
          return;
        }
        if (ar.isMoveWordForward(Ae)) {
          ae.preventDefault(), Be && ke.isExpanded(Be) && ge.collapse(x, {
            edge: "focus"
          }), ge.move(x, {
            unit: "word",
            reverse: We
          });
          return;
        }
        if (zl) {
          if ((uM || nc) && Be && (ar.isDeleteBackward(Ae) || ar.isDeleteForward(Ae)) && ke.isCollapsed(Be)) {
            var Tt = Te.parent(x, Be.anchor.path);
            if (Je.isElement(Tt) && q.isVoid(x, Tt) && (q.isInline(x, Tt) || q.isBlock(x, Tt))) {
              ae.preventDefault(), q.deleteBackward(x, {
                unit: "block"
              });
              return;
            }
          }
        } else {
          if (ar.isBold(Ae) || ar.isItalic(Ae) || ar.isTransposeCharacter(Ae)) {
            ae.preventDefault();
            return;
          }
          if (ar.isSoftBreak(Ae)) {
            ae.preventDefault(), q.insertSoftBreak(x);
            return;
          }
          if (ar.isSplitBlock(Ae)) {
            ae.preventDefault(), q.insertBreak(x);
            return;
          }
          if (ar.isDeleteBackward(Ae)) {
            ae.preventDefault(), Be && ke.isExpanded(Be) ? q.deleteFragment(x, {
              direction: "backward"
            }) : q.deleteBackward(x);
            return;
          }
          if (ar.isDeleteForward(Ae)) {
            ae.preventDefault(), Be && ke.isExpanded(Be) ? q.deleteFragment(x, {
              direction: "forward"
            }) : q.deleteForward(x);
            return;
          }
          if (ar.isDeleteLineBackward(Ae)) {
            ae.preventDefault(), Be && ke.isExpanded(Be) ? q.deleteFragment(x, {
              direction: "backward"
            }) : q.deleteBackward(x, {
              unit: "line"
            });
            return;
          }
          if (ar.isDeleteLineForward(Ae)) {
            ae.preventDefault(), Be && ke.isExpanded(Be) ? q.deleteFragment(x, {
              direction: "forward"
            }) : q.deleteForward(x, {
              unit: "line"
            });
            return;
          }
          if (ar.isDeleteWordBackward(Ae)) {
            ae.preventDefault(), Be && ke.isExpanded(Be) ? q.deleteFragment(x, {
              direction: "backward"
            }) : q.deleteBackward(x, {
              unit: "word"
            });
            return;
          }
          if (ar.isDeleteWordForward(Ae)) {
            ae.preventDefault(), Be && ke.isExpanded(Be) ? q.deleteFragment(x, {
              direction: "forward"
            }) : q.deleteForward(x, {
              unit: "word"
            });
            return;
          }
        }
      }
    }, [s, x, g.onKeyDown]),
    onPaste: v.useCallback((ae) => {
      !s && Ue.hasEditableTarget(x, ae.target) && !Ai(ae, g.onPaste) && (!zl || v2e(ae.nativeEvent) || nc) && (ae.preventDefault(), Ue.insertData(x, ae.clipboardData));
    }, [s, x, g.onPaste])
  }), /* @__PURE__ */ dt.createElement(t3e, {
    decorations: j,
    node: x,
    renderElement: l,
    renderPlaceholder: d,
    renderLeaf: u,
    selection: x.selection
  }))))));
}), r3e = (e) => {
  var {
    attributes: t,
    children: n
  } = e;
  return (
    // COMPAT: Artificially add a line-break to the end on the placeholder element
    // to prevent Android IMEs to pick up its content in autocorrect and to auto-capitalize the first letter
    /* @__PURE__ */ dt.createElement("span", es({}, t), n, zi && /* @__PURE__ */ dt.createElement("br", null))
  );
}, i3e = () => [], o3e = (e, t) => {
  if (t.getBoundingClientRect && (!e.selection || e.selection && ke.isCollapsed(e.selection))) {
    var n = t.startContainer.parentElement;
    n.getBoundingClientRect = t.getBoundingClientRect.bind(t), d2e(n, {
      scrollMode: "if-needed"
    }), delete n.getBoundingClientRect;
  }
}, Ai = (e, t) => {
  if (!t)
    return !1;
  var n = t(e);
  return n ?? (e.isDefaultPrevented() || e.isPropagationStopped());
}, Pk = (e) => wu(e.target) && (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement), a3e = (e, t) => {
  if (!t)
    return !1;
  var n = t(e);
  return n ?? e.defaultPrevented;
}, zM = /* @__PURE__ */ v.createContext(!1), s3e = () => v.useContext(zM), l3e = /* @__PURE__ */ v.createContext({});
function u3e(e) {
  var t = v.useRef([]).current, n = v.useRef({
    editor: e
  }).current, r = v.useCallback((o) => {
    n.editor = o, t.forEach((a) => a(o));
  }, [t, n]), i = v.useMemo(() => ({
    getSlate: () => n.editor,
    addEventListener: (o) => (t.push(o), () => {
      t.splice(t.indexOf(o), 1);
    })
  }), [t, n]);
  return {
    selectorContext: i,
    onChange: r
  };
}
var FM = parseInt(dt.version.split(".")[0], 10), c3e = ["editor", "children", "onChange", "onSelectionChange", "onValueChange", "initialValue"], d3e = (e) => {
  var {
    editor: t,
    children: n,
    onChange: r,
    onSelectionChange: i,
    onValueChange: o,
    initialValue: a
  } = e, s = Jm(e, c3e), [l, u] = dt.useState(() => {
    if (!Te.isNodeList(a))
      throw new Error("[Slate] initialValue is invalid! Expected a list of elements but got: ".concat(Gr.stringify(a)));
    if (!q.isEditor(t))
      throw new Error("[Slate] editor is invalid! You passed: ".concat(Gr.stringify(t)));
    return t.children = a, Object.assign(t, s), {
      v: 0,
      editor: t
    };
  }), {
    selectorContext: d,
    onChange: p
  } = u3e(t), f = v.useCallback((g) => {
    var x;
    switch (r && r(t.children), g == null || (x = g.operation) === null || x === void 0 ? void 0 : x.type) {
      case "set_selection":
        i == null || i(t.selection);
        break;
      default:
        o == null || o(t.children);
    }
    u((E) => ({
      v: E.v + 1,
      editor: t
    })), p(t);
  }, [t, p, r, i, o]);
  v.useEffect(() => (G5.set(t, f), () => {
    G5.set(t, () => {
    });
  }), [t, f]);
  var [m, y] = v.useState(Ue.isFocused(t));
  return v.useEffect(() => {
    y(Ue.isFocused(t));
  }, [t]), hf(() => {
    var g = () => y(Ue.isFocused(t));
    return FM >= 17 ? (document.addEventListener("focusin", g), document.addEventListener("focusout", g), () => {
      document.removeEventListener("focusin", g), document.removeEventListener("focusout", g);
    }) : (document.addEventListener("focus", g, !0), document.addEventListener("blur", g, !0), () => {
      document.removeEventListener("focus", g, !0), document.removeEventListener("blur", g, !0);
    });
  }, []), /* @__PURE__ */ dt.createElement(l3e.Provider, {
    value: d
  }, /* @__PURE__ */ dt.createElement(NM.Provider, {
    value: l
  }, /* @__PURE__ */ dt.createElement(x8.Provider, {
    value: l.editor
  }, /* @__PURE__ */ dt.createElement(zM.Provider, {
    value: m
  }, n))));
}, p3e = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x-slate-fragment", n = e;
  n = $2e(n, t);
  var {
    onChange: r
  } = n;
  return n.onChange = (i) => {
    var o = FM < 18 ? Cf.unstable_batchedUpdates : (a) => a();
    o(() => {
      r(i);
    });
  }, n;
};
const f3e = (e) => {
  const { normalizeNode: t } = e;
  return e.normalizeNode = (n, { operation: r } = { operation: void 0 }) => {
    const [i, o] = n, a = (r == null ? void 0 : r.type) === "blur_container";
    if (h3e(e, i, o, a)) {
      ge.removeNodes(e, { at: o }), a && Ue.blur(e);
      return;
    }
    t(n);
  }, e;
};
function Gd(e, t) {
  return Je.isElement(t) && t.type === "p" && q.isEmpty(e, t);
}
function h3e(e, t, n, r) {
  if (!Gd(e, t)) return !1;
  const i = ee.hasPrevious(n) && ee.previous(n);
  if (!i || !Te.has(e, i)) return !1;
  const o = Te.get(e, i), a = Gd(
    e,
    o
  );
  if (r) return a;
  let s = a ? 1 : 0;
  const l = ee.next(n);
  let u = !1;
  if (Te.has(e, l)) {
    const f = Te.get(e, l);
    u = Gd(e, f), u && (s += 1);
  }
  if (s > 1) return !0;
  const d = ee.hasPrevious(i) && ee.previous(i);
  if (d && Te.has(e, d)) {
    const f = Te.get(e, d);
    a && Gd(e, f) && (s += 1);
  }
  if (s > 1) return !0;
  const p = ee.next(l);
  if (Te.has(e, p)) {
    const f = Te.get(e, p);
    u && Gd(e, f) && (s += 1);
  }
  return s > 1;
}
const m3e = (e) => {
  const { isInline: t } = e;
  return e.isInline = (n) => n.type === "a" ? !0 : t(n), e;
};
function Cs(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.selection;
  if (!n)
    return [];
  const r = g3e(n), i = q.nodes(e, {
    at: n,
    match: t.isListItemNode
  });
  return Array.from(i).filter((o) => {
    let [, a] = o;
    const [, s] = ee.ancestors(r, {
      reverse: !0
    }), l = ee.equals(a, s), u = ee.isDescendant(r, a), d = ee.isAfter(r, a);
    return u ? !d && l : !d;
  });
}
function g3e(e) {
  if (ke.isRange(e))
    return ke.start(e).path;
  if (Ut.isPoint(e))
    return e.path;
  if (a8.isSpan(e)) {
    const [t, n] = e;
    return ee.compare(t, n) <= 0 ? t : n;
  }
  return e;
}
function T2(e, t, n) {
  return q.above(e, {
    at: n,
    match: (r) => t.isListItemNode(r)
  }) ?? null;
}
function Zf(e, t) {
  let n;
  try {
    n = ee.previous(t);
  } catch {
    return null;
  }
  return Te.has(e, n) ? [Te.get(e, n), n] : null;
}
function j2(e, t) {
  return t ? ke.isRange(t) ? ke.isCollapsed(t) ? t.focus : null : a8.isSpan(t) ? ee.equals(t[0], t[1]) ? j2(e, t[0]) : null : ee.isPath(t) ? q.point(e, t, {
    edge: "start"
  }) : t : null;
}
function LM(e, t, n) {
  const r = q.start(e, n), i = q.end(e, n), o = Ut.equals(t, r);
  return {
    isEnd: Ut.equals(t, i),
    isStart: o
  };
}
function MM(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.selection;
  const r = j2(e, n);
  if (!r)
    return !1;
  const i = Cs(e, t, r);
  if (i.length !== 1)
    return !1;
  const [[, o]] = i, {
    isStart: a
  } = LM(e, r, o);
  return a;
}
function BM(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.selection;
  const r = Cs(e, t, n);
  if (r.length === 0)
    return !0;
  const [[, i]] = r, o = T2(e, t, i) !== null, a = Zf(e, i) === null;
  return o || !a || !MM(e, t);
}
function b8(e, t, n) {
  return q.above(e, {
    at: n,
    match: (r) => t.isListNode(r)
  }) ?? null;
}
function IM(e, t, n) {
  return Cs(e, t, n).map((r) => {
    let [, i] = r;
    return b8(e, t, i);
  }).filter((r) => r !== null);
}
let sa = /* @__PURE__ */ function(e) {
  return e.ORDERED = "ol", e.UNORDERED = "ul", e;
}({});
function mf(e, t) {
  const n = Je.isElement(t);
  return n && e.isListNode(t, sa.ORDERED) ? sa.ORDERED : (n && e.isListNode(t, sa.UNORDERED), sa.UNORDERED);
}
const RM = 0, nd = 1;
function PM(e, t, n) {
  const r = [...n, nd];
  if (!Te.has(e, r))
    return null;
  const i = Te.get(e, r);
  return Je.isElement(i) && t.isListNode(i) ? [i, r] : null;
}
function v3e(e, t) {
  let n;
  try {
    n = ee.next(t);
  } catch {
    return null;
  }
  return Te.has(e, n) ? [Te.get(e, n), n] : null;
}
function _M(e, t, n) {
  return Je.isElement(n) && t.isListItemNode(n) ? n.children.some((r) => Je.isElement(r) && t.isListItemTextNode(r) && !q.isEmpty(e, r)) : !1;
}
function qM(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.selection;
  const r = j2(e, n);
  if (!r)
    return !1;
  const i = Cs(e, t, r);
  if (i.length !== 1)
    return !1;
  const [[o]] = i;
  return !_M(e, t, o);
}
function $M(e) {
  return e.children.some(xt.isText);
}
function HM(e) {
  return "children" in e;
}
function y3e(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.selection;
  if (!n)
    return !1;
  for (const [r] of q.levels(e, {
    at: n
  }))
    if (t.isListNode(r))
      return !0;
  return !1;
}
function VM(e) {
  return e.filter((t) => {
    let [, n] = t;
    return !ee.ancestors(n).some((r) => e.some((i) => {
      let [, o] = i;
      return ee.equals(o, r);
    }));
  });
}
const w8 = /* @__PURE__ */ new WeakMap();
function x3e(e, t) {
  w8.set(e, t);
}
function _k(e) {
  return w8.has(e);
}
function UM(e) {
  const t = w8.get(e);
  if (!t)
    throw new Error("This editor instance does not have a ListsSchema associated. Make sure you initialize it with withLists() before using ListsEditor functionality.");
  return t;
}
function C8(e, t, n) {
  const r = Zf(e, n);
  if (!r)
    return !1;
  const [i, o] = r;
  if (!t.isListItemNode(i))
    return !1;
  const a = [...o, nd], s = Te.has(e, a);
  let l = !1;
  return q.withoutNormalizing(e, () => {
    if (!s) {
      const d = ee.ancestors(n, {
        reverse: !0
      })[0], p = Te.get(e, d);
      ge.insertNodes(e, t.createListNode(mf(t, p), {
        children: []
      }), {
        at: a
      }), l = !0;
    }
    const u = Te.get(e, a);
    if (Je.isElement(u) && t.isListNode(u)) {
      const d = s ? u.children.length : 0;
      ge.moveNodes(e, {
        at: n,
        to: [...a, d]
      }), l = !0;
    }
  }), l;
}
function WM(e, t, n) {
  const r = b8(e, t, n);
  if (!r)
    return !1;
  const [i, o] = r, a = T2(e, t, n), s = n[n.length - 1], l = i.children.slice(0, s), u = i.children.slice(s + 1);
  return q.withoutNormalizing(e, () => {
    if (u.forEach(() => {
      const d = [...o, s + 1];
      C8(e, t, d);
    }), a) {
      const [, d] = a;
      ge.moveNodes(e, {
        at: n,
        to: ee.next(d)
      }), l.length === 0 && ge.removeNodes(e, {
        at: o
      });
    } else {
      const d = [...n, RM], p = [...n, nd];
      Te.has(e, p) && (ge.setNodes(e, t.createListNode(mf(t, i), {
        children: []
      }), {
        at: p
      }), ge.liftNodes(e, {
        at: p
      }), ge.liftNodes(e, {
        at: ee.next(n)
      })), Te.has(e, d) && (ge.setNodes(e, t.createDefaultTextNode(), {
        at: d
      }), ge.liftNodes(e, {
        at: d
      }), ge.liftNodes(e, {
        at: n
      }));
    }
  }), !0;
}
function Gf(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.selection;
  if (!n)
    return !1;
  const r = Cs(e, t, n), i = VM(r).map((a) => {
    let [s, l] = a;
    return q.pathRef(e, l);
  });
  let o = !1;
  return i.forEach((a) => {
    a.current && (o = WM(e, t, a.current) || o), a.unref();
  }), o;
}
function ZM(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : e.selection;
  if (!r)
    return !1;
  const i = Array.from(q.nodes(e, {
    at: r,
    match: (o) => Je.isElement(o) && !t.isListNode(o) && !t.isListItemNode(o) && !t.isListItemTextNode(o) && t.isConvertibleToListTextNode(o)
  }));
  return i.length === 0 ? !1 : (i.map((o) => {
    let [a, s] = o;
    return q.pathRef(e, s);
  }).forEach((o) => {
    const a = o.current;
    a && q.withoutNormalizing(e, () => {
      ge.setNodes(e, t.createListItemTextNode(), {
        at: a
      }), ge.wrapNodes(e, t.createListItemNode(), {
        at: a
      }), ge.wrapNodes(e, t.createListNode(n), {
        at: a
      });
    }), o.unref();
  }), !0);
}
function GM(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.selection;
  if (!n)
    return !1;
  const r = Cs(e, t, n).filter((o) => {
    let [, a] = o;
    return Zf(e, a) !== null;
  });
  if (r.length === 0)
    return !1;
  const i = VM(r).map((o) => {
    let [a, s] = o;
    return q.pathRef(e, s);
  });
  return q.withoutNormalizing(e, () => {
    ZM(e, t, sa.UNORDERED), i.forEach((o) => {
      o.current && C8(e, t, o.current), o.unref();
    });
  }), !0;
}
function J5(e, t, n) {
  let [r, i] = n;
  if (!t.isListNode(r))
    return !1;
  const o = Zf(e, i);
  if (!o)
    return !1;
  const [a] = o;
  if (!t.isListNode(a))
    return !1;
  const s = !!T2(e, t, i);
  return mf(t, a) !== mf(t, r) && !s ? !1 : (ge.mergeNodes(e, {
    at: i
  }), !0);
}
function KM(e, t, n) {
  const [r, i] = n.at, [o, a] = n.to;
  if (Je.isElement(r) && Je.isElement(o) && t.isListNode(r) && t.isListNode(o) && r.children.length > 0) {
    for (let s = 0; s < r.children.length; ++s)
      ge.moveNodes(e, {
        at: [...i, 0],
        to: [...a, o.children.length + s]
      });
    return !0;
  }
  return !1;
}
function XM(e, t, n) {
  const [r, i] = n.at, [o, a] = n.to;
  !t.isListNode(r) || !t.isListItemNode(o) || ge.moveNodes(e, {
    at: i,
    to: [...a, nd]
  });
}
function b3e(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : e.selection;
  if (!r)
    return !1;
  const i = IM(e, t, r);
  return i.length === 0 ? !1 : (i.map((o) => {
    let [a, s] = o;
    return q.pathRef(e, s);
  }).forEach((o) => {
    const a = o.current, s = a ? Te.get(e, a) : null;
    s && a && ge.setNodes(e, t.createListNode(n, s), {
      at: a
    }), o.unref();
  }), !0);
}
function QM(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.selection;
  if (!n)
    return !1;
  const r = j2(e, ke.isRange(n) ? ke.start(n) : n);
  if (!r)
    return !1;
  ke.isRange(n) && ke.isExpanded(n) && ge.delete(e);
  const i = Cs(e, t, e.selection);
  if (i.length !== 1)
    return !1;
  const [[o, a]] = i, s = [...a, RM], {
    isEnd: l,
    isStart: u
  } = LM(e, r, s);
  if (u) {
    const m = t.createListItemNode({
      children: [t.createListItemTextNode()]
    });
    return ge.insertNodes(e, m, {
      at: a
    }), !0;
  }
  const d = ee.next(a), p = ee.next(s), f = Te.has(o, [nd]);
  return q.withoutNormalizing(e, () => {
    if (l) {
      const m = t.createListItemNode({
        children: [t.createListItemTextNode()]
      });
      ge.insertNodes(e, m, {
        at: d
      }), ge.select(e, d);
    } else
      ge.splitNodes(e), ge.wrapNodes(e, t.createListItemNode(), {
        at: p
      }), ge.moveNodes(e, {
        at: p,
        to: d
      });
    f && ge.moveNodes(e, {
      at: ee.next(s),
      to: [...d, nd]
    });
  }), !0;
}
function w3e(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.selection;
  if (!n)
    return !1;
  let r = 0;
  const i = C3e(n), o = q.pathRef(e, i[0]), a = q.pathRef(e, i[1]);
  return q.withoutNormalizing(e, () => {
    do {
      if (!o.current || !a.current)
        break;
      const s = [o.current, a.current];
      if (Cs(e, t, s).length === 0)
        break;
      r++, Gf(e, t, s);
    } while (r < 1e3);
    if (r >= 1e3)
      throw new Error("Too many iterations. Most likely there is a bug causing an infinite loop.");
  }), o.unref(), a.unref(), r > 0;
}
function C3e(e) {
  if (ke.isRange(e)) {
    const [t, n] = ke.edges(e);
    return [t.path, n.path];
  }
  return Ut.isPoint(e) ? [e.path, e.path] : [e, e];
}
function gn(e) {
  return UM(e);
}
const Li = {
  // ListsEditor schema availability
  isListsEnabled(e) {
    return _k(e);
  },
  getListsSchema(e) {
    return _k(e) ? UM(e) : void 0;
  },
  // Schema proxies
  isConvertibleToListTextNode(e, t) {
    return gn(e).isConvertibleToListTextNode(t);
  },
  isDefaultTextNode(e, t) {
    return gn(e).isDefaultTextNode(t);
  },
  isListNode(e, t, n) {
    return gn(e).isListNode(t, n);
  },
  isListItemNode(e, t) {
    return gn(e).isListItemNode(t);
  },
  isListItemTextNode(e, t) {
    return gn(e).isListItemTextNode(t);
  },
  createDefaultTextNode(e, t) {
    return gn(e).createDefaultTextNode(t);
  },
  createListNode(e, t, n) {
    return gn(e).createListNode(t, n);
  },
  createListItemNode(e, t) {
    return gn(e).createListItemNode(t);
  },
  createListItemTextNode(e, t) {
    return gn(e).createListItemTextNode(t);
  },
  // Checks & Getters
  isDeleteBackwardAllowed(e, t) {
    return BM(e, gn(e), t);
  },
  isAtStartOfListItem(e, t) {
    return MM(e, gn(e), t);
  },
  isAtEmptyListItem(e, t) {
    return qM(e, gn(e), t);
  },
  isAtList(e, t) {
    return y3e(e, gn(e), t);
  },
  isListItemContainingText(e, t) {
    return _M(e, gn(e), t);
  },
  getLists(e, t) {
    return IM(e, gn(e), t);
  },
  getListItems(e, t) {
    return Cs(e, gn(e), t);
  },
  getListType(e, t) {
    return mf(gn(e), t);
  },
  getNestedList(e, t) {
    return PM(e, gn(e), t);
  },
  getParentList(e, t) {
    return b8(e, gn(e), t);
  },
  getParentListItem(e, t) {
    return T2(e, gn(e), t);
  },
  // Transformations
  increaseDepth(e, t) {
    return GM(e, gn(e), t);
  },
  increaseListItemDepth(e, t) {
    return C8(e, gn(e), t);
  },
  decreaseDepth(e, t) {
    return Gf(e, gn(e), t);
  },
  decreaseListItemDepth(e, t) {
    return WM(e, gn(e), t);
  },
  mergeListWithPreviousSiblingList(e, t) {
    return J5(e, gn(e), t);
  },
  moveListItemsToAnotherList(e, t) {
    return KM(e, gn(e), t);
  },
  moveListToListItem(e, t) {
    return XM(e, gn(e), t);
  },
  setListType(e, t, n) {
    return b3e(e, gn(e), t, n);
  },
  splitListItem(e, t) {
    return QM(e, gn(e), t);
  },
  unwrapList(e, t) {
    return w3e(e, gn(e), t);
  },
  wrapInList(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : sa.UNORDERED, n = arguments.length > 2 ? arguments[2] : void 0;
    return ZM(e, gn(e), t, n);
  }
};
function k3e(e, t, n) {
  let [r, i] = n;
  if (!t.isListNode(r))
    return !1;
  const o = Array.from(Te.children(e, i));
  for (const [a, s] of o) {
    if (xt.isText(a))
      return a.text.trim() === "" ? (o.length > 1 ? ge.removeNodes(e, {
        at: s
      }) : ge.removeNodes(e, {
        at: i
      }), !0) : (ge.wrapNodes(e, t.createListItemNode({
        children: [t.createListItemTextNode({
          children: [a]
        })]
      }), {
        at: s
      }), !0);
    if (t.isListItemTextNode(a))
      return ge.wrapNodes(e, t.createListItemNode(), {
        at: s
      }), !0;
    if (t.isListNode(a))
      return ge.wrapNodes(e, t.createListItemNode(), {
        at: s
      }), !0;
    if (!t.isListItemNode(a))
      return ge.setNodes(e, t.createListItemTextNode(), {
        at: s
      }), ge.wrapNodes(e, t.createListItemNode(), {
        at: s
      }), !0;
  }
  return !1;
}
function E3e(e, t, n) {
  let [r, i] = n;
  if (!t.isListItemNode(r))
    return !1;
  const o = Array.from(Te.children(e, i));
  for (const [a, [s, l]] of o.entries()) {
    if (xt.isText(s) || e.isInline(s)) {
      const u = t.createListItemTextNode({
        children: [s]
      });
      if (ge.wrapNodes(e, u, {
        at: l
      }), a > 0) {
        const [d] = o[a - 1];
        t.isListItemTextNode(d) && ge.mergeNodes(e, {
          at: l
        });
      }
      return !0;
    }
    if (t.isListItemNode(s))
      return ge.liftNodes(e, {
        at: l
      }), !0;
    if (t.isListItemTextNode(s) && a !== 0)
      return ge.wrapNodes(e, t.createListItemNode(), {
        at: l
      }), !0;
    if (!t.isListItemTextNode(s) && !t.isListNode(s))
      return ge.setNodes(e, t.createListItemTextNode(), {
        at: l
      }), !0;
  }
  return !1;
}
function S3e(e, t, n) {
  let [r, i] = n;
  if (!t.isListItemTextNode(r))
    return !1;
  for (const [o, a] of Te.children(e, i))
    if (Je.isElement(o) && !q.isInline(e, o))
      return ge.unwrapNodes(e, {
        at: a
      }), !0;
  return !1;
}
function D3e(e, t, n) {
  let [r, i] = n;
  if (HM(r) && !t.isListNode(r)) {
    for (const [o, a] of r.children.entries())
      if (Je.isElement(a) && t.isListItemNode(a))
        return $M(a) ? ge.setNodes(e, t.createDefaultTextNode(), {
          at: [...i, o]
        }) : ge.unwrapNodes(e, {
          at: [...i, o],
          mode: "highest"
        }), !0;
  }
  return !1;
}
function A3e(e, t, n) {
  let [r, i] = n;
  if (HM(r) && !t.isListItemNode(r)) {
    for (const [o, a] of r.children.entries())
      if (Je.isElement(a) && t.isListItemTextNode(a))
        return $M(a) ? ge.setNodes(e, t.createDefaultTextNode(), {
          at: [...i, o]
        }) : ge.unwrapNodes(e, {
          at: [...i, o],
          mode: "highest"
        }), !0;
  }
  return !1;
}
function T3e(e, t, n) {
  let [r, i] = n;
  if (!t.isListItemNode(r))
    return !1;
  const o = Array.from(Te.children(e, i));
  if (o.length !== 1)
    return !1;
  const [a] = o, [s, l] = a;
  if (!t.isListNode(s))
    return !1;
  const u = Zf(e, i);
  if (u) {
    const [, d] = u, p = PM(e, t, d);
    p ? KM(e, t, {
      at: a,
      to: p
    }) : XM(e, t, {
      at: a,
      to: u
    }), ge.removeNodes(e, {
      at: i
    });
  } else
    ge.unwrapNodes(e, {
      at: l
    }), ge.unwrapNodes(e, {
      at: i
    });
  return !0;
}
function j3e(e, t, n) {
  if (J5(e, t, n))
    return !0;
  const [, r] = n, i = v3e(e, r);
  return i ? J5(e, t, i) : !1;
}
function ns(e, t) {
  const n = Li.getListsSchema(e);
  return n ? ns.normalizeListChildren(e, n, t) || ns.normalizeListItemChildren(e, n, t) || ns.normalizeListItemTextChildren(e, n, t) || ns.normalizeOrphanListItem(e, n, t) || ns.normalizeOrphanListItemText(e, n, t) || ns.normalizeOrphanNestedList(e, n, t) || ns.normalizeSiblingLists(e, n, t) : !1;
}
(function(e) {
  e.normalizeListChildren = k3e, e.normalizeListItemChildren = E3e, e.normalizeListItemTextChildren = S3e, e.normalizeOrphanListItem = D3e, e.normalizeOrphanListItemText = A3e, e.normalizeOrphanNestedList = T3e, e.normalizeSiblingLists = j3e;
})(ns || (ns = {}));
function N3e(e, t) {
  const n = Li.getListsSchema(e);
  return n && uu("backspace", t.nativeEvent) && !BM(e, n) ? (t.preventDefault(), Gf(e, n)) : !1;
}
function O3e(e, t) {
  const n = Li.getListsSchema(e);
  return n && uu("enter", t.nativeEvent) && qM(e, n) ? (t.preventDefault(), Gf(e, n)) : !1;
}
function z3e(e, t) {
  const n = Li.getListsSchema(e);
  return n && uu("enter", t.nativeEvent) && Cs(e, n, e.selection).length > 0 ? (t.preventDefault(), QM(e, n)) : !1;
}
function F3e(e, t) {
  const n = Li.getListsSchema(e);
  return n && uu("shift+tab", t.nativeEvent) ? (t.preventDefault(), Gf(e, n)) : !1;
}
function L3e(e, t) {
  const n = Li.getListsSchema(e);
  return n && uu("tab", t.nativeEvent) ? (t.preventDefault(), GM(e, n)) : !1;
}
function Hl(e, t) {
  if (Li.isListsEnabled(e))
    try {
      return Hl.onTabIncreaseListDepth(e, t) || Hl.onShiftTabDecreaseListDepth(e, t) || Hl.onBackspaceDecreaseListDepth(e, t) || Hl.onEnterEscapeFromEmptyList(e, t) || Hl.onEnterSplitNonEmptyList(e, t);
    } finally {
      q.normalize(e, {
        force: !0
      });
    }
}
(function(e) {
  e.onTabIncreaseListDepth = L3e, e.onShiftTabDecreaseListDepth = F3e, e.onBackspaceDecreaseListDepth = N3e, e.onEnterEscapeFromEmptyList = O3e, e.onEnterSplitNonEmptyList = z3e;
})(Hl || (Hl = {}));
function M3e(e) {
  const t = {
    normalizeNode: e.normalizeNode
  };
  return e.normalizeNode = (n, r) => ns(e, n) || t.normalizeNode(n, r), e;
}
function qk(e) {
  const t = document.createDocumentFragment();
  return t.append(...e), t;
}
function $k(e, t) {
  const n = document.createElement(t);
  return n.append(...e), n;
}
function B3e(e) {
  const t = document.createElement("li");
  return t.append(...e), t;
}
function I3e() {
  const e = Range.prototype.cloneContents;
  return Range.prototype.cloneContents = function() {
    const t = e.apply(this);
    return this.commonAncestorContainer.nodeName === "OL" || this.commonAncestorContainer.nodeName === "UL" ? qk([$k([...t.childNodes], this.commonAncestorContainer.nodeName)]) : this.commonAncestorContainer.nodeName === "LI" && this.commonAncestorContainer.parentElement && (this.commonAncestorContainer.parentElement.nodeName === "OL" || this.commonAncestorContainer.parentElement.nodeName === "UL") ? qk([$k([B3e([...t.childNodes])], this.commonAncestorContainer.parentElement.nodeName)]) : t;
  }, function() {
    Range.prototype.cloneContents = e;
  };
}
function R3e(e) {
  const t = I3e();
  try {
    e();
  } finally {
    t();
  }
}
function YM(e) {
  const {
    setFragmentData: t
  } = e;
  return e.setFragmentData = (n) => {
    R3e(function() {
      t(n);
    });
  }, e;
}
function P3e(e) {
  return function(t) {
    return x3e(t, e), t;
  };
}
function _3e(e) {
  return (t) => YM(M3e(P3e(e)(t)));
}
const JM = (e = {}) => ({
  children: [{ text: "" }],
  ...e,
  type: ur.LIST_ITEM_TEXT
}), Hk = (e = {}) => ({
  children: [JM()],
  ...e,
  type: ur.LIST_ITEM
}), q3e = (e) => {
  const t = _3e({
    isConvertibleToListTextNode(n) {
      return Je.isElementType(n, "p");
    },
    isDefaultTextNode(n) {
      return Je.isElementType(n, "p");
    },
    isListNode(n, r) {
      return r ? Je.isElementType(n, r) : Je.isElementType(n, ur.ORDERED_LIST) || Je.isElementType(n, ur.UNORDERED_LIST);
    },
    isListItemNode(n) {
      return Je.isElementType(n, ur.LIST_ITEM);
    },
    isListItemTextNode(n) {
      return Je.isElementType(n, ur.LIST_ITEM_TEXT);
    },
    createDefaultTextNode(n = {}) {
      return { children: [{ text: "" }], ...n, type: "p" };
    },
    createListNode(n = sa.UNORDERED, r = {}) {
      const i = n === sa.ORDERED ? ur.ORDERED_LIST : ur.UNORDERED_LIST;
      return {
        children: [Hk()],
        ...r,
        type: i
      };
    },
    createListItemNode: Hk,
    createListItemTextNode: JM
  });
  return YM(t(e));
}, $3e = (e) => {
  const { isInline: t, isVoid: n } = e;
  return e.isInline = (r) => r.type === "math" ? r.inline : t(r), e.isVoid = (r) => r.type === "math" ? !0 : n(r), e;
}, H3e = (e) => {
  const { isInline: t, isVoid: n, normalizeNode: r } = e;
  return e.isInline = (i) => i.type === "textBlank" ? !0 : t(i), e.isVoid = (i) => i.type === "textBlank" ? !0 : n(i), e.normalizeNode = (i) => {
    const [o, a] = i;
    Je.isElement(o) && o.type === "textBlank" && [...Te.elements(e)].some(
      ([s, l]) => s.type === "textBlank" && !ee.equals(l, a) && s.blankId === o.blankId
    ) && ge.setNodes(e, { blankId: fa() }, { at: a }), r(i);
  }, e;
}, V3e = ({ color: e }) => /* @__PURE__ */ c.jsx("span", { className: "relative inline-block align-middle", children: /* @__PURE__ */ c.jsxs("span", { className: "flex flex-col items-center", children: [
  /* @__PURE__ */ c.jsx(ip, { pathData: oue }),
  /* @__PURE__ */ c.jsx(
    "span",
    {
      className: "absolute bottom-[1.5px] w-[70%] rounded-[3px] border-2",
      style: { borderColor: e }
    }
  )
] }) });
function Vk(e, t) {
  const n = q.start(e, [0]);
  return Ut.compare(n, t.focus) > -1;
}
function eg(e, t) {
  const n = e.children.length, r = q.end(e, [n - 1]);
  return Ut.compare(r, t.focus) < 1;
}
function k8(e, { location: t }, n) {
  return Array.from(
    q.nodes(n, {
      at: t,
      match: (r) => !q.isEditor(r) && Je.isElement(r) && e(r)
    })
  ).length !== 0;
}
function Kf(e, t) {
  return t.selection ? k8(
    e,
    { location: q.unhangRange(t, t.selection) },
    t
  ) : !1;
}
function $c(e) {
  const t = e.selection;
  if (!t) return null;
  let n = q.string(e, t);
  const r = ke.isBackward(t);
  let i = t.anchor.offset, o = t.focus.offset;
  for (; n.startsWith(" "); )
    r ? o++ : i++, n = n.substring(1);
  for (; n.endsWith(" "); )
    r ? i-- : o--, n = n.substring(0, n.length - 1);
  const a = {
    anchor: { ...t.anchor, offset: i },
    focus: { ...t.focus, offset: o }
  };
  return ge.setSelection(e, a), a;
}
function U3e(e) {
  return Je.isElement(e) && e.type === "textBlank";
}
function E8(e) {
  return Kf((t) => t.type === "textBlank", e);
}
function W3e(e) {
  const [t] = Array.from(q.nodes(e, { match: U3e }));
  return t && t[0];
}
function Z3e(e) {
  E8(e) ? eB(e) : G3e(e);
}
function eB(e) {
  q.withoutNormalizing(e, () => {
    if (!e.selection) return;
    const t = e.selection.anchor.path, n = e.selection.focus.path, r = ee.compare(t, n) > -1;
    [...Te.elements(e, { from: t, to: n, reverse: r })].forEach((i) => {
      var o;
      if (i[0].type !== "textBlank") return;
      const a = i[1], s = ((o = i[0].correctAnswers.at(0)) == null ? void 0 : o.answer) ?? "";
      ge.insertText(e, s, { at: a, voids: !0 });
    }), ge.unwrapNodes(e, {
      voids: !0,
      match: (i) => Je.isElement(i) && i.type === "textBlank"
    });
  }), setTimeout(() => Ue.focus(e));
}
function G3e(e) {
  const t = $c(e);
  if (t === null) return;
  const n = {
    type: "textBlank",
    blankId: fa(),
    correctAnswers: [{ answer: q.string(e, t).trim() }],
    acceptMathEquivalents: !0,
    children: [{ text: "" }]
  };
  if (eg(e, t)) {
    ge.insertNodes(e, [n, { text: " " }]);
    return;
  } else
    ge.insertNodes(e, n);
}
const K3e = (e) => {
  var t;
  return typeof ((t = q.marks(e)) == null ? void 0 : t.color) == "number";
}, tB = (e) => (t) => {
  var n;
  return ((n = q.marks(t)) == null ? void 0 : n.color) === e;
}, X3e = (e) => {
  q.removeMark(e, "color");
}, Q3e = (e) => (t) => {
  $c(t), tB(e)(t) ? q.removeMark(t, "color") : q.addMark(t, "color", e), ge.collapse(t, { edge: "end" });
}, Y3e = (e) => {
  var t;
  return (t = q.marks(e)) == null ? void 0 : t.color;
};
function nB(e) {
  return Je.isElement(e) && e.type === "a";
}
function S8(e) {
  return Kf((t) => t.type === "a", e);
}
function J3e(e) {
  const [t] = Array.from(q.nodes(e, { match: nB }));
  return t && t[0];
}
function rB(e) {
  if (S8(e)) {
    ge.unwrapNodes(e, { match: nB });
    return;
  }
  const { selection: t } = e;
  if (t && ke.isCollapsed(t)) {
    ge.insertNodes(e, {
      type: "a",
      href: "",
      children: [{ text: " " }]
    });
    return;
  }
  $c(e), ge.wrapNodes(
    e,
    {
      type: "a",
      href: "",
      children: []
    },
    { split: !0 }
  ), ge.collapse(e, { edge: "end" });
}
function eve(e, t) {
  return k8(
    (n) => n.type === ur.ORDERED_LIST || n.type === ur.UNORDERED_LIST,
    { location: Ue.findPath(t, e) },
    t
  );
}
function Xf(e, t) {
  return e.selection ? k8(
    (n) => t ? n.type === t : n.type === ur.ORDERED_LIST || n.type === ur.UNORDERED_LIST,
    { location: q.unhangRange(e, e.selection) },
    e
  ) : !1;
}
function D8(e) {
  return Xf(e, ur.UNORDERED_LIST);
}
function A8(e) {
  return Xf(e, ur.ORDERED_LIST);
}
function tve(e) {
  D8(e) ? (Li.unwrapList(e), Li.wrapInList(e, sa.ORDERED)) : A8(e) ? Li.unwrapList(e) : Li.wrapInList(e, sa.ORDERED);
}
function iB(e) {
  A8(e) ? (Li.unwrapList(e), Li.wrapInList(e, sa.UNORDERED)) : D8(e) ? Li.unwrapList(e) : Li.wrapInList(e, sa.UNORDERED);
}
function oB(e) {
  return Kf((t) => t.type === "math", e);
}
function aB(e) {
  if (oB(e)) {
    ge.removeNodes(e, {
      match: (r) => Je.isElement(r) && r.type === "math"
    });
    return;
  }
  const { selection: t } = e;
  if (!t) return;
  if (ke.isCollapsed(t)) {
    ge.insertNodes(e, {
      type: "math",
      src: "",
      inline: !0,
      children: [{ text: "" }]
    });
    return;
  }
  const n = $c(e);
  n && (ge.insertNodes(
    e,
    [
      {
        type: "math",
        src: q.string(e, n) || "",
        inline: !0,
        children: [{ text: "" }]
      }
    ],
    { at: n }
  ), ge.setSelection(e, {
    anchor: t.anchor,
    focus: t.anchor
  }), ge.move(e, { distance: 1 }));
}
function sB(e) {
  var t;
  return ((t = q.marks(e)) == null ? void 0 : t.strong) === !0;
}
function lB(e) {
  $c(e), sB(e) ? q.removeMark(e, "strong") : q.addMark(e, "strong", !0);
}
function uB(e) {
  var t;
  return ((t = q.marks(e)) == null ? void 0 : t.em) === !0;
}
function cB(e) {
  $c(e), uB(e) ? q.removeMark(e, "em") : q.addMark(e, "em", !0);
}
function dB(e) {
  var t;
  return ((t = q.marks(e)) == null ? void 0 : t.code) === !0;
}
function e6(e) {
  $c(e), dB(e) ? q.removeMark(e, "code") : q.addMark(e, "code", !0);
}
function nve(e) {
  return Kf((t) => t.type === "h", e);
}
const pB = (e) => (t) => Kf(
  (n) => n.type === "h" && n.level === e,
  t
), Z1 = (e) => (t) => {
  pB(e)(t) ? (ge.setNodes(t, {
    type: "p"
  }), ge.unsetNodes(t, "level")) : ge.setNodes(t, {
    type: "h",
    level: e
  });
}, fB = {
  [tt.math]: $3e,
  [tt.links]: m3e,
  [tt.lists]: q3e,
  [tt.textBlank]: H3e
}, rve = (e) => e in fB, ive = [
  {
    hotkey: "mod+b",
    option: tt.richTextBold,
    handler: lB
  },
  {
    hotkey: "mod+i",
    option: tt.richTextItalic,
    handler: cB
  },
  {
    hotkey: "mod+k",
    option: tt.links,
    handler: rB
  },
  {
    hotkey: "mod+m",
    option: tt.math,
    handler: aB
  },
  {
    hotkey: "mod+shift+c",
    option: tt.code,
    handler: e6
  },
  {
    hotkey: "mod+shift+`",
    option: tt.code,
    handler: e6
  }
], ove = [
  {
    keys: ["*", "-", "+"],
    option: tt.lists,
    handler: iB
  },
  {
    keys: ["#"],
    option: tt.headings,
    handler: Z1(1)
  },
  {
    keys: ["##"],
    option: tt.headings,
    handler: Z1(2)
  },
  {
    keys: ["###"],
    option: tt.headings,
    handler: Z1(3)
  }
], hB = (e) => {
  const t = Un().misc.ctrl, n = nt().plugins.text, r = v.useCallback(
    (l) => e.reduce((u, d) => rve(d) ? fB[d](u) : u, l),
    [e]
  ), i = v.useMemo(
    () => ave(e, n, t),
    [e, t, n]
  ), o = v.useCallback(
    (l, u) => {
      for (const { hotkey: d, option: p, handler: f } of ive)
        if (e.includes(p) && _s(d, l)) {
          l.preventDefault(), f(u);
          break;
        }
    },
    [e]
  ), a = v.useCallback(
    (l, u) => {
      const { selection: d } = u;
      if (!d || l.key !== " ") return;
      const p = q.first(u, d), f = Te.string(p[0]).slice(0, d.focus.offset).replace(/\s*/g, "");
      for (const { keys: m, option: y, handler: g } of ove)
        if (e.includes(y) && m.includes(f)) {
          l.preventDefault(), g(u), u.deleteBackward("word");
          break;
        }
    },
    [e]
  ), s = v.useCallback(
    (l, u) => {
      if (!e.includes(
        tt.lists
      )) return;
      const d = Xf(u), p = _s("tab", l) || _s("shift+tab", l);
      if (!(!d && p))
        return Hl(u, l);
    },
    [e]
  );
  return {
    createTextEditor: r,
    toolbarControls: i,
    textColors: Im,
    handleHotkeys: o,
    handleMarkdownShortcuts: a,
    handleListsShortcuts: s
  };
};
function ave(e, t, n) {
  return [
    // Blank (For Fill in the Blank Exercises)
    {
      name: tt.textBlank,
      title: t.createBlank,
      activeTitle: t.removeBlank,
      isActive: E8,
      onClick: Z3e,
      group: "blank",
      renderIcon: () => /* @__PURE__ */ c.jsx("span", { className: "relative -top-0.25 mx-1 rounded-lg border-2 border-current px-1.5 text-[13px] font-bold", children: t.blank })
    },
    // Bold
    {
      name: tt.richTextBold,
      title: t.bold,
      isActive: sB,
      onClick: lB,
      group: "default",
      renderIcon: () => /* @__PURE__ */ c.jsx(ip, { pathData: aue })
    },
    // Italic
    {
      name: tt.richTextItalic,
      title: t.italic,
      isActive: uB,
      onClick: cB,
      group: "default",
      renderIcon: () => /* @__PURE__ */ c.jsx(ip, { pathData: iue })
    },
    // Link
    {
      name: tt.links,
      title: t.link,
      isActive: S8,
      onClick: rB,
      group: "default",
      renderIcon: () => /* @__PURE__ */ c.jsx(ip, { pathData: rue })
    },
    // Headings
    {
      name: tt.headings,
      title: t.headings,
      closeMenuTitle: t.closeSubMenu,
      isActive: nve,
      group: "default",
      renderIcon: () => /* @__PURE__ */ c.jsx(ip, { pathData: nue }),
      subMenuButtons: [1, 2, 3].map((r) => ({
        name: tt.headings,
        title: `${t.heading} ${r}`,
        isActive: pB(r),
        onClick: Z1(r),
        renderIcon: () => /* @__PURE__ */ c.jsxs("span", { "data-qa": `plugin-toolbar-heading-${r}`, children: [
          "H",
          r
        ] })
      }))
    },
    // Colors
    {
      name: tt.colors,
      title: t.colors,
      closeMenuTitle: t.closeSubMenu,
      isActive: () => !1,
      group: "default",
      renderIcon: (r) => {
        const i = Y3e(r), o = i ? Im[i].value : "black";
        return /* @__PURE__ */ c.jsx(V3e, { color: o });
      },
      subMenuButtons: [
        {
          name: tt.colors,
          title: t.resetColor,
          isActive: (r) => !K3e(r),
          onClick: X3e,
          renderIcon: () => /* @__PURE__ */ c.jsx("div", { className: "m-[3px] inline-block h-[19px] w-[19px] rounded-full bg-black align-middle" })
        },
        ...Im.map((r, i) => ({
          name: tt.colors,
          title: Object.hasOwn(t.colorNames, r.name) ? t.colorNames[r.name] : r.name,
          isActive: tB(i),
          onClick: Q3e(i),
          renderIcon: () => /* @__PURE__ */ c.jsx(
            "div",
            {
              className: "m-[3px] inline-block h-[19px] w-[19px] rounded-full align-middle",
              style: { backgroundColor: r.value }
            }
          )
        }))
      ]
    },
    // Ordered list
    {
      name: tt.lists,
      title: t.orderedList,
      isActive: A8,
      onClick: tve,
      group: "lists",
      renderIcon: () => /* @__PURE__ */ c.jsx(ot, { className: "h-[15px]", icon: vV })
    },
    // Unordered list
    {
      name: tt.lists,
      title: t.unorderedList,
      isActive: D8,
      onClick: iB,
      group: "lists",
      renderIcon: () => /* @__PURE__ */ c.jsx(ot, { className: "h-[15px]", icon: RV })
    },
    // Math
    {
      name: tt.math,
      title: t.mathFormula,
      isActive: oB,
      onClick: aB,
      group: "default",
      renderIcon: () => /* @__PURE__ */ c.jsx(ot, { className: "h-[15px]", icon: jV })
    },
    // Code
    {
      name: tt.code,
      title: t.code,
      isActive: dB,
      onClick: e6,
      group: "default",
      renderIcon: () => /* @__PURE__ */ c.jsx(ot, { className: "h-[15px]", icon: yV })
    }
  ].map((r) => ({
    ...r,
    title: r.title.replace("%ctrlOrCmd%", DT ? "⌘" : n)
  })).filter(
    ({ name: r }) => e.includes(tt[r])
  );
}
function mB(e) {
  const { width: t, anchor: n, children: r } = e, i = qc(), o = v.useRef(null);
  return v.useEffect(() => {
    const a = setTimeout(() => {
      var s, l;
      if (!o.current) return;
      const u = sve(i, n), d = (s = o.current.closest(".rows-editor-renderer-container")) == null ? void 0 : s.getBoundingClientRect(), p = (l = o.current.offsetParent) == null ? void 0 : l.getBoundingClientRect();
      if (!u || !d || !p) return;
      const f = u.left - 2, m = f + t - d.right, y = f - m, g = (m > 0 ? y : f) - p.left - 5;
      o.current.style.left = `${g}px`, o.current.style.top = `${u.bottom + 20 - p.top}px`;
    }, 1);
    return () => clearTimeout(a);
  }, [i, n, t]), /* @__PURE__ */ c.jsx("div", { ref: o, className: "absolute z-[95]", children: /* @__PURE__ */ c.jsx(
    "div",
    {
      className: "rounded bg-white text-start not-italic shadow-menu",
      style: { width: `${t}px` },
      children: r
    }
  ) });
}
function sve(e, t) {
  var n;
  if (t)
    return ((n = Ue.toDOMNode(e, t)) == null ? void 0 : n.getBoundingClientRect()) ?? null;
  const r = window.getSelection();
  return r && r.rangeCount > 0 ? r.getRangeAt(0).getBoundingClientRect() : null;
}
const lve = 460;
function uve() {
  const [e, t] = v.useState(null), [n, r] = v.useState(""), [i, o] = v.useState(n.length === 0), { lang: a } = nt(), s = qc(), { selection: l } = s, u = gl() && a === "de";
  v.useEffect(() => {
    if (l)
      if (l && ke.isCollapsed(l) && S8(s)) {
        const m = J3e(s) || null;
        t(m), r(m ? m.href : "");
      } else
        t(null);
  }, [l, s]), v.useEffect(() => {
    o(n.length === 0);
  }, [e]);
  function d() {
    t(null);
    const m = Ue.findPath(s, e);
    ge.unwrapNodes(s, { at: m }), Ue.focus(s);
  }
  function p(m) {
    r(m);
    const y = Ue.findPath(s, e);
    ge.setNodes(s, { href: m }, { at: y }), ge.move(s, { unit: "offset" }), Ue.focus(s);
  }
  if (!e) return null;
  const f = i && e.children[0].text.trim() !== "";
  return /* @__PURE__ */ c.jsx(mB, { width: lve, anchor: e, children: i ? /* @__PURE__ */ c.jsx(
    _L,
    {
      isSerloLinkSearchActive: u,
      setHref: p,
      removeLink: d,
      value: n,
      shouldFocus: f
    }
  ) : /* @__PURE__ */ c.jsx(
    qL,
    {
      value: n,
      removeLink: d,
      setIsEditMode: o
    }
  ) });
}
function Uk({
  active: e,
  children: t,
  tooltipText: n,
  onMouseDown: r
}) {
  const [i, o] = (n == null ? void 0 : n.split("(")) || [
    void 0,
    void 0
  ];
  return /* @__PURE__ */ c.jsxs(
    "button",
    {
      className: Le(
        e ? "bg-editor-primary-200 text-almost-black shadow-menu hover:text-black" : "#b6b6b6 hover:text-editor-primary",
        "b-0 m-1 h-6 w-auto min-w-[1.5rem] cursor-pointer rounded p-0 outline-none",
        "serlo-tooltip-trigger"
      ),
      "data-qa": `plugin-toolbar-button-${i ? i.toLowerCase().trim().replace(/ /g, "-") : ""}`,
      onMouseDown: r,
      children: [
        /* @__PURE__ */ c.jsx(
          vn,
          {
            text: i,
            hotkeys: o == null ? void 0 : o.slice(0, -1),
            className: "top-8"
          }
        ),
        t
      ]
    }
  );
}
function Wk(e) {
  return Object.hasOwn(e, "subMenuButtons");
}
function Zk({
  controls: e,
  editor: t
}) {
  var n;
  const [r, i] = v.useState(), o = (y) => Object.hasOwn(y, "name") && y.name === tt.math, a = (y) => Object.hasOwn(y, "name") && y.name === tt.textBlank, s = (n = e.find(o)) == null ? void 0 : n.isActive(t), l = e.find(a), u = l == null ? void 0 : l.isActive(t), d = s || u;
  if (typeof r != "number")
    return /* @__PURE__ */ c.jsx(c.Fragment, { children: e.map((y, g) => {
      if (s && !o(y) || u && !a(y)) return null;
      const x = e.at(g + 1), E = !d && !!x && x.group !== y.group;
      return /* @__PURE__ */ c.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ c.jsx(
          Uk,
          {
            active: y.isActive(t),
            tooltipText: y.isActive(t) && Object.hasOwn(y, "activeTitle") ? y.activeTitle : y.title,
            onMouseDown: (b) => {
              b.preventDefault(), b.stopPropagation(), Wk(y) ? i(g) : y.onClick(t);
            },
            children: y.renderIcon(t)
          }
        ),
        E ? /* @__PURE__ */ c.jsx("span", { className: "opacity-30", children: " | " }) : null
      ] }, y.title);
    }) });
  const p = e[r];
  if (!Wk(p)) return null;
  const f = {
    isActive() {
      return !1;
    },
    renderIcon() {
      return /* @__PURE__ */ c.jsx(ot, { icon: Fg });
    },
    onClick() {
      i(void 0);
    },
    title: p.closeMenuTitle
  }, m = [...p.subMenuButtons, f];
  return /* @__PURE__ */ c.jsx(c.Fragment, { children: m.map((y, g) => /* @__PURE__ */ c.jsx(
    Uk,
    {
      active: y.isActive(t),
      tooltipText: y.title,
      onMouseDown: (x) => {
        x.preventDefault(), y.onClick(t), i(void 0);
      },
      children: y.renderIcon(t)
    },
    g
  )) });
}
function cve({
  id: e,
  toolbarControls: t,
  config: n,
  containerRef: r
}) {
  var i;
  const o = qc();
  if (n.isInlineChildEditor) {
    if (!r || !r.current) return null;
    const a = (i = r.current.closest(".plugin-wrapper-container")) == null ? void 0 : i.querySelector(".toolbar-controls-target");
    return a ? ms.createPortal(
      /* @__PURE__ */ c.jsx(Zk, { controls: t, editor: o }),
      a
    ) : null;
  }
  return /* @__PURE__ */ c.jsx(
    Ci,
    {
      pluginType: Y.Text,
      contentControls: /* @__PURE__ */ c.jsx(Zk, { controls: t, editor: o }),
      pluginControls: n.isInlineChildEditor ? void 0 : /* @__PURE__ */ c.jsx(Pi, { pluginId: e })
    }
  );
}
const G1 = () => ({
  value: [{ type: "p", children: [{ text: "" }] }],
  selection: null
});
function dve(e) {
  if (!e.selection) return;
  let t = null;
  q.insertBreak(e);
  const n = e.selection.anchor.path[0], r = e.children.length;
  return eg(e, e.selection) || (t = e.children.slice(n, r)), ge.removeNodes(e, {
    at: {
      anchor: { offset: 0, path: [n] },
      focus: { offset: 0, path: [r] }
    }
  }), t;
}
function pve(e, t, n, r, i) {
  const o = Sg(r(), n), a = il(r(), n);
  if (!o || !a) return;
  const s = fve(
    n,
    e,
    r
  ), l = bi(r(), s == null ? void 0 : s.id);
  if (!s || !l) return;
  if (Te.string(t) === "" && t.children.length <= 1) {
    const f = rl(r());
    i((e === "previous" ? Ag : Dg)(f)), i(j0({ parent: a.id, child: n }));
    return;
  }
  const u = bi(r(), n);
  if (!u) return;
  const d = a.children || [], p = d.findIndex(
    (f) => f.id === n
  );
  if (e === "previous") {
    if (p < 1) return;
    if (l.plugin === u.plugin) {
      const f = l.state.value, m = f.length, y = [...f, ...t.children];
      return t.children = y, i(
        j0({
          parent: a.id,
          child: s.id
        })
      ), {
        value: y,
        selection: {
          anchor: {
            offset: 0,
            path: [m, 0]
          },
          focus: {
            offset: 0,
            path: [m, 0]
          }
        }
      };
    }
  } else {
    if (p + 1 >= d.length) return;
    if (l.plugin === u.plugin) {
      const f = l.state.value, m = [...t.children, ...f];
      return t.children = m, i(
        j0({ parent: a.id, child: s.id })
      ), {
        value: m,
        selection: t.selection
      };
    }
  }
}
function fve(e, t, n) {
  const r = il(n(), e), i = (r == null ? void 0 : r.children) || [], o = i.findIndex(
    (s) => s.id === e
  ), a = t === "previous" ? o - 1 : o + 1;
  return i[a];
}
function gB({
  plugins: e,
  editor: t,
  id: n,
  getStoreState: r,
  dispatch: i
}) {
  if (!e.length) return;
  const o = r(), a = bi(o, n), s = Sg(o, n), l = il(o, n);
  if (!a || !s || !l) return;
  const u = a.plugin, d = ED(e);
  Te.string(t) === "" || Te.string(t) === "/" ? p() : f(l.id);
  for (const { pluginType: m, state: y } of d)
    i(
      Qp({
        parent: l.id,
        sibling: n,
        document: { plugin: m, state: y }
      })
    );
  function p() {
    const m = d.pop(), { pluginType: y, state: g } = m;
    i(YD({ id: n, pluginType: y, state: g }));
  }
  function f(m) {
    const y = dve(t);
    if (y) {
      const g = Te.string(y[0]).length ? y : y.slice(1);
      if (!g.length) return;
      i(
        Qp({
          parent: m,
          sibling: n,
          document: {
            plugin: u,
            state: g
          }
        })
      );
    }
  }
}
const hve = (e) => {
  const { config: t, editor: n, id: r, state: i } = e, o = zn(), a = Ur(), s = hB(t.formattingOptions), { pluginMenuDispatch: l } = v.useContext(r2);
  return v.useCallback(
    (u) => {
      var d;
      t.noLinebreaks && u.key === "Enter" && u.preventDefault();
      const { selection: p } = n;
      if (p && ke.isCollapsed(p)) {
        const f = Xf(n);
        if (u.key === "/" && !f) {
          const { path: g } = p.focus, x = Te.get(n, g), E = il(o.getState(), r);
          if (Object.hasOwn(x, "text") && x.text.length === 0 && E) {
            const b = (d = E.children) == null ? void 0 : d.findIndex(
              (T) => T.id === r
            ), C = b !== void 0 ? b + 1 : void 0;
            l({
              type: su.OPEN_WITH_SLASH_KEY,
              payload: {
                insertIndex: C,
                insertCallback: (T) => {
                  gB({
                    plugins: [
                      { pluginType: T.plugin, state: T.state }
                    ],
                    editor: n,
                    id: r,
                    getStoreState: () => o.getState(),
                    dispatch: a
                  });
                }
              }
            }), u.preventDefault();
          }
        }
        if (_s("right", u)) {
          const { path: g, offset: x } = p.focus, E = Te.get(n, g), b = Te.parent(n, g);
          E && b && Object.hasOwn(b, "type") && b.type === "a" && Object.hasOwn(E, "text") && E.text.length - 1 <= x && (ge.move(n), ge.move(n, { unit: "offset" }), u.preventDefault());
        }
        if (u.key === "Enter") {
          const { path: g, offset: x } = p.focus, E = Te.get(n, g), b = Te.parent(n, g);
          if (E && b && Object.hasOwn(b, "type") && b.type === "a" && Object.hasOwn(E, "text")) {
            if (x === 0) return;
            if (u.preventDefault(), E.text.length === x) ge.move(n);
            else return !1;
          }
        }
        if (_s(["enter", "shift+enter"], u) && !f) {
          const g = n.getFragment()[0];
          Object.hasOwn(g, "type") && g.type === "h" && (u.preventDefault(), ge.insertNodes(n, G1().value));
        }
        const m = _s("backspace", u) && Vk(n, p), y = _s("delete", u) && eg(n, p);
        if ((m || y) && !f) {
          u.preventDefault();
          const g = pve(
            m ? "previous" : "next",
            n,
            r,
            () => o.getState(),
            a
          );
          g && i.set(
            {
              value: g.value,
              selection: g.selection
            },
            ({ value: x }) => ({
              value: x,
              selection: wo[r].selection
            })
          );
        }
        if (_s("up", u) && Vk(n, p)) {
          u.preventDefault();
          const g = rl(o.getState());
          a(Ag(g));
        }
        if (_s("down", u) && eg(n, p)) {
          u.preventDefault();
          const g = rl(o.getState());
          a(Dg(g));
        }
      }
      s.handleHotkeys(u, n), s.handleMarkdownShortcuts(u, n), s.handleListsShortcuts(u, n);
    },
    [
      t.noLinebreaks,
      n,
      s,
      l,
      r,
      i,
      a,
      o
    ]
  );
};
async function mve({
  event: e,
  files: t,
  text: n,
  id: r,
  dispatch: i,
  getStoreState: o
}) {
  var a, s, l;
  const u = p7(o(), r);
  if (u !== Y.Image) return;
  const d = si.getByType(u), p = ((a = d.onFiles) == null ? void 0 : a.call(d, t)) ?? await ((s = d.onText) == null ? void 0 : s.call(d, n));
  if (!(p != null && p.state)) return;
  const f = p.state.src, m = (l = rA(o(), r)) == null ? void 0 : l.at(-2);
  m && (i(
    ad({
      id: m,
      state: {
        initial: (y) => ({
          ...y,
          src: f
        })
      }
    })
  ), e.preventDefault());
}
var vB = {}, N2 = {}, ks = {}, wl = {};
(function(e) {
  var t = Sn && Sn.__spreadArray || function(w, M, R) {
    if (R || arguments.length === 2) for (var F = 0, W = M.length, X; F < W; F++)
      (X || !(F in M)) && (X || (X = Array.prototype.slice.call(M, 0, F)), X[F] = M[F]);
    return w.concat(X || Array.prototype.slice.call(M));
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.dual = e.getEndomorphismMonoid = e.SK = e.hole = e.constVoid = e.constUndefined = e.constNull = e.constFalse = e.constTrue = e.unsafeCoerce = e.apply = e.getRing = e.getSemiring = e.getMonoid = e.getSemigroup = e.getBooleanAlgebra = void 0, e.identity = l, e.constant = u, e.flip = d, e.flow = p, e.tuple = f, e.increment = m, e.decrement = y, e.absurd = g, e.tupled = x, e.untupled = E, e.pipe = b, e.not = T;
  var n = function(w) {
    return function() {
      return {
        meet: function(M, R) {
          return function(F) {
            return w.meet(M(F), R(F));
          };
        },
        join: function(M, R) {
          return function(F) {
            return w.join(M(F), R(F));
          };
        },
        zero: function() {
          return w.zero;
        },
        one: function() {
          return w.one;
        },
        implies: function(M, R) {
          return function(F) {
            return w.implies(M(F), R(F));
          };
        },
        not: function(M) {
          return function(R) {
            return w.not(M(R));
          };
        }
      };
    };
  };
  e.getBooleanAlgebra = n;
  var r = function(w) {
    return function() {
      return {
        concat: function(M, R) {
          return function(F) {
            return w.concat(M(F), R(F));
          };
        }
      };
    };
  };
  e.getSemigroup = r;
  var i = function(w) {
    var M = (0, e.getSemigroup)(w);
    return function() {
      return {
        concat: M().concat,
        empty: function() {
          return w.empty;
        }
      };
    };
  };
  e.getMonoid = i;
  var o = function(w) {
    return {
      add: function(M, R) {
        return function(F) {
          return w.add(M(F), R(F));
        };
      },
      zero: function() {
        return w.zero;
      },
      mul: function(M, R) {
        return function(F) {
          return w.mul(M(F), R(F));
        };
      },
      one: function() {
        return w.one;
      }
    };
  };
  e.getSemiring = o;
  var a = function(w) {
    var M = (0, e.getSemiring)(w);
    return {
      add: M.add,
      mul: M.mul,
      one: M.one,
      zero: M.zero,
      sub: function(R, F) {
        return function(W) {
          return w.sub(R(W), F(W));
        };
      }
    };
  };
  e.getRing = a;
  var s = function(w) {
    return function(M) {
      return M(w);
    };
  };
  e.apply = s;
  function l(w) {
    return w;
  }
  e.unsafeCoerce = l;
  function u(w) {
    return function() {
      return w;
    };
  }
  e.constTrue = u(!0), e.constFalse = u(!1), e.constNull = u(null), e.constUndefined = u(void 0), e.constVoid = e.constUndefined;
  function d(w) {
    return function() {
      for (var M = [], R = 0; R < arguments.length; R++)
        M[R] = arguments[R];
      return M.length > 1 ? w(M[1], M[0]) : function(F) {
        return w(F)(M[0]);
      };
    };
  }
  function p(w, M, R, F, W, X, le, ne, fe) {
    switch (arguments.length) {
      case 1:
        return w;
      case 2:
        return function() {
          return M(w.apply(this, arguments));
        };
      case 3:
        return function() {
          return R(M(w.apply(this, arguments)));
        };
      case 4:
        return function() {
          return F(R(M(w.apply(this, arguments))));
        };
      case 5:
        return function() {
          return W(F(R(M(w.apply(this, arguments)))));
        };
      case 6:
        return function() {
          return X(W(F(R(M(w.apply(this, arguments))))));
        };
      case 7:
        return function() {
          return le(X(W(F(R(M(w.apply(this, arguments)))))));
        };
      case 8:
        return function() {
          return ne(le(X(W(F(R(M(w.apply(this, arguments))))))));
        };
      case 9:
        return function() {
          return fe(ne(le(X(W(F(R(M(w.apply(this, arguments)))))))));
        };
    }
  }
  function f() {
    for (var w = [], M = 0; M < arguments.length; M++)
      w[M] = arguments[M];
    return w;
  }
  function m(w) {
    return w + 1;
  }
  function y(w) {
    return w - 1;
  }
  function g(w) {
    throw new Error("Called `absurd` function which should be uncallable");
  }
  function x(w) {
    return function(M) {
      return w.apply(void 0, M);
    };
  }
  function E(w) {
    return function() {
      for (var M = [], R = 0; R < arguments.length; R++)
        M[R] = arguments[R];
      return w(M);
    };
  }
  function b(w, M, R, F, W, X, le, ne, fe) {
    switch (arguments.length) {
      case 1:
        return w;
      case 2:
        return M(w);
      case 3:
        return R(M(w));
      case 4:
        return F(R(M(w)));
      case 5:
        return W(F(R(M(w))));
      case 6:
        return X(W(F(R(M(w)))));
      case 7:
        return le(X(W(F(R(M(w))))));
      case 8:
        return ne(le(X(W(F(R(M(w)))))));
      case 9:
        return fe(ne(le(X(W(F(R(M(w))))))));
      default: {
        for (var D = arguments[0], j = 1; j < arguments.length; j++)
          D = arguments[j](D);
        return D;
      }
    }
  }
  e.hole = g;
  var C = function(w, M) {
    return M;
  };
  e.SK = C;
  function T(w) {
    return function(M) {
      return !w(M);
    };
  }
  var z = function() {
    return {
      concat: function(w, M) {
        return p(w, M);
      },
      empty: l
    };
  };
  e.getEndomorphismMonoid = z;
  var I = function(w, M) {
    var R = typeof w == "number" ? function(F) {
      return F.length >= w;
    } : w;
    return function() {
      var F = Array.from(arguments);
      return R(arguments) ? M.apply(this, F) : function(W) {
        return M.apply(void 0, t([W], F, !1));
      };
    };
  };
  e.dual = I;
})(wl);
var Qf = {};
(function(e) {
  var t = Sn && Sn.__spreadArray || function(w, M, R) {
    if (R || arguments.length === 2) for (var F = 0, W = M.length, X; F < W; F++)
      (X || !(F in M)) && (X || (X = Array.prototype.slice.call(M, 0, F)), X[F] = M[F]);
    return w.concat(X || Array.prototype.slice.call(M));
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.flatMapReader = e.flatMapTask = e.flatMapIO = e.flatMapEither = e.flatMapOption = e.flatMapNullable = e.liftOption = e.liftNullable = e.fromReadonlyNonEmptyArray = e.has = e.emptyRecord = e.emptyReadonlyArray = e.tail = e.head = e.isNonEmpty = e.singleton = e.right = e.left = e.isRight = e.isLeft = e.some = e.none = e.isSome = e.isNone = void 0;
  var n = wl, r = function(w) {
    return w._tag === "None";
  };
  e.isNone = r;
  var i = function(w) {
    return w._tag === "Some";
  };
  e.isSome = i, e.none = { _tag: "None" };
  var o = function(w) {
    return { _tag: "Some", value: w };
  };
  e.some = o;
  var a = function(w) {
    return w._tag === "Left";
  };
  e.isLeft = a;
  var s = function(w) {
    return w._tag === "Right";
  };
  e.isRight = s;
  var l = function(w) {
    return { _tag: "Left", left: w };
  };
  e.left = l;
  var u = function(w) {
    return { _tag: "Right", right: w };
  };
  e.right = u;
  var d = function(w) {
    return [w];
  };
  e.singleton = d;
  var p = function(w) {
    return w.length > 0;
  };
  e.isNonEmpty = p;
  var f = function(w) {
    return w[0];
  };
  e.head = f;
  var m = function(w) {
    return w.slice(1);
  };
  e.tail = m, e.emptyReadonlyArray = [], e.emptyRecord = {}, e.has = Object.prototype.hasOwnProperty;
  var y = function(w) {
    return t([w[0]], w.slice(1), !0);
  };
  e.fromReadonlyNonEmptyArray = y;
  var g = function(w) {
    return function(M, R) {
      return function() {
        for (var F = [], W = 0; W < arguments.length; W++)
          F[W] = arguments[W];
        var X = M.apply(void 0, F);
        return w.fromEither(X == null ? (0, e.left)(R.apply(void 0, F)) : (0, e.right)(X));
      };
    };
  };
  e.liftNullable = g;
  var x = function(w) {
    return function(M, R) {
      return function() {
        for (var F = [], W = 0; W < arguments.length; W++)
          F[W] = arguments[W];
        var X = M.apply(void 0, F);
        return w.fromEither((0, e.isNone)(X) ? (0, e.left)(R.apply(void 0, F)) : (0, e.right)(X.value));
      };
    };
  };
  e.liftOption = x;
  var E = function(w, M) {
    return /* @__PURE__ */ (0, n.dual)(3, function(R, F, W) {
      return M.flatMap(R, (0, e.liftNullable)(w)(F, W));
    });
  };
  e.flatMapNullable = E;
  var b = function(w, M) {
    return /* @__PURE__ */ (0, n.dual)(3, function(R, F, W) {
      return M.flatMap(R, (0, e.liftOption)(w)(F, W));
    });
  };
  e.flatMapOption = b;
  var C = function(w, M) {
    return /* @__PURE__ */ (0, n.dual)(2, function(R, F) {
      return M.flatMap(R, function(W) {
        return w.fromEither(F(W));
      });
    });
  };
  e.flatMapEither = C;
  var T = function(w, M) {
    return /* @__PURE__ */ (0, n.dual)(2, function(R, F) {
      return M.flatMap(R, function(W) {
        return w.fromIO(F(W));
      });
    });
  };
  e.flatMapIO = T;
  var z = function(w, M) {
    return /* @__PURE__ */ (0, n.dual)(2, function(R, F) {
      return M.flatMap(R, function(W) {
        return w.fromTask(F(W));
      });
    });
  };
  e.flatMapTask = z;
  var I = function(w, M) {
    return /* @__PURE__ */ (0, n.dual)(2, function(R, F) {
      return M.flatMap(R, function(W) {
        return w.fromReader(F(W));
      });
    });
  };
  e.flatMapReader = I;
})(Qf);
var gve = Sn && Sn.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), vve = Sn && Sn.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), yve = Sn && Sn.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (e != null) for (var n in e) n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && gve(t, e, n);
  return vve(t, e), t;
};
Object.defineProperty(ks, "__esModule", { value: !0 });
ks.ap = wve;
ks.apFirst = Cve;
ks.apSecond = kve;
ks.apS = Eve;
ks.getApplySemigroup = Sve;
ks.sequenceT = Ave;
ks.sequenceS = jve;
var xve = wl, bve = yve(Qf);
function wve(e, t) {
  return function(n) {
    return function(r) {
      return e.ap(e.map(r, function(i) {
        return function(o) {
          return t.ap(i, o);
        };
      }), n);
    };
  };
}
function Cve(e) {
  return function(t) {
    return function(n) {
      return e.ap(e.map(n, function(r) {
        return function() {
          return r;
        };
      }), t);
    };
  };
}
function kve(e) {
  return function(t) {
    return function(n) {
      return e.ap(e.map(n, function() {
        return function(r) {
          return r;
        };
      }), t);
    };
  };
}
function Eve(e) {
  return function(t, n) {
    return function(r) {
      return e.ap(e.map(r, function(i) {
        return function(o) {
          var a;
          return Object.assign({}, i, (a = {}, a[t] = o, a));
        };
      }), n);
    };
  };
}
function Sve(e) {
  return function(t) {
    return {
      concat: function(n, r) {
        return e.ap(e.map(n, function(i) {
          return function(o) {
            return t.concat(i, o);
          };
        }), r);
      }
    };
  };
}
function T8(e, t, n) {
  return function(r) {
    for (var i = Array(n.length + 1), o = 0; o < n.length; o++)
      i[o] = n[o];
    return i[n.length] = r, t === 0 ? e.apply(null, i) : T8(e, t - 1, i);
  };
}
var O3 = {
  1: function(e) {
    return [e];
  },
  2: function(e) {
    return function(t) {
      return [e, t];
    };
  },
  3: function(e) {
    return function(t) {
      return function(n) {
        return [e, t, n];
      };
    };
  },
  4: function(e) {
    return function(t) {
      return function(n) {
        return function(r) {
          return [e, t, n, r];
        };
      };
    };
  },
  5: function(e) {
    return function(t) {
      return function(n) {
        return function(r) {
          return function(i) {
            return [e, t, n, r, i];
          };
        };
      };
    };
  }
};
function Dve(e) {
  return bve.has.call(O3, e) || (O3[e] = T8(xve.tuple, e - 1, [])), O3[e];
}
function Ave(e) {
  return function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    for (var r = t.length, i = Dve(r), o = e.map(t[0], i), a = 1; a < r; a++)
      o = e.ap(o, t[a]);
    return o;
  };
}
function Tve(e) {
  var t = e.length;
  switch (t) {
    case 1:
      return function(n) {
        var r;
        return r = {}, r[e[0]] = n, r;
      };
    case 2:
      return function(n) {
        return function(r) {
          var i;
          return i = {}, i[e[0]] = n, i[e[1]] = r, i;
        };
      };
    case 3:
      return function(n) {
        return function(r) {
          return function(i) {
            var o;
            return o = {}, o[e[0]] = n, o[e[1]] = r, o[e[2]] = i, o;
          };
        };
      };
    case 4:
      return function(n) {
        return function(r) {
          return function(i) {
            return function(o) {
              var a;
              return a = {}, a[e[0]] = n, a[e[1]] = r, a[e[2]] = i, a[e[3]] = o, a;
            };
          };
        };
      };
    case 5:
      return function(n) {
        return function(r) {
          return function(i) {
            return function(o) {
              return function(a) {
                var s;
                return s = {}, s[e[0]] = n, s[e[1]] = r, s[e[2]] = i, s[e[3]] = o, s[e[4]] = a, s;
              };
            };
          };
        };
      };
    default:
      return T8(function() {
        for (var n = [], r = 0; r < arguments.length; r++)
          n[r] = arguments[r];
        for (var i = {}, o = 0; o < t; o++)
          i[e[o]] = n[o];
        return i;
      }, t - 1, []);
  }
}
function jve(e) {
  return function(t) {
    for (var n = Object.keys(t), r = n.length, i = Tve(n), o = e.map(t[n[0]], i), a = 1; a < r; a++)
      o = e.ap(o, t[n[a]]);
    return o;
  };
}
var Wa = {};
Object.defineProperty(Wa, "__esModule", { value: !0 });
Wa.map = yB;
Wa.flap = Ove;
Wa.bindTo = zve;
Wa.let = Fve;
Wa.getFunctorComposition = Lve;
Wa.as = xB;
Wa.asUnit = Mve;
var Nve = wl;
function yB(e, t) {
  return function(n) {
    return function(r) {
      return e.map(r, function(i) {
        return t.map(i, n);
      });
    };
  };
}
function Ove(e) {
  return function(t) {
    return function(n) {
      return e.map(n, function(r) {
        return r(t);
      });
    };
  };
}
function zve(e) {
  return function(t) {
    return function(n) {
      return e.map(n, function(r) {
        var i;
        return i = {}, i[t] = r, i;
      });
    };
  };
}
function Fve(e) {
  return function(t, n) {
    return function(r) {
      return e.map(r, function(i) {
        var o;
        return Object.assign({}, i, (o = {}, o[t] = n(i), o));
      });
    };
  };
}
function Lve(e, t) {
  var n = yB(e, t);
  return {
    map: function(r, i) {
      return (0, Nve.pipe)(r, n(i));
    }
  };
}
function xB(e) {
  return function(t, n) {
    return e.map(t, function() {
      return n;
    });
  };
}
function Mve(e) {
  var t = xB(e);
  return function(n) {
    return t(n, void 0);
  };
}
Object.defineProperty(N2, "__esModule", { value: !0 });
N2.getApplicativeMonoid = Rve;
N2.getApplicativeComposition = Pve;
var bB = ks, Bve = wl, Ive = Wa;
function Rve(e) {
  var t = (0, bB.getApplySemigroup)(e);
  return function(n) {
    return {
      concat: t(n).concat,
      empty: e.of(n.empty)
    };
  };
}
function Pve(e, t) {
  var n = (0, Ive.getFunctorComposition)(e, t).map, r = (0, bB.ap)(e, t);
  return {
    map: n,
    of: function(i) {
      return e.of(t.of(i));
    },
    ap: function(i, o) {
      return (0, Bve.pipe)(i, r(o));
    }
  };
}
var Cd = {};
Object.defineProperty(Cd, "__esModule", { value: !0 });
Cd.chainFirst = _ve;
Cd.tap = wB;
Cd.bind = qve;
function _ve(e) {
  var t = wB(e);
  return function(n) {
    return function(r) {
      return t(r, n);
    };
  };
}
function wB(e) {
  return function(t, n) {
    return e.chain(t, function(r) {
      return e.map(n(r), function() {
        return r;
      });
    });
  };
}
function qve(e) {
  return function(t, n) {
    return function(r) {
      return e.chain(r, function(i) {
        return e.map(n(i), function(o) {
          var a;
          return Object.assign({}, i, (a = {}, a[t] = o, a));
        });
      });
    };
  };
}
var O2 = {};
Object.defineProperty(O2, "__esModule", { value: !0 });
O2.tailRec = void 0;
var $ve = function(e, t) {
  for (var n = t(e); n._tag === "Left"; )
    n = t(n.left);
  return n.right;
};
O2.tailRec = $ve;
var Za = {}, Hve = Sn && Sn.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Vve = Sn && Sn.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Uve = Sn && Sn.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (e != null) for (var n in e) n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Hve(t, e, n);
  return Vve(t, e), t;
};
Object.defineProperty(Za, "__esModule", { value: !0 });
Za.fromOption = kB;
Za.fromPredicate = Zve;
Za.fromOptionK = EB;
Za.chainOptionK = Gve;
Za.fromEitherK = j8;
Za.chainEitherK = Kve;
Za.chainFirstEitherK = Xve;
Za.filterOrElse = Qve;
Za.tapEither = SB;
var Wve = Cd, CB = wl, vc = Uve(Qf);
function kB(e) {
  return function(t) {
    return function(n) {
      return e.fromEither(vc.isNone(n) ? vc.left(t()) : vc.right(n.value));
    };
  };
}
function Zve(e) {
  return function(t, n) {
    return function(r) {
      return e.fromEither(t(r) ? vc.right(r) : vc.left(n(r)));
    };
  };
}
function EB(e) {
  var t = kB(e);
  return function(n) {
    var r = t(n);
    return function(i) {
      return (0, CB.flow)(i, r);
    };
  };
}
function Gve(e, t) {
  var n = EB(e);
  return function(r) {
    var i = n(r);
    return function(o) {
      return function(a) {
        return t.chain(a, i(o));
      };
    };
  };
}
function j8(e) {
  return function(t) {
    return (0, CB.flow)(t, e.fromEither);
  };
}
function Kve(e, t) {
  var n = j8(e);
  return function(r) {
    return function(i) {
      return t.chain(i, n(r));
    };
  };
}
function Xve(e, t) {
  var n = SB(e, t);
  return function(r) {
    return function(i) {
      return n(i, r);
    };
  };
}
function Qve(e, t) {
  return function(n, r) {
    return function(i) {
      return t.chain(i, function(o) {
        return e.fromEither(n(o) ? vc.right(o) : vc.left(r(o)));
      });
    };
  };
}
function SB(e, t) {
  var n = j8(e), r = (0, Wve.tap)(t);
  return function(i, o) {
    return r(i, n(o));
  };
}
var DB = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.right = e.left = e.flap = e.Functor = e.Bifunctor = e.URI = e.bimap = e.mapLeft = e.map = e.separated = void 0;
  var t = wl, n = Wa, r = function(f, m) {
    return { left: f, right: m };
  };
  e.separated = r;
  var i = function(f, m) {
    return (0, t.pipe)(f, (0, e.map)(m));
  }, o = function(f, m) {
    return (0, t.pipe)(f, (0, e.mapLeft)(m));
  }, a = function(f, m, y) {
    return (0, t.pipe)(f, (0, e.bimap)(m, y));
  }, s = function(f) {
    return function(m) {
      return (0, e.separated)((0, e.left)(m), f((0, e.right)(m)));
    };
  };
  e.map = s;
  var l = function(f) {
    return function(m) {
      return (0, e.separated)(f((0, e.left)(m)), (0, e.right)(m));
    };
  };
  e.mapLeft = l;
  var u = function(f, m) {
    return function(y) {
      return (0, e.separated)(f((0, e.left)(y)), m((0, e.right)(y)));
    };
  };
  e.bimap = u, e.URI = "Separated", e.Bifunctor = {
    URI: e.URI,
    mapLeft: o,
    bimap: a
  }, e.Functor = {
    URI: e.URI,
    map: i
  }, e.flap = (0, n.flap)(e.Functor);
  var d = function(f) {
    return f.left;
  };
  e.left = d;
  var p = function(f) {
    return f.right;
  };
  e.right = p;
})(DB);
var Yf = {}, Yve = Sn && Sn.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Jve = Sn && Sn.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), e5e = Sn && Sn.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (e != null) for (var n in e) n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Yve(t, e, n);
  return Jve(t, e), t;
};
Object.defineProperty(Yf, "__esModule", { value: !0 });
Yf.wiltDefault = t5e;
Yf.witherDefault = n5e;
Yf.filterE = r5e;
var Gk = e5e(Qf);
function t5e(e, t) {
  return function(n) {
    var r = e.traverse(n);
    return function(i, o) {
      return n.map(r(i, o), t.separate);
    };
  };
}
function n5e(e, t) {
  return function(n) {
    var r = e.traverse(n);
    return function(i, o) {
      return n.map(r(i, o), t.compact);
    };
  };
}
function r5e(e) {
  return function(t) {
    var n = e.wither(t);
    return function(r) {
      return function(i) {
        return n(i, function(o) {
          return t.map(r(o), function(a) {
            return a ? Gk.some(o) : Gk.none;
          });
        });
      };
    };
  };
}
(function(e) {
  var t = Sn && Sn.__createBinding || (Object.create ? function(Ce, xe, Oe, Ft) {
    Ft === void 0 && (Ft = Oe);
    var on = Object.getOwnPropertyDescriptor(xe, Oe);
    (!on || ("get" in on ? !xe.__esModule : on.writable || on.configurable)) && (on = { enumerable: !0, get: function() {
      return xe[Oe];
    } }), Object.defineProperty(Ce, Ft, on);
  } : function(Ce, xe, Oe, Ft) {
    Ft === void 0 && (Ft = Oe), Ce[Ft] = xe[Oe];
  }), n = Sn && Sn.__setModuleDefault || (Object.create ? function(Ce, xe) {
    Object.defineProperty(Ce, "default", { enumerable: !0, value: xe });
  } : function(Ce, xe) {
    Ce.default = xe;
  }), r = Sn && Sn.__importStar || function(Ce) {
    if (Ce && Ce.__esModule) return Ce;
    var xe = {};
    if (Ce != null) for (var Oe in Ce) Oe !== "default" && Object.prototype.hasOwnProperty.call(Ce, Oe) && t(xe, Ce, Oe);
    return n(xe, Ce), xe;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.match = e.foldW = e.matchW = e.isRight = e.isLeft = e.fromOption = e.fromPredicate = e.FromEither = e.MonadThrow = e.throwError = e.ChainRec = e.Extend = e.extend = e.Alt = e.alt = e.altW = e.Bifunctor = e.mapLeft = e.bimap = e.Traversable = e.sequence = e.traverse = e.Foldable = e.reduceRight = e.foldMap = e.reduce = e.Monad = e.Chain = e.Applicative = e.Apply = e.ap = e.apW = e.Pointed = e.of = e.asUnit = e.as = e.Functor = e.map = e.getAltValidation = e.getApplicativeValidation = e.getWitherable = e.getFilterable = e.getCompactable = e.getSemigroup = e.getEq = e.getShow = e.URI = e.flatMap = e.right = e.left = void 0, e.either = e.stringifyJSON = e.chainFirstW = e.chainFirst = e.chain = e.chainW = e.sequenceArray = e.traverseArray = e.traverseArrayWithIndex = e.traverseReadonlyArrayWithIndex = e.traverseReadonlyNonEmptyArrayWithIndex = e.ApT = e.apSW = e.apS = e.bindW = e.bind = e.let = e.bindTo = e.Do = e.exists = e.toUnion = e.chainNullableK = e.fromNullableK = e.tryCatchK = e.tryCatch = e.fromNullable = e.orElse = e.orElseW = e.swap = e.filterOrElseW = e.filterOrElse = e.flatMapOption = e.flatMapNullable = e.liftOption = e.liftNullable = e.chainOptionKW = e.chainOptionK = e.fromOptionK = e.duplicate = e.flatten = e.flattenW = e.tap = e.apSecondW = e.apSecond = e.apFirstW = e.apFirst = e.flap = e.getOrElse = e.getOrElseW = e.fold = void 0, e.getValidationMonoid = e.getValidationSemigroup = e.getApplyMonoid = e.getApplySemigroup = void 0, e.toError = Lt, e.elem = ct, e.parseJSON = tn, e.getValidation = Yn;
  var i = N2, o = ks, a = r(Cd), s = O2, l = Za, u = wl, d = Wa, p = r(Qf), f = DB, m = Yf;
  e.left = p.left, e.right = p.right, e.flatMap = (0, u.dual)(2, function(Ce, xe) {
    return (0, e.isLeft)(Ce) ? Ce : xe(Ce.right);
  });
  var y = function(Ce, xe) {
    return (0, u.pipe)(Ce, (0, e.map)(xe));
  }, g = function(Ce, xe) {
    return (0, u.pipe)(Ce, (0, e.ap)(xe));
  }, x = function(Ce, xe, Oe) {
    return (0, u.pipe)(Ce, (0, e.reduce)(xe, Oe));
  }, E = function(Ce) {
    return function(xe, Oe) {
      var Ft = (0, e.foldMap)(Ce);
      return (0, u.pipe)(xe, Ft(Oe));
    };
  }, b = function(Ce, xe, Oe) {
    return (0, u.pipe)(Ce, (0, e.reduceRight)(xe, Oe));
  }, C = function(Ce) {
    var xe = (0, e.traverse)(Ce);
    return function(Oe, Ft) {
      return (0, u.pipe)(Oe, xe(Ft));
    };
  }, T = function(Ce, xe, Oe) {
    return (0, u.pipe)(Ce, (0, e.bimap)(xe, Oe));
  }, z = function(Ce, xe) {
    return (0, u.pipe)(Ce, (0, e.mapLeft)(xe));
  }, I = function(Ce, xe) {
    return (0, u.pipe)(Ce, (0, e.alt)(xe));
  }, w = function(Ce, xe) {
    return (0, u.pipe)(Ce, (0, e.extend)(xe));
  }, M = function(Ce, xe) {
    return (0, s.tailRec)(xe(Ce), function(Oe) {
      return (0, e.isLeft)(Oe) ? (0, e.right)((0, e.left)(Oe.left)) : (0, e.isLeft)(Oe.right) ? (0, e.left)(xe(Oe.right.left)) : (0, e.right)((0, e.right)(Oe.right.right));
    });
  };
  e.URI = "Either";
  var R = function(Ce, xe) {
    return {
      show: function(Oe) {
        return (0, e.isLeft)(Oe) ? "left(".concat(Ce.show(Oe.left), ")") : "right(".concat(xe.show(Oe.right), ")");
      }
    };
  };
  e.getShow = R;
  var F = function(Ce, xe) {
    return {
      equals: function(Oe, Ft) {
        return Oe === Ft || ((0, e.isLeft)(Oe) ? (0, e.isLeft)(Ft) && Ce.equals(Oe.left, Ft.left) : (0, e.isRight)(Ft) && xe.equals(Oe.right, Ft.right));
      }
    };
  };
  e.getEq = F;
  var W = function(Ce) {
    return {
      concat: function(xe, Oe) {
        return (0, e.isLeft)(Oe) ? xe : (0, e.isLeft)(xe) ? Oe : (0, e.right)(Ce.concat(xe.right, Oe.right));
      }
    };
  };
  e.getSemigroup = W;
  var X = function(Ce) {
    var xe = (0, e.left)(Ce.empty);
    return {
      URI: e.URI,
      _E: void 0,
      compact: function(Oe) {
        return (0, e.isLeft)(Oe) ? Oe : Oe.right._tag === "None" ? xe : (0, e.right)(Oe.right.value);
      },
      separate: function(Oe) {
        return (0, e.isLeft)(Oe) ? (0, f.separated)(Oe, Oe) : (0, e.isLeft)(Oe.right) ? (0, f.separated)((0, e.right)(Oe.right.left), xe) : (0, f.separated)(xe, (0, e.right)(Oe.right.right));
      }
    };
  };
  e.getCompactable = X;
  var le = function(Ce) {
    var xe = (0, e.left)(Ce.empty), Oe = (0, e.getCompactable)(Ce), Ft = Oe.compact, on = Oe.separate, yr = function(cn, Jn) {
      return (0, e.isLeft)(cn) || Jn(cn.right) ? cn : xe;
    }, Ho = function(cn, Jn) {
      return (0, e.isLeft)(cn) ? (0, f.separated)(cn, cn) : Jn(cn.right) ? (0, f.separated)(xe, (0, e.right)(cn.right)) : (0, f.separated)((0, e.right)(cn.right), xe);
    };
    return {
      URI: e.URI,
      _E: void 0,
      map: y,
      compact: Ft,
      separate: on,
      filter: yr,
      filterMap: function(cn, Jn) {
        if ((0, e.isLeft)(cn))
          return cn;
        var un = Jn(cn.right);
        return un._tag === "None" ? xe : (0, e.right)(un.value);
      },
      partition: Ho,
      partitionMap: function(cn, Jn) {
        if ((0, e.isLeft)(cn))
          return (0, f.separated)(cn, cn);
        var un = Jn(cn.right);
        return (0, e.isLeft)(un) ? (0, f.separated)((0, e.right)(un.left), xe) : (0, f.separated)(xe, (0, e.right)(un.right));
      }
    };
  };
  e.getFilterable = le;
  var ne = function(Ce) {
    var xe = (0, e.getFilterable)(Ce), Oe = (0, e.getCompactable)(Ce);
    return {
      URI: e.URI,
      _E: void 0,
      map: y,
      compact: xe.compact,
      separate: xe.separate,
      filter: xe.filter,
      filterMap: xe.filterMap,
      partition: xe.partition,
      partitionMap: xe.partitionMap,
      traverse: C,
      sequence: e.sequence,
      reduce: x,
      foldMap: E,
      reduceRight: b,
      wither: (0, m.witherDefault)(e.Traversable, Oe),
      wilt: (0, m.wiltDefault)(e.Traversable, Oe)
    };
  };
  e.getWitherable = ne;
  var fe = function(Ce) {
    return {
      URI: e.URI,
      _E: void 0,
      map: y,
      ap: function(xe, Oe) {
        return (0, e.isLeft)(xe) ? (0, e.isLeft)(Oe) ? (0, e.left)(Ce.concat(xe.left, Oe.left)) : xe : (0, e.isLeft)(Oe) ? Oe : (0, e.right)(xe.right(Oe.right));
      },
      of: e.of
    };
  };
  e.getApplicativeValidation = fe;
  var D = function(Ce) {
    return {
      URI: e.URI,
      _E: void 0,
      map: y,
      alt: function(xe, Oe) {
        if ((0, e.isRight)(xe))
          return xe;
        var Ft = Oe();
        return (0, e.isLeft)(Ft) ? (0, e.left)(Ce.concat(xe.left, Ft.left)) : Ft;
      }
    };
  };
  e.getAltValidation = D;
  var j = function(Ce) {
    return function(xe) {
      return (0, e.isLeft)(xe) ? xe : (0, e.right)(Ce(xe.right));
    };
  };
  e.map = j, e.Functor = {
    URI: e.URI,
    map: y
  }, e.as = (0, u.dual)(2, (0, d.as)(e.Functor)), e.asUnit = (0, d.asUnit)(e.Functor), e.of = e.right, e.Pointed = {
    URI: e.URI,
    of: e.of
  };
  var de = function(Ce) {
    return function(xe) {
      return (0, e.isLeft)(xe) ? xe : (0, e.isLeft)(Ce) ? Ce : (0, e.right)(xe.right(Ce.right));
    };
  };
  e.apW = de, e.ap = e.apW, e.Apply = {
    URI: e.URI,
    map: y,
    ap: g
  }, e.Applicative = {
    URI: e.URI,
    map: y,
    ap: g,
    of: e.of
  }, e.Chain = {
    URI: e.URI,
    map: y,
    ap: g,
    chain: e.flatMap
  }, e.Monad = {
    URI: e.URI,
    map: y,
    ap: g,
    of: e.of,
    chain: e.flatMap
  };
  var ye = function(Ce, xe) {
    return function(Oe) {
      return (0, e.isLeft)(Oe) ? Ce : xe(Ce, Oe.right);
    };
  };
  e.reduce = ye;
  var Ne = function(Ce) {
    return function(xe) {
      return function(Oe) {
        return (0, e.isLeft)(Oe) ? Ce.empty : xe(Oe.right);
      };
    };
  };
  e.foldMap = Ne;
  var Me = function(Ce, xe) {
    return function(Oe) {
      return (0, e.isLeft)(Oe) ? Ce : xe(Oe.right, Ce);
    };
  };
  e.reduceRight = Me, e.Foldable = {
    URI: e.URI,
    reduce: x,
    foldMap: E,
    reduceRight: b
  };
  var Ie = function(Ce) {
    return function(xe) {
      return function(Oe) {
        return (0, e.isLeft)(Oe) ? Ce.of((0, e.left)(Oe.left)) : Ce.map(xe(Oe.right), e.right);
      };
    };
  };
  e.traverse = Ie;
  var at = function(Ce) {
    return function(xe) {
      return (0, e.isLeft)(xe) ? Ce.of((0, e.left)(xe.left)) : Ce.map(xe.right, e.right);
    };
  };
  e.sequence = at, e.Traversable = {
    URI: e.URI,
    map: y,
    reduce: x,
    foldMap: E,
    reduceRight: b,
    traverse: C,
    sequence: e.sequence
  };
  var Ve = function(Ce, xe) {
    return function(Oe) {
      return (0, e.isLeft)(Oe) ? (0, e.left)(Ce(Oe.left)) : (0, e.right)(xe(Oe.right));
    };
  };
  e.bimap = Ve;
  var mt = function(Ce) {
    return function(xe) {
      return (0, e.isLeft)(xe) ? (0, e.left)(Ce(xe.left)) : xe;
    };
  };
  e.mapLeft = mt, e.Bifunctor = {
    URI: e.URI,
    bimap: T,
    mapLeft: z
  };
  var ae = function(Ce) {
    return function(xe) {
      return (0, e.isLeft)(xe) ? Ce() : xe;
    };
  };
  e.altW = ae, e.alt = e.altW, e.Alt = {
    URI: e.URI,
    map: y,
    alt: I
  };
  var Se = function(Ce) {
    return function(xe) {
      return (0, e.isLeft)(xe) ? xe : (0, e.right)(Ce(xe));
    };
  };
  e.extend = Se, e.Extend = {
    URI: e.URI,
    map: y,
    extend: w
  }, e.ChainRec = {
    URI: e.URI,
    map: y,
    ap: g,
    chain: e.flatMap,
    chainRec: M
  }, e.throwError = e.left, e.MonadThrow = {
    URI: e.URI,
    map: y,
    ap: g,
    of: e.of,
    chain: e.flatMap,
    throwError: e.throwError
  }, e.FromEither = {
    URI: e.URI,
    fromEither: u.identity
  }, e.fromPredicate = (0, l.fromPredicate)(e.FromEither), e.fromOption = /* @__PURE__ */ (0, l.fromOption)(e.FromEither), e.isLeft = p.isLeft, e.isRight = p.isRight;
  var Ae = function(Ce, xe) {
    return function(Oe) {
      return (0, e.isLeft)(Oe) ? Ce(Oe.left) : xe(Oe.right);
    };
  };
  e.matchW = Ae, e.foldW = e.matchW, e.match = e.matchW, e.fold = e.match;
  var Be = function(Ce) {
    return function(xe) {
      return (0, e.isLeft)(xe) ? Ce(xe.left) : xe.right;
    };
  };
  e.getOrElseW = Be, e.getOrElse = e.getOrElseW, e.flap = (0, d.flap)(e.Functor), e.apFirst = (0, o.apFirst)(e.Apply), e.apFirstW = e.apFirst, e.apSecond = (0, o.apSecond)(e.Apply), e.apSecondW = e.apSecond, e.tap = (0, u.dual)(2, a.tap(e.Chain)), e.flattenW = /* @__PURE__ */ (0, e.flatMap)(u.identity), e.flatten = e.flattenW, e.duplicate = (0, e.extend)(u.identity), e.fromOptionK = /* @__PURE__ */ (0, l.fromOptionK)(e.FromEither), e.chainOptionK = (0, l.chainOptionK)(e.FromEither, e.Chain), e.chainOptionKW = e.chainOptionK;
  var Ze = {
    fromEither: e.FromEither.fromEither
  };
  e.liftNullable = p.liftNullable(Ze), e.liftOption = p.liftOption(Ze);
  var We = {
    flatMap: e.flatMap
  };
  e.flatMapNullable = p.flatMapNullable(Ze, We), e.flatMapOption = p.flatMapOption(Ze, We), e.filterOrElse = (0, l.filterOrElse)(e.FromEither, e.Chain), e.filterOrElseW = e.filterOrElse;
  var St = function(Ce) {
    return (0, e.isLeft)(Ce) ? (0, e.right)(Ce.left) : (0, e.left)(Ce.right);
  };
  e.swap = St;
  var pt = function(Ce) {
    return function(xe) {
      return (0, e.isLeft)(xe) ? Ce(xe.left) : xe;
    };
  };
  e.orElseW = pt, e.orElse = e.orElseW;
  var Tt = function(Ce) {
    return function(xe) {
      return xe == null ? (0, e.left)(Ce) : (0, e.right)(xe);
    };
  };
  e.fromNullable = Tt;
  var Wt = function(Ce, xe) {
    try {
      return (0, e.right)(Ce());
    } catch (Oe) {
      return (0, e.left)(xe(Oe));
    }
  };
  e.tryCatch = Wt;
  var et = function(Ce, xe) {
    return function() {
      for (var Oe = [], Ft = 0; Ft < arguments.length; Ft++)
        Oe[Ft] = arguments[Ft];
      return (0, e.tryCatch)(function() {
        return Ce.apply(void 0, Oe);
      }, xe);
    };
  };
  e.tryCatchK = et;
  var At = function(Ce) {
    var xe = (0, e.fromNullable)(Ce);
    return function(Oe) {
      return (0, u.flow)(Oe, xe);
    };
  };
  e.fromNullableK = At;
  var Gt = function(Ce) {
    var xe = (0, e.fromNullableK)(Ce);
    return function(Oe) {
      return (0, e.flatMap)(xe(Oe));
    };
  };
  e.chainNullableK = Gt, e.toUnion = (0, e.foldW)(u.identity, u.identity);
  function Lt(Ce) {
    try {
      return Ce instanceof Error ? Ce : new Error(String(Ce));
    } catch {
      return new Error();
    }
  }
  function ct(Ce) {
    return function(xe, Oe) {
      if (Oe === void 0) {
        var Ft = ct(Ce);
        return function(on) {
          return Ft(xe, on);
        };
      }
      return (0, e.isLeft)(Oe) ? !1 : Ce.equals(xe, Oe.right);
    };
  }
  var re = function(Ce) {
    return function(xe) {
      return (0, e.isLeft)(xe) ? !1 : Ce(xe.right);
    };
  };
  e.exists = re, e.Do = (0, e.of)(p.emptyRecord), e.bindTo = (0, d.bindTo)(e.Functor);
  var $e = /* @__PURE__ */ (0, d.let)(e.Functor);
  e.let = $e, e.bind = a.bind(e.Chain), e.bindW = e.bind, e.apS = (0, o.apS)(e.Apply), e.apSW = e.apS, e.ApT = (0, e.of)(p.emptyReadonlyArray);
  var vt = function(Ce) {
    return function(xe) {
      var Oe = Ce(0, p.head(xe));
      if ((0, e.isLeft)(Oe))
        return Oe;
      for (var Ft = [Oe.right], on = 1; on < xe.length; on++) {
        var yr = Ce(on, xe[on]);
        if ((0, e.isLeft)(yr))
          return yr;
        Ft.push(yr.right);
      }
      return (0, e.right)(Ft);
    };
  };
  e.traverseReadonlyNonEmptyArrayWithIndex = vt;
  var rt = function(Ce) {
    var xe = (0, e.traverseReadonlyNonEmptyArrayWithIndex)(Ce);
    return function(Oe) {
      return p.isNonEmpty(Oe) ? xe(Oe) : e.ApT;
    };
  };
  e.traverseReadonlyArrayWithIndex = rt, e.traverseArrayWithIndex = e.traverseReadonlyArrayWithIndex;
  var Dt = function(Ce) {
    return (0, e.traverseReadonlyArrayWithIndex)(function(xe, Oe) {
      return Ce(Oe);
    });
  };
  e.traverseArray = Dt, e.sequenceArray = /* @__PURE__ */ (0, e.traverseArray)(u.identity), e.chainW = e.flatMap, e.chain = e.flatMap, e.chainFirst = e.tap, e.chainFirstW = e.tap;
  function tn(Ce, xe) {
    return (0, e.tryCatch)(function() {
      return JSON.parse(Ce);
    }, xe);
  }
  var Xn = function(Ce, xe) {
    return (0, e.tryCatch)(function() {
      var Oe = JSON.stringify(Ce);
      if (typeof Oe != "string")
        throw new Error("Converting unsupported structure to JSON");
      return Oe;
    }, xe);
  };
  e.stringifyJSON = Xn, e.either = {
    URI: e.URI,
    map: y,
    of: e.of,
    ap: g,
    chain: e.flatMap,
    reduce: x,
    foldMap: E,
    reduceRight: b,
    traverse: C,
    sequence: e.sequence,
    bimap: T,
    mapLeft: z,
    alt: I,
    extend: w,
    chainRec: M,
    throwError: e.throwError
  }, e.getApplySemigroup = /* @__PURE__ */ (0, o.getApplySemigroup)(e.Apply), e.getApplyMonoid = /* @__PURE__ */ (0, i.getApplicativeMonoid)(e.Applicative);
  var In = function(Ce, xe) {
    return (0, o.getApplySemigroup)((0, e.getApplicativeValidation)(Ce))(xe);
  };
  e.getValidationSemigroup = In;
  var Qn = function(Ce, xe) {
    return (0, i.getApplicativeMonoid)((0, e.getApplicativeValidation)(Ce))(xe);
  };
  e.getValidationMonoid = Qn;
  function Yn(Ce) {
    var xe = (0, e.getApplicativeValidation)(Ce).ap, Oe = (0, e.getAltValidation)(Ce).alt;
    return {
      URI: e.URI,
      _E: void 0,
      map: y,
      of: e.of,
      chain: e.flatMap,
      bimap: T,
      mapLeft: z,
      reduce: x,
      foldMap: E,
      reduceRight: b,
      extend: w,
      traverse: C,
      sequence: e.sequence,
      chainRec: M,
      throwError: e.throwError,
      ap: xe,
      alt: Oe
    };
  }
})(vB);
function i5e({
  event: e,
  text: t,
  editor: n
}) {
  if (!t.includes("\\(") || !t.includes("\\)")) return;
  const r = t.split(/\n\s*\n|\\\\\n/gm);
  r.forEach((i, o) => {
    const a = i.split(/\\\((.*?)\\\)/gm);
    if (!a.length) return;
    const s = a.map((l, u) => u % 2 === 1 ? {
      type: "math",
      src: l,
      inline: !0,
      children: [{ text: "" }]
    } : { text: l });
    ge.insertNodes(n, s), o < r.length - 1 && ge.insertNodes(n, {
      type: "p",
      children: [{ text: "" }]
    }), e.preventDefault();
  });
}
const o5e = (e) => {
  const t = zn(), { editor: n, id: r } = e, i = Ur(), o = nt().plugins.text;
  return v.useCallback(
    async (a) => {
      var s, l;
      const u = Array.from(a.clipboardData.files), d = a.clipboardData.getData("text");
      if (!u.length && !d) return;
      const p = t.getState(), f = bi(p, r), m = Sg(p, r);
      if (!f || (mve({
        event: a,
        files: u,
        text: d,
        id: r,
        dispatch: i,
        getStoreState: () => p
      }), d.startsWith("![](https://cdn.mathpix.com") && a.preventDefault(), i5e({ event: a, editor: n, text: d }), !m)) return;
      let y = [];
      if (!y.length && d.startsWith('{"plugin":"rows"')) {
        MP(E);
        const C = g(d);
        if (!C || !C.state.length) return;
        C.state.forEach(x);
      }
      if (!y.length)
        for (const { plugin: C, type: T } of si.getAllWithData()) {
          const z = ((s = C.onFiles) == null ? void 0 : s.call(C, u)) ?? await ((l = C.onText) == null ? void 0 : l.call(C, d));
          if (z != null && z.state) {
            y = [{ state: z.state, pluginType: T }];
            break;
          }
        }
      if (!y.length) return;
      if (a.preventDefault(), Xf(n)) {
        yi(o.noElementPasteInLists, "warning");
        return;
      }
      gB({
        plugins: y,
        editor: n,
        id: r,
        getStoreState: () => t.getState(),
        dispatch: i
      }), BP(E);
      function g(C) {
        return wl.pipe(
          a5e.decode(JSON.parse(C)),
          vB.fold(
            (T) => b(T) ?? null,
            (T) => T
          )
        );
      }
      function x({ plugin: C, state: T }) {
        const z = Eg(t.getState(), r);
        z !== null && (ry(C, z) ? y.push({ pluginType: C, state: T }) : yi(o.pastingPluginNotAllowedHere, "warning"));
      }
      function E() {
        yi(o.unsupportedPluginsPasted, "warning");
      }
      function b(C) {
        yi(o.invalidDataPasted, "warning"), console.error("Pasted JSON data is not a valid editor-state: ", C);
      }
    },
    [i, n, r, o, t]
  );
}, a5e = xw({
  plugin: mi(Y.Rows),
  state: SN(
    xw({
      plugin: Cr,
      state: Y7
    })
  )
}), s5e = (e) => {
  const { editor: t, state: n, id: r, focused: i } = e;
  return wo[r] || (wo[r] = {
    value: n.value.value,
    selection: n.value.selection,
    needRefocus: 1
  }), v.useMemo(() => {
    const { selection: o, value: a } = n.value;
    wo[r].value !== a && (wo[r].value = a, wo[r].selection = o, t.children = a, V5(t, () => {
      ge.deselect(t), ge.select(t, o ?? q.start(t, []));
    }));
  }, [t, n.value, r]), v.useEffect(() => {
    const o = wo[r];
    if (i && o.needRefocus > 0) {
      const a = o.selection ?? q.start(t, []);
      V5(t, () => {
        ge.deselect(t), ge.select(t, a);
      }), requestAnimationFrame(() => {
        l5e(t) && (Ue.focus(t, { retries: 2 }), o.needRefocus--);
      });
    }
  }), v.useEffect(() => {
    i && (wo[r].needRefocus = 2, wo[r].selection = {
      anchor: q.start(t, []),
      focus: q.start(t, [])
    });
  }, [i, r, t]), v.useCallback(
    (o) => {
      const a = t.operations.some(
        ({ type: l }) => l !== "set_selection"
      ), s = wo[r];
      a && (s.value = o, n.set(
        { value: o, selection: t.selection },
        ({ value: l }) => ({ value: l, selection: s.selection })
      )), s.selection = t.selection;
    },
    [t.operations, t.selection, n, r]
  );
};
function l5e(e) {
  try {
    const t = Ue.toDOMNode(e, e);
    return document.body.contains(t);
  } catch (t) {
    return console.warn("Error checking if editor is in DOM. Not mounted!", t), !1;
  }
}
function AB(e) {
  return Ey.isValidAttribute("a", "href", e) ? e : "";
}
const u5e = 320;
function c5e(e) {
  const {
    blankId: t,
    correctAnswers: n,
    acceptMathEquivalents: r,
    onAlternativeAnswerAdd: i,
    onAlternativeAnswerChange: o,
    onAlternativeAnswerRemove: a,
    onAcceptMathEquivalentsChange: s
  } = e, [l, u] = v.useState(null), d = qc(), { selection: p } = d, f = v.useRef(null), m = nt().plugins.blanksExercise;
  v.useEffect(() => {
    if (p)
      if (p && ke.isCollapsed(p) && E8(d)) {
        const E = W3e(d) || null;
        u(
          (E == null ? void 0 : E.blankId) === t ? E : null
        );
      } else
        u(null);
  }, [p, d, t]);
  const y = v.useMemo(() => {
    var E;
    return ((E = n[0]) == null ? void 0 : E.length) === 0 ? !0 : /^[a-zA-Z]+$/.test(n[0]);
  }, [n]);
  function g() {
    i(), setTimeout(() => {
      var E;
      const b = (E = f.current) == null ? void 0 : E.querySelectorAll("input");
      b == null || b[b.length - 1].focus();
    }, 10);
  }
  function x(E) {
    a(E), setTimeout(() => {
      var b;
      const C = (b = f.current) == null ? void 0 : b.querySelectorAll("input");
      if (!C) return;
      const T = C[E - 2];
      if (T) return T.focus();
      const z = C[E - 1];
      z && z.focus();
    }, 10);
  }
  return l ? /* @__PURE__ */ c.jsx(mB, { width: u5e, anchor: l, children: /* @__PURE__ */ c.jsxs(
    "div",
    {
      className: "p-side",
      onClick: (E) => {
        E.detail === 3 && E.stopPropagation();
      },
      children: [
        y ? null : /* @__PURE__ */ c.jsxs("label", { className: "items-top mb-6 flex cursor-pointer text-sm", children: [
          /* @__PURE__ */ c.jsx(
            "input",
            {
              className: "w-0.25 opacity-0",
              type: "checkbox",
              checked: r || !1,
              onChange: s
            }
          ),
          /* @__PURE__ */ c.jsx(
            ot,
            {
              icon: r ? E7 : F7,
              className: "mr-[7px] mt-[3px] text-xl text-editor-primary"
            }
          ),
          m.acceptMathEquivalents
        ] }),
        n.length <= 1 ? /* @__PURE__ */ c.jsxs(
          "button",
          {
            onClick: g,
            className: "serlo-button-edit-primary text-sm font-normal",
            children: [
              /* @__PURE__ */ c.jsx(ot, { className: "mr-1", icon: Dc }),
              m.addAlternativeAnswer
            ]
          }
        ) : /* @__PURE__ */ c.jsxs("div", { children: [
          /* @__PURE__ */ c.jsx("div", { className: "mb-4 text-sm font-bold", children: m.alternativeAnswers }),
          /* @__PURE__ */ c.jsxs(
            "div",
            {
              className: "flex flex-wrap items-center gap-2",
              ref: f,
              children: [
                n.map((E, b) => b === 0 ? null : /* @__PURE__ */ c.jsx(
                  Q7,
                  {
                    tooltipText: m.removeAlternativeAnswer,
                    onRemoveClick: () => {
                      x(b);
                    },
                    children: /* @__PURE__ */ c.jsx(
                      X7,
                      {
                        value: E,
                        className: "serlo-input-font-reset",
                        onChange: (C) => {
                          o(b, C.target.value);
                        },
                        onKeyDown: (C) => {
                          C.key === "Enter" && g(), C.key === "Backspace" && E === "" && x(b);
                        }
                      }
                    )
                  },
                  b
                )),
                /* @__PURE__ */ c.jsx(
                  "button",
                  {
                    onClick: g,
                    className: "serlo-button-edit-primary h-5 w-5 p-0 text-xs",
                    children: /* @__PURE__ */ c.jsx(ot, { icon: Dc, className: "h-5 w-3" })
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  ) }) : null;
}
function d5e(e) {
  const { element: t, focused: n } = e, { blankId: r, correctAnswers: i } = t, o = qc(), a = AM(), s = s3e(), l = v.useMemo(() => t.acceptMathEquivalents === void 0 ? !0 : t.acceptMathEquivalents, [t.acceptMathEquivalents]), u = v.useRef(null);
  v.useEffect(() => {
    function C(T) {
      const z = u.current;
      z && document.activeElement !== z && s && a && o.selection && ke.isCollapsed(o.selection) && (z.focus(), T.key === "ArrowRight" && z.setSelectionRange(0, 0));
    }
    return document.addEventListener("keydown", C), () => document.removeEventListener("keydown", C);
  }, [o, s, u, a]);
  const d = v.useContext(Qg);
  if (d === null) return null;
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      TO,
      {
        ref: u,
        blankId: r,
        context: d,
        onChange: p,
        onKeyDown: f,
        onBlur: m
      }
    ),
    n && d.mode === "typing" ? /* @__PURE__ */ c.jsx(
      c5e,
      {
        blankId: r,
        correctAnswers: i.map(({ answer: C }) => C),
        acceptMathEquivalents: l,
        onAlternativeAnswerAdd: y,
        onAlternativeAnswerChange: g,
        onAlternativeAnswerRemove: x,
        onAcceptMathEquivalentsChange: b
      }
    ) : null
  ] });
  function p(C) {
    g(0, C.target.value);
  }
  function f(C) {
    if (!u || !u.current) return;
    const { selectionStart: T, selectionEnd: z, value: I } = u.current, w = T === z, M = z === I.length, R = T === 0;
    I.length === 0 && (C.key === "Backspace" || C.key === "Delete") && (C.preventDefault(), eB(o)), C.key === "ArrowRight" && !C.shiftKey && w && M && (ge.move(o, { unit: "character" }), Ue.focus(o)), C.key === "ArrowLeft" && !C.shiftKey && w && R && (ge.move(o, { unit: "character", reverse: !0 }), Ue.focus(o));
  }
  function m() {
    var C;
    g(0, (C = i[0]) == null ? void 0 : C.answer.trim()), E(
      i.map(({ answer: T }) => ({ answer: T.trim() })).filter(({ answer: T }, z) => z === 0 || T.length > 0)
    );
  }
  function y() {
    Ue.blur(o), E([...i, { answer: "" }]);
  }
  function g(C, T) {
    E(
      i.map(({ answer: z }, I) => ({
        answer: I === C ? T : z
      }))
    );
  }
  function x(C) {
    E(i.filter((T, z) => z !== C));
  }
  function E(C) {
    const T = Ue.findPath(o, t);
    ge.setNodes(o, { correctAnswers: C }, { at: T });
  }
  function b() {
    ge.setNodes(
      o,
      { acceptMathEquivalents: !l },
      { at: Ue.findPath(o, t) }
    );
  }
}
function p5e({
  element: e,
  attributes: t,
  focused: n,
  children: r
}) {
  const i = qc(), o = AM(), a = v.useContext(z7), s = !!a.get("visualMath"), l = v.useMemo(() => eve(e, i), [i, e]);
  if (!(n && o && i.selection && ke.isCollapsed(i.selection)))
    return /* @__PURE__ */ c.jsx(c.Fragment, { children: /* @__PURE__ */ c.jsxs("span", { ...t, contentEditable: !1, className: "select-none", children: [
      /* @__PURE__ */ c.jsx(Km, { src: e.src, inline: e.inline, type: "math" }),
      r
    ] }) });
  const u = e.inline ? "span" : "div";
  return (
    // Slate void elements need to set attributes and contentEditable={false}
    // See: https://docs.slatejs.org/api/nodes/element#rendering-void-elements
    /* @__PURE__ */ c.jsx(c.Fragment, { children: /* @__PURE__ */ c.jsxs(u, { ...t, tabIndex: -1, contentEditable: !1, children: [
      /* @__PURE__ */ c.jsx(
        OF,
        {
          state: e.src,
          inline: e.inline,
          readOnly: !1,
          visual: s,
          disableBlock: l,
          onInlineChange: p,
          onChange: (m) => d({ src: m }),
          closeMathEditorOverlay: f,
          onMoveOutRight: f,
          onMoveOutLeft: () => {
            f({ reverse: !0 });
          },
          onDeleteOutRight: () => {
            f({ shouldDelete: !0 });
          },
          onDeleteOutLeft: () => {
            f({ shouldDelete: !0, reverse: !0 });
          },
          onEditorChange: (m) => a.set("visualMath", m)
        }
      ),
      r
    ] }) })
  );
  function d(m) {
    const y = Ue.findPath(i, e);
    ge.setNodes(i, m, { at: y });
  }
  function p(m) {
    q.withoutNormalizing(i, () => {
      const y = Ue.findPath(i, e);
      ge.setNodes(i, { inline: m }, { at: y }), m ? g() : x();
      function g() {
        const E = Te.get(i, y);
        ge.removeNodes(i, { at: y });
        const b = {
          type: "p",
          children: [
            { text: "" },
            {
              ...E
            },
            { text: "" }
          ]
        };
        ge.insertNodes(i, b, { at: y });
        const C = ee.next(y);
        if (Te.has(i, C)) {
          const T = Te.get(i, C);
          "type" in T && T.type === "p" && ge.mergeNodes(i, { at: C });
        }
        if (y[y.length - 1] !== 0) {
          const T = Te.get(i, ee.previous(y));
          "type" in T && T.type === "p" && ge.mergeNodes(i, { at: y });
        }
      }
      function x() {
        ge.liftNodes(i, { at: y });
      }
    });
  }
  function f({
    reverse: m = !1,
    shouldDelete: y = !1
  } = {}) {
    const g = "character";
    ge.move(i, { unit: g, reverse: m }), y && ge.delete(i, { unit: g, reverse: m }), Ue.focus(i);
  }
}
const f5e = ({
  focused: e
}) => {
  const t = v.useCallback(
    (r) => {
      const { element: i, attributes: o, children: a } = r;
      if (i.type === "h") {
        const s = ["serlo-h1", "serlo-h2", "serlo-h3"];
        return v.createElement(
          `h${i.level}`,
          { ...o, className: s[i.level - 1] },
          /* @__PURE__ */ c.jsx(c.Fragment, { children: a })
        );
      }
      return i.type === "a" ? /* @__PURE__ */ c.jsx(
        "a",
        {
          href: AB(i.href),
          className: "serlo-link cursor-pointer",
          ...o,
          children: a
        }
      ) : i.type === ur.UNORDERED_LIST ? /* @__PURE__ */ c.jsx("ul", { className: "serlo-ul", ...o, children: a }) : i.type === ur.ORDERED_LIST ? /* @__PURE__ */ c.jsx("ol", { className: "serlo-ol", ...o, children: a }) : i.type === ur.LIST_ITEM ? /* @__PURE__ */ c.jsx("li", { ...o, children: a }) : i.type === ur.LIST_ITEM_TEXT ? /* @__PURE__ */ c.jsx("div", { ...o, children: a }) : i.type === "math" ? /* @__PURE__ */ c.jsx(
        p5e,
        {
          element: i,
          attributes: o,
          focused: e,
          children: a
        }
      ) : i.type === "textBlank" ? /* @__PURE__ */ c.jsxs(
        "span",
        {
          ...o,
          contentEditable: !1,
          style: { userSelect: "none" },
          children: [
            /* @__PURE__ */ c.jsx(d5e, { element: i, focused: e }),
            a
          ]
        }
      ) : /* @__PURE__ */ c.jsx("div", { ...o, children: a });
    },
    [e]
  ), n = v.useCallback(
    (r) => /* @__PURE__ */ c.jsx("span", { ...r.attributes, "data-qa": "plugin-text-leaf-element", children: /* @__PURE__ */ c.jsx(jO, { ...r }) }),
    []
  );
  return { handleRenderElement: t, handleRenderLeaf: n };
}, h5e = [
  tt.code,
  tt.colors,
  tt.headings,
  tt.links,
  tt.lists,
  tt.math,
  tt.richTextBold,
  tt.richTextItalic
], m5e = (e) => ({
  formattingOptions: e.formattingOptions ?? h5e,
  placeholder: e.placeholder ?? void 0,
  noLinebreaks: e.noLinebreaks ?? !1,
  controls: e.controls ?? void 0,
  isInlineChildEditor: e.isInlineChildEditor ?? void 0
}), g5e = (e) => {
  const { deleteBackward: t, deleteForward: n, insertBreak: r } = e;
  return e.insertBreak = () => {
    if (!e.selection || !ke.isCollapsed(e.selection))
      return r();
    const i = ee.parent(e.selection.anchor.path), o = Te.get(e, i);
    if (q.isVoid(e, o)) {
      q.insertNode(e, {
        type: "p",
        children: [{ text: "" }]
      });
      return;
    }
    r();
  }, e.deleteBackward = (i) => {
    if (!e.selection || !ke.isCollapsed(e.selection) || e.selection.anchor.offset !== 0)
      return t(i);
    const o = ee.parent(e.selection.anchor.path), a = Te.get(e, o);
    if (Te.string(a).length === 0 && ee.hasPrevious(o)) {
      const s = ee.previous(o), l = Te.get(e, s);
      if (q.isVoid(e, l))
        return ge.removeNodes(e);
    }
    t(i);
  }, e.deleteForward = (i) => {
    if (!e.selection || !ke.isCollapsed(e.selection) || e.selection.anchor.offset !== 0)
      return n(i);
    const o = ee.parent(e.selection.anchor.path), a = Te.get(e, o), s = Te.string(a).length === 0, l = ee.next(o), u = Te.has(e, l);
    if (s && u) {
      const d = Te.get(e, l);
      if (q.isVoid(e, d))
        return ge.removeNodes(e);
    }
    n(i);
  }, e;
};
function v5e(e) {
  const { state: t, id: n, focused: r, containerRef: i } = e, o = nt().plugins.text, a = m5e(e.config), s = hB(a.formattingOptions), { createTextEditor: l, toolbarControls: u } = s, { editor: d, editorKey: p } = v.useMemo(() => ({
    editor: l(
      p3e(
        f3e(g5e(Jme()))
      )
    ),
    // Fast Refresh will rerun useMemo and create a new editor instance,
    // but <Slate /> is confused by it
    // Generate a unique key per editor instance and set it on the component
    // to synchronize rerendering
    editorKey: fa()
  }), [l]), { handleRenderElement: f, handleRenderLeaf: m } = f5e({
    focused: r
  }), y = s5e({
    editor: d,
    state: t,
    id: n,
    focused: r
  }), g = hve({
    config: a,
    editor: d,
    id: n,
    state: t
  }), x = o5e({
    editor: d,
    id: n
  });
  return v.useEffect(() => {
    const b = Te.string(d);
    "type" in d.children[0] && d.children[0].type === "p" && (b === "" && (ge.select(d, { offset: 0, path: [0, 0] }), wo[n].selection = d.selection), r && Ue.focus(d));
  }, [d, r, n]), /* @__PURE__ */ c.jsxs(
    d3e,
    {
      editor: d,
      initialValue: wo[n].value,
      onChange: y,
      children: [
        r ? /* @__PURE__ */ c.jsx(
          cve,
          {
            id: n,
            toolbarControls: u,
            config: a,
            containerRef: i
          }
        ) : null,
        /* @__PURE__ */ c.jsx(
          n3e,
          {
            readOnly: !1,
            onKeyDown: g,
            onPaste: x,
            onBlur: E,
            renderElement: f,
            renderLeaf: m,
            placeholder: a.placeholder ?? o.placeholder,
            className: "pb-1 outline-none focus:outline-none [&>[data-slate-node]]:mx-side",
            "data-qa": "plugin-text-editor"
          }
        ),
        r ? /* @__PURE__ */ c.jsx(uve, {}) : null
      ]
    },
    p
  );
  function E() {
    d.normalize({ force: !0, operation: { type: "blur_container" } });
  }
}
const y5e = (e) => e && Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype, x5e = (e) => ({
  Component: v5e,
  config: e,
  state: aj(G1(), {
    toStaticState({ value: t }) {
      return t;
    },
    toStoreState(t) {
      if (t.length === 0)
        return G1();
      const n = t[0].children[0];
      return y5e(n) ? G1() : { value: t, selection: null };
    }
  }),
  onKeyDown() {
    return !1;
  },
  isEmpty: (t) => t.value.value.map((n) => [...Te.elements(n)].find(
    ([r]) => r.type === "math" && r.src && r.src.length
  ) ? !1 : Te.string(n)).join("") === ""
});
function TB() {
  return /* @__PURE__ */ c.jsx(
    "textarea",
    {
      rows: 3,
      spellCheck: !1,
      className: "mx-side my-5 w-full resize-y rounded-xl border border-brand bg-brand-50 p-2"
    }
  );
}
function b5e({ id: e }) {
  return /* @__PURE__ */ c.jsx(TB, {});
}
function w5e() {
  return ln({});
}
const C5e = {
  Component: b5e,
  state: w5e(),
  config: {}
}, k5e = (e) => {
  var t;
  const n = nt().plugins.unsupported, r = zn(), i = (t = li(
    r.getState(),
    e.id
  )) == null ? void 0 : t.plugin, { focused: o, id: a } = e;
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    o ? /* @__PURE__ */ c.jsx(
      Ci,
      {
        pluginType: Y.Unsupported,
        pluginControls: /* @__PURE__ */ c.jsx(Pi, { pluginId: a })
      }
    ) : null,
    /* @__PURE__ */ c.jsxs("div", { className: "my-8 rounded-2xl bg-gray-100 p-4", children: [
      /* @__PURE__ */ c.jsxs("b", { children: [
        /* @__PURE__ */ c.jsx(ot, { icon: GV }),
        " ",
        n.notSupported,
        " [",
        i,
        "]"
      ] }),
      /* @__PURE__ */ c.jsx("p", { className: "mb-1 mt-3", children: n.explanation })
    ] })
  ] });
}, E5e = ln({
  plugin: rn(),
  state: Vg({})
}), S5e = {
  Component: k5e,
  state: E5e,
  config: {}
};
function jB({ src: e, type: t }) {
  const n = Un().plugins.video;
  return t ? /* @__PURE__ */ c.jsx("div", { className: "my-0 aspect-[16/9] w-full p-0", children: t === "SerloAsset" ? /* @__PURE__ */ c.jsx("video", { controls: !0, src: e, className: Kk }) : /* @__PURE__ */ c.jsx(
    "iframe",
    {
      src: e,
      frameBorder: "0",
      allow: "autoplay; encrypted-media; picture-in-picture",
      allowFullScreen: !0,
      className: Kk
    }
  ) }) : /* @__PURE__ */ c.jsxs("div", { className: "mx-side text-center print:hidden", children: [
    /* @__PURE__ */ c.jsx(ot, { icon: aV, className: "h-16" }),
    /* @__PURE__ */ c.jsx("p", { className: "serlo-p text-almost-black", children: e ? `${n.failed}: ${e}` : "" })
  ] });
}
const Kk = Le("h-full w-full border-none bg-black/30");
function N8(e, t) {
  const n = /^(https?:\/\/)?(.*?vimeo\.com\/)(.+)/.exec(e);
  if (n)
    return [
      `https://player.vimeo.com/video/${n[3]}?autoplay=1`,
      "Vimeo"
      /* Vimeo */
    ];
  if (/^(https:\/\/assets\.serlo\.org\/wikimedia\/)(.+)(webm)$/.exec(e)) return [
    e,
    "SerloAsset"
    /* SerloAsset */
  ];
  const r = /^(https?:\/\/)?(.*?youtube\.com\/watch\?(.*&)?v=|.*?youtu\.be\/)([a-zA-Z0-9_-]{11})/.exec(e);
  if (r) {
    const i = encodeURIComponent(r[4]), o = new URL(e), a = parseInt(o.searchParams.get("t") ?? ""), s = o.search.includes("cc_load_policy=1");
    return [
      `https://www.youtube-nocookie.com/embed/${i}?autoplay=1&html5=1${s ? `&cc_lang_pref=${t ?? "de"}&cc_load_policy=1` : ""}${isNaN(a) ? "" : `&start=${a}`}`,
      "YouTube"
      /* YouTube */
    ];
  }
  return [e, void 0];
}
const D5e = ({
  id: e,
  state: t,
  showSettingsModal: n,
  setShowSettingsModal: r
}) => {
  const i = nt().plugins.video;
  return /* @__PURE__ */ c.jsx(
    Ci,
    {
      pluginType: Y.Video,
      pluginSettings: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
        /* @__PURE__ */ c.jsxs(
          "button",
          {
            onClick: () => r("url"),
            className: "mr-2 rounded-md border border-gray-500 px-1 text-sm transition-all hover:bg-editor-primary-200 focus-visible:bg-editor-primary-200",
            children: [
              i.videoUrl,
              " ",
              /* @__PURE__ */ c.jsx(ot, { icon: W0 })
            ]
          }
        ),
        /* @__PURE__ */ c.jsxs(
          "button",
          {
            onClick: () => r("description"),
            className: "mr-2 rounded-md border border-gray-500 px-1 text-sm transition-all hover:bg-editor-primary-200 focus-visible:bg-editor-primary-200",
            children: [
              i.videoDescription,
              " ",
              /* @__PURE__ */ c.jsx(ot, { icon: W0 })
            ]
          }
        ),
        /* @__PURE__ */ c.jsxs(
          qo,
          {
            isOpen: !!n,
            setIsOpen: (o) => {
              o || r(!1);
            },
            className: "top-8 max-w-xl translate-y-0 sm:top-24",
            title: i.title,
            extraTitleClassName: "serlo-h3 mt-4",
            children: [
              /* @__PURE__ */ c.jsx("div", { className: "mx-side mb-3", children: /* @__PURE__ */ c.jsx(
                tf,
                {
                  autoFocus: n === "url",
                  label: `${i.videoUrl}: `,
                  value: t.src.value,
                  onChange: (o) => {
                    t.src.set(o.target.value);
                  },
                  inputWidth: "100%",
                  width: "100%",
                  placeholder: "(YouTube, Vimeo)",
                  className: "block"
                }
              ) }),
              /* @__PURE__ */ c.jsx("div", { className: "mx-side mb-3", children: /* @__PURE__ */ c.jsx(
                tf,
                {
                  autoFocus: n === "description",
                  label: `${i.videoDescription}: `,
                  value: t.alt.value,
                  onChange: (o) => t.alt.set(o.target.value),
                  width: "100%",
                  inputWidth: "100%",
                  className: "block"
                }
              ) })
            ]
          }
        )
      ] }),
      pluginControls: /* @__PURE__ */ c.jsx(Pi, { pluginId: e })
    }
  );
}, A5e = (e) => {
  const { focused: t, state: n } = e, [r, i] = v.useState(!1), [o, a] = N8(n.src.value), s = a !== void 0;
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    t && /* @__PURE__ */ c.jsx(
      D5e,
      {
        ...e,
        showSettingsModal: r,
        setShowSettingsModal: i
      }
    ),
    s ? /* @__PURE__ */ c.jsx(
      BF,
      {
        type: "video",
        provider: a,
        embedUrl: o,
        className: t ? "" : "pointer-events-none",
        children: /* @__PURE__ */ c.jsx(jB, { src: o, type: a })
      }
    ) : /* @__PURE__ */ c.jsx(
      "div",
      {
        className: "cursor-pointer rounded-lg bg-editor-primary-50 py-32 text-center",
        "data-qa": "plugin-video-placeholder",
        onClick: () => i("url"),
        children: /* @__PURE__ */ c.jsx(
          ot,
          {
            icon: uT,
            className: "text-7xl text-editor-primary-200"
          }
        )
      }
    )
  ] });
}, T5e = ln({ src: rn(), alt: rn() }), j5e = {
  Component: A5e,
  config: {},
  state: T5e,
  onText(e) {
    const [t, n] = N8(e);
    if (n) return { state: { src: e, alt: "" } };
  }
}, N5e = (e) => {
  const { onClick: t, onFocus: n, onBlur: r } = e, i = nt().plugins.image;
  return /* @__PURE__ */ c.jsxs(
    "button",
    {
      "data-qa": "plugin-image-pixabay-search-button",
      onClick: t,
      onFocus: n,
      onBlur: r,
      className: "serlo-button-edit-primary mb-4 min-w-full rounded-lg px-1 py-2 font-semibold",
      children: [
        /* @__PURE__ */ c.jsx("span", { className: "mr-2 inline-block", children: /* @__PURE__ */ c.jsx(ot, { icon: IV }) }),
        i.searchOnline
      ]
    }
  );
};
function O5e(e) {
  const { query: t, onChange: n, onKeyDown: r, onClearButtonClick: i } = e, o = nt().plugins.image, a = v.useRef(null);
  return /* @__PURE__ */ c.jsxs("div", { className: "relative w-full", children: [
    /* @__PURE__ */ c.jsx(
      "input",
      {
        ref: a,
        type: "text",
        value: t,
        onChange: n,
        placeholder: o.search,
        onKeyDown: r,
        className: "w-full rounded-lg border-0 bg-yellow-100 py-2 pl-4 pr-10 text-gray-600"
      }
    ),
    t ? /* @__PURE__ */ c.jsx(
      "button",
      {
        className: "absolute right-0 items-center p-2 text-gray-400 hover:text-black",
        onClick: i,
        children: /* @__PURE__ */ c.jsx(ot, { icon: XV })
      }
    ) : null
  ] });
}
function z5e(e) {
  const { images: t, isLoadingImage: n, isSearching: r, hasSearched: i, onClick: o } = e, a = nt().plugins.image;
  return /* @__PURE__ */ c.jsxs(
    "div",
    {
      className: Le(
        "mt-4 grid grid-cols-2 gap-4",
        n && "max-h-100 border-1 border border-red-500",
        n ? "overflow-hidden" : "overflow-auto"
      ),
      children: [
        n || r ? /* @__PURE__ */ c.jsx("div", { className: "absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 backdrop-blur-sm", children: /* @__PURE__ */ c.jsxs("h1", { className: "text-center text-xl font-bold", children: [
          /* @__PURE__ */ c.jsx(Nz, { noText: !0 }),
          n ? a.loadingImage : a.searching
        ] }) }) : null,
        i && t.length === 0 && !r && /* @__PURE__ */ c.jsx("div", { className: "col-span-2 mt-10 w-full text-center text-lg", children: a.noImagesFound }),
        t.map((s) => /* @__PURE__ */ c.jsx(
          "img",
          {
            src: s.webformatURL.replace("_640", "_340"),
            alt: s.tags,
            className: "h-auto w-full cursor-pointer rounded-lg",
            loading: "lazy",
            onClick: () => o(s)
          },
          s.id
        ))
      ]
    }
  );
}
const F5e = {
  math: "Mathematik",
  nature: "Natur",
  plants: "Pflanzen",
  adventure: "Abenteuer",
  teamwork: "Teamwork",
  journey: "Reise",
  sports: "Sport",
  chemistry: "Chemie",
  lab: "Labor",
  tech: "Technologie",
  humans: "Menschen",
  pyramide: "Pyramide",
  cylinder: "Zylinder",
  art: "Kunst",
  music: "Musik",
  school: "Schule"
};
function L5e(e) {
  const { onClick: t } = e;
  return /* @__PURE__ */ c.jsx("div", { className: "mb-6 mt-10 flex flex-wrap justify-center overflow-auto", children: Object.values(F5e).map((n) => /* @__PURE__ */ c.jsx(
    "button",
    {
      onClick: () => t(n),
      className: "m-2 inline-block rounded-md bg-white px-2 py-1 text-sm text-black shadow-md",
      children: n
    },
    n
  )) });
}
function M5e({
  onSelectImage: e,
  onFocus: t,
  onBlur: n
}) {
  const [r, i] = v.useState(""), [o, a] = v.useState([]), [s, l] = v.useState(!1), [u, d] = v.useState(!1), [p, f] = v.useState(!1), [m, y] = v.useState(!1), g = v.useRef(null), x = nt(), E = x.lang, b = x.plugins.image, C = "44761287-06b5809c17d0a9132219f5173", T = async (X) => {
    if (X) {
      d(!0), f(!0);
      try {
        const le = await (await fetch(
          `https://pixabay.com/api/?key=${C}&q=${encodeURIComponent(X)}&image_type=photo&lang=de`
        )).json();
        a(le.hits);
      } catch (le) {
        console.error("Error fetching images from Pixabay:", le);
      } finally {
        d(!1);
      }
    }
  }, z = v.useCallback(
    jT((X) => {
      T(X);
    }, 300),
    []
  );
  v.useEffect(() => (r.length > 3 && z(r), () => {
    z.cancel();
  }), [r, z]);
  const I = (X) => {
    i(X.target.value);
  }, w = async (X) => {
    i(X), await T(X);
  }, M = async (X) => {
    X.key === "Enter" && await T(r);
  }, R = () => {
    i(""), a([]), f(!1), setTimeout(() => {
      var X;
      (X = g.current) == null || X.focus();
    });
  }, F = (X) => {
    l(!0), e(X.largeImageURL), y(!1);
  }, W = E === "de" && o.length === 0 && !u;
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      N5e,
      {
        onClick: () => y(!0),
        onFocus: t,
        onBlur: n
      }
    ),
    /* @__PURE__ */ c.jsxs(
      qo,
      {
        isOpen: m,
        setIsOpen: y,
        className: "top-1/2 flex max-h-[90vh] w-[900px] max-w-[90vw] flex-col px-10 pt-0",
        title: b.licenceFree,
        extraTitleClassName: "text-lg border-none ml-0",
        children: [
          /* @__PURE__ */ c.jsx(
            O5e,
            {
              query: r,
              onChange: I,
              onKeyDown: M,
              onClearButtonClick: R
            }
          ),
          W ? /* @__PURE__ */ c.jsx(L5e, { onClick: w }) : null,
          /* @__PURE__ */ c.jsx(
            z5e,
            {
              images: o,
              isLoadingImage: s,
              isSearching: u,
              hasSearched: p,
              onClick: F
            }
          ),
          /* @__PURE__ */ c.jsx("div", { className: "w-full justify-center pt-4 text-center text-sm", children: W ? b.pixabayText : b.pixabayLoadedText })
        ]
      }
    )
  ] });
}
const B5e = 2 * 1024 * 1024, I5e = ["gif", "jpg", "jpeg", "png", "svg", "webp"];
function R5e(e) {
  return e ? P5e(e.name) ? e.size > B5e ? (Zs("File is too big"), !1) : !0 : (Zs("Not an accepted file type"), !1) : (Zs("No file selected"), !1);
}
function P5e(e) {
  const t = e.toLowerCase().slice(e.lastIndexOf(".") + 1);
  return I5e.includes(t);
}
function Zs(e) {
  console.error(e), yi(e, "warning");
}
function NB(e) {
  const { editorVariant: t, userId: n } = v.useContext(zf), r = (i) => q5e({ file: i, editorVariant: t, userId: n });
  return _5e() ? r : e;
}
function _5e() {
  if (typeof window > "u") return !1;
  const e = window.location.hostname, t = e.startsWith("frontend-git") && e.endsWith("vercel.app") || e.endsWith("serlo-staging.dev") || e === "localhost" || !1 || e.endsWith("serlo.dev");
  return t && console.log("using new upload method and temporary bucket"), t;
}
async function q5e({
  file: e,
  editorVariant: t,
  userId: n
}) {
  if (!R5e(e)) return Promise.reject();
  const r = V5e(), i = new URL(`https://${$5e}/media/presigned-url`);
  i.searchParams.append("mimeType", e.type), i.searchParams.append("editorVariant", t), i.searchParams.append("parentHost", r), n && i.searchParams.append("userId", n);
  const o = await fetch(i).catch((u) => {
    console.error(u), Zs(t6);
  });
  if (o && !o.ok) {
    const u = new Error("Failed to get signed URL");
    return Zs(u.message), Promise.reject(u);
  }
  const a = await (o == null ? void 0 : o.json().catch(() => null));
  if (!a) {
    const u = new Error("Failed to get signed URL");
    return Zs(u.message), Promise.reject(u);
  }
  const { signedUrl: s, fileUrl: l } = a;
  if (!await H5e({ file: e, signedUrl: s })) {
    const u = new Error("Failed to upload file");
    return Zs(u.message), Promise.reject(u);
  }
  return Promise.resolve(l);
}
const $5e = "editor.serlo.dev", t6 = "Error while uploading";
async function H5e({
  file: e,
  signedUrl: t
}) {
  const n = await fetch(t, {
    method: "PUT",
    body: e,
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": e.type
    }
  }).catch((r) => {
    console.error(r), Zs(t6);
  });
  if (!n || n.status !== 200) {
    Zs(t6);
    return;
  }
  return !0;
}
function V5e() {
  var e;
  const t = ((e = window.location.ancestorOrigins) == null ? void 0 : e[0]) || window !== window.parent && document.referrer || window.location.href;
  return new URL(t).host;
}
function U5e({
  config: e,
  src: t,
  onFocus: n,
  onBlur: r
}) {
  const i = nt().plugins.image, o = _a(t.value) && t.value.failed, a = NB(e.upload), [s, l] = v.useState(!1);
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsxs(
      "label",
      {
        onFocus: (u) => {
          u.stopPropagation(), l(!0), n == null || n();
        },
        onBlur: (u) => {
          u.stopPropagation(), l(!1), r == null || r();
        },
        className: Le(
          "mb-4 flex w-full py-2",
          "items-center justify-center",
          "cursor-pointer rounded-lg",
          "font-semibold text-gray-800",
          "bg-editor-primary-200 hover:bg-editor-primary-300",
          s ? "outline outline-2 outline-brand" : ""
        ),
        children: [
          /* @__PURE__ */ c.jsx("span", { className: "almost-black mr-2 inline-block", children: /* @__PURE__ */ c.jsx(ot, { icon: cV }) }),
          /* @__PURE__ */ c.jsx(
            "input",
            {
              type: "file",
              multiple: !!e.onMultipleUpload,
              accept: "image/*",
              className: "sr-only",
              onChange: ({ target: u }) => {
                var d;
                if (u.files && u.files.length) {
                  const p = Array.from(u.files);
                  t.upload(p[0], a), (d = e.onMultipleUpload) == null || d.call(e, p.slice(1));
                }
              },
              "data-qa": "plugin-image-upload"
            }
          ),
          e.onMultipleUpload ? i.uploadMultiple : i.upload
        ]
      }
    ),
    o ? /* @__PURE__ */ c.jsxs(
      "button",
      {
        className: "serlo-button-edit-primary serlo-tooltip-trigger mr-2 scale-90",
        onClick: () => t.upload(t.value.failed, a),
        "data-qa": "plugin-image-retry",
        children: [
          /* @__PURE__ */ c.jsx(vn, { text: i.retry, className: "top-10" }),
          /* @__PURE__ */ c.jsx(ot, { icon: FV })
        ]
      }
    ) : null
  ] });
}
const W5e = /\.(gif|jpe?g|png|svg|webp)$/i, O8 = (e) => W5e.test(e);
function Z5e({
  config: e,
  state: t,
  urlInputRef: n,
  setIsAButtonFocused: r
}) {
  const i = nt(), { src: o, licence: a } = t, s = i.plugins.image, l = e.disableFileUpload, u = _a(o.value) ? o.value.failed ? s.placeholderFailed : s.placeholderUploading : s.placeholderEmpty, d = o.value, p = d.length > 5 && !O8(d), f = (m) => {
    var y;
    t.src.set(m), a.defined ? a.set("Pixabay") : a.create("Pixabay"), (y = e.onMultipleUpload) == null || y.call(e, []);
  };
  return /* @__PURE__ */ c.jsx(
    "div",
    {
      className: "mx-auto rounded-md bg-yellow-50 p-8 shadow-md",
      "data-qa": "plugin-image-empty-wrapper",
      children: /* @__PURE__ */ c.jsxs("div", { className: "mx-auto my-8 w-[60%]", children: [
        l ? null : /* @__PURE__ */ c.jsx(
          U5e,
          {
            config: e,
            src: o,
            onFocus: () => r(!0),
            onBlur: () => r(!1)
          }
        ),
        /* @__PURE__ */ c.jsx(
          M5e,
          {
            onFocus: () => r(!0),
            onBlur: () => r(!1),
            onSelectImage: f
          }
        ),
        /* @__PURE__ */ c.jsx("span", { className: "mb-1 flex w-full justify-center font-medium text-almost-black", children: s.imageUrl }),
        /* @__PURE__ */ c.jsxs("span", { className: "serlo-tooltip-trigger", children: [
          /* @__PURE__ */ c.jsx(
            "input",
            {
              ref: n,
              placeholder: u,
              value: _a(o.value) ? "" : o.value,
              disabled: _a(o.value) && !o.value.failed,
              onChange: (m) => {
                t.src.set(m.target.value), e.onMultipleUpload && setTimeout(() => {
                  var y;
                  (y = e.onMultipleUpload) == null || y.call(e, []);
                });
              },
              className: Le(
                "w-full rounded-lg border-0 bg-yellow-100 px-4 py-2 text-gray-600",
                p && "outline outline-1 outline-red-500"
              ),
              onFocus: () => r(!0),
              onBlur: () => r(!1),
              "data-qa": "plugin-image-src"
            }
          ),
          p && /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
            /* @__PURE__ */ c.jsx(
              "span",
              {
                className: "mt-1 inline-block pl-1 text-sm font-semibold text-red-500",
                "data-qa": "plugin-image-src-error",
                children: s.invalidImageUrl
              }
            ),
            /* @__PURE__ */ c.jsx(vn, { text: s.invalidImageUrlMessage })
          ] })
        ] })
      ] })
    }
  );
}
function OB({
  image: e,
  caption: t,
  placeholder: n,
  forceNewTab: r
}) {
  const i = Un().plugins.image.altFallback, { src: o, href: a, alt: s, maxWidth: l } = e, u = l ? `${l}px` : void 0;
  return /* @__PURE__ */ c.jsx(
    "figure",
    {
      className: "mb-block px-4 text-center",
      itemScope: !0,
      itemType: "http://schema.org/ImageObject",
      children: /* @__PURE__ */ c.jsxs("div", { style: { maxWidth: u }, className: "mx-auto", children: [
        d(
          n ?? /* @__PURE__ */ c.jsx(
            sl,
            {
              className: "serlo-img bg-white",
              src: o,
              alt: s || i,
              itemProp: "contentUrl",
              loading: "lazy"
            }
          )
        ),
        /* @__PURE__ */ c.jsx("figcaption", { className: "mt-3 italic", children: t })
      ] })
    }
  );
  function d(p) {
    return a ? /* @__PURE__ */ c.jsx(
      "a",
      {
        href: a,
        target: r ? "_blank" : void 0,
        rel: r ? "noreferrer" : void 0,
        "data-qa": "plugin-image-link",
        children: p
      }
    ) : p;
  }
}
function G5e({ state: e }) {
  const { alt: t, src: n, imageSource: r, licence: i } = e, o = nt().plugins.image, a = _a(n.value), s = _a(n.value) && n.value.failed, l = (u) => {
    i != null && i.defined ? i.set(u) : i.create(u);
  };
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      Rm,
      {
        label: o.imageUrl,
        autoFocus: !0,
        placeholder: a ? s ? o.placeholderFailed : o.placeholderUploading : o.placeholderEmpty,
        value: a ? "" : n.value.toString(),
        disabled: !0,
        onChange: (u) => {
          n.set(u.target.value);
        }
      }
    ),
    /* @__PURE__ */ c.jsx(
      Rm,
      {
        label: o.imageSource,
        autoFocus: !0,
        placeholder: o.placeholderSource,
        value: r.defined ? r.value.toString() : "",
        onChange: (u) => {
          r != null && r.defined ? r.set(u.target.value) : r.create(u.target.value);
        },
        tooltip: /* @__PURE__ */ c.jsxs("span", { className: "serlo-tooltip-trigger w-1/4", children: [
          /* @__PURE__ */ c.jsx(ot, { className: "ml-2", icon: dj }),
          /* @__PURE__ */ c.jsx(vn, { text: o.imageSourceHelpText })
        ] })
      }
    ),
    /* @__PURE__ */ c.jsx(
      Tz,
      {
        currentLicence: i.defined ? i == null ? void 0 : i.value : void 0,
        onLicenseChange: l,
        src: n.value.toString()
      }
    ),
    /* @__PURE__ */ c.jsxs("label", { className: "mx-auto mb-0 mt-5 flex flex-row justify-between", children: [
      /* @__PURE__ */ c.jsx("span", { className: "w-[20%]", children: o.alt }),
      /* @__PURE__ */ c.jsx(
        "textarea",
        {
          placeholder: o.altPlaceholder,
          value: t.defined ? t.value : "",
          onChange: ({ target: u }) => {
            const { value: d } = u;
            t.defined ? d ? t.set(d) : t.remove() : t.create(d);
          },
          className: Le(`
            serlo-input-font-reset
            mt-1.5 min-h-[100px] w-3/4 resize-none rounded-md
            border-2 border-editor-primary-100  bg-editor-primary-100 p-2.5 
            focus:border-editor-primary-300 focus:outline-none
          `)
        }
      )
    ] })
  ] });
}
function K5e({
  id: e,
  state: t,
  title: n,
  showSettingsButtons: r,
  onChangeImageButtonClick: i
}) {
  const [o, a] = v.useState(!1), s = nt(), l = s.plugins.image, u = r ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsxs(
      "button",
      {
        onClick: i,
        className: "mr-2 rounded-md border border-gray-500 px-1 text-sm transition-all hover:bg-editor-primary-200 focus-visible:bg-editor-primary-200",
        children: [
          l.change,
          " ",
          /* @__PURE__ */ c.jsx(ot, { className: "ml-1", icon: xT })
        ]
      }
    ),
    /* @__PURE__ */ c.jsxs(
      "button",
      {
        onClick: () => a(!0),
        className: "mr-2 rounded-md border border-gray-500 px-1 text-sm transition-all hover:bg-editor-primary-200 focus-visible:bg-editor-primary-200",
        "data-qa": "plugin-image-settings",
        children: [
          s.edtrIo.settings,
          " ",
          /* @__PURE__ */ c.jsx(ot, { className: "ml-1", icon: jf })
        ]
      }
    ),
    /* @__PURE__ */ c.jsx(
      qo,
      {
        isOpen: o,
        setIsOpen: a,
        className: "top-8 max-w-xl translate-y-0 sm:top-24",
        title: `${s.edtrIo.settings}: ${l.title}`,
        extraTitleClassName: "serlo-h3 mt-4",
        children: /* @__PURE__ */ c.jsx("div", { className: "mx-side mb-3", children: /* @__PURE__ */ c.jsx(G5e, { state: t }) })
      }
    )
  ] }) : void 0;
  return /* @__PURE__ */ c.jsx(
    Ci,
    {
      pluginType: Y.Image,
      pluginSettings: u,
      pluginControls: /* @__PURE__ */ c.jsx(Pi, { pluginId: e }),
      pluginTitle: n,
      noWhiteShadow: !0
    }
  );
}
const X5e = [
  tt.richTextBold,
  tt.links,
  tt.math,
  tt.code
];
function Q5e(e) {
  const { id: t, focused: n, state: r, config: i } = e, o = nt().plugins.image, a = NB(i.upload);
  rK(r.src, a);
  const [s, l] = v.useState(!r.src.value), u = r.src.value.toString(), d = O8(u), p = i.onMultipleUpload && !d ? o.galleryTitle : void 0, f = yn(
    (z) => r.caption.defined ? cs(z, r.caption.id) : !1
  ), [m, y] = v.useState(!1), g = n || f || m && !d || i.onMultipleUpload, x = _a(r.src.value) && !r.src.value.loaded, E = v.useRef(null);
  v.useEffect(() => {
    r.caption.defined || r.caption.create({ plugin: Y.Text });
  }, [r.caption]), v.useEffect(() => {
    l(!r.src.value);
  }, [n]), v.useEffect(() => {
    n && setTimeout(() => {
      var z;
      (z = E.current) == null || z.focus();
    });
  }, []);
  function b() {
    r.src.set(""), r.alt.defined && r.alt.remove(), r.caption.defined && r.caption.remove(), r.link.defined && r.link.remove();
  }
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    g ? /* @__PURE__ */ c.jsx(
      K5e,
      {
        id: t,
        state: r,
        title: p,
        showSettingsButtons: d,
        onChangeImageButtonClick: b
      }
    ) : null,
    /* @__PURE__ */ c.jsx(
      "div",
      {
        className: Le(
          "z-[2] pl-1 [&_img]:min-h-[4rem]",
          g && s ? "relative" : ""
        ),
        "data-qa": "plugin-image-editor",
        children: d ? /* @__PURE__ */ c.jsx(
          OB,
          {
            image: {
              src: u,
              href: r.link.defined ? r.link.href.value : void 0,
              alt: r.alt.defined ? r.alt.value : void 0,
              maxWidth: r.maxWidth.defined ? r.maxWidth.value : void 0
            },
            caption: T(),
            placeholder: C(),
            forceNewTab: !0
          }
        ) : /* @__PURE__ */ c.jsx(
          Z5e,
          {
            config: i,
            state: r,
            setIsAButtonFocused: y,
            urlInputRef: E
          }
        )
      }
    )
  ] });
  function C() {
    return !x && u.length ? null : /* @__PURE__ */ c.jsx(
      "div",
      {
        className: "relative w-full rounded-lg bg-editor-primary-50 px-side py-32 text-center",
        "data-qa": "plugin-image-placeholder",
        children: /* @__PURE__ */ c.jsx(
          ot,
          {
            icon: gT,
            className: "mb-4 text-7xl text-editor-primary-200"
          }
        )
      }
    );
  }
  function T() {
    return r.caption.defined ? r.caption.render({
      config: {
        placeholder: o.captionPlaceholder,
        formattingOptions: X5e,
        isInlineChildEditor: !0
      }
    }) : null;
  }
}
const Y5e = ln({
  src: nK(""),
  link: qr(ln({ href: rn("") })),
  alt: qr(rn("")),
  imageSource: qr(rn("")),
  licence: qr(rn("")),
  maxWidth: qr(oa(0)),
  caption: qr(
    Vn({
      plugin: Y.Text,
      config: {
        noLinebreaks: !0
      }
    })
  )
});
function J5e(e) {
  return {
    Component: Q5e,
    config: e,
    state: Y5e,
    async onText(t) {
      if (t.startsWith("![](https://cdn.mathpix.com")) {
        const n = t.substring(4, t.length - 1), r = "/api/frontend/mathpix-image-proxy?imageUrl=";
        try {
          const i = await (await fetch(r + encodeURIComponent(n))).blob(), { type: o } = i, a = si.getByType("image");
          if (a.onFiles)
            return a.onFiles([
              new File([i], `image.${i.type.split("/")[1]}`, {
                type: o
              })
            ]);
        } catch (i) {
          console.error(i);
        }
      }
      if (O8(t.toLowerCase()))
        return {
          state: {
            src: t,
            link: void 0,
            alt: void 0,
            maxWidth: void 0,
            caption: { plugin: Y.Text }
          }
        };
    },
    onFiles(t) {
      if (t.length === 1) {
        const n = t[0], r = e.validate(n);
        if (r.valid)
          return {
            state: {
              src: { pending: t[0] },
              link: void 0,
              alt: void 0,
              licence: void 0,
              imageSource: void 0,
              maxWidth: void 0,
              caption: { plugin: Y.Text }
            }
          };
        for (const i of r.errors) yi(i.message);
      }
    },
    isEmpty: (t) => (!t.src.value || _a(t.src.value)) && (!t.link.defined || !t.link.href.value) && (!t.alt.defined || !t.alt.value)
  };
}
const e6e = 2 * 1024 * 1024, t6e = ["gif", "jpg", "jpeg", "png", "svg", "webp"], n6e = {
  "image/gif": "IMAGE_GIF",
  "image/jpeg": "IMAGE_JPEG",
  "image/png": "IMAGE_PNG",
  "image/svg+xml": "IMAGE_SVG_XML",
  "image/webp": "IMAGE_WEBP"
  /* ImageWebp */
}, zB = (e) => {
  let t = [];
  if (!e)
    t = [
      ...t,
      1
      /* NO_FILE_SELECTED */
    ];
  else if (!a6e(e.name))
    t = [
      ...t,
      2
      /* BAD_EXTENSION */
    ];
  else if (e.size > e6e)
    t = [
      ...t,
      3
      /* FILE_TOO_BIG */
    ];
  else
    return { valid: !0 };
  return { valid: !1, errors: FB(t) };
}, r6e = (e) => J5e({
  upload: i6e(e),
  validate: zB,
  disableFileUpload: !e
});
function i6e(e) {
  const t = o6e(e);
  return async function(n) {
    const r = zB(n);
    if (!r.valid)
      return Xk(r.errors), Promise.reject(r.errors);
    try {
      return (await t(n)).dataUrl;
    } catch (i) {
      console.error("Upload failed:", i);
      const o = i instanceof Error && Number(i.message) || 4, a = FB([o]);
      return Xk(a), Promise.reject(a);
    }
  };
}
function o6e(e) {
  return async function(t) {
    var n, r, i, o;
    if (!e)
      throw new Error("6");
    const a = await fetch("https://api.serlo-staging.dev/graphql", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-SERLO-EDITOR-TESTING": e
      },
      method: "POST",
      body: JSON.stringify({
        query: u6e,
        variables: {
          mediaType: n6e[t.type]
        }
      })
    });
    if (!a.ok)
      throw new Error("8");
    const { data: s, errors: l } = await a.json();
    if (l != null && l.length)
      throw console.error("GraphQL errors:", l), ((r = (n = l[0]) == null ? void 0 : n.extensions) == null ? void 0 : r.code) === "UNAUTHENTICATED" ? new Error("5") : new Error("4");
    if (!s || !((o = (i = s == null ? void 0 : s.media) == null ? void 0 : i.newUpload) != null && o.uploadUrl) || !s.media.newUpload.urlAfterUpload)
      throw console.error("Server responded with following invalid data: ", s), new Error("7");
    if (!(await fetch(s.media.newUpload.uploadUrl, {
      method: "PUT",
      headers: { "Content-Type": t.type },
      body: t
    })).ok)
      throw new Error("4");
    return {
      file: t,
      dataUrl: s.media.newUpload.urlAfterUpload
    };
  };
}
function a6e(e) {
  const t = e.toLowerCase().slice(e.lastIndexOf(".") + 1);
  return t6e.includes(t);
}
function FB(e) {
  return e.map((t) => ({
    errorCode: t,
    message: s6e(t)
  }));
}
function Xk(e) {
  yi(e.map((t) => t.message).join(`
`), "warning");
}
function s6e(e) {
  switch (e) {
    case 0:
      return "You can only upload one file";
    case 1:
      return "No file selected";
    case 2:
      return "Not an accepted file type";
    case 3:
      return "Filesize is too big";
    case 4:
      return "Error while uploading";
    case 5:
      return "You are not authorized to upload images. Ensure the testingSecret is correct!";
    case 6:
      return "Missing authentication credentials (testingSecret)!";
    case 7:
      return "Server returned invalid data";
    case 8:
      return "Network error while uploading";
  }
}
function l6e(e, ...t) {
  return e.reduce((n, r, i) => n + t[i - 1] + r);
}
const u6e = l6e`
  query mediaUpload($mediaType: MediaType!) {
    media {
      newUpload(mediaType: $mediaType) {
        uploadUrl
        urlAfterUpload
      }
    }
  }
`;
function c6e(e, t) {
  return [
    {
      type: Y.Text,
      plugin: x5e({})
    },
    {
      type: Y.Image,
      plugin: r6e(t)
    },
    {
      type: Y.ImageGallery,
      plugin: zfe()
    },
    {
      type: Y.Multimedia,
      plugin: Kfe(e)
    },
    {
      type: Y.Video,
      plugin: j5e
    },
    {
      type: Y.Spoiler,
      plugin: Lhe(e)
    },
    {
      type: Y.Equations,
      plugin: eue
    },
    {
      type: Y.Box,
      plugin: Zte(e)
    },
    {
      type: Y.SerloTable,
      plugin: ghe()
    },
    {
      type: Y.Geogebra,
      plugin: yue
    },
    {
      type: Y.Highlight,
      plugin: bfe()
    },
    {
      type: Y.EdusharingAsset,
      plugin: Oae()
    },
    {
      type: Y.SerloInjection,
      plugin: she(),
      renderer: FL
    },
    // Exercises etc.
    // ===================================================
    {
      type: Y.Exercise,
      plugin: fue
    },
    {
      type: Y.Solution,
      plugin: jhe
    },
    {
      type: Y.InputExercise,
      plugin: Pfe()
    },
    {
      type: Y.ScMcExercise,
      plugin: nhe()
    },
    {
      type: Y.BlanksExercise,
      plugin: dJ()
    },
    {
      type: Y.TextAreaExercise,
      plugin: C5e
    },
    {
      type: Y.DropzoneImage,
      plugin: Yoe()
    },
    // Special plugins, never visible in suggestions
    // ===================================================
    { type: Y.Rows, plugin: Bte() },
    { type: Y.Unsupported, plugin: S5e },
    {
      type: Us.GenericContent,
      plugin: xhe
    }
  ].filter(({ type: n }) => e.includes(n));
}
function d6e({ state: e }) {
  return /* @__PURE__ */ c.jsx("a", { id: e });
}
function p6e({
  introduction: e,
  content: t,
  exercises: n,
  exercisesFolder: r,
  relatedContent: i,
  relatedContentExtra: o,
  sources: a,
  title: s
}) {
  const l = Un().plugins.article;
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx("div", { className: "[&>div]:rounded-lg [&>div]:border-3 [&>div]:border-brand-50 [&>div]:py-5 ", children: e }),
    t,
    n || r ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsxs("h2", { className: "serlo-h2 mb-16", children: [
        l.exercisesTitle,
        s ? `: ${s}` : null
      ] }),
      n,
      r ? /* @__PURE__ */ c.jsxs("p", { className: "serlo-p mt-8", children: [
        l.moreExercises,
        ":",
        /* @__PURE__ */ c.jsx("br", {}),
        r
      ] }) : null
    ] }) : null,
    u(),
    a ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx("h2", { className: "serlo-h2", children: l.sourcesTitle }),
      /* @__PURE__ */ c.jsx("ul", { className: "serlo-ul mb-4 mt-2 text-lg" }),
      a
    ] }) : null
  ] });
  function u() {
    const { articles: p, courses: f, videos: m } = i;
    return !p && !f && !m && !o ? null : /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx("h2", { className: "serlo-h2", children: l.relatedContentTitle }),
      /* @__PURE__ */ c.jsx("p", { className: "serlo-p", children: l.relatedContentText }),
      d("articles"),
      d("courses"),
      d("videos"),
      o
    ] });
  }
  function d(p) {
    return i[p] ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx("h3", { className: "serlo-h3 mb-0", children: l.subsectionTypes[p] }),
      /* @__PURE__ */ c.jsx("ul", { className: "serlo-ul mb-4 mt-2 text-lg", children: i[p] })
    ] }) : null;
  }
}
function f6e({
  state: e,
  serloContext: t
}) {
  const {
    introduction: n,
    content: r,
    exercises: i,
    exerciseFolder: o,
    relatedContent: a,
    sources: s
  } = e, l = t == null ? void 0 : t.articleTitle, u = i == null ? void 0 : i.filter(({ state: E }) => !!E), d = o.id && o.title, p = u && u.length, f = io(
    n.state.explanation
  ) ? null : /* @__PURE__ */ c.jsx(Nn, { document: { ...n, plugin: "multimedia" } }), m = hu.getLinkRenderer();
  return /* @__PURE__ */ c.jsx(
    p6e,
    {
      introduction: f,
      content: /* @__PURE__ */ c.jsx(Nn, { document: r }),
      exercises: p ? /* @__PURE__ */ c.jsx(Nn, { document: u }) : null,
      exercisesFolder: d ? /* @__PURE__ */ c.jsx("a", { className: "serlo-link font-bold", href: `/${o.id}`, children: o.title }) : null,
      relatedContent: {
        articles: y("articles"),
        courses: y("courses"),
        videos: y("videos")
      },
      sources: x(),
      title: l
    }
  );
  function y(E) {
    if (!a) return null;
    const b = a[E];
    return b.length === 0 || g(b) ? null : /* @__PURE__ */ c.jsx(c.Fragment, { children: b.map(({ id: C, title: T }) => /* @__PURE__ */ c.jsx("li", { children: /* @__PURE__ */ c.jsx(m, { href: `/${C}`, children: T }) }, C)) });
  }
  function g(E) {
    return E ? !E.filter((b) => b.id !== "").length : !0;
  }
  function x() {
    return s.length === 0 ? null : /* @__PURE__ */ c.jsx(c.Fragment, { children: /* @__PURE__ */ c.jsx("ul", { className: "serlo-ul mb-4 mt-2 text-lg", children: s.map((E) => /* @__PURE__ */ c.jsx("li", { className: "!mb-0", children: E.href ? /* @__PURE__ */ c.jsx(m, { href: E.href, children: E.title }) : E.title }, E.href)) }) });
  }
}
function z8(e) {
  return MN(e) ? e.state.length === 0 ? !0 : e.state.every(io) : !1;
}
function h6e({ state: e }) {
  var t;
  const { type: n, title: r, anchorId: i, content: o } = e;
  if (!o || !n || z8(o)) return null;
  const a = (t = r.state) == null ? void 0 : t[0].children, s = a ? /* @__PURE__ */ c.jsx("b", { children: /* @__PURE__ */ c.jsx(Ki, { element: a }) }) : void 0;
  return /* @__PURE__ */ c.jsx(
    iy,
    {
      boxType: n,
      title: s,
      anchorId: i,
      children: /* @__PURE__ */ c.jsx(Nn, { document: o })
    }
  );
}
function m6e(e) {
  var t, n;
  const r = (t = e.state.edusharingAsset) == null ? void 0 : t.nodeId, i = (n = e.state.edusharingAsset) == null ? void 0 : n.repositoryId, { contentWidth: o } = e.state, { ltik: a } = v.useContext(zf);
  return a ? /* @__PURE__ */ c.jsx(
    Fz,
    {
      nodeId: r,
      repositoryId: i,
      contentWidth: o,
      ltik: a
    }
  ) : null;
}
function g6e({ state: e }) {
  const { content: t, interactive: n, solution: r, hideInteractiveInitially: i } = e, [o, a] = v.useState(
    i
  ), s = Un().plugins.exercise;
  if (!t) return null;
  const l = MN(t) && t.state.length === 1 && io(t.state[0]);
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    l ? /* @__PURE__ */ c.jsx("div", { className: "mt-6" }) : /* @__PURE__ */ c.jsx(Nn, { document: t }),
    o ? /* @__PURE__ */ c.jsxs(
      "button",
      {
        className: "serlo-button-learner-transparent ml-side text-base hover:bg-brand-100 hover:text-brand-700",
        onClick: () => a(!1),
        children: [
          /* @__PURE__ */ c.jsx(ot, { icon: lj }),
          " ",
          s.showHiddenInteractive
        ]
      }
    ) : /* @__PURE__ */ c.jsx(Nn, { document: n }),
    /* @__PURE__ */ c.jsx(Nn, { document: r })
  ] });
}
function v6e({ state: e }) {
  const { cleanId: t } = RF(e);
  return /* @__PURE__ */ c.jsx(IF, { geogebraId: t });
}
function y6e({ state: e }) {
  return e.code.trim().length ? /* @__PURE__ */ c.jsx(DL, { ...e }) : null;
}
function LB(e) {
  return Object.hasOwn(e, "type") && Object.hasOwn(e, "children") ? e.children.map(LB).join(" ") : e.text ? e.text.trim() : "";
}
function x6e(e) {
  return e && e2(e) && e.state.length > 0 ? e.state.map(LB).join(" ").trim() : "";
}
function MB(e, t, n) {
  const r = t && !io(t);
  return n || (r ? x6e(t) : e);
}
function b6e({
  state: e,
  pathNameBase: t
}) {
  const { caption: n, src: r, link: i, alt: o, maxWidth: a } = e, s = Un().plugins.image.altFallback, l = MB(s, n, o), u = String(r);
  if (!u) return null;
  const d = n && !io(n);
  return /* @__PURE__ */ c.jsx(
    OB,
    {
      image: {
        src: p(),
        href: i == null ? void 0 : i.href,
        alt: l,
        maxWidth: a
      },
      caption: d ? /* @__PURE__ */ c.jsx(Nn, { document: n }) : null
    }
  );
  function p() {
    if (!u.startsWith("https://assets.serlo.org/") || !u.includes("/image."))
      return u;
    const f = o && o.length > 3 ? o : t, m = (f == null ? void 0 : f.replace(/[^\w+]/g, "")) ?? "";
    if ((m == null ? void 0 : m.length) < 4 && m.match(/^[0-9]+$/)) return u;
    const y = u.lastIndexOf(".");
    return `${u.substring(0, y)}/${m}${u.substring(
      y
    )}`.replace("/image", "");
  }
}
function w6e({ images: e, onImageClick: t }) {
  return /* @__PURE__ */ c.jsx("div", { className: "flex snap-x snap-mandatory items-center gap-x-4 overflow-x-auto px-[10%]", children: e.map(({ src: n, alt: r, caption: i }, o) => /* @__PURE__ */ c.jsxs(
    "button",
    {
      className: "w-full flex-shrink-0 snap-center snap-always text-center",
      onClick: () => t(o),
      children: [
        /* @__PURE__ */ c.jsx(sl, { src: n, alt: r }),
        /* @__PURE__ */ c.jsxs("div", { className: "mt-3", children: [
          i ? /* @__PURE__ */ c.jsx("div", { className: "italic text-gray-700 [&_a]:text-brand-400", children: i }) : null,
          /* @__PURE__ */ c.jsx("div", { className: "text-sm text-gray-400", children: `${o + 1}/${e.length}` })
        ] })
      ]
    },
    o
  )) });
}
function Qk({ caption: e, src: t, alt: n }) {
  return e ? /* @__PURE__ */ c.jsxs("div", { className: "text-center", children: [
    /* @__PURE__ */ c.jsx(sl, { src: t, alt: n, className: "max-h-[60vh] bg-white" }),
    /* @__PURE__ */ c.jsx("div", { className: "mt-3 italic text-gray-100 [&_a]:text-brand-400", children: e })
  ] }) : /* @__PURE__ */ c.jsx(sl, { src: t, className: "max-h-[60vh] bg-white" });
}
function C6e({
  enabled: e,
  onPrevious: t,
  onNext: n,
  children: r
}) {
  const i = v.useRef(null), o = v.useRef(null);
  return v.useEffect(() => {
    function a(s) {
      var l, u;
      s.key === "ArrowLeft" && (t(), (l = i.current) == null || l.focus()), s.key === "ArrowRight" && (n(), (u = o.current) == null || u.focus());
    }
    return e ? document.addEventListener("keydown", a) : document.removeEventListener("keydown", a), () => document.removeEventListener("keydown", a);
  }, [e, n, t]), /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      "button",
      {
        ref: i,
        className: "flex p-1 text-gray-400 hover:text-gray-200 focus-visible:outline focus-visible:outline-gray-400",
        onClick: t,
        children: /* @__PURE__ */ c.jsx(ot, { className: "text-4xl", icon: vT })
      }
    ),
    /* @__PURE__ */ c.jsx("div", { className: "flex justify-center", children: r }),
    /* @__PURE__ */ c.jsx(
      "button",
      {
        ref: o,
        className: "flex p-1 text-gray-400 hover:text-gray-200 focus-visible:outline focus-visible:outline-gray-400",
        onClick: n,
        children: /* @__PURE__ */ c.jsx(ot, { className: "text-4xl", icon: yT })
      }
    )
  ] });
}
function k6e({
  image: e,
  isSelected: t,
  onClick: n
}) {
  const { src: r, alt: i } = e;
  return /* @__PURE__ */ c.jsxs("button", { className: "group relative", onClick: n, children: [
    /* @__PURE__ */ c.jsx(sl, { src: r, alt: i, className: "max-h-[120px] bg-white" }),
    /* @__PURE__ */ c.jsx(
      "div",
      {
        className: Le(
          "absolute inset-0 bg-black bg-opacity-70 group-hover:block",
          t ? "block" : "hidden"
        )
      }
    )
  ] });
}
const E6e = v.lazy(
  () => Promise.resolve().then(() => Gj).then((e) => ({
    default: e.EditorModal
  }))
);
function S6e({
  images: e,
  isOpen: t,
  currentImageIndex: n,
  setIsOpen: r,
  setCurrentImageIndex: i
}) {
  const o = Un().plugins.imageGallery.lightboxSrTitle;
  function a(u) {
    u || (i(null), r(!1));
  }
  const s = v.useCallback(() => {
    i(
      n === 0 ? e.length - 1 : n - 1
    );
  }, [n, e.length, i]), l = v.useCallback(() => {
    i(
      n === e.length - 1 ? 0 : n + 1
    );
  }, [n, e.length, i]);
  return /* @__PURE__ */ c.jsx(v.Suspense, { fallback: /* @__PURE__ */ c.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ c.jsx(
    E6e,
    {
      className: "top-1/2 w-auto max-w-[95%] rounded-lg bg-gray-700 px-4 pb-14 pt-16",
      extraCloseButtonClassName: "text-gray-400 hover:bg-gray-600 hover:text-gray-200",
      extraOverlayClassName: "bg-gray-700 bg-opacity-80",
      extraTitleClassName: "sr-only",
      title: o,
      isOpen: t,
      setIsOpen: a,
      children: e.length < 2 ? /* @__PURE__ */ c.jsx(Qk, { ...e[n] }) : /* @__PURE__ */ c.jsxs(
        "div",
        {
          className: Le(
            "grid grid-cols-[32px_1fr_32px] items-center gap-y-3",
            "sm:grid-cols-[32px_600px_32px] sm:gap-x-8",
            "md:grid-cols-[32px_764px_32px] md:gap-x-14"
          ),
          children: [
            /* @__PURE__ */ c.jsx(
              C6e,
              {
                enabled: t && e.length > 1,
                onPrevious: s,
                onNext: l,
                children: /* @__PURE__ */ c.jsx(Qk, { ...e[n] })
              }
            ),
            /* @__PURE__ */ c.jsx("div", { className: "col-start-2 flex justify-center gap-2", children: e.map((u, d) => /* @__PURE__ */ c.jsx(
              k6e,
              {
                image: u,
                isSelected: d === n,
                onClick: () => i(d)
              },
              d
            )) })
          ]
        }
      )
    }
  ) });
}
function D6e({
  images: e,
  currentImageIndex: t,
  onScroll: n
}) {
  const r = v.useRef(null);
  return v.useEffect(() => {
    var i;
    const o = r.current, a = (i = o == null ? void 0 : o.firstElementChild) == null ? void 0 : i.clientWidth;
    (o == null ? void 0 : o.scrollLeft) !== void 0 && a !== void 0 && (o.scrollLeft = a * t);
  }, [t]), /* @__PURE__ */ c.jsx(
    "div",
    {
      ref: r,
      className: "flex snap-x snap-mandatory items-center overflow-x-auto",
      onScroll: n,
      children: e.map(({ src: i, alt: o, caption: a }, s) => /* @__PURE__ */ c.jsxs(
        "div",
        {
          className: "w-full flex-shrink-0 snap-center snap-always text-center",
          children: [
            /* @__PURE__ */ c.jsx(sl, { src: i, alt: o }),
            /* @__PURE__ */ c.jsxs("div", { className: "mt-3", children: [
              a ? /* @__PURE__ */ c.jsx("div", { className: "italic text-gray-100 [&_a]:text-brand-400", children: a }) : null,
              /* @__PURE__ */ c.jsx("div", { className: "text-sm text-gray-400", children: `${s + 1}/${e.length}` })
            ] })
          ]
        },
        s
      ))
    }
  );
}
const A6e = v.lazy(
  () => Promise.resolve().then(() => Gj).then((e) => ({
    default: e.EditorModal
  }))
);
function T6e({
  images: e,
  isOpen: t,
  currentImageIndex: n,
  setIsOpen: r,
  setCurrentImageIndex: i
}) {
  const o = Un().plugins.imageGallery.lightboxSrTitle;
  function a(d) {
    d || (i(null), r(!1));
  }
  function s(d) {
    var p;
    if (((p = d.currentTarget.firstElementChild) == null ? void 0 : p.clientWidth) === void 0) return;
    const f = d.currentTarget.scrollLeft / d.currentTarget.firstElementChild.clientWidth;
    f % 1 === 0 && i(f);
  }
  function l() {
    n !== 0 && i(n - 1);
  }
  function u() {
    n !== e.length - 1 && i(n + 1);
  }
  return /* @__PURE__ */ c.jsx(v.Suspense, { fallback: /* @__PURE__ */ c.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ c.jsx(
    A6e,
    {
      className: "top-1/2 w-auto w-full max-w-full rounded-none bg-gray-700 px-2 pb-14 pt-16",
      extraCloseButtonClassName: "text-gray-400 hover:bg-gray-600 hover:text-gray-200",
      extraOverlayClassName: "bg-gray-700 bg-opacity-80",
      extraTitleClassName: "sr-only",
      title: o,
      isOpen: t,
      setIsOpen: a,
      children: /* @__PURE__ */ c.jsxs("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ c.jsx(
          "button",
          {
            className: Le(
              "flex p-1 text-gray-400 hover:text-gray-200",
              n === 0 && "invisible"
            ),
            onClick: l,
            children: /* @__PURE__ */ c.jsx(ot, { className: "text-2xl", icon: vT })
          }
        ),
        /* @__PURE__ */ c.jsx(
          D6e,
          {
            images: e,
            currentImageIndex: n,
            onScroll: s
          }
        ),
        /* @__PURE__ */ c.jsx(
          "button",
          {
            className: Le(
              "flex p-1 text-gray-400 hover:text-gray-200",
              n === e.length - 1 && "invisible"
            ),
            onClick: u,
            children: /* @__PURE__ */ c.jsx(ot, { className: "text-2xl", icon: yT })
          }
        )
      ] })
    }
  ) });
}
function j6e({
  state: e
}) {
  const [t, n] = v.useState(!1), [r, i] = v.useState(!1), [o, a] = v.useState(
    null
  ), s = Un().plugins.image.altFallback, l = e.images.map((p) => p.imagePlugin).filter(Bf).map(
    ({ state: { src: p, caption: f, alt: m } }, y) => {
      const g = f && !io(f);
      return {
        // eslint-disable-next-line @typescript-eslint/no-base-to-string
        src: String(p),
        alt: MB(s, f, m),
        dimensions: e.images[y].dimensions,
        caption: g ? /* @__PURE__ */ c.jsx(Nn, { document: f }) : null
      };
    }
  );
  function u(p) {
    a(p), n(!0);
  }
  function d(p) {
    a(p), i(!0);
  }
  return l.some((p) => p.dimensions.width === 0) ? null : /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsxs("div", { className: "hidden p-4 sm:block", children: [
      /* @__PURE__ */ c.jsx(AL, { images: l, onImageClick: u }),
      l.length && o !== null ? /* @__PURE__ */ c.jsx(
        S6e,
        {
          images: l,
          isOpen: t,
          currentImageIndex: o,
          setIsOpen: n,
          setCurrentImageIndex: a
        }
      ) : null
    ] }),
    /* @__PURE__ */ c.jsxs("div", { className: "sm:hidden", children: [
      /* @__PURE__ */ c.jsx(
        w6e,
        {
          images: l,
          onImageClick: d
        }
      ),
      l.length && o !== null ? /* @__PURE__ */ c.jsx(
        T6e,
        {
          images: l,
          isOpen: r,
          currentImageIndex: o,
          setIsOpen: i,
          setCurrentImageIndex: a
        }
      ) : null
    ] })
  ] });
}
function N6e({
  state: e,
  setOpen: t
}) {
  const { explanation: n, multimedia: r, width: i } = e;
  if (o() && z8(n)) return null;
  return /* @__PURE__ */ c.jsx(
    jL,
    {
      media: /* @__PURE__ */ c.jsx(Nn, { document: r }),
      explanation: /* @__PURE__ */ c.jsx(Nn, { document: n }),
      mediaWidth: i ?? 50,
      extraMediaClasses: t ? "mobile:[&_img]:cursor-zoom-in" : "",
      onClick: ({ target: a }) => {
        !t || a.tagName !== "IMG" || t(!0);
      }
    }
  );
  function o() {
    var a;
    const s = r;
    return !String(
      s.plugin === "geogebra" ? s.state : (
        // @ts-expect-error not sure…
        (a = s.state) == null ? void 0 : a.src
      )
    );
  }
}
function O6e({ state: e }) {
  return e ? /* @__PURE__ */ c.jsx(c.Fragment, { children: e.map((t, n) => {
    var r;
    const i = t.id ?? `${t.plugin}${n}`;
    return t.plugin === Y.Anchor ? /* @__PURE__ */ c.jsx(Nn, { document: t }, i) : /* @__PURE__ */ c.jsx("div", { id: (r = t.id) == null ? void 0 : r.split("-")[0], className: "my-block", children: /* @__PURE__ */ c.jsx(Nn, { document: t }) }, i);
  }) }) : null;
}
function z6e({ state: e }) {
  const { rows: t, tableType: n } = e;
  if (!t || t.length === 0) return null;
  const r = t.map((i, o) => {
    var a;
    return {
      cells: ((a = i.columns) == null ? void 0 : a.map(({ content: s }, l) => s ? /* @__PURE__ */ c.jsx("div", { children: /* @__PURE__ */ c.jsx(Nn, { document: s }) }, `${o}:${l}`) : null)) ?? /* @__PURE__ */ c.jsx(c.Fragment, {})
    };
  });
  return /* @__PURE__ */ c.jsx("div", { className: "overflow-x-auto", children: /* @__PURE__ */ c.jsx(LL, { rows: r, tableType: n }) });
}
function F6e({
  state: e
}) {
  return /* @__PURE__ */ c.jsx(
    BL,
    {
      content: /* @__PURE__ */ c.jsx(Nn, { document: e.content })
    }
  );
}
function L6e({
  id: e,
  state: t,
  solutionVisibleOnInit: n,
  beforeSlot: r,
  afterSlot: i
}) {
  var o;
  const { prerequisite: a, strategy: s, steps: l } = t, u = io(s) ? null : /* @__PURE__ */ c.jsx(Nn, { document: s });
  if (z8(l) && !u) return null;
  const d = a && a.id && ((o = a.title) == null ? void 0 : o.length), p = hu.getLinkRenderer(), f = d ? /* @__PURE__ */ c.jsx(p, { href: a.alias ?? `/${a.id}`, children: a.title }) : null;
  function m() {
    var y;
    (y = ii.trigger) == null || y.call(ii, {
      pluginId: e,
      verb: "opened",
      contentType: "solution",
      value: "open"
    });
  }
  return /* @__PURE__ */ c.jsx(
    IL,
    {
      prerequisite: f,
      strategy: u,
      elementBeforePrerequisite: r,
      steps: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
        /* @__PURE__ */ c.jsx(Nn, { document: l }),
        i
      ] }),
      solutionVisibleOnInit: n,
      onSolutionOpen: m
    }
  );
}
function M6e({
  id: e,
  state: t,
  openOverwrite: n
}) {
  const [r, i] = v.useState(!1), { title: o, richTitle: a, content: s } = t, l = a ? /* @__PURE__ */ c.jsx(Nn, { document: a }) : /* @__PURE__ */ c.jsx(c.Fragment, { children: o });
  function u() {
    var d;
    n || r || ((d = ii.trigger) == null || d.call(ii, {
      pluginId: e,
      verb: "opened",
      contentType: "spoiler",
      value: "open"
    }), i(!0));
  }
  return /* @__PURE__ */ c.jsx(
    $L,
    {
      title: l,
      openOverwrite: n,
      onOpen: u,
      children: /* @__PURE__ */ c.jsx(Nn, { document: s })
    }
  );
}
function B6e({ state: e }) {
  return e ? /* @__PURE__ */ c.jsx(c.Fragment, { children: Object.values(e).map((t, n) => /* @__PURE__ */ c.jsx(v.Fragment, { children: /* @__PURE__ */ c.jsx(Ki, { element: t }) }, n)) }) : null;
}
function I6e(e) {
  return /* @__PURE__ */ c.jsx(TB, {});
}
function R6e({ state: { src: e } }) {
  const { lang: t } = Un(), [n, r] = N8(e, t);
  return !r || !n ? null : /* @__PURE__ */ c.jsx(jB, { src: n, type: r });
}
function BB() {
  return {
    pluginRenderers: [
      // plugins
      { type: Y.Article, renderer: f6e },
      { type: Y.Rows, renderer: O6e },
      { type: Y.Text, renderer: B6e },
      { type: Y.Image, renderer: b6e },
      {
        type: Y.ImageGallery,
        renderer: j6e
      },
      {
        type: Y.Multimedia,
        renderer: N6e
      },
      {
        type: Y.Spoiler,
        renderer: M6e
      },
      {
        type: Y.DropzoneImage,
        renderer: IO
      },
      { type: Y.Box, renderer: h6e },
      { type: Y.SerloTable, renderer: z6e },
      { type: Y.Equations, renderer: FF },
      {
        type: Y.Geogebra,
        renderer: v6e
      },
      {
        type: Y.Video,
        renderer: R6e
      },
      {
        type: Y.Anchor,
        renderer: d6e
      },
      // exercises
      {
        type: Y.Exercise,
        renderer: g6e
      },
      {
        type: Y.Solution,
        renderer: L6e
      },
      {
        type: Y.Highlight,
        renderer: y6e
      },
      {
        type: Y.InputExercise,
        renderer: TL
      },
      {
        type: Y.ScMcExercise,
        renderer: OL
      },
      {
        type: Y.BlanksExercise,
        renderer: zN
      },
      {
        type: Y.TextAreaExercise,
        renderer: I6e
      },
      {
        type: Y.EdusharingAsset,
        renderer: m6e
      },
      {
        type: Y.SerloInjection,
        renderer: FL
      },
      {
        type: Y.Unsupported,
        renderer: (e) => (console.warn("unsupported renderer: ", e), null)
      },
      {
        type: Us.GenericContent,
        renderer: F6e
      }
    ],
    mathRenderer: (e) => /* @__PURE__ */ c.jsx(Km, { ...e }),
    linkRenderer: ({ href: e, children: t }) => /* @__PURE__ */ c.jsx(
      "a",
      {
        className: "serlo-link cursor-pointer",
        href: AB(e),
        target: "_blank",
        rel: "noopener noreferrer",
        children: t
      }
    )
  };
}
function tg() {
  return (/* @__PURE__ */ new Date()).toISOString();
}
const F8 = [
  Y.Text,
  Y.Image,
  Y.Video,
  Y.Multimedia,
  Y.Spoiler,
  Y.Box,
  Y.SerloTable,
  Y.Equations,
  Y.Geogebra,
  Y.Highlight,
  Y.Exercise,
  Y.InputExercise,
  Y.ScMcExercise,
  Y.BlanksExercise,
  Y.DropzoneImage,
  Y.Solution,
  Y.Rows,
  Y.TextAreaExercise,
  Y.ImageGallery,
  Y.Unsupported,
  Us.GenericContent
], IB = {
  plugins: F8,
  onChange: void 0,
  language: "de",
  isProductionEnvironment: !1
}, RB = {
  lang: "de",
  confirmRouteChange: "Willst du wirklich die Seite verlassen ohne zu speichern?",
  noChangesWarning: "Bisher hast du nichts geändert",
  savedContentMightDisappearWarning: "⚠️ Dies ist eine Testumgebung. Bitte erstelle hier noch keine Inhalte, die du langfristig behalten willst. Fragen? vicky@serlo.org",
  addPluginsModal: {
    searchInputPlaceholder: "Suche...",
    basicPluginsTitle: "Inhalte",
    interactivePluginsTitle: "Aufgaben",
    noPluginsFoundTitle: "Leider gibt es keine Elemente, die zu deiner Suche passen.",
    noPluginsFoundDescription: "Versuche es mit anderen Suchbegriffen oder stöbere durch alle verfügbaren Elemente."
  },
  pluginMenu: {
    singleChoiceExercise: {
      title: "Single-Choice-Aufgabe",
      description: "Eine Aufgabe mit einer Auswahl an Antwortoptionen (Es ist immer nur eine Antwort richtig)."
    },
    multipleChoiceExercise: {
      title: "Multiple-Choice-Aufgabe",
      description: "Eine Aufgabe mit einer Auswahl an Antwortoptionen (eine oder mehrere richtige Antworten)."
    },
    blanksExercise: {
      title: "Lückentext (Eintippen)",
      description: "Erstelle einen Lückentext oder eine Tabelle, bei dem die Antworten durch Eintippen eingefügt werden."
    },
    blanksExerciseDragAndDrop: {
      title: "Lückentext (Drag&Drop)",
      description: "Erstelle einen Lückentext oder eine Tabelle, bei dem die Antworten via Drag und Drop eingefügt werden."
    }
  },
  plugins: {
    anchor: {
      title: "Sprungmarke",
      description: "Füge eine Sprungmarke innerhalb deines Inhalts hinzu.",
      identifier: 'Ziel-Name (z.B. "lange-erlaerung")',
      anchorId: "Name der Sprungmarke"
    },
    box: {
      title: "Box",
      description: "Füge eine Box für Beispiele, Zitate, Warnungen, Definitionen, Hinweise usw. ein.",
      type: "Art der Box",
      typeTooltip: "Wähle die Art der Box",
      titlePlaceholder: "(optionaler Titel)",
      anchorId: "Sprungmarke (anchor id)",
      emptyContentWarning: "Boxen ohne Inhalt werden nicht angezeigt"
    },
    dropzoneImage: {
      title: "Interaktives Bild (Ablagezonen)",
      description: "Erstelle eine Aufgabe, bei der vorgegebene Antworten in die richtigen Zonen eines Bilds oder einen leeren Hintergrund gezogen werden müssen.",
      backgroundImage: "Hintergrundbild",
      addDropZone: "Ablagezone hinzufügen",
      removeDropZone: "Ablagezone entfernen",
      dropzoneVisibility: "Ablagezone Sichtbarkeit",
      visibilityOptions: {
        full: "Voll",
        partial: "Nur Rahmen",
        none: "Kein"
      },
      answers: {
        add: "Antwort hinzufügen",
        remove: "Antwort entfernen",
        edit: "Antwort bearbeiten",
        settings: "Antworteinstellungen",
        answersPlaceholder: "Hier findest du deine Antworten"
      },
      answerZone: {
        description: "Beschreibung (optional)",
        sizeLabel: "Größe der Zone manuell festlegen",
        duplicate: "Zone duplizieren",
        delete: "Zone entfernen"
      },
      backgroundType: {
        description: "Füge ein Hintergrundbild hinzu oder starte mit leerem Hintergrund",
        image: "Hintergrundbild hinzufügen",
        blank: "Leerer Hintergrund"
      },
      backgroundShapes: {
        description: "Lege die Ausrichtung des Hintergrundes fest",
        square: "Quadratisch",
        landscape: "Querformat",
        portrait: "Hochformat"
      },
      or: "oder",
      modal: {
        settings: "Einstellungen",
        createDropZone: "Neue Ablagezone",
        edit: "Antwort bearbeiten",
        createWrongAnswer: "Falsche Antwort hinzufügen"
      }
    },
    unsupported: {
      title: "Nicht unterstützt",
      description: "Plugin wird von dieser Version des Editors nicht unterstützt.",
      notSupported: "Sorry, dieses Plugin wird nicht unterstützt:",
      explanation: "Es wird Usern nicht angezeigt. Du kannst es entweder entfernen oder unsere Entwickler*innen um Unterstützung bitten."
    },
    equations: {
      title: "Terme und Gleichungen",
      description: "Erstelle Termumformungen und löse mehrzeilige Gleichungen.",
      leftHandSide: "linke Seite",
      transformation: "Umformung",
      mode: "Modus",
      transformationExample: "z.B. -3x",
      transformationOfEquations: "Gleichungsumformung",
      transformationOfTerms: "Termumformung",
      addNewRow: "Neue Zeile hinzufügen",
      explanation: "Erklärung",
      term: "Term",
      rightHandSide: "rechte Seite",
      combineLikeTerms: "Fasse die Terme zusammen.",
      setEqual: "Setze die Terme gleich.",
      firstExplanation: "Erste Erklärung",
      removeRowLabel: "Zeile entfernen"
    },
    geogebra: {
      title: "GeoGebra Applet",
      description: "Binde GeoGebra Inhalte via Link oder ID ein.",
      chooseApplet: "Applet auswählen",
      urlOrId: "GeoGebra Materials URL oder ID"
    },
    highlight: {
      title: "Code",
      description: "Schreibe Code und hebe ihn je nach Programmiersprache hervor.",
      clickAndEnter: "Klicke hier und füge deinen Quellcode ein…",
      enterHere: "Füge hier deinen Quellcode ein. Verlasse den Bereich, um eine Vorschau zu sehen.",
      language: "Programmiersprache",
      languageTooltip: "Wähle die Sprache für's Syntax-Highlighting",
      showLineNumbers: "Zeilennummern",
      lineNumbersTooltip: "Sollten die Besucher*innen Zeilennummern sehen?"
    },
    image: {
      title: "Bild",
      galleryTitle: "Galerie",
      description: "Lade Bilder hoch oder suche online nach frei lizenzierten Bildern.",
      upload: "Bild hochladen",
      uploadMultiple: "Bilder hochladen",
      imageUrl: "Bild-URL",
      imageSource: "Bildquelle",
      imageSourceHelpText: "Füge hier weitere Informationen wie den Urheber dieses Bildes hinzu.",
      invalidImageUrl: "Fehler: Ungültige oder unvollständige URL",
      invalidImageUrlMessage: 'Die eingegebene URL ist entweder ungültig oder unvollständig. Bitte stelle sicher, dass du die vollständige URL korrekt kopiert und eingefügt hast. Die URL sollte mit "http://" oder "https://" beginnen.',
      search: "Suche",
      searchOnline: "Online nach lizenzfreien Bildern suchen",
      placeholderSource: "Quelle (optional)",
      placeholderEmpty: "https://example.com/image.png",
      placeholderUploading: "Wird hochgeladen …",
      placeholderFailed: "Hochladen fehlgeschlagen",
      retry: "Erneut versuchen",
      failedUpload: "Hochladen fehlgeschlagen",
      captionPlaceholder: "Bildunterschrift (optional)",
      href: "Link",
      hrefPlaceholder: "Bild verlinken",
      alt: "Alternativtext (wird nicht angezeigt)",
      altPlaceholder: "Was ist auf dem Bild zu sehen?",
      maxWidth: "Maximale Breite",
      maxWidthPlaceholder: "Gib die maximal Breite an",
      helpTooltipText: "Mehr Informationen und Hilfe",
      change: "Bild ändern",
      licence: "Lizenz",
      licenceHelpText: "Externe Inhalte mit den folgenden Lizenzen können auf serlo.org integriert werden:",
      licenceFree: "Frei lizenzierte Bilder",
      pixabayText: "Die Bilder werden von der freien Bilder-Datenbank von Pixabay zur Verfügung gestellt",
      pixabayLoadedText: "Die Bilder werden von der freien Bilder-Datenbank von Pixabay zur Verfügung gestellt",
      searching: "Suche nach Bildern ...",
      loadingImage: "Bilder werden heruntergeladen ...",
      noImagesFound: "Keine Bilder gefunden"
    },
    imageGallery: {
      title: "Bilder Galerie",
      description: "Füge eine Bildergalerie hinzu, um zusammenhängende Bilder organisiert darzustellen.",
      modalScreenReaderTitle: "Popup, das ein einzelnes Bild anzeigt mit Einstellungen und optionaler Bildunterschrift.",
      addImages: "Bilder hinzufügen",
      tooManyImagesMessage: "Du kannst maximal %max_images% Bilder in der Galerie hochladen. Bitte wähle weniger Bilder aus und versuche es erneut.",
      alreadyMaxImagesMessage: "Maximal %max_images% Bilder erlaubt. Bitte entferne ein oder mehrere Bilder, um neue hochzuladen."
    },
    injection: {
      title: "serlo.org Inhalt",
      description: "Binde einen bestehenden Inhalt von serlo.org via ID ein.",
      illegalInjectionFound: "Ungültige Injection gefunden",
      serloEntitySrc: "Serlo Inhalt {{src}}",
      serloId: "Serlo ID",
      placeholder: "Serlo ID (z.B. 1565)",
      invalidStateWarning: "Bitte verwende eine gültige Serlo ID (nur Zahlen) – z.B. '/1555'",
      errorLoading: "Inhalt konnte nicht geladen werden, bitte überprüfe die ID"
    },
    interactiveVideo: {
      title: "Interaktives Video",
      description: "Erstelle ein interaktives Video mit Aufgaben",
      editOverlayTitle: "Aufgabe erstellen",
      titlePlaceholder: "Aufgabentitel",
      defaultTitle: "Aufgabe",
      autoOpenLabel: "Automatisch öffnen",
      autoOpenExplanation: "Die Aufgabe wird automatisch geöffnet, wenn das Video dort ankommt",
      mandatoryLabel: "Verpflichtende Aufgabe",
      mandatoryExplanation: "Die Aufgabe muss richtig beantwortet werden, um das Video weiter abzuspielen",
      forceRewatchLabel: "Auto-Wiederholung",
      forceRewatchExplanation: "Wenn die Aufgabe falsch beantwortet wurde, kann der Lernende per Button den letzten Abschnitt noch mal anschauen",
      editMark: "Bearbeiten",
      removeMark: "Löschen",
      removeAllMarks: "Alle Aufgaben löschen",
      confirmRemoveAllMarks: "Bist du sicher, dass du alle Aufgaben löschen willst?",
      addOverlayContent: "Aufgabe an aktueller Stelle einfügen",
      addVideo: "Füge ein Video hinzu (z.B. YouTube)",
      changeVideo: "Video austauschen",
      saveInfo: "Änderungen werden automatisch gespeichert!"
    },
    multimedia: {
      title: "Erklärung mit Multimedia-Inhalt",
      description: "Erstelle einen veranschaulichenden oder erklärenden Multimedia-Inhalt mit zugehöriger Erklärung.",
      chooseSize: "Größe des Multimedia-Inhalts",
      changeType: "Tausche das Multimedia Element aus",
      howImportant: "Wie wichtig ist der Multimedia Inhalt?",
      isIllustrating: "Es ist nur eine Veranschaulichung",
      isEssential: "Es spielt eine zentrale Rolle",
      reset: "Multimedia-Inhalt zurücksetzen"
    },
    pageLayout: {
      title: "Layout-Spalten für Seiten",
      description: "Das Plugin, das alle wollen, aber nicht bekommen 🤫",
      chooseRatio: "Spaltenverhältnis auswählen"
    },
    pasteHack: {
      title: "(experiment) Editor State einfügen",
      description: "nur in staging"
    },
    pagePartners: {
      title: "Partner Liste",
      description: "Nur für die Partnerseite (Liste der Partnerlogos wie auf de.serlo.org)"
    },
    rows: {
      title: "Zeilen",
      description: "Rows plugin holds other plugins",
      searchForTools: "Suche hier nach Tools…",
      duplicate: "Duplizieren",
      remove: "Löschen",
      close: "Schließen",
      dragElement: "Verschiebe das Element innerhalb des Dokuments",
      addAnElement: "Füge ein Element hinzu",
      copyAnchorLink: "Link zu diesem Element kopieren",
      copySuccess: "Erfolgreich kopiert",
      pluginCopyInfo: "Du kannst das Plugin jetzt in Text-Plugins einfügen",
      pluginCopyButtonLabel: "Plugin in die Zwischenablage kopieren"
    },
    serloTable: {
      title: "Tabelle",
      description: "Erstelle eine anpassbare Tabelle.",
      mode: "Modus",
      columnHeaders: "Nur Spaltentitel",
      rowHeaders: "Nur Zeilentitel",
      columnAndRowHeaders: "Spalten- und Zeilentitel",
      convertToText: "Text als Inhalt",
      convertToImage: "Bild als Inhalt",
      row: "Zeile",
      column: "Spalte",
      addType: "%type% hinzufügen",
      addTypeBefore: "%type% davor hinzufügen",
      deleteType: "%type% löschen",
      confirmDelete: "Sicher, dass diese %type% und ihren Inhalt löschen willst?"
    },
    spoiler: {
      title: "Spoiler",
      description: "Füge eine ausklappbare Box ein, z.B. für Exkurse oder Hilfestellungen.",
      enterATitle: "Titel eingeben"
    },
    solution: {
      title: `Freitext Aufgabe
`,
      description: "Erstelle eine nicht interaktive Aufgabe, die die Lernenden manuell beantworten. Du kannst weiterhin Lösungen und Strategien einfügen."
    },
    text: {
      title: "Text",
      description: "Schreibe Text und Matheformeln, und formatiere sie.",
      placeholder: "Schreibe etwas …",
      addButtonExplanation: "Klicke, um ein neues Element einzufügen",
      quote: "Zitat",
      setColor: "Einfärben",
      resetColor: "Farbe zurücksetzen",
      colors: "Textfarben",
      closeSubMenu: "Untermenü schließen",
      heading: "Überschrift",
      headings: "Überschriften",
      link: "Link (%ctrlOrCmd% + K)",
      noElementPasteInLists: "Sorry,  Elemente einfügen klappt nicht in Listen.",
      pastingPluginNotAllowedHere: "Sorry, dieses Plugin kannst du hier nicht einfügen.",
      unsupportedPluginsPasted: "Ein paar der Plugins die du eingefügt hast, werden hier nicht unterstützt.",
      invalidDataPasted: "Sorry, mit den Daten die du einfügen willst stimmt etwas nicht. Das liegt wahrscheinlich an uns.",
      linkOverlay: {
        placeholder: 'Suchbegriff oder "/1234"',
        placeholderNonSerlo: "Link",
        inputLabel: "Suche einen Inhalt oder füge einen Link ein",
        inputLabelNonSerlo: "Füge einen Link ein",
        edit: "Link bearbeiten",
        remove: "Link entfernen",
        customLink: "Eigener Link",
        invalidLinkWarning: 'Bitte gib einen gültigen Link ein, der anfängt mit "https(s)://…"'
      },
      openInNewTab: "Öffne den Link in einem neuen Tab",
      orderedList: "Nummerierte Liste",
      unorderedList: "Aufzählung",
      lists: "Listen",
      mathFormula: "Matheformel (%ctrlOrCmd% + M)",
      code: "Code (%ctrlOrCmd% + ⇧ + C)",
      blank: "Lücke",
      createBlank: "Lücke erstellen",
      removeBlank: "Lücke entfernen",
      bold: "Fett (%ctrlOrCmd% + B)",
      italic: "Kursiv (%ctrlOrCmd% + I)",
      colorNames: {
        blue: "Blau",
        green: "Grün",
        orange: "Orange"
      },
      math: {
        formula: "[neue Formel]",
        visual: "visuell",
        latex: "LaTeX",
        latexEditorTitle: "LaTeX-Editor",
        onlyLatex: "Nur LaTeX verfügbar",
        shortcuts: "Tastenkürzel",
        fraction: "Bruch",
        superscript: "Hochgestellt",
        or: "oder",
        subscript: "Tiefgestellt",
        root: "Wurzel",
        mathSymbols: "Mathematische Symbole",
        eG: "z.B.",
        functions: "Funktionen",
        displayAsBlock: "eigene Zeile",
        closeMathFormulaEditor: "Mathe-Formel Editor schließen"
      }
    },
    video: {
      title: "Video",
      description: "Binde Videos von z.B. YouTube, Vimeo oder Wikimedia Commons ein.",
      videoUrl: "Video URL",
      videoDescription: "Beschreibung",
      titlePlaceholder: "Titel",
      url: "URL",
      seoTitle: "Titel für Suchmaschinen"
    },
    audio: {
      title: "Audio",
      description: "Audioaufnahmen von Vocaroo einbinden",
      audioUrl: "Audio URL eingeben"
    },
    exercise: {
      title: "Aufgabe",
      description: "Interaktive- oder Textaufgaben",
      placeholder: "Füge hier den Arbeitsauftrag ein (Optional)",
      hideInteractiveInitially: {
        info: "Interaktives Element ist versteckt beim laden",
        deactivate: "Interaktives Element sichtbar laden",
        activate: "Interaktives Element versteckt laden"
      },
      addOptionalInteractiveEx: "Füge optional ein interaktives Element hinzu:",
      changeInteractive: "Interaktives Element ändern",
      confirmRemoveInteractive: "Deine aktuellen Änderungen werden dabei überschrieben, bist du sicher?",
      createSolution: "Lösungsvorschlag hinzufügen",
      removeSolution: "Lösungsvorschlag entfernen",
      toLearnersView: "Zur Lernenden-Ansicht",
      toEditView: "Zur Bearbeitungs-Ansicht"
    },
    exerciseGroup: {
      title: "Aufgabe mit Teilaufgaben",
      description: "Liste von Aufgaben mit Teilaufgaben"
    },
    inputExercise: {
      title: "Eingabefeld",
      description: "Erstelle eine Aufgabe, bei der eine exakte Eingabe oder ein Wert eingegeben und validiert werden kann."
    },
    textAreaExercise: {
      title: "Freitext",
      description: "Ein großes Eingabefeld"
    },
    scMcExercise: {
      title: "SC/MC Aufgabe"
    },
    h5p: {
      title: "H5P",
      description: "Importiere eine interaktive Aufgabe von H5P via URL."
    },
    blanksExercise: {
      title: "Lückentext",
      placeholder: "Schreibe einen Text und füge Lücken ein",
      chooseType: "Wähle den Aufgabentyp",
      chooseChildPluginType: "Wähle den Eingabetyp",
      modes: {
        typing: "Tippen",
        "drag-and-drop": "Drag & Drop"
      },
      dummyAnswers: "Falsche Antwortmöglichkeiten",
      addDummyAnswer: "Falsche Antwort hinzufügen",
      removeDummyAnswer: "Falsche Antwort entfernen",
      addAlternativeAnswer: "Alternative Antwort hinzufügen",
      removeAlternativeAnswer: "Alternative Antwort entfernen",
      alternativeAnswers: "Alternative Antworten",
      acceptMathEquivalents: "Mathematisch gleichwertige Ausdrücke als gültige Antwort",
      childPluginSelection: "Möchtest du einen Lückentext oder eine Tabelle mit Lücken?"
    },
    edusharingAsset: {
      title: "Edu-sharing Inhalt",
      description: "Inhalte von edu-sharing einbinden"
    }
  },
  templatePlugins: {
    entity: {
      titlePlaceholder: "Titel",
      seoTitle: "Titel für Suchmaschinen",
      seoDesc: "Beschreibung für Suchmaschinen",
      moveUpLabel: "Eins nach oben verschieben",
      moveDownLabel: "Nach unten verschieben"
    },
    article: {
      writeShortIntro: "Fasse das Thema des Artikels kurz zusammen",
      stillWantMore: "Du hast noch nicht genug vom Thema?",
      moreOnTopic: "Hier findest du noch weitere passende Inhalte zum Thema",
      addSource: "Quellenangabe hinzufügen",
      removeLabel: "Löschen",
      dragLabel: "Ziehen, um die Reihenfolge zu ändern",
      openInTab: "Öffne den Link in einem neuen Tab",
      sources: "Quellen",
      sourceText: "Quelle",
      sourceUrl: "Optionaler Link",
      moreInFolder: "Weitere Aufgaben zum Thema findest du im folgenden Aufgabenordner",
      addModal: {
        introText: "Was würde den Lernenden nach dem Artikel weiterhelfen?%break% Hier kannst du %exercises% einbetten oder eine %exerciseFolder% verlinken. %break% Oder du kannst weiterführende %articles%, %courses% oder %videos% empehlen.",
        introText2: "Du kannst entweder eine Serlo ID oder einen Link einfügen, oder unten Inhalte aus dem Elternordner einfügen.",
        buttonEx: "Aufgaben hinzufügen",
        buttonExFolder: "Aufgabenordner auswählen",
        buttonContent: "Inhalt hinzufügen",
        buttonAddType: "%type% hinzufügen",
        title: "Weiterführende Inhalte oder Übungsaufgaben hinzufügen",
        invalidInput: "Ungültige ID oder URL",
        fetchError: "Etwas ist schief gelaufen, bitte versuche es später noch einmal",
        loading: "Wird geladen …",
        notFound: "Inhalt konnte nicht gefunden werden",
        unsupportedType: "Sorry, der Typ [%type%] wird hier nicht unterstützt",
        unsupportedId: "Sorry, diese ID ist hier nicht erlaubt. (z.B. weil sie schon ausgewählt ist, oder weil du diese ID bearbeitest…)",
        addFromFolderTitle: "Aus dem Ordner",
        placeholder: "Eine Serlo Id oder URL hier einfügen",
        exerciseFolderNote: "Hier kann nur ein Ordner ausgewählt werden"
      }
    },
    course: {
      removeCoursePage: "Kursseite entfernen",
      addCoursePage: "Kursseite hinzufügen",
      confirmDelete: "Sicher, dass du diese Kursseite löschen willst?"
    },
    inputExercise: {
      chooseType: "Wähle den Antworttyp",
      unit: "Einheit (optional)",
      addAnswer: "Antwort hinzufügen",
      enterTheValue: "Gib hier die Antwort ein",
      feedbackPlaceholder: "Schreibe ein Feedback für diese Antwort",
      yourSolution: "Deine Lösung",
      types: {
        "input-string-normalized-match-challenge": "Text (genau, z.B. 'Tiger')",
        "input-number-exact-match-challenge": "Zahl (genau, z.B. '0.5')",
        "input-expression-equal-match-challenge": 'Mathematischer Ausdruck (gleichwertig, z.B. "0,5", "1/2" oder "2/4")'
      }
    },
    scMcExercise: {
      singleChoice: "Single Choice",
      multipleChoice: "Multiple Choice",
      chooseType: "Wähle den Antworttyp",
      addAnswer: "Antwort hinzufügen"
    },
    solution: {
      optionalExplanation: "Beschreibe hier optional die Lösungsstrategie",
      idArticle: "ID eines Artikels, z.B. 1855",
      openArticleTab: "Öffne den Artikel in einem neuen Tab",
      linkTitle: "Titel der Verlinkung",
      showSolution: "Lösung anzeigen",
      hideSolution: "Lösung ausblenden",
      changeLicense: "Lizenz ändern",
      addPrerequisite: "Link hinzufügen"
    },
    textExerciseGroup: {
      removeExercise: "Teilaufgabe entfernen",
      addExercise: "Teilaufgabe hinzufügen",
      kindOfExerciseGroup: "Art der Aufgabengruppe",
      addIntermediateTask: "Zwischentext hinzufügen",
      removeIntermediateTask: "Zwischentext entfernen",
      intermediateTask: "Zwischentext"
    }
  },
  edtrIo: {
    localStorage: {
      found: "Du hast lokal gespeicherte Änderungen dieses Inhalts. Möchtest du sie laden?",
      foundButton: "Änderungen laden",
      restoreInitial: "Du kannst auch wieder zurück zur Ausgangsversion. Vorsicht, dabei werden deine bisherigen Änderungen gelöscht.",
      restoreInitialButton: "Änderungen löschen",
      confirmRestore: "Sicher, dass du deine Änderugen unwiderruflich löschen möchtest?"
    },
    settings: "Einstellungen",
    extendedSettings: "Erweiterte Einstellungen",
    close: "Schließen",
    save: "Speichern",
    saveWithReview: "Speichern und reviewen lassen",
    cancel: "Abbrechen",
    saving: "Speichert…",
    missingChanges: "Du musst zuerst die Änderungen ausfüllen.",
    missingLicenseTerms: "Du musst zuerst die Lizenzbedingungen akzeptieren.",
    missingChangesAndLicenseTerms: "Du musst zuerst die Lizenzbedingungen akzeptieren und die Änderungen ausfüllen.",
    errorSaving: "Es trat ein Fehler beim Speichern auf.",
    saveLocallyAndRefresh: "Du kannst die Bearbeitung lokal zwischenspeichern, dann die Seite neu laden und es erneut versuchen.",
    revisionSaved: "Bearbeitung gespeichert",
    saveRevision: "Bearbeitung zwischenspeichern",
    changes: "Beschreibe deine Änderungen am Inhalt",
    importOther: "Aus einem anderen Inhalt importieren",
    importOtherExplanation: "Du kannst den Content eines anderen Inhalts hier importieren. Füge dazu einfach hier die URL oder ID eines anderen Inhalts auf serlo.org ein. (Nur gleiche Inhaltstypen sind erlaubt – also Artikel können nur in Artikeln importiert werden). Diese Funktion ist NICHT dazu gedacht exakte Kopien anzulegen. Aufgabengruppen und Kurse werden nicht unterstützt (aber Aufgaben und Kursseiten klappen)",
    importOtherWarning: "Vorsicht: Diese Funktion überschreibt alle bestehenden Inhalte in diesem Editor.",
    importOtherButton: "Inhalte Importieren",
    current: "Aktuell",
    author: "Autor*in",
    createdAt: "Zeitstempel",
    ready: "Bereit zum Speichern?"
  }
}, P6e = {
  lang: "de",
  plugins: {
    article: {
      exercisesTitle: "Übungsaufgaben",
      moreExercises: "Weitere Aufgaben zum Thema findest du im folgenden Aufgabenordner",
      relatedContentTitle: "Du hast noch nicht genug vom Thema?",
      relatedContentText: "Hier findest du noch weitere passende Inhalte zum Thema:",
      sourcesTitle: "Quellen",
      subsectionTypes: {
        articles: "Artikel",
        courses: "Kurse",
        videos: "Videos"
      }
    },
    audio: {
      failed: "Sorry, beim laden der Audio-Datei ist was schiefgegangen."
    },
    box: {
      types: {
        blank: "Blanko",
        example: "Beispiel",
        quote: "Zitat",
        approach: "Vorgehen",
        remember: "Merke",
        attention: "Vorsicht",
        note: "Beachte",
        definition: "Definition",
        theorem: "Satz",
        proof: "Beweis"
      }
    },
    course: {
      title: "Kurse",
      showPages: "Kursübersicht anzeigen",
      pages: "Kursübersicht",
      next: "Weiter",
      back: "Zurück",
      noPagesWarning: "Leider gibt es für diesen Kurs noch keine akzeptierten Seiten.",
      noRevisionForPage: "Ungegeprüfte Seite"
    },
    exercise: {
      title: "Aufgabe",
      prerequisite: "Für diese Aufgabe benötigst Du folgendes Grundwissen:",
      task: "Aufgabenstellung",
      correct: "Richtig",
      missedSome: "Fast! Dir fehlt noch mindestens eine richtige Antwort.",
      wrong: "Leider nicht richtig",
      feedback: "Feedback",
      answer: "Antwort",
      check: "Stimmt's?",
      yourAnswer: "Deine Antwort…",
      chooseOption: "Klicke auf eine der Optionen.",
      printModeChooseOption: "Kreuze eine der Optionen an.",
      strategy: "Strategie",
      solution: "Lösungsvorschlag",
      showHiddenInteractive: "Hier deine Lösung prüfen"
    },
    image: {
      altFallback: "Bild"
    },
    imageGallery: {
      lightboxSrTitle: "Popup mit einem großen Bild und Schaltflächen, um zu anderen Bildern in der Galerie zu navigieren"
    },
    video: {
      failed: "Sorry, das Video konnte nicht geladen werden."
    },
    interactiveVideo: {
      play: "Abspielen",
      rewind: "Zurückspulen",
      mandatoryWarning: "Du musst erst die Aufgabe lösen.",
      exerciseSolved: "Gut gemacht! Jetzt geht's weiter.",
      repeatPromt: "Schau dir doch noch mal den Teil des Videos vor der Aufgabe an"
    }
  },
  embed: {
    activateEmbed: "Aktivieren",
    previewImage: "Vorschaubild"
  },
  misc: {
    ctrl: "Strg",
    return: "Enter",
    loading: "Laden"
  }
}, L8 = {
  lang: "en",
  confirmRouteChange: "Are you sure you want to leave without saving?",
  noChangesWarning: "Nothing changed so there is no need to save yet",
  savedContentMightDisappearWarning: "⚠️ This is a test environment. Please do not create content that you want to keep long term here. Questions? vicky@serlo.org",
  addPluginsModal: {
    searchInputPlaceholder: "Search...",
    basicPluginsTitle: "Content Elements",
    interactivePluginsTitle: "Exercises",
    noPluginsFoundTitle: "Sorry, no elements match your search.",
    noPluginsFoundDescription: "Please try different keywords or browse through all available elements."
  },
  pluginMenu: {
    singleChoiceExercise: {
      title: "Single Choice Exercise",
      description: "A question with a selection of answer options and a single correct one."
    },
    multipleChoiceExercise: {
      title: "Multiple Choice Exercise",
      description: "A question with a selection of answer options with potentially multiple correct answers."
    },
    blanksExercise: {
      title: "Fill In The Blanks (Typing)",
      description: "Create a fill in the blanks exercise (text or table) where learners add the answers via typing."
    },
    blanksExerciseDragAndDrop: {
      title: "Fill In The Blanks (Drag&Drop)",
      description: "Create a fill in the blanks exercise (text or table) where learners add the answers via drag and drop."
    }
  },
  plugins: {
    anchor: {
      title: "Anchor",
      description: "Insert an anchor.",
      identifier: 'Identifier (e.g. "long-explanation")',
      anchorId: "ID of the anchor"
    },
    box: {
      title: "Container",
      description: "Insert a container for examples, quotes, warnings, theorems, notes…",
      type: "Type of box",
      typeTooltip: "Choose the type of the box",
      titlePlaceholder: "(optional title)",
      anchorId: "Anchor ID",
      emptyContentWarning: "Boxes without content will not be displayed"
    },
    dropzoneImage: {
      title: "Interactive Image (Dropzones)",
      description: "Create an exercise where given answers must be dragged into the correct zones of a picture or a blank background.",
      backgroundImage: "Background image",
      addDropZone: "Add drop zone",
      removeDropZone: "Remove drop zone",
      dropzoneVisibility: "Dropzone Visibility",
      visibilityOptions: {
        full: "full",
        partial: "partial",
        none: "none"
      },
      answers: {
        add: "Add answer",
        remove: "Remove answer",
        edit: "Edit answer",
        settings: "Answer settings",
        answersPlaceholder: "Here you will find your dropzone answers"
      },
      answerZone: {
        description: "Description (optional)",
        sizeLabel: "Configure the size of the drop zone",
        duplicate: "Duplicate zone",
        delete: "Delete zone"
      },
      backgroundType: {
        description: "Insert a background image or proceed with a blank background",
        image: "Background Image",
        blank: "Blank background"
      },
      backgroundShapes: {
        description: "Choose the layout of the background",
        square: "Square",
        landscape: "Landscape",
        portrait: "Portrait"
      },
      or: "or",
      modal: {
        settings: "Settings",
        createDropZone: "New Drop Zone",
        edit: "Edit Answer",
        createWrongAnswer: "Create Wrong Answer"
      }
    },
    unsupported: {
      title: "Unsupported",
      description: "Plugin not supported by this version of the editor.",
      notSupported: "Sorry, this plugin is not supported:",
      explanation: "It will not be displayed to users. You can either remove it or asks developers for support."
    },
    equations: {
      title: "Terms and equations",
      description: "Create term transformations and solve multi-line equations.",
      leftHandSide: "left-hand side",
      transformation: "transformation",
      mode: "Mode",
      transformationExample: "e.g. -3x",
      transformationOfEquations: "Transformation of equations",
      transformationOfTerms: "Transformation of terms",
      addNewRow: "Add new row",
      explanation: "Explanation",
      term: "Term",
      rightHandSide: "right-hand side",
      combineLikeTerms: "Combine like terms.",
      setEqual: "Set the terms equal to each other.",
      firstExplanation: "First explanation",
      removeRowLabel: "Remove row"
    },
    geogebra: {
      title: "GeoGebra Applet",
      description: "Embed GeoGebra materials applets via URL or ID.",
      chooseApplet: "Choose Applet",
      urlOrId: "GeoGebra URL or ID"
    },
    highlight: {
      title: "Source Code",
      description: "Write code and highlight it according to the programming language.",
      clickAndEnter: "Click here and enter your source code…",
      enterHere: "Enter your source code here",
      language: "Language",
      languageTooltip: "Choose language for syntax highlighting",
      showLineNumbers: "Line numbers",
      lineNumbersTooltip: "Should users see line numbers?"
    },
    image: {
      title: "Image",
      galleryTitle: "Gallery",
      description: "Upload images or search online for freely licensed images.",
      upload: "Upload Image",
      uploadMultiple: "Upload Images",
      imageUrl: "Image URL",
      imageSource: "Image Source",
      imageSourceHelpText: "Add the author or source of this image here",
      invalidImageUrl: "Error: Invalid or Incomplete URL",
      invalidImageUrlMessage: 'The URL you entered is either invalid or incomplete. Please ensure you have copied and pasted the full URL correctly. The URL should start with "http://" or "https://".',
      search: "Search",
      searchOnline: "Search online for licence-free images",
      placeholderSource: "Source (optional)",
      placeholderEmpty: "https://example.com/image.png",
      placeholderUploading: "Uploading…",
      placeholderFailed: "Upload failed…",
      retry: "Retry",
      failedUpload: "Upload failed",
      captionPlaceholder: "Optional caption",
      href: "Link",
      hrefPlaceholder: "Link the image",
      alt: "Description (hidden)",
      altPlaceholder: "Describe what the image shows",
      maxWidth: "Maximum width",
      maxWidthPlaceholder: "Enter the maximum width",
      helpTooltipText: "More information and help related to Image Plugin",
      change: "Change image",
      licence: "Licence",
      licenceHelpText: "External content with the following licenses may be integrated on serlo.org:",
      licenceFree: "Licence Free Images",
      pixabayText: "Images will be fetched from Pixabay",
      pixabayLoadedText: "These images were loaded from Pixabay.",
      searching: "Searching for images ...",
      loadingImage: "Downloading image ...",
      noImagesFound: "No images found"
    },
    imageGallery: {
      title: "Image Gallery",
      description: "Add an image gallery to display related images in an organized way.",
      modalScreenReaderTitle: "Modal displaying single image options for caption and settings.",
      addImages: "Add Images",
      tooManyImagesMessage: "You can only upload %max_images% images in this element. Please select fewer images and try again.",
      alreadyMaxImagesMessage: "Maximum of %max_images% images reached. Please remove one or more images to upload new ones."
    },
    injection: {
      title: "serlo.org Content",
      description: "Embed an existing content from serlo.org via ID.",
      illegalInjectionFound: "Illegal injection found",
      serloEntitySrc: "Serlo entity {{src}}",
      serloId: "Serlo ID",
      placeholder: "Serlo ID (e.g. /1565)",
      invalidStateWarning: "Please use a valid Serlo ID (just numbers). E.g. '/1555'",
      errorLoading: "Content could not be loaded, please check the id"
    },
    interactiveVideo: {
      title: "Interactive Video",
      description: "Create an interactive video with questions and feedback.",
      editOverlayTitle: "Edit Exercise",
      titlePlaceholder: "Exercise Title",
      defaultTitle: "Exercise",
      autoOpenLabel: "Automatically open",
      autoOpenExplanation: "Content automatically opens when video is at mark",
      mandatoryLabel: "Mandatory Exercise",
      mandatoryExplanation: "Exercise has to be solved to continue video",
      forceRewatchLabel: "Auto Rewatch",
      forceRewatchExplanation: "If an exercise is answered incorrectly, the video jumps back to the last mark",
      editMark: "Edit",
      removeMark: "Remove",
      removeAllMarks: "Remove all exercises",
      confirmRemoveAllMarks: "Are you sure you want to remove all exercises?",
      addOverlayContent: "Add exercise",
      addVideo: "Add a video url (e.g. YouTube) to get started",
      changeVideo: "Change video",
      saveInfo: "Changes are continually saved!"
    },
    multimedia: {
      title: "Multimedia content associated with text",
      description: "Create an illustrating or explaining multimedia content associated with text.",
      chooseSize: "Choose size of multimedia element",
      changeType: "Change the multimedia type",
      howImportant: "How important is the multimedia content?",
      isIllustrating: "It is illustrating",
      isEssential: "It is essential",
      reset: "Reset the multimedia content"
    },
    pageLayout: {
      title: "Layout Column for Pages",
      description: "The plugin the people want but don't get 🤫",
      chooseRatio: "Choose column ratio"
    },
    pasteHack: {
      title: "Experimental State-Paste Plugin",
      description: "only on staging"
    },
    pagePartners: {
      title: "Partner List",
      description: "Only for partner page (List of partner logos like on de.serlo.org/)"
    },
    rows: {
      title: "Rows",
      description: "Rows plugin holds other plugins",
      searchForTools: "Search for tools…",
      duplicate: "Duplicate",
      remove: "Remove",
      close: "Close",
      dragElement: "Drag the element within the document",
      addAnElement: "Add an element",
      copyAnchorLink: "Copy link to this element",
      copySuccess: "Successfully copied!",
      pluginCopyInfo: "You can now paste this plugin into text plugins",
      pluginCopyButtonLabel: "Copy plugin to clipboard"
    },
    serloTable: {
      title: "Table",
      description: "Create a customizable table.",
      mode: "Mode",
      columnHeaders: "Only column headers",
      rowHeaders: "Only row headers",
      columnAndRowHeaders: "Column and row headers",
      convertToText: "Convert to text",
      convertToImage: "Convert to image",
      row: "row",
      column: "column",
      addType: "Add %type%",
      addTypeBefore: "Add %type% before",
      deleteType: "Delete %type%",
      confirmDelete: "Are you sure you want to delete this %type% and the content in it?"
    },
    spoiler: {
      title: "Spoiler",
      description: "Insert a fold-out box, e.g. for additional content or help.",
      enterATitle: "Enter a title"
    },
    solution: {
      title: "Non interactive exercise",
      description: "Create a non-interactive task that learners answer manually. You can still include solutions and strategies."
    },
    text: {
      title: "Text",
      description: "Compose content using rich text and math formulas.",
      placeholder: "Write something...",
      addButtonExplanation: "Click to insert new element",
      quote: "Quote",
      setColor: "Set color",
      resetColor: "Reset color",
      colors: "Colors",
      closeSubMenu: "Close sub menu",
      heading: "Heading",
      headings: "Headings",
      link: "Link (%ctrlOrCmd% + K)",
      noElementPasteInLists: "Sorry, pasting elements inside of lists is not allowed.",
      pastingPluginNotAllowedHere: "Sorry, pasting this plugin here is not allowed.",
      unsupportedPluginsPasted: "There were unsupported plugins in the data you pasted.",
      invalidDataPasted: "Sorry, something is wrong with the data you pasted.",
      linkOverlay: {
        placeholder: "https://… or /1234",
        placeholderNonSerlo: "https://",
        inputLabel: "Paste or type a link",
        inputLabelNonSerlo: "Insert a link",
        edit: "Edit Link",
        remove: "Remove Link",
        customLink: "Custom Link",
        invalidLinkWarning: "Please provide a valid link that starts with http(s)://…"
      },
      openInNewTab: "Open in new tab",
      orderedList: "Ordered list",
      unorderedList: "Unordered list",
      lists: "Lists",
      mathFormula: "Math formula (%ctrlOrCmd% + M)",
      code: "Code (%ctrlOrCmd% + ⇧ + C)",
      blank: "Blank",
      createBlank: "Create Blank",
      removeBlank: "Remove Blank",
      bold: "Bold (%ctrlOrCmd% + B)",
      italic: "Italic (%ctrlOrCmd% + I)",
      colorNames: {
        blue: "Blue",
        green: "Green",
        orange: "Orange"
      },
      math: {
        formula: "[formula]",
        visual: "visual",
        latex: "LaTeX",
        latexEditorTitle: "LaTeX editor",
        onlyLatex: "Only LaTeX editor available",
        shortcuts: "Shortcuts",
        fraction: "Fraction",
        superscript: "Superscript",
        or: "or",
        subscript: "Subscript",
        root: "Root",
        mathSymbols: "Math symbols",
        eG: "e.g.",
        functions: "Functions",
        displayAsBlock: "Display as block",
        closeMathFormulaEditor: "Close math formula editor"
      }
    },
    video: {
      title: "Video",
      description: "Embed videos from e.g. YouTube or Vimeo.",
      videoUrl: "Video URL",
      videoDescription: "Description",
      titlePlaceholder: "Title",
      url: "URL",
      seoTitle: "Title for search engines"
    },
    audio: {
      title: "Audio",
      description: "Link to audio files on Vocaroo",
      audioUrl: "Enter Audio URL"
    },
    exercise: {
      title: "Exercise",
      description: "Interactive or text based exercise",
      placeholder: "Type the assignment here (Optional)",
      hideInteractiveInitially: {
        info: "Interactive element collapsed on load",
        deactivate: "Load Interactive Element visible",
        activate: "Load Interactive Element collapsed"
      },
      addOptionalInteractiveEx: "Add an optional interactive exercise:",
      changeInteractive: "Change interactive element",
      confirmRemoveInteractive: "Your current changes will be replaced. Are you sure?",
      createSolution: "Create proposed solution",
      removeSolution: "Remove proposed solution",
      toLearnersView: "To Learners View",
      toEditView: "To Edit View"
    },
    exerciseGroup: {
      title: "Exercise Group",
      description: "Group multiple exercises together"
    },
    inputExercise: {
      title: "Input Exercise",
      description: "Create a task where an exact input or value can be entered and validated."
    },
    textAreaExercise: {
      title: "Text Box Exercise",
      description: "A big text box for long answers. No feedback."
    },
    scMcExercise: {
      title: "SC/MC Exercise"
    },
    h5p: {
      title: "H5P",
      description: "Import an interactive task from H5P via URL."
    },
    blanksExercise: {
      title: "Fill In The Blanks",
      placeholder: "Write a text and add blanks",
      chooseType: "Choose the exercise type",
      chooseChildPluginType: "Choose the answer type",
      modes: {
        typing: "Typing",
        "drag-and-drop": "Drag & Drop"
      },
      dummyAnswers: "Extra incorrect answers",
      addDummyAnswer: "Add an incorrect answer",
      removeDummyAnswer: "Remove extra answer",
      addAlternativeAnswer: "Add an alternative answer",
      removeAlternativeAnswer: "Remove alternative answer",
      alternativeAnswers: "Alternative answers",
      acceptMathEquivalents: "Accept all equivalent mathematical values",
      childPluginSelection: "Would you like to add blanks to a text or a table?"
    },
    edusharingAsset: {
      title: "Edu-sharing Content",
      description: "Embed content from edu-sharing"
    }
  },
  templatePlugins: {
    entity: {
      titlePlaceholder: "Title",
      seoTitle: "Title for search engines",
      seoDesc: "Description for search engines",
      moveUpLabel: "Move up",
      moveDownLabel: "Move down"
    },
    article: {
      stillWantMore: "Still want more?",
      moreOnTopic: "You can find more content on this topic here",
      addSource: "Add source",
      removeLabel: "Remove",
      dragLabel: "Drag to change order",
      openInTab: "Open in new tab",
      sources: "Sources",
      sourceText: "Source Text",
      sourceUrl: "Optional URL",
      moreInFolder: "You can find more exercises in the following folder",
      addModal: {
        introText: "After reading the article, what would help out learners next? %break% Here you can add some %exercises% or link to a single %exerciseFolder%. %break% Or you can suggest %articles%, %courses% or %videos% to follow up with.",
        introText2: "You can either paste an Serlo ID, an URL or choose content from the parent folder below.",
        buttonEx: "Add exercises",
        buttonExFolder: "Select exercise folder",
        buttonContent: "Add content",
        buttonAddType: "Add %type%",
        title: "Add related Content or Exercises",
        invalidInput: "Invalid id or url",
        fetchError: "Something went wrong, please try later",
        loading: "Loading…",
        notFound: "Could not find that content",
        unsupportedType: "Sorry, type [%type%] is not supported here",
        unsupportedId: "Sorry, this ID is not supported here",
        addFromFolderTitle: "From the folder",
        placeholder: "Paste Serlo ID or URL here",
        exerciseFolderNote: "Only one can be selected here"
      }
    },
    course: {
      removeCoursePage: "Remove course page",
      addCoursePage: "Add course page",
      confirmDelete: "Are you sure you want to delete this course page?"
    },
    inputExercise: {
      chooseType: "Choose the exercise type",
      unit: "Unit",
      addAnswer: "Add answer",
      enterTheValue: "Enter the value",
      feedbackPlaceholder: "Add a feedback message for this answer",
      yourSolution: "Your solution",
      types: {
        "input-string-normalized-match-challenge": "Text (exact, e.g. 'tiger')",
        "input-number-exact-match-challenge": "Number (exact, e.g. '0.5')",
        "input-expression-equal-match-challenge": "Mathematical expression (equivalent, e.g. '0.5' or '1/2' or '2/4'"
      }
    },
    scMcExercise: {
      singleChoice: "Single-choice",
      multipleChoice: "Multiple-choice",
      chooseType: "Choose the exercise type",
      addAnswer: "Add answer"
    },
    solution: {
      optionalExplanation: "Optionally explain the solution strategy here",
      idArticle: "ID of an article, e.g. 1855",
      openArticleTab: "Open the article in a new tab:",
      linkTitle: "Title of the link",
      showSolution: "Show solution",
      hideSolution: "Hide solution",
      changeLicense: "Change license",
      addPrerequisite: "Add link"
    },
    textExerciseGroup: {
      removeExercise: "Remove exercise",
      addExercise: "Add exercise",
      kindOfExerciseGroup: "Kind of exercise group",
      addIntermediateTask: "Add Intermediate Task",
      removeIntermediateTask: "Remove intermediate Task",
      intermediateTask: "Intermediate Task"
    }
  },
  edtrIo: {
    localStorage: {
      found: "You have locally saved edits of this revision. Do you want to load them?",
      foundButton: "Load stored edits",
      restoreInitial: "Want to start fresh? Beware that this will delete your current edits!",
      restoreInitialButton: "Delete changes",
      confirmRestore: "Are you sure you want to delete all your changes?"
    },
    settings: "Settings",
    extendedSettings: "Extended Settings",
    close: "Close",
    save: "Save",
    saveWithReview: "Save and get review",
    cancel: "Cancel",
    saving: "Saving…",
    missingChanges: "You need to fill out the changes you made",
    missingLicenseTerms: "You need to accept the license terms",
    missingChangesAndLicenseTerms: "You need to fill out the changes you made and accept the license terms",
    errorSaving: "An error occurred during saving.",
    saveLocallyAndRefresh: "You can store the revision locally, refresh the page and try to save again.",
    revisionSaved: "Revision saved",
    saveRevision: "Save revision",
    changes: "Describe your changes to the content",
    importOther: "Import content from other entity",
    importOtherExplanation: "Just paste the url or id of another serlo.org entity of the same type here to duplicate it's content here. Do NOT use this to make exact copies or move content. Exercise Groups and Courses are not supported (but Exercises and Course Pages).",
    importOtherWarning: "Warning: This overwrites everything that is already present in this editor!",
    importOtherButton: "Import content",
    current: "Current",
    author: "Author",
    createdAt: "when?",
    ready: "Ready to save?"
  }
}, _6e = {
  lang: "en",
  plugins: {
    article: {
      exercisesTitle: "Exercises",
      moreExercises: "You can find more exercises in the following folder:",
      relatedContentTitle: "Still want more?",
      relatedContentText: "You can find more content on this topic here:",
      sourcesTitle: "Sources",
      subsectionTypes: {
        articles: "Articles",
        courses: "Courses",
        videos: "Videos"
      }
    },
    audio: {
      failed: "Sorry, the audio file couldn't be loaded."
    },
    box: {
      types: {
        blank: "Blank",
        example: "Example",
        quote: "Quote",
        approach: "Approach",
        remember: "Remember",
        attention: "Attention",
        note: "Note",
        definition: "Definition",
        theorem: "Theorem",
        proof: "Proof"
      }
    },
    course: {
      title: "Course",
      showPages: "Show course overview",
      pages: "Course overview",
      next: "Next",
      back: "Back",
      noPagesWarning: "Sorry there seem to be no reviewed pages in this course yet.",
      noRevisionForPage: "unreviewed page"
    },
    exercise: {
      title: "Exercise",
      prerequisite: "For this task you need the following basic knowledge:",
      task: "Task",
      correct: "Correct",
      missedSome: "Almost! You missed at least one correct answer.",
      wrong: "Wrong",
      feedback: "Feedback",
      answer: "Answer",
      check: "Check",
      yourAnswer: "Your answer…",
      chooseOption: "Click on one of the options.",
      printModeChooseOption: "Check one of the options.",
      strategy: "Strategy",
      solution: "Proposed Solution",
      showHiddenInteractive: "Check your solution here"
    },
    image: {
      altFallback: "Image"
    },
    imageGallery: {
      lightboxSrTitle: "Modal displaying a single large image, with buttons to navigate to other images in the gallery"
    },
    video: {
      failed: "Sorry, the video couldn't be loaded."
    },
    interactiveVideo: {
      play: "Play",
      rewind: "Rewind",
      mandatoryWarning: "You have to solve the task first.",
      exerciseSolved: "Well done! Let's move on.",
      repeatPromt: "Take another look at the part of the video before the task"
    }
  },
  embed: {
    activateEmbed: "Activate",
    previewImage: "Preview Image"
  },
  misc: {
    ctrl: "ctrl",
    return: "return",
    loading: "Loading"
  }
}, PB = {
  de: {
    staticStrings: P6e,
    editStrings: RB
  },
  en: {
    staticStrings: _6e,
    editStrings: L8
  }
}, Jf = "https://serlo.org/editor", M8 = i0([
  mi("https://github.com/serlo/serlo-editor-for-edusharing"),
  // TODO: remove soon
  mi("lti-tool"),
  mi("serlo-org"),
  mi("kiron"),
  mi("scobees"),
  mi("moodle"),
  mi("chancenwerk"),
  mi("unknown")
]), gf = TN([
  Do({ plugin: Cr }),
  DN({ state: Y7 })
]), n6 = Do({
  type: mi(Jf),
  variant: M8,
  version: mi(0),
  dateModified: Cr,
  document: gf
}), r6 = Do({
  id: Cr,
  type: mi(Jf),
  variant: M8,
  version: mi(1),
  editorVersion: Cr,
  dateModified: Cr,
  document: gf
}), i6 = [
  // Migration 0: Add editorVersion & id
  (e) => {
    if (!n6.is(e))
      throw new Error(
        `Unexpected type during migration. Expected ${JSON.stringify(n6)} but got ${JSON.stringify(e)}`
      );
    return {
      ...e,
      editorVersion: ud(),
      id: fa()
    };
  },
  // Migration 1: Add domainOrigin
  (e) => {
    if (!r6.is(e))
      throw new Error(
        `Unexpected type during migration. Expected ${JSON.stringify(r6)} but got ${JSON.stringify(e)}`
      );
    return {
      ...e,
      domainOrigin: typeof window < "u" ? window.location.origin : "server"
    };
  }
  // ...
  // Add new migrations here. Make sure the last one returns the new StorageFormat.
], _B = i6.length;
function qB(e) {
  return {
    id: fa(),
    type: Jf,
    variant: e,
    domainOrigin: window.location.origin,
    version: _B,
    editorVersion: ud(),
    dateModified: tg(),
    document: {
      plugin: Us.GenericContent,
      state: {
        content: {
          plugin: Y.Rows
        }
      }
    }
  };
}
function Yk(e) {
  return JSON.parse(JSON.stringify(e));
}
function $B(e, t) {
  if (!n6.is(e) && !r6.is(e) && !Jk.is(e) && !gf.is(e))
    throw new Error(
      `Unknown state type when trying to run migrations. Got ${JSON.stringify(e)}`
    );
  let n = !1, r = i();
  function i() {
    return gf.is(e) ? (n = !0, {
      type: Jf,
      variant: t,
      version: 0,
      dateModified: tg(),
      document: Yk(e)
    }) : Yk(e);
  }
  const o = r.version;
  for (let a = o; a < i6.length; a++)
    r = i6[a](r), n = !0, r.version = a + 1;
  if (!Jk.is(r))
    throw new Error(
      "Storage format after migrations does not match StorageFormatType"
    );
  return n && (r.editorVersion = ud(), r.dateModified = tg()), { migratedState: r, stateChanged: n };
}
const Jk = Do({
  // Constant values (set at creation)
  id: Cr,
  // https://dini-ag-kim.github.io/amb/20231019/#id
  type: mi(Jf),
  variant: M8,
  domainOrigin: Cr,
  // Variable values (can change when state modified)
  version: mi(_B),
  // Index of the next migration to apply
  editorVersion: Cr,
  dateModified: Cr,
  document: gf
});
function q6e(e) {
  const {
    children: t,
    editorVariant: n,
    onChange: r,
    language: i,
    plugins: o,
    isProductionEnvironment: a,
    userId: s,
    _testingSecret: l,
    _ltik: u
  } = {
    ...IB,
    ...e
  }, d = e.initialState ? e.initialState : qB(n), { migratedState: p, stateChanged: f } = $B(d, n);
  r && f && r(p);
  const { staticStrings: m, editStrings: y } = PB[i], g = c6e(o, l);
  si.init(g);
  const x = BB();
  return hu.init(x), /* @__PURE__ */ c.jsx(ET, { value: m, children: /* @__PURE__ */ c.jsx(TT, { value: y, children: /* @__PURE__ */ c.jsxs(
    zf.Provider,
    {
      value: { editorVariant: n, userId: s, ltik: u },
      children: [
        a ? null : b(),
        /* @__PURE__ */ c.jsx(
          XG,
          {
            initialState: p.document,
            onChange: E,
            children: t
          }
        )
      ]
    }
  ) }) });
  function E({ getDocument: C }) {
    if (!r) return;
    const T = C();
    T && r({
      ...p,
      dateModified: tg(),
      editorVersion: ud(),
      document: T
    });
  }
  function b() {
    return /* @__PURE__ */ c.jsx("div", { className: "bg-editor-primary-100 px-1.5 py-0.5 text-sm", children: y.savedContentMightDisappearWarning });
  }
}
function HB(e) {
  const { language: t, _ltik: n, editorVariant: r } = {
    ...IB,
    ...e
  }, i = e.state ? e.state : qB(r), { migratedState: o } = $B(i, r), { staticStrings: a, editStrings: s } = PB[t], l = BB();
  return hu.init(l), e.handleLearnerEvent && ii.init(e.handleLearnerEvent), /* @__PURE__ */ c.jsx(ET, { value: a, children: /* @__PURE__ */ c.jsx(TT, { value: s, children: /* @__PURE__ */ c.jsx(zf.Provider, { value: { editorVariant: r, ltik: n }, children: /* @__PURE__ */ c.jsx(
    "div",
    {
      className: "serlo-content-with-spacing-fixes",
      "data-editor-version": ud(),
      children: /* @__PURE__ */ c.jsx(Nn, { document: o.document })
    }
  ) }) }) });
}
const $6e = i2(
  i7(L8, RB)
).reduce((e, t) => ({ ...e, [t.type]: t }), {}), H6e = i2(L8).reduce(
  (e, t) => ({ ...e, [t.type]: t }),
  {}
), V6e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EditorPluginType: Y,
  SerloEditor: q6e,
  SerloRenderer: HB,
  defaultPlugins: F8,
  pluginMenuDe: $6e,
  pluginMenuEn: H6e
}, Symbol.toStringTag, { value: "Module" }));
var VB = { exports: {} }, z2 = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var U6e = v, W6e = Symbol.for("react.element"), Z6e = Symbol.for("react.fragment"), G6e = Object.prototype.hasOwnProperty, K6e = U6e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, X6e = { key: !0, ref: !0, __self: !0, __source: !0 };
function UB(e, t, n) {
  var r, i = {}, o = null, a = null;
  n !== void 0 && (o = "" + n), t.key !== void 0 && (o = "" + t.key), t.ref !== void 0 && (a = t.ref);
  for (r in t) G6e.call(t, r) && !X6e.hasOwnProperty(r) && (i[r] = t[r]);
  if (e && e.defaultProps) for (r in t = e.defaultProps, t) i[r] === void 0 && (i[r] = t[r]);
  return { $$typeof: W6e, type: e, key: o, ref: a, props: i, _owner: K6e.current };
}
z2.Fragment = Z6e;
z2.jsx = UB;
z2.jsxs = UB;
VB.exports = z2;
var Xu = VB.exports;
const Q6e = `.react-resizable{position:relative}.react-resizable-handle{position:absolute;width:20px;height:20px;background-repeat:no-repeat;background-origin:content-box;box-sizing:border-box;background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+);background-position:bottom right;padding:0 3px 3px 0}.react-resizable-handle-sw{bottom:0;left:0;cursor:sw-resize;transform:rotate(90deg)}.react-resizable-handle-se{bottom:0;right:0;cursor:se-resize}.react-resizable-handle-nw{top:0;left:0;cursor:nw-resize;transform:rotate(180deg)}.react-resizable-handle-ne{top:0;right:0;cursor:ne-resize;transform:rotate(270deg)}.react-resizable-handle-w,.react-resizable-handle-e{top:50%;margin-top:-10px;cursor:ew-resize}.react-resizable-handle-w{left:0;transform:rotate(135deg)}.react-resizable-handle-e{right:0;transform:rotate(315deg)}.react-resizable-handle-n,.react-resizable-handle-s{left:50%;margin-left:-10px;cursor:ns-resize}.react-resizable-handle-n{top:0;transform:rotate(225deg)}.react-resizable-handle-s{bottom:0;transform:rotate(45deg)}.katex{font: 1.1em KaTeX_Main,sans-serif;line-height:1.4;text-indent:0;text-rendering:auto}.katex *{-ms-high-contrast-adjust:none!important;border-color:currentColor}.katex .katex-version:after{content:"0.13.11"}.katex .katex-mathml{position:absolute;clip:rect(1px,1px,1px,1px);padding:0;border:0;height:1px;width:1px;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;user-select:none}.katex .katex-html>.newline{display:block}.katex .base{position:relative;display:inline-block;white-space:nowrap;width:-moz-min-content;width:min-content}.katex .strut{display:inline-block}.katex .textbf{font-weight:700}.katex .textit{font-style:italic}.katex .textrm{font-family:KaTeX_Main}.katex .textsf{font-family:KaTeX_SansSerif}.katex .texttt{font-family:KaTeX_Typewriter}.katex .mathnormal{font-family:KaTeX_Math;font-style:italic}.katex .mathit{font-family:KaTeX_Main;font-style:italic}.katex .mathrm{font-style:normal}.katex .mathbf{font-family:KaTeX_Main;font-weight:700}.katex .boldsymbol{font-family:KaTeX_Math;font-weight:700;font-style:italic}.katex .amsrm,.katex .mathbb,.katex .textbb{font-family:KaTeX_AMS}.katex .mathcal{font-family:KaTeX_Caligraphic}.katex .mathfrak,.katex .textfrak{font-family:KaTeX_Fraktur}.katex .mathtt{font-family:KaTeX_Typewriter}.katex .mathscr,.katex .textscr{font-family:KaTeX_Script}.katex .mathsf,.katex .textsf{font-family:KaTeX_SansSerif}.katex .mathboldsf,.katex .textboldsf{font-family:KaTeX_SansSerif;font-weight:700}.katex .mathitsf,.katex .textitsf{font-family:KaTeX_SansSerif;font-style:italic}.katex .mainrm{font-family:KaTeX_Main;font-style:normal}.katex .vlist-t{display:inline-table;table-layout:fixed;border-collapse:collapse}.katex .vlist-r{display:table-row}.katex .vlist{display:table-cell;vertical-align:bottom;position:relative}.katex .vlist>span{display:block;height:0;position:relative}.katex .vlist>span>span{display:inline-block}.katex .vlist>span>.pstrut{overflow:hidden;width:0}.katex .vlist-t2{margin-right:-2px}.katex .vlist-s{display:table-cell;vertical-align:bottom;font-size:1px;width:2px;min-width:2px}.katex .vbox{display:inline-flex;flex-direction:column;align-items:baseline}.katex .hbox{display:inline-flex;flex-direction:row;width:100%}.katex .thinbox{display:inline-flex;flex-direction:row;width:0;max-width:0}.katex .msupsub{text-align:left}.katex .mfrac>span>span{text-align:center}.katex .mfrac .frac-line{display:inline-block;width:100%;border-bottom-style:solid}.katex .mfrac .frac-line,.katex .overline .overline-line,.katex .underline .underline-line,.katex .hline,.katex .hdashline,.katex .rule{min-height:1px}.katex .mspace{display:inline-block}.katex .llap,.katex .rlap,.katex .clap{width:0;position:relative}.katex .llap>.inner,.katex .rlap>.inner,.katex .clap>.inner{position:absolute}.katex .llap>.fix,.katex .rlap>.fix,.katex .clap>.fix{display:inline-block}.katex .llap>.inner{right:0}.katex .rlap>.inner,.katex .clap>.inner{left:0}.katex .clap>.inner>span{margin-left:-50%;margin-right:50%}.katex .rule{display:inline-block;border:solid 0;position:relative}.katex .overline .overline-line,.katex .underline .underline-line,.katex .hline{display:inline-block;width:100%;border-bottom-style:solid}.katex .hdashline{display:inline-block;width:100%;border-bottom-style:dashed}.katex .sqrt>.root{margin-left:.27777778em;margin-right:-.55555556em}.katex .sizing.reset-size1.size1,.katex .fontsize-ensurer.reset-size1.size1{font-size:1em}.katex .sizing.reset-size1.size2,.katex .fontsize-ensurer.reset-size1.size2{font-size:1.2em}.katex .sizing.reset-size1.size3,.katex .fontsize-ensurer.reset-size1.size3{font-size:1.4em}.katex .sizing.reset-size1.size4,.katex .fontsize-ensurer.reset-size1.size4{font-size:1.6em}.katex .sizing.reset-size1.size5,.katex .fontsize-ensurer.reset-size1.size5{font-size:1.8em}.katex .sizing.reset-size1.size6,.katex .fontsize-ensurer.reset-size1.size6{font-size:2em}.katex .sizing.reset-size1.size7,.katex .fontsize-ensurer.reset-size1.size7{font-size:2.4em}.katex .sizing.reset-size1.size8,.katex .fontsize-ensurer.reset-size1.size8{font-size:2.88em}.katex .sizing.reset-size1.size9,.katex .fontsize-ensurer.reset-size1.size9{font-size:3.456em}.katex .sizing.reset-size1.size10,.katex .fontsize-ensurer.reset-size1.size10{font-size:4.148em}.katex .sizing.reset-size1.size11,.katex .fontsize-ensurer.reset-size1.size11{font-size:4.976em}.katex .sizing.reset-size2.size1,.katex .fontsize-ensurer.reset-size2.size1{font-size:.83333333em}.katex .sizing.reset-size2.size2,.katex .fontsize-ensurer.reset-size2.size2{font-size:1em}.katex .sizing.reset-size2.size3,.katex .fontsize-ensurer.reset-size2.size3{font-size:1.16666667em}.katex .sizing.reset-size2.size4,.katex .fontsize-ensurer.reset-size2.size4{font-size:1.33333333em}.katex .sizing.reset-size2.size5,.katex .fontsize-ensurer.reset-size2.size5{font-size:1.5em}.katex .sizing.reset-size2.size6,.katex .fontsize-ensurer.reset-size2.size6{font-size:1.66666667em}.katex .sizing.reset-size2.size7,.katex .fontsize-ensurer.reset-size2.size7{font-size:2em}.katex .sizing.reset-size2.size8,.katex .fontsize-ensurer.reset-size2.size8{font-size:2.4em}.katex .sizing.reset-size2.size9,.katex .fontsize-ensurer.reset-size2.size9{font-size:2.88em}.katex .sizing.reset-size2.size10,.katex .fontsize-ensurer.reset-size2.size10{font-size:3.45666667em}.katex .sizing.reset-size2.size11,.katex .fontsize-ensurer.reset-size2.size11{font-size:4.14666667em}.katex .sizing.reset-size3.size1,.katex .fontsize-ensurer.reset-size3.size1{font-size:.71428571em}.katex .sizing.reset-size3.size2,.katex .fontsize-ensurer.reset-size3.size2{font-size:.85714286em}.katex .sizing.reset-size3.size3,.katex .fontsize-ensurer.reset-size3.size3{font-size:1em}.katex .sizing.reset-size3.size4,.katex .fontsize-ensurer.reset-size3.size4{font-size:1.14285714em}.katex .sizing.reset-size3.size5,.katex .fontsize-ensurer.reset-size3.size5{font-size:1.28571429em}.katex .sizing.reset-size3.size6,.katex .fontsize-ensurer.reset-size3.size6{font-size:1.42857143em}.katex .sizing.reset-size3.size7,.katex .fontsize-ensurer.reset-size3.size7{font-size:1.71428571em}.katex .sizing.reset-size3.size8,.katex .fontsize-ensurer.reset-size3.size8{font-size:2.05714286em}.katex .sizing.reset-size3.size9,.katex .fontsize-ensurer.reset-size3.size9{font-size:2.46857143em}.katex .sizing.reset-size3.size10,.katex .fontsize-ensurer.reset-size3.size10{font-size:2.96285714em}.katex .sizing.reset-size3.size11,.katex .fontsize-ensurer.reset-size3.size11{font-size:3.55428571em}.katex .sizing.reset-size4.size1,.katex .fontsize-ensurer.reset-size4.size1{font-size:.625em}.katex .sizing.reset-size4.size2,.katex .fontsize-ensurer.reset-size4.size2{font-size:.75em}.katex .sizing.reset-size4.size3,.katex .fontsize-ensurer.reset-size4.size3{font-size:.875em}.katex .sizing.reset-size4.size4,.katex .fontsize-ensurer.reset-size4.size4{font-size:1em}.katex .sizing.reset-size4.size5,.katex .fontsize-ensurer.reset-size4.size5{font-size:1.125em}.katex .sizing.reset-size4.size6,.katex .fontsize-ensurer.reset-size4.size6{font-size:1.25em}.katex .sizing.reset-size4.size7,.katex .fontsize-ensurer.reset-size4.size7{font-size:1.5em}.katex .sizing.reset-size4.size8,.katex .fontsize-ensurer.reset-size4.size8{font-size:1.8em}.katex .sizing.reset-size4.size9,.katex .fontsize-ensurer.reset-size4.size9{font-size:2.16em}.katex .sizing.reset-size4.size10,.katex .fontsize-ensurer.reset-size4.size10{font-size:2.5925em}.katex .sizing.reset-size4.size11,.katex .fontsize-ensurer.reset-size4.size11{font-size:3.11em}.katex .sizing.reset-size5.size1,.katex .fontsize-ensurer.reset-size5.size1{font-size:.55555556em}.katex .sizing.reset-size5.size2,.katex .fontsize-ensurer.reset-size5.size2{font-size:.66666667em}.katex .sizing.reset-size5.size3,.katex .fontsize-ensurer.reset-size5.size3{font-size:.77777778em}.katex .sizing.reset-size5.size4,.katex .fontsize-ensurer.reset-size5.size4{font-size:.88888889em}.katex .sizing.reset-size5.size5,.katex .fontsize-ensurer.reset-size5.size5{font-size:1em}.katex .sizing.reset-size5.size6,.katex .fontsize-ensurer.reset-size5.size6{font-size:1.11111111em}.katex .sizing.reset-size5.size7,.katex .fontsize-ensurer.reset-size5.size7{font-size:1.33333333em}.katex .sizing.reset-size5.size8,.katex .fontsize-ensurer.reset-size5.size8{font-size:1.6em}.katex .sizing.reset-size5.size9,.katex .fontsize-ensurer.reset-size5.size9{font-size:1.92em}.katex .sizing.reset-size5.size10,.katex .fontsize-ensurer.reset-size5.size10{font-size:2.30444444em}.katex .sizing.reset-size5.size11,.katex .fontsize-ensurer.reset-size5.size11{font-size:2.76444444em}.katex .sizing.reset-size6.size1,.katex .fontsize-ensurer.reset-size6.size1{font-size:.5em}.katex .sizing.reset-size6.size2,.katex .fontsize-ensurer.reset-size6.size2{font-size:.6em}.katex .sizing.reset-size6.size3,.katex .fontsize-ensurer.reset-size6.size3{font-size:.7em}.katex .sizing.reset-size6.size4,.katex .fontsize-ensurer.reset-size6.size4{font-size:.8em}.katex .sizing.reset-size6.size5,.katex .fontsize-ensurer.reset-size6.size5{font-size:.9em}.katex .sizing.reset-size6.size6,.katex .fontsize-ensurer.reset-size6.size6{font-size:1em}.katex .sizing.reset-size6.size7,.katex .fontsize-ensurer.reset-size6.size7{font-size:1.2em}.katex .sizing.reset-size6.size8,.katex .fontsize-ensurer.reset-size6.size8{font-size:1.44em}.katex .sizing.reset-size6.size9,.katex .fontsize-ensurer.reset-size6.size9{font-size:1.728em}.katex .sizing.reset-size6.size10,.katex .fontsize-ensurer.reset-size6.size10{font-size:2.074em}.katex .sizing.reset-size6.size11,.katex .fontsize-ensurer.reset-size6.size11{font-size:2.488em}.katex .sizing.reset-size7.size1,.katex .fontsize-ensurer.reset-size7.size1{font-size:.41666667em}.katex .sizing.reset-size7.size2,.katex .fontsize-ensurer.reset-size7.size2{font-size:.5em}.katex .sizing.reset-size7.size3,.katex .fontsize-ensurer.reset-size7.size3{font-size:.58333333em}.katex .sizing.reset-size7.size4,.katex .fontsize-ensurer.reset-size7.size4{font-size:.66666667em}.katex .sizing.reset-size7.size5,.katex .fontsize-ensurer.reset-size7.size5{font-size:.75em}.katex .sizing.reset-size7.size6,.katex .fontsize-ensurer.reset-size7.size6{font-size:.83333333em}.katex .sizing.reset-size7.size7,.katex .fontsize-ensurer.reset-size7.size7{font-size:1em}.katex .sizing.reset-size7.size8,.katex .fontsize-ensurer.reset-size7.size8{font-size:1.2em}.katex .sizing.reset-size7.size9,.katex .fontsize-ensurer.reset-size7.size9{font-size:1.44em}.katex .sizing.reset-size7.size10,.katex .fontsize-ensurer.reset-size7.size10{font-size:1.72833333em}.katex .sizing.reset-size7.size11,.katex .fontsize-ensurer.reset-size7.size11{font-size:2.07333333em}.katex .sizing.reset-size8.size1,.katex .fontsize-ensurer.reset-size8.size1{font-size:.34722222em}.katex .sizing.reset-size8.size2,.katex .fontsize-ensurer.reset-size8.size2{font-size:.41666667em}.katex .sizing.reset-size8.size3,.katex .fontsize-ensurer.reset-size8.size3{font-size:.48611111em}.katex .sizing.reset-size8.size4,.katex .fontsize-ensurer.reset-size8.size4{font-size:.55555556em}.katex .sizing.reset-size8.size5,.katex .fontsize-ensurer.reset-size8.size5{font-size:.625em}.katex .sizing.reset-size8.size6,.katex .fontsize-ensurer.reset-size8.size6{font-size:.69444444em}.katex .sizing.reset-size8.size7,.katex .fontsize-ensurer.reset-size8.size7{font-size:.83333333em}.katex .sizing.reset-size8.size8,.katex .fontsize-ensurer.reset-size8.size8{font-size:1em}.katex .sizing.reset-size8.size9,.katex .fontsize-ensurer.reset-size8.size9{font-size:1.2em}.katex .sizing.reset-size8.size10,.katex .fontsize-ensurer.reset-size8.size10{font-size:1.44027778em}.katex .sizing.reset-size8.size11,.katex .fontsize-ensurer.reset-size8.size11{font-size:1.72777778em}.katex .sizing.reset-size9.size1,.katex .fontsize-ensurer.reset-size9.size1{font-size:.28935185em}.katex .sizing.reset-size9.size2,.katex .fontsize-ensurer.reset-size9.size2{font-size:.34722222em}.katex .sizing.reset-size9.size3,.katex .fontsize-ensurer.reset-size9.size3{font-size:.40509259em}.katex .sizing.reset-size9.size4,.katex .fontsize-ensurer.reset-size9.size4{font-size:.46296296em}.katex .sizing.reset-size9.size5,.katex .fontsize-ensurer.reset-size9.size5{font-size:.52083333em}.katex .sizing.reset-size9.size6,.katex .fontsize-ensurer.reset-size9.size6{font-size:.5787037em}.katex .sizing.reset-size9.size7,.katex .fontsize-ensurer.reset-size9.size7{font-size:.69444444em}.katex .sizing.reset-size9.size8,.katex .fontsize-ensurer.reset-size9.size8{font-size:.83333333em}.katex .sizing.reset-size9.size9,.katex .fontsize-ensurer.reset-size9.size9{font-size:1em}.katex .sizing.reset-size9.size10,.katex .fontsize-ensurer.reset-size9.size10{font-size:1.20023148em}.katex .sizing.reset-size9.size11,.katex .fontsize-ensurer.reset-size9.size11{font-size:1.43981481em}.katex .sizing.reset-size10.size1,.katex .fontsize-ensurer.reset-size10.size1{font-size:.24108004em}.katex .sizing.reset-size10.size2,.katex .fontsize-ensurer.reset-size10.size2{font-size:.28929605em}.katex .sizing.reset-size10.size3,.katex .fontsize-ensurer.reset-size10.size3{font-size:.33751205em}.katex .sizing.reset-size10.size4,.katex .fontsize-ensurer.reset-size10.size4{font-size:.38572806em}.katex .sizing.reset-size10.size5,.katex .fontsize-ensurer.reset-size10.size5{font-size:.43394407em}.katex .sizing.reset-size10.size6,.katex .fontsize-ensurer.reset-size10.size6{font-size:.48216008em}.katex .sizing.reset-size10.size7,.katex .fontsize-ensurer.reset-size10.size7{font-size:.57859209em}.katex .sizing.reset-size10.size8,.katex .fontsize-ensurer.reset-size10.size8{font-size:.69431051em}.katex .sizing.reset-size10.size9,.katex .fontsize-ensurer.reset-size10.size9{font-size:.83317261em}.katex .sizing.reset-size10.size10,.katex .fontsize-ensurer.reset-size10.size10{font-size:1em}.katex .sizing.reset-size10.size11,.katex .fontsize-ensurer.reset-size10.size11{font-size:1.19961427em}.katex .sizing.reset-size11.size1,.katex .fontsize-ensurer.reset-size11.size1{font-size:.20096463em}.katex .sizing.reset-size11.size2,.katex .fontsize-ensurer.reset-size11.size2{font-size:.24115756em}.katex .sizing.reset-size11.size3,.katex .fontsize-ensurer.reset-size11.size3{font-size:.28135048em}.katex .sizing.reset-size11.size4,.katex .fontsize-ensurer.reset-size11.size4{font-size:.32154341em}.katex .sizing.reset-size11.size5,.katex .fontsize-ensurer.reset-size11.size5{font-size:.36173633em}.katex .sizing.reset-size11.size6,.katex .fontsize-ensurer.reset-size11.size6{font-size:.40192926em}.katex .sizing.reset-size11.size7,.katex .fontsize-ensurer.reset-size11.size7{font-size:.48231511em}.katex .sizing.reset-size11.size8,.katex .fontsize-ensurer.reset-size11.size8{font-size:.57877814em}.katex .sizing.reset-size11.size9,.katex .fontsize-ensurer.reset-size11.size9{font-size:.69453376em}.katex .sizing.reset-size11.size10,.katex .fontsize-ensurer.reset-size11.size10{font-size:.83360129em}.katex .sizing.reset-size11.size11,.katex .fontsize-ensurer.reset-size11.size11{font-size:1em}.katex .delimsizing.size1{font-family:KaTeX_Size1}.katex .delimsizing.size2{font-family:KaTeX_Size2}.katex .delimsizing.size3{font-family:KaTeX_Size3}.katex .delimsizing.size4{font-family:KaTeX_Size4}.katex .delimsizing.mult .delim-size1>span{font-family:KaTeX_Size1}.katex .delimsizing.mult .delim-size4>span{font-family:KaTeX_Size4}.katex .nulldelimiter{display:inline-block;width:.12em}.katex .delimcenter,.katex .op-symbol{position:relative}.katex .op-symbol.small-op{font-family:KaTeX_Size1}.katex .op-symbol.large-op{font-family:KaTeX_Size2}.katex .op-limits>.vlist-t{text-align:center}.katex .accent>.vlist-t{text-align:center}.katex .accent .accent-body{position:relative}.katex .accent .accent-body:not(.accent-full){width:0}.katex .overlay{display:block}.katex .mtable .vertical-separator{display:inline-block;min-width:1px}.katex .mtable .arraycolsep{display:inline-block}.katex .mtable .col-align-c>.vlist-t{text-align:center}.katex .mtable .col-align-l>.vlist-t{text-align:left}.katex .mtable .col-align-r>.vlist-t{text-align:right}.katex .svg-align{text-align:left}.katex svg{display:block;position:absolute;width:100%;height:inherit;fill:currentColor;stroke:currentColor;fill-rule:nonzero;fill-opacity:1;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1}.katex svg path{stroke:none}.katex img{border-style:none;min-width:0;min-height:0;max-width:none;max-height:none}.katex .stretchy{width:100%;display:block;position:relative;overflow:hidden}.katex .stretchy:before,.katex .stretchy:after{content:""}.katex .hide-tail{width:100%;position:relative;overflow:hidden}.katex .halfarrow-left{position:absolute;left:0;width:50.2%;overflow:hidden}.katex .halfarrow-right{position:absolute;right:0;width:50.2%;overflow:hidden}.katex .brace-left{position:absolute;left:0;width:25.1%;overflow:hidden}.katex .brace-center{position:absolute;left:25%;width:50%;overflow:hidden}.katex .brace-right{position:absolute;right:0;width:25.1%;overflow:hidden}.katex .x-arrow-pad{padding:0 .5em}.katex .cd-arrow-pad{padding:0 .55556em 0 .27778em}.katex .x-arrow,.katex .mover,.katex .munder{text-align:center}.katex .boxpad{padding:0 .3em}.katex .fbox,.katex .fcolorbox{box-sizing:border-box;border:.04em solid}.katex .cancel-pad{padding:0 .2em}.katex .cancel-lap{margin-left:-.2em;margin-right:-.2em}.katex .sout{border-bottom-style:solid;border-bottom-width:.08em}.katex .angl{box-sizing:border-content;border-top:.049em solid;border-right:.049em solid;margin-right:.03889em}.katex .anglpad{padding:0 .03889em}.katex .eqn-num:before{counter-increment:katexEqnNo;content:"(" counter(katexEqnNo) ")"}.katex .mml-eqn-num:before{counter-increment:mmlEqnNo;content:"(" counter(mmlEqnNo) ")"}.katex .mtr-glue{width:50%}.katex .cd-vert-arrow{display:inline-block;position:relative}.katex .cd-label-left{display:inline-block;position:absolute;right:calc(50% + .3em);text-align:left}.katex .cd-label-right{display:inline-block;position:absolute;left:calc(50% + .3em);text-align:right}.katex-display{display:block;margin:1em 0;text-align:center}.katex-display>.katex{display:block;text-align:center;white-space:nowrap}.katex-display>.katex>.katex-html{display:block;position:relative}.katex-display>.katex>.katex-html>.tag{position:absolute;right:0}.katex-display.leqno>.katex>.katex-html>.tag{left:0;right:auto}.katex-display.fleqn>.katex{text-align:left;padding-left:2em}body{counter-reset:katexEqnNo mmlEqnNo}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e5e5}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#a3a3a3}input::placeholder,textarea::placeholder{opacity:1;color:#a3a3a3}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}.editor-core{all:initial;display:block;font-size:1rem;line-height:1.5rem;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;margin:0;border-width:0px;padding:0;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";line-height:1.5}.\\!container{width:100%!important}.container{width:100%}@media (min-width: 500px){.\\!container{max-width:500px!important}.container{max-width:500px}}@media (min-width: 550px){.\\!container{max-width:550px!important}.container{max-width:550px}}@media (min-width: 800px){.\\!container{max-width:800px!important}.container{max-width:800px}}@media (min-width: 1024px){.\\!container{max-width:1024px!important}.container{max-width:1024px}}@media (min-width: 1216px){.\\!container{max-width:1216px!important}.container{max-width:1216px}}@media (min-width: 1300px){.\\!container{max-width:1300px!important}.container{max-width:1300px}}@media (min-width: 1436px){.\\!container{max-width:1436px!important}.container{max-width:1436px}}.serlo-link{overflow-wrap:break-word;--tw-text-opacity: 1;color:rgb(0 118 185 / var(--tw-text-opacity, 1));text-decoration-line:none}.serlo-link:hover{text-decoration-line:underline}.serlo-p{margin:0 16px 30px;-webkit-hyphens:auto;hyphens:auto;font-size:1.125rem;line-height:1.75rem;line-height:1.33}.serlo-h1{margin-left:16px;margin-right:16px;margin-bottom:2.25rem;margin-top:1rem;padding:0;font-size:2rem;line-height:1.22;font-weight:700}.serlo-h2{margin-left:16px;margin-right:16px;margin-bottom:1.5rem;margin-top:0;padding-bottom:.25rem;padding-top:1.5rem;-webkit-hyphens:auto;hyphens:auto;font-size:1.7rem;line-height:1.22;font-weight:700;border-bottom-width:1px;--tw-border-opacity: 1;border-color:rgb(212 212 212 / var(--tw-border-opacity, 1));--tw-text-opacity: 1;color:rgb(23 23 23 / var(--tw-text-opacity, 1))}.serlo-h3{margin-left:16px;margin-right:16px;margin-bottom:2rem;margin-top:0;padding-top:.75rem;font-size:1.3125rem;line-height:1.22;font-weight:700;--tw-text-opacity: 1;color:rgb(23 23 23 / var(--tw-text-opacity, 1))}.serlo-h4{margin-left:16px;margin-right:16px;margin-bottom:1.25rem;margin-top:0;font-size:1.1875rem;line-height:1.22;font-weight:700}.serlo-button-edit{display:inline-block;border-radius:.375rem;padding:.25rem .5rem;transition-property:all;cursor:pointer;border-style:none;font-weight:700;text-decoration-line:none;font-size:1.125rem;line-height:1.75rem;line-height:normal;letter-spacing:-.006em;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);animation-duration:.2s;animation-timing-function:cubic-bezier(.4,0,.2,1)}.serlo-button-edit:hover{text-decoration-line:none}.serlo-button-edit:focus-visible{outline-style:dashed;outline-width:2px;outline-color:#007ec1}.serlo-button-round{aspect-ratio:1 / 1;border-radius:9999px!important}.serlo-button-learner-primary{display:inline-block;border-radius:4rem;padding:.25rem .5rem;transition-property:all;cursor:pointer;border-style:none;font-weight:700;text-decoration-line:none;font-size:1.125rem;line-height:1.75rem;line-height:normal;letter-spacing:-.006em;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);animation-duration:.2s;animation-timing-function:cubic-bezier(.4,0,.2,1)}.serlo-button-learner-primary:hover{text-decoration-line:none}.serlo-button-learner-primary:focus-visible{outline-style:dashed;outline-width:2px;outline-color:#007ec1}.serlo-button-learner-primary{--tw-bg-opacity: 1;background-color:rgb(0 126 193 / var(--tw-bg-opacity, 1));--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.serlo-button-learner-primary:hover{--tw-bg-opacity: 1;background-color:rgb(81 165 209 / var(--tw-bg-opacity, 1))}.serlo-button-learner-secondary{display:inline-block;border-radius:4rem;padding:.25rem .5rem;transition-property:all;cursor:pointer;border-style:none;font-weight:700;text-decoration-line:none;font-size:1.125rem;line-height:1.75rem;line-height:normal;letter-spacing:-.006em;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);animation-duration:.2s;animation-timing-function:cubic-bezier(.4,0,.2,1)}.serlo-button-learner-secondary:hover{text-decoration-line:none}.serlo-button-learner-secondary:focus-visible{outline-style:dashed;outline-width:2px;outline-color:#007ec1}.serlo-button-learner-secondary{--tw-bg-opacity: 1;background-color:rgb(239 247 251 / var(--tw-bg-opacity, 1));--tw-text-opacity: 1;color:rgb(0 118 185 / var(--tw-text-opacity, 1))}.serlo-button-learner-secondary:hover{--tw-bg-opacity: 1;background-color:rgb(0 126 193 / var(--tw-bg-opacity, 1));--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.serlo-button-learner-transparent{display:inline-block;border-radius:4rem;padding:.25rem .5rem;transition-property:all;cursor:pointer;border-style:none;font-weight:700;text-decoration-line:none;font-size:1.125rem;line-height:1.75rem;line-height:normal;letter-spacing:-.006em;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);animation-duration:.2s;animation-timing-function:cubic-bezier(.4,0,.2,1)}.serlo-button-learner-transparent:hover{text-decoration-line:none}.serlo-button-learner-transparent:focus-visible{outline-style:dashed;outline-width:2px;outline-color:#007ec1}.serlo-button-learner-transparent{background-color:transparent;--tw-text-opacity: 1;color:rgb(0 126 193 / var(--tw-text-opacity, 1))}.serlo-button-learner-transparent:hover{--tw-bg-opacity: 1;background-color:rgb(0 118 185 / var(--tw-bg-opacity, 1));--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.serlo-button-edit-primary{display:inline-block;border-radius:.375rem;padding:.25rem .5rem;transition-property:all;cursor:pointer;border-style:none;font-weight:700;text-decoration-line:none;font-size:1.125rem;line-height:1.75rem;line-height:normal;letter-spacing:-.006em;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);animation-duration:.2s;animation-timing-function:cubic-bezier(.4,0,.2,1)}.serlo-button-edit-primary:hover{text-decoration-line:none}.serlo-button-edit-primary:focus-visible{outline-style:dashed;outline-width:2px;outline-color:#007ec1}.serlo-button-edit-primary{--tw-bg-opacity: 1;background-color:rgb(255 218 163 / var(--tw-bg-opacity, 1));--tw-text-opacity: 1;color:rgb(64 64 64 / var(--tw-text-opacity, 1))}.serlo-button-edit-primary:hover{--tw-bg-opacity: 1;background-color:rgb(255 190 94 / var(--tw-bg-opacity, 1))}.serlo-button-edit-secondary{display:inline-block;border-radius:.375rem;padding:.25rem .5rem;transition-property:all;cursor:pointer;border-style:none;font-weight:700;text-decoration-line:none;font-size:1.125rem;line-height:1.75rem;line-height:normal;letter-spacing:-.006em;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);animation-duration:.2s;animation-timing-function:cubic-bezier(.4,0,.2,1)}.serlo-button-edit-secondary:hover{text-decoration-line:none}.serlo-button-edit-secondary:focus-visible{outline-style:dashed;outline-width:2px;outline-color:#007ec1}.serlo-button-edit-secondary{--tw-bg-opacity: 1;background-color:rgb(255 241 219 / var(--tw-bg-opacity, 1));--tw-text-opacity: 1;color:rgb(64 64 64 / var(--tw-text-opacity, 1))}.serlo-button-edit-secondary:hover{--tw-bg-opacity: 1;background-color:rgb(255 218 163 / var(--tw-bg-opacity, 1))}.serlo-modal{position:fixed;left:50%;max-width:85%;--tw-translate-x: -50%;--tw-translate-y: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));bottom:0;top:40%;height:-moz-fit-content;height:fit-content;width:500px;outline:2px solid transparent;outline-offset:2px;border-radius:.75rem;border-style:none;--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1));padding:.625rem .625rem 2.5rem;--tw-shadow: 0px 0px 10px 0px rgba(0, 0, 0, .25);--tw-shadow-colored: 0px 0px 10px 0px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow);z-index:101}.serlo-table{margin-left:16px;margin-right:16px;border-collapse:separate;--tw-border-spacing-x: 0px;--tw-border-spacing-y: 0px;border-spacing:var(--tw-border-spacing-x) var(--tw-border-spacing-y);-webkit-hyphens:auto;hyphens:auto;white-space:nowrap;overflow-wrap:normal;word-break:normal;--tw-border-opacity: 1;border-color:rgb(217 235 245 / var(--tw-border-opacity, 1))}@media (min-width: 800px){.serlo-table{white-space:normal}}.serlo-th{border-bottom-width:3px;border-right-width:3px;--tw-border-opacity: 1;border-color:rgb(217 235 245 / var(--tw-border-opacity, 1));--tw-bg-opacity: 1;background-color:rgb(239 247 251 / var(--tw-bg-opacity, 1));padding:.375rem .375rem .375rem .75rem;text-align:left}.serlo-td{border-bottom-width:3px;border-right-width:3px;--tw-border-opacity: 1;border-color:rgb(217 235 245 / var(--tw-border-opacity, 1));padding:.375rem;vertical-align:top}.serlo-td>p.serlo-p{margin-left:0;margin-right:0}.serlo-ul{margin-left:16px;margin-right:16px;margin-bottom:30px;margin-top:1rem;list-style-type:none;padding-left:1.25rem}.serlo-ul>li:before{position:absolute;--tw-bg-opacity: 1;background-color:rgb(142 197 226 / var(--tw-bg-opacity, 1));--tw-content: " ";content:var(--tw-content);margin-left:-1.25rem;margin-top:9px;height:.625rem;width:.625rem;border-radius:9999px}.serlo-ul>li{margin-bottom:.5rem}.serlo-ul>li>ul,.serlo-ul>li>ol{margin-bottom:1rem!important;margin-top:.5rem}.serlo-ol{margin:0 16px 30px;list-style-type:none;padding-left:1.5rem;counter-reset:list-counter}.serlo-ol>li:before{position:absolute;--tw-content: counter(list-counter);content:var(--tw-content);counter-increment:list-counter;margin-left:-1.5rem;border-radius:9999px;text-align:center;font-weight:700;margin-top:.125rem;height:17px;width:17px;--tw-bg-opacity: 1;background-color:rgb(230 242 249 / var(--tw-bg-opacity, 1));font-size:.75rem;line-height:1rem;padding-top:1px;line-height:1.25;--tw-text-opacity: 1;color:rgb(0 118 185 / var(--tw-text-opacity, 1))}.serlo-ol>li{margin-bottom:.5rem}.serlo-ol>li>ul,.serlo-ol>li>ol{margin-bottom:1rem!important;margin-top:.5rem}.serlo-sub-list-hover{margin:0;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1));padding:.75rem 1rem .75rem .625rem;display:block;width:auto;list-style-type:none;overflow:auto;text-align:left;border-radius:.5rem;--tw-shadow: rgba(0, 0, 0, .2) 0px 2px 4px;--tw-shadow-colored: 0px 2px 4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow);min-width:180px;--tw-bg-opacity: 1;background-color:rgb(244 249 252 / var(--tw-bg-opacity, 1))}.serlo-img{display:inline;height:auto;max-width:100%;border-radius:.375rem}.serlo-solution-box{margin-left:16px;margin-right:16px;margin-bottom:30px;border-left-width:8px;--tw-border-opacity: 1;border-color:rgb(217 235 245 / var(--tw-border-opacity, 1));padding-top:.625rem;padding-bottom:.625rem}.serlo-exercise-wrapper{margin-bottom:.625rem;margin-top:2.5rem}@media (hoverhover){.serlo-exercise-wrapper input{opacity:.2;transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.serlo-exercise-wrapper:hover input{opacity:1}}.serlo-exercise-wrapper .serlo-input-font-reset{font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-size:1rem;line-height:1.5rem;letter-spacing:-.006em}.serlo-exercise-wrapper .serlo-input-font-reset:focus-visible{outline-style:dashed;outline-width:2px;outline-color:#007ec1}.serlo-tooltip-trigger{position:relative}.serlo-tooltip-trigger:hover>.serlo-tooltip,.serlo-tooltip-trigger:focus>.serlo-tooltip{position:static;width:auto;height:auto;padding:0;margin:0;overflow:visible;clip:auto;white-space:normal;position:absolute;z-index:23;padding-bottom:.7rem;opacity:.9}.serlo-content-with-spacing-fixes{overflow-wrap:break-word}.serlo-content-with-spacing-fixes p:not(.slate-p)+ul{margin-top:-.875rem}.serlo-content-with-spacing-fixes li>p,.serlo-content-with-spacing-fixes li>.slate-container>p{margin-left:0;margin-right:0;margin-bottom:.5rem}.serlo-content-with-spacing-fixes li>.serlo-math-wrapper{padding-left:0;padding-right:0}.serlo-content-with-spacing-fixes .serlo-solution-box>p:last-child,.serlo-content-with-spacing-fixes .serlo-solution-box>.serlo-math-wrapper:last-child,.serlo-content-with-spacing-fixes .serlo-solution-box>ul:last-child,.serlo-content-with-spacing-fixes .serlo-solution-box>ol:last-child,.serlo-content-with-spacing-fixes .serlo-solution-box>figure:last-child,.serlo-content-with-spacing-fixes .serlo-solution-box>.serlo-exercise-wrapper:last-child,.serlo-content-with-spacing-fixes .serlo-solution-box>.slate-container:last-child,.serlo-content-with-spacing-fixes .serlo-box>p:last-child,.serlo-content-with-spacing-fixes .serlo-box>.serlo-math-wrapper:last-child,.serlo-content-with-spacing-fixes .serlo-box>ul:last-child,.serlo-content-with-spacing-fixes .serlo-box>ol:last-child,.serlo-content-with-spacing-fixes .serlo-box>figure:last-child,.serlo-content-with-spacing-fixes .serlo-box>.serlo-exercise-wrapper:last-child,.serlo-content-with-spacing-fixes .serlo-box>.slate-container:last-child,.serlo-content-with-spacing-fixes .serlo-box>blockquote>p:last-child,.serlo-content-with-spacing-fixes .serlo-box>blockquote>.serlo-math-wrapper:last-child,.serlo-content-with-spacing-fixes .serlo-box>blockquote>ul:last-child,.serlo-content-with-spacing-fixes .serlo-box>blockquote>ol:last-child,.serlo-content-with-spacing-fixes .serlo-box>blockquote>figure:last-child,.serlo-content-with-spacing-fixes .serlo-box>blockquote>.serlo-exercise-wrapper:last-child,.serlo-content-with-spacing-fixes .serlo-box>blockquote>.slate-container:last-child,.serlo-content-with-spacing-fixes .slate-container>p:last-child,.serlo-content-with-spacing-fixes .slate-container>.serlo-math-wrapper:last-child,.serlo-content-with-spacing-fixes .slate-container>ul:last-child,.serlo-content-with-spacing-fixes .slate-container>ol:last-child,.serlo-content-with-spacing-fixes .slate-container>figure:last-child,.serlo-content-with-spacing-fixes .slate-container>.serlo-exercise-wrapper:last-child,.serlo-content-with-spacing-fixes .slate-container>.slate-container:last-child,.serlo-content-with-spacing-fixes li>p:last-child,.serlo-content-with-spacing-fixes li>.serlo-math-wrapper:last-child,.serlo-content-with-spacing-fixes li>ul:last-child,.serlo-content-with-spacing-fixes li>ol:last-child,.serlo-content-with-spacing-fixes li>figure:last-child,.serlo-content-with-spacing-fixes li>.serlo-exercise-wrapper:last-child,.serlo-content-with-spacing-fixes li>.slate-container:last-child,.serlo-content-with-spacing-fixes th>p:last-child,.serlo-content-with-spacing-fixes th>.serlo-math-wrapper:last-child,.serlo-content-with-spacing-fixes th>ul:last-child,.serlo-content-with-spacing-fixes th>ol:last-child,.serlo-content-with-spacing-fixes th>figure:last-child,.serlo-content-with-spacing-fixes th>.serlo-exercise-wrapper:last-child,.serlo-content-with-spacing-fixes th>.slate-container:last-child,.serlo-content-with-spacing-fixes td>p:last-child,.serlo-content-with-spacing-fixes td>.serlo-math-wrapper:last-child,.serlo-content-with-spacing-fixes td>ul:last-child,.serlo-content-with-spacing-fixes td>ol:last-child,.serlo-content-with-spacing-fixes td>figure:last-child,.serlo-content-with-spacing-fixes td>.serlo-exercise-wrapper:last-child,.serlo-content-with-spacing-fixes td>.slate-container:last-child{margin-bottom:0}.serlo-content-with-spacing-fixes .serlo-solution-box>.serlo-math-wrapper:first-child,.serlo-content-with-spacing-fixes .serlo-box>.serlo-math-wrapper:first-child,.serlo-content-with-spacing-fixes .serlo-box>blockquote>.serlo-math-wrapper:first-child,.serlo-content-with-spacing-fixes .slate-container>.serlo-math-wrapper:first-child,.serlo-content-with-spacing-fixes li>.serlo-math-wrapper:first-child,.serlo-content-with-spacing-fixes th>.serlo-math-wrapper:first-child,.serlo-content-with-spacing-fixes td>.serlo-math-wrapper:first-child{margin-top:0}.serlo-content-with-spacing-fixes .serlo-solution-box>.serlo-exercise-wrapper:first-child,.serlo-content-with-spacing-fixes .serlo-box>.serlo-exercise-wrapper:first-child,.serlo-content-with-spacing-fixes .serlo-box>blockquote>.serlo-exercise-wrapper:first-child,.serlo-content-with-spacing-fixes .slate-container>.serlo-exercise-wrapper:first-child,.serlo-content-with-spacing-fixes li>.serlo-exercise-wrapper:first-child,.serlo-content-with-spacing-fixes th>.serlo-exercise-wrapper:first-child,.serlo-content-with-spacing-fixes td>.serlo-exercise-wrapper:first-child{margin-top:0}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.pointer-events-none{pointer-events:none}.pointer-events-auto{pointer-events:auto}.visible{visibility:visible}.invisible{visibility:hidden}.collapse{visibility:collapse}.static{position:static}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.sticky{position:sticky}.inset-0{top:0;right:0;bottom:0;left:0}.\\!-top-12{top:-3rem!important}.\\!left-0{left:0!important}.\\!right-\\[84px\\]{right:84px!important}.\\!top-\\[-30px\\]{top:-30px!important}.-bottom-1\\.5{bottom:-.375rem}.-left-0\\.5{left:-.125rem}.-left-2\\.5{left:-.625rem}.-left-24{left:-6rem}.-left-side{left:-16px}.-right-2\\.5{right:-.625rem}.-top-0\\.25{top:-1px}.-top-0\\.5{top:-.125rem}.-top-10{top:-2.5rem}.-top-4{top:-1rem}.-top-9{top:-2.25rem}.-top-\\[33px\\]{top:-33px}.-top-\\[9px\\]{top:-9px}.bottom-0{bottom:0}.bottom-14{bottom:3.5rem}.bottom-24{bottom:6rem}.bottom-\\[1\\.5px\\]{bottom:1.5px}.bottom-\\[5\\%\\]{bottom:5%}.bottom-full{bottom:100%}.left-0{left:0}.left-1\\/2{left:50%}.left-12{left:3rem}.left-2{left:.5rem}.left-3{left:.75rem}.left-8{left:2rem}.left-\\[1px\\]{left:1px}.left-\\[7px\\]{left:7px}.right-0{right:0}.right-1{right:.25rem}.right-10{right:2.5rem}.right-12{right:3rem}.right-16{right:4rem}.right-3\\.5{right:.875rem}.right-4{right:1rem}.right-6{right:1.5rem}.right-\\[1px\\]{right:1px}.right-\\[2\\%\\]{right:2%}.right-\\[3\\%\\]{right:3%}.top-0{top:0}.top-1\\/2{top:50%}.top-10{top:2.5rem}.top-2{top:.5rem}.top-28{top:7rem}.top-3{top:.75rem}.top-3\\.5{top:.875rem}.top-4{top:1rem}.top-6{top:1.5rem}.top-8{top:2rem}.top-\\[-33px\\]{top:-33px}.top-\\[-64px\\]{top:-64px}.top-\\[10\\%\\]{top:10%}.top-\\[31px\\]{top:31px}.top-\\[4\\%\\]{top:4%}.top-\\[5\\%\\]{top:5%}.top-\\[50\\%\\]{top:50%}.top-side{top:16px}.\\!z-\\[22\\]{z-index:22!important}.z-10{z-index:10}.z-20{z-index:20}.z-30{z-index:30}.z-40{z-index:40}.z-50{z-index:50}.z-\\[101\\]{z-index:101}.z-\\[1040\\]{z-index:1040}.z-\\[15\\]{z-index:15}.z-\\[21\\]{z-index:21}.z-\\[22\\]{z-index:22}.z-\\[2\\]{z-index:2}.z-\\[90\\]{z-index:90}.z-\\[95\\]{z-index:95}.col-span-2{grid-column:span 2 / span 2}.col-start-2{grid-column-start:2}.float-right{float:right}.m-0{margin:0}.m-1{margin:.25rem}.m-2{margin:.5rem}.m-\\[3px\\]{margin:3px}.m-auto{margin:auto}.m-side{margin:16px}.-mx-2{margin-left:-.5rem;margin-right:-.5rem}.mx-0{margin-left:0;margin-right:0}.mx-1{margin-left:.25rem;margin-right:.25rem}.mx-1\\.5{margin-left:.375rem;margin-right:.375rem}.mx-2{margin-left:.5rem;margin-right:.5rem}.mx-4{margin-left:1rem;margin-right:1rem}.mx-auto{margin-left:auto;margin-right:auto}.mx-side{margin-left:16px;margin-right:16px}.my-0{margin-top:0;margin-bottom:0}.my-1{margin-top:.25rem;margin-bottom:.25rem}.my-12{margin-top:3rem;margin-bottom:3rem}.my-3{margin-top:.75rem;margin-bottom:.75rem}.my-4{margin-top:1rem;margin-bottom:1rem}.my-5{margin-top:1.25rem;margin-bottom:1.25rem}.my-6{margin-top:1.5rem;margin-bottom:1.5rem}.my-8{margin-top:2rem;margin-bottom:2rem}.my-\\[1\\.45em\\]{margin-top:1.45em;margin-bottom:1.45em}.my-block{margin-top:30px;margin-bottom:30px}.\\!-ml-1{margin-left:-.25rem!important}.\\!-ml-2{margin-left:-.5rem!important}.\\!-ml-3{margin-left:-.75rem!important}.\\!mb-0{margin-bottom:0!important}.\\!mt-1{margin-top:.25rem!important}.-mb-6{margin-bottom:-1.5rem}.-ml-0\\.25{margin-left:-1px}.-ml-1{margin-left:-.25rem}.-ml-12{margin-left:-3rem}.-ml-2{margin-left:-.5rem}.-ml-4{margin-left:-1rem}.-ml-5{margin-left:-1.25rem}.-ml-7{margin-left:-1.75rem}.-ml-\\[7px\\]{margin-left:-7px}.-ml-side{margin-left:-16px}.-mt-1{margin-top:-.25rem}.-mt-1\\.5{margin-top:-.375rem}.-mt-10{margin-top:-2.5rem}.-mt-2{margin-top:-.5rem}.-mt-2\\.5{margin-top:-.625rem}.-mt-3{margin-top:-.75rem}.-mt-4{margin-top:-1rem}.-mt-5{margin-top:-1.25rem}.-mt-\\[1\\.45rem\\]{margin-top:-1.45rem}.-mt-\\[3px\\]{margin-top:-3px}.mb-0{margin-bottom:0}.mb-1{margin-bottom:.25rem}.mb-12{margin-bottom:3rem}.mb-16{margin-bottom:4rem}.mb-2{margin-bottom:.5rem}.mb-2\\.5{margin-bottom:.625rem}.mb-24{margin-bottom:6rem}.mb-3{margin-bottom:.75rem}.mb-4{margin-bottom:1rem}.mb-5{margin-bottom:1.25rem}.mb-6{margin-bottom:1.5rem}.mb-7{margin-bottom:1.75rem}.mb-8{margin-bottom:2rem}.mb-block{margin-bottom:30px}.ml-0{margin-left:0}.ml-0\\.5{margin-left:.125rem}.ml-1{margin-left:.25rem}.ml-2{margin-left:.5rem}.ml-2\\.5{margin-left:.625rem}.ml-3{margin-left:.75rem}.ml-3\\.5{margin-left:.875rem}.ml-4{margin-left:1rem}.ml-6{margin-left:1.5rem}.ml-8{margin-left:2rem}.ml-\\[-25px\\]{margin-left:-25px}.ml-\\[-8px\\]{margin-left:-8px}.ml-auto{margin-left:auto}.ml-side{margin-left:16px}.mr-0{margin-right:0}.mr-0\\.5{margin-right:.125rem}.mr-1{margin-right:.25rem}.mr-1\\.5{margin-right:.375rem}.mr-2{margin-right:.5rem}.mr-2\\.5{margin-right:.625rem}.mr-3{margin-right:.75rem}.mr-4{margin-right:1rem}.mr-\\[5px\\]{margin-right:5px}.mr-\\[7px\\]{margin-right:7px}.mr-auto{margin-right:auto}.mr-side{margin-right:16px}.mt-0{margin-top:0}.mt-0\\.5{margin-top:.125rem}.mt-1{margin-top:.25rem}.mt-1\\.5{margin-top:.375rem}.mt-10{margin-top:2.5rem}.mt-12{margin-top:3rem}.mt-16{margin-top:4rem}.mt-2{margin-top:.5rem}.mt-2\\.5{margin-top:.625rem}.mt-20{margin-top:5rem}.mt-24{margin-top:6rem}.mt-3{margin-top:.75rem}.mt-32{margin-top:8rem}.mt-4{margin-top:1rem}.mt-5{margin-top:1.25rem}.mt-6{margin-top:1.5rem}.mt-7{margin-top:1.75rem}.mt-8{margin-top:2rem}.mt-\\[-2px\\]{margin-top:-2px}.mt-\\[3px\\]{margin-top:3px}.mt-\\[3rem\\]{margin-top:3rem}.mt-auto{margin-top:auto}.mt-block{margin-top:30px}.mt-side{margin-top:16px}.box-content{box-sizing:content-box}.block{display:block}.inline-block{display:inline-block}.inline{display:inline}.flex{display:flex}.inline-flex{display:inline-flex}.table{display:table}.flow-root{display:flow-root}.grid{display:grid}.inline-grid{display:inline-grid}.list-item{display:list-item}.hidden{display:none}.aspect-\\[16\\/9\\]{aspect-ratio:16/9}.aspect-square{aspect-ratio:1 / 1}.h-10{height:2.5rem}.h-12{height:3rem}.h-14{height:3.5rem}.h-16{height:4rem}.h-20{height:5rem}.h-24{height:6rem}.h-4{height:1rem}.h-40{height:10rem}.h-5{height:1.25rem}.h-6{height:1.5rem}.h-7{height:1.75rem}.h-8{height:2rem}.h-9{height:2.25rem}.h-\\[15px\\]{height:15px}.h-\\[17px\\]{height:17px}.h-\\[19px\\]{height:19px}.h-\\[1em\\]{height:1em}.h-\\[25px\\]{height:25px}.h-\\[90\\%\\]{height:90%}.h-\\[calc\\(100\\%_-_5px\\)\\]{height:calc(100% - 5px)}.h-auto{height:auto}.h-fit{height:-moz-fit-content;height:fit-content}.h-full{height:100%}.max-h-6{max-height:1.5rem}.max-h-96{max-height:24rem}.max-h-\\[120px\\]{max-height:120px}.max-h-\\[4\\.5rem\\]{max-height:4.5rem}.max-h-\\[60vh\\]{max-height:60vh}.max-h-\\[80\\%\\]{max-height:80%}.max-h-\\[90vh\\]{max-height:90vh}.max-h-\\[calc\\(100vh-2rem\\)\\]{max-height:calc(100vh - 2rem)}.max-h-\\[calc\\(100vh-6rem\\)\\]{max-height:calc(100vh - 6rem)}.max-h-full{max-height:100%}.min-h-8{min-height:32px}.min-h-\\[1\\.33em\\]{min-height:1.33em}.min-h-\\[100px\\]{min-height:100px}.min-h-\\[10px\\]{min-height:10px}.min-h-screen{min-height:100vh}.w-0\\.25{width:1px}.w-1\\.5{width:.375rem}.w-1\\/2{width:50%}.w-1\\/4{width:25%}.w-1\\/5{width:20%}.w-10{width:2.5rem}.w-11{width:2.75rem}.w-12{width:3rem}.w-20{width:5rem}.w-24{width:6rem}.w-3{width:.75rem}.w-3\\.5{width:.875rem}.w-3\\/4{width:75%}.w-32{width:8rem}.w-4{width:1rem}.w-5{width:1.25rem}.w-6{width:1.5rem}.w-7{width:1.75rem}.w-8{width:2rem}.w-80{width:20rem}.w-9{width:2.25rem}.w-\\[10\\%\\]{width:10%}.w-\\[17px\\]{width:17px}.w-\\[19px\\]{width:19px}.w-\\[20\\%\\]{width:20%}.w-\\[25rem\\]{width:25rem}.w-\\[27rem\\]{width:27rem}.w-\\[2px\\]{width:2px}.w-\\[460px\\]{width:460px}.w-\\[50vw\\]{width:50vw}.w-\\[60\\%\\]{width:60%}.w-\\[70\\%\\]{width:70%}.w-\\[700px\\]{width:700px}.w-\\[80vw\\]{width:80vw}.w-\\[90\\%\\]{width:90%}.w-\\[900px\\]{width:900px}.w-\\[calc\\(100\\%-1\\.9rem\\)\\]{width:calc(100% - 1.9rem)}.w-\\[calc\\(100\\%_-_0\\.25rem\\)\\]{width:calc(100% - .25rem)}.w-\\[calc\\(34\\%-0\\.5rem\\)\\]{width:calc(34% - .5rem)}.w-\\[calc\\(40\\%-0\\.5rem\\)\\]{width:calc(40% - .5rem)}.w-\\[calc\\(60\\%-0\\.5rem\\)\\]{width:calc(60% - .5rem)}.w-\\[calc\\(66\\%-0\\.5rem\\)\\]{width:calc(66% - .5rem)}.w-auto{width:auto}.w-fit{width:-moz-fit-content;width:fit-content}.w-full{width:100%}.w-min{width:-moz-min-content;width:min-content}.min-w-5{min-width:1.25rem}.min-w-9{min-width:2.25rem}.min-w-\\[1\\.5rem\\]{min-width:1.5rem}.min-w-\\[10rem\\]{min-width:10rem}.min-w-\\[15rem\\]{min-width:15rem}.min-w-\\[20px\\]{min-width:20px}.min-w-\\[700px\\]{min-width:700px}.min-w-\\[80px\\]{min-width:80px}.min-w-full{min-width:100%}.max-w-12{max-width:3rem}.max-w-4xl{max-width:56rem}.max-w-5xl{max-width:64rem}.max-w-\\[13rem\\]{max-width:13rem}.max-w-\\[20rem\\]{max-width:20rem}.max-w-\\[27rem\\]{max-width:27rem}.max-w-\\[50\\%\\]{max-width:50%}.max-w-\\[600px\\]{max-width:600px}.max-w-\\[90vw\\]{max-width:90vw}.max-w-\\[95\\%\\]{max-width:95%}.max-w-\\[calc\\(100\\%-32px\\)\\]{max-width:calc(100% - 32px)}.max-w-fit{max-width:-moz-fit-content;max-width:fit-content}.max-w-full{max-width:100%}.max-w-md{max-width:28rem}.max-w-sm{max-width:24rem}.max-w-xl{max-width:36rem}.flex-1{flex:1 1}.flex-shrink-0{flex-shrink:0}.flex-grow,.grow{flex-grow:1}.-translate-x-1\\/2{--tw-translate-x: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-6{--tw-translate-x: 1.5rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-y-0{--tw-translate-y: 0px;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-y-0\\.5{--tw-translate-y: .125rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-y-\\[1px\\]{--tw-translate-y: 1px;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rotate-180{--tw-rotate: 180deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.scale-90{--tw-scale-x: .9;--tw-scale-y: .9;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-scale-x-100{--tw-scale-x: -1;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.transform-none{transform:none}@keyframes pulse{50%{opacity:.5}}.animate-pulse{animation:pulse 2s cubic-bezier(.4,0,.6,1) infinite}@keyframes spin{to{transform:rotate(360deg)}}.animate-spin-slow{animation:spin 2s linear infinite}.cursor-default{cursor:default}.cursor-grab{cursor:grab}.cursor-grabbing{cursor:grabbing}.cursor-move{cursor:move}.cursor-pointer{cursor:pointer}.select-none{-webkit-user-select:none;-moz-user-select:none;user-select:none}.resize-none{resize:none}.resize-y{resize:vertical}.resize{resize:both}.snap-x{scroll-snap-type:x var(--tw-scroll-snap-strictness)}.snap-mandatory{--tw-scroll-snap-strictness: mandatory}.snap-center{scroll-snap-align:center}.snap-always{scroll-snap-stop:always}.list-none{list-style-type:none}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.grid-cols-5{grid-template-columns:repeat(5,minmax(0,1fr))}.grid-cols-\\[32px_1fr_32px\\]{grid-template-columns:32px 1fr 32px}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.content-between{align-content:space-between}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.items-stretch{align-items:stretch}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}.gap-1{gap:.25rem}.gap-2{gap:.5rem}.gap-3{gap:.75rem}.gap-4{gap:1rem}.gap-6{gap:1.5rem}.gap-x-4{-moz-column-gap:1rem;column-gap:1rem}.gap-y-3{row-gap:.75rem}.space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(1rem * var(--tw-space-x-reverse));margin-left:calc(1rem * calc(1 - var(--tw-space-x-reverse)))}.space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.5rem * var(--tw-space-y-reverse))}.self-center{align-self:center}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-visible{overflow:visible}.overflow-x-auto{overflow-x:auto}.overflow-y-auto{overflow-y:auto}.overflow-y-scroll{overflow-y:scroll}.whitespace-normal{white-space:normal}.whitespace-nowrap{white-space:nowrap}.rounded{border-radius:.25rem}.rounded-2xl{border-radius:1rem}.rounded-3xl{border-radius:1.5rem}.rounded-\\[3px\\]{border-radius:3px}.rounded-full{border-radius:9999px}.rounded-lg{border-radius:.5rem}.rounded-md{border-radius:.375rem}.rounded-none{border-radius:0}.rounded-sm{border-radius:.125rem}.rounded-xl{border-radius:.75rem}.rounded-b-lg{border-bottom-right-radius:.5rem;border-bottom-left-radius:.5rem}.rounded-b-none{border-bottom-right-radius:0;border-bottom-left-radius:0}.rounded-l-md{border-top-left-radius:.375rem;border-bottom-left-radius:.375rem}.rounded-t-lg{border-top-left-radius:.5rem;border-top-right-radius:.5rem}.rounded-t-md{border-top-left-radius:.375rem;border-top-right-radius:.375rem}.rounded-t-none{border-top-left-radius:0;border-top-right-radius:0}.rounded-t-xl{border-top-left-radius:.75rem;border-top-right-radius:.75rem}.\\!border{border-width:1px!important}.\\!border-0{border-width:0px!important}.\\!border-2{border-width:2px!important}.border{border-width:1px}.border-0{border-width:0px}.border-2{border-width:2px}.border-3{border-width:3px}.border-4{border-width:4px}.border-\\[1px\\]{border-width:1px}.border-b-0{border-bottom-width:0px}.border-b-2{border-bottom-width:2px}.border-b-3{border-bottom-width:3px}.border-l{border-left-width:1px}.border-r-0{border-right-width:0px}.border-t{border-top-width:1px}.border-t-2{border-top-width:2px}.border-t-3{border-top-width:3px}.\\!border-solid{border-style:solid!important}.border-solid{border-style:solid}.border-dashed{border-style:dashed}.border-none{border-style:none}.\\!border-gray-100{--tw-border-opacity: 1 !important;border-color:rgb(245 245 245 / var(--tw-border-opacity, 1))!important}.border-almost-black{--tw-border-opacity: 1;border-color:rgb(64 64 64 / var(--tw-border-opacity, 1))}.border-black{--tw-border-opacity: 1;border-color:rgb(0 0 0 / var(--tw-border-opacity, 1))}.border-blue-500{--tw-border-opacity: 1;border-color:rgb(59 130 246 / var(--tw-border-opacity, 1))}.border-brand{--tw-border-opacity: 1;border-color:rgb(0 126 193 / var(--tw-border-opacity, 1))}.border-brand-100{--tw-border-opacity: 1;border-color:rgb(239 247 251 / var(--tw-border-opacity, 1))}.border-brand-150{--tw-border-opacity: 1;border-color:rgb(230 242 249 / var(--tw-border-opacity, 1))}.border-brand-200{--tw-border-opacity: 1;border-color:rgb(217 235 245 / var(--tw-border-opacity, 1))}.border-brand-400{--tw-border-opacity: 1;border-color:rgb(142 197 226 / var(--tw-border-opacity, 1))}.border-brand-500{--tw-border-opacity: 1;border-color:rgb(81 165 209 / var(--tw-border-opacity, 1))}.border-current{border-color:currentColor}.border-editor-primary{--tw-border-opacity: 1;border-color:rgb(255 190 94 / var(--tw-border-opacity, 1))}.border-editor-primary-100{--tw-border-opacity: 1;border-color:rgb(255 241 219 / var(--tw-border-opacity, 1))}.border-editor-primary-200{--tw-border-opacity: 1;border-color:rgb(255 218 163 / var(--tw-border-opacity, 1))}.border-editor-primary-50{--tw-border-opacity: 1;border-color:rgb(255 249 240 / var(--tw-border-opacity, 1))}.border-gray-100{--tw-border-opacity: 1;border-color:rgb(245 245 245 / var(--tw-border-opacity, 1))}.border-gray-200{--tw-border-opacity: 1;border-color:rgb(229 229 229 / var(--tw-border-opacity, 1))}.border-gray-300{--tw-border-opacity: 1;border-color:rgb(212 212 212 / var(--tw-border-opacity, 1))}.border-gray-500{--tw-border-opacity: 1;border-color:rgb(115 115 115 / var(--tw-border-opacity, 1))}.border-gray-600{--tw-border-opacity: 1;border-color:rgb(82 82 82 / var(--tw-border-opacity, 1))}.border-green-500{--tw-border-opacity: 1;border-color:rgb(34 197 94 / var(--tw-border-opacity, 1))}.border-red-100{--tw-border-opacity: 1;border-color:rgb(254 226 226 / var(--tw-border-opacity, 1))}.border-red-400{--tw-border-opacity: 1;border-color:rgb(248 113 113 / var(--tw-border-opacity, 1))}.border-red-500{--tw-border-opacity: 1;border-color:rgb(239 68 68 / var(--tw-border-opacity, 1))}.border-transparent{border-color:transparent}.border-b-gray-300{--tw-border-opacity: 1;border-bottom-color:rgb(212 212 212 / var(--tw-border-opacity, 1))}.\\!bg-brand-100{--tw-bg-opacity: 1 !important;background-color:rgb(239 247 251 / var(--tw-bg-opacity, 1))!important}.\\!bg-brandgreen-500{--tw-bg-opacity: 1 !important;background-color:rgb(149 188 26 / var(--tw-bg-opacity, 1))!important}.\\!bg-editor-primary-100{--tw-bg-opacity: 1 !important;background-color:rgb(255 241 219 / var(--tw-bg-opacity, 1))!important}.\\!bg-orange-100{--tw-bg-opacity: 1 !important;background-color:rgb(255 237 213 / var(--tw-bg-opacity, 1))!important}.bg-\\[\\#ddd\\]{--tw-bg-opacity: 1;background-color:rgb(221 221 221 / var(--tw-bg-opacity, 1))}.bg-\\[\\#fefefe\\]{--tw-bg-opacity: 1;background-color:rgb(254 254 254 / var(--tw-bg-opacity, 1))}.bg-almost-black{--tw-bg-opacity: 1;background-color:rgb(64 64 64 / var(--tw-bg-opacity, 1))}.bg-black{--tw-bg-opacity: 1;background-color:rgb(0 0 0 / var(--tw-bg-opacity, 1))}.bg-black\\/30{background-color:#0000004d}.bg-brand{--tw-bg-opacity: 1;background-color:rgb(0 126 193 / var(--tw-bg-opacity, 1))}.bg-brand-100{--tw-bg-opacity: 1;background-color:rgb(239 247 251 / var(--tw-bg-opacity, 1))}.bg-brand-200{--tw-bg-opacity: 1;background-color:rgb(217 235 245 / var(--tw-bg-opacity, 1))}.bg-brand-400{--tw-bg-opacity: 1;background-color:rgb(142 197 226 / var(--tw-bg-opacity, 1))}.bg-brand-50{--tw-bg-opacity: 1;background-color:rgb(244 249 252 / var(--tw-bg-opacity, 1))}.bg-brand-500{--tw-bg-opacity: 1;background-color:rgb(81 165 209 / var(--tw-bg-opacity, 1))}.bg-editor-primary-100{--tw-bg-opacity: 1;background-color:rgb(255 241 219 / var(--tw-bg-opacity, 1))}.bg-editor-primary-200{--tw-bg-opacity: 1;background-color:rgb(255 218 163 / var(--tw-bg-opacity, 1))}.bg-editor-primary-300{--tw-bg-opacity: 1;background-color:rgb(255 190 94 / var(--tw-bg-opacity, 1))}.bg-editor-primary-50{--tw-bg-opacity: 1;background-color:rgb(255 249 240 / var(--tw-bg-opacity, 1))}.bg-gray-100{--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity, 1))}.bg-gray-200{--tw-bg-opacity: 1;background-color:rgb(229 229 229 / var(--tw-bg-opacity, 1))}.bg-gray-300{--tw-bg-opacity: 1;background-color:rgb(212 212 212 / var(--tw-bg-opacity, 1))}.bg-gray-50{--tw-bg-opacity: 1;background-color:rgb(250 250 250 / var(--tw-bg-opacity, 1))}.bg-gray-500{--tw-bg-opacity: 1;background-color:rgb(115 115 115 / var(--tw-bg-opacity, 1))}.bg-gray-700{--tw-bg-opacity: 1;background-color:rgb(64 64 64 / var(--tw-bg-opacity, 1))}.bg-green-400{--tw-bg-opacity: 1;background-color:rgb(74 222 128 / var(--tw-bg-opacity, 1))}.bg-orange-100{--tw-bg-opacity: 1;background-color:rgb(255 237 213 / var(--tw-bg-opacity, 1))}.bg-orange-200{--tw-bg-opacity: 1;background-color:rgb(254 215 170 / var(--tw-bg-opacity, 1))}.bg-orange-400{--tw-bg-opacity: 1;background-color:rgb(251 146 60 / var(--tw-bg-opacity, 1))}.bg-slate-100{--tw-bg-opacity: 1;background-color:rgb(241 245 249 / var(--tw-bg-opacity, 1))}.bg-slate-200{--tw-bg-opacity: 1;background-color:rgb(226 232 240 / var(--tw-bg-opacity, 1))}.bg-slate-400{--tw-bg-opacity: 1;background-color:rgb(148 163 184 / var(--tw-bg-opacity, 1))}.bg-transparent{background-color:transparent}.bg-white{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1))}.bg-yellow-100{--tw-bg-opacity: 1;background-color:rgb(255 241 219 / var(--tw-bg-opacity, 1))}.bg-yellow-50{--tw-bg-opacity: 1;background-color:rgb(255 249 240 / var(--tw-bg-opacity, 1))}.bg-opacity-0{--tw-bg-opacity: 0}.bg-opacity-20{--tw-bg-opacity: .2}.bg-opacity-70{--tw-bg-opacity: .7}.bg-opacity-75{--tw-bg-opacity: .75}.bg-opacity-80{--tw-bg-opacity: .8}.bg-gradient-to-b{background-image:linear-gradient(to bottom,var(--tw-gradient-stops))}.bg-none{background-image:none}.from-transparent{--tw-gradient-from: transparent var(--tw-gradient-from-position);--tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)}.via-\\[rgba\\(0\\,0\\,0\\,0\\.15\\)\\]{--tw-gradient-to: rgba(0, 0, 0, 0) var(--tw-gradient-to-position);--tw-gradient-stops: var(--tw-gradient-from), rgba(0,0,0,.15) var(--tw-gradient-via-position), var(--tw-gradient-to)}.via-white{--tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);--tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to)}.via-70\\%{--tw-gradient-via-position: 70%}.to-\\[rgba\\(0\\,0\\,0\\,0\\.8\\)\\]{--tw-gradient-to: rgba(0,0,0,.8) var(--tw-gradient-to-position)}.to-transparent{--tw-gradient-to: transparent var(--tw-gradient-to-position)}.to-85\\%{--tw-gradient-to-position: 85%}.bg-cover{background-size:cover}.bg-center{background-position:center}.bg-no-repeat{background-repeat:no-repeat}.object-contain{-o-object-fit:contain;object-fit:contain}.p-0{padding:0}.p-0\\.25{padding:1px}.p-1{padding:.25rem}.p-10{padding:2.5rem}.p-2{padding:.5rem}.p-2\\.5{padding:.625rem}.p-3{padding:.75rem}.p-4{padding:1rem}.p-8{padding:2rem}.p-side{padding:16px}.px-0{padding-left:0;padding-right:0}.px-0\\.5{padding-left:.125rem;padding-right:.125rem}.px-1{padding-left:.25rem;padding-right:.25rem}.px-1\\.5{padding-left:.375rem;padding-right:.375rem}.px-10{padding-left:2.5rem;padding-right:2.5rem}.px-16{padding-left:4rem;padding-right:4rem}.px-2{padding-left:.5rem;padding-right:.5rem}.px-2\\.5{padding-left:.625rem;padding-right:.625rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-4{padding-left:1rem;padding-right:1rem}.px-5{padding-left:1.25rem;padding-right:1.25rem}.px-6{padding-left:1.5rem;padding-right:1.5rem}.px-8{padding-left:2rem;padding-right:2rem}.px-\\[10\\%\\]{padding-left:10%;padding-right:10%}.px-\\[3px\\]{padding-left:3px;padding-right:3px}.px-side{padding-left:16px;padding-right:16px}.py-0{padding-top:0;padding-bottom:0}.py-0\\.25{padding-top:1px;padding-bottom:1px}.py-0\\.5{padding-top:.125rem;padding-bottom:.125rem}.py-1{padding-top:.25rem;padding-bottom:.25rem}.py-1\\.5{padding-top:.375rem;padding-bottom:.375rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-2\\.5{padding-top:.625rem;padding-bottom:.625rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.py-32{padding-top:8rem;padding-bottom:8rem}.py-4{padding-top:1rem;padding-bottom:1rem}.py-5{padding-top:1.25rem;padding-bottom:1.25rem}.py-6{padding-top:1.5rem;padding-bottom:1.5rem}.py-\\[1px\\]{padding-top:1px;padding-bottom:1px}.py-\\[3px\\]{padding-top:3px;padding-bottom:3px}.\\!pb-1{padding-bottom:.25rem!important}.\\!pb-2{padding-bottom:.5rem!important}.pb-0{padding-bottom:0}.pb-0\\.25{padding-bottom:1px}.pb-1{padding-bottom:.25rem}.pb-10{padding-bottom:2.5rem}.pb-12{padding-bottom:3rem}.pb-14{padding-bottom:3.5rem}.pb-2{padding-bottom:.5rem}.pb-3{padding-bottom:.75rem}.pb-3\\.5{padding-bottom:.875rem}.pb-4{padding-bottom:1rem}.pb-40{padding-bottom:10rem}.pb-5{padding-bottom:1.25rem}.pb-6{padding-bottom:1.5rem}.pb-7{padding-bottom:1.75rem}.pb-8{padding-bottom:2rem}.pb-\\[5px\\]{padding-bottom:5px}.pl-0\\.5{padding-left:.125rem}.pl-1{padding-left:.25rem}.pl-12{padding-left:3rem}.pl-2{padding-left:.5rem}.pl-3{padding-left:.75rem}.pl-4{padding-left:1rem}.pl-5{padding-left:1.25rem}.pl-6{padding-left:1.5rem}.pl-\\[5px\\]{padding-left:5px}.pr-10{padding-right:2.5rem}.pr-12{padding-right:3rem}.pr-2{padding-right:.5rem}.pr-3{padding-right:.75rem}.pr-4{padding-right:1rem}.pr-\\[15px\\]{padding-right:15px}.pt-0{padding-top:0}.pt-0\\.25{padding-top:1px}.pt-0\\.5{padding-top:.125rem}.pt-1{padding-top:.25rem}.pt-10{padding-top:2.5rem}.pt-16{padding-top:4rem}.pt-2{padding-top:.5rem}.pt-2\\.5{padding-top:.625rem}.pt-3{padding-top:.75rem}.pt-4{padding-top:1rem}.pt-6{padding-top:1.5rem}.pt-7{padding-top:1.75rem}.pt-8{padding-top:2rem}.pt-\\[0\\.8rem\\]{padding-top:.8rem}.pt-\\[2px\\]{padding-top:2px}.pt-\\[3px\\]{padding-top:3px}.text-left{text-align:left}.text-center{text-align:center}.text-right{text-align:right}.text-start{text-align:start}.align-baseline{vertical-align:baseline}.align-top{vertical-align:top}.align-middle{vertical-align:middle}.align-bottom{vertical-align:bottom}.align-\\[-0\\.125em\\]{vertical-align:-.125em}.align-\\[-3px\\]{vertical-align:-3px}.font-\\[serif\\]{font-family:serif}.font-mono{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}.text-2xl{font-size:1.5rem;line-height:2rem}.text-3xl{font-size:1.875rem;line-height:2.25rem}.text-4xl{font-size:2.25rem;line-height:2.5rem}.text-7xl{font-size:4.5rem;line-height:1}.text-\\[0\\.5rem\\]{font-size:.5rem}.text-\\[13px\\]{font-size:13px}.text-\\[15px\\]{font-size:15px}.text-\\[1rem\\]{font-size:1rem}.text-base{font-size:1rem;line-height:1.5rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.text-xs{font-size:.75rem;line-height:1rem}.font-bold{font-weight:700}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.italic{font-style:italic}.not-italic{font-style:normal}.leading-browser{line-height:normal}.leading-cozy{line-height:1.33}.leading-none{line-height:1}.leading-normal{line-height:1.5}.leading-tight{line-height:1.25}.\\!text-black{--tw-text-opacity: 1 !important;color:rgb(0 0 0 / var(--tw-text-opacity, 1))!important}.\\!text-gray-800{--tw-text-opacity: 1 !important;color:rgb(38 38 38 / var(--tw-text-opacity, 1))!important}.text-almost-black{--tw-text-opacity: 1;color:rgb(64 64 64 / var(--tw-text-opacity, 1))}.text-black{--tw-text-opacity: 1;color:rgb(0 0 0 / var(--tw-text-opacity, 1))}.text-brand{--tw-text-opacity: 1;color:rgb(0 126 193 / var(--tw-text-opacity, 1))}.text-brand-50{--tw-text-opacity: 1;color:rgb(244 249 252 / var(--tw-text-opacity, 1))}.text-editor-primary{--tw-text-opacity: 1;color:rgb(255 190 94 / var(--tw-text-opacity, 1))}.text-editor-primary-200{--tw-text-opacity: 1;color:rgb(255 218 163 / var(--tw-text-opacity, 1))}.text-gray-100{--tw-text-opacity: 1;color:rgb(245 245 245 / var(--tw-text-opacity, 1))}.text-gray-200{--tw-text-opacity: 1;color:rgb(229 229 229 / var(--tw-text-opacity, 1))}.text-gray-300{--tw-text-opacity: 1;color:rgb(212 212 212 / var(--tw-text-opacity, 1))}.text-gray-400{--tw-text-opacity: 1;color:rgb(163 163 163 / var(--tw-text-opacity, 1))}.text-gray-500{--tw-text-opacity: 1;color:rgb(115 115 115 / var(--tw-text-opacity, 1))}.text-gray-600{--tw-text-opacity: 1;color:rgb(82 82 82 / var(--tw-text-opacity, 1))}.text-gray-700{--tw-text-opacity: 1;color:rgb(64 64 64 / var(--tw-text-opacity, 1))}.text-gray-800{--tw-text-opacity: 1;color:rgb(38 38 38 / var(--tw-text-opacity, 1))}.text-gray-900{--tw-text-opacity: 1;color:rgb(23 23 23 / var(--tw-text-opacity, 1))}.text-green-500{--tw-text-opacity: 1;color:rgb(34 197 94 / var(--tw-text-opacity, 1))}.text-orange{--tw-text-opacity: 1;color:rgb(124 45 18 / var(--tw-text-opacity, 1))}.text-red-500{--tw-text-opacity: 1;color:rgb(239 68 68 / var(--tw-text-opacity, 1))}.text-slate-400{--tw-text-opacity: 1;color:rgb(148 163 184 / var(--tw-text-opacity, 1))}.text-white{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.\\!no-underline{text-decoration-line:none!important}.placeholder-brand::-moz-placeholder{--tw-placeholder-opacity: 1;color:rgb(0 126 193 / var(--tw-placeholder-opacity, 1))}.placeholder-brand::placeholder{--tw-placeholder-opacity: 1;color:rgb(0 126 193 / var(--tw-placeholder-opacity, 1))}.\\!opacity-100{opacity:1!important}.opacity-0{opacity:0}.opacity-100{opacity:1}.opacity-30{opacity:.3}.opacity-40{opacity:.4}.opacity-50{opacity:.5}.opacity-75{opacity:.75}.opacity-80{opacity:.8}.shadow{--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / .1), 0 1px 2px -1px rgb(0 0 0 / .1);--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-md{--tw-shadow: 0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1);--tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-menu{--tw-shadow: rgba(0, 0, 0, .2) 0px 2px 4px;--tw-shadow-colored: 0px 2px 4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-plugin-focus{--tw-shadow: 0 4px 4px 0 rgba(0, 0, 0, .25);--tw-shadow-colored: 0 4px 4px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-stickysearch{--tw-shadow: 0px 7px 7px 3px rgba(255,255,255,.8);--tw-shadow-colored: 0px 7px 7px 3px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-xl{--tw-shadow: 0 20px 25px -5px rgb(0 0 0 / .1), 0 8px 10px -6px rgb(0 0 0 / .1);--tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.outline-none{outline:2px solid transparent;outline-offset:2px}.outline{outline-style:solid}.outline-1{outline-width:1px}.outline-2{outline-width:2px}.outline-brand{outline-color:#007ec1}.outline-red-500{outline-color:#ef4444}.blur{--tw-blur: blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.backdrop-blur-sm{--tw-backdrop-blur: blur(4px);-webkit-backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-colors{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-opacity{transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-transform{transition-property:transform;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.duration-100{transition-duration:.1s}.duration-300{transition-duration:.3s}.duration-500{transition-duration:.5s}.ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}@keyframes enter{0%{opacity:var(--tw-enter-opacity, 1);transform:translate3d(var(--tw-enter-translate-x, 0),var(--tw-enter-translate-y, 0),0) scale3d(var(--tw-enter-scale, 1),var(--tw-enter-scale, 1),var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0))}}@keyframes exit{to{opacity:var(--tw-exit-opacity, 1);transform:translate3d(var(--tw-exit-translate-x, 0),var(--tw-exit-translate-y, 0),0) scale3d(var(--tw-exit-scale, 1),var(--tw-exit-scale, 1),var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0))}}.animate-in{animation-name:enter;animation-duration:.15s;--tw-enter-opacity: initial;--tw-enter-scale: initial;--tw-enter-rotate: initial;--tw-enter-translate-x: initial;--tw-enter-translate-y: initial}.fade-in{--tw-enter-opacity: 0}.zoom-in{--tw-enter-scale: 0}.slide-in-from-bottom-4{--tw-enter-translate-y: 1rem}.slide-in-from-top{--tw-enter-translate-y: -100%}.duration-100{animation-duration:.1s}.duration-300{animation-duration:.3s}.duration-500{animation-duration:.5s}.ease-in-out{animation-timing-function:cubic-bezier(.4,0,.2,1)}.running{animation-play-state:running}.paused{animation-play-state:paused}.clip-vertical-shadow{clip-path:inset(0 -10px)}.\\[contain\\:content\\]{contain:content}.\\[counter-increment\\:exercises\\]{counter-increment:exercises}.\\[counter-reset\\:exercises\\]{counter-reset:exercises}.\\[grid-area\\:1_\\/_2\\]{grid-area:1 / 2}.\\[page-break-inside\\:avoid\\]{page-break-inside:avoid}body.ReactModal__Body--open{overflow:hidden;height:100vh}.before\\:pointer-events-none:before{content:var(--tw-content);pointer-events:none}.before\\:absolute:before{content:var(--tw-content);position:absolute}.before\\:-top-7:before{content:var(--tw-content);top:-1.75rem}.before\\:left-0:before{content:var(--tw-content);left:0}.before\\:mx-side:before{content:var(--tw-content);margin-left:16px;margin-right:16px}.before\\:mb-2\\.5:before{content:var(--tw-content);margin-bottom:.625rem}.before\\:block:before{content:var(--tw-content);display:block}.before\\:flex:before{content:var(--tw-content);display:flex}.before\\:h-7:before{content:var(--tw-content);height:1.75rem}.before\\:w-7:before{content:var(--tw-content);width:1.75rem}.before\\:w-full:before{content:var(--tw-content);width:100%}.before\\:justify-center:before{content:var(--tw-content);justify-content:center}.before\\:rounded-full:before{content:var(--tw-content);border-radius:9999px}.before\\:bg-brand-200:before{content:var(--tw-content);--tw-bg-opacity: 1;background-color:rgb(217 235 245 / var(--tw-bg-opacity, 1))}.before\\:bg-gradient-to-t:before{content:var(--tw-content);background-image:linear-gradient(to top,var(--tw-gradient-stops))}.before\\:from-\\[rgba\\(255\\,255\\,255\\,0\\.95\\)\\]:before{content:var(--tw-content);--tw-gradient-from: rgba(255,255,255,.95) var(--tw-gradient-from-position);--tw-gradient-to: rgba(255, 255, 255, 0) var(--tw-gradient-to-position);--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)}.before\\:via-\\[rgba\\(255\\,255\\,255\\,0\\.7\\)\\]:before{content:var(--tw-content);--tw-gradient-to: rgba(255, 255, 255, 0) var(--tw-gradient-to-position);--tw-gradient-stops: var(--tw-gradient-from), rgba(255,255,255,.7) var(--tw-gradient-via-position), var(--tw-gradient-to)}.before\\:to-transparent:before{content:var(--tw-content);--tw-gradient-to: transparent var(--tw-gradient-to-position)}.before\\:align-middle:before{content:var(--tw-content);vertical-align:middle}.before\\:text-xl:before{content:var(--tw-content);font-size:1.25rem;line-height:1.75rem}.before\\:font-bold:before{content:var(--tw-content);font-weight:700}.before\\:text-brand:before{content:var(--tw-content);--tw-text-opacity: 1;color:rgb(0 126 193 / var(--tw-text-opacity, 1))}.before\\:content-\\[counter\\(exercises\\,_lower-alpha\\)\\]:before{--tw-content: counter(exercises, lower-alpha);content:var(--tw-content)}.after\\:invisible:after{content:var(--tw-content);visibility:hidden}.after\\:-ml-2:after{content:var(--tw-content);margin-left:-.5rem}.after\\:w-auto:after{content:var(--tw-content);width:auto}.after\\:min-w-16:after{content:var(--tw-content);min-width:4rem}.after\\:resize-none:after{content:var(--tw-content);resize:none}.after\\:whitespace-pre-wrap:after{content:var(--tw-content);white-space:pre-wrap}.after\\:px-3:after{content:var(--tw-content);padding-left:.75rem;padding-right:.75rem}.after\\:content-\\[attr\\(data-value\\)_\\'_\\'\\]:after{--tw-content: attr(data-value) " ";content:var(--tw-content)}.after\\:\\[grid-area\\:1_\\/_2\\]:after{content:var(--tw-content);grid-area:1 / 2}.first\\:rounded-bl-xl:first-child{border-bottom-left-radius:.75rem}.first\\:rounded-tl-xl:first-child{border-top-left-radius:.75rem}.first\\:border-l-3:first-child{border-left-width:3px}.last\\:rounded-br-xl:last-child{border-bottom-right-radius:.75rem}.last\\:rounded-tr-xl:last-child{border-top-right-radius:.75rem}.focus-within\\:rounded-xl:focus-within{border-radius:.75rem}.focus-within\\:\\!border-gray-100:focus-within{--tw-border-opacity: 1 !important;border-color:rgb(245 245 245 / var(--tw-border-opacity, 1))!important}.focus-within\\:border-brand-200:focus-within{--tw-border-opacity: 1;border-color:rgb(217 235 245 / var(--tw-border-opacity, 1))}.focus-within\\:border-editor-primary:focus-within{--tw-border-opacity: 1;border-color:rgb(255 190 94 / var(--tw-border-opacity, 1))}.focus-within\\:border-gray-100:focus-within{--tw-border-opacity: 1;border-color:rgb(245 245 245 / var(--tw-border-opacity, 1))}.focus-within\\:opacity-100:focus-within{opacity:1}.focus-within\\:shadow-plugin-focus:focus-within{--tw-shadow: 0 4px 4px 0 rgba(0, 0, 0, .25);--tw-shadow-colored: 0 4px 4px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.focus-within\\:outline-none:focus-within{outline:2px solid transparent;outline-offset:2px}.focus-within\\:outline:focus-within{outline-style:solid}.focus-within\\:outline-2:focus-within{outline-width:2px}.focus-within\\:outline-offset-1:focus-within{outline-offset:1px}.focus-within\\:outline-editor-primary:focus-within{outline-color:#ffbe5e}.hover\\:z-50:hover{z-index:50}.hover\\:cursor-pointer:hover{cursor:pointer}.hover\\:border-editor-primary-100:hover{--tw-border-opacity: 1;border-color:rgb(255 241 219 / var(--tw-border-opacity, 1))}.hover\\:\\!bg-editor-primary-100:hover{--tw-bg-opacity: 1 !important;background-color:rgb(255 241 219 / var(--tw-bg-opacity, 1))!important}.hover\\:bg-brand:hover{--tw-bg-opacity: 1;background-color:rgb(0 126 193 / var(--tw-bg-opacity, 1))}.hover\\:bg-brand-100:hover{--tw-bg-opacity: 1;background-color:rgb(239 247 251 / var(--tw-bg-opacity, 1))}.hover\\:bg-editor-primary-100:hover{--tw-bg-opacity: 1;background-color:rgb(255 241 219 / var(--tw-bg-opacity, 1))}.hover\\:bg-editor-primary-200:hover{--tw-bg-opacity: 1;background-color:rgb(255 218 163 / var(--tw-bg-opacity, 1))}.hover\\:bg-editor-primary-300:hover{--tw-bg-opacity: 1;background-color:rgb(255 190 94 / var(--tw-bg-opacity, 1))}.hover\\:bg-gray-200:hover{--tw-bg-opacity: 1;background-color:rgb(229 229 229 / var(--tw-bg-opacity, 1))}.hover\\:bg-gray-600:hover{--tw-bg-opacity: 1;background-color:rgb(82 82 82 / var(--tw-bg-opacity, 1))}.hover\\:bg-orange-200:hover{--tw-bg-opacity: 1;background-color:rgb(254 215 170 / var(--tw-bg-opacity, 1))}.hover\\:bg-opacity-50:hover{--tw-bg-opacity: .5}.hover\\:text-black:hover{--tw-text-opacity: 1;color:rgb(0 0 0 / var(--tw-text-opacity, 1))}.hover\\:text-brand-700:hover{--tw-text-opacity: 1;color:rgb(0 118 185 / var(--tw-text-opacity, 1))}.hover\\:text-editor-primary:hover{--tw-text-opacity: 1;color:rgb(255 190 94 / var(--tw-text-opacity, 1))}.hover\\:text-gray-200:hover{--tw-text-opacity: 1;color:rgb(229 229 229 / var(--tw-text-opacity, 1))}.hover\\:text-gray-900:hover{--tw-text-opacity: 1;color:rgb(23 23 23 / var(--tw-text-opacity, 1))}.hover\\:text-white:hover{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.hover\\:\\!no-underline:hover{text-decoration-line:none!important}.hover\\:no-underline:hover{text-decoration-line:none}.hover\\:opacity-100:hover{opacity:1}.hover\\:shadow-plugin-hover:hover{--tw-shadow: 0 4px 4px 0 rgba(0, 0, 0, .1);--tw-shadow-colored: 0 4px 4px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.hover\\:shadow-xl:hover{--tw-shadow: 0 20px 25px -5px rgb(0 0 0 / .1), 0 8px 10px -6px rgb(0 0 0 / .1);--tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.hover\\:focus-within\\:\\!shadow-plugin-focus:focus-within:hover{--tw-shadow: 0 4px 4px 0 rgba(0, 0, 0, .25) !important;--tw-shadow-colored: 0 4px 4px 0 var(--tw-shadow-color) !important;box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)!important}.focus\\:z-50:focus{z-index:50}.focus\\:border-2:focus{border-width:2px}.focus\\:border-brand:focus{--tw-border-opacity: 1;border-color:rgb(0 126 193 / var(--tw-border-opacity, 1))}.focus\\:border-editor-primary:focus{--tw-border-opacity: 1;border-color:rgb(255 190 94 / var(--tw-border-opacity, 1))}.focus\\:border-editor-primary-200:focus{--tw-border-opacity: 1;border-color:rgb(255 218 163 / var(--tw-border-opacity, 1))}.focus\\:border-editor-primary-300:focus{--tw-border-opacity: 1;border-color:rgb(255 190 94 / var(--tw-border-opacity, 1))}.focus\\:border-red-400:focus{--tw-border-opacity: 1;border-color:rgb(248 113 113 / var(--tw-border-opacity, 1))}.focus\\:bg-editor-primary-100:focus{--tw-bg-opacity: 1;background-color:rgb(255 241 219 / var(--tw-bg-opacity, 1))}.focus\\:bg-editor-primary-200:focus{--tw-bg-opacity: 1;background-color:rgb(255 218 163 / var(--tw-bg-opacity, 1))}.focus\\:bg-white:focus{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1))}.focus\\:text-brand:focus{--tw-text-opacity: 1;color:rgb(0 126 193 / var(--tw-text-opacity, 1))}.focus\\:text-editor-primary:focus{--tw-text-opacity: 1;color:rgb(255 190 94 / var(--tw-text-opacity, 1))}.focus\\:underline:focus{text-decoration-line:underline}.focus\\:placeholder-opacity-0:focus::-moz-placeholder{--tw-placeholder-opacity: 0}.focus\\:placeholder-opacity-0:focus::placeholder{--tw-placeholder-opacity: 0}.focus\\:opacity-100:focus{opacity:1}.focus\\:shadow-xl:focus{--tw-shadow: 0 20px 25px -5px rgb(0 0 0 / .1), 0 8px 10px -6px rgb(0 0 0 / .1);--tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.focus\\:outline:focus{outline-style:solid}.focus\\:outline-1:focus{outline-width:1px}.focus\\:outline-green-500:focus{outline-color:#22c55e}.focus\\:outline-red-400:focus{outline-color:#f87171}.focus\\:ring-2:focus{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.focus\\:ring-gray-700:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(64 64 64 / var(--tw-ring-opacity, 1))}.focus-visible\\:bg-editor-primary-200:focus-visible{--tw-bg-opacity: 1;background-color:rgb(255 218 163 / var(--tw-bg-opacity, 1))}.focus-visible\\:bg-editor-primary-300:focus-visible{--tw-bg-opacity: 1;background-color:rgb(255 190 94 / var(--tw-bg-opacity, 1))}.focus-visible\\:outline:focus-visible{outline-style:solid}.focus-visible\\:outline-gray-400:focus-visible{outline-color:#a3a3a3}.active\\:border-brand:active{--tw-border-opacity: 1;border-color:rgb(0 126 193 / var(--tw-border-opacity, 1))}.active\\:bg-editor-primary-200:active{--tw-bg-opacity: 1;background-color:rgb(255 218 163 / var(--tw-bg-opacity, 1))}.active\\:bg-opacity-60:active{--tw-bg-opacity: .6}.active\\:text-editor-primary:active{--tw-text-opacity: 1;color:rgb(255 190 94 / var(--tw-text-opacity, 1))}.group\\/exercise:focus-within .group-focus-within\\/exercise\\:block{display:block}.group\\/multimedia:focus-within .group-focus-within\\/multimedia\\:block{display:block}.group:focus-within .group-focus-within\\:opacity-100{opacity:1}.group:hover .group-hover\\:block{display:block}.group\\/edit:hover .group-hover\\/edit\\:flex{display:flex}.group\\/button:hover .group-hover\\/button\\:bg-editor-primary-200{--tw-bg-opacity: 1;background-color:rgb(255 218 163 / var(--tw-bg-opacity, 1))}.group:hover .group-hover\\:bg-editor-primary{--tw-bg-opacity: 1;background-color:rgb(255 190 94 / var(--tw-bg-opacity, 1))}.group:hover .group-hover\\:opacity-100{opacity:1}.group:focus .group-focus\\:bg-editor-primary{--tw-bg-opacity: 1;background-color:rgb(255 190 94 / var(--tw-bg-opacity, 1))}.group\\/exercise:has(.blanks-child-plugin-selection) .group-has-\\[\\.blanks-child-plugin-selection\\]\\/exercise\\:hidden{display:none}@media (prefers-reduced-motion: no-preference){.motion-safe\\:animate-in{animation-name:enter;animation-duration:.15s;--tw-enter-opacity: initial;--tw-enter-scale: initial;--tw-enter-rotate: initial;--tw-enter-translate-x: initial;--tw-enter-translate-y: initial}.motion-safe\\:zoom-in{--tw-enter-scale: 0}}@media (min-width: 500px){.mobile\\:basis-1\\/4{flex-basis:25%}.mobile\\:basis-2\\/4{flex-basis:50%}.mobile\\:basis-3\\/4{flex-basis:75%}}@media (min-width: 800px){.sm\\:top-20{top:5rem}.sm\\:top-24{top:6rem}.sm\\:mx-auto{margin-left:auto;margin-right:auto}.sm\\:block{display:block}.sm\\:flex{display:flex}.sm\\:hidden{display:none}.sm\\:max-h-\\[5\\.3rem\\]{max-height:5.3rem}.sm\\:grid-cols-\\[32px_600px_32px\\]{grid-template-columns:32px 600px 32px}.sm\\:flex-row{flex-direction:row}.sm\\:flex-wrap{flex-wrap:wrap}.sm\\:items-start{align-items:flex-start}.sm\\:justify-center{justify-content:center}.sm\\:gap-x-8{-moz-column-gap:2rem;column-gap:2rem}.sm\\:bg-white{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1))}.sm\\:px-8{padding-left:2rem;padding-right:2rem}.sm\\:pb-11{padding-bottom:2.75rem}.sm\\:pl-12{padding-left:3rem}.sm\\:pl-4{padding-left:1rem}.before\\:sm\\:absolute:before{content:var(--tw-content);position:absolute}.before\\:sm\\:-ml-10:before{content:var(--tw-content);margin-left:-2.5rem}.before\\:sm\\:-mt-1:before{content:var(--tw-content);margin-top:-.25rem}}@media (min-width: 1024px){.md\\:-ml-28{margin-left:-7rem}.md\\:mr-\\[-11\\.5vw\\]{margin-right:-11.5vw}.md\\:max-h-24{max-height:6rem}.md\\:grid-cols-\\[32px_764px_32px\\]{grid-template-columns:32px 764px 32px}.md\\:gap-x-14{-moz-column-gap:3.5rem;column-gap:3.5rem}.md\\:bg-transparent{background-color:transparent}}@media (min-width: 1216px){.lg\\:-ml-40{margin-left:-10rem}.lg\\:-mr-52{margin-right:-13rem}}@media (min-width: 1300px){.xl\\:-mr-64{margin-right:-16rem}}@media (prefers-color-scheme: dark){.dark\\:text-gray-600{--tw-text-opacity: 1;color:rgb(82 82 82 / var(--tw-text-opacity, 1))}}@media print{.print\\:hidden{display:none}}@keyframes bounce{0%,to{transform:translateY(-25%);animation-timing-function:cubic-bezier(.8,0,1,1)}50%{transform:none;animation-timing-function:cubic-bezier(0,0,.2,1)}}.\\[\\&\\.triggered\\]\\:animate-bounce.triggered{animation:bounce 1s infinite}.\\[\\&\\:focus-within\\>\\.row-controls\\]\\:opacity-100:focus-within>.row-controls{opacity:1}.\\[\\&\\:focus-within_\\.box-warning\\]\\:hidden:focus-within .box-warning{display:none}.\\[\\&\\:has\\(\\.explanation-wrapper\\>\\.plugin-wrapper-container\\:not\\(\\.plugin-rows\\)\\:focus-within\\)\\>div\\]\\:rounded-t-none:has(.explanation-wrapper>.plugin-wrapper-container:not(.plugin-rows):focus-within)>div{border-top-left-radius:0;border-top-right-radius:0}.\\[\\&\\:has\\(\\.explanation-wrapper\\>\\.plugin-wrapper-container\\:not\\(\\.plugin-rows\\)\\:focus-within\\)\\>div\\]\\:border-t-transparent:has(.explanation-wrapper>.plugin-wrapper-container:not(.plugin-rows):focus-within)>div{border-top-color:transparent}.\\[\\&\\:has\\(\\.explanation-wrapper_\\.rows-child\\:first-child\\:focus-within\\)\\>div\\]\\:rounded-t-none:has(.explanation-wrapper .rows-child:first-child:focus-within)>div{border-top-left-radius:0;border-top-right-radius:0}.\\[\\&\\:has\\(\\.explanation-wrapper_\\.rows-child\\:first-child\\:focus-within\\)\\>div\\]\\:border-t-transparent:has(.explanation-wrapper .rows-child:first-child:focus-within)>div{border-top-color:transparent}.\\[\\&\\:has\\(\\.media-wrapper\\:focus-within\\)\\>div\\]\\:rounded-t-none:has(.media-wrapper:focus-within)>div{border-top-left-radius:0;border-top-right-radius:0}.\\[\\&\\:has\\(\\.media-wrapper\\:focus-within\\)\\>div\\]\\:border-t-transparent:has(.media-wrapper:focus-within)>div{border-top-color:transparent}.\\[\\&\\:has\\(\\.rows-editor-renderer-container\\:focus-within\\)\\>\\.row-controls\\]\\:opacity-0:has(.rows-editor-renderer-container:focus-within)>.row-controls{opacity:0}.\\[\\&\\:hover\\>\\.row-controls\\]\\:\\!opacity-100:hover>.row-controls{opacity:1!important}.\\[\\&\\>\\.row-controls\\]\\:\\!-left-1>.row-controls{left:-.25rem!important}.\\[\\&\\>\\.row-controls\\]\\:\\!-top-9>.row-controls{top:-2.25rem!important}.\\[\\&\\>\\[data-slate-node\\]\\]\\:mx-side>[data-slate-node]{margin-left:16px;margin-right:16px}.\\[\\&\\>div\\.my-block\\:first-of-type\\]\\:mt-5>div.my-block:first-of-type{margin-top:1.25rem}.\\[\\&\\>div\\.my-block\\]\\:first\\:mt-3\\.5:first-child>div.my-block{margin-top:.875rem}.\\[\\&\\>div\\.my-block\\]\\:last\\:mb-3\\.5:last-child>div.my-block{margin-bottom:.875rem}.\\[\\&\\>div\\>\\[data-slate-editor\\]\\]\\:pb-block>div>[data-slate-editor]{padding-bottom:30px}.\\[\\&\\>div\\>\\[data-slate-editor\\]\\]\\:pr-2>div>[data-slate-editor]{padding-right:.5rem}.\\[\\&\\>div\\>button\\]\\:\\!mb-\\[17px\\]>div>button{margin-bottom:17px!important}.\\[\\&\\>div\\>div\\>div\\[data-slate-node\\=\\"element\\"\\]\\]\\:leading-\\[30px\\]>div>div>div[data-slate-node=element]{line-height:30px}.\\[\\&\\>div\\]\\:rounded-lg>div{border-radius:.5rem}.\\[\\&\\>div\\]\\:rounded-t-none>div{border-top-left-radius:0;border-top-right-radius:0}.\\[\\&\\>div\\]\\:border-3>div{border-width:3px}.\\[\\&\\>div\\]\\:border-none>div{border-style:none}.\\[\\&\\>div\\]\\:border-brand-50>div{--tw-border-opacity: 1;border-color:rgb(244 249 252 / var(--tw-border-opacity, 1))}.\\[\\&\\>div\\]\\:border-editor-primary-100>div{--tw-border-opacity: 1;border-color:rgb(255 241 219 / var(--tw-border-opacity, 1))}.\\[\\&\\>div\\]\\:py-5>div{padding-top:1.25rem;padding-bottom:1.25rem}.\\[\\&\\>figure\\>figcaption\\]\\:\\!mb-9>figure>figcaption{margin-bottom:2.25rem!important}.\\[\\&\\>figure\\]\\:rounded-t-none>figure{border-top-left-radius:0;border-top-right-radius:0}.\\[\\&\\>p\\]\\:mx-1>p{margin-left:.25rem;margin-right:.25rem}.\\[\\&\\>p\\]\\:text-xs>p{font-size:.75rem;line-height:1rem}.\\[\\&\\>p\\]\\:leading-\\[30px\\]>p{line-height:30px}@media (min-width: 800px){.\\[\\&\\>p\\]\\:sm\\:mx-2>p{margin-left:.5rem;margin-right:.5rem}.\\[\\&\\>p\\]\\:sm\\:text-base>p{font-size:1rem;line-height:1.5rem}}@media (min-width: 1024px){.\\[\\&\\>p\\]\\:md\\:mx-4>p{margin-left:1rem;margin-right:1rem}.\\[\\&\\>p\\]\\:md\\:text-lg>p{font-size:1.125rem;line-height:1.75rem}}.\\[\\&\\>span\\]\\:\\!min-w-80>span{min-width:20rem!important}.\\[\\&\\>svg\\]\\:rounded-md>svg{border-radius:.375rem}.\\[\\&_\\.add-trigger\\]\\:relative .add-trigger{position:relative}.\\[\\&_\\.add-trigger\\]\\:-left-1\\/4 .add-trigger{left:-25%}.\\[\\&_\\.explanation-wrapper\\>\\.plugin-wrapper-container_\\.plugin-toolbar\\]\\:left-\\[9px\\] .explanation-wrapper>.plugin-wrapper-container .plugin-toolbar{left:9px}.\\[\\&_\\.explanation-wrapper\\>\\.plugin-wrapper-container_\\.plugin-toolbar\\]\\:\\!w-\\[196\\%\\] .explanation-wrapper>.plugin-wrapper-container .plugin-toolbar{width:196%!important}.\\[\\&_\\.explanation-wrapper\\>\\.plugin-wrapper-container_\\.plugin-toolbar\\]\\:rounded-tr-none .explanation-wrapper>.plugin-wrapper-container .plugin-toolbar{border-top-right-radius:0}.\\[\\&_\\.explanation-wrapper_\\.plugin-rows_\\>_div\\]\\:mt-0 .explanation-wrapper .plugin-rows>div{margin-top:0}.\\[\\&_\\.explanation-wrapper_\\.rows-child\\:first-child_\\.plugin-toolbar\\]\\:\\!-top-\\[48px\\] .explanation-wrapper .rows-child:first-child .plugin-toolbar{top:-48px!important}.\\[\\&_\\.explanation-wrapper_\\.rows-child\\:first-child_\\.plugin-toolbar\\]\\:left-\\[-5px\\] .explanation-wrapper .rows-child:first-child .plugin-toolbar{left:-5px}.\\[\\&_\\.explanation-wrapper_\\.rows-child\\:first-child_\\.plugin-toolbar\\]\\:rounded-tr-none .explanation-wrapper .rows-child:first-child .plugin-toolbar{border-top-right-radius:0}.\\[\\&_\\.explanation-wrapper_\\.rows-child\\:not\\(\\:first-child\\)_\\.plugin-toolbar\\]\\:left-\\[-6px\\] .explanation-wrapper .rows-child:not(:first-child) .plugin-toolbar{left:-6px}.\\[\\&_\\.explanation-wrapper_\\.rows-child\\:not\\(\\:first-child\\)_\\.plugin-toolbar\\]\\:\\!ml-\\[1px\\] .explanation-wrapper .rows-child:not(:first-child) .plugin-toolbar{margin-left:1px!important}.\\[\\&_\\.explanation-wrapper_\\.rows-child\\:not\\(\\:first-child\\)_\\.plugin-toolbar\\]\\:\\!mr-0 .explanation-wrapper .rows-child:not(:first-child) .plugin-toolbar{margin-right:0!important}.\\[\\&_\\.explanation-wrapper_\\.rows-child\\:not\\(\\:first-child\\)_\\.plugin-toolbar\\]\\:rounded-t-none .explanation-wrapper .rows-child:not(:first-child) .plugin-toolbar{border-top-left-radius:0;border-top-right-radius:0}.\\[\\&_\\.explanation-wrapper_\\.rows-child\\]\\:\\!pl-\\[4rem\\] .explanation-wrapper .rows-child{padding-left:4rem!important}.\\[\\&_\\.explanation-wrapper_\\.rows-child\\]\\:\\!pr-\\[0\\.75rem\\] .explanation-wrapper .rows-child{padding-right:.75rem!important}.\\[\\&_\\.media-wrapper\\]\\:\\!static .media-wrapper{position:static!important}.\\[\\&_\\.media-wrapper_\\.plugin-toolbar\\]\\:rounded-tr-none .media-wrapper .plugin-toolbar{border-top-right-radius:0}.\\[\\&_\\.media-wrapper_\\.plugin-wrapper-container\\]\\:\\!static .media-wrapper .plugin-wrapper-container{position:static!important}.\\[\\&_\\.ml-4\\.flex\\]\\:mb-block .ml-4.flex{margin-bottom:30px}.\\[\\&_\\.mq-editable-field\\]\\:\\!border-none .mq-editable-field{border-style:none!important}.\\[\\&_\\.mq-editable-field\\]\\:\\!shadow-none .mq-editable-field{--tw-shadow: 0 0 #0000 !important;--tw-shadow-colored: 0 0 #0000 !important;box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)!important}.\\[\\&_\\.multimedia-renderer-wrapper-half_\\.explanation-wrapper_\\.rows-child_\\.plugin-toolbar\\]\\:\\!w-\\[209\\.4\\%\\] .multimedia-renderer-wrapper-half .explanation-wrapper .rows-child .plugin-toolbar{width:209.4%!important}.\\[\\&_\\.multimedia-renderer-wrapper-quarter_\\.explanation-wrapper_\\.rows-child_\\.plugin-toolbar\\]\\:\\!w-\\[137\\.3\\%\\] .multimedia-renderer-wrapper-quarter .explanation-wrapper .rows-child .plugin-toolbar{width:137.3%!important}.\\[\\&_\\.plugin-image\\]\\:\\!-ml-\\[5px\\] .plugin-image{margin-left:-5px!important}.\\[\\&_\\.plugin-rows\\]\\:pl-\\[7px\\] .plugin-rows{padding-left:7px}.\\[\\&_\\.plugin-toolbar\\]\\:left-side .plugin-toolbar{left:16px}.\\[\\&_\\.plugin-toolbar\\]\\:top-\\[-60px\\] .plugin-toolbar{top:-60px}.\\[\\&_\\.plugin-toolbar\\]\\:\\!hidden .plugin-toolbar{display:none!important}.\\[\\&_\\.rows-child\\:first-child_\\.plugin-toolbar\\:before\\]\\:hidden .rows-child:first-child .plugin-toolbar:before{display:none}.\\[\\&_\\.slate-container\\]\\:mb-0 .slate-container{margin-bottom:0}.\\[\\&_\\.slate-p\\]\\:ml-2 .slate-p{margin-left:.5rem}.\\[\\&_\\.vds-chapter-title\\]\\:opacity-0 .vds-chapter-title{opacity:0}.\\[\\&_a\\[data-key\\]\\]\\:hyphens-auto a[data-key]{-webkit-hyphens:auto;hyphens:auto}.\\[\\&_a\\]\\:text-brand-400 a{--tw-text-opacity: 1;color:rgb(142 197 226 / var(--tw-text-opacity, 1))}.\\[\\&_button\\>div\\>svg\\]\\:mx-1\\.5 button>div>svg{margin-left:.375rem;margin-right:.375rem}.\\[\\&_button\\>div\\>svg\\]\\:mb-1 button>div>svg{margin-bottom:.25rem}.\\[\\&_button\\>div\\>svg\\]\\:mt-2 button>div>svg{margin-top:.5rem}.\\[\\&_div\\.my-block\\:last-child\\]\\:mb-0 div.my-block:last-child{margin-bottom:0}.\\[\\&_div\\.my-block\\]\\:mt-0 div.my-block,.\\[\\&_div\\[contenteditable\\]_\\.serlo-h3\\]\\:mt-0 div[contenteditable] .serlo-h3{margin-top:0}.\\[\\&_div\\]\\:m-0 div{margin:0}.\\[\\&_h1\\]\\:hyphens-auto h1{-webkit-hyphens:auto;hyphens:auto}.\\[\\&_img\\]\\:max-h-\\[70vh\\] img{max-height:70vh}.\\[\\&_img\\]\\:min-h-\\[4rem\\] img{min-height:4rem}@media (min-width: 500px){.mobile\\:\\[\\&_img\\]\\:cursor-zoom-in img{cursor:zoom-in}}.\\[\\&_select\\]\\:border-2 select{border-width:2px}.\\[\\&_svg\\]\\:min-w-20 svg{min-width:5rem}.\\[\\&_textarea\\]\\:w-\\[430px\\] textarea{width:430px}.\\[\\&_textarea\\]\\:max-w-\\[100\\%\\] textarea{max-width:100%}.\\[\\&_textarea\\]\\:focus-within\\:\\!outline-none:focus-within textarea{outline:2px solid transparent!important;outline-offset:2px!important}.\\[\\&_textarea\\]\\:focus\\:\\!outline-none:focus textarea{outline:2px solid transparent!important;outline-offset:2px!important}
`;
var WB, eE = ms;
WB = eE.createRoot, eE.hydrateRoot;
const tE = {
  plugin: "rows",
  state: [
    {
      plugin: "text",
      state: [
        {
          type: "h",
          level: 1,
          children: [
            {
              text: "Beispiel überschrift"
            }
          ]
        },
        {
          type: "p",
          children: [
            {
              text: "Bestimme den Differenzenquotient der Funktion "
            },
            {
              type: "math",
              src: "f(x)=x^2",
              inline: !0,
              children: [
                {
                  text: "f(x)=x^2"
                }
              ]
            },
            {
              text: " im Intervall  "
            },
            {
              type: "math",
              src: "\\left[1;3\\right]",
              inline: !0,
              children: [
                {
                  text: "\\left[1;3\\right]"
                }
              ]
            },
            {
              text: " "
            },
            {
              type: "math",
              src: "\\Rightarrow x_1=1",
              inline: !0,
              children: [
                {
                  text: "\\Rightarrow x_1=1\\;x_2=3"
                }
              ]
            },
            {
              text: " und "
            },
            {
              type: "math",
              src: "x_2=3",
              inline: !0,
              children: [
                {
                  text: ""
                }
              ]
            },
            {
              text: "."
            }
          ]
        }
      ]
    },
    {
      plugin: "equations",
      state: {
        transformationTarget: "equation",
        firstExplanation: {
          plugin: "text",
          state: [
            {
              type: "p",
              children: [{}]
            }
          ]
        },
        steps: [
          {
            left: "m",
            sign: "equals",
            right: "\\frac{f(3)-f(1)}{3-1}",
            transform: "",
            explanation: {
              plugin: "text",
              state: [
                {
                  type: "p",
                  children: [
                    {
                      text: "Ausrechnen"
                    }
                  ]
                }
              ]
            }
          },
          {
            left: "",
            sign: "equals",
            right: "4",
            transform: "",
            explanation: {
              plugin: "text",
              state: [
                {
                  type: "p",
                  children: [{}]
                }
              ]
            }
          }
        ]
      }
    }
  ]
}, Y6e = v.lazy(
  () => Promise.resolve().then(() => V6e).then((e) => ({ default: e.SerloEditor }))
);
class p7e extends HTMLElement {
  constructor() {
    super(), this.reactRoot = null, this._mode = "read", this._history = null, this._initialState = tE, this._testingSecret = null, this._editorVariant = "unknown", this._plugins = F8, this._isProductionEnvironment = !1, this._language = "de", this.container = document.createElement("div");
  }
  static get observedAttributes() {
    return [
      "initial-state",
      "mode",
      "testing-secret",
      "editor-variant",
      "plugins",
      "is-production-environment",
      "language"
    ];
  }
  attributeChangedCallback(t, n, r) {
    if (t === "initial-state" && n !== r)
      this.initialState = JSON.parse(r);
    else if (t === "mode" && n !== r && (r === "read" || r === "write"))
      this.mode = r;
    else if (t === "editor-variant" && n !== r)
      this.editorVariant = r;
    else if (t === "plugins" && n !== r)
      this.plugins = JSON.parse(r);
    else if (t === "is-production-environment")
      this.isProductionEnvironment = r === "true";
    else if (t === "language" && n !== r) {
      const i = r === "en" ? "en" : "de";
      this.language = i;
    }
  }
  get initialState() {
    return this._initialState;
  }
  set initialState(t) {
    this._initialState = t, this._currentState = t, this.setAttribute("initial-state", JSON.stringify(t)), this.mountReactComponent();
  }
  get mode() {
    return this._mode;
  }
  set mode(t) {
    t !== this._mode && (t === "read" || t === "write") && (this._mode = t, this.setAttribute("mode", t), this.mountReactComponent());
  }
  get currentState() {
    return this._currentState;
  }
  set currentState(t) {
    throw new Error(
      "currentState is a readonly property. To modify state, please change the initialState."
    );
  }
  get history() {
    return this._history;
  }
  get testingSecret() {
    return this._testingSecret;
  }
  set testingSecret(t) {
    t && this.setAttribute("testing-secret", t);
  }
  get editorVariant() {
    return this._editorVariant;
  }
  set editorVariant(t) {
    this._editorVariant = t, this.setAttribute("editor-variant", t), this.mountReactComponent();
  }
  get plugins() {
    return this._plugins;
  }
  set plugins(t) {
    this._plugins = t, t && this.setAttribute("plugins", JSON.stringify(t)), this.mountReactComponent();
  }
  get isProductionEnvironment() {
    return this._isProductionEnvironment;
  }
  set isProductionEnvironment(t) {
    this._isProductionEnvironment = t, this.setAttribute("is-production-environment", String(t)), this.mountReactComponent();
  }
  get language() {
    return this._language;
  }
  set language(t) {
    if (t !== "en" && t !== "de")
      throw new Error(
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        `Invalid language value: ${t}. Supported values are 'en' or 'de'.`
      );
    this._language = t, this.setAttribute("language", t), this.mountReactComponent();
  }
  connectedCallback() {
    this.appendChild(this.container), this.loadAndApplyStyles(), this.reactRoot || (this.reactRoot = WB(this.container)), this.mountReactComponent();
  }
  loadAndApplyStyles() {
    const t = document.createElement("style");
    t.textContent = Q6e, this.appendChild(t);
  }
  broadcastNewState(t) {
    const n = new CustomEvent("state-changed", {
      detail: { newState: t }
    });
    this.dispatchEvent(n);
  }
  mountReactComponent() {
    const t = this.getAttribute("initial-state"), n = this.getAttribute("testing-secret"), r = t ? JSON.parse(t) : tE;
    if (!this._currentState && r && (this._currentState = r), !this.reactRoot)
      return null;
    this.reactRoot.render(
      /* @__PURE__ */ Xu.jsx(dt.StrictMode, { children: /* @__PURE__ */ Xu.jsx("div", { id: "serlo-root", className: "relative", children: this._mode === "write" ? /* @__PURE__ */ Xu.jsx(v.Suspense, { fallback: /* @__PURE__ */ Xu.jsx("div", { children: "Loading editor..." }), children: /* @__PURE__ */ Xu.jsx(
        Y6e,
        {
          editorVariant: this.editorVariant,
          initialState: this.initialState,
          _testingSecret: n,
          plugins: this.plugins,
          isProductionEnvironment: this.isProductionEnvironment,
          onChange: (i) => {
            this._currentState = i, this.broadcastNewState(i);
          },
          language: this.language,
          children: (i) => (this._history = i.history, /* @__PURE__ */ Xu.jsx("div", { children: i.element }))
        }
      ) }) : /* @__PURE__ */ Xu.jsx(
        HB,
        {
          state: this.initialState,
          editorVariant: this.editorVariant,
          language: this.language
        }
      ) }) })
    );
  }
  disconnectedCallback() {
    this.reactRoot && (this.reactRoot.unmount(), this.reactRoot = null);
  }
}
export {
  jc as $,
  $t as A,
  l7e as B,
  NJ as C,
  IJ as D,
  WJ as E,
  ty as F,
  RN as G,
  Cw as H,
  bJ as I,
  VN as J,
  tO as K,
  Fm as L,
  QN as M,
  J7 as N,
  ZJ as O,
  XJ as P,
  $N as Q,
  n7e as R,
  $h as S,
  Sn as T,
  IN as U,
  KJ as V,
  nO as W,
  GJ as X,
  rO as Y,
  Wu as Z,
  s7e as _,
  vJ as a,
  a7e as a0,
  pJ as a1,
  HN as a2,
  u7e as a3,
  OJ as a4,
  i7e as a5,
  zJ as a6,
  UN as a7,
  qN as a8,
  u5 as a9,
  hJ as aa,
  mJ as ab,
  EJ as ac,
  yee as ad,
  tee as ae,
  qJ as af,
  fee as ag,
  Lm as ah,
  nt as ai,
  KG as aj,
  Le as ak,
  vn as al,
  ot as am,
  qo as an,
  $6e as ao,
  H6e as ap,
  Y as aq,
  F8 as ar,
  p7e as as,
  v as b,
  WN as c,
  kJ as d,
  c5 as e,
  _4 as f,
  o7e as g,
  r7e as h,
  gee as i,
  gJ as j,
  _J as k,
  TJ as l,
  AJ as m,
  ZN as n,
  KN as o,
  DP as p,
  n2 as q,
  wi as r,
  vee as s,
  fJ as t,
  c as u,
  jJ as v,
  FJ as w,
  pee as x,
  YN as y,
  t2 as z
};
